webpackJsonp([1],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);


/* harmony default export */ __webpack_exports__["a"] = ({
  hashCode: function hashCode(str) {
    return !str ? null : str.split('').reduce(function (prevHash, currVal) {
      return (prevHash << 5) - prevHash + currVal.charCodeAt(0) | 0;
    }, 0);
  },
  getValue: function getValue(obj, path) {
    var get = function get(p, o) {
      return p.reduce(function (xs, x) {
        return xs && xs[x] ? xs[x] : null;
      }, o);
    };
    return get(path, obj);
  },
  uniqBy: function uniqBy(a, key) {
    var seen = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a();
    return a.filter(function (item) {
      var k = item[key];
      return seen.has(k) ? false : seen.add(k);
    });
  },
  blank: function blank(v, formatter, msg) {
    msg = msg || '-';
    return !v && msg || v && v === 'null' && msg || formatter && formatter(v) || v;
  },
  isDate: function isDate(date) {
    return new Date(date) !== 'Invalid Date' && !isNaN(new Date(date));
  },
  formatDate: function formatDate(dateTime) {
    return new Date(dateTime).toLocaleDateString(navigator.languages);
  },
  formatDateToISO: function formatDateToISO(dateTime) {
    var d = new Date(dateTime);
    // console.log('formatDateToISO', d.toISOString().slice(0, 10))
    return d.toISOString().slice(0, 10);
  },
  formatDateTime: function formatDateTime(dateTime) {
    return new Date(dateTime).toLocaleString(navigator.languages);
  },
  formatTime: function formatTime(dateTime) {
    return new Date(dateTime).toLocaleTimeString(navigator.languages);
  },
  formatCurrency: function formatCurrency(number) {
    return number.toLocaleString(navigator.languages);
  },
  formatNumber: function formatNumber(number) {
    return number.toLocaleString(navigator.languages, { minimumFractionDigits: 1, maximumFractionDigits: 2 });
  },
  isString: function isString(v) {
    return Object.prototype.toString.call(v) === '[object String]';
  },
  compareString: function compareString(a, b) {
    return a ? a.localeCompare(b, 'ru', { sensitivity: 'base' }) : b ? -1 : 0;
  },
  isRefCode: function isRefCode(v) {
    return (/^(nza:\d{11}|ogrn:\d{13}|ogrnip:\d{15})$/.test(v)
    );
  },
  splitRefCode: function splitRefCode(v) {
    if (!this.isRefCode(v)) {
      return {};
    }
    return { type: v.split(':')[0], code: v.split(':')[1] };
  },
  isOgrn: function isOgrn(v) {
    return (/^[1-9][0-9]{12}$/.test(v)
    );
  },
  isInn: function isInn(v) {
    return (/^(?:(?!00)\d{10}|(?!0)\d{9})$/.test(v)
    );
  },
  formatInn: function formatInn(v) {
    return Number(v).toLocaleString(navigator.languages, { useGrouping: false, minimumIntegerDigits: 10 });
  },
  isRefCodes: function isRefCodes(v) {
    return (/^(?:(?:(ogrn:)\d{13}|(nza:)\d{11}|(ogrnip:)\d{15})[\s,]*)+$/g.test(v)
    );
  },
  splitRefCodes: function splitRefCodes(v) {
    var re = /(?:(ogrn:)\d{13}|(nza:)\d{11}|(ogrnip:)\d{15})/g;
    return v ? v.match(re) || [] : [];
  },
  isInns: function isInns(v) {
    return (/^(?:(?:(?!00)\d{10}|(?!0)\d{9})[\s,]*)+$/g.test(v)
    );
  },
  splitInns: function splitInns(v) {
    var re = /(?:(?!00)\d{10}|(?!0)\d{9})/g;
    return v ? v.match(re) || [] : [];
  },
  isInnfl: function isInnfl(v) {
    return (/^(?:(?!00)\d{12}|(?!0)\d{11})$/.test(v)
    );
  },
  formatInnfl: function formatInnfl(v) {
    return Number(v).toLocaleString(navigator.languages, { useGrouping: false, minimumIntegerDigits: 12 });
  },
  isDepoUid: function isDepoUid(v) {
    return (/^[2]\d{19}$/.test(v)
    );
  },
  splitDepoUids: function splitDepoUids(v) {
    var re = /(?:[2]\d{19})/g;
    return v ? v.match(re) || [] : [];
  },
  isEmail: function isEmail(v) {
    var re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Zа-яёА-ЯЁ\-0-9]+\.)+[a-zA-Zа-яёА-ЯЁ]{2,}))$/;
    return re.test(String(v).toLowerCase());
  },
  isEmails: function isEmails(v) {
    var vs = v.split(/[, ]+/);
    var result = vs.length > 0;
    for (var i = 0; i < vs.length; i++) {
      result = result && this.isEmail(vs[i]);
    }
    return result;
  },
  isPhone: function isPhone(v) {
    var re = /^(\+)?([0-69]){1,3}\(\d{1,5}\)(\d){4,8}(x\d*)?$/;
    var re1 = /^(\+7|8)(\(\d{3}\)\d{7}|\(\d{4}\)\d{6}|\(\d{5}\)\d{4,5})(x\d*)?$/;
    return re1.test(v) || re.test(v);
  },
  formatPhone: function formatPhone(v) {
    var _a = function _a(a, n) {
      return a.length > n && a[n] ? a[n] : '';
    };
    if (!v) {
      return '';
    }
    var ms = v.match(/^(\+?\d+)\D+(\d*)\D+([\d\s-]*)[^\d\s-]*([\d\s-]*)?\D*$/);
    if (!ms) {
      ms = v.match(/^(\+?\d{1})(\d{3})([\d\s-]*)[^\d\s-]*([\d\s-]*)?\D*$/);
    }
    if (ms) {
      var c = ms.length > 1 ? ms[1] === '8' ? '+7' : ms[1] : '';
      c = c[0] !== '+' && '+' + c || c;
      var o = _a(ms, 2);
      var n = _a(ms, 3).replace(/\D/g, '');
      var x = _a(ms, 4).length > 0 ? 'x' + _a(ms, 4).replace(/\D/g, '') : '';
      var result = c + '(' + o + ')' + n + x;
      return result;
    }
    return v;
  },
  isPassword: function isPassword(v) {
    var re = /^(?=.*\d)(?=.*[a-zA-Z]).{4,}$/;
    return re.test(String(v));
  },
  isBankAccount: function isBankAccount(v) {
    var re = /^\d{20}$/;
    return re.test(String(v));
  },
  isBankRcbic: function isBankRcbic(v) {
    var re = /^\d{9}$/;
    return re.test(String(v));
  },
  isSnils: function isSnils(v) {
    var re = /^\d{11}$/;
    return re.test(String(v));
  },
  isNameRu: function isNameRu(v, size) {
    var re = new RegExp('^[\u0410-\u042F\u0401][\u0430-\u044F\u0451\u0410-\u042F\u0401 -\']{1,' + (size - 1) + '}$');
    return re.test(String(v));
  },
  isNameLat: function isNameLat(v, size) {
    var re = new RegExp('^[A-Z][a-zA-Z-]{1,' + (size - 1) + '}$');
    return re.test(String(v));
  },
  parseSearchTerms: function parseSearchTerms(v) {
    // Парсинг с учетом пробелов внутри кавычек
    var re = /(?:"((?:[^"]|"")*)"|([^a-zA-Zа-яёА-ЯЁ"\s]+)|([^"\s]{3,}))/g;
    var arr = [].concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_toConsumableArray___default()(v && v.toLowerCase().matchAll(re) || [])).map(function (i) {
      return ('' + (i[1] || i[0])).replaceAll(/""/g, '"');
    });
    return arr;
  },
  stringifySearchTerms: function stringifySearchTerms(terms) {
    return terms && terms.map(function (t) {
      return (/\s/.test(t) && '"' + t.replaceAll(/"/g, '""') + '"' || t
      );
    }).join(' ');
  },
  createComp: function createComp(template) {
    return { template: template };
  },
  formatSuccessHtml: function formatSuccessHtml(warning) {
    return warning && warning.length > 0 ? '<span class="success--text">' + warning + '</span>' : '';
  },
  formatWarningHtml: function formatWarningHtml(warning) {
    return warning && warning.length > 0 ? '<span class="warning--text">' + warning + '</span>' : '';
  },
  formatErrorHtml: function formatErrorHtml(error) {
    return error && error.length > 0 ? '<b><span class="error--text">' + error + '</span></b>' : '';
  }
});

/***/ }),
/* 6 */,
/* 7 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmForm_vue__ = __webpack_require__(796);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__ConfirmForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__ConfirmForm_vue__);



var modalFactory = null;

/* harmony default export */ __webpack_exports__["a"] = ({
  setModalFactory: function setModalFactory(ref) {
    modalFactory = ref;
  },
  isModal: function isModal() {
    return modalFactory && modalFactory.isModal();
  },
  register: function register(tag, component) {
    __WEBPACK_IMPORTED_MODULE_0_vue__["default"].component(tag, component);
  },
  modal: function modal(comp) {
    if (modalFactory) {
      modalFactory.open(comp);
    } else {
      console.log('dialogs.modal', 'Error Modal Factory was not defined');
    }
  },
  confirm: function confirm(self, title, question, cb, cancelCb) {
    var onOk = function onOk() {
      return cb(self);
    };
    var onCancel = function onCancel() {
      return cancelCb ? cancelCb(self) : {};
    };
    this.register('v-confirm-form', __WEBPACK_IMPORTED_MODULE_1__ConfirmForm_vue___default.a);
    var fullscreen = false;
    var comp = { template: '\n      <v-confirm-form v-on:close="$emit(\'close\')"\n      v-on:ok="okCb"\n      v-on:cancel="cancelCb"\n      :fullscreen="fullscreen"\n      :title="title"\n      :question="question"\n      ></v-confirm-form>\n      ',
      data: function data() {
        return {
          fullscreen: fullscreen,
          okCb: onOk,
          cancelCb: onCancel,
          title: title,
          question: question
        };
      }
    };
    this.modal(comp);
  },
  message: function message(self, title, question) {
    var okCb = function okCb() {};
    this.register('v-confirm-form', __WEBPACK_IMPORTED_MODULE_1__ConfirmForm_vue___default.a);
    var fullscreen = false;
    var comp = { template: '\n      <v-confirm-form v-on:close="$emit(\'close\')"\n      v-on:ok="okCb"\n      :fullscreen="fullscreen"\n      :title="title"\n      :question="question"\n      noCancel\n      ></v-confirm-form>\n      ',
      data: function data() {
        return {
          fullscreen: fullscreen,
          okCb: okCb,
          title: title,
          question: question
        };
      }
    };
    this.modal(comp);
  }
});

/***/ }),
/* 8 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(69);



var baseUrl = null;
var isRefreshing = false;

function getBase() {
  if (!baseUrl) {
    var result = window.location.href.substring(0, window.location.href.lastIndexOf('/#'));
    // Dev
    if (window.location.host.match(/localhost:8080/i)) {
      result = 'http://localhost:8081';
    }
    if (window.location.host.match(/127.0.0.1:8080/i)) {
      result = 'http://localhost:8081';
    }
    // Dev end
    baseUrl = result;
  }
  return baseUrl;
}

function setRefreshing(value) {
  isRefreshing = value;
}

/* harmony default export */ __webpack_exports__["a"] = ({
  getAccessToken: function getAccessToken() {
    return window.localStorage && window.localStorage.getItem('accessToken') !== null ? window.localStorage.getItem('accessToken') : null;
  },
  getRefreshToken: function getRefreshToken() {
    return window.localStorage && window.localStorage.getItem('refreshToken') !== null ? window.localStorage.getItem('refreshToken') : null;
  },
  getJti: function getJti() {
    return window.localStorage && window.localStorage.getItem('jti') !== null ? window.localStorage.getItem('jti') : null;
  },
  getCurrentClient: function getCurrentClient() {
    return window.localStorage && window.localStorage.getItem('currentClient') !== null ? window.localStorage.getItem('currentClient') : null;
  },
  getLastLogin: function getLastLogin() {
    return window.localStorage && window.localStorage.getItem('lastLogin') !== null ? window.localStorage.getItem('lastLogin') : null;
  },
  getIsExpired: function getIsExpired() {
    return window.localStorage && window.localStorage.getItem('expires_in') !== null ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_number_parse_int___default()(window.localStorage.getItem('expires_in')) < new Date().getTime() : true;
  },
  getIsRefreshing: function getIsRefreshing() {
    return isRefreshing;
  },


  // getIsRefreshing () {
  //   return (window.localStorage && window.localStorage.getItem('isRefreshing') !== null)
  //   ? window.localStorage.getItem('isRefreshing') === 'true' : false
  // },
  saveToStorage: function saveToStorage(key, value) {
    // console.log('saveToStorage', key, value)
    if (window.localStorage) {
      if (value !== null) {
        window.localStorage.setItem(key, value);
      } else {
        window.localStorage.removeItem(key);
      }
    }
  },
  saveJwtInfo: function saveJwtInfo(data) {
    this.saveToStorage('accessToken', data ? data.access_token : null);
    this.saveToStorage('refreshToken', data ? data.refresh_token : null);
    this.saveToStorage('jti', data ? data.jti : null);
    this.saveToStorage('expires_in', data ? new Date().setSeconds(new Date().getSeconds() + data.expires_in) : null);
  },
  getBaseUrl: function getBaseUrl() {
    return getBase();
  },
  openApiGetParams: function openApiGetParams(uri, params, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(getBase() + uri, { params: params }).then(function (responce) {
      return cb(responce.data);
    }).catch(function (e) {
      return errorCb(e);
    });
  },
  openApiGet: function openApiGet(uri, cb, errorCb) {
    this.openApiGetParams(uri, {}, cb, errorCb);
  },
  openApiPost: function openApiPost(uri, data, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(getBase() + uri, data).then(function (responce) {
      return cb(responce.data);
    }).catch(function (e) {
      return errorCb(e);
    });
  },
  openApiPostConfig: function openApiPostConfig(uri, data, config, cb, errorCb) {
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(getBase() + uri, data, config).then(function (responce) {
      return cb(responce.data);
    }).catch(function (e) {
      return errorCb(e);
    });
  },

  // get token for registration
  // curl register-app:secret@localhost:8081/oauth/token -d "grant_type=client_credentials&client_id=register-app&secret=secret&scope=registerUser"
  // curl -H "Authorization: Bearer [ACCESS_TOKEN]" -H "Content-Type: application/json" -X POST localhost:8081/api/account/register -d '{"username":"user2", "password":"password"}'
  register: function register(request, cb, errorCb) {
    var _this = this;

    var config = {
      auth: {
        username: 'register-app',
        password: 'none'
      }
    };
    var formData = new FormData();
    formData.append('grant_type', 'client_credentials');
    formData.append('client_id', config.auth.username);
    formData.append('secret', config.auth.password);
    formData.append('scope', 'registerUser');
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(getBase() + '/oauth/token', formData, config).then(function (responce) {
      return _this.apiPostToken(responce.data.access_token, '/api/account/register', request, cb, errorCb);
    }).catch(function (e) {
      return errorCb(e);
    });
  },

  // curl client-app:secret@localhost:8080/oauth/token -d "grant_type=password&username=user&password=password"
  login: function login(request, cb, errorCb) {
    var self = this;
    var cbF = function cbF(data) {
      console.log('cbF');
      self.saveJwtInfo(data);
      setRefreshing(false);
      cb(null);
    };
    var config = {
      auth: {
        username: 'client-app',
        password: 'none'
      }
    };
    var formData = new FormData();
    formData.append('grant_type', 'password');
    formData.append('username', request.username);
    formData.append('password', request.password);
    formData.append('orgId', this.getCurrentClient());
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(getBase() + '/oauth/token', formData, config).then(function (responce) {
      return cbF(responce.data);
    }).catch(function (e) {
      return errorCb(e);
    });
  },
  logout: function logout() {
    this.saveJwtInfo(null);
  },
  refreshInternal: function refreshInternal(cb, errorCb) {
    setRefreshing(true);
    var self = this;
    var cbF = function cbF(data) {
      console.log('cbF');
      self.saveJwtInfo(data);
      setRefreshing(false);
      cb();
    };
    var errorCbF = function errorCbF(e) {
      setRefreshing(false);
      self.logout();
      errorCb({ response: { data: { error: 'invalid_token' }, status: 401 } });
    };
    var config = {
      auth: {
        username: 'client-app',
        password: 'none'
      }
    };
    if (!this.getRefreshToken() === 'null') {
      errorCbF(null);
    }
    var formData = new FormData();
    formData.append('grant_type', 'refresh_token');
    formData.append('jti', this.getJti());
    formData.append('refresh_token', this.getRefreshToken());
    formData.append('orgId', this.getCurrentClient());
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(getBase() + '/oauth/token', formData, config).then(function (responce) {
      return cbF(responce.data);
    }).catch(function (e) {
      return errorCbF(e);
    });
  },
  checkExpiration: function checkExpiration(cb, errorCb) {
    var _this2 = this;

    var self = this;
    var cbF = function cbF() {
      if (!self.getIsExpired()) {
        cb(_this2);
      } else {
        setTimeout(function () {
          return cbF();
        }, 60);
      }
    };
    if (this.getIsExpired() && this.getIsRefreshing() === false) {
      this.refreshInternal(cbF, errorCb);
    } else {
      cbF();
    }
  },
  refresh: function refresh(request, cb, errorCb) {
    var cbF = function cbF(self) {
      return self.refreshInternal(cb, errorCb);
    };
    this.checkExpiration(cbF, errorCb);
  },

  //     curl -H "Authorization: Bearer [ACCESS_TOKEN]" localhost:8080/api/hello
  apiGetInternal: function apiGetInternal(uri, params, cb, errorCb) {
    var config = {
      params: params,
      headers: {
        Authorization: 'bearer ' + this.getAccessToken()
      }
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.get(getBase() + uri, config).then(function (responce) {
      return cb(responce.data);
    }).catch(function (e) {
      return errorCb(e);
    });
  },
  apiGetParams: function apiGetParams(uri, params, cb, errorCb) {
    console.log('apiGetParams', uri);
    var cbF = function cbF(self) {
      return self.apiGetInternal(uri, params, cb, errorCb);
    };
    this.checkExpiration(cbF, errorCb);
  },
  apiGet: function apiGet(uri, cb, errorCb) {
    this.apiGetParams(uri, {}, cb, errorCb);
  },
  apiPostToken: function apiPostToken(accessToken, uri, data, cb, errorCb) {
    var config = {
      headers: {
        Authorization: 'bearer ' + accessToken
      }
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(getBase() + uri, data, config).then(function (responce) {
      return cb(responce.data);
    }).catch(function (e) {
      return errorCb(e);
    });
  },
  apiPostInternal: function apiPostInternal(uri, data, cb, errorCb) {
    this.apiPostToken(this.getAccessToken(), uri, data, cb, errorCb);
  },
  apiPost: function apiPost(uri, data, cb, errorCb) {
    var cbF = function cbF(self) {
      return self.apiPostInternal(uri, data, cb, errorCb);
    };
    this.checkExpiration(cbF, errorCb);
  },
  apiPutInternal: function apiPutInternal(uri, data, cb, errorCb) {
    var config = {
      headers: {
        Authorization: 'bearer ' + this.getAccessToken()
      }
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.put(getBase() + uri, data, config).then(function (responce) {
      return cb(responce.data);
    }).catch(function (e) {
      return errorCb(e);
    });
  },
  apiPut: function apiPut(uri, data, cb, errorCb) {
    var cbF = function cbF(self) {
      return self.apiPutInternal(uri, data, cb, errorCb);
    };
    this.checkExpiration(cbF, errorCb);
  },
  apiDeleteInternal: function apiDeleteInternal(uri, cb, errorCb) {
    var config = {
      headers: {
        Authorization: 'bearer ' + this.getAccessToken()
      }
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.delete(getBase() + uri, config).then(function (responce) {
      return cb(responce.data);
    }).catch(function (e) {
      return errorCb(e);
    });
  },
  apiDelete: function apiDelete(uri, cb, errorCb) {
    var cbF = function cbF(self) {
      return self.apiDeleteInternal(uri, cb, errorCb);
    };
    this.checkExpiration(cbF, errorCb);
  },
  apiUploadInternal: function apiUploadInternal(uri, data, cb, errorCb) {
    var config = {
      headers: {
        Authorization: 'bearer ' + this.getAccessToken(),
        'Content-Type': undefined
      }
    };
    __WEBPACK_IMPORTED_MODULE_1_vue__["default"].axios.post(getBase() + uri, data, config).then(function (responce) {
      return cb(responce.data);
    }).catch(function (e) {
      return errorCb(e);
    });
  },
  apiUpload: function apiUpload(uri, data, cb, errorCb) {
    var cbF = function cbF(self) {
      return self.apiUploadInternal(uri, data, cb, errorCb);
    };
    this.checkExpiration(cbF, errorCb);
  }
});

/***/ }),
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(854),
  /* template */
  __webpack_require__(857),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 17 */,
/* 18 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(798),
  /* template */
  __webpack_require__(801),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 19 */,
/* 20 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_formats__ = __webpack_require__(5);


/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    formats: function formats() {
      return __WEBPACK_IMPORTED_MODULE_0__api_formats__["a" /* default */];
    }
  }
});

/***/ }),
/* 21 */,
/* 22 */,
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(799),
  /* template */
  __webpack_require__(800),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 24 */,
/* 25 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);





var modes = {
  VIEW: 1,
  SELECT: 2
};

var Action = function () {
  function Action(context, title, visibleFunc, runFunc) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Action);

    this.context = context;
    this.title = title;
    this.visibleFunc = visibleFunc || function () {
      return true;
    };
    this.runFunc = runFunc || function () {};
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Action, [{
    key: 'caption',
    value: function caption() {
      return this.title;
    }
  }, {
    key: 'isVisible',
    value: function isVisible() {
      return this.visibleFunc();
    }
  }, {
    key: 'run',
    value: function run() {
      return this.runFunc();
    }
  }]);

  return Action;
}();

var FilterAction = function (_Action) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(FilterAction, _Action);

  function FilterAction(context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, FilterAction);

    return _this = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FilterAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FilterAction)).call(this, context, 'Фильтр...', function () {
      return !_this.context.filterMode;
    }, function () {
      _this.context.filterMode = true;
    }));
  }

  return FilterAction;
}(Action);

var FilterEndAction = function (_Action2) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(FilterEndAction, _Action2);

  function FilterEndAction(context) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, FilterEndAction);

    return _this2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (FilterEndAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(FilterEndAction)).call(this, context, 'Убрать фильтр', function () {
      return _this2.context.filterMode;
    }, function () {
      _this2.context.filterMode = false;
      _this2.context.filterString = null;
    }));
  }

  return FilterEndAction;
}(Action);

var ActiveScopeAction = function (_Action3) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ActiveScopeAction, _Action3);

  function ActiveScopeAction(context) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ActiveScopeAction);

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ActiveScopeAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ActiveScopeAction)).call(this, context, 'Активные'));
  }

  return ActiveScopeAction;
}(Action);

var AllScopeAction = function (_Action4) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(AllScopeAction, _Action4);

  function AllScopeAction(context) {
    var _this4;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AllScopeAction);

    return _this4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AllScopeAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(AllScopeAction)).call(this, context, 'Все', null, function () {
      _this4.context.showAll();
    }));
  }

  return AllScopeAction;
}(Action);

var SelectAction = function (_Action5) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SelectAction, _Action5);

  function SelectAction(context) {
    var _this5;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SelectAction);

    return _this5 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SelectAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SelectAction)).call(this, context, 'Операции', null, function () {
      _this5.context.mode = modes.SELECT;
    }));
  }

  return SelectAction;
}(Action);

var SelectEndAction = function (_Action6) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SelectEndAction, _Action6);

  function SelectEndAction(context) {
    var _this6;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SelectEndAction);

    return _this6 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SelectEndAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SelectEndAction)).call(this, context, 'Отмена', null, function () {
      _this6.context.mode = modes.VIEW;
      _this6.context.clear();
    }));
  }

  return SelectEndAction;
}(Action);

var SelectAllAction = function (_Action7) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(SelectAllAction, _Action7);

  function SelectAllAction(context) {
    var _this7;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SelectAllAction);

    return _this7 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SelectAllAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(SelectAllAction)).call(this, context, 'Выбрать Всех', null, function () {
      return _this7.context.checkAll();
    }));
  }

  return SelectAllAction;
}(Action);

var ClearAllAction = function (_Action8) {
  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_inherits___default()(ClearAllAction, _Action8);

  function ClearAllAction(context) {
    var _this8;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ClearAllAction);

    return _this8 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ClearAllAction.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(ClearAllAction)).call(this, context, 'Очистить', null, function () {
      return _this8.context.clear();
    }));
  }

  return ClearAllAction;
}(Action);

var MultiSelectContext = function () {
  function MultiSelectContext(allItemsIdF) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, MultiSelectContext);

    this.allItemsIdF = allItemsIdF;
    this.filterMode = false;
    this.filterString = null;
    this.mode = modes.VIEW;
    this.activeId = null;
    this.selectedIds = [];
    this.actions = [];
    this.actionIcon = 'more_vert';
    this.selectActions = [];
    this.title = 'Просмотр';
    this.titleIcon = null;
    this.selectTitle = 'Выбор';
    this.selectTitleIcon = null;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(MultiSelectContext, [{
    key: 'activate',
    value: function activate(uid) {
      this.activeId = uid;
    }
  }, {
    key: 'activated',
    value: function activated(uid) {
      return this.activeId === uid;
    }
  }, {
    key: 'select',
    value: function select(uid) {
      this.activate(uid);
      if (this.isSelectMode()) {
        if (!this.check(uid)) {
          this.selectedIds.push(uid);
        } else {
          this.selectedIds = this.selectedIds.filter(function (i) {
            return i !== uid;
          });
        }
      }
    }
  }, {
    key: 'uncheck',
    value: function uncheck(uid) {
      return this.isSelectMode() && !this.selectedIds.includes(uid);
    }
  }, {
    key: 'check',
    value: function check(uid) {
      return this.isSelectMode() && this.selectedIds.includes(uid);
    }
  }, {
    key: 'clear',
    value: function clear() {
      this.selectedIds = [];
    }
  }, {
    key: 'checkAll',
    value: function checkAll() {
      this.selectedIds = this.allItemsIdF();
    }
  }, {
    key: 'showAll',
    value: function showAll() {
      this.mode = modes.VIEW;
      this.clear();
      this.filterString = null;
    }
  }, {
    key: 'selected',
    value: function selected() {
      return this.selectedIds;
    }
  }, {
    key: 'setSelected',
    value: function setSelected(uids) {
      this.selectedIds = uids || [];
    }
  }, {
    key: 'selectedCount',
    value: function selectedCount() {
      return this.selectedIds.length;
    }
  }, {
    key: 'isSelectMode',
    value: function isSelectMode() {
      return this.mode === modes.SELECT;
    }
  }, {
    key: 'isFilterMode',
    value: function isFilterMode() {
      return this.filterMode;
    }
  }, {
    key: 'getTitle',
    value: function getTitle() {
      return this.isSelectMode() ? this.selectTitle : this.title;
    }
  }, {
    key: 'getTitleIcon',
    value: function getTitleIcon() {
      return this.isSelectMode() && this.selectTitleIcon ? this.selectTitleIcon : this.titleIcon;
    }
  }, {
    key: 'getActions',
    value: function getActions() {
      return this.isSelectMode() ? this.selectActions : this.actions;
    }
  }, {
    key: 'toViewMode',
    value: function toViewMode() {
      if (this.isSelectMode()) {
        this.clear();
        this.mode = modes.VIEW;
      }
    }
  }]);

  return MultiSelectContext;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  modes: modes,
  Action: Action,
  FilterAction: FilterAction,
  FilterEndAction: FilterEndAction,
  ActiveScopeAction: ActiveScopeAction,
  AllScopeAction: AllScopeAction,
  SelectAction: SelectAction,
  SelectEndAction: SelectEndAction,
  SelectAllAction: SelectAllAction,
  ClearAllAction: ClearAllAction,
  MultiSelectContext: MultiSelectContext
});

/***/ }),
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_forms__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IndividualSelector__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__IndividualSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__IndividualSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PeopleLoader__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PeopleLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PeopleLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContactForm__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__ContactForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__ContactForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HolderList__ = __webpack_require__(909);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__HolderList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__HolderList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DocPassportRF_js__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__DocTemporaryIdRF_js__ = __webpack_require__(913);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__DocBirthCertRF_js__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__DocPensionCertRF_js__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__DocDriverLicRF_js__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__DocMarriageCertRF_js__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Individual_js__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Contact_js__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__client_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__api_formats__ = __webpack_require__(5);





















/* harmony default export */ __webpack_exports__["a"] = ({
  registeredTypeDoc: function registeredTypeDoc() {
    return ['PASSPORT_RF', 'TEMPORARY_ID_RF', 'BIRTH_CERT_RF', 'PENSION_CERT_RF', 'DRIVER_LIC_RF', 'MARRIAGE_CERT_RF'];
  },
  createStrategy: function createStrategy(cxt, type) {
    switch (type) {
      case 'PASSPORT_RF':
        {
          return __WEBPACK_IMPORTED_MODULE_10__DocPassportRF_js__["a" /* default */].createStrategy(cxt);
        }
      case 'TEMPORARY_ID_RF':
        {
          return __WEBPACK_IMPORTED_MODULE_11__DocTemporaryIdRF_js__["a" /* default */].createStrategy(cxt);
        }
      case 'BIRTH_CERT_RF':
        {
          return __WEBPACK_IMPORTED_MODULE_12__DocBirthCertRF_js__["a" /* default */].createStrategy(cxt);
        }
      case 'PENSION_CERT_RF':
        {
          return __WEBPACK_IMPORTED_MODULE_13__DocPensionCertRF_js__["a" /* default */].createStrategy(cxt);
        }
      case 'DRIVER_LIC_RF':
        {
          return __WEBPACK_IMPORTED_MODULE_14__DocDriverLicRF_js__["a" /* default */].createStrategy(cxt);
        }
      case 'MARRIAGE_CERT_RF':
        {
          return __WEBPACK_IMPORTED_MODULE_15__DocMarriageCertRF_js__["a" /* default */].createStrategy(cxt);
        }
      case 'INDIVIDUAL':
        {
          return __WEBPACK_IMPORTED_MODULE_16__Individual_js__["a" /* default */].createStrategy(cxt);
        }
      case 'CONTACT':
        {
          return __WEBPACK_IMPORTED_MODULE_17__Contact_js__["a" /* default */].createStrategy(cxt);
        }

      // default: {
      //   return docPassportRF.createStrategy(cxt)
      // }
    }
  },
  newForm: function newForm() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].register('v-contact-form', __WEBPACK_IMPORTED_MODULE_8__ContactForm___default.a);
      var fullscreen = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getIsMobile;
      var comp = { template: '\n        <v-contact-form\n        v-on:close="$emit(\'close\')"\n        v-on:change="onChange"\n        :fullscreen="fullscreen"></v-contact-form>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            onChange: function onChange(data) {
              return resolve(data);
            }
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].modal(comp);
    });
  },
  loadForm: function loadForm() {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].register('v-people-loader', __WEBPACK_IMPORTED_MODULE_7__PeopleLoader___default.a);
      var fullscreen = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getIsMobile;
      var comp = { template: '\n        <v-people-loader\n        v-on:close="$emit(\'close\')"\n        v-on:change="onChange"\n        :fullscreen="fullscreen"></v-people-loader>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            onChange: function onChange(data) {
              return resolve(data);
            }
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].modal(comp);
    });
  },
  open: function open(itemId, newWindow) {
    var url = this.getItemRef(itemId);
    if (!newWindow) {
      __WEBPACK_IMPORTED_MODULE_3__router__["a" /* default */].push({ path: url.replace('#', '') });
    } else {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('openLocation', url);
    }
  },
  openFormStg: function openFormStg(strategy, itemId) {
    return __WEBPACK_IMPORTED_MODULE_5__common_forms__["a" /* default */].openFormStg(strategy, itemId);
  },
  openForm: function openForm(itemId) {
    var strategy = this.createStrategy(null, 'INDIVIDUAL');
    return this.openFormStg(strategy, itemId);
  },
  getIndividual: function getIndividual(id) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getPeopleIndividual', id).then(function (data) {
        resolve(data);
      });
    });
  },
  findPeopleByInn: function findPeopleByInn(inn) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('findPeople', inn).then(function (data) {
        return resolve(data);
      });
    });
  },
  findIndividualByInn: function findIndividualByInn(inn) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this.findPeopleByInn(inn).then(function (peopleItems) {
        if (peopleItems && peopleItems.content && peopleItems.content.length > 0) {
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getPeopleIndividual', peopleItems.content[0].id).then(function (individual) {
            return resolve(individual);
          });
        } else {
          resolve(null);
        }
      });
    });
  },
  addHuman: function addHuman(companyRefCode, human) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('updatePeopleIndividual', {
        individual: { lastName: human.lastName, firstName: human.firstName, middleName: human.middleName, innfl: human.inn },
        contact: companyRefCode ? { companyRefCode: companyRefCode, position: human.position } : null
      }).then(function (id) {
        resolve(id);
      });
    });
  },
  openByHuman: function openByHuman(companyRefCode, human) {
    var _this2 = this;

    if (human && human.inn) {
      this.findPeopleByInn(human.inn).then(function (data) {
        if (data && data.content) {
          if (data.content.length > 0) {
            _this2.open(data.content[0].id);
          } else {
            _this2.addHuman(companyRefCode, human).then(function (id) {
              _this2.open(id);
            });
          }
        }
      });
    }
  },
  getHolderPassports: function getHolderPassports(companyRefCode) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var result = [];
      if (companyRefCode) {
        __WEBPACK_IMPORTED_MODULE_18__client_index_js__["a" /* default */].getHoldersByCompany(companyRefCode).then(function (hs) {
          console.log('getHolderPassports', hs);
          var innfls = hs.map(function (h) {
            return h.refObject && h.refObject.namespace === 'HUMAN' && h.refObject.inn ? h.refObject.inn.toString() : null;
          });
          __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getPeopleIndividualPassport', { innfls: innfls, companyRefCode: companyRefCode }).then(function (data) {
            var hMap = data.reduce(function (map, obj) {
              return map.set(obj.individual.innfl, obj);
            }, new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a());
            hs.forEach(function (h) {
              var innfl = h.refObject && h.refObject.namespace === 'HUMAN' && h.refObject.inn ? h.refObject.inn.toString() : null;
              var hItem = hMap.get(innfl);
              result.push({
                ref: h.ref,
                name: h.name,
                share: h.shares,
                innfl: innfl,
                personId: hItem && hItem.individual ? hItem.individual.id : null,
                individual: hItem && hItem.individual ? hItem.individual : null,
                passportId: hItem && hItem.doc ? hItem.doc.id : null,
                passport_rf: hItem && hItem.doc ? JSON.parse(hItem.doc.model) : null,
                contactId: hItem && hItem.contact ? hItem.contact.id : null,
                contact: hItem && hItem.contact ? hItem.contact : null,
                reason: ''
              });
            });
            resolve(result);
          });
        });
      } else {
        resolve(result);
      }
    });
  },
  openHolders: function openHolders(companyRefCode, holders) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].register('v-holder-list', __WEBPACK_IMPORTED_MODULE_9__HolderList___default.a);
      var onInput = function onInput(data) {
        resolve(data);
      };
      var title = 'Укажите паcпортные данные участников или представителей';
      var fullscreen = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getIsMobile;
      var comp = { template: '\n        <v-holder-list :fullscreen="fullscreen" :companyRefCode="companyRefCode" :holders="holders" :title="title" v-on:input="onSelect" v-on:close="$emit(\'close\')"></v-holder-list>\n      ',
        data: function data() {
          return {
            onSelect: onInput,
            fullscreen: fullscreen,
            companyRefCode: companyRefCode,
            holders: holders,
            title: title
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].modal(comp);
    });
  },
  getItemRef: function getItemRef(itemId) {
    return __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getRefToUrl('PERSON:' + itemId);
  },
  openContact: function openContact(itemId, parentId) {
    var _this3 = this;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this3.getIndividual(parentId).then(function (individual) {
        var strategy = _this3.createStrategy(null, 'CONTACT');
        strategy.setParentProps(individual);
        _this3.openFormStg(strategy, itemId).then(function (data) {
          return resolve(data);
        });
      });
    });
  },
  openDoc: function openDoc(itemId, parentId, type) {
    var _this4 = this;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this4.getIndividual(parentId).then(function (individual) {
        var strategy = _this4.createStrategy(null, type);
        strategy.setParentProps(individual);
        _this4.openFormStg(strategy, itemId).then(function (data) {
          return resolve(data);
        });
      });
    });
  },
  selectDocByIndividual: function selectDocByIndividual(cxt, individual, itemId, type) {
    var _this5 = this;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var items = [];
      if (individual && individual.docs) {
        var docs = !type ? individual.docs : individual.docs.filter(function (doc) {
          return __WEBPACK_IMPORTED_MODULE_19__api_formats__["a" /* default */].compareString(doc.type, type) === 0;
        });
        docs.forEach(function (doc) {
          var strategy = _this5.createStrategy(cxt, doc.type);
          items.push({ value: doc.id, text: '' + strategy.viewTitle(strategy.createModelFromData(doc)) });
        });
      }
      __WEBPACK_IMPORTED_MODULE_5__common_forms__["a" /* default */].selectItem(items, [], 'Выберите документ').then(function (data) {
        return resolve(data);
      });
    });
  },
  selectContactByIndividual: function selectContactByIndividual(cxt, individual, itemId, companyInn) {
    var _f = function _f(v) {
      return v || '-';
    };
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var items = [];
      if (individual && individual.contacts) {
        var contacts = !companyInn ? individual.contacts : individual.contacts.filter(function (contact) {
          return __WEBPACK_IMPORTED_MODULE_19__api_formats__["a" /* default */].compareString(companyInn, contact.companyInn === 0);
        });
        contacts.forEach(function (contact) {
          items.push({ value: contact.id, text: _f(contact.name) + ': ' + _f(contact.phone) + ', ' + _f(contact.email) });
        });
      }
      __WEBPACK_IMPORTED_MODULE_5__common_forms__["a" /* default */].selectItem(items, [], 'Выберите контакт').then(function (data) {
        return resolve(data);
      });
    });
  },
  getContactsByCompany: function getContactsByCompany(refCode) {
    return refCode ? __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getCompanyContacts', refCode) : [];
  },
  sortContactsByCompany: function sortContactsByCompany(items) {
    return items.sort(function (a, b) {
      return __WEBPACK_IMPORTED_MODULE_19__api_formats__["a" /* default */].compareString(a.nameForCompany, b.nameForCompany);
    });
  },
  selectContactByCompany: function selectContactByCompany(cxt, refCode) {
    var _this6 = this;

    var _f = function _f(v) {
      return v || '-';
    };
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var items = [];
      _this6.getContactsByCompany(refCode).then(function (data) {
        var contacts = _this6.sortContactsByCompany(data);
        contacts.forEach(function (contact) {
          items.push({ value: contact.id, text: _f(contact.nameForCompany) + ': ' + _f(contact.phone) + ', ' + _f(contact.email) });
        });
        __WEBPACK_IMPORTED_MODULE_5__common_forms__["a" /* default */].selectItem(items, [], 'Выберите контакт').then(function (data) {
          return resolve(data);
        });
      });
    });
  },
  sortIndividualDoc: function sortIndividualDoc(items) {
    var types = this.registeredTypeDoc();
    var comp = function comp(a, b) {
      return types.indexOf(a.type) > types.indexOf(b.type) ? 1 : a.type === b.type ? a && a.issued && a.issued > b.issued ? -1 : 1 : -1;
    };
    return items.sort(comp);
  },
  getIndividualDoc: function getIndividualDoc(cxt, id) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getPeopleIndividualDoc', id).then(function (doc) {
        resolve(doc);
      });
    });
  },
  sortIndividualContact: function sortIndividualContact(items) {
    return items.sort(function (a, b) {
      return __WEBPACK_IMPORTED_MODULE_19__api_formats__["a" /* default */].compareString(a.name, b.name);
    });
  },
  getIndividualContact: function getIndividualContact(id) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('getPeopleIndividualContact', id).then(function (doc) {
        resolve(doc);
      });
    });
  },
  selectIndividual: function selectIndividual(cxt, queryCxt, getQuery, favorite, radio) {
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].register('v-individual-selector', __WEBPACK_IMPORTED_MODULE_6__IndividualSelector___default.a);
      var fullscreen = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getIsMobile;
      var comp = { template: '\n        <v-individual-selector\n        v-on:close="$emit(\'close\')"\n        v-on:input="onSelect"\n        :queryCxt="queryCxt"\n        :query="getQuery()"\n        :fullscreen="fullscreen"\n        :favorite="favorite"\n        :radio="radio"\n        ></v-individual-selector>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            onSelect: function onSelect(data) {
              return resolve(data);
            },
            queryCxt: queryCxt,
            getQuery: getQuery,
            favorite: favorite,
            radio: radio
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].modal(comp);
    });
  },
  genders: function genders() {
    return [{ value: 'F', text: 'Жен.' }, { value: 'M', text: 'Муж.' }];
  },
  citizenships: function citizenships() {
    return [{ value: 'Российская Федерация' }];
  }
});

/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_formats_js__ = __webpack_require__(5);















var Step = function () {
  function Step(title, subTitle, props, model) {
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, Step);

    this.title = title;
    this.subTitle = subTitle;
    this.props = props;
    this.model = model;
    this.editable = false;
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(Step, [{
    key: 'addToArray',
    value: function addToArray(array) {
      array.push(this);
      this.number = array.length;
    }
  }, {
    key: 'setModel',
    value: function setModel(model) {
      this.model = model;
    }
  }, {
    key: 'formatField',
    value: function formatField(name) {
      var v = this.model[name];
      if (!v) {
        return ' - ';
      }
      if (v instanceof Date) {
        return __WEBPACK_IMPORTED_MODULE_12__api_formats_js__["a" /* default */].formatDate(v);
      }
      return v.toString();
    }
  }, {
    key: 'nextEnabled',
    value: function nextEnabled() {
      return true;
    }
  }, {
    key: 'nextLabel',
    value: function nextLabel() {
      return 'Дальше';
    }
  }, {
    key: 'backEnabled',
    value: function backEnabled() {
      return true;
    }
  }, {
    key: 'backLabel',
    value: function backLabel() {
      return 'Назад';
    }
  }, {
    key: 'next',
    value: function next(model, nextFn) {
      return nextFn(model);
    }
  }, {
    key: 'back',
    value: function back(model, backFn) {
      return backFn(model);
    }
  }]);

  return Step;
}();

var Model = function () {
  function Model() {
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, Model);

    this.currentStep = 1;
    // step1
    this.companyInn = null;
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(Model, [{
    key: 'getCurrentStep',
    value: function getCurrentStep() {
      return this.currentStep;
    }
  }, {
    key: 'setCurrentStep',
    value: function setCurrentStep(val) {
      this.currentStep = val;
    }
  }, {
    key: 'getCompanyInn',
    value: function getCompanyInn() {
      return this.companyInn;
    }
  }, {
    key: 'getDescription',
    value: function getDescription() {
      return '';
    }
  }, {
    key: 'getDescription2',
    value: function getDescription2() {
      return '';
    }
  }]);

  return Model;
}();

var Strategy = function () {
  function Strategy(cxt) {
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    this.context = cxt;
    this.steps = [];
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getSteps',
    value: function getSteps() {
      return this.steps;
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      return new Model();
    }
  }]);

  return Strategy;
}();

var Repository = function () {
  function Repository() {
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, Repository);
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(Repository, [{
    key: 'get',
    value: function get(key) {
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve(null);
      });
    }
  }, {
    key: 'update',
    value: function update(key, item) {
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve(key);
      });
    }
  }, {
    key: 'delete',
    value: function _delete(key) {
      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve();
      });
    }
  }]);

  return Repository;
}();

var MapRepository = function (_Repository) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(MapRepository, _Repository);

  function MapRepository(keyCb, arr) {
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, MapRepository);

    var _this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (MapRepository.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(MapRepository)).call(this));

    _this.keyCb = keyCb;
    _this.items = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a();
    _this.setItems(arr);
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(MapRepository, [{
    key: 'setItems',
    value: function setItems(arr) {
      var map = new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_map___default.a();
      if (arr && Array.isArray(arr)) {
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(arr), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var item = _step.value;

            map.set(this.keyCb(item), item);
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      }
      this.items = map;
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(this.items.values());
    }
    // Repository overrides

  }, {
    key: 'get',
    value: function get(key) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve(_this2.items.get(key));
      });
    }
  }, {
    key: 'update',
    value: function update(key, item) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var k = key || _this3.keyCb(item);
        _this3.items.set(k, item);
        resolve(k);
      });
    }
  }, {
    key: 'delete',
    value: function _delete(key) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.items.delete(key);
        resolve();
      });
    }
  }]);

  return MapRepository;
}(Repository);

var SingleStepStrategy = function (_Strategy) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(SingleStepStrategy, _Strategy);

  function SingleStepStrategy(cxt, typeCode) {
    __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_classCallCheck___default()(this, SingleStepStrategy);

    var _this5 = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SingleStepStrategy.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(SingleStepStrategy)).call(this, cxt));

    _this5.repo = null;
    _this5.typeCode = typeCode;
    return _this5;
  }

  __WEBPACK_IMPORTED_MODULE_11_babel_runtime_helpers_createClass___default()(SingleStepStrategy, [{
    key: 'setRepo',
    value: function setRepo(repo) {
      this.repo = repo;
    }
  }, {
    key: 'getTypeCode',
    value: function getTypeCode() {
      return this.typeCode;
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return this.getTypeCode();
    }
  }, {
    key: 'setContext',
    value: function setContext(cxt) {
      this.context = cxt;
    }
  }, {
    key: 'createModelFromJSON',
    value: function createModelFromJSON(json) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), JSON.parse(json));
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel() {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), {});
    }
  }, {
    key: 'createModelFromData',
    value: function createModelFromData(data) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), data);
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var steps = [];
      new Step('', function (step) {}, {
        scheme: this.updateScheme()
      }, {}).addToArray(steps);
      this.steps = steps;
      return this;
    }
  }, {
    key: 'updateScheme',
    value: function updateScheme(scheme) {
      return [];
    }
  }, {
    key: 'getModel',
    value: function getModel() {
      var steps = this.getSteps();
      return steps && steps.length > 0 && steps[0].model;
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.getSteps().forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'fetchData',
    value: function fetchData(itemId) {
      return this.repo ? this.repo.get(itemId) : new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve(null);
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(itemId, model) {
      return this.repo ? this.repo.update(itemId, model) : new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve(itemId);
      });
    }
  }, {
    key: 'deleteData',
    value: function deleteData(itemId, model) {
      return this.repo ? this.repo.delete(itemId) : new __WEBPACK_IMPORTED_MODULE_9_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve();
      });
    }
  }, {
    key: 'viewTitle',
    value: function viewTitle(model) {
      return this.getTypeName();
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_12__api_formats_js__["a" /* default */].createComp('<span>' + this.viewTitle() + '</span>');
    }
  }, {
    key: 'viewContent',
    value: function viewContent(model) {
      var _f = function _f(v) {
        return v || '-';
      };
      if (!model) {
        return '';
      }
      var modelStr = '';
      var _iteratorNormalCompletion2 = true;
      var _didIteratorError2 = false;
      var _iteratorError2 = undefined;

      try {
        for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(model)), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
          var _ref = _step2.value;

          var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2);

          var key = _ref2[0];
          var value = _ref2[1];

          modelStr.concat(key + ': ' + _f(value) + '\n');
        }
      } catch (err) {
        _didIteratorError2 = true;
        _iteratorError2 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion2 && _iterator2.return) {
            _iterator2.return();
          }
        } finally {
          if (_didIteratorError2) {
            throw _iteratorError2;
          }
        }
      }

      return '' + modelStr;
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      var _f = function _f(v) {
        return v || '-';
      };
      if (!model) {
        return '';
      }
      var modelStr = '';
      var _iteratorNormalCompletion3 = true;
      var _didIteratorError3 = false;
      var _iteratorError3 = undefined;

      try {
        for (var _iterator3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_get_iterator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_entries___default()(model)), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
          var _ref3 = _step3.value;

          var _ref4 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref3, 2);

          var key = _ref4[0];
          var value = _ref4[1];

          modelStr.concat('<div>' + key + ': <b>' + _f(value) + '</b></div>');
        }
      } catch (err) {
        _didIteratorError3 = true;
        _iteratorError3 = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion3 && _iterator3.return) {
            _iterator3.return();
          }
        } finally {
          if (_didIteratorError3) {
            throw _iteratorError3;
          }
        }
      }

      return __WEBPACK_IMPORTED_MODULE_12__api_formats_js__["a" /* default */].createComp('\n      <div>' + modelStr + '</div>\n    ');
    }
  }]);

  return SingleStepStrategy;
}(Strategy);

/* harmony default export */ __webpack_exports__["a"] = ({
  Step: Step,
  Model: Model,
  MapRepository: MapRepository,
  Strategy: Strategy,
  SingleStepStrategy: SingleStepStrategy
});

/***/ }),
/* 33 */,
/* 34 */,
/* 35 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DocNew_vue__ = __webpack_require__(850);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__DocNew_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__DocNew_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DocForm_vue__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__DocForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__DocForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depo_DocSelector__ = __webpack_require__(861);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depo_DocSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__depo_DocSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__depo_DocPropSelector__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__depo_DocPropSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__depo_DocPropSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__depo_DocPropList__ = __webpack_require__(886);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__depo_DocPropList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__depo_DocPropList__);










/* harmony default export */ __webpack_exports__["a"] = ({
  newFile: function newFile(path, onSelect, id, tags) {
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].register('v-doc-new', __WEBPACK_IMPORTED_MODULE_4__DocNew_vue___default.a);
    var comp = { template: '\n      <v-doc-new toolbar :fileItemId="dialogItemId" :newPath="path" :newTags="tags" v-on:input="onSelect" v-on:close="$emit(\'close\')"></v-doc-new>\n      ',
      data: function data() {
        return {
          dialogItemId: id,
          path: path,
          tags: tags,
          onSelect: onSelect || function () {}
        };
      }
    };
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].modal(comp);
  },
  openFile: function openFile(id, path, readonly, onNewVersion, exactVersion) {
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].register('v-doc-form', __WEBPACK_IMPORTED_MODULE_5__DocForm_vue___default.a);
    var comp = { template: '\n      <v-doc-form toolbar :fileItemId="dialogItemId" :readonly="readonly" :newPath="path" v-on:close="$emit(\'close\')"\n      v-on:new-version="onNewVersion" :exactVersion="exactVersion"\n      > </v-doc-form>\n      ',
      data: function data() {
        return {
          dialogItemId: id,
          path: path,
          readonly: readonly && readonly === true,
          exactVersion: exactVersion && exactVersion === true,
          onNewVersion: onNewVersion || function () {}
        };
      }
    };
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].modal(comp);
  },
  createPreview: function createPreview(item, cxt) {
    var vIcon = function vIcon(name) {
      return '<v-icon @click.stop="self.openFile(item.uid)">' + name + '</v-icon>';
    };
    var template = null;

    switch (item.fileExt) {
      case '.jpg':
      case '.jpeg':
      case '.png':
      case '.gif':
        template = '<img :src="self.getDepoUrl(item.uid) + \'/preview?width=100\'" @click.stop="self.openFile(item.uid)"/>';
        break;
      case '.pdf':
        template = vIcon('dealger-file-pdf');
        break;
      case '.doc':
      case '.docx':
        template = vIcon('dealger-file-word');
        break;
      case '.xls':
      case '.xlsx':
        template = vIcon('dealger-file-excel');
        break;
      default:
        template = vIcon('dealger-file-empty');
    }
    return {
      template: template,
      data: function data() {
        return {
          self: cxt,
          item: item
        };
      }
    };
  },
  selectDoc: function selectDoc(cxt, onSelect, multi, queryCxt) {
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].register('v-doc-selector', __WEBPACK_IMPORTED_MODULE_6__depo_DocSelector___default.a);
    var fullscreen = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getIsMobile;
    var comp = { template: '\n      <v-doc-selector :queryCxt="queryCxt" :fullscreen="fullscreen" :radio="radio" v-on:input="setDoc" v-on:close="$emit(\'close\')"></v-doc-selector>\n    ',
      data: function data() {
        return {
          setDoc: onSelect,
          fullscreen: fullscreen,
          radio: !multi,
          queryCxt: queryCxt
        };
      }
    };
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].modal(comp);
  },
  selectDocProp: function selectDocProp(cxt, onSelect, items, selected, title) {
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].register('v-docprop-selector', __WEBPACK_IMPORTED_MODULE_7__depo_DocPropSelector___default.a);
    var fullscreen = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getIsMobile;
    var comp = { template: '\n      <v-docprop-selector :fullscreen="fullscreen" :items="items" :selected="selected" :title="title" v-on:input="onSelect" v-on:close="$emit(\'close\')"></v-docprop-selector>\n    ',
      data: function data() {
        return {
          selected: selected,
          onSelect: onSelect,
          fullscreen: fullscreen,
          items: items,
          title: title
        };
      }
    };
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].modal(comp);
  },
  openDocProps: function openDocProps(companyRefCode, docprops) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].register('v-docprop-list', __WEBPACK_IMPORTED_MODULE_8__depo_DocPropList___default.a);
      var onInput = function onInput(data) {
        resolve(data);
      };
      var title = 'Список документов';
      var fullscreen = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getIsMobile;
      var comp = { template: '\n        <v-docprop-list :fullscreen="fullscreen" :companyRefCode="companyRefCode" :docprops="docprops" :title="title" v-on:input="onSelect" v-on:close="$emit(\'close\')"></v-docprop-list>\n      ',
        data: function data() {
          return {
            onSelect: onInput,
            fullscreen: fullscreen,
            companyRefCode: companyRefCode,
            docprops: docprops,
            title: title
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].modal(comp);
    });
  },
  downloadFile: function downloadFile(url) {
    var element = document.createElement('a');
    element.setAttribute('href', url);
    element.setAttribute('download', '');
    element.style.display = 'none';
    document.body.appendChild(element);
    element.click();
    document.body.removeChild(element);
  },
  getDepoFilesUrl: function getDepoFilesUrl(ids) {
    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDepoFilesUrl(ids);
  },
  downloadFiles: function downloadFiles(ids) {
    var link = this.getDepoFilesUrl(ids);
    this.downloadFile(link);
  },
  sendProps: function sendProps(ids, email, emailProp) {
    var printProps = function printProps(f) {
      return '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442: ' + f.docName + (f.signed ? '\n\t' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.renderDepoFileSignMessage(f) : '') + '\n      \tC\u0441\u044B\u043B\u043A\u0430: ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDepoUrl(f.uid) + '\n      \t\u0414\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDateTime(f.uploaded) + ' (\u043F\u043E: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(f.deleted) + ')\n      \t\u0414\u0435\u043F\u043E\u043D\u0435\u043D\u0442: ' + f.ownerShortName + ' \u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInn(f.ownerInn) + '\n';
    };
    var prepareList = function prepareList(data) {
      var filePropText = '\n' + data.map(function (i) {
        return printProps(i);
      }).join('\n');
      var downloads = '\n \u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0432\u0441\u0435: ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDepoFilesUrl(ids);
      var sign = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.nameShort + '\n\n' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.clientNameShort + ' \n \u0418\u041D\u041D ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.clientInn;
      var subject = emailProp && emailProp.subject ? emailProp.subject : 'Список ссылок на документы';
      var intro = emailProp && emailProp.body ? emailProp.body : 'Добрый день,\nНаправляю Вам ссылки для скачивания следующих документов:';
      var emailBody = ''.concat(intro, '\n', filePropText, '\n', downloads, '\n', '\n', 'С уважением,', '\n', sign);
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('shareTo', { email: email, subject: subject, emailBody: emailBody });
    };
    __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('getDepoFileProps', { uids: ids }).then(function (data) {
      return prepareList(data);
    });
  },
  sendPropsByServer: function sendPropsByServer(ids, email, emailProp, asAttach) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var printProps = function printProps(f) {
        return '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442: ' + f.docName + (f.signed ? '\n\t' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.renderDepoFileSignMessage(f) : '') + '\n        \tC\u0441\u044B\u043B\u043A\u0430: ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDepoUrl(f.uid) + '\n        \t\u0414\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDateTime(f.uploaded) + ' (\u043F\u043E: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(f.deleted) + ')\n        \t\u0414\u0435\u043F\u043E\u043D\u0435\u043D\u0442: ' + f.ownerShortName + ' \u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInn(f.ownerInn) + '\n';
      };
      var prepareList = function prepareList(data) {
        var filePropText = '\n' + data.map(function (i) {
          return printProps(i);
        }).join('\n');
        var downloads = '\n \u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0432\u0441\u0435: ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDepoFilesUrl(ids);
        var sign = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.nameShort + '\n\n' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.clientNameShort + ' \n \u0418\u041D\u041D ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.clientInn;
        var subject = emailProp && emailProp.subject ? emailProp.subject : 'Список ссылок на документы';
        var intro = emailProp && emailProp.body ? emailProp.body : 'Добрый день,\nНаправляю Вам ссылки для скачивания следующих документов:';
        var emailBody = ''.concat(intro, '\n', filePropText, '\n', downloads, '\n', '\n', 'С уважением,', '\n', sign);
        console.log('sendPropsByServer', asAttach ? ids : null);
        __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('sendTo', { email: email, subject: subject, body: emailBody, uids: asAttach ? ids : null }).then(function (data) {
          return resolve(data);
        });
      };
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('getDepoFileProps', { uids: ids }).then(function (data) {
        return prepareList(data);
      });
    });
  },
  getPropsText: function getPropsText(ids, body, subject) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var printProps = function printProps(f) {
        return '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442: ' + f.docName + (f.signed ? '\n\t' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.renderDepoFileSignMessage(f) : '') + '\n        \tC\u0441\u044B\u043B\u043A\u0430: ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDepoUrl(f.uid) + '\n        \t\u0414\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDateTime(f.uploaded) + ' (\u043F\u043E: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(f.deleted) + ')\n        \t\u0414\u0435\u043F\u043E\u043D\u0435\u043D\u0442: ' + f.ownerShortName + ' \u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInn(f.ownerInn) + '\n';
      };
      var prepareList = function prepareList(data) {
        var filePropText = '\n' + data.map(function (i) {
          return printProps(i);
        }).join('\n');
        var downloads = '\n \u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0432\u0441\u0435: ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDepoFilesUrl(ids);
        var sign = __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.nameShort + '\n\n' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.clientNameShort + ' \n \u0418\u041D\u041D ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.clientInn;
        var emailSubject = subject || 'Список ссылок на документы';
        var intro = body || 'Добрый день, Направляю Вам ссылки для скачивания следующих документов:';
        var emailBody = ''.concat(intro, '\n', filePropText, '\n', downloads, '\n', '\n', 'С уважением,', '\n', sign);
        resolve({ subject: emailSubject, body: emailBody, uids: ids });
      };
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('getDepoFileProps', { uids: ids }).then(function (data) {
        return prepareList(data);
      });
    });
  },
  getPropsHtml: function getPropsHtml(ids, body, subject, signature) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var printProps = function printProps(f) {
        return '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442: <a href="' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDepoUrl(f.uid) + '">' + f.docName + '</a>\n        <p style="margin-left: 40px">\n        ' + (f.signed ? __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.renderDepoFileSignMessage(f) : '') + '\n        \u0414\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDateTime(f.uploaded) + ' (\u043F\u043E: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(f.deleted) + ') <br>\n        \u0414\u0435\u043F\u043E\u043D\u0435\u043D\u0442: ' + f.ownerShortName + ' \u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInn(f.ownerInn) + ' \n        </p>';
      };
      var prepareList = function prepareList(data) {
        var filePropText = '\n' + data.map(function (i) {
          return printProps(i);
        }).join('<br>');
        var downloads = '<a href="' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getDepoFilesUrl(ids) + '">\u0421\u043A\u0430\u0447\u0430\u0442\u044C \u0432\u0441\u0435</a>';
        var sign = signature || __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.nameShort + '<br><br>' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.clientNameShort + '  <br> \u0418\u041D\u041D ' + __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getProfile.clientInn;
        var emailSubject = subject || 'Список ссылок на документы';
        var intro = body || 'Добрый день, <p style="margin-left: 40px"> Направляю Вам ссылки для скачивания следующих документов: </p>';
        var emailBody = ''.concat(intro, filePropText, downloads, '<br>', '<br>', sign);
        resolve({ subject: emailSubject, body: emailBody, uids: ids });
      };
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('getDepoFileProps', { uids: ids }).then(function (data) {
        return prepareList(data);
      });
    });
  }
});

/***/ }),
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__modules_context__ = __webpack_require__(713);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__modules_depo__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__modules_chat__ = __webpack_require__(766);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__modules_favorite__ = __webpack_require__(767);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__modules_client__ = __webpack_require__(768);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__modules_ClientRender__ = __webpack_require__(769);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__modules_open__ = __webpack_require__(770);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__modules_report__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__modules_assist__ = __webpack_require__(772);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__modules_people__ = __webpack_require__(969);













__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["default"]);

var debug = "production" !== 'production';

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuex__["default"].Store({
  modules: {
    context: __WEBPACK_IMPORTED_MODULE_2__modules_context__["a" /* default */],
    depo: __WEBPACK_IMPORTED_MODULE_3__modules_depo__["a" /* default */],
    chat: __WEBPACK_IMPORTED_MODULE_4__modules_chat__["a" /* default */],
    client: __WEBPACK_IMPORTED_MODULE_6__modules_client__["a" /* default */],
    clientRender: __WEBPACK_IMPORTED_MODULE_7__modules_ClientRender__["a" /* default */],
    open: __WEBPACK_IMPORTED_MODULE_8__modules_open__["a" /* default */],
    favorite: __WEBPACK_IMPORTED_MODULE_5__modules_favorite__["a" /* default */],
    people: __WEBPACK_IMPORTED_MODULE_11__modules_people__["a" /* default */],
    report: __WEBPACK_IMPORTED_MODULE_9__modules_report__["a" /* default */],
    assist: __WEBPACK_IMPORTED_MODULE_10__modules_assist__["a" /* default */]
  },
  strict: debug
}));

/***/ }),
/* 37 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClientSelector__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ClientSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ClientSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ClientMailbox_js__ = __webpack_require__(881);









/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: function createStrategy(cxt, type) {
    switch (type) {
      case 'CLIENT_MAILBOX':
        {
          return __WEBPACK_IMPORTED_MODULE_7__ClientMailbox_js__["a" /* default */].createStrategy(cxt);
        }
    }
  },
  getCachedRefs: function getCachedRefs(refcodes, cb) {
    __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('getCachedRefs', { refcodes: refcodes }).then(function (data) {
      return cb(data);
    }, function () {});
  },
  convertInnToRefCode: function convertInnToRefCode(inns) {
    return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('convertInnToRefCode', { inns: inns });
  },
  getBriefCompanies: function getBriefCompanies(refCodes) {
    return __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].dispatch('getBriefCompaniesByRefCode', { refCodes: refCodes });
  },
  selectRef: function selectRef(cxt, onSelect, getQuery, favorite, radio, partner) {
    var _this = this;

    var cbSelect = function cbSelect(refCodes) {
      console.log('cbSelect', refCodes);
      if (radio) {
        return _this.getBriefCompanies(refCodes).then(function (data) {
          console.log('selectRef', data);
          onSelect(data);
        });
      }
      return onSelect(refCodes);
    };
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].register('v-client-selector', __WEBPACK_IMPORTED_MODULE_6__ClientSelector___default.a);
    var fullscreen = __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].getters.getIsMobile;
    var comp = { template: '\n      <v-client-selector\n      v-on:close="$emit(\'close\')"\n      v-on:input="onSelect"\n      :query="getQuery()"\n      :fullscreen="fullscreen"\n      :favorite="favorite"\n      :radio="radio"\n      :partner="partner"\n      refCode\n      ></v-client-selector>\n      ',
      data: function data() {
        return {
          fullscreen: fullscreen,
          onSelect: cbSelect,
          getQuery: getQuery,
          favorite: favorite,
          radio: radio,
          partner: partner
        };
      }
    };
    __WEBPACK_IMPORTED_MODULE_2__common_dialogs__["a" /* default */].modal(comp);
  },
  getHumanProps: function getHumanProps(inn) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cbError = function cbError(e) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о физическом лице из ЕГРЮЛ ' });
      };
      var cb = function cb(data) {
        return resolve(data);
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server_js__["a" /* default */].openApiGet('/openapi/humans/' + inn, cb, cbError);
    });
  },
  getHoldersByCompany: function getHoldersByCompany(companyRefCode) {
    console.log('getHoldersByCompany', companyRefCode);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cbError = function cbError(e) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации об участниках из ЕГРЮЛ ' });
      };
      var cb = function cb(data) {
        return resolve(data);
      };
      if (!__WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].isRefCode(companyRefCode)) {
        __WEBPACK_IMPORTED_MODULE_4__store__["a" /* default */].commit('setErrorStatus', { error: '\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 [' + companyRefCode + '] ', context: 'Ошибка клиента при получении информации об участниках из ЕГРЮЛ ' });
      }
      __WEBPACK_IMPORTED_MODULE_3__api_server_js__["a" /* default */].openApiGet('/openapi/companies/' + __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].splitRefCode(companyRefCode).code + '/holders', cb, cbError);
    });
  },
  openClientMailbox: function openClientMailbox(itemId, clientId, clientNameShort) {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var strategy = _this2.createStrategy(null, 'CLIENT_MAILBOX');
      strategy.setParentProps({ clientId: clientId, clientNameShort: clientNameShort });
      __WEBPACK_IMPORTED_MODULE_5__common_forms_js__["a" /* default */].openFormStg(strategy, itemId).then(function (data) {
        return resolve(data);
      });
    });
  }
});

/***/ }),
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StrategyForm_vue__ = __webpack_require__(803);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StrategyForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__StrategyForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StrategySelector_vue__ = __webpack_require__(842);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StrategySelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__StrategySelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditorForm_vue__ = __webpack_require__(845);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__EditorForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__EditorForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmailForm_vue__ = __webpack_require__(848);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EmailForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__EmailForm_vue__);








/* harmony default export */ __webpack_exports__["a"] = ({
  openFormStg: function openFormStg(strategy, itemId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__dialogs_js__["a" /* default */].register('v-strategy-form', __WEBPACK_IMPORTED_MODULE_3__StrategyForm_vue___default.a);
      var fullscreen = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getIsMobile;
      strategy.updateSteps();
      var comp = { template: '\n        <v-strategy-form\n        :itemId="itemId"\n        :strategy="strategy"\n        v-on:close="$emit(\'close\')"\n        v-on:change="onChange"\n        v-on:createNew="onCreateNew"\n        :fullscreen="fullscreen"></v-strategy-form>\n        ',
        data: function data() {
          var _this = this;

          return {
            fullscreen: fullscreen,
            onChange: function onChange(data) {
              return resolve(data);
            },
            onCreateNew: function onCreateNew(data) {
              _this.itemId = null;
            },
            itemId: itemId ? itemId.toString() : null,
            strategy: strategy
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_1__dialogs_js__["a" /* default */].modal(comp);
    });
  },
  selectItem: function selectItem(items, selected, title) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__dialogs_js__["a" /* default */].register('strategy-selector', __WEBPACK_IMPORTED_MODULE_4__StrategySelector_vue___default.a);
      var fullscreen = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getIsMobile;
      var comp = { template: '\n        <strategy-selector radio :fullscreen="fullscreen" :items="items" :selected="selected" :title="title" v-on:input="onSelect" v-on:close="$emit(\'close\')"></strategy-selector>\n      ',
        data: function data() {
          return {
            selected: selected,
            onSelect: function onSelect(data) {
              return resolve(data);
            },
            fullscreen: fullscreen,
            items: items,
            title: title
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_1__dialogs_js__["a" /* default */].modal(comp);
    });
  },
  openEditor: function openEditor(value) {
    console.log('openEditor', value);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__dialogs_js__["a" /* default */].register('v-editor-form', __WEBPACK_IMPORTED_MODULE_5__EditorForm_vue___default.a);
      var fullscreen = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getIsMobile;
      var comp = { template: '\n        <v-editor-form\n        :value="value"\n        v-on:close="$emit(\'close\')"\n        v-on:change="onChange"\n        :fullscreen="fullscreen"></v-editor-form>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            onChange: function onChange(data) {
              return resolve(data);
            },
            value: value
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_1__dialogs_js__["a" /* default */].modal(comp);
    });
  },
  openEmail: function openEmail(value) {
    console.log('openEmail', value);
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__dialogs_js__["a" /* default */].register('v-email-form', __WEBPACK_IMPORTED_MODULE_6__EmailForm_vue___default.a);
      var fullscreen = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getIsMobile;
      var comp = { template: '\n        <v-email-form\n        :model="value"\n        v-on:close="$emit(\'close\')"\n        v-on:change="onChange"\n        :fullscreen="fullscreen"></v-email-form>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            onChange: function onChange(data) {
              return resolve(data);
            },
            value: value
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_1__dialogs_js__["a" /* default */].modal(comp);
    });
  }
});

/***/ }),
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(806)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(808),
  /* template */
  __webpack_require__(811),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 55 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(858),
  /* template */
  __webpack_require__(859),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);



var FieldObject = function () {
  function FieldObject(cxt, name, type, ref, fieldValue, def) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, FieldObject);

    this.cxt = cxt;
    this.name = name;
    this.type = type;
    this.ref = ref;
    this.fieldValue = fieldValue;
    this.def = def;
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(FieldObject, [{
    key: 'getCode',
    value: function getCode(model) {
      return model[this.name] ? model[this.name] + '' : null;
    }
  }, {
    key: 'setCode',
    value: function setCode(model, newCode, onChange) {
      this.setValue(model, newCode, null, onChange);
    }
  }, {
    key: 'getValue',
    value: function getValue(model) {
      return model[this.name];
    }
  }, {
    key: 'setValue',
    value: function setValue(model, newCode, newObject, onChange) {
      // console.log('FieldObject.setValue', newCode, newObject)
      if (!this.equalCode(model, newCode)) {
        onChange && onChange(model, this.name, newCode);
        model[this.name] = newCode;
      }
    }
  }, {
    key: 'equalCode',
    value: function equalCode(model, value) {
      //    console.log('FieldObject.equalCode', this.name, value, (!!this.getCode(model)) && (!!value) && (this.getCode(model) === value))
      return !!this.getCode(model) && !!value && this.getCode(model) === value;
    }
  }, {
    key: 'init',
    value: function init(model) {
      this.setValue(model, null);
    }
  }, {
    key: 'initDescription',
    value: function initDescription(model) {}
  }, {
    key: 'getDescription',
    value: function getDescription(model) {
      return '';
    }
  }, {
    key: 'getHint',
    value: function getHint(model) {
      return model[this.name];
    }
  }, {
    key: 'clearRef',
    value: function clearRef(model) {
      var _this = this;

      var refs = this.cxt.refMap.get(this.name);
      if (refs) {
        refs.forEach(function (r) {
          var fobj = _this.cxt.fieldObjects.get(r);
          fobj.init(model);
          fobj.clearRef(model);
        });
      }
    }
  }, {
    key: 'fillRef',
    value: function fillRef(model, data, onChange) {}
  }]);

  return FieldObject;
}();

/* harmony default export */ __webpack_exports__["a"] = (FieldObject);

/***/ }),
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__index_js__ = __webpack_require__(27);











var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy(cxt) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).call(this, cxt));

    _this.pProps = null;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'setContext',
    value: function setContext(cxt) {
      this.context = cxt;
    }
  }, {
    key: 'setParentProps',
    value: function setParentProps(pProps) {
      this.pProps = pProps;
    }
  }, {
    key: 'createModelFromJSON',
    value: function createModelFromJSON(json) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.createModel(), JSON.parse(json));
    }
  }, {
    key: 'createModelFromData',
    value: function createModelFromData(data) {
      if (data && data.model) {
        return this.createModelFromJSON(data.model);
      }
      return this.createDefaultModel(this.pProps);
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'fetchData',
    value: function fetchData(itemId) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (itemId) {
          __WEBPACK_IMPORTED_MODULE_9__index_js__["a" /* default */].getIndividualDoc(null, itemId).then(function (data) {
            resolve(data);
          });
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(itemId, model) {
      var _this2 = this;

      var item = {
        id: itemId,
        clientIndividualId: this.pProps ? this.pProps.id : null,
        type: this.getTypeCode(),
        model: model
      };
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this2.context.$store.dispatch('updatePeopleDoc', item).then(function (id) {
          resolve(id);
        });
      });
    }
  }, {
    key: 'deleteData',
    value: function deleteData(itemId, model) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_7__common_dialogs_js__["a" /* default */].confirm(_this3.context, 'Подтвердите', '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C \u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0435 ?', function (self) {
          self.$store.dispatch('deletePeopleDocs', { ids: [itemId] }).then(function () {
            return resolve();
          });
        });
      });
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      return '';
    }
  }, {
    key: 'viewTitle',
    value: function viewTitle(model) {
      return this.getTypeName() + ': ' + this.viewNumber(model);
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__["a" /* default */].Strategy);

/* harmony default export */ __webpack_exports__["a"] = ({
  Strategy: Strategy
});

/***/ }),
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */
/***/ (function(module, exports) {

module.exports = "data:application/vnd.ms-fontobject;base64,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"

/***/ }),
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(805),
  /* template */
  __webpack_require__(840),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(816),
  /* template */
  __webpack_require__(817),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(823)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(825),
  /* template */
  __webpack_require__(831),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__server__ = __webpack_require__(8);

/* harmony default export */ __webpack_exports__["a"] = ({
  readFileAsUrl: function readFileAsUrl(blob, cb) {
    var reader = new FileReader();
    reader.onload = function () {
      cb(reader.result);
    };
    reader.readAsDataURL(blob);
  },
  readFileAsByteArray: function readFileAsByteArray(blob, cb) {
    var reader = new FileReader();
    reader.onload = function () {
      cb(reader.result);
    };
    reader.readAsArrayBuffer(blob);
  },
  convertToCsv: function convertToCsv(file, data, cb, cbErr) {
    var _this = this;

    if (/.*\.csv/i.test(file.name)) {
      cb(data);
      return;
    }
    var fd = new FormData();
    fd.append('format', 'csv');
    fd.append('file', file);
    __WEBPACK_IMPORTED_MODULE_0__server__["a" /* default */].openApiPostConfig('/openapi/converts', fd, { responseType: 'blob' }, function (blob) {
      _this.readFileAsByteArray(blob, function (bytes) {
        cb(bytes);
      });
    }, function (e) {
      cbErr(e);
    });
  },
  notValidUtf: function notValidUtf(arr) {
    var result = false;
    for (var i = 0; i < arr.length; i++) {
      if ((arr[i] & 0xE0) === 0xC0 && !(i + 1 < arr.length && (arr[i + 1] & 0xC0) === 0x80)) {
        result = true;
        break;
      }
      if ((arr[i] & 0xF0) === 0xE0 && !(i + 2 < arr.length && (arr[i + 1] & 0xC0) === 0x80 && (arr[i + 2] & 0xC0) === 0x80)) {
        result = true;
        break;
      }
      if ((arr[i] & 0xF8) === 0xF0 && !(i + 3 < arr.length && (arr[i + 1] & 0xC0) === 0x80 && (arr[i + 2] & 0xC0) === 0x80 && (arr[i + 3] & 0xC0) === 0x80)) {
        result = true;
        break;
      }
    }
    return result;
  },
  decode: function decode(bytes, codepage) {
    if (!bytes) {
      return '';
    }
    if (codepage) {
      return new TextDecoder(codepage).decode(bytes);
    }
    if (!this.notValidUtf(new Uint8Array(bytes))) {
      // No Rus win1251 symbols, looks like it is utf-8, not support more 2 byte unicode
      return new TextDecoder('UTF-8').decode(bytes);
    }
    return new TextDecoder('windows-1251').decode(bytes);
  },
  parseCsv: function parseCsv(str) {
    // https://gist.github.com/Jezternz/c8e9fafc2c114e079829974e3764db75
    var csvStringToArray = function csvStringToArray(strData, delimiter) {
      var objPattern = new RegExp('(' + delimiter + '|\\r?\\n|\\r|^)(?:"([^"]*(?:""[^"]*)*)"|([^' + delimiter + '\\r\\n]*))', 'gi');
      var arrMatches = null;
      var arrData = [[]];
      arrMatches = objPattern.exec(strData);
      while (arrMatches) {
        if (arrMatches[1].length && arrMatches[1] !== delimiter) {
          arrData.push([]);
        }
        arrData[arrData.length - 1].push(arrMatches[2] ? arrMatches[2].replace(new RegExp('""', 'g'), '"') : arrMatches[3]);
        arrMatches = objPattern.exec(strData);
      }
      return arrData;
    };
    if (str) {
      var delimiterExpr = /,|;/g;
      var delimiter = str.search(delimiterExpr) >= 0 ? str[str.search(delimiterExpr)] : ',';
      return csvStringToArray(str, delimiter);
    }
    return [];
  },
  import: function _import(fields, data, dateFormat) {
    var map = [];
    var keyField = null;
    fields.forEach(function (f) {
      map[f.name] = f.number;
      if (f.key || !keyField) {
        keyField = f.name;
      }
    });
    var _g = function _g(rec, name) {
      return map[name] !== null ? rec[map[name]] : null;
    };
    var _n = function _n(val) {
      if (!val) return null;
      val = val.replace(/\s/g, '');
      if (/,.*\.+/g.test(val)) {
        val = val.replace(/,/g, '');
      }
      if (!/,.*\.+/g.test(val)) {
        val = val.replace(/,/g, '.');
      }
      return Number(val);
    };
    var _d = function _d(val) {
      var formatDateToISO = function formatDateToISO(dateTime) {
        return new Date(dateTime).toISOString().slice(0, 10);
      };
      if (!val) return null;
      var v = val.trim();
      var result = null;
      var ms = null;
      switch (dateFormat) {
        case 'YYYY-MM-DD':
          ms = /^((?:19|20)\d\d)-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[0,1])$/.exec(v);
          result = ms ? ms[1] + '-' + ms[2] + '-' + ms[3] : null;
          break;
        case 'DD/MM/YYYY':
          ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\/(0[1-9]|1[012])\/((?:19|20)\d\d)$/.exec(v);
          result = ms ? ms[3] + '-' + ms[2] + '-' + ms[1] : null;
          break;
        case 'DD/MM/YY':
          ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\/(0[1-9]|1[012])\/(\d\d)$/.exec(v);
          result = ms ? '20' + ms[3] + '-' + ms[2] + '-' + ms[1] : null;
          break;
        case 'DD.MM.YYYY':
          ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\.(0[1-9]|1[012])\.((?:19|20)\d\d)$/.exec(v);
          result = ms ? ms[3] + '-' + ms[2] + '-' + ms[1] : null;
          break;
        case 'DD.MM.YY':
          ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\.(0[1-9]|1[012])\.(\d\d)$/.exec(v);
          result = ms ? '20' + ms[3] + '-' + ms[2] + '-' + ms[1] : null;
          break;
      }
      return result === formatDateToISO(result) ? result : null;
    };
    var result = {};
    data.forEach(function (r, index) {
      if (index !== 0 && _g(r, keyField)) {
        var item = {};
        fields.forEach(function (f) {
          switch (f.type) {
            case 'NUMBER':
              item[f.name] = _n(_g(r, f.name));
              break;
            case 'DATE':
              item[f.name] = _d(_g(r, f.name));
              break;
            default:
              item[f.name] = _g(r, f.name);
          }
        });
        result[_g(r, keyField) + ''] = item;
      }
    });
    return result;
  },
  errorFileMessage: function errorFileMessage(file) {
    if (file && file.size && file.size >= 16777216) {
      return 'Поддерживаются файлы до 16Мб';
    }
    return null;
  }
});

/***/ }),
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__people_index_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__companyBank_js__ = __webpack_require__(923);


// import router from '../../router'
// import dialogs from '../common/dialogs'
// import vPersonForm from './PersonForm'



// import formats from '../../api/formats'

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: function createStrategy(cxt, type) {
    switch (type) {
      case 'COMPANY_BANK':
        {
          return __WEBPACK_IMPORTED_MODULE_4__companyBank_js__["a" /* default */].createStrategy(cxt);
        }
    }
  },
  selectCompanyBankByInn: function selectCompanyBankByInn(cxt, refCode, itemId) {
    var _this = this;

    var _f = function _f(v) {
      return v || '-';
    };
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      _this.getCompanyBanks(refCode).then(function (banks) {
        var items = [];
        banks.forEach(function (ba) {
          items.push({ value: ba.id, text: _f(ba.name) + ': ' + _f(ba.bankName) + ', ' + _f(ba.bankAccount) });
        });
        __WEBPACK_IMPORTED_MODULE_3__common_forms_js__["a" /* default */].selectItem(items, [], 'Выберите Банк').then(function (data) {
          return resolve(data);
        });
      }, function () {
        console.log('selectCompanyBankByInn - error');
        return;
      });
    });
  },
  openCompanyBank: function openCompanyBank(itemId, refCode, companyNameShort, clientCompanyId) {
    var _this2 = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var strategy = _this2.createStrategy(null, 'COMPANY_BANK');
      strategy.setParentProps({ refCode: refCode, companyNameShort: companyNameShort, clientCompanyId: clientCompanyId });
      __WEBPACK_IMPORTED_MODULE_3__common_forms_js__["a" /* default */].openFormStg(strategy, itemId).then(function (data) {
        return resolve(data);
      });
    });
  },
  openCompanyContact: function openCompanyContact(itemId, refCode, companyNameShort, clientCompanyId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var strategy = __WEBPACK_IMPORTED_MODULE_2__people_index_js__["a" /* default */].createStrategy(null, 'CONTACT');
      strategy.setParentProps({ refCode: refCode, nameShort: companyNameShort, clientCompanyId: clientCompanyId });
      __WEBPACK_IMPORTED_MODULE_3__common_forms_js__["a" /* default */].openFormStg(strategy, itemId).then(function (data) {
        return resolve(data);
      });
    });
  },
  getCompanyRef: function getCompanyRef(refCode) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('getFavoriteRefs', refCode).then(function (data) {
        return resolve(data[0]);
      });
    });
  },
  getCompanyBanks: function getCompanyBanks(refCode) {
    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('getCompanyBanks', refCode);
  }
});

/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldObject_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__people__ = __webpack_require__(27);









var JsonField = function (_FieldObject) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(JsonField, _FieldObject);

  function JsonField() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, JsonField);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (JsonField.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(JsonField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(JsonField, [{
    key: 'getStrategy',
    value: function getStrategy() {
      return __WEBPACK_IMPORTED_MODULE_7__people__["a" /* default */].createStrategy(this.cxt.context, this.type);
    }
  }, {
    key: 'getCode',
    value: function getCode(model) {
      return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null;
    }
  }, {
    key: 'setCode',
    value: function setCode(model, newCode, onChange) {
      var _this2 = this;

      var fstrategy = this.getStrategy();
      fstrategy.fetchData(newCode).then(function (data) {
        _this2.setValue(model, newCode, fstrategy.createModelFromData(data), onChange);
        _this2.fillRef(model, data, onChange);
        _this2.cxt.updateItems(model);
      });
    }
  }, {
    key: 'setValue',
    value: function setValue(model, newCode, newObject, onChange) {
      if (!this.equalCode(model, newCode)) {
        onChange && onChange(model, this.name, newCode);
        model[this.name + '_CODE'] = newCode ? newCode + '' : null;
      }
      model[this.name] = newCode ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newObject) : null;
    }
  }, {
    key: 'fillRef',
    value: function fillRef(model, data, onChange) {}
  }]);

  return JsonField;
}(__WEBPACK_IMPORTED_MODULE_6__FieldObject_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (JsonField);

/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Action_js__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionProp_vue__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ActionProp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ActionProp_vue__);







/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: function createStrategy(cxt, type) {
    switch (type) {
      case 'ACTION':
        {
          return __WEBPACK_IMPORTED_MODULE_2__Action_js__["a" /* default */].createStrategy(cxt);
        }
    }
  },
  openLogAction: function openLogAction(itemId, resourceId) {
    var _this = this;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var strategy = _this.createStrategy(null, 'ACTION');
      _this.openPropStg(strategy, itemId, resourceId).then(function (data) {
        resolve(data);
      });
    });
  },
  openPropStg: function openPropStg(strategy, itemId, resourceId) {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__common_dialogs_js__["a" /* default */].register('v-action-prop', __WEBPACK_IMPORTED_MODULE_4__ActionProp_vue___default.a);
      var fullscreen = __WEBPACK_IMPORTED_MODULE_3__store__["a" /* default */].getters.getIsMobile;
      strategy.updateSteps();
      var comp = { template: '\n        <v-action-prop\n        :itemId="itemId"\n        :resourceId="resourceId"\n        :strategy="strategy"\n        v-on:close="onClose"\n        :fullscreen="fullscreen"></v-action-prop>\n        ',
        data: function data() {
          var _this2 = this;

          return {
            fullscreen: fullscreen,
            itemId: itemId ? itemId.toString() : null,
            resourceId: resourceId ? resourceId.toString() : null,
            strategy: strategy,
            onClose: function onClose() {
              _this2.$emit('close');
              resolve();
            }
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_1__common_dialogs_js__["a" /* default */].modal(comp);
    });
  }
});

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1020),
  /* template */
  __webpack_require__(1021),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(712);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Full__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers_Full___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__containers_Full__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_login_Login__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_login_Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_login_Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_login_Register__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_login_Register___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_login_Register__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_login_Agreement__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_login_Agreement___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_login_Agreement__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profile_Profile__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_profile_Profile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_profile_Profile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_profile_ActionLogPage__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_profile_ActionLogPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_profile_ActionLogPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_client_ClientProfile__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_client_ClientProfile___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_client_ClientProfile__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_client_ClientPanel__ = __webpack_require__(1010);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_client_ClientPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_client_ClientPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_people_PeoplePanel__ = __webpack_require__(1119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_people_PeoplePanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_people_PeoplePanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_favorite_FavoriteCompanyPanel__ = __webpack_require__(1128);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_favorite_FavoriteCompanyPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_favorite_FavoriteCompanyPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_MainPage__ = __webpack_require__(1137);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_MainPage___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_MainPage__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_favorite_MonitoringPanel__ = __webpack_require__(1143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_favorite_MonitoringPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_favorite_MonitoringPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_assist_AssistPanel__ = __webpack_require__(1149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_assist_AssistPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_assist_AssistPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_depo_DocList__ = __webpack_require__(1171);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_depo_DocList___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__components_depo_DocList__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_depo_DocForm__ = __webpack_require__(463);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__components_depo_DocForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__components_depo_DocForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_depo_DocDlg__ = __webpack_require__(1180);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__components_depo_DocDlg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__components_depo_DocDlg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chat_ChatPanel__ = __webpack_require__(1186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__components_chat_ChatPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__components_chat_ChatPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chat_Chat__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__components_chat_Chat___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__components_chat_Chat__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_NotImplemented__ = __webpack_require__(1223);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__components_NotImplemented___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__components_NotImplemented__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Test__ = __webpack_require__(1226);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__components_Test___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__components_Test__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__containers_NewWindow__ = __webpack_require__(1229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__containers_NewWindow___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__containers_NewWindow__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_gate_Payment__ = __webpack_require__(1232);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__components_gate_Payment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__components_gate_Payment__);



























__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  from: {},
  routes: [{
    path: '/new_window',
    name: 'NewWindow',
    component: __WEBPACK_IMPORTED_MODULE_24__containers_NewWindow___default.a
  }, {
    path: '/',
    redirect: '/home',
    name: 'Home',
    component: __WEBPACK_IMPORTED_MODULE_4__containers_Full___default.a,
    children: [{
      path: 'home',
      name: 'MainPage',
      component: __WEBPACK_IMPORTED_MODULE_14__components_MainPage___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'file/:uid',
      name: 'DocDlg',
      component: __WEBPACK_IMPORTED_MODULE_19__components_depo_DocDlg___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'login',
      name: 'Login',
      component: __WEBPACK_IMPORTED_MODULE_5__components_login_Login___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'register',
      name: 'Register',
      component: __WEBPACK_IMPORTED_MODULE_6__components_login_Register___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'agreement',
      name: 'Agreement',
      component: __WEBPACK_IMPORTED_MODULE_7__components_login_Agreement___default.a
    }, {
      path: 'profile',
      name: 'Profile',
      component: __WEBPACK_IMPORTED_MODULE_8__components_profile_Profile___default.a
    }, {
      path: 'profile_log',
      name: 'ActionLogPage',
      component: __WEBPACK_IMPORTED_MODULE_9__components_profile_ActionLogPage___default.a
    }, {
      path: 'client_profile',
      name: 'ClientProfile',
      component: __WEBPACK_IMPORTED_MODULE_10__components_client_ClientProfile___default.a
    }, {
      path: 'doc_list/:folderName',
      name: 'DocList',
      component: __WEBPACK_IMPORTED_MODULE_17__components_depo_DocList___default.a,
      children: [{
        path: 'doc/:uid',
        name: 'DocForm',
        component: __WEBPACK_IMPORTED_MODULE_18__components_depo_DocForm___default.a
      }],
      meta: { requiresAuth: false }
    }, {
      path: 'chats/:chatId',
      name: 'ChatPanel',
      component: __WEBPACK_IMPORTED_MODULE_20__components_chat_ChatPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: '/chat',
      name: 'Chat',
      component: __WEBPACK_IMPORTED_MODULE_21__components_chat_Chat___default.a
    }, {
      path: 'clients',
      name: 'ClientList',
      component: __WEBPACK_IMPORTED_MODULE_11__components_client_ClientPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'clients/:clientInn',
      name: 'ClientPanel',
      component: __WEBPACK_IMPORTED_MODULE_11__components_client_ClientPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'loners/:ogrnip',
      name: 'LonerPage',
      component: __WEBPACK_IMPORTED_MODULE_11__components_client_ClientPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'humans/:humanId',
      name: 'HumanPanel',
      component: __WEBPACK_IMPORTED_MODULE_11__components_client_ClientPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'fagency/:fagencyId',
      name: 'ForeignAgencyPanel',
      component: __WEBPACK_IMPORTED_MODULE_11__components_client_ClientPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'foreigns/:foreignId',
      name: 'ForeignPanel',
      component: __WEBPACK_IMPORTED_MODULE_11__components_client_ClientPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'favoritecompanies',
      name: 'FavoriteCompanyPanel',
      component: __WEBPACK_IMPORTED_MODULE_13__components_favorite_FavoriteCompanyPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'monitoring_page',
      name: 'MonitoringPage',
      component: __WEBPACK_IMPORTED_MODULE_15__components_favorite_MonitoringPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'cagents/:cagentId',
      name: 'CAgentPage',
      component: __WEBPACK_IMPORTED_MODULE_13__components_favorite_FavoriteCompanyPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'assist',
      name: 'AssistPanel',
      component: __WEBPACK_IMPORTED_MODULE_16__components_assist_AssistPanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'assist/:matterId',
      name: 'AssistPage',
      component: __WEBPACK_IMPORTED_MODULE_16__components_assist_AssistPanel___default.a
    }, {
      path: 'people',
      name: 'PeoplePanel',
      component: __WEBPACK_IMPORTED_MODULE_12__components_people_PeoplePanel___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'people/:personId',
      name: 'PersonPage',
      component: __WEBPACK_IMPORTED_MODULE_12__components_people_PeoplePanel___default.a
    }, {
      path: 'payment',
      name: 'Payment',
      component: __WEBPACK_IMPORTED_MODULE_25__components_gate_Payment___default.a,
      meta: { requiresAuth: false }
    }, {
      path: 'notImplemented',
      name: 'NotImplemented',
      component: __WEBPACK_IMPORTED_MODULE_22__components_NotImplemented___default.a
    }, {
      path: 'test',
      name: 'Test',
      component: __WEBPACK_IMPORTED_MODULE_23__components_Test___default.a
    }]
  }]
});

router.beforeEach(function (to, from, next) {
  console.log('to', to, 'from', from, 'isModal', __WEBPACK_IMPORTED_MODULE_3__components_common_dialogs__["a" /* default */].isModal());
  if (__WEBPACK_IMPORTED_MODULE_3__components_common_dialogs__["a" /* default */].isModal()) {
    // Disable route if Modal dialog is opened
    next(false);
    return;
  }
  if (to.name !== 'Login') {
    var isAuthorized = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getIsAuthorized(true);
    var isProfileLoaded = __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].getters.getProfileLoaded;
    if (!isAuthorized) {
      if (!(to.meta && to.meta.requiresAuth === false)) {
        next({
          path: '/login',
          query: {
            redirect: to.fullPath
          }
        });
      } else {
        next();
      }
    } else {
      if (!isProfileLoaded) {
        __WEBPACK_IMPORTED_MODULE_2__store__["a" /* default */].dispatch('fetchAccountProfile');
      }
      router.options.from = from;
      next();
    }
  } else {
    next();
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 143 */,
/* 144 */,
/* 145 */,
/* 146 */,
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);

function isIE() {
  return (/Trident\/|MSIE/.test(window.navigator.userAgent)
  );
}

function getOrientation(file, callback) {
  var reader = new FileReader();
  reader.onload = function (e) {
    var view = new DataView(e.target.result);
    if (view.getUint16(0, false) !== 0xFFD8) {
      return callback(-2);
    }
    var length = view.byteLength;
    var offset = 2;
    while (offset < length) {
      if (view.getUint16(offset + 2, false) <= 8) return callback(-1);
      var marker = view.getUint16(offset, false);
      offset += 2;
      if (marker === 0xFFE1) {
        if (view.getUint32(offset += 2, false) !== 0x45786966) {
          return callback(-1);
        }
        var little = view.getUint16(offset += 6, false) === 0x4949;
        offset += view.getUint32(offset + 4, little);
        var tags = view.getUint16(offset, little);
        offset += 2;
        for (var i = 0; i < tags; i++) {
          if (view.getUint16(offset + i * 12, little) === 0x0112) {
            return callback(view.getUint16(offset + i * 12 + 8, little));
          }
        }
      } else if ((marker & 0xFF00) !== 0xFF00) {
        break;
      } else {
        offset += view.getUint16(offset, false);
      }
    }
    return callback(-1);
  };
  reader.readAsArrayBuffer(file);
}

function setTransformations(canvas, scale, srcOrientation, cb) {
  var width = canvas.width * scale;
  var height = canvas.height * scale;
  // set proper canvas dimensions before transform & export
  if (srcOrientation > 4 && srcOrientation < 9) {
    canvas.width = height;
    canvas.height = width;
  } else {
    canvas.width = width;
    canvas.height = height;
  }
  // transform context before drawing image
  var ctx = canvas.getContext('2d');
  switch (srcOrientation) {
    case 2:
      ctx.transform(-1, 0, 0, 1, width, 0);
      break;
    case 3:
      ctx.transform(-1, 0, 0, -1, width, height);
      break;
    case 4:
      ctx.transform(1, 0, 0, -1, 0, height);
      break;
    case 5:
      ctx.transform(0, 1, 1, 0, 0, 0);
      break;
    case 6:
      ctx.transform(0, 1, -1, 0, height, 0);
      break;
    case 7:
      ctx.transform(0, -1, -1, 0, height, width);
      break;
    case 8:
      ctx.transform(0, -1, 1, 0, 0, width);
      break;
    default:
      break;
  }
  ctx.transform(scale, 0, 0, scale, 0, 0);
  cb();
}

function _compress(file, cb, props) {
  if ('image/jpeg, image/png, image/gif, image/ico, image/bmp, image/x-bmp'.toUpperCase().includes(file.type.toUpperCase())) {
    props = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({ maxWidth: 1280, quality: 0.8 }, props);
    var fr = new FileReader();
    fr.onload = function (e) {
      var img = new Image();
      img.onload = function () {
        getOrientation(file, function (srcOrientation) {
          var scale = props.maxWidth >= img.width ? 1 : props.maxWidth / img.width;
          var canvas = document.createElement('canvas');
          document.body.appendChild(canvas);
          canvas.width = img.width;
          canvas.height = img.height;
          setTransformations(canvas, scale, srcOrientation, function () {
            var ctx = canvas.getContext('2d');
            ctx.drawImage(img, 0, 0);
            ctx.canvas.toBlob(function (blob) {
              var filename = file.name.substring(0, file.name.lastIndexOf('.')) + '.jpg';
              var newFile = new File([blob], filename, {
                type: 'image/jpeg',
                lastModified: Date.now()
              });
              document.body.removeChild(canvas);
              cb(newFile);
            }, 'image/jpeg', props.quality);
          });
        });
      };
      img.src = e.target.result;
    };
    fr.readAsDataURL(file);
  } else {
    cb(file);
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  copyContentToClipboard: function copyContentToClipboard(html, text) {
    var res = false;
    if (isIE()) {
      res = this.copyContentToClipboard1(html);
    } else {
      res = this.copyContentToClipboard2(html, text);
    }
    return res;
  },
  copyContentToClipboard2: function copyContentToClipboard2(html, text) {
    var modifyCopy = function modifyCopy(e) {
      if (text) {
        e.clipboardData.setData('text/plain', text);
      }
      if (html) {
        e.clipboardData.setData('text/html', html);
      }
      e.preventDefault();
    };
    var res = document.queryCommandSupported('copy');
    if (res) {
      document.addEventListener('copy', modifyCopy, { once: true });
      res = document.execCommand('copy');
      // If browser (safari Version 11.0.3 (13604.5.6)), could not copy without selection of any tag
      // we create and select new div with html and replace by our content in our listener
      if (!res) {
        res = this.copyContentToClipboard(html);
      }
    }
    return res;
  },
  elementSelect: function elementSelect(element) {
    this.elementDeSelect();
    if (document.selection) {
      var range = document.body.createTextRange();
      range.moveToElementText(element);
      range.select();
    } else if (window.getSelection) {
      var rangeNode = document.createRange();
      rangeNode.selectNode(element);
      window.getSelection().addRange(rangeNode);
    }
  },
  elementDeSelect: function elementDeSelect() {
    if (document.selection) {
      document.selection.empty();
    } else if (window.getSelection) {
      window.getSelection().removeAllRanges();
    }
  },
  copyTextToClipboard: function copyTextToClipboard(text) {
    var res = false;
    var input = document.createElement('textarea');
    input.value = text;
    document.body.appendChild(input);
    input.select();
    res = document.execCommand('copy');
    document.body.removeChild(input);
    return res;
  },
  copyElementToClipboard: function copyElementToClipboard(element) {
    this.elementSelect(element);
    var res = document.execCommand('copy');
    this.elementDeSelect();
    return res;
  },
  copyContentToClipboard1: function copyContentToClipboard1(content) {
    var res = false;
    try {
      var input = document.createElement('div');
      input.innerHTML = content;
      document.body.appendChild(input);
      res = this.copyElementToClipboard(input);
    } finally {
      document.body.removeChild(input);
    }
    return res;
  },
  copyHrefToClipboard: function copyHrefToClipboard(element) {
    element.style.display = 'block';
    var res = this.copyElementToClipboard(element);
    element.style.display = 'none';
    if (res) {
      alert('Ссылка на результаты скопирована в буфер обмена');
    } else {
      alert('К сожалению, Ваш браузер не позволяет автоматически копировать текст.\nВы можете самостоятельно скопировать ссылку из адресной строки браузера.');
    }
  },
  makepage: function makepage(title, html) {
    return '<html>\n' + '<head>\n' + '<META http-equiv=Content-Type content="text/html; charset=utf-8">\n' + '<title>' + title + '</title>\n' + '</head>\n' + '<body>\n' + html + '</body>\n' + '</html>\n';
  },
  compress: function compress(file, cb, props) {
    _compress(file, cb, props);
  }
});

/***/ }),
/* 153 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);







var ItemSet = function () {
  function ItemSet(keyCb, filterContext) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ItemSet);

    this.keyCb = keyCb;
    this.items = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
    this.loadedPages = null;
    this.total = 0;
    this.last = false;
    this.sort = null;
    this.page = 0;
    this.filter = filterContext || {
      search: ''
    };
    this.filterChanged = true;
    this.processing = false;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ItemSet, [{
    key: 'setItems',
    value: function setItems(data, cxt) {
      var self = this;
      var concatMaps = function concatMaps(map) {
        for (var _len = arguments.length, iterables = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          iterables[_key - 1] = arguments[_key];
        }

        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(iterables), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var iterable = _step.value;
            var _iteratorNormalCompletion2 = true;
            var _didIteratorError2 = false;
            var _iteratorError2 = undefined;

            try {
              for (var _iterator2 = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_get_iterator___default()(iterable), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
                var item = _step2.value;

                map.set(self.keyCb(item), item);
              }
            } catch (err) {
              _didIteratorError2 = true;
              _iteratorError2 = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion2 && _iterator2.return) {
                  _iterator2.return();
                }
              } finally {
                if (_didIteratorError2) {
                  throw _iteratorError2;
                }
              }
            }
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }
      };
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.filter) === __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(cxt)) {
        this.processing = false;
        if (this.loadedPages === null || data.first) {
          this.items = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a();
        }
        var map = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_map___default.a(this.items);
        concatMaps(map, data.content);
        this.items = map;
        this.last = data.last;
        if (data.totalPages) {
          this.loadedPages = this.last === false ? data.number + 1 : data.totalPages;
          this.total = data.totalElements;
        } else {
          this.loadedPages = this.last === false ? data.number + 1 : this.loadedPages;
          this.total = this.last === false ? this.getLoadedSize() + 1 : this.getLoadedSize();
        }
      }
    }
  }, {
    key: 'getItems',
    value: function getItems() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(this.items.values());
    }
  }, {
    key: 'getLoadedSize',
    value: function getLoadedSize() {
      return this.items.size;
    }
  }, {
    key: 'getTotal',
    value: function getTotal() {
      return this.total;
    }
  }, {
    key: 'isLast',
    value: function isLast() {
      return this.last;
    }
  }, {
    key: 'getFilter',
    value: function getFilter() {
      return this.filter;
    }
  }, {
    key: 'setFilter',
    value: function setFilter(cxt) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.filter) !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(cxt)) {
        this.loadedPages = null;
        this.last = false;
        this.page = 0;
        this.filter = cxt;
        this.filterChanged = true;
      }
    }
  }, {
    key: 'getSort',
    value: function getSort() {
      return this.sort;
    }
  }, {
    key: 'setSort',
    value: function setSort(sort) {
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.sort) !== __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(sort)) {
        this.loadedPages = null;
        this.last = false;
        this.page = 0;
        this.sort = sort;
        this.filterChanged = true;
      }
    }
  }, {
    key: 'isChanged',
    value: function isChanged() {
      return this.filterChanged;
    }
  }, {
    key: 'clearChanged',
    value: function clearChanged() {
      this.filterChanged = false;
    }
  }, {
    key: 'start',
    value: function start() {
      this.processing = true;
    }
  }, {
    key: 'stop',
    value: function stop() {
      this.processing = false;
    }
  }, {
    key: 'isProcessing',
    value: function isProcessing() {
      return this.processing;
    }
  }, {
    key: 'nextPage',
    value: function nextPage() {
      if (!this.isLast()) {
        if (this.page !== this.loadedPages) {
          if (this.getLoadedSize() < this.total) {
            this.page = this.loadedPages ? this.loadedPages : 0;
            this.filterChanged = true;
          }
        }
      }
    }
  }]);

  return ItemSet;
}();

/* harmony default export */ __webpack_exports__["a"] = ({
  ItemSet: ItemSet
});

/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(836)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(838),
  /* template */
  __webpack_require__(839),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get__ = __webpack_require__(890);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__people__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__fields_SimpleField__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__fields_CompanyField__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__fields_JsonField__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__fields_HoldersField__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__fields_CompanyFilesField__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__fields_CalcField__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__fields_IndividualField__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__fields_ContactField__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__fields_PersonDocField__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__fields_CompanyBankField__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__fields_ActionField__ = __webpack_require__(950);


























var Step = function (_AssistClasses$Step) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(Step, _AssistClasses$Step);

  function Step(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Step);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Step.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Step)).call(this, 'Укажите данные для создания документа', null, {
      scheme: []
    }, {}));

    _this.context = cxt;
    _this.editable = true;
    _this.refMap = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
    _this.fieldObjects = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_map___default.a();
    _this.items = [];
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Step, [{
    key: 'calcHeighEditor',
    value: function calcHeighEditor(rows, type) {
      if (type === 'macro') {
        rows = rows > 0 ? rows : 1;
        return rows * 20 + 18 + 'px';
      }
      rows = rows > 0 ? rows : 6;
      return rows * 20 + 32 + 'px';
    }
  }, {
    key: 'fillFields',
    value: function fillFields(fields) {
      var _this2 = this;

      // const ruleInn = v => !v || formats.isInn(v) || 'Введите ИНН или Выберите компанию из списка'
      var onChange = function onChange(model, fieldName, value) {
        return _this2.onChange(model, fieldName, value);
      };
      var onCompanyChange = function onCompanyChange(model, fieldName, value) {
        console.log('onCompanyChange', fieldName, value);
        if (__WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].isRefCode(value)) {
          var fobj = _this2.getFieldObject(fieldName);
          if (fobj) {
            fobj.fillRef(model, value, onChange);
          }
        } else {
          onChange(model, fieldName, value);
        }
      };
      var onSimpleChange = function onSimpleChange(model, fieldName, value) {
        console.log('onSimpleChange', fieldName, value);
        var fobj = _this2.getFieldObject(fieldName);
        if (fobj) {
          fobj.fillRef(model, value, onChange);
        }
      };
      if (!fields) {
        this.props.scheme = [];
        return this;
      }
      var persistentHint = true;
      var lScheme = [];
      fields.forEach(function (f) {
        var fullFieldName = !f.target ? '' + f.name : '/' + f.target + '/' + f.name;
        var fieldValue = f.value;
        switch (f.type) {
          case 'company':
            lScheme.push({
              fieldType: 'v-chips-field',
              emptyChip: function emptyChip(model, field) {
                return field.name !== model['postListField'] ? 'Выбрать' : 'Заполняется из списка';
              },
              label: f.label,
              name: fullFieldName + '_CODE',
              defValue: f.value,
              disabled: function disabled(model, field) {
                return field.name === model['postListField'] || f.value === 'self';
              },
              events: {
                'remove': function remove() {
                  var fobj = _this2.getFieldObject(fullFieldName);
                  if (fobj) {
                    fobj.setCode(_this2.model, null, onChange);
                  }
                },
                'click': function click() {
                  return _this2.onClick(fullFieldName, onCompanyChange);
                }
              },
              chipSize: 30,
              items: function items(model, field) {
                return _this2.items.filter(function (i) {
                  return i.fieldName === fullFieldName;
                });
              },
              hint: function hint(model, field) {
                return f.hint;
              },
              size: { sm12: true, xs12: true }
            });
            _this2.addFieldObject(_this2.createFieldObject(fullFieldName, f.value, f.type, f.def));
            _this2.addToModel(fullFieldName);
            break;
          case 'json':
            _this2.addFieldObject(_this2.createFieldObject(fullFieldName, f.value, f.type, f.def));
            _this2.addToModel(fullFieldName);
            lScheme.push({
              fieldType: 'v-chips-field',
              emptyChip: 'Выбрать',
              label: f.label,
              name: fullFieldName + '_CODE',
              defValue: f.value,
              events: {
                'remove': function remove() {
                  var fobj = _this2.getFieldObject(fullFieldName);
                  if (fobj) {
                    fobj.setCode(_this2.model, null, onChange);
                  }
                },
                'click': function click() {
                  return _this2.onClick(fullFieldName, onChange);
                }
              },
              chipSize: 30,
              items: function items(model, field) {
                //              console.log('json', this.items.filter(i => i.fieldName === fullFieldName))
                return _this2.items.filter(function (i) {
                  return i.fieldName === fullFieldName;
                });
              },
              size: { sm12: true, xs12: true }
            });
            break;
          case 'text':
            _this2.addFieldObject(new __WEBPACK_IMPORTED_MODULE_14__fields_SimpleField__["a" /* default */](_this2, fullFieldName, 'TEXT', null, f.value));
            _this2.addToModel(fullFieldName);
            lScheme.push({
              fieldType: 'v-text-field',
              label: f.label,
              hint: f.hint,
              persistentHint: persistentHint,
              name: fullFieldName,
              size: { sm10: true }
            });
            break;
          case 'macro':
            _this2.addFieldObject(new __WEBPACK_IMPORTED_MODULE_14__fields_SimpleField__["a" /* default */](_this2, fullFieldName, 'TEXT', null, f.value));
            _this2.addToModel(fullFieldName);
            lScheme.push({
              fieldType: 'v-macro-field',
              label: f.label,
              hint: f.hint,
              persistentHint: persistentHint,
              name: fullFieldName,
              macro: true,
              heightEditor: _this2.calcHeighEditor(f.rows, f.type),
              events: {
                'check': function check(content) {
                  return _this2.onMacroCheck(fullFieldName, content);
                }
              },
              size: { sm10: true }
            });
            break;
          case 'email':
            _this2.addFieldObject(new __WEBPACK_IMPORTED_MODULE_14__fields_SimpleField__["a" /* default */](_this2, fullFieldName, 'TEXT', null, f.value));
            _this2.addToModel(fullFieldName);
            lScheme.push({
              fieldType: 'v-text-field',
              label: f.label,
              hint: f.hint,
              persistentHint: persistentHint,
              name: fullFieldName,
              size: { sm10: true }
            });
            break;
          case 'textarea':
            _this2.addFieldObject(new __WEBPACK_IMPORTED_MODULE_14__fields_SimpleField__["a" /* default */](_this2, fullFieldName, 'TEXT', null, f.value));
            _this2.addToModel(fullFieldName);
            if (fullFieldName !== '/email-send/body') {
              lScheme.push({
                fieldType: 'v-textarea',
                label: f.label,
                hint: f.hint,
                persistentHint: persistentHint,
                name: fullFieldName,
                rows: f.rows > 0 ? f.rows : 1,
                size: { sm10: true }
              });
            } else {
              lScheme.push({
                fieldType: 'v-html-field',
                label: f.label,
                hint: f.hint,
                persistentHint: persistentHint,
                name: fullFieldName,
                macro: true,
                heightEditor: _this2.calcHeighEditor(f.rows, f.type),
                events: {
                  'check': function check(content) {
                    return _this2.onMacroCheck(fullFieldName, content);
                  }
                },
                size: { sm10: true }
              });
            }
            break;
          case 'html':
            _this2.addFieldObject(new __WEBPACK_IMPORTED_MODULE_14__fields_SimpleField__["a" /* default */](_this2, fullFieldName, 'TEXT', null, f.value));
            _this2.addToModel(fullFieldName);
            lScheme.push({
              fieldType: 'v-html-field',
              label: f.label,
              hint: f.hint,
              persistentHint: persistentHint,
              name: fullFieldName,
              macro: true,
              heightEditor: _this2.calcHeighEditor(f.rows, f.type),
              events: {
                'check': function check(content) {
                  return _this2.onMacroCheck(fullFieldName, content);
                }
              },
              size: { sm10: true }
            });
            break;
          case 'date':
            _this2.addFieldObject(new __WEBPACK_IMPORTED_MODULE_14__fields_SimpleField__["a" /* default */](_this2, fullFieldName, 'DATE', null, f.value));
            _this2.addToModel(fullFieldName);
            lScheme.push({
              fieldType: 'v-date-field',
              label: f.label,
              hint: f.hint,
              events: {
                'input': function input(value) {
                  return onSimpleChange(_this2.model, fullFieldName, value);
                }
              },
              persistentHint: persistentHint,
              name: fullFieldName,
              size: { sm10: true }
            });
            break;
          case 'select':
            _this2.addFieldObject(new __WEBPACK_IMPORTED_MODULE_14__fields_SimpleField__["a" /* default */](_this2, fullFieldName, 'SELECT', null, fieldValue));
            _this2.addToModel(fullFieldName);
            lScheme.push({
              fieldType: 'v-select',
              label: f.label,
              hint: f.hint,
              items: f.options,
              persistentHint: persistentHint,
              name: fullFieldName,
              size: { sm10: true }
            });
            break;
          case 'radio':
            _this2.addFieldObject(new __WEBPACK_IMPORTED_MODULE_14__fields_SimpleField__["a" /* default */](_this2, fullFieldName, 'RADIO', null, fieldValue));
            _this2.addToModel(fullFieldName);
            lScheme.push({
              fieldType: 'v-select-radio',
              label: f.label,
              hint: f.hint,
              itemText: 'text',
              itemValue: 'value',
              items: f.options,
              persistentHint: persistentHint,
              name: fullFieldName,
              size: { sm10: true }
            });
            break;
          case 'comment':
            lScheme.push({
              slot: f.value.replaceAll('[', '<').replaceAll(']', '>'),
              fieldType: 'v-flex',
              shrink: false,
              size: { sm10: true }
            });
            break;
        }
      });
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'next',
    value: function next(model, cb) {
      return cb(model);
    }
  }, {
    key: 'addRef',
    value: function addRef(fieldName, reference) {
      if (!reference) {
        return;
      }
      if (this.refMap.get(reference)) {
        this.refMap.get(reference).add(fieldName);
      } else {
        this.refMap.set(reference, new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a([fieldName]));
      }
    }
  }, {
    key: 'createFieldObject',
    value: function createFieldObject(fieldName, fieldValue, fieldType, fieldDef) {
      var type = null;
      var ref = null;
      switch (fieldType) {
        case 'company':
          type = 'COMPANY';
          matches = new RegExp('/{0,1}(self)').exec(fieldValue);
          if (matches) {
            ref = 'SELF';
          }
          return new __WEBPACK_IMPORTED_MODULE_15__fields_CompanyField__["a" /* default */](this, fieldName, type, ref, fieldValue, fieldDef);
        case 'json':
          // let path = (new URL(fieldValue, 'http://parse')).pathname
          // console.log('createFieldObject', path)
          var matches = new RegExp('/fields/([^/]+)/([^/?]+)').exec(fieldValue);
          if (matches && matches.length > 2) {
            ref = '' + matches[1];
            var t = matches[2].toUpperCase();
            if (t === 'BANK') {
              type = 'COMPANY_BANK';
              return new __WEBPACK_IMPORTED_MODULE_23__fields_CompanyBankField__["a" /* default */](this, fieldName, type, ref, fieldValue);
            }
            if (t === 'HUMAN') {
              type = 'INDIVIDUAL';
              return new __WEBPACK_IMPORTED_MODULE_20__fields_IndividualField__["a" /* default */](this, fieldName, type, ref, fieldValue, fieldDef);
            }
            if (t === 'CONTACT') {
              type = 'CONTACT';
              return new __WEBPACK_IMPORTED_MODULE_21__fields_ContactField__["a" /* default */](this, fieldName, type, ref, fieldValue);
            }
            if (t === 'ACTION') {
              type = 'ACTION';
              return new __WEBPACK_IMPORTED_MODULE_24__fields_ActionField__["a" /* default */](this, fieldName, type, ref, fieldValue);
            }
            if (t === 'FILES') {
              type = 'FILES';
              return new __WEBPACK_IMPORTED_MODULE_18__fields_CompanyFilesField__["a" /* default */](this, fieldName, type, ref, fieldValue);
            }
            if (t === 'HOLDERS') {
              type = 'HOLDERS';
              return new __WEBPACK_IMPORTED_MODULE_17__fields_HoldersField__["a" /* default */](this, fieldName, type, ref, fieldValue);
            }
            t = t.split('-').join('_');
            if (__WEBPACK_IMPORTED_MODULE_13__people__["a" /* default */].registeredTypeDoc().includes(t)) {
              type = t;
              return new __WEBPACK_IMPORTED_MODULE_22__fields_PersonDocField__["a" /* default */](this, fieldName, type, ref, fieldValue);
            }
            break;
          }
          matches = new RegExp('^/human').exec(fieldValue);
          if (matches) {
            ref = 'LOCAL';
            type = 'INDIVIDUAL';
            return new __WEBPACK_IMPORTED_MODULE_20__fields_IndividualField__["a" /* default */](this, fieldName, type, ref, fieldValue, fieldDef);
          }
          matches = new RegExp('^/calc$').exec(fieldValue);
          if (matches) {
            ref = 'LOCAL';
            type = 'CALC';
            return new __WEBPACK_IMPORTED_MODULE_19__fields_CalcField__["a" /* default */](this, fieldName, type, ref, fieldValue);
          }
          matches = new RegExp('^/action$').exec(fieldValue);
          if (matches) {
            ref = 'LOCAL';
            type = 'ACTION';
            return new __WEBPACK_IMPORTED_MODULE_24__fields_ActionField__["a" /* default */](this, fieldName, type, ref, fieldValue);
          }
          matches = new RegExp('^/me$').exec(fieldValue);
          if (matches) {
            ref = 'LOCAL';
            type = 'INDIVIDUAL';
            return new __WEBPACK_IMPORTED_MODULE_20__fields_IndividualField__["a" /* default */](this, fieldName, type, ref, fieldValue, fieldDef);
          }
      }
      return new __WEBPACK_IMPORTED_MODULE_16__fields_JsonField__["a" /* default */](this, fieldName, type, ref, fieldValue);
    }
  }, {
    key: 'addFieldObject',
    value: function addFieldObject(fieldObject) {
      if (!fieldObject) {
        return;
      }
      this.fieldObjects.set(fieldObject.name, fieldObject);
      this.addRef(fieldObject.name, fieldObject.ref);
    }
  }, {
    key: 'getFieldObject',
    value: function getFieldObject(fieldName) {
      return this.fieldObjects.get(fieldName);
    }
  }, {
    key: 'addToModel',
    value: function addToModel(fieldName, value) {
      var fobj = this.getFieldObject(fieldName);
      if (fobj) {
        fobj.init(this.model);
      } else {
        this.model[fieldName] = value != null ? value : null;
      }
    }
  }, {
    key: 'getReferencePerson',
    value: function getReferencePerson(model, fieldName) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var fobj = _this3.getFieldObject(fieldName);
        if (fobj) {
          // console.log('getReferencePerson', fobj, model)
          fobj = _this3.getFieldObject(fobj.ref);
          if (__WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].isInnfl(model[fobj.name])) {
            var innfl = model[fobj.name];
            __WEBPACK_IMPORTED_MODULE_13__people__["a" /* default */].findIndividualByInn(innfl).then(function (individual) {
              if (individual) {
                resolve(individual.id + '');
              } else {
                __WEBPACK_IMPORTED_MODULE_11__common_dialogs_js__["a" /* default */].message(null, 'Совет', 'Для использования данных физического лица нужно внести информацию');
              }
            });
            return;
          }
          if (fobj.type === 'INDIVIDUAL') {
            if (fobj.getCode(model)) {
              resolve(fobj.getCode(model));
            } else {
              __WEBPACK_IMPORTED_MODULE_11__common_dialogs_js__["a" /* default */].message(null, 'Совет', 'Сначала выберите физическое лицо');
            }
          } else {
            reject();
          }
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: 'getReferenceCompanyInn',
    value: function getReferenceCompanyInn(model, fieldName) {
      var fobj = this.getFieldObject(fieldName);
      while (fobj && fobj.ref && fobj.type !== 'COMPANY') {
        fobj = this.getFieldObject(fobj.ref);
      }
      if (fobj && fobj.type === 'COMPANY') {
        var result = fobj.ref === 'SELF' ? model['companyInn'] : fobj.getValue(model);
        return result ? result.toString() : result;
      }
      return null;
    }
  }, {
    key: 'getReferenceCompanyRefCode',
    value: function getReferenceCompanyRefCode(model, fieldName) {
      var fobj = this.getFieldObject(fieldName);
      while (fobj && fobj.ref && fobj.type !== 'COMPANY') {
        fobj = this.getFieldObject(fobj.ref);
      }
      if (fobj && fobj.type === 'COMPANY') {
        var result = fobj.ref === 'SELF' ? model['companyRefCode'] : fobj.getCode(model);
        return result ? result.toString() : result;
      }
      return null;
    }
  }, {
    key: 'updateItems',
    value: function updateItems(model) {
      var items = [];
      this.fieldObjects.forEach(function (fobj) {
        if (fobj.getCode(model)) {
          items.push({ fieldName: fobj.name, value: fobj.getCode(model), text: fobj.getDescription(model), hint: fobj.getHint(model), error: null });
        }
      });
      this.items = items;
      // console.log('updateItems', items)
    }
  }, {
    key: 'onChange',
    value: function onChange(model, fieldName, value) {
      console.log('onChange', fieldName, value);
      var fobj = this.getFieldObject(fieldName);
      if (!fobj.equalCode(model, value)) {
        console.log('onChange1', fieldName, value);
        fobj.clearRef(model);
        this.updateItems(model);
      }
    }
  }, {
    key: 'onClick',
    value: function onClick(fieldName, onChange) {
      console.log('onClick', fieldName);
      var fobj = this.getFieldObject(fieldName);
      if (fobj.getCode(this.model)) {
        return fobj.open(this.model, onChange);
      }
      return fobj.select(this.model, onChange);
    }
  }, {
    key: 'onMacroCheck',
    value: function onMacroCheck(fieldName, content) {
      this.context.macro(content).then(function (bodyHtml) {
        console.log('onMacroCheck', fieldName, bodyHtml);
        __WEBPACK_IMPORTED_MODULE_12__common_forms_js__["a" /* default */].openEditor(bodyHtml);
      });
    }
  }, {
    key: 'setModel',
    value: function setModel(model) {
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_get___default()(Step.prototype.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Step.prototype), 'setModel', this).call(this, model);
      this.updateItems(model);
    }
  }]);

  return Step;
}(__WEBPACK_IMPORTED_MODULE_9__AssistClasses_js__["a" /* default */].Step);

/* harmony default export */ __webpack_exports__["a"] = ({
  Step: Step
});

/***/ }),
/* 156 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1051),
  /* template */
  __webpack_require__(1052),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(185);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("77f57f49", content, true, {});

/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, "@-webkit-keyframes shake{59%{margin-left:0}60%,80%{margin-left:2px}70%,90%{margin-left:-2px}}@keyframes shake{59%{margin-left:0}60%,80%{margin-left:2px}70%,90%{margin-left:-2px}}.black{background-color:#000!important;border-color:#000!important}.black--text{color:#000!important;caret-color:#000!important}.white{background-color:#fff!important;border-color:#fff!important}.white--text{color:#fff!important;caret-color:#fff!important}.transparent{background-color:transparent!important;border-color:transparent!important}.transparent--text{color:transparent!important;caret-color:transparent!important}.red{background-color:#f44336!important;border-color:#f44336!important}.red--text{color:#f44336!important;caret-color:#f44336!important}.red.lighten-5{background-color:#ffebee!important;border-color:#ffebee!important}.red--text.text--lighten-5{color:#ffebee!important;caret-color:#ffebee!important}.red.lighten-4{background-color:#ffcdd2!important;border-color:#ffcdd2!important}.red--text.text--lighten-4{color:#ffcdd2!important;caret-color:#ffcdd2!important}.red.lighten-3{background-color:#ef9a9a!important;border-color:#ef9a9a!important}.red--text.text--lighten-3{color:#ef9a9a!important;caret-color:#ef9a9a!important}.red.lighten-2{background-color:#e57373!important;border-color:#e57373!important}.red--text.text--lighten-2{color:#e57373!important;caret-color:#e57373!important}.red.lighten-1{background-color:#ef5350!important;border-color:#ef5350!important}.red--text.text--lighten-1{color:#ef5350!important;caret-color:#ef5350!important}.red.darken-1{background-color:#e53935!important;border-color:#e53935!important}.red--text.text--darken-1{color:#e53935!important;caret-color:#e53935!important}.red.darken-2{background-color:#d32f2f!important;border-color:#d32f2f!important}.red--text.text--darken-2{color:#d32f2f!important;caret-color:#d32f2f!important}.red.darken-3{background-color:#c62828!important;border-color:#c62828!important}.red--text.text--darken-3{color:#c62828!important;caret-color:#c62828!important}.red.darken-4{background-color:#b71c1c!important;border-color:#b71c1c!important}.red--text.text--darken-4{color:#b71c1c!important;caret-color:#b71c1c!important}.red.accent-1{background-color:#ff8a80!important;border-color:#ff8a80!important}.red--text.text--accent-1{color:#ff8a80!important;caret-color:#ff8a80!important}.red.accent-2{background-color:#ff5252!important;border-color:#ff5252!important}.red--text.text--accent-2{color:#ff5252!important;caret-color:#ff5252!important}.red.accent-3{background-color:#ff1744!important;border-color:#ff1744!important}.red--text.text--accent-3{color:#ff1744!important;caret-color:#ff1744!important}.red.accent-4{background-color:#d50000!important;border-color:#d50000!important}.red--text.text--accent-4{color:#d50000!important;caret-color:#d50000!important}.pink{background-color:#e91e63!important;border-color:#e91e63!important}.pink--text{color:#e91e63!important;caret-color:#e91e63!important}.pink.lighten-5{background-color:#fce4ec!important;border-color:#fce4ec!important}.pink--text.text--lighten-5{color:#fce4ec!important;caret-color:#fce4ec!important}.pink.lighten-4{background-color:#f8bbd0!important;border-color:#f8bbd0!important}.pink--text.text--lighten-4{color:#f8bbd0!important;caret-color:#f8bbd0!important}.pink.lighten-3{background-color:#f48fb1!important;border-color:#f48fb1!important}.pink--text.text--lighten-3{color:#f48fb1!important;caret-color:#f48fb1!important}.pink.lighten-2{background-color:#f06292!important;border-color:#f06292!important}.pink--text.text--lighten-2{color:#f06292!important;caret-color:#f06292!important}.pink.lighten-1{background-color:#ec407a!important;border-color:#ec407a!important}.pink--text.text--lighten-1{color:#ec407a!important;caret-color:#ec407a!important}.pink.darken-1{background-color:#d81b60!important;border-color:#d81b60!important}.pink--text.text--darken-1{color:#d81b60!important;caret-color:#d81b60!important}.pink.darken-2{background-color:#c2185b!important;border-color:#c2185b!important}.pink--text.text--darken-2{color:#c2185b!important;caret-color:#c2185b!important}.pink.darken-3{background-color:#ad1457!important;border-color:#ad1457!important}.pink--text.text--darken-3{color:#ad1457!important;caret-color:#ad1457!important}.pink.darken-4{background-color:#880e4f!important;border-color:#880e4f!important}.pink--text.text--darken-4{color:#880e4f!important;caret-color:#880e4f!important}.pink.accent-1{background-color:#ff80ab!important;border-color:#ff80ab!important}.pink--text.text--accent-1{color:#ff80ab!important;caret-color:#ff80ab!important}.pink.accent-2{background-color:#ff4081!important;border-color:#ff4081!important}.pink--text.text--accent-2{color:#ff4081!important;caret-color:#ff4081!important}.pink.accent-3{background-color:#f50057!important;border-color:#f50057!important}.pink--text.text--accent-3{color:#f50057!important;caret-color:#f50057!important}.pink.accent-4{background-color:#c51162!important;border-color:#c51162!important}.pink--text.text--accent-4{color:#c51162!important;caret-color:#c51162!important}.purple{background-color:#9c27b0!important;border-color:#9c27b0!important}.purple--text{color:#9c27b0!important;caret-color:#9c27b0!important}.purple.lighten-5{background-color:#f3e5f5!important;border-color:#f3e5f5!important}.purple--text.text--lighten-5{color:#f3e5f5!important;caret-color:#f3e5f5!important}.purple.lighten-4{background-color:#e1bee7!important;border-color:#e1bee7!important}.purple--text.text--lighten-4{color:#e1bee7!important;caret-color:#e1bee7!important}.purple.lighten-3{background-color:#ce93d8!important;border-color:#ce93d8!important}.purple--text.text--lighten-3{color:#ce93d8!important;caret-color:#ce93d8!important}.purple.lighten-2{background-color:#ba68c8!important;border-color:#ba68c8!important}.purple--text.text--lighten-2{color:#ba68c8!important;caret-color:#ba68c8!important}.purple.lighten-1{background-color:#ab47bc!important;border-color:#ab47bc!important}.purple--text.text--lighten-1{color:#ab47bc!important;caret-color:#ab47bc!important}.purple.darken-1{background-color:#8e24aa!important;border-color:#8e24aa!important}.purple--text.text--darken-1{color:#8e24aa!important;caret-color:#8e24aa!important}.purple.darken-2{background-color:#7b1fa2!important;border-color:#7b1fa2!important}.purple--text.text--darken-2{color:#7b1fa2!important;caret-color:#7b1fa2!important}.purple.darken-3{background-color:#6a1b9a!important;border-color:#6a1b9a!important}.purple--text.text--darken-3{color:#6a1b9a!important;caret-color:#6a1b9a!important}.purple.darken-4{background-color:#4a148c!important;border-color:#4a148c!important}.purple--text.text--darken-4{color:#4a148c!important;caret-color:#4a148c!important}.purple.accent-1{background-color:#ea80fc!important;border-color:#ea80fc!important}.purple--text.text--accent-1{color:#ea80fc!important;caret-color:#ea80fc!important}.purple.accent-2{background-color:#e040fb!important;border-color:#e040fb!important}.purple--text.text--accent-2{color:#e040fb!important;caret-color:#e040fb!important}.purple.accent-3{background-color:#d500f9!important;border-color:#d500f9!important}.purple--text.text--accent-3{color:#d500f9!important;caret-color:#d500f9!important}.purple.accent-4{background-color:#a0f!important;border-color:#a0f!important}.purple--text.text--accent-4{color:#a0f!important;caret-color:#a0f!important}.deep-purple{background-color:#673ab7!important;border-color:#673ab7!important}.deep-purple--text{color:#673ab7!important;caret-color:#673ab7!important}.deep-purple.lighten-5{background-color:#ede7f6!important;border-color:#ede7f6!important}.deep-purple--text.text--lighten-5{color:#ede7f6!important;caret-color:#ede7f6!important}.deep-purple.lighten-4{background-color:#d1c4e9!important;border-color:#d1c4e9!important}.deep-purple--text.text--lighten-4{color:#d1c4e9!important;caret-color:#d1c4e9!important}.deep-purple.lighten-3{background-color:#b39ddb!important;border-color:#b39ddb!important}.deep-purple--text.text--lighten-3{color:#b39ddb!important;caret-color:#b39ddb!important}.deep-purple.lighten-2{background-color:#9575cd!important;border-color:#9575cd!important}.deep-purple--text.text--lighten-2{color:#9575cd!important;caret-color:#9575cd!important}.deep-purple.lighten-1{background-color:#7e57c2!important;border-color:#7e57c2!important}.deep-purple--text.text--lighten-1{color:#7e57c2!important;caret-color:#7e57c2!important}.deep-purple.darken-1{background-color:#5e35b1!important;border-color:#5e35b1!important}.deep-purple--text.text--darken-1{color:#5e35b1!important;caret-color:#5e35b1!important}.deep-purple.darken-2{background-color:#512da8!important;border-color:#512da8!important}.deep-purple--text.text--darken-2{color:#512da8!important;caret-color:#512da8!important}.deep-purple.darken-3{background-color:#4527a0!important;border-color:#4527a0!important}.deep-purple--text.text--darken-3{color:#4527a0!important;caret-color:#4527a0!important}.deep-purple.darken-4{background-color:#311b92!important;border-color:#311b92!important}.deep-purple--text.text--darken-4{color:#311b92!important;caret-color:#311b92!important}.deep-purple.accent-1{background-color:#b388ff!important;border-color:#b388ff!important}.deep-purple--text.text--accent-1{color:#b388ff!important;caret-color:#b388ff!important}.deep-purple.accent-2{background-color:#7c4dff!important;border-color:#7c4dff!important}.deep-purple--text.text--accent-2{color:#7c4dff!important;caret-color:#7c4dff!important}.deep-purple.accent-3{background-color:#651fff!important;border-color:#651fff!important}.deep-purple--text.text--accent-3{color:#651fff!important;caret-color:#651fff!important}.deep-purple.accent-4{background-color:#6200ea!important;border-color:#6200ea!important}.deep-purple--text.text--accent-4{color:#6200ea!important;caret-color:#6200ea!important}.indigo{background-color:#3f51b5!important;border-color:#3f51b5!important}.indigo--text{color:#3f51b5!important;caret-color:#3f51b5!important}.indigo.lighten-5{background-color:#e8eaf6!important;border-color:#e8eaf6!important}.indigo--text.text--lighten-5{color:#e8eaf6!important;caret-color:#e8eaf6!important}.indigo.lighten-4{background-color:#c5cae9!important;border-color:#c5cae9!important}.indigo--text.text--lighten-4{color:#c5cae9!important;caret-color:#c5cae9!important}.indigo.lighten-3{background-color:#9fa8da!important;border-color:#9fa8da!important}.indigo--text.text--lighten-3{color:#9fa8da!important;caret-color:#9fa8da!important}.indigo.lighten-2{background-color:#7986cb!important;border-color:#7986cb!important}.indigo--text.text--lighten-2{color:#7986cb!important;caret-color:#7986cb!important}.indigo.lighten-1{background-color:#5c6bc0!important;border-color:#5c6bc0!important}.indigo--text.text--lighten-1{color:#5c6bc0!important;caret-color:#5c6bc0!important}.indigo.darken-1{background-color:#3949ab!important;border-color:#3949ab!important}.indigo--text.text--darken-1{color:#3949ab!important;caret-color:#3949ab!important}.indigo.darken-2{background-color:#303f9f!important;border-color:#303f9f!important}.indigo--text.text--darken-2{color:#303f9f!important;caret-color:#303f9f!important}.indigo.darken-3{background-color:#283593!important;border-color:#283593!important}.indigo--text.text--darken-3{color:#283593!important;caret-color:#283593!important}.indigo.darken-4{background-color:#1a237e!important;border-color:#1a237e!important}.indigo--text.text--darken-4{color:#1a237e!important;caret-color:#1a237e!important}.indigo.accent-1{background-color:#8c9eff!important;border-color:#8c9eff!important}.indigo--text.text--accent-1{color:#8c9eff!important;caret-color:#8c9eff!important}.indigo.accent-2{background-color:#536dfe!important;border-color:#536dfe!important}.indigo--text.text--accent-2{color:#536dfe!important;caret-color:#536dfe!important}.indigo.accent-3{background-color:#3d5afe!important;border-color:#3d5afe!important}.indigo--text.text--accent-3{color:#3d5afe!important;caret-color:#3d5afe!important}.indigo.accent-4{background-color:#304ffe!important;border-color:#304ffe!important}.indigo--text.text--accent-4{color:#304ffe!important;caret-color:#304ffe!important}.blue{background-color:#2196f3!important;border-color:#2196f3!important}.blue--text{color:#2196f3!important;caret-color:#2196f3!important}.blue.lighten-5{background-color:#e3f2fd!important;border-color:#e3f2fd!important}.blue--text.text--lighten-5{color:#e3f2fd!important;caret-color:#e3f2fd!important}.blue.lighten-4{background-color:#bbdefb!important;border-color:#bbdefb!important}.blue--text.text--lighten-4{color:#bbdefb!important;caret-color:#bbdefb!important}.blue.lighten-3{background-color:#90caf9!important;border-color:#90caf9!important}.blue--text.text--lighten-3{color:#90caf9!important;caret-color:#90caf9!important}.blue.lighten-2{background-color:#64b5f6!important;border-color:#64b5f6!important}.blue--text.text--lighten-2{color:#64b5f6!important;caret-color:#64b5f6!important}.blue.lighten-1{background-color:#42a5f5!important;border-color:#42a5f5!important}.blue--text.text--lighten-1{color:#42a5f5!important;caret-color:#42a5f5!important}.blue.darken-1{background-color:#1e88e5!important;border-color:#1e88e5!important}.blue--text.text--darken-1{color:#1e88e5!important;caret-color:#1e88e5!important}.blue.darken-2{background-color:#1976d2!important;border-color:#1976d2!important}.blue--text.text--darken-2{color:#1976d2!important;caret-color:#1976d2!important}.blue.darken-3{background-color:#1565c0!important;border-color:#1565c0!important}.blue--text.text--darken-3{color:#1565c0!important;caret-color:#1565c0!important}.blue.darken-4{background-color:#0d47a1!important;border-color:#0d47a1!important}.blue--text.text--darken-4{color:#0d47a1!important;caret-color:#0d47a1!important}.blue.accent-1{background-color:#82b1ff!important;border-color:#82b1ff!important}.blue--text.text--accent-1{color:#82b1ff!important;caret-color:#82b1ff!important}.blue.accent-2{background-color:#448aff!important;border-color:#448aff!important}.blue--text.text--accent-2{color:#448aff!important;caret-color:#448aff!important}.blue.accent-3{background-color:#2979ff!important;border-color:#2979ff!important}.blue--text.text--accent-3{color:#2979ff!important;caret-color:#2979ff!important}.blue.accent-4{background-color:#2962ff!important;border-color:#2962ff!important}.blue--text.text--accent-4{color:#2962ff!important;caret-color:#2962ff!important}.light-blue{background-color:#03a9f4!important;border-color:#03a9f4!important}.light-blue--text{color:#03a9f4!important;caret-color:#03a9f4!important}.light-blue.lighten-5{background-color:#e1f5fe!important;border-color:#e1f5fe!important}.light-blue--text.text--lighten-5{color:#e1f5fe!important;caret-color:#e1f5fe!important}.light-blue.lighten-4{background-color:#b3e5fc!important;border-color:#b3e5fc!important}.light-blue--text.text--lighten-4{color:#b3e5fc!important;caret-color:#b3e5fc!important}.light-blue.lighten-3{background-color:#81d4fa!important;border-color:#81d4fa!important}.light-blue--text.text--lighten-3{color:#81d4fa!important;caret-color:#81d4fa!important}.light-blue.lighten-2{background-color:#4fc3f7!important;border-color:#4fc3f7!important}.light-blue--text.text--lighten-2{color:#4fc3f7!important;caret-color:#4fc3f7!important}.light-blue.lighten-1{background-color:#29b6f6!important;border-color:#29b6f6!important}.light-blue--text.text--lighten-1{color:#29b6f6!important;caret-color:#29b6f6!important}.light-blue.darken-1{background-color:#039be5!important;border-color:#039be5!important}.light-blue--text.text--darken-1{color:#039be5!important;caret-color:#039be5!important}.light-blue.darken-2{background-color:#0288d1!important;border-color:#0288d1!important}.light-blue--text.text--darken-2{color:#0288d1!important;caret-color:#0288d1!important}.light-blue.darken-3{background-color:#0277bd!important;border-color:#0277bd!important}.light-blue--text.text--darken-3{color:#0277bd!important;caret-color:#0277bd!important}.light-blue.darken-4{background-color:#01579b!important;border-color:#01579b!important}.light-blue--text.text--darken-4{color:#01579b!important;caret-color:#01579b!important}.light-blue.accent-1{background-color:#80d8ff!important;border-color:#80d8ff!important}.light-blue--text.text--accent-1{color:#80d8ff!important;caret-color:#80d8ff!important}.light-blue.accent-2{background-color:#40c4ff!important;border-color:#40c4ff!important}.light-blue--text.text--accent-2{color:#40c4ff!important;caret-color:#40c4ff!important}.light-blue.accent-3{background-color:#00b0ff!important;border-color:#00b0ff!important}.light-blue--text.text--accent-3{color:#00b0ff!important;caret-color:#00b0ff!important}.light-blue.accent-4{background-color:#0091ea!important;border-color:#0091ea!important}.light-blue--text.text--accent-4{color:#0091ea!important;caret-color:#0091ea!important}.cyan{background-color:#00bcd4!important;border-color:#00bcd4!important}.cyan--text{color:#00bcd4!important;caret-color:#00bcd4!important}.cyan.lighten-5{background-color:#e0f7fa!important;border-color:#e0f7fa!important}.cyan--text.text--lighten-5{color:#e0f7fa!important;caret-color:#e0f7fa!important}.cyan.lighten-4{background-color:#b2ebf2!important;border-color:#b2ebf2!important}.cyan--text.text--lighten-4{color:#b2ebf2!important;caret-color:#b2ebf2!important}.cyan.lighten-3{background-color:#80deea!important;border-color:#80deea!important}.cyan--text.text--lighten-3{color:#80deea!important;caret-color:#80deea!important}.cyan.lighten-2{background-color:#4dd0e1!important;border-color:#4dd0e1!important}.cyan--text.text--lighten-2{color:#4dd0e1!important;caret-color:#4dd0e1!important}.cyan.lighten-1{background-color:#26c6da!important;border-color:#26c6da!important}.cyan--text.text--lighten-1{color:#26c6da!important;caret-color:#26c6da!important}.cyan.darken-1{background-color:#00acc1!important;border-color:#00acc1!important}.cyan--text.text--darken-1{color:#00acc1!important;caret-color:#00acc1!important}.cyan.darken-2{background-color:#0097a7!important;border-color:#0097a7!important}.cyan--text.text--darken-2{color:#0097a7!important;caret-color:#0097a7!important}.cyan.darken-3{background-color:#00838f!important;border-color:#00838f!important}.cyan--text.text--darken-3{color:#00838f!important;caret-color:#00838f!important}.cyan.darken-4{background-color:#006064!important;border-color:#006064!important}.cyan--text.text--darken-4{color:#006064!important;caret-color:#006064!important}.cyan.accent-1{background-color:#84ffff!important;border-color:#84ffff!important}.cyan--text.text--accent-1{color:#84ffff!important;caret-color:#84ffff!important}.cyan.accent-2{background-color:#18ffff!important;border-color:#18ffff!important}.cyan--text.text--accent-2{color:#18ffff!important;caret-color:#18ffff!important}.cyan.accent-3{background-color:#00e5ff!important;border-color:#00e5ff!important}.cyan--text.text--accent-3{color:#00e5ff!important;caret-color:#00e5ff!important}.cyan.accent-4{background-color:#00b8d4!important;border-color:#00b8d4!important}.cyan--text.text--accent-4{color:#00b8d4!important;caret-color:#00b8d4!important}.teal{background-color:#009688!important;border-color:#009688!important}.teal--text{color:#009688!important;caret-color:#009688!important}.teal.lighten-5{background-color:#e0f2f1!important;border-color:#e0f2f1!important}.teal--text.text--lighten-5{color:#e0f2f1!important;caret-color:#e0f2f1!important}.teal.lighten-4{background-color:#b2dfdb!important;border-color:#b2dfdb!important}.teal--text.text--lighten-4{color:#b2dfdb!important;caret-color:#b2dfdb!important}.teal.lighten-3{background-color:#80cbc4!important;border-color:#80cbc4!important}.teal--text.text--lighten-3{color:#80cbc4!important;caret-color:#80cbc4!important}.teal.lighten-2{background-color:#4db6ac!important;border-color:#4db6ac!important}.teal--text.text--lighten-2{color:#4db6ac!important;caret-color:#4db6ac!important}.teal.lighten-1{background-color:#26a69a!important;border-color:#26a69a!important}.teal--text.text--lighten-1{color:#26a69a!important;caret-color:#26a69a!important}.teal.darken-1{background-color:#00897b!important;border-color:#00897b!important}.teal--text.text--darken-1{color:#00897b!important;caret-color:#00897b!important}.teal.darken-2{background-color:#00796b!important;border-color:#00796b!important}.teal--text.text--darken-2{color:#00796b!important;caret-color:#00796b!important}.teal.darken-3{background-color:#00695c!important;border-color:#00695c!important}.teal--text.text--darken-3{color:#00695c!important;caret-color:#00695c!important}.teal.darken-4{background-color:#004d40!important;border-color:#004d40!important}.teal--text.text--darken-4{color:#004d40!important;caret-color:#004d40!important}.teal.accent-1{background-color:#a7ffeb!important;border-color:#a7ffeb!important}.teal--text.text--accent-1{color:#a7ffeb!important;caret-color:#a7ffeb!important}.teal.accent-2{background-color:#64ffda!important;border-color:#64ffda!important}.teal--text.text--accent-2{color:#64ffda!important;caret-color:#64ffda!important}.teal.accent-3{background-color:#1de9b6!important;border-color:#1de9b6!important}.teal--text.text--accent-3{color:#1de9b6!important;caret-color:#1de9b6!important}.teal.accent-4{background-color:#00bfa5!important;border-color:#00bfa5!important}.teal--text.text--accent-4{color:#00bfa5!important;caret-color:#00bfa5!important}.green{background-color:#4caf50!important;border-color:#4caf50!important}.green--text{color:#4caf50!important;caret-color:#4caf50!important}.green.lighten-5{background-color:#e8f5e9!important;border-color:#e8f5e9!important}.green--text.text--lighten-5{color:#e8f5e9!important;caret-color:#e8f5e9!important}.green.lighten-4{background-color:#c8e6c9!important;border-color:#c8e6c9!important}.green--text.text--lighten-4{color:#c8e6c9!important;caret-color:#c8e6c9!important}.green.lighten-3{background-color:#a5d6a7!important;border-color:#a5d6a7!important}.green--text.text--lighten-3{color:#a5d6a7!important;caret-color:#a5d6a7!important}.green.lighten-2{background-color:#81c784!important;border-color:#81c784!important}.green--text.text--lighten-2{color:#81c784!important;caret-color:#81c784!important}.green.lighten-1{background-color:#66bb6a!important;border-color:#66bb6a!important}.green--text.text--lighten-1{color:#66bb6a!important;caret-color:#66bb6a!important}.green.darken-1{background-color:#43a047!important;border-color:#43a047!important}.green--text.text--darken-1{color:#43a047!important;caret-color:#43a047!important}.green.darken-2{background-color:#388e3c!important;border-color:#388e3c!important}.green--text.text--darken-2{color:#388e3c!important;caret-color:#388e3c!important}.green.darken-3{background-color:#2e7d32!important;border-color:#2e7d32!important}.green--text.text--darken-3{color:#2e7d32!important;caret-color:#2e7d32!important}.green.darken-4{background-color:#1b5e20!important;border-color:#1b5e20!important}.green--text.text--darken-4{color:#1b5e20!important;caret-color:#1b5e20!important}.green.accent-1{background-color:#b9f6ca!important;border-color:#b9f6ca!important}.green--text.text--accent-1{color:#b9f6ca!important;caret-color:#b9f6ca!important}.green.accent-2{background-color:#69f0ae!important;border-color:#69f0ae!important}.green--text.text--accent-2{color:#69f0ae!important;caret-color:#69f0ae!important}.green.accent-3{background-color:#00e676!important;border-color:#00e676!important}.green--text.text--accent-3{color:#00e676!important;caret-color:#00e676!important}.green.accent-4{background-color:#00c853!important;border-color:#00c853!important}.green--text.text--accent-4{color:#00c853!important;caret-color:#00c853!important}.light-green{background-color:#8bc34a!important;border-color:#8bc34a!important}.light-green--text{color:#8bc34a!important;caret-color:#8bc34a!important}.light-green.lighten-5{background-color:#f1f8e9!important;border-color:#f1f8e9!important}.light-green--text.text--lighten-5{color:#f1f8e9!important;caret-color:#f1f8e9!important}.light-green.lighten-4{background-color:#dcedc8!important;border-color:#dcedc8!important}.light-green--text.text--lighten-4{color:#dcedc8!important;caret-color:#dcedc8!important}.light-green.lighten-3{background-color:#c5e1a5!important;border-color:#c5e1a5!important}.light-green--text.text--lighten-3{color:#c5e1a5!important;caret-color:#c5e1a5!important}.light-green.lighten-2{background-color:#aed581!important;border-color:#aed581!important}.light-green--text.text--lighten-2{color:#aed581!important;caret-color:#aed581!important}.light-green.lighten-1{background-color:#9ccc65!important;border-color:#9ccc65!important}.light-green--text.text--lighten-1{color:#9ccc65!important;caret-color:#9ccc65!important}.light-green.darken-1{background-color:#7cb342!important;border-color:#7cb342!important}.light-green--text.text--darken-1{color:#7cb342!important;caret-color:#7cb342!important}.light-green.darken-2{background-color:#689f38!important;border-color:#689f38!important}.light-green--text.text--darken-2{color:#689f38!important;caret-color:#689f38!important}.light-green.darken-3{background-color:#558b2f!important;border-color:#558b2f!important}.light-green--text.text--darken-3{color:#558b2f!important;caret-color:#558b2f!important}.light-green.darken-4{background-color:#33691e!important;border-color:#33691e!important}.light-green--text.text--darken-4{color:#33691e!important;caret-color:#33691e!important}.light-green.accent-1{background-color:#ccff90!important;border-color:#ccff90!important}.light-green--text.text--accent-1{color:#ccff90!important;caret-color:#ccff90!important}.light-green.accent-2{background-color:#b2ff59!important;border-color:#b2ff59!important}.light-green--text.text--accent-2{color:#b2ff59!important;caret-color:#b2ff59!important}.light-green.accent-3{background-color:#76ff03!important;border-color:#76ff03!important}.light-green--text.text--accent-3{color:#76ff03!important;caret-color:#76ff03!important}.light-green.accent-4{background-color:#64dd17!important;border-color:#64dd17!important}.light-green--text.text--accent-4{color:#64dd17!important;caret-color:#64dd17!important}.lime{background-color:#cddc39!important;border-color:#cddc39!important}.lime--text{color:#cddc39!important;caret-color:#cddc39!important}.lime.lighten-5{background-color:#f9fbe7!important;border-color:#f9fbe7!important}.lime--text.text--lighten-5{color:#f9fbe7!important;caret-color:#f9fbe7!important}.lime.lighten-4{background-color:#f0f4c3!important;border-color:#f0f4c3!important}.lime--text.text--lighten-4{color:#f0f4c3!important;caret-color:#f0f4c3!important}.lime.lighten-3{background-color:#e6ee9c!important;border-color:#e6ee9c!important}.lime--text.text--lighten-3{color:#e6ee9c!important;caret-color:#e6ee9c!important}.lime.lighten-2{background-color:#dce775!important;border-color:#dce775!important}.lime--text.text--lighten-2{color:#dce775!important;caret-color:#dce775!important}.lime.lighten-1{background-color:#d4e157!important;border-color:#d4e157!important}.lime--text.text--lighten-1{color:#d4e157!important;caret-color:#d4e157!important}.lime.darken-1{background-color:#c0ca33!important;border-color:#c0ca33!important}.lime--text.text--darken-1{color:#c0ca33!important;caret-color:#c0ca33!important}.lime.darken-2{background-color:#afb42b!important;border-color:#afb42b!important}.lime--text.text--darken-2{color:#afb42b!important;caret-color:#afb42b!important}.lime.darken-3{background-color:#9e9d24!important;border-color:#9e9d24!important}.lime--text.text--darken-3{color:#9e9d24!important;caret-color:#9e9d24!important}.lime.darken-4{background-color:#827717!important;border-color:#827717!important}.lime--text.text--darken-4{color:#827717!important;caret-color:#827717!important}.lime.accent-1{background-color:#f4ff81!important;border-color:#f4ff81!important}.lime--text.text--accent-1{color:#f4ff81!important;caret-color:#f4ff81!important}.lime.accent-2{background-color:#eeff41!important;border-color:#eeff41!important}.lime--text.text--accent-2{color:#eeff41!important;caret-color:#eeff41!important}.lime.accent-3{background-color:#c6ff00!important;border-color:#c6ff00!important}.lime--text.text--accent-3{color:#c6ff00!important;caret-color:#c6ff00!important}.lime.accent-4{background-color:#aeea00!important;border-color:#aeea00!important}.lime--text.text--accent-4{color:#aeea00!important;caret-color:#aeea00!important}.yellow{background-color:#ffeb3b!important;border-color:#ffeb3b!important}.yellow--text{color:#ffeb3b!important;caret-color:#ffeb3b!important}.yellow.lighten-5{background-color:#fffde7!important;border-color:#fffde7!important}.yellow--text.text--lighten-5{color:#fffde7!important;caret-color:#fffde7!important}.yellow.lighten-4{background-color:#fff9c4!important;border-color:#fff9c4!important}.yellow--text.text--lighten-4{color:#fff9c4!important;caret-color:#fff9c4!important}.yellow.lighten-3{background-color:#fff59d!important;border-color:#fff59d!important}.yellow--text.text--lighten-3{color:#fff59d!important;caret-color:#fff59d!important}.yellow.lighten-2{background-color:#fff176!important;border-color:#fff176!important}.yellow--text.text--lighten-2{color:#fff176!important;caret-color:#fff176!important}.yellow.lighten-1{background-color:#ffee58!important;border-color:#ffee58!important}.yellow--text.text--lighten-1{color:#ffee58!important;caret-color:#ffee58!important}.yellow.darken-1{background-color:#fdd835!important;border-color:#fdd835!important}.yellow--text.text--darken-1{color:#fdd835!important;caret-color:#fdd835!important}.yellow.darken-2{background-color:#fbc02d!important;border-color:#fbc02d!important}.yellow--text.text--darken-2{color:#fbc02d!important;caret-color:#fbc02d!important}.yellow.darken-3{background-color:#f9a825!important;border-color:#f9a825!important}.yellow--text.text--darken-3{color:#f9a825!important;caret-color:#f9a825!important}.yellow.darken-4{background-color:#f57f17!important;border-color:#f57f17!important}.yellow--text.text--darken-4{color:#f57f17!important;caret-color:#f57f17!important}.yellow.accent-1{background-color:#ffff8d!important;border-color:#ffff8d!important}.yellow--text.text--accent-1{color:#ffff8d!important;caret-color:#ffff8d!important}.yellow.accent-2{background-color:#ff0!important;border-color:#ff0!important}.yellow--text.text--accent-2{color:#ff0!important;caret-color:#ff0!important}.yellow.accent-3{background-color:#ffea00!important;border-color:#ffea00!important}.yellow--text.text--accent-3{color:#ffea00!important;caret-color:#ffea00!important}.yellow.accent-4{background-color:#ffd600!important;border-color:#ffd600!important}.yellow--text.text--accent-4{color:#ffd600!important;caret-color:#ffd600!important}.amber{background-color:#ffc107!important;border-color:#ffc107!important}.amber--text{color:#ffc107!important;caret-color:#ffc107!important}.amber.lighten-5{background-color:#fff8e1!important;border-color:#fff8e1!important}.amber--text.text--lighten-5{color:#fff8e1!important;caret-color:#fff8e1!important}.amber.lighten-4{background-color:#ffecb3!important;border-color:#ffecb3!important}.amber--text.text--lighten-4{color:#ffecb3!important;caret-color:#ffecb3!important}.amber.lighten-3{background-color:#ffe082!important;border-color:#ffe082!important}.amber--text.text--lighten-3{color:#ffe082!important;caret-color:#ffe082!important}.amber.lighten-2{background-color:#ffd54f!important;border-color:#ffd54f!important}.amber--text.text--lighten-2{color:#ffd54f!important;caret-color:#ffd54f!important}.amber.lighten-1{background-color:#ffca28!important;border-color:#ffca28!important}.amber--text.text--lighten-1{color:#ffca28!important;caret-color:#ffca28!important}.amber.darken-1{background-color:#ffb300!important;border-color:#ffb300!important}.amber--text.text--darken-1{color:#ffb300!important;caret-color:#ffb300!important}.amber.darken-2{background-color:#ffa000!important;border-color:#ffa000!important}.amber--text.text--darken-2{color:#ffa000!important;caret-color:#ffa000!important}.amber.darken-3{background-color:#ff8f00!important;border-color:#ff8f00!important}.amber--text.text--darken-3{color:#ff8f00!important;caret-color:#ff8f00!important}.amber.darken-4{background-color:#ff6f00!important;border-color:#ff6f00!important}.amber--text.text--darken-4{color:#ff6f00!important;caret-color:#ff6f00!important}.amber.accent-1{background-color:#ffe57f!important;border-color:#ffe57f!important}.amber--text.text--accent-1{color:#ffe57f!important;caret-color:#ffe57f!important}.amber.accent-2{background-color:#ffd740!important;border-color:#ffd740!important}.amber--text.text--accent-2{color:#ffd740!important;caret-color:#ffd740!important}.amber.accent-3{background-color:#ffc400!important;border-color:#ffc400!important}.amber--text.text--accent-3{color:#ffc400!important;caret-color:#ffc400!important}.amber.accent-4{background-color:#ffab00!important;border-color:#ffab00!important}.amber--text.text--accent-4{color:#ffab00!important;caret-color:#ffab00!important}.orange{background-color:#ff9800!important;border-color:#ff9800!important}.orange--text{color:#ff9800!important;caret-color:#ff9800!important}.orange.lighten-5{background-color:#fff3e0!important;border-color:#fff3e0!important}.orange--text.text--lighten-5{color:#fff3e0!important;caret-color:#fff3e0!important}.orange.lighten-4{background-color:#ffe0b2!important;border-color:#ffe0b2!important}.orange--text.text--lighten-4{color:#ffe0b2!important;caret-color:#ffe0b2!important}.orange.lighten-3{background-color:#ffcc80!important;border-color:#ffcc80!important}.orange--text.text--lighten-3{color:#ffcc80!important;caret-color:#ffcc80!important}.orange.lighten-2{background-color:#ffb74d!important;border-color:#ffb74d!important}.orange--text.text--lighten-2{color:#ffb74d!important;caret-color:#ffb74d!important}.orange.lighten-1{background-color:#ffa726!important;border-color:#ffa726!important}.orange--text.text--lighten-1{color:#ffa726!important;caret-color:#ffa726!important}.orange.darken-1{background-color:#fb8c00!important;border-color:#fb8c00!important}.orange--text.text--darken-1{color:#fb8c00!important;caret-color:#fb8c00!important}.orange.darken-2{background-color:#f57c00!important;border-color:#f57c00!important}.orange--text.text--darken-2{color:#f57c00!important;caret-color:#f57c00!important}.orange.darken-3{background-color:#ef6c00!important;border-color:#ef6c00!important}.orange--text.text--darken-3{color:#ef6c00!important;caret-color:#ef6c00!important}.orange.darken-4{background-color:#e65100!important;border-color:#e65100!important}.orange--text.text--darken-4{color:#e65100!important;caret-color:#e65100!important}.orange.accent-1{background-color:#ffd180!important;border-color:#ffd180!important}.orange--text.text--accent-1{color:#ffd180!important;caret-color:#ffd180!important}.orange.accent-2{background-color:#ffab40!important;border-color:#ffab40!important}.orange--text.text--accent-2{color:#ffab40!important;caret-color:#ffab40!important}.orange.accent-3{background-color:#ff9100!important;border-color:#ff9100!important}.orange--text.text--accent-3{color:#ff9100!important;caret-color:#ff9100!important}.orange.accent-4{background-color:#ff6d00!important;border-color:#ff6d00!important}.orange--text.text--accent-4{color:#ff6d00!important;caret-color:#ff6d00!important}.deep-orange{background-color:#ff5722!important;border-color:#ff5722!important}.deep-orange--text{color:#ff5722!important;caret-color:#ff5722!important}.deep-orange.lighten-5{background-color:#fbe9e7!important;border-color:#fbe9e7!important}.deep-orange--text.text--lighten-5{color:#fbe9e7!important;caret-color:#fbe9e7!important}.deep-orange.lighten-4{background-color:#ffccbc!important;border-color:#ffccbc!important}.deep-orange--text.text--lighten-4{color:#ffccbc!important;caret-color:#ffccbc!important}.deep-orange.lighten-3{background-color:#ffab91!important;border-color:#ffab91!important}.deep-orange--text.text--lighten-3{color:#ffab91!important;caret-color:#ffab91!important}.deep-orange.lighten-2{background-color:#ff8a65!important;border-color:#ff8a65!important}.deep-orange--text.text--lighten-2{color:#ff8a65!important;caret-color:#ff8a65!important}.deep-orange.lighten-1{background-color:#ff7043!important;border-color:#ff7043!important}.deep-orange--text.text--lighten-1{color:#ff7043!important;caret-color:#ff7043!important}.deep-orange.darken-1{background-color:#f4511e!important;border-color:#f4511e!important}.deep-orange--text.text--darken-1{color:#f4511e!important;caret-color:#f4511e!important}.deep-orange.darken-2{background-color:#e64a19!important;border-color:#e64a19!important}.deep-orange--text.text--darken-2{color:#e64a19!important;caret-color:#e64a19!important}.deep-orange.darken-3{background-color:#d84315!important;border-color:#d84315!important}.deep-orange--text.text--darken-3{color:#d84315!important;caret-color:#d84315!important}.deep-orange.darken-4{background-color:#bf360c!important;border-color:#bf360c!important}.deep-orange--text.text--darken-4{color:#bf360c!important;caret-color:#bf360c!important}.deep-orange.accent-1{background-color:#ff9e80!important;border-color:#ff9e80!important}.deep-orange--text.text--accent-1{color:#ff9e80!important;caret-color:#ff9e80!important}.deep-orange.accent-2{background-color:#ff6e40!important;border-color:#ff6e40!important}.deep-orange--text.text--accent-2{color:#ff6e40!important;caret-color:#ff6e40!important}.deep-orange.accent-3{background-color:#ff3d00!important;border-color:#ff3d00!important}.deep-orange--text.text--accent-3{color:#ff3d00!important;caret-color:#ff3d00!important}.deep-orange.accent-4{background-color:#dd2c00!important;border-color:#dd2c00!important}.deep-orange--text.text--accent-4{color:#dd2c00!important;caret-color:#dd2c00!important}.brown{background-color:#795548!important;border-color:#795548!important}.brown--text{color:#795548!important;caret-color:#795548!important}.brown.lighten-5{background-color:#efebe9!important;border-color:#efebe9!important}.brown--text.text--lighten-5{color:#efebe9!important;caret-color:#efebe9!important}.brown.lighten-4{background-color:#d7ccc8!important;border-color:#d7ccc8!important}.brown--text.text--lighten-4{color:#d7ccc8!important;caret-color:#d7ccc8!important}.brown.lighten-3{background-color:#bcaaa4!important;border-color:#bcaaa4!important}.brown--text.text--lighten-3{color:#bcaaa4!important;caret-color:#bcaaa4!important}.brown.lighten-2{background-color:#a1887f!important;border-color:#a1887f!important}.brown--text.text--lighten-2{color:#a1887f!important;caret-color:#a1887f!important}.brown.lighten-1{background-color:#8d6e63!important;border-color:#8d6e63!important}.brown--text.text--lighten-1{color:#8d6e63!important;caret-color:#8d6e63!important}.brown.darken-1{background-color:#6d4c41!important;border-color:#6d4c41!important}.brown--text.text--darken-1{color:#6d4c41!important;caret-color:#6d4c41!important}.brown.darken-2{background-color:#5d4037!important;border-color:#5d4037!important}.brown--text.text--darken-2{color:#5d4037!important;caret-color:#5d4037!important}.brown.darken-3{background-color:#4e342e!important;border-color:#4e342e!important}.brown--text.text--darken-3{color:#4e342e!important;caret-color:#4e342e!important}.brown.darken-4{background-color:#3e2723!important;border-color:#3e2723!important}.brown--text.text--darken-4{color:#3e2723!important;caret-color:#3e2723!important}.blue-grey{background-color:#607d8b!important;border-color:#607d8b!important}.blue-grey--text{color:#607d8b!important;caret-color:#607d8b!important}.blue-grey.lighten-5{background-color:#eceff1!important;border-color:#eceff1!important}.blue-grey--text.text--lighten-5{color:#eceff1!important;caret-color:#eceff1!important}.blue-grey.lighten-4{background-color:#cfd8dc!important;border-color:#cfd8dc!important}.blue-grey--text.text--lighten-4{color:#cfd8dc!important;caret-color:#cfd8dc!important}.blue-grey.lighten-3{background-color:#b0bec5!important;border-color:#b0bec5!important}.blue-grey--text.text--lighten-3{color:#b0bec5!important;caret-color:#b0bec5!important}.blue-grey.lighten-2{background-color:#90a4ae!important;border-color:#90a4ae!important}.blue-grey--text.text--lighten-2{color:#90a4ae!important;caret-color:#90a4ae!important}.blue-grey.lighten-1{background-color:#78909c!important;border-color:#78909c!important}.blue-grey--text.text--lighten-1{color:#78909c!important;caret-color:#78909c!important}.blue-grey.darken-1{background-color:#546e7a!important;border-color:#546e7a!important}.blue-grey--text.text--darken-1{color:#546e7a!important;caret-color:#546e7a!important}.blue-grey.darken-2{background-color:#455a64!important;border-color:#455a64!important}.blue-grey--text.text--darken-2{color:#455a64!important;caret-color:#455a64!important}.blue-grey.darken-3{background-color:#37474f!important;border-color:#37474f!important}.blue-grey--text.text--darken-3{color:#37474f!important;caret-color:#37474f!important}.blue-grey.darken-4{background-color:#263238!important;border-color:#263238!important}.blue-grey--text.text--darken-4{color:#263238!important;caret-color:#263238!important}.grey{background-color:#9e9e9e!important;border-color:#9e9e9e!important}.grey--text{color:#9e9e9e!important;caret-color:#9e9e9e!important}.grey.lighten-5{background-color:#fafafa!important;border-color:#fafafa!important}.grey--text.text--lighten-5{color:#fafafa!important;caret-color:#fafafa!important}.grey.lighten-4{background-color:#f5f5f5!important;border-color:#f5f5f5!important}.grey--text.text--lighten-4{color:#f5f5f5!important;caret-color:#f5f5f5!important}.grey.lighten-3{background-color:#eee!important;border-color:#eee!important}.grey--text.text--lighten-3{color:#eee!important;caret-color:#eee!important}.grey.lighten-2{background-color:#e0e0e0!important;border-color:#e0e0e0!important}.grey--text.text--lighten-2{color:#e0e0e0!important;caret-color:#e0e0e0!important}.grey.lighten-1{background-color:#bdbdbd!important;border-color:#bdbdbd!important}.grey--text.text--lighten-1{color:#bdbdbd!important;caret-color:#bdbdbd!important}.grey.darken-1{background-color:#757575!important;border-color:#757575!important}.grey--text.text--darken-1{color:#757575!important;caret-color:#757575!important}.grey.darken-2{background-color:#616161!important;border-color:#616161!important}.grey--text.text--darken-2{color:#616161!important;caret-color:#616161!important}.grey.darken-3{background-color:#424242!important;border-color:#424242!important}.grey--text.text--darken-3{color:#424242!important;caret-color:#424242!important}.grey.darken-4{background-color:#212121!important;border-color:#212121!important}.grey--text.text--darken-4{color:#212121!important;caret-color:#212121!important}.shades.black{background-color:#000!important;border-color:#000!important}.shades--text.text--black{color:#000!important;caret-color:#000!important}.shades.white{background-color:#fff!important;border-color:#fff!important}.shades--text.text--white{color:#fff!important;caret-color:#fff!important}.shades.transparent{background-color:transparent!important;border-color:transparent!important}.shades--text.text--transparent{color:transparent!important;caret-color:transparent!important}.elevation-0{box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)!important}.elevation-1{box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)!important}.elevation-2{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)!important}.elevation-3{box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)!important}.elevation-4{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)!important}.elevation-5{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 5px 8px 0 rgba(0,0,0,.14),0 1px 14px 0 rgba(0,0,0,.12)!important}.elevation-6{box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)!important}.elevation-7{box-shadow:0 4px 5px -2px rgba(0,0,0,.2),0 7px 10px 1px rgba(0,0,0,.14),0 2px 16px 1px rgba(0,0,0,.12)!important}.elevation-8{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)!important}.elevation-9{box-shadow:0 5px 6px -3px rgba(0,0,0,.2),0 9px 12px 1px rgba(0,0,0,.14),0 3px 16px 2px rgba(0,0,0,.12)!important}.elevation-10{box-shadow:0 6px 6px -3px rgba(0,0,0,.2),0 10px 14px 1px rgba(0,0,0,.14),0 4px 18px 3px rgba(0,0,0,.12)!important}.elevation-11{box-shadow:0 6px 7px -4px rgba(0,0,0,.2),0 11px 15px 1px rgba(0,0,0,.14),0 4px 20px 3px rgba(0,0,0,.12)!important}.elevation-12{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)!important}.elevation-13{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 13px 19px 2px rgba(0,0,0,.14),0 5px 24px 4px rgba(0,0,0,.12)!important}.elevation-14{box-shadow:0 7px 9px -4px rgba(0,0,0,.2),0 14px 21px 2px rgba(0,0,0,.14),0 5px 26px 4px rgba(0,0,0,.12)!important}.elevation-15{box-shadow:0 8px 9px -5px rgba(0,0,0,.2),0 15px 22px 2px rgba(0,0,0,.14),0 6px 28px 5px rgba(0,0,0,.12)!important}.elevation-16{box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)!important}.elevation-17{box-shadow:0 8px 11px -5px rgba(0,0,0,.2),0 17px 26px 2px rgba(0,0,0,.14),0 6px 32px 5px rgba(0,0,0,.12)!important}.elevation-18{box-shadow:0 9px 11px -5px rgba(0,0,0,.2),0 18px 28px 2px rgba(0,0,0,.14),0 7px 34px 6px rgba(0,0,0,.12)!important}.elevation-19{box-shadow:0 9px 12px -6px rgba(0,0,0,.2),0 19px 29px 2px rgba(0,0,0,.14),0 7px 36px 6px rgba(0,0,0,.12)!important}.elevation-20{box-shadow:0 10px 13px -6px rgba(0,0,0,.2),0 20px 31px 3px rgba(0,0,0,.14),0 8px 38px 7px rgba(0,0,0,.12)!important}.elevation-21{box-shadow:0 10px 13px -6px rgba(0,0,0,.2),0 21px 33px 3px rgba(0,0,0,.14),0 8px 40px 7px rgba(0,0,0,.12)!important}.elevation-22{box-shadow:0 10px 14px -6px rgba(0,0,0,.2),0 22px 35px 3px rgba(0,0,0,.14),0 8px 42px 7px rgba(0,0,0,.12)!important}.elevation-23{box-shadow:0 11px 14px -7px rgba(0,0,0,.2),0 23px 36px 3px rgba(0,0,0,.14),0 9px 44px 8px rgba(0,0,0,.12)!important}.elevation-24{box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12)!important}html{box-sizing:border-box;overflow-y:scroll;-webkit-text-size-adjust:100%}*,:after,:before{box-sizing:inherit}:after,:before{text-decoration:inherit;vertical-align:inherit}*{background-repeat:no-repeat;padding:0;margin:0}audio:not([controls]){display:none;height:0}hr{overflow:visible}article,aside,details,figcaption,figure,footer,header,main,menu,nav,section,summary{display:block}summary{display:list-item}small{font-size:80%}[hidden],template{display:none}abbr[title]{border-bottom:1px dotted;text-decoration:none}a{background-color:transparent;-webkit-text-decoration-skip:objects}a:active,a:hover{outline-width:0}code,kbd,pre,samp{font-family:monospace,monospace}b,strong{font-weight:bolder}dfn{font-style:italic}mark{background-color:#ff0;color:#000}sub,sup{font-size:75%;line-height:0;position:relative;vertical-align:baseline}sub{bottom:-.25em}sup{top:-.5em}input{border-radius:0}[role=button],[type=button],[type=reset],[type=submit],button{cursor:pointer}[disabled]{cursor:default}[type=number]{width:auto}[type=search]::-webkit-search-cancel-button,[type=search]::-webkit-search-decoration{-webkit-appearance:none}textarea{overflow:auto;resize:vertical}button,input,optgroup,select,textarea{font:inherit}optgroup{font-weight:700}button{overflow:visible}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button::-moz-focus-inner{border-style:0;padding:0}[type=button]::-moz-focus-inner,[type=reset]::-moz-focus-inner,[type=submit]::-moz-focus-inner,button:-moz-focusring{outline:0;border:0}[type=reset],[type=submit],button,html [type=button]{-webkit-appearance:button}button,select{text-transform:none}button,input,select,textarea{background-color:transparent;border-style:none;color:inherit}select{-moz-appearance:none;-webkit-appearance:none}select::-ms-expand{display:none}select::-ms-value{color:currentColor}legend{border:0;color:inherit;display:table;max-width:100%;white-space:normal}::-webkit-file-upload-button{-webkit-appearance:button;font:inherit}[type=search]{-webkit-appearance:textfield;outline-offset:-2px}img{border-style:none}progress{vertical-align:baseline}svg:not(:root){overflow:hidden}audio,canvas,progress,video{display:inline-block}[aria-busy=true]{cursor:progress}[aria-controls]{cursor:pointer}[aria-disabled]{cursor:default}::selection{background-color:#b3d4fc;color:#000;text-shadow:none}.bottom-sheet-transition-enter,.bottom-sheet-transition-leave-to{-webkit-transform:translateY(100%);transform:translateY(100%)}.carousel-transition-enter{-webkit-transform:translate(100%);transform:translate(100%)}.carousel-transition-leave,.carousel-transition-leave-to{position:absolute;top:0}.carousel-reverse-transition-enter,.carousel-transition-leave,.carousel-transition-leave-to{-webkit-transform:translate(-100%);transform:translate(-100%)}.carousel-reverse-transition-leave,.carousel-reverse-transition-leave-to{position:absolute;top:0;-webkit-transform:translate(100%);transform:translate(100%)}.dialog-transition-enter,.dialog-transition-leave-to{-webkit-transform:scale(.5);transform:scale(.5);opacity:0}.dialog-transition-enter-to,.dialog-transition-leave{opacity:1}.dialog-bottom-transition-enter,.dialog-bottom-transition-leave-to{-webkit-transform:translateY(100%);transform:translateY(100%)}.picker-reverse-transition-enter-active,.picker-reverse-transition-leave-active,.picker-transition-enter-active,.picker-transition-leave-active{transition:.3s cubic-bezier(0,0,.2,1)}.picker-reverse-transition-enter,.picker-reverse-transition-leave-to,.picker-transition-enter,.picker-transition-leave-to{opacity:0}.picker-reverse-transition-leave,.picker-reverse-transition-leave-active,.picker-reverse-transition-leave-to,.picker-transition-leave,.picker-transition-leave-active,.picker-transition-leave-to{position:absolute!important}.picker-transition-enter{-webkit-transform:translateY(100%);transform:translateY(100%)}.picker-reverse-transition-enter,.picker-transition-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%)}.picker-reverse-transition-leave-to{-webkit-transform:translateY(100%);transform:translateY(100%)}.picker-title-transition-enter-to,.picker-title-transition-leave{-webkit-transform:translate(0);transform:translate(0)}.picker-title-transition-enter{-webkit-transform:translate(-100%);transform:translate(-100%)}.picker-title-transition-leave-to{opacity:0;-webkit-transform:translate(100%);transform:translate(100%)}.picker-title-transition-leave,.picker-title-transition-leave-active,.picker-title-transition-leave-to{position:absolute!important}.tab-transition-enter{-webkit-transform:translate(100%);transform:translate(100%)}.tab-transition-leave,.tab-transition-leave-active{position:absolute;top:0}.tab-transition-leave-to{position:absolute}.tab-reverse-transition-enter,.tab-transition-leave-to{-webkit-transform:translate(-100%);transform:translate(-100%)}.tab-reverse-transition-leave,.tab-reverse-transition-leave-to{top:0;position:absolute;-webkit-transform:translate(100%);transform:translate(100%)}.expand-transition-enter-active,.expand-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.expand-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.expand-x-transition-enter-active,.expand-x-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.expand-x-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.scale-transition-enter-active,.scale-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.scale-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.scale-transition-enter,.scale-transition-leave,.scale-transition-leave-to{opacity:0;-webkit-transform:scale(0);transform:scale(0)}.message-transition-enter-active,.message-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.message-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.message-transition-enter,.message-transition-leave-to{opacity:0;-webkit-transform:translateY(-15px);transform:translateY(-15px)}.message-transition-leave,.message-transition-leave-active{position:absolute}.slide-y-transition-enter-active,.slide-y-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.slide-y-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.slide-y-transition-enter,.slide-y-transition-leave-to{opacity:0;-webkit-transform:translateY(-15px);transform:translateY(-15px)}.slide-y-reverse-transition-enter-active,.slide-y-reverse-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.slide-y-reverse-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.slide-y-reverse-transition-enter,.slide-y-reverse-transition-leave-to{opacity:0;-webkit-transform:translateY(15px);transform:translateY(15px)}.scroll-y-transition-enter-active,.scroll-y-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.scroll-y-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.scroll-y-transition-enter,.scroll-y-transition-leave-to{opacity:0}.scroll-y-transition-enter{-webkit-transform:translateY(-15px);transform:translateY(-15px)}.scroll-y-transition-leave-to{-webkit-transform:translateY(15px);transform:translateY(15px)}.scroll-y-reverse-transition-enter-active,.scroll-y-reverse-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.scroll-y-reverse-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.scroll-y-reverse-transition-enter,.scroll-y-reverse-transition-leave-to{opacity:0}.scroll-y-reverse-transition-enter{-webkit-transform:translateY(15px);transform:translateY(15px)}.scroll-y-reverse-transition-leave-to{-webkit-transform:translateY(-15px);transform:translateY(-15px)}.scroll-x-transition-enter-active,.scroll-x-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.scroll-x-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.scroll-x-transition-enter,.scroll-x-transition-leave-to{opacity:0}.scroll-x-transition-enter{-webkit-transform:translateX(-15px);transform:translateX(-15px)}.scroll-x-transition-leave-to{-webkit-transform:translateX(15px);transform:translateX(15px)}.scroll-x-reverse-transition-enter-active,.scroll-x-reverse-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.scroll-x-reverse-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.scroll-x-reverse-transition-enter,.scroll-x-reverse-transition-leave-to{opacity:0}.scroll-x-reverse-transition-enter{-webkit-transform:translateX(15px);transform:translateX(15px)}.scroll-x-reverse-transition-leave-to{-webkit-transform:translateX(-15px);transform:translateX(-15px)}.slide-x-transition-enter-active,.slide-x-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.slide-x-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.slide-x-transition-enter,.slide-x-transition-leave-to{opacity:0;-webkit-transform:translateX(-15px);transform:translateX(-15px)}.slide-x-reverse-transition-enter-active,.slide-x-reverse-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.slide-x-reverse-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.slide-x-reverse-transition-enter,.slide-x-reverse-transition-leave-to{opacity:0;-webkit-transform:translateX(15px);transform:translateX(15px)}.fade-transition-enter-active,.fade-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.fade-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.fade-transition-enter,.fade-transition-leave-to{opacity:0}.fab-transition-enter-active,.fab-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.fab-transition-move{transition:-webkit-transform .6s;transition:transform .6s;transition:transform .6s,-webkit-transform .6s}.fab-transition-enter,.fab-transition-leave-to{-webkit-transform:scale(0) rotate(-45deg);transform:scale(0) rotate(-45deg)}.blockquote{padding:16px 0 16px 24px;font-size:18px;font-weight:300}code,kbd{display:inline-block;border-radius:3px;white-space:pre-wrap;font-size:85%;font-weight:900}code:after,code:before,kbd:after,kbd:before{content:\"\\A0\";letter-spacing:-1px}code{background-color:#f5f5f5;color:#bd4147;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}kbd{background:#616161;color:#fff}html{font-size:14px;overflow-x:hidden;text-rendering:optimizeLegibility;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale;-webkit-tap-highlight-color:rgba(0,0,0,0)}.application{font-family:Roboto,sans-serif;line-height:1.5}::-ms-clear,::-ms-reveal{display:none}ol,ul{padding-left:24px}.display-4{font-size:112px!important;font-weight:300;line-height:1!important;letter-spacing:-.04em!important;font-family:Roboto,sans-serif!important}.display-3{font-size:56px!important;line-height:1.35!important;letter-spacing:-.02em!important}.display-2,.display-3{font-weight:400;font-family:Roboto,sans-serif!important}.display-2{font-size:45px!important;line-height:48px!important;letter-spacing:normal!important}.display-1{font-size:34px!important;line-height:40px!important}.display-1,.headline{font-weight:400;letter-spacing:normal!important;font-family:Roboto,sans-serif!important}.headline{font-size:24px!important;line-height:32px!important}.title{font-size:20px!important;font-weight:500;line-height:1!important;letter-spacing:.02em!important;font-family:Roboto,sans-serif!important}.subheading{font-size:16px!important;font-weight:400}.body-2{font-weight:500}.body-1,.body-2{font-size:14px!important}.body-1,.caption{font-weight:400}.caption{font-size:12px!important}p{margin-bottom:16px}.overflow-hidden{overflow:hidden}.overflow-x-hidden{overflow-x:hidden}.overflow-y-hidden{overflow-y:hidden}.right{float:right!important}.left{float:left!important}.ma-auto{margin:auto!important}.my-auto{margin-top:auto!important;margin-bottom:auto!important}.mx-auto{margin-left:auto!important;margin-right:auto!important}.mt-auto{margin-top:auto!important}.mr-auto{margin-right:auto!important}.mb-auto{margin-bottom:auto!important}.ml-auto{margin-left:auto!important}.ma-0{margin:0!important}.my-0{margin-top:0!important;margin-bottom:0!important}.mx-0{margin-left:0!important;margin-right:0!important}.mt-0{margin-top:0!important}.mr-0{margin-right:0!important}.mb-0{margin-bottom:0!important}.ml-0{margin-left:0!important}.pa-0{padding:0!important}.py-0{padding-top:0!important;padding-bottom:0!important}.px-0{padding-left:0!important;padding-right:0!important}.pt-0{padding-top:0!important}.pr-0{padding-right:0!important}.pb-0{padding-bottom:0!important}.pl-0{padding-left:0!important}.ma-1{margin:4px!important}.my-1{margin-top:4px!important;margin-bottom:4px!important}.mx-1{margin-left:4px!important;margin-right:4px!important}.mt-1{margin-top:4px!important}.mr-1{margin-right:4px!important}.mb-1{margin-bottom:4px!important}.ml-1{margin-left:4px!important}.pa-1{padding:4px!important}.py-1{padding-top:4px!important;padding-bottom:4px!important}.px-1{padding-left:4px!important;padding-right:4px!important}.pt-1{padding-top:4px!important}.pr-1{padding-right:4px!important}.pb-1{padding-bottom:4px!important}.pl-1{padding-left:4px!important}.ma-2{margin:8px!important}.my-2{margin-top:8px!important;margin-bottom:8px!important}.mx-2{margin-left:8px!important;margin-right:8px!important}.mt-2{margin-top:8px!important}.mr-2{margin-right:8px!important}.mb-2{margin-bottom:8px!important}.ml-2{margin-left:8px!important}.pa-2{padding:8px!important}.py-2{padding-top:8px!important;padding-bottom:8px!important}.px-2{padding-left:8px!important;padding-right:8px!important}.pt-2{padding-top:8px!important}.pr-2{padding-right:8px!important}.pb-2{padding-bottom:8px!important}.pl-2{padding-left:8px!important}.ma-3{margin:16px!important}.my-3{margin-top:16px!important;margin-bottom:16px!important}.mx-3{margin-left:16px!important;margin-right:16px!important}.mt-3{margin-top:16px!important}.mr-3{margin-right:16px!important}.mb-3{margin-bottom:16px!important}.ml-3{margin-left:16px!important}.pa-3{padding:16px!important}.py-3{padding-top:16px!important;padding-bottom:16px!important}.px-3{padding-left:16px!important;padding-right:16px!important}.pt-3{padding-top:16px!important}.pr-3{padding-right:16px!important}.pb-3{padding-bottom:16px!important}.pl-3{padding-left:16px!important}.ma-4{margin:24px!important}.my-4{margin-top:24px!important;margin-bottom:24px!important}.mx-4{margin-left:24px!important;margin-right:24px!important}.mt-4{margin-top:24px!important}.mr-4{margin-right:24px!important}.mb-4{margin-bottom:24px!important}.ml-4{margin-left:24px!important}.pa-4{padding:24px!important}.py-4{padding-top:24px!important;padding-bottom:24px!important}.px-4{padding-left:24px!important;padding-right:24px!important}.pt-4{padding-top:24px!important}.pr-4{padding-right:24px!important}.pb-4{padding-bottom:24px!important}.pl-4{padding-left:24px!important}.ma-5{margin:48px!important}.my-5{margin-top:48px!important;margin-bottom:48px!important}.mx-5{margin-left:48px!important;margin-right:48px!important}.mt-5{margin-top:48px!important}.mr-5{margin-right:48px!important}.mb-5{margin-bottom:48px!important}.ml-5{margin-left:48px!important}.pa-5{padding:48px!important}.py-5{padding-top:48px!important;padding-bottom:48px!important}.px-5{padding-left:48px!important;padding-right:48px!important}.pt-5{padding-top:48px!important}.pr-5{padding-right:48px!important}.pb-5{padding-bottom:48px!important}.pl-5{padding-left:48px!important}.font-weight-thin{font-weight:100!important}.font-weight-light{font-weight:300!important}.font-weight-regular{font-weight:400!important}.font-weight-medium{font-weight:500!important}.font-weight-bold{font-weight:700!important}.font-weight-black{font-weight:900!important}.font-italic{font-style:italic!important}.text-capitalize{text-transform:capitalize!important}.text-lowercase{text-transform:lowercase!important}.text-none{text-transform:none!important}.text-uppercase{text-transform:uppercase!important}.text-no-wrap,.text-truncate{white-space:nowrap!important}.text-truncate{overflow:hidden!important;text-overflow:ellipsis!important;line-height:1.1!important}.transition-fast-out-slow-in{transition:.3s cubic-bezier(.4,0,.2,1)!important}.transition-linear-out-slow-in{transition:.3s cubic-bezier(0,0,.2,1)!important}.transition-fast-out-linear-in{transition:.3s cubic-bezier(.4,0,1,1)!important}.transition-ease-in-out{transition:.3s cubic-bezier(.4,0,.6,1)!important}.transition-fast-in-fast-out{transition:.3s cubic-bezier(.25,.8,.25,1)!important}.transition-swing{transition:.3s cubic-bezier(.25,.8,.5,1)!important}@media screen{[hidden~=screen]{display:inherit}[hidden~=screen]:not(:active):not(:focus):not(:target){position:absolute!important;clip:rect(0 0 0 0)!important}}@media only print{.hidden-print-only{display:none!important}}@media only screen{.hidden-screen-only{display:none!important}}@media only screen and (max-width:599px){.hidden-xs-only{display:none!important}}@media only screen and (min-width:600px) and (max-width:959px){.hidden-sm-only{display:none!important}}@media only screen and (max-width:959px){.hidden-sm-and-down{display:none!important}}@media only screen and (min-width:600px){.hidden-sm-and-up{display:none!important}}@media only screen and (min-width:960px) and (max-width:1263px){.hidden-md-only{display:none!important}}@media only screen and (max-width:1263px){.hidden-md-and-down{display:none!important}}@media only screen and (min-width:960px){.hidden-md-and-up{display:none!important}}@media only screen and (min-width:1264px) and (max-width:1903px){.hidden-lg-only{display:none!important}}@media only screen and (max-width:1903px){.hidden-lg-and-down{display:none!important}}@media only screen and (min-width:1264px){.hidden-lg-and-up{display:none!important}}@media only screen and (min-width:1904px){.hidden-xl-only{display:none!important}}@media (min-width:0){.text-xs-left{text-align:left!important}.text-xs-center{text-align:center!important}.text-xs-right{text-align:right!important}.text-xs-justify{text-align:justify!important}}@media (min-width:600px){.text-sm-left{text-align:left!important}.text-sm-center{text-align:center!important}.text-sm-right{text-align:right!important}.text-sm-justify{text-align:justify!important}}@media (min-width:960px){.text-md-left{text-align:left!important}.text-md-center{text-align:center!important}.text-md-right{text-align:right!important}.text-md-justify{text-align:justify!important}}@media (min-width:1264px){.text-lg-left{text-align:left!important}.text-lg-center{text-align:center!important}.text-lg-right{text-align:right!important}.text-lg-justify{text-align:justify!important}}@media (min-width:1904px){.text-xl-left{text-align:left!important}.text-xl-center{text-align:center!important}.text-xl-right{text-align:right!important}.text-xl-justify{text-align:justify!important}}.application{display:flex}.application a{cursor:pointer}.application--is-rtl{direction:rtl}.application--wrap{flex:1 1 auto;-webkit-backface-visibility:hidden;backface-visibility:hidden;display:flex;flex-direction:column;min-height:100vh;max-width:100%;position:relative}.theme--light.application{background:#fafafa;color:rgba(0,0,0,.87)}.theme--light.application .text--primary{color:rgba(0,0,0,.87)!important}.theme--light.application .text--secondary{color:rgba(0,0,0,.54)!important}.theme--light.application .text--disabled{color:rgba(0,0,0,.38)!important}.theme--dark.application{background:#303030;color:#fff}.theme--dark.application .text--primary{color:#fff!important}.theme--dark.application .text--secondary{color:hsla(0,0%,100%,.7)!important}.theme--dark.application .text--disabled{color:hsla(0,0%,100%,.5)!important}@media print{@-moz-document url-prefix(){.application,.application--wrap{display:block}}}.v-alert{border-radius:0;border-width:4px 0 0;border-style:solid;color:#fff;display:flex;font-size:14px;margin:4px auto;padding:16px;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-alert .v-alert__icon.v-icon,.v-alert__dismissible .v-icon{align-self:center;color:rgba(0,0,0,.3);font-size:24px}.v-alert--outline .v-icon{color:inherit!important}.v-alert__icon{margin-right:16px}.v-alert__dismissible{align-self:flex-start;color:inherit;margin-left:16px;margin-right:0;text-decoration:none;transition:.3s cubic-bezier(.25,.8,.5,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-alert__dismissible:hover{opacity:.8}.v-alert--no-icon .v-alert__icon{display:none}.v-alert>div{align-self:center;flex:1 1}.v-alert.v-alert{border-color:rgba(0,0,0,.12)!important}.v-alert.v-alert--outline{border:1px solid currentColor!important}@media screen and (max-width:600px){.v-alert__icon{display:none}}.theme--light.v-icon{color:rgba(0,0,0,.54)}.theme--light.v-icon.v-icon--disabled{color:rgba(0,0,0,.38)!important}.theme--dark.v-icon{color:#fff}.theme--dark.v-icon.v-icon--disabled{color:hsla(0,0%,100%,.5)!important}.v-icon{align-items:center;display:inline-flex;-webkit-font-feature-settings:\"liga\";font-feature-settings:\"liga\";font-size:24px;justify-content:center;line-height:1;transition:.3s cubic-bezier(.25,.8,.5,1);vertical-align:text-bottom}.v-icon--right{margin-left:16px}.v-icon--left{margin-right:16px}.v-icon.v-icon.v-icon--link{cursor:pointer}.v-icon--disabled{pointer-events:none;opacity:.6}.v-icon--is-component{height:24px}.v-autocomplete.v-input>.v-input__control>.v-input__slot{cursor:text}.v-autocomplete input{align-self:center}.v-autocomplete--is-selecting-index input{opacity:0}.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot>input{margin-top:24px}.v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input{pointer-events:inherit}.v-autocomplete__content.v-menu__content,.v-autocomplete__content.v-menu__content .v-card{border-radius:0}.theme--light.v-text-field>.v-input__control>.v-input__slot:before{border-color:rgba(0,0,0,.42)}.theme--light.v-text-field:not(.v-input--has-state)>.v-input__control>.v-input__slot:hover:before{border-color:rgba(0,0,0,.87)}.theme--light.v-text-field.v-input--is-disabled>.v-input__control>.v-input__slot:before{border-image:repeating-linear-gradient(90deg,rgba(0,0,0,.38) 0,rgba(0,0,0,.38) 2px,transparent 0,transparent 4px) 1 repeat}.theme--light.v-text-field.v-input--is-disabled>.v-input__control>.v-input__slot:before .v-text-field__prefix,.theme--light.v-text-field.v-input--is-disabled>.v-input__control>.v-input__slot:before .v-text-field__suffix{color:rgba(0,0,0,.38)}.theme--light.v-text-field__prefix,.theme--light.v-text-field__suffix{color:rgba(0,0,0,.54)}.theme--light.v-text-field--solo>.v-input__control>.v-input__slot{border-radius:2px;background:#fff}.theme--light.v-text-field--solo-inverted.v-text-field--solo>.v-input__control>.v-input__slot{background:rgba(0,0,0,.16)}.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused>.v-input__control>.v-input__slot{background:#424242}.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused>.v-input__control>.v-input__slot .v-label,.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused>.v-input__control>.v-input__slot input{color:#fff}.theme--light.v-text-field--box>.v-input__control>.v-input__slot{background:rgba(0,0,0,.06)}.theme--light.v-text-field--box .v-text-field__prefix{max-height:32px;margin-top:22px}.theme--light.v-text-field--box.v-input--is-dirty .v-text-field__prefix,.theme--light.v-text-field--box.v-input--is-focused .v-text-field__prefix,.theme--light.v-text-field--box.v-text-field--placeholder .v-text-field__prefix{margin-top:22px;transition:.3s cubic-bezier(.25,.8,.5,1)}.theme--light.v-text-field--box:not(.v-input--is-focused)>.v-input__control>.v-input__slot:hover{background:rgba(0,0,0,.12)}.theme--light.v-text-field--outline>.v-input__control>.v-input__slot{border:2px solid rgba(0,0,0,.54)}.theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover{border:2px solid rgba(0,0,0,.87)}.theme--dark.v-text-field>.v-input__control>.v-input__slot:before{border-color:hsla(0,0%,100%,.7)}.theme--dark.v-text-field:not(.v-input--has-state)>.v-input__control>.v-input__slot:hover:before{border-color:#fff}.theme--dark.v-text-field.v-input--is-disabled>.v-input__control>.v-input__slot:before{border-image:repeating-linear-gradient(90deg,hsla(0,0%,100%,.5) 0,hsla(0,0%,100%,.5) 2px,transparent 0,transparent 4px) 1 repeat}.theme--dark.v-text-field.v-input--is-disabled>.v-input__control>.v-input__slot:before .v-text-field__prefix,.theme--dark.v-text-field.v-input--is-disabled>.v-input__control>.v-input__slot:before .v-text-field__suffix{color:hsla(0,0%,100%,.5)}.theme--dark.v-text-field__prefix,.theme--dark.v-text-field__suffix{color:hsla(0,0%,100%,.7)}.theme--dark.v-text-field--solo>.v-input__control>.v-input__slot{border-radius:2px;background:#424242}.theme--dark.v-text-field--solo-inverted.v-text-field--solo>.v-input__control>.v-input__slot{background:hsla(0,0%,100%,.16)}.theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused>.v-input__control>.v-input__slot{background:#fff}.theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused>.v-input__control>.v-input__slot .v-label,.theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused>.v-input__control>.v-input__slot input{color:rgba(0,0,0,.87)}.theme--dark.v-text-field--box>.v-input__control>.v-input__slot{background:rgba(0,0,0,.1)}.theme--dark.v-text-field--box .v-text-field__prefix{max-height:32px;margin-top:22px}.theme--dark.v-text-field--box.v-input--is-dirty .v-text-field__prefix,.theme--dark.v-text-field--box.v-input--is-focused .v-text-field__prefix,.theme--dark.v-text-field--box.v-text-field--placeholder .v-text-field__prefix{margin-top:22px;transition:.3s cubic-bezier(.25,.8,.5,1)}.theme--dark.v-text-field--box:not(.v-input--is-focused)>.v-input__control>.v-input__slot:hover{background:rgba(0,0,0,.2)}.theme--dark.v-text-field--outline>.v-input__control>.v-input__slot{border:2px solid hsla(0,0%,100%,.7)}.theme--dark.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state)>.v-input__control>.v-input__slot:hover{border:2px solid #fff}.application--is-rtl .v-text-field .v-label{-webkit-transform-origin:top right;transform-origin:top right}.application--is-rtl .v-text-field .v-counter{margin-left:0;margin-right:8px}.application--is-rtl .v-text-field--enclosed .v-input__append-outer{margin-left:0;margin-right:16px}.application--is-rtl .v-text-field--enclosed .v-input__prepend-outer{margin-left:16px;margin-right:0}.application--is-rtl .v-text-field--reverse input{text-align:left}.application--is-rtl .v-text-field--reverse .v-label{-webkit-transform-origin:top left;transform-origin:top left}.application--is-rtl .v-text-field__prefix{text-align:left;padding-right:0;padding-left:4px}.application--is-rtl .v-text-field__suffix{padding-left:0;padding-right:4px}.application--is-rtl .v-text-field--reverse .v-text-field__prefix{text-align:right;padding-left:0;padding-right:4px}.application--is-rtl .v-text-field--reverse .v-text-field__suffix{padding-left:0;padding-right:4px}.v-text-field{padding-top:12px;margin-top:4px}.v-text-field input{flex:1 1 auto;line-height:20px;padding:8px 0;max-width:100%;min-width:0;width:100%}.v-text-field .v-input__append-inner,.v-text-field .v-input__prepend-inner{align-self:flex-start;display:inline-flex;margin-top:4px;line-height:1;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-text-field .v-input__prepend-inner{margin-right:auto;padding-right:4px}.v-text-field .v-input__append-inner{margin-left:auto;padding-left:4px}.v-text-field .v-counter{margin-left:8px;white-space:nowrap}.v-text-field .v-label{max-width:90%;overflow:hidden;text-overflow:ellipsis;top:6px;-webkit-transform-origin:top left;transform-origin:top left;white-space:nowrap;pointer-events:none}.v-text-field .v-label--active{max-width:133%;-webkit-transform:translateY(-18px) scale(.75);transform:translateY(-18px) scale(.75)}.v-text-field>.v-input__control>.v-input__slot{cursor:text;transition:background .3s cubic-bezier(.25,.8,.5,1)}.v-text-field>.v-input__control>.v-input__slot:after,.v-text-field>.v-input__control>.v-input__slot:before{bottom:-1px;content:\"\";left:0;position:absolute;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-text-field>.v-input__control>.v-input__slot:before{border-style:solid;border-width:thin 0 0}.v-text-field>.v-input__control>.v-input__slot:after{border-color:currentColor;border-style:solid;border-width:thin 0;-webkit-transform:scaleX(0);transform:scaleX(0)}.v-text-field__details{display:flex;flex:1 0 auto;max-width:100%;overflow:hidden}.v-text-field__prefix,.v-text-field__suffix{align-self:center;cursor:default}.v-text-field__prefix{text-align:right;padding-right:4px}.v-text-field__suffix{padding-left:4px;white-space:nowrap}.v-text-field--reverse .v-text-field__prefix{text-align:left;padding-right:0;padding-left:4px}.v-text-field--reverse .v-text-field__suffix{padding-left:0;padding-right:4px}.v-text-field>.v-input__control>.v-input__slot>.v-text-field__slot{display:flex;flex:1 1 auto;position:relative}.v-text-field--box,.v-text-field--full-width,.v-text-field--outline{position:relative}.v-text-field--box>.v-input__control>.v-input__slot,.v-text-field--full-width>.v-input__control>.v-input__slot,.v-text-field--outline>.v-input__control>.v-input__slot{align-items:stretch;min-height:56px}.v-text-field--box input,.v-text-field--full-width input,.v-text-field--outline input{margin-top:22px}.v-text-field--box.v-text-field--single-line input,.v-text-field--full-width.v-text-field--single-line input,.v-text-field--outline.v-text-field--single-line input{margin-top:12px}.v-text-field--box .v-label,.v-text-field--full-width .v-label,.v-text-field--outline .v-label{top:18px}.v-text-field--box .v-label--active,.v-text-field--full-width .v-label--active,.v-text-field--outline .v-label--active{-webkit-transform:translateY(-6px) scale(.75);transform:translateY(-6px) scale(.75)}.v-text-field--box>.v-input__control>.v-input__slot{border-top-left-radius:4px;border-top-right-radius:4px}.v-text-field--box>.v-input__control>.v-input__slot:before{border-style:solid;border-width:thin 0}.v-text-field.v-text-field--enclosed{margin:0;padding:0}.v-text-field.v-text-field--enclosed:not(.v-text-field--box) .v-progress-linear__background{display:none}.v-text-field.v-text-field--enclosed .v-input__append-inner,.v-text-field.v-text-field--enclosed .v-input__append-outer,.v-text-field.v-text-field--enclosed .v-input__prepend-inner,.v-text-field.v-text-field--enclosed .v-input__prepend-outer{margin-top:16px}.v-text-field.v-text-field--enclosed .v-text-field__details,.v-text-field.v-text-field--enclosed>.v-input__control>.v-input__slot{padding:0 12px}.v-text-field.v-text-field--enclosed .v-text-field__details{margin-bottom:8px}.v-text-field--reverse input{text-align:right}.v-text-field--reverse .v-label{-webkit-transform-origin:top right;transform-origin:top right}.v-text-field--reverse .v-text-field__slot,.v-text-field--reverse>.v-input__control>.v-input__slot{flex-direction:row-reverse}.v-text-field--full-width>.v-input__control>.v-input__slot:after,.v-text-field--full-width>.v-input__control>.v-input__slot:before,.v-text-field--outline>.v-input__control>.v-input__slot:after,.v-text-field--outline>.v-input__control>.v-input__slot:before,.v-text-field--solo>.v-input__control>.v-input__slot:after,.v-text-field--solo>.v-input__control>.v-input__slot:before{display:none}.v-text-field--outline{margin-bottom:16px;transition:border .3s cubic-bezier(.25,.8,.5,1)}.v-text-field--outline>.v-input__control>.v-input__slot{background:transparent!important;border-radius:4px}.v-text-field--outline .v-text-field__prefix{margin-top:22px;max-height:32px}.v-text-field--outline .v-input__append-outer,.v-text-field--outline .v-input__prepend-outer{margin-top:18px}.v-text-field--outline.v-input--is-dirty .v-text-field__prefix,.v-text-field--outline.v-input--is-focused .v-text-field__prefix,.v-text-field--outline.v-text-field--placeholder .v-text-field__prefix{margin-top:22px;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-text-field--outline.v-input--has-state>.v-input__control>.v-input__slot,.v-text-field--outline.v-input--is-focused>.v-input__control>.v-input__slot{border:2px solid currentColor;transition:border .3s cubic-bezier(.25,.8,.5,1)}.v-text-field.v-text-field--solo .v-label{top:calc(50% - 10px)}.v-text-field.v-text-field--solo .v-input__control{min-height:48px;padding:0}.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat)>.v-input__control>.v-input__slot{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.v-text-field.v-text-field--solo .v-text-field__slot{align-items:center}.v-text-field.v-text-field--solo .v-input__append-inner,.v-text-field.v-text-field--solo .v-input__prepend-inner{align-self:center;margin-top:0}.v-text-field.v-text-field--solo .v-input__append-outer,.v-text-field.v-text-field--solo .v-input__prepend-outer{margin-top:12px}.v-text-field.v-input--is-focused>.v-input__control>.v-input__slot:after{-webkit-transform:scaleX(1);transform:scaleX(1)}.v-text-field.v-input--has-state>.v-input__control>.v-input__slot:before{border-color:currentColor}.theme--light.v-select .v-select__selections{color:rgba(0,0,0,.87)}.theme--light.v-select .v-chip--disabled,.theme--light.v-select.v-input--is-disabled .v-select__selections,.theme--light.v-select .v-select__selection--disabled{color:rgba(0,0,0,.38)}.theme--dark.v-select .v-select__selections,.theme--light.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selections{color:#fff}.theme--dark.v-select .v-chip--disabled,.theme--dark.v-select.v-input--is-disabled .v-select__selections,.theme--dark.v-select .v-select__selection--disabled{color:hsla(0,0%,100%,.5)}.theme--dark.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selections{color:rgba(0,0,0,.87)}.v-select{position:relative}.v-select>.v-input__control>.v-input__slot{cursor:pointer}.v-select .v-chip{flex:0 1 auto}.v-select .fade-transition-leave-active{position:absolute;left:0}.v-select.v-input--is-dirty ::-webkit-input-placeholder{color:transparent!important}.v-select.v-input--is-dirty :-ms-input-placeholder,.v-select.v-input--is-dirty ::-ms-input-placeholder{color:transparent!important}.v-select.v-input--is-dirty ::placeholder{color:transparent!important}.v-select:not(.v-input--is-dirty):not(.v-input--is-focused) .v-text-field__prefix{line-height:20px;position:absolute;top:7px;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections{padding-top:24px}.v-select.v-text-field input{flex:1 1;margin-top:0;min-width:0;pointer-events:none;position:relative}.v-select.v-select--is-menu-active .v-input__icon--append .v-icon{-webkit-transform:rotate(180deg);transform:rotate(180deg)}.v-select.v-select--chips input{margin:0}.v-select.v-select--chips .v-select__selections{min-height:42px}.v-select.v-select--chips.v-select--chips--small .v-select__selections{min-height:32px}.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box .v-select__selections,.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections{min-height:68px}.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box.v-select--chips--small .v-select__selections,.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-select--chips--small .v-select__selections{min-height:56px}.v-select.v-text-field--reverse .v-select__selections,.v-select.v-text-field--reverse .v-select__slot{flex-direction:row-reverse}.v-select__selections{align-items:center;display:flex;flex:1 1 auto;flex-wrap:wrap;line-height:18px}.v-select__selection{max-width:90%}.v-select__selection--comma{align-items:center;display:inline-flex;margin:7px 4px 7px 0}.v-select__slot{position:relative;align-items:center;display:flex;width:100%}.v-select:not(.v-text-field--single-line) .v-select__slot>input{align-self:flex-end}.theme--light.v-chip{background:#e0e0e0;color:rgba(0,0,0,.87)}.theme--light.v-chip--disabled{color:rgba(0,0,0,.38)}.theme--dark.v-chip{background:#555;color:#fff}.theme--dark.v-chip--disabled{color:hsla(0,0%,100%,.5)}.application--is-rtl .v-chip__close{margin:0 8px 0 2px}.application--is-rtl .v-chip--removable .v-chip__content{padding:0 12px 0 4px}.application--is-rtl .v-chip--select-multi{margin:4px 0 4px 4px}.application--is-rtl .v-chip .v-avatar{margin-right:-12px;margin-left:8px}.application--is-rtl .v-chip .v-icon--right{margin-right:12px;margin-left:-8px}.application--is-rtl .v-chip .v-icon--left{margin-right:-8px;margin-left:12px}.v-chip{font-size:13px;margin:4px;outline:none;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-chip,.v-chip .v-chip__content{align-items:center;border-radius:28px;display:inline-flex;vertical-align:middle}.v-chip .v-chip__content{cursor:default;height:32px;justify-content:space-between;padding:0 12px;white-space:nowrap;z-index:1}.v-chip--removable .v-chip__content{padding:0 4px 0 12px}.v-chip .v-avatar{height:32px!important;margin-left:-12px;margin-right:8px;min-width:32px;width:32px!important}.v-chip .v-avatar img{height:100%;width:100%}.v-chip--active,.v-chip--selected,.v-chip:focus:not(.v-chip--disabled){border-color:rgba(0,0,0,.13);box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.v-chip--active:after,.v-chip--selected:after,.v-chip:focus:not(.v-chip--disabled):after{background:currentColor;border-radius:inherit;content:\"\";height:100%;position:absolute;top:0;left:0;transition:inherit;width:100%;pointer-events:none;opacity:.13}.v-chip--label,.v-chip--label .v-chip__content{border-radius:2px}.v-chip.v-chip.v-chip--outline{background:transparent!important;border:1px solid currentColor;color:#9e9e9e;height:32px}.v-chip.v-chip.v-chip--outline .v-avatar{margin-left:-13px}.v-chip--small{height:24px!important}.v-chip--small .v-avatar{height:24px!important;min-width:24px;width:24px!important}.v-chip--small .v-icon{font-size:20px}.v-chip__close{align-items:center;color:inherit;display:flex;font-size:20px;margin:0 2px 0 8px;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-chip__close>.v-icon{color:inherit!important;font-size:20px;cursor:pointer;opacity:.5}.v-chip__close>.v-icon:hover{opacity:1}.v-chip--disabled .v-chip__close{pointer-events:none}.v-chip--select-multi{margin:4px 4px 4px 0}.v-chip .v-icon{color:inherit}.v-chip .v-icon--right{margin-left:12px;margin-right:-8px}.v-chip .v-icon--left{margin-left:-8px;margin-right:12px}.v-menu{display:block;vertical-align:middle}.v-menu--inline{display:inline-block}.v-menu__activator{align-items:center;cursor:pointer;display:flex}.v-menu__activator *{cursor:pointer}.v-menu__content{position:absolute;display:inline-block;border-radius:2px;max-width:80%;overflow-y:auto;overflow-x:hidden;contain:content;will-change:transform;box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.v-menu__content--active{pointer-events:none}.v-menu__content--fixed{position:fixed}.v-menu__content>.card{contain:content;-webkit-backface-visibility:hidden;backface-visibility:hidden}.v-menu>.v-menu__content{max-width:none}.v-menu-transition-enter .v-list__tile{min-width:0;pointer-events:none}.v-menu-transition-enter-to .v-list__tile{pointer-events:auto;transition-delay:.1s}.v-menu-transition-leave-active,.v-menu-transition-leave-to{pointer-events:none}.v-menu-transition-enter,.v-menu-transition-leave-to{opacity:0}.v-menu-transition-enter-active,.v-menu-transition-leave-active{transition:all .3s cubic-bezier(.25,.8,.25,1)}.v-menu-transition-enter.v-menu__content--auto{transition:none!important}.v-menu-transition-enter.v-menu__content--auto .v-list__tile{opacity:0;-webkit-transform:translateY(-15px);transform:translateY(-15px)}.v-menu-transition-enter.v-menu__content--auto .v-list__tile--active{opacity:1;-webkit-transform:none!important;transform:none!important;pointer-events:auto}.theme--light.v-card{background-color:#fff;border-color:#fff;color:rgba(0,0,0,.87)}.theme--dark.v-card{background-color:#424242;border-color:#424242;color:#fff}.v-card{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);text-decoration:none}.v-card>:first-child:not(.v-btn):not(.v-chip){border-top-left-radius:inherit;border-top-right-radius:inherit}.v-card>:last-child:not(.v-btn):not(.v-chip){border-bottom-left-radius:inherit;border-bottom-right-radius:inherit}.v-card--flat{box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.v-card--hover{cursor:pointer;transition:all .4s cubic-bezier(.25,.8,.25,1);transition-property:box-shadow}.v-card--hover:hover{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.v-card__title{align-items:center;display:flex;flex-wrap:wrap;padding:16px}.v-card__title--primary{padding-top:24px}.v-card__text{padding:16px;width:100%}.v-card__actions{align-items:center;display:flex;padding:8px}.v-card__actions .v-btn,.v-card__actions>*{margin:0}.v-card__actions .v-btn+.v-btn{margin-left:8px}.theme--light.v-input--selection-controls.v-input--is-disabled .v-icon{color:rgba(0,0,0,.26)!important}.theme--dark.v-input--selection-controls.v-input--is-disabled .v-icon{color:hsla(0,0%,100%,.3)!important}.application--is-rtl .v-input--selection-controls .v-input--selection-controls__input{margin-right:0;margin-left:8px}.v-input--selection-controls{margin-top:16px;padding-top:4px}.v-input--selection-controls .v-input__append-outer,.v-input--selection-controls .v-input__prepend-outer{margin-top:0;margin-bottom:0}.v-input--selection-controls .v-input__control{flex-grow:0;width:auto}.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot{margin-bottom:12px}.v-input--selection-controls__input{color:inherit;display:inline-flex;flex:0 0 auto;height:24px;position:relative;margin-right:8px;transition:.3s cubic-bezier(.25,.8,.25,1);transition-property:color,-webkit-transform;transition-property:color,transform;transition-property:color,transform,-webkit-transform;width:24px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-input--selection-controls__input input{position:absolute;opacity:0;width:100%;height:100%}.v-input--selection-controls__input+.v-label,.v-input--selection-controls__input input{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-input--selection-controls__ripple{border-radius:50%;cursor:pointer;height:34px;position:absolute;transition:inherit;width:34px;left:-12px;top:calc(50% - 24px);margin:7px}.v-input--selection-controls__ripple:before{border-radius:inherit;bottom:0;content:\"\";position:absolute;opacity:.2;left:0;right:0;top:0;-webkit-transform-origin:center center;transform-origin:center center;-webkit-transform:scale(.2);transform:scale(.2);transition:inherit}.v-input--selection-controls__ripple .v-ripple__container{-webkit-transform:scale(1.4);transform:scale(1.4)}.v-input--selection-controls.v-input .v-label{align-items:center;display:inline-flex;top:0;height:auto}.v-input--selection-controls.v-input--is-focused .v-input--selection-controls__ripple:before,.v-input--selection-controls .v-radio--is-focused .v-input--selection-controls__ripple:before{background:currentColor;-webkit-transform:scale(.8);transform:scale(.8)}.theme--light.v-input:not(.v-input--is-disabled) input,.theme--light.v-input:not(.v-input--is-disabled) textarea{color:rgba(0,0,0,.87)}.theme--light.v-input input::-webkit-input-placeholder,.theme--light.v-input textarea::-webkit-input-placeholder{color:rgba(0,0,0,.38)}.theme--light.v-input input:-ms-input-placeholder,.theme--light.v-input input::-ms-input-placeholder,.theme--light.v-input textarea:-ms-input-placeholder,.theme--light.v-input textarea::-ms-input-placeholder{color:rgba(0,0,0,.38)}.theme--light.v-input input::placeholder,.theme--light.v-input textarea::placeholder{color:rgba(0,0,0,.38)}.theme--light.v-input--is-disabled .v-label,.theme--light.v-input--is-disabled input,.theme--light.v-input--is-disabled textarea{color:rgba(0,0,0,.38)}.theme--dark.v-input:not(.v-input--is-disabled) input,.theme--dark.v-input:not(.v-input--is-disabled) textarea{color:#fff}.theme--dark.v-input input::-webkit-input-placeholder,.theme--dark.v-input textarea::-webkit-input-placeholder{color:hsla(0,0%,100%,.5)}.theme--dark.v-input input:-ms-input-placeholder,.theme--dark.v-input input::-ms-input-placeholder,.theme--dark.v-input textarea:-ms-input-placeholder,.theme--dark.v-input textarea::-ms-input-placeholder{color:hsla(0,0%,100%,.5)}.theme--dark.v-input input::placeholder,.theme--dark.v-input textarea::placeholder{color:hsla(0,0%,100%,.5)}.theme--dark.v-input--is-disabled .v-label,.theme--dark.v-input--is-disabled input,.theme--dark.v-input--is-disabled textarea{color:hsla(0,0%,100%,.5)}.v-input{align-items:flex-start;display:flex;flex:1 1 auto;font-size:16px;text-align:left}.v-input .v-progress-linear{top:calc(100% - 1px);left:0;margin:0;position:absolute}.v-input input{max-height:32px}.v-input input:invalid,.v-input textarea:invalid{box-shadow:none}.v-input input:active,.v-input input:focus,.v-input textarea:active,.v-input textarea:focus{outline:none}.v-input .v-label{height:20px;line-height:20px}.v-input__append-outer,.v-input__prepend-outer{display:inline-flex;margin-bottom:4px;margin-top:4px;line-height:1}.v-input__append-outer .v-icon,.v-input__prepend-outer .v-icon{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-input__append-outer{margin-left:9px}.v-input__prepend-outer{margin-right:9px}.v-input__control{display:flex;flex-direction:column;height:auto;flex-grow:1;flex-wrap:wrap;width:100%}.v-input__icon{align-items:center;display:inline-flex;height:24px;flex:1 0 auto;justify-content:center;min-width:24px;width:24px}.v-input__icon--clear{border-radius:50%}.v-input__slot{align-items:center;color:inherit;display:flex;margin-bottom:8px;min-height:inherit;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-input--is-disabled:not(.v-input--is-readonly){pointer-events:none}.v-input--is-loading>.v-input__control>.v-input__slot:after,.v-input--is-loading>.v-input__control>.v-input__slot:before{display:none}.v-input--hide-details>.v-input__control>.v-input__slot{margin-bottom:0}.v-input--has-state.error--text .v-label{-webkit-animation:shake .6s cubic-bezier(.25,.8,.5,1);animation:shake .6s cubic-bezier(.25,.8,.5,1)}.theme--light.v-label{color:rgba(0,0,0,.54)}.theme--light.v-label--is-disabled{color:rgba(0,0,0,.38)}.theme--dark.v-label{color:hsla(0,0%,100%,.7)}.theme--dark.v-label--is-disabled{color:hsla(0,0%,100%,.5)}.v-label{font-size:16px;line-height:1;min-height:8px;transition:.3s cubic-bezier(.25,.8,.5,1)}.theme--light.v-messages{color:rgba(0,0,0,.54)}.theme--dark.v-messages{color:hsla(0,0%,100%,.7)}.application--is-rtl .v-messages{text-align:right}.v-messages{flex:1 1 auto;font-size:12px;min-height:12px;min-width:1px;position:relative}.v-messages__message{line-height:normal;word-break:break-word;overflow-wrap:break-word;word-wrap:break-word;-webkit-hyphens:auto;-ms-hyphens:auto;hyphens:auto}.theme--light.v-divider{border-color:rgba(0,0,0,.12)}.theme--dark.v-divider{border-color:hsla(0,0%,100%,.12)}.v-divider{display:block;flex:1 1 0px;max-width:100%;height:0;max-height:0;border:solid;border-width:thin 0 0;transition:inherit}.v-divider--inset:not(.v-divider--vertical){margin-left:72px;max-width:calc(100% - 72px)}.v-divider--vertical{align-self:stretch;border:solid;border-width:0 thin 0 0;display:inline-flex;height:inherit;min-height:100%;max-height:100%;max-width:0;width:0;vertical-align:text-bottom}.v-divider--vertical.v-divider--inset{margin-top:8px;min-height:0;max-height:calc(100% - 16px)}.theme--light.v-subheader{color:rgba(0,0,0,.54)}.theme--dark.v-subheader{color:hsla(0,0%,100%,.7)}.v-subheader{align-items:center;display:flex;height:48px;font-size:14px;font-weight:500;padding:0 16px}.v-subheader--inset{margin-left:56px}.theme--light.v-list{background:#fff;color:rgba(0,0,0,.87)}.theme--light.v-list .v-list--disabled{color:rgba(0,0,0,.38)}.theme--light.v-list .v-list__tile__sub-title{color:rgba(0,0,0,.54)}.theme--light.v-list .v-list__tile__mask{color:rgba(0,0,0,.38);background:#eee}.theme--light.v-list .v-list__group__header:hover,.theme--light.v-list .v-list__tile--highlighted,.theme--light.v-list .v-list__tile--link:hover{background:rgba(0,0,0,.04)}.theme--light.v-list .v-list__group--active:after,.theme--light.v-list .v-list__group--active:before{background:rgba(0,0,0,.12)}.theme--light.v-list .v-list__group--disabled .v-list__group__header__prepend-icon .v-icon,.theme--light.v-list .v-list__group--disabled .v-list__tile{color:rgba(0,0,0,.38)!important}.theme--dark.v-list{background:#424242;color:#fff}.theme--dark.v-list .v-list--disabled{color:hsla(0,0%,100%,.5)}.theme--dark.v-list .v-list__tile__sub-title{color:hsla(0,0%,100%,.7)}.theme--dark.v-list .v-list__tile__mask{color:hsla(0,0%,100%,.5);background:#494949}.theme--dark.v-list .v-list__group__header:hover,.theme--dark.v-list .v-list__tile--highlighted,.theme--dark.v-list .v-list__tile--link:hover{background:hsla(0,0%,100%,.08)}.theme--dark.v-list .v-list__group--active:after,.theme--dark.v-list .v-list__group--active:before{background:hsla(0,0%,100%,.12)}.theme--dark.v-list .v-list__group--disabled .v-list__group__header__prepend-icon .v-icon,.theme--dark.v-list .v-list__group--disabled .v-list__tile{color:hsla(0,0%,100%,.5)!important}.application--is-rtl .v-list__tile__content,.application--is-rtl .v-list__tile__title{text-align:right}.v-list{list-style-type:none;padding:8px 0;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-list>div{transition:inherit}.v-list__tile{align-items:center;color:inherit;display:flex;font-size:16px;font-weight:400;height:48px;margin:0;padding:0 16px;position:relative;text-decoration:none;transition:background .3s cubic-bezier(.25,.8,.5,1)}.v-list__tile--link{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-list__tile__action,.v-list__tile__content{height:100%}.v-list__tile__sub-title,.v-list__tile__title{white-space:nowrap;overflow:hidden;text-overflow:ellipsis;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-list__tile__title{height:24px;line-height:24px;position:relative;text-align:left}.v-list__tile__sub-title{font-size:14px}.v-list__tile__action,.v-list__tile__avatar{display:flex;justify-content:flex-start;min-width:56px}.v-list__tile__action{align-items:center}.v-list__tile__action .v-btn{padding:0;margin:0}.v-list__tile__action .v-btn--icon{margin:-6px}.v-list__tile__action .v-radio.v-radio{margin:0}.v-list__tile__action .v-input--selection-controls{padding:0;margin:0}.v-list__tile__action .v-input--selection-controls .v-messages{display:none}.v-list__tile__action .v-input--selection-controls .v-input__slot{margin:0}.v-list__tile__action-text{color:#9e9e9e;font-size:12px}.v-list__tile__action--stack{align-items:flex-end;justify-content:space-between;padding-top:8px;padding-bottom:8px;white-space:nowrap;flex-direction:column}.v-list__tile__content{text-align:left;flex:1 1 auto;overflow:hidden;display:flex;align-items:flex-start;justify-content:center;flex-direction:column}.v-list__tile__content~.v-list__tile__action:not(.v-list__tile__action--stack),.v-list__tile__content~.v-list__tile__avatar{justify-content:flex-end}.v-list__tile--active .v-list__tile__action:first-of-type .v-icon{color:inherit}.v-list__tile--avatar{height:56px}.v-list--dense{padding-top:4px;padding-bottom:4px}.v-list--dense .v-subheader{font-size:13px;height:40px}.v-list--dense .v-list__group .v-subheader{height:40px}.v-list--dense .v-list__tile{font-size:13px}.v-list--dense .v-list__tile--avatar{height:48px}.v-list--dense .v-list__tile:not(.v-list__tile--avatar){height:40px}.v-list--dense .v-list__tile .v-icon{font-size:22px}.v-list--dense .v-list__tile__sub-title{font-size:13px}.v-list--disabled{pointer-events:none}.v-list--two-line .v-list__tile{height:72px}.v-list--two-line.v-list--dense .v-list__tile{height:60px}.v-list--three-line .v-list__tile{height:88px}.v-list--three-line .v-list__tile__avatar{margin-top:-18px}.v-list--three-line .v-list__tile__sub-title{white-space:normal;-webkit-line-clamp:2;display:-webkit-box}.v-list--three-line.v-list--dense .v-list__tile{height:76px}.v-list>.v-list__group:before{top:0}.v-list>.v-list__group:before .v-list__tile__avatar{margin-top:-14px}.v-list__group{padding:0;position:relative;transition:inherit}.v-list__group:after,.v-list__group:before{content:\"\";height:1px;left:0;position:absolute;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-list__group--active~.v-list__group:before{display:none}.v-list__group__header{align-items:center;cursor:pointer;display:flex;list-style-type:none}.v-list__group__header>div:not(.v-list__group__header__prepend-icon):not(.v-list__group__header__append-icon){flex:1 1 auto;overflow:hidden}.v-list__group__header .v-list__group__header__append-icon,.v-list__group__header .v-list__group__header__prepend-icon{padding:0 16px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-list__group__header--sub-group{align-items:center;display:flex}.v-list__group__header--sub-group div .v-list__tile{padding-left:0}.v-list__group__header--sub-group .v-list__group__header__prepend-icon{padding:0 0 0 40px;margin-right:8px}.v-list__group__header .v-list__group__header__prepend-icon{display:flex;justify-content:flex-start;min-width:56px}.v-list__group__header--active .v-list__group__header__append-icon .v-icon{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.v-list__group__header--active .v-list__group__header__prepend-icon .v-icon{color:inherit}.v-list__group__header--active.v-list__group__header--sub-group .v-list__group__header__prepend-icon .v-icon{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.v-list__group__items{position:relative;padding:0;transition:inherit}.v-list__group__items>div{display:block}.v-list__group__items--no-action .v-list__tile{padding-left:72px}.v-list__group--disabled{pointer-events:none}.v-list--subheader{padding-top:0}.v-avatar{align-items:center;border-radius:50%;display:inline-flex;justify-content:center;position:relative;text-align:center;vertical-align:middle}.v-avatar .v-icon,.v-avatar .v-image,.v-avatar img{border-radius:50%;display:inline-flex;height:inherit;width:inherit}.v-avatar--tile,.v-avatar--tile .v-icon,.v-avatar--tile .v-image,.v-avatar--tile img{border-radius:0}.theme--light.v-counter{color:rgba(0,0,0,.54)}.theme--dark.v-counter{color:hsla(0,0%,100%,.7)}.v-counter{flex:0 1 auto;font-size:12px;min-height:12px;line-height:1}.v-progress-linear{background:transparent;margin:1rem 0;overflow:hidden;width:100%;position:relative}.v-progress-linear__bar{width:100%;position:relative;z-index:1}.v-progress-linear__bar,.v-progress-linear__bar__determinate{height:inherit;transition:.2s cubic-bezier(.4,0,.6,1)}.v-progress-linear__bar__indeterminate .long,.v-progress-linear__bar__indeterminate .short{height:inherit;position:absolute;left:0;top:0;bottom:0;will-change:left,right;width:auto;background-color:inherit}.v-progress-linear__bar__indeterminate--active .long{-webkit-animation:indeterminate;animation:indeterminate;-webkit-animation-duration:2.2s;animation-duration:2.2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.v-progress-linear__bar__indeterminate--active .short{-webkit-animation:indeterminate-short;animation:indeterminate-short;-webkit-animation-duration:2.2s;animation-duration:2.2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.v-progress-linear__background{position:absolute;top:0;left:0;bottom:0;transition:.3s ease-in}.v-progress-linear__content{width:100%;height:100%;position:absolute;top:0;left:0;z-index:2}.v-progress-linear--query .v-progress-linear__bar__indeterminate--active .long{-webkit-animation:query;animation:query;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}.v-progress-linear--query .v-progress-linear__bar__indeterminate--active .short{-webkit-animation:query-short;animation:query-short;-webkit-animation-duration:2s;animation-duration:2s;-webkit-animation-iteration-count:infinite;animation-iteration-count:infinite}@-webkit-keyframes indeterminate{0%{left:-90%;right:100%}60%{left:-90%;right:100%}to{left:100%;right:-35%}}@keyframes indeterminate{0%{left:-90%;right:100%}60%{left:-90%;right:100%}to{left:100%;right:-35%}}@-webkit-keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}@keyframes indeterminate-short{0%{left:-200%;right:100%}60%{left:107%;right:-8%}to{left:107%;right:-8%}}@-webkit-keyframes query{0%{right:-90%;left:100%}60%{right:-90%;left:100%}to{right:100%;left:-35%}}@keyframes query{0%{right:-90%;left:100%}60%{right:-90%;left:100%}to{right:100%;left:-35%}}@-webkit-keyframes query-short{0%{right:-200%;left:100%}60%{right:107%;left:-8%}to{right:107%;left:-8%}}@keyframes query-short{0%{right:-200%;left:100%}60%{right:107%;left:-8%}to{right:107%;left:-8%}}.application--is-rtl .v-badge__badge{right:auto;left:-22px}.application--is-rtl .v-badge--overlap .v-badge__badge{right:auto;left:-8px}.application--is-rtl .v-badge--overlap.v-badge--left .v-badge__badge{right:-8px;left:auto}.application--is-rtl .v-badge--left .v-badge__badge{right:-22px;left:auto}.v-badge{display:inline-block;position:relative}.v-badge__badge{color:#fff;display:flex;position:absolute;font-size:14px;top:-11px;right:-22px;border-radius:50%;height:22px;width:22px;justify-content:center;align-items:center;flex-direction:row;flex-wrap:wrap;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-badge__badge .v-icon{font-size:14px}.v-badge--overlap .v-badge__badge{top:-8px;right:-8px}.v-badge--overlap.v-badge--left .v-badge__badge{left:-8px;right:auto}.v-badge--overlap.v-badge--bottom .v-badge__badge{bottom:-8px;top:auto}.v-badge--left .v-badge__badge{left:-22px}.v-badge--bottom .v-badge__badge{bottom:-11px;top:auto}.theme--light.v-bottom-nav{background-color:#fff}.theme--light.v-bottom-nav .v-btn:not(.v-btn--active){color:rgba(0,0,0,.54)!important}.theme--dark.v-bottom-nav{background-color:#424242}.theme--dark.v-bottom-nav .v-btn:not(.v-btn--active){color:hsla(0,0%,100%,.7)!important}.v-item-group.v-bottom-nav{bottom:0;box-shadow:0 3px 14px 2px rgba(0,0,0,.12);display:flex;left:0;justify-content:center;-webkit-transform:translateY(60px);transform:translateY(60px);transition:all .4s cubic-bezier(.25,.8,.5,1);width:100%}.v-item-group.v-bottom-nav--absolute{position:absolute}.v-item-group.v-bottom-nav--active{-webkit-transform:translate(0);transform:translate(0)}.v-item-group.v-bottom-nav--fixed{position:fixed;z-index:4}.v-item-group.v-bottom-nav .v-btn{background:transparent!important;border-radius:0;box-shadow:none!important;font-weight:400;height:100%;margin:0;max-width:168px;min-width:80px;padding:8px 12px 10px;text-transform:none;width:100%;flex-shrink:1}.v-item-group.v-bottom-nav .v-btn .v-btn__content{flex-direction:column-reverse;font-size:12px;white-space:nowrap;will-change:font-size}.v-item-group.v-bottom-nav .v-btn .v-btn__content i.v-icon{color:inherit;margin-bottom:4px;transition:all .4s cubic-bezier(.25,.8,.5,1)}.v-item-group.v-bottom-nav .v-btn .v-btn__content span{line-height:1}.v-item-group.v-bottom-nav .v-btn--active{padding-top:6px}.v-item-group.v-bottom-nav .v-btn--active:before{background-color:transparent}.v-item-group.v-bottom-nav .v-btn--active .v-btn__content{font-size:14px}.v-item-group.v-bottom-nav .v-btn--active .v-btn__content .v-icon{-webkit-transform:none;transform:none}.v-item-group.v-bottom-nav--shift .v-btn__content{font-size:14px}.v-item-group.v-bottom-nav--shift .v-btn{transition:all .3s;min-width:56px;max-width:96px}.v-item-group.v-bottom-nav--shift .v-btn--active{min-width:96px;max-width:168px}.v-bottom-nav--shift .v-btn:not(.v-btn--active) .v-btn__content .v-icon{-webkit-transform:scale(1) translateY(8px);transform:scale(1) translateY(8px)}.v-bottom-nav--shift .v-btn:not(.v-btn--active) .v-btn__content>span:not(.v-badge){color:transparent}.v-item-group{flex:0 1 auto;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-item-group>*{cursor:pointer;flex:1 1 auto}.v-bottom-sheet.v-dialog{align-self:flex-end;border-radius:0;flex:1 0 100%;margin:0;min-width:100%;overflow:visible;transition:.3s cubic-bezier(.25,.8,.25,1)}.v-bottom-sheet.v-dialog.v-bottom-sheet--inset{max-width:70%;min-width:0}@media only screen and (max-width:599px){.v-bottom-sheet.v-dialog.v-bottom-sheet--inset{max-width:none}}.v-dialog{box-shadow:0 11px 15px -7px rgba(0,0,0,.2),0 24px 38px 3px rgba(0,0,0,.14),0 9px 46px 8px rgba(0,0,0,.12);border-radius:2px;margin:24px;overflow-y:auto;pointer-events:auto;transition:.3s cubic-bezier(.25,.8,.25,1);width:100%;z-index:inherit}.v-dialog__content{align-items:center;display:flex;height:100%;justify-content:center;left:0;pointer-events:none;position:fixed;top:0;transition:.2s cubic-bezier(.25,.8,.25,1);width:100%;z-index:6;outline:none}.v-dialog:not(.v-dialog--fullscreen){max-height:90%}.v-dialog__activator,.v-dialog__activator *{cursor:pointer}.v-dialog__container{display:inline-block;vertical-align:middle}.v-dialog--animated{-webkit-animation-duration:.15s;animation-duration:.15s;-webkit-animation-name:animate-dialog;animation-name:animate-dialog;-webkit-animation-timing-function:cubic-bezier(.25,.8,.25,1);animation-timing-function:cubic-bezier(.25,.8,.25,1)}.v-dialog--fullscreen{border-radius:0;margin:0;height:100%;position:fixed;overflow-y:auto;top:0;left:0}.v-dialog--fullscreen>.v-card{min-height:100%;min-width:100%;margin:0!important;padding:0!important}.v-dialog--scrollable,.v-dialog--scrollable>form{display:flex}.v-dialog--scrollable>.v-card,.v-dialog--scrollable>form>.v-card{display:flex;flex:1 1 100%;max-width:100%;flex-direction:column}.v-dialog--scrollable>.v-card>.v-card__actions,.v-dialog--scrollable>.v-card>.v-card__title,.v-dialog--scrollable>form>.v-card>.v-card__actions,.v-dialog--scrollable>form>.v-card>.v-card__title{flex:1 0 auto}.v-dialog--scrollable>.v-card>.v-card__text,.v-dialog--scrollable>form>.v-card>.v-card__text{overflow-y:auto;-webkit-backface-visibility:hidden;backface-visibility:hidden}@-webkit-keyframes animate-dialog{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(1.03);transform:scale(1.03)}to{-webkit-transform:scale(1);transform:scale(1)}}@keyframes animate-dialog{0%{-webkit-transform:scale(1);transform:scale(1)}50%{-webkit-transform:scale(1.03);transform:scale(1.03)}to{-webkit-transform:scale(1);transform:scale(1)}}.v-overlay{position:fixed;top:0;left:0;right:0;bottom:0;pointer-events:none;transition:.3s cubic-bezier(.25,.8,.5,1);z-index:5}.v-overlay--absolute{position:absolute}.v-overlay:before{background-color:#212121;bottom:0;content:\"\";height:100%;left:0;opacity:0;position:absolute;right:0;top:0;transition:inherit;transition-delay:.15s;width:100%}.v-overlay--active{pointer-events:auto;touch-action:none}.v-overlay--active:before{opacity:.46}.theme--light.v-breadcrumbs .v-breadcrumbs__divider,.theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled{color:rgba(0,0,0,.38)}.theme--dark.v-breadcrumbs .v-breadcrumbs__divider,.theme--dark.v-breadcrumbs .v-breadcrumbs__item--disabled{color:hsla(0,0%,100%,.5)}.v-breadcrumbs{align-items:center;display:flex;flex-wrap:wrap;flex:0 1 auto;list-style-type:none;margin:0;padding:18px 12px}.v-breadcrumbs li{align-items:center;display:inline-flex;font-size:14px}.v-breadcrumbs li .v-icon{font-size:16px}.v-breadcrumbs li:nth-child(2n){padding:0 12px}.v-breadcrumbs--large li,.v-breadcrumbs--large li .v-icon{font-size:16px}.v-breadcrumbs__item{align-items:center;display:inline-flex;text-decoration:none;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-breadcrumbs__item--disabled{pointer-events:none}.v-ripple__container{border-radius:inherit;width:100%;height:100%;z-index:0;contain:strict}.v-ripple__animation,.v-ripple__container{color:inherit;position:absolute;left:0;top:0;overflow:hidden;pointer-events:none}.v-ripple__animation{border-radius:50%;background:currentColor;opacity:0;will-change:transform,opacity}.v-ripple__animation--enter{transition:none}.v-ripple__animation--in{transition:opacity .1s cubic-bezier(.4,0,.2,1),-webkit-transform .25s cubic-bezier(.4,0,.2,1);transition:transform .25s cubic-bezier(.4,0,.2,1),opacity .1s cubic-bezier(.4,0,.2,1);transition:transform .25s cubic-bezier(.4,0,.2,1),opacity .1s cubic-bezier(.4,0,.2,1),-webkit-transform .25s cubic-bezier(.4,0,.2,1)}.v-ripple__animation--out{transition:opacity .3s cubic-bezier(.4,0,.2,1)}.theme--light.v-btn{color:rgba(0,0,0,.87)}.theme--light.v-btn.v-btn--disabled,.theme--light.v-btn.v-btn--disabled .v-btn__loading,.theme--light.v-btn.v-btn--disabled .v-icon{color:rgba(0,0,0,.26)!important}.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline){background-color:rgba(0,0,0,.12)!important}.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat){background-color:#f5f5f5}.theme--dark.v-btn{color:#fff}.theme--dark.v-btn.v-btn--disabled,.theme--dark.v-btn.v-btn--disabled .v-btn__loading,.theme--dark.v-btn.v-btn--disabled .v-icon{color:hsla(0,0%,100%,.3)!important}.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline){background-color:hsla(0,0%,100%,.12)!important}.theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat){background-color:#212121}.v-btn{align-items:center;border-radius:2px;display:inline-flex;height:36px;flex:0 0 auto;font-size:14px;font-weight:500;justify-content:center;margin:6px 8px;min-width:88px;outline:0;text-transform:uppercase;text-decoration:none;transition:.3s cubic-bezier(.25,.8,.5,1),color 1ms;position:relative;vertical-align:middle;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-btn:before{border-radius:inherit;color:inherit;content:\"\";position:absolute;left:0;top:0;height:100%;opacity:.12;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-btn{padding:0 16px}.v-btn--active,.v-btn:focus,.v-btn:hover{position:relative}.v-btn--active:before,.v-btn:focus:before,.v-btn:hover:before{background-color:currentColor}.v-btn__content{align-items:center;border-radius:inherit;color:inherit;display:flex;flex:1 0 auto;justify-content:center;margin:0 auto;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1);white-space:nowrap;width:inherit}.v-btn--small{font-size:13px;height:28px;padding:0 8px}.v-btn--large{font-size:15px;height:44px;padding:0 32px}.v-btn .v-btn__content .v-icon{color:inherit}.v-btn:not(.v-btn--depressed):not(.v-btn--flat){will-change:box-shadow;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.v-btn:not(.v-btn--depressed):not(.v-btn--flat):active{box-shadow:0 5px 5px -3px rgba(0,0,0,.2),0 8px 10px 1px rgba(0,0,0,.14),0 3px 14px 2px rgba(0,0,0,.12)}.v-btn--icon{background:transparent;box-shadow:none!important;border-radius:50%;justify-content:center;min-width:0;width:36px}.v-btn--icon.v-btn--small{width:28px}.v-btn--icon.v-btn--large{width:44px}.v-btn--floating,.v-btn--icon:before{border-radius:50%}.v-btn--floating{min-width:0;height:56px;width:56px;padding:0}.v-btn--floating.v-btn--absolute,.v-btn--floating.v-btn--fixed{z-index:4}.v-btn--floating:not(.v-btn--depressed):not(.v-btn--flat){box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.v-btn--floating:not(.v-btn--depressed):not(.v-btn--flat):active{box-shadow:0 7px 8px -4px rgba(0,0,0,.2),0 12px 17px 2px rgba(0,0,0,.14),0 5px 22px 4px rgba(0,0,0,.12)}.v-btn--floating .v-btn__content{flex:1 1 auto;margin:0;height:100%}.v-btn--floating:after{border-radius:50%}.v-btn--floating .v-btn__content>:not(:only-child){transition:.3s cubic-bezier(.25,.8,.5,1)}.v-btn--floating .v-btn__content>:not(:only-child):first-child{opacity:1}.v-btn--floating .v-btn__content>:not(:only-child):last-child{opacity:0;-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.v-btn--floating .v-btn__content>:not(:only-child):first-child,.v-btn--floating .v-btn__content>:not(:only-child):last-child{-webkit-backface-visibility:hidden;position:absolute;left:0;top:0}.v-btn--floating.v-btn--active .v-btn__content>:not(:only-child):first-child{opacity:0;-webkit-transform:rotate(45deg);transform:rotate(45deg)}.v-btn--floating.v-btn--active .v-btn__content>:not(:only-child):last-child{opacity:1;-webkit-transform:rotate(0);transform:rotate(0)}.v-btn--floating .v-icon{height:inherit;width:inherit}.v-btn--floating.v-btn--small{height:40px;width:40px}.v-btn--floating.v-btn--small .v-icon{font-size:18px}.v-btn--floating.v-btn--large{height:72px;width:72px}.v-btn--floating.v-btn--large .v-icon{font-size:30px}.v-btn--reverse .v-btn__content{flex-direction:row-reverse}.v-btn--reverse.v-btn--column .v-btn__content{flex-direction:column-reverse}.v-btn--absolute,.v-btn--fixed{margin:0}.v-btn.v-btn--absolute{position:absolute}.v-btn.v-btn--fixed{position:fixed}.v-btn--top:not(.v-btn--absolute){top:16px}.v-btn--top.v-btn--absolute{top:-28px}.v-btn--top.v-btn--absolute.v-btn--small{top:-20px}.v-btn--top.v-btn--absolute.v-btn--large{top:-36px}.v-btn--bottom:not(.v-btn--absolute){bottom:16px}.v-btn--bottom.v-btn--absolute{bottom:-28px}.v-btn--bottom.v-btn--absolute.v-btn--small{bottom:-20px}.v-btn--bottom.v-btn--absolute.v-btn--large{bottom:-36px}.v-btn--left{left:16px}.v-btn--right{right:16px}.v-btn.v-btn--disabled{box-shadow:none!important;pointer-events:none}.v-btn:not(.v-btn--disabled):not(.v-btn--floating):not(.v-btn--icon) .v-btn__content .v-icon{transition:none}.v-btn--icon{padding:0}.v-btn--loader{pointer-events:none}.v-btn--loader .v-btn__content{opacity:0}.v-btn__loading{align-items:center;display:flex;height:100%;justify-content:center;left:0;position:absolute;top:0;width:100%}.v-btn__loading .v-icon--left{margin-right:1rem;line-height:inherit}.v-btn__loading .v-icon--right{margin-left:1rem;line-height:inherit}.v-btn.v-btn--outline{border:1px solid currentColor;background:transparent!important;box-shadow:none}.v-btn.v-btn--outline:hover{box-shadow:none}.v-btn--block{display:flex;flex:1;margin:6px 0;width:100%}.v-btn--round,.v-btn--round:after{border-radius:28px}.v-btn:not(.v-btn--outline).accent,.v-btn:not(.v-btn--outline).error,.v-btn:not(.v-btn--outline).info,.v-btn:not(.v-btn--outline).primary,.v-btn:not(.v-btn--outline).secondary,.v-btn:not(.v-btn--outline).success,.v-btn:not(.v-btn--outline).warning{color:#fff}@media (hover:none){.v-btn:hover:before{background-color:transparent}}.v-progress-circular{position:relative;display:inline-flex;vertical-align:middle}.v-progress-circular svg{width:100%;height:100%;margin:auto;position:absolute;top:0;bottom:0;left:0;right:0;z-index:0}.v-progress-circular--indeterminate svg{-webkit-animation:progress-circular-rotate 1.4s linear infinite;animation:progress-circular-rotate 1.4s linear infinite;-webkit-transform-origin:center center;transform-origin:center center;transition:all .2s ease-in-out}.v-progress-circular--indeterminate .v-progress-circular__overlay{-webkit-animation:progress-circular-dash 1.4s ease-in-out infinite;animation:progress-circular-dash 1.4s ease-in-out infinite;stroke-linecap:round;stroke-dasharray:80,200;stroke-dashoffset:0px}.v-progress-circular__underlay{stroke:rgba(0,0,0,.1);z-index:1}.v-progress-circular__overlay{stroke:currentColor;z-index:2;transition:all .6s ease-in-out}.v-progress-circular__info{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}@-webkit-keyframes progress-circular-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0px}50%{stroke-dasharray:100,200;stroke-dashoffset:-15px}to{stroke-dasharray:100,200;stroke-dashoffset:-125px}}@keyframes progress-circular-dash{0%{stroke-dasharray:1,200;stroke-dashoffset:0px}50%{stroke-dasharray:100,200;stroke-dashoffset:-15px}to{stroke-dasharray:100,200;stroke-dashoffset:-125px}}@-webkit-keyframes progress-circular-rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}@keyframes progress-circular-rotate{to{-webkit-transform:rotate(1turn);transform:rotate(1turn)}}.theme--light.v-btn-toggle{background:#fff}.theme--light.v-btn-toggle .v-btn{color:rgba(0,0,0,.87)}.theme--light.v-btn-toggle:not(.v-btn-toggle--only-child) .v-btn.v-btn--active:not(:last-child){border-right-color:rgba(0,0,0,.26)}.theme--dark.v-btn-toggle{background:#424242}.theme--dark.v-btn-toggle .v-btn{color:#fff}.theme--dark.v-btn-toggle:not(.v-btn-toggle--only-child) .v-btn.v-btn--active:not(:last-child){border-right-color:hsla(0,0%,100%,.3)}.v-btn-toggle{display:inline-flex;border-radius:2px;transition:.3s cubic-bezier(.25,.8,.5,1);will-change:background,box-shadow}.v-btn-toggle .v-btn{justify-content:center;min-width:auto;width:auto;padding:0 8px;margin:0;opacity:.4;border-radius:0}.v-btn-toggle .v-btn:not(:last-child){border-right:1px solid transparent}.v-btn-toggle .v-btn:after{display:none}.v-btn-toggle .v-btn.v-btn--active{opacity:1}.v-btn-toggle .v-btn span+.v-icon{font-size:medium;margin-left:10px}.v-btn-toggle .v-btn:first-child{border-radius:2px 0 0 2px}.v-btn-toggle .v-btn:last-child{border-radius:0 2px 2px 0}.v-btn-toggle--selected{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.theme--light.v-calendar-weekly{background-color:#fff}.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday{border-right:1px solid #e0e0e0;color:#000}.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past{color:rgba(0,0,0,.38)}.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside{background-color:#f7f7f7}.theme--light.v-calendar-weekly .v-calendar-weekly__day{border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;color:#000}.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside{background-color:#f7f7f7}.theme--dark.v-calendar-weekly{background-color:#303030}.theme--dark.v-calendar-weekly .v-calendar-weekly__head-weekday{border-right:1px solid #9e9e9e;color:#fff}.theme--dark.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past{color:hsla(0,0%,100%,.5)}.theme--dark.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside{background-color:#202020}.theme--dark.v-calendar-weekly .v-calendar-weekly__day{border-right:1px solid #9e9e9e;border-bottom:1px solid #9e9e9e;color:#fff}.theme--dark.v-calendar-weekly .v-calendar-weekly__day.v-outside{background-color:#202020}.v-calendar-weekly{width:100%;height:100%;display:flex;flex-direction:column}.v-calendar-weekly__head{display:flex}.v-calendar-weekly__head,.v-calendar-weekly__head-weekday{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-calendar-weekly__head-weekday{flex:1 0 20px;padding:0 4px;font-size:14px}.v-calendar-weekly__week{display:flex;flex:1}.v-calendar-weekly__day{flex:1;width:0;overflow:hidden;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;position:relative;padding:32px 4px 4px}.v-calendar-weekly__day.v-present .v-calendar-weekly__day-label{border:1px solid currentColor}.v-calendar-weekly__day.v-present .v-calendar-weekly__day-month{color:currentColor}.v-calendar-weekly__day-label{position:absolute;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;cursor:pointer;box-shadow:none;text-align:center;left:0;top:0;border-radius:16px;width:32px;height:32px;line-height:32px}.v-calendar-weekly__day-label:hover{text-decoration:underline}.v-calendar-weekly__day-month{position:absolute;text-decoration:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;box-shadow:none;top:0;left:36px;height:32px;line-height:32px}.theme--light.v-calendar-daily{background-color:#fff}.theme--light.v-calendar-daily .v-calendar-daily__intervals-head{border-right:1px solid #e0e0e0}.theme--light.v-calendar-daily .v-calendar-daily_head-day{border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0;color:#000}.theme--light.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-day-label,.theme--light.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-weekday{color:rgba(0,0,0,.38)}.theme--light.v-calendar-daily .v-calendar-daily__intervals-body{border-right:1px solid #e0e0e0}.theme--light.v-calendar-daily .v-calendar-daily__intervals-body .v-calendar-daily__interval-text{color:#424242}.theme--light.v-calendar-daily .v-calendar-daily__day{border-right:1px solid #e0e0e0;border-bottom:1px solid #e0e0e0}.theme--light.v-calendar-daily .v-calendar-daily__day-interval{border-top:1px solid #e0e0e0}.theme--light.v-calendar-daily .v-calendar-daily__day-interval:first-child{border-top:none!important}.theme--dark.v-calendar-daily{background-color:#303030}.theme--dark.v-calendar-daily .v-calendar-daily__intervals-head{border-right:1px solid #9e9e9e}.theme--dark.v-calendar-daily .v-calendar-daily_head-day{border-right:1px solid #9e9e9e;border-bottom:1px solid #9e9e9e;color:#fff}.theme--dark.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-day-label,.theme--dark.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-weekday{color:hsla(0,0%,100%,.5)}.theme--dark.v-calendar-daily .v-calendar-daily__intervals-body{border-right:1px solid #9e9e9e}.theme--dark.v-calendar-daily .v-calendar-daily__intervals-body .v-calendar-daily__interval-text{color:#eee}.theme--dark.v-calendar-daily .v-calendar-daily__day{border-right:1px solid #616161;border-bottom:1px solid #616161}.theme--dark.v-calendar-daily .v-calendar-daily__day-interval{border-top:1px solid #616161}.theme--dark.v-calendar-daily .v-calendar-daily__day-interval:first-child{border-top:none!important}.v-calendar-daily{display:flex;flex-direction:column;overflow:hidden;height:100%}.v-calendar-daily__head{flex:none;display:flex}.v-calendar-daily__intervals-head{flex:none;width:44px}.v-calendar-daily_head-day{flex:1 1 auto;width:0}.v-calendar-daily_head-weekday{padding:4px 4px 4px 8px;font-size:14px}.v-calendar-daily_head-day-label,.v-calendar-daily_head-weekday{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-calendar-daily_head-day-label{font-size:40px;padding:0 4px 4px 8px;line-height:40px;cursor:pointer}.v-calendar-daily_head-day-label:hover{text-decoration:underline}.v-calendar-daily__body{flex:1 1 60%;overflow:hidden;display:flex;position:relative;flex-direction:column}.v-calendar-daily__scroll-area{overflow-y:scroll;flex:1 1 auto;display:flex;align-items:flex-start}.v-calendar-daily__pane{width:100%;overflow-y:hidden;flex:none;display:flex;align-items:flex-start}.v-calendar-daily__day-container{display:flex;flex:1;width:100%;height:100%}.v-calendar-daily__intervals-body{flex:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:44px}.v-calendar-daily__interval{text-align:center;border-bottom:none}.v-calendar-daily__interval-text{display:block;position:relative;top:-6px;font-size:10px}.v-calendar-daily__day{flex:1;width:0;position:relative}.theme--light.v-sheet{background-color:#fff;border-color:#fff;color:rgba(0,0,0,.87)}.theme--dark.v-sheet{background-color:#424242;border-color:#424242;color:#fff}.v-sheet{display:block;border-radius:2px;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-sheet--tile{border-radius:0}.v-image{z-index:0}.v-image__image,.v-image__placeholder{z-index:-1;position:absolute;top:0;left:0;width:100%;height:100%}.v-image__image{background-repeat:no-repeat}.v-image__image--preload{-webkit-filter:blur(2px);filter:blur(2px)}.v-image__image--contain{background-size:contain}.v-image__image--cover{background-size:cover}.v-responsive{position:relative;overflow:hidden;flex:1 0 auto;display:flex}.v-responsive__content{flex:1 0 0px}.v-responsive__sizer{transition:padding-bottom .2s cubic-bezier(.25,.8,.5,1);flex:0 0 0px}.application--is-rtl .v-carousel__prev{left:auto;right:5px}.application--is-rtl .v-carousel__next{left:5px;right:auto}.v-carousel{width:100%;position:relative;overflow:hidden;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.v-carousel__next,.v-carousel__prev{position:absolute;top:50%;z-index:1;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.v-carousel__next .v-btn,.v-carousel__prev .v-btn{margin:0;height:auto;width:auto}.v-carousel__next .v-btn i,.v-carousel__prev .v-btn i{font-size:48px}.v-carousel__next .v-btn:hover,.v-carousel__prev .v-btn:hover{background:none}.v-carousel__prev{left:5px}.v-carousel__next{right:5px}.v-carousel__controls{background:rgba(0,0,0,.5);align-items:center;bottom:0;display:flex;justify-content:center;left:0;position:absolute;height:50px;list-style-type:none;width:100%;z-index:1}.v-carousel__controls>.v-item-group{flex:0 1 auto}.v-carousel__controls__item{margin:0 8px!important}.v-carousel__controls__item .v-icon{opacity:.5;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-carousel__controls__item--active .v-icon{opacity:1;vertical-align:middle}.v-carousel__controls__item:hover{background:none}.v-carousel__controls__item:hover .v-icon{opacity:.8}.v-window__container{position:relative;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-window__container--is-active{overflow:hidden}.v-window-x-reverse-transition-enter-active,.v-window-x-reverse-transition-leave-active,.v-window-x-transition-enter-active,.v-window-x-transition-leave-active,.v-window-y-reverse-transition-enter-active,.v-window-y-reverse-transition-leave-active,.v-window-y-transition-enter-active,.v-window-y-transition-leave-active{transition:.3s cubic-bezier(.25,.8,.5,1)}.v-window-x-reverse-transition-leave,.v-window-x-reverse-transition-leave-to,.v-window-x-transition-leave,.v-window-x-transition-leave-to,.v-window-y-reverse-transition-leave,.v-window-y-reverse-transition-leave-to,.v-window-y-transition-leave,.v-window-y-transition-leave-to{position:absolute!important;top:0;width:100%}.v-window-x-transition-enter{-webkit-transform:translateX(100%);transform:translateX(100%)}.v-window-x-reverse-transition-enter,.v-window-x-transition-leave-to{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.v-window-x-reverse-transition-leave-to{-webkit-transform:translateX(100%);transform:translateX(100%)}.v-window-y-transition-enter{-webkit-transform:translateY(100%);transform:translateY(100%)}.v-window-y-reverse-transition-enter,.v-window-y-transition-leave-to{-webkit-transform:translateY(-100%);transform:translateY(-100%)}.v-window-y-reverse-transition-leave-to{-webkit-transform:translateY(100%);transform:translateY(100%)}.theme--light.v-data-iterator .v-data-iterator__actions{color:rgba(0,0,0,.54)}.theme--light.v-data-iterator .v-data-iterator__actions__select .v-select .v-input__append-inner,.theme--light.v-data-iterator .v-data-iterator__actions__select .v-select .v-select__selection--comma{color:rgba(0,0,0,.54)!important}.theme--dark.v-data-iterator .v-data-iterator__actions{color:hsla(0,0%,100%,.7)}.theme--dark.v-data-iterator .v-data-iterator__actions__select .v-select .v-input__append-inner,.theme--dark.v-data-iterator .v-data-iterator__actions__select .v-select .v-select__selection--comma{color:hsla(0,0%,100%,.7)!important}.v-data-iterator__actions{display:flex;justify-content:flex-end;align-items:center;font-size:12px;flex-wrap:wrap-reverse}.v-data-iterator__actions .v-btn{color:inherit}.v-data-iterator__actions .v-btn:last-of-type{margin-left:14px}.v-data-iterator__actions__range-controls{display:flex;align-items:center;min-height:48px}.v-data-iterator__actions__pagination{display:block;text-align:center;margin:0 32px 0 24px}.v-data-iterator__actions__select{display:flex;align-items:center;justify-content:flex-end;margin-right:14px;white-space:nowrap}.v-data-iterator__actions__select .v-select{flex:0 1 0;margin:13px 0 13px 34px;padding:0;position:static}.v-data-iterator__actions__select .v-select__selections{flex-wrap:nowrap}.v-data-iterator__actions__select .v-select__selections .v-select__selection--comma{font-size:12px}.theme--light.v-overflow-btn .v-input__control:before,.theme--light.v-overflow-btn .v-input__slot:before{background-color:rgba(0,0,0,.12)!important}.theme--light.v-overflow-btn.v-text-field--outline .v-input__control:before,.theme--light.v-overflow-btn.v-text-field--outline .v-input__slot:before{background-color:transparent!important}.theme--light.v-overflow-btn--editable.v-input--is-focused .v-input__append-inner,.theme--light.v-overflow-btn--editable.v-select--is-menu-active .v-input__append-inner,.theme--light.v-overflow-btn--editable:hover .v-input__append-inner,.theme--light.v-overflow-btn--segmented .v-input__append-inner{border-left:1px solid rgba(0,0,0,.12)}.theme--light.v-overflow-btn.v-input--is-focused .v-input__slot,.theme--light.v-overflow-btn.v-select--is-menu-active .v-input__slot,.theme--light.v-overflow-btn:hover .v-input__slot{background:#fff}.theme--dark.v-overflow-btn .v-input__control:before,.theme--dark.v-overflow-btn .v-input__slot:before{background-color:hsla(0,0%,100%,.12)!important}.theme--dark.v-overflow-btn.v-text-field--outline .v-input__control:before,.theme--dark.v-overflow-btn.v-text-field--outline .v-input__slot:before{background-color:transparent!important}.theme--dark.v-overflow-btn--editable.v-input--is-focused .v-input__append-inner,.theme--dark.v-overflow-btn--editable.v-select--is-menu-active .v-input__append-inner,.theme--dark.v-overflow-btn--editable:hover .v-input__append-inner,.theme--dark.v-overflow-btn--segmented .v-input__append-inner{border-left:1px solid hsla(0,0%,100%,.12)}.theme--dark.v-overflow-btn.v-input--is-focused .v-input__slot,.theme--dark.v-overflow-btn.v-select--is-menu-active .v-input__slot,.theme--dark.v-overflow-btn:hover .v-input__slot{background:#424242}.v-overflow-btn{margin-top:12px;padding-top:0}.v-overflow-btn:not(.v-overflow-btn--editable)>.v-input__control>.v-input__slot{cursor:pointer}.v-overflow-btn .v-select__slot{height:48px}.v-overflow-btn .v-select__slot input{margin-left:16px;cursor:pointer}.v-overflow-btn .v-select__selection--comma:first-child{margin-left:16px}.v-overflow-btn .v-input__slot{transition:.3s cubic-bezier(.25,.8,.5,1)}.v-overflow-btn .v-input__slot:after{content:none}.v-overflow-btn .v-label{margin-left:16px;top:calc(50% - 10px)}.v-overflow-btn .v-input__append-inner{width:48px;height:48px;align-self:auto;align-items:center;margin-top:0;padding:0;flex-shrink:0}.v-overflow-btn .v-input__append-outer,.v-overflow-btn .v-input__prepend-outer{margin-top:12px;margin-bottom:12px}.v-overflow-btn .v-input__control:before{height:1px;top:-1px;content:\"\";left:0;position:absolute;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-overflow-btn.v-input--is-focused .v-input__slot,.v-overflow-btn.v-select--is-menu-active .v-input__slot{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.v-overflow-btn .v-select__selections{width:0}.v-overflow-btn--segmented .v-select__selections{flex-wrap:nowrap}.v-overflow-btn--segmented .v-select__selections .v-btn{border-radius:0;margin:0;margin-right:-16px;height:48px;width:100%}.v-overflow-btn--segmented .v-select__selections .v-btn__content{justify-content:start}.v-overflow-btn--segmented .v-select__selections .v-btn__content:before{background-color:transparent}.v-overflow-btn--editable .v-select__slot input{cursor:text}.v-overflow-btn--editable .v-input__append-inner,.v-overflow-btn--editable .v-input__append-inner *{cursor:pointer}.theme--light.v-table{background-color:#fff;color:rgba(0,0,0,.87)}.theme--light.v-table thead tr:first-child{border-bottom:1px solid rgba(0,0,0,.12)}.theme--light.v-table thead th{color:rgba(0,0,0,.54)}.theme--light.v-table tbody tr:not(:first-child){border-top:1px solid rgba(0,0,0,.12)}.theme--light.v-table tbody tr[active]{background:#f5f5f5}.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row){background:#eee}.theme--light.v-table tfoot tr{border-top:1px solid rgba(0,0,0,.12)}.theme--dark.v-table{background-color:#424242;color:#fff}.theme--dark.v-table thead tr:first-child{border-bottom:1px solid hsla(0,0%,100%,.12)}.theme--dark.v-table thead th{color:hsla(0,0%,100%,.7)}.theme--dark.v-table tbody tr:not(:first-child){border-top:1px solid hsla(0,0%,100%,.12)}.theme--dark.v-table tbody tr[active]{background:#505050}.theme--dark.v-table tbody tr:hover:not(.v-datatable__expand-row){background:#616161}.theme--dark.v-table tfoot tr{border-top:1px solid hsla(0,0%,100%,.12)}.v-table__overflow{width:100%;overflow-x:auto;overflow-y:hidden}table.v-table{border-radius:2px;border-collapse:collapse;border-spacing:0;width:100%;max-width:100%}table.v-table tbody td:first-child,table.v-table tbody td:not(:first-child),table.v-table tbody th:first-child,table.v-table tbody th:not(:first-child),table.v-table thead td:first-child,table.v-table thead td:not(:first-child),table.v-table thead th:first-child,table.v-table thead th:not(:first-child){padding:0 24px}table.v-table thead tr{height:56px}table.v-table thead th{font-weight:500;font-size:12px;transition:.3s cubic-bezier(.25,.8,.5,1);white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}table.v-table thead th.sortable{pointer-events:auto}table.v-table thead th>div{width:100%}table.v-table tbody tr{transition:background .3s cubic-bezier(.25,.8,.5,1);will-change:background}table.v-table tbody td,table.v-table tbody th{height:48px}table.v-table tbody td{font-weight:400;font-size:13px}table.v-table .input-group--selection-controls{padding:0}table.v-table .input-group--selection-controls .input-group__details{display:none}table.v-table .input-group--selection-controls.checkbox .v-icon{left:50%;-webkit-transform:translateX(-50%);transform:translateX(-50%)}table.v-table .input-group--selection-controls.checkbox .input-group--selection-controls__ripple{left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}table.v-table tfoot tr{height:48px}table.v-table tfoot tr td{padding:0 24px}.theme--light.v-datatable thead th.column.sortable .v-icon{color:rgba(0,0,0,.38)}.theme--light.v-datatable thead th.column.sortable.active,.theme--light.v-datatable thead th.column.sortable.active .v-icon,.theme--light.v-datatable thead th.column.sortable:hover{color:rgba(0,0,0,.87)}.theme--light.v-datatable .v-datatable__actions{background-color:#fff;color:rgba(0,0,0,.54);border-top:1px solid rgba(0,0,0,.12)}.theme--light.v-datatable .v-datatable__expand-col--expanded{border-bottom:1px solid #e0e0e0}.theme--dark.v-datatable thead th.column.sortable .v-icon{color:hsla(0,0%,100%,.5)}.theme--dark.v-datatable thead th.column.sortable.active,.theme--dark.v-datatable thead th.column.sortable.active .v-icon,.theme--dark.v-datatable thead th.column.sortable:hover{color:#fff}.theme--dark.v-datatable .v-datatable__actions{background-color:#424242;color:hsla(0,0%,100%,.7);border-top:1px solid hsla(0,0%,100%,.12)}.theme--dark.v-datatable .v-datatable__expand-col--expanded{border-bottom:1px solid #616161}.v-datatable .v-input--selection-controls{margin:0;padding:0}.v-datatable thead th.column.sortable{cursor:pointer;outline:0}.v-datatable thead th.column.sortable .v-icon{font-size:16px;display:inline-block;opacity:0;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-datatable thead th.column.sortable:focus .v-icon,.v-datatable thead th.column.sortable:hover .v-icon{opacity:.6}.v-datatable thead th.column.sortable.active{-webkit-transform:none;transform:none}.v-datatable thead th.column.sortable.active .v-icon{opacity:1}.v-datatable thead th.column.sortable.active.desc .v-icon{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.v-datatable__actions{display:flex;justify-content:flex-end;align-items:center;font-size:12px;flex-wrap:wrap-reverse}.v-datatable__actions .v-btn{color:inherit}.v-datatable__actions .v-btn:last-of-type{margin-left:14px}.v-datatable__actions__range-controls{display:flex;align-items:center;min-height:48px}.v-datatable__actions__pagination{display:block;text-align:center;margin:0 32px 0 24px}.v-datatable__actions__select{display:flex;align-items:center;justify-content:flex-end;margin-right:14px;white-space:nowrap}.v-datatable__actions__select .v-select{flex:0 1 0;margin:13px 0 13px 34px;padding:0;position:static}.v-datatable__actions__select .v-select__selections{flex-wrap:nowrap}.v-datatable__actions__select .v-select__selections .v-select__selection--comma{font-size:12px}.v-datatable__progress,.v-datatable__progress td,.v-datatable__progress th,.v-datatable__progress tr{height:auto!important}.v-datatable__progress th{padding:0!important}.v-datatable__progress th .v-progress-linear{margin:0}.v-datatable__expand-row{border-top:none!important}.v-datatable__expand-col{padding:0!important;height:0!important;visibility:hidden}.v-datatable__expand-col--expanded{visibility:visible}.v-datatable__expand-content{transition:height .3s cubic-bezier(.25,.8,.5,1)}.v-datatable__expand-content>.card{border-radius:0;box-shadow:none}.theme--light.v-small-dialog a{color:rgba(0,0,0,.87)}.theme--dark.v-small-dialog a{color:#fff}.theme--light.v-small-dialog__content{background:#fff}.theme--dark.v-small-dialog__content{background:#424242}.theme--light.v-small-dialog__actions{background:#fff}.theme--dark.v-small-dialog__actions{background:#424242}.v-small-dialog{display:block;width:100%;height:100%}.v-small-dialog__content{padding:0 24px}.v-small-dialog__actions{text-align:right;white-space:pre}.v-small-dialog a{display:flex;align-items:center;height:100%;text-decoration:none}.v-small-dialog a>*{width:100%}.v-small-dialog .v-menu__activator{height:100%}.application--is-rtl .v-date-picker-title .v-picker__title__btn{text-align:right}.v-date-picker-title{display:flex;justify-content:space-between;flex-direction:column;flex-wrap:wrap;line-height:1}.v-date-picker-title__year{align-items:center;display:inline-flex;font-size:14px;font-weight:500;margin-bottom:8px}.v-date-picker-title__date{font-size:34px;text-align:left;font-weight:500;position:relative;overflow:hidden;padding-bottom:8px;margin-bottom:-8px}.v-date-picker-title__date>div{position:relative}.v-date-picker-title--disabled{pointer-events:none}.theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus){color:rgba(0,0,0,.87)}.theme--light.v-date-picker-header .v-date-picker-header__value--disabled button{color:rgba(0,0,0,.38)}.theme--dark.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus){color:#fff}.theme--dark.v-date-picker-header .v-date-picker-header__value--disabled button{color:hsla(0,0%,100%,.5)}.v-date-picker-header{padding:4px 16px;align-items:center;display:flex;justify-content:space-between;position:relative}.v-date-picker-header .v-btn{margin:0;z-index:auto}.v-date-picker-header .v-icon{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-date-picker-header__value{flex:1;text-align:center;position:relative;overflow:hidden}.v-date-picker-header__value div{transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-date-picker-header__value button{cursor:pointer;font-weight:700;outline:none;padding:.5rem;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-date-picker-header--disabled{pointer-events:none}.theme--light.v-date-picker-table .v-date-picker-table--date__week,.theme--light.v-date-picker-table th{color:rgba(0,0,0,.38)}.theme--dark.v-date-picker-table .v-date-picker-table--date__week,.theme--dark.v-date-picker-table th{color:hsla(0,0%,100%,.5)}.v-date-picker-table{position:relative;padding:0 12px;height:242px}.v-date-picker-table table{transition:.3s cubic-bezier(.25,.8,.5,1);top:0;table-layout:fixed;width:100%}.v-date-picker-table td,.v-date-picker-table th{text-align:center;position:relative}.v-date-picker-table th{font-size:12px}.v-date-picker-table--date .v-btn{height:32px;width:32px}.v-date-picker-table .v-btn{z-index:auto;margin:0;font-size:12px}.v-date-picker-table .v-btn.v-btn--active{color:#fff}.v-date-picker-table--month td{width:33.333333%;height:56px;vertical-align:middle;text-align:center}.v-date-picker-table--month td .v-btn{margin:0 auto;max-width:160px;min-width:40px;width:100%}.v-date-picker-table--date th{padding:8px 0;font-weight:600}.v-date-picker-table--date td{width:45px}.v-date-picker-table__events{height:8px;left:0;position:absolute;text-align:center;white-space:pre;width:100%}.v-date-picker-table__events>div{border-radius:50%;display:inline-block;height:8px;margin:0 1px;width:8px}.v-date-picker-table--date .v-date-picker-table__events{bottom:6px}.v-date-picker-table--month .v-date-picker-table__events{bottom:8px}.v-date-picker-table--disabled{pointer-events:none}.v-date-picker-years{font-size:16px;font-weight:400;height:286px;list-style-type:none;overflow:auto;padding:0;text-align:center}.v-date-picker-years li{cursor:pointer;padding:8px 0;transition:none}.v-date-picker-years li.active{font-size:26px;font-weight:500;padding:10px 0}.v-date-picker-years li:hover{background:rgba(0,0,0,.12)}.v-picker--landscape .v-date-picker-years{height:286px}.theme--light.v-picker__title{background:#e0e0e0}.theme--dark.v-picker__title{background:#616161}.theme--light.v-picker__body{background:#fff}.theme--dark.v-picker__body{background:#424242}.v-picker{border-radius:2px;contain:layout style;display:inline-flex;flex-direction:column;vertical-align:top;position:relative}.v-picker--full-width{display:flex}.v-picker__title{color:#fff;border-top-left-radius:2px;border-top-right-radius:2px;padding:16px}.v-picker__title__btn{transition:.3s cubic-bezier(.25,.8,.5,1)}.v-picker__title__btn:not(.v-picker__title__btn--active){opacity:.6;cursor:pointer}.v-picker__title__btn:not(.v-picker__title__btn--active):hover:not(:focus){opacity:1}.v-picker__title__btn--readonly{pointer-events:none}.v-picker__title__btn--active{opacity:1}.v-picker__body{height:auto;overflow:hidden;position:relative;z-index:0;flex:1 0 auto;display:flex;flex-direction:column;align-items:center}.v-picker__body>div{width:100%}.v-picker__body>div.fade-transition-leave-active{position:absolute}.v-picker--landscape .v-picker__title{border-top-right-radius:0;border-bottom-right-radius:0;width:170px;position:absolute;top:0;left:0;height:100%;z-index:1}.v-picker--landscape .v-picker__actions,.v-picker--landscape .v-picker__body{margin-left:170px}.theme--light.v-expansion-panel .v-expansion-panel__container{border-top:1px solid rgba(0,0,0,.12);background-color:#fff;color:rgba(0,0,0,.87)}.theme--light.v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon{color:rgba(0,0,0,.54)}.theme--light.v-expansion-panel .v-expansion-panel__container--disabled{color:rgba(0,0,0,.38)}.theme--light.v-expansion-panel--focusable .v-expansion-panel__container:focus{background-color:#eee}.theme--dark.v-expansion-panel .v-expansion-panel__container{border-top:1px solid hsla(0,0%,100%,.12);background-color:#424242;color:#fff}.theme--dark.v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon{color:#fff}.theme--dark.v-expansion-panel .v-expansion-panel__container--disabled{color:hsla(0,0%,100%,.5)}.theme--dark.v-expansion-panel--focusable .v-expansion-panel__container:focus{background-color:#494949}.v-expansion-panel{display:flex;flex-wrap:wrap;justify-content:center;list-style-type:none;padding:0;text-align:left;width:100%;box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12)}.v-expansion-panel__container{flex:1 0 100%;max-width:100%;outline:none;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-expansion-panel__container:first-child{border-top:none!important}.v-expansion-panel__container .v-expansion-panel__header__iconnel__header__icon{margin-left:auto}.v-expansion-panel__container--disabled .v-expansion-panel__header{pointer-events:none}.v-expansion-panel__container--active>.v-expansion-panel__header .v-expansion-panel__header__icon .v-icon{-webkit-transform:rotate(-180deg);transform:rotate(-180deg)}.v-expansion-panel__header{display:flex;cursor:pointer;align-items:center;position:relative;padding:12px 24px;min-height:48px}.v-expansion-panel__header>:not(.v-expansion-panel__header__icon){flex:1 1 auto}.v-expansion-panel__body{transition:.3s cubic-bezier(.25,.8,.5,1)}.v-expansion-panel__body>.v-card{border-radius:0;box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)!important}.v-expansion-panel--inset,.v-expansion-panel--popout{box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.v-expansion-panel--inset .v-expansion-panel__container--active,.v-expansion-panel--popout .v-expansion-panel__container--active{margin:16px;box-shadow:0 3px 3px -2px rgba(0,0,0,.2),0 3px 4px 0 rgba(0,0,0,.14),0 1px 8px 0 rgba(0,0,0,.12)}.v-expansion-panel--inset .v-expansion-panel__container,.v-expansion-panel--popout .v-expansion-panel__container{max-width:95%}.v-expansion-panel--popout .v-expansion-panel__container--active{max-width:100%}.v-expansion-panel--inset .v-expansion-panel__container--active{max-width:85%}.theme--light.v-footer{background:#f5f5f5;color:rgba(0,0,0,.87)}.theme--dark.v-footer{background:#212121;color:#fff}.v-footer{align-items:center;display:flex;flex:0 1 auto!important;min-height:36px;transition:.2s cubic-bezier(.4,0,.2,1)}.v-footer--absolute,.v-footer--fixed{bottom:0;left:0;width:100%;z-index:3}.v-footer--inset{z-index:2}.v-footer--absolute{position:absolute}.v-footer--fixed{position:fixed}.v-form>.container{padding:16px}.v-form>.container>.layout>.flex{padding:8px}.v-form>.container>.layout:only-child{margin:-8px}.v-form>.container>.layout:not(:only-child){margin:auto -8px}.container{flex:1 1 100%;margin:auto;padding:24px;width:100%}.container.fluid{max-width:100%}.container.fill-height{align-items:center;display:flex}.container.fill-height>.layout{height:100%;flex:1 1 auto}.container.grid-list-xs .layout .flex{padding:1px}.container.grid-list-xs .layout:only-child{margin:-1px}.container.grid-list-xs .layout:not(:only-child){margin:auto -1px}.container.grid-list-xs :not(:only-child) .layout:first-child{margin-top:-1px}.container.grid-list-xs :not(:only-child) .layout:last-child{margin-bottom:-1px}.container.grid-list-sm .layout .flex{padding:2px}.container.grid-list-sm .layout:only-child{margin:-2px}.container.grid-list-sm .layout:not(:only-child){margin:auto -2px}.container.grid-list-sm :not(:only-child) .layout:first-child{margin-top:-2px}.container.grid-list-sm :not(:only-child) .layout:last-child{margin-bottom:-2px}.container.grid-list-md .layout .flex{padding:4px}.container.grid-list-md .layout:only-child{margin:-4px}.container.grid-list-md .layout:not(:only-child){margin:auto -4px}.container.grid-list-md :not(:only-child) .layout:first-child{margin-top:-4px}.container.grid-list-md :not(:only-child) .layout:last-child{margin-bottom:-4px}.container.grid-list-lg .layout .flex{padding:8px}.container.grid-list-lg .layout:only-child{margin:-8px}.container.grid-list-lg .layout:not(:only-child){margin:auto -8px}.container.grid-list-lg :not(:only-child) .layout:first-child{margin-top:-8px}.container.grid-list-lg :not(:only-child) .layout:last-child{margin-bottom:-8px}.container.grid-list-xl .layout .flex{padding:12px}.container.grid-list-xl .layout:only-child{margin:-12px}.container.grid-list-xl .layout:not(:only-child){margin:auto -12px}.container.grid-list-xl :not(:only-child) .layout:first-child{margin-top:-12px}.container.grid-list-xl :not(:only-child) .layout:last-child{margin-bottom:-12px}.layout{display:flex;flex:1 1 auto;flex-wrap:nowrap;min-width:0}.layout.row{flex-direction:row}.layout.row.reverse{flex-direction:row-reverse}.layout.column{flex-direction:column}.layout.column.reverse{flex-direction:column-reverse}.layout.column>.flex{max-width:100%}.layout.wrap{flex-wrap:wrap}.child-flex>*,.flex{flex:1 1 auto;max-width:100%}.align-start{align-items:flex-start}.align-end{align-items:flex-end}.align-center{align-items:center}.align-baseline{align-items:baseline}.align-self-start{align-self:flex-start}.align-self-end{align-self:flex-end}.align-self-center{align-self:center}.align-self-baseline{align-self:baseline}.align-content-start{align-content:flex-start}.align-content-end{align-content:flex-end}.align-content-center{align-content:center}.align-content-space-between{align-content:space-between}.align-content-space-around{align-content:space-around}.justify-start{justify-content:flex-start}.justify-end{justify-content:flex-end}.justify-center{justify-content:center}.justify-space-around{justify-content:space-around}.justify-space-between{justify-content:space-between}.justify-self-start{justify-self:flex-start}.justify-self-end{justify-self:flex-end}.justify-self-center{justify-self:center}.justify-self-baseline{justify-self:baseline}.grow,.spacer{flex-grow:1!important}.grow{flex-shrink:0!important}.shrink{flex-grow:0!important;flex-shrink:1!important}.scroll-y{overflow-y:auto}.fill-height{height:100%}.hide-overflow{overflow:hidden!important}.show-overflow{overflow:visible!important}.ellipsis,.no-wrap{white-space:nowrap}.ellipsis{overflow:hidden;text-overflow:ellipsis}.d-flex{display:flex!important}.d-inline-flex{display:inline-flex!important}.d-flex>*,.d-inline-flex>*{flex:1 1 auto!important}.d-block{display:block!important}.d-inline-block{display:inline-block!important}.d-inline{display:inline!important}.d-none{display:none!important}@media only screen and (min-width:960px){.container{max-width:900px}}@media only screen and (min-width:1264px){.container{max-width:1185px}}@media only screen and (min-width:1904px){.container{max-width:1785px}}@media only screen and (max-width:959px){.container{padding:16px}}@media (min-width:0){.flex.xs1{flex-basis:8.333333333333332%;flex-grow:0;max-width:8.333333333333332%}.flex.order-xs1{order:1}.flex.xs2{flex-basis:16.666666666666664%;flex-grow:0;max-width:16.666666666666664%}.flex.order-xs2{order:2}.flex.xs3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-xs3{order:3}.flex.xs4{flex-basis:33.33333333333333%;flex-grow:0;max-width:33.33333333333333%}.flex.order-xs4{order:4}.flex.xs5{flex-basis:41.66666666666667%;flex-grow:0;max-width:41.66666666666667%}.flex.order-xs5{order:5}.flex.xs6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-xs6{order:6}.flex.xs7{flex-basis:58.333333333333336%;flex-grow:0;max-width:58.333333333333336%}.flex.order-xs7{order:7}.flex.xs8{flex-basis:66.66666666666666%;flex-grow:0;max-width:66.66666666666666%}.flex.order-xs8{order:8}.flex.xs9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-xs9{order:9}.flex.xs10{flex-basis:83.33333333333334%;flex-grow:0;max-width:83.33333333333334%}.flex.order-xs10{order:10}.flex.xs11{flex-basis:91.66666666666666%;flex-grow:0;max-width:91.66666666666666%}.flex.order-xs11{order:11}.flex.xs12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-xs12{order:12}.flex.offset-xs0{margin-left:0}.flex.offset-xs1{margin-left:8.333333333333332%}.flex.offset-xs2{margin-left:16.666666666666664%}.flex.offset-xs3{margin-left:25%}.flex.offset-xs4{margin-left:33.33333333333333%}.flex.offset-xs5{margin-left:41.66666666666667%}.flex.offset-xs6{margin-left:50%}.flex.offset-xs7{margin-left:58.333333333333336%}.flex.offset-xs8{margin-left:66.66666666666666%}.flex.offset-xs9{margin-left:75%}.flex.offset-xs10{margin-left:83.33333333333334%}.flex.offset-xs11{margin-left:91.66666666666666%}.flex.offset-xs12{margin-left:100%}}@media (min-width:600px){.flex.sm1{flex-basis:8.333333333333332%;flex-grow:0;max-width:8.333333333333332%}.flex.order-sm1{order:1}.flex.sm2{flex-basis:16.666666666666664%;flex-grow:0;max-width:16.666666666666664%}.flex.order-sm2{order:2}.flex.sm3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-sm3{order:3}.flex.sm4{flex-basis:33.33333333333333%;flex-grow:0;max-width:33.33333333333333%}.flex.order-sm4{order:4}.flex.sm5{flex-basis:41.66666666666667%;flex-grow:0;max-width:41.66666666666667%}.flex.order-sm5{order:5}.flex.sm6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-sm6{order:6}.flex.sm7{flex-basis:58.333333333333336%;flex-grow:0;max-width:58.333333333333336%}.flex.order-sm7{order:7}.flex.sm8{flex-basis:66.66666666666666%;flex-grow:0;max-width:66.66666666666666%}.flex.order-sm8{order:8}.flex.sm9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-sm9{order:9}.flex.sm10{flex-basis:83.33333333333334%;flex-grow:0;max-width:83.33333333333334%}.flex.order-sm10{order:10}.flex.sm11{flex-basis:91.66666666666666%;flex-grow:0;max-width:91.66666666666666%}.flex.order-sm11{order:11}.flex.sm12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-sm12{order:12}.flex.offset-sm0{margin-left:0}.flex.offset-sm1{margin-left:8.333333333333332%}.flex.offset-sm2{margin-left:16.666666666666664%}.flex.offset-sm3{margin-left:25%}.flex.offset-sm4{margin-left:33.33333333333333%}.flex.offset-sm5{margin-left:41.66666666666667%}.flex.offset-sm6{margin-left:50%}.flex.offset-sm7{margin-left:58.333333333333336%}.flex.offset-sm8{margin-left:66.66666666666666%}.flex.offset-sm9{margin-left:75%}.flex.offset-sm10{margin-left:83.33333333333334%}.flex.offset-sm11{margin-left:91.66666666666666%}.flex.offset-sm12{margin-left:100%}}@media (min-width:960px){.flex.md1{flex-basis:8.333333333333332%;flex-grow:0;max-width:8.333333333333332%}.flex.order-md1{order:1}.flex.md2{flex-basis:16.666666666666664%;flex-grow:0;max-width:16.666666666666664%}.flex.order-md2{order:2}.flex.md3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-md3{order:3}.flex.md4{flex-basis:33.33333333333333%;flex-grow:0;max-width:33.33333333333333%}.flex.order-md4{order:4}.flex.md5{flex-basis:41.66666666666667%;flex-grow:0;max-width:41.66666666666667%}.flex.order-md5{order:5}.flex.md6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-md6{order:6}.flex.md7{flex-basis:58.333333333333336%;flex-grow:0;max-width:58.333333333333336%}.flex.order-md7{order:7}.flex.md8{flex-basis:66.66666666666666%;flex-grow:0;max-width:66.66666666666666%}.flex.order-md8{order:8}.flex.md9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-md9{order:9}.flex.md10{flex-basis:83.33333333333334%;flex-grow:0;max-width:83.33333333333334%}.flex.order-md10{order:10}.flex.md11{flex-basis:91.66666666666666%;flex-grow:0;max-width:91.66666666666666%}.flex.order-md11{order:11}.flex.md12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-md12{order:12}.flex.offset-md0{margin-left:0}.flex.offset-md1{margin-left:8.333333333333332%}.flex.offset-md2{margin-left:16.666666666666664%}.flex.offset-md3{margin-left:25%}.flex.offset-md4{margin-left:33.33333333333333%}.flex.offset-md5{margin-left:41.66666666666667%}.flex.offset-md6{margin-left:50%}.flex.offset-md7{margin-left:58.333333333333336%}.flex.offset-md8{margin-left:66.66666666666666%}.flex.offset-md9{margin-left:75%}.flex.offset-md10{margin-left:83.33333333333334%}.flex.offset-md11{margin-left:91.66666666666666%}.flex.offset-md12{margin-left:100%}}@media (min-width:1264px){.flex.lg1{flex-basis:8.333333333333332%;flex-grow:0;max-width:8.333333333333332%}.flex.order-lg1{order:1}.flex.lg2{flex-basis:16.666666666666664%;flex-grow:0;max-width:16.666666666666664%}.flex.order-lg2{order:2}.flex.lg3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-lg3{order:3}.flex.lg4{flex-basis:33.33333333333333%;flex-grow:0;max-width:33.33333333333333%}.flex.order-lg4{order:4}.flex.lg5{flex-basis:41.66666666666667%;flex-grow:0;max-width:41.66666666666667%}.flex.order-lg5{order:5}.flex.lg6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-lg6{order:6}.flex.lg7{flex-basis:58.333333333333336%;flex-grow:0;max-width:58.333333333333336%}.flex.order-lg7{order:7}.flex.lg8{flex-basis:66.66666666666666%;flex-grow:0;max-width:66.66666666666666%}.flex.order-lg8{order:8}.flex.lg9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-lg9{order:9}.flex.lg10{flex-basis:83.33333333333334%;flex-grow:0;max-width:83.33333333333334%}.flex.order-lg10{order:10}.flex.lg11{flex-basis:91.66666666666666%;flex-grow:0;max-width:91.66666666666666%}.flex.order-lg11{order:11}.flex.lg12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-lg12{order:12}.flex.offset-lg0{margin-left:0}.flex.offset-lg1{margin-left:8.333333333333332%}.flex.offset-lg2{margin-left:16.666666666666664%}.flex.offset-lg3{margin-left:25%}.flex.offset-lg4{margin-left:33.33333333333333%}.flex.offset-lg5{margin-left:41.66666666666667%}.flex.offset-lg6{margin-left:50%}.flex.offset-lg7{margin-left:58.333333333333336%}.flex.offset-lg8{margin-left:66.66666666666666%}.flex.offset-lg9{margin-left:75%}.flex.offset-lg10{margin-left:83.33333333333334%}.flex.offset-lg11{margin-left:91.66666666666666%}.flex.offset-lg12{margin-left:100%}}@media (min-width:1904px){.flex.xl1{flex-basis:8.333333333333332%;flex-grow:0;max-width:8.333333333333332%}.flex.order-xl1{order:1}.flex.xl2{flex-basis:16.666666666666664%;flex-grow:0;max-width:16.666666666666664%}.flex.order-xl2{order:2}.flex.xl3{flex-basis:25%;flex-grow:0;max-width:25%}.flex.order-xl3{order:3}.flex.xl4{flex-basis:33.33333333333333%;flex-grow:0;max-width:33.33333333333333%}.flex.order-xl4{order:4}.flex.xl5{flex-basis:41.66666666666667%;flex-grow:0;max-width:41.66666666666667%}.flex.order-xl5{order:5}.flex.xl6{flex-basis:50%;flex-grow:0;max-width:50%}.flex.order-xl6{order:6}.flex.xl7{flex-basis:58.333333333333336%;flex-grow:0;max-width:58.333333333333336%}.flex.order-xl7{order:7}.flex.xl8{flex-basis:66.66666666666666%;flex-grow:0;max-width:66.66666666666666%}.flex.order-xl8{order:8}.flex.xl9{flex-basis:75%;flex-grow:0;max-width:75%}.flex.order-xl9{order:9}.flex.xl10{flex-basis:83.33333333333334%;flex-grow:0;max-width:83.33333333333334%}.flex.order-xl10{order:10}.flex.xl11{flex-basis:91.66666666666666%;flex-grow:0;max-width:91.66666666666666%}.flex.order-xl11{order:11}.flex.xl12{flex-basis:100%;flex-grow:0;max-width:100%}.flex.order-xl12{order:12}.flex.offset-xl0{margin-left:0}.flex.offset-xl1{margin-left:8.333333333333332%}.flex.offset-xl2{margin-left:16.666666666666664%}.flex.offset-xl3{margin-left:25%}.flex.offset-xl4{margin-left:33.33333333333333%}.flex.offset-xl5{margin-left:41.66666666666667%}.flex.offset-xl6{margin-left:50%}.flex.offset-xl7{margin-left:58.333333333333336%}.flex.offset-xl8{margin-left:66.66666666666666%}.flex.offset-xl9{margin-left:75%}.flex.offset-xl10{margin-left:83.33333333333334%}.flex.offset-xl11{margin-left:91.66666666666666%}.flex.offset-xl12{margin-left:100%}}.v-content{transition:none;display:flex;flex:1 0 auto;max-width:100%}.v-content[data-booted=true]{transition:.2s cubic-bezier(.4,0,.2,1)}.v-content__wrap{flex:1 1 auto;max-width:100%;position:relative}@media print{@-moz-document url-prefix(){.v-content{display:block}}}.theme--light.v-jumbotron .v-jumbotron__content{color:rgba(0,0,0,.87)}.theme--dark.v-jumbotron .v-jumbotron__content{color:#fff}.v-jumbotron{display:block;top:0;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-jumbotron__wrapper{height:100%;overflow:hidden;position:relative;transition:inherit;width:100%}.v-jumbotron__background{position:absolute;top:0;left:0;right:0;bottom:0;contain:strict;transition:inherit}.v-jumbotron__image{position:absolute;top:50%;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);min-width:100%;will-change:transform;transition:inherit}.v-jumbotron__content{height:100%;position:relative;transition:inherit}.theme--light.v-navigation-drawer{background-color:#fff}.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border{background-color:rgba(0,0,0,.12)}.theme--light.v-navigation-drawer .v-divider{border-color:rgba(0,0,0,.12)}.theme--dark.v-navigation-drawer{background-color:#424242}.theme--dark.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border{background-color:hsla(0,0%,100%,.12)}.theme--dark.v-navigation-drawer .v-divider{border-color:hsla(0,0%,100%,.12)}.v-navigation-drawer{transition:none;display:block;left:0;max-width:100%;overflow-y:auto;overflow-x:hidden;pointer-events:auto;top:0;will-change:transform;z-index:3;-webkit-overflow-scrolling:touch}.v-navigation-drawer[data-booted=true]{transition:.2s cubic-bezier(.4,0,.2,1);transition-property:width,-webkit-transform;transition-property:transform,width;transition-property:transform,width,-webkit-transform}.v-navigation-drawer__border{position:absolute;right:0;top:0;height:100%;width:1px}.v-navigation-drawer.v-navigation-drawer--right:after{left:0;right:auto}.v-navigation-drawer--right{left:auto;right:0}.v-navigation-drawer--right>.v-navigation-drawer__border{right:auto;left:0}.v-navigation-drawer--absolute{position:absolute}.v-navigation-drawer--fixed{position:fixed}.v-navigation-drawer--floating:after{display:none}.v-navigation-drawer--mini-variant{overflow:hidden}.v-navigation-drawer--mini-variant .v-list__group__header__prepend-icon{flex:1 0 auto;justify-content:center;width:100%}.v-navigation-drawer--mini-variant .v-list__tile__action,.v-navigation-drawer--mini-variant .v-list__tile__avatar{justify-content:center;min-width:48px}.v-navigation-drawer--mini-variant .v-list__tile:after,.v-navigation-drawer--mini-variant .v-list__tile__content{opacity:0}.v-navigation-drawer--mini-variant .v-divider,.v-navigation-drawer--mini-variant .v-list--group,.v-navigation-drawer--mini-variant .v-subheader{display:none!important}.v-navigation-drawer--is-mobile,.v-navigation-drawer--temporary{z-index:6}.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close),.v-navigation-drawer--temporary:not(.v-navigation-drawer--close){box-shadow:0 8px 10px -5px rgba(0,0,0,.2),0 16px 24px 2px rgba(0,0,0,.14),0 6px 30px 5px rgba(0,0,0,.12)}.v-navigation-drawer .v-list{background:inherit}.v-navigation-drawer>.v-list .v-list__tile{transition:none;font-weight:500}.v-navigation-drawer>.v-list .v-list__tile--active .v-list__tile__title{color:inherit}.v-navigation-drawer>.v-list .v-list--group .v-list__tile{font-weight:400}.v-navigation-drawer>.v-list .v-list--group__header--active:after{background:transparent}.v-navigation-drawer>.v-list:not(.v-list--dense) .v-list__tile{font-size:14px}.theme--light.v-pagination .v-pagination__item{background:#fff;color:#000;width:auto;min-width:34px;padding:0 5px}.theme--light.v-pagination .v-pagination__item--active{color:#fff}.theme--light.v-pagination .v-pagination__navigation{background:#fff}.theme--light.v-pagination .v-pagination__navigation .v-icon{color:rgba(0,0,0,.54)}.theme--dark.v-pagination .v-pagination__item{background:#424242;color:#fff;width:auto;min-width:34px;padding:0 5px}.theme--dark.v-pagination .v-pagination__item--active{color:#fff}.theme--dark.v-pagination .v-pagination__navigation{background:#424242}.theme--dark.v-pagination .v-pagination__navigation .v-icon{color:#fff}.v-pagination{align-items:center;display:inline-flex;list-style-type:none;margin:0;max-width:100%;padding:0}.v-pagination>li{align-items:center;display:flex}.v-pagination--circle .v-pagination__item,.v-pagination--circle .v-pagination__more,.v-pagination--circle .v-pagination__navigation{border-radius:50%}.v-pagination--disabled{pointer-events:none;opacity:.6}.v-pagination__item{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);border-radius:4px;font-size:14px;background:transparent;height:34px;width:34px;margin:.3rem;text-decoration:none;transition:.3s cubic-bezier(0,0,.2,1)}.v-pagination__item--active{box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)}.v-pagination__navigation{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12);display:inline-flex;justify-content:center;align-items:center;text-decoration:none;height:2rem;border-radius:4px;width:2rem;margin:.3rem 10px}.v-pagination__navigation .v-icon{font-size:2rem;transition:.2s cubic-bezier(.4,0,.6,1);vertical-align:middle}.v-pagination__navigation--disabled{opacity:.6;pointer-events:none}.v-pagination__more{margin:.3rem;display:inline-flex;align-items:flex-end;justify-content:center;height:2rem;width:2rem}.v-parallax{position:relative;overflow:hidden;z-index:0}.v-parallax__image-container{position:absolute;top:0;left:0;right:0;bottom:0;z-index:1;contain:strict}.v-parallax__image{position:absolute;bottom:0;left:50%;min-width:100%;min-height:100%;display:none;-webkit-transform:translate(-50%);transform:translate(-50%);will-change:transform;transition:opacity .3s cubic-bezier(.25,.8,.5,1);z-index:1}.v-parallax__content{color:#fff;height:100%;z-index:2;position:relative;display:flex;flex-direction:column;justify-content:center;padding:0 1rem}.v-input--radio-group__input{display:flex;width:100%}.v-input--radio-group--column .v-input--radio-group__input>.v-label{padding-bottom:8px}.v-input--radio-group--row .v-input--radio-group__input>.v-label{padding-right:8px}.v-input--radio-group--row .v-input--radio-group__input{flex-direction:row;flex-wrap:wrap}.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child){margin-bottom:8px}.v-input--radio-group--column .v-input--radio-group__input{flex-direction:column}.theme--light.v-radio--is-disabled label{color:rgba(0,0,0,.38)}.theme--light.v-radio--is-disabled .v-icon{color:rgba(0,0,0,.26)!important}.theme--dark.v-radio--is-disabled label{color:hsla(0,0%,100%,.5)}.theme--dark.v-radio--is-disabled .v-icon{color:hsla(0,0%,100%,.3)!important}.v-radio{align-items:center;display:flex;height:auto;margin-right:16px;outline:none}.v-radio--is-disabled{pointer-events:none}.theme--light.v-input--range-slider.v-input--slider.v-input--is-disabled .v-slider.v-slider .v-slider__thumb{background:#bdbdbd}.theme--dark.v-input--range-slider.v-input--slider.v-input--is-disabled .v-slider.v-slider .v-slider__thumb{background:#424242}.v-input--range-slider.v-input--is-disabled .v-slider__track-fill{display:none}.v-input--range-slider.v-input--is-disabled.v-input--slider .v-slider.v-slider .v-slider__thumb{border-color:transparent}.theme--light.v-input--slider .v-slider__track,.theme--light.v-input--slider .v-slider__track-fill{background:rgba(0,0,0,.26)}.theme--light.v-input--slider .v-slider__track__container:after{border:1px solid rgba(0,0,0,.87)}.theme--light.v-input--slider .v-slider__ticks{border-color:rgba(0,0,0,.87);color:rgba(0,0,0,.54)}.theme--light.v-input--slider:not(.v-input--is-dirty) .v-slider__thumb-label{background:rgba(0,0,0,.26)}.theme--light.v-input--slider:not(.v-input--is-dirty) .v-slider__thumb{border:3px solid rgba(0,0,0,.26)}.theme--light.v-input--slider:not(.v-input--is-dirty).v-input--slider--is-active .v-slider__thumb{border:3px solid rgba(0,0,0,.38)}.theme--light.v-input--slider.v-input--is-disabled .v-slider__thumb{border:5px solid rgba(0,0,0,.26)}.theme--light.v-input--slider.v-input--is-disabled.v-input--is-dirty .v-slider__thumb{background:rgba(0,0,0,.26)}.theme--light.v-input--slider.v-input--slider--is-active .v-slider__track{background:rgba(0,0,0,.38)}.theme--dark.v-input--slider .v-slider__track,.theme--dark.v-input--slider .v-slider__track-fill{background:hsla(0,0%,100%,.2)}.theme--dark.v-input--slider .v-slider__track__container:after{border:1px solid #fff}.theme--dark.v-input--slider .v-slider__ticks{border-color:#fff;color:hsla(0,0%,100%,.7)}.theme--dark.v-input--slider:not(.v-input--is-dirty) .v-slider__thumb-label{background:hsla(0,0%,100%,.2)}.theme--dark.v-input--slider:not(.v-input--is-dirty) .v-slider__thumb{border:3px solid hsla(0,0%,100%,.2)}.theme--dark.v-input--slider:not(.v-input--is-dirty).v-input--slider--is-active .v-slider__thumb{border:3px solid hsla(0,0%,100%,.3)}.theme--dark.v-input--slider.v-input--is-disabled .v-slider__thumb{border:5px solid hsla(0,0%,100%,.2)}.theme--dark.v-input--slider.v-input--is-disabled.v-input--is-dirty .v-slider__thumb{background:hsla(0,0%,100%,.2)}.theme--dark.v-input--slider.v-input--slider--is-active .v-slider__track{background:hsla(0,0%,100%,.3)}.application--is-rtl .v-input--slider .v-label{margin-left:16px;margin-right:0}.v-input--slider{margin-top:16px}.v-input--slider.v-input--is-focused .v-slider__thumb-container--is-active:not(.v-slider__thumb-container--show-label):before{opacity:.2;-webkit-transform:scale(1);transform:scale(1)}.v-input--slider.v-input--is-focused .v-slider__track{transition:none}.v-input--slider.v-input--is-focused.v-input--slider--ticks .v-slider .v-slider__tick,.v-input--slider.v-input--is-focused.v-input--slider--ticks .v-slider__track__container:after,.v-input--slider.v-input--slider--ticks .v-slider__ticks.v-slider__ticks--always-show{opacity:1}.v-input--slider.v-input--slider--ticks-labels .v-input__slot{margin-bottom:16px}.v-input--slider.v-input--is-readonly .v-input__control{pointer-events:none}.v-input--slider.v-input--is-disabled .v-slider__thumb{-webkit-transform:translateY(-50%) scale(.45);transform:translateY(-50%) scale(.45)}.v-input--slider.v-input--is-disabled.v-input--is-dirty .v-slider__thumb{border:0 solid transparent}.v-input--slider .v-input__slot>:first-child:not(:only-child){margin-right:16px}.v-slider{cursor:default;display:flex;align-items:center;position:relative;height:32px;flex:1;outline:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-slider input{cursor:default;opacity:0;padding:0;width:100%}.v-slider__track__container{height:2px;left:0;overflow:hidden;pointer-events:none;position:absolute;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%);width:100%}.v-slider__track__container:after{content:\"\";position:absolute;right:0;top:0;height:2px;transition:.3s cubic-bezier(.25,.8,.5,1);width:2px;opacity:0}.v-slider__thumb,.v-slider__ticks,.v-slider__track{position:absolute;top:0}.v-slider__track{-webkit-transform-origin:right;transform-origin:right;overflow:hidden}.v-slider__track,.v-slider__track-fill{height:2px;left:0;transition:.3s cubic-bezier(.25,.8,.5,1);width:100%}.v-slider__track-fill{position:absolute;-webkit-transform-origin:left;transform-origin:left}.v-slider__ticks-container{position:absolute;left:0;height:2px;width:100%;top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.v-slider__ticks{opacity:0;border-style:solid;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-slider__ticks>span{position:absolute;top:8px;-webkit-transform:translateX(-50%);transform:translateX(-50%);white-space:nowrap;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-slider__ticks:first-child>span{-webkit-transform:translateX(0);transform:translateX(0)}.v-slider__ticks:last-child>span{-webkit-transform:translateX(-100%);transform:translateX(-100%)}.v-slider:not(.v-input--is-dirty) .v-slider__ticks:first-child{border-color:transparent}.v-slider__thumb-container{position:absolute;top:50%;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-slider__thumb-container:before{content:\"\";color:inherit;background:currentColor;height:32px;left:-16px;opacity:0;overflow:hidden;pointer-events:none;position:absolute;top:-16px;-webkit-transform:scale(.2);transform:scale(.2);width:32px;will-change:transform,opacity}.v-slider__thumb,.v-slider__thumb-container:before{border-radius:50%;transition:.3s cubic-bezier(.25,.8,.5,1)}.v-slider__thumb{width:24px;height:24px;left:-12px;top:50%;background:transparent;-webkit-transform:translateY(-50%) scale(.6);transform:translateY(-50%) scale(.6);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-slider--is-active .v-slider__thumb-container--is-active .v-slider__thumb{-webkit-transform:translateY(-50%) scale(1);transform:translateY(-50%) scale(1)}.v-slider--is-active .v-slider__thumb-container--is-active.v-slider__thumb-container--show-label .v-slider__thumb{-webkit-transform:translateY(-50%) scale(0);transform:translateY(-50%) scale(0)}.v-slider--is-active .v-slider__ticks-container .v-slider__ticks{opacity:1}.v-slider__thumb-label__container{top:0}.v-slider__thumb-label,.v-slider__thumb-label__container{position:absolute;left:0;transition:.3s cubic-bezier(.25,.8,.25,1)}.v-slider__thumb-label{display:flex;align-items:center;justify-content:center;font-size:12px;color:#fff;width:32px;height:32px;border-radius:50% 50% 0;bottom:100%;-webkit-transform:translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);transform:translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-slider__thumb-label>*{-webkit-transform:rotate(-45deg);transform:rotate(-45deg)}.v-slider__track,.v-slider__track-fill{position:absolute}.v-rating .v-icon{padding:.5rem;border-radius:50%;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-rating--readonly .v-icon{pointer-events:none}.v-rating--dense .v-icon{padding:.1rem}.application--is-rtl .v-snack__content .v-btn{margin:0 24px 0 0}.v-snack{position:fixed;display:flex;align-items:center;color:#fff;pointer-events:none;z-index:1000;font-size:14px;left:0;right:0}.v-snack--absolute{position:absolute}.v-snack--top{top:0}.v-snack--bottom{bottom:0}.v-snack__wrapper{background-color:#323232;pointer-events:auto;box-shadow:0 3px 5px -1px rgba(0,0,0,.2),0 6px 10px 0 rgba(0,0,0,.14),0 1px 18px 0 rgba(0,0,0,.12)}.v-snack__content,.v-snack__wrapper{display:flex;align-items:center;width:100%}.v-snack__content{height:48px;padding:14px 24px;justify-content:space-between;overflow:hidden}.v-snack__content .v-btn{color:#fff;flex:0 0 auto;padding:8px;margin:0 0 0 24px;height:auto;min-width:auto;width:auto}.v-snack__content .v-btn__content{margin:-2px}.v-snack__content .v-btn:before{display:none}.v-snack--multi-line .v-snack__content{height:80px;padding:24px}.v-snack--vertical .v-snack__content{height:112px;padding:24px 24px 14px;flex-direction:column;align-items:stretch}.v-snack--vertical .v-snack__content .v-btn.v-btn{justify-content:flex-end;padding:0;margin-left:0;margin-top:24px}.v-snack--vertical .v-snack__content .v-btn__content{flex:0 0 auto;margin:0}.v-snack--auto-height .v-snack__content{height:auto}.v-snack-transition-enter-active,.v-snack-transition-leave-active{transition:-webkit-transform .4s cubic-bezier(.25,.8,.5,1);transition:transform .4s cubic-bezier(.25,.8,.5,1);transition:transform .4s cubic-bezier(.25,.8,.5,1),-webkit-transform .4s cubic-bezier(.25,.8,.5,1)}.v-snack-transition-enter-active .v-snack__content,.v-snack-transition-leave-active .v-snack__content{transition:opacity .3s linear .1s}.v-snack-transition-enter .v-snack__content{opacity:0}.v-snack-transition-enter-to .v-snack__content,.v-snack-transition-leave .v-snack__content{opacity:1}.v-snack-transition-enter.v-snack.v-snack--top,.v-snack-transition-leave-to.v-snack.v-snack--top{-webkit-transform:translateY(calc(-100% - 8px));transform:translateY(calc(-100% - 8px))}.v-snack-transition-enter.v-snack.v-snack--bottom,.v-snack-transition-leave-to.v-snack.v-snack--bottom{-webkit-transform:translateY(100%);transform:translateY(100%)}@media only screen and (min-width:600px){.application--is-rtl .v-snack__content .v-btn:first-of-type{margin-left:0;margin-right:42px}.v-snack__wrapper{width:auto;max-width:568px;min-width:288px;margin:0 auto;border-radius:2px}.v-snack--left .v-snack__wrapper{margin-left:0}.v-snack--right .v-snack__wrapper{margin-right:0}.v-snack--left,.v-snack--right{margin:0 24px}.v-snack--left.v-snack--top,.v-snack--right.v-snack--top{-webkit-transform:translateY(24px);transform:translateY(24px)}.v-snack--left.v-snack--bottom,.v-snack--right.v-snack--bottom{-webkit-transform:translateY(-24px);transform:translateY(-24px)}.v-snack__content .v-btn:first-of-type{margin-left:42px}}.v-speed-dial{position:relative}.v-speed-dial--absolute{position:absolute}.v-speed-dial--fixed{position:fixed}.v-speed-dial--absolute,.v-speed-dial--fixed{z-index:4}.v-speed-dial--absolute>.v-btn--floating,.v-speed-dial--fixed>.v-btn--floating{margin:0}.v-speed-dial--top:not(.v-speed-dial--absolute){top:16px}.v-speed-dial--top.v-speed-dial--absolute{top:50%;-webkit-transform:translateY(-50%);transform:translateY(-50%)}.v-speed-dial--bottom:not(.v-speed-dial--absolute){bottom:16px}.v-speed-dial--bottom.v-speed-dial--absolute{bottom:50%;-webkit-transform:translateY(50%);transform:translateY(50%)}.v-speed-dial--left{left:16px}.v-speed-dial--right{right:16px}.v-speed-dial--direction-left .v-speed-dial__list,.v-speed-dial--direction-right .v-speed-dial__list{height:100%;top:0}.v-speed-dial--direction-bottom .v-speed-dial__list,.v-speed-dial--direction-top .v-speed-dial__list{left:0;width:100%}.v-speed-dial--direction-top .v-speed-dial__list{flex-direction:column-reverse;bottom:100%}.v-speed-dial--direction-right .v-speed-dial__list{flex-direction:row;left:100%}.v-speed-dial--direction-bottom .v-speed-dial__list{flex-direction:column;top:100%}.v-speed-dial--direction-left .v-speed-dial__list{flex-direction:row-reverse;right:100%}.v-speed-dial__list{align-items:center;display:flex;justify-content:center;position:absolute}.theme--light.v-stepper{background:#fff}.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step{background:rgba(0,0,0,.38)}.theme--light.v-stepper .v-stepper__step__step,.theme--light.v-stepper .v-stepper__step__step .v-icon{color:#fff}.theme--light.v-stepper .v-stepper__header .v-divider{border-color:rgba(0,0,0,.12)}.theme--light.v-stepper .v-stepper__step--active .v-stepper__label{text-shadow:0 0 0 #000}.theme--light.v-stepper .v-stepper__step--editable:hover{background:rgba(0,0,0,.06)}.theme--light.v-stepper .v-stepper__step--editable:hover .v-stepper__label{text-shadow:0 0 0 #000}.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label{color:rgba(0,0,0,.87)}.theme--light.v-stepper .v-stepper__step--inactive.v-stepper__step--editable:not(.v-stepper__step--error):hover .v-stepper__step__step{background:rgba(0,0,0,.54)}.theme--light.v-stepper .v-stepper__label{color:rgba(0,0,0,.38)}.theme--light.v-stepper--non-linear .v-stepper__step:not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label,.theme--light.v-stepper .v-stepper__label small{color:rgba(0,0,0,.54)}.theme--light.v-stepper--vertical .v-stepper__content:not(:last-child){border-left:1px solid rgba(0,0,0,.12)}.theme--dark.v-stepper{background:#303030}.theme--dark.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step{background:hsla(0,0%,100%,.5)}.theme--dark.v-stepper .v-stepper__step__step,.theme--dark.v-stepper .v-stepper__step__step .v-icon{color:#fff}.theme--dark.v-stepper .v-stepper__header .v-divider{border-color:hsla(0,0%,100%,.12)}.theme--dark.v-stepper .v-stepper__step--active .v-stepper__label{text-shadow:0 0 0 #fff}.theme--dark.v-stepper .v-stepper__step--editable:hover{background:hsla(0,0%,100%,.06)}.theme--dark.v-stepper .v-stepper__step--editable:hover .v-stepper__label{text-shadow:0 0 0 #fff}.theme--dark.v-stepper .v-stepper__step--complete .v-stepper__label{color:hsla(0,0%,100%,.87)}.theme--dark.v-stepper .v-stepper__step--inactive.v-stepper__step--editable:not(.v-stepper__step--error):hover .v-stepper__step__step{background:hsla(0,0%,100%,.75)}.theme--dark.v-stepper .v-stepper__label{color:hsla(0,0%,100%,.5)}.theme--dark.v-stepper--non-linear .v-stepper__step:not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label,.theme--dark.v-stepper .v-stepper__label small{color:hsla(0,0%,100%,.7)}.theme--dark.v-stepper--vertical .v-stepper__content:not(:last-child){border-left:1px solid hsla(0,0%,100%,.12)}.application--is-rtl .v-stepper .v-stepper__step__step{margin-right:0;margin-left:12px}.v-stepper{overflow:hidden;position:relative}.v-stepper,.v-stepper__header{box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.v-stepper__header{height:72px;align-items:stretch;display:flex;flex-wrap:wrap;justify-content:space-between}.v-stepper__header .v-divider{align-self:center;margin:0 -16px}.v-stepper__items{position:relative;overflow:hidden}.v-stepper__step__step{align-items:center;border-radius:50%;display:inline-flex;font-size:12px;justify-content:center;height:24px;margin-right:8px;min-width:24px;width:24px;transition:.3s cubic-bezier(.25,.8,.25,1)}.v-stepper__step__step .v-icon{font-size:18px}.v-stepper__step{align-items:center;display:flex;flex-direction:row;padding:24px;position:relative}.v-stepper__step--active .v-stepper__label{transition:.3s cubic-bezier(.4,0,.6,1)}.v-stepper__step--editable{cursor:pointer}.v-stepper__step.v-stepper__step--error .v-stepper__step__step{background:transparent;color:inherit}.v-stepper__step.v-stepper__step--error .v-stepper__step__step .v-icon{font-size:24px;color:inherit}.v-stepper__step.v-stepper__step--error .v-stepper__label{color:inherit;text-shadow:none;font-weight:500}.v-stepper__step.v-stepper__step--error .v-stepper__label small{color:inherit}.v-stepper__label{align-items:flex-start;display:flex;flex-direction:column;text-align:left}.v-stepper__label small{font-size:12px;font-weight:300;text-shadow:none}.v-stepper__wrapper{overflow:hidden;transition:none}.v-stepper__content{top:0;padding:24px 24px 16px;flex:1 0 auto;width:100%}.v-stepper__content>.v-btn{margin:24px 8px 8px 0}.v-stepper--is-booted .v-stepper__content,.v-stepper--is-booted .v-stepper__wrapper{transition:.3s cubic-bezier(.25,.8,.5,1)}.v-stepper--vertical{padding-bottom:36px}.v-stepper--vertical .v-stepper__content{margin:-8px -36px -16px 36px;padding:16px 60px 16px 23px;width:auto}.v-stepper--vertical .v-stepper__step{padding:24px 24px 16px}.v-stepper--vertical .v-stepper__step__step{margin-right:12px}.v-stepper--alt-labels .v-stepper__header{height:auto}.v-stepper--alt-labels .v-stepper__header .v-divider{margin:35px -67px 0;align-self:flex-start}.v-stepper--alt-labels .v-stepper__step{flex-direction:column;justify-content:flex-start;align-items:center;flex-basis:175px}.v-stepper--alt-labels .v-stepper__step small{align-self:center}.v-stepper--alt-labels .v-stepper__step__step{margin-right:0;margin-bottom:11px}@media only screen and (max-width:959px){.v-stepper:not(.v-stepper--vertical) .v-stepper__label{display:none}.v-stepper:not(.v-stepper--vertical) .v-stepper__step__step{margin-right:0}}.theme--light.v-input--switch__thumb{color:#fafafa}.theme--light.v-input--switch__track{color:rgba(0,0,0,.38)}.theme--light.v-input--switch.v-input--is-disabled .v-input--switch__thumb{color:#bdbdbd!important}.theme--light.v-input--switch.v-input--is-disabled .v-input--switch__track{color:rgba(0,0,0,.12)!important}.theme--dark.v-input--switch__thumb{color:#bdbdbd}.theme--dark.v-input--switch__track{color:hsla(0,0%,100%,.3)}.theme--dark.v-input--switch.v-input--is-disabled .v-input--switch__thumb{color:#424242!important}.theme--dark.v-input--switch.v-input--is-disabled .v-input--switch__track{color:hsla(0,0%,100%,.1)!important}.application--is-rtl .v-input--switch .v-input--selection-controls__ripple{left:auto;right:-14px}.application--is-rtl .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,.application--is-rtl .v-input--switch.v-input--is-dirty .v-input--switch__thumb{-webkit-transform:translate(-16px);transform:translate(-16px)}.v-input--switch__thumb,.v-input--switch__track{background-color:currentColor;pointer-events:none;transition:inherit}.v-input--switch__track{border-radius:8px;height:14px;left:2px;opacity:.6;position:absolute;right:2px;top:calc(50% - 7px)}.v-input--switch__thumb{border-radius:50%;top:calc(50% - 10px);height:20px;position:relative;width:20px;display:flex;justify-content:center;align-items:center;box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12)}.v-input--switch .v-input--selection-controls__input{width:38px}.v-input--switch .v-input--selection-controls__ripple{left:-14px;top:calc(50% - 24px)}.v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,.v-input--switch.v-input--is-dirty .v-input--switch__thumb{-webkit-transform:translate(16px);transform:translate(16px)}.theme--light.v-system-bar{background-color:#e0e0e0;color:rgba(0,0,0,.54)}.theme--light.v-system-bar .v-icon{color:rgba(0,0,0,.54)}.theme--light.v-system-bar--lights-out{background-color:hsla(0,0%,100%,.7)!important}.theme--dark.v-system-bar{background-color:#000;color:hsla(0,0%,100%,.7)}.theme--dark.v-system-bar .v-icon{color:hsla(0,0%,100%,.7)}.theme--dark.v-system-bar--lights-out{background-color:rgba(0,0,0,.2)!important}.v-system-bar{align-items:center;display:flex;font-size:14px;font-weight:500;padding:0 8px}.v-system-bar .v-icon{font-size:16px}.v-system-bar--absolute,.v-system-bar--fixed{left:0;top:0;width:100%;z-index:3}.v-system-bar--fixed{position:fixed}.v-system-bar--absolute{position:absolute}.v-system-bar--status .v-icon{margin-right:4px}.v-system-bar--window .v-icon{font-size:20px;margin-right:8px}.theme--light.v-tabs__bar{background-color:#fff}.theme--light.v-tabs__bar .v-tabs__div{color:rgba(0,0,0,.87)}.theme--light.v-tabs__bar .v-tabs__item--disabled{color:rgba(0,0,0,.26)}.theme--dark.v-tabs__bar{background-color:#424242}.theme--dark.v-tabs__bar .v-tabs__div{color:#fff}.theme--dark.v-tabs__bar .v-tabs__item--disabled{color:hsla(0,0%,100%,.3)}.v-tabs,.v-tabs__bar{position:relative}.v-tabs__bar{border-radius:inherit}.v-tabs__icon{align-items:center;cursor:pointer;display:inline-flex;height:100%;position:absolute;top:0;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:32px}.v-tabs__icon--prev{left:4px}.v-tabs__icon--next{right:4px}.v-tabs__wrapper{overflow:hidden;contain:content;display:flex}.v-tabs__wrapper--show-arrows{margin-left:40px;margin-right:40px}.v-tabs__wrapper--show-arrows .v-tabs__container--align-with-title{padding-left:16px}.v-tabs__container{flex:1 0 auto;display:flex;height:48px;list-style-type:none;transition:-webkit-transform .6s cubic-bezier(.86,0,.07,1);transition:transform .6s cubic-bezier(.86,0,.07,1);transition:transform .6s cubic-bezier(.86,0,.07,1),-webkit-transform .6s cubic-bezier(.86,0,.07,1);white-space:nowrap;position:relative}.v-tabs__container--overflow .v-tabs__div{flex:1 0 auto}.v-tabs__container--grow .v-tabs__div{flex:1 0 auto;max-width:none}.v-tabs__container--icons-and-text{height:72px}.v-tabs__container--align-with-title{padding-left:56px}.v-tabs__container--fixed-tabs .v-tabs__div,.v-tabs__container--icons-and-text .v-tabs__div{min-width:72px}.v-tabs__container--centered .v-tabs__slider-wrapper+.v-tabs__div,.v-tabs__container--centered>.v-tabs__div:first-child,.v-tabs__container--fixed-tabs .v-tabs__slider-wrapper+.v-tabs__div,.v-tabs__container--fixed-tabs>.v-tabs__div:first-child,.v-tabs__container--right .v-tabs__slider-wrapper+.v-tabs__div,.v-tabs__container--right>.v-tabs__div:first-child{margin-left:auto}.v-tabs__container--centered>.v-tabs__div:last-child,.v-tabs__container--fixed-tabs>.v-tabs__div:last-child{margin-right:auto}.v-tabs__container--icons-and-text .v-tabs__item{flex-direction:column-reverse}.v-tabs__container--icons-and-text .v-tabs__item .v-icon{margin-bottom:6px}.v-tabs__div{align-items:center;display:inline-flex;flex:0 1 auto;font-size:14px;font-weight:500;line-height:normal;height:inherit;max-width:264px;text-align:center;text-transform:uppercase;vertical-align:middle}.v-tabs__item{align-items:center;color:inherit;display:flex;flex:1 1 auto;height:100%;justify-content:center;max-width:inherit;padding:6px 12px;text-decoration:none;transition:.3s cubic-bezier(.25,.8,.5,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;white-space:normal}.v-tabs__item:not(.v-tabs__item--active){opacity:.7}.v-tabs__item--disabled{pointer-events:none}.v-tabs__slider{height:2px;width:100%}.v-tabs__slider-wrapper{bottom:0;margin:0!important;position:absolute;transition:.3s cubic-bezier(.25,.8,.5,1)}@media only screen and (max-width:599px){.v-tabs__wrapper--show-arrows .v-tabs__container--align-with-title{padding-left:24px}.v-tabs__container--fixed-tabs .v-tabs__div{flex:1 0 auto}}@media only screen and (min-width:600px){.v-tabs__container--fixed-tabs .v-tabs__div,.v-tabs__container--icons-and-text .v-tabs__div{min-width:160px}}.theme--light.v-textarea.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused textarea{color:#fff}.theme--dark.v-textarea.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused textarea{color:rgba(0,0,0,.87)}.application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot{margin-right:0;margin-left:-12px}.application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot textarea{padding-right:0;padding-left:12px}.v-textarea textarea{flex:1 1 auto;line-height:18px;max-width:100%;min-height:32px;outline:none;padding:7px 0 8px;width:100%}.v-textarea .v-text-field__prefix{padding-top:4px;align-self:start}.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__slot textarea,.v-textarea.v-text-field--full-width .v-text-field__slot textarea{margin-top:0}.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__details,.v-textarea.v-text-field--full-width .v-text-field__details{bottom:4px}.v-textarea.v-text-field--enclosed .v-text-field__slot{margin-right:-12px}.v-textarea.v-text-field--enclosed .v-text-field__slot textarea{padding-right:12px}.v-textarea.v-text-field--box .v-text-field__prefix,.v-textarea.v-text-field--box textarea,.v-textarea.v-text-field--enclosed .v-text-field__prefix,.v-textarea.v-text-field--enclosed textarea{margin-top:24px}.v-textarea.v-text-field--box.v-text-field--single-line .v-text-field__prefix,.v-textarea.v-text-field--box.v-text-field--single-line textarea,.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-text-field__prefix,.v-textarea.v-text-field--enclosed.v-text-field--single-line textarea{margin-top:12px}.v-textarea.v-text-field--box.v-text-field--single-line .v-label,.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-label{top:18px}.v-textarea.v-text-field--box.v-text-field--single-line.v-text-field--outline .v-input__control,.v-textarea.v-text-field--enclosed.v-text-field--single-line.v-text-field--outline .v-input__control{padding-top:0}.v-textarea.v-text-field--solo{align-items:flex-start}.v-textarea.v-text-field--solo .v-input__append-inner,.v-textarea.v-text-field--solo .v-input__append-outer,.v-textarea.v-text-field--solo .v-input__prepend-inner,.v-textarea.v-text-field--solo .v-input__prepend-outer{align-self:flex-start;margin-top:16px}.v-textarea--auto-grow textarea{overflow:hidden}.v-textarea--no-resize textarea{resize:none}.theme--light.v-timeline:before{background:rgba(0,0,0,.12)}.theme--light.v-timeline .v-timeline-item__dot{background:#fff}.theme--light.v-timeline .v-timeline-item .v-card:before{border-right-color:rgba(0,0,0,.12)}.theme--dark.v-timeline:before{background:hsla(0,0%,100%,.12)}.theme--dark.v-timeline .v-timeline-item__dot{background:#424242}.theme--dark.v-timeline .v-timeline-item .v-card:before{border-right-color:rgba(0,0,0,.12)}.v-timeline-item{display:flex;flex-direction:row-reverse;padding-bottom:24px}.v-timeline-item--left,.v-timeline-item:nth-child(odd):not(.v-timeline-item--right){flex-direction:row}.v-timeline-item--left .v-card:after,.v-timeline-item--left .v-card:before,.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-card:after,.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-card:before{-webkit-transform:rotate(180deg);transform:rotate(180deg);left:100%}.v-timeline-item--left .v-timeline-item__opposite,.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-timeline-item__opposite{margin-left:96px;text-align:left}.v-timeline-item--left .v-timeline-item__opposite .v-card:after,.v-timeline-item--left .v-timeline-item__opposite .v-card:before,.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-timeline-item__opposite .v-card:after,.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-timeline-item__opposite .v-card:before{-webkit-transform:rotate(0);transform:rotate(0);left:-10px}.v-timeline-item--right .v-card:after,.v-timeline-item--right .v-card:before,.v-timeline-item:nth-child(2n):not(.v-timeline-item--left) .v-card:after,.v-timeline-item:nth-child(2n):not(.v-timeline-item--left) .v-card:before{right:100%}.v-timeline-item--right .v-timeline-item__opposite,.v-timeline-item:nth-child(2n):not(.v-timeline-item--left) .v-timeline-item__opposite{margin-right:96px;text-align:right}.v-timeline-item--right .v-timeline-item__opposite .v-card:after,.v-timeline-item--right .v-timeline-item__opposite .v-card:before,.v-timeline-item:nth-child(2n):not(.v-timeline-item--left) .v-timeline-item__opposite .v-card:after,.v-timeline-item:nth-child(2n):not(.v-timeline-item--left) .v-timeline-item__opposite .v-card:before{-webkit-transform:rotate(180deg);transform:rotate(180deg);right:-10px}.v-timeline-item__dot,.v-timeline-item__inner-dot{border-radius:50%}.v-timeline-item__dot{box-shadow:0 2px 1px -1px rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 1px 3px 0 rgba(0,0,0,.12);align-self:center;position:absolute;height:38px;left:calc(50% - 19px);width:38px}.v-timeline-item__dot .v-timeline-item__inner-dot{height:30px;margin:4px;width:30px}.v-timeline-item__dot--small{height:24px;left:calc(50% - 12px);width:24px}.v-timeline-item__dot--small .v-timeline-item__inner-dot{height:18px;margin:3px;width:18px}.v-timeline-item__dot--large{height:52px;left:calc(50% - 26px);width:52px}.v-timeline-item__dot--large .v-timeline-item__inner-dot{height:42px;margin:5px;width:42px}.v-timeline-item__inner-dot{display:flex;justify-content:center;align-items:center}.v-timeline-item__body{position:relative;height:100%;flex:1 1 100%;max-width:calc(50% - 48px)}.v-timeline-item .v-card:after,.v-timeline-item .v-card:before{content:\"\";position:absolute;border-top:10px solid transparent;border-bottom:10px solid transparent;border-right:10px solid #000;top:calc(50% - 10px)}.v-timeline-item .v-card:after{border-right-color:inherit}.v-timeline-item .v-card:before{top:calc(50% - 10px + 2px)}.v-timeline-item__opposite{flex:1 1 auto;align-self:center;max-width:calc(50% - 48px)}.v-timeline-item--fill-dot .v-timeline-item__inner-dot{height:inherit;margin:0;width:inherit}.v-timeline{padding-top:24px;position:relative}.v-timeline:before{bottom:0;content:\"\";height:100%;left:calc(50% - 1px);position:absolute;top:0;width:2px}.v-timeline--align-top .v-timeline-item{position:relative}.v-timeline--align-top .v-timeline-item__dot{top:6px}.v-timeline--align-top .v-timeline-item__dot--small{top:12px}.v-timeline--align-top .v-timeline-item__dot--large{top:0}.v-timeline--align-top .v-timeline-item .v-card:before{top:calc(0% + 10px + 2px)}.v-timeline--align-top .v-timeline-item .v-card:after{top:calc(0% + 10px)}.v-timeline--dense:before{left:18px}.v-timeline--dense .v-timeline-item--left,.v-timeline--dense .v-timeline-item:nth-child(odd):not(.v-timeline-item--right){flex-direction:row-reverse}.v-timeline--dense .v-timeline-item--left .v-card:after,.v-timeline--dense .v-timeline-item--left .v-card:before,.v-timeline--dense .v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-card:after,.v-timeline--dense .v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-card:before{right:auto;left:-10px;-webkit-transform:none;transform:none}.v-timeline--dense .v-timeline-item__dot{left:0}.v-timeline--dense .v-timeline-item__dot--small{left:7px}.v-timeline--dense .v-timeline-item__dot--large{left:-7px}.v-timeline--dense .v-timeline-item__body{max-width:calc(100% - 64px)}.v-timeline--dense .v-timeline-item__opposite{display:none}.v-time-picker-title{color:#fff;display:flex;line-height:1;justify-content:flex-end}.v-time-picker-title__time{white-space:nowrap}.v-time-picker-title__time .v-picker__title__btn,.v-time-picker-title__time span{align-items:center;display:inline-flex;height:70px;font-size:70px;justify-content:center}.v-time-picker-title__ampm{align-self:flex-end;display:flex;flex-direction:column;font-size:16px;margin:8px 0 6px 8px;text-transform:uppercase}.v-time-picker-title__ampm div:only-child{flex-direction:row}.v-picker__title--landscape .v-time-picker-title{flex-direction:column;justify-content:center;height:100%}.v-picker__title--landscape .v-time-picker-title__time{text-align:right}.v-picker__title--landscape .v-time-picker-title__time .v-picker__title__btn,.v-picker__title--landscape .v-time-picker-title__time span{height:55px;font-size:55px}.v-picker__title--landscape .v-time-picker-title__ampm{margin:16px 0 0;align-self:auto;text-align:center}.theme--light.v-time-picker-clock{background:#e0e0e0}.theme--light.v-time-picker-clock .v-time-picker-clock__item--disabled{color:rgba(0,0,0,.26)}.theme--light.v-time-picker-clock .v-time-picker-clock__item--disabled.v-time-picker-clock__item--active{color:hsla(0,0%,100%,.3)}.theme--light.v-time-picker-clock--indeterminate .v-time-picker-clock__hand{background-color:#bdbdbd}.theme--light.v-time-picker-clock--indeterminate .v-time-picker-clock__hand:after{color:#bdbdbd}.theme--light.v-time-picker-clock--indeterminate .v-time-picker-clock__item--active{background-color:#bdbdbd}.theme--dark.v-time-picker-clock{background:#616161}.theme--dark.v-time-picker-clock .v-time-picker-clock__item--disabled,.theme--dark.v-time-picker-clock .v-time-picker-clock__item--disabled.v-time-picker-clock__item--active{color:hsla(0,0%,100%,.3)}.theme--dark.v-time-picker-clock--indeterminate .v-time-picker-clock__hand{background-color:#757575}.theme--dark.v-time-picker-clock--indeterminate .v-time-picker-clock__hand:after{color:#757575}.theme--dark.v-time-picker-clock--indeterminate .v-time-picker-clock__item--active{background-color:#757575}.v-time-picker-clock{border-radius:100%;position:relative;transition:.3s cubic-bezier(.25,.8,.5,1);-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;width:100%;padding-top:100%}.v-time-picker-clock__container{display:flex;align-items:center;justify-content:center;padding:10px}.v-time-picker-clock__hand{height:calc(50% - 4px);width:2px;bottom:50%;left:calc(50% - 1px);-webkit-transform-origin:center bottom;transform-origin:center bottom;position:absolute;will-change:transform;z-index:1}.v-time-picker-clock__hand:before{background:transparent;border-width:2px;width:10px;height:10px;top:-4px}.v-time-picker-clock__hand:after,.v-time-picker-clock__hand:before{border-style:solid;border-color:inherit;border-radius:100%;content:\"\";position:absolute;left:50%;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.v-time-picker-clock__hand:after{height:8px;width:8px;top:100%;background-color:inherit}.v-time-picker-clock__hand--inner:after{height:14px}.v-picker--full-width .v-time-picker-clock__container{max-width:290px}.v-time-picker-clock__inner{position:absolute;bottom:27px;left:27px;right:27px;top:27px}.v-time-picker-clock__item{align-items:center;border-radius:100%;cursor:default;display:flex;font-size:16px;justify-content:center;height:40px;position:absolute;text-align:center;width:40px;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%)}.v-time-picker-clock__item>span{z-index:1}.v-time-picker-clock__item:after,.v-time-picker-clock__item:before{content:\"\";border-radius:100%;position:absolute;top:50%;left:50%;height:14px;width:14px;-webkit-transform:translate(-50%,-50%);transform:translate(-50%,-50%);height:40px;width:40px}.v-time-picker-clock__item--active{color:#fff;cursor:default;z-index:2}.v-time-picker-clock__item--disabled{pointer-events:none}.theme--light.v-toolbar{background-color:#f5f5f5;color:rgba(0,0,0,.87)}.theme--dark.v-toolbar{background-color:#212121;color:#fff}.application--is-rtl .v-toolbar__title:not(:first-child){margin-left:0;margin-right:20px}.v-toolbar{transition:none;box-shadow:0 2px 4px -1px rgba(0,0,0,.2),0 4px 5px 0 rgba(0,0,0,.14),0 1px 10px 0 rgba(0,0,0,.12);position:relative;width:100%;will-change:padding-left,padding-right}.v-toolbar[data-booted=true]{transition:.2s cubic-bezier(.4,0,.2,1)}.v-toolbar .v-text-field--box,.v-toolbar .v-text-field--enclosed{margin:0}.v-toolbar .v-text-field--box .v-text-field__details,.v-toolbar .v-text-field--enclosed .v-text-field__details{display:none}.v-toolbar .v-tabs{width:100%}.v-toolbar__title{font-size:20px;font-weight:500;letter-spacing:.02em;white-space:nowrap;overflow:hidden;text-overflow:ellipsis}.v-toolbar__title:not(:first-child){margin-left:20px}.v-toolbar__content,.v-toolbar__extension{align-items:center;display:flex;padding:0 24px}.v-toolbar__content .v-btn--icon,.v-toolbar__extension .v-btn--icon{margin:6px}.v-toolbar__content>:first-child,.v-toolbar__extension>:first-child{margin-left:0}.v-toolbar__content>:first-child.v-btn--icon,.v-toolbar__extension>:first-child.v-btn--icon{margin-left:-6px}.v-toolbar__content>:first-child.v-menu .v-menu__activator .v-btn,.v-toolbar__content>:first-child.v-tooltip span .v-btn,.v-toolbar__extension>:first-child.v-menu .v-menu__activator .v-btn,.v-toolbar__extension>:first-child.v-tooltip span .v-btn{margin-left:0}.v-toolbar__content>:first-child.v-menu .v-menu__activator .v-btn--icon,.v-toolbar__content>:first-child.v-tooltip span .v-btn--icon,.v-toolbar__extension>:first-child.v-menu .v-menu__activator .v-btn--icon,.v-toolbar__extension>:first-child.v-tooltip span .v-btn--icon{margin-left:-6px}.v-toolbar__content>:last-child,.v-toolbar__extension>:last-child{margin-right:0}.v-toolbar__content>:last-child.v-btn--icon,.v-toolbar__extension>:last-child.v-btn--icon{margin-right:-6px}.v-toolbar__content>:last-child.v-menu .v-menu__activator .v-btn,.v-toolbar__content>:last-child.v-tooltip span .v-btn,.v-toolbar__extension>:last-child.v-menu .v-menu__activator .v-btn,.v-toolbar__extension>:last-child.v-tooltip span .v-btn{margin-right:0}.v-toolbar__content>:last-child.v-menu .v-menu__activator .v-btn--icon,.v-toolbar__content>:last-child.v-tooltip span .v-btn--icon,.v-toolbar__extension>:last-child.v-menu .v-menu__activator .v-btn--icon,.v-toolbar__extension>:last-child.v-tooltip span .v-btn--icon{margin-right:-6px}.v-toolbar__content>.v-list,.v-toolbar__extension>.v-list{flex:1 1 auto;max-height:100%}.v-toolbar__content>.v-list:first-child,.v-toolbar__extension>.v-list:first-child{margin-left:-24px}.v-toolbar__content>.v-list:last-child,.v-toolbar__extension>.v-list:last-child{margin-right:-24px}.v-toolbar__extension>.v-toolbar__title{margin-left:72px}.v-toolbar__items{display:flex;height:inherit;max-width:100%;padding:0}.v-toolbar__items .v-btn{align-items:center;align-self:center}.v-toolbar__items .v-tooltip,.v-toolbar__items .v-tooltip>span{height:inherit}.v-toolbar__items .v-btn:not(.v-btn--floating):not(.v-btn--icon),.v-toolbar__items .v-menu,.v-toolbar__items .v-menu__activator{height:inherit;margin:0}.v-toolbar .v-btn-toggle,.v-toolbar .v-overflow-btn{box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.v-toolbar .v-input{margin:0}.v-toolbar .v-overflow-btn .v-input__control:before,.v-toolbar .v-overflow-btn .v-input__slot:before{display:none}.v-toolbar--card{border-radius:2px 2px 0 0;box-shadow:0 0 0 0 rgba(0,0,0,.2),0 0 0 0 rgba(0,0,0,.14),0 0 0 0 rgba(0,0,0,.12)}.v-toolbar--fixed{position:fixed;z-index:2}.v-toolbar--absolute,.v-toolbar--fixed{top:0;left:0}.v-toolbar--absolute{position:absolute;z-index:2}.v-toolbar--floating{display:inline-flex;margin:16px;width:auto}.v-toolbar--clipped{z-index:3}@media only screen and (max-width:959px){.v-toolbar__content,.v-toolbar__extension{padding:0 16px}.v-toolbar__content>.v-list:first-child,.v-toolbar__extension>.v-list:first-child{margin-left:-16px}.v-toolbar__content>.v-list:last-child,.v-toolbar__extension>.v-list:last-child{margin-right:-16px}}.v-tooltip__content{background:#616161;border-radius:2px;color:#fff;font-size:12px;display:inline-block;padding:5px 8px;position:absolute;text-transform:none;width:auto;box-shadow:0 3px 1px -2px rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 1px 5px 0 rgba(0,0,0,.12)}.v-tooltip__content[class*=-active]{transition:.15s cubic-bezier(.25,.8,.5,1);pointer-events:none}.v-tooltip__content--fixed{position:fixed}@media only screen and (max-width:959px){.v-tooltip .v-tooltip__content{padding:10px 16px}}.theme--light.v-treeview{color:rgba(0,0,0,.87)}.theme--light.v-treeview--hoverable .v-treeview-node__root:hover,.theme--light.v-treeview .v-treeview-node--active{background:rgba(0,0,0,.12)}.theme--dark.v-treeview{color:#fff}.theme--dark.v-treeview--hoverable .v-treeview-node__root:hover,.theme--dark.v-treeview .v-treeview-node--active{background:hsla(0,0%,100%,.12)}.application--is-rtl .v-treeview>.v-treeview-node{margin-right:0}.application--is-rtl .v-treeview>.v-treeview-node--leaf{margin-right:24px;margin-left:0}.application--is-rtl .v-treeview-node{margin-right:26px;margin-left:0}.application--is-rtl .v-treeview-node--leaf{margin-right:50px;margin-left:0}.application--is-rtl .v-treeview-node__toggle{-webkit-transform:rotate(90deg);transform:rotate(90deg)}.application--is-rtl .v-treeview-node__toggle--open{-webkit-transform:none;transform:none}.v-treeview>.v-treeview-node{margin-left:0}.v-treeview>.v-treeview-node--leaf{margin-left:24px}.v-treeview-node{margin-left:26px}.v-treeview-node--excluded{display:none}.v-treeview-node--click>.v-treeview-node__root,.v-treeview-node--click>.v-treeview-node__root>.v-treeview-node__content>*{cursor:pointer;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-treeview-node--leaf{margin-left:50px}.v-treeview-node__root{display:flex;align-items:center;min-height:34px}.v-treeview-node__content{display:flex;flex-grow:1;flex-shrink:0;align-items:center}.v-treeview-node__content .v-btn{flex-grow:0!important;flex-shrink:1!important}.v-treeview-node__label{font-size:1.2rem;margin-left:6px;flex-grow:1;flex-shrink:0}.v-treeview-node__label .v-icon{padding-right:8px}.v-treeview-node__checkbox,.v-treeview-node__toggle{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.v-treeview-node__toggle{-webkit-transform:rotate(-90deg);transform:rotate(-90deg)}.v-treeview-node__toggle--open{-webkit-transform:none;transform:none}.v-treeview-node__toggle--loading{-webkit-animation:progress-circular-rotate 1s linear infinite;animation:progress-circular-rotate 1s linear infinite}.v-treeview-node__children{transition:all .2s cubic-bezier(0,0,.2,1)}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/node_modules/vuetify/dist/vuetify.css"],"names":[],"mappings":"AAAA,yBACE,IACE,aAAe,CAChB,AACD,QACE,eAAiB,CAClB,AACD,QACE,gBAAkB,CACnB,CACF,AACD,iBACE,IACE,aAAe,CAChB,AACD,QACE,eAAiB,CAClB,AACD,QACE,gBAAkB,CACnB,CACF,AACD,OACE,gCAAkC,AAClC,2BAA8B,CAC/B,AACD,aACE,qBAAuB,AACvB,0BAA6B,CAC9B,AACD,OACE,gCAAkC,AAClC,2BAA8B,CAC/B,AACD,aACE,qBAAuB,AACvB,0BAA6B,CAC9B,AACD,aACE,uCAAyC,AACzC,kCAAqC,CACtC,AACD,mBACE,4BAA8B,AAC9B,iCAAoC,CACrC,AACD,KACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,WACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,cACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,0BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,cACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,0BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,cACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,0BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,cACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,0BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,cACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,0BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,cACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,0BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,cACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,0BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,cACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,0BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,MACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,YACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,QACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,cACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,gCAAkC,AAClC,2BAA8B,CAC/B,AACD,6BACE,qBAAuB,AACvB,0BAA6B,CAC9B,AACD,aACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mBACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,QACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,cACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,MACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,YACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,YACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kBACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,MACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,YACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,MACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,YACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,OACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,aACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,aACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mBACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,MACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,YACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,QACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,cACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,gCAAkC,AAClC,2BAA8B,CAC/B,AACD,6BACE,qBAAuB,AACvB,0BAA6B,CAC9B,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,OACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,aACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,QACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,cACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,kBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,8BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,aACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mBACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,uBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,mCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,sBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,kCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,OACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,aACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,iBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,6BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,WACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iBACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,qBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,iCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,oBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,gCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,oBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,gCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,oBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,gCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,oBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,gCACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,MACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,YACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,gCAAkC,AAClC,2BAA8B,CAC/B,AACD,4BACE,qBAAuB,AACvB,0BAA6B,CAC9B,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,gBACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,4BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,eACE,mCAAqC,AACrC,8BAAiC,CAClC,AACD,2BACE,wBAA0B,AAC1B,6BAAgC,CACjC,AACD,cACE,gCAAkC,AAClC,2BAA8B,CAC/B,AACD,0BACE,qBAAuB,AACvB,0BAA6B,CAC9B,AACD,cACE,gCAAkC,AAClC,2BAA8B,CAC/B,AACD,0BACE,qBAAuB,AACvB,0BAA6B,CAC9B,AACD,oBACE,uCAAyC,AACzC,kCAAqC,CACtC,AACD,gCACE,4BAA8B,AAC9B,iCAAoC,CACrC,AACD,aACE,2FAA2H,CAC5H,AACD,aACE,0GAA4H,CAC7H,AACD,aACE,0GAA4H,CAC7H,AACD,aACE,0GAA4H,CAC7H,AACD,aACE,2GAA6H,CAC9H,AACD,aACE,2GAA6H,CAC9H,AACD,aACE,4GAA8H,CAC/H,AACD,aACE,gHAA8H,CAC/H,AACD,aACE,gHAA8H,CAC/H,AACD,aACE,gHAA8H,CAC/H,AACD,cACE,iHAA+H,CAChI,AACD,cACE,iHAA+H,CAChI,AACD,cACE,iHAA+H,CAChI,AACD,cACE,iHAA+H,CAChI,AACD,cACE,iHAA+H,CAChI,AACD,cACE,iHAA+H,CAChI,AACD,cACE,kHAAgI,CACjI,AACD,cACE,kHAAgI,CACjI,AACD,cACE,kHAAgI,CACjI,AACD,cACE,kHAAgI,CACjI,AACD,cACE,mHAAiI,CAClI,AACD,cACE,mHAAiI,CAClI,AACD,cACE,mHAAiI,CAClI,AACD,cACE,mHAAiI,CAClI,AACD,cACE,mHAAiI,CAClI,AACD,KACE,sBAAuB,AACvB,kBAAmB,AACnB,6BAA+B,CAChC,AACD,iBAGE,kBAAoB,CACrB,AACD,eAEE,wBAAyB,AACzB,sBAAwB,CACzB,AACD,EACE,4BAA6B,AAC7B,UAAW,AACX,QAAU,CACX,AACD,sBACE,aAAc,AACd,QAAU,CACX,AACD,GACE,gBAAkB,CACnB,AACD,oFAYE,aAAe,CAChB,AACD,QACE,iBAAmB,CACpB,AACD,MACE,aAAe,CAChB,AACD,kBAEE,YAAc,CACf,AACD,YACE,yBAA0B,AAC1B,oBAAsB,CACvB,AACD,EACE,6BAA8B,AAC9B,oCAAsC,CACvC,AACD,iBAEE,eAAiB,CAClB,AACD,kBAIE,+BAAkC,CACnC,AACD,SAEE,kBAAoB,CACrB,AACD,IACE,iBAAmB,CACpB,AACD,KACE,sBAAuB,AACvB,UAAY,CACb,AACD,QAEE,cAAe,AACf,cAAe,AACf,kBAAmB,AACnB,uBAAyB,CAC1B,AACD,IACE,aAAgB,CACjB,AACD,IACE,SAAY,CACb,AACD,MACE,eAAiB,CAClB,AACD,8DAKE,cAAgB,CACjB,AACD,WACE,cAAgB,CACjB,AACD,cACE,UAAY,CACb,AAID,qFAEE,uBAAyB,CAC1B,AACD,SACE,cAAe,AACf,eAAiB,CAClB,AACD,sCAKE,YAAc,CACf,AACD,SACE,eAAkB,CACnB,AACD,OACE,gBAAkB,CACnB,AACD,wHAIE,eAAgB,AAChB,SAAW,CACZ,AACD,qHAIE,UAAW,AACX,QAAU,CACX,AACD,qDAIE,yBAA2B,CAC5B,AACD,cAEE,mBAAqB,CACtB,AACD,6BAIE,6BAA8B,AAC9B,kBAAmB,AACnB,aAAe,CAChB,AACD,OACE,qBAAsB,AACtB,uBAAyB,CAC1B,AACD,mBACE,YAAc,CACf,AACD,kBACE,kBAAoB,CACrB,AACD,OACE,SAAU,AACV,cAAe,AACf,cAAe,AACf,eAAgB,AAChB,kBAAoB,CACrB,AACD,6BACE,0BAA2B,AAC3B,YAAc,CACf,AACD,cACE,6BAA8B,AAC9B,mBAAqB,CACtB,AACD,IACE,iBAAmB,CACpB,AACD,SACE,uBAAyB,CAC1B,AACD,eACE,eAAiB,CAClB,AACD,4BAIE,oBAAsB,CACvB,AACD,iBACE,eAAiB,CAClB,AACD,gBACE,cAAgB,CACjB,AACD,gBACE,cAAgB,CACjB,AACD,YACE,yBAA0B,AAC1B,WAAY,AACZ,gBAAkB,CACnB,AAKD,iEACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,2BACE,kCAAsC,AAC9B,yBAA8B,CACvC,AACD,yDAEE,kBAAmB,AACnB,KAAO,CAGR,AACD,4FAHE,mCAAuC,AAC/B,0BAA+B,CAKxC,AACD,yEAEE,kBAAmB,AACnB,MAAO,AACP,kCAAsC,AAC9B,yBAA8B,CACvC,AACD,qDAEE,4BAA8B,AACtB,oBAAsB,AAC9B,SAAW,CACZ,AACD,qDAEE,SAAW,CACZ,AACD,mEAEE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,gJAIE,qCAA4C,CAC7C,AACD,0HAIE,SAAW,CACZ,AACD,kMAME,2BAA8B,CAC/B,AACD,yBACE,mCAAsC,AAC9B,0BAA8B,CACvC,AAKD,6DACE,oCAAuC,AAC/B,2BAA+B,CACxC,AACD,oCACE,mCAAsC,AAC9B,0BAA8B,CACvC,AACD,iEAEE,+BAAmC,AAC3B,sBAA2B,CACpC,AACD,+BACE,mCAAuC,AAC/B,0BAA+B,CACxC,AACD,kCACE,UAAW,AACX,kCAAsC,AAC9B,yBAA8B,CACvC,AACD,uGAGE,2BAA8B,CAC/B,AACD,sBACE,kCAAsC,AAC9B,yBAA8B,CACvC,AACD,mDAEE,kBAAmB,AACnB,KAAO,CACR,AACD,yBACE,iBAAmB,CAGpB,AACD,uDAHE,mCAAuC,AAC/B,0BAA+B,CAKxC,AACD,+DAEE,MAAO,AACP,kBAAmB,AACnB,kCAAsC,AAC9B,yBAA8B,CACvC,AACD,gEAEE,wCAAiD,CAClD,AACD,wBACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,oEAEE,wCAAiD,CAClD,AACD,0BACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,8DAEE,wCAAiD,CAClD,AACD,uBACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,2EAGE,UAAW,AACX,2BAA4B,AACpB,kBAAoB,CAC7B,AACD,kEAEE,wCAAiD,CAClD,AACD,yBACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,uDAEE,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,2DAEE,iBAAmB,CACpB,AACD,kEAEE,wCAAiD,CAClD,AACD,yBACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,uDAEE,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,kFAEE,wCAAiD,CAClD,AACD,iCACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,uEAEE,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,oEAEE,wCAAiD,CAClD,AACD,0BACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,yDAEE,SAAW,CACZ,AACD,2BACE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,8BACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,oFAEE,wCAAiD,CAClD,AACD,kCACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,yEAEE,SAAW,CACZ,AACD,mCACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,sCACE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,oEAEE,wCAAiD,CAClD,AACD,0BACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,yDAEE,SAAW,CACZ,AACD,2BACE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,8BACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,oFAEE,wCAAiD,CAClD,AACD,kCACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,yEAEE,SAAW,CACZ,AACD,mCACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,sCACE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,kEAEE,wCAAiD,CAClD,AACD,yBACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,uDAEE,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,kFAEE,wCAAiD,CAClD,AACD,iCACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,uEAEE,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,4DAEE,wCAAiD,CAClD,AACD,sBACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,iDAEE,SAAW,CACZ,AACD,0DAEE,wCAAiD,CAClD,AACD,qBACE,iCAAmC,AACnC,yBAA2B,AAC3B,8CAAmD,CACpD,AACD,+CAEE,0CAA2C,AACnC,iCAAmC,CAC5C,AACD,YACE,yBAA0B,AAC1B,eAAgB,AAChB,eAAiB,CAClB,AACD,SAEE,qBAAsB,AACtB,kBAAmB,AACnB,qBAAsB,AACtB,cAAe,AACf,eAAiB,CAClB,AACD,4CAIE,cAAiB,AACjB,mBAAqB,CACtB,AACD,KACE,yBAA0B,AAC1B,cAAe,AACf,gGAAiH,CAClH,AACD,IACE,mBAAoB,AACpB,UAAY,CACb,AACD,KACE,eAAgB,AAChB,kBAAmB,AACnB,kCAAmC,AACnC,mCAAoC,AACpC,kCAAmC,AACnC,yCAA2C,CAC5C,AACD,aACE,8BAAkC,AAClC,eAAiB,CAClB,AACD,yBAEE,YAAc,CACf,AACD,MAEE,iBAAmB,CACpB,AACD,WACE,0BAA4B,AAC5B,gBAAiB,AACjB,wBAA0B,AAC1B,gCAAmC,AACnC,uCAA6C,CAC9C,AACD,WACE,yBAA2B,AAE3B,2BAA6B,AAC7B,+BAAmC,CAEpC,AACD,sBALE,gBAAiB,AAGjB,uCAA6C,CAQ9C,AAND,WACE,yBAA2B,AAE3B,2BAA6B,AAC7B,+BAAkC,CAEnC,AACD,WACE,yBAA2B,AAE3B,0BAA6B,CAG9B,AACD,qBALE,gBAAiB,AAEjB,gCAAkC,AAClC,uCAA6C,CAQ9C,AAND,UACE,yBAA2B,AAE3B,0BAA6B,CAG9B,AACD,OACE,yBAA2B,AAC3B,gBAAiB,AACjB,wBAA0B,AAC1B,+BAAkC,AAClC,uCAA6C,CAC9C,AACD,YACE,yBAA2B,AAC3B,eAAiB,CAClB,AACD,QAEE,eAAiB,CAClB,AACD,gBAHE,wBAA2B,CAM5B,AACD,iBAFE,eAAiB,CAKlB,AAHD,SACE,wBAA2B,CAE5B,AACD,EACE,kBAAoB,CACrB,AACD,iBACE,eAAiB,CAClB,AACD,mBACE,iBAAmB,CACpB,AACD,mBACE,iBAAmB,CACpB,AACD,OACE,qBAAwB,CACzB,AACD,MACE,oBAAuB,CACxB,AACD,SAIE,qBAA6B,CAC9B,AACD,SACE,0BAA4B,AAC5B,4BAA+B,CAChC,AACD,SACE,2BAA6B,AAC7B,2BAA8B,CAC/B,AACD,SACE,yBAA4B,CAC7B,AACD,SACE,2BAA8B,CAC/B,AACD,SACE,4BAA+B,CAChC,AACD,SACE,0BAA6B,CAC9B,AACD,MACE,kBAAuB,CACxB,AACD,MACE,uBAAyB,AACzB,yBAA4B,CAC7B,AACD,MACE,wBAA0B,AAC1B,wBAA2B,CAC5B,AACD,MACE,sBAAyB,CAC1B,AACD,MACE,wBAA2B,CAC5B,AACD,MACE,yBAA4B,CAC7B,AACD,MACE,uBAA0B,CAC3B,AACD,MACE,mBAAwB,CACzB,AACD,MACE,wBAA0B,AAC1B,0BAA6B,CAC9B,AACD,MACE,yBAA2B,AAC3B,yBAA4B,CAC7B,AACD,MACE,uBAA0B,CAC3B,AACD,MACE,yBAA4B,CAC7B,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,wBAA2B,CAC5B,AACD,MACE,oBAA2B,CAC5B,AACD,MACE,yBAA2B,AAC3B,2BAA8B,CAC/B,AACD,MACE,0BAA4B,AAC5B,0BAA6B,CAC9B,AACD,MACE,wBAA2B,CAC5B,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,2BAA8B,CAC/B,AACD,MACE,yBAA4B,CAC7B,AACD,MACE,qBAA4B,CAC7B,AACD,MACE,0BAA4B,AAC5B,4BAA+B,CAChC,AACD,MACE,2BAA6B,AAC7B,2BAA8B,CAC/B,AACD,MACE,yBAA4B,CAC7B,AACD,MACE,2BAA8B,CAC/B,AACD,MACE,4BAA+B,CAChC,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,oBAA2B,CAC5B,AACD,MACE,yBAA2B,AAC3B,2BAA8B,CAC/B,AACD,MACE,0BAA4B,AAC5B,0BAA6B,CAC9B,AACD,MACE,wBAA2B,CAC5B,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,2BAA8B,CAC/B,AACD,MACE,yBAA4B,CAC7B,AACD,MACE,qBAA4B,CAC7B,AACD,MACE,0BAA4B,AAC5B,4BAA+B,CAChC,AACD,MACE,2BAA6B,AAC7B,2BAA8B,CAC/B,AACD,MACE,yBAA4B,CAC7B,AACD,MACE,2BAA8B,CAC/B,AACD,MACE,4BAA+B,CAChC,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,qBAA6B,CAC9B,AACD,MACE,0BAA4B,AAC5B,4BAA+B,CAChC,AACD,MACE,2BAA6B,AAC7B,2BAA8B,CAC/B,AACD,MACE,yBAA4B,CAC7B,AACD,MACE,2BAA8B,CAC/B,AACD,MACE,4BAA+B,CAChC,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,sBAA8B,CAC/B,AACD,MACE,2BAA6B,AAC7B,6BAAgC,CACjC,AACD,MACE,4BAA8B,AAC9B,4BAA+B,CAChC,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,4BAA+B,CAChC,AACD,MACE,6BAAgC,CACjC,AACD,MACE,2BAA8B,CAC/B,AACD,MACE,qBAA6B,CAC9B,AACD,MACE,0BAA4B,AAC5B,4BAA+B,CAChC,AACD,MACE,2BAA6B,AAC7B,2BAA8B,CAC/B,AACD,MACE,yBAA4B,CAC7B,AACD,MACE,2BAA8B,CAC/B,AACD,MACE,4BAA+B,CAChC,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,sBAA8B,CAC/B,AACD,MACE,2BAA6B,AAC7B,6BAAgC,CACjC,AACD,MACE,4BAA8B,AAC9B,4BAA+B,CAChC,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,4BAA+B,CAChC,AACD,MACE,6BAAgC,CACjC,AACD,MACE,2BAA8B,CAC/B,AACD,MACE,qBAA6B,CAC9B,AACD,MACE,0BAA4B,AAC5B,4BAA+B,CAChC,AACD,MACE,2BAA6B,AAC7B,2BAA8B,CAC/B,AACD,MACE,yBAA4B,CAC7B,AACD,MACE,2BAA8B,CAC/B,AACD,MACE,4BAA+B,CAChC,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,sBAA8B,CAC/B,AACD,MACE,2BAA6B,AAC7B,6BAAgC,CACjC,AACD,MACE,4BAA8B,AAC9B,4BAA+B,CAChC,AACD,MACE,0BAA6B,CAC9B,AACD,MACE,4BAA+B,CAChC,AACD,MACE,6BAAgC,CACjC,AACD,MACE,2BAA8B,CAC/B,AACD,kBACE,yBAA4B,CAC7B,AACD,mBACE,yBAA4B,CAC7B,AACD,qBACE,yBAA4B,CAC7B,AACD,oBACE,yBAA4B,CAC7B,AACD,kBACE,yBAA4B,CAC7B,AACD,mBACE,yBAA4B,CAC7B,AACD,aACE,2BAA8B,CAC/B,AACD,iBACE,mCAAsC,CACvC,AACD,gBACE,kCAAqC,CACtC,AACD,WACE,6BAAgC,CACjC,AACD,gBACE,kCAAqC,CACtC,AAID,6BAFE,4BAA+B,CAOhC,AALD,eAEE,0BAA4B,AAC5B,iCAAmC,AACnC,yBAA4B,CAC7B,AACD,6BACE,gDAAyD,CAC1D,AACD,+BACE,+CAAuD,CACxD,AACD,+BACE,+CAAuD,CACxD,AACD,wBACE,gDAAyD,CAC1D,AACD,6BACE,mDAA6D,CAC9D,AACD,kBACE,kDAA4D,CAC7D,AACD,cACE,iBACE,eAAiB,CAClB,AACD,uDACE,4BAA8B,AAC9B,4BAA+B,CAChC,CACF,AACD,kBACE,mBACE,sBAAyB,CAC1B,CACF,AACD,mBACE,oBACE,sBAAyB,CAC1B,CACF,AACD,yCACE,gBACE,sBAAyB,CAC1B,CACF,AACD,+DACE,gBACE,sBAAyB,CAC1B,CACF,AACD,yCACE,oBACE,sBAAyB,CAC1B,CACF,AACD,yCACE,kBACE,sBAAyB,CAC1B,CACF,AACD,gEACE,gBACE,sBAAyB,CAC1B,CACF,AACD,0CACE,oBACE,sBAAyB,CAC1B,CACF,AACD,yCACE,kBACE,sBAAyB,CAC1B,CACF,AACD,iEACE,gBACE,sBAAyB,CAC1B,CACF,AACD,0CACE,oBACE,sBAAyB,CAC1B,CACF,AACD,0CACE,kBACE,sBAAyB,CAC1B,CACF,AACD,0CACE,gBACE,sBAAyB,CAC1B,CACF,AACD,qBACE,cACE,yBAA4B,CAC7B,AACD,gBACE,2BAA8B,CAC/B,AACD,eACE,0BAA6B,CAC9B,AACD,iBACE,4BAA+B,CAChC,CACF,AACD,yBACE,cACE,yBAA4B,CAC7B,AACD,gBACE,2BAA8B,CAC/B,AACD,eACE,0BAA6B,CAC9B,AACD,iBACE,4BAA+B,CAChC,CACF,AACD,yBACE,cACE,yBAA4B,CAC7B,AACD,gBACE,2BAA8B,CAC/B,AACD,eACE,0BAA6B,CAC9B,AACD,iBACE,4BAA+B,CAChC,CACF,AACD,0BACE,cACE,yBAA4B,CAC7B,AACD,gBACE,2BAA8B,CAC/B,AACD,eACE,0BAA6B,CAC9B,AACD,iBACE,4BAA+B,CAChC,CACF,AACD,0BACE,cACE,yBAA4B,CAC7B,AACD,gBACE,2BAA8B,CAC/B,AACD,eACE,0BAA6B,CAC9B,AACD,iBACE,4BAA+B,CAChC,CACF,AAED,aACE,YAAc,CACf,AACD,eACE,cAAgB,CACjB,AACD,qBACE,aAAe,CAChB,AACD,mBACE,cAAe,AACf,mCAAoC,AAC5B,2BAA4B,AACpC,aAAc,AACd,sBAAuB,AACvB,iBAAkB,AAClB,eAAgB,AAChB,iBAAmB,CACpB,AACD,0BACE,mBAAoB,AACpB,qBAAwB,CACzB,AACD,yCACE,+BAAmC,CACpC,AACD,2CACE,+BAAmC,CACpC,AACD,0CACE,+BAAmC,CACpC,AACD,yBACE,mBAAoB,AACpB,UAAY,CACb,AACD,wCACE,oBAAuB,CACxB,AACD,0CACE,kCAAwC,CACzC,AACD,yCACE,kCAAwC,CACzC,AAGD,aACE,4BAIE,gCACE,aAAe,CAChB,CACF,CACF,AAED,SACE,gBAAiB,AACjB,qBAAwB,AACxB,mBAAoB,AACpB,WAAY,AACZ,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,aAAc,AACd,kBAAmB,AACnB,wCAAiD,CAClD,AACD,6DAEE,kBAAmB,AACnB,qBAAuB,AACvB,cAAgB,CACjB,AACD,0BACE,uBAA0B,CAC3B,AACD,eACE,iBAAmB,CACpB,AACD,sBACE,sBAAuB,AACvB,cAAe,AACf,iBAAkB,AAClB,eAAgB,AAChB,qBAAsB,AACtB,yCAAiD,AACjD,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,4BACE,UAAa,CACd,AACD,iCACE,YAAc,CACf,AACD,aACE,kBAAmB,AACnB,QAAU,CACX,AACD,iBACE,sCAA0C,CAC3C,AACD,0BACE,uCAA0C,CAC3C,AACD,oCACE,eACE,YAAc,CACf,CACF,AAGD,qBACE,qBAAwB,CACzB,AACD,sCACE,+BAAmC,CACpC,AACD,oBACE,UAAY,CACb,AACD,qCACE,kCAAwC,CACzC,AACD,QACE,mBAAoB,AACpB,oBAAqB,AACrB,qCAAsC,AAC9B,6BAA8B,AACtC,eAAgB,AAChB,uBAAwB,AACxB,cAAe,AACf,yCAAiD,AACjD,0BAA4B,CAC7B,AACD,eACE,gBAAkB,CACnB,AACD,cACE,iBAAmB,CACpB,AACD,4BACE,cAAgB,CACjB,AACD,kBACE,oBAAqB,AACrB,UAAa,CACd,AACD,sBACE,WAAa,CACd,AAED,yDACE,WAAa,CACd,AACD,sBACE,iBAAmB,CACpB,AACD,0CACE,SAAW,CACZ,AACD,sHACE,eAAiB,CAClB,AACD,uEACE,sBAAwB,CACzB,AAID,0FACE,eAAiB,CAClB,AAED,mEACE,4BAA+B,CAChC,AACD,kGACE,4BAA+B,CAChC,AACD,wFACE,0HAAyI,CAC1I,AACD,4NAEE,qBAAwB,CACzB,AACD,sEAEE,qBAAwB,CACzB,AACD,kEACE,kBAAmB,AACnB,eAAiB,CAClB,AACD,8FACE,0BAA6B,CAC9B,AACD,kHACE,kBAAoB,CACrB,AACD,mPAEE,UAAY,CACb,AACD,iEACE,0BAA6B,CAC9B,AACD,sDACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,kOAGE,gBAAiB,AACjB,wCAAiD,CAClD,AACD,iGACE,0BAA6B,CAC9B,AACD,qEACE,gCAAmC,CACpC,AACD,8HACE,gCAAmC,CACpC,AACD,kEACE,+BAAoC,CACrC,AACD,iGACE,iBAAmB,CACpB,AACD,uFACE,gIAAmJ,CACpJ,AACD,0NAEE,wBAA6B,CAC9B,AACD,oEAEE,wBAA6B,CAC9B,AACD,iEACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,6FACE,8BAAmC,CACpC,AACD,iHACE,eAAiB,CAClB,AACD,iPAEE,qBAAwB,CACzB,AACD,gEACE,yBAA4B,CAC7B,AACD,qDACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,+NAGE,gBAAiB,AACjB,wCAAiD,CAClD,AACD,gGACE,yBAA4B,CAC7B,AACD,oEACE,mCAAwC,CACzC,AACD,6HACE,qBAAuB,CACxB,AACD,4CACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,8CACE,cAAe,AACf,gBAAkB,CACnB,AACD,oEACE,cAAe,AACf,iBAAmB,CACpB,AACD,qEACE,iBAAkB,AAClB,cAAgB,CACjB,AACD,kDACE,eAAiB,CAClB,AACD,qDACE,kCAAmC,AAC3B,yBAA2B,CACpC,AACD,2CACE,gBAAiB,AACjB,gBAAiB,AACjB,gBAAkB,CACnB,AACD,2CACE,eAAgB,AAChB,iBAAmB,CACpB,AACD,kEACE,iBAAkB,AAClB,eAAgB,AAChB,iBAAmB,CACpB,AACD,kEACE,eAAgB,AAChB,iBAAmB,CACpB,AACD,cACE,iBAAkB,AAClB,cAAgB,CACjB,AACD,oBACE,cAAe,AACf,iBAAkB,AAClB,cAAmB,AACnB,eAAgB,AAChB,YAAe,AACf,UAAY,CACb,AACD,2EAEE,sBAAuB,AACvB,oBAAqB,AACrB,eAAgB,AAChB,cAAe,AACf,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,sCACE,kBAAmB,AACnB,iBAAmB,CACpB,AACD,qCACE,iBAAkB,AAClB,gBAAkB,CACnB,AACD,yBACE,gBAAiB,AACjB,kBAAoB,CACrB,AACD,uBACE,cAAe,AACf,gBAAiB,AACjB,uBAAwB,AACxB,QAAS,AACT,kCAAmC,AAC3B,0BAA2B,AACnC,mBAAoB,AACpB,mBAAqB,CACtB,AACD,+BACE,eAAgB,AAChB,+CAAiD,AACzC,sCAAyC,CAClD,AACD,+CACE,YAAa,AACb,mDAA4D,CAC7D,AACD,2GAEE,YAAa,AACb,WAAY,AACZ,OAAQ,AACR,kBAAmB,AACnB,yCAAiD,AACjD,UAAY,CACb,AACD,sDACE,mBAAoB,AACpB,qBAAyB,CAC1B,AACD,qDACE,0BAA2B,AAC3B,mBAAoB,AACpB,oBAA4B,AAC5B,4BAA6B,AACrB,mBAAqB,CAC9B,AACD,uBACE,aAAc,AACd,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,4CAEE,kBAAmB,AACnB,cAAgB,CACjB,AACD,sBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,sBACE,iBAAkB,AAClB,kBAAoB,CACrB,AACD,6CACE,gBAAiB,AACjB,gBAAiB,AACjB,gBAAkB,CACnB,AACD,6CACE,eAAgB,AAChB,iBAAmB,CACpB,AACD,mEACE,aAAc,AACd,cAAe,AACf,iBAAmB,CACpB,AACD,oEAGE,iBAAmB,CACpB,AACD,uKAGE,oBAAqB,AACrB,eAAiB,CAClB,AACD,sFAGE,eAAiB,CAClB,AACD,oKAGE,eAAiB,CAClB,AACD,+FAGE,QAAU,CACX,AACD,uHAGE,8CAAgD,AACxC,qCAAwC,CACjD,AACD,oDACE,2BAA4B,AAC5B,2BAA6B,CAC9B,AACD,2DACE,mBAAoB,AACpB,mBAA4B,CAC7B,AACD,qCACE,SAAU,AACV,SAAW,CACZ,AACD,4FACE,YAAc,CACf,AACD,kPAIE,eAAiB,CAClB,AACD,kIAEE,cAAgB,CACjB,AACD,4DACE,iBAAmB,CACpB,AACD,6BACE,gBAAkB,CACnB,AACD,gCACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,mGAEE,0BAA4B,CAC7B,AACD,uXAME,YAAc,CACf,AACD,uBACE,mBAAoB,AACpB,+CAAwD,CACzD,AACD,wDACE,iCAAmC,AACnC,iBAAmB,CACpB,AACD,6CACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,6FAEE,eAAiB,CAClB,AACD,uMAGE,gBAAiB,AACjB,wCAAiD,CAClD,AACD,uJAEE,8BAA+B,AAC/B,+CAAwD,CACzD,AACD,0CACE,oBAAsB,CACvB,AACD,mDACE,gBAAiB,AACjB,SAAW,CACZ,AACD,gGACE,gGAAiH,CAClH,AACD,qDACE,kBAAoB,CACrB,AACD,iHAEE,kBAAmB,AACnB,YAAc,CACf,AACD,iHAEE,eAAiB,CAClB,AACD,yEACE,4BAA6B,AACrB,mBAAqB,CAC9B,AACD,yEACE,yBAA2B,CAC5B,AAED,6CACE,qBAAwB,CACzB,AAID,iKAEE,qBAAwB,CACzB,AAID,yIACE,UAAY,CACb,AAID,8JAEE,wBAA6B,CAC9B,AACD,4FACE,qBAAwB,CACzB,AACD,UACE,iBAAmB,CACpB,AACD,2CACE,cAAgB,CACjB,AACD,kBACE,aAAe,CAChB,AACD,wCACE,kBAAmB,AACnB,MAAQ,CACT,AACD,wDACE,2BAA8B,CAC/B,AAID,uGACE,2BAA8B,CAC/B,AACD,0CACE,2BAA8B,CAC/B,AACD,kFACE,iBAAkB,AAClB,kBAAmB,AACnB,QAAS,AACT,wCAAiD,CAClD,AACD,uFACE,gBAAkB,CACnB,AACD,6BACE,SAAU,AACV,aAAc,AACd,YAAa,AACb,oBAAqB,AACrB,iBAAmB,CACpB,AACD,kEACE,iCAAkC,AAC1B,wBAA0B,CACnC,AACD,gCACE,QAAU,CACX,AACD,gDACE,eAAiB,CAClB,AACD,uEACE,eAAiB,CAClB,AACD,yMAEE,eAAiB,CAClB,AACD,uPAEE,eAAiB,CAClB,AACD,sGAEE,0BAA4B,CAC7B,AACD,sBACE,mBAAoB,AACpB,aAAc,AACd,cAAe,AACf,eAAgB,AAChB,gBAAkB,CACnB,AACD,qBACE,aAAe,CAChB,AACD,4BACE,mBAAoB,AACpB,oBAAqB,AACrB,oBAAsB,CACvB,AACD,gBACE,kBAAmB,AACnB,mBAAoB,AACpB,aAAc,AACd,UAAY,CACb,AACD,gEACE,mBAAqB,CACtB,AAED,qBACE,mBAAoB,AACpB,qBAAwB,CACzB,AACD,+BACE,qBAAwB,CACzB,AACD,oBACE,gBAAiB,AACjB,UAAY,CACb,AACD,8BACE,wBAA6B,CAC9B,AACD,oCACE,kBAAoB,CACrB,AACD,yDACE,oBAAsB,CACvB,AACD,2CACE,oBAAsB,CACvB,AACD,uCACE,mBAAoB,AACpB,eAAiB,CAClB,AACD,4CACE,kBAAmB,AACnB,gBAAkB,CACnB,AACD,2CACE,kBAAmB,AACnB,gBAAkB,CACnB,AACD,QAIE,eAAgB,AAChB,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,wCAAiD,CAElD,AACD,iCAVE,mBAAoB,AACpB,mBAAoB,AACpB,oBAAqB,AAMrB,qBAAuB,CAaxB,AAXD,yBAGE,eAAgB,AAEhB,YAAa,AACb,8BAA+B,AAC/B,eAAgB,AAEhB,mBAAoB,AACpB,SAAW,CACZ,AACD,oCACE,oBAAsB,CACvB,AACD,kBACE,sBAAwB,AACxB,kBAAmB,AACnB,iBAAkB,AAClB,eAAgB,AAChB,oBAAuB,CACxB,AACD,sBACE,YAAa,AACb,UAAY,CACb,AACD,uEAGE,6BAA+B,AAC/B,gGAAiH,CAClH,AACD,yFAGE,wBAAyB,AACzB,sBAAuB,AACvB,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,mBAAoB,AACpB,WAAY,AACZ,oBAAqB,AACrB,WAAc,CACf,AAID,+CACE,iBAAmB,CACpB,AACD,+BACE,iCAAmC,AACnC,8BAA+B,AAC/B,cAAe,AACf,WAAa,CACd,AACD,yCACE,iBAAmB,CACpB,AACD,eACE,qBAAwB,CACzB,AACD,yBACE,sBAAwB,AACxB,eAAgB,AAChB,oBAAuB,CACxB,AACD,uBACE,cAAgB,CACjB,AACD,eACE,mBAAoB,AACpB,cAAe,AACf,aAAc,AACd,eAAgB,AAChB,mBAAoB,AACpB,qBAAsB,AACtB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,uBACE,wBAA0B,AAC1B,eAAgB,AAChB,eAAgB,AAChB,UAAa,CACd,AACD,6BACE,SAAW,CACZ,AACD,iCACE,mBAAqB,CACtB,AACD,sBACE,oBAAsB,CACvB,AACD,gBACE,aAAe,CAChB,AACD,uBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,sBACE,iBAAkB,AAClB,iBAAmB,CACpB,AAED,QACE,cAAe,AACf,qBAAuB,CACxB,AACD,gBACE,oBAAsB,CACvB,AACD,mBACE,mBAAoB,AACpB,eAAgB,AAChB,YAAc,CACf,AACD,qBACE,cAAgB,CACjB,AACD,iBACE,kBAAmB,AACnB,qBAAsB,AACtB,kBAAmB,AACnB,cAAe,AACf,gBAAiB,AACjB,kBAAmB,AACnB,gBAAiB,AACjB,sBAAuB,AACvB,sGAAmH,CACpH,AACD,yBACE,mBAAqB,CACtB,AACD,wBACE,cAAgB,CACjB,AACD,uBACE,gBAAiB,AACjB,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,yBACE,cAAgB,CACjB,AACD,uCACE,YAAa,AACb,mBAAqB,CACtB,AACD,0CACE,oBAAqB,AACrB,oBAAuB,CACxB,AACD,4DAEE,mBAAqB,CACtB,AACD,qDAEE,SAAW,CACZ,AACD,gEAEE,6CAAsD,CACvD,AACD,+CACE,yBAA4B,CAC7B,AACD,6DACE,UAAW,AACX,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,qEACE,UAAW,AACX,iCAAmC,AAC3B,yBAA2B,AACnC,mBAAqB,CACtB,AAGD,qBACE,sBAAuB,AACvB,kBAAmB,AACnB,qBAAwB,CACzB,AACD,oBACE,yBAA0B,AAC1B,qBAAsB,AACtB,UAAY,CACb,AACD,QACE,iGAAiH,AACjH,oBAAsB,CACvB,AACD,8CACE,+BAAgC,AAChC,+BAAiC,CAClC,AACD,6CACE,kCAAmC,AACnC,kCAAoC,CACrC,AACD,cACE,iFAAgH,CACjH,AACD,eACE,eAAgB,AAChB,8CAAsD,AACtD,8BAAgC,CACjC,AACD,qBACE,sGAAmH,CACpH,AACD,eACE,mBAAoB,AACpB,aAAc,AACd,eAAgB,AAChB,YAAc,CACf,AACD,wBACE,gBAAkB,CACnB,AACD,cACE,aAAc,AACd,UAAY,CACb,AACD,iBACE,mBAAoB,AACpB,aAAc,AACd,WAAa,CACd,AACD,2CAEE,QAAU,CACX,AACD,+BACE,eAAiB,CAClB,AAGD,uEACE,+BAAmC,CACpC,AACD,sEACE,kCAAwC,CACzC,AACD,sFACE,eAAgB,AAChB,eAAiB,CAClB,AACD,6BACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,yGAEE,aAAc,AACd,eAAiB,CAClB,AACD,+CACE,YAAa,AACb,UAAY,CACb,AACD,wEACE,kBAAoB,CACrB,AACD,oCACE,cAAe,AACf,oBAAqB,AACrB,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,iBAAkB,AAClB,0CAAkD,AAClD,4CAA8C,AAC9C,oCAAsC,AACtC,sDAAyD,AACzD,WAAY,AACZ,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,0CACE,kBAAmB,AACnB,UAAW,AACX,WAAY,AACZ,WAAa,CAMd,AACD,uFANE,eAAgB,AAChB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAQ3B,AACD,qCACE,kBAAmB,AACnB,eAAgB,AAChB,YAAa,AACb,kBAAmB,AACnB,mBAAoB,AACpB,WAAY,AACZ,WAAY,AACZ,qBAAsB,AACtB,UAAY,CACb,AACD,4CACE,sBAAuB,AACvB,SAAU,AACV,WAAY,AACZ,kBAAmB,AACnB,WAAa,AACb,OAAQ,AACR,QAAS,AACT,MAAO,AACP,uCAAwC,AAChC,+BAAgC,AACxC,4BAA8B,AACtB,oBAAsB,AAC9B,kBAAoB,CACrB,AACD,0DACE,6BAA8B,AACtB,oBAAsB,CAC/B,AACD,8CACE,mBAAoB,AACpB,oBAAqB,AACrB,MAAO,AACP,WAAa,CACd,AACD,2LAEE,wBAAyB,AACzB,4BAA8B,AACtB,mBAAsB,CAC/B,AAGD,iHAEE,qBAAwB,CACzB,AACD,iHAEE,qBAAwB,CACzB,AAKD,gNAEE,qBAAwB,CACzB,AACD,qFAEE,qBAAwB,CACzB,AACD,iIAGE,qBAAwB,CACzB,AACD,+GAEE,UAAY,CACb,AACD,+GAEE,wBAA6B,CAC9B,AAKD,4MAEE,wBAA6B,CAC9B,AACD,mFAEE,wBAA6B,CAC9B,AACD,8HAGE,wBAA6B,CAC9B,AACD,SACE,uBAAwB,AACxB,aAAc,AACd,cAAe,AACf,eAAgB,AAChB,eAAiB,CAClB,AACD,4BACE,qBAAsB,AACtB,OAAQ,AACR,SAAU,AACV,iBAAmB,CACpB,AACD,eACE,eAAiB,CAClB,AACD,iDAEE,eAAiB,CAClB,AACD,4FAIE,YAAc,CACf,AACD,kBACE,YAAa,AACb,gBAAkB,CACnB,AACD,+CAEE,oBAAqB,AACrB,kBAAmB,AACnB,eAAgB,AAChB,aAAe,CAChB,AACD,+DAEE,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,uBACE,eAAiB,CAClB,AACD,wBACE,gBAAkB,CACnB,AACD,kBACE,aAAc,AACd,sBAAuB,AACvB,YAAa,AACb,YAAa,AACb,eAAgB,AAChB,UAAY,CACb,AACD,eACE,mBAAoB,AACpB,oBAAqB,AACrB,YAAa,AACb,cAAe,AACf,uBAAwB,AACxB,eAAgB,AAChB,UAAY,CACb,AACD,sBACE,iBAAmB,CACpB,AACD,eACE,mBAAoB,AACpB,cAAe,AACf,aAAc,AACd,kBAAmB,AACnB,mBAAoB,AACpB,kBAAmB,AACnB,yCAAiD,AACjD,UAAY,CACb,AACD,iDACE,mBAAqB,CACtB,AACD,yHAEE,YAAc,CACf,AACD,wDACE,eAAiB,CAClB,AACD,yCACE,sDAA8D,AACtD,6CAAsD,CAC/D,AAED,sBACE,qBAAwB,CACzB,AACD,mCACE,qBAAwB,CACzB,AACD,qBACE,wBAA6B,CAC9B,AACD,kCACE,wBAA6B,CAC9B,AACD,SACE,eAAgB,AAChB,cAAe,AACf,eAAgB,AAChB,wCAAiD,CAClD,AAGD,yBACE,qBAAwB,CACzB,AACD,wBACE,wBAA6B,CAC9B,AACD,iCACE,gBAAkB,CACnB,AACD,YACE,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,cAAe,AACf,iBAAmB,CACpB,AACD,qBACE,mBAAoB,AACpB,sBAAuB,AACvB,yBAA0B,AAC1B,qBAAsB,AACtB,qBAAsB,AAClB,iBAAkB,AACd,YAAc,CACvB,AAED,wBACE,4BAA+B,CAChC,AACD,uBACE,gCAAqC,CACtC,AACD,WACE,cAAe,AACf,aAAc,AACd,eAAgB,AAChB,SAAY,AACZ,aAAgB,AAChB,aAAc,AACd,sBAAyB,AACzB,kBAAoB,CACrB,AACD,4CACE,iBAAkB,AAClB,2BAA6B,CAC9B,AACD,qBACE,mBAAoB,AACpB,aAAc,AACd,wBAAyB,AACzB,oBAAqB,AACrB,eAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,YAAe,AACf,QAAW,AACX,0BAA4B,CAC7B,AACD,sCACE,eAAgB,AAChB,aAAc,AACd,4BAA8B,CAC/B,AAED,0BACE,qBAAwB,CACzB,AACD,yBACE,wBAA6B,CAC9B,AACD,aACE,mBAAoB,AACpB,aAAc,AACd,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,cAAuB,CACxB,AACD,oBACE,gBAAkB,CACnB,AAGD,qBACE,gBAAiB,AACjB,qBAAwB,CACzB,AACD,uCACE,qBAAwB,CACzB,AACD,8CACE,qBAAwB,CACzB,AACD,yCACE,sBAAwB,AACxB,eAAiB,CAClB,AACD,iJAGE,0BAA6B,CAC9B,AACD,qGAEE,0BAA6B,CAC9B,AAID,uJACE,+BAAmC,CACpC,AACD,oBACE,mBAAoB,AACpB,UAAY,CACb,AACD,sCACE,wBAA6B,CAC9B,AACD,6CACE,wBAA6B,CAC9B,AACD,wCACE,yBAA6B,AAC7B,kBAAoB,CACrB,AACD,8IAGE,8BAAmC,CACpC,AACD,mGAEE,8BAAmC,CACpC,AAID,qJACE,kCAAwC,CACzC,AAID,sFACE,gBAAkB,CACnB,AACD,QACE,qBAAsB,AACtB,cAAmB,AACnB,wCAAiD,CAClD,AACD,YACE,kBAAoB,CACrB,AACD,cACE,mBAAoB,AACpB,cAAe,AACf,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,YAAa,AACb,SAAU,AACV,eAAgB,AAChB,kBAAmB,AACnB,qBAAsB,AACtB,mDAA4D,CAC7D,AACD,oBACE,eAAgB,AAChB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,6CAEE,WAAa,CACd,AACD,8CAEE,mBAAoB,AACpB,gBAAiB,AACjB,uBAAwB,AACxB,yCAAiD,AACjD,UAAY,CACb,AACD,qBACE,YAAa,AACb,iBAAkB,AAClB,kBAAmB,AACnB,eAAiB,CAClB,AACD,yBACE,cAAgB,CACjB,AAMD,4CAJE,aAAc,AACd,2BAA4B,AAC5B,cAAgB,CAOjB,AALD,sBAIE,kBAAoB,CACrB,AACD,6BACE,UAAW,AACX,QAAU,CACX,AACD,mCACE,WAAa,CACd,AACD,uCACE,QAAU,CACX,AACD,mDACE,UAAW,AACX,QAAU,CACX,AACD,+DACE,YAAc,CACf,AACD,kEACE,QAAU,CACX,AACD,2BACE,cAAe,AACf,cAAgB,CACjB,AACD,6BACE,qBAAsB,AACtB,8BAA+B,AAC/B,gBAAiB,AACjB,mBAAoB,AACpB,mBAAoB,AACpB,qBAAuB,CACxB,AACD,uBACE,gBAAiB,AACjB,cAAe,AACf,gBAAiB,AACjB,aAAc,AACd,uBAAwB,AACxB,uBAAwB,AACxB,qBAAuB,CACxB,AAID,4HACE,wBAA0B,CAC3B,AACD,kEACE,aAAe,CAChB,AACD,sBACE,WAAa,CACd,AACD,eACE,gBAAiB,AACjB,kBAAoB,CACrB,AACD,4BACE,eAAgB,AAChB,WAAa,CACd,AACD,2CACE,WAAa,CACd,AACD,6BACE,cAAgB,CACjB,AACD,qCACE,WAAa,CACd,AACD,wDACE,WAAa,CACd,AACD,qCACE,cAAgB,CACjB,AACD,wCACE,cAAgB,CACjB,AACD,kBACE,mBAAqB,CACtB,AACD,gCACE,WAAa,CACd,AACD,8CACE,WAAa,CACd,AACD,kCACE,WAAa,CACd,AACD,0CACE,gBAAkB,CACnB,AACD,6CACE,mBAAqB,AACrB,qBAAsB,AACtB,mBAAqB,CACtB,AACD,gDACE,WAAa,CACd,AACD,8BACE,KAAO,CACR,AACD,oDACE,gBAAkB,CACnB,AACD,eACE,UAAW,AACX,kBAAmB,AACnB,kBAAoB,CACrB,AACD,2CAEE,WAAY,AACZ,WAAY,AACZ,OAAQ,AACR,kBAAmB,AACnB,yCAAiD,AACjD,UAAY,CACb,AACD,6CACE,YAAc,CACf,AACD,uBACE,mBAAoB,AACpB,eAAgB,AAChB,aAAc,AACd,oBAAsB,CACvB,AACD,8GACE,cAAe,AACf,eAAiB,CAClB,AACD,uHAEE,eAAgB,AAChB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,kCACE,mBAAoB,AACpB,YAAc,CACf,AACD,oDACE,cAAgB,CACjB,AACD,uEACE,mBAAoB,AACpB,gBAAkB,CACnB,AACD,4DACE,aAAc,AACd,2BAA4B,AAC5B,cAAgB,CACjB,AACD,2EACE,kCAAmC,AAC3B,yBAA2B,CACpC,AACD,4EACE,aAAe,CAChB,AACD,6GACE,kCAAmC,AAC3B,yBAA2B,CACpC,AACD,sBACE,kBAAmB,AACnB,UAAW,AACX,kBAAoB,CACrB,AACD,0BACE,aAAe,CAChB,AACD,+CACE,iBAAmB,CACpB,AACD,yBACE,mBAAqB,CACtB,AACD,mBACE,aAAe,CAChB,AAED,UACE,mBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,uBAAwB,AACxB,kBAAmB,AACnB,kBAAmB,AACnB,qBAAuB,CACxB,AACD,mDAGE,kBAAmB,AACnB,oBAAqB,AACrB,eAAgB,AAChB,aAAe,CAChB,AAID,qFAGE,eAAiB,CAClB,AAGD,wBACE,qBAAwB,CACzB,AACD,uBACE,wBAA6B,CAC9B,AACD,WACE,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CAChB,AAED,mBACE,uBAAwB,AACxB,cAAe,AACf,gBAAiB,AACjB,WAAY,AACZ,iBAAmB,CACpB,AACD,wBACE,WAAY,AAEZ,kBAAmB,AAEnB,SAAW,CACZ,AACD,6DALE,eAAgB,AAEhB,sCAA8C,CAM/C,AACD,2FAEE,eAAgB,AAChB,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,SAAU,AACV,uBAAyB,AACzB,WAAY,AACZ,wBAA0B,CAC3B,AACD,qDACE,gCAAiC,AACzB,wBAAyB,AACjC,gCAAiC,AACzB,wBAAyB,AACjC,2CAA4C,AACpC,kCAAoC,CAC7C,AACD,sDACE,sCAAuC,AAC/B,8BAA+B,AACvC,gCAAiC,AACzB,wBAAyB,AACjC,2CAA4C,AACpC,kCAAoC,CAC7C,AACD,+BACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,SAAU,AACV,sBAAyB,CAC1B,AACD,4BACE,WAAY,AACZ,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,SAAW,CACZ,AACD,+EACE,wBAAyB,AACjB,gBAAiB,AACzB,8BAA+B,AACvB,sBAAuB,AAC/B,2CAA4C,AACpC,kCAAoC,CAC7C,AACD,gFACE,8BAA+B,AACvB,sBAAuB,AAC/B,8BAA+B,AACvB,sBAAuB,AAC/B,2CAA4C,AACpC,kCAAoC,CAC7C,AACD,iCACE,GACE,UAAW,AACX,UAAY,CACb,AACD,IACE,UAAW,AACX,UAAY,CACb,AACD,GACE,UAAW,AACX,UAAY,CACb,CACF,AACD,yBACE,GACE,UAAW,AACX,UAAY,CACb,AACD,IACE,UAAW,AACX,UAAY,CACb,AACD,GACE,UAAW,AACX,UAAY,CACb,CACF,AACD,uCACE,GACE,WAAY,AACZ,UAAY,CACb,AACD,IACE,UAAW,AACX,SAAW,CACZ,AACD,GACE,UAAW,AACX,SAAW,CACZ,CACF,AACD,+BACE,GACE,WAAY,AACZ,UAAY,CACb,AACD,IACE,UAAW,AACX,SAAW,CACZ,AACD,GACE,UAAW,AACX,SAAW,CACZ,CACF,AACD,yBACE,GACE,WAAY,AACZ,SAAW,CACZ,AACD,IACE,WAAY,AACZ,SAAW,CACZ,AACD,GACE,WAAY,AACZ,SAAW,CACZ,CACF,AACD,iBACE,GACE,WAAY,AACZ,SAAW,CACZ,AACD,IACE,WAAY,AACZ,SAAW,CACZ,AACD,GACE,WAAY,AACZ,SAAW,CACZ,CACF,AACD,+BACE,GACE,YAAa,AACb,SAAW,CACZ,AACD,IACE,WAAY,AACZ,QAAU,CACX,AACD,GACE,WAAY,AACZ,QAAU,CACX,CACF,AACD,uBACE,GACE,YAAa,AACb,SAAW,CACZ,AACD,IACE,WAAY,AACZ,QAAU,CACX,AACD,GACE,WAAY,AACZ,QAAU,CACX,CACF,AAED,qCACE,WAAe,AACf,UAAY,CACb,AACD,uDACE,WAAe,AACf,SAAW,CACZ,AACD,qEACE,WAAY,AACZ,SAAc,CACf,AACD,oDACE,YAAa,AACb,SAAc,CACf,AACD,SACE,qBAAsB,AACtB,iBAAmB,CACpB,AACD,gBACE,WAAY,AACZ,aAAc,AACd,kBAAmB,AACnB,eAAgB,AAChB,UAAW,AACX,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,WAAY,AACZ,uBAAwB,AACxB,mBAAoB,AACpB,mBAAoB,AACpB,eAAgB,AAChB,wCAAiD,CAClD,AACD,wBACE,cAAgB,CACjB,AACD,kCACE,SAAU,AACV,UAAY,CACb,AACD,gDACE,UAAW,AACX,UAAe,CAChB,AACD,kDACE,YAAa,AACb,QAAa,CACd,AACD,+BACE,UAAY,CACb,AACD,iCACE,aAAc,AACd,QAAa,CACd,AAED,2BACE,qBAAuB,CACxB,AACD,sDACE,+BAAmC,CACpC,AACD,0BACE,wBAA0B,CAC3B,AACD,qDACE,kCAAwC,CACzC,AACD,2BACE,SAAU,AACV,0CAA4C,AAC5C,aAAc,AACd,OAAQ,AACR,uBAAwB,AACxB,mCAAsC,AAC9B,2BAA8B,AACtC,6CAAqD,AACrD,UAAY,CACb,AACD,qCACE,iBAAmB,CACpB,AACD,mCACE,+BAAmC,AAC3B,sBAA2B,CACpC,AACD,kCACE,eAAgB,AAChB,SAAW,CACZ,AACD,kCACE,iCAAmC,AACnC,gBAAiB,AACjB,0BAA4B,AAC5B,gBAAiB,AACjB,YAAa,AACb,SAAU,AACV,gBAAiB,AACjB,eAAgB,AAChB,sBAAuB,AACvB,oBAAqB,AACrB,WAAY,AACZ,aAAe,CAChB,AACD,kDACE,8BAA+B,AAC/B,eAAgB,AAChB,mBAAoB,AACpB,qBAAuB,CACxB,AACD,2DACE,cAAe,AACf,kBAAmB,AACnB,4CAAqD,CACtD,AACD,uDACE,aAAe,CAChB,AACD,0CACE,eAAiB,CAClB,AACD,iDACE,4BAA8B,CAC/B,AACD,0DACE,cAAgB,CACjB,AACD,kEACE,uBAAwB,AAChB,cAAgB,CACzB,AACD,kDACE,cAAgB,CACjB,AACD,yCACE,mBAAqB,AACrB,eAAgB,AAChB,cAAgB,CACjB,AACD,iDACE,eAAgB,AAChB,eAAiB,CAClB,AACD,wEACE,2CAAiD,AACzC,kCAAyC,CAClD,AACD,mFACE,iBAAmB,CACpB,AAED,cACE,cAAe,AACf,kBAAmB,AACnB,wCAAiD,CAClD,AACD,gBACE,eAAgB,AAChB,aAAe,CAChB,AAED,yBACE,oBAAqB,AACrB,gBAAiB,AACjB,cAAe,AACf,SAAU,AACV,eAAgB,AAChB,iBAAkB,AAClB,yCAAkD,CACnD,AACD,+CACE,cAAe,AACf,WAAa,CACd,AACD,yCACE,+CACE,cAAgB,CACjB,CACF,AAED,UACE,0GAAsH,AACtH,kBAAmB,AACnB,YAAa,AACb,gBAAiB,AACjB,oBAAqB,AACrB,0CAAkD,AAClD,WAAY,AACZ,eAAiB,CAClB,AACD,mBACE,mBAAoB,AACpB,aAAc,AACd,YAAa,AACb,uBAAwB,AACxB,OAAQ,AACR,oBAAqB,AACrB,eAAgB,AAChB,MAAO,AACP,0CAAkD,AAClD,WAAY,AACZ,UAAW,AACX,YAAc,CACf,AACD,qCACE,cAAgB,CACjB,AAID,4CACE,cAAgB,CACjB,AACD,qBACE,qBAAsB,AACtB,qBAAuB,CACxB,AACD,oBACE,gCAAkC,AAC1B,wBAA0B,AAClC,sCAAuC,AAC/B,8BAA+B,AACvC,6DAAoE,AAC5D,oDAA4D,CACrE,AACD,sBACE,gBAAiB,AACjB,SAAU,AACV,YAAa,AACb,eAAgB,AAChB,gBAAiB,AACjB,MAAO,AACP,MAAQ,CACT,AACD,8BACE,gBAAiB,AACjB,eAAgB,AAChB,mBAAqB,AACrB,mBAAsB,CACvB,AACD,iDAEE,YAAc,CACf,AACD,iEAEE,aAAc,AACd,cAAe,AACf,eAAgB,AAChB,qBAAuB,CACxB,AACD,kMAIE,aAAe,CAChB,AACD,6FAEE,gBAAiB,AACjB,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,kCACE,GACE,2BAA4B,AACpB,kBAAoB,CAC7B,AACD,IACE,8BAA+B,AACvB,qBAAuB,CAChC,AACD,GACE,2BAA4B,AACpB,kBAAoB,CAC7B,CACF,AACD,0BACE,GACE,2BAA4B,AACpB,kBAAoB,CAC7B,AACD,IACE,8BAA+B,AACvB,qBAAuB,CAChC,AACD,GACE,2BAA4B,AACpB,kBAAoB,CAC7B,CACF,AAED,WACE,eAAgB,AAChB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,oBAAqB,AACrB,yCAAiD,AACjD,SAAW,CACZ,AACD,qBACE,iBAAmB,CACpB,AACD,kBACE,yBAA0B,AAC1B,SAAU,AACV,WAAY,AACZ,YAAa,AACb,OAAQ,AACR,UAAW,AACX,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,mBAAoB,AACpB,sBAAwB,AACxB,UAAY,CACb,AACD,mBACE,oBAAqB,AACrB,iBAAmB,CACpB,AACD,0BACE,WAAc,CACf,AAED,+GAEE,qBAAwB,CACzB,AACD,6GAEE,wBAA6B,CAC9B,AACD,eACE,mBAAoB,AACpB,aAAc,AACd,eAAgB,AAChB,cAAe,AACf,qBAAsB,AACtB,SAAU,AACV,iBAAmB,CACpB,AACD,kBACE,mBAAoB,AACpB,oBAAqB,AACrB,cAAgB,CACjB,AACD,0BACE,cAAgB,CACjB,AACD,gCACE,cAAgB,CACjB,AAID,0DACE,cAAgB,CACjB,AACD,qBACE,mBAAoB,AACpB,oBAAqB,AACrB,qBAAsB,AACtB,wCAAiD,CAClD,AACD,+BACE,mBAAqB,CACtB,AAED,qBAEE,sBAAuB,AAEvB,WAAY,AACZ,YAAa,AAIb,UAAW,AAEX,cAAgB,CACjB,AACD,0CAZE,cAAe,AAEf,kBAAmB,AAGnB,OAAQ,AACR,MAAO,AACP,gBAAiB,AAEjB,mBAAqB,CActB,AAXD,qBAKE,kBAAmB,AACnB,wBAAyB,AACzB,UAAW,AAGX,6BAAgC,CACjC,AACD,4BACE,eAAiB,CAClB,AACD,yBACE,8FAA4G,AAC5G,sFAAoG,AACpG,oIAA0J,CAC3J,AACD,0BACE,8CAAsD,CACvD,AACD,oBACE,qBAAwB,CACzB,AAID,oIAEE,+BAAmC,CACpC,AACD,6FACE,0CAA8C,CAC/C,AACD,wDACE,wBAA0B,CAC3B,AACD,mBACE,UAAY,CACb,AAID,iIAEE,kCAAwC,CACzC,AACD,4FACE,8CAAoD,CACrD,AACD,uDACE,wBAA0B,CAC3B,AAED,OACE,mBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,YAAa,AACb,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,uBAAwB,AACxB,eAAgB,AAChB,eAAgB,AAChB,UAAW,AACX,yBAA0B,AAC1B,qBAAsB,AACtB,mDAA4D,AAC5D,kBAAmB,AACnB,sBAAuB,AACvB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AAED,cACE,sBAAuB,AACvB,cAAe,AACf,WAAY,AACZ,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,YAAa,AACb,YAAc,AACd,yCAAiD,AACjD,UAAY,CACb,AAED,OACE,cAAgB,CACjB,AACD,yCAGE,iBAAmB,CACpB,AACD,8DAGE,6BAA+B,CAChC,AACD,gBACE,mBAAoB,AACpB,sBAAuB,AACvB,cAAe,AACf,aAAc,AACd,cAAe,AACf,uBAAwB,AACxB,cAAe,AACf,kBAAmB,AACnB,yCAAiD,AACjD,mBAAoB,AACpB,aAAe,CAChB,AAED,cACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,cACE,eAAgB,AAChB,YAAa,AACb,cAAgB,CACjB,AAED,+BACE,aAAe,CAChB,AAED,gDACE,uBAAwB,AACxB,gGAAiH,CAClH,AACD,uDACE,sGAAmH,CACpH,AACD,aACE,uBAAwB,AACxB,0BAA4B,AAC5B,kBAAmB,AACnB,uBAAwB,AACxB,YAAa,AACb,UAAY,CACb,AACD,0BACE,UAAY,CACb,AACD,0BACE,UAAY,CACb,AAID,qCAFE,iBAAmB,CAQpB,AAND,iBAEE,YAAa,AACb,YAAa,AACb,WAAY,AACZ,SAAW,CACZ,AACD,+DAEE,SAAW,CACZ,AACD,0DACE,kGAAmH,CACpH,AACD,iEACE,uGAAoH,CACrH,AACD,iCACE,cAAe,AACf,SAAU,AACV,WAAa,CACd,AACD,uBACE,iBAAmB,CACpB,AACD,mDACE,wCAAiD,CAClD,AACD,+DACE,SAAW,CACZ,AACD,8DACE,UAAW,AACX,iCAAkC,AAC1B,wBAA0B,CACnC,AACD,6HAEE,mCAAoC,AACpC,kBAAmB,AACnB,OAAQ,AACR,KAAO,CACR,AACD,6EACE,UAAW,AACX,gCAAiC,AACzB,uBAAyB,CAClC,AACD,4EACE,UAAW,AACX,4BAA6B,AACrB,mBAAqB,CAC9B,AACD,yBACE,eAAgB,AAChB,aAAe,CAChB,AACD,8BACE,YAAa,AACb,UAAY,CACb,AACD,sCACE,cAAgB,CACjB,AACD,8BACE,YAAa,AACb,UAAY,CACb,AACD,sCACE,cAAgB,CACjB,AACD,gCACE,0BAA4B,CAC7B,AACD,8CACE,6BAA+B,CAChC,AACD,+BAEE,QAAU,CACX,AACD,uBACE,iBAAmB,CACpB,AACD,oBACE,cAAgB,CACjB,AACD,kCACE,QAAU,CACX,AACD,4BACE,SAAW,CACZ,AACD,yCACE,SAAW,CACZ,AACD,yCACE,SAAW,CACZ,AACD,qCACE,WAAa,CACd,AACD,+BACE,YAAc,CACf,AACD,4CACE,YAAc,CACf,AACD,4CACE,YAAc,CACf,AACD,aACE,SAAW,CACZ,AACD,cACE,UAAY,CACb,AAED,uBACE,0BAA4B,AAC5B,mBAAqB,CACtB,AACD,6FACE,eAAiB,CAClB,AACD,aACE,SAAW,CACZ,AAED,eACE,mBAAqB,CACtB,AACD,+BACE,SAAW,CACZ,AACD,gBACE,mBAAoB,AACpB,aAAc,AACd,YAAa,AACb,uBAAwB,AACxB,OAAQ,AACR,kBAAmB,AACnB,MAAO,AACP,UAAY,CACb,AACD,8BACE,kBAAmB,AACnB,mBAAqB,CACtB,AACD,+BACE,iBAAkB,AAClB,mBAAqB,CACtB,AAED,sBACE,8BAA+B,AAC/B,iCAAmC,AACnC,eAAiB,CAClB,AACD,4BACE,eAAiB,CAClB,AACD,cACE,aAAc,AACd,OAAQ,AACR,aAAc,AACd,UAAY,CACb,AAID,kCACE,kBAAoB,CACrB,AAED,wPAOE,UAAY,CACb,AACD,oBACE,oBACE,4BAA8B,CAC/B,CACF,AAED,qBACE,kBAAmB,AACnB,oBAAqB,AACrB,qBAAuB,CACxB,AACD,yBACE,WAAY,AACZ,YAAa,AACb,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,SAAU,AACV,OAAQ,AACR,QAAS,AACT,SAAW,CACZ,AACD,wCACE,gEAAiE,AACzD,wDAAyD,AACjE,uCAAwC,AAChC,+BAAgC,AACxC,8BAAiC,CAClC,AACD,kEACE,mEAAoE,AAC5D,2DAA4D,AACpE,qBAAsB,AACtB,wBAA0B,AAC1B,qBAAuB,CACxB,AACD,+BACE,sBAAwB,AACxB,SAAW,CACZ,AACD,8BACE,oBAAqB,AACrB,UAAW,AACX,8BAAiC,CAClC,AACD,2BACE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,uCAAyC,AACjC,8BAAiC,CAC1C,AACD,0CACE,GACE,uBAAyB,AACzB,qBAAuB,CACxB,AACD,IACE,yBAA2B,AAC3B,uBAAyB,CAC1B,AACD,GACE,yBAA2B,AAC3B,wBAA0B,CAC3B,CACF,AACD,kCACE,GACE,uBAAyB,AACzB,qBAAuB,CACxB,AACD,IACE,yBAA2B,AAC3B,uBAAyB,CAC1B,AACD,GACE,yBAA2B,AAC3B,wBAA0B,CAC3B,CACF,AACD,4CACE,GACE,gCAAkC,AAC1B,uBAA0B,CACnC,CACF,AACD,oCACE,GACE,gCAAkC,AAC1B,uBAA0B,CACnC,CACF,AAGD,2BACE,eAAiB,CAClB,AACD,kCACE,qBAAwB,CACzB,AACD,gGACE,kCAAqC,CACtC,AACD,0BACE,kBAAoB,CACrB,AACD,iCACE,UAAY,CACb,AACD,+FACE,qCAA0C,CAC3C,AACD,cACE,oBAAqB,AACrB,kBAAmB,AACnB,yCAAiD,AACjD,iCAAoC,CACrC,AACD,qBACE,uBAAwB,AACxB,eAAgB,AAChB,WAAY,AACZ,cAAe,AACf,SAAU,AACV,WAAa,AACb,eAAiB,CAClB,AACD,sCACE,kCAAoC,CACrC,AACD,2BACE,YAAc,CACf,AACD,mCACE,SAAW,CACZ,AACD,kCACE,iBAAmB,AACnB,gBAAkB,CACnB,AACD,iCACE,yBAA2B,CAC5B,AACD,gCACE,yBAA2B,CAC5B,AACD,wBACE,gGAAiH,CAClH,AAED,gCACE,qBAAuB,CACxB,AACD,iEACE,+BAAgC,AAChC,UAAY,CACb,AACD,wEACE,qBAAwB,CACzB,AACD,2EACE,wBAA0B,CAC3B,AACD,wDACE,+BAAgC,AAChC,gCAAiC,AACjC,UAAY,CACb,AACD,kEACE,wBAA0B,CAC3B,AACD,+BACE,wBAA0B,CAC3B,AACD,gEACE,+BAAgC,AAChC,UAAY,CACb,AACD,uEACE,wBAA6B,CAC9B,AACD,0EACE,wBAA0B,CAC3B,AACD,uDACE,+BAAgC,AAChC,gCAAiC,AACjC,UAAY,CACb,AACD,iEACE,wBAA0B,CAC3B,AACD,mBACE,WAAY,AACZ,YAAa,AACb,aAAc,AACd,qBAAuB,CACxB,AACD,yBACE,YAAc,CAKf,AACD,0DALE,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAU3B,AARD,iCACE,cAAe,AAKf,cAAyB,AACzB,cAAgB,CACjB,AACD,yBACE,aAAc,AACd,MAAQ,CACT,AACD,wBACE,OAAQ,AACR,QAAS,AACT,gBAAiB,AACjB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,kBAAmB,AACnB,oBAA0B,CAC3B,AACD,gEACE,6BAA+B,CAChC,AACD,gEACE,kBAAoB,CACrB,AACD,8BACE,kBAAmB,AACnB,qBAAsB,AACtB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,OAAQ,AACR,MAAO,AACP,mBAAoB,AACpB,WAAY,AACZ,YAAa,AACb,gBAAkB,CACnB,AACD,oCACE,yBAA2B,CAC5B,AACD,8BACE,kBAAmB,AACnB,qBAAsB,AACtB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,gBAAiB,AACjB,MAAO,AACP,UAAW,AACX,YAAa,AACb,gBAAkB,CACnB,AAED,+BACE,qBAAuB,CACxB,AACD,iEACE,8BAAgC,CACjC,AACD,0DACE,+BAAgC,AAChC,gCAAiC,AACjC,UAAY,CACb,AACD,kMAEE,qBAAwB,CACzB,AACD,iEACE,8BAAgC,CACjC,AACD,kGACE,aAAe,CAChB,AACD,sDACE,+BAAgC,AAChC,+BAAiC,CAClC,AACD,+DACE,4BAA8B,CAC/B,AACD,2EACE,yBAA4B,CAC7B,AACD,8BACE,wBAA0B,CAC3B,AACD,gEACE,8BAAgC,CACjC,AACD,yDACE,+BAAgC,AAChC,gCAAiC,AACjC,UAAY,CACb,AACD,gMAEE,wBAA6B,CAC9B,AACD,gEACE,8BAAgC,CACjC,AACD,iGACE,UAAY,CACb,AACD,qDACE,+BAAgC,AAChC,+BAAiC,CAClC,AACD,8DACE,4BAA8B,CAC/B,AACD,0EACE,yBAA4B,CAC7B,AACD,kBACE,aAAc,AACd,sBAAuB,AACvB,gBAAiB,AACjB,WAAa,CACd,AACD,wBACE,UAAW,AACX,YAAc,CACf,AACD,kCACE,UAAW,AACX,UAAY,CACb,AACD,2BACE,cAAe,AACf,OAAS,CACV,AACD,+BAKE,wBAAyB,AACzB,cAAgB,CACjB,AACD,gEAPE,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAa3B,AATD,iCAKE,eAAgB,AAChB,sBAAyB,AACzB,iBAAkB,AAClB,cAAgB,CACjB,AACD,uCACE,yBAA2B,CAC5B,AACD,wBACE,aAAc,AACd,gBAAiB,AACjB,aAAc,AACd,kBAAmB,AACnB,qBAAuB,CACxB,AACD,+BACE,kBAAmB,AACnB,cAAe,AACf,aAAc,AACd,sBAAwB,CACzB,AACD,wBACE,WAAY,AACZ,kBAAmB,AACnB,UAAW,AACX,aAAc,AACd,sBAAwB,CACzB,AACD,iCACE,aAAc,AACd,OAAQ,AACR,WAAY,AACZ,WAAa,CACd,AACD,kCACE,UAAW,AACX,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,UAAY,CACb,AACD,4BACE,kBAAmB,AACnB,kBAAoB,CACrB,AACD,iCACE,cAAe,AACf,kBAAmB,AACnB,SAAU,AACV,cAAgB,CACjB,AACD,uBACE,OAAQ,AACR,QAAS,AACT,iBAAmB,CACpB,AAGD,sBACE,sBAAuB,AACvB,kBAAmB,AACnB,qBAAwB,CACzB,AACD,qBACE,yBAA0B,AAC1B,qBAAsB,AACtB,UAAY,CACb,AACD,SACE,cAAe,AACf,kBAAmB,AACnB,kBAAmB,AACnB,wCAAiD,CAClD,AACD,eACE,eAAiB,CAClB,AAED,SACE,SAAW,CACZ,AACD,sCAEE,WAAY,AACZ,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,WAAY,AACZ,WAAa,CACd,AACD,gBACE,2BAA6B,CAC9B,AACD,yBACE,yBAA0B,AAClB,gBAAkB,CAC3B,AACD,yBACE,uBAAyB,CAC1B,AACD,uBACE,qBAAuB,CACxB,AAED,cACE,kBAAmB,AACnB,gBAAiB,AACjB,cAAe,AACf,YAAc,CACf,AACD,uBACE,YAAc,CACf,AACD,qBACE,wDAAgE,AAChE,YAAc,CACf,AAED,uCACE,UAAW,AACX,SAAW,CACZ,AACD,uCACE,SAAU,AACV,UAAY,CACb,AACD,YACE,WAAY,AACZ,kBAAmB,AACnB,gBAAiB,AACjB,gGAAiH,CAClH,AACD,oCAEE,kBAAmB,AACnB,QAAS,AACT,UAAW,AACX,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,kDAEE,SAAU,AACV,YAAa,AACb,UAAY,CACb,AACD,sDAEE,cAAgB,CACjB,AACD,8DAEE,eAAiB,CAClB,AACD,kBACE,QAAU,CACX,AACD,kBACE,SAAW,CACZ,AACD,sBACE,0BAA4B,AAC5B,mBAAoB,AACpB,SAAU,AACV,aAAc,AACd,uBAAwB,AACxB,OAAQ,AACR,kBAAmB,AACnB,YAAa,AACb,qBAAsB,AACtB,WAAY,AACZ,SAAW,CACZ,AACD,oCACE,aAAe,CAChB,AACD,4BACE,sBAAyB,CAC1B,AACD,oCACE,WAAa,AACb,wCAAiD,CAClD,AACD,4CACE,UAAW,AACX,qBAAuB,CACxB,AACD,kCACE,eAAiB,CAClB,AACD,0CACE,UAAa,CACd,AAED,qBACE,kBAAmB,AACnB,wCAAiD,CAClD,AACD,gCACE,eAAiB,CAClB,AACD,gUAQE,wCAAiD,CAClD,AACD,oRAQE,4BAA8B,AAC9B,MAAO,AACP,UAAY,CACb,AACD,6BACE,mCAAoC,AAC5B,0BAA4B,CACrC,AAKD,qEACE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,wCACE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,6BACE,mCAAoC,AAC5B,0BAA4B,CACrC,AAKD,qEACE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,wCACE,mCAAoC,AAC5B,0BAA4B,CACrC,AAED,wDACE,qBAAwB,CACzB,AAID,uMACE,+BAAmC,CACpC,AACD,uDACE,wBAA6B,CAC9B,AAID,qMACE,kCAAwC,CACzC,AAED,0BACE,aAAc,AACd,yBAA0B,AAC1B,mBAAoB,AACpB,eAAgB,AAChB,sBAAwB,CACzB,AACD,iCACE,aAAe,CAChB,AACD,8CACE,gBAAkB,CACnB,AACD,0CACE,aAAc,AACd,mBAAoB,AACpB,eAAiB,CAClB,AACD,sCACE,cAAe,AACf,kBAAmB,AACnB,oBAAsB,CACvB,AACD,kCACE,aAAc,AACd,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,kBAAoB,CACrB,AACD,4CACE,WAAY,AACZ,wBAAyB,AACzB,UAAW,AACX,eAAkB,CACnB,AACD,wDACE,gBAAkB,CACnB,AACD,oFACE,cAAgB,CACjB,AAED,yGAEE,0CAA8C,CAC/C,AACD,qJAEE,sCAAyC,CAC1C,AACD,4SAIE,qCAAwC,CACzC,AACD,uLAGE,eAAiB,CAClB,AACD,uGAEE,8CAAoD,CACrD,AACD,mJAEE,sCAAyC,CAC1C,AACD,wSAIE,yCAA8C,CAC/C,AACD,oLAGE,kBAAoB,CACrB,AACD,gBACE,gBAAiB,AACjB,aAAe,CAChB,AACD,gFACE,cAAgB,CACjB,AACD,gCACE,WAAa,CACd,AACD,sCACE,iBAAkB,AAClB,cAAgB,CACjB,AACD,wDACE,gBAAkB,CACnB,AACD,+BACE,wCAAiD,CAClD,AACD,qCACE,YAAc,CACf,AACD,yBACE,iBAAkB,AAClB,oBAAsB,CACvB,AACD,uCACE,WAAY,AACZ,YAAa,AACb,gBAAiB,AACjB,mBAAoB,AACpB,aAAc,AACd,UAAW,AACX,aAAe,CAChB,AACD,+EAEE,gBAAiB,AACjB,kBAAoB,CACrB,AACD,yCACE,WAAY,AACZ,SAAU,AACV,WAAY,AACZ,OAAQ,AACR,kBAAmB,AACnB,yCAAiD,AACjD,UAAY,CACb,AACD,2GAEE,gGAAiH,CAClH,AACD,sCACE,OAAW,CACZ,AACD,iDACE,gBAAkB,CACnB,AACD,wDACE,gBAAiB,AACjB,SAAU,AACV,mBAAoB,AACpB,YAAa,AACb,UAAY,CACb,AACD,iEACE,qBAAuB,CACxB,AACD,wEACE,4BAA8B,CAC/B,AACD,gDACE,WAAa,CACd,AACD,oGAEE,cAAgB,CACjB,AAGD,sBACE,sBAAuB,AACvB,qBAAwB,CACzB,AACD,2CACE,uCAA0C,CAC3C,AACD,+BACE,qBAAwB,CACzB,AACD,iDACE,oCAAuC,CACxC,AACD,uCACE,kBAAoB,CACrB,AACD,mEACE,eAAiB,CAClB,AACD,+BACE,oCAAuC,CACxC,AACD,qBACE,yBAA0B,AAC1B,UAAY,CACb,AACD,0CACE,2CAAgD,CACjD,AACD,8BACE,wBAA6B,CAC9B,AACD,gDACE,wCAA6C,CAC9C,AACD,sCACE,kBAAoB,CACrB,AACD,kEACE,kBAAoB,CACrB,AACD,8BACE,wCAA6C,CAC9C,AACD,mBACE,WAAY,AACZ,gBAAiB,AACjB,iBAAmB,CACpB,AACD,cACE,kBAAmB,AACnB,yBAA0B,AAC1B,iBAAkB,AAClB,WAAY,AACZ,cAAgB,CACjB,AACD,gTAQE,cAAgB,CACjB,AACD,uBACE,WAAa,CACd,AACD,uBACE,gBAAiB,AACjB,eAAgB,AAChB,yCAAiD,AACjD,mBAAoB,AACpB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,gCACE,mBAAqB,CACtB,AACD,2BACE,UAAY,CACb,AACD,uBACE,oDAA4D,AAC5D,sBAAwB,CACzB,AACD,8CAEE,WAAa,CACd,AACD,uBACE,gBAAiB,AACjB,cAAgB,CACjB,AACD,+CACE,SAAW,CACZ,AACD,qEACE,YAAc,CACf,AACD,gEACE,SAAU,AACV,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,iGACE,SAAU,AACV,uCAAyC,AACjC,8BAAiC,CAC1C,AACD,uBACE,WAAa,CACd,AACD,0BACE,cAAgB,CACjB,AAGD,2DACE,qBAAwB,CACzB,AAOD,qLACE,qBAAwB,CACzB,AACD,gDACE,sBAAuB,AACvB,sBAAwB,AACxB,oCAAuC,CACxC,AACD,6DACE,+BAAiC,CAClC,AACD,0DACE,wBAA6B,CAC9B,AAOD,kLACE,UAAY,CACb,AACD,+CACE,yBAA0B,AAC1B,yBAA6B,AAC7B,wCAA6C,CAC9C,AACD,4DACE,+BAAiC,CAClC,AACD,0CACE,SAAU,AACV,SAAW,CACZ,AACD,sCACE,eAAgB,AAChB,SAAW,CACZ,AACD,8CACE,eAAgB,AAChB,qBAAsB,AACtB,UAAW,AACX,wCAAiD,CAClD,AACD,wGAEE,UAAa,CACd,AACD,6CACE,uBAAwB,AAChB,cAAgB,CACzB,AACD,qDACE,SAAW,CACZ,AACD,0DACE,kCAAmC,AAC3B,yBAA2B,CACpC,AAED,sBACE,aAAc,AACd,yBAA0B,AAC1B,mBAAoB,AACpB,eAAgB,AAChB,sBAAwB,CACzB,AACD,6BACE,aAAe,CAChB,AACD,0CACE,gBAAkB,CACnB,AACD,sCACE,aAAc,AACd,mBAAoB,AACpB,eAAiB,CAClB,AACD,kCACE,cAAe,AACf,kBAAmB,AACnB,oBAAsB,CACvB,AACD,8BACE,aAAc,AACd,mBAAoB,AACpB,yBAA0B,AAC1B,kBAAmB,AACnB,kBAAoB,CACrB,AACD,wCACE,WAAY,AACZ,wBAAyB,AACzB,UAAW,AACX,eAAkB,CACnB,AACD,oDACE,gBAAkB,CACnB,AACD,gFACE,cAAgB,CACjB,AAID,qGAGE,qBAAwB,CACzB,AACD,0BACE,mBAAsB,CACvB,AACD,6CACE,QAAU,CACX,AACD,yBACE,yBAA4B,CAC7B,AACD,yBACE,oBAAsB,AACtB,mBAAuB,AACvB,iBAAmB,CACpB,AACD,mCACE,kBAAoB,CACrB,AACD,6BACE,+CAAwD,CACzD,AACD,mCACE,gBAAiB,AACjB,eAAiB,CAClB,AAED,+BACE,qBAAwB,CACzB,AACD,8BACE,UAAY,CACb,AACD,sCACE,eAAiB,CAClB,AACD,qCACE,kBAAoB,CACrB,AACD,sCACE,eAAiB,CAClB,AACD,qCACE,kBAAoB,CACrB,AACD,gBACE,cAAe,AACf,WAAY,AACZ,WAAa,CACd,AACD,yBACE,cAAgB,CACjB,AACD,yBACE,iBAAkB,AAClB,eAAiB,CAClB,AACD,kBACE,aAAc,AACd,mBAAoB,AACpB,YAAa,AACb,oBAAsB,CACvB,AACD,oBACE,UAAY,CACb,AACD,mCACE,WAAa,CACd,AAED,gEACE,gBAAkB,CACnB,AACD,qBACE,aAAc,AACd,8BAA+B,AAC/B,sBAAuB,AACvB,eAAgB,AAChB,aAAe,CAChB,AACD,2BACE,mBAAoB,AACpB,oBAAqB,AACrB,eAAgB,AAChB,gBAAiB,AACjB,iBAAmB,CACpB,AACD,2BACE,eAAgB,AAChB,gBAAiB,AACjB,gBAAiB,AACjB,kBAAmB,AACnB,gBAAiB,AACjB,mBAAoB,AACpB,kBAAoB,CACrB,AACD,+BACE,iBAAmB,CACpB,AACD,+BACE,mBAAqB,CACtB,AAED,2IACE,qBAAwB,CACzB,AACD,iFACE,qBAAwB,CACzB,AACD,0IACE,UAAY,CACb,AACD,gFACE,wBAA6B,CAC9B,AACD,sBACE,iBAAkB,AAClB,mBAAoB,AACpB,aAAc,AACd,8BAA+B,AAC/B,iBAAmB,CACpB,AACD,6BACE,SAAU,AACV,YAAc,CACf,AACD,8BACE,eAAgB,AAChB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,6BACE,OAAQ,AACR,kBAAmB,AACnB,kBAAmB,AACnB,eAAiB,CAClB,AACD,iCACE,yCAAiD,AACjD,UAAY,CACb,AACD,oCACE,eAAgB,AAChB,gBAAkB,AAClB,aAAc,AACd,cAAgB,AAChB,wCAAiD,CAClD,AACD,gCACE,mBAAqB,CACtB,AAED,wGAEE,qBAAwB,CACzB,AACD,sGAEE,wBAA6B,CAC9B,AACD,qBACE,kBAAmB,AACnB,eAAgB,AAChB,YAAc,CACf,AACD,2BACE,yCAAiD,AACjD,MAAO,AACP,mBAAoB,AACpB,UAAY,CACb,AACD,gDAEE,kBAAmB,AACnB,iBAAmB,CACpB,AACD,wBACE,cAAgB,CACjB,AACD,kCACE,YAAa,AACb,UAAY,CACb,AACD,4BACE,aAAc,AACd,SAAU,AACV,cAAgB,CACjB,AACD,0CACE,UAAY,CACb,AACD,+BACE,iBAAkB,AAClB,YAAa,AACb,sBAAuB,AACvB,iBAAmB,CACpB,AACD,sCACE,cAAe,AACf,gBAAiB,AACjB,eAAgB,AAChB,UAAY,CACb,AACD,8BACE,cAAe,AACf,eAAiB,CAClB,AACD,8BACE,UAAY,CACb,AACD,6BACE,WAAY,AACZ,OAAQ,AACR,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,UAAY,CACb,AACD,iCACE,kBAAmB,AACnB,qBAAsB,AACtB,WAAY,AACZ,aAAc,AACd,SAAW,CACZ,AACD,wDACE,UAAY,CACb,AACD,yDACE,UAAY,CACb,AACD,+BACE,mBAAqB,CACtB,AAED,qBACE,eAAgB,AAChB,gBAAiB,AACjB,aAAc,AACd,qBAAsB,AACtB,cAAe,AACf,UAAW,AACX,iBAAmB,CACpB,AACD,wBACE,eAAgB,AAChB,cAAe,AACf,eAAiB,CAClB,AACD,+BACE,eAAgB,AAChB,gBAAiB,AACjB,cAAgB,CACjB,AACD,8BACE,0BAA6B,CAC9B,AACD,0CACE,YAAc,CACf,AAGD,8BACE,kBAAoB,CACrB,AACD,6BACE,kBAAoB,CACrB,AACD,6BACE,eAAiB,CAClB,AACD,4BACE,kBAAoB,CACrB,AACD,UACE,kBAAmB,AACnB,qBAAsB,AACtB,oBAAqB,AACrB,sBAAuB,AACvB,mBAAoB,AACpB,iBAAmB,CACpB,AACD,sBACE,YAAc,CACf,AACD,iBACE,WAAY,AACZ,2BAA4B,AAC5B,4BAA6B,AAC7B,YAAc,CACf,AACD,sBACE,wCAAiD,CAClD,AACD,yDACE,WAAa,AACb,cAAgB,CACjB,AACD,2EACE,SAAW,CACZ,AACD,gCACE,mBAAqB,CACtB,AACD,8BACE,SAAW,CACZ,AACD,gBACE,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,UAAW,AACX,cAAe,AACf,aAAc,AACd,sBAAuB,AACvB,kBAAoB,CACrB,AACD,oBACE,UAAY,CACb,AACD,iDACE,iBAAmB,CACpB,AACD,sCACE,0BAA2B,AAC3B,6BAA8B,AAC9B,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,YAAa,AACb,SAAW,CACZ,AACD,6EAEE,iBAAmB,CACpB,AAGD,8DACE,qCAAuC,AACvC,sBAAuB,AACvB,qBAAwB,CACzB,AACD,kIACE,qBAAwB,CACzB,AACD,wEACE,qBAAwB,CACzB,AACD,+EACE,qBAAuB,CACxB,AACD,6DACE,yCAA6C,AAC7C,yBAA0B,AAC1B,UAAY,CACb,AACD,iIACE,UAAY,CACb,AACD,uEACE,wBAA6B,CAC9B,AACD,8EACE,wBAA0B,CAC3B,AACD,mBACE,aAAc,AACd,eAAgB,AAChB,uBAAwB,AACxB,qBAAsB,AACtB,UAAW,AACX,gBAAiB,AACjB,WAAY,AACZ,gGAAiH,CAClH,AACD,8BACE,cAAe,AACf,eAAgB,AAChB,aAAc,AACd,wCAAiD,CAClD,AACD,0CACE,yBAA4B,CAC7B,AACD,gFACE,gBAAkB,CACnB,AACD,mEACE,mBAAqB,CACtB,AACD,0GACE,kCAAmC,AAC3B,yBAA2B,CACpC,AACD,2BACE,aAAc,AACd,eAAgB,AAChB,mBAAoB,AACpB,kBAAmB,AACnB,kBAAmB,AACnB,eAAiB,CAClB,AACD,kEACE,aAAe,CAChB,AACD,yBACE,wCAAiD,CAClD,AACD,iCACE,gBAAiB,AACjB,2FAA2H,CAC5H,AACD,qDAEE,iFAAgH,CACjH,AACD,iIAEE,YAAa,AACb,gGAAiH,CAClH,AACD,iHAEE,aAAe,CAChB,AACD,iEACE,cAAgB,CACjB,AACD,gEACE,aAAe,CAChB,AAED,uBACE,mBAAoB,AACpB,qBAAwB,CACzB,AACD,sBACE,mBAAoB,AACpB,UAAY,CACb,AACD,UACE,mBAAoB,AACpB,aAAc,AACd,wBAA0B,AAC1B,gBAAiB,AACjB,sCAA8C,CAC/C,AACD,qCAEE,SAAU,AACV,OAAQ,AACR,WAAY,AACZ,SAAW,CACZ,AACD,iBACE,SAAW,CACZ,AACD,oBACE,iBAAmB,CACpB,AACD,iBACE,cAAgB,CACjB,AAED,mBACE,YAAc,CACf,AACD,iCACE,WAAa,CACd,AACD,sCACE,WAAa,CACd,AACD,4CACE,gBAAkB,CACnB,AAED,WACE,cAAe,AACf,YAAa,AACb,aAAc,AACd,UAAY,CACb,AACD,iBACE,cAAgB,CACjB,AACD,uBACE,mBAAoB,AACpB,YAAc,CACf,AACD,+BACE,YAAa,AACb,aAAe,CAChB,AACD,sCACE,WAAa,CACd,AACD,2CACE,WAAa,CACd,AACD,iDACE,gBAAkB,CACnB,AACD,8DACE,eAAiB,CAClB,AACD,6DACE,kBAAoB,CACrB,AACD,sCACE,WAAa,CACd,AACD,2CACE,WAAa,CACd,AACD,iDACE,gBAAkB,CACnB,AACD,8DACE,eAAiB,CAClB,AACD,6DACE,kBAAoB,CACrB,AACD,sCACE,WAAa,CACd,AACD,2CACE,WAAa,CACd,AACD,iDACE,gBAAkB,CACnB,AACD,8DACE,eAAiB,CAClB,AACD,6DACE,kBAAoB,CACrB,AACD,sCACE,WAAa,CACd,AACD,2CACE,WAAa,CACd,AACD,iDACE,gBAAkB,CACnB,AACD,8DACE,eAAiB,CAClB,AACD,6DACE,kBAAoB,CACrB,AACD,sCACE,YAAc,CACf,AACD,2CACE,YAAc,CACf,AACD,iDACE,iBAAmB,CACpB,AACD,8DACE,gBAAkB,CACnB,AACD,6DACE,mBAAqB,CACtB,AACD,QACE,aAAc,AACd,cAAe,AACf,iBAAkB,AAClB,WAAa,CACd,AACD,YACE,kBAAoB,CACrB,AACD,oBACE,0BAA4B,CAC7B,AACD,eACE,qBAAuB,CACxB,AACD,uBACE,6BAA+B,CAChC,AACD,qBACE,cAAgB,CACjB,AACD,aACE,cAAgB,CACjB,AACD,oBAEE,cAAe,AACf,cAAgB,CACjB,AACD,aACE,sBAAwB,CACzB,AACD,WACE,oBAAsB,CACvB,AACD,cACE,kBAAoB,CACrB,AACD,gBACE,oBAAsB,CACvB,AACD,kBACE,qBAAuB,CACxB,AACD,gBACE,mBAAqB,CACtB,AACD,mBACE,iBAAmB,CACpB,AACD,qBACE,mBAAqB,CACtB,AACD,qBACE,wBAA0B,CAC3B,AACD,mBACE,sBAAwB,CACzB,AACD,sBACE,oBAAsB,CACvB,AACD,6BACE,2BAA6B,CAC9B,AACD,4BACE,0BAA4B,CAC7B,AACD,eACE,0BAA4B,CAC7B,AACD,aACE,wBAA0B,CAC3B,AACD,gBACE,sBAAwB,CACzB,AACD,sBACE,4BAA8B,CAC/B,AACD,uBACE,6BAA+B,CAChC,AACD,oBACE,uBAAyB,CAC1B,AACD,kBACE,qBAAuB,CACxB,AACD,qBACE,mBAAqB,CACtB,AACD,uBACE,qBAAuB,CACxB,AAID,cAFE,qBAAwB,CAKzB,AAHD,MAEE,uBAA0B,CAC3B,AACD,QACE,sBAAwB,AACxB,uBAA0B,CAC3B,AACD,UACE,eAAiB,CAClB,AACD,aACE,WAAa,CACd,AACD,eACE,yBAA4B,CAC7B,AACD,eACE,0BAA6B,CAC9B,AAID,mBAFE,kBAAoB,CAMrB,AAJD,UAEE,gBAAiB,AACjB,sBAAwB,CACzB,AACD,QACE,sBAAyB,CAC1B,AACD,eACE,6BAAgC,CACjC,AACD,2BAEE,uBAA0B,CAC3B,AACD,SACE,uBAA0B,CAC3B,AACD,gBACE,8BAAiC,CAClC,AACD,UACE,wBAA2B,CAC5B,AACD,QACE,sBAAyB,CAC1B,AACD,yCACE,WACE,eAAiB,CAClB,CACF,AACD,0CACE,WACE,gBAAkB,CACnB,CACF,AACD,0CACE,WACE,gBAAkB,CACnB,CACF,AACD,yCACE,WACE,YAAc,CACf,CACF,AACD,qBACE,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,gBAAiB,AACjB,YAAa,AACb,cAAgB,CACjB,AACD,iBACE,QAAU,CACX,AACD,iBACE,aAAgB,CACjB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,gBAAkB,CACnB,CACF,AACD,yBACE,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,gBAAiB,AACjB,YAAa,AACb,cAAgB,CACjB,AACD,iBACE,QAAU,CACX,AACD,iBACE,aAAgB,CACjB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,gBAAkB,CACnB,CACF,AACD,yBACE,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,gBAAiB,AACjB,YAAa,AACb,cAAgB,CACjB,AACD,iBACE,QAAU,CACX,AACD,iBACE,aAAgB,CACjB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,gBAAkB,CACnB,CACF,AACD,0BACE,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,gBAAiB,AACjB,YAAa,AACb,cAAgB,CACjB,AACD,iBACE,QAAU,CACX,AACD,iBACE,aAAgB,CACjB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,gBAAkB,CACnB,CACF,AACD,0BACE,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,UACE,+BAAgC,AAChC,YAAa,AACb,6BAA+B,CAChC,AACD,gBACE,OAAS,CACV,AACD,UACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,gBACE,OAAS,CACV,AACD,UACE,eAAgB,AAChB,YAAa,AACb,aAAe,CAChB,AACD,gBACE,OAAS,CACV,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,8BAA+B,AAC/B,YAAa,AACb,4BAA8B,CAC/B,AACD,iBACE,QAAU,CACX,AACD,WACE,gBAAiB,AACjB,YAAa,AACb,cAAgB,CACjB,AACD,iBACE,QAAU,CACX,AACD,iBACE,aAAgB,CACjB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,iBACE,+BAAiC,CAClC,AACD,iBACE,8BAAgC,CACjC,AACD,iBACE,eAAiB,CAClB,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,8BAAgC,CACjC,AACD,kBACE,gBAAkB,CACnB,CACF,AAED,WACE,gBAAiB,AACjB,aAAc,AACd,cAAe,AACf,cAAgB,CACjB,AACD,6BACE,sCAA8C,CAC/C,AACD,iBACE,cAAe,AACf,eAAgB,AAChB,iBAAmB,CACpB,AAGD,aACE,4BACE,WACE,aAAe,CAChB,CACF,CACF,AAED,gDACE,qBAAwB,CACzB,AACD,+CACE,UAAY,CACb,AACD,aACE,cAAe,AACf,MAAO,AACP,yCAAiD,AACjD,UAAY,CACb,AACD,sBACE,YAAa,AACb,gBAAiB,AACjB,kBAAmB,AACnB,mBAAoB,AACpB,UAAY,CACb,AACD,yBACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,eAAgB,AAChB,kBAAoB,CACrB,AACD,oBACE,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,uCAAyC,AACjC,+BAAiC,AACzC,eAAgB,AAChB,sBAAuB,AACvB,kBAAoB,CACrB,AACD,sBACE,YAAa,AACb,kBAAmB,AACnB,kBAAoB,CACrB,AAED,kCACE,qBAAuB,CACxB,AACD,mGACE,gCAAmC,CACpC,AACD,6CACE,4BAA+B,CAChC,AACD,iCACE,wBAA0B,CAC3B,AACD,kGACE,oCAAyC,CAC1C,AACD,4CACE,gCAAqC,CACtC,AACD,qBACE,gBAAiB,AACjB,cAAe,AACf,OAAQ,AACR,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,oBAAqB,AACrB,MAAO,AACP,sBAAuB,AACvB,UAAW,AACX,gCAAkC,CACnC,AACD,uCACE,uCAA8C,AAG9C,4CAA8C,AAC9C,oCAAsC,AACtC,qDAAyD,CAJ1D,AAMD,6BACE,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,YAAa,AACb,SAAW,CACZ,AACD,sDACE,OAAQ,AACR,UAAe,CAChB,AACD,4BACE,UAAW,AACX,OAAS,CACV,AACD,yDACE,WAAY,AACZ,MAAQ,CACT,AACD,+BACE,iBAAmB,CACpB,AACD,4BACE,cAAgB,CACjB,AACD,qCACE,YAAc,CACf,AACD,mCACE,eAAiB,CAClB,AACD,wEACE,cAAe,AACf,uBAAwB,AACxB,UAAY,CACb,AACD,kHAEE,uBAAwB,AACxB,cAAgB,CACjB,AACD,iHAEE,SAAW,CACZ,AACD,gJAGE,sBAAyB,CAC1B,AACD,gEAEE,SAAW,CACZ,AACD,kIAEE,wGAAqH,CACtH,AACD,6BACE,kBAAoB,CACrB,AACD,2CACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,wEACE,aAAe,CAChB,AACD,0DACE,eAAiB,CAClB,AACD,kEACE,sBAAwB,CACzB,AACD,+DACE,cAAgB,CACjB,AAED,+CACE,gBAAiB,AACjB,WAAY,AACZ,WAAY,AACZ,eAAgB,AAChB,aAAe,CAChB,AACD,uDACE,UAAY,CACb,AACD,qDACE,eAAiB,CAClB,AACD,6DACE,qBAAwB,CACzB,AACD,8CACE,mBAAoB,AACpB,WAAY,AACZ,WAAY,AACZ,eAAgB,AAChB,aAAe,CAChB,AACD,sDACE,UAAY,CACb,AACD,oDACE,kBAAoB,CACrB,AACD,4DACE,UAAY,CACb,AACD,cACE,mBAAoB,AACpB,oBAAqB,AACrB,qBAAsB,AACtB,SAAU,AACV,eAAgB,AAChB,SAAW,CACZ,AACD,iBACE,mBAAoB,AACpB,YAAc,CACf,AACD,oIAGE,iBAAmB,CACpB,AACD,wBACE,oBAAqB,AACrB,UAAa,CACd,AACD,oBACE,iGAAiH,AACjH,kBAAmB,AACnB,eAAgB,AAChB,uBAAwB,AACxB,YAAa,AACb,WAAY,AACZ,aAAe,AACf,qBAAsB,AACtB,qCAA4C,CAC7C,AACD,4BACE,iGAAkH,CACnH,AACD,0BACE,iGAAiH,AACjH,oBAAqB,AACrB,uBAAwB,AACxB,mBAAoB,AACpB,qBAAsB,AACtB,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,iBAAoB,CACrB,AACD,kCACE,eAAgB,AAChB,uCAA8C,AAC9C,qBAAuB,CACxB,AACD,oCACE,WAAa,AACb,mBAAqB,CACtB,AACD,oBACE,aAAe,AACf,oBAAqB,AACrB,qBAAsB,AACtB,uBAAwB,AACxB,YAAa,AACb,UAAY,CACb,AAED,YACE,kBAAmB,AACnB,gBAAiB,AACjB,SAAW,CACZ,AACD,6BACE,kBAAmB,AACnB,MAAO,AACP,OAAQ,AACR,QAAS,AACT,SAAU,AACV,UAAW,AACX,cAAgB,CACjB,AACD,mBACE,kBAAmB,AACnB,SAAU,AACV,SAAU,AACV,eAAgB,AAChB,gBAAiB,AACjB,aAAc,AACd,kCAAsC,AAC9B,0BAA8B,AACtC,sBAAuB,AACvB,iDAAyD,AACzD,SAAW,CACZ,AACD,qBACE,WAAY,AACZ,YAAa,AACb,UAAW,AACX,kBAAmB,AACnB,aAAc,AACd,sBAAuB,AACvB,uBAAwB,AACxB,cAAgB,CACjB,AAED,6BACE,aAAc,AACd,UAAY,CACb,AACD,oEACE,kBAAoB,CACrB,AACD,iEACE,iBAAmB,CACpB,AACD,wDACE,mBAAoB,AACpB,cAAgB,CACjB,AACD,yEACE,iBAAmB,CACpB,AACD,2DACE,qBAAuB,CACxB,AAED,yCACE,qBAAwB,CACzB,AACD,2CACE,+BAAmC,CACpC,AACD,wCACE,wBAA6B,CAC9B,AACD,0CACE,kCAAwC,CACzC,AACD,SACE,mBAAoB,AACpB,aAAc,AACd,YAAa,AACb,kBAAmB,AACnB,YAAc,CACf,AACD,sBACE,mBAAqB,CACtB,AAGD,6GACE,kBAAoB,CACrB,AACD,4GACE,kBAAoB,CACrB,AAED,kEACE,YAAc,CACf,AACD,gGACE,wBAA0B,CAC3B,AAGD,mGAEE,0BAA6B,CAC9B,AACD,gEACE,gCAAmC,CACpC,AACD,+CACE,6BAA+B,AAC/B,qBAAwB,CACzB,AACD,6EACE,0BAA6B,CAC9B,AACD,uEACE,gCAAmC,CACpC,AACD,kGACE,gCAAmC,CACpC,AACD,oEACE,gCAAmC,CACpC,AACD,sFACE,0BAA6B,CAC9B,AACD,0EACE,0BAA6B,CAC9B,AACD,iGAEE,6BAAkC,CACnC,AACD,+DACE,qBAAuB,CACxB,AACD,8CACE,kBAAmB,AACnB,wBAA6B,CAC9B,AACD,4EACE,6BAAkC,CACnC,AACD,sEACE,mCAAwC,CACzC,AACD,iGACE,mCAAwC,CACzC,AACD,mEACE,mCAAwC,CACzC,AACD,qFACE,6BAAkC,CACnC,AACD,yEACE,6BAAkC,CACnC,AACD,+CACE,iBAAkB,AAClB,cAAgB,CACjB,AAED,iBACE,eAAiB,CAClB,AACD,8HACE,WAAa,AACb,2BAA4B,AACpB,kBAAoB,CAC7B,AACD,sDACE,eAAiB,CAClB,AAKD,0QACE,SAAW,CACZ,AACD,8DACE,kBAAoB,CACrB,AACD,wDACE,mBAAqB,CACtB,AACD,uDACE,8CAAgD,AACxC,qCAAwC,CACjD,AACD,yEACE,0BAA8B,CAC/B,AACD,8DACE,iBAAmB,CACpB,AAED,UACE,eAAgB,AAChB,aAAc,AACd,mBAAoB,AACpB,kBAAmB,AACnB,YAAa,AACb,OAAQ,AACR,aAAc,AACd,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,gBACE,eAAgB,AAChB,UAAW,AACX,UAAW,AACX,UAAY,CACb,AAED,4BACE,WAAY,AACZ,OAAQ,AACR,gBAAiB,AACjB,oBAAqB,AACrB,kBAAmB,AACnB,QAAS,AACT,mCAAoC,AAC5B,2BAA4B,AACpC,UAAY,CACb,AACD,kCACE,WAAY,AACZ,kBAAmB,AACnB,QAAS,AACT,MAAO,AACP,WAAY,AACZ,yCAAiD,AACjD,UAAW,AACX,SAAW,CACZ,AACD,mDAGE,kBAAmB,AACnB,KAAO,CACR,AACD,iBAIE,+BAAgC,AACxB,uBAAwB,AAChC,eAAiB,CAElB,AACD,uCARE,WAAY,AACZ,OAAQ,AACR,yCAAiD,AAIjD,UAAY,CAUb,AARD,sBACE,kBAAmB,AAGnB,8BAA+B,AACvB,qBAAuB,CAGhC,AACD,2BACE,kBAAmB,AACnB,OAAQ,AACR,WAAY,AACZ,WAAY,AACZ,QAAS,AACT,mCAAsC,AAC9B,0BAA8B,CACvC,AACD,iBACE,UAAW,AACX,mBAAoB,AACpB,wCAAiD,CAClD,AACD,sBACE,kBAAmB,AACnB,QAAS,AACT,mCAAoC,AAC5B,2BAA4B,AACpC,mBAAoB,AACpB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,kCACE,gCAAiC,AACzB,uBAAyB,CAClC,AACD,iCACE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,+DACE,wBAA0B,CAC3B,AACD,2BACE,kBAAmB,AACnB,QAAS,AACT,wCAAiD,CAClD,AACD,kCACE,WAAY,AACZ,cAAe,AAEf,wBAAyB,AACzB,YAAa,AACb,WAAY,AACZ,UAAW,AACX,gBAAiB,AACjB,oBAAqB,AACrB,kBAAmB,AACnB,UAAW,AACX,4BAA8B,AACtB,oBAAsB,AAE9B,WAAY,AACZ,6BAAgC,CACjC,AACD,mDAfE,kBAAmB,AAWnB,wCAAiD,CAkBlD,AAdD,iBACE,WAAY,AACZ,YAAa,AACb,WAAY,AACZ,QAAS,AAET,uBAAwB,AAExB,6CAA+C,AACvC,qCAAuC,AAC/C,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AAED,4EACE,4CAA6C,AACrC,mCAAqC,CAC9C,AACD,kHACE,4CAA6C,AACrC,mCAAqC,CAC9C,AACD,iEACE,SAAW,CACZ,AACD,kCAGE,KAAO,CAER,AACD,yDALE,kBAAmB,AACnB,OAAQ,AAER,yCAAkD,CAqBnD,AAnBD,uBACE,aAAc,AACd,mBAAoB,AACpB,uBAAwB,AACxB,eAAgB,AAChB,WAAY,AACZ,WAAY,AACZ,YAAa,AACb,wBAAyB,AAGzB,YAAa,AACb,oFAAqF,AAC7E,4EAA6E,AACrF,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAE3B,AACD,yBACE,iCAAkC,AAC1B,wBAA0B,CACnC,AACD,uCAEE,iBAAmB,CACpB,AAED,kBACE,cAAgB,AAChB,kBAAmB,AACnB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,4BACE,mBAAqB,CACtB,AACD,yBACE,aAAgB,CACjB,AAED,8CACE,iBAAmB,CACpB,AACD,SACE,eAAgB,AAChB,aAAc,AACd,mBAAoB,AACpB,WAAY,AACZ,oBAAqB,AACrB,aAAc,AACd,eAAgB,AAChB,OAAQ,AACR,OAAS,CACV,AACD,mBACE,iBAAmB,CACpB,AACD,cACE,KAAO,CACR,AACD,iBACE,QAAU,CACX,AACD,kBAGE,yBAA0B,AAC1B,oBAAqB,AAErB,kGAAmH,CACpH,AACD,oCAPE,aAAc,AACd,mBAAoB,AAGpB,UAAY,CAWb,AARD,kBAEE,YAAa,AACb,kBAAmB,AAGnB,8BAA+B,AAC/B,eAAiB,CAClB,AACD,yBACE,WAAY,AACZ,cAAe,AACf,YAAa,AACb,kBAAmB,AACnB,YAAa,AACb,eAAgB,AAChB,UAAY,CACb,AACD,kCACE,WAAa,CACd,AACD,gCACE,YAAc,CACf,AACD,uCACE,YAAa,AACb,YAAc,CACf,AACD,qCACE,aAAc,AACd,uBAAwB,AACxB,sBAAuB,AACvB,mBAAqB,CACtB,AACD,kDACE,yBAA0B,AAC1B,UAAW,AACX,cAAe,AACf,eAAiB,CAClB,AACD,qDACE,cAAe,AACf,QAAU,CACX,AACD,wCACE,WAAa,CACd,AACD,kEAEE,2DAAmE,AACnE,mDAA2D,AAC3D,kGAAmH,CACpH,AACD,sGAEE,iCAAqC,CACtC,AACD,4CACE,SAAW,CACZ,AACD,2FAEE,SAAW,CACZ,AACD,iGAEE,gDAAiD,AACzC,uCAAyC,CAClD,AACD,uGAEE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,yCACE,4DACE,cAAe,AACf,iBAAmB,CACpB,AACD,kBACE,WAAY,AACZ,gBAAiB,AACjB,gBAAiB,AACjB,cAAe,AACf,iBAAmB,CACpB,AACD,iCACE,aAAe,CAChB,AACD,kCACE,cAAgB,CACjB,AACD,+BAEE,aAAe,CAChB,AACD,yDAEE,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,+DAEE,oCAAqC,AAC7B,2BAA6B,CACtC,AACD,uCACE,gBAAkB,CACnB,CACF,AAED,cACE,iBAAmB,CACpB,AACD,wBACE,iBAAmB,CACpB,AACD,qBACE,cAAgB,CACjB,AACD,6CAEE,SAAW,CACZ,AACD,+EAEE,QAAU,CACX,AACD,gDACE,QAAU,CACX,AACD,0CACE,QAAS,AACT,mCAAoC,AAC5B,0BAA4B,CACrC,AACD,mDACE,WAAa,CACd,AACD,6CACE,WAAY,AACZ,kCAAmC,AAC3B,yBAA2B,CACpC,AACD,oBACE,SAAW,CACZ,AACD,qBACE,UAAY,CACb,AACD,qGAEE,YAAa,AACb,KAAO,CACR,AACD,qGAEE,OAAQ,AACR,UAAY,CACb,AACD,iDACE,8BAA+B,AAC/B,WAAa,CACd,AACD,mDACE,mBAAoB,AACpB,SAAW,CACZ,AACD,oDACE,sBAAuB,AACvB,QAAU,CACX,AACD,kDACE,2BAA4B,AAC5B,UAAY,CACb,AAED,oBACE,mBAAoB,AACpB,aAAc,AACd,uBAAwB,AACxB,iBAAmB,CACpB,AAED,wBACE,eAAiB,CAClB,AACD,2JACE,0BAA6B,CAC9B,AAID,sGACE,UAAY,CACb,AACD,sDACE,4BAA+B,CAChC,AACD,mEACE,sBAA8B,CAC/B,AACD,yDACE,0BAA6B,CAC9B,AACD,2EACE,sBAA8B,CAC/B,AACD,qEACE,qBAAwB,CACzB,AACD,uIACE,0BAA6B,CAC9B,AACD,0CACE,qBAAwB,CACzB,AAID,oLACE,qBAAwB,CACzB,AACD,uEACE,qCAAwC,CACzC,AACD,uBACE,kBAAoB,CACrB,AACD,0JACE,6BAAkC,CACnC,AAID,oGACE,UAAY,CACb,AACD,qDACE,gCAAqC,CACtC,AACD,kEACE,sBAA8B,CAC/B,AACD,wDACE,8BAAmC,CACpC,AACD,0EACE,sBAA8B,CAC/B,AACD,oEACE,yBAA8B,CAC/B,AACD,sIACE,8BAAmC,CACpC,AACD,yCACE,wBAA6B,CAC9B,AAID,kLACE,wBAA6B,CAC9B,AACD,sEACE,yCAA8C,CAC/C,AACD,uDACE,eAAgB,AAChB,gBAAkB,CACnB,AACD,WACE,gBAAiB,AACjB,iBAAmB,CAEpB,AACD,8BAFE,gGAAiH,CASlH,AAPD,mBACE,YAAa,AACb,oBAAqB,AACrB,aAAc,AACd,eAAgB,AAChB,6BAA+B,CAEhC,AACD,8BACE,kBAAmB,AACnB,cAAgB,CACjB,AACD,kBACE,kBAAmB,AACnB,eAAiB,CAClB,AACD,uBACE,mBAAoB,AACpB,kBAAmB,AACnB,oBAAqB,AACrB,eAAgB,AAChB,uBAAwB,AACxB,YAAa,AACb,iBAAkB,AAClB,eAAgB,AAChB,WAAY,AACZ,yCAAkD,CACnD,AACD,+BACE,cAAgB,CACjB,AACD,iBACE,mBAAoB,AACpB,aAAc,AACd,mBAAoB,AACpB,aAAc,AACd,iBAAmB,CACpB,AACD,2CACE,sCAA8C,CAC/C,AACD,2BACE,cAAgB,CACjB,AACD,+DACE,uBAAwB,AACxB,aAAe,CAChB,AACD,uEACE,eAAgB,AAChB,aAAe,CAChB,AACD,0DACE,cAAe,AACf,iBAAkB,AAClB,eAAiB,CAClB,AACD,gEACE,aAAe,CAChB,AACD,kBACE,uBAAwB,AACxB,aAAc,AACd,sBAAuB,AACvB,eAAiB,CAClB,AACD,wBACE,eAAgB,AAChB,gBAAiB,AACjB,gBAAkB,CACnB,AACD,oBACE,gBAAiB,AACjB,eAAiB,CAClB,AACD,oBACE,MAAO,AACP,uBAA6B,AAC7B,cAAe,AACf,UAAY,CACb,AACD,2BACE,qBAAuB,CACxB,AACD,oFAEE,wCAAiD,CAClD,AACD,qBACE,mBAAqB,CACtB,AACD,yCACE,6BAA8B,AAC9B,4BAA6B,AAC7B,UAAY,CACb,AACD,sCACE,sBAAwB,CACzB,AACD,4CACE,iBAAmB,CACpB,AACD,0CACE,WAAa,CACd,AACD,qDACE,oBAAqB,AACrB,qBAAuB,CACxB,AACD,wCACE,sBAAuB,AACvB,2BAA4B,AAC5B,mBAAoB,AACpB,gBAAkB,CACnB,AACD,8CACE,iBAAmB,CACpB,AACD,8CACE,eAAgB,AAChB,kBAAoB,CACrB,AACD,yCACE,uDACE,YAAc,CACf,AACD,4DACE,cAAgB,CACjB,CACF,AAGD,qCACE,aAAe,CAChB,AACD,qCACE,qBAAwB,CACzB,AACD,2EACE,uBAA0B,CAC3B,AACD,2EACE,+BAAmC,CACpC,AACD,oCACE,aAAe,CAChB,AACD,oCACE,wBAA6B,CAC9B,AACD,0EACE,uBAA0B,CAC3B,AACD,0EACE,kCAAwC,CACzC,AACD,2EACE,UAAW,AACX,WAAa,CACd,AACD,6KAEE,mCAAuC,AAC/B,0BAA+B,CACxC,AACD,gDAEE,8BAA+B,AAC/B,oBAAqB,AACrB,kBAAoB,CACrB,AACD,wBACE,kBAAmB,AACnB,YAAa,AACb,SAAU,AACV,WAAa,AACb,kBAAmB,AACnB,UAAW,AACX,mBAAqB,CACtB,AACD,wBACE,kBAAmB,AACnB,qBAAsB,AACtB,YAAa,AACb,kBAAmB,AACnB,WAAY,AACZ,aAAc,AACd,uBAAwB,AACxB,mBAAoB,AACpB,iGAAkH,CACnH,AACD,qDACE,UAAY,CACb,AACD,sDACE,WAAY,AACZ,oBAAsB,CACvB,AACD,mIAEE,kCAAsC,AAC9B,yBAA8B,CACvC,AAGD,2BACE,yBAA0B,AAC1B,qBAAwB,CACzB,AACD,mCACE,qBAAwB,CACzB,AACD,uCACE,6CAAmD,CACpD,AACD,0BACE,sBAAuB,AACvB,wBAA6B,CAC9B,AACD,kCACE,wBAA6B,CAC9B,AACD,sCACE,yCAA6C,CAC9C,AACD,cACE,mBAAoB,AACpB,aAAc,AACd,eAAgB,AAChB,gBAAiB,AACjB,aAAe,CAChB,AACD,sBACE,cAAgB,CACjB,AACD,6CAEE,OAAQ,AACR,MAAO,AACP,WAAY,AACZ,SAAW,CACZ,AACD,qBACE,cAAgB,CACjB,AACD,wBACE,iBAAmB,CACpB,AACD,8BACE,gBAAkB,CACnB,AACD,8BACE,eAAgB,AAChB,gBAAkB,CACnB,AAGD,0BACE,qBAAuB,CACxB,AACD,uCACE,qBAAwB,CACzB,AACD,kDACE,qBAAwB,CACzB,AACD,yBACE,wBAA0B,CAC3B,AACD,sCACE,UAAY,CACb,AACD,iDACE,wBAA6B,CAC9B,AAID,qBAFE,iBAAmB,CAKpB,AAHD,aAEE,qBAAuB,CACxB,AACD,cACE,mBAAoB,AACpB,eAAgB,AAChB,oBAAqB,AACrB,YAAa,AACb,kBAAmB,AACnB,MAAO,AACP,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,UAAY,CACb,AACD,oBACE,QAAU,CACX,AACD,oBACE,SAAW,CACZ,AACD,iBACE,gBAAiB,AACjB,gBAAiB,AACjB,YAAc,CACf,AACD,8BACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,mEACE,iBAAmB,CACpB,AACD,mBACE,cAAe,AACf,aAAc,AACd,YAAa,AACb,qBAAsB,AACtB,2DAAkE,AAClE,mDAA0D,AAC1D,mGAAiH,AACjH,mBAAoB,AACpB,iBAAmB,CACpB,AACD,0CACE,aAAe,CAChB,AACD,sCACE,cAAe,AACf,cAAgB,CACjB,AACD,mCACE,WAAa,CACd,AACD,qCACE,iBAAmB,CACpB,AACD,4FAEE,cAAgB,CACjB,AAMD,sWAGE,gBAAkB,CACnB,AACD,4GAEE,iBAAmB,CACpB,AACD,iDACE,6BAA+B,CAChC,AACD,yDACE,iBAAmB,CACpB,AACD,aACE,mBAAoB,AACpB,oBAAqB,AACrB,cAAe,AACf,eAAgB,AAChB,gBAAiB,AACjB,mBAAoB,AACpB,eAAgB,AAChB,gBAAiB,AACjB,kBAAmB,AACnB,yBAA0B,AAC1B,qBAAuB,CACxB,AACD,cACE,mBAAoB,AACpB,cAAe,AACf,aAAc,AACd,cAAe,AACf,YAAa,AACb,uBAAwB,AACxB,kBAAmB,AACnB,iBAAkB,AAClB,qBAAsB,AACtB,yCAAiD,AACjD,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,kBAAoB,CACrB,AACD,yCACE,UAAa,CACd,AACD,wBACE,mBAAqB,CACtB,AACD,gBACE,WAAY,AACZ,UAAY,CACb,AACD,wBACE,SAAU,AACV,mBAAqB,AACrB,kBAAmB,AACnB,wCAAiD,CAClD,AACD,yCACE,mEACE,iBAAmB,CACpB,AACD,4CACE,aAAe,CAChB,CACF,AACD,yCACE,4FAEE,eAAiB,CAClB,CACF,AAED,qGACE,UAAY,CACb,AACD,oGACE,qBAAwB,CACzB,AACD,4EACE,eAAgB,AAChB,iBAAmB,CACpB,AACD,qFACE,gBAAiB,AACjB,iBAAmB,CACpB,AACD,qBACE,cAAe,AACf,iBAAkB,AAClB,eAAgB,AAChB,gBAAiB,AACjB,aAAc,AACd,kBAAmB,AACnB,UAAY,CACb,AACD,kCACE,gBAAiB,AACjB,gBAAkB,CACnB,AACD,8JAEE,YAAc,CACf,AACD,kJAEE,UAAY,CACb,AACD,uDACE,kBAAoB,CACrB,AACD,gEACE,kBAAoB,CACrB,AACD,gMAIE,eAAiB,CAClB,AACD,wSAIE,eAAiB,CAClB,AACD,uIAEE,QAAU,CACX,AACD,qMAEE,aAAe,CAChB,AACD,+BACE,sBAAwB,CACzB,AACD,0NAIE,sBAAuB,AACvB,eAAiB,CAClB,AACD,gCACE,eAAiB,CAClB,AACD,gCACE,WAAa,CACd,AAED,gCACE,0BAA6B,CAC9B,AACD,+CACE,eAAiB,CAClB,AACD,yDACE,kCAAqC,CACtC,AACD,+BACE,8BAAmC,CACpC,AACD,8CACE,kBAAoB,CACrB,AACD,wDACE,kCAAqC,CACtC,AACD,iBACE,aAAc,AACd,2BAA4B,AAC5B,mBAAqB,CACtB,AACD,oFAEE,kBAAoB,CACrB,AACD,kOAIE,iCAAkC,AAC1B,yBAA0B,AAClC,SAAW,CACZ,AACD,0IAEE,iBAAkB,AAClB,eAAiB,CAClB,AACD,8UAIE,4BAA6B,AACrB,oBAAqB,AAC7B,UAAY,CACb,AACD,gOAIE,UAAY,CACb,AACD,yIAEE,kBAAmB,AACnB,gBAAkB,CACnB,AACD,4UAIE,iCAAkC,AAC1B,yBAA0B,AAClC,WAAa,CACd,AACD,kDAEE,iBAAmB,CACpB,AACD,sBACE,iGAAiH,AACjH,kBAAmB,AACnB,kBAAmB,AACnB,YAAa,AACb,sBAAuB,AACvB,UAAY,CACb,AACD,kDACE,YAAa,AACb,WAAY,AACZ,UAAY,CACb,AACD,6BACE,YAAa,AACb,sBAAuB,AACvB,UAAY,CACb,AACD,yDACE,YAAa,AACb,WAAY,AACZ,UAAY,CACb,AACD,6BACE,YAAa,AACb,sBAAuB,AACvB,UAAY,CACb,AACD,yDACE,YAAa,AACb,WAAY,AACZ,UAAY,CACb,AACD,4BACE,aAAc,AACd,uBAAwB,AACxB,kBAAoB,CACrB,AACD,uBACE,kBAAmB,AACnB,YAAa,AACb,cAAe,AACf,0BAA4B,CAC7B,AACD,+DAEE,WAAY,AACZ,kBAAmB,AACnB,kCAAmC,AACnC,qCAAsC,AACtC,6BAA8B,AAC9B,oBAAsB,CACvB,AACD,+BACE,0BAA4B,CAC7B,AACD,gCACE,0BAA4B,CAC7B,AACD,2BACE,cAAe,AACf,kBAAmB,AACnB,0BAA4B,CAC7B,AACD,uDACE,eAAgB,AAChB,SAAU,AACV,aAAe,CAChB,AACD,YACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,mBACE,SAAU,AACV,WAAY,AACZ,YAAa,AACb,qBAAsB,AACtB,kBAAmB,AACnB,MAAO,AACP,SAAW,CACZ,AACD,wCACE,iBAAmB,CACpB,AACD,6CACE,OAAS,CACV,AACD,oDACE,QAAU,CACX,AACD,oDACE,KAAO,CACR,AACD,uDACE,yBAA2B,CAC5B,AACD,sDACE,mBAAqB,CACtB,AACD,0BACE,SAAW,CACZ,AACD,0HAEE,0BAA4B,CAC7B,AACD,8SAIE,WAAe,AACf,WAAY,AACZ,uBAAwB,AAChB,cAAgB,CACzB,AACD,yCACE,MAAQ,CACT,AACD,gDACE,QAAU,CACX,AACD,gDACE,SAAW,CACZ,AACD,0CACE,2BAA6B,CAC9B,AACD,8CACE,YAAc,CACf,AAED,qBACE,WAAY,AACZ,aAAc,AACd,cAAe,AACf,wBAA0B,CAC3B,AACD,2BACE,kBAAoB,CACrB,AACD,iFAEE,mBAAoB,AACpB,oBAAqB,AACrB,YAAa,AACb,eAAgB,AAChB,sBAAwB,CACzB,AACD,2BACE,oBAAqB,AACrB,aAAc,AACd,sBAAuB,AACvB,eAAgB,AAChB,qBAAsB,AACtB,wBAA0B,CAC3B,AACD,0CACE,kBAAoB,CACrB,AACD,iDACE,sBAAuB,AACvB,uBAAwB,AACxB,WAAa,CACd,AACD,uDACE,gBAAkB,CACnB,AACD,yIAEE,YAAa,AACb,cAAgB,CACjB,AACD,uDACE,gBAAiB,AACjB,gBAAoB,AACpB,iBAAmB,CACpB,AAGD,kCACE,kBAAoB,CACrB,AACD,uEACE,qBAAwB,CACzB,AACD,yGACE,wBAA6B,CAC9B,AACD,4EACE,wBAA0B,CAC3B,AACD,kFACE,aAAe,CAChB,AACD,oFACE,wBAA0B,CAC3B,AACD,iCACE,kBAAoB,CACrB,AAID,8KACE,wBAA6B,CAC9B,AACD,2EACE,wBAA0B,CAC3B,AACD,iFACE,aAAe,CAChB,AACD,mFACE,wBAA0B,CAC3B,AACD,qBACE,mBAAoB,AACpB,kBAAmB,AACnB,yCAAiD,AACjD,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,WAAY,AACZ,gBAAkB,CACnB,AACD,gCACE,aAAc,AACd,mBAAoB,AACpB,uBAAwB,AACxB,YAAc,CACf,AACD,2BACE,uBAAwB,AACxB,UAAW,AACX,WAAY,AACZ,qBAAsB,AACtB,uCAAwC,AAChC,+BAAgC,AACxC,kBAAmB,AACnB,sBAAuB,AACvB,SAAW,CACZ,AACD,kCACE,uBAAwB,AACxB,iBAAkB,AAIlB,WAAY,AACZ,YAAa,AAGb,QAAU,CAIX,AACD,mEAZE,mBAAoB,AACpB,qBAAsB,AACtB,mBAAoB,AAGpB,WAAY,AACZ,kBAAmB,AAEnB,SAAU,AACV,uCAAyC,AACjC,8BAAiC,CAe1C,AAbD,iCAGE,WAAY,AACZ,UAAW,AACX,SAAU,AAKV,wBAA0B,CAG3B,AACD,wCACE,WAAa,CACd,AACD,sDACE,eAAiB,CAClB,AACD,4BACE,kBAAmB,AACnB,YAAa,AACb,UAAW,AACX,WAAY,AACZ,QAAU,CACX,AACD,2BACE,mBAAoB,AACpB,mBAAoB,AACpB,eAAgB,AAChB,aAAc,AACd,eAAgB,AAChB,uBAAwB,AACxB,YAAa,AACb,kBAAmB,AACnB,kBAAmB,AACnB,WAAY,AACZ,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,iBAAkB,AAC1B,uCAAyC,AACjC,8BAAiC,CAC1C,AACD,gCACE,SAAW,CACZ,AACD,mEAEE,WAAY,AACZ,mBAAoB,AACpB,kBAAmB,AACnB,QAAS,AACT,SAAU,AACV,YAAa,AACb,WAAY,AACZ,uCAAyC,AACjC,+BAAiC,AAIzC,YAAa,AACb,UAAY,CAJb,AAMD,mCACE,WAAY,AACZ,eAAgB,AAChB,SAAW,CACZ,AACD,qCACE,mBAAqB,CACtB,AAGD,wBACE,yBAA0B,AAC1B,qBAAwB,CACzB,AACD,uBACE,yBAA0B,AAC1B,UAAY,CACb,AACD,yDACE,cAAe,AACf,iBAAmB,CACpB,AACD,WACE,gBAAiB,AACjB,kGAAkH,AAClH,kBAAmB,AACnB,WAAY,AACZ,sCAAyC,CAC1C,AACD,6BACE,sCAA8C,CAC/C,AACD,iEAEE,QAAU,CACX,AACD,+GAEE,YAAc,CACf,AAED,mBACE,UAAY,CACb,AACD,kBACE,eAAgB,AAChB,gBAAiB,AACjB,qBAAuB,AACvB,mBAAoB,AACpB,gBAAiB,AACjB,sBAAwB,CACzB,AACD,oCACE,gBAAkB,CACnB,AACD,0CAEE,mBAAoB,AACpB,aAAc,AACd,cAAgB,CACjB,AACD,oEAEE,UAAY,CACb,AACD,oEAEE,aAAe,CAChB,AACD,4FAEE,gBAAkB,CACnB,AACD,sPAIE,aAAe,CAChB,AACD,8QAIE,gBAAkB,CACnB,AACD,kEAEE,cAAgB,CACjB,AACD,0FAEE,iBAAmB,CACpB,AACD,kPAIE,cAAgB,CACjB,AACD,0QAIE,iBAAmB,CACpB,AACD,0DAEE,cAAe,AACf,eAAiB,CAClB,AACD,kFAEE,iBAAmB,CACpB,AACD,gFAEE,kBAAoB,CACrB,AACD,wCACE,gBAAkB,CACnB,AACD,kBACE,aAAc,AACd,eAAgB,AAChB,eAAgB,AAChB,SAAW,CACZ,AACD,yBACE,mBAAoB,AACpB,iBAAmB,CACpB,AACD,+DAEE,cAAgB,CACjB,AACD,gIAGE,eAAgB,AAChB,QAAU,CACX,AAED,oDAEE,iFAAgH,CACjH,AACD,oBACE,QAAU,CACX,AACD,qGAEE,YAAc,CACf,AACD,iBACE,0BAA2B,AAC3B,iFAAgH,CACjH,AACD,kBACE,eAAgB,AAChB,SAAW,CACZ,AACD,uCAEE,MAAO,AACP,MAAQ,CACT,AACD,qBACE,kBAAmB,AACnB,SAAW,CACZ,AACD,qBACE,oBAAqB,AACrB,YAAa,AACb,UAAY,CACb,AACD,oBACE,SAAW,CACZ,AACD,yCACE,0CAEE,cAAgB,CACjB,AACD,kFAEE,iBAAmB,CACpB,AACD,gFAEE,kBAAoB,CACrB,CACF,AAED,oBACE,mBAAoB,AACpB,kBAAmB,AACnB,WAAY,AACZ,eAAgB,AAChB,qBAAsB,AACtB,gBAAiB,AACjB,kBAAmB,AACnB,oBAAwB,AACxB,WAAY,AACZ,gGAAiH,CAClH,AACD,oCACE,0CAAkD,AAClD,mBAAqB,CACtB,AACD,2BACE,cAAgB,CACjB,AACD,yCACE,+BACE,iBAAmB,CACpB,CACF,AAGD,yBACE,qBAAwB,CACzB,AACD,mHAEE,0BAA6B,CAC9B,AACD,wBACE,UAAY,CACb,AACD,iHAEE,8BAAmC,CACpC,AACD,kDACE,cAAgB,CACjB,AACD,wDACE,kBAAmB,AACnB,aAAe,CAChB,AACD,sCACE,kBAAmB,AACnB,aAAe,CAChB,AACD,4CACE,kBAAmB,AACnB,aAAe,CAChB,AACD,8CACE,gCAAiC,AACzB,uBAAyB,CAClC,AACD,oDACE,uBAAwB,AAChB,cAAgB,CACzB,AACD,6BACE,aAAe,CAChB,AACD,mCACE,gBAAkB,CACnB,AACD,iBACE,gBAAkB,CACnB,AACD,2BACE,YAAc,CACf,AACD,0HAEE,eAAgB,AAChB,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAC3B,AACD,uBACE,gBAAkB,CACnB,AACD,uBACE,aAAc,AACd,mBAAoB,AACpB,eAAiB,CAClB,AACD,0BACE,aAAc,AACd,YAAa,AACb,cAAe,AACf,kBAAoB,CACrB,AACD,iCACE,sBAAwB,AACxB,uBAA0B,CAC3B,AACD,wBACE,iBAAkB,AAClB,gBAAiB,AACjB,YAAa,AACb,aAAe,CAChB,AACD,gCACE,iBAAmB,CACpB,AAOD,oDALE,yBAA0B,AACvB,sBAAuB,AACtB,qBAAsB,AAClB,gBAAkB,CAS3B,AAPD,yBAKE,iCAAkC,AAC1B,wBAA0B,CACnC,AACD,+BACE,uBAAwB,AAChB,cAAgB,CACzB,AACD,kCACE,8DAA+D,AACvD,qDAAuD,CAChE,AACD,2BACE,yCAAgD,CACjD","file":"vuetify.css","sourcesContent":["@-webkit-keyframes shake {\n  59% {\n    margin-left: 0;\n  }\n  60%, 80% {\n    margin-left: 2px;\n  }\n  70%, 90% {\n    margin-left: -2px;\n  }\n}\n@keyframes shake {\n  59% {\n    margin-left: 0;\n  }\n  60%, 80% {\n    margin-left: 2px;\n  }\n  70%, 90% {\n    margin-left: -2px;\n  }\n}\n.black {\n  background-color: #000 !important;\n  border-color: #000 !important;\n}\n.black--text {\n  color: #000 !important;\n  caret-color: #000 !important;\n}\n.white {\n  background-color: #fff !important;\n  border-color: #fff !important;\n}\n.white--text {\n  color: #fff !important;\n  caret-color: #fff !important;\n}\n.transparent {\n  background-color: transparent !important;\n  border-color: transparent !important;\n}\n.transparent--text {\n  color: transparent !important;\n  caret-color: transparent !important;\n}\n.red {\n  background-color: #f44336 !important;\n  border-color: #f44336 !important;\n}\n.red--text {\n  color: #f44336 !important;\n  caret-color: #f44336 !important;\n}\n.red.lighten-5 {\n  background-color: #ffebee !important;\n  border-color: #ffebee !important;\n}\n.red--text.text--lighten-5 {\n  color: #ffebee !important;\n  caret-color: #ffebee !important;\n}\n.red.lighten-4 {\n  background-color: #ffcdd2 !important;\n  border-color: #ffcdd2 !important;\n}\n.red--text.text--lighten-4 {\n  color: #ffcdd2 !important;\n  caret-color: #ffcdd2 !important;\n}\n.red.lighten-3 {\n  background-color: #ef9a9a !important;\n  border-color: #ef9a9a !important;\n}\n.red--text.text--lighten-3 {\n  color: #ef9a9a !important;\n  caret-color: #ef9a9a !important;\n}\n.red.lighten-2 {\n  background-color: #e57373 !important;\n  border-color: #e57373 !important;\n}\n.red--text.text--lighten-2 {\n  color: #e57373 !important;\n  caret-color: #e57373 !important;\n}\n.red.lighten-1 {\n  background-color: #ef5350 !important;\n  border-color: #ef5350 !important;\n}\n.red--text.text--lighten-1 {\n  color: #ef5350 !important;\n  caret-color: #ef5350 !important;\n}\n.red.darken-1 {\n  background-color: #e53935 !important;\n  border-color: #e53935 !important;\n}\n.red--text.text--darken-1 {\n  color: #e53935 !important;\n  caret-color: #e53935 !important;\n}\n.red.darken-2 {\n  background-color: #d32f2f !important;\n  border-color: #d32f2f !important;\n}\n.red--text.text--darken-2 {\n  color: #d32f2f !important;\n  caret-color: #d32f2f !important;\n}\n.red.darken-3 {\n  background-color: #c62828 !important;\n  border-color: #c62828 !important;\n}\n.red--text.text--darken-3 {\n  color: #c62828 !important;\n  caret-color: #c62828 !important;\n}\n.red.darken-4 {\n  background-color: #b71c1c !important;\n  border-color: #b71c1c !important;\n}\n.red--text.text--darken-4 {\n  color: #b71c1c !important;\n  caret-color: #b71c1c !important;\n}\n.red.accent-1 {\n  background-color: #ff8a80 !important;\n  border-color: #ff8a80 !important;\n}\n.red--text.text--accent-1 {\n  color: #ff8a80 !important;\n  caret-color: #ff8a80 !important;\n}\n.red.accent-2 {\n  background-color: #ff5252 !important;\n  border-color: #ff5252 !important;\n}\n.red--text.text--accent-2 {\n  color: #ff5252 !important;\n  caret-color: #ff5252 !important;\n}\n.red.accent-3 {\n  background-color: #ff1744 !important;\n  border-color: #ff1744 !important;\n}\n.red--text.text--accent-3 {\n  color: #ff1744 !important;\n  caret-color: #ff1744 !important;\n}\n.red.accent-4 {\n  background-color: #d50000 !important;\n  border-color: #d50000 !important;\n}\n.red--text.text--accent-4 {\n  color: #d50000 !important;\n  caret-color: #d50000 !important;\n}\n.pink {\n  background-color: #e91e63 !important;\n  border-color: #e91e63 !important;\n}\n.pink--text {\n  color: #e91e63 !important;\n  caret-color: #e91e63 !important;\n}\n.pink.lighten-5 {\n  background-color: #fce4ec !important;\n  border-color: #fce4ec !important;\n}\n.pink--text.text--lighten-5 {\n  color: #fce4ec !important;\n  caret-color: #fce4ec !important;\n}\n.pink.lighten-4 {\n  background-color: #f8bbd0 !important;\n  border-color: #f8bbd0 !important;\n}\n.pink--text.text--lighten-4 {\n  color: #f8bbd0 !important;\n  caret-color: #f8bbd0 !important;\n}\n.pink.lighten-3 {\n  background-color: #f48fb1 !important;\n  border-color: #f48fb1 !important;\n}\n.pink--text.text--lighten-3 {\n  color: #f48fb1 !important;\n  caret-color: #f48fb1 !important;\n}\n.pink.lighten-2 {\n  background-color: #f06292 !important;\n  border-color: #f06292 !important;\n}\n.pink--text.text--lighten-2 {\n  color: #f06292 !important;\n  caret-color: #f06292 !important;\n}\n.pink.lighten-1 {\n  background-color: #ec407a !important;\n  border-color: #ec407a !important;\n}\n.pink--text.text--lighten-1 {\n  color: #ec407a !important;\n  caret-color: #ec407a !important;\n}\n.pink.darken-1 {\n  background-color: #d81b60 !important;\n  border-color: #d81b60 !important;\n}\n.pink--text.text--darken-1 {\n  color: #d81b60 !important;\n  caret-color: #d81b60 !important;\n}\n.pink.darken-2 {\n  background-color: #c2185b !important;\n  border-color: #c2185b !important;\n}\n.pink--text.text--darken-2 {\n  color: #c2185b !important;\n  caret-color: #c2185b !important;\n}\n.pink.darken-3 {\n  background-color: #ad1457 !important;\n  border-color: #ad1457 !important;\n}\n.pink--text.text--darken-3 {\n  color: #ad1457 !important;\n  caret-color: #ad1457 !important;\n}\n.pink.darken-4 {\n  background-color: #880e4f !important;\n  border-color: #880e4f !important;\n}\n.pink--text.text--darken-4 {\n  color: #880e4f !important;\n  caret-color: #880e4f !important;\n}\n.pink.accent-1 {\n  background-color: #ff80ab !important;\n  border-color: #ff80ab !important;\n}\n.pink--text.text--accent-1 {\n  color: #ff80ab !important;\n  caret-color: #ff80ab !important;\n}\n.pink.accent-2 {\n  background-color: #ff4081 !important;\n  border-color: #ff4081 !important;\n}\n.pink--text.text--accent-2 {\n  color: #ff4081 !important;\n  caret-color: #ff4081 !important;\n}\n.pink.accent-3 {\n  background-color: #f50057 !important;\n  border-color: #f50057 !important;\n}\n.pink--text.text--accent-3 {\n  color: #f50057 !important;\n  caret-color: #f50057 !important;\n}\n.pink.accent-4 {\n  background-color: #c51162 !important;\n  border-color: #c51162 !important;\n}\n.pink--text.text--accent-4 {\n  color: #c51162 !important;\n  caret-color: #c51162 !important;\n}\n.purple {\n  background-color: #9c27b0 !important;\n  border-color: #9c27b0 !important;\n}\n.purple--text {\n  color: #9c27b0 !important;\n  caret-color: #9c27b0 !important;\n}\n.purple.lighten-5 {\n  background-color: #f3e5f5 !important;\n  border-color: #f3e5f5 !important;\n}\n.purple--text.text--lighten-5 {\n  color: #f3e5f5 !important;\n  caret-color: #f3e5f5 !important;\n}\n.purple.lighten-4 {\n  background-color: #e1bee7 !important;\n  border-color: #e1bee7 !important;\n}\n.purple--text.text--lighten-4 {\n  color: #e1bee7 !important;\n  caret-color: #e1bee7 !important;\n}\n.purple.lighten-3 {\n  background-color: #ce93d8 !important;\n  border-color: #ce93d8 !important;\n}\n.purple--text.text--lighten-3 {\n  color: #ce93d8 !important;\n  caret-color: #ce93d8 !important;\n}\n.purple.lighten-2 {\n  background-color: #ba68c8 !important;\n  border-color: #ba68c8 !important;\n}\n.purple--text.text--lighten-2 {\n  color: #ba68c8 !important;\n  caret-color: #ba68c8 !important;\n}\n.purple.lighten-1 {\n  background-color: #ab47bc !important;\n  border-color: #ab47bc !important;\n}\n.purple--text.text--lighten-1 {\n  color: #ab47bc !important;\n  caret-color: #ab47bc !important;\n}\n.purple.darken-1 {\n  background-color: #8e24aa !important;\n  border-color: #8e24aa !important;\n}\n.purple--text.text--darken-1 {\n  color: #8e24aa !important;\n  caret-color: #8e24aa !important;\n}\n.purple.darken-2 {\n  background-color: #7b1fa2 !important;\n  border-color: #7b1fa2 !important;\n}\n.purple--text.text--darken-2 {\n  color: #7b1fa2 !important;\n  caret-color: #7b1fa2 !important;\n}\n.purple.darken-3 {\n  background-color: #6a1b9a !important;\n  border-color: #6a1b9a !important;\n}\n.purple--text.text--darken-3 {\n  color: #6a1b9a !important;\n  caret-color: #6a1b9a !important;\n}\n.purple.darken-4 {\n  background-color: #4a148c !important;\n  border-color: #4a148c !important;\n}\n.purple--text.text--darken-4 {\n  color: #4a148c !important;\n  caret-color: #4a148c !important;\n}\n.purple.accent-1 {\n  background-color: #ea80fc !important;\n  border-color: #ea80fc !important;\n}\n.purple--text.text--accent-1 {\n  color: #ea80fc !important;\n  caret-color: #ea80fc !important;\n}\n.purple.accent-2 {\n  background-color: #e040fb !important;\n  border-color: #e040fb !important;\n}\n.purple--text.text--accent-2 {\n  color: #e040fb !important;\n  caret-color: #e040fb !important;\n}\n.purple.accent-3 {\n  background-color: #d500f9 !important;\n  border-color: #d500f9 !important;\n}\n.purple--text.text--accent-3 {\n  color: #d500f9 !important;\n  caret-color: #d500f9 !important;\n}\n.purple.accent-4 {\n  background-color: #a0f !important;\n  border-color: #a0f !important;\n}\n.purple--text.text--accent-4 {\n  color: #a0f !important;\n  caret-color: #a0f !important;\n}\n.deep-purple {\n  background-color: #673ab7 !important;\n  border-color: #673ab7 !important;\n}\n.deep-purple--text {\n  color: #673ab7 !important;\n  caret-color: #673ab7 !important;\n}\n.deep-purple.lighten-5 {\n  background-color: #ede7f6 !important;\n  border-color: #ede7f6 !important;\n}\n.deep-purple--text.text--lighten-5 {\n  color: #ede7f6 !important;\n  caret-color: #ede7f6 !important;\n}\n.deep-purple.lighten-4 {\n  background-color: #d1c4e9 !important;\n  border-color: #d1c4e9 !important;\n}\n.deep-purple--text.text--lighten-4 {\n  color: #d1c4e9 !important;\n  caret-color: #d1c4e9 !important;\n}\n.deep-purple.lighten-3 {\n  background-color: #b39ddb !important;\n  border-color: #b39ddb !important;\n}\n.deep-purple--text.text--lighten-3 {\n  color: #b39ddb !important;\n  caret-color: #b39ddb !important;\n}\n.deep-purple.lighten-2 {\n  background-color: #9575cd !important;\n  border-color: #9575cd !important;\n}\n.deep-purple--text.text--lighten-2 {\n  color: #9575cd !important;\n  caret-color: #9575cd !important;\n}\n.deep-purple.lighten-1 {\n  background-color: #7e57c2 !important;\n  border-color: #7e57c2 !important;\n}\n.deep-purple--text.text--lighten-1 {\n  color: #7e57c2 !important;\n  caret-color: #7e57c2 !important;\n}\n.deep-purple.darken-1 {\n  background-color: #5e35b1 !important;\n  border-color: #5e35b1 !important;\n}\n.deep-purple--text.text--darken-1 {\n  color: #5e35b1 !important;\n  caret-color: #5e35b1 !important;\n}\n.deep-purple.darken-2 {\n  background-color: #512da8 !important;\n  border-color: #512da8 !important;\n}\n.deep-purple--text.text--darken-2 {\n  color: #512da8 !important;\n  caret-color: #512da8 !important;\n}\n.deep-purple.darken-3 {\n  background-color: #4527a0 !important;\n  border-color: #4527a0 !important;\n}\n.deep-purple--text.text--darken-3 {\n  color: #4527a0 !important;\n  caret-color: #4527a0 !important;\n}\n.deep-purple.darken-4 {\n  background-color: #311b92 !important;\n  border-color: #311b92 !important;\n}\n.deep-purple--text.text--darken-4 {\n  color: #311b92 !important;\n  caret-color: #311b92 !important;\n}\n.deep-purple.accent-1 {\n  background-color: #b388ff !important;\n  border-color: #b388ff !important;\n}\n.deep-purple--text.text--accent-1 {\n  color: #b388ff !important;\n  caret-color: #b388ff !important;\n}\n.deep-purple.accent-2 {\n  background-color: #7c4dff !important;\n  border-color: #7c4dff !important;\n}\n.deep-purple--text.text--accent-2 {\n  color: #7c4dff !important;\n  caret-color: #7c4dff !important;\n}\n.deep-purple.accent-3 {\n  background-color: #651fff !important;\n  border-color: #651fff !important;\n}\n.deep-purple--text.text--accent-3 {\n  color: #651fff !important;\n  caret-color: #651fff !important;\n}\n.deep-purple.accent-4 {\n  background-color: #6200ea !important;\n  border-color: #6200ea !important;\n}\n.deep-purple--text.text--accent-4 {\n  color: #6200ea !important;\n  caret-color: #6200ea !important;\n}\n.indigo {\n  background-color: #3f51b5 !important;\n  border-color: #3f51b5 !important;\n}\n.indigo--text {\n  color: #3f51b5 !important;\n  caret-color: #3f51b5 !important;\n}\n.indigo.lighten-5 {\n  background-color: #e8eaf6 !important;\n  border-color: #e8eaf6 !important;\n}\n.indigo--text.text--lighten-5 {\n  color: #e8eaf6 !important;\n  caret-color: #e8eaf6 !important;\n}\n.indigo.lighten-4 {\n  background-color: #c5cae9 !important;\n  border-color: #c5cae9 !important;\n}\n.indigo--text.text--lighten-4 {\n  color: #c5cae9 !important;\n  caret-color: #c5cae9 !important;\n}\n.indigo.lighten-3 {\n  background-color: #9fa8da !important;\n  border-color: #9fa8da !important;\n}\n.indigo--text.text--lighten-3 {\n  color: #9fa8da !important;\n  caret-color: #9fa8da !important;\n}\n.indigo.lighten-2 {\n  background-color: #7986cb !important;\n  border-color: #7986cb !important;\n}\n.indigo--text.text--lighten-2 {\n  color: #7986cb !important;\n  caret-color: #7986cb !important;\n}\n.indigo.lighten-1 {\n  background-color: #5c6bc0 !important;\n  border-color: #5c6bc0 !important;\n}\n.indigo--text.text--lighten-1 {\n  color: #5c6bc0 !important;\n  caret-color: #5c6bc0 !important;\n}\n.indigo.darken-1 {\n  background-color: #3949ab !important;\n  border-color: #3949ab !important;\n}\n.indigo--text.text--darken-1 {\n  color: #3949ab !important;\n  caret-color: #3949ab !important;\n}\n.indigo.darken-2 {\n  background-color: #303f9f !important;\n  border-color: #303f9f !important;\n}\n.indigo--text.text--darken-2 {\n  color: #303f9f !important;\n  caret-color: #303f9f !important;\n}\n.indigo.darken-3 {\n  background-color: #283593 !important;\n  border-color: #283593 !important;\n}\n.indigo--text.text--darken-3 {\n  color: #283593 !important;\n  caret-color: #283593 !important;\n}\n.indigo.darken-4 {\n  background-color: #1a237e !important;\n  border-color: #1a237e !important;\n}\n.indigo--text.text--darken-4 {\n  color: #1a237e !important;\n  caret-color: #1a237e !important;\n}\n.indigo.accent-1 {\n  background-color: #8c9eff !important;\n  border-color: #8c9eff !important;\n}\n.indigo--text.text--accent-1 {\n  color: #8c9eff !important;\n  caret-color: #8c9eff !important;\n}\n.indigo.accent-2 {\n  background-color: #536dfe !important;\n  border-color: #536dfe !important;\n}\n.indigo--text.text--accent-2 {\n  color: #536dfe !important;\n  caret-color: #536dfe !important;\n}\n.indigo.accent-3 {\n  background-color: #3d5afe !important;\n  border-color: #3d5afe !important;\n}\n.indigo--text.text--accent-3 {\n  color: #3d5afe !important;\n  caret-color: #3d5afe !important;\n}\n.indigo.accent-4 {\n  background-color: #304ffe !important;\n  border-color: #304ffe !important;\n}\n.indigo--text.text--accent-4 {\n  color: #304ffe !important;\n  caret-color: #304ffe !important;\n}\n.blue {\n  background-color: #2196f3 !important;\n  border-color: #2196f3 !important;\n}\n.blue--text {\n  color: #2196f3 !important;\n  caret-color: #2196f3 !important;\n}\n.blue.lighten-5 {\n  background-color: #e3f2fd !important;\n  border-color: #e3f2fd !important;\n}\n.blue--text.text--lighten-5 {\n  color: #e3f2fd !important;\n  caret-color: #e3f2fd !important;\n}\n.blue.lighten-4 {\n  background-color: #bbdefb !important;\n  border-color: #bbdefb !important;\n}\n.blue--text.text--lighten-4 {\n  color: #bbdefb !important;\n  caret-color: #bbdefb !important;\n}\n.blue.lighten-3 {\n  background-color: #90caf9 !important;\n  border-color: #90caf9 !important;\n}\n.blue--text.text--lighten-3 {\n  color: #90caf9 !important;\n  caret-color: #90caf9 !important;\n}\n.blue.lighten-2 {\n  background-color: #64b5f6 !important;\n  border-color: #64b5f6 !important;\n}\n.blue--text.text--lighten-2 {\n  color: #64b5f6 !important;\n  caret-color: #64b5f6 !important;\n}\n.blue.lighten-1 {\n  background-color: #42a5f5 !important;\n  border-color: #42a5f5 !important;\n}\n.blue--text.text--lighten-1 {\n  color: #42a5f5 !important;\n  caret-color: #42a5f5 !important;\n}\n.blue.darken-1 {\n  background-color: #1e88e5 !important;\n  border-color: #1e88e5 !important;\n}\n.blue--text.text--darken-1 {\n  color: #1e88e5 !important;\n  caret-color: #1e88e5 !important;\n}\n.blue.darken-2 {\n  background-color: #1976d2 !important;\n  border-color: #1976d2 !important;\n}\n.blue--text.text--darken-2 {\n  color: #1976d2 !important;\n  caret-color: #1976d2 !important;\n}\n.blue.darken-3 {\n  background-color: #1565c0 !important;\n  border-color: #1565c0 !important;\n}\n.blue--text.text--darken-3 {\n  color: #1565c0 !important;\n  caret-color: #1565c0 !important;\n}\n.blue.darken-4 {\n  background-color: #0d47a1 !important;\n  border-color: #0d47a1 !important;\n}\n.blue--text.text--darken-4 {\n  color: #0d47a1 !important;\n  caret-color: #0d47a1 !important;\n}\n.blue.accent-1 {\n  background-color: #82b1ff !important;\n  border-color: #82b1ff !important;\n}\n.blue--text.text--accent-1 {\n  color: #82b1ff !important;\n  caret-color: #82b1ff !important;\n}\n.blue.accent-2 {\n  background-color: #448aff !important;\n  border-color: #448aff !important;\n}\n.blue--text.text--accent-2 {\n  color: #448aff !important;\n  caret-color: #448aff !important;\n}\n.blue.accent-3 {\n  background-color: #2979ff !important;\n  border-color: #2979ff !important;\n}\n.blue--text.text--accent-3 {\n  color: #2979ff !important;\n  caret-color: #2979ff !important;\n}\n.blue.accent-4 {\n  background-color: #2962ff !important;\n  border-color: #2962ff !important;\n}\n.blue--text.text--accent-4 {\n  color: #2962ff !important;\n  caret-color: #2962ff !important;\n}\n.light-blue {\n  background-color: #03a9f4 !important;\n  border-color: #03a9f4 !important;\n}\n.light-blue--text {\n  color: #03a9f4 !important;\n  caret-color: #03a9f4 !important;\n}\n.light-blue.lighten-5 {\n  background-color: #e1f5fe !important;\n  border-color: #e1f5fe !important;\n}\n.light-blue--text.text--lighten-5 {\n  color: #e1f5fe !important;\n  caret-color: #e1f5fe !important;\n}\n.light-blue.lighten-4 {\n  background-color: #b3e5fc !important;\n  border-color: #b3e5fc !important;\n}\n.light-blue--text.text--lighten-4 {\n  color: #b3e5fc !important;\n  caret-color: #b3e5fc !important;\n}\n.light-blue.lighten-3 {\n  background-color: #81d4fa !important;\n  border-color: #81d4fa !important;\n}\n.light-blue--text.text--lighten-3 {\n  color: #81d4fa !important;\n  caret-color: #81d4fa !important;\n}\n.light-blue.lighten-2 {\n  background-color: #4fc3f7 !important;\n  border-color: #4fc3f7 !important;\n}\n.light-blue--text.text--lighten-2 {\n  color: #4fc3f7 !important;\n  caret-color: #4fc3f7 !important;\n}\n.light-blue.lighten-1 {\n  background-color: #29b6f6 !important;\n  border-color: #29b6f6 !important;\n}\n.light-blue--text.text--lighten-1 {\n  color: #29b6f6 !important;\n  caret-color: #29b6f6 !important;\n}\n.light-blue.darken-1 {\n  background-color: #039be5 !important;\n  border-color: #039be5 !important;\n}\n.light-blue--text.text--darken-1 {\n  color: #039be5 !important;\n  caret-color: #039be5 !important;\n}\n.light-blue.darken-2 {\n  background-color: #0288d1 !important;\n  border-color: #0288d1 !important;\n}\n.light-blue--text.text--darken-2 {\n  color: #0288d1 !important;\n  caret-color: #0288d1 !important;\n}\n.light-blue.darken-3 {\n  background-color: #0277bd !important;\n  border-color: #0277bd !important;\n}\n.light-blue--text.text--darken-3 {\n  color: #0277bd !important;\n  caret-color: #0277bd !important;\n}\n.light-blue.darken-4 {\n  background-color: #01579b !important;\n  border-color: #01579b !important;\n}\n.light-blue--text.text--darken-4 {\n  color: #01579b !important;\n  caret-color: #01579b !important;\n}\n.light-blue.accent-1 {\n  background-color: #80d8ff !important;\n  border-color: #80d8ff !important;\n}\n.light-blue--text.text--accent-1 {\n  color: #80d8ff !important;\n  caret-color: #80d8ff !important;\n}\n.light-blue.accent-2 {\n  background-color: #40c4ff !important;\n  border-color: #40c4ff !important;\n}\n.light-blue--text.text--accent-2 {\n  color: #40c4ff !important;\n  caret-color: #40c4ff !important;\n}\n.light-blue.accent-3 {\n  background-color: #00b0ff !important;\n  border-color: #00b0ff !important;\n}\n.light-blue--text.text--accent-3 {\n  color: #00b0ff !important;\n  caret-color: #00b0ff !important;\n}\n.light-blue.accent-4 {\n  background-color: #0091ea !important;\n  border-color: #0091ea !important;\n}\n.light-blue--text.text--accent-4 {\n  color: #0091ea !important;\n  caret-color: #0091ea !important;\n}\n.cyan {\n  background-color: #00bcd4 !important;\n  border-color: #00bcd4 !important;\n}\n.cyan--text {\n  color: #00bcd4 !important;\n  caret-color: #00bcd4 !important;\n}\n.cyan.lighten-5 {\n  background-color: #e0f7fa !important;\n  border-color: #e0f7fa !important;\n}\n.cyan--text.text--lighten-5 {\n  color: #e0f7fa !important;\n  caret-color: #e0f7fa !important;\n}\n.cyan.lighten-4 {\n  background-color: #b2ebf2 !important;\n  border-color: #b2ebf2 !important;\n}\n.cyan--text.text--lighten-4 {\n  color: #b2ebf2 !important;\n  caret-color: #b2ebf2 !important;\n}\n.cyan.lighten-3 {\n  background-color: #80deea !important;\n  border-color: #80deea !important;\n}\n.cyan--text.text--lighten-3 {\n  color: #80deea !important;\n  caret-color: #80deea !important;\n}\n.cyan.lighten-2 {\n  background-color: #4dd0e1 !important;\n  border-color: #4dd0e1 !important;\n}\n.cyan--text.text--lighten-2 {\n  color: #4dd0e1 !important;\n  caret-color: #4dd0e1 !important;\n}\n.cyan.lighten-1 {\n  background-color: #26c6da !important;\n  border-color: #26c6da !important;\n}\n.cyan--text.text--lighten-1 {\n  color: #26c6da !important;\n  caret-color: #26c6da !important;\n}\n.cyan.darken-1 {\n  background-color: #00acc1 !important;\n  border-color: #00acc1 !important;\n}\n.cyan--text.text--darken-1 {\n  color: #00acc1 !important;\n  caret-color: #00acc1 !important;\n}\n.cyan.darken-2 {\n  background-color: #0097a7 !important;\n  border-color: #0097a7 !important;\n}\n.cyan--text.text--darken-2 {\n  color: #0097a7 !important;\n  caret-color: #0097a7 !important;\n}\n.cyan.darken-3 {\n  background-color: #00838f !important;\n  border-color: #00838f !important;\n}\n.cyan--text.text--darken-3 {\n  color: #00838f !important;\n  caret-color: #00838f !important;\n}\n.cyan.darken-4 {\n  background-color: #006064 !important;\n  border-color: #006064 !important;\n}\n.cyan--text.text--darken-4 {\n  color: #006064 !important;\n  caret-color: #006064 !important;\n}\n.cyan.accent-1 {\n  background-color: #84ffff !important;\n  border-color: #84ffff !important;\n}\n.cyan--text.text--accent-1 {\n  color: #84ffff !important;\n  caret-color: #84ffff !important;\n}\n.cyan.accent-2 {\n  background-color: #18ffff !important;\n  border-color: #18ffff !important;\n}\n.cyan--text.text--accent-2 {\n  color: #18ffff !important;\n  caret-color: #18ffff !important;\n}\n.cyan.accent-3 {\n  background-color: #00e5ff !important;\n  border-color: #00e5ff !important;\n}\n.cyan--text.text--accent-3 {\n  color: #00e5ff !important;\n  caret-color: #00e5ff !important;\n}\n.cyan.accent-4 {\n  background-color: #00b8d4 !important;\n  border-color: #00b8d4 !important;\n}\n.cyan--text.text--accent-4 {\n  color: #00b8d4 !important;\n  caret-color: #00b8d4 !important;\n}\n.teal {\n  background-color: #009688 !important;\n  border-color: #009688 !important;\n}\n.teal--text {\n  color: #009688 !important;\n  caret-color: #009688 !important;\n}\n.teal.lighten-5 {\n  background-color: #e0f2f1 !important;\n  border-color: #e0f2f1 !important;\n}\n.teal--text.text--lighten-5 {\n  color: #e0f2f1 !important;\n  caret-color: #e0f2f1 !important;\n}\n.teal.lighten-4 {\n  background-color: #b2dfdb !important;\n  border-color: #b2dfdb !important;\n}\n.teal--text.text--lighten-4 {\n  color: #b2dfdb !important;\n  caret-color: #b2dfdb !important;\n}\n.teal.lighten-3 {\n  background-color: #80cbc4 !important;\n  border-color: #80cbc4 !important;\n}\n.teal--text.text--lighten-3 {\n  color: #80cbc4 !important;\n  caret-color: #80cbc4 !important;\n}\n.teal.lighten-2 {\n  background-color: #4db6ac !important;\n  border-color: #4db6ac !important;\n}\n.teal--text.text--lighten-2 {\n  color: #4db6ac !important;\n  caret-color: #4db6ac !important;\n}\n.teal.lighten-1 {\n  background-color: #26a69a !important;\n  border-color: #26a69a !important;\n}\n.teal--text.text--lighten-1 {\n  color: #26a69a !important;\n  caret-color: #26a69a !important;\n}\n.teal.darken-1 {\n  background-color: #00897b !important;\n  border-color: #00897b !important;\n}\n.teal--text.text--darken-1 {\n  color: #00897b !important;\n  caret-color: #00897b !important;\n}\n.teal.darken-2 {\n  background-color: #00796b !important;\n  border-color: #00796b !important;\n}\n.teal--text.text--darken-2 {\n  color: #00796b !important;\n  caret-color: #00796b !important;\n}\n.teal.darken-3 {\n  background-color: #00695c !important;\n  border-color: #00695c !important;\n}\n.teal--text.text--darken-3 {\n  color: #00695c !important;\n  caret-color: #00695c !important;\n}\n.teal.darken-4 {\n  background-color: #004d40 !important;\n  border-color: #004d40 !important;\n}\n.teal--text.text--darken-4 {\n  color: #004d40 !important;\n  caret-color: #004d40 !important;\n}\n.teal.accent-1 {\n  background-color: #a7ffeb !important;\n  border-color: #a7ffeb !important;\n}\n.teal--text.text--accent-1 {\n  color: #a7ffeb !important;\n  caret-color: #a7ffeb !important;\n}\n.teal.accent-2 {\n  background-color: #64ffda !important;\n  border-color: #64ffda !important;\n}\n.teal--text.text--accent-2 {\n  color: #64ffda !important;\n  caret-color: #64ffda !important;\n}\n.teal.accent-3 {\n  background-color: #1de9b6 !important;\n  border-color: #1de9b6 !important;\n}\n.teal--text.text--accent-3 {\n  color: #1de9b6 !important;\n  caret-color: #1de9b6 !important;\n}\n.teal.accent-4 {\n  background-color: #00bfa5 !important;\n  border-color: #00bfa5 !important;\n}\n.teal--text.text--accent-4 {\n  color: #00bfa5 !important;\n  caret-color: #00bfa5 !important;\n}\n.green {\n  background-color: #4caf50 !important;\n  border-color: #4caf50 !important;\n}\n.green--text {\n  color: #4caf50 !important;\n  caret-color: #4caf50 !important;\n}\n.green.lighten-5 {\n  background-color: #e8f5e9 !important;\n  border-color: #e8f5e9 !important;\n}\n.green--text.text--lighten-5 {\n  color: #e8f5e9 !important;\n  caret-color: #e8f5e9 !important;\n}\n.green.lighten-4 {\n  background-color: #c8e6c9 !important;\n  border-color: #c8e6c9 !important;\n}\n.green--text.text--lighten-4 {\n  color: #c8e6c9 !important;\n  caret-color: #c8e6c9 !important;\n}\n.green.lighten-3 {\n  background-color: #a5d6a7 !important;\n  border-color: #a5d6a7 !important;\n}\n.green--text.text--lighten-3 {\n  color: #a5d6a7 !important;\n  caret-color: #a5d6a7 !important;\n}\n.green.lighten-2 {\n  background-color: #81c784 !important;\n  border-color: #81c784 !important;\n}\n.green--text.text--lighten-2 {\n  color: #81c784 !important;\n  caret-color: #81c784 !important;\n}\n.green.lighten-1 {\n  background-color: #66bb6a !important;\n  border-color: #66bb6a !important;\n}\n.green--text.text--lighten-1 {\n  color: #66bb6a !important;\n  caret-color: #66bb6a !important;\n}\n.green.darken-1 {\n  background-color: #43a047 !important;\n  border-color: #43a047 !important;\n}\n.green--text.text--darken-1 {\n  color: #43a047 !important;\n  caret-color: #43a047 !important;\n}\n.green.darken-2 {\n  background-color: #388e3c !important;\n  border-color: #388e3c !important;\n}\n.green--text.text--darken-2 {\n  color: #388e3c !important;\n  caret-color: #388e3c !important;\n}\n.green.darken-3 {\n  background-color: #2e7d32 !important;\n  border-color: #2e7d32 !important;\n}\n.green--text.text--darken-3 {\n  color: #2e7d32 !important;\n  caret-color: #2e7d32 !important;\n}\n.green.darken-4 {\n  background-color: #1b5e20 !important;\n  border-color: #1b5e20 !important;\n}\n.green--text.text--darken-4 {\n  color: #1b5e20 !important;\n  caret-color: #1b5e20 !important;\n}\n.green.accent-1 {\n  background-color: #b9f6ca !important;\n  border-color: #b9f6ca !important;\n}\n.green--text.text--accent-1 {\n  color: #b9f6ca !important;\n  caret-color: #b9f6ca !important;\n}\n.green.accent-2 {\n  background-color: #69f0ae !important;\n  border-color: #69f0ae !important;\n}\n.green--text.text--accent-2 {\n  color: #69f0ae !important;\n  caret-color: #69f0ae !important;\n}\n.green.accent-3 {\n  background-color: #00e676 !important;\n  border-color: #00e676 !important;\n}\n.green--text.text--accent-3 {\n  color: #00e676 !important;\n  caret-color: #00e676 !important;\n}\n.green.accent-4 {\n  background-color: #00c853 !important;\n  border-color: #00c853 !important;\n}\n.green--text.text--accent-4 {\n  color: #00c853 !important;\n  caret-color: #00c853 !important;\n}\n.light-green {\n  background-color: #8bc34a !important;\n  border-color: #8bc34a !important;\n}\n.light-green--text {\n  color: #8bc34a !important;\n  caret-color: #8bc34a !important;\n}\n.light-green.lighten-5 {\n  background-color: #f1f8e9 !important;\n  border-color: #f1f8e9 !important;\n}\n.light-green--text.text--lighten-5 {\n  color: #f1f8e9 !important;\n  caret-color: #f1f8e9 !important;\n}\n.light-green.lighten-4 {\n  background-color: #dcedc8 !important;\n  border-color: #dcedc8 !important;\n}\n.light-green--text.text--lighten-4 {\n  color: #dcedc8 !important;\n  caret-color: #dcedc8 !important;\n}\n.light-green.lighten-3 {\n  background-color: #c5e1a5 !important;\n  border-color: #c5e1a5 !important;\n}\n.light-green--text.text--lighten-3 {\n  color: #c5e1a5 !important;\n  caret-color: #c5e1a5 !important;\n}\n.light-green.lighten-2 {\n  background-color: #aed581 !important;\n  border-color: #aed581 !important;\n}\n.light-green--text.text--lighten-2 {\n  color: #aed581 !important;\n  caret-color: #aed581 !important;\n}\n.light-green.lighten-1 {\n  background-color: #9ccc65 !important;\n  border-color: #9ccc65 !important;\n}\n.light-green--text.text--lighten-1 {\n  color: #9ccc65 !important;\n  caret-color: #9ccc65 !important;\n}\n.light-green.darken-1 {\n  background-color: #7cb342 !important;\n  border-color: #7cb342 !important;\n}\n.light-green--text.text--darken-1 {\n  color: #7cb342 !important;\n  caret-color: #7cb342 !important;\n}\n.light-green.darken-2 {\n  background-color: #689f38 !important;\n  border-color: #689f38 !important;\n}\n.light-green--text.text--darken-2 {\n  color: #689f38 !important;\n  caret-color: #689f38 !important;\n}\n.light-green.darken-3 {\n  background-color: #558b2f !important;\n  border-color: #558b2f !important;\n}\n.light-green--text.text--darken-3 {\n  color: #558b2f !important;\n  caret-color: #558b2f !important;\n}\n.light-green.darken-4 {\n  background-color: #33691e !important;\n  border-color: #33691e !important;\n}\n.light-green--text.text--darken-4 {\n  color: #33691e !important;\n  caret-color: #33691e !important;\n}\n.light-green.accent-1 {\n  background-color: #ccff90 !important;\n  border-color: #ccff90 !important;\n}\n.light-green--text.text--accent-1 {\n  color: #ccff90 !important;\n  caret-color: #ccff90 !important;\n}\n.light-green.accent-2 {\n  background-color: #b2ff59 !important;\n  border-color: #b2ff59 !important;\n}\n.light-green--text.text--accent-2 {\n  color: #b2ff59 !important;\n  caret-color: #b2ff59 !important;\n}\n.light-green.accent-3 {\n  background-color: #76ff03 !important;\n  border-color: #76ff03 !important;\n}\n.light-green--text.text--accent-3 {\n  color: #76ff03 !important;\n  caret-color: #76ff03 !important;\n}\n.light-green.accent-4 {\n  background-color: #64dd17 !important;\n  border-color: #64dd17 !important;\n}\n.light-green--text.text--accent-4 {\n  color: #64dd17 !important;\n  caret-color: #64dd17 !important;\n}\n.lime {\n  background-color: #cddc39 !important;\n  border-color: #cddc39 !important;\n}\n.lime--text {\n  color: #cddc39 !important;\n  caret-color: #cddc39 !important;\n}\n.lime.lighten-5 {\n  background-color: #f9fbe7 !important;\n  border-color: #f9fbe7 !important;\n}\n.lime--text.text--lighten-5 {\n  color: #f9fbe7 !important;\n  caret-color: #f9fbe7 !important;\n}\n.lime.lighten-4 {\n  background-color: #f0f4c3 !important;\n  border-color: #f0f4c3 !important;\n}\n.lime--text.text--lighten-4 {\n  color: #f0f4c3 !important;\n  caret-color: #f0f4c3 !important;\n}\n.lime.lighten-3 {\n  background-color: #e6ee9c !important;\n  border-color: #e6ee9c !important;\n}\n.lime--text.text--lighten-3 {\n  color: #e6ee9c !important;\n  caret-color: #e6ee9c !important;\n}\n.lime.lighten-2 {\n  background-color: #dce775 !important;\n  border-color: #dce775 !important;\n}\n.lime--text.text--lighten-2 {\n  color: #dce775 !important;\n  caret-color: #dce775 !important;\n}\n.lime.lighten-1 {\n  background-color: #d4e157 !important;\n  border-color: #d4e157 !important;\n}\n.lime--text.text--lighten-1 {\n  color: #d4e157 !important;\n  caret-color: #d4e157 !important;\n}\n.lime.darken-1 {\n  background-color: #c0ca33 !important;\n  border-color: #c0ca33 !important;\n}\n.lime--text.text--darken-1 {\n  color: #c0ca33 !important;\n  caret-color: #c0ca33 !important;\n}\n.lime.darken-2 {\n  background-color: #afb42b !important;\n  border-color: #afb42b !important;\n}\n.lime--text.text--darken-2 {\n  color: #afb42b !important;\n  caret-color: #afb42b !important;\n}\n.lime.darken-3 {\n  background-color: #9e9d24 !important;\n  border-color: #9e9d24 !important;\n}\n.lime--text.text--darken-3 {\n  color: #9e9d24 !important;\n  caret-color: #9e9d24 !important;\n}\n.lime.darken-4 {\n  background-color: #827717 !important;\n  border-color: #827717 !important;\n}\n.lime--text.text--darken-4 {\n  color: #827717 !important;\n  caret-color: #827717 !important;\n}\n.lime.accent-1 {\n  background-color: #f4ff81 !important;\n  border-color: #f4ff81 !important;\n}\n.lime--text.text--accent-1 {\n  color: #f4ff81 !important;\n  caret-color: #f4ff81 !important;\n}\n.lime.accent-2 {\n  background-color: #eeff41 !important;\n  border-color: #eeff41 !important;\n}\n.lime--text.text--accent-2 {\n  color: #eeff41 !important;\n  caret-color: #eeff41 !important;\n}\n.lime.accent-3 {\n  background-color: #c6ff00 !important;\n  border-color: #c6ff00 !important;\n}\n.lime--text.text--accent-3 {\n  color: #c6ff00 !important;\n  caret-color: #c6ff00 !important;\n}\n.lime.accent-4 {\n  background-color: #aeea00 !important;\n  border-color: #aeea00 !important;\n}\n.lime--text.text--accent-4 {\n  color: #aeea00 !important;\n  caret-color: #aeea00 !important;\n}\n.yellow {\n  background-color: #ffeb3b !important;\n  border-color: #ffeb3b !important;\n}\n.yellow--text {\n  color: #ffeb3b !important;\n  caret-color: #ffeb3b !important;\n}\n.yellow.lighten-5 {\n  background-color: #fffde7 !important;\n  border-color: #fffde7 !important;\n}\n.yellow--text.text--lighten-5 {\n  color: #fffde7 !important;\n  caret-color: #fffde7 !important;\n}\n.yellow.lighten-4 {\n  background-color: #fff9c4 !important;\n  border-color: #fff9c4 !important;\n}\n.yellow--text.text--lighten-4 {\n  color: #fff9c4 !important;\n  caret-color: #fff9c4 !important;\n}\n.yellow.lighten-3 {\n  background-color: #fff59d !important;\n  border-color: #fff59d !important;\n}\n.yellow--text.text--lighten-3 {\n  color: #fff59d !important;\n  caret-color: #fff59d !important;\n}\n.yellow.lighten-2 {\n  background-color: #fff176 !important;\n  border-color: #fff176 !important;\n}\n.yellow--text.text--lighten-2 {\n  color: #fff176 !important;\n  caret-color: #fff176 !important;\n}\n.yellow.lighten-1 {\n  background-color: #ffee58 !important;\n  border-color: #ffee58 !important;\n}\n.yellow--text.text--lighten-1 {\n  color: #ffee58 !important;\n  caret-color: #ffee58 !important;\n}\n.yellow.darken-1 {\n  background-color: #fdd835 !important;\n  border-color: #fdd835 !important;\n}\n.yellow--text.text--darken-1 {\n  color: #fdd835 !important;\n  caret-color: #fdd835 !important;\n}\n.yellow.darken-2 {\n  background-color: #fbc02d !important;\n  border-color: #fbc02d !important;\n}\n.yellow--text.text--darken-2 {\n  color: #fbc02d !important;\n  caret-color: #fbc02d !important;\n}\n.yellow.darken-3 {\n  background-color: #f9a825 !important;\n  border-color: #f9a825 !important;\n}\n.yellow--text.text--darken-3 {\n  color: #f9a825 !important;\n  caret-color: #f9a825 !important;\n}\n.yellow.darken-4 {\n  background-color: #f57f17 !important;\n  border-color: #f57f17 !important;\n}\n.yellow--text.text--darken-4 {\n  color: #f57f17 !important;\n  caret-color: #f57f17 !important;\n}\n.yellow.accent-1 {\n  background-color: #ffff8d !important;\n  border-color: #ffff8d !important;\n}\n.yellow--text.text--accent-1 {\n  color: #ffff8d !important;\n  caret-color: #ffff8d !important;\n}\n.yellow.accent-2 {\n  background-color: #ff0 !important;\n  border-color: #ff0 !important;\n}\n.yellow--text.text--accent-2 {\n  color: #ff0 !important;\n  caret-color: #ff0 !important;\n}\n.yellow.accent-3 {\n  background-color: #ffea00 !important;\n  border-color: #ffea00 !important;\n}\n.yellow--text.text--accent-3 {\n  color: #ffea00 !important;\n  caret-color: #ffea00 !important;\n}\n.yellow.accent-4 {\n  background-color: #ffd600 !important;\n  border-color: #ffd600 !important;\n}\n.yellow--text.text--accent-4 {\n  color: #ffd600 !important;\n  caret-color: #ffd600 !important;\n}\n.amber {\n  background-color: #ffc107 !important;\n  border-color: #ffc107 !important;\n}\n.amber--text {\n  color: #ffc107 !important;\n  caret-color: #ffc107 !important;\n}\n.amber.lighten-5 {\n  background-color: #fff8e1 !important;\n  border-color: #fff8e1 !important;\n}\n.amber--text.text--lighten-5 {\n  color: #fff8e1 !important;\n  caret-color: #fff8e1 !important;\n}\n.amber.lighten-4 {\n  background-color: #ffecb3 !important;\n  border-color: #ffecb3 !important;\n}\n.amber--text.text--lighten-4 {\n  color: #ffecb3 !important;\n  caret-color: #ffecb3 !important;\n}\n.amber.lighten-3 {\n  background-color: #ffe082 !important;\n  border-color: #ffe082 !important;\n}\n.amber--text.text--lighten-3 {\n  color: #ffe082 !important;\n  caret-color: #ffe082 !important;\n}\n.amber.lighten-2 {\n  background-color: #ffd54f !important;\n  border-color: #ffd54f !important;\n}\n.amber--text.text--lighten-2 {\n  color: #ffd54f !important;\n  caret-color: #ffd54f !important;\n}\n.amber.lighten-1 {\n  background-color: #ffca28 !important;\n  border-color: #ffca28 !important;\n}\n.amber--text.text--lighten-1 {\n  color: #ffca28 !important;\n  caret-color: #ffca28 !important;\n}\n.amber.darken-1 {\n  background-color: #ffb300 !important;\n  border-color: #ffb300 !important;\n}\n.amber--text.text--darken-1 {\n  color: #ffb300 !important;\n  caret-color: #ffb300 !important;\n}\n.amber.darken-2 {\n  background-color: #ffa000 !important;\n  border-color: #ffa000 !important;\n}\n.amber--text.text--darken-2 {\n  color: #ffa000 !important;\n  caret-color: #ffa000 !important;\n}\n.amber.darken-3 {\n  background-color: #ff8f00 !important;\n  border-color: #ff8f00 !important;\n}\n.amber--text.text--darken-3 {\n  color: #ff8f00 !important;\n  caret-color: #ff8f00 !important;\n}\n.amber.darken-4 {\n  background-color: #ff6f00 !important;\n  border-color: #ff6f00 !important;\n}\n.amber--text.text--darken-4 {\n  color: #ff6f00 !important;\n  caret-color: #ff6f00 !important;\n}\n.amber.accent-1 {\n  background-color: #ffe57f !important;\n  border-color: #ffe57f !important;\n}\n.amber--text.text--accent-1 {\n  color: #ffe57f !important;\n  caret-color: #ffe57f !important;\n}\n.amber.accent-2 {\n  background-color: #ffd740 !important;\n  border-color: #ffd740 !important;\n}\n.amber--text.text--accent-2 {\n  color: #ffd740 !important;\n  caret-color: #ffd740 !important;\n}\n.amber.accent-3 {\n  background-color: #ffc400 !important;\n  border-color: #ffc400 !important;\n}\n.amber--text.text--accent-3 {\n  color: #ffc400 !important;\n  caret-color: #ffc400 !important;\n}\n.amber.accent-4 {\n  background-color: #ffab00 !important;\n  border-color: #ffab00 !important;\n}\n.amber--text.text--accent-4 {\n  color: #ffab00 !important;\n  caret-color: #ffab00 !important;\n}\n.orange {\n  background-color: #ff9800 !important;\n  border-color: #ff9800 !important;\n}\n.orange--text {\n  color: #ff9800 !important;\n  caret-color: #ff9800 !important;\n}\n.orange.lighten-5 {\n  background-color: #fff3e0 !important;\n  border-color: #fff3e0 !important;\n}\n.orange--text.text--lighten-5 {\n  color: #fff3e0 !important;\n  caret-color: #fff3e0 !important;\n}\n.orange.lighten-4 {\n  background-color: #ffe0b2 !important;\n  border-color: #ffe0b2 !important;\n}\n.orange--text.text--lighten-4 {\n  color: #ffe0b2 !important;\n  caret-color: #ffe0b2 !important;\n}\n.orange.lighten-3 {\n  background-color: #ffcc80 !important;\n  border-color: #ffcc80 !important;\n}\n.orange--text.text--lighten-3 {\n  color: #ffcc80 !important;\n  caret-color: #ffcc80 !important;\n}\n.orange.lighten-2 {\n  background-color: #ffb74d !important;\n  border-color: #ffb74d !important;\n}\n.orange--text.text--lighten-2 {\n  color: #ffb74d !important;\n  caret-color: #ffb74d !important;\n}\n.orange.lighten-1 {\n  background-color: #ffa726 !important;\n  border-color: #ffa726 !important;\n}\n.orange--text.text--lighten-1 {\n  color: #ffa726 !important;\n  caret-color: #ffa726 !important;\n}\n.orange.darken-1 {\n  background-color: #fb8c00 !important;\n  border-color: #fb8c00 !important;\n}\n.orange--text.text--darken-1 {\n  color: #fb8c00 !important;\n  caret-color: #fb8c00 !important;\n}\n.orange.darken-2 {\n  background-color: #f57c00 !important;\n  border-color: #f57c00 !important;\n}\n.orange--text.text--darken-2 {\n  color: #f57c00 !important;\n  caret-color: #f57c00 !important;\n}\n.orange.darken-3 {\n  background-color: #ef6c00 !important;\n  border-color: #ef6c00 !important;\n}\n.orange--text.text--darken-3 {\n  color: #ef6c00 !important;\n  caret-color: #ef6c00 !important;\n}\n.orange.darken-4 {\n  background-color: #e65100 !important;\n  border-color: #e65100 !important;\n}\n.orange--text.text--darken-4 {\n  color: #e65100 !important;\n  caret-color: #e65100 !important;\n}\n.orange.accent-1 {\n  background-color: #ffd180 !important;\n  border-color: #ffd180 !important;\n}\n.orange--text.text--accent-1 {\n  color: #ffd180 !important;\n  caret-color: #ffd180 !important;\n}\n.orange.accent-2 {\n  background-color: #ffab40 !important;\n  border-color: #ffab40 !important;\n}\n.orange--text.text--accent-2 {\n  color: #ffab40 !important;\n  caret-color: #ffab40 !important;\n}\n.orange.accent-3 {\n  background-color: #ff9100 !important;\n  border-color: #ff9100 !important;\n}\n.orange--text.text--accent-3 {\n  color: #ff9100 !important;\n  caret-color: #ff9100 !important;\n}\n.orange.accent-4 {\n  background-color: #ff6d00 !important;\n  border-color: #ff6d00 !important;\n}\n.orange--text.text--accent-4 {\n  color: #ff6d00 !important;\n  caret-color: #ff6d00 !important;\n}\n.deep-orange {\n  background-color: #ff5722 !important;\n  border-color: #ff5722 !important;\n}\n.deep-orange--text {\n  color: #ff5722 !important;\n  caret-color: #ff5722 !important;\n}\n.deep-orange.lighten-5 {\n  background-color: #fbe9e7 !important;\n  border-color: #fbe9e7 !important;\n}\n.deep-orange--text.text--lighten-5 {\n  color: #fbe9e7 !important;\n  caret-color: #fbe9e7 !important;\n}\n.deep-orange.lighten-4 {\n  background-color: #ffccbc !important;\n  border-color: #ffccbc !important;\n}\n.deep-orange--text.text--lighten-4 {\n  color: #ffccbc !important;\n  caret-color: #ffccbc !important;\n}\n.deep-orange.lighten-3 {\n  background-color: #ffab91 !important;\n  border-color: #ffab91 !important;\n}\n.deep-orange--text.text--lighten-3 {\n  color: #ffab91 !important;\n  caret-color: #ffab91 !important;\n}\n.deep-orange.lighten-2 {\n  background-color: #ff8a65 !important;\n  border-color: #ff8a65 !important;\n}\n.deep-orange--text.text--lighten-2 {\n  color: #ff8a65 !important;\n  caret-color: #ff8a65 !important;\n}\n.deep-orange.lighten-1 {\n  background-color: #ff7043 !important;\n  border-color: #ff7043 !important;\n}\n.deep-orange--text.text--lighten-1 {\n  color: #ff7043 !important;\n  caret-color: #ff7043 !important;\n}\n.deep-orange.darken-1 {\n  background-color: #f4511e !important;\n  border-color: #f4511e !important;\n}\n.deep-orange--text.text--darken-1 {\n  color: #f4511e !important;\n  caret-color: #f4511e !important;\n}\n.deep-orange.darken-2 {\n  background-color: #e64a19 !important;\n  border-color: #e64a19 !important;\n}\n.deep-orange--text.text--darken-2 {\n  color: #e64a19 !important;\n  caret-color: #e64a19 !important;\n}\n.deep-orange.darken-3 {\n  background-color: #d84315 !important;\n  border-color: #d84315 !important;\n}\n.deep-orange--text.text--darken-3 {\n  color: #d84315 !important;\n  caret-color: #d84315 !important;\n}\n.deep-orange.darken-4 {\n  background-color: #bf360c !important;\n  border-color: #bf360c !important;\n}\n.deep-orange--text.text--darken-4 {\n  color: #bf360c !important;\n  caret-color: #bf360c !important;\n}\n.deep-orange.accent-1 {\n  background-color: #ff9e80 !important;\n  border-color: #ff9e80 !important;\n}\n.deep-orange--text.text--accent-1 {\n  color: #ff9e80 !important;\n  caret-color: #ff9e80 !important;\n}\n.deep-orange.accent-2 {\n  background-color: #ff6e40 !important;\n  border-color: #ff6e40 !important;\n}\n.deep-orange--text.text--accent-2 {\n  color: #ff6e40 !important;\n  caret-color: #ff6e40 !important;\n}\n.deep-orange.accent-3 {\n  background-color: #ff3d00 !important;\n  border-color: #ff3d00 !important;\n}\n.deep-orange--text.text--accent-3 {\n  color: #ff3d00 !important;\n  caret-color: #ff3d00 !important;\n}\n.deep-orange.accent-4 {\n  background-color: #dd2c00 !important;\n  border-color: #dd2c00 !important;\n}\n.deep-orange--text.text--accent-4 {\n  color: #dd2c00 !important;\n  caret-color: #dd2c00 !important;\n}\n.brown {\n  background-color: #795548 !important;\n  border-color: #795548 !important;\n}\n.brown--text {\n  color: #795548 !important;\n  caret-color: #795548 !important;\n}\n.brown.lighten-5 {\n  background-color: #efebe9 !important;\n  border-color: #efebe9 !important;\n}\n.brown--text.text--lighten-5 {\n  color: #efebe9 !important;\n  caret-color: #efebe9 !important;\n}\n.brown.lighten-4 {\n  background-color: #d7ccc8 !important;\n  border-color: #d7ccc8 !important;\n}\n.brown--text.text--lighten-4 {\n  color: #d7ccc8 !important;\n  caret-color: #d7ccc8 !important;\n}\n.brown.lighten-3 {\n  background-color: #bcaaa4 !important;\n  border-color: #bcaaa4 !important;\n}\n.brown--text.text--lighten-3 {\n  color: #bcaaa4 !important;\n  caret-color: #bcaaa4 !important;\n}\n.brown.lighten-2 {\n  background-color: #a1887f !important;\n  border-color: #a1887f !important;\n}\n.brown--text.text--lighten-2 {\n  color: #a1887f !important;\n  caret-color: #a1887f !important;\n}\n.brown.lighten-1 {\n  background-color: #8d6e63 !important;\n  border-color: #8d6e63 !important;\n}\n.brown--text.text--lighten-1 {\n  color: #8d6e63 !important;\n  caret-color: #8d6e63 !important;\n}\n.brown.darken-1 {\n  background-color: #6d4c41 !important;\n  border-color: #6d4c41 !important;\n}\n.brown--text.text--darken-1 {\n  color: #6d4c41 !important;\n  caret-color: #6d4c41 !important;\n}\n.brown.darken-2 {\n  background-color: #5d4037 !important;\n  border-color: #5d4037 !important;\n}\n.brown--text.text--darken-2 {\n  color: #5d4037 !important;\n  caret-color: #5d4037 !important;\n}\n.brown.darken-3 {\n  background-color: #4e342e !important;\n  border-color: #4e342e !important;\n}\n.brown--text.text--darken-3 {\n  color: #4e342e !important;\n  caret-color: #4e342e !important;\n}\n.brown.darken-4 {\n  background-color: #3e2723 !important;\n  border-color: #3e2723 !important;\n}\n.brown--text.text--darken-4 {\n  color: #3e2723 !important;\n  caret-color: #3e2723 !important;\n}\n.blue-grey {\n  background-color: #607d8b !important;\n  border-color: #607d8b !important;\n}\n.blue-grey--text {\n  color: #607d8b !important;\n  caret-color: #607d8b !important;\n}\n.blue-grey.lighten-5 {\n  background-color: #eceff1 !important;\n  border-color: #eceff1 !important;\n}\n.blue-grey--text.text--lighten-5 {\n  color: #eceff1 !important;\n  caret-color: #eceff1 !important;\n}\n.blue-grey.lighten-4 {\n  background-color: #cfd8dc !important;\n  border-color: #cfd8dc !important;\n}\n.blue-grey--text.text--lighten-4 {\n  color: #cfd8dc !important;\n  caret-color: #cfd8dc !important;\n}\n.blue-grey.lighten-3 {\n  background-color: #b0bec5 !important;\n  border-color: #b0bec5 !important;\n}\n.blue-grey--text.text--lighten-3 {\n  color: #b0bec5 !important;\n  caret-color: #b0bec5 !important;\n}\n.blue-grey.lighten-2 {\n  background-color: #90a4ae !important;\n  border-color: #90a4ae !important;\n}\n.blue-grey--text.text--lighten-2 {\n  color: #90a4ae !important;\n  caret-color: #90a4ae !important;\n}\n.blue-grey.lighten-1 {\n  background-color: #78909c !important;\n  border-color: #78909c !important;\n}\n.blue-grey--text.text--lighten-1 {\n  color: #78909c !important;\n  caret-color: #78909c !important;\n}\n.blue-grey.darken-1 {\n  background-color: #546e7a !important;\n  border-color: #546e7a !important;\n}\n.blue-grey--text.text--darken-1 {\n  color: #546e7a !important;\n  caret-color: #546e7a !important;\n}\n.blue-grey.darken-2 {\n  background-color: #455a64 !important;\n  border-color: #455a64 !important;\n}\n.blue-grey--text.text--darken-2 {\n  color: #455a64 !important;\n  caret-color: #455a64 !important;\n}\n.blue-grey.darken-3 {\n  background-color: #37474f !important;\n  border-color: #37474f !important;\n}\n.blue-grey--text.text--darken-3 {\n  color: #37474f !important;\n  caret-color: #37474f !important;\n}\n.blue-grey.darken-4 {\n  background-color: #263238 !important;\n  border-color: #263238 !important;\n}\n.blue-grey--text.text--darken-4 {\n  color: #263238 !important;\n  caret-color: #263238 !important;\n}\n.grey {\n  background-color: #9e9e9e !important;\n  border-color: #9e9e9e !important;\n}\n.grey--text {\n  color: #9e9e9e !important;\n  caret-color: #9e9e9e !important;\n}\n.grey.lighten-5 {\n  background-color: #fafafa !important;\n  border-color: #fafafa !important;\n}\n.grey--text.text--lighten-5 {\n  color: #fafafa !important;\n  caret-color: #fafafa !important;\n}\n.grey.lighten-4 {\n  background-color: #f5f5f5 !important;\n  border-color: #f5f5f5 !important;\n}\n.grey--text.text--lighten-4 {\n  color: #f5f5f5 !important;\n  caret-color: #f5f5f5 !important;\n}\n.grey.lighten-3 {\n  background-color: #eee !important;\n  border-color: #eee !important;\n}\n.grey--text.text--lighten-3 {\n  color: #eee !important;\n  caret-color: #eee !important;\n}\n.grey.lighten-2 {\n  background-color: #e0e0e0 !important;\n  border-color: #e0e0e0 !important;\n}\n.grey--text.text--lighten-2 {\n  color: #e0e0e0 !important;\n  caret-color: #e0e0e0 !important;\n}\n.grey.lighten-1 {\n  background-color: #bdbdbd !important;\n  border-color: #bdbdbd !important;\n}\n.grey--text.text--lighten-1 {\n  color: #bdbdbd !important;\n  caret-color: #bdbdbd !important;\n}\n.grey.darken-1 {\n  background-color: #757575 !important;\n  border-color: #757575 !important;\n}\n.grey--text.text--darken-1 {\n  color: #757575 !important;\n  caret-color: #757575 !important;\n}\n.grey.darken-2 {\n  background-color: #616161 !important;\n  border-color: #616161 !important;\n}\n.grey--text.text--darken-2 {\n  color: #616161 !important;\n  caret-color: #616161 !important;\n}\n.grey.darken-3 {\n  background-color: #424242 !important;\n  border-color: #424242 !important;\n}\n.grey--text.text--darken-3 {\n  color: #424242 !important;\n  caret-color: #424242 !important;\n}\n.grey.darken-4 {\n  background-color: #212121 !important;\n  border-color: #212121 !important;\n}\n.grey--text.text--darken-4 {\n  color: #212121 !important;\n  caret-color: #212121 !important;\n}\n.shades.black {\n  background-color: #000 !important;\n  border-color: #000 !important;\n}\n.shades--text.text--black {\n  color: #000 !important;\n  caret-color: #000 !important;\n}\n.shades.white {\n  background-color: #fff !important;\n  border-color: #fff !important;\n}\n.shades--text.text--white {\n  color: #fff !important;\n  caret-color: #fff !important;\n}\n.shades.transparent {\n  background-color: transparent !important;\n  border-color: transparent !important;\n}\n.shades--text.text--transparent {\n  color: transparent !important;\n  caret-color: transparent !important;\n}\n.elevation-0 {\n  box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-1 {\n  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-2 {\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-3 {\n  box-shadow: 0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-4 {\n  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-5 {\n  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 5px 8px 0px rgba(0,0,0,0.14), 0px 1px 14px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-6 {\n  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12) !important;\n}\n.elevation-7 {\n  box-shadow: 0px 4px 5px -2px rgba(0,0,0,0.2), 0px 7px 10px 1px rgba(0,0,0,0.14), 0px 2px 16px 1px rgba(0,0,0,0.12) !important;\n}\n.elevation-8 {\n  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12) !important;\n}\n.elevation-9 {\n  box-shadow: 0px 5px 6px -3px rgba(0,0,0,0.2), 0px 9px 12px 1px rgba(0,0,0,0.14), 0px 3px 16px 2px rgba(0,0,0,0.12) !important;\n}\n.elevation-10 {\n  box-shadow: 0px 6px 6px -3px rgba(0,0,0,0.2), 0px 10px 14px 1px rgba(0,0,0,0.14), 0px 4px 18px 3px rgba(0,0,0,0.12) !important;\n}\n.elevation-11 {\n  box-shadow: 0px 6px 7px -4px rgba(0,0,0,0.2), 0px 11px 15px 1px rgba(0,0,0,0.14), 0px 4px 20px 3px rgba(0,0,0,0.12) !important;\n}\n.elevation-12 {\n  box-shadow: 0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12) !important;\n}\n.elevation-13 {\n  box-shadow: 0px 7px 8px -4px rgba(0,0,0,0.2), 0px 13px 19px 2px rgba(0,0,0,0.14), 0px 5px 24px 4px rgba(0,0,0,0.12) !important;\n}\n.elevation-14 {\n  box-shadow: 0px 7px 9px -4px rgba(0,0,0,0.2), 0px 14px 21px 2px rgba(0,0,0,0.14), 0px 5px 26px 4px rgba(0,0,0,0.12) !important;\n}\n.elevation-15 {\n  box-shadow: 0px 8px 9px -5px rgba(0,0,0,0.2), 0px 15px 22px 2px rgba(0,0,0,0.14), 0px 6px 28px 5px rgba(0,0,0,0.12) !important;\n}\n.elevation-16 {\n  box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12) !important;\n}\n.elevation-17 {\n  box-shadow: 0px 8px 11px -5px rgba(0,0,0,0.2), 0px 17px 26px 2px rgba(0,0,0,0.14), 0px 6px 32px 5px rgba(0,0,0,0.12) !important;\n}\n.elevation-18 {\n  box-shadow: 0px 9px 11px -5px rgba(0,0,0,0.2), 0px 18px 28px 2px rgba(0,0,0,0.14), 0px 7px 34px 6px rgba(0,0,0,0.12) !important;\n}\n.elevation-19 {\n  box-shadow: 0px 9px 12px -6px rgba(0,0,0,0.2), 0px 19px 29px 2px rgba(0,0,0,0.14), 0px 7px 36px 6px rgba(0,0,0,0.12) !important;\n}\n.elevation-20 {\n  box-shadow: 0px 10px 13px -6px rgba(0,0,0,0.2), 0px 20px 31px 3px rgba(0,0,0,0.14), 0px 8px 38px 7px rgba(0,0,0,0.12) !important;\n}\n.elevation-21 {\n  box-shadow: 0px 10px 13px -6px rgba(0,0,0,0.2), 0px 21px 33px 3px rgba(0,0,0,0.14), 0px 8px 40px 7px rgba(0,0,0,0.12) !important;\n}\n.elevation-22 {\n  box-shadow: 0px 10px 14px -6px rgba(0,0,0,0.2), 0px 22px 35px 3px rgba(0,0,0,0.14), 0px 8px 42px 7px rgba(0,0,0,0.12) !important;\n}\n.elevation-23 {\n  box-shadow: 0px 11px 14px -7px rgba(0,0,0,0.2), 0px 23px 36px 3px rgba(0,0,0,0.14), 0px 9px 44px 8px rgba(0,0,0,0.12) !important;\n}\n.elevation-24 {\n  box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12) !important;\n}\nhtml {\n  box-sizing: border-box;\n  overflow-y: scroll; /* All browsers without overlaying scrollbars */\n  -webkit-text-size-adjust: 100%; /* iOS 8+ */\n}\n*,\n::before,\n::after {\n  box-sizing: inherit;\n}\n::before,\n::after {\n  text-decoration: inherit; /* Inherit text-decoration and vertical align to ::before and ::after pseudo elements */\n  vertical-align: inherit;\n}\n* {\n  background-repeat: no-repeat; /* Set `background-repeat: no-repeat` to all elements */\n  padding: 0; /* Reset `padding` and `margin` of all elements */\n  margin: 0;\n}\naudio:not([controls]) {\n  display: none;\n  height: 0;\n}\nhr {\n  overflow: visible; /* Show the overflow in Edge and IE */\n}\narticle,\naside,\ndetails,\nfigcaption,\nfigure,\nfooter,\nheader,\nmain,\nmenu,\nnav,\nsection,\nsummary {\n  display: block;\n}\nsummary {\n  display: list-item; /* Add the correct display in all browsers */\n}\nsmall {\n  font-size: 80%; /* Set font-size to 80% in `small` elements */\n}\n[hidden],\ntemplate {\n  display: none; /* Add the correct display in IE */\n}\nabbr[title] {\n  border-bottom: 1px dotted; /* Add a bordered underline effect in all browsers */\n  text-decoration: none; /* Remove text decoration in Firefox 40+ */\n}\na {\n  background-color: transparent; /* Remove the gray background on active links in IE 10 */\n  -webkit-text-decoration-skip: objects; /* Remove gaps in links underline in iOS 8+ and Safari 8+ */\n}\na:active,\na:hover {\n  outline-width: 0; /* Remove the outline when hovering in all browsers */\n}\ncode,\nkbd,\npre,\nsamp {\n  font-family: monospace, monospace; /* Specify the font family of code elements */\n}\nb,\nstrong {\n  font-weight: bolder; /* Correct style set to `bold` in Edge 12+, Safari 6.2+, and Chrome 18+ */\n}\ndfn {\n  font-style: italic; /* Address styling not present in Safari and Chrome */\n}\nmark {\n  background-color: #ff0;\n  color: #000;\n}\nsub,\nsup {\n  font-size: 75%;\n  line-height: 0;\n  position: relative;\n  vertical-align: baseline;\n}\nsub {\n  bottom: -0.25em;\n}\nsup {\n  top: -0.5em;\n}\ninput {\n  border-radius: 0;\n}\nbutton,\n[type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"],\n[role=\"button\"] {\n  cursor: pointer;\n}\n[disabled] {\n  cursor: default;\n}\n[type=\"number\"] {\n  width: auto; /* Firefox 36+ */\n}\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* Safari 8+ */\n}\n[type=\"search\"]::-webkit-search-cancel-button,\n[type=\"search\"]::-webkit-search-decoration {\n  -webkit-appearance: none; /* Safari 8 */\n}\ntextarea {\n  overflow: auto; /* Internet Explorer 11+ */\n  resize: vertical; /* Specify textarea resizability */\n}\nbutton,\ninput,\noptgroup,\nselect,\ntextarea {\n  font: inherit; /* Specify font inheritance of form elements */\n}\noptgroup {\n  font-weight: bold; /* Restore the font weight unset by the previous rule. */\n}\nbutton {\n  overflow: visible; /* Address `overflow` set to `hidden` in IE 8/9/10/11 */\n}\nbutton::-moz-focus-inner,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  border-style: 0;\n  padding: 0;\n}\nbutton:-moz-focusring,\n[type=\"button\"]::-moz-focus-inner,\n[type=\"reset\"]::-moz-focus-inner,\n[type=\"submit\"]::-moz-focus-inner {\n  outline: 0;\n  border: 0;\n}\nbutton,\nhtml [type=\"button\"],\n[type=\"reset\"],\n[type=\"submit\"] {\n  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS */\n}\nbutton,\nselect {\n  text-transform: none; /* Firefox 40+, Internet Explorer 11- */\n}\nbutton,\ninput,\nselect,\ntextarea {\n  background-color: transparent;\n  border-style: none;\n  color: inherit;\n}\nselect {\n  -moz-appearance: none; /* Firefox 36+ */\n  -webkit-appearance: none; /* Chrome 41+ */\n}\nselect::-ms-expand {\n  display: none; /* Internet Explorer 11+ */\n}\nselect::-ms-value {\n  color: currentColor; /* Internet Explorer 11+ */\n}\nlegend {\n  border: 0; /* Correct `color` not being inherited in IE 8/9/10/11 */\n  color: inherit; /* Correct the color inheritance from `fieldset` elements in IE */\n  display: table; /* Correct the text wrapping in Edge and IE */\n  max-width: 100%; /* Correct the text wrapping in Edge and IE */\n  white-space: normal; /* Correct the text wrapping in Edge and IE */\n}\n::-webkit-file-upload-button {\n  -webkit-appearance: button; /* Correct the inability to style clickable types in iOS and Safari */\n  font: inherit; /* Change font properties to `inherit` in Chrome and Safari */\n}\n[type=\"search\"] {\n  -webkit-appearance: textfield; /* Correct the odd appearance in Chrome and Safari */\n  outline-offset: -2px; /* Correct the outline style in Safari */\n}\nimg {\n  border-style: none; /* Remove border when inside `a` element in IE 8/9/10 */\n}\nprogress {\n  vertical-align: baseline;\n}\nsvg:not(:root) {\n  overflow: hidden; /* Internet Explorer 11- */\n}\naudio,\ncanvas,\nprogress,\nvideo {\n  display: inline-block; /* Internet Explorer 11+, Windows Phone 8.1+ */\n}\n[aria-busy=\"true\"] {\n  cursor: progress;\n}\n[aria-controls] {\n  cursor: pointer;\n}\n[aria-disabled] {\n  cursor: default;\n}\n::selection {\n  background-color: #b3d4fc; /* Required when declaring ::selection */\n  color: #000;\n  text-shadow: none;\n}\n.bottom-sheet-transition-enter {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n.bottom-sheet-transition-leave-to {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n.carousel-transition-enter {\n  -webkit-transform: translate(100%, 0);\n          transform: translate(100%, 0);\n}\n.carousel-transition-leave,\n.carousel-transition-leave-to {\n  position: absolute;\n  top: 0;\n  -webkit-transform: translate(-100%, 0);\n          transform: translate(-100%, 0);\n}\n.carousel-reverse-transition-enter {\n  -webkit-transform: translate(-100%, 0);\n          transform: translate(-100%, 0);\n}\n.carousel-reverse-transition-leave,\n.carousel-reverse-transition-leave-to {\n  position: absolute;\n  top: 0;\n  -webkit-transform: translate(100%, 0);\n          transform: translate(100%, 0);\n}\n.dialog-transition-enter,\n.dialog-transition-leave-to {\n  -webkit-transform: scale(0.5);\n          transform: scale(0.5);\n  opacity: 0;\n}\n.dialog-transition-enter-to,\n.dialog-transition-leave {\n  opacity: 1;\n}\n.dialog-bottom-transition-enter,\n.dialog-bottom-transition-leave-to {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n.picker-transition-enter-active,\n.picker-reverse-transition-enter-active,\n.picker-transition-leave-active,\n.picker-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0, 0, 0.2, 1);\n}\n.picker-transition-enter,\n.picker-reverse-transition-enter,\n.picker-transition-leave-to,\n.picker-reverse-transition-leave-to {\n  opacity: 0;\n}\n.picker-transition-leave,\n.picker-reverse-transition-leave,\n.picker-transition-leave-active,\n.picker-reverse-transition-leave-active,\n.picker-transition-leave-to,\n.picker-reverse-transition-leave-to {\n  position: absolute !important;\n}\n.picker-transition-enter {\n  -webkit-transform: translate(0, 100%);\n          transform: translate(0, 100%);\n}\n.picker-transition-leave-to {\n  -webkit-transform: translate(0, -100%);\n          transform: translate(0, -100%);\n}\n.picker-reverse-transition-enter {\n  -webkit-transform: translate(0, -100%);\n          transform: translate(0, -100%);\n}\n.picker-reverse-transition-leave-to {\n  -webkit-transform: translate(0, 100%);\n          transform: translate(0, 100%);\n}\n.picker-title-transition-enter-to,\n.picker-title-transition-leave {\n  -webkit-transform: translate(0, 0);\n          transform: translate(0, 0);\n}\n.picker-title-transition-enter {\n  -webkit-transform: translate(-100%, 0);\n          transform: translate(-100%, 0);\n}\n.picker-title-transition-leave-to {\n  opacity: 0;\n  -webkit-transform: translate(100%, 0);\n          transform: translate(100%, 0);\n}\n.picker-title-transition-leave,\n.picker-title-transition-leave-to,\n.picker-title-transition-leave-active {\n  position: absolute !important;\n}\n.tab-transition-enter {\n  -webkit-transform: translate(100%, 0);\n          transform: translate(100%, 0);\n}\n.tab-transition-leave,\n.tab-transition-leave-active {\n  position: absolute;\n  top: 0;\n}\n.tab-transition-leave-to {\n  position: absolute;\n  -webkit-transform: translate(-100%, 0);\n          transform: translate(-100%, 0);\n}\n.tab-reverse-transition-enter {\n  -webkit-transform: translate(-100%, 0);\n          transform: translate(-100%, 0);\n}\n.tab-reverse-transition-leave,\n.tab-reverse-transition-leave-to {\n  top: 0;\n  position: absolute;\n  -webkit-transform: translate(100%, 0);\n          transform: translate(100%, 0);\n}\n.expand-transition-enter-active,\n.expand-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.expand-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.expand-x-transition-enter-active,\n.expand-x-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.expand-x-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.scale-transition-enter-active,\n.scale-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scale-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.scale-transition-enter,\n.scale-transition-leave,\n.scale-transition-leave-to {\n  opacity: 0;\n  -webkit-transform: scale(0);\n          transform: scale(0);\n}\n.message-transition-enter-active,\n.message-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.message-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.message-transition-enter,\n.message-transition-leave-to {\n  opacity: 0;\n  -webkit-transform: translateY(-15px);\n          transform: translateY(-15px);\n}\n.message-transition-leave,\n.message-transition-leave-active {\n  position: absolute;\n}\n.slide-y-transition-enter-active,\n.slide-y-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.slide-y-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.slide-y-transition-enter,\n.slide-y-transition-leave-to {\n  opacity: 0;\n  -webkit-transform: translateY(-15px);\n          transform: translateY(-15px);\n}\n.slide-y-reverse-transition-enter-active,\n.slide-y-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.slide-y-reverse-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.slide-y-reverse-transition-enter,\n.slide-y-reverse-transition-leave-to {\n  opacity: 0;\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n}\n.scroll-y-transition-enter-active,\n.scroll-y-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scroll-y-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.scroll-y-transition-enter,\n.scroll-y-transition-leave-to {\n  opacity: 0;\n}\n.scroll-y-transition-enter {\n  -webkit-transform: translateY(-15px);\n          transform: translateY(-15px);\n}\n.scroll-y-transition-leave-to {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n}\n.scroll-y-reverse-transition-enter-active,\n.scroll-y-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scroll-y-reverse-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.scroll-y-reverse-transition-enter,\n.scroll-y-reverse-transition-leave-to {\n  opacity: 0;\n}\n.scroll-y-reverse-transition-enter {\n  -webkit-transform: translateY(15px);\n          transform: translateY(15px);\n}\n.scroll-y-reverse-transition-leave-to {\n  -webkit-transform: translateY(-15px);\n          transform: translateY(-15px);\n}\n.scroll-x-transition-enter-active,\n.scroll-x-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scroll-x-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.scroll-x-transition-enter,\n.scroll-x-transition-leave-to {\n  opacity: 0;\n}\n.scroll-x-transition-enter {\n  -webkit-transform: translateX(-15px);\n          transform: translateX(-15px);\n}\n.scroll-x-transition-leave-to {\n  -webkit-transform: translateX(15px);\n          transform: translateX(15px);\n}\n.scroll-x-reverse-transition-enter-active,\n.scroll-x-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.scroll-x-reverse-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.scroll-x-reverse-transition-enter,\n.scroll-x-reverse-transition-leave-to {\n  opacity: 0;\n}\n.scroll-x-reverse-transition-enter {\n  -webkit-transform: translateX(15px);\n          transform: translateX(15px);\n}\n.scroll-x-reverse-transition-leave-to {\n  -webkit-transform: translateX(-15px);\n          transform: translateX(-15px);\n}\n.slide-x-transition-enter-active,\n.slide-x-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.slide-x-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.slide-x-transition-enter,\n.slide-x-transition-leave-to {\n  opacity: 0;\n  -webkit-transform: translateX(-15px);\n          transform: translateX(-15px);\n}\n.slide-x-reverse-transition-enter-active,\n.slide-x-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.slide-x-reverse-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.slide-x-reverse-transition-enter,\n.slide-x-reverse-transition-leave-to {\n  opacity: 0;\n  -webkit-transform: translateX(15px);\n          transform: translateX(15px);\n}\n.fade-transition-enter-active,\n.fade-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.fade-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.fade-transition-enter,\n.fade-transition-leave-to {\n  opacity: 0;\n}\n.fab-transition-enter-active,\n.fab-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.fab-transition-move {\n  transition: -webkit-transform 0.6s;\n  transition: transform 0.6s;\n  transition: transform 0.6s, -webkit-transform 0.6s;\n}\n.fab-transition-enter,\n.fab-transition-leave-to {\n  -webkit-transform: scale(0) rotate(-45deg);\n          transform: scale(0) rotate(-45deg);\n}\n.blockquote {\n  padding: 16px 0 16px 24px;\n  font-size: 18px;\n  font-weight: 300;\n}\ncode,\nkbd {\n  display: inline-block;\n  border-radius: 3px;\n  white-space: pre-wrap;\n  font-size: 85%;\n  font-weight: 900;\n}\ncode:after,\nkbd:after,\ncode:before,\nkbd:before {\n  content: \"\\00a0\";\n  letter-spacing: -1px;\n}\ncode {\n  background-color: #f5f5f5;\n  color: #bd4147;\n  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);\n}\nkbd {\n  background: #616161;\n  color: #fff;\n}\nhtml {\n  font-size: 14px;\n  overflow-x: hidden;\n  text-rendering: optimizeLegibility;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n  -webkit-tap-highlight-color: rgba(0,0,0,0);\n}\n.application {\n  font-family: 'Roboto', sans-serif;\n  line-height: 1.5;\n}\n::-ms-clear,\n::-ms-reveal {\n  display: none;\n}\nul,\nol {\n  padding-left: 24px;\n}\n.display-4 {\n  font-size: 112px !important;\n  font-weight: 300;\n  line-height: 1 !important;\n  letter-spacing: -0.04em !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.display-3 {\n  font-size: 56px !important;\n  font-weight: 400;\n  line-height: 1.35 !important;\n  letter-spacing: -0.02em !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.display-2 {\n  font-size: 45px !important;\n  font-weight: 400;\n  line-height: 48px !important;\n  letter-spacing: normal !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.display-1 {\n  font-size: 34px !important;\n  font-weight: 400;\n  line-height: 40px !important;\n  letter-spacing: normal !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.headline {\n  font-size: 24px !important;\n  font-weight: 400;\n  line-height: 32px !important;\n  letter-spacing: normal !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.title {\n  font-size: 20px !important;\n  font-weight: 500;\n  line-height: 1 !important;\n  letter-spacing: 0.02em !important;\n  font-family: 'Roboto', sans-serif !important;\n}\n.subheading {\n  font-size: 16px !important;\n  font-weight: 400;\n}\n.body-2 {\n  font-size: 14px !important;\n  font-weight: 500;\n}\n.body-1 {\n  font-size: 14px !important;\n  font-weight: 400;\n}\n.caption {\n  font-size: 12px !important;\n  font-weight: 400;\n}\np {\n  margin-bottom: 16px;\n}\n.overflow-hidden {\n  overflow: hidden;\n}\n.overflow-x-hidden {\n  overflow-x: hidden;\n}\n.overflow-y-hidden {\n  overflow-y: hidden;\n}\n.right {\n  float: right !important;\n}\n.left {\n  float: left !important;\n}\n.ma-auto {\n  margin-top: auto !important;\n  margin-right: auto !important;\n  margin-bottom: auto !important;\n  margin-left: auto !important;\n}\n.my-auto {\n  margin-top: auto !important;\n  margin-bottom: auto !important;\n}\n.mx-auto {\n  margin-left: auto !important;\n  margin-right: auto !important;\n}\n.mt-auto {\n  margin-top: auto !important;\n}\n.mr-auto {\n  margin-right: auto !important;\n}\n.mb-auto {\n  margin-bottom: auto !important;\n}\n.ml-auto {\n  margin-left: auto !important;\n}\n.ma-0 {\n  margin: 0 0 !important;\n}\n.my-0 {\n  margin-top: 0 !important;\n  margin-bottom: 0 !important;\n}\n.mx-0 {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n.mt-0 {\n  margin-top: 0 !important;\n}\n.mr-0 {\n  margin-right: 0 !important;\n}\n.mb-0 {\n  margin-bottom: 0 !important;\n}\n.ml-0 {\n  margin-left: 0 !important;\n}\n.pa-0 {\n  padding: 0 0 !important;\n}\n.py-0 {\n  padding-top: 0 !important;\n  padding-bottom: 0 !important;\n}\n.px-0 {\n  padding-left: 0 !important;\n  padding-right: 0 !important;\n}\n.pt-0 {\n  padding-top: 0 !important;\n}\n.pr-0 {\n  padding-right: 0 !important;\n}\n.pb-0 {\n  padding-bottom: 0 !important;\n}\n.pl-0 {\n  padding-left: 0 !important;\n}\n.ma-1 {\n  margin: 4px 4px !important;\n}\n.my-1 {\n  margin-top: 4px !important;\n  margin-bottom: 4px !important;\n}\n.mx-1 {\n  margin-left: 4px !important;\n  margin-right: 4px !important;\n}\n.mt-1 {\n  margin-top: 4px !important;\n}\n.mr-1 {\n  margin-right: 4px !important;\n}\n.mb-1 {\n  margin-bottom: 4px !important;\n}\n.ml-1 {\n  margin-left: 4px !important;\n}\n.pa-1 {\n  padding: 4px 4px !important;\n}\n.py-1 {\n  padding-top: 4px !important;\n  padding-bottom: 4px !important;\n}\n.px-1 {\n  padding-left: 4px !important;\n  padding-right: 4px !important;\n}\n.pt-1 {\n  padding-top: 4px !important;\n}\n.pr-1 {\n  padding-right: 4px !important;\n}\n.pb-1 {\n  padding-bottom: 4px !important;\n}\n.pl-1 {\n  padding-left: 4px !important;\n}\n.ma-2 {\n  margin: 8px 8px !important;\n}\n.my-2 {\n  margin-top: 8px !important;\n  margin-bottom: 8px !important;\n}\n.mx-2 {\n  margin-left: 8px !important;\n  margin-right: 8px !important;\n}\n.mt-2 {\n  margin-top: 8px !important;\n}\n.mr-2 {\n  margin-right: 8px !important;\n}\n.mb-2 {\n  margin-bottom: 8px !important;\n}\n.ml-2 {\n  margin-left: 8px !important;\n}\n.pa-2 {\n  padding: 8px 8px !important;\n}\n.py-2 {\n  padding-top: 8px !important;\n  padding-bottom: 8px !important;\n}\n.px-2 {\n  padding-left: 8px !important;\n  padding-right: 8px !important;\n}\n.pt-2 {\n  padding-top: 8px !important;\n}\n.pr-2 {\n  padding-right: 8px !important;\n}\n.pb-2 {\n  padding-bottom: 8px !important;\n}\n.pl-2 {\n  padding-left: 8px !important;\n}\n.ma-3 {\n  margin: 16px 16px !important;\n}\n.my-3 {\n  margin-top: 16px !important;\n  margin-bottom: 16px !important;\n}\n.mx-3 {\n  margin-left: 16px !important;\n  margin-right: 16px !important;\n}\n.mt-3 {\n  margin-top: 16px !important;\n}\n.mr-3 {\n  margin-right: 16px !important;\n}\n.mb-3 {\n  margin-bottom: 16px !important;\n}\n.ml-3 {\n  margin-left: 16px !important;\n}\n.pa-3 {\n  padding: 16px 16px !important;\n}\n.py-3 {\n  padding-top: 16px !important;\n  padding-bottom: 16px !important;\n}\n.px-3 {\n  padding-left: 16px !important;\n  padding-right: 16px !important;\n}\n.pt-3 {\n  padding-top: 16px !important;\n}\n.pr-3 {\n  padding-right: 16px !important;\n}\n.pb-3 {\n  padding-bottom: 16px !important;\n}\n.pl-3 {\n  padding-left: 16px !important;\n}\n.ma-4 {\n  margin: 24px 24px !important;\n}\n.my-4 {\n  margin-top: 24px !important;\n  margin-bottom: 24px !important;\n}\n.mx-4 {\n  margin-left: 24px !important;\n  margin-right: 24px !important;\n}\n.mt-4 {\n  margin-top: 24px !important;\n}\n.mr-4 {\n  margin-right: 24px !important;\n}\n.mb-4 {\n  margin-bottom: 24px !important;\n}\n.ml-4 {\n  margin-left: 24px !important;\n}\n.pa-4 {\n  padding: 24px 24px !important;\n}\n.py-4 {\n  padding-top: 24px !important;\n  padding-bottom: 24px !important;\n}\n.px-4 {\n  padding-left: 24px !important;\n  padding-right: 24px !important;\n}\n.pt-4 {\n  padding-top: 24px !important;\n}\n.pr-4 {\n  padding-right: 24px !important;\n}\n.pb-4 {\n  padding-bottom: 24px !important;\n}\n.pl-4 {\n  padding-left: 24px !important;\n}\n.ma-5 {\n  margin: 48px 48px !important;\n}\n.my-5 {\n  margin-top: 48px !important;\n  margin-bottom: 48px !important;\n}\n.mx-5 {\n  margin-left: 48px !important;\n  margin-right: 48px !important;\n}\n.mt-5 {\n  margin-top: 48px !important;\n}\n.mr-5 {\n  margin-right: 48px !important;\n}\n.mb-5 {\n  margin-bottom: 48px !important;\n}\n.ml-5 {\n  margin-left: 48px !important;\n}\n.pa-5 {\n  padding: 48px 48px !important;\n}\n.py-5 {\n  padding-top: 48px !important;\n  padding-bottom: 48px !important;\n}\n.px-5 {\n  padding-left: 48px !important;\n  padding-right: 48px !important;\n}\n.pt-5 {\n  padding-top: 48px !important;\n}\n.pr-5 {\n  padding-right: 48px !important;\n}\n.pb-5 {\n  padding-bottom: 48px !important;\n}\n.pl-5 {\n  padding-left: 48px !important;\n}\n.font-weight-thin {\n  font-weight: 100 !important;\n}\n.font-weight-light {\n  font-weight: 300 !important;\n}\n.font-weight-regular {\n  font-weight: 400 !important;\n}\n.font-weight-medium {\n  font-weight: 500 !important;\n}\n.font-weight-bold {\n  font-weight: 700 !important;\n}\n.font-weight-black {\n  font-weight: 900 !important;\n}\n.font-italic {\n  font-style: italic !important;\n}\n.text-capitalize {\n  text-transform: capitalize !important;\n}\n.text-lowercase {\n  text-transform: lowercase !important;\n}\n.text-none {\n  text-transform: none !important;\n}\n.text-uppercase {\n  text-transform: uppercase !important;\n}\n.text-no-wrap {\n  white-space: nowrap !important;\n}\n.text-truncate {\n  white-space: nowrap !important;\n  overflow: hidden !important;\n  text-overflow: ellipsis !important;\n  line-height: 1.1 !important;\n}\n.transition-fast-out-slow-in {\n  transition: 0.3s cubic-bezier(0.4, 0, 0.2, 1) !important;\n}\n.transition-linear-out-slow-in {\n  transition: 0.3s cubic-bezier(0, 0, 0.2, 1) !important;\n}\n.transition-fast-out-linear-in {\n  transition: 0.3s cubic-bezier(0.4, 0, 1, 1) !important;\n}\n.transition-ease-in-out {\n  transition: 0.3s cubic-bezier(0.4, 0, 0.6, 1) !important;\n}\n.transition-fast-in-fast-out {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1) !important;\n}\n.transition-swing {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1) !important;\n}\n@media screen {\n  [hidden~=\"screen\"] {\n    display: inherit;\n  }\n  [hidden~=\"screen\"]:not(:active):not(:focus):not(:target) {\n    position: absolute !important;\n    clip: rect(0 0 0 0) !important;\n  }\n}\n@media only print {\n  .hidden-print-only {\n    display: none !important;\n  }\n}\n@media only screen {\n  .hidden-screen-only {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 599px) {\n  .hidden-xs-only {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 600px) and (max-width: 959px) {\n  .hidden-sm-only {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 959px) {\n  .hidden-sm-and-down {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 600px) {\n  .hidden-sm-and-up {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 960px) and (max-width: 1263px) {\n  .hidden-md-only {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 1263px) {\n  .hidden-md-and-down {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 960px) {\n  .hidden-md-and-up {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 1264px) and (max-width: 1903px) {\n  .hidden-lg-only {\n    display: none !important;\n  }\n}\n@media only screen and (max-width: 1903px) {\n  .hidden-lg-and-down {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 1264px) {\n  .hidden-lg-and-up {\n    display: none !important;\n  }\n}\n@media only screen and (min-width: 1904px) {\n  .hidden-xl-only {\n    display: none !important;\n  }\n}\n@media all and (min-width: 0) {\n  .text-xs-left {\n    text-align: left !important;\n  }\n  .text-xs-center {\n    text-align: center !important;\n  }\n  .text-xs-right {\n    text-align: right !important;\n  }\n  .text-xs-justify {\n    text-align: justify !important;\n  }\n}\n@media all and (min-width: 600px) {\n  .text-sm-left {\n    text-align: left !important;\n  }\n  .text-sm-center {\n    text-align: center !important;\n  }\n  .text-sm-right {\n    text-align: right !important;\n  }\n  .text-sm-justify {\n    text-align: justify !important;\n  }\n}\n@media all and (min-width: 960px) {\n  .text-md-left {\n    text-align: left !important;\n  }\n  .text-md-center {\n    text-align: center !important;\n  }\n  .text-md-right {\n    text-align: right !important;\n  }\n  .text-md-justify {\n    text-align: justify !important;\n  }\n}\n@media all and (min-width: 1264px) {\n  .text-lg-left {\n    text-align: left !important;\n  }\n  .text-lg-center {\n    text-align: center !important;\n  }\n  .text-lg-right {\n    text-align: right !important;\n  }\n  .text-lg-justify {\n    text-align: justify !important;\n  }\n}\n@media all and (min-width: 1904px) {\n  .text-xl-left {\n    text-align: left !important;\n  }\n  .text-xl-center {\n    text-align: center !important;\n  }\n  .text-xl-right {\n    text-align: right !important;\n  }\n  .text-xl-justify {\n    text-align: justify !important;\n  }\n}\n\n.application {\n  display: flex;\n}\n.application a {\n  cursor: pointer;\n}\n.application--is-rtl {\n  direction: rtl;\n}\n.application--wrap {\n  flex: 1 1 auto;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  max-width: 100%;\n  position: relative;\n}\n.theme--light.application {\n  background: #fafafa;\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.application .text--primary {\n  color: rgba(0,0,0,0.87) !important;\n}\n.theme--light.application .text--secondary {\n  color: rgba(0,0,0,0.54) !important;\n}\n.theme--light.application .text--disabled {\n  color: rgba(0,0,0,0.38) !important;\n}\n.theme--dark.application {\n  background: #303030;\n  color: #fff;\n}\n.theme--dark.application .text--primary {\n  color: #fff !important;\n}\n.theme--dark.application .text--secondary {\n  color: rgba(255,255,255,0.7) !important;\n}\n.theme--dark.application .text--disabled {\n  color: rgba(255,255,255,0.5) !important;\n}\n@-moz-document url-prefix() {\n}\n@media print {\n  @-moz-document url-prefix() {\n    .application {\n      display: block;\n    }\n    .application--wrap {\n      display: block;\n    }\n  }\n}\n\n.v-alert {\n  border-radius: 0;\n  border-width: 4px 0 0 0;\n  border-style: solid;\n  color: #fff;\n  display: flex;\n  font-size: 14px;\n  margin: 4px auto;\n  padding: 16px;\n  position: relative;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-alert .v-alert__icon.v-icon,\n.v-alert__dismissible .v-icon {\n  align-self: center;\n  color: rgba(0,0,0,0.3);\n  font-size: 24px;\n}\n.v-alert--outline .v-icon {\n  color: inherit !important;\n}\n.v-alert__icon {\n  margin-right: 16px;\n}\n.v-alert__dismissible {\n  align-self: flex-start;\n  color: inherit;\n  margin-left: 16px;\n  margin-right: 0;\n  text-decoration: none;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-alert__dismissible:hover {\n  opacity: 0.8;\n}\n.v-alert--no-icon .v-alert__icon {\n  display: none;\n}\n.v-alert > div {\n  align-self: center;\n  flex: 1 1;\n}\n.v-alert.v-alert {\n  border-color: rgba(0,0,0,0.12) !important;\n}\n.v-alert.v-alert--outline {\n  border: 1px solid currentColor !important;\n}\n@media screen and (max-width: 600px) {\n  .v-alert__icon {\n    display: none;\n  }\n}\n\n/* Themes */\n.theme--light.v-icon {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-icon.v-icon--disabled {\n  color: rgba(0,0,0,0.38) !important;\n}\n.theme--dark.v-icon {\n  color: #fff;\n}\n.theme--dark.v-icon.v-icon--disabled {\n  color: rgba(255,255,255,0.5) !important;\n}\n.v-icon {\n  align-items: center;\n  display: inline-flex;\n  -webkit-font-feature-settings: 'liga';\n          font-feature-settings: 'liga';\n  font-size: 24px;\n  justify-content: center;\n  line-height: 1;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  vertical-align: text-bottom;\n}\n.v-icon--right {\n  margin-left: 16px;\n}\n.v-icon--left {\n  margin-right: 16px;\n}\n.v-icon.v-icon.v-icon--link {\n  cursor: pointer;\n}\n.v-icon--disabled {\n  pointer-events: none;\n  opacity: 0.6;\n}\n.v-icon--is-component {\n  height: 24px;\n}\n\n.v-autocomplete.v-input > .v-input__control > .v-input__slot {\n  cursor: text;\n}\n.v-autocomplete input {\n  align-self: center;\n}\n.v-autocomplete--is-selecting-index input {\n  opacity: 0;\n}\n.v-autocomplete.v-text-field--enclosed:not(.v-text-field--solo):not(.v-text-field--single-line) .v-select__slot > input {\n  margin-top: 24px;\n}\n.v-autocomplete:not(.v-input--is-disabled).v-select.v-text-field input {\n  pointer-events: inherit;\n}\n.v-autocomplete__content.v-menu__content {\n  border-radius: 0;\n}\n.v-autocomplete__content.v-menu__content .v-card {\n  border-radius: 0;\n}\n\n.theme--light.v-text-field > .v-input__control > .v-input__slot:before {\n  border-color: rgba(0,0,0,0.42);\n}\n.theme--light.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {\n  border-color: rgba(0,0,0,0.87);\n}\n.theme--light.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before {\n  border-image: repeating-linear-gradient(to right, rgba(0,0,0,0.38) 0px, rgba(0,0,0,0.38) 2px, transparent 2px, transparent 4px) 1 repeat;\n}\n.theme--light.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before .v-text-field__prefix,\n.theme--light.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before .v-text-field__suffix {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-text-field__prefix,\n.theme--light.v-text-field__suffix {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {\n  border-radius: 2px;\n  background: #fff;\n}\n.theme--light.v-text-field--solo-inverted.v-text-field--solo > .v-input__control > .v-input__slot {\n  background: rgba(0,0,0,0.16);\n}\n.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot {\n  background: #424242;\n}\n.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot .v-label,\n.theme--light.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot input {\n  color: #fff;\n}\n.theme--light.v-text-field--box > .v-input__control > .v-input__slot {\n  background: rgba(0,0,0,0.06);\n}\n.theme--light.v-text-field--box .v-text-field__prefix {\n  max-height: 32px;\n  margin-top: 22px;\n}\n.theme--light.v-text-field--box.v-input--is-dirty .v-text-field__prefix,\n.theme--light.v-text-field--box.v-input--is-focused .v-text-field__prefix,\n.theme--light.v-text-field--box.v-text-field--placeholder .v-text-field__prefix {\n  margin-top: 22px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.theme--light.v-text-field--box:not(.v-input--is-focused) > .v-input__control > .v-input__slot:hover {\n  background: rgba(0,0,0,0.12);\n}\n.theme--light.v-text-field--outline > .v-input__control > .v-input__slot {\n  border: 2px solid rgba(0,0,0,0.54);\n}\n.theme--light.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover {\n  border: 2px solid rgba(0,0,0,0.87);\n}\n.theme--dark.v-text-field > .v-input__control > .v-input__slot:before {\n  border-color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-text-field:not(.v-input--has-state) > .v-input__control > .v-input__slot:hover:before {\n  border-color: #fff;\n}\n.theme--dark.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before {\n  border-image: repeating-linear-gradient(to right, rgba(255,255,255,0.5) 0px, rgba(255,255,255,0.5) 2px, transparent 2px, transparent 4px) 1 repeat;\n}\n.theme--dark.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before .v-text-field__prefix,\n.theme--dark.v-text-field.v-input--is-disabled > .v-input__control > .v-input__slot:before .v-text-field__suffix {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-text-field__prefix,\n.theme--dark.v-text-field__suffix {\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-text-field--solo > .v-input__control > .v-input__slot {\n  border-radius: 2px;\n  background: #424242;\n}\n.theme--dark.v-text-field--solo-inverted.v-text-field--solo > .v-input__control > .v-input__slot {\n  background: rgba(255,255,255,0.16);\n}\n.theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot {\n  background: #fff;\n}\n.theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot .v-label,\n.theme--dark.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused > .v-input__control > .v-input__slot input {\n  color: rgba(0,0,0,0.87);\n}\n.theme--dark.v-text-field--box > .v-input__control > .v-input__slot {\n  background: rgba(0,0,0,0.1);\n}\n.theme--dark.v-text-field--box .v-text-field__prefix {\n  max-height: 32px;\n  margin-top: 22px;\n}\n.theme--dark.v-text-field--box.v-input--is-dirty .v-text-field__prefix,\n.theme--dark.v-text-field--box.v-input--is-focused .v-text-field__prefix,\n.theme--dark.v-text-field--box.v-text-field--placeholder .v-text-field__prefix {\n  margin-top: 22px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.theme--dark.v-text-field--box:not(.v-input--is-focused) > .v-input__control > .v-input__slot:hover {\n  background: rgba(0,0,0,0.2);\n}\n.theme--dark.v-text-field--outline > .v-input__control > .v-input__slot {\n  border: 2px solid rgba(255,255,255,0.7);\n}\n.theme--dark.v-text-field--outline:not(.v-input--is-focused):not(.v-input--has-state) > .v-input__control > .v-input__slot:hover {\n  border: 2px solid #fff;\n}\n.application--is-rtl .v-text-field .v-label {\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n.application--is-rtl .v-text-field .v-counter {\n  margin-left: 0;\n  margin-right: 8px;\n}\n.application--is-rtl .v-text-field--enclosed .v-input__append-outer {\n  margin-left: 0;\n  margin-right: 16px;\n}\n.application--is-rtl .v-text-field--enclosed .v-input__prepend-outer {\n  margin-left: 16px;\n  margin-right: 0;\n}\n.application--is-rtl .v-text-field--reverse input {\n  text-align: left;\n}\n.application--is-rtl .v-text-field--reverse .v-label {\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n}\n.application--is-rtl .v-text-field__prefix {\n  text-align: left;\n  padding-right: 0;\n  padding-left: 4px;\n}\n.application--is-rtl .v-text-field__suffix {\n  padding-left: 0;\n  padding-right: 4px;\n}\n.application--is-rtl .v-text-field--reverse .v-text-field__prefix {\n  text-align: right;\n  padding-left: 0;\n  padding-right: 4px;\n}\n.application--is-rtl .v-text-field--reverse .v-text-field__suffix {\n  padding-left: 0;\n  padding-right: 4px;\n}\n.v-text-field {\n  padding-top: 12px;\n  margin-top: 4px;\n}\n.v-text-field input {\n  flex: 1 1 auto;\n  line-height: 20px;\n  padding: 8px 0 8px;\n  max-width: 100%;\n  min-width: 0px;\n  width: 100%;\n}\n.v-text-field .v-input__prepend-inner,\n.v-text-field .v-input__append-inner {\n  align-self: flex-start;\n  display: inline-flex;\n  margin-top: 4px;\n  line-height: 1;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-text-field .v-input__prepend-inner {\n  margin-right: auto;\n  padding-right: 4px;\n}\n.v-text-field .v-input__append-inner {\n  margin-left: auto;\n  padding-left: 4px;\n}\n.v-text-field .v-counter {\n  margin-left: 8px;\n  white-space: nowrap;\n}\n.v-text-field .v-label {\n  max-width: 90%;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  top: 6px;\n  -webkit-transform-origin: top left;\n          transform-origin: top left;\n  white-space: nowrap;\n  pointer-events: none;\n}\n.v-text-field .v-label--active {\n  max-width: 133%;\n  -webkit-transform: translateY(-18px) scale(0.75);\n          transform: translateY(-18px) scale(0.75);\n}\n.v-text-field > .v-input__control > .v-input__slot {\n  cursor: text;\n  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-text-field > .v-input__control > .v-input__slot:before,\n.v-text-field > .v-input__control > .v-input__slot:after {\n  bottom: -1px;\n  content: '';\n  left: 0;\n  position: absolute;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 100%;\n}\n.v-text-field > .v-input__control > .v-input__slot:before {\n  border-style: solid;\n  border-width: thin 0 0 0;\n}\n.v-text-field > .v-input__control > .v-input__slot:after {\n  border-color: currentColor;\n  border-style: solid;\n  border-width: thin 0 thin 0;\n  -webkit-transform: scaleX(0);\n          transform: scaleX(0);\n}\n.v-text-field__details {\n  display: flex;\n  flex: 1 0 auto;\n  max-width: 100%;\n  overflow: hidden;\n}\n.v-text-field__prefix,\n.v-text-field__suffix {\n  align-self: center;\n  cursor: default;\n}\n.v-text-field__prefix {\n  text-align: right;\n  padding-right: 4px;\n}\n.v-text-field__suffix {\n  padding-left: 4px;\n  white-space: nowrap;\n}\n.v-text-field--reverse .v-text-field__prefix {\n  text-align: left;\n  padding-right: 0;\n  padding-left: 4px;\n}\n.v-text-field--reverse .v-text-field__suffix {\n  padding-left: 0;\n  padding-right: 4px;\n}\n.v-text-field > .v-input__control > .v-input__slot > .v-text-field__slot {\n  display: flex;\n  flex: 1 1 auto;\n  position: relative;\n}\n.v-text-field--box,\n.v-text-field--full-width,\n.v-text-field--outline {\n  position: relative;\n}\n.v-text-field--box > .v-input__control > .v-input__slot,\n.v-text-field--full-width > .v-input__control > .v-input__slot,\n.v-text-field--outline > .v-input__control > .v-input__slot {\n  align-items: stretch;\n  min-height: 56px;\n}\n.v-text-field--box input,\n.v-text-field--full-width input,\n.v-text-field--outline input {\n  margin-top: 22px;\n}\n.v-text-field--box.v-text-field--single-line input,\n.v-text-field--full-width.v-text-field--single-line input,\n.v-text-field--outline.v-text-field--single-line input {\n  margin-top: 12px;\n}\n.v-text-field--box .v-label,\n.v-text-field--full-width .v-label,\n.v-text-field--outline .v-label {\n  top: 18px;\n}\n.v-text-field--box .v-label--active,\n.v-text-field--full-width .v-label--active,\n.v-text-field--outline .v-label--active {\n  -webkit-transform: translateY(-6px) scale(0.75);\n          transform: translateY(-6px) scale(0.75);\n}\n.v-text-field--box > .v-input__control > .v-input__slot {\n  border-top-left-radius: 4px;\n  border-top-right-radius: 4px;\n}\n.v-text-field--box > .v-input__control > .v-input__slot:before {\n  border-style: solid;\n  border-width: thin 0 thin 0;\n}\n.v-text-field.v-text-field--enclosed {\n  margin: 0;\n  padding: 0;\n}\n.v-text-field.v-text-field--enclosed:not(.v-text-field--box) .v-progress-linear__background {\n  display: none;\n}\n.v-text-field.v-text-field--enclosed .v-input__prepend-outer,\n.v-text-field.v-text-field--enclosed .v-input__prepend-inner,\n.v-text-field.v-text-field--enclosed .v-input__append-inner,\n.v-text-field.v-text-field--enclosed .v-input__append-outer {\n  margin-top: 16px;\n}\n.v-text-field.v-text-field--enclosed .v-text-field__details,\n.v-text-field.v-text-field--enclosed > .v-input__control > .v-input__slot {\n  padding: 0 12px;\n}\n.v-text-field.v-text-field--enclosed .v-text-field__details {\n  margin-bottom: 8px;\n}\n.v-text-field--reverse input {\n  text-align: right;\n}\n.v-text-field--reverse .v-label {\n  -webkit-transform-origin: top right;\n          transform-origin: top right;\n}\n.v-text-field--reverse > .v-input__control > .v-input__slot,\n.v-text-field--reverse .v-text-field__slot {\n  flex-direction: row-reverse;\n}\n.v-text-field--solo > .v-input__control > .v-input__slot:before,\n.v-text-field--outline > .v-input__control > .v-input__slot:before,\n.v-text-field--full-width > .v-input__control > .v-input__slot:before,\n.v-text-field--solo > .v-input__control > .v-input__slot:after,\n.v-text-field--outline > .v-input__control > .v-input__slot:after,\n.v-text-field--full-width > .v-input__control > .v-input__slot:after {\n  display: none;\n}\n.v-text-field--outline {\n  margin-bottom: 16px;\n  transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-text-field--outline > .v-input__control > .v-input__slot {\n  background: transparent !important;\n  border-radius: 4px;\n}\n.v-text-field--outline .v-text-field__prefix {\n  margin-top: 22px;\n  max-height: 32px;\n}\n.v-text-field--outline .v-input__prepend-outer,\n.v-text-field--outline .v-input__append-outer {\n  margin-top: 18px;\n}\n.v-text-field--outline.v-input--is-dirty .v-text-field__prefix,\n.v-text-field--outline.v-input--is-focused .v-text-field__prefix,\n.v-text-field--outline.v-text-field--placeholder .v-text-field__prefix {\n  margin-top: 22px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-text-field--outline.v-input--is-focused > .v-input__control > .v-input__slot,\n.v-text-field--outline.v-input--has-state > .v-input__control > .v-input__slot {\n  border: 2px solid currentColor;\n  transition: border 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-text-field.v-text-field--solo .v-label {\n  top: calc(50% - 10px);\n}\n.v-text-field.v-text-field--solo .v-input__control {\n  min-height: 48px;\n  padding: 0;\n}\n.v-text-field.v-text-field--solo:not(.v-text-field--solo-flat) > .v-input__control > .v-input__slot {\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n}\n.v-text-field.v-text-field--solo .v-text-field__slot {\n  align-items: center;\n}\n.v-text-field.v-text-field--solo .v-input__append-inner,\n.v-text-field.v-text-field--solo .v-input__prepend-inner {\n  align-self: center;\n  margin-top: 0;\n}\n.v-text-field.v-text-field--solo .v-input__prepend-outer,\n.v-text-field.v-text-field--solo .v-input__append-outer {\n  margin-top: 12px;\n}\n.v-text-field.v-input--is-focused > .v-input__control > .v-input__slot:after {\n  -webkit-transform: scaleX(1);\n          transform: scaleX(1);\n}\n.v-text-field.v-input--has-state > .v-input__control > .v-input__slot:before {\n  border-color: currentColor;\n}\n\n.theme--light.v-select .v-select__selections {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-select.v-input--is-disabled .v-select__selections {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-select .v-chip--disabled,\n.theme--light.v-select .v-select__selection--disabled {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selections {\n  color: #fff;\n}\n.theme--dark.v-select .v-select__selections {\n  color: #fff;\n}\n.theme--dark.v-select.v-input--is-disabled .v-select__selections {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-select .v-chip--disabled,\n.theme--dark.v-select .v-select__selection--disabled {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-select.v-text-field--solo-inverted.v-input--is-focused .v-select__selections {\n  color: rgba(0,0,0,0.87);\n}\n.v-select {\n  position: relative;\n}\n.v-select > .v-input__control > .v-input__slot {\n  cursor: pointer;\n}\n.v-select .v-chip {\n  flex: 0 1 auto;\n}\n.v-select .fade-transition-leave-active {\n  position: absolute;\n  left: 0;\n}\n.v-select.v-input--is-dirty ::-webkit-input-placeholder {\n  color: transparent !important;\n}\n.v-select.v-input--is-dirty :-ms-input-placeholder {\n  color: transparent !important;\n}\n.v-select.v-input--is-dirty ::-ms-input-placeholder {\n  color: transparent !important;\n}\n.v-select.v-input--is-dirty ::placeholder {\n  color: transparent !important;\n}\n.v-select:not(.v-input--is-dirty):not(.v-input--is-focused) .v-text-field__prefix {\n  line-height: 20px;\n  position: absolute;\n  top: 7px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-select.v-text-field--enclosed:not(.v-text-field--single-line) .v-select__selections {\n  padding-top: 24px;\n}\n.v-select.v-text-field input {\n  flex: 1 1;\n  margin-top: 0;\n  min-width: 0;\n  pointer-events: none;\n  position: relative;\n}\n.v-select.v-select--is-menu-active .v-input__icon--append .v-icon {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n}\n.v-select.v-select--chips input {\n  margin: 0;\n}\n.v-select.v-select--chips .v-select__selections {\n  min-height: 42px;\n}\n.v-select.v-select--chips.v-select--chips--small .v-select__selections {\n  min-height: 32px;\n}\n.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box .v-select__selections,\n.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed .v-select__selections {\n  min-height: 68px;\n}\n.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--box.v-select--chips--small .v-select__selections,\n.v-select.v-select--chips:not(.v-text-field--single-line).v-text-field--enclosed.v-select--chips--small .v-select__selections {\n  min-height: 56px;\n}\n.v-select.v-text-field--reverse .v-select__slot,\n.v-select.v-text-field--reverse .v-select__selections {\n  flex-direction: row-reverse;\n}\n.v-select__selections {\n  align-items: center;\n  display: flex;\n  flex: 1 1 auto;\n  flex-wrap: wrap;\n  line-height: 18px;\n}\n.v-select__selection {\n  max-width: 90%;\n}\n.v-select__selection--comma {\n  align-items: center;\n  display: inline-flex;\n  margin: 7px 4px 7px 0;\n}\n.v-select__slot {\n  position: relative;\n  align-items: center;\n  display: flex;\n  width: 100%;\n}\n.v-select:not(.v-text-field--single-line) .v-select__slot > input {\n  align-self: flex-end;\n}\n\n.theme--light.v-chip {\n  background: #e0e0e0;\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-chip--disabled {\n  color: rgba(0,0,0,0.38);\n}\n.theme--dark.v-chip {\n  background: #555;\n  color: #fff;\n}\n.theme--dark.v-chip--disabled {\n  color: rgba(255,255,255,0.5);\n}\n.application--is-rtl .v-chip__close {\n  margin: 0 8px 0 2px;\n}\n.application--is-rtl .v-chip--removable .v-chip__content {\n  padding: 0 12px 0 4px;\n}\n.application--is-rtl .v-chip--select-multi {\n  margin: 4px 0 4px 4px;\n}\n.application--is-rtl .v-chip .v-avatar {\n  margin-right: -12px;\n  margin-left: 8px;\n}\n.application--is-rtl .v-chip .v-icon--right {\n  margin-right: 12px;\n  margin-left: -8px;\n}\n.application--is-rtl .v-chip .v-icon--left {\n  margin-right: -8px;\n  margin-left: 12px;\n}\n.v-chip {\n  align-items: center;\n  border-radius: 28px;\n  display: inline-flex;\n  font-size: 13px;\n  margin: 4px;\n  outline: none;\n  position: relative;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  vertical-align: middle;\n}\n.v-chip .v-chip__content {\n  align-items: center;\n  border-radius: 28px;\n  cursor: default;\n  display: inline-flex;\n  height: 32px;\n  justify-content: space-between;\n  padding: 0 12px;\n  vertical-align: middle;\n  white-space: nowrap;\n  z-index: 1;\n}\n.v-chip--removable .v-chip__content {\n  padding: 0 4px 0 12px;\n}\n.v-chip .v-avatar {\n  height: 32px !important;\n  margin-left: -12px;\n  margin-right: 8px;\n  min-width: 32px;\n  width: 32px !important;\n}\n.v-chip .v-avatar img {\n  height: 100%;\n  width: 100%;\n}\n.v-chip:focus:not(.v-chip--disabled),\n.v-chip--active,\n.v-chip--selected {\n  border-color: rgba(0,0,0,0.13);\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n}\n.v-chip:focus:not(.v-chip--disabled):after,\n.v-chip--active:after,\n.v-chip--selected:after {\n  background: currentColor;\n  border-radius: inherit;\n  content: '';\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  transition: inherit;\n  width: 100%;\n  pointer-events: none;\n  opacity: 0.13;\n}\n.v-chip--label {\n  border-radius: 2px;\n}\n.v-chip--label .v-chip__content {\n  border-radius: 2px;\n}\n.v-chip.v-chip.v-chip--outline {\n  background: transparent !important;\n  border: 1px solid currentColor;\n  color: #9e9e9e;\n  height: 32px;\n}\n.v-chip.v-chip.v-chip--outline .v-avatar {\n  margin-left: -13px;\n}\n.v-chip--small {\n  height: 24px !important;\n}\n.v-chip--small .v-avatar {\n  height: 24px !important;\n  min-width: 24px;\n  width: 24px !important;\n}\n.v-chip--small .v-icon {\n  font-size: 20px;\n}\n.v-chip__close {\n  align-items: center;\n  color: inherit;\n  display: flex;\n  font-size: 20px;\n  margin: 0 2px 0 8px;\n  text-decoration: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-chip__close > .v-icon {\n  color: inherit !important;\n  font-size: 20px;\n  cursor: pointer;\n  opacity: 0.5;\n}\n.v-chip__close > .v-icon:hover {\n  opacity: 1;\n}\n.v-chip--disabled .v-chip__close {\n  pointer-events: none;\n}\n.v-chip--select-multi {\n  margin: 4px 4px 4px 0;\n}\n.v-chip .v-icon {\n  color: inherit;\n}\n.v-chip .v-icon--right {\n  margin-left: 12px;\n  margin-right: -8px;\n}\n.v-chip .v-icon--left {\n  margin-left: -8px;\n  margin-right: 12px;\n}\n\n.v-menu {\n  display: block;\n  vertical-align: middle;\n}\n.v-menu--inline {\n  display: inline-block;\n}\n.v-menu__activator {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n}\n.v-menu__activator * {\n  cursor: pointer;\n}\n.v-menu__content {\n  position: absolute;\n  display: inline-block;\n  border-radius: 2px;\n  max-width: 80%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  contain: content;\n  will-change: transform;\n  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);\n}\n.v-menu__content--active {\n  pointer-events: none;\n}\n.v-menu__content--fixed {\n  position: fixed;\n}\n.v-menu__content > .card {\n  contain: content;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n.v-menu > .v-menu__content {\n  max-width: none;\n}\n.v-menu-transition-enter .v-list__tile {\n  min-width: 0;\n  pointer-events: none;\n}\n.v-menu-transition-enter-to .v-list__tile {\n  pointer-events: auto;\n  transition-delay: 0.1s;\n}\n.v-menu-transition-leave-active,\n.v-menu-transition-leave-to {\n  pointer-events: none;\n}\n.v-menu-transition-enter,\n.v-menu-transition-leave-to {\n  opacity: 0;\n}\n.v-menu-transition-enter-active,\n.v-menu-transition-leave-active {\n  transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.v-menu-transition-enter.v-menu__content--auto {\n  transition: none !important;\n}\n.v-menu-transition-enter.v-menu__content--auto .v-list__tile {\n  opacity: 0;\n  -webkit-transform: translateY(-15px);\n          transform: translateY(-15px);\n}\n.v-menu-transition-enter.v-menu__content--auto .v-list__tile--active {\n  opacity: 1;\n  -webkit-transform: none !important;\n          transform: none !important;\n  pointer-events: auto;\n}\n\n/* Themes */\n.theme--light.v-card {\n  background-color: #fff;\n  border-color: #fff;\n  color: rgba(0,0,0,0.87);\n}\n.theme--dark.v-card {\n  background-color: #424242;\n  border-color: #424242;\n  color: #fff;\n}\n.v-card {\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n  text-decoration: none;\n}\n.v-card > *:first-child:not(.v-btn):not(.v-chip) {\n  border-top-left-radius: inherit;\n  border-top-right-radius: inherit;\n}\n.v-card > *:last-child:not(.v-btn):not(.v-chip) {\n  border-bottom-left-radius: inherit;\n  border-bottom-right-radius: inherit;\n}\n.v-card--flat {\n  box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12);\n}\n.v-card--hover {\n  cursor: pointer;\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.25, 1);\n  transition-property: box-shadow;\n}\n.v-card--hover:hover {\n  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);\n}\n.v-card__title {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 16px;\n}\n.v-card__title--primary {\n  padding-top: 24px;\n}\n.v-card__text {\n  padding: 16px;\n  width: 100%;\n}\n.v-card__actions {\n  align-items: center;\n  display: flex;\n  padding: 8px;\n}\n.v-card__actions > *,\n.v-card__actions .v-btn {\n  margin: 0;\n}\n.v-card__actions .v-btn + .v-btn {\n  margin-left: 8px;\n}\n\n/** Theme */\n.theme--light.v-input--selection-controls.v-input--is-disabled .v-icon {\n  color: rgba(0,0,0,0.26) !important;\n}\n.theme--dark.v-input--selection-controls.v-input--is-disabled .v-icon {\n  color: rgba(255,255,255,0.3) !important;\n}\n.application--is-rtl .v-input--selection-controls .v-input--selection-controls__input {\n  margin-right: 0;\n  margin-left: 8px;\n}\n.v-input--selection-controls {\n  margin-top: 16px;\n  padding-top: 4px;\n}\n.v-input--selection-controls .v-input__append-outer,\n.v-input--selection-controls .v-input__prepend-outer {\n  margin-top: 0;\n  margin-bottom: 0;\n}\n.v-input--selection-controls .v-input__control {\n  flex-grow: 0;\n  width: auto;\n}\n.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {\n  margin-bottom: 12px;\n}\n.v-input--selection-controls__input {\n  color: inherit;\n  display: inline-flex;\n  flex: 0 0 auto;\n  height: 24px;\n  position: relative;\n  margin-right: 8px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  transition-property: color, -webkit-transform;\n  transition-property: color, transform;\n  transition-property: color, transform, -webkit-transform;\n  width: 24px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-input--selection-controls__input input {\n  position: absolute;\n  opacity: 0;\n  width: 100%;\n  height: 100%;\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-input--selection-controls__input + .v-label {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-input--selection-controls__ripple {\n  border-radius: 50%;\n  cursor: pointer;\n  height: 34px;\n  position: absolute;\n  transition: inherit;\n  width: 34px;\n  left: -12px;\n  top: calc(50% - 24px);\n  margin: 7px;\n}\n.v-input--selection-controls__ripple:before {\n  border-radius: inherit;\n  bottom: 0;\n  content: '';\n  position: absolute;\n  opacity: 0.2;\n  left: 0;\n  right: 0;\n  top: 0;\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n  -webkit-transform: scale(0.2);\n          transform: scale(0.2);\n  transition: inherit;\n}\n.v-input--selection-controls__ripple .v-ripple__container {\n  -webkit-transform: scale(1.4);\n          transform: scale(1.4);\n}\n.v-input--selection-controls.v-input .v-label {\n  align-items: center;\n  display: inline-flex;\n  top: 0;\n  height: auto;\n}\n.v-input--selection-controls.v-input--is-focused .v-input--selection-controls__ripple:before,\n.v-input--selection-controls .v-radio--is-focused .v-input--selection-controls__ripple:before {\n  background: currentColor;\n  -webkit-transform: scale(0.8);\n          transform: scale(0.8);\n}\n\n/* Theme */\n.theme--light.v-input:not(.v-input--is-disabled) input,\n.theme--light.v-input:not(.v-input--is-disabled) textarea {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-input input::-webkit-input-placeholder,\n.theme--light.v-input textarea::-webkit-input-placeholder {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-input input:-ms-input-placeholder,\n.theme--light.v-input textarea:-ms-input-placeholder {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-input input::-ms-input-placeholder,\n.theme--light.v-input textarea::-ms-input-placeholder {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-input input::placeholder,\n.theme--light.v-input textarea::placeholder {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-input--is-disabled .v-label,\n.theme--light.v-input--is-disabled input,\n.theme--light.v-input--is-disabled textarea {\n  color: rgba(0,0,0,0.38);\n}\n.theme--dark.v-input:not(.v-input--is-disabled) input,\n.theme--dark.v-input:not(.v-input--is-disabled) textarea {\n  color: #fff;\n}\n.theme--dark.v-input input::-webkit-input-placeholder,\n.theme--dark.v-input textarea::-webkit-input-placeholder {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-input input:-ms-input-placeholder,\n.theme--dark.v-input textarea:-ms-input-placeholder {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-input input::-ms-input-placeholder,\n.theme--dark.v-input textarea::-ms-input-placeholder {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-input input::placeholder,\n.theme--dark.v-input textarea::placeholder {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-input--is-disabled .v-label,\n.theme--dark.v-input--is-disabled input,\n.theme--dark.v-input--is-disabled textarea {\n  color: rgba(255,255,255,0.5);\n}\n.v-input {\n  align-items: flex-start;\n  display: flex;\n  flex: 1 1 auto;\n  font-size: 16px;\n  text-align: left;\n}\n.v-input .v-progress-linear {\n  top: calc(100% - 1px);\n  left: 0;\n  margin: 0;\n  position: absolute;\n}\n.v-input input {\n  max-height: 32px;\n}\n.v-input input:invalid,\n.v-input textarea:invalid {\n  box-shadow: none;\n}\n.v-input input:focus,\n.v-input textarea:focus,\n.v-input input:active,\n.v-input textarea:active {\n  outline: none;\n}\n.v-input .v-label {\n  height: 20px;\n  line-height: 20px;\n}\n.v-input__append-outer,\n.v-input__prepend-outer {\n  display: inline-flex;\n  margin-bottom: 4px;\n  margin-top: 4px;\n  line-height: 1;\n}\n.v-input__append-outer .v-icon,\n.v-input__prepend-outer .v-icon {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-input__append-outer {\n  margin-left: 9px;\n}\n.v-input__prepend-outer {\n  margin-right: 9px;\n}\n.v-input__control {\n  display: flex;\n  flex-direction: column;\n  height: auto;\n  flex-grow: 1;\n  flex-wrap: wrap;\n  width: 100%;\n}\n.v-input__icon {\n  align-items: center;\n  display: inline-flex;\n  height: 24px;\n  flex: 1 0 auto;\n  justify-content: center;\n  min-width: 24px;\n  width: 24px;\n}\n.v-input__icon--clear {\n  border-radius: 50%;\n}\n.v-input__slot {\n  align-items: center;\n  color: inherit;\n  display: flex;\n  margin-bottom: 8px;\n  min-height: inherit;\n  position: relative;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 100%;\n}\n.v-input--is-disabled:not(.v-input--is-readonly) {\n  pointer-events: none;\n}\n.v-input--is-loading > .v-input__control > .v-input__slot:before,\n.v-input--is-loading > .v-input__control > .v-input__slot:after {\n  display: none;\n}\n.v-input--hide-details > .v-input__control > .v-input__slot {\n  margin-bottom: 0;\n}\n.v-input--has-state.error--text .v-label {\n  -webkit-animation: shake 0.6s cubic-bezier(0.25, 0.8, 0.5, 1);\n          animation: shake 0.6s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n\n.theme--light.v-label {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-label--is-disabled {\n  color: rgba(0,0,0,0.38);\n}\n.theme--dark.v-label {\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-label--is-disabled {\n  color: rgba(255,255,255,0.5);\n}\n.v-label {\n  font-size: 16px;\n  line-height: 1;\n  min-height: 8px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n\n/* Theme */\n.theme--light.v-messages {\n  color: rgba(0,0,0,0.54);\n}\n.theme--dark.v-messages {\n  color: rgba(255,255,255,0.7);\n}\n.application--is-rtl .v-messages {\n  text-align: right;\n}\n.v-messages {\n  flex: 1 1 auto;\n  font-size: 12px;\n  min-height: 12px;\n  min-width: 1px;\n  position: relative;\n}\n.v-messages__message {\n  line-height: normal;\n  word-break: break-word;\n  overflow-wrap: break-word;\n  word-wrap: break-word;\n  -webkit-hyphens: auto;\n      -ms-hyphens: auto;\n          hyphens: auto;\n}\n\n.theme--light.v-divider {\n  border-color: rgba(0,0,0,0.12);\n}\n.theme--dark.v-divider {\n  border-color: rgba(255,255,255,0.12);\n}\n.v-divider {\n  display: block;\n  flex: 1 1 0px;\n  max-width: 100%;\n  height: 0px;\n  max-height: 0px;\n  border: solid;\n  border-width: thin 0 0 0;\n  transition: inherit;\n}\n.v-divider--inset:not(.v-divider--vertical) {\n  margin-left: 72px;\n  max-width: calc(100% - 72px);\n}\n.v-divider--vertical {\n  align-self: stretch;\n  border: solid;\n  border-width: 0 thin 0 0;\n  display: inline-flex;\n  height: inherit;\n  min-height: 100%;\n  max-height: 100%;\n  max-width: 0px;\n  width: 0px;\n  vertical-align: text-bottom;\n}\n.v-divider--vertical.v-divider--inset {\n  margin-top: 8px;\n  min-height: 0;\n  max-height: calc(100% - 16px);\n}\n\n.theme--light.v-subheader {\n  color: rgba(0,0,0,0.54);\n}\n.theme--dark.v-subheader {\n  color: rgba(255,255,255,0.7);\n}\n.v-subheader {\n  align-items: center;\n  display: flex;\n  height: 48px;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 16px 0 16px;\n}\n.v-subheader--inset {\n  margin-left: 56px;\n}\n\n/* Themes */\n.theme--light.v-list {\n  background: #fff;\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-list .v-list--disabled {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-list .v-list__tile__sub-title {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-list .v-list__tile__mask {\n  color: rgba(0,0,0,0.38);\n  background: #eee;\n}\n.theme--light.v-list .v-list__tile--link:hover,\n.theme--light.v-list .v-list__tile--highlighted,\n.theme--light.v-list .v-list__group__header:hover {\n  background: rgba(0,0,0,0.04);\n}\n.theme--light.v-list .v-list__group--active:before,\n.theme--light.v-list .v-list__group--active:after {\n  background: rgba(0,0,0,0.12);\n}\n.theme--light.v-list .v-list__group--disabled .v-list__tile {\n  color: rgba(0,0,0,0.38) !important;\n}\n.theme--light.v-list .v-list__group--disabled .v-list__group__header__prepend-icon .v-icon {\n  color: rgba(0,0,0,0.38) !important;\n}\n.theme--dark.v-list {\n  background: #424242;\n  color: #fff;\n}\n.theme--dark.v-list .v-list--disabled {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-list .v-list__tile__sub-title {\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-list .v-list__tile__mask {\n  color: rgba(255,255,255,0.5);\n  background: #494949;\n}\n.theme--dark.v-list .v-list__tile--link:hover,\n.theme--dark.v-list .v-list__tile--highlighted,\n.theme--dark.v-list .v-list__group__header:hover {\n  background: rgba(255,255,255,0.08);\n}\n.theme--dark.v-list .v-list__group--active:before,\n.theme--dark.v-list .v-list__group--active:after {\n  background: rgba(255,255,255,0.12);\n}\n.theme--dark.v-list .v-list__group--disabled .v-list__tile {\n  color: rgba(255,255,255,0.5) !important;\n}\n.theme--dark.v-list .v-list__group--disabled .v-list__group__header__prepend-icon .v-icon {\n  color: rgba(255,255,255,0.5) !important;\n}\n.application--is-rtl .v-list__tile__title {\n  text-align: right;\n}\n.application--is-rtl .v-list__tile__content {\n  text-align: right;\n}\n.v-list {\n  list-style-type: none;\n  padding: 8px 0 8px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-list > div {\n  transition: inherit;\n}\n.v-list__tile {\n  align-items: center;\n  color: inherit;\n  display: flex;\n  font-size: 16px;\n  font-weight: 400;\n  height: 48px;\n  margin: 0;\n  padding: 0 16px;\n  position: relative;\n  text-decoration: none;\n  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-list__tile--link {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-list__tile__content,\n.v-list__tile__action {\n  height: 100%;\n}\n.v-list__tile__title,\n.v-list__tile__sub-title {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 100%;\n}\n.v-list__tile__title {\n  height: 24px;\n  line-height: 24px;\n  position: relative;\n  text-align: left;\n}\n.v-list__tile__sub-title {\n  font-size: 14px;\n}\n.v-list__tile__avatar {\n  display: flex;\n  justify-content: flex-start;\n  min-width: 56px;\n}\n.v-list__tile__action {\n  display: flex;\n  justify-content: flex-start;\n  min-width: 56px;\n  align-items: center;\n}\n.v-list__tile__action .v-btn {\n  padding: 0;\n  margin: 0;\n}\n.v-list__tile__action .v-btn--icon {\n  margin: -6px;\n}\n.v-list__tile__action .v-radio.v-radio {\n  margin: 0;\n}\n.v-list__tile__action .v-input--selection-controls {\n  padding: 0;\n  margin: 0;\n}\n.v-list__tile__action .v-input--selection-controls .v-messages {\n  display: none;\n}\n.v-list__tile__action .v-input--selection-controls .v-input__slot {\n  margin: 0;\n}\n.v-list__tile__action-text {\n  color: #9e9e9e;\n  font-size: 12px;\n}\n.v-list__tile__action--stack {\n  align-items: flex-end;\n  justify-content: space-between;\n  padding-top: 8px;\n  padding-bottom: 8px;\n  white-space: nowrap;\n  flex-direction: column;\n}\n.v-list__tile__content {\n  text-align: left;\n  flex: 1 1 auto;\n  overflow: hidden;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  flex-direction: column;\n}\n.v-list__tile__content ~ .v-list__tile__avatar {\n  justify-content: flex-end;\n}\n.v-list__tile__content ~ .v-list__tile__action:not(.v-list__tile__action--stack) {\n  justify-content: flex-end;\n}\n.v-list__tile--active .v-list__tile__action:first-of-type .v-icon {\n  color: inherit;\n}\n.v-list__tile--avatar {\n  height: 56px;\n}\n.v-list--dense {\n  padding-top: 4px;\n  padding-bottom: 4px;\n}\n.v-list--dense .v-subheader {\n  font-size: 13px;\n  height: 40px;\n}\n.v-list--dense .v-list__group .v-subheader {\n  height: 40px;\n}\n.v-list--dense .v-list__tile {\n  font-size: 13px;\n}\n.v-list--dense .v-list__tile--avatar {\n  height: 48px;\n}\n.v-list--dense .v-list__tile:not(.v-list__tile--avatar) {\n  height: 40px;\n}\n.v-list--dense .v-list__tile .v-icon {\n  font-size: 22px;\n}\n.v-list--dense .v-list__tile__sub-title {\n  font-size: 13px;\n}\n.v-list--disabled {\n  pointer-events: none;\n}\n.v-list--two-line .v-list__tile {\n  height: 72px;\n}\n.v-list--two-line.v-list--dense .v-list__tile {\n  height: 60px;\n}\n.v-list--three-line .v-list__tile {\n  height: 88px;\n}\n.v-list--three-line .v-list__tile__avatar {\n  margin-top: -18px;\n}\n.v-list--three-line .v-list__tile__sub-title {\n  white-space: initial;\n  -webkit-line-clamp: 2;\n  display: -webkit-box;\n}\n.v-list--three-line.v-list--dense .v-list__tile {\n  height: 76px;\n}\n.v-list > .v-list__group:before {\n  top: 0;\n}\n.v-list > .v-list__group:before .v-list__tile__avatar {\n  margin-top: -14px;\n}\n.v-list__group {\n  padding: 0;\n  position: relative;\n  transition: inherit;\n}\n.v-list__group:before,\n.v-list__group:after {\n  content: '';\n  height: 1px;\n  left: 0;\n  position: absolute;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 100%;\n}\n.v-list__group--active ~ .v-list__group:before {\n  display: none;\n}\n.v-list__group__header {\n  align-items: center;\n  cursor: pointer;\n  display: flex;\n  list-style-type: none;\n}\n.v-list__group__header > div:not(.v-list__group__header__prepend-icon):not(.v-list__group__header__append-icon) {\n  flex: 1 1 auto;\n  overflow: hidden;\n}\n.v-list__group__header .v-list__group__header__append-icon,\n.v-list__group__header .v-list__group__header__prepend-icon {\n  padding: 0 16px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-list__group__header--sub-group {\n  align-items: center;\n  display: flex;\n}\n.v-list__group__header--sub-group div .v-list__tile {\n  padding-left: 0;\n}\n.v-list__group__header--sub-group .v-list__group__header__prepend-icon {\n  padding: 0 0 0 40px;\n  margin-right: 8px;\n}\n.v-list__group__header .v-list__group__header__prepend-icon {\n  display: flex;\n  justify-content: flex-start;\n  min-width: 56px;\n}\n.v-list__group__header--active .v-list__group__header__append-icon .v-icon {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n.v-list__group__header--active .v-list__group__header__prepend-icon .v-icon {\n  color: inherit;\n}\n.v-list__group__header--active.v-list__group__header--sub-group .v-list__group__header__prepend-icon .v-icon {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n.v-list__group__items {\n  position: relative;\n  padding: 0;\n  transition: inherit;\n}\n.v-list__group__items > div {\n  display: block;\n}\n.v-list__group__items--no-action .v-list__tile {\n  padding-left: 72px;\n}\n.v-list__group--disabled {\n  pointer-events: none;\n}\n.v-list--subheader {\n  padding-top: 0;\n}\n\n.v-avatar {\n  align-items: center;\n  border-radius: 50%;\n  display: inline-flex;\n  justify-content: center;\n  position: relative;\n  text-align: center;\n  vertical-align: middle;\n}\n.v-avatar img,\n.v-avatar .v-icon,\n.v-avatar .v-image {\n  border-radius: 50%;\n  display: inline-flex;\n  height: inherit;\n  width: inherit;\n}\n.v-avatar--tile {\n  border-radius: 0;\n}\n.v-avatar--tile img,\n.v-avatar--tile .v-icon,\n.v-avatar--tile .v-image {\n  border-radius: 0;\n}\n\n/* Theme */\n.theme--light.v-counter {\n  color: rgba(0,0,0,0.54);\n}\n.theme--dark.v-counter {\n  color: rgba(255,255,255,0.7);\n}\n.v-counter {\n  flex: 0 1 auto;\n  font-size: 12px;\n  min-height: 12px;\n  line-height: 1;\n}\n\n.v-progress-linear {\n  background: transparent;\n  margin: 1rem 0;\n  overflow: hidden;\n  width: 100%;\n  position: relative;\n}\n.v-progress-linear__bar {\n  width: 100%;\n  height: inherit;\n  position: relative;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);\n  z-index: 1;\n}\n.v-progress-linear__bar__determinate {\n  height: inherit;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);\n}\n.v-progress-linear__bar__indeterminate .long,\n.v-progress-linear__bar__indeterminate .short {\n  height: inherit;\n  position: absolute;\n  left: 0;\n  top: 0;\n  bottom: 0;\n  will-change: left, right;\n  width: auto;\n  background-color: inherit;\n}\n.v-progress-linear__bar__indeterminate--active .long {\n  -webkit-animation: indeterminate;\n          animation: indeterminate;\n  -webkit-animation-duration: 2.2s;\n          animation-duration: 2.2s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n.v-progress-linear__bar__indeterminate--active .short {\n  -webkit-animation: indeterminate-short;\n          animation: indeterminate-short;\n  -webkit-animation-duration: 2.2s;\n          animation-duration: 2.2s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n.v-progress-linear__background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  bottom: 0;\n  transition: 0.3s ease-in;\n}\n.v-progress-linear__content {\n  width: 100%;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  left: 0;\n  z-index: 2;\n}\n.v-progress-linear--query .v-progress-linear__bar__indeterminate--active .long {\n  -webkit-animation: query;\n          animation: query;\n  -webkit-animation-duration: 2s;\n          animation-duration: 2s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n.v-progress-linear--query .v-progress-linear__bar__indeterminate--active .short {\n  -webkit-animation: query-short;\n          animation: query-short;\n  -webkit-animation-duration: 2s;\n          animation-duration: 2s;\n  -webkit-animation-iteration-count: infinite;\n          animation-iteration-count: infinite;\n}\n@-webkit-keyframes indeterminate {\n  0% {\n    left: -90%;\n    right: 100%;\n  }\n  60% {\n    left: -90%;\n    right: 100%;\n  }\n  100% {\n    left: 100%;\n    right: -35%;\n  }\n}\n@keyframes indeterminate {\n  0% {\n    left: -90%;\n    right: 100%;\n  }\n  60% {\n    left: -90%;\n    right: 100%;\n  }\n  100% {\n    left: 100%;\n    right: -35%;\n  }\n}\n@-webkit-keyframes indeterminate-short {\n  0% {\n    left: -200%;\n    right: 100%;\n  }\n  60% {\n    left: 107%;\n    right: -8%;\n  }\n  100% {\n    left: 107%;\n    right: -8%;\n  }\n}\n@keyframes indeterminate-short {\n  0% {\n    left: -200%;\n    right: 100%;\n  }\n  60% {\n    left: 107%;\n    right: -8%;\n  }\n  100% {\n    left: 107%;\n    right: -8%;\n  }\n}\n@-webkit-keyframes query {\n  0% {\n    right: -90%;\n    left: 100%;\n  }\n  60% {\n    right: -90%;\n    left: 100%;\n  }\n  100% {\n    right: 100%;\n    left: -35%;\n  }\n}\n@keyframes query {\n  0% {\n    right: -90%;\n    left: 100%;\n  }\n  60% {\n    right: -90%;\n    left: 100%;\n  }\n  100% {\n    right: 100%;\n    left: -35%;\n  }\n}\n@-webkit-keyframes query-short {\n  0% {\n    right: -200%;\n    left: 100%;\n  }\n  60% {\n    right: 107%;\n    left: -8%;\n  }\n  100% {\n    right: 107%;\n    left: -8%;\n  }\n}\n@keyframes query-short {\n  0% {\n    right: -200%;\n    left: 100%;\n  }\n  60% {\n    right: 107%;\n    left: -8%;\n  }\n  100% {\n    right: 107%;\n    left: -8%;\n  }\n}\n\n.application--is-rtl .v-badge__badge {\n  right: initial;\n  left: -22px;\n}\n.application--is-rtl .v-badge--overlap .v-badge__badge {\n  right: initial;\n  left: -8px;\n}\n.application--is-rtl .v-badge--overlap.v-badge--left .v-badge__badge {\n  right: -8px;\n  left: initial;\n}\n.application--is-rtl .v-badge--left .v-badge__badge {\n  right: -22px;\n  left: initial;\n}\n.v-badge {\n  display: inline-block;\n  position: relative;\n}\n.v-badge__badge {\n  color: #fff;\n  display: flex;\n  position: absolute;\n  font-size: 14px;\n  top: -11px;\n  right: -22px;\n  border-radius: 50%;\n  height: 22px;\n  width: 22px;\n  justify-content: center;\n  align-items: center;\n  flex-direction: row;\n  flex-wrap: wrap;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-badge__badge .v-icon {\n  font-size: 14px;\n}\n.v-badge--overlap .v-badge__badge {\n  top: -8px;\n  right: -8px;\n}\n.v-badge--overlap.v-badge--left .v-badge__badge {\n  left: -8px;\n  right: initial;\n}\n.v-badge--overlap.v-badge--bottom .v-badge__badge {\n  bottom: -8px;\n  top: initial;\n}\n.v-badge--left .v-badge__badge {\n  left: -22px;\n}\n.v-badge--bottom .v-badge__badge {\n  bottom: -11px;\n  top: initial;\n}\n\n.theme--light.v-bottom-nav {\n  background-color: #fff;\n}\n.theme--light.v-bottom-nav .v-btn:not(.v-btn--active) {\n  color: rgba(0,0,0,0.54) !important;\n}\n.theme--dark.v-bottom-nav {\n  background-color: #424242;\n}\n.theme--dark.v-bottom-nav .v-btn:not(.v-btn--active) {\n  color: rgba(255,255,255,0.7) !important;\n}\n.v-item-group.v-bottom-nav {\n  bottom: 0;\n  box-shadow: 0 3px 14px 2px rgba(0,0,0,0.12);\n  display: flex;\n  left: 0;\n  justify-content: center;\n  -webkit-transform: translate(0, 60px);\n          transform: translate(0, 60px);\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 100%;\n}\n.v-item-group.v-bottom-nav--absolute {\n  position: absolute;\n}\n.v-item-group.v-bottom-nav--active {\n  -webkit-transform: translate(0, 0);\n          transform: translate(0, 0);\n}\n.v-item-group.v-bottom-nav--fixed {\n  position: fixed;\n  z-index: 4;\n}\n.v-item-group.v-bottom-nav .v-btn {\n  background: transparent !important;\n  border-radius: 0;\n  box-shadow: none !important;\n  font-weight: 400;\n  height: 100%;\n  margin: 0;\n  max-width: 168px;\n  min-width: 80px;\n  padding: 8px 12px 10px;\n  text-transform: none;\n  width: 100%;\n  flex-shrink: 1;\n}\n.v-item-group.v-bottom-nav .v-btn .v-btn__content {\n  flex-direction: column-reverse;\n  font-size: 12px;\n  white-space: nowrap;\n  will-change: font-size;\n}\n.v-item-group.v-bottom-nav .v-btn .v-btn__content i.v-icon {\n  color: inherit;\n  margin-bottom: 4px;\n  transition: all 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-item-group.v-bottom-nav .v-btn .v-btn__content span {\n  line-height: 1;\n}\n.v-item-group.v-bottom-nav .v-btn--active {\n  padding-top: 6px;\n}\n.v-item-group.v-bottom-nav .v-btn--active:before {\n  background-color: transparent;\n}\n.v-item-group.v-bottom-nav .v-btn--active .v-btn__content {\n  font-size: 14px;\n}\n.v-item-group.v-bottom-nav .v-btn--active .v-btn__content .v-icon {\n  -webkit-transform: none;\n          transform: none;\n}\n.v-item-group.v-bottom-nav--shift .v-btn__content {\n  font-size: 14px;\n}\n.v-item-group.v-bottom-nav--shift .v-btn {\n  transition: all 0.3s;\n  min-width: 56px;\n  max-width: 96px;\n}\n.v-item-group.v-bottom-nav--shift .v-btn--active {\n  min-width: 96px;\n  max-width: 168px;\n}\n.v-bottom-nav--shift .v-btn:not(.v-btn--active) .v-btn__content .v-icon {\n  -webkit-transform: scale(1, 1) translate(0, 8px);\n          transform: scale(1, 1) translate(0, 8px);\n}\n.v-bottom-nav--shift .v-btn:not(.v-btn--active) .v-btn__content > span:not(.v-badge) {\n  color: transparent;\n}\n\n.v-item-group {\n  flex: 0 1 auto;\n  position: relative;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-item-group > * {\n  cursor: pointer;\n  flex: 1 1 auto;\n}\n\n.v-bottom-sheet.v-dialog {\n  align-self: flex-end;\n  border-radius: 0;\n  flex: 1 0 100%;\n  margin: 0;\n  min-width: 100%;\n  overflow: visible;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.v-bottom-sheet.v-dialog.v-bottom-sheet--inset {\n  max-width: 70%;\n  min-width: 0;\n}\n@media only screen and (max-width: 599px) {\n  .v-bottom-sheet.v-dialog.v-bottom-sheet--inset {\n    max-width: none;\n  }\n}\n\n.v-dialog {\n  box-shadow: 0px 11px 15px -7px rgba(0,0,0,0.2), 0px 24px 38px 3px rgba(0,0,0,0.14), 0px 9px 46px 8px rgba(0,0,0,0.12);\n  border-radius: 2px;\n  margin: 24px;\n  overflow-y: auto;\n  pointer-events: auto;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n  width: 100%;\n  z-index: inherit;\n}\n.v-dialog__content {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  pointer-events: none;\n  position: fixed;\n  top: 0;\n  transition: 0.2s cubic-bezier(0.25, 0.8, 0.25, 1);\n  width: 100%;\n  z-index: 6;\n  outline: none;\n}\n.v-dialog:not(.v-dialog--fullscreen) {\n  max-height: 90%;\n}\n.v-dialog__activator {\n  cursor: pointer;\n}\n.v-dialog__activator * {\n  cursor: pointer;\n}\n.v-dialog__container {\n  display: inline-block;\n  vertical-align: middle;\n}\n.v-dialog--animated {\n  -webkit-animation-duration: 0.15s;\n          animation-duration: 0.15s;\n  -webkit-animation-name: animate-dialog;\n          animation-name: animate-dialog;\n  -webkit-animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);\n          animation-timing-function: cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.v-dialog--fullscreen {\n  border-radius: 0;\n  margin: 0;\n  height: 100%;\n  position: fixed;\n  overflow-y: auto;\n  top: 0;\n  left: 0;\n}\n.v-dialog--fullscreen > .v-card {\n  min-height: 100%;\n  min-width: 100%;\n  margin: 0 !important;\n  padding: 0 !important;\n}\n.v-dialog--scrollable,\n.v-dialog--scrollable > form {\n  display: flex;\n}\n.v-dialog--scrollable > .v-card,\n.v-dialog--scrollable > form > .v-card {\n  display: flex;\n  flex: 1 1 100%;\n  max-width: 100%;\n  flex-direction: column;\n}\n.v-dialog--scrollable > .v-card > .v-card__title,\n.v-dialog--scrollable > form > .v-card > .v-card__title,\n.v-dialog--scrollable > .v-card > .v-card__actions,\n.v-dialog--scrollable > form > .v-card > .v-card__actions {\n  flex: 1 0 auto;\n}\n.v-dialog--scrollable > .v-card > .v-card__text,\n.v-dialog--scrollable > form > .v-card > .v-card__text {\n  overflow-y: auto;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n}\n@-webkit-keyframes animate-dialog {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    -webkit-transform: scale(1.03);\n            transform: scale(1.03);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n@keyframes animate-dialog {\n  0% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n  50% {\n    -webkit-transform: scale(1.03);\n            transform: scale(1.03);\n  }\n  100% {\n    -webkit-transform: scale(1);\n            transform: scale(1);\n  }\n}\n\n.v-overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  pointer-events: none;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  z-index: 5;\n}\n.v-overlay--absolute {\n  position: absolute;\n}\n.v-overlay:before {\n  background-color: #212121;\n  bottom: 0;\n  content: '';\n  height: 100%;\n  left: 0;\n  opacity: 0;\n  position: absolute;\n  right: 0;\n  top: 0;\n  transition: inherit;\n  transition-delay: 150ms;\n  width: 100%;\n}\n.v-overlay--active {\n  pointer-events: auto;\n  touch-action: none;\n}\n.v-overlay--active:before {\n  opacity: 0.46;\n}\n\n.theme--light.v-breadcrumbs .v-breadcrumbs__divider,\n.theme--light.v-breadcrumbs .v-breadcrumbs__item--disabled {\n  color: rgba(0,0,0,0.38);\n}\n.theme--dark.v-breadcrumbs .v-breadcrumbs__divider,\n.theme--dark.v-breadcrumbs .v-breadcrumbs__item--disabled {\n  color: rgba(255,255,255,0.5);\n}\n.v-breadcrumbs {\n  align-items: center;\n  display: flex;\n  flex-wrap: wrap;\n  flex: 0 1 auto;\n  list-style-type: none;\n  margin: 0;\n  padding: 18px 12px;\n}\n.v-breadcrumbs li {\n  align-items: center;\n  display: inline-flex;\n  font-size: 14px;\n}\n.v-breadcrumbs li .v-icon {\n  font-size: 16px;\n}\n.v-breadcrumbs li:nth-child(even) {\n  padding: 0 12px;\n}\n.v-breadcrumbs--large li {\n  font-size: 16px;\n}\n.v-breadcrumbs--large li .v-icon {\n  font-size: 16px;\n}\n.v-breadcrumbs__item {\n  align-items: center;\n  display: inline-flex;\n  text-decoration: none;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-breadcrumbs__item--disabled {\n  pointer-events: none;\n}\n\n.v-ripple__container {\n  color: inherit;\n  border-radius: inherit;\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  left: 0;\n  top: 0;\n  overflow: hidden;\n  z-index: 0;\n  pointer-events: none;\n  contain: strict;\n}\n.v-ripple__animation {\n  color: inherit;\n  position: absolute;\n  top: 0;\n  left: 0;\n  border-radius: 50%;\n  background: currentColor;\n  opacity: 0;\n  pointer-events: none;\n  overflow: hidden;\n  will-change: transform, opacity;\n}\n.v-ripple__animation--enter {\n  transition: none;\n}\n.v-ripple__animation--in {\n  transition: opacity 0.1s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.1s cubic-bezier(0.4, 0, 0.2, 1);\n  transition: transform 0.25s cubic-bezier(0.4, 0, 0.2, 1), opacity 0.1s cubic-bezier(0.4, 0, 0.2, 1), -webkit-transform 0.25s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-ripple__animation--out {\n  transition: opacity 0.3s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.theme--light.v-btn {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-btn.v-btn--disabled {\n  color: rgba(0,0,0,0.26) !important;\n}\n.theme--light.v-btn.v-btn--disabled .v-icon,\n.theme--light.v-btn.v-btn--disabled .v-btn__loading {\n  color: rgba(0,0,0,0.26) !important;\n}\n.theme--light.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {\n  background-color: rgba(0,0,0,0.12) !important;\n}\n.theme--light.v-btn:not(.v-btn--icon):not(.v-btn--flat) {\n  background-color: #f5f5f5;\n}\n.theme--dark.v-btn {\n  color: #fff;\n}\n.theme--dark.v-btn.v-btn--disabled {\n  color: rgba(255,255,255,0.3) !important;\n}\n.theme--dark.v-btn.v-btn--disabled .v-icon,\n.theme--dark.v-btn.v-btn--disabled .v-btn__loading {\n  color: rgba(255,255,255,0.3) !important;\n}\n.theme--dark.v-btn.v-btn--disabled:not(.v-btn--icon):not(.v-btn--flat):not(.v-btn--outline) {\n  background-color: rgba(255,255,255,0.12) !important;\n}\n.theme--dark.v-btn:not(.v-btn--icon):not(.v-btn--flat) {\n  background-color: #212121;\n}\n/** Base Spec */\n.v-btn {\n  align-items: center;\n  border-radius: 2px;\n  display: inline-flex;\n  height: 36px;\n  flex: 0 0 auto;\n  font-size: 14px;\n  font-weight: 500;\n  justify-content: center;\n  margin: 6px 8px;\n  min-width: 88px;\n  outline: 0;\n  text-transform: uppercase;\n  text-decoration: none;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1), color 1ms;\n  position: relative;\n  vertical-align: middle;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n/** Psuedo */\n.v-btn:before {\n  border-radius: inherit;\n  color: inherit;\n  content: '';\n  position: absolute;\n  left: 0;\n  top: 0;\n  height: 100%;\n  opacity: 0.12;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 100%;\n}\n/** Content */\n.v-btn {\n  padding: 0 16px;\n}\n.v-btn--active,\n.v-btn:hover,\n.v-btn:focus {\n  position: relative;\n}\n.v-btn--active:before,\n.v-btn:hover:before,\n.v-btn:focus:before {\n  background-color: currentColor;\n}\n.v-btn__content {\n  align-items: center;\n  border-radius: inherit;\n  color: inherit;\n  display: flex;\n  flex: 1 0 auto;\n  justify-content: center;\n  margin: 0 auto;\n  position: relative;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  white-space: nowrap;\n  width: inherit;\n}\n/** Sizes */\n.v-btn--small {\n  font-size: 13px;\n  height: 28px;\n  padding: 0 8px;\n}\n.v-btn--large {\n  font-size: 15px;\n  height: 44px;\n  padding: 0 32px;\n}\n/** Icons */\n.v-btn .v-btn__content .v-icon {\n  color: inherit;\n}\n/** Types */\n.v-btn:not(.v-btn--depressed):not(.v-btn--flat) {\n  will-change: box-shadow;\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n}\n.v-btn:not(.v-btn--depressed):not(.v-btn--flat):active {\n  box-shadow: 0px 5px 5px -3px rgba(0,0,0,0.2), 0px 8px 10px 1px rgba(0,0,0,0.14), 0px 3px 14px 2px rgba(0,0,0,0.12);\n}\n.v-btn--icon {\n  background: transparent;\n  box-shadow: none !important;\n  border-radius: 50%;\n  justify-content: center;\n  min-width: 0;\n  width: 36px;\n}\n.v-btn--icon.v-btn--small {\n  width: 28px;\n}\n.v-btn--icon.v-btn--large {\n  width: 44px;\n}\n.v-btn--icon:before {\n  border-radius: 50%;\n}\n.v-btn--floating {\n  border-radius: 50%;\n  min-width: 0;\n  height: 56px;\n  width: 56px;\n  padding: 0;\n}\n.v-btn--floating.v-btn--fixed,\n.v-btn--floating.v-btn--absolute {\n  z-index: 4;\n}\n.v-btn--floating:not(.v-btn--depressed):not(.v-btn--flat) {\n  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);\n}\n.v-btn--floating:not(.v-btn--depressed):not(.v-btn--flat):active {\n  box-shadow: 0px 7px 8px -4px rgba(0,0,0,0.2), 0px 12px 17px 2px rgba(0,0,0,0.14), 0px 5px 22px 4px rgba(0,0,0,0.12);\n}\n.v-btn--floating .v-btn__content {\n  flex: 1 1 auto;\n  margin: 0;\n  height: 100%;\n}\n.v-btn--floating:after {\n  border-radius: 50%;\n}\n.v-btn--floating .v-btn__content > :not(:only-child) {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-btn--floating .v-btn__content > :not(:only-child):first-child {\n  opacity: 1;\n}\n.v-btn--floating .v-btn__content > :not(:only-child):last-child {\n  opacity: 0;\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n}\n.v-btn--floating .v-btn__content > :not(:only-child):last-child,\n.v-btn--floating .v-btn__content > :not(:only-child):first-child {\n  -webkit-backface-visibility: hidden;\n  position: absolute;\n  left: 0;\n  top: 0;\n}\n.v-btn--floating.v-btn--active .v-btn__content > :not(:only-child):first-child {\n  opacity: 0;\n  -webkit-transform: rotate(45deg);\n          transform: rotate(45deg);\n}\n.v-btn--floating.v-btn--active .v-btn__content > :not(:only-child):last-child {\n  opacity: 1;\n  -webkit-transform: rotate(0);\n          transform: rotate(0);\n}\n.v-btn--floating .v-icon {\n  height: inherit;\n  width: inherit;\n}\n.v-btn--floating.v-btn--small {\n  height: 40px;\n  width: 40px;\n}\n.v-btn--floating.v-btn--small .v-icon {\n  font-size: 18px;\n}\n.v-btn--floating.v-btn--large {\n  height: 72px;\n  width: 72px;\n}\n.v-btn--floating.v-btn--large .v-icon {\n  font-size: 30px;\n}\n.v-btn--reverse .v-btn__content {\n  flex-direction: row-reverse;\n}\n.v-btn--reverse.v-btn--column .v-btn__content {\n  flex-direction: column-reverse;\n}\n.v-btn--fixed,\n.v-btn--absolute {\n  margin: 0;\n}\n.v-btn.v-btn--absolute {\n  position: absolute;\n}\n.v-btn.v-btn--fixed {\n  position: fixed;\n}\n.v-btn--top:not(.v-btn--absolute) {\n  top: 16px;\n}\n.v-btn--top.v-btn--absolute {\n  top: -28px;\n}\n.v-btn--top.v-btn--absolute.v-btn--small {\n  top: -20px;\n}\n.v-btn--top.v-btn--absolute.v-btn--large {\n  top: -36px;\n}\n.v-btn--bottom:not(.v-btn--absolute) {\n  bottom: 16px;\n}\n.v-btn--bottom.v-btn--absolute {\n  bottom: -28px;\n}\n.v-btn--bottom.v-btn--absolute.v-btn--small {\n  bottom: -20px;\n}\n.v-btn--bottom.v-btn--absolute.v-btn--large {\n  bottom: -36px;\n}\n.v-btn--left {\n  left: 16px;\n}\n.v-btn--right {\n  right: 16px;\n}\n/** Disabled */\n.v-btn.v-btn--disabled {\n  box-shadow: none !important;\n  pointer-events: none;\n}\n.v-btn:not(.v-btn--disabled):not(.v-btn--floating):not(.v-btn--icon) .v-btn__content .v-icon {\n  transition: none;\n}\n.v-btn--icon {\n  padding: 0;\n}\n/** Loader */\n.v-btn--loader {\n  pointer-events: none;\n}\n.v-btn--loader .v-btn__content {\n  opacity: 0;\n}\n.v-btn__loading {\n  align-items: center;\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  top: 0;\n  width: 100%;\n}\n.v-btn__loading .v-icon--left {\n  margin-right: 1rem;\n  line-height: inherit;\n}\n.v-btn__loading .v-icon--right {\n  margin-left: 1rem;\n  line-height: inherit;\n}\n/** Custom Buttons */\n.v-btn.v-btn--outline {\n  border: 1px solid currentColor;\n  background: transparent !important;\n  box-shadow: none;\n}\n.v-btn.v-btn--outline:hover {\n  box-shadow: none;\n}\n.v-btn--block {\n  display: flex;\n  flex: 1;\n  margin: 6px 0;\n  width: 100%;\n}\n.v-btn--round {\n  border-radius: 28px;\n}\n.v-btn--round:after {\n  border-radius: 28px;\n}\n/** Themes */\n.v-btn:not(.v-btn--outline).primary,\n.v-btn:not(.v-btn--outline).secondary,\n.v-btn:not(.v-btn--outline).accent,\n.v-btn:not(.v-btn--outline).success,\n.v-btn:not(.v-btn--outline).error,\n.v-btn:not(.v-btn--outline).warning,\n.v-btn:not(.v-btn--outline).info {\n  color: #fff;\n}\n@media (hover: none) {\n  .v-btn:hover::before {\n    background-color: transparent;\n  }\n}\n\n.v-progress-circular {\n  position: relative;\n  display: inline-flex;\n  vertical-align: middle;\n}\n.v-progress-circular svg {\n  width: 100%;\n  height: 100%;\n  margin: auto;\n  position: absolute;\n  top: 0;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  z-index: 0;\n}\n.v-progress-circular--indeterminate svg {\n  -webkit-animation: progress-circular-rotate 1.4s linear infinite;\n          animation: progress-circular-rotate 1.4s linear infinite;\n  -webkit-transform-origin: center center;\n          transform-origin: center center;\n  transition: all 0.2s ease-in-out;\n}\n.v-progress-circular--indeterminate .v-progress-circular__overlay {\n  -webkit-animation: progress-circular-dash 1.4s ease-in-out infinite;\n          animation: progress-circular-dash 1.4s ease-in-out infinite;\n  stroke-linecap: round;\n  stroke-dasharray: 80, 200;\n  stroke-dashoffset: 0px;\n}\n.v-progress-circular__underlay {\n  stroke: rgba(0,0,0,0.1);\n  z-index: 1;\n}\n.v-progress-circular__overlay {\n  stroke: currentColor;\n  z-index: 2;\n  transition: all 0.6s ease-in-out;\n}\n.v-progress-circular__info {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n@-webkit-keyframes progress-circular-dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0px;\n  }\n  50% {\n    stroke-dasharray: 100, 200;\n    stroke-dashoffset: -15px;\n  }\n  100% {\n    stroke-dasharray: 100, 200;\n    stroke-dashoffset: -125px;\n  }\n}\n@keyframes progress-circular-dash {\n  0% {\n    stroke-dasharray: 1, 200;\n    stroke-dashoffset: 0px;\n  }\n  50% {\n    stroke-dasharray: 100, 200;\n    stroke-dashoffset: -15px;\n  }\n  100% {\n    stroke-dasharray: 100, 200;\n    stroke-dashoffset: -125px;\n  }\n}\n@-webkit-keyframes progress-circular-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n@keyframes progress-circular-rotate {\n  100% {\n    -webkit-transform: rotate(360deg);\n            transform: rotate(360deg);\n  }\n}\n\n/** Themes */\n.theme--light.v-btn-toggle {\n  background: #fff;\n}\n.theme--light.v-btn-toggle .v-btn {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-btn-toggle:not(.v-btn-toggle--only-child) .v-btn.v-btn--active:not(:last-child) {\n  border-right-color: rgba(0,0,0,0.26);\n}\n.theme--dark.v-btn-toggle {\n  background: #424242;\n}\n.theme--dark.v-btn-toggle .v-btn {\n  color: #fff;\n}\n.theme--dark.v-btn-toggle:not(.v-btn-toggle--only-child) .v-btn.v-btn--active:not(:last-child) {\n  border-right-color: rgba(255,255,255,0.3);\n}\n.v-btn-toggle {\n  display: inline-flex;\n  border-radius: 2px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  will-change: background, box-shadow;\n}\n.v-btn-toggle .v-btn {\n  justify-content: center;\n  min-width: auto;\n  width: auto;\n  padding: 0 8px;\n  margin: 0;\n  opacity: 0.4;\n  border-radius: 0;\n}\n.v-btn-toggle .v-btn:not(:last-child) {\n  border-right: 1px solid transparent;\n}\n.v-btn-toggle .v-btn:after {\n  display: none;\n}\n.v-btn-toggle .v-btn.v-btn--active {\n  opacity: 1;\n}\n.v-btn-toggle .v-btn span + .v-icon {\n  font-size: initial;\n  margin-left: 10px;\n}\n.v-btn-toggle .v-btn:first-child {\n  border-radius: 2px 0 0 2px;\n}\n.v-btn-toggle .v-btn:last-child {\n  border-radius: 0 2px 2px 0;\n}\n.v-btn-toggle--selected {\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n}\n\n.theme--light.v-calendar-weekly {\n  background-color: #fff;\n}\n.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday {\n  border-right: #e0e0e0 1px solid;\n  color: #000;\n}\n.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {\n  background-color: #f7f7f7;\n}\n.theme--light.v-calendar-weekly .v-calendar-weekly__day {\n  border-right: #e0e0e0 1px solid;\n  border-bottom: #e0e0e0 1px solid;\n  color: #000;\n}\n.theme--light.v-calendar-weekly .v-calendar-weekly__day.v-outside {\n  background-color: #f7f7f7;\n}\n.theme--dark.v-calendar-weekly {\n  background-color: #303030;\n}\n.theme--dark.v-calendar-weekly .v-calendar-weekly__head-weekday {\n  border-right: #9e9e9e 1px solid;\n  color: #fff;\n}\n.theme--dark.v-calendar-weekly .v-calendar-weekly__head-weekday.v-past {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-calendar-weekly .v-calendar-weekly__head-weekday.v-outside {\n  background-color: #202020;\n}\n.theme--dark.v-calendar-weekly .v-calendar-weekly__day {\n  border-right: #9e9e9e 1px solid;\n  border-bottom: #9e9e9e 1px solid;\n  color: #fff;\n}\n.theme--dark.v-calendar-weekly .v-calendar-weekly__day.v-outside {\n  background-color: #202020;\n}\n.v-calendar-weekly {\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n}\n.v-calendar-weekly__head {\n  display: flex;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-calendar-weekly__head-weekday {\n  flex: 1 0 20px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  padding: 0px 4px 0px 4px;\n  font-size: 14px;\n}\n.v-calendar-weekly__week {\n  display: flex;\n  flex: 1;\n}\n.v-calendar-weekly__day {\n  flex: 1;\n  width: 0;\n  overflow: hidden;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  position: relative;\n  padding: 32px 4px 4px 4px;\n}\n.v-calendar-weekly__day.v-present .v-calendar-weekly__day-label {\n  border: 1px solid currentColor;\n}\n.v-calendar-weekly__day.v-present .v-calendar-weekly__day-month {\n  color: currentColor;\n}\n.v-calendar-weekly__day-label {\n  position: absolute;\n  text-decoration: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  cursor: pointer;\n  box-shadow: none;\n  text-align: center;\n  left: 0;\n  top: 0;\n  border-radius: 16px;\n  width: 32px;\n  height: 32px;\n  line-height: 32px;\n}\n.v-calendar-weekly__day-label:hover {\n  text-decoration: underline;\n}\n.v-calendar-weekly__day-month {\n  position: absolute;\n  text-decoration: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  box-shadow: none;\n  top: 0;\n  left: 36px;\n  height: 32px;\n  line-height: 32px;\n}\n\n.theme--light.v-calendar-daily {\n  background-color: #fff;\n}\n.theme--light.v-calendar-daily .v-calendar-daily__intervals-head {\n  border-right: #e0e0e0 1px solid;\n}\n.theme--light.v-calendar-daily .v-calendar-daily_head-day {\n  border-right: #e0e0e0 1px solid;\n  border-bottom: #e0e0e0 1px solid;\n  color: #000;\n}\n.theme--light.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-weekday,\n.theme--light.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-day-label {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-calendar-daily .v-calendar-daily__intervals-body {\n  border-right: #e0e0e0 1px solid;\n}\n.theme--light.v-calendar-daily .v-calendar-daily__intervals-body .v-calendar-daily__interval-text {\n  color: #424242;\n}\n.theme--light.v-calendar-daily .v-calendar-daily__day {\n  border-right: #e0e0e0 1px solid;\n  border-bottom: #e0e0e0 1px solid;\n}\n.theme--light.v-calendar-daily .v-calendar-daily__day-interval {\n  border-top: #e0e0e0 1px solid;\n}\n.theme--light.v-calendar-daily .v-calendar-daily__day-interval:first-child {\n  border-top: none !important;\n}\n.theme--dark.v-calendar-daily {\n  background-color: #303030;\n}\n.theme--dark.v-calendar-daily .v-calendar-daily__intervals-head {\n  border-right: #9e9e9e 1px solid;\n}\n.theme--dark.v-calendar-daily .v-calendar-daily_head-day {\n  border-right: #9e9e9e 1px solid;\n  border-bottom: #9e9e9e 1px solid;\n  color: #fff;\n}\n.theme--dark.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-weekday,\n.theme--dark.v-calendar-daily .v-calendar-daily_head-day.v-past .v-calendar-daily_head-day-label {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-calendar-daily .v-calendar-daily__intervals-body {\n  border-right: #9e9e9e 1px solid;\n}\n.theme--dark.v-calendar-daily .v-calendar-daily__intervals-body .v-calendar-daily__interval-text {\n  color: #eee;\n}\n.theme--dark.v-calendar-daily .v-calendar-daily__day {\n  border-right: #616161 1px solid;\n  border-bottom: #616161 1px solid;\n}\n.theme--dark.v-calendar-daily .v-calendar-daily__day-interval {\n  border-top: #616161 1px solid;\n}\n.theme--dark.v-calendar-daily .v-calendar-daily__day-interval:first-child {\n  border-top: none !important;\n}\n.v-calendar-daily {\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  height: 100%;\n}\n.v-calendar-daily__head {\n  flex: none;\n  display: flex;\n}\n.v-calendar-daily__intervals-head {\n  flex: none;\n  width: 44px;\n}\n.v-calendar-daily_head-day {\n  flex: 1 1 auto;\n  width: 0;\n}\n.v-calendar-daily_head-weekday {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  padding: 4px 4px 4px 8px;\n  font-size: 14px;\n}\n.v-calendar-daily_head-day-label {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  font-size: 40px;\n  padding: 0px 4px 4px 8px;\n  line-height: 40px;\n  cursor: pointer;\n}\n.v-calendar-daily_head-day-label:hover {\n  text-decoration: underline;\n}\n.v-calendar-daily__body {\n  flex: 1 1 60%;\n  overflow: hidden;\n  display: flex;\n  position: relative;\n  flex-direction: column;\n}\n.v-calendar-daily__scroll-area {\n  overflow-y: scroll;\n  flex: 1 1 auto;\n  display: flex;\n  align-items: flex-start;\n}\n.v-calendar-daily__pane {\n  width: 100%;\n  overflow-y: hidden;\n  flex: none;\n  display: flex;\n  align-items: flex-start;\n}\n.v-calendar-daily__day-container {\n  display: flex;\n  flex: 1;\n  width: 100%;\n  height: 100%;\n}\n.v-calendar-daily__intervals-body {\n  flex: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 44px;\n}\n.v-calendar-daily__interval {\n  text-align: center;\n  border-bottom: none;\n}\n.v-calendar-daily__interval-text {\n  display: block;\n  position: relative;\n  top: -6px;\n  font-size: 10px;\n}\n.v-calendar-daily__day {\n  flex: 1;\n  width: 0;\n  position: relative;\n}\n\n/* Themes */\n.theme--light.v-sheet {\n  background-color: #fff;\n  border-color: #fff;\n  color: rgba(0,0,0,0.87);\n}\n.theme--dark.v-sheet {\n  background-color: #424242;\n  border-color: #424242;\n  color: #fff;\n}\n.v-sheet {\n  display: block;\n  border-radius: 2px;\n  position: relative;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-sheet--tile {\n  border-radius: 0;\n}\n\n.v-image {\n  z-index: 0;\n}\n.v-image__image,\n.v-image__placeholder {\n  z-index: -1;\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n.v-image__image {\n  background-repeat: no-repeat;\n}\n.v-image__image--preload {\n  -webkit-filter: blur(2px);\n          filter: blur(2px);\n}\n.v-image__image--contain {\n  background-size: contain;\n}\n.v-image__image--cover {\n  background-size: cover;\n}\n\n.v-responsive {\n  position: relative;\n  overflow: hidden;\n  flex: 1 0 auto;\n  display: flex;\n}\n.v-responsive__content {\n  flex: 1 0 0px;\n}\n.v-responsive__sizer {\n  transition: padding-bottom 0.2s cubic-bezier(0.25, 0.8, 0.5, 1);\n  flex: 0 0 0px;\n}\n\n.application--is-rtl .v-carousel__prev {\n  left: auto;\n  right: 5px;\n}\n.application--is-rtl .v-carousel__next {\n  left: 5px;\n  right: auto;\n}\n.v-carousel {\n  width: 100%;\n  position: relative;\n  overflow: hidden;\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n}\n.v-carousel__prev,\n.v-carousel__next {\n  position: absolute;\n  top: 50%;\n  z-index: 1;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.v-carousel__prev .v-btn,\n.v-carousel__next .v-btn {\n  margin: 0;\n  height: auto;\n  width: auto;\n}\n.v-carousel__prev .v-btn i,\n.v-carousel__next .v-btn i {\n  font-size: 48px;\n}\n.v-carousel__prev .v-btn:hover,\n.v-carousel__next .v-btn:hover {\n  background: none;\n}\n.v-carousel__prev {\n  left: 5px;\n}\n.v-carousel__next {\n  right: 5px;\n}\n.v-carousel__controls {\n  background: rgba(0,0,0,0.5);\n  align-items: center;\n  bottom: 0;\n  display: flex;\n  justify-content: center;\n  left: 0;\n  position: absolute;\n  height: 50px;\n  list-style-type: none;\n  width: 100%;\n  z-index: 1;\n}\n.v-carousel__controls > .v-item-group {\n  flex: 0 1 auto;\n}\n.v-carousel__controls__item {\n  margin: 0 8px !important;\n}\n.v-carousel__controls__item .v-icon {\n  opacity: 0.5;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-carousel__controls__item--active .v-icon {\n  opacity: 1;\n  vertical-align: middle;\n}\n.v-carousel__controls__item:hover {\n  background: none;\n}\n.v-carousel__controls__item:hover .v-icon {\n  opacity: 0.8;\n}\n\n.v-window__container {\n  position: relative;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-window__container--is-active {\n  overflow: hidden;\n}\n.v-window-x-transition-enter-active,\n.v-window-x-reverse-transition-enter-active,\n.v-window-y-transition-enter-active,\n.v-window-y-reverse-transition-enter-active,\n.v-window-x-transition-leave-active,\n.v-window-x-reverse-transition-leave-active,\n.v-window-y-transition-leave-active,\n.v-window-y-reverse-transition-leave-active {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-window-x-transition-leave,\n.v-window-x-reverse-transition-leave,\n.v-window-y-transition-leave,\n.v-window-y-reverse-transition-leave,\n.v-window-x-transition-leave-to,\n.v-window-x-reverse-transition-leave-to,\n.v-window-y-transition-leave-to,\n.v-window-y-reverse-transition-leave-to {\n  position: absolute !important;\n  top: 0;\n  width: 100%;\n}\n.v-window-x-transition-enter {\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n}\n.v-window-x-transition-leave-to {\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.v-window-x-reverse-transition-enter {\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.v-window-x-reverse-transition-leave-to {\n  -webkit-transform: translateX(100%);\n          transform: translateX(100%);\n}\n.v-window-y-transition-enter {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n.v-window-y-transition-leave-to {\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n.v-window-y-reverse-transition-enter {\n  -webkit-transform: translateY(-100%);\n          transform: translateY(-100%);\n}\n.v-window-y-reverse-transition-leave-to {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n\n.theme--light.v-data-iterator .v-data-iterator__actions {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-data-iterator .v-data-iterator__actions__select .v-select .v-select__selection--comma {\n  color: rgba(0,0,0,0.54) !important;\n}\n.theme--light.v-data-iterator .v-data-iterator__actions__select .v-select .v-input__append-inner {\n  color: rgba(0,0,0,0.54) !important;\n}\n.theme--dark.v-data-iterator .v-data-iterator__actions {\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-data-iterator .v-data-iterator__actions__select .v-select .v-select__selection--comma {\n  color: rgba(255,255,255,0.7) !important;\n}\n.theme--dark.v-data-iterator .v-data-iterator__actions__select .v-select .v-input__append-inner {\n  color: rgba(255,255,255,0.7) !important;\n}\n/** Actions */\n.v-data-iterator__actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  font-size: 12px;\n  flex-wrap: wrap-reverse;\n}\n.v-data-iterator__actions .v-btn {\n  color: inherit;\n}\n.v-data-iterator__actions .v-btn:last-of-type {\n  margin-left: 14px;\n}\n.v-data-iterator__actions__range-controls {\n  display: flex;\n  align-items: center;\n  min-height: 48px;\n}\n.v-data-iterator__actions__pagination {\n  display: block;\n  text-align: center;\n  margin: 0 32px 0 24px;\n}\n.v-data-iterator__actions__select {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-right: 14px;\n  white-space: nowrap;\n}\n.v-data-iterator__actions__select .v-select {\n  flex: 0 1 0;\n  margin: 13px 0 13px 34px;\n  padding: 0;\n  position: initial;\n}\n.v-data-iterator__actions__select .v-select__selections {\n  flex-wrap: nowrap;\n}\n.v-data-iterator__actions__select .v-select__selections .v-select__selection--comma {\n  font-size: 12px;\n}\n\n.theme--light.v-overflow-btn .v-input__control::before,\n.theme--light.v-overflow-btn .v-input__slot::before {\n  background-color: rgba(0,0,0,0.12) !important;\n}\n.theme--light.v-overflow-btn.v-text-field--outline .v-input__control::before,\n.theme--light.v-overflow-btn.v-text-field--outline .v-input__slot::before {\n  background-color: transparent !important;\n}\n.theme--light.v-overflow-btn--segmented .v-input__append-inner,\n.theme--light.v-overflow-btn--editable:hover .v-input__append-inner,\n.theme--light.v-overflow-btn--editable.v-input--is-focused .v-input__append-inner,\n.theme--light.v-overflow-btn--editable.v-select--is-menu-active .v-input__append-inner {\n  border-left: 1px solid rgba(0,0,0,0.12);\n}\n.theme--light.v-overflow-btn:hover .v-input__slot,\n.theme--light.v-overflow-btn.v-input--is-focused .v-input__slot,\n.theme--light.v-overflow-btn.v-select--is-menu-active .v-input__slot {\n  background: #fff;\n}\n.theme--dark.v-overflow-btn .v-input__control::before,\n.theme--dark.v-overflow-btn .v-input__slot::before {\n  background-color: rgba(255,255,255,0.12) !important;\n}\n.theme--dark.v-overflow-btn.v-text-field--outline .v-input__control::before,\n.theme--dark.v-overflow-btn.v-text-field--outline .v-input__slot::before {\n  background-color: transparent !important;\n}\n.theme--dark.v-overflow-btn--segmented .v-input__append-inner,\n.theme--dark.v-overflow-btn--editable:hover .v-input__append-inner,\n.theme--dark.v-overflow-btn--editable.v-input--is-focused .v-input__append-inner,\n.theme--dark.v-overflow-btn--editable.v-select--is-menu-active .v-input__append-inner {\n  border-left: 1px solid rgba(255,255,255,0.12);\n}\n.theme--dark.v-overflow-btn:hover .v-input__slot,\n.theme--dark.v-overflow-btn.v-input--is-focused .v-input__slot,\n.theme--dark.v-overflow-btn.v-select--is-menu-active .v-input__slot {\n  background: #424242;\n}\n.v-overflow-btn {\n  margin-top: 12px;\n  padding-top: 0;\n}\n.v-overflow-btn:not(.v-overflow-btn--editable) > .v-input__control > .v-input__slot {\n  cursor: pointer;\n}\n.v-overflow-btn .v-select__slot {\n  height: 48px;\n}\n.v-overflow-btn .v-select__slot input {\n  margin-left: 16px;\n  cursor: pointer;\n}\n.v-overflow-btn .v-select__selection--comma:first-child {\n  margin-left: 16px;\n}\n.v-overflow-btn .v-input__slot {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-overflow-btn .v-input__slot::after {\n  content: none;\n}\n.v-overflow-btn .v-label {\n  margin-left: 16px;\n  top: calc(50% - 10px);\n}\n.v-overflow-btn .v-input__append-inner {\n  width: 48px;\n  height: 48px;\n  align-self: auto;\n  align-items: center;\n  margin-top: 0;\n  padding: 0;\n  flex-shrink: 0;\n}\n.v-overflow-btn .v-input__append-outer,\n.v-overflow-btn .v-input__prepend-outer {\n  margin-top: 12px;\n  margin-bottom: 12px;\n}\n.v-overflow-btn .v-input__control::before {\n  height: 1px;\n  top: -1px;\n  content: '';\n  left: 0;\n  position: absolute;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 100%;\n}\n.v-overflow-btn.v-input--is-focused .v-input__slot,\n.v-overflow-btn.v-select--is-menu-active .v-input__slot {\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n}\n.v-overflow-btn .v-select__selections {\n  width: 0px;\n}\n.v-overflow-btn--segmented .v-select__selections {\n  flex-wrap: nowrap;\n}\n.v-overflow-btn--segmented .v-select__selections .v-btn {\n  border-radius: 0;\n  margin: 0;\n  margin-right: -16px;\n  height: 48px;\n  width: 100%;\n}\n.v-overflow-btn--segmented .v-select__selections .v-btn__content {\n  justify-content: start;\n}\n.v-overflow-btn--segmented .v-select__selections .v-btn__content::before {\n  background-color: transparent;\n}\n.v-overflow-btn--editable .v-select__slot input {\n  cursor: text;\n}\n.v-overflow-btn--editable .v-input__append-inner,\n.v-overflow-btn--editable .v-input__append-inner * {\n  cursor: pointer;\n}\n\n/* Theme */\n.theme--light.v-table {\n  background-color: #fff;\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-table thead tr:first-child {\n  border-bottom: 1px solid rgba(0,0,0,0.12);\n}\n.theme--light.v-table thead th {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-table tbody tr:not(:first-child) {\n  border-top: 1px solid rgba(0,0,0,0.12);\n}\n.theme--light.v-table tbody tr[active] {\n  background: #f5f5f5;\n}\n.theme--light.v-table tbody tr:hover:not(.v-datatable__expand-row) {\n  background: #eee;\n}\n.theme--light.v-table tfoot tr {\n  border-top: 1px solid rgba(0,0,0,0.12);\n}\n.theme--dark.v-table {\n  background-color: #424242;\n  color: #fff;\n}\n.theme--dark.v-table thead tr:first-child {\n  border-bottom: 1px solid rgba(255,255,255,0.12);\n}\n.theme--dark.v-table thead th {\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-table tbody tr:not(:first-child) {\n  border-top: 1px solid rgba(255,255,255,0.12);\n}\n.theme--dark.v-table tbody tr[active] {\n  background: #505050;\n}\n.theme--dark.v-table tbody tr:hover:not(.v-datatable__expand-row) {\n  background: #616161;\n}\n.theme--dark.v-table tfoot tr {\n  border-top: 1px solid rgba(255,255,255,0.12);\n}\n.v-table__overflow {\n  width: 100%;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\ntable.v-table {\n  border-radius: 2px;\n  border-collapse: collapse;\n  border-spacing: 0;\n  width: 100%;\n  max-width: 100%;\n}\ntable.v-table thead td:not(:nth-child(1)),\ntable.v-table tbody td:not(:nth-child(1)),\ntable.v-table thead th:not(:nth-child(1)),\ntable.v-table tbody th:not(:nth-child(1)),\ntable.v-table thead td:first-child,\ntable.v-table tbody td:first-child,\ntable.v-table thead th:first-child,\ntable.v-table tbody th:first-child {\n  padding: 0 24px;\n}\ntable.v-table thead tr {\n  height: 56px;\n}\ntable.v-table thead th {\n  font-weight: 500;\n  font-size: 12px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  white-space: nowrap;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\ntable.v-table thead th.sortable {\n  pointer-events: auto;\n}\ntable.v-table thead th > div {\n  width: 100%;\n}\ntable.v-table tbody tr {\n  transition: background 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  will-change: background;\n}\ntable.v-table tbody td,\ntable.v-table tbody th {\n  height: 48px;\n}\ntable.v-table tbody td {\n  font-weight: 400;\n  font-size: 13px;\n}\ntable.v-table .input-group--selection-controls {\n  padding: 0;\n}\ntable.v-table .input-group--selection-controls .input-group__details {\n  display: none;\n}\ntable.v-table .input-group--selection-controls.checkbox .v-icon {\n  left: 50%;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n}\ntable.v-table .input-group--selection-controls.checkbox .input-group--selection-controls__ripple {\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\ntable.v-table tfoot tr {\n  height: 48px;\n}\ntable.v-table tfoot tr td {\n  padding: 0 24px;\n}\n\n/* Theme */\n.theme--light.v-datatable thead th.column.sortable .v-icon {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-datatable thead th.column.sortable:hover {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-datatable thead th.column.sortable.active {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-datatable thead th.column.sortable.active .v-icon {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-datatable .v-datatable__actions {\n  background-color: #fff;\n  color: rgba(0,0,0,0.54);\n  border-top: 1px solid rgba(0,0,0,0.12);\n}\n.theme--light.v-datatable .v-datatable__expand-col--expanded {\n  border-bottom: 1px solid #e0e0e0;\n}\n.theme--dark.v-datatable thead th.column.sortable .v-icon {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-datatable thead th.column.sortable:hover {\n  color: #fff;\n}\n.theme--dark.v-datatable thead th.column.sortable.active {\n  color: #fff;\n}\n.theme--dark.v-datatable thead th.column.sortable.active .v-icon {\n  color: #fff;\n}\n.theme--dark.v-datatable .v-datatable__actions {\n  background-color: #424242;\n  color: rgba(255,255,255,0.7);\n  border-top: 1px solid rgba(255,255,255,0.12);\n}\n.theme--dark.v-datatable .v-datatable__expand-col--expanded {\n  border-bottom: 1px solid #616161;\n}\n.v-datatable .v-input--selection-controls {\n  margin: 0;\n  padding: 0;\n}\n.v-datatable thead th.column.sortable {\n  cursor: pointer;\n  outline: 0;\n}\n.v-datatable thead th.column.sortable .v-icon {\n  font-size: 16px;\n  display: inline-block;\n  opacity: 0;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-datatable thead th.column.sortable:focus .v-icon,\n.v-datatable thead th.column.sortable:hover .v-icon {\n  opacity: 0.6;\n}\n.v-datatable thead th.column.sortable.active {\n  -webkit-transform: none;\n          transform: none;\n}\n.v-datatable thead th.column.sortable.active .v-icon {\n  opacity: 1;\n}\n.v-datatable thead th.column.sortable.active.desc .v-icon {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n/** Actions */\n.v-datatable__actions {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  font-size: 12px;\n  flex-wrap: wrap-reverse;\n}\n.v-datatable__actions .v-btn {\n  color: inherit;\n}\n.v-datatable__actions .v-btn:last-of-type {\n  margin-left: 14px;\n}\n.v-datatable__actions__range-controls {\n  display: flex;\n  align-items: center;\n  min-height: 48px;\n}\n.v-datatable__actions__pagination {\n  display: block;\n  text-align: center;\n  margin: 0 32px 0 24px;\n}\n.v-datatable__actions__select {\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  margin-right: 14px;\n  white-space: nowrap;\n}\n.v-datatable__actions__select .v-select {\n  flex: 0 1 0;\n  margin: 13px 0 13px 34px;\n  padding: 0;\n  position: initial;\n}\n.v-datatable__actions__select .v-select__selections {\n  flex-wrap: nowrap;\n}\n.v-datatable__actions__select .v-select__selections .v-select__selection--comma {\n  font-size: 12px;\n}\n.v-datatable__progress {\n  height: auto !important;\n}\n.v-datatable__progress tr,\n.v-datatable__progress td,\n.v-datatable__progress th {\n  height: auto !important;\n}\n.v-datatable__progress th {\n  padding: 0 !important;\n}\n.v-datatable__progress th .v-progress-linear {\n  margin: 0;\n}\n.v-datatable__expand-row {\n  border-top: none !important;\n}\n.v-datatable__expand-col {\n  padding: 0 !important;\n  height: 0px !important;\n  visibility: hidden;\n}\n.v-datatable__expand-col--expanded {\n  visibility: visible;\n}\n.v-datatable__expand-content {\n  transition: height 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-datatable__expand-content > .card {\n  border-radius: 0;\n  box-shadow: none;\n}\n\n.theme--light.v-small-dialog a {\n  color: rgba(0,0,0,0.87);\n}\n.theme--dark.v-small-dialog a {\n  color: #fff;\n}\n.theme--light.v-small-dialog__content {\n  background: #fff;\n}\n.theme--dark.v-small-dialog__content {\n  background: #424242;\n}\n.theme--light.v-small-dialog__actions {\n  background: #fff;\n}\n.theme--dark.v-small-dialog__actions {\n  background: #424242;\n}\n.v-small-dialog {\n  display: block;\n  width: 100%;\n  height: 100%;\n}\n.v-small-dialog__content {\n  padding: 0 24px;\n}\n.v-small-dialog__actions {\n  text-align: right;\n  white-space: pre;\n}\n.v-small-dialog a {\n  display: flex;\n  align-items: center;\n  height: 100%;\n  text-decoration: none;\n}\n.v-small-dialog a > * {\n  width: 100%;\n}\n.v-small-dialog .v-menu__activator {\n  height: 100%;\n}\n\n.application--is-rtl .v-date-picker-title .v-picker__title__btn {\n  text-align: right;\n}\n.v-date-picker-title {\n  display: flex;\n  justify-content: space-between;\n  flex-direction: column;\n  flex-wrap: wrap;\n  line-height: 1;\n}\n.v-date-picker-title__year {\n  align-items: center;\n  display: inline-flex;\n  font-size: 14px;\n  font-weight: 500;\n  margin-bottom: 8px;\n}\n.v-date-picker-title__date {\n  font-size: 34px;\n  text-align: left;\n  font-weight: 500;\n  position: relative;\n  overflow: hidden;\n  padding-bottom: 8px;\n  margin-bottom: -8px;\n}\n.v-date-picker-title__date > div {\n  position: relative;\n}\n.v-date-picker-title--disabled {\n  pointer-events: none;\n}\n\n.theme--light.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-date-picker-header .v-date-picker-header__value--disabled button {\n  color: rgba(0,0,0,0.38);\n}\n.theme--dark.v-date-picker-header .v-date-picker-header__value:not(.v-date-picker-header__value--disabled) button:not(:hover):not(:focus) {\n  color: #fff;\n}\n.theme--dark.v-date-picker-header .v-date-picker-header__value--disabled button {\n  color: rgba(255,255,255,0.5);\n}\n.v-date-picker-header {\n  padding: 4px 16px;\n  align-items: center;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n}\n.v-date-picker-header .v-btn {\n  margin: 0;\n  z-index: auto;\n}\n.v-date-picker-header .v-icon {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-date-picker-header__value {\n  flex: 1;\n  text-align: center;\n  position: relative;\n  overflow: hidden;\n}\n.v-date-picker-header__value div {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 100%;\n}\n.v-date-picker-header__value button {\n  cursor: pointer;\n  font-weight: bold;\n  outline: none;\n  padding: 0.5rem;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-date-picker-header--disabled {\n  pointer-events: none;\n}\n\n.theme--light.v-date-picker-table th,\n.theme--light.v-date-picker-table .v-date-picker-table--date__week {\n  color: rgba(0,0,0,0.38);\n}\n.theme--dark.v-date-picker-table th,\n.theme--dark.v-date-picker-table .v-date-picker-table--date__week {\n  color: rgba(255,255,255,0.5);\n}\n.v-date-picker-table {\n  position: relative;\n  padding: 0 12px;\n  height: 242px;\n}\n.v-date-picker-table table {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  top: 0;\n  table-layout: fixed;\n  width: 100%;\n}\n.v-date-picker-table td,\n.v-date-picker-table th {\n  text-align: center;\n  position: relative;\n}\n.v-date-picker-table th {\n  font-size: 12px;\n}\n.v-date-picker-table--date .v-btn {\n  height: 32px;\n  width: 32px;\n}\n.v-date-picker-table .v-btn {\n  z-index: auto;\n  margin: 0;\n  font-size: 12px;\n}\n.v-date-picker-table .v-btn.v-btn--active {\n  color: #fff;\n}\n.v-date-picker-table--month td {\n  width: 33.333333%;\n  height: 56px;\n  vertical-align: middle;\n  text-align: center;\n}\n.v-date-picker-table--month td .v-btn {\n  margin: 0 auto;\n  max-width: 160px;\n  min-width: 40px;\n  width: 100%;\n}\n.v-date-picker-table--date th {\n  padding: 8px 0;\n  font-weight: 600;\n}\n.v-date-picker-table--date td {\n  width: 45px;\n}\n.v-date-picker-table__events {\n  height: 8px;\n  left: 0;\n  position: absolute;\n  text-align: center;\n  white-space: pre;\n  width: 100%;\n}\n.v-date-picker-table__events > div {\n  border-radius: 50%;\n  display: inline-block;\n  height: 8px;\n  margin: 0 1px;\n  width: 8px;\n}\n.v-date-picker-table--date .v-date-picker-table__events {\n  bottom: 6px;\n}\n.v-date-picker-table--month .v-date-picker-table__events {\n  bottom: 8px;\n}\n.v-date-picker-table--disabled {\n  pointer-events: none;\n}\n\n.v-date-picker-years {\n  font-size: 16px;\n  font-weight: 400;\n  height: 286px;\n  list-style-type: none;\n  overflow: auto;\n  padding: 0;\n  text-align: center;\n}\n.v-date-picker-years li {\n  cursor: pointer;\n  padding: 8px 0;\n  transition: none;\n}\n.v-date-picker-years li.active {\n  font-size: 26px;\n  font-weight: 500;\n  padding: 10px 0;\n}\n.v-date-picker-years li:hover {\n  background: rgba(0,0,0,0.12);\n}\n.v-picker--landscape .v-date-picker-years {\n  height: 286px;\n}\n\n/* Themes */\n.theme--light.v-picker__title {\n  background: #e0e0e0;\n}\n.theme--dark.v-picker__title {\n  background: #616161;\n}\n.theme--light.v-picker__body {\n  background: #fff;\n}\n.theme--dark.v-picker__body {\n  background: #424242;\n}\n.v-picker {\n  border-radius: 2px;\n  contain: layout style;\n  display: inline-flex;\n  flex-direction: column;\n  vertical-align: top;\n  position: relative;\n}\n.v-picker--full-width {\n  display: flex;\n}\n.v-picker__title {\n  color: #fff;\n  border-top-left-radius: 2px;\n  border-top-right-radius: 2px;\n  padding: 16px;\n}\n.v-picker__title__btn {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-picker__title__btn:not(.v-picker__title__btn--active) {\n  opacity: 0.6;\n  cursor: pointer;\n}\n.v-picker__title__btn:not(.v-picker__title__btn--active):hover:not(:focus) {\n  opacity: 1;\n}\n.v-picker__title__btn--readonly {\n  pointer-events: none;\n}\n.v-picker__title__btn--active {\n  opacity: 1;\n}\n.v-picker__body {\n  height: auto;\n  overflow: hidden;\n  position: relative;\n  z-index: 0;\n  flex: 1 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n.v-picker__body > div {\n  width: 100%;\n}\n.v-picker__body > div.fade-transition-leave-active {\n  position: absolute;\n}\n.v-picker--landscape .v-picker__title {\n  border-top-right-radius: 0;\n  border-bottom-right-radius: 0;\n  width: 170px;\n  position: absolute;\n  top: 0;\n  left: 0;\n  height: 100%;\n  z-index: 1;\n}\n.v-picker--landscape .v-picker__body,\n.v-picker--landscape .v-picker__actions {\n  margin-left: 170px;\n}\n\n/** Theme */\n.theme--light.v-expansion-panel .v-expansion-panel__container {\n  border-top: 1px solid rgba(0,0,0,0.12);\n  background-color: #fff;\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-expansion-panel .v-expansion-panel__container--disabled {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-expansion-panel--focusable .v-expansion-panel__container:focus {\n  background-color: #eee;\n}\n.theme--dark.v-expansion-panel .v-expansion-panel__container {\n  border-top: 1px solid rgba(255,255,255,0.12);\n  background-color: #424242;\n  color: #fff;\n}\n.theme--dark.v-expansion-panel .v-expansion-panel__container .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {\n  color: #fff;\n}\n.theme--dark.v-expansion-panel .v-expansion-panel__container--disabled {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-expansion-panel--focusable .v-expansion-panel__container:focus {\n  background-color: #494949;\n}\n.v-expansion-panel {\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: center;\n  list-style-type: none;\n  padding: 0;\n  text-align: left;\n  width: 100%;\n  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);\n}\n.v-expansion-panel__container {\n  flex: 1 0 100%;\n  max-width: 100%;\n  outline: none;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-expansion-panel__container:first-child {\n  border-top: none !important;\n}\n.v-expansion-panel__container .v-expansion-panel__header__iconnel__header__icon {\n  margin-left: auto;\n}\n.v-expansion-panel__container--disabled .v-expansion-panel__header {\n  pointer-events: none;\n}\n.v-expansion-panel__container--active > .v-expansion-panel__header .v-expansion-panel__header__icon .v-icon {\n  -webkit-transform: rotate(-180deg);\n          transform: rotate(-180deg);\n}\n.v-expansion-panel__header {\n  display: flex;\n  cursor: pointer;\n  align-items: center;\n  position: relative;\n  padding: 12px 24px;\n  min-height: 48px;\n}\n.v-expansion-panel__header > *:not(.v-expansion-panel__header__icon) {\n  flex: 1 1 auto;\n}\n.v-expansion-panel__body {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-expansion-panel__body > .v-card {\n  border-radius: 0;\n  box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12) !important;\n}\n.v-expansion-panel--popout,\n.v-expansion-panel--inset {\n  box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12);\n}\n.v-expansion-panel--popout .v-expansion-panel__container--active,\n.v-expansion-panel--inset .v-expansion-panel__container--active {\n  margin: 16px;\n  box-shadow: 0px 3px 3px -2px rgba(0,0,0,0.2), 0px 3px 4px 0px rgba(0,0,0,0.14), 0px 1px 8px 0px rgba(0,0,0,0.12);\n}\n.v-expansion-panel--popout .v-expansion-panel__container,\n.v-expansion-panel--inset .v-expansion-panel__container {\n  max-width: 95%;\n}\n.v-expansion-panel--popout .v-expansion-panel__container--active {\n  max-width: 100%;\n}\n.v-expansion-panel--inset .v-expansion-panel__container--active {\n  max-width: 85%;\n}\n\n.theme--light.v-footer {\n  background: #f5f5f5;\n  color: rgba(0,0,0,0.87);\n}\n.theme--dark.v-footer {\n  background: #212121;\n  color: #fff;\n}\n.v-footer {\n  align-items: center;\n  display: flex;\n  flex: 0 1 auto !important;\n  min-height: 36px;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-footer--absolute,\n.v-footer--fixed {\n  bottom: 0;\n  left: 0;\n  width: 100%;\n  z-index: 3;\n}\n.v-footer--inset {\n  z-index: 2;\n}\n.v-footer--absolute {\n  position: absolute;\n}\n.v-footer--fixed {\n  position: fixed;\n}\n\n.v-form > .container {\n  padding: 16px;\n}\n.v-form > .container > .layout > .flex {\n  padding: 8px;\n}\n.v-form > .container > .layout:only-child {\n  margin: -8px;\n}\n.v-form > .container > .layout:not(:only-child) {\n  margin: auto -8px;\n}\n\n.container {\n  flex: 1 1 100%;\n  margin: auto;\n  padding: 24px;\n  width: 100%;\n}\n.container.fluid {\n  max-width: 100%;\n}\n.container.fill-height {\n  align-items: center;\n  display: flex;\n}\n.container.fill-height > .layout {\n  height: 100%;\n  flex: 1 1 auto;\n}\n.container.grid-list-xs .layout .flex {\n  padding: 1px;\n}\n.container.grid-list-xs .layout:only-child {\n  margin: -1px;\n}\n.container.grid-list-xs .layout:not(:only-child) {\n  margin: auto -1px;\n}\n.container.grid-list-xs *:not(:only-child) .layout:first-child {\n  margin-top: -1px;\n}\n.container.grid-list-xs *:not(:only-child) .layout:last-child {\n  margin-bottom: -1px;\n}\n.container.grid-list-sm .layout .flex {\n  padding: 2px;\n}\n.container.grid-list-sm .layout:only-child {\n  margin: -2px;\n}\n.container.grid-list-sm .layout:not(:only-child) {\n  margin: auto -2px;\n}\n.container.grid-list-sm *:not(:only-child) .layout:first-child {\n  margin-top: -2px;\n}\n.container.grid-list-sm *:not(:only-child) .layout:last-child {\n  margin-bottom: -2px;\n}\n.container.grid-list-md .layout .flex {\n  padding: 4px;\n}\n.container.grid-list-md .layout:only-child {\n  margin: -4px;\n}\n.container.grid-list-md .layout:not(:only-child) {\n  margin: auto -4px;\n}\n.container.grid-list-md *:not(:only-child) .layout:first-child {\n  margin-top: -4px;\n}\n.container.grid-list-md *:not(:only-child) .layout:last-child {\n  margin-bottom: -4px;\n}\n.container.grid-list-lg .layout .flex {\n  padding: 8px;\n}\n.container.grid-list-lg .layout:only-child {\n  margin: -8px;\n}\n.container.grid-list-lg .layout:not(:only-child) {\n  margin: auto -8px;\n}\n.container.grid-list-lg *:not(:only-child) .layout:first-child {\n  margin-top: -8px;\n}\n.container.grid-list-lg *:not(:only-child) .layout:last-child {\n  margin-bottom: -8px;\n}\n.container.grid-list-xl .layout .flex {\n  padding: 12px;\n}\n.container.grid-list-xl .layout:only-child {\n  margin: -12px;\n}\n.container.grid-list-xl .layout:not(:only-child) {\n  margin: auto -12px;\n}\n.container.grid-list-xl *:not(:only-child) .layout:first-child {\n  margin-top: -12px;\n}\n.container.grid-list-xl *:not(:only-child) .layout:last-child {\n  margin-bottom: -12px;\n}\n.layout {\n  display: flex;\n  flex: 1 1 auto;\n  flex-wrap: nowrap;\n  min-width: 0;\n}\n.layout.row {\n  flex-direction: row;\n}\n.layout.row.reverse {\n  flex-direction: row-reverse;\n}\n.layout.column {\n  flex-direction: column;\n}\n.layout.column.reverse {\n  flex-direction: column-reverse;\n}\n.layout.column > .flex {\n  max-width: 100%;\n}\n.layout.wrap {\n  flex-wrap: wrap;\n}\n.flex,\n.child-flex > * {\n  flex: 1 1 auto;\n  max-width: 100%;\n}\n.align-start {\n  align-items: flex-start;\n}\n.align-end {\n  align-items: flex-end;\n}\n.align-center {\n  align-items: center;\n}\n.align-baseline {\n  align-items: baseline;\n}\n.align-self-start {\n  align-self: flex-start;\n}\n.align-self-end {\n  align-self: flex-end;\n}\n.align-self-center {\n  align-self: center;\n}\n.align-self-baseline {\n  align-self: baseline;\n}\n.align-content-start {\n  align-content: flex-start;\n}\n.align-content-end {\n  align-content: flex-end;\n}\n.align-content-center {\n  align-content: center;\n}\n.align-content-space-between {\n  align-content: space-between;\n}\n.align-content-space-around {\n  align-content: space-around;\n}\n.justify-start {\n  justify-content: flex-start;\n}\n.justify-end {\n  justify-content: flex-end;\n}\n.justify-center {\n  justify-content: center;\n}\n.justify-space-around {\n  justify-content: space-around;\n}\n.justify-space-between {\n  justify-content: space-between;\n}\n.justify-self-start {\n  justify-self: flex-start;\n}\n.justify-self-end {\n  justify-self: flex-end;\n}\n.justify-self-center {\n  justify-self: center;\n}\n.justify-self-baseline {\n  justify-self: baseline;\n}\n.spacer {\n  flex-grow: 1 !important;\n}\n.grow {\n  flex-grow: 1 !important;\n  flex-shrink: 0 !important;\n}\n.shrink {\n  flex-grow: 0 !important;\n  flex-shrink: 1 !important;\n}\n.scroll-y {\n  overflow-y: auto;\n}\n.fill-height {\n  height: 100%;\n}\n.hide-overflow {\n  overflow: hidden !important;\n}\n.show-overflow {\n  overflow: visible !important;\n}\n.no-wrap {\n  white-space: nowrap;\n}\n.ellipsis {\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.d-flex {\n  display: flex !important;\n}\n.d-inline-flex {\n  display: inline-flex !important;\n}\n.d-flex > *,\n.d-inline-flex > * {\n  flex: 1 1 auto !important;\n}\n.d-block {\n  display: block !important;\n}\n.d-inline-block {\n  display: inline-block !important;\n}\n.d-inline {\n  display: inline !important;\n}\n.d-none {\n  display: none !important;\n}\n@media only screen and (min-width: 960px) {\n  .container {\n    max-width: 900px;\n  }\n}\n@media only screen and (min-width: 1264px) {\n  .container {\n    max-width: 1185px;\n  }\n}\n@media only screen and (min-width: 1904px) {\n  .container {\n    max-width: 1785px;\n  }\n}\n@media only screen and (max-width: 959px) {\n  .container {\n    padding: 16px;\n  }\n}\n@media all and (min-width: 0) {\n  .flex.xs1 {\n    flex-basis: 8.333333333333332%;\n    flex-grow: 0;\n    max-width: 8.333333333333332%;\n  }\n  .flex.order-xs1 {\n    order: 1;\n  }\n  .flex.xs2 {\n    flex-basis: 16.666666666666664%;\n    flex-grow: 0;\n    max-width: 16.666666666666664%;\n  }\n  .flex.order-xs2 {\n    order: 2;\n  }\n  .flex.xs3 {\n    flex-basis: 25%;\n    flex-grow: 0;\n    max-width: 25%;\n  }\n  .flex.order-xs3 {\n    order: 3;\n  }\n  .flex.xs4 {\n    flex-basis: 33.33333333333333%;\n    flex-grow: 0;\n    max-width: 33.33333333333333%;\n  }\n  .flex.order-xs4 {\n    order: 4;\n  }\n  .flex.xs5 {\n    flex-basis: 41.66666666666667%;\n    flex-grow: 0;\n    max-width: 41.66666666666667%;\n  }\n  .flex.order-xs5 {\n    order: 5;\n  }\n  .flex.xs6 {\n    flex-basis: 50%;\n    flex-grow: 0;\n    max-width: 50%;\n  }\n  .flex.order-xs6 {\n    order: 6;\n  }\n  .flex.xs7 {\n    flex-basis: 58.333333333333336%;\n    flex-grow: 0;\n    max-width: 58.333333333333336%;\n  }\n  .flex.order-xs7 {\n    order: 7;\n  }\n  .flex.xs8 {\n    flex-basis: 66.66666666666666%;\n    flex-grow: 0;\n    max-width: 66.66666666666666%;\n  }\n  .flex.order-xs8 {\n    order: 8;\n  }\n  .flex.xs9 {\n    flex-basis: 75%;\n    flex-grow: 0;\n    max-width: 75%;\n  }\n  .flex.order-xs9 {\n    order: 9;\n  }\n  .flex.xs10 {\n    flex-basis: 83.33333333333334%;\n    flex-grow: 0;\n    max-width: 83.33333333333334%;\n  }\n  .flex.order-xs10 {\n    order: 10;\n  }\n  .flex.xs11 {\n    flex-basis: 91.66666666666666%;\n    flex-grow: 0;\n    max-width: 91.66666666666666%;\n  }\n  .flex.order-xs11 {\n    order: 11;\n  }\n  .flex.xs12 {\n    flex-basis: 100%;\n    flex-grow: 0;\n    max-width: 100%;\n  }\n  .flex.order-xs12 {\n    order: 12;\n  }\n  .flex.offset-xs0 {\n    margin-left: 0%;\n  }\n  .flex.offset-xs1 {\n    margin-left: 8.333333333333332%;\n  }\n  .flex.offset-xs2 {\n    margin-left: 16.666666666666664%;\n  }\n  .flex.offset-xs3 {\n    margin-left: 25%;\n  }\n  .flex.offset-xs4 {\n    margin-left: 33.33333333333333%;\n  }\n  .flex.offset-xs5 {\n    margin-left: 41.66666666666667%;\n  }\n  .flex.offset-xs6 {\n    margin-left: 50%;\n  }\n  .flex.offset-xs7 {\n    margin-left: 58.333333333333336%;\n  }\n  .flex.offset-xs8 {\n    margin-left: 66.66666666666666%;\n  }\n  .flex.offset-xs9 {\n    margin-left: 75%;\n  }\n  .flex.offset-xs10 {\n    margin-left: 83.33333333333334%;\n  }\n  .flex.offset-xs11 {\n    margin-left: 91.66666666666666%;\n  }\n  .flex.offset-xs12 {\n    margin-left: 100%;\n  }\n}\n@media all and (min-width: 600px) {\n  .flex.sm1 {\n    flex-basis: 8.333333333333332%;\n    flex-grow: 0;\n    max-width: 8.333333333333332%;\n  }\n  .flex.order-sm1 {\n    order: 1;\n  }\n  .flex.sm2 {\n    flex-basis: 16.666666666666664%;\n    flex-grow: 0;\n    max-width: 16.666666666666664%;\n  }\n  .flex.order-sm2 {\n    order: 2;\n  }\n  .flex.sm3 {\n    flex-basis: 25%;\n    flex-grow: 0;\n    max-width: 25%;\n  }\n  .flex.order-sm3 {\n    order: 3;\n  }\n  .flex.sm4 {\n    flex-basis: 33.33333333333333%;\n    flex-grow: 0;\n    max-width: 33.33333333333333%;\n  }\n  .flex.order-sm4 {\n    order: 4;\n  }\n  .flex.sm5 {\n    flex-basis: 41.66666666666667%;\n    flex-grow: 0;\n    max-width: 41.66666666666667%;\n  }\n  .flex.order-sm5 {\n    order: 5;\n  }\n  .flex.sm6 {\n    flex-basis: 50%;\n    flex-grow: 0;\n    max-width: 50%;\n  }\n  .flex.order-sm6 {\n    order: 6;\n  }\n  .flex.sm7 {\n    flex-basis: 58.333333333333336%;\n    flex-grow: 0;\n    max-width: 58.333333333333336%;\n  }\n  .flex.order-sm7 {\n    order: 7;\n  }\n  .flex.sm8 {\n    flex-basis: 66.66666666666666%;\n    flex-grow: 0;\n    max-width: 66.66666666666666%;\n  }\n  .flex.order-sm8 {\n    order: 8;\n  }\n  .flex.sm9 {\n    flex-basis: 75%;\n    flex-grow: 0;\n    max-width: 75%;\n  }\n  .flex.order-sm9 {\n    order: 9;\n  }\n  .flex.sm10 {\n    flex-basis: 83.33333333333334%;\n    flex-grow: 0;\n    max-width: 83.33333333333334%;\n  }\n  .flex.order-sm10 {\n    order: 10;\n  }\n  .flex.sm11 {\n    flex-basis: 91.66666666666666%;\n    flex-grow: 0;\n    max-width: 91.66666666666666%;\n  }\n  .flex.order-sm11 {\n    order: 11;\n  }\n  .flex.sm12 {\n    flex-basis: 100%;\n    flex-grow: 0;\n    max-width: 100%;\n  }\n  .flex.order-sm12 {\n    order: 12;\n  }\n  .flex.offset-sm0 {\n    margin-left: 0%;\n  }\n  .flex.offset-sm1 {\n    margin-left: 8.333333333333332%;\n  }\n  .flex.offset-sm2 {\n    margin-left: 16.666666666666664%;\n  }\n  .flex.offset-sm3 {\n    margin-left: 25%;\n  }\n  .flex.offset-sm4 {\n    margin-left: 33.33333333333333%;\n  }\n  .flex.offset-sm5 {\n    margin-left: 41.66666666666667%;\n  }\n  .flex.offset-sm6 {\n    margin-left: 50%;\n  }\n  .flex.offset-sm7 {\n    margin-left: 58.333333333333336%;\n  }\n  .flex.offset-sm8 {\n    margin-left: 66.66666666666666%;\n  }\n  .flex.offset-sm9 {\n    margin-left: 75%;\n  }\n  .flex.offset-sm10 {\n    margin-left: 83.33333333333334%;\n  }\n  .flex.offset-sm11 {\n    margin-left: 91.66666666666666%;\n  }\n  .flex.offset-sm12 {\n    margin-left: 100%;\n  }\n}\n@media all and (min-width: 960px) {\n  .flex.md1 {\n    flex-basis: 8.333333333333332%;\n    flex-grow: 0;\n    max-width: 8.333333333333332%;\n  }\n  .flex.order-md1 {\n    order: 1;\n  }\n  .flex.md2 {\n    flex-basis: 16.666666666666664%;\n    flex-grow: 0;\n    max-width: 16.666666666666664%;\n  }\n  .flex.order-md2 {\n    order: 2;\n  }\n  .flex.md3 {\n    flex-basis: 25%;\n    flex-grow: 0;\n    max-width: 25%;\n  }\n  .flex.order-md3 {\n    order: 3;\n  }\n  .flex.md4 {\n    flex-basis: 33.33333333333333%;\n    flex-grow: 0;\n    max-width: 33.33333333333333%;\n  }\n  .flex.order-md4 {\n    order: 4;\n  }\n  .flex.md5 {\n    flex-basis: 41.66666666666667%;\n    flex-grow: 0;\n    max-width: 41.66666666666667%;\n  }\n  .flex.order-md5 {\n    order: 5;\n  }\n  .flex.md6 {\n    flex-basis: 50%;\n    flex-grow: 0;\n    max-width: 50%;\n  }\n  .flex.order-md6 {\n    order: 6;\n  }\n  .flex.md7 {\n    flex-basis: 58.333333333333336%;\n    flex-grow: 0;\n    max-width: 58.333333333333336%;\n  }\n  .flex.order-md7 {\n    order: 7;\n  }\n  .flex.md8 {\n    flex-basis: 66.66666666666666%;\n    flex-grow: 0;\n    max-width: 66.66666666666666%;\n  }\n  .flex.order-md8 {\n    order: 8;\n  }\n  .flex.md9 {\n    flex-basis: 75%;\n    flex-grow: 0;\n    max-width: 75%;\n  }\n  .flex.order-md9 {\n    order: 9;\n  }\n  .flex.md10 {\n    flex-basis: 83.33333333333334%;\n    flex-grow: 0;\n    max-width: 83.33333333333334%;\n  }\n  .flex.order-md10 {\n    order: 10;\n  }\n  .flex.md11 {\n    flex-basis: 91.66666666666666%;\n    flex-grow: 0;\n    max-width: 91.66666666666666%;\n  }\n  .flex.order-md11 {\n    order: 11;\n  }\n  .flex.md12 {\n    flex-basis: 100%;\n    flex-grow: 0;\n    max-width: 100%;\n  }\n  .flex.order-md12 {\n    order: 12;\n  }\n  .flex.offset-md0 {\n    margin-left: 0%;\n  }\n  .flex.offset-md1 {\n    margin-left: 8.333333333333332%;\n  }\n  .flex.offset-md2 {\n    margin-left: 16.666666666666664%;\n  }\n  .flex.offset-md3 {\n    margin-left: 25%;\n  }\n  .flex.offset-md4 {\n    margin-left: 33.33333333333333%;\n  }\n  .flex.offset-md5 {\n    margin-left: 41.66666666666667%;\n  }\n  .flex.offset-md6 {\n    margin-left: 50%;\n  }\n  .flex.offset-md7 {\n    margin-left: 58.333333333333336%;\n  }\n  .flex.offset-md8 {\n    margin-left: 66.66666666666666%;\n  }\n  .flex.offset-md9 {\n    margin-left: 75%;\n  }\n  .flex.offset-md10 {\n    margin-left: 83.33333333333334%;\n  }\n  .flex.offset-md11 {\n    margin-left: 91.66666666666666%;\n  }\n  .flex.offset-md12 {\n    margin-left: 100%;\n  }\n}\n@media all and (min-width: 1264px) {\n  .flex.lg1 {\n    flex-basis: 8.333333333333332%;\n    flex-grow: 0;\n    max-width: 8.333333333333332%;\n  }\n  .flex.order-lg1 {\n    order: 1;\n  }\n  .flex.lg2 {\n    flex-basis: 16.666666666666664%;\n    flex-grow: 0;\n    max-width: 16.666666666666664%;\n  }\n  .flex.order-lg2 {\n    order: 2;\n  }\n  .flex.lg3 {\n    flex-basis: 25%;\n    flex-grow: 0;\n    max-width: 25%;\n  }\n  .flex.order-lg3 {\n    order: 3;\n  }\n  .flex.lg4 {\n    flex-basis: 33.33333333333333%;\n    flex-grow: 0;\n    max-width: 33.33333333333333%;\n  }\n  .flex.order-lg4 {\n    order: 4;\n  }\n  .flex.lg5 {\n    flex-basis: 41.66666666666667%;\n    flex-grow: 0;\n    max-width: 41.66666666666667%;\n  }\n  .flex.order-lg5 {\n    order: 5;\n  }\n  .flex.lg6 {\n    flex-basis: 50%;\n    flex-grow: 0;\n    max-width: 50%;\n  }\n  .flex.order-lg6 {\n    order: 6;\n  }\n  .flex.lg7 {\n    flex-basis: 58.333333333333336%;\n    flex-grow: 0;\n    max-width: 58.333333333333336%;\n  }\n  .flex.order-lg7 {\n    order: 7;\n  }\n  .flex.lg8 {\n    flex-basis: 66.66666666666666%;\n    flex-grow: 0;\n    max-width: 66.66666666666666%;\n  }\n  .flex.order-lg8 {\n    order: 8;\n  }\n  .flex.lg9 {\n    flex-basis: 75%;\n    flex-grow: 0;\n    max-width: 75%;\n  }\n  .flex.order-lg9 {\n    order: 9;\n  }\n  .flex.lg10 {\n    flex-basis: 83.33333333333334%;\n    flex-grow: 0;\n    max-width: 83.33333333333334%;\n  }\n  .flex.order-lg10 {\n    order: 10;\n  }\n  .flex.lg11 {\n    flex-basis: 91.66666666666666%;\n    flex-grow: 0;\n    max-width: 91.66666666666666%;\n  }\n  .flex.order-lg11 {\n    order: 11;\n  }\n  .flex.lg12 {\n    flex-basis: 100%;\n    flex-grow: 0;\n    max-width: 100%;\n  }\n  .flex.order-lg12 {\n    order: 12;\n  }\n  .flex.offset-lg0 {\n    margin-left: 0%;\n  }\n  .flex.offset-lg1 {\n    margin-left: 8.333333333333332%;\n  }\n  .flex.offset-lg2 {\n    margin-left: 16.666666666666664%;\n  }\n  .flex.offset-lg3 {\n    margin-left: 25%;\n  }\n  .flex.offset-lg4 {\n    margin-left: 33.33333333333333%;\n  }\n  .flex.offset-lg5 {\n    margin-left: 41.66666666666667%;\n  }\n  .flex.offset-lg6 {\n    margin-left: 50%;\n  }\n  .flex.offset-lg7 {\n    margin-left: 58.333333333333336%;\n  }\n  .flex.offset-lg8 {\n    margin-left: 66.66666666666666%;\n  }\n  .flex.offset-lg9 {\n    margin-left: 75%;\n  }\n  .flex.offset-lg10 {\n    margin-left: 83.33333333333334%;\n  }\n  .flex.offset-lg11 {\n    margin-left: 91.66666666666666%;\n  }\n  .flex.offset-lg12 {\n    margin-left: 100%;\n  }\n}\n@media all and (min-width: 1904px) {\n  .flex.xl1 {\n    flex-basis: 8.333333333333332%;\n    flex-grow: 0;\n    max-width: 8.333333333333332%;\n  }\n  .flex.order-xl1 {\n    order: 1;\n  }\n  .flex.xl2 {\n    flex-basis: 16.666666666666664%;\n    flex-grow: 0;\n    max-width: 16.666666666666664%;\n  }\n  .flex.order-xl2 {\n    order: 2;\n  }\n  .flex.xl3 {\n    flex-basis: 25%;\n    flex-grow: 0;\n    max-width: 25%;\n  }\n  .flex.order-xl3 {\n    order: 3;\n  }\n  .flex.xl4 {\n    flex-basis: 33.33333333333333%;\n    flex-grow: 0;\n    max-width: 33.33333333333333%;\n  }\n  .flex.order-xl4 {\n    order: 4;\n  }\n  .flex.xl5 {\n    flex-basis: 41.66666666666667%;\n    flex-grow: 0;\n    max-width: 41.66666666666667%;\n  }\n  .flex.order-xl5 {\n    order: 5;\n  }\n  .flex.xl6 {\n    flex-basis: 50%;\n    flex-grow: 0;\n    max-width: 50%;\n  }\n  .flex.order-xl6 {\n    order: 6;\n  }\n  .flex.xl7 {\n    flex-basis: 58.333333333333336%;\n    flex-grow: 0;\n    max-width: 58.333333333333336%;\n  }\n  .flex.order-xl7 {\n    order: 7;\n  }\n  .flex.xl8 {\n    flex-basis: 66.66666666666666%;\n    flex-grow: 0;\n    max-width: 66.66666666666666%;\n  }\n  .flex.order-xl8 {\n    order: 8;\n  }\n  .flex.xl9 {\n    flex-basis: 75%;\n    flex-grow: 0;\n    max-width: 75%;\n  }\n  .flex.order-xl9 {\n    order: 9;\n  }\n  .flex.xl10 {\n    flex-basis: 83.33333333333334%;\n    flex-grow: 0;\n    max-width: 83.33333333333334%;\n  }\n  .flex.order-xl10 {\n    order: 10;\n  }\n  .flex.xl11 {\n    flex-basis: 91.66666666666666%;\n    flex-grow: 0;\n    max-width: 91.66666666666666%;\n  }\n  .flex.order-xl11 {\n    order: 11;\n  }\n  .flex.xl12 {\n    flex-basis: 100%;\n    flex-grow: 0;\n    max-width: 100%;\n  }\n  .flex.order-xl12 {\n    order: 12;\n  }\n  .flex.offset-xl0 {\n    margin-left: 0%;\n  }\n  .flex.offset-xl1 {\n    margin-left: 8.333333333333332%;\n  }\n  .flex.offset-xl2 {\n    margin-left: 16.666666666666664%;\n  }\n  .flex.offset-xl3 {\n    margin-left: 25%;\n  }\n  .flex.offset-xl4 {\n    margin-left: 33.33333333333333%;\n  }\n  .flex.offset-xl5 {\n    margin-left: 41.66666666666667%;\n  }\n  .flex.offset-xl6 {\n    margin-left: 50%;\n  }\n  .flex.offset-xl7 {\n    margin-left: 58.333333333333336%;\n  }\n  .flex.offset-xl8 {\n    margin-left: 66.66666666666666%;\n  }\n  .flex.offset-xl9 {\n    margin-left: 75%;\n  }\n  .flex.offset-xl10 {\n    margin-left: 83.33333333333334%;\n  }\n  .flex.offset-xl11 {\n    margin-left: 91.66666666666666%;\n  }\n  .flex.offset-xl12 {\n    margin-left: 100%;\n  }\n}\n\n.v-content {\n  transition: none;\n  display: flex;\n  flex: 1 0 auto;\n  max-width: 100%;\n}\n.v-content[data-booted=\"true\"] {\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-content__wrap {\n  flex: 1 1 auto;\n  max-width: 100%;\n  position: relative;\n}\n@-moz-document url-prefix() {\n}\n@media print {\n  @-moz-document url-prefix() {\n    .v-content {\n      display: block;\n    }\n  }\n}\n\n.theme--light.v-jumbotron .v-jumbotron__content {\n  color: rgba(0,0,0,0.87);\n}\n.theme--dark.v-jumbotron .v-jumbotron__content {\n  color: #fff;\n}\n.v-jumbotron {\n  display: block;\n  top: 0;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 100%;\n}\n.v-jumbotron__wrapper {\n  height: 100%;\n  overflow: hidden;\n  position: relative;\n  transition: inherit;\n  width: 100%;\n}\n.v-jumbotron__background {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  contain: strict;\n  transition: inherit;\n}\n.v-jumbotron__image {\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n  min-width: 100%;\n  will-change: transform;\n  transition: inherit;\n}\n.v-jumbotron__content {\n  height: 100%;\n  position: relative;\n  transition: inherit;\n}\n\n.theme--light.v-navigation-drawer {\n  background-color: #fff;\n}\n.theme--light.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {\n  background-color: rgba(0,0,0,0.12);\n}\n.theme--light.v-navigation-drawer .v-divider {\n  border-color: rgba(0,0,0,0.12);\n}\n.theme--dark.v-navigation-drawer {\n  background-color: #424242;\n}\n.theme--dark.v-navigation-drawer:not(.v-navigation-drawer--floating) .v-navigation-drawer__border {\n  background-color: rgba(255,255,255,0.12);\n}\n.theme--dark.v-navigation-drawer .v-divider {\n  border-color: rgba(255,255,255,0.12);\n}\n.v-navigation-drawer {\n  transition: none;\n  display: block;\n  left: 0;\n  max-width: 100%;\n  overflow-y: auto;\n  overflow-x: hidden;\n  pointer-events: auto;\n  top: 0;\n  will-change: transform;\n  z-index: 3;\n  -webkit-overflow-scrolling: touch;\n}\n.v-navigation-drawer[data-booted=\"true\"] {\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-navigation-drawer[data-booted=\"true\"] {\n  transition-property: width, -webkit-transform;\n  transition-property: transform, width;\n  transition-property: transform, width, -webkit-transform;\n}\n.v-navigation-drawer__border {\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 100%;\n  width: 1px;\n}\n.v-navigation-drawer.v-navigation-drawer--right:after {\n  left: 0;\n  right: initial;\n}\n.v-navigation-drawer--right {\n  left: auto;\n  right: 0;\n}\n.v-navigation-drawer--right > .v-navigation-drawer__border {\n  right: auto;\n  left: 0;\n}\n.v-navigation-drawer--absolute {\n  position: absolute;\n}\n.v-navigation-drawer--fixed {\n  position: fixed;\n}\n.v-navigation-drawer--floating:after {\n  display: none;\n}\n.v-navigation-drawer--mini-variant {\n  overflow: hidden;\n}\n.v-navigation-drawer--mini-variant .v-list__group__header__prepend-icon {\n  flex: 1 0 auto;\n  justify-content: center;\n  width: 100%;\n}\n.v-navigation-drawer--mini-variant .v-list__tile__action,\n.v-navigation-drawer--mini-variant .v-list__tile__avatar {\n  justify-content: center;\n  min-width: 48px;\n}\n.v-navigation-drawer--mini-variant .v-list__tile__content,\n.v-navigation-drawer--mini-variant .v-list__tile:after {\n  opacity: 0;\n}\n.v-navigation-drawer--mini-variant .v-subheader,\n.v-navigation-drawer--mini-variant .v-divider,\n.v-navigation-drawer--mini-variant .v-list--group {\n  display: none !important;\n}\n.v-navigation-drawer--temporary,\n.v-navigation-drawer--is-mobile {\n  z-index: 6;\n}\n.v-navigation-drawer--temporary:not(.v-navigation-drawer--close),\n.v-navigation-drawer--is-mobile:not(.v-navigation-drawer--close) {\n  box-shadow: 0px 8px 10px -5px rgba(0,0,0,0.2), 0px 16px 24px 2px rgba(0,0,0,0.14), 0px 6px 30px 5px rgba(0,0,0,0.12);\n}\n.v-navigation-drawer .v-list {\n  background: inherit;\n}\n.v-navigation-drawer > .v-list .v-list__tile {\n  transition: none;\n  font-weight: 500;\n}\n.v-navigation-drawer > .v-list .v-list__tile--active .v-list__tile__title {\n  color: inherit;\n}\n.v-navigation-drawer > .v-list .v-list--group .v-list__tile {\n  font-weight: 400;\n}\n.v-navigation-drawer > .v-list .v-list--group__header--active:after {\n  background: transparent;\n}\n.v-navigation-drawer > .v-list:not(.v-list--dense) .v-list__tile {\n  font-size: 14px;\n}\n\n.theme--light.v-pagination .v-pagination__item {\n  background: #fff;\n  color: #000;\n  width: auto;\n  min-width: 34px;\n  padding: 0 5px;\n}\n.theme--light.v-pagination .v-pagination__item--active {\n  color: #fff;\n}\n.theme--light.v-pagination .v-pagination__navigation {\n  background: #fff;\n}\n.theme--light.v-pagination .v-pagination__navigation .v-icon {\n  color: rgba(0,0,0,0.54);\n}\n.theme--dark.v-pagination .v-pagination__item {\n  background: #424242;\n  color: #fff;\n  width: auto;\n  min-width: 34px;\n  padding: 0 5px;\n}\n.theme--dark.v-pagination .v-pagination__item--active {\n  color: #fff;\n}\n.theme--dark.v-pagination .v-pagination__navigation {\n  background: #424242;\n}\n.theme--dark.v-pagination .v-pagination__navigation .v-icon {\n  color: #fff;\n}\n.v-pagination {\n  align-items: center;\n  display: inline-flex;\n  list-style-type: none;\n  margin: 0;\n  max-width: 100%;\n  padding: 0;\n}\n.v-pagination > li {\n  align-items: center;\n  display: flex;\n}\n.v-pagination--circle .v-pagination__item,\n.v-pagination--circle .v-pagination__more,\n.v-pagination--circle .v-pagination__navigation {\n  border-radius: 50%;\n}\n.v-pagination--disabled {\n  pointer-events: none;\n  opacity: 0.6;\n}\n.v-pagination__item {\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n  border-radius: 4px;\n  font-size: 14px;\n  background: transparent;\n  height: 34px;\n  width: 34px;\n  margin: 0.3rem;\n  text-decoration: none;\n  transition: 0.3s cubic-bezier(0, 0, 0.2, 1);\n}\n.v-pagination__item--active {\n  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);\n}\n.v-pagination__navigation {\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  text-decoration: none;\n  height: 2rem;\n  border-radius: 4px;\n  width: 2rem;\n  margin: 0.3rem 10px;\n}\n.v-pagination__navigation .v-icon {\n  font-size: 2rem;\n  transition: 0.2s cubic-bezier(0.4, 0, 0.6, 1);\n  vertical-align: middle;\n}\n.v-pagination__navigation--disabled {\n  opacity: 0.6;\n  pointer-events: none;\n}\n.v-pagination__more {\n  margin: 0.3rem;\n  display: inline-flex;\n  align-items: flex-end;\n  justify-content: center;\n  height: 2rem;\n  width: 2rem;\n}\n\n.v-parallax {\n  position: relative;\n  overflow: hidden;\n  z-index: 0;\n}\n.v-parallax__image-container {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 1;\n  contain: strict;\n}\n.v-parallax__image {\n  position: absolute;\n  bottom: 0;\n  left: 50%;\n  min-width: 100%;\n  min-height: 100%;\n  display: none;\n  -webkit-transform: translate(-50%, 0);\n          transform: translate(-50%, 0);\n  will-change: transform;\n  transition: 0.3s opacity cubic-bezier(0.25, 0.8, 0.5, 1);\n  z-index: 1;\n}\n.v-parallax__content {\n  color: #fff;\n  height: 100%;\n  z-index: 2;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  padding: 0 1rem;\n}\n\n.v-input--radio-group__input {\n  display: flex;\n  width: 100%;\n}\n.v-input--radio-group--column .v-input--radio-group__input > .v-label {\n  padding-bottom: 8px;\n}\n.v-input--radio-group--row .v-input--radio-group__input > .v-label {\n  padding-right: 8px;\n}\n.v-input--radio-group--row .v-input--radio-group__input {\n  flex-direction: row;\n  flex-wrap: wrap;\n}\n.v-input--radio-group--column .v-radio:not(:last-child):not(:only-child) {\n  margin-bottom: 8px;\n}\n.v-input--radio-group--column .v-input--radio-group__input {\n  flex-direction: column;\n}\n\n.theme--light.v-radio--is-disabled label {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-radio--is-disabled .v-icon {\n  color: rgba(0,0,0,0.26) !important;\n}\n.theme--dark.v-radio--is-disabled label {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-radio--is-disabled .v-icon {\n  color: rgba(255,255,255,0.3) !important;\n}\n.v-radio {\n  align-items: center;\n  display: flex;\n  height: auto;\n  margin-right: 16px;\n  outline: none;\n}\n.v-radio--is-disabled {\n  pointer-events: none;\n}\n\n/* Theme */\n.theme--light.v-input--range-slider.v-input--slider.v-input--is-disabled .v-slider.v-slider .v-slider__thumb {\n  background: #bdbdbd;\n}\n.theme--dark.v-input--range-slider.v-input--slider.v-input--is-disabled .v-slider.v-slider .v-slider__thumb {\n  background: #424242;\n}\n/** Input Group */\n.v-input--range-slider.v-input--is-disabled .v-slider__track-fill {\n  display: none;\n}\n.v-input--range-slider.v-input--is-disabled.v-input--slider .v-slider.v-slider .v-slider__thumb {\n  border-color: transparent;\n}\n\n/* Theme */\n.theme--light.v-input--slider .v-slider__track,\n.theme--light.v-input--slider .v-slider__track-fill {\n  background: rgba(0,0,0,0.26);\n}\n.theme--light.v-input--slider .v-slider__track__container:after {\n  border: 1px solid rgba(0,0,0,0.87);\n}\n.theme--light.v-input--slider .v-slider__ticks {\n  border-color: rgba(0,0,0,0.87);\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-input--slider:not(.v-input--is-dirty) .v-slider__thumb-label {\n  background: rgba(0,0,0,0.26);\n}\n.theme--light.v-input--slider:not(.v-input--is-dirty) .v-slider__thumb {\n  border: 3px solid rgba(0,0,0,0.26);\n}\n.theme--light.v-input--slider:not(.v-input--is-dirty).v-input--slider--is-active .v-slider__thumb {\n  border: 3px solid rgba(0,0,0,0.38);\n}\n.theme--light.v-input--slider.v-input--is-disabled .v-slider__thumb {\n  border: 5px solid rgba(0,0,0,0.26);\n}\n.theme--light.v-input--slider.v-input--is-disabled.v-input--is-dirty .v-slider__thumb {\n  background: rgba(0,0,0,0.26);\n}\n.theme--light.v-input--slider.v-input--slider--is-active .v-slider__track {\n  background: rgba(0,0,0,0.38);\n}\n.theme--dark.v-input--slider .v-slider__track,\n.theme--dark.v-input--slider .v-slider__track-fill {\n  background: rgba(255,255,255,0.2);\n}\n.theme--dark.v-input--slider .v-slider__track__container:after {\n  border: 1px solid #fff;\n}\n.theme--dark.v-input--slider .v-slider__ticks {\n  border-color: #fff;\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-input--slider:not(.v-input--is-dirty) .v-slider__thumb-label {\n  background: rgba(255,255,255,0.2);\n}\n.theme--dark.v-input--slider:not(.v-input--is-dirty) .v-slider__thumb {\n  border: 3px solid rgba(255,255,255,0.2);\n}\n.theme--dark.v-input--slider:not(.v-input--is-dirty).v-input--slider--is-active .v-slider__thumb {\n  border: 3px solid rgba(255,255,255,0.3);\n}\n.theme--dark.v-input--slider.v-input--is-disabled .v-slider__thumb {\n  border: 5px solid rgba(255,255,255,0.2);\n}\n.theme--dark.v-input--slider.v-input--is-disabled.v-input--is-dirty .v-slider__thumb {\n  background: rgba(255,255,255,0.2);\n}\n.theme--dark.v-input--slider.v-input--slider--is-active .v-slider__track {\n  background: rgba(255,255,255,0.3);\n}\n.application--is-rtl .v-input--slider .v-label {\n  margin-left: 16px;\n  margin-right: 0;\n}\n/** Input Group */\n.v-input--slider {\n  margin-top: 16px;\n}\n.v-input--slider.v-input--is-focused .v-slider__thumb-container--is-active:not(.v-slider__thumb-container--show-label):before {\n  opacity: 0.2;\n  -webkit-transform: scale(1);\n          transform: scale(1);\n}\n.v-input--slider.v-input--is-focused .v-slider__track {\n  transition: none;\n}\n.v-input--slider.v-input--is-focused.v-input--slider--ticks .v-slider__track__container:after,\n.v-input--slider.v-input--is-focused.v-input--slider--ticks .v-slider .v-slider__tick {\n  opacity: 1;\n}\n.v-input--slider.v-input--slider--ticks .v-slider__ticks.v-slider__ticks--always-show {\n  opacity: 1;\n}\n.v-input--slider.v-input--slider--ticks-labels .v-input__slot {\n  margin-bottom: 16px;\n}\n.v-input--slider.v-input--is-readonly .v-input__control {\n  pointer-events: none;\n}\n.v-input--slider.v-input--is-disabled .v-slider__thumb {\n  -webkit-transform: translateY(-50%) scale(0.45);\n          transform: translateY(-50%) scale(0.45);\n}\n.v-input--slider.v-input--is-disabled.v-input--is-dirty .v-slider__thumb {\n  border: 0px solid transparent;\n}\n.v-input--slider .v-input__slot > *:first-child:not(:only-child) {\n  margin-right: 16px;\n}\n/** Slider */\n.v-slider {\n  cursor: default;\n  display: flex;\n  align-items: center;\n  position: relative;\n  height: 32px;\n  flex: 1;\n  outline: none;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-slider input {\n  cursor: default;\n  opacity: 0;\n  padding: 0;\n  width: 100%;\n}\n/** Thumb/Track/Ticks */\n.v-slider__track__container {\n  height: 2px;\n  left: 0;\n  overflow: hidden;\n  pointer-events: none;\n  position: absolute;\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n  width: 100%;\n}\n.v-slider__track__container:after {\n  content: '';\n  position: absolute;\n  right: 0;\n  top: 0;\n  height: 2px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 2px;\n  opacity: 0;\n}\n.v-slider__track,\n.v-slider__thumb,\n.v-slider__ticks {\n  position: absolute;\n  top: 0;\n}\n.v-slider__track {\n  height: 2px;\n  left: 0;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  -webkit-transform-origin: right;\n          transform-origin: right;\n  overflow: hidden;\n  width: 100%;\n}\n.v-slider__track-fill {\n  position: absolute;\n  left: 0;\n  height: 2px;\n  -webkit-transform-origin: left;\n          transform-origin: left;\n  width: 100%;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-slider__ticks-container {\n  position: absolute;\n  left: 0;\n  height: 2px;\n  width: 100%;\n  top: 50%;\n  -webkit-transform: translate(0, -50%);\n          transform: translate(0, -50%);\n}\n.v-slider__ticks {\n  opacity: 0;\n  border-style: solid;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-slider__ticks > span {\n  position: absolute;\n  top: 8px;\n  -webkit-transform: translateX(-50%);\n          transform: translateX(-50%);\n  white-space: nowrap;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-slider__ticks:first-child > span {\n  -webkit-transform: translateX(0);\n          transform: translateX(0);\n}\n.v-slider__ticks:last-child > span {\n  -webkit-transform: translateX(-100%);\n          transform: translateX(-100%);\n}\n.v-slider:not(.v-input--is-dirty) .v-slider__ticks:first-child {\n  border-color: transparent;\n}\n.v-slider__thumb-container {\n  position: absolute;\n  top: 50%;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-slider__thumb-container:before {\n  content: '';\n  color: inherit;\n  border-radius: 50%;\n  background: currentColor;\n  height: 32px;\n  left: -16px;\n  opacity: 0;\n  overflow: hidden;\n  pointer-events: none;\n  position: absolute;\n  top: -16px;\n  -webkit-transform: scale(0.2);\n          transform: scale(0.2);\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  width: 32px;\n  will-change: transform, opacity;\n}\n.v-slider__thumb {\n  width: 24px;\n  height: 24px;\n  left: -12px;\n  top: 50%;\n  border-radius: 50%;\n  background: transparent;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  -webkit-transform: translateY(-50%) scale(0.6);\n          transform: translateY(-50%) scale(0.6);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n/** Thumb Label */\n.v-slider--is-active .v-slider__thumb-container--is-active .v-slider__thumb {\n  -webkit-transform: translateY(-50%) scale(1);\n          transform: translateY(-50%) scale(1);\n}\n.v-slider--is-active .v-slider__thumb-container--is-active.v-slider__thumb-container--show-label .v-slider__thumb {\n  -webkit-transform: translateY(-50%) scale(0);\n          transform: translateY(-50%) scale(0);\n}\n.v-slider--is-active .v-slider__ticks-container .v-slider__ticks {\n  opacity: 1;\n}\n.v-slider__thumb-label__container {\n  position: absolute;\n  left: 0;\n  top: 0;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.v-slider__thumb-label {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 12px;\n  color: #fff;\n  width: 32px;\n  height: 32px;\n  border-radius: 50% 50% 0;\n  position: absolute;\n  left: 0;\n  bottom: 100%;\n  -webkit-transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);\n          transform: translateY(-20%) translateY(-12px) translateX(-50%) rotate(45deg);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.v-slider__thumb-label > * {\n  -webkit-transform: rotate(-45deg);\n          transform: rotate(-45deg);\n}\n.v-slider__track,\n.v-slider__track-fill {\n  position: absolute;\n}\n\n.v-rating .v-icon {\n  padding: 0.5rem;\n  border-radius: 50%;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-rating--readonly .v-icon {\n  pointer-events: none;\n}\n.v-rating--dense .v-icon {\n  padding: 0.1rem;\n}\n\n.application--is-rtl .v-snack__content .v-btn {\n  margin: 0 24px 0 0;\n}\n.v-snack {\n  position: fixed;\n  display: flex;\n  align-items: center;\n  color: #fff;\n  pointer-events: none;\n  z-index: 1000;\n  font-size: 14px;\n  left: 0;\n  right: 0;\n}\n.v-snack--absolute {\n  position: absolute;\n}\n.v-snack--top {\n  top: 0;\n}\n.v-snack--bottom {\n  bottom: 0;\n}\n.v-snack__wrapper {\n  display: flex;\n  align-items: center;\n  background-color: #323232;\n  pointer-events: auto;\n  width: 100%;\n  box-shadow: 0px 3px 5px -1px rgba(0,0,0,0.2), 0px 6px 10px 0px rgba(0,0,0,0.14), 0px 1px 18px 0px rgba(0,0,0,0.12);\n}\n.v-snack__content {\n  width: 100%;\n  height: 48px;\n  padding: 14px 24px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  overflow: hidden;\n}\n.v-snack__content .v-btn {\n  color: #fff;\n  flex: 0 0 auto;\n  padding: 8px;\n  margin: 0 0 0 24px;\n  height: auto;\n  min-width: auto;\n  width: auto;\n}\n.v-snack__content .v-btn__content {\n  margin: -2px;\n}\n.v-snack__content .v-btn::before {\n  display: none;\n}\n.v-snack--multi-line .v-snack__content {\n  height: 80px;\n  padding: 24px;\n}\n.v-snack--vertical .v-snack__content {\n  height: 112px;\n  padding: 24px 24px 14px;\n  flex-direction: column;\n  align-items: stretch;\n}\n.v-snack--vertical .v-snack__content .v-btn.v-btn {\n  justify-content: flex-end;\n  padding: 0;\n  margin-left: 0;\n  margin-top: 24px;\n}\n.v-snack--vertical .v-snack__content .v-btn__content {\n  flex: 0 0 auto;\n  margin: 0;\n}\n.v-snack--auto-height .v-snack__content {\n  height: auto;\n}\n.v-snack-transition-enter-active,\n.v-snack-transition-leave-active {\n  transition: -webkit-transform 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);\n  transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);\n  transition: transform 0.4s cubic-bezier(0.25, 0.8, 0.5, 1), -webkit-transform 0.4s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-snack-transition-enter-active .v-snack__content,\n.v-snack-transition-leave-active .v-snack__content {\n  transition: opacity 0.3s linear 0.1s;\n}\n.v-snack-transition-enter .v-snack__content {\n  opacity: 0;\n}\n.v-snack-transition-enter-to .v-snack__content,\n.v-snack-transition-leave .v-snack__content {\n  opacity: 1;\n}\n.v-snack-transition-enter.v-snack.v-snack--top,\n.v-snack-transition-leave-to.v-snack.v-snack--top {\n  -webkit-transform: translateY(calc(-100% - 8px));\n          transform: translateY(calc(-100% - 8px));\n}\n.v-snack-transition-enter.v-snack.v-snack--bottom,\n.v-snack-transition-leave-to.v-snack.v-snack--bottom {\n  -webkit-transform: translateY(100%);\n          transform: translateY(100%);\n}\n@media only screen and (min-width: 600px) {\n  .application--is-rtl .v-snack__content .v-btn:first-of-type {\n    margin-left: 0;\n    margin-right: 42px;\n  }\n  .v-snack__wrapper {\n    width: auto;\n    max-width: 568px;\n    min-width: 288px;\n    margin: 0 auto;\n    border-radius: 2px;\n  }\n  .v-snack--left .v-snack__wrapper {\n    margin-left: 0;\n  }\n  .v-snack--right .v-snack__wrapper {\n    margin-right: 0;\n  }\n  .v-snack--left,\n  .v-snack--right {\n    margin: 0 24px;\n  }\n  .v-snack--left.v-snack--top,\n  .v-snack--right.v-snack--top {\n    -webkit-transform: translateY(24px);\n            transform: translateY(24px);\n  }\n  .v-snack--left.v-snack--bottom,\n  .v-snack--right.v-snack--bottom {\n    -webkit-transform: translateY(-24px);\n            transform: translateY(-24px);\n  }\n  .v-snack__content .v-btn:first-of-type {\n    margin-left: 42px;\n  }\n}\n\n.v-speed-dial {\n  position: relative;\n}\n.v-speed-dial--absolute {\n  position: absolute;\n}\n.v-speed-dial--fixed {\n  position: fixed;\n}\n.v-speed-dial--fixed,\n.v-speed-dial--absolute {\n  z-index: 4;\n}\n.v-speed-dial--fixed > .v-btn--floating,\n.v-speed-dial--absolute > .v-btn--floating {\n  margin: 0;\n}\n.v-speed-dial--top:not(.v-speed-dial--absolute) {\n  top: 16px;\n}\n.v-speed-dial--top.v-speed-dial--absolute {\n  top: 50%;\n  -webkit-transform: translateY(-50%);\n          transform: translateY(-50%);\n}\n.v-speed-dial--bottom:not(.v-speed-dial--absolute) {\n  bottom: 16px;\n}\n.v-speed-dial--bottom.v-speed-dial--absolute {\n  bottom: 50%;\n  -webkit-transform: translateY(50%);\n          transform: translateY(50%);\n}\n.v-speed-dial--left {\n  left: 16px;\n}\n.v-speed-dial--right {\n  right: 16px;\n}\n.v-speed-dial--direction-left .v-speed-dial__list,\n.v-speed-dial--direction-right .v-speed-dial__list {\n  height: 100%;\n  top: 0;\n}\n.v-speed-dial--direction-top .v-speed-dial__list,\n.v-speed-dial--direction-bottom .v-speed-dial__list {\n  left: 0;\n  width: 100%;\n}\n.v-speed-dial--direction-top .v-speed-dial__list {\n  flex-direction: column-reverse;\n  bottom: 100%;\n}\n.v-speed-dial--direction-right .v-speed-dial__list {\n  flex-direction: row;\n  left: 100%;\n}\n.v-speed-dial--direction-bottom .v-speed-dial__list {\n  flex-direction: column;\n  top: 100%;\n}\n.v-speed-dial--direction-left .v-speed-dial__list {\n  flex-direction: row-reverse;\n  right: 100%;\n}\n/** Elements */\n.v-speed-dial__list {\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  position: absolute;\n}\n\n.theme--light.v-stepper {\n  background: #fff;\n}\n.theme--light.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {\n  background: rgba(0,0,0,0.38);\n}\n.theme--light.v-stepper .v-stepper__step__step {\n  color: #fff;\n}\n.theme--light.v-stepper .v-stepper__step__step .v-icon {\n  color: #fff;\n}\n.theme--light.v-stepper .v-stepper__header .v-divider {\n  border-color: rgba(0,0,0,0.12);\n}\n.theme--light.v-stepper .v-stepper__step--active .v-stepper__label {\n  text-shadow: 0px 0px 0px #000;\n}\n.theme--light.v-stepper .v-stepper__step--editable:hover {\n  background: rgba(0,0,0,0.06);\n}\n.theme--light.v-stepper .v-stepper__step--editable:hover .v-stepper__label {\n  text-shadow: 0px 0px 0px #000;\n}\n.theme--light.v-stepper .v-stepper__step--complete .v-stepper__label {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-stepper .v-stepper__step--inactive.v-stepper__step--editable:not(.v-stepper__step--error):hover .v-stepper__step__step {\n  background: rgba(0,0,0,0.54);\n}\n.theme--light.v-stepper .v-stepper__label {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-stepper .v-stepper__label small {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-stepper--non-linear .v-stepper__step:not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-stepper--vertical .v-stepper__content:not(:last-child) {\n  border-left: 1px solid rgba(0,0,0,0.12);\n}\n.theme--dark.v-stepper {\n  background: #303030;\n}\n.theme--dark.v-stepper .v-stepper__step:not(.v-stepper__step--active):not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__step__step {\n  background: rgba(255,255,255,0.5);\n}\n.theme--dark.v-stepper .v-stepper__step__step {\n  color: #fff;\n}\n.theme--dark.v-stepper .v-stepper__step__step .v-icon {\n  color: #fff;\n}\n.theme--dark.v-stepper .v-stepper__header .v-divider {\n  border-color: rgba(255,255,255,0.12);\n}\n.theme--dark.v-stepper .v-stepper__step--active .v-stepper__label {\n  text-shadow: 0px 0px 0px #fff;\n}\n.theme--dark.v-stepper .v-stepper__step--editable:hover {\n  background: rgba(255,255,255,0.06);\n}\n.theme--dark.v-stepper .v-stepper__step--editable:hover .v-stepper__label {\n  text-shadow: 0px 0px 0px #fff;\n}\n.theme--dark.v-stepper .v-stepper__step--complete .v-stepper__label {\n  color: rgba(255,255,255,0.87);\n}\n.theme--dark.v-stepper .v-stepper__step--inactive.v-stepper__step--editable:not(.v-stepper__step--error):hover .v-stepper__step__step {\n  background: rgba(255,255,255,0.75);\n}\n.theme--dark.v-stepper .v-stepper__label {\n  color: rgba(255,255,255,0.5);\n}\n.theme--dark.v-stepper .v-stepper__label small {\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-stepper--non-linear .v-stepper__step:not(.v-stepper__step--complete):not(.v-stepper__step--error) .v-stepper__label {\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-stepper--vertical .v-stepper__content:not(:last-child) {\n  border-left: 1px solid rgba(255,255,255,0.12);\n}\n.application--is-rtl .v-stepper .v-stepper__step__step {\n  margin-right: 0;\n  margin-left: 12px;\n}\n.v-stepper {\n  overflow: hidden;\n  position: relative;\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n}\n.v-stepper__header {\n  height: 72px;\n  align-items: stretch;\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n}\n.v-stepper__header .v-divider {\n  align-self: center;\n  margin: 0 -16px;\n}\n.v-stepper__items {\n  position: relative;\n  overflow: hidden;\n}\n.v-stepper__step__step {\n  align-items: center;\n  border-radius: 50%;\n  display: inline-flex;\n  font-size: 12px;\n  justify-content: center;\n  height: 24px;\n  margin-right: 8px;\n  min-width: 24px;\n  width: 24px;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);\n}\n.v-stepper__step__step .v-icon {\n  font-size: 18px;\n}\n.v-stepper__step {\n  align-items: center;\n  display: flex;\n  flex-direction: row;\n  padding: 24px;\n  position: relative;\n}\n.v-stepper__step--active .v-stepper__label {\n  transition: 0.3s cubic-bezier(0.4, 0, 0.6, 1);\n}\n.v-stepper__step--editable {\n  cursor: pointer;\n}\n.v-stepper__step.v-stepper__step--error .v-stepper__step__step {\n  background: transparent;\n  color: inherit;\n}\n.v-stepper__step.v-stepper__step--error .v-stepper__step__step .v-icon {\n  font-size: 24px;\n  color: inherit;\n}\n.v-stepper__step.v-stepper__step--error .v-stepper__label {\n  color: inherit;\n  text-shadow: none;\n  font-weight: 500;\n}\n.v-stepper__step.v-stepper__step--error .v-stepper__label small {\n  color: inherit;\n}\n.v-stepper__label {\n  align-items: flex-start;\n  display: flex;\n  flex-direction: column;\n  text-align: left;\n}\n.v-stepper__label small {\n  font-size: 12px;\n  font-weight: 300;\n  text-shadow: none;\n}\n.v-stepper__wrapper {\n  overflow: hidden;\n  transition: none;\n}\n.v-stepper__content {\n  top: 0;\n  padding: 24px 24px 16px 24px;\n  flex: 1 0 auto;\n  width: 100%;\n}\n.v-stepper__content > .v-btn {\n  margin: 24px 8px 8px 0;\n}\n.v-stepper--is-booted .v-stepper__content,\n.v-stepper--is-booted .v-stepper__wrapper {\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n.v-stepper--vertical {\n  padding-bottom: 36px;\n}\n.v-stepper--vertical .v-stepper__content {\n  margin: -8px -36px -16px 36px;\n  padding: 16px 60px 16px 23px;\n  width: auto;\n}\n.v-stepper--vertical .v-stepper__step {\n  padding: 24px 24px 16px;\n}\n.v-stepper--vertical .v-stepper__step__step {\n  margin-right: 12px;\n}\n.v-stepper--alt-labels .v-stepper__header {\n  height: auto;\n}\n.v-stepper--alt-labels .v-stepper__header .v-divider {\n  margin: 35px -67px 0;\n  align-self: flex-start;\n}\n.v-stepper--alt-labels .v-stepper__step {\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  flex-basis: 175px;\n}\n.v-stepper--alt-labels .v-stepper__step small {\n  align-self: center;\n}\n.v-stepper--alt-labels .v-stepper__step__step {\n  margin-right: 0;\n  margin-bottom: 11px;\n}\n@media only screen and (max-width: 959px) {\n  .v-stepper:not(.v-stepper--vertical) .v-stepper__label {\n    display: none;\n  }\n  .v-stepper:not(.v-stepper--vertical) .v-stepper__step__step {\n    margin-right: 0;\n  }\n}\n\n/** Theme */\n.theme--light.v-input--switch__thumb {\n  color: #fafafa;\n}\n.theme--light.v-input--switch__track {\n  color: rgba(0,0,0,0.38);\n}\n.theme--light.v-input--switch.v-input--is-disabled .v-input--switch__thumb {\n  color: #bdbdbd !important;\n}\n.theme--light.v-input--switch.v-input--is-disabled .v-input--switch__track {\n  color: rgba(0,0,0,0.12) !important;\n}\n.theme--dark.v-input--switch__thumb {\n  color: #bdbdbd;\n}\n.theme--dark.v-input--switch__track {\n  color: rgba(255,255,255,0.3);\n}\n.theme--dark.v-input--switch.v-input--is-disabled .v-input--switch__thumb {\n  color: #424242 !important;\n}\n.theme--dark.v-input--switch.v-input--is-disabled .v-input--switch__track {\n  color: rgba(255,255,255,0.1) !important;\n}\n.application--is-rtl .v-input--switch .v-input--selection-controls__ripple {\n  left: auto;\n  right: -14px;\n}\n.application--is-rtl .v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,\n.application--is-rtl .v-input--switch.v-input--is-dirty .v-input--switch__thumb {\n  -webkit-transform: translate(-16px, 0);\n          transform: translate(-16px, 0);\n}\n.v-input--switch__track,\n.v-input--switch__thumb {\n  background-color: currentColor;\n  pointer-events: none;\n  transition: inherit;\n}\n.v-input--switch__track {\n  border-radius: 8px;\n  height: 14px;\n  left: 2px;\n  opacity: 0.6;\n  position: absolute;\n  right: 2px;\n  top: calc(50% - 7px);\n}\n.v-input--switch__thumb {\n  border-radius: 50%;\n  top: calc(50% - 10px);\n  height: 20px;\n  position: relative;\n  width: 20px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);\n}\n.v-input--switch .v-input--selection-controls__input {\n  width: 38px;\n}\n.v-input--switch .v-input--selection-controls__ripple {\n  left: -14px;\n  top: calc(50% - 24px);\n}\n.v-input--switch.v-input--is-dirty .v-input--selection-controls__ripple,\n.v-input--switch.v-input--is-dirty .v-input--switch__thumb {\n  -webkit-transform: translate(16px, 0);\n          transform: translate(16px, 0);\n}\n\n/* Theme */\n.theme--light.v-system-bar {\n  background-color: #e0e0e0;\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-system-bar .v-icon {\n  color: rgba(0,0,0,0.54);\n}\n.theme--light.v-system-bar--lights-out {\n  background-color: rgba(255,255,255,0.7) !important;\n}\n.theme--dark.v-system-bar {\n  background-color: #000;\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-system-bar .v-icon {\n  color: rgba(255,255,255,0.7);\n}\n.theme--dark.v-system-bar--lights-out {\n  background-color: rgba(0,0,0,0.2) !important;\n}\n.v-system-bar {\n  align-items: center;\n  display: flex;\n  font-size: 14px;\n  font-weight: 500;\n  padding: 0 8px;\n}\n.v-system-bar .v-icon {\n  font-size: 16px;\n}\n.v-system-bar--fixed,\n.v-system-bar--absolute {\n  left: 0;\n  top: 0;\n  width: 100%;\n  z-index: 3;\n}\n.v-system-bar--fixed {\n  position: fixed;\n}\n.v-system-bar--absolute {\n  position: absolute;\n}\n.v-system-bar--status .v-icon {\n  margin-right: 4px;\n}\n.v-system-bar--window .v-icon {\n  font-size: 20px;\n  margin-right: 8px;\n}\n\n/* Theme */\n.theme--light.v-tabs__bar {\n  background-color: #fff;\n}\n.theme--light.v-tabs__bar .v-tabs__div {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-tabs__bar .v-tabs__item--disabled {\n  color: rgba(0,0,0,0.26);\n}\n.theme--dark.v-tabs__bar {\n  background-color: #424242;\n}\n.theme--dark.v-tabs__bar .v-tabs__div {\n  color: #fff;\n}\n.theme--dark.v-tabs__bar .v-tabs__item--disabled {\n  color: rgba(255,255,255,0.3);\n}\n.v-tabs {\n  position: relative;\n}\n.v-tabs__bar {\n  position: relative;\n  border-radius: inherit;\n}\n.v-tabs__icon {\n  align-items: center;\n  cursor: pointer;\n  display: inline-flex;\n  height: 100%;\n  position: absolute;\n  top: 0;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 32px;\n}\n.v-tabs__icon--prev {\n  left: 4px;\n}\n.v-tabs__icon--next {\n  right: 4px;\n}\n.v-tabs__wrapper {\n  overflow: hidden;\n  contain: content;\n  display: flex;\n}\n.v-tabs__wrapper--show-arrows {\n  margin-left: 40px;\n  margin-right: 40px;\n}\n.v-tabs__wrapper--show-arrows .v-tabs__container--align-with-title {\n  padding-left: 16px;\n}\n.v-tabs__container {\n  flex: 1 0 auto;\n  display: flex;\n  height: 48px;\n  list-style-type: none;\n  transition: -webkit-transform 0.6s cubic-bezier(0.86, 0, 0.07, 1);\n  transition: transform 0.6s cubic-bezier(0.86, 0, 0.07, 1);\n  transition: transform 0.6s cubic-bezier(0.86, 0, 0.07, 1), -webkit-transform 0.6s cubic-bezier(0.86, 0, 0.07, 1);\n  white-space: nowrap;\n  position: relative;\n}\n.v-tabs__container--overflow .v-tabs__div {\n  flex: 1 0 auto;\n}\n.v-tabs__container--grow .v-tabs__div {\n  flex: 1 0 auto;\n  max-width: none;\n}\n.v-tabs__container--icons-and-text {\n  height: 72px;\n}\n.v-tabs__container--align-with-title {\n  padding-left: 56px;\n}\n.v-tabs__container--fixed-tabs .v-tabs__div,\n.v-tabs__container--icons-and-text .v-tabs__div {\n  min-width: 72px;\n}\n.v-tabs__container--centered > .v-tabs__div:first-child,\n.v-tabs__container--fixed-tabs > .v-tabs__div:first-child,\n.v-tabs__container--right > .v-tabs__div:first-child {\n  margin-left: auto;\n}\n.v-tabs__container--centered .v-tabs__slider-wrapper + .v-tabs__div,\n.v-tabs__container--fixed-tabs .v-tabs__slider-wrapper + .v-tabs__div,\n.v-tabs__container--right .v-tabs__slider-wrapper + .v-tabs__div {\n  margin-left: auto;\n}\n.v-tabs__container--centered > .v-tabs__div:last-child,\n.v-tabs__container--fixed-tabs > .v-tabs__div:last-child {\n  margin-right: auto;\n}\n.v-tabs__container--icons-and-text .v-tabs__item {\n  flex-direction: column-reverse;\n}\n.v-tabs__container--icons-and-text .v-tabs__item .v-icon {\n  margin-bottom: 6px;\n}\n.v-tabs__div {\n  align-items: center;\n  display: inline-flex;\n  flex: 0 1 auto;\n  font-size: 14px;\n  font-weight: 500;\n  line-height: normal;\n  height: inherit;\n  max-width: 264px;\n  text-align: center;\n  text-transform: uppercase;\n  vertical-align: middle;\n}\n.v-tabs__item {\n  align-items: center;\n  color: inherit;\n  display: flex;\n  flex: 1 1 auto;\n  height: 100%;\n  justify-content: center;\n  max-width: inherit;\n  padding: 6px 12px;\n  text-decoration: none;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  white-space: normal;\n}\n.v-tabs__item:not(.v-tabs__item--active) {\n  opacity: 0.7;\n}\n.v-tabs__item--disabled {\n  pointer-events: none;\n}\n.v-tabs__slider {\n  height: 2px;\n  width: 100%;\n}\n.v-tabs__slider-wrapper {\n  bottom: 0;\n  margin: 0 !important;\n  position: absolute;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n}\n@media only screen and (max-width: 599px) {\n  .v-tabs__wrapper--show-arrows .v-tabs__container--align-with-title {\n    padding-left: 24px;\n  }\n  .v-tabs__container--fixed-tabs .v-tabs__div {\n    flex: 1 0 auto;\n  }\n}\n@media only screen and (min-width: 600px) {\n  .v-tabs__container--fixed-tabs .v-tabs__div,\n  .v-tabs__container--icons-and-text .v-tabs__div {\n    min-width: 160px;\n  }\n}\n\n.theme--light.v-textarea.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused textarea {\n  color: #fff;\n}\n.theme--dark.v-textarea.v-text-field--solo-inverted.v-text-field--solo.v-input--is-focused textarea {\n  color: rgba(0,0,0,0.87);\n}\n.application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot {\n  margin-right: 0;\n  margin-left: -12px;\n}\n.application--is-rtl .v-textarea.v-text-field--enclosed .v-text-field__slot textarea {\n  padding-right: 0;\n  padding-left: 12px;\n}\n.v-textarea textarea {\n  flex: 1 1 auto;\n  line-height: 18px;\n  max-width: 100%;\n  min-height: 32px;\n  outline: none;\n  padding: 7px 0 8px;\n  width: 100%;\n}\n.v-textarea .v-text-field__prefix {\n  padding-top: 4px;\n  align-self: start;\n}\n.v-textarea.v-text-field--full-width .v-text-field__slot textarea,\n.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__slot textarea {\n  margin-top: 0;\n}\n.v-textarea.v-text-field--full-width .v-text-field__details,\n.v-textarea.v-text-field--full-width.v-text-field--single-line .v-text-field__details {\n  bottom: 4px;\n}\n.v-textarea.v-text-field--enclosed .v-text-field__slot {\n  margin-right: -12px;\n}\n.v-textarea.v-text-field--enclosed .v-text-field__slot textarea {\n  padding-right: 12px;\n}\n.v-textarea.v-text-field--box .v-text-field__prefix,\n.v-textarea.v-text-field--enclosed .v-text-field__prefix,\n.v-textarea.v-text-field--box textarea,\n.v-textarea.v-text-field--enclosed textarea {\n  margin-top: 24px;\n}\n.v-textarea.v-text-field--box.v-text-field--single-line .v-text-field__prefix,\n.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-text-field__prefix,\n.v-textarea.v-text-field--box.v-text-field--single-line textarea,\n.v-textarea.v-text-field--enclosed.v-text-field--single-line textarea {\n  margin-top: 12px;\n}\n.v-textarea.v-text-field--box.v-text-field--single-line .v-label,\n.v-textarea.v-text-field--enclosed.v-text-field--single-line .v-label {\n  top: 18px;\n}\n.v-textarea.v-text-field--box.v-text-field--single-line.v-text-field--outline .v-input__control,\n.v-textarea.v-text-field--enclosed.v-text-field--single-line.v-text-field--outline .v-input__control {\n  padding-top: 0;\n}\n.v-textarea.v-text-field--solo {\n  align-items: flex-start;\n}\n.v-textarea.v-text-field--solo .v-input__prepend-inner,\n.v-textarea.v-text-field--solo .v-input__prepend-outer,\n.v-textarea.v-text-field--solo .v-input__append-inner,\n.v-textarea.v-text-field--solo .v-input__append-outer {\n  align-self: flex-start;\n  margin-top: 16px;\n}\n.v-textarea--auto-grow textarea {\n  overflow: hidden;\n}\n.v-textarea--no-resize textarea {\n  resize: none;\n}\n\n.theme--light.v-timeline:before {\n  background: rgba(0,0,0,0.12);\n}\n.theme--light.v-timeline .v-timeline-item__dot {\n  background: #fff;\n}\n.theme--light.v-timeline .v-timeline-item .v-card:before {\n  border-right-color: rgba(0,0,0,0.12);\n}\n.theme--dark.v-timeline:before {\n  background: rgba(255,255,255,0.12);\n}\n.theme--dark.v-timeline .v-timeline-item__dot {\n  background: #424242;\n}\n.theme--dark.v-timeline .v-timeline-item .v-card:before {\n  border-right-color: rgba(0,0,0,0.12);\n}\n.v-timeline-item {\n  display: flex;\n  flex-direction: row-reverse;\n  padding-bottom: 24px;\n}\n.v-timeline-item:nth-child(odd):not(.v-timeline-item--right),\n.v-timeline-item--left {\n  flex-direction: row;\n}\n.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-card:before,\n.v-timeline-item--left .v-card:before,\n.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-card:after,\n.v-timeline-item--left .v-card:after {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n  left: 100%;\n}\n.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-timeline-item__opposite,\n.v-timeline-item--left .v-timeline-item__opposite {\n  margin-left: 96px;\n  text-align: left;\n}\n.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-timeline-item__opposite .v-card:before,\n.v-timeline-item--left .v-timeline-item__opposite .v-card:before,\n.v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-timeline-item__opposite .v-card:after,\n.v-timeline-item--left .v-timeline-item__opposite .v-card:after {\n  -webkit-transform: rotate(0);\n          transform: rotate(0);\n  left: -10px;\n}\n.v-timeline-item:nth-child(even):not(.v-timeline-item--left) .v-card:before,\n.v-timeline-item--right .v-card:before,\n.v-timeline-item:nth-child(even):not(.v-timeline-item--left) .v-card:after,\n.v-timeline-item--right .v-card:after {\n  right: 100%;\n}\n.v-timeline-item:nth-child(even):not(.v-timeline-item--left) .v-timeline-item__opposite,\n.v-timeline-item--right .v-timeline-item__opposite {\n  margin-right: 96px;\n  text-align: right;\n}\n.v-timeline-item:nth-child(even):not(.v-timeline-item--left) .v-timeline-item__opposite .v-card:before,\n.v-timeline-item--right .v-timeline-item__opposite .v-card:before,\n.v-timeline-item:nth-child(even):not(.v-timeline-item--left) .v-timeline-item__opposite .v-card:after,\n.v-timeline-item--right .v-timeline-item__opposite .v-card:after {\n  -webkit-transform: rotate(180deg);\n          transform: rotate(180deg);\n  right: -10px;\n}\n.v-timeline-item__dot,\n.v-timeline-item__inner-dot {\n  border-radius: 50%;\n}\n.v-timeline-item__dot {\n  box-shadow: 0px 2px 1px -1px rgba(0,0,0,0.2), 0px 1px 1px 0px rgba(0,0,0,0.14), 0px 1px 3px 0px rgba(0,0,0,0.12);\n  align-self: center;\n  position: absolute;\n  height: 38px;\n  left: calc(50% - 19px);\n  width: 38px;\n}\n.v-timeline-item__dot .v-timeline-item__inner-dot {\n  height: 30px;\n  margin: 4px;\n  width: 30px;\n}\n.v-timeline-item__dot--small {\n  height: 24px;\n  left: calc(50% - 12px);\n  width: 24px;\n}\n.v-timeline-item__dot--small .v-timeline-item__inner-dot {\n  height: 18px;\n  margin: 3px;\n  width: 18px;\n}\n.v-timeline-item__dot--large {\n  height: 52px;\n  left: calc(50% - 26px);\n  width: 52px;\n}\n.v-timeline-item__dot--large .v-timeline-item__inner-dot {\n  height: 42px;\n  margin: 5px;\n  width: 42px;\n}\n.v-timeline-item__inner-dot {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n.v-timeline-item__body {\n  position: relative;\n  height: 100%;\n  flex: 1 1 100%;\n  max-width: calc(50% - 48px);\n}\n.v-timeline-item .v-card:before,\n.v-timeline-item .v-card:after {\n  content: '';\n  position: absolute;\n  border-top: 10px solid transparent;\n  border-bottom: 10px solid transparent;\n  border-right: 10px solid #000;\n  top: calc(50% - 10px);\n}\n.v-timeline-item .v-card:after {\n  border-right-color: inherit;\n}\n.v-timeline-item .v-card:before {\n  top: calc(50% - 10px + 2px);\n}\n.v-timeline-item__opposite {\n  flex: 1 1 auto;\n  align-self: center;\n  max-width: calc(50% - 48px);\n}\n.v-timeline-item--fill-dot .v-timeline-item__inner-dot {\n  height: inherit;\n  margin: 0;\n  width: inherit;\n}\n.v-timeline {\n  padding-top: 24px;\n  position: relative;\n}\n.v-timeline:before {\n  bottom: 0;\n  content: '';\n  height: 100%;\n  left: calc(50% - 1px);\n  position: absolute;\n  top: 0;\n  width: 2px;\n}\n.v-timeline--align-top .v-timeline-item {\n  position: relative;\n}\n.v-timeline--align-top .v-timeline-item__dot {\n  top: 6px;\n}\n.v-timeline--align-top .v-timeline-item__dot--small {\n  top: 12px;\n}\n.v-timeline--align-top .v-timeline-item__dot--large {\n  top: 0;\n}\n.v-timeline--align-top .v-timeline-item .v-card:before {\n  top: calc(0% + 10px + 2px);\n}\n.v-timeline--align-top .v-timeline-item .v-card:after {\n  top: calc(0% + 10px);\n}\n.v-timeline--dense:before {\n  left: 18px;\n}\n.v-timeline--dense .v-timeline-item:nth-child(odd):not(.v-timeline-item--right),\n.v-timeline--dense .v-timeline-item--left {\n  flex-direction: row-reverse;\n}\n.v-timeline--dense .v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-card:before,\n.v-timeline--dense .v-timeline-item--left .v-card:before,\n.v-timeline--dense .v-timeline-item:nth-child(odd):not(.v-timeline-item--right) .v-card:after,\n.v-timeline--dense .v-timeline-item--left .v-card:after {\n  right: initial;\n  left: -10px;\n  -webkit-transform: none;\n          transform: none;\n}\n.v-timeline--dense .v-timeline-item__dot {\n  left: 0;\n}\n.v-timeline--dense .v-timeline-item__dot--small {\n  left: 7px;\n}\n.v-timeline--dense .v-timeline-item__dot--large {\n  left: -7px;\n}\n.v-timeline--dense .v-timeline-item__body {\n  max-width: calc(100% - 64px);\n}\n.v-timeline--dense .v-timeline-item__opposite {\n  display: none;\n}\n\n.v-time-picker-title {\n  color: #fff;\n  display: flex;\n  line-height: 1;\n  justify-content: flex-end;\n}\n.v-time-picker-title__time {\n  white-space: nowrap;\n}\n.v-time-picker-title__time .v-picker__title__btn,\n.v-time-picker-title__time span {\n  align-items: center;\n  display: inline-flex;\n  height: 70px;\n  font-size: 70px;\n  justify-content: center;\n}\n.v-time-picker-title__ampm {\n  align-self: flex-end;\n  display: flex;\n  flex-direction: column;\n  font-size: 16px;\n  margin: 8px 0 6px 8px;\n  text-transform: uppercase;\n}\n.v-time-picker-title__ampm div:only-child {\n  flex-direction: row;\n}\n.v-picker__title--landscape .v-time-picker-title {\n  flex-direction: column;\n  justify-content: center;\n  height: 100%;\n}\n.v-picker__title--landscape .v-time-picker-title__time {\n  text-align: right;\n}\n.v-picker__title--landscape .v-time-picker-title__time .v-picker__title__btn,\n.v-picker__title--landscape .v-time-picker-title__time span {\n  height: 55px;\n  font-size: 55px;\n}\n.v-picker__title--landscape .v-time-picker-title__ampm {\n  margin: 16px 0 0;\n  align-self: initial;\n  text-align: center;\n}\n\n/** Themes */\n.theme--light.v-time-picker-clock {\n  background: #e0e0e0;\n}\n.theme--light.v-time-picker-clock .v-time-picker-clock__item--disabled {\n  color: rgba(0,0,0,0.26);\n}\n.theme--light.v-time-picker-clock .v-time-picker-clock__item--disabled.v-time-picker-clock__item--active {\n  color: rgba(255,255,255,0.3);\n}\n.theme--light.v-time-picker-clock--indeterminate .v-time-picker-clock__hand {\n  background-color: #bdbdbd;\n}\n.theme--light.v-time-picker-clock--indeterminate .v-time-picker-clock__hand:after {\n  color: #bdbdbd;\n}\n.theme--light.v-time-picker-clock--indeterminate .v-time-picker-clock__item--active {\n  background-color: #bdbdbd;\n}\n.theme--dark.v-time-picker-clock {\n  background: #616161;\n}\n.theme--dark.v-time-picker-clock .v-time-picker-clock__item--disabled {\n  color: rgba(255,255,255,0.3);\n}\n.theme--dark.v-time-picker-clock .v-time-picker-clock__item--disabled.v-time-picker-clock__item--active {\n  color: rgba(255,255,255,0.3);\n}\n.theme--dark.v-time-picker-clock--indeterminate .v-time-picker-clock__hand {\n  background-color: #757575;\n}\n.theme--dark.v-time-picker-clock--indeterminate .v-time-picker-clock__hand:after {\n  color: #757575;\n}\n.theme--dark.v-time-picker-clock--indeterminate .v-time-picker-clock__item--active {\n  background-color: #757575;\n}\n.v-time-picker-clock {\n  border-radius: 100%;\n  position: relative;\n  transition: 0.3s cubic-bezier(0.25, 0.8, 0.5, 1);\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  width: 100%;\n  padding-top: 100%;\n}\n.v-time-picker-clock__container {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 10px;\n}\n.v-time-picker-clock__hand {\n  height: calc(50% - 4px);\n  width: 2px;\n  bottom: 50%;\n  left: calc(50% - 1px);\n  -webkit-transform-origin: center bottom;\n          transform-origin: center bottom;\n  position: absolute;\n  will-change: transform;\n  z-index: 1;\n}\n.v-time-picker-clock__hand:before {\n  background: transparent;\n  border-width: 2px;\n  border-style: solid;\n  border-color: inherit;\n  border-radius: 100%;\n  width: 10px;\n  height: 10px;\n  content: '';\n  position: absolute;\n  top: -4px;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.v-time-picker-clock__hand:after {\n  content: '';\n  position: absolute;\n  height: 8px;\n  width: 8px;\n  top: 100%;\n  left: 50%;\n  border-radius: 100%;\n  border-style: solid;\n  border-color: inherit;\n  background-color: inherit;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.v-time-picker-clock__hand--inner:after {\n  height: 14px;\n}\n.v-picker--full-width .v-time-picker-clock__container {\n  max-width: 290px;\n}\n.v-time-picker-clock__inner {\n  position: absolute;\n  bottom: 27px;\n  left: 27px;\n  right: 27px;\n  top: 27px;\n}\n.v-time-picker-clock__item {\n  align-items: center;\n  border-radius: 100%;\n  cursor: default;\n  display: flex;\n  font-size: 16px;\n  justify-content: center;\n  height: 40px;\n  position: absolute;\n  text-align: center;\n  width: 40px;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.v-time-picker-clock__item > span {\n  z-index: 1;\n}\n.v-time-picker-clock__item:before,\n.v-time-picker-clock__item:after {\n  content: '';\n  border-radius: 100%;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  height: 14px;\n  width: 14px;\n  -webkit-transform: translate(-50%, -50%);\n          transform: translate(-50%, -50%);\n}\n.v-time-picker-clock__item:after,\n.v-time-picker-clock__item:before {\n  height: 40px;\n  width: 40px;\n}\n.v-time-picker-clock__item--active {\n  color: #fff;\n  cursor: default;\n  z-index: 2;\n}\n.v-time-picker-clock__item--disabled {\n  pointer-events: none;\n}\n\n/* Theme */\n.theme--light.v-toolbar {\n  background-color: #f5f5f5;\n  color: rgba(0,0,0,0.87);\n}\n.theme--dark.v-toolbar {\n  background-color: #212121;\n  color: #fff;\n}\n.application--is-rtl .v-toolbar__title:not(:first-child) {\n  margin-left: 0;\n  margin-right: 20px;\n}\n.v-toolbar {\n  transition: none;\n  box-shadow: 0px 2px 4px -1px rgba(0,0,0,0.2), 0px 4px 5px 0px rgba(0,0,0,0.14), 0px 1px 10px 0px rgba(0,0,0,0.12);\n  position: relative;\n  width: 100%;\n  will-change: padding-left, padding-right;\n}\n.v-toolbar[data-booted=\"true\"] {\n  transition: 0.2s cubic-bezier(0.4, 0, 0.2, 1);\n}\n.v-toolbar .v-text-field--enclosed,\n.v-toolbar .v-text-field--box {\n  margin: 0;\n}\n.v-toolbar .v-text-field--enclosed .v-text-field__details,\n.v-toolbar .v-text-field--box .v-text-field__details {\n  display: none;\n}\n/** Children */\n.v-toolbar .v-tabs {\n  width: 100%;\n}\n.v-toolbar__title {\n  font-size: 20px;\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n.v-toolbar__title:not(:first-child) {\n  margin-left: 20px;\n}\n.v-toolbar__content,\n.v-toolbar__extension {\n  align-items: center;\n  display: flex;\n  padding: 0 24px;\n}\n.v-toolbar__content .v-btn--icon,\n.v-toolbar__extension .v-btn--icon {\n  margin: 6px;\n}\n.v-toolbar__content > *:first-child,\n.v-toolbar__extension > *:first-child {\n  margin-left: 0;\n}\n.v-toolbar__content > *:first-child.v-btn--icon,\n.v-toolbar__extension > *:first-child.v-btn--icon {\n  margin-left: -6px;\n}\n.v-toolbar__content > *:first-child.v-menu .v-menu__activator .v-btn,\n.v-toolbar__extension > *:first-child.v-menu .v-menu__activator .v-btn,\n.v-toolbar__content > *:first-child.v-tooltip span .v-btn,\n.v-toolbar__extension > *:first-child.v-tooltip span .v-btn {\n  margin-left: 0;\n}\n.v-toolbar__content > *:first-child.v-menu .v-menu__activator .v-btn--icon,\n.v-toolbar__extension > *:first-child.v-menu .v-menu__activator .v-btn--icon,\n.v-toolbar__content > *:first-child.v-tooltip span .v-btn--icon,\n.v-toolbar__extension > *:first-child.v-tooltip span .v-btn--icon {\n  margin-left: -6px;\n}\n.v-toolbar__content > *:last-child,\n.v-toolbar__extension > *:last-child {\n  margin-right: 0;\n}\n.v-toolbar__content > *:last-child.v-btn--icon,\n.v-toolbar__extension > *:last-child.v-btn--icon {\n  margin-right: -6px;\n}\n.v-toolbar__content > *:last-child.v-menu .v-menu__activator .v-btn,\n.v-toolbar__extension > *:last-child.v-menu .v-menu__activator .v-btn,\n.v-toolbar__content > *:last-child.v-tooltip span .v-btn,\n.v-toolbar__extension > *:last-child.v-tooltip span .v-btn {\n  margin-right: 0;\n}\n.v-toolbar__content > *:last-child.v-menu .v-menu__activator .v-btn--icon,\n.v-toolbar__extension > *:last-child.v-menu .v-menu__activator .v-btn--icon,\n.v-toolbar__content > *:last-child.v-tooltip span .v-btn--icon,\n.v-toolbar__extension > *:last-child.v-tooltip span .v-btn--icon {\n  margin-right: -6px;\n}\n.v-toolbar__content > .v-list,\n.v-toolbar__extension > .v-list {\n  flex: 1 1 auto;\n  max-height: 100%;\n}\n.v-toolbar__content > .v-list:first-child,\n.v-toolbar__extension > .v-list:first-child {\n  margin-left: -24px;\n}\n.v-toolbar__content > .v-list:last-child,\n.v-toolbar__extension > .v-list:last-child {\n  margin-right: -24px;\n}\n.v-toolbar__extension > .v-toolbar__title {\n  margin-left: 72px;\n}\n.v-toolbar__items {\n  display: flex;\n  height: inherit;\n  max-width: 100%;\n  padding: 0;\n}\n.v-toolbar__items .v-btn {\n  align-items: center;\n  align-self: center;\n}\n.v-toolbar__items .v-tooltip,\n.v-toolbar__items .v-tooltip > span {\n  height: inherit;\n}\n.v-toolbar__items .v-btn:not(.v-btn--floating):not(.v-btn--icon),\n.v-toolbar__items .v-menu,\n.v-toolbar__items .v-menu__activator {\n  height: inherit;\n  margin: 0;\n}\n/** Types */\n.v-toolbar .v-overflow-btn,\n.v-toolbar .v-btn-toggle {\n  box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12);\n}\n.v-toolbar .v-input {\n  margin: 0;\n}\n.v-toolbar .v-overflow-btn .v-input__control:before,\n.v-toolbar .v-overflow-btn .v-input__slot:before {\n  display: none;\n}\n.v-toolbar--card {\n  border-radius: 2px 2px 0 0;\n  box-shadow: 0px 0px 0px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 0px 0px rgba(0,0,0,0.12);\n}\n.v-toolbar--fixed {\n  position: fixed;\n  z-index: 2;\n}\n.v-toolbar--fixed,\n.v-toolbar--absolute {\n  top: 0;\n  left: 0;\n}\n.v-toolbar--absolute {\n  position: absolute;\n  z-index: 2;\n}\n.v-toolbar--floating {\n  display: inline-flex;\n  margin: 16px;\n  width: auto;\n}\n.v-toolbar--clipped {\n  z-index: 3;\n}\n@media only screen and (max-width: 959px) {\n  .v-toolbar__content,\n  .v-toolbar__extension {\n    padding: 0 16px;\n  }\n  .v-toolbar__content > .v-list:first-child,\n  .v-toolbar__extension > .v-list:first-child {\n    margin-left: -16px;\n  }\n  .v-toolbar__content > .v-list:last-child,\n  .v-toolbar__extension > .v-list:last-child {\n    margin-right: -16px;\n  }\n}\n\n.v-tooltip__content {\n  background: #616161;\n  border-radius: 2px;\n  color: #fff;\n  font-size: 12px;\n  display: inline-block;\n  padding: 5px 8px;\n  position: absolute;\n  text-transform: initial;\n  width: auto;\n  box-shadow: 0px 3px 1px -2px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 1px 5px 0px rgba(0,0,0,0.12);\n}\n.v-tooltip__content[class*=\"-active\"] {\n  transition: 0.15s cubic-bezier(0.25, 0.8, 0.5, 1);\n  pointer-events: none;\n}\n.v-tooltip__content--fixed {\n  position: fixed;\n}\n@media only screen and (max-width: 959px) {\n  .v-tooltip .v-tooltip__content {\n    padding: 10px 16px;\n  }\n}\n\n/* Theme */\n.theme--light.v-treeview {\n  color: rgba(0,0,0,0.87);\n}\n.theme--light.v-treeview--hoverable .v-treeview-node__root:hover,\n.theme--light.v-treeview .v-treeview-node--active {\n  background: rgba(0,0,0,0.12);\n}\n.theme--dark.v-treeview {\n  color: #fff;\n}\n.theme--dark.v-treeview--hoverable .v-treeview-node__root:hover,\n.theme--dark.v-treeview .v-treeview-node--active {\n  background: rgba(255,255,255,0.12);\n}\n.application--is-rtl .v-treeview > .v-treeview-node {\n  margin-right: 0;\n}\n.application--is-rtl .v-treeview > .v-treeview-node--leaf {\n  margin-right: 24px;\n  margin-left: 0;\n}\n.application--is-rtl .v-treeview-node {\n  margin-right: 26px;\n  margin-left: 0;\n}\n.application--is-rtl .v-treeview-node--leaf {\n  margin-right: 50px;\n  margin-left: 0;\n}\n.application--is-rtl .v-treeview-node__toggle {\n  -webkit-transform: rotate(90deg);\n          transform: rotate(90deg);\n}\n.application--is-rtl .v-treeview-node__toggle--open {\n  -webkit-transform: none;\n          transform: none;\n}\n.v-treeview > .v-treeview-node {\n  margin-left: 0;\n}\n.v-treeview > .v-treeview-node--leaf {\n  margin-left: 24px;\n}\n.v-treeview-node {\n  margin-left: 26px;\n}\n.v-treeview-node--excluded {\n  display: none;\n}\n.v-treeview-node--click > .v-treeview-node__root,\n.v-treeview-node--click > .v-treeview-node__root > .v-treeview-node__content > * {\n  cursor: pointer;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-treeview-node--leaf {\n  margin-left: 50px;\n}\n.v-treeview-node__root {\n  display: flex;\n  align-items: center;\n  min-height: 34px;\n}\n.v-treeview-node__content {\n  display: flex;\n  flex-grow: 1;\n  flex-shrink: 0;\n  align-items: center;\n}\n.v-treeview-node__content .v-btn {\n  flex-grow: 0 !important;\n  flex-shrink: 1 !important;\n}\n.v-treeview-node__label {\n  font-size: 1.2rem;\n  margin-left: 6px;\n  flex-grow: 1;\n  flex-shrink: 0;\n}\n.v-treeview-node__label .v-icon {\n  padding-right: 8px;\n}\n.v-treeview-node__checkbox {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n}\n.v-treeview-node__toggle {\n  -webkit-user-select: none;\n     -moz-user-select: none;\n      -ms-user-select: none;\n          user-select: none;\n  -webkit-transform: rotate(-90deg);\n          transform: rotate(-90deg);\n}\n.v-treeview-node__toggle--open {\n  -webkit-transform: none;\n          transform: none;\n}\n.v-treeview-node__toggle--loading {\n  -webkit-animation: progress-circular-rotate 1s linear infinite;\n          animation: progress-circular-rotate 1s linear infinite;\n}\n.v-treeview-node__children {\n  transition: all 0.2s cubic-bezier(0, 0, 0.2, 1);\n}\n\n\n/*# sourceMappingURL=vuetify.css.map*/"],"sourceRoot":""}]);

// exports


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(187);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("3123aff7", content, true, {});

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(100);
exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Material Icons;font-style:normal;font-weight:400;src:url(" + escape(__webpack_require__(188)) + ");src:local(\"\\263A\"),url(" + escape(__webpack_require__(189)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(190)) + ") format(\"woff\"),url(" + escape(__webpack_require__(191)) + ") format(\"truetype\")}.material-icons{font-family:Material Icons;font-weight:400;font-style:normal;font-size:24px;display:inline-block;line-height:1;text-transform:none;letter-spacing:normal;word-wrap:normal;white-space:nowrap;direction:ltr;-webkit-font-smoothing:antialiased;text-rendering:optimizeLegibility;-moz-osx-font-smoothing:grayscale;font-feature-settings:\"liga\";font-display:block}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/node_modules/material-design-icons-iconfont/dist/material-design-icons.css"],"names":[],"mappings":"AACA,WACE,2BAA8B,AAC9B,kBAAmB,AACnB,gBAAiB,AACjB,kCAA8C,AAE9C,8JAAmM,CAAE,AAEvM,gBACE,2BAA8B,AAC9B,gBAAoB,AACpB,kBAAmB,AACnB,eAAgB,AAEhB,qBAAsB,AACtB,cAAe,AACf,oBAAqB,AACrB,sBAAuB,AACvB,iBAAkB,AAClB,mBAAoB,AACpB,cAAe,AAEf,mCAAoC,AAEpC,kCAAmC,AAEnC,kCAAmC,AAEnC,6BAA8B,AAC9B,kBAAoB,CAAE","file":"material-design-icons.css","sourcesContent":["@charset \"UTF-8\";\n@font-face {\n  font-family: 'Material Icons';\n  font-style: normal;\n  font-weight: 400;\n  src: url(\"./fonts/MaterialIcons-Regular.eot\");\n  /* For IE6-8 */\n  src: local(\"☺\"), url(\"./fonts/MaterialIcons-Regular.woff2\") format(\"woff2\"), url(\"./fonts/MaterialIcons-Regular.woff\") format(\"woff\"), url(\"./fonts/MaterialIcons-Regular.ttf\") format(\"truetype\"); }\n\n.material-icons {\n  font-family: 'Material Icons';\n  font-weight: normal;\n  font-style: normal;\n  font-size: 24px;\n  /* Preferred icon size */\n  display: inline-block;\n  line-height: 1;\n  text-transform: none;\n  letter-spacing: normal;\n  word-wrap: normal;\n  white-space: nowrap;\n  direction: ltr;\n  /* Support for all WebKit browsers. */\n  -webkit-font-smoothing: antialiased;\n  /* Support for Safari and Chrome. */\n  text-rendering: optimizeLegibility;\n  /* Support for Firefox. */\n  -moz-osx-font-smoothing: grayscale;\n  /* Support for IE. */\n  font-feature-settings: 'liga';\n  font-display: block; }\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/MaterialIcons-Regular.b661c28.eot";

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/MaterialIcons-Regular.bca3a18.woff2";

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/MaterialIcons-Regular.9219a80.woff";

/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/MaterialIcons-Regular.586090b.ttf";

/***/ }),
/* 192 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(193);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("72ee3af9", content, true, {});

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(100);
exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:dealger;src:url(" + escape(__webpack_require__(112)) + ");src:url(" + escape(__webpack_require__(112)) + "#iefix) format(\"embedded-opentype\"),url(" + escape(__webpack_require__(194)) + ") format(\"truetype\"),url(" + escape(__webpack_require__(195)) + ") format(\"woff\"),url(" + escape(__webpack_require__(196)) + "#dealger) format(\"svg\");font-weight:400;font-style:normal}[class*=\" dealger-\"],[class^=dealger-]{font-family:dealger!important;speak:none;font-style:normal;font-weight:400;font-variant:normal;text-transform:none;line-height:1;-webkit-font-smoothing:antialiased;-moz-osx-font-smoothing:grayscale}.dealger-file-empty:before{content:\"\\E924\"}.dealger-file-pdf:before{content:\"\\EADF\"}.dealger-file-openoffice:before{content:\"\\EAE0\"}.dealger-file-word:before{content:\"\\EAE1\"}.dealger-file-excel:before{content:\"\\EAE2\"}.dealger-crown:before{content:\"\\E900\"}.dealger-chart-pie:before{content:\"\\E901\"}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/static/dealger.css"],"names":[],"mappings":"AAAA,WACE,oBAAuB,AACvB,kCAAsC,AACtC,wMAGwD,AACxD,gBAAoB,AACpB,iBAAmB,CACpB,AAED,uCAEE,8BAAkC,AAClC,WAAY,AACZ,kBAAmB,AACnB,gBAAoB,AACpB,oBAAqB,AACrB,oBAAqB,AACrB,cAAe,AAGf,mCAAoC,AACpC,iCAAmC,CACpC,AAED,2BACE,eAAiB,CAClB,AACD,yBACE,eAAiB,CAClB,AACD,gCACE,eAAiB,CAClB,AACD,0BACE,eAAiB,CAClB,AACD,2BACE,eAAiB,CAClB,AACD,sBACE,eAAiB,CAClB,AACD,0BACE,eAAiB,CAClB","file":"dealger.css","sourcesContent":["@font-face {\r\n  font-family: 'dealger';\r\n  src:  url('fonts/dealger.eot?hde72c');\r\n  src:  url('fonts/dealger.eot?hde72c#iefix') format('embedded-opentype'),\r\n    url('fonts/dealger.ttf?hde72c') format('truetype'),\r\n    url('fonts/dealger.woff?hde72c') format('woff'),\r\n    url('fonts/dealger.svg?hde72c#dealger') format('svg');\r\n  font-weight: normal;\r\n  font-style: normal;\r\n}\r\n\r\n[class^=\"dealger-\"], [class*=\" dealger-\"] {\r\n  /* use !important to prevent issues with browser extensions that change fonts */\r\n  font-family: 'dealger' !important;\r\n  speak: none;\r\n  font-style: normal;\r\n  font-weight: normal;\r\n  font-variant: normal;\r\n  text-transform: none;\r\n  line-height: 1;\r\n\r\n  /* Better Font Rendering =========== */\r\n  -webkit-font-smoothing: antialiased;\r\n  -moz-osx-font-smoothing: grayscale;\r\n}\r\n\r\n.dealger-file-empty:before {\r\n  content: \"\\e924\";\r\n}\r\n.dealger-file-pdf:before {\r\n  content: \"\\eadf\";\r\n}\r\n.dealger-file-openoffice:before {\r\n  content: \"\\eae0\";\r\n}\r\n.dealger-file-word:before {\r\n  content: \"\\eae1\";\r\n}\r\n.dealger-file-excel:before {\r\n  content: \"\\eae2\";\r\n}\r\n.dealger-crown:before {\r\n  content: \"\\e900\";\r\n}\r\n.dealger-chart-pie:before {\r\n  content: \"\\e901\";\r\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 194 */
/***/ (function(module, exports) {

module.exports = "data:application/x-font-ttf;base64,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"

/***/ }),
/* 195 */
/***/ (function(module, exports) {

module.exports = "data:application/font-woff;base64,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"

/***/ }),
/* 196 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(198);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("1af255eb", content, true, {});

/***/ }),
/* 198 */
/***/ (function(module, exports, __webpack_require__) {

var escape = __webpack_require__(100);
exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, "@font-face{font-family:Roboto;font-style:normal;font-display:swap;font-weight:100;src:local(\"Roboto Thin \"),local(\"Roboto-Thin\"),url(" + escape(__webpack_require__(199)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(200)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:italic;font-display:swap;font-weight:100;src:local(\"Roboto Thin italic\"),local(\"Roboto-Thinitalic\"),url(" + escape(__webpack_require__(201)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(202)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-display:swap;font-weight:300;src:local(\"Roboto Light \"),local(\"Roboto-Light\"),url(" + escape(__webpack_require__(203)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(204)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:italic;font-display:swap;font-weight:300;src:local(\"Roboto Light italic\"),local(\"Roboto-Lightitalic\"),url(" + escape(__webpack_require__(205)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(206)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-display:swap;font-weight:400;src:local(\"Roboto Regular \"),local(\"Roboto-Regular\"),url(" + escape(__webpack_require__(207)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(208)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:italic;font-display:swap;font-weight:400;src:local(\"Roboto Regular italic\"),local(\"Roboto-Regularitalic\"),url(" + escape(__webpack_require__(209)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(210)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-display:swap;font-weight:500;src:local(\"Roboto Medium \"),local(\"Roboto-Medium\"),url(" + escape(__webpack_require__(211)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(212)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:italic;font-display:swap;font-weight:500;src:local(\"Roboto Medium italic\"),local(\"Roboto-Mediumitalic\"),url(" + escape(__webpack_require__(213)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(214)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-display:swap;font-weight:700;src:local(\"Roboto Bold \"),local(\"Roboto-Bold\"),url(" + escape(__webpack_require__(215)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(216)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:italic;font-display:swap;font-weight:700;src:local(\"Roboto Bold italic\"),local(\"Roboto-Bolditalic\"),url(" + escape(__webpack_require__(217)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(218)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:normal;font-display:swap;font-weight:900;src:local(\"Roboto Black \"),local(\"Roboto-Black\"),url(" + escape(__webpack_require__(219)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(220)) + ") format(\"woff\")}@font-face{font-family:Roboto;font-style:italic;font-display:swap;font-weight:900;src:local(\"Roboto Black italic\"),local(\"Roboto-Blackitalic\"),url(" + escape(__webpack_require__(221)) + ") format(\"woff2\"),url(" + escape(__webpack_require__(222)) + ") format(\"woff\")}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/node_modules/typeface-roboto/index.css"],"names":[],"mappings":"AACA,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,yIAIsD,CACvD,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,qJAI4D,CAC7D,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,2IAIsD,CACvD,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,uJAI4D,CAC7D,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,+IAIsD,CACvD,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,6JAI4D,CAC7D,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,+IAIsD,CACvD,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,2JAI4D,CAC7D,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,2IAIsD,CACvD,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,uJAI4D,CAC7D,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,6IAIsD,CACvD,AAGD,WACE,mBAAsB,AACtB,kBAAmB,AACnB,kBAAmB,AACnB,gBAAiB,AACjB,yJAI4D,CAC7D","file":"index.css","sourcesContent":["/* roboto-100normal - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 100;\n  src:\n    local('Roboto Thin '),\n    local('Roboto-Thin'),\n    url('./files/roboto-latin-100.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-100.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-100italic - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: italic;\n  font-display: swap;\n  font-weight: 100;\n  src:\n    local('Roboto Thin italic'),\n    local('Roboto-Thinitalic'),\n    url('./files/roboto-latin-100italic.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-100italic.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-300normal - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 300;\n  src:\n    local('Roboto Light '),\n    local('Roboto-Light'),\n    url('./files/roboto-latin-300.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-300.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-300italic - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: italic;\n  font-display: swap;\n  font-weight: 300;\n  src:\n    local('Roboto Light italic'),\n    local('Roboto-Lightitalic'),\n    url('./files/roboto-latin-300italic.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-300italic.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-400normal - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 400;\n  src:\n    local('Roboto Regular '),\n    local('Roboto-Regular'),\n    url('./files/roboto-latin-400.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-400.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-400italic - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: italic;\n  font-display: swap;\n  font-weight: 400;\n  src:\n    local('Roboto Regular italic'),\n    local('Roboto-Regularitalic'),\n    url('./files/roboto-latin-400italic.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-400italic.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-500normal - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 500;\n  src:\n    local('Roboto Medium '),\n    local('Roboto-Medium'),\n    url('./files/roboto-latin-500.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-500.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-500italic - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: italic;\n  font-display: swap;\n  font-weight: 500;\n  src:\n    local('Roboto Medium italic'),\n    local('Roboto-Mediumitalic'),\n    url('./files/roboto-latin-500italic.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-500italic.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-700normal - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 700;\n  src:\n    local('Roboto Bold '),\n    local('Roboto-Bold'),\n    url('./files/roboto-latin-700.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-700.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-700italic - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: italic;\n  font-display: swap;\n  font-weight: 700;\n  src:\n    local('Roboto Bold italic'),\n    local('Roboto-Bolditalic'),\n    url('./files/roboto-latin-700italic.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-700italic.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-900normal - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: normal;\n  font-display: swap;\n  font-weight: 900;\n  src:\n    local('Roboto Black '),\n    local('Roboto-Black'),\n    url('./files/roboto-latin-900.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-900.woff') format('woff'); /* Modern Browsers */\n}\n\n/* roboto-900italic - latin */\n@font-face {\n  font-family: 'Roboto';\n  font-style: italic;\n  font-display: swap;\n  font-weight: 900;\n  src:\n    local('Roboto Black italic'),\n    local('Roboto-Blackitalic'),\n    url('./files/roboto-latin-900italic.woff2') format('woff2'), /* Super Modern Browsers */\n    url('./files/roboto-latin-900italic.woff') format('woff'); /* Modern Browsers */\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 199 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-100.987b845.woff2";

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-100.e9dbbe8.woff";

/***/ }),
/* 201 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-100italic.6232f43.woff2";

/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-100italic.d704bb3.woff";

/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-300.55536c8.woff2";

/***/ }),
/* 204 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-300.a1471d1.woff";

/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-300italic.d69924b.woff2";

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-300italic.210a7c7.woff";

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-400.5d4aeb4.woff2";

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-400.bafb105.woff";

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-400italic.d8bcbe7.woff2";

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-400italic.9680d5a.woff";

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-500.2854671.woff2";

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-500.de8b743.woff";

/***/ }),
/* 213 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-500italic.510dec3.woff2";

/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-500italic.ffcc050.woff";

/***/ }),
/* 215 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-700.037d830.woff2";

/***/ }),
/* 216 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-700.cf6613d.woff";

/***/ }),
/* 217 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-700italic.010c1ae.woff2";

/***/ }),
/* 218 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-700italic.846d189.woff";

/***/ }),
/* 219 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-900.19b7a0a.woff2";

/***/ }),
/* 220 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-900.8c2ade5.woff";

/***/ }),
/* 221 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-900italic.7b770d6.woff2";

/***/ }),
/* 222 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/fonts/roboto-latin-900italic.bc833e7.woff";

/***/ }),
/* 223 */,
/* 224 */,
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */,
/* 229 */,
/* 230 */,
/* 231 */,
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(814),
  /* template */
  __webpack_require__(815),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(864),
  /* template */
  __webpack_require__(865),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(868),
  /* template */
  __webpack_require__(872),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1001),
  /* template */
  __webpack_require__(1002),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1016),
  /* template */
  __webpack_require__(1017),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1048),
  /* template */
  __webpack_require__(1049),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1084)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1086),
  /* template */
  __webpack_require__(1087),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 251 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1092),
  /* template */
  __webpack_require__(1093),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */,
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */,
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */,
/* 275 */,
/* 276 */,
/* 277 */,
/* 278 */,
/* 279 */,
/* 280 */,
/* 281 */,
/* 282 */,
/* 283 */,
/* 284 */,
/* 285 */,
/* 286 */,
/* 287 */,
/* 288 */,
/* 289 */,
/* 290 */,
/* 291 */,
/* 292 */,
/* 293 */,
/* 294 */,
/* 295 */,
/* 296 */,
/* 297 */,
/* 298 */,
/* 299 */,
/* 300 */,
/* 301 */,
/* 302 */,
/* 303 */,
/* 304 */,
/* 305 */,
/* 306 */,
/* 307 */,
/* 308 */,
/* 309 */,
/* 310 */,
/* 311 */,
/* 312 */,
/* 313 */,
/* 314 */,
/* 315 */,
/* 316 */,
/* 317 */,
/* 318 */,
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__ = __webpack_require__(32);










function createSteps(cxt) {
  var steps = [];
  var rule = function rule(v) {
    return !!v || 'Введите значение';
  };

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Укажите должника', function (step) {
    return '\u0418\u043D\u043D: ' + step.formatField('companyInn');
  }, {
    scheme: [{
      fieldType: 'v-text-field',
      label: 'Инн контрагента',
      name: 'companyInn',
      grow: true,
      size: { sm8: true, xs6: true }
    }, {
      fieldType: 'v-btn',
      slot: 'Выбрать',
      events: { 'click': cxt.selectCompany },
      shrink: true,
      size: { sm4: true, xs6: true }
    }]
  }, {
    companyInn: null,
    refCode: null
  }).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Укажите вид, название, номер и дату договора', function (step) {
    return '\u0414\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 ' + step.formatField('agreementNumber') + ' \u043E\u0442 ' + step.formatField('agreementDate') + ': ' + step.formatField('agreementName');
  }, {
    scheme: [{
      fieldType: 'v-select',
      label: 'Тип договора',
      name: 'agreementType',
      itemText: 'text',
      itemValue: 'value',
      items: [{
        text: 'Договор поставки',
        value: 1
      }, {
        text: 'type2',
        value: 2
      }],
      sm12: true
    }, {
      fieldType: 'v-text-field',
      label: 'Название договора',
      name: 'agreementName',
      sm12: true
    }, {
      fieldType: 'v-text-field',
      label: 'Номер договора',
      name: 'agreementNumber'
    }, {
      fieldType: 'v-date-field',
      label: 'Дата договора',
      name: 'agreementDate',
      rules: __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_array_of___default()(rule)
    }]
  }, {
    agreementType: 1,
    agreementName: null,
    agreementNumber: null,
    agreementDate: null
  }).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Сообщите, Основные положения договора', null, {
    scheme: [{
      fieldType: 'v-text-field',
      label: 'Пункт о предмете договора (п. 1.1)',
      name: 'agreement_topic_title1',
      xs12: true
    }, {
      fieldType: 'v-textarea',
      label: 'Выдержка о предмете договора',
      rows: 5,
      name: 'agreement_topic_content1',
      xs12: true
    }, {
      fieldType: 'v-text-field',
      label: 'Пункт о доставке (п. 1.2)',
      name: 'agreement_topic_title2',
      xs12: true
    }, {
      fieldType: 'v-textarea',
      label: 'Выдержка о доставке',
      rows: 5,
      name: 'agreement_topic_content2',
      xs12: true
    }, {
      fieldType: 'v-text-field',
      label: 'Пункт о подтверждающих документах (п. 1.3)',
      name: 'agreement_topic_title3',
      xs12: true
    }, {
      fieldType: 'v-textarea',
      label: 'Выдержка о подтверждающих документах',
      rows: 5,
      name: 'agreement_topic_content3',
      xs12: true
    }, {
      fieldType: 'v-text-field',
      label: 'Пункт о подтверждении выполнения обязательств (п. 1.4)',
      name: 'agreement_topic_title4',
      xs12: true
    }, {
      fieldType: 'v-textarea',
      label: 'Выдержка о подтверждении выполнения обязательств',
      rows: 5,
      name: 'agreement_topic_content4',
      xs12: true
    }, {
      fieldType: 'v-text-field',
      label: 'Пункт о праве собственности (п. 1.5)',
      name: 'agreement_topic_title5',
      xs12: true
    }, {
      fieldType: 'v-textarea',
      label: 'Выдержка о праве собственности',
      rows: 5,
      name: 'agreement_topic_content5',
      xs12: true
    }]
  }, {
    'agreement_topic_title1': null,
    'agreement_topic_content1': null,
    'agreement_topic_title2': null,
    'agreement_topic_content2': null,
    'agreement_topic_title3': null,
    'agreement_topic_content3': null,
    'agreement_topic_title4': null,
    'agreement_topic_content4': null,
    'agreement_topic_content5': null
  }).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Сообщите, Ваша компания была Поставщиком/Продавцом товара либо приобрела права требования по договору цессии или в результате правопреемства', function (step) {
    switch (step.model.clientRole) {
      case 1:
        return 'Мы были Поставщиком/Продавцом товара';
      case 2:
        return 'Мы приобрели права требования к должнику по вышеуказанному договору на основании договора цессии';
      case 3:
        return 'Мы приобрели права требования к должнику по вышеуказанному договору в связи с правопреемством (реорганизацией юридических лиц)';
    }
  }, {
    scheme: [{
      fieldType: 'v-select-radio',
      name: 'clientRole',
      itemText: 'text',
      itemValue: 'value',
      items: [{ value: 1, text: 'Мы были Поставщиком/Продавцом товара' }, { value: 2, text: 'Мы приобрели права требования к должнику по вышеуказанному договору на основании договора цессии (Вам надо будет предоставить Системе этот договор цессии)' }, { value: 3, text: 'Мы приобрели права требования к должнику по вышеуказанному договору в связи с правопреемством (реорганизацией юридических лиц) (Вам надо будет предоставить Системе доказательства реорганизации)' }],
      sm12: true
    }]
  }, {
    clientRole: 1
  }).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Сообщите на основании, какого объема документов следует рассчитать сумму долга и составить претензию', function (step) {
    return '\u0421\u0443\u043C\u043C\u0430 \u043F\u043E \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u044B\u043C ' + step.formatField('consignment_sum') + ' \u0440\u0443\u0431. \u0421\u0443\u043C\u043C\u0430 \u043F\u043E \u043F\u043B\u0430\u0442\u0435\u0436\u043A\u0430\u043C ' + step.formatField('payment_sum') + '  \u0440\u0443\u0431.';
  }, {
    scheme: [{
      fieldType: 'v-select-radio',
      name: 'invoicesCountType',
      itemText: 'text',
      itemValue: 'value',
      items: [{ value: 1, text: 'я предоставлю Системе только неоплаченные должником накладные, взыскать долг надо только по ним' }, { value: 2, text: 'я затрудняюсь определить оплаченные и неоплаченные накладные, Системе следует рассчитать сумму долга целиком по договору' }],
      sm12: true
    }, {
      fieldType: 'v-text-field',
      label: 'Сумма по накладным',
      name: 'consignment_sum',
      xs12: true,
      sm6: true
    }, {
      fieldType: 'v-text-field',
      label: 'Сумма по платежкам',
      name: 'payment_sum',
      xs12: true,
      sm6: true
    }]
  }, {
    invoicesCountType: 1,
    consignment_sum: null,
    payment_sum: null
  }).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Укажите, что надо взыскать с должника', function (step) {
    switch (step.model.debtType) {
      case 1:
        return 'Только долг';
      case 2:
        return 'Только неустойку';
      case 3:
        return 'Долг и неустойку';
    }
  }, {
    scheme: [{
      fieldType: 'v-select-radio',
      name: 'debtType',
      itemText: 'text',
      itemValue: 'value',
      items: [{ value: 1, text: 'Только долг за поставку товара' }, { value: 2, text: 'Только неустойку' }, { value: 3, text: 'Долг и неустойку' }],
      sm12: true
    }]
  }, {
    debtType: 1
  }).addToArray(steps);

  var claimIsGoodsReturned = function claimIsGoodsReturned(model, field) {
    return model['claimIsGoodsReturned'] === 1;
  };

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Сообщите, был ли осуществлен возврат товара', function (step) {
    return step.model.claimIsGoodsReturned === 1 ? '\u0414\u0430, \u0421\u0443\u043C\u043C\u0430 \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 ' + step.formatField('return_sum') + '  \u0440\u0443\u0431.' : 'Нет';
  }, {
    scheme: [{
      fieldType: 'v-select-radio',
      name: 'claimIsGoodsReturned',
      itemText: 'text',
      itemValue: 'value',
      items: [{ value: 1, text: 'Да (Вам надо будет предоставить Системе накладные на возврат товара)' }, { value: 2, text: 'Нет' }],
      sm12: true
    }, {
      fieldType: 'v-text-field',
      label: 'Сумма возврата',
      name: 'return_sum',
      xs12: true,
      sm6: true,
      if: claimIsGoodsReturned
    }]
  }, {
    claimIsGoodsReturned: 2,
    return_sum: null
  }).addToArray(steps);

  var claimIsSetOff = function claimIsSetOff(model, field) {
    return model['claimIsSetOff'] === 1;
  };

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Сообщите, была ли осуществлена частичная оплата товара путем зачета', function (step) {
    return step.model.claimIsSetOff === 1 ? '\u0414\u0430, \u0421\u0443\u043C\u043C\u0430 \u0437\u0430\u0447\u0435\u0442\u0430 ' + step.formatField('setoff_sum') + ' \u0440\u0443\u0431.' : 'Нет';
  }, {
    scheme: [{
      fieldType: 'v-select-radio',
      name: 'claimIsSetOff',
      itemText: 'text',
      itemValue: 'value',
      items: [{ value: 1, text: 'Да (Вам надо будет предоставить Системе соглашение/уведомление о зачете с доказательством ее го получения должником)' }, { value: 2, text: 'Нет' }],
      sm12: true
    }, {
      fieldType: 'v-text-field',
      label: 'Сумма зачета',
      name: 'setoff_sum',
      xs12: true,
      sm6: true,
      if: claimIsSetOff
    }]
  }, {
    claimIsSetOff: 1,
    setoff_sum: null
  }).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Сообщите, как рассчитывать сумму долга и пункт договора, в котором указано это условие (если есть такой пункт)', function (step) {
    switch (step.model.agreementSumCalcType) {
      case 1:
        return 'Сначала неустойка';
      case 2:
        return 'Сначала долг';
    }
  }, {
    scheme: [{
      fieldType: 'v-select-radio',
      name: 'agreementSumCalcType',
      itemText: 'text',
      itemValue: 'value',
      items: [{ value: 1, text: 'полученная оплата засчитывается в счет погашения суммы долга, а потом в счет погашения неустойки' }, { value: 2, text: 'полученная оплата подлежит зачету в счет погашения неустойки, а потом в счет погашения суммы долга' }]
    }, {
      fieldType: 'v-text-field',
      label: '№ пункта договора',
      name: 'agreementSumCalcTopic',
      xs12: true,
      shrink: true
    }]
  }, {
    agreementSumCalcType: 1,
    agreementSumCalcTopic: '5.1'
  }).addToArray(steps);

  var dependOnInterval = function dependOnInterval(model, field) {
    return model['agreementPercentCalcType'] !== 1;
  };
  var notDependOnInterval = function notDependOnInterval(model, field) {
    return model['agreementPercentCalcType'] === 1;
  };

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Укажите процент неустойки по договору и номер пункта договора, содержащий это условие', function (step) {
    if (step.model.agreementPercentCalcType === 1) {
      if (step.model.agreementPercentCalc) {
        return step.model.agreementPercentCalc + ' % \u0433\u043E\u0434\u043E\u0432\u044B\u0445';
      }
      return '';
    }
    var result = '';
    if (step.model.agreementPercentDays1) {
      result = '\u041F\u0440\u043E\u0441\u0440\u043E\u0447\u043A\u0430 ' + step.model.agreementPercentDays1 + ' \u0434\u043D\u0435\u0439 - ' + step.formatField('agreementPercentCalc1') + ' % \u0433\u043E\u0434\u043E\u0432\u044B\u0445';
    }
    if (step.model.agreementPercentDays2) {
      result = result.concat(', ' + step.model.agreementPercentDays2 + ' \u0434\u043D\u0435\u0439 - ' + step.formatField('agreementPercentCalc2') + ' % \u0433\u043E\u0434\u043E\u0432\u044B\u0445');
    }
    if (step.model.agreementPercentDays3) {
      result = result.concat(', ' + step.model.agreementPercentDays3 + ' \u0434\u043D\u0435\u0439 - ' + step.formatField('agreementPercentCalc3') + ' % \u0433\u043E\u0434\u043E\u0432\u044B\u0445');
    }
    return result;
  }, {
    scheme: [{
      fieldType: 'v-select-radio',
      name: 'agreementPercentCalcType',
      itemText: 'text',
      itemValue: 'value',
      items: [{ value: 1, text: ' % годовых не зависит от просрочки' }, { value: 2, text: ' % годовых зависит от просрочки' }],
      sm12: true
    }, {
      fieldType: 'v-text-field',
      label: 'неустойка за весь период(%)',
      name: 'agreementPercentCalc',
      xs10: true,
      if: notDependOnInterval
    }, {
      fieldType: 'v-text-field',
      label: 'просрочка (дней)',
      name: 'agreementPercentDays1',
      xs6: true,
      if: dependOnInterval
    }, {
      fieldType: 'v-text-field',
      label: 'неустойка (%)',
      name: 'agreementPercentCalc1',
      xs6: true,
      if: dependOnInterval
    }, {
      fieldType: 'v-text-field',
      label: 'просрочка (дней)',
      name: 'agreementPercentDays2',
      xs6: true,
      if: dependOnInterval
    }, {
      fieldType: 'v-text-field',
      label: 'неустойка (%)',
      name: 'agreementPercentCalc2',
      xs6: true,
      if: dependOnInterval
    }, {
      fieldType: 'v-text-field',
      label: 'просрочка (дней)',
      name: 'agreementPercentDays3',
      xs6: true,
      if: dependOnInterval
    }, {
      fieldType: 'v-text-field',
      label: 'неустойка (%)',
      name: 'agreementPercentCalc3',
      xs6: true,
      if: dependOnInterval
    }, {
      fieldType: 'v-text-field',
      label: '№ пункта договора',
      name: 'agreementPercentCalcTopic',
      xs12: true
    }]
  }, {
    agreementPercentCalcType: 1,
    agreementPercentCalcTopic: null,
    agreementPercentCalc: null,
    agreementPercentDays1: null,
    agreementPercentCalc1: null,
    agreementPercentDays2: null,
    agreementPercentCalc2: null,
    agreementPercentDays3: null,
    agreementPercentCalc3: null
  }).addToArray(steps);

  var isAgreementDayCalcType2 = function isAgreementDayCalcType2(model, field) {
    return model['agreementDayCalcType'] === 2;
  };
  var isAgreementDayCalcType3 = function isAgreementDayCalcType3(model, field) {
    return model['agreementDayCalcType'] === 3;
  };

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Укажите, с какого момента следует начислять неустойку и номер пункта договора, в котором указано это условие', function (step) {
    if (step.model.agreementDayCalcType === 1) {
      if (step.model.agreementPercentCalc) {
        return ' \u041D\u0435\u0443\u0441\u0442\u043E\u0439\u043A\u0430 \u0441 \u0434\u0430\u0442\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u0442\u043E\u0432\u0430\u0440\u0430';
      }
      return '';
    }
    if (step.model.agreementDayCalcType === 2) {
      return ' \u041D\u0435\u0443\u0441\u0442\u043E\u0439\u043A\u0430 \u0441 \u0434\u0430\u0442\u044B \u043F\u043E\u0441\u0442\u0430\u0432\u043A\u0438 \u0442\u043E\u0432\u0430\u0440\u0430 \u0441 \u043E\u0442\u0441\u0440\u043E\u0447\u043A\u043E\u0439 ' + step.formatField('agreementDayDays') + ' \u0434\u043D\u0435\u0439';
    }
    var result = '';
    if (step.model.agreementDayDays1) {
      result = '\u041E\u0442\u0441\u0440\u043E\u0447\u043A\u0430 \u043F\u0440\u0438 % ' + step.formatField('agreementDayCalc1') + ' - ' + step.formatField('agreementDayDays1') + ' \u0434\u043D\u0435\u0439';
    }
    if (step.model.agreementDayDays2) {
      result = '\u041E\u0442\u0441\u0440\u043E\u0447\u043A\u0430 \u043F\u0440\u0438 % ' + step.formatField('agreementDayCalc2') + ' - ' + step.formatField('agreementDayDays2') + ' \u0434\u043D\u0435\u0439';
    }
    if (step.model.agreementDayDays3) {
      result = '\u041E\u0442\u0441\u0440\u043E\u0447\u043A\u0430 \u043F\u0440\u0438 % ' + step.formatField('agreementDayCalc3') + ' - ' + step.formatField('agreementDayDays3') + ' \u0434\u043D\u0435\u0439';
    }
    return result;
  }, {
    scheme: [{
      fieldType: 'v-select-radio',
      name: 'agreementDayCalcType',
      itemText: 'text',
      itemValue: 'value',
      items: [{ value: 1, text: ' неустойка начислятся с даты поставки товара' }, { value: 2, text: ' неустойка начисляется с даты поставки с отсрочкой (дней)' }, { value: 3, text: ' отсрочка платежа зависит от % от суммы накладной' }],
      sm12: true
    }, {
      fieldType: 'v-text-field',
      label: 'отсрочка (дней)',
      name: 'agreementDayDays',
      xs10: true,
      if: isAgreementDayCalcType2
    }, {
      fieldType: 'v-text-field',
      label: '% от суммы',
      name: 'agreementDayCalc1',
      xs6: true,
      if: isAgreementDayCalcType3
    }, {
      fieldType: 'v-text-field',
      label: 'отсрочка (дней)',
      name: 'agreementDayDays1',
      xs6: true,
      if: isAgreementDayCalcType3
    }, {
      fieldType: 'v-text-field',
      label: '% от суммы',
      name: 'agreementDayCalc2',
      xs6: true,
      if: isAgreementDayCalcType3
    }, {
      fieldType: 'v-text-field',
      label: 'отсрочка (дней)',
      name: 'agreementDayDays2',
      xs6: true,
      if: isAgreementDayCalcType3
    }, {
      fieldType: 'v-text-field',
      label: '% от суммы',
      name: 'agreementDayCalc3',
      xs6: true,
      if: isAgreementDayCalcType3
    }, {
      fieldType: 'v-text-field',
      label: 'отсрочка (дней)',
      name: 'agreementDayDays3',
      xs6: true,
      if: isAgreementDayCalcType3
    }, {
      fieldType: 'v-text-field',
      label: '№ пункта договора',
      name: 'agreementDayCalcTopic',
      xs12: true
    }]
  }, {
    agreementDayCalcType: 1,
    agreementDayCalcTopic: null,
    agreementDayCalc: null,
    agreementDayDays1: null,
    agreementDayCalc1: null,
    agreementDayDays2: null,
    agreementDayCalc2: null,
    agreementDayDays3: null,
    agreementDayCalc3: null
  }).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Укажите срок ответа на претензию, если он предусмотрен договором и номер этого пункта договора ', function (step) {
    switch (step.model.agreementSumCalcType) {
      case 1:
        return 'С даты направления претензии';
      case 2:
        return 'С даты получения претензии';
    }
  }, {
    scheme: [{
      fieldType: 'v-select-radio',
      name: 'claimResponseDayType',
      itemText: 'text',
      itemValue: 'value',
      items: [{ value: 1, text: 'срок отсчитывается с даты направления претензии' }, { value: 2, text: 'срок отсчитывается с даты получения должником претензии' }],
      sm12: true
    }, {
      fieldType: 'v-text-field',
      label: 'срок ответа (дней)',
      name: 'claimResponseDayValue'
    }, {
      fieldType: 'v-text-field',
      label: '№ пункта договора',
      name: 'claimResponseDayTopic',
      xs12: true
    }]
  }, {
    claimResponseDayType: 1,
    claimResponseDayValue: null,
    claimResponseDayTopic: null
  }).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Сообщите банковские реквизиты ', null, {
    scheme: [{
      fieldType: 'v-textarea',
      label: 'Банковские реквизиты',
      rows: 5,
      name: 'clientBankAccount',
      xs12: true
    }]
  }, {
    clientBankAccount: null
  }).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Разместите в депозитарии и добавьте ссылки на документы необходимые для оформления претензии ', null, {
    scheme: []
  }, {}).addToArray(steps);

  new __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step('Отправьте запрос на подготовку претензии', null, {
    scheme: []
  }, {}).addToArray(steps);

  return steps;
}

var Model = function (_AssistClasses$Model) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Model, _AssistClasses$Model);

  function Model() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Model);

    // step1
    // this.companyInn = null
    // step2
    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Model.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Model)).call(this));

    _this.agreementType = 1;
    _this.agreementName = null;
    _this.agreementNumber = null;
    _this.agreementDate = null;
    // step3
    _this.clientRole = 1;
    // step4
    _this.invoicesCountType = 1;
    // step5
    _this.debtType = 1;
    // step6
    _this.claimIsGoodsReturned = 1;
    // step7
    _this.claimIsSetOff = 1;
    // step8
    _this.agreementSumCalcType = 1;
    _this.agreementSumCalcTopic = null;
    // step9
    _this.agreementPercentCalcType = 1;
    _this.agreementPercentCalcTopic = null;
    _this.agreementPercentCalc = null;
    _this.agreementPercentDays1 = null;
    _this.agreementPercentCalc1 = null;
    _this.agreementPercentDays2 = null;
    _this.agreementPercentCalc2 = null;
    _this.agreementPercentDays3 = null;
    _this.agreementPercentCalc3 = null;
    // step10
    _this.agreementDayCalcType = 1;
    _this.agreementDayCalcTopic = null;
    _this.agreementDayCalc = null;
    _this.agreementDayDays1 = null;
    _this.agreementDayCalc1 = null;
    _this.agreementDayDays2 = null;
    _this.agreementDayCalc2 = null;
    _this.agreementDayDays3 = null;
    _this.agreementDayCalc3 = null;
    // step11
    _this.claimResponseDayType = 1;
    _this.claimResponseDayValue = null;
    _this.claimResponseDayTopic = null;
    // step12
    _this.clientBankAccount = null;
    // step13
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Model, [{
    key: 'copy',
    value: function copy() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Model(), this);
    }
  }]);

  return Model;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Model);

var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Strategy);

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  createSteps: createSteps,
  Model: Model
});

/***/ }),
/* 320 */,
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */,
/* 338 */,
/* 339 */,
/* 340 */,
/* 341 */,
/* 342 */,
/* 343 */,
/* 344 */,
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */,
/* 364 */,
/* 365 */,
/* 366 */,
/* 367 */,
/* 368 */,
/* 369 */,
/* 370 */,
/* 371 */,
/* 372 */,
/* 373 */,
/* 374 */,
/* 375 */,
/* 376 */,
/* 377 */,
/* 378 */,
/* 379 */,
/* 380 */,
/* 381 */,
/* 382 */,
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */,
/* 405 */,
/* 406 */,
/* 407 */,
/* 408 */,
/* 409 */,
/* 410 */,
/* 411 */,
/* 412 */,
/* 413 */,
/* 414 */,
/* 415 */,
/* 416 */,
/* 417 */,
/* 418 */,
/* 419 */,
/* 420 */,
/* 421 */,
/* 422 */,
/* 423 */,
/* 424 */,
/* 425 */,
/* 426 */,
/* 427 */,
/* 428 */,
/* 429 */,
/* 430 */,
/* 431 */,
/* 432 */,
/* 433 */,
/* 434 */,
/* 435 */,
/* 436 */,
/* 437 */,
/* 438 */,
/* 439 */,
/* 440 */,
/* 441 */,
/* 442 */,
/* 443 */,
/* 444 */,
/* 445 */,
/* 446 */,
/* 447 */,
/* 448 */,
/* 449 */,
/* 450 */,
/* 451 */,
/* 452 */,
/* 453 */,
/* 454 */,
/* 455 */,
/* 456 */,
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(812),
  /* template */
  __webpack_require__(813),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 458 */,
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

var lang = {
  app: {},

  removeFormat: { title: 'Убрать форматирование' },

  bold: { title: 'Жирный' },
  italic: { title: 'Курсив' },
  underline: { title: 'Подчеркнутый' },
  strikeThrough: { title: 'Перечеркнутый' },

  superscript: { title: 'Верхний индекс' },
  subscript: { title: 'Нижний индекс' },
  indent: { title: 'Отступ' },
  outdent: { title: 'Выступ' },

  justifyLeft: { title: 'По левому краю' },
  justifyCenter: { title: 'По центру' },
  justifyRight: { title: 'По правому краю' },
  justifyFull: { title: 'На всю ширину' },

  insertOrderedList: { title: 'Вставить нумерованный список' },
  insertUnorderedList: { title: 'Вставить ненумерованный список' },

  foreColor: {
    title: 'Цвет шрифта',
    ok: 'ok',
    colorCode: 'Цветовой режим',
    invalidColorCodeMsg: 'Пожалуйста введите корректный цветовой код'
  },
  backColor: {
    title: 'Цвет фона',
    ok: 'ok',
    colorCode: 'Цветовой режим',
    invalidColorCodeMsg: 'Пожалуйста введите корректный цветовой код'
  },

  fontName: {},
  fontSize: {},
  code: {},
  element: {},

  design: {
    ieMsg: 'Вы должны выбрать текст, чтобы использовать эту функцию в браузере IE'
  },
  link: {
    title: 'Добавить ссылку',
    ok: 'OK'
  },
  unLink: {
    title: 'Убрать ссылку'
  },
  markdown: {
    title: 'markdown'
  },
  picture: {
    title: 'Вставить изображение',
    ok: 'OK',
    cancel: 'Отмена',
    invalidFile: 'Выбранный файл не является изображением'
  },
  sourceCode: {
    title: 'Исходный код'
  },
  fullscreen: {
    title: 'полный экран'
  },
  table: { title: 'Таблица' },
  undo: { title: 'Назадо' },
  redo: { title: 'Вперед' }
};
/* harmony default export */ __webpack_exports__["a"] = (lang);

/***/ }),
/* 460 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(826)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(828),
  /* template */
  __webpack_require__(829),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 461 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(830);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("214e3eca", content, true, {});

/***/ }),
/* 462 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(832)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(834),
  /* template */
  __webpack_require__(835),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(853),
  /* template */
  __webpack_require__(860),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 464 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(855),
  /* template */
  __webpack_require__(856),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(863),
  /* template */
  __webpack_require__(880),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 466 */,
/* 467 */,
/* 468 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(991)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(993),
  /* template */
  __webpack_require__(994),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1015),
  /* template */
  __webpack_require__(1096),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1023),
  /* template */
  __webpack_require__(1024),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1050),
  /* template */
  __webpack_require__(1053),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1060),
  /* template */
  __webpack_require__(1061),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1088),
  /* template */
  __webpack_require__(1089),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1090),
  /* template */
  __webpack_require__(1091),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1094),
  /* template */
  __webpack_require__(1095),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__router__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__store__ = __webpack_require__(36);



/* harmony default export */ __webpack_exports__["a"] = ({
  getTypeCode: function getTypeCode(itemId) {
    return __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].getters.getAssistMatterTypes().get(itemId.toUpperCase()) != null ? itemId.toUpperCase() : null;
  },
  open: function open(itemId, newWindow) {
    if (this.getTypeCode(itemId)) {
      itemId = itemId.toLowerCase();
    }
    var url = this.getItemRef(itemId);
    if (!newWindow) {
      __WEBPACK_IMPORTED_MODULE_0__router__["a" /* default */].push({ path: url.replace('#', '') });
    } else {
      __WEBPACK_IMPORTED_MODULE_1__store__["a" /* default */].dispatch('openLocation', url);
    }
  },
  getItemRef: function getItemRef(itemId) {
    return '#/assist/' + itemId;
  }
});

/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1161),
  /* template */
  __webpack_require__(1162),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 478 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1163),
  /* template */
  __webpack_require__(1164),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(1194)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1196),
  /* template */
  __webpack_require__(1221),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(252);
module.exports = __webpack_require__(682);


/***/ }),
/* 481 */,
/* 482 */,
/* 483 */,
/* 484 */,
/* 485 */,
/* 486 */,
/* 487 */,
/* 488 */,
/* 489 */,
/* 490 */,
/* 491 */,
/* 492 */,
/* 493 */,
/* 494 */,
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */,
/* 505 */,
/* 506 */,
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */,
/* 511 */,
/* 512 */,
/* 513 */,
/* 514 */,
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */,
/* 535 */,
/* 536 */,
/* 537 */,
/* 538 */,
/* 539 */,
/* 540 */,
/* 541 */,
/* 542 */,
/* 543 */,
/* 544 */,
/* 545 */,
/* 546 */,
/* 547 */,
/* 548 */,
/* 549 */,
/* 550 */,
/* 551 */,
/* 552 */,
/* 553 */,
/* 554 */,
/* 555 */,
/* 556 */,
/* 557 */,
/* 558 */,
/* 559 */,
/* 560 */,
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */,
/* 593 */,
/* 594 */,
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */,
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */,
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */,
/* 640 */,
/* 641 */,
/* 642 */,
/* 643 */,
/* 644 */,
/* 645 */,
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */,
/* 657 */,
/* 658 */,
/* 659 */,
/* 660 */,
/* 661 */,
/* 662 */,
/* 663 */,
/* 664 */,
/* 665 */,
/* 666 */,
/* 667 */,
/* 668 */,
/* 669 */,
/* 670 */,
/* 671 */,
/* 672 */,
/* 673 */,
/* 674 */,
/* 675 */,
/* 676 */,
/* 677 */,
/* 678 */,
/* 679 */,
/* 680 */,
/* 681 */,
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_css__ = __webpack_require__(184);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_design_icons_iconfont_dist_material_design_icons_css__ = __webpack_require__(186);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_material_design_icons_iconfont_dist_material_design_icons_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_material_design_icons_iconfont_dist_material_design_icons_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_dealger_css__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__static_dealger_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__static_dealger_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_typeface_roboto_index_css__ = __webpack_require__(197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_typeface_roboto_index_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_typeface_roboto_index_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cordova__ = __webpack_require__(686);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vue_cordova___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vue_cordova__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_head__ = __webpack_require__(687);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vue_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_vue_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios__ = __webpack_require__(688);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_axios__ = __webpack_require__(706);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_vue_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_vue_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__router__ = __webpack_require__(142);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__api_server__ = __webpack_require__(8);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.



// import '@mdi/font/css/materialdesignicons.css'
// import 'vue-material-design-icons/styles.css'













// import colors from 'vuetify/es5/util/colors'

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vuetify___default.a, {
  theme: {

    primary: '#80080a',
    secondary: '#606060',
    accent: '#DBBCBC',
    info: '#7F7F7F',
    // red: - default
    warning: '#FAAC59',
    success: '#088908'

    // primary.base: 'BA0C0F'
    // primary: '#80080a'
    // accent: '#FF888A',
    // accent: '#FFC6C7',

    // secondary.base: '#7F7F7F',
    // secondary: '#0C343D',
    // accent: '#ff5050'
    // accent: '#DBBCBC',
    // ,
    // warning: '#FAAC59',
    // success: '#088908'
  }
});

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_9_vue_axios___default.a, __WEBPACK_IMPORTED_MODULE_8_axios___default.a);
// your config here
// let config = {
//  toolbar: [
//    'removeFormat', 'undo', '|', 'elements', 'fontName', 'fontSize', 'foreColor', 'backColor'
//  ],
//  fontName: [
//    {val: 'arial black'},
//    {val: 'times new roman'},
//    {val: 'Courier New'}
//  ],
//  fontSize: ['12px', '14px', '16px', '18px', '0.8rem', '1.0rem', '1.2rem', '1.5rem', '2.0rem'],
//  uploadUrl: ''
// }

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.defaults.baseURL = __WEBPACK_IMPORTED_MODULE_13__api_server__["a" /* default */].getBaseUrl();
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].axios.defaults.headers.post['Content-Type'] = 'application/json; charset=utf-8';

__WEBPACK_IMPORTED_MODULE_4_vue__["default"].config.productionTip = false;
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6_vue_cordova___default.a);
__WEBPACK_IMPORTED_MODULE_4_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_7_vue_head___default.a);

// add cordova.js only if serving the app through file://
if (window.location.protocol === 'file:' || window.location.port === '3000') {
  var cordovaScript = document.createElement('script');
  cordovaScript.setAttribute('type', 'text/javascript');
  cordovaScript.setAttribute('src', 'cordova.js');
  document.body.appendChild(cordovaScript);
}

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_4_vue__["default"]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_11__router__["a" /* default */],
  store: __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_10__App___default.a },
  head: {
    meta: [{
      name: 'viewport',
      content: 'width=device-width, initial-scale=1, minimum-scale=1.0, maximum-scale=1.0, user-scalable=no'
    }]
  }
});

/***/ }),
/* 683 */,
/* 684 */,
/* 685 */,
/* 686 */,
/* 687 */,
/* 688 */,
/* 689 */,
/* 690 */,
/* 691 */,
/* 692 */,
/* 693 */,
/* 694 */,
/* 695 */,
/* 696 */,
/* 697 */,
/* 698 */,
/* 699 */,
/* 700 */,
/* 701 */,
/* 702 */,
/* 703 */,
/* 704 */,
/* 705 */,
/* 706 */,
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(708)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(710),
  /* template */
  __webpack_require__(711),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 708 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(709);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("2bd3d204", content, true, {});

/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"App.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(69);
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      cordova: __WEBPACK_IMPORTED_MODULE_0_vue__["default"].cordova
    };
  },
  created: function created() {
    var self = this;
    this.cordova.on('deviceready', function () {
      self.onDeviceReady();
    });
  },

  computed: {},
  methods: {
    onDeviceReady: function onDeviceReady() {
      // Handle the device ready event.
      this.cordova.on('pause', this.onPause, false);
      this.cordova.on('resume', this.onResume, false);
      if (this.cordova.device.platform === 'Android') {
        document.addEventListener('backbutton', this.onBackKeyDown, false);
      }
    },
    onPause: function onPause() {
      // Handle the pause lifecycle event.
      console.log('pause');
    },
    onResume: function onResume() {
      // Handle the resume lifecycle event.
      // SetTimeout required for iOS.
      setTimeout(function () {
        console.log('resume');
      }, 0);
    },
    onBackKeyDown: function onBackKeyDown() {
      // Handle the back-button event on Android. By default it will exit the app.
      navigator.app.exitApp();
    }
  }
});

/***/ }),
/* 711 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    attrs: {
      "light": ""
    }
  }, [_c('router-view')], 1)
},staticRenderFns: []}

/***/ }),
/* 712 */,
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__router__ = __webpack_require__(142);











// import moment from 'moment'

var state = {
  authorizingStarted: false,
  accessToken: null,
  breakpoint: null,
  status: {
    show: false,
    type: null,
    message: null,
    details: null
  },
  profile: {
    isHaveClient: null,
    isConfirmed: false,
    msg: '',
    nameShort: '',
    clientId: null,
    clientNameShort: ''
  },
  rights: {},
  accountClients: [],
  clientProfile: {
    isRefreshed: false,
    bankDetails: {
      account: '',
      bankName: '',
      corrAccount: '',
      bankBic: ''
    }
  },
  clientAccounts: {},
  dashboardCounters: {
    notReviewedChats: 0
  },
  messages: function messages() {
    return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a([['NOT_SPECIFIED', 'Что то пошло не так'], ['ACTION_NOTALLOWED', 'Действие не разрешено'], ['EMAIL_NOTFOUND', 'Адрес электронной почты не найден'], ['EMAIL_DUPLICATED', 'Адрес электронной почты уже зарегистрирован в системе'], ['EMAIL_WRONG', 'Неверный адрес электронной почты'], ['INN_WRONG', 'Неверный ИНН компании'], ['CONFIRMATION_CODE_WRONG', 'Неверный код подтверждения или истек срок действия кода'], ['SMS_PHONE_WRONG', 'Неверный номер телефона пользователя'], ['SMS_ERROR', 'Сервис СМС временно не доступен'], ['SMTP_CONFIG_WRONG', 'Ошибка конфигурации почтового сервера'], ['MACRO_WRONG', 'Ошибка обработки макроса'], ['INDIVIDUAL_DUPLICATED', 'Существует другая запись об этом контакте (ФИО и ИНН совпадают)'], ['EGRULAPI_TIMEOUT', 'Сервер не может обработать запрос, время ожидания истекло'], ['Internal Server Error', 'Внутренняя ошибка сервера'], ['invalid_grant', 'Пользователь с такими параметрами  входа не найден'], ['invalid_token', 'Ваша соединение устарело, необходимо снова войти в систему']]);
  },
  icons: function icons() {
    return new __WEBPACK_IMPORTED_MODULE_8_babel_runtime_core_js_map___default.a([['head', 'dealger-crown'], ['holder', 'work'], ['sign', 'dealger-crown'], ['loner', 'school']
    // ['holder', 'dealger-chart-pie']
    ]);
  }
};

// getters
var getters = {
  getLastLogin: function getLastLogin(state) {
    return function (nocache) {
      return __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].getLastLogin();
    };
  },
  getStatus: function getStatus(state) {
    return state.status;
  },
  getProfile: function getProfile(state) {
    return state.profile;
  },
  getProfileHaveClient: function getProfileHaveClient(state) {
    return state.profile.haveClient !== null && state.profile.haveClient;
  },
  getProfileLoaded: function getProfileLoaded(state) {
    return state.profile.isHaveClient !== null;
  },
  getAccountClients: function getAccountClients(state) {
    return state.accountClients;
  },
  getClientProfile: function getClientProfile(state) {
    return state.clientProfile;
  },
  getClientMonitoring: function getClientMonitoring(state) {
    return state.profile.clientMonitoring !== null && state.profile.clientMonitorng;
  },
  getClientAccounts: function getClientAccounts(state) {
    return state.clientAccounts;
  },
  //  TODO need refactor login routing
  getIsAuthorized: function getIsAuthorized(state) {
    return function (nocache) {
      return __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].getAccessToken() !== null || state.authorizingStarted;
    };
  },
  getDashboardCounters: function getDashboardCounters(state) {
    return state.dashboardCounters;
  },
  getIsAllow: function getIsAllow(state) {
    return function (obj) {
      var result = state.rights != null;
      __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(obj).forEach(function (_ref) {
        var _ref2 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
            k = _ref2[0],
            v = _ref2[1];

        var action = state.rights[k];
        result = result && action && Array.isArray(action) && action.indexOf(String(v)) >= 0;
      });
      return result;
    };
  },
  getIconName: function getIconName(state) {
    return function (name) {
      return state.icons().get(name);
    };
  },
  getIsMobile: function getIsMobile(state) {
    return state.breakpoint && state.breakpoint.xsOnly;
  },
  getDialogHeight: function getDialogHeight(state) {
    return state.breakpoint && (getters.getIsMobile(state) === true ? state.breakpoint.height : state.breakpoint.height * 0.9);
  },
  calcScroll: function calcScroll(state) {
    return function (delta, deltaMobile) {
      if (getters.getIsMobile(state) === true) {
        return state.breakpoint.height - (deltaMobile || delta) + 'px';
      }
      // Main toolbar incresed to 64 on large screen
      if (state.breakpoint.mdAndUp) {
        delta = delta + 16;
      }
      return state.breakpoint.height - delta + 'px';
    };
  },
  calcDialogScroll: function calcDialogScroll(state) {
    return function (delta, deltaMobile) {
      if (getters.getIsMobile(state) === true) {
        return state.breakpoint.height - (deltaMobile || delta) + 'px';
      }
      return state.breakpoint.height * 0.9 - delta + 'px';
    };
  },
  calcOfs: function calcOfs(state) {
    return function (delta, deltaMobile) {
      if (getters.getIsMobile(state) === true) {
        return (deltaMobile || delta) + '';
      }
      return delta + '';
    };
  },
  calcDialogOfs: function calcDialogOfs(state) {
    return function (delta, deltaMobile) {
      if (getters.getIsMobile(state) === true) {
        return (deltaMobile || delta) + '';
      }
      return state.breakpoint.height * 0.1 + delta + '';
    };
  }

  // actions
};var actions = {
  login: function login(_ref3, request) {
    var _this = this;

    var commit = _ref3.commit,
        state = _ref3.state;

    commit('startAuthorizing');
    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].saveToStorage('lastLogin', request.username);
    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].login(request, function () {
      commit('finishAuthorizing');
      _this.dispatch('fetchAccountProfile');
      commit('setSuccessStatus');
    }, function (e) {
      _this.dispatch('logout');
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при логине' });
    });
  },
  register: function register(_ref4, request) {
    var _this2 = this;

    var commit = _ref4.commit,
        state = _ref4.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].register(request, function (data) {
      // this.dispatch('fetchAccountProfile')
      commit('setStatus', {
        show: true,
        type: 'success',
        message: 'Пользователь ' + request.username + ' зарегистрирован в системе! Можете входить в систему! ' + 'Вам на почту был направлен код подтверждения для ввода при заполнении профайла' });
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при регистрации' });
      _this2.dispatch('logout');
    });
  },
  logout: function logout(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].logout();
    commit('setProfile', null);
    commit('setClientCompany', null);
    commit('setClientProfile', null);
    commit('finishAuthorizing');
  },
  confirmEmail: function confirmEmail(_ref6, code) {
    var _this3 = this;

    var commit = _ref6.commit,
        state = _ref6.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPost('/api/account/confirmEmail', code, function (data) {
      commit('setStatus', {
        show: true,
        type: 'success',
        message: 'Поздравляем! Ваша почта подтверждена, войдите заново и заполните личную информацию'
      });
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении кода подтверждения' });
      _this3.dispatch('logout');
    });
  },
  fetchAccountProfile: function fetchAccountProfile(_ref7) {
    var _this4 = this;

    var commit = _ref7.commit,
        state = _ref7.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiGet('/api/me/profile', function (data) {
      commit('setProfile', data);
      commit('setSuccessStatus');
      commit('cleanRights');
      _this4.dispatch('fetchDashboardCounters');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении профайла' });
    });
  },
  fetchAccountClients: function fetchAccountClients(_ref8) {
    var commit = _ref8.commit,
        state = _ref8.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiGet('/api/me/profile/clients', function (data) {
      commit('setAccountClients', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении данных о полномочиях пользователя' });
    });
  },
  fetchClientProfile: function fetchClientProfile(_ref9, force) {
    var commit = _ref9.commit,
        state = _ref9.state;

    if (state.clientProfile.isRefreshed && !force) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiGet('/api/me/client', function (data) {
      data.isRefreshed = true;
      commit('setClientProfile', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении данных о клиенте ' });
    });
  },
  fetchClientAccounts: function fetchClientAccounts(_ref10) {
    var commit = _ref10.commit,
        state = _ref10.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiGet('/api/me/client/accounts', function (data) {
      commit('setClientAccounts', data);
      // статус перезатерает предыдущее информационное сообщение
      // commit('setSuccessStatus')
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении инфрмации о представителях клиента ' });
    });
  },
  getClientAccount: function getClientAccount(_ref11) {
    var commit = _ref11.commit,
        state = _ref11.state;

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiGet('/api/me/client/account', function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении инфрмации о пользователе в текущей компании' });
      });
    });
  },
  fetchDashboardCounters: function fetchDashboardCounters(_ref12) {
    var commit = _ref12.commit,
        state = _ref12.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiGet('/api/me/dashboard/usercounters', function (data) {
      commit('setDashboardCounters', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о счетчиках ' });
    });
  },
  saveAccountProfile: function saveAccountProfile(_ref13, profile) {
    var _this5 = this;

    var commit = _ref13.commit,
        state = _ref13.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPost('/api/me/profile', profile, function (data) {
      commit('setProfile', data);
      _this5.dispatch('fetchAccountProfile');
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении профайла ' });
    });
  },
  attachCompany: function attachCompany(_ref14, request) {
    var commit = _ref14.commit,
        state = _ref14.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPost('/api/me/profile/client', request, function (data) {
      commit('setStatus', { show: true, type: 'success', message: 'Запрос на проверку достоверности данных был послан Администратору' });
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка формирования запроса подключения к компании  ' });
    });
  },
  setCurrentClient: function setCurrentClient(_ref15, clientId) {
    var _this6 = this;

    var commit = _ref15.commit,
        state = _ref15.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].saveToStorage('currentClient', clientId);
    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].refresh(null, function (data) {
      // при установки href происходит reload страницы и весь state обновляется
      location.href = '/';
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении токена' });
      _this6.dispatch('logout');
    });
  },
  updateFromEgrul: function updateFromEgrul(_ref16) {
    var _this7 = this;

    var commit = _ref16.commit,
        state = _ref16.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPost('/api/me/client/command-egrul-updates', null, function (data) {
      _this7.dispatch('fetchClientProfile', true);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка при обновлении данных из ЕГРЮЛ ' });
    });
  },
  saveClientProfile: function saveClientProfile(_ref17, profile) {
    var _this8 = this;

    var commit = _ref17.commit,
        state = _ref17.state;

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPost('/api/me/client', profile, function (data) {
        commit('setClientProfile', data);
        _this8.dispatch('fetchClientProfile', true);
        commit('setSuccessStatus');
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при обновлении профайла клиента ' });
        reject(e);
      });
    });
  },
  uploadPartnersFile: function uploadPartnersFile(_ref18, _ref19) {
    var commit = _ref18.commit,
        state = _ref18.state,
        rootState = _ref18.rootState;
    var fileName = _ref19.fileName,
        file = _ref19.file;

    var fd = new FormData();
    fd.append('file', file);
    fd.append('json', new Blob([__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_json_stringify___default()({ fileName: fileName })], {
      type: 'application/json'
    }));
    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiUpload('/api/me/partner/uploads', fd, function (data) {
      commit('setStatus', { show: true, type: 'success', message: 'Список контрагентов был послан Администратору' });
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при отсылке списка контрагентов ' });
    });
  },
  addClientAgent: function addClientAgent(_ref20, request) {
    var _this9 = this;

    var commit = _ref20.commit,
        state = _ref20.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPost('/api/me/client/agents', request, function (data) {
      _this9.dispatch('fetchClientAccounts');
      var msg = request.username ? 'Пользователь ' + request.username + ' подключен к Вашей компании!' + ' На почту был направленj уведомление' : 'Пользователь ' + request.dto.clientEmail + ' зарегистрирован в системе и подключен к Вашей компании!' + ' На почту был направлен пароль для входа в систему';
      commit('setStatus', {
        show: true,
        type: 'success',
        message: msg });
    }, function (e) {
      var msg = request.username ? 'Ошибка сервера при подключении пользователя ' + request.username + ' администратором компании ' : 'Ошибка сервера при создании и подключении пользователя ' + request.dto.clientEmail + ' администратором компании ';
      commit('setErrorStatus', { error: e, context: msg });
    });
  },
  updateClientAgent: function updateClientAgent(_ref21, agent) {
    var _this10 = this;

    var commit = _ref21.commit,
        state = _ref21.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPut('/api/me/client/agents/' + agent.accountProfileId, agent, function (data) {
      _this10.dispatch('fetchClientAccounts');
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при обновлении пользователя администратором компании' });
    });
  },
  removeClientAgent: function removeClientAgent(_ref22, agent) {
    var _this11 = this;

    var commit = _ref22.commit,
        state = _ref22.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiDelete('/api/me/client/agents/' + agent.accountProfileId, function (data) {
      _this11.dispatch('fetchClientAccounts');
      commit('setStatus', {
        show: true,
        type: 'success',
        message: 'Пользователь ' + agent.clientEmail + ' был отключен от Вашей компании!' + ' На почту было направлено уведомление' });
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при отключении от компании' });
    });
  },
  refreshAgentPassword: function refreshAgentPassword(_ref23, agent) {
    var commit = _ref23.commit,
        state = _ref23.state;

    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPost('/api/me/client/actions/password-refreshes', agent.accountProfileId, function (data) {
      commit('setStatus', {
        show: true,
        type: 'success',
        message: 'Пароль пользователя ' + agent.clientEmail + ' был обновлен! ' + 'На почту было направлено уведомление' });
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при сбросе пароля ' });
    });
  },
  getClientMailboxes: function getClientMailboxes(_ref24) {
    var commit = _ref24.commit,
        state = _ref24.state,
        rootState = _ref24.rootState;

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiGet('/api/me/client/mailboxes', function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка почтовых ящиков клиента ' });
      });
    });
  },
  getClientMailbox: function getClientMailbox(_ref25, id) {
    var commit = _ref25.commit,
        state = _ref25.state,
        rootState = _ref25.rootState;

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiGet('/api/me/client/mailboxes?ids=' + id, function (data) {
        resolve(data && data.length > 0 && data[0] || null);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении почтового ящика клиента' });
      });
    });
  },
  updateClientMailbox: function updateClientMailbox(_ref26, request) {
    var _this12 = this;

    var commit = _ref26.commit,
        state = _ref26.state,
        rootState = _ref26.rootState;

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPost('/api/me/client/command-mailbox-updates', { dto: request.dto }, function (data) {
        _this12.dispatch('fetchFavoriteCompanies', true);
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении почтового ящика клиента ' });
      });
    });
  },
  deleteClientMailbox: function deleteClientMailbox(_ref27, request) {
    var _this13 = this;

    var commit = _ref27.commit,
        state = _ref27.state,
        rootState = _ref27.rootState;

    return new __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiPost('/api/me/client/command-mailbox-deletes', { ids: request.ids }, function (data) {
        _this13.dispatch('fetchFavoriteCompanies', true);
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении записей о почтовом ящике клиента ' });
      });
    });
  },
  fetchRights: function fetchRights(_ref28, rights) {
    var commit = _ref28.commit,
        state = _ref28.state;

    function serialize(obj) {
      return '?' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_keys___default()(obj).reduce(function (a, k) {
        a.push(k + '=' + encodeURIComponent(obj[k]));
        return a;
      }, []).join('&');
    }
    var queryString = serialize(rights);
    // Special serialization, it does not work with server.apiGetParams
    __WEBPACK_IMPORTED_MODULE_9__api_server__["a" /* default */].apiGet('/api/me/rightsmap' + queryString, function (data) {
      commit('setRights', data);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о праах пользователя ' });
    });
  }
};

// mutations
var mutations = {
  setStatus: function setStatus(state, status) {
    if (status.type === 'error') {
      status.show = true;
    }
    if (status.show) {
      state.status = status;
    }
  },
  closeAlert: function closeAlert(state) {
    state.status.show = false;
  },
  setProfile: function setProfile(state, profile) {
    if (!profile) {
      profile = {
        msg: '',
        nameShort: '',
        clientId: null,
        clientNameShort: ''
      };
    } else {
      if (!(profile && profile.ruleAgreed)) {
        if (__WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].currentRoute.name !== 'DocDlg') {
          __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push({ name: 'Agreement' });
        }
      }
    }
    state.profile = profile;
  },
  setClientProfile: function setClientProfile(state, profile) {
    if (!profile) {
      profile = {
        isRefreshed: false,
        inn: '',
        email: '',
        nameShort: '',
        address: '',
        phone: '',
        website: '',
        bankDetails: {
          account: '',
          bankName: '',
          corrAccount: '',
          bankBic: ''
        },
        notes: '',
        about: '',
        contacts: '',
        services: '',
        price: '',
        docs: '',
        tags: '',
        other: ''
      };
    }
    state.clientProfile = profile;
  },
  setClientAccounts: function setClientAccounts(state, data) {
    state.clientAccounts = data;
  },
  startAuthorizing: function startAuthorizing(state) {
    state.authorizingStarted = true;
  },
  finishAuthorizing: function finishAuthorizing(state) {
    state.authorizingStarted = false;
    if (!getters.getIsAuthorized()) {
      __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push('/login');
    } else {
      var rdUrl = __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].currentRoute.query && __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].currentRoute.query.redirect ? __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].currentRoute.query.redirect : '/';
      __WEBPACK_IMPORTED_MODULE_10__router__["a" /* default */].push(rdUrl);
    }
  },
  setAccountClients: function setAccountClients(state, data) {
    state.accountClients = data;
  },
  setSuccessStatus: function setSuccessStatus(state, msg) {
    if (!msg) {
      msg = 'Данные получены';
    }
    this.commit('setStatus', { show: false, type: 'success', message: msg });
  },
  setWarningStatus: function setWarningStatus(state, msg) {
    if (!msg) {
      msg = 'Что то пошло не совсем так!';
    }
    this.commit('setStatus', { show: true, type: 'warning', message: msg });
  },
  setInfoStatus: function setInfoStatus(state, msg) {
    this.commit('setStatus', { show: true, type: 'info', message: msg });
  },
  setErrorStatus: function setErrorStatus(state, _ref29) {
    var error = _ref29.error,
        context = _ref29.context;

    var msg = error.message;
    var details = null;
    var type = 'error';
    if (!error.response && error.message === 'Network Error') {
      msg = 'Сервер не доступен';
      this.dispatch('logout');
    }
    if (error.response && error.response.data && error.response.data.code) {
      msg = state.messages().get(error.response.data.code);
      details = error.response.data.message;
    }
    if (error.response && error.response.data && error.response.data.error) {
      msg = state.messages().get(error.response.data.error);
      if (error.response.status && error.response.status === 401) {
        this.dispatch('logout');
        this.commit('setInfoStatus', msg);
        return;
      }
      if (error.response.status && error.response.status === 500) {
        details = error.response.data.message;
      }
    }
    this.commit('setStatus', { type: type, message: context + ' ( ' + msg + ' )!', details: details });
  },
  setDashboardCounters: function setDashboardCounters(state, data) {
    state.dashboardCounters = data;
  },
  cleanRights: function cleanRights(state) {
    state.rights = {};
  },
  setRights: function setRights(state, data) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_core_js_object_entries___default()(data).forEach(function (_ref30) {
      var _ref31 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_slicedToArray___default()(_ref30, 2),
          k = _ref31[0],
          v = _ref31[1];

      var action = state.rights[k];
      state.rights[k] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(Array.isArray(action) ? action.concat(v) : v));
    });
    state.rights = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, state.rights);
  },
  setBreakpoint: function setBreakpoint(state, value) {
    // console.log('setMobile', value)
    state.breakpoint = value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 714 */,
/* 715 */,
/* 716 */,
/* 717 */,
/* 718 */,
/* 719 */,
/* 720 */,
/* 721 */,
/* 722 */,
/* 723 */,
/* 724 */,
/* 725 */,
/* 726 */,
/* 727 */,
/* 728 */,
/* 729 */,
/* 730 */,
/* 731 */,
/* 732 */,
/* 733 */,
/* 734 */,
/* 735 */,
/* 736 */,
/* 737 */,
/* 738 */,
/* 739 */,
/* 740 */,
/* 741 */,
/* 742 */,
/* 743 */,
/* 744 */,
/* 745 */,
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */,
/* 751 */,
/* 752 */,
/* 753 */,
/* 754 */,
/* 755 */,
/* 756 */,
/* 757 */,
/* 758 */,
/* 759 */,
/* 760 */,
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_utils__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__StoreClasses__ = __webpack_require__(153);









// import moment from 'moment'

var state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  depoFileSet: new __WEBPACK_IMPORTED_MODULE_7__StoreClasses__["a" /* default */].ItemSet(function (item) {
    return item.uid;
  }),
  files: [],
  folders: [],
  paths: null,
  rootFolder: {
    fileName: 'root',
    path: '/',
    docName: 'Депозитарий'
  }

  // getters
};var getters = {
  getDepoUrl: function getDepoUrl(state, getters) {
    return function (uid) {
      return getters.getOpenSettings.linkBaseUrl + '/depo/' + uid;
    };
  },
  getDepoFilesUrl: function getDepoFilesUrl(state, getters) {
    return function (uids) {
      var uidsStr = 'uids=' + uids.join(',');
      return getters.getOpenSettings.linkBaseUrl + '/depo?' + uidsStr;
    };
  },
  getDepoCurrentPath: function getDepoCurrentPath(state, getters) {
    return getters.getDepoFileSet.getFilter().path || '//root';
  },
  getDepoPathByFolder: function getDepoPathByFolder(state, getters) {
    return function (folderName) {
      var folder = state.folders.find(function (item) {
        return item.fileName === folderName;
      }) || state.rootFolder;
      return folder.path + '/' + folder.fileName;
    };
  },
  getDepoDisplayPaths: function getDepoDisplayPaths(state) {
    return state.paths;
  },
  getDepoFolderById: function getDepoFolderById(state) {
    return function (uid) {
      return state.folders.find(function (file) {
        return file.uid === uid;
      });
    };
  },
  getDepoFilteredFolders: function getDepoFilteredFolders(state, getters) {
    var path = getters.getDepoCurrentPath;
    return state.folders.filter(function (file) {
      return file.path.localeCompare(path) === 0;
    });
  },
  getDepoFileSet: function getDepoFileSet(state) {
    return state.depoFileSet;
  },
  getDepoPathFolders: function getDepoPathFolders(state, getters) {
    var path = getters.getDepoCurrentPath;
    var result = [];
    if (path) {
      var fileNames = path.split('/');
      result = state.folders.filter(function (folder) {
        return fileNames.includes(folder.fileName);
      });
    }
    return result;
  },
  getDepoConstant: function getDepoConstant(state) {
    return state.constant;
  },
  renderDepoFileSignMessage: function renderDepoFileSignMessage(state, getters) {
    return function (fileDto) {
      return fileDto.signed ? '\u042F, ' + fileDto.signText + ', \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0430\u044E, \u0447\u0442\u043E \u0434\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0439 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 (\u0444\u0430\u0439\u043B) \u0440\u0430\u0432\u043D\u043E\u0437\u043D\u0430\u0447\u0435\u043D \u043F\u043E\u0434\u043B\u0438\u043D\u043D\u0438\u043A\u0443 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u043D\u0430 \u0431\u0443\u043C\u0430\u0436\u043D\u043E\u043C \u043D\u043E\u0441\u0438\u0442\u0435\u043B\u0435. \u041F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u043E \u043F\u0440\u043E\u0441\u0442\u043E\u0439 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0439 \u043F\u043E\u0434\u043F\u0438\u0441\u044C\u044E ' + __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].formatDate(fileDto.signed) + '.' : '';
    };
  },
  renderDepoFileSignature: function renderDepoFileSignature(state, getters) {
    return function (fileDto) {
      var template = ''.concat('<v-flex class="caption" v-if="fileDto && fileDto.signed">\n        <span>{{getters.renderDepoFileSignMessage(fileDto)}}</span>\n      </v-flex>');
      return {
        template: template,
        data: function data() {
          return {
            fileDto: fileDto,
            getters: getters
          };
        },
        methods: {
          formatDate: __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].formatDate
        }
      };
    };
  }

  // actions
};var actions = {
  getDepoFile: function getDepoFile(_ref, uid) {
    var commit = _ref.commit,
        state = _ref.state,
        getters = _ref.getters;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiGet('/api/me/depo/files/' + uid, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении описания файла ' });
        reject(e);
      });
    });
  },
  getDepoFolder: function getDepoFolder(_ref2, uid) {
    var commit = _ref2.commit,
        state = _ref2.state,
        getters = _ref2.getters;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiGet('/api/me/depo/folder/' + uid, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении описания файла ' });
        reject(e);
      });
    });
  },
  fetchDepoFiles: function fetchDepoFiles(_ref3) {
    var commit = _ref3.commit,
        state = _ref3.state,
        getters = _ref3.getters;

    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiGet('/api/me/depo/files', function (data) {
      commit('setDepoFiles', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка файлов из депозитария клиента ' });
    });
  },
  fetchDepoFileSet: function fetchDepoFileSet(_ref4, force) {
    var commit = _ref4.commit,
        state = _ref4.state,
        getters = _ref4.getters;

    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    if (!force && !state.depoFileSet.isChanged()) {
      return;
    }
    var page = force ? 0 : state.depoFileSet.page;
    var sort = state.depoFileSet.sort;
    // console.log('fetchDepoFileSet', sort)
    var fxt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, getters.getDepoFileSet.getFilter());
    commit('startDepoFileSet');
    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiGetParams('/api/me/depo/files', {
      size: 20,
      page: page,
      sort: sort,
      request: {
        search: fxt.search,
        path: fxt.path,
        tags: fxt.tags && fxt.tags.join(', ') || null,
        scope: fxt.scope
      }
    }, function (data) {
      commit('setDepoFileSet', { data: data, cxt: fxt });
      commit('setSuccessStatus');
    }, function (e) {
      commit('stopDepoFileSet');
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка файлов из депозитария ' });
    });
  },
  fetchDepoFolders: function fetchDepoFolders(_ref5) {
    var commit = _ref5.commit,
        state = _ref5.state,
        getters = _ref5.getters;

    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiGet('/api/me/depo/folders', function (data) {
      commit('setDepoFolders', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка файлов из депозитария клиента ' });
    });
  },
  getDepoFileProp: function getDepoFileProp(_ref6, uid) {
    var commit = _ref6.commit,
        state = _ref6.state,
        rootState = _ref6.rootState;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].openApiGet('/depo/' + uid + '/prop', function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении описания файла ' });
        reject(e);
      });
    });
  },
  getDepoFileProps: function getDepoFileProps(_ref7, request) {
    var commit = _ref7.commit,
        state = _ref7.state,
        rootState = _ref7.rootState;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var uidsStr = request.uids.join(',');
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].openApiGetParams('/depo/props', {
        uids: uidsStr
      }, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении описания файлов ' });
        reject(e);
      });
    });
  },
  getDepoFileVersions: function getDepoFileVersions(_ref8, uid) {
    var commit = _ref8.commit,
        state = _ref8.state,
        rootState = _ref8.rootState;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].openApiGet('/depo/' + uid + '/versions', function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении описания файла ' });
        reject(e);
      });
    });
  },
  fetchDepoFileProp: function fetchDepoFileProp(_ref9, uid) {
    var commit = _ref9.commit,
        state = _ref9.state,
        rootState = _ref9.rootState;

    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].openApiGet('/depo/' + uid + '/prop', function (data) {
      commit('setDepoFileProp', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении описания файла ' });
    });
  },
  createDepoFolder: function createDepoFolder(_ref10, fileItem) {
    var _this = this;

    var commit = _ref10.commit,
        state = _ref10.state,
        rootState = _ref10.rootState;

    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiPost('/api/me/depo/folders', fileItem, function (data) {
      _this.dispatch('fetchDepoFolders');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении описания файла ' });
    });
  },
  updateDepoFolder: function updateDepoFolder(_ref11, fileItem) {
    var _this2 = this;

    var commit = _ref11.commit,
        state = _ref11.state,
        rootState = _ref11.rootState;

    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiPut('/api/me/depo/folders/' + fileItem.uid, fileItem, function (data) {
      _this2.dispatch('fetchDepoFolders');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении описания файла ' });
    });
  },
  deleteDepoFolder: function deleteDepoFolder(_ref12, fileItem) {
    var _this3 = this;

    var commit = _ref12.commit,
        state = _ref12.state,
        rootState = _ref12.rootState;

    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiDelete('/api/me/depo/folders/' + fileItem.uid, function (data) {
      _this3.dispatch('fetchDepoFolders');
      _this3.dispatch('fetchDepoFileSet', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении папки ' });
    });
  },
  updateDepoFile: function updateDepoFile(_ref13, fileItem) {
    var _this4 = this;

    var commit = _ref13.commit,
        state = _ref13.state,
        rootState = _ref13.rootState;

    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiPut('/api/me/depo/files/' + fileItem.uid, fileItem, function (data) {
      _this4.dispatch('fetchDepoFileSet', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении описания файла ' });
    });
  },
  updateDepoFilePaths: function updateDepoFilePaths(_ref14, request) {
    var _this5 = this;

    var commit = _ref14.commit,
        state = _ref14.state,
        rootState = _ref14.rootState;

    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiPost('/api/me/depo/command-path-updates', { uids: request.uids, path: request.path }, function (data) {
      _this5.dispatch('fetchDepoFolders');
      _this5.dispatch('fetchDepoFileSet', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении папки размещения файлов ' });
    });
  },
  updateDepoFileTags: function updateDepoFileTags(_ref15, request) {
    var _this6 = this;

    var commit = _ref15.commit,
        state = _ref15.state,
        rootState = _ref15.rootState;

    __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiPost('/api/me/depo/command-tags-updates', { uids: request.uids, tags: request.tags }, function (data) {
      _this6.dispatch('fetchDepoFileSet');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при меток файла ' });
    });
  },
  signDepoFiles: function signDepoFiles(_ref16, request) {
    var _this7 = this;

    var commit = _ref16.commit,
        state = _ref16.state,
        rootState = _ref16.rootState;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiPost('/api/me/depo/command-file-signs', { uids: request.uids }, function (data) {
        _this7.dispatch('fetchDepoFileSet');
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при заверении электронной копии документа ' });
        reject(e);
      });
    });
  },
  uploadDepoFile: function uploadDepoFile(_ref17, _ref18) {
    var _this8 = this;

    var commit = _ref17.commit,
        state = _ref17.state,
        rootState = _ref17.rootState;
    var fileItem = _ref18.fileItem,
        file = _ref18.file;

    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var fd = new FormData();
      fd.append('file', file);
      fd.append('json', new Blob([__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(fileItem)], {
        type: 'application/json'
      }));
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiUpload('/api/me/depo/files/', fd, function (data) {
        resolve(data.uid);
        _this8.dispatch('fetchDepoFileSet');
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении описания файла ' });
      });
    });
  },
  uploadDepoFiles: function uploadDepoFiles(_ref19, _ref20) {
    var _this9 = this;

    var commit = _ref19.commit,
        state = _ref19.state,
        rootState = _ref19.rootState;
    var docItem = _ref20.docItem,
        files = _ref20.files;

    var uids = [];
    var count = files.length;
    return new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      files.forEach(function (file) {
        var meta = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, docItem, {
          fileName: file.name,
          fileExt: file.name.substring(file.name.lastIndexOf('.')),
          fileSize: file.size,
          docName: docItem.docName ? docItem.docName : file.name.substring(0, file.name.lastIndexOf('.'))
        });
        _this9.dispatch('uploadDepoFile', { fileItem: meta, file: file }).then(function (uid) {
          uids.push(uid);
          if (uids.length >= count) {
            resolve(uids);
          }
        });
      });
    });
  },
  copyDepoFileLink: function copyDepoFileLink(_ref21, url) {
    var commit = _ref21.commit,
        state = _ref21.state;

    __WEBPACK_IMPORTED_MODULE_5__api_utils__["a" /* default */].copyTextToClipboard(url);
    commit('setStatus', { show: true, type: 'success', message: 'Ссылка на файл скопирована в буфер обмена.' });
  }
};

// mutations
var mutations = {
  // Set Api
  setDepoFileSetFilterContext: function setDepoFileSetFilterContext(state, cxt) {
    state.depoFileSet.setFilter(cxt);
  },
  setDepoFileSetSort: function setDepoFileSetSort(state, sort) {
    state.depoFileSet.setSort(sort);
  },
  startDepoFileSet: function startDepoFileSet(state) {
    state.depoFileSet.clearChanged();
    state.depoFileSet.start();
  },
  stopDepoFileSet: function stopDepoFileSet(state) {
    state.depoFileSet.stop();
  },
  nextDepoFileSet: function nextDepoFileSet(state) {
    state.depoFileSet.nextPage();
  },
  setDepoFileSet: function setDepoFileSet(state, _ref22) {
    var data = _ref22.data,
        cxt = _ref22.cxt;

    state.depoFileSet.setItems(data, cxt);
    state.depoFileSet.stop();
  },

  // Set Api end
  setDepoFolders: function setDepoFolders(state, data) {
    state.folders = data;
    state.folders.unshift(state.rootFolder);
    this.commit('setDepoPaths');
  },
  setDepoPaths: function setDepoPaths(state) {
    var fs = state.folders.sort(function (a, b) {
      return a.path ? a.path.localeCompare(b.path) : -1;
    });
    var result = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a();
    fs.forEach(function (folder) {
      var path = folder.path;
      var dpath = result.get(path);

      if (!dpath) {
        dpath = folder.docName;
      } else {
        dpath = dpath + '/' + folder.docName;
      }
      result.set(folder.path + '/' + folder.fileName, dpath);
    });
    state.paths = result;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_server__ = __webpack_require__(8);


// import moment from 'moment'

var state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  clients: [],
  chats: [],
  filterContext: {
    search: '',
    scope: '',
    folderName: 0
  },
  chat: {
    prop: {
      id: null,
      name: null
    },
    members: [],
    posts: [],
    loadedPages: 0,
    chatId: null
  },
  postItem: {
    id: null,
    chatId: null,
    clientId: null,
    clientName: null,
    accountId: null,
    accountName: null,
    typeCode: null,
    text: null,
    published: null
  },
  postTypes: function postTypes() {
    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_map___default.a([['CHAT_INVITATION', { caption: 'Приглашение в чат' }], ['PLAIN', { caption: 'Сообщение' }], ['OFFER', { caption: 'Оферта' }], ['ACT', { caption: 'Акт/Накладная' }], ['OFFER_CANCEL', { caption: 'Отмена оферты' }], ['CLAIM', { caption: 'Претензия' }], ['OFFER_REQUEST', { caption: 'Запрос оферты / коммерческого предложения' }], ['NOTIFY', { caption: 'Уведомление' }]]);
  }
};

// getters
var getters = {
  getChatterChats: function getChatterChats(state) {
    return state.chats;
  },
  getChatterChat: function getChatterChat(state) {
    return state.chat.prop;
  },
  getChatterChatById: function getChatterChatById(state) {
    return function (id) {
      return state.chats.find(function (chat) {
        return chat.id === id;
      });
    };
  },
  getChatterPosts: function getChatterPosts(state) {
    return state.chat.posts;
  },
  getChatterPostById: function getChatterPostById(state) {
    return function (id) {
      return state.chat.posts.find(function (post) {
        return post.id === id;
      });
    };
  },
  getChatterFilterContext: function getChatterFilterContext(state) {
    return state.filterContext;
  },
  getChatterConstant: function getChatterConstant(state) {
    return state.constant;
  },
  getPostTypes: function getPostTypes(state) {
    return state.postTypes();
  },
  getPostTypeByCode: function getPostTypeByCode(state) {
    return function (code) {
      return state.postTypes.get(code);
    };
  }

  // actions
};var actions = {
  fetchChatterChats: function fetchChatterChats(_ref) {
    var commit = _ref.commit,
        state = _ref.state,
        getters = _ref.getters;

    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiGet('/api/me/chats', function (data) {
      commit('setChatterChats', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка диалогов клиента  ' });
    });
  },
  fetchChatterChat: function fetchChatterChat(_ref2, id) {
    var commit = _ref2.commit,
        state = _ref2.state,
        rootState = _ref2.rootState;

    if (id === 'root') {
      commit('setChatterChat', null);
      return;
    }
    __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiGet('/api/me/chats/' + id, function (data) {
      commit('setChatterChat', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении описания диалога ' });
    });
  },
  fetchChatterChatPosts: function fetchChatterChatPosts(_ref3, cxt) {
    var commit = _ref3.commit,
        state = _ref3.state,
        dispatch = _ref3.dispatch;

    if (cxt.chatId === 'root') {
      commit('setChatterChatPosts', null);
      return;
    }
    if (state.chat.chatId !== cxt.chatId) {
      commit('setChatterChatPosts', null);
    }
    var page = cxt.force ? 0 : state.chat.loadedPages;
    __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiGetParams('/api/me/chats/' + cxt.chatId + '/posts/', {
      size: 20,
      page: page,
      sort: 'id,desc'
    }, function (data) {
      commit('setChatterChatPosts', { chatId: cxt.chatId, data: data, force: cxt.force });
      commit('setSuccessStatus');
      dispatch('fetchDashboardCounters', null, { root: true });
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка диалогов клиента ' });
    });
  },
  fetchChatterPost: function fetchChatterPost(_ref4, _ref5) {
    var commit = _ref4.commit,
        state = _ref4.state,
        rootState = _ref4.rootState;
    var chatId = _ref5.chatId,
        postId = _ref5.postId;

    __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiGet('/chats/' + chatId + '/posts/' + postId, function (data) {
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении сообщения ' });
    });
  },
  addChatterChat: function addChatterChat(_ref6, item) {
    var _this = this;

    var commit = _ref6.commit,
        state = _ref6.state,
        rootState = _ref6.rootState;

    __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiPost('/api/me/chats/', item, function (data) {
      _this.dispatch('fetchChatterChats');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при создании диалога ' });
    });
  },
  updateChatterChat: function updateChatterChat(_ref7, item) {
    var _this2 = this;

    var commit = _ref7.commit,
        state = _ref7.state,
        rootState = _ref7.rootState;

    __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiPost('/api/me/chats/' + item.id, item, function (data) {
      _this2.dispatch('fetchChatterChats');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении описания диалога ' });
    });
  },
  deleteChatterChat: function deleteChatterChat(_ref8, item) {
    var _this3 = this;

    var commit = _ref8.commit,
        state = _ref8.state,
        rootState = _ref8.rootState;

    __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiPost('/api/me/chats/' + item.id + '/delete', item, function (data) {
      _this3.dispatch('fetchChatterChats');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении (изменении видимости) диалога ' });
    });
  },
  addChatterPost: function addChatterPost(_ref9, item) {
    var _this4 = this;

    var commit = _ref9.commit,
        state = _ref9.state,
        rootState = _ref9.rootState;

    __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiPost('/api/me/chats/' + item.chatId + '/posts', item, function (data) {
      _this4.dispatch('fetchChatterChatPosts', { chatId: item.chatId, force: true });
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при создании сообщения ' });
    });
  },
  setChatterPostAction: function setChatterPostAction(_ref10, _ref11) {
    var _this5 = this;

    var commit = _ref10.commit,
        state = _ref10.state,
        rootState = _ref10.rootState;
    var item = _ref11.item,
        action = _ref11.action;

    __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiPost('/api/me/posts/' + item.id + '/actions', action, function (data) {
      _this5.dispatch('fetchChatterChatPosts', { chatId: item.chatId, force: true });
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении статуса сообщения' });
    });
  }
};

// mutations
var mutations = {
  setChatterChats: function setChatterChats(state, data) {
    state.chats = data;
  },
  setChatterChat: function setChatterChat(state, data) {
    state.chat.prop = data;
  },
  setChatterChatPosts: function setChatterChatPosts(state, cxt) {
    if (!cxt) {
      state.chat.posts = [];
      state.chat.loadedPages = 0;
      state.chat.chatId = 'root';
    } else {
      cxt.data.content.sort(function (a, b) {
        return a.id - b.id;
      });
      state.chat.posts = cxt.force ? cxt.data.content : cxt.data.content.concat(state.chat.posts);
      state.chat.loadedPages = cxt.data.totalPages > cxt.data.number ? cxt.data.number + 1 : cxt.data.totalPages;
      state.chat.chatId = cxt.chatId;
    }
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 767 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__StoreClasses__ = __webpack_require__(153);


// import Vue from 'vue'



// import moment from 'moment'

var state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  tags: [],
  searchSet: new __WEBPACK_IMPORTED_MODULE_3__StoreClasses__["a" /* default */].ItemSet(function (item) {
    return item.ref.ref;
  }, {
    search: '',
    tagIds: [],
    isShowOther: false
  }),
  favoriteSet: new __WEBPACK_IMPORTED_MODULE_3__StoreClasses__["a" /* default */].ItemSet(function (item) {
    return item.ref.ref + '_' + item.accountId;
  }, {
    search: '',
    tagIds: [],
    isShowOther: false
  }),
  monitoringSet: new __WEBPACK_IMPORTED_MODULE_3__StoreClasses__["a" /* default */].ItemSet(function (item) {
    return item.ref.ref;
  }, {
    search: '',
    tagIds: [],
    isShowOther: false
  })

  // getters
};var getters = {
  getSearchSet: function getSearchSet(state) {
    return state.searchSet;
  },
  getFavoriteSet: function getFavoriteSet(state) {
    return state.favoriteSet;
  },
  getMonitoredSet: function getMonitoredSet(state) {
    return state.monitoringSet;
  },
  getFavoriteShowOther: function getFavoriteShowOther(state) {
    return state.favoriteSet.filter.isShowOther;
  },
  getTags: function getTags(state) {
    return state.tags;
  }

  // actions
};var actions = {
  fetchSearchCompanies: function fetchSearchCompanies(_ref, force) {
    var commit = _ref.commit,
        state = _ref.state,
        getters = _ref.getters;

    var fetchcall = function fetchcall(params) {
      // const cb = (count, data) => data.last ? 0 : count - data.numberOfElements
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        commit('startSearchCompanies');
        if (getters.getProfileHaveClient) {
          if (params && params.request && !params.request.search) {
            __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiGetParams('/api/me/visited/companies', params, function (data) {
              commit('setSearchCompanies', { data: data, cxt: fxt });
              commit('setSuccessStatus');
              resolve();
            }, function (e) {
              commit('stopSearchCompanies');
              commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка компаний  ' });
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiGetParams('/api/me/search/companies', params, function (data) {
              commit('setSearchCompanies', { data: data, cxt: fxt });
              commit('setSuccessStatus');
              resolve();
            }, function (e) {
              commit('stopSearchCompanies');
              commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка компаний  ' });
            });
          }
        } else {
          __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGetParams('/openapi/companies', params, function (data) {
            commit('setSearchCompanies', { data: data, cxt: fxt });
            commit('setSuccessStatus');
            resolve();
          }, function (e) {
            commit('stopSearchCompanies');
            commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка компаний  ' });
          });
        }
      });
    };
    if (!force && !state.searchSet.isChanged()) {
      return;
    }
    commit('closeAlert');
    var page = force ? 0 : state.searchSet.page;
    var fxt = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, getters.getSearchSet.getFilter());
    var size = 20;
    var startLoaded = state.searchSet.getLoadedSize();
    var limitLoaded = startLoaded + size / 2;
    var loop = function loop() {
      if (!state.searchSet.isLast() && startLoaded <= state.searchSet.getLoadedSize() && state.searchSet.getLoadedSize() < limitLoaded) {
        fetchcall({ size: size, page: page++, request: { search: fxt.search } }).then(function () {
          return loop();
        });
      }
    };
    loop();
  },
  fetchFavoriteCompanies: function fetchFavoriteCompanies(_ref2, force) {
    var commit = _ref2.commit,
        state = _ref2.state,
        getters = _ref2.getters;

    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    if (!force && !state.favoriteSet.isChanged()) {
      return;
    }
    var page = force ? 0 : state.favoriteSet.page;
    var fxt = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, getters.getFavoriteSet.getFilter());
    commit('startFavoriteCompanies');
    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiGetParams('/api/me/favorite/companies', {
      size: 100,
      page: page,
      request: {
        search: fxt.search,
        tagIds: fxt.tagIds,
        isShowOther: fxt.isShowOther,
        isMonitoring: false
      }
    }, function (data) {
      commit('setFavoriteCompanies', { data: data, cxt: fxt });
      commit('setSuccessStatus');
    }, function (e) {
      commit('stopFavoriteCompanies');
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка контрагентов клиента  ' });
    });
  },
  fetchMonitoredCompanies: function fetchMonitoredCompanies(_ref3, force) {
    var commit = _ref3.commit,
        state = _ref3.state,
        getters = _ref3.getters;

    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    if (!force && !state.monitoringSet.isChanged()) {
      return;
    }
    var page = force ? 0 : state.monitoringSet.page;
    var fxt = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, getters.getMonitoredSet.getFilter());
    commit('startMonitoredCompanies');
    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiGetParams('/api/me/favorite/companies', {
      size: 100,
      page: page,
      request: {
        search: fxt.search,
        tagIds: fxt.tagIds,
        isShowOther: false,
        isMonitoring: true
      }
    }, function (data) {
      commit('setMonitoredCompanies', { data: data, cxt: fxt });
      commit('setSuccessStatus');
    }, function (e) {
      commit('stopMonitoredCompanies');
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка контрагентов клиента  ' });
    });
  },
  getCompanyProps: function getCompanyProps(_ref4, refCode) {
    var commit = _ref4.commit,
        state = _ref4.state,
        getters = _ref4.getters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cb = function cb(data) {
        resolve(data);
      };
      var cbError = function cbError(e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о компании из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/companies/' + refCode, cb, cbError);
    });
  },
  getFavoriteRefs: function getFavoriteRefs(_ref5, refCode) {
    var commit = _ref5.commit,
        state = _ref5.state,
        getters = _ref5.getters;

    if (!(getters.getProfileLoaded && getters.getProfileHaveClient === true)) {
      return;
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var cb = function cb(data) {
        resolve(data);
      };
      var cbError = function cbError(e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о компании из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiGet('/api/me/favorites/' + refCode, cb, cbError);
    });
  },
  addFavoriteCompany: function addFavoriteCompany(_ref6, request) {
    var _this = this;

    var commit = _ref6.commit,
        state = _ref6.state,
        rootState = _ref6.rootState;

    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/favorite/companies/', { refCode: request.refCode, tagIds: request.tagIds }, function (data) {
      _this.dispatch('fetchFavoriteCompanies', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при добавлении контрагента в избранное ' });
    });
  },
  addFavoriteCompanies: function addFavoriteCompanies(_ref7, request) {
    var _this2 = this;

    var commit = _ref7.commit,
        state = _ref7.state,
        rootState = _ref7.rootState;

    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/favorite/command-companies-adds', { refCodes: request.refCodes, tagIds: request.tagIds }, function (data) {
      _this2.dispatch('fetchFavoriteCompanies', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при добавлении контрагента в избранное ' });
    });
  },
  deleteFavoriteCompany: function deleteFavoriteCompany(_ref8, refCode) {
    var _this3 = this;

    var commit = _ref8.commit,
        state = _ref8.state,
        rootState = _ref8.rootState;

    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiDelete('/api/me/favorite/companies/' + refCode, function (data) {
      _this3.dispatch('fetchFavoriteCompanies', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении контрагента из избранного ' });
    });
  },
  deleteFavoriteCompanies: function deleteFavoriteCompanies(_ref9, requests) {
    var _this4 = this;

    var commit = _ref9.commit,
        state = _ref9.state,
        rootState = _ref9.rootState;

    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/favorite/command-companies-deletes', { refCodes: requests.refCodes }, function (data) {
      _this4.dispatch('fetchFavoriteCompanies', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при добавлении контрагента в избранное ' });
    });
  },
  updateFavoriteCompanyNotes: function updateFavoriteCompanyNotes(_ref10, request) {
    var _this5 = this;

    var commit = _ref10.commit,
        state = _ref10.state,
        rootState = _ref10.rootState;

    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/favorite/companies/' + request.refCode + '/command-notes-updates', { notes: request.notes, privateNotes: request.privateNotes }, function (data) {
      _this5.dispatch('fetchFavoriteCompanies', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении примечания компании ' });
    });
  },
  switchClientMonitoring: function switchClientMonitoring(_ref11, request) {
    var _this6 = this;

    var commit = _ref11.commit,
        state = _ref11.state,
        rootState = _ref11.rootState;

    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/monitoring/command-monitoring-switches', { monitoring: request.monitoring, addFavorites: request.addFavorites }, function (data) {
      _this6.dispatch('fetchFavoriteCompanies', true);
      _this6.dispatch('fetchAccountProfile');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении режима мониторинга ' });
    });
  },
  updateMonitoringCompanies: function updateMonitoringCompanies(_ref12, request) {
    var _this7 = this;

    var commit = _ref12.commit,
        state = _ref12.state,
        rootState = _ref12.rootState;

    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/monitoring/command-monitoring-updates', { refCodes: request.refCodes, monitoring: request.monitoring }, function (data) {
      _this7.dispatch('fetchFavoriteCompanies', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменения режима мониторинга для компании ' });
    });
  },
  updateFavoriteCompanyTags: function updateFavoriteCompanyTags(_ref13, request) {
    var _this8 = this;

    var commit = _ref13.commit,
        state = _ref13.state,
        rootState = _ref13.rootState;

    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/favorite/companies/' + request.refCode + '/command-tags-updates', { tags: request.tags }, function (data) {
      _this8.dispatch('fetchFavoriteCompanies', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении меток компании ' });
    });
  },
  fetchTags: function fetchTags(_ref14, force) {
    var commit = _ref14.commit,
        state = _ref14.state;

    if (state.tags.length > 0 && !force) {
      return;
    }
    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiGet('/api/me/tags', function (data) {
      commit('setTags', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка меток клиента  ' });
    });
  },
  getCompanyBanks: function getCompanyBanks(_ref15, refCode) {
    var commit = _ref15.commit,
        state = _ref15.state,
        rootState = _ref15.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiGet('/api/me/favorites/' + refCode + '/banks', function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка банковских счетов компании  ' });
      });
    });
  },
  getCompanyBank: function getCompanyBank(_ref16, id) {
    var commit = _ref16.commit,
        state = _ref16.state,
        rootState = _ref16.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiGet('/api/me/companyBanks/' + id, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении банковского счета' });
      });
    });
  },
  updateCompanyBank: function updateCompanyBank(_ref17, request) {
    var _this9 = this;

    var commit = _ref17.commit,
        state = _ref17.state,
        rootState = _ref17.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/companies/command-bank-updates', { dto: request.dto }, function (data) {
        _this9.dispatch('fetchFavoriteCompanies', true);
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении банкоасктх реквизитов компании ' });
      });
    });
  },
  deleteCompanyBank: function deleteCompanyBank(_ref18, request) {
    var _this10 = this;

    var commit = _ref18.commit,
        state = _ref18.state,
        rootState = _ref18.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/companies/command-bank-deletes', { ids: request.ids }, function (data) {
        _this10.dispatch('fetchFavoriteCompanies', true);
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении записей о контактах ' });
      });
    });
  },
  getCompanyContacts: function getCompanyContacts(_ref19, refCode) {
    var commit = _ref19.commit,
        state = _ref19.state,
        rootState = _ref19.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiGet('/api/me/favorites/' + refCode + '/contacts', function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка контактов компании  ' });
      });
    });
  }
};

// mutations
var mutations = {
  setSearchFilterContext: function setSearchFilterContext(state, cxt) {
    state.searchSet.setFilter(cxt);
  },
  startSearchCompanies: function startSearchCompanies(state) {
    state.searchSet.clearChanged();
    state.searchSet.start();
  },
  stopSearchCompanies: function stopSearchCompanies(state) {
    state.searchSet.stop();
  },
  nextSearchCompanies: function nextSearchCompanies(state) {
    state.searchSet.nextPage();
  },
  setSearchCompanies: function setSearchCompanies(state, _ref20) {
    var data = _ref20.data,
        cxt = _ref20.cxt;

    state.searchSet.setItems(data, cxt);
    state.searchSet.stop();
  },
  setFavoritesFilterContext: function setFavoritesFilterContext(state, cxt) {
    state.favoriteSet.setFilter(cxt);
  },
  startFavoriteCompanies: function startFavoriteCompanies(state) {
    state.favoriteSet.clearChanged();
    state.favoriteSet.start();
  },
  stopFavoriteCompanies: function stopFavoriteCompanies(state) {
    state.favoriteSet.stop();
  },
  nextFavoriteCompanies: function nextFavoriteCompanies(state) {
    state.favoriteSet.nextPage();
  },
  setFavoriteCompanies: function setFavoriteCompanies(state, _ref21) {
    var data = _ref21.data,
        cxt = _ref21.cxt;

    state.favoriteSet.setItems(data, cxt);
    state.favoriteSet.stop();
  },
  setMonitoredFilterContext: function setMonitoredFilterContext(state, cxt) {
    state.monitoringSet.setFilter(cxt);
  },
  startMonitoredCompanies: function startMonitoredCompanies(state) {
    state.monitoringSet.clearChanged();
    state.monitoringSet.start();
  },
  stopMonitoredCompanies: function stopMonitoredCompanies(state) {
    state.monitoringSet.stop();
  },
  nextMonitoredCompanies: function nextMonitoredCompanies(state) {
    state.monitoringSet.nextPage();
  },
  setMonitoredCompanies: function setMonitoredCompanies(state, _ref22) {
    var data = _ref22.data,
        cxt = _ref22.cxt;

    state.monitoringSet.setItems(data, cxt);
    state.monitoringSet.stop();
  },
  setTags: function setTags(state, data) {
    state.tags = data.sort(function (a, b) {
      return a.name.localeCompare(b.name);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 768 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_utils__ = __webpack_require__(152);

// import Vue from 'vue'



// import moment from 'moment'

var state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  clientCompany: null,
  cachedRefs: {},
  requests: null,
  isSearching: false

  // getters
};var getters = {
  getClientUrl: function getClientUrl(state, getters) {
    return function (inn) {
      return getters.getOpenSettings.linkBaseUrl + '/pages/' + inn;
    };
  },
  getRefIsValid: function getRefIsValid(state, getters) {
    return function (ref) {
      var kind = ['ogrn', 'nza', 'ogrnip', 'COMPANY', 'HUMAN', 'FOREIGN', 'FAGENCY'];
      var rArr = ref.split(':');
      return rArr.length > 1 && kind.indexOf(rArr[0]) >= 0 && rArr[1] !== '0' && rArr[1] !== 'null';
    };
  },
  getRefToUrl: function getRefToUrl(state, getters) {
    return function (ref, profileId) {
      var rArr = ref.split(':');
      switch (rArr[0]) {
        case 'ogrn':
          return '#/clients/' + rArr[1] + (profileId ? '?profileId=' + profileId : '');
        case 'HUMAN':
          return '#/humans/' + rArr[1];
        case 'FOREIGN':
          return '#/foreigns/' + rArr[1];
        case 'PERSON':
          return '#/people/' + rArr[1];
        case 'nza':
          return '#/fagency/' + rArr[1] + (profileId ? '?profileId=' + profileId : '');
        case 'ogrnip':
          return '#/loners/' + rArr[1];
      }
      return '#/clients/' + rArr[1];
    };
  },
  getClientCompany: function getClientCompany(state) {
    return state.clientCompany;
  }

  // actions
};var actions = {
  copyCompanyLink: function copyCompanyLink(_ref, url) {
    var commit = _ref.commit,
        state = _ref.state;

    __WEBPACK_IMPORTED_MODULE_2__api_utils__["a" /* default */].copyTextToClipboard(url);
    commit('setStatus', { show: true, type: 'success', message: 'Ссылка на страницу компании скопирована в буфер обмена.' });
  },
  getCachedRefs: function getCachedRefs(_ref2, request) {
    var commit = _ref2.commit,
        state = _ref2.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var refcodesStr = request.refcodes.join(',');
      if (state.cachedRefs[refcodesStr]) {
        resolve(state.cachedRefs[refcodesStr]);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].openApiGetParams('/openapi/cached/refs', {
        id: refcodesStr
      }, function (data) {
        commit('setCachedRefs', { key: refcodesStr, value: data });
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении кешированной информвции о компаниях ' });
        reject(e);
      });
    });
  },
  getBriefCompaniesByInn: function getBriefCompaniesByInn(_ref3, request) {
    var commit = _ref3.commit,
        state = _ref3.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var refcodesStr = request.inns.map(function (inn) {
        return 'inn:' + inn;
      }).join(',');
      if (state.cachedRefs[refcodesStr]) {
        resolve(state.cachedRefs[refcodesStr]);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].openApiGetParams('/openapi/briefs', {
        id: refcodesStr
      }, function (data) {
        commit('setCachedRefs', { key: refcodesStr, value: data });
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информвции о компаниях ' });
        reject(e);
      });
    });
  },
  getBriefCompaniesByRefCode: function getBriefCompaniesByRefCode(_ref4, request) {
    var commit = _ref4.commit,
        state = _ref4.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var refcodesStr = request.refCodes.join(',');
      if (state.cachedRefs[refcodesStr]) {
        resolve(state.cachedRefs[refcodesStr]);
        return;
      }
      __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].openApiGetParams('/openapi/briefs', {
        id: refcodesStr
      }, function (data) {
        commit('setCachedRefs', { key: refcodesStr, value: data });
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информвции о компаниях ' });
        reject(e);
      });
    });
  },
  getBriefCompanies: function getBriefCompanies(_ref5, request) {
    var commit = _ref5.commit,
        state = _ref5.state;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var innsStr = request.inns.join(',');
      innsStr = innsStr.replaceAll('nza:', '').replaceAll('ogrn:', '').replaceAll('ogrnip:', '').replaceAll('inn:', '');
      if (state.cachedRefs[innsStr]) {
        resolve(state.cachedRefs[innsStr]);
        return;
      }
      var params = { size: request.inns.length, page: 0, request: { search: innsStr } };
      __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].openApiGetParams('/openapi/companies', params, function (data) {
        var dtos = data.content.map(function (c) {
          return c.ref;
        });
        resolve(dtos);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка компаний  ' });
        reject(e);
      });
    });
  },
  convertInnToRefCode: function convertInnToRefCode(_ref6, request) {
    var commit = _ref6.commit,
        state = _ref6.state,
        rootState = _ref6.rootState;

    return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].openApiPost('/openapi/command-code-converts', { codes: request.inns }, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при добавлении контрагента в избранное ' });
        reject(e);
      });
    });
  }
};

// mutations
var mutations = {
  setClientCompany: function setClientCompany(state, company) {
    state.clientCompany = company;
  },
  setCachedRefs: function setCachedRefs(state, pair) {
    state.cachedRefs[pair.key] = pair.value;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 769 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_formats__ = __webpack_require__(5);



var state = {};

// getters
var getters = {
  renderReference: function renderReference(state, getters) {
    return function (item, target) {
      return ''.concat('<span>', getters.getRefIsValid(item.ref) ? '<a href=' + getters.getRefToUrl(item.ref) + ' ' + (target ? 'target="' + target + '"' : '') + '>' : '', '<b>' + item.caption + '</b>', getters.getRefIsValid(item.ref) ? '</a>' : '', '</span>');
    };
  },
  renderHeads: function renderHeads(state, getters) {
    return function (ref) {
      var result = [];
      if (ref.management) {
        result = result.concat('Управляющая компания: ' + ref.management);
      }
      if (ref.heads) {
        if (ref.namespace === 'ogrnip') {
          result = result.concat(ref.heads.map(function (h) {
            return ''.concat(h.nameShort);
          }));
        } else {
          result = result.concat(ref.heads.map(function (h) {
            return ''.concat(h.position, ': ', h.nameShort);
          }));
        }
      }
      return result.join(', ');
    };
  },
  renderEmployeeReference: function renderEmployeeReference(state, getters) {
    return function (item, target) {
      console.log('renderEmployeeReference', item);
      return ''.concat('<span>', getters.getRefIsValid(item.ref) ? '<a href=' + getters.getRefToUrl(item.ref) + ' ' + (target ? 'target="' + target + '"' : '') + '>' : '', '<b>' + item.nameFull + '</b>', getters.getRefIsValid(item.ref) ? '</a>' : '', '</span>');
    };
  },
  renderShare: function renderShare(state, getters) {
    return function (share) {
      if (share == null) {
        return '';
      }
      var typeCode = share.typeCode;
      var numerator = __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].getValue(share, ['part', 'numerator']);
      var denominator = __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].getValue(share, ['part', 'denominator']);
      denominator = denominator !== 0 ? denominator : null;
      if (numerator !== null && denominator !== null) {
        switch (typeCode) {
          case 'PERCENT':
            return numerator / denominator + '% ';
          case 'FLOAT':
            return __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatNumber(numerator / denominator) + ' ';
          case 'PART':
            return numerator + '/' + denominator + ' ';
        }
      }
      return '';
    };
  },
  renderHolderPercent: function renderHolderPercent(state, getters) {
    return function (item) {
      var share = __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].getValue(item, ['shares', 0]);
      return ''.concat('<span>', getters.getRefIsValid(item.ref) ? '<a href=' + getters.getRefToUrl(item.ref) + '>' : '', '<b>', getters.renderShare(share), item.caption, '</b>', getters.getRefIsValid(item.ref) ? '</a>' : '', '</span>');
    };
  },
  renderInnHtml: function renderInnHtml(state, getters) {
    return function (inn) {
      return __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].isInn(inn) ? __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatInn(inn) : __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись об ИНН');
    };
  },
  renderInnflHtml: function renderInnflHtml(state, getters) {
    return function (inn) {
      return __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].isInnfl(inn) ? __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatInnfl(inn) : __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись об ИНН');
    };
  },
  renderInnOrInnflHtml: function renderInnOrInnflHtml(state, getters) {
    return function (inn) {
      return __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].isInn(inn) || __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].isInnfl(inn) ? inn : __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatWarningHtml('Запись об ИНН не найдена');
    };
  },
  renderDateSince: function renderDateSince(state, getters) {
    return function (valueDTO) {
      if (!valueDTO || !valueDTO.created && !valueDTO.updated) {
        return '';
      }
      var result = '';
      result = result.concat(' (c', '\xa0', valueDTO.created ? __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatDate(valueDTO.created) : __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatDate(valueDTO.updated), valueDTO.created && valueDTO.updated && valueDTO.created !== valueDTO.updated ? ', изменено ' + __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatDate(valueDTO.updated) : '', valueDTO.created && valueDTO.updated && valueDTO.created !== valueDTO.updated && valueDTO.deleted ? ',' : '', valueDTO.deleted ? ' по ' + __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatDate(valueDTO.deleted) : '', ')');
      return result;
    };
  },
  renderStatus: function renderStatus(state, getters) {
    return function (status) {
      var text = status ? status.text : __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись об статусе компании');
      if (status) {
        if (status.kind === 'GOOD') {
          text = __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatSuccessHtml(status.text);
        }
        if (status.kind === 'WARN') {
          text = __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatWarningHtml(status.text + ' (' + __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatDate(status.updated) + ')');
        }
        if (status.kind === 'BAD') {
          text = __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatErrorHtml(status.text + ' (' + __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatDate(status.updated) + ')');
        }
        if (status.kind === 'OLD') {
          text = __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatErrorHtml(status.text + ' (' + __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatDate(status.updated) + ')');
        }
      }
      return ''.concat('<b>', text, '</b>');
    };
  },
  renderFlags: function renderFlags(state, getters) {
    return function (companyFlags, small) {
      if (!(companyFlags && Array.isArray(companyFlags) && companyFlags.length > 0)) {
        return null;
      }
      var flagList = [{ code: '0401', icon: 'monetization_on', class: 'warning--text', text: 'Начата процедура банкротства' }, { code: '0402', icon: 'monetization_on', class: 'error--text', text: 'Банкротство неизбежно' }, { code: '0301', icon: 'outlined_flag', class: 'error--text', text: 'Недостоверные данные' }, { code: '0201', icon: 'error_outline', class: 'error--text', text: 'Действующее ЮЛ со статусами, связанными с последующей ликвидацией (прекращением деятельности)' }, { code: '0202', icon: 'error_outline', class: 'warning--text', text: 'Действующее ЮЛ со статусами изменения ключевого показателя, не связанного с обязательной ликвидацией' }, { code: '0203', icon: 'not_interested', class: 'error--text', text: 'Недействующее ЮЛ (потеря дееспособности и правоспособности)' }];
      var template = '\n      <v-tooltip lazy bottom open-delay="500" max-width="20em">\n        <span slot="activator">\n          <template v-for="flag in flags">\n            <v-icon :small="small" :class="flag.class">{{flag.icon}}</v-icon>\n          </template>\n        </span>\n          <template v-for="flag in flags">\n            <div>\n              <v-icon small :class="flag.class">{{flag.icon}}</v-icon>\n              {{flag.text}}\n            </div>\n          </template>\n      </v-tooltip>\n    ';
      var flagSet = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(companyFlags.map(function (f) {
        return f.code;
      }));
      var flags = flagList.filter(function (f) {
        return flagSet.has(f.code);
      });
      return {
        template: template,
        data: function data() {
          return {
            flags: flags,
            small: small
          };
        }
      };
    };
  },
  renderFirstActivityHtml: function renderFirstActivityHtml(state, getters) {
    return function (activities) {
      return activities && activities.length > 0 && activities[0].name ? activities[0].name : __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись о видах деятельности компании');
    };
  },
  renderUnreliable: function renderUnreliable(state, getters) {
    return function (unreliableDTO) {
      if (!unreliableDTO || !unreliableDTO.unreliables || unreliableDTO.unreliables.length === 0) {
        return '';
      }
      var result = '';
      unreliableDTO.unreliables.forEach(function (u) {
        result = result.concat(u.unreliableText ? u.unreliableText[0].toUpperCase() + u.unreliableText.slice(1) : 'Cведения недостоверны', u.unreliableDate ? ' (' + __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatDate(u.unreliableDate) + ')' : '');
      });
      return result;
    };
  },
  renderUnreliableHtml: function renderUnreliableHtml(state, getters) {
    return function (unreliableDTO) {
      return __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatWarningHtml(getters.renderUnreliable(unreliableDTO));
    };
  },
  renderCopyButton: function renderCopyButton(state, getters) {
    return function (hint, action, param) {
      var template = ''.concat('<span><v-tooltip bottom open-delay="500">\n        <span slot="activator">\n          <v-btn style="margin:0" small icon @click="copyToClipboard">\n            <v-icon small>{{icon}}</v-icon>\n          </v-btn>\n        </span>\n        <span>{{hint}}</span>\n      </v-tooltip></span>');
      return {
        template: template,
        data: function data() {
          return {
            icon: 'content_copy',
            hint: hint,
            action: action
          };
        },
        methods: {
          copyToClipboard: function copyToClipboard() {
            var text = action(param);
            this.$store.dispatch('copyToClipboard', { text: text });
          }
        }
      };
    };
  },
  renderContactButton: function renderContactButton(state, getters) {
    return function (hint, action, param) {
      var template = ''.concat('<span><v-tooltip bottom open-delay="500">\n        <span slot="activator">\n          <v-btn style="margin:0" small icon @click="onClick">\n            <v-icon small>{{icon}}</v-icon>\n          </v-btn>\n        </span>\n        <span>{{hint}}</span>\n      </v-tooltip></span>');
      return {
        template: template,
        data: function data() {
          return {
            icon: 'person_outline',
            hint: hint,
            action: action
          };
        },
        methods: {
          onClick: function onClick() {
            action(param);
          }
        }
      };
    };
  },
  renderValueLink: function renderValueLink(state, getters) {
    return function (value, label, link, hint, html, post) {
      var caption = html || '<b>' + value + '</b>';
      var template = ''.concat('<span ><v-tooltip :disabled="!hint" bottom open-delay="500">\n        <span slot="activator">\n          {{label ? label + \'&nbsp\' : \'\'}}\n          <span style="white-space: normal;">\n            <a v-if="link" href="link" v-html="caption"></a>\n            <span v-if="!link" v-html="caption"></span>\n            <span v-if="post">&nbsp{{post}}&nbsp</span>\n          <v-btn style="margin:0" small icon @click="copyToClipboard()">\n            <v-icon small height="16px" width="16px" >{{icon}}</v-icon>\n          </v-btn>\n          </span>\n        </span>\n        <span v-show="hint">{{hint}}</span>\n      </v-tooltip></span>');
      return {
        template: template,
        data: function data() {
          return {
            icon: 'content_copy',
            hint: hint,
            label: label,
            link: link,
            caption: caption,
            post: post
          };
        },
        methods: {
          copyToClipboard: function copyToClipboard() {
            this.$store.dispatch('copyToClipboard', { text: value });
          }
        }
      };
    };
  }

  // actions
};var actions = {};

// mutations
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_server__ = __webpack_require__(8);


var state = {
  settings: {}

  // getters
};var getters = {
  getOpenSettings: function getOpenSettings(state) {
    return state.settings;
  }

  // actions
};var actions = {
  fetchOpenSettings: function fetchOpenSettings(_ref) {
    var commit = _ref.commit,
        state = _ref.state;

    __WEBPACK_IMPORTED_MODULE_0__api_server__["a" /* default */].openApiGet('/openapi/settings', function (data) {
      commit('setOpenSettings', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении текущей конфигурации клиента ' });
    });
  }
};

// mutations
var mutations = {
  setOpenSettings: function setOpenSettings(state, data) {
    state.settings = data;
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_utils__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);





var state = {};

// getters
var getters = {
  getEmailHeaderReport: function getEmailHeaderReport(state) {
    return function (company) {
      var getHeadName = function getHeadName(head) {
        return (head ? head.firstName + ' ' + head.middleName : '').toUpperCase();
      };
      var head = company.heads && company.heads.length > 0 ? company.heads[0] : null;
      return company.name.value + '\n\u041E\u0413\u0420\u041D ' + company.ogrn + ', \u0418\u041D\u041D ' + company.inn + '\n\n' + (head ? head.nameShort : '') + '\n' + (company.address && company.address.value ? company.address.value : '') + '\n\n\u0418\u0441\u0445. \u2116 _____ \u043E\u0442 "__" _____________ 20__ \u0433.\n\u041D\u0430 \u0432\u043D. \u2116 _____ \u043E\u0442 "__" _____________ 20__ \u0433.\n\n\u0423\u0412\u0410\u0416\u0410\u0415\u041C\u042B\u0419(\u0410\u042F) ' + getHeadName(head) + '! ';
    };
  },
  getAgreementHeader1Report: function getAgreementHeader1Report(state) {
    return function (company, clientCompany) {
      var footer = 'ВАЖНО! Если Вы осуществите копирование сведений о компании в режиме зарегистрированного участника Системы "АТЛАНТ-СМАРТ", то пустые поля Стороны-2 будут заполнены данными Вашей компании.\n\nРегистрируйтесь в Системе "АТЛАНТ-СМАРТ". Сделайте Вашу работу проще и удобнее.';
      var cstr1 = company ? company.name.value + ' (' + company.nameShort + ')' : '________________ ________________';
      var hstr1 = company && company.heads && company.heads.length > 0 ? company.heads[0].position + ' ' + company.heads[0].nameShort : '________________ ________________';
      var cstr2 = clientCompany ? clientCompany.name.value + ' (' + clientCompany.nameShort + ')' : '________________ ________________';
      var hstr2 = clientCompany && clientCompany.heads && clientCompany.heads.length > 0 ? clientCompany.heads[0].position + ' ' + clientCompany.heads[0].nameShort : '________________ ________________';
      return cstr1 + ', \u0438\u043C\u0435\u043D\u0443\u0435\u043C\u043E\u0435 \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C "\u0421\u0442\u043E\u0440\u043E\u043D\u0430-1", \u0432 \u043B\u0438\u0446\u0435 ' + hstr1 + ', \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0423\u0441\u0442\u0430\u0432\u0430, \u0441 \u043E\u0434\u043D\u043E\u0439 \u0441\u0442\u043E\u0440\u043E\u043D\u044B, \u0438 ' + cstr2 + ', \u0438\u043C\u0435\u043D\u0443\u0435\u043C\u043E\u0435 \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C "\u0421\u0442\u043E\u0440\u043E\u043D\u0430-2", \u0432 \u043B\u0438\u0446\u0435 ' + hstr2 + ', \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0423\u0441\u0442\u0430\u0432\u0430, \u0441 \u0434\u0440\u0443\u0433\u043E\u0439 \u0441\u0442\u043E\u0440\u043E\u043D\u044B, \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043E \u043D\u0438\u0436\u0435\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C. ' + (clientCompany ? '' : '\n\n' + footer);
    };
  },
  getAgreementHeader2Report: function getAgreementHeader2Report(state) {
    return function (company, clientCompany) {
      var footer = 'ВАЖНО! Если Вы осуществите копирование сведений о компании в режиме зарегистрированного участника Системы "АТЛАНТ-СМАРТ", то пустые поля Стороны-2 будут заполнены данными Вашей компании.\n\nРегистрируйтесь в Системе "АТЛАНТ-СМАРТ". Сделайте Вашу работу проще и удобнее.';
      var cstr1 = company ? '' + company.nameShort : '________________';
      var hstr1 = company && company.heads && company.heads.length > 0 ? company.heads[0].position + ' ' + company.heads[0].nameShort : '________________ ________________';
      var cstr2 = clientCompany ? '' + clientCompany.nameShort : '________________';
      var hstr2 = clientCompany && clientCompany.heads && clientCompany.heads.length > 0 ? clientCompany.heads[0].position + ' ' + clientCompany.heads[0].nameShort : '________________ ________________';
      return hstr1 + ', \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0423\u0441\u0442\u0430\u0432\u0430 \u0438 \u043E\u0442 \u0438\u043C\u0435\u043D\u0438 ' + cstr1 + ', \u0438\u043C\u0435\u043D\u0443\u0435\u043C\u043E\u0435 \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C "\u0421\u0442\u043E\u0440\u043E\u043D\u0430-1", \u0441 \u043E\u0434\u043D\u043E\u0439 \u0441\u0442\u043E\u0440\u043E\u043D\u044B, \u0438 ' + hstr2 + ', \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0423\u0441\u0442\u0430\u0432\u0430 \u0438 \u043E\u0442 \u0438\u043C\u0435\u043D\u0438 ' + cstr2 + ', \u0438\u043C\u0435\u043D\u0443\u0435\u043C\u043E\u0435 \u0432 \u0434\u0430\u043B\u044C\u043D\u0435\u0439\u0448\u0435\u043C "\u0421\u0442\u043E\u0440\u043E\u043D\u0430-2", \u0441 \u0434\u0440\u0443\u0433\u043E\u0439 \u0441\u0442\u043E\u0440\u043E\u043D\u044B, \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u043B\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u043E \u043D\u0438\u0436\u0435\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C. ' + (clientCompany ? '' : '\n\n' + footer);
    };
  },
  getAgreementFooterReport: function getAgreementFooterReport(state) {
    return function (company, clientCompany, companyInfo, clientInfo) {
      var footer = 'ВАЖНО! Если Вы осуществите копирование сведений о компании в режиме зарегистрированного участника Системы "АТЛАНТ-СМАРТ", то пустые поля Стороны-2 будут заполнены данными Вашей компании.\n\nРегистрируйтесь в Системе "АТЛАНТ-СМАРТ". Сделайте Вашу работу проще и удобнее.';
      var _f = function _f(value, emptySize) {
        return value !== null ? value : '_'.repeat(emptySize);
      };

      var createModel = function createModel() {
        return {
          company: {
            head: {
              position: null,
              nameShort: null
            },
            nameShort: null,
            ogrn: null,
            inn: null,
            kpp: null,
            address: {
              value: null
            }
          },
          info: {
            phone: null,
            email: null,
            bankDetails: {
              account: null,
              bankName: null,
              corrAccount: null,
              bankBic: null
            }
          }
        };
      };
      var getModel = function getModel(company, info) {
        var model = createModel();
        if (company) {
          if (company.heads && company.heads.length > 0) {
            model.company.head.position = company.heads[0].position;
            model.company.head.nameShort = company.heads[0].nameShort;
          }
          model.company.nameShort = company.nameShort;
          model.company.ogrn = company.ogrn;
          model.company.inn = company.inn;
          model.company.kpp = company.kpp;
          model.company.address.value = company.address.value;
        }
        if (info) {
          model.info.phone = info.phone;
          model.info.email = info.email;
          model.info.bankDetails.account = info.bankDetails.account;
          model.info.bankDetails.bankName = info.bankDetails.bankName;
          model.info.bankDetails.corrAccount = info.bankDetails.corrAccount;
          model.info.bankDetails.bankBic = info.bankDetails.bankBic;
        }
        return model;
      };
      var model1 = getModel(company, companyInfo && companyInfo.isRefreshed ? companyInfo : null);
      var model2 = getModel(clientCompany, clientInfo && clientInfo.isRefreshed ? clientInfo : null);

      var side = function side(model) {
        return _f(model.company.nameShort, 20) + '\n\u041E\u0413\u0420\u041D ' + _f(model.company.ogrn, 16) + ', \u0418\u041D\u041D ' + _f(model.company.inn, 10) + ', \u041A\u041F\u041F ' + _f(model.company.kpp, 10) + '\n\u0410\u0434\u0440\u0435\u0441: ' + _f(model.company.address.value, 40) + '\n\n\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0435 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B:\n\u0440/\u0441 ' + _f(model.info.bankDetails.account, 20) + '\n\u0432 ' + _f(model.info.bankDetails.bankName, 22) + '\n\u043A/\u0441 ' + _f(model.info.bankDetails.corrAccount, 20) + '\n\u0411\u0418\u041A ' + _f(model.info.bankDetails.bankBic, 9) + '\n\n\u0422\u0435\u043B.: ' + (model.info.phone ? model.info.phone : '+7 (___) ____-___-___') + '\n\u042D\u043B.\u043F\u043E\u0447\u0442\u0430: ' + (model.info.email ? model.info.email : '________@___________.__');
      };

      var sign = function sign(model) {
        return _f(model.company.nameShort, 20) + '\n' + _f(model.company.head.position, 20) + '\n\n' + _f(null, 20) + ' /' + _f(model.company.head.nameShort, 20);
      };
      return '\u0420\u0415\u041A\u0412\u0418\u0417\u0418\u0422\u042B \u0421\u0422\u041E\u0420\u041E\u041D\n\n\u0421\u0442\u043E\u0440\u043E\u043D\u0430-1:\n' + side(model1) + '\n\n\u0421\u0442\u043E\u0440\u043E\u043D\u0430-2:\n' + side(model2) + '\n\n\n\u041F\u041E\u0414\u041F\u0418\u0421\u0418 \u0421\u0422\u041E\u0420\u041E\u041D\n\n\u0421\u0442\u043E\u0440\u043E\u043D\u0430-1:\n' + sign(model1) + '\n\n\u0421\u0442\u043E\u0440\u043E\u043D\u0430-2:\n' + sign(model2) + (clientInfo && clientInfo.isRefreshed ? '' : '\n\n' + footer);
    };
  },
  getClientEnvelopeReport: function getClientEnvelopeReport(state) {
    return function (company, clientCompany) {
      var footer = 'ВАЖНО! Если Вы осуществите копирование сведений о компании в режиме зарегистрированного участника Системы "АТЛАНТ-СМАРТ", то пустые поля отправителя письма (от кого, откуда) будут заполнены данными Вашей компании.\n\nРегистрируйтесь в Системе "АТЛАНТ-СМАРТ". Сделайте Вашу работу проще и удобнее.';
      var _f = function _f(value, emptySize) {
        return value !== null ? value : '_'.repeat(emptySize);
      };
      var splitAddress = function splitAddress(address) {
        if (!address || !address.value) {
          return null;
        }
        var alist = address.value.split(',');
        if (alist.length <= 1) {
          return null;
        }
        var index = alist[1].trim();
        alist.splice(1, 1);
        return { index: index, address: alist.join(',') };
      };
      var createModel = function createModel() {
        return {
          company: {
            head: {
              position: null,
              nameShort: null
            },
            nameShort: null,
            address: {
              value: null,
              index: null
            }
          }
        };
      };
      var getModel = function getModel(company) {
        var model = createModel();
        if (company) {
          if (company.heads && company.heads.length > 0) {
            model.company.head.position = company.heads[0].position;
            model.company.head.nameShort = company.heads[0].nameShort;
          }
          model.company.nameShort = company.nameShort;
          var a = splitAddress(company.address);
          model.company.address.value = a.address;
          model.company.address.index = a.index;
        }
        return model;
      };

      var side1 = function side1(m) {
        return '\u041E\u0442 \u043A\u043E\u0433\u043E: ' + _f(m.company.nameShort, 21) + '\n' + _f(m.company.head.position, 15) + ' ' + _f(m.company.head.nameShort, 15) + '\n\n\u041E\u0442\u043A\u0443\u0434\u0430: ' + _f(m.company.address.value, 21) + '\n' + _f(m.company.address.index, 6);
      };
      var side2 = function side2(m) {
        return '\u041A\u043E\u043C\u0443: ' + _f(m.company.nameShort, 21) + '\n' + _f(m.company.head.position, 15) + ' ' + _f(m.company.head.nameShort, 15) + '\n\n\u041A\u0443\u0434\u0430: ' + _f(m.company.address.value, 21) + '\n' + _f(m.company.address.index, 6);
      };
      return side1(getModel(clientCompany)) + '\n\n' + side2(getModel(company)) + (clientCompany ? '' : '\n\n' + footer);
    };
  }

  // actions
};var actions = {
  copyToClipboard: function copyToClipboard(_ref, request) {
    var commit = _ref.commit,
        state = _ref.state;

    var res = false;
    if (!request) {
      return;
    }
    // res = utils.copyTextToClipboard(text)
    if (request.text && !request.html) {
      res = __WEBPACK_IMPORTED_MODULE_2__api_utils__["a" /* default */].copyTextToClipboard(request.text);
    } else {
      res = __WEBPACK_IMPORTED_MODULE_2__api_utils__["a" /* default */].copyContentToClipboard(request.html, request.text);
    }
    if (res) {
      commit('setStatus', { show: true, type: 'success', message: 'Данные скопированы в буфер обмена.' });
    } else {
      commit('setStatus', { show: true, type: 'info', message: 'К сожалению, Ваш браузер не позволяет автоматически копировать текст. Данные подготовлены, нажмите "Ctrl-C"' });
    }
  },
  mailTo: function mailTo(_ref2, _ref3) {
    var commit = _ref2.commit,
        state = _ref2.state;
    var email = _ref3.email,
        subject = _ref3.subject,
        emailBody = _ref3.emailBody;

    email = encodeURIComponent(email);
    subject = encodeURIComponent(subject);
    var eBody = encodeURIComponent(emailBody);
    var link = 'mailto:' + email + '?subject=' + subject + '&body=' + eBody;
    var size = link.length;
    if (size < 2048) {
      document.location = link;
      return;
    }
    var res = __WEBPACK_IMPORTED_MODULE_2__api_utils__["a" /* default */].copyTextToClipboard(emailBody);
    if (res) {
      eBody = '<ВСТАВЬТЕ ДАННЫЕ ИЗ БУФЕРА ОБМЕНА>';
      eBody = encodeURIComponent(eBody);
      link = 'mailto:' + email + '?subject=' + subject + '&body=' + eBody;
      document.location = link;
      commit('setStatus', { show: true, type: 'info', message: '\u041A \u0441\u043E\u0436\u0430\u043B\u0435\u043D\u0438\u044E, \u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0435 \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0430\u0432\u0442\u043E\u043C\u0430\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0441\u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u043E \u0440\u0430\u0437\u043C\u0435\u0440\u043E\u043C ' + size + ' \u0431\u0430\u0439\u0442. \u0412\u044B \u043C\u043E\u0436\u0435\u0442\u0435 \u044D\u0442\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0432\u0440\u0443\u0447\u043D\u0443\u044E. \u0414\u0430\u043D\u043D\u044B\u0435 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0435\u043D\u0430.' });
    } else {
      commit('setStatus', { show: true, type: 'info', message: 'К сожалению, Ваш браузер не позволяет автоматически сформировать письмо, Вы можете это сделать вручную. Данные подготовлены, нажмите "Ctrl-C" для копирования в буфер обмена' });
    }
  },
  shareTo: function shareTo(_ref4, _ref5) {
    var commit = _ref4.commit,
        state = _ref4.state;
    var email = _ref5.email,
        subject = _ref5.subject,
        emailBody = _ref5.emailBody;

    if (!email && navigator.share !== undefined) {
      navigator.share({
        title: subject,
        text: emailBody
      }).then(function () {}).catch(function (e) {
        return commit('setErrorStatus', { error: e, context: 'Ошибка в функции поделиться браузера ' });
      });
    } else {
      this.dispatch('mailTo', { email: email || '', subject: subject, emailBody: emailBody });
    }
  },
  openLocation: function openLocation(_ref6, location) {
    var commit = _ref6.commit,
        state = _ref6.state;

    var popUp = window.open(location, '_blank');
    if (!popUp) {
      commit('setStatus', { show: true, type: 'info', message: 'К сожалению, Ваш браузер не позволяет открывать всплывающие окна' });
    }
  },
  sendTo: function sendTo(_ref7, request) {
    var _this = this;

    var commit = _ref7.commit,
        state = _ref7.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, request);
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPost('/api/me/companies/command-mail-sends', item, function (data) {
        commit('setStatus', { show: true, type: 'success', message: 'Письмо подготовлено и поставлено в очередь.' });
        _this.dispatch('fetchDashboardCounters');
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при посылке письма' });
        reject(e);
      });
    });
  }
};

// mutations
var mutations = {};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 772 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_assist_ClaimSteps__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_assist_DeedSteps__ = __webpack_require__(795);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_assist_PostSteps__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_assist_ContractorCheckSteps__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_assist_BinderSteps__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_assist_PackageSteps__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uuid__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__StoreClasses__ = __webpack_require__(153);







// import Vue from 'vue'










var state = {
  assistMatterSet: new __WEBPACK_IMPORTED_MODULE_15__StoreClasses__["a" /* default */].ItemSet(function (item) {
    return item.id;
  }),
  //  assistMatters: [],
  deeds: [],
  folders: [],
  types: function types() {
    return new __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_map___default.a([['CLAIM', 'Претензия'], ['DEED', 'Документ'], ['BINDER', 'Подшивка'], ['PACKAGE', 'Пакет'], ['POST', 'Рассылка'], ['CONTRACTOR_CHECK', 'Проверка контрагента']]);
  }
};

function getStrategy(typeCode, cxt) {
  switch (typeCode) {
    case 'CLAIM':
      return __WEBPACK_IMPORTED_MODULE_8__components_assist_ClaimSteps__["a" /* default */].createStrategy(cxt);
    case 'DEED':
      return __WEBPACK_IMPORTED_MODULE_9__components_assist_DeedSteps__["a" /* default */].createStrategy(cxt);
    case 'BINDER':
      return __WEBPACK_IMPORTED_MODULE_12__components_assist_BinderSteps__["a" /* default */].createStrategy(cxt);
    case 'PACKAGE':
      return __WEBPACK_IMPORTED_MODULE_13__components_assist_PackageSteps__["a" /* default */].createStrategy(cxt);
    case 'POST':
      return __WEBPACK_IMPORTED_MODULE_10__components_assist_PostSteps__["a" /* default */].createStrategy(cxt);
    case 'CONTRACTOR_CHECK':
      return __WEBPACK_IMPORTED_MODULE_11__components_assist_ContractorCheckSteps__["a" /* default */].createStrategy(cxt);
  }
  return __WEBPACK_IMPORTED_MODULE_8__components_assist_ClaimSteps__["a" /* default */].createStrategy(cxt);
}

function createModel(typeCode) {
  switch (typeCode) {
    case 'CLAIM':
      return new __WEBPACK_IMPORTED_MODULE_8__components_assist_ClaimSteps__["a" /* default */].Model();
    case 'DEED':
      return new __WEBPACK_IMPORTED_MODULE_9__components_assist_DeedSteps__["a" /* default */].Model();
    case 'BINDER':
      return new __WEBPACK_IMPORTED_MODULE_12__components_assist_BinderSteps__["a" /* default */].Model();
    case 'PACKAGE':
      return new __WEBPACK_IMPORTED_MODULE_13__components_assist_PackageSteps__["a" /* default */].Model();
    case 'POST':
      return new __WEBPACK_IMPORTED_MODULE_10__components_assist_PostSteps__["a" /* default */].Model();
    case 'CONTRACTOR_CHECK':
      return new __WEBPACK_IMPORTED_MODULE_11__components_assist_ContractorCheckSteps__["a" /* default */].Model();
  }
  return new __WEBPACK_IMPORTED_MODULE_8__components_assist_ClaimSteps__["a" /* default */].Model();
}

var AssistMatter = function () {
  function AssistMatter(ops) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, AssistMatter);

    var options = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, ops);
    this.id = options.id || __WEBPACK_IMPORTED_MODULE_14_uuid___default()();
    this.typeCode = options.typeCode || 'CLAIM';
    this.type = this.typeCode.localeCompare('CLAIM') === 0 ? 'Претензия' : 'Новый тип';
    this.created = options.created || new Date();
    this.state = options.state || 'NEW';
    this.name = options.name || null;
    this.notes = options.notes || null;
    this.model = options.model || createModel(this.typeCode);
    this.accountNameShort = options.accountNameShort || null;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(AssistMatter, [{
    key: 'copy',
    value: function copy() {
      var model = this.model.copy();
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(new AssistMatter(), this, { model: model });
    }
  }]);

  return AssistMatter;
}();

// getters


var getters = {
  getAssistMatterTypes: function getAssistMatterTypes(state) {
    return state.types;
  },
  getAssistMatterSet: function getAssistMatterSet(state) {
    return state.assistMatterSet;
  },
  //  getAssistMatters: state => state.assistMatters,
  getNewAssistMatter: function getNewAssistMatter(state) {
    return function (ops) {
      return new AssistMatter(ops);
    };
  },
  getAssistMatterStrategy: function getAssistMatterStrategy(state) {
    return function (typeCode, cxt) {
      return getStrategy(typeCode, cxt);
    };
  },
  getAssistDeedFolders: function getAssistDeedFolders(state) {
    return state.folders;
  },
  getAssistDeedsByPath: function getAssistDeedsByPath(state) {
    return function (path) {
      var map = {};
      state.deeds.filter(function (d) {
        return !path || !d.path || d.path.startsWith(path);
      }).forEach(function (d) {
        map[d.value] = { value: d.value, text: d.text, description: d.description };
      });
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_values___default()(map);
    };
  }

  // actions
};var actions = {
  getAssistScheme: function getAssistScheme(_ref, itemId) {
    var commit = _ref.commit,
        state = _ref.state,
        getters = _ref.getters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiGet('/api/me/assist/matters/' + itemId + '/scheme', function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о полях запроса ассистенту ' });
        reject(e);
      });
    });
  },
  getAssistMatter: function getAssistMatter(_ref2, itemId) {
    var commit = _ref2.commit,
        state = _ref2.state,
        getters = _ref2.getters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiGet('/api/me/assist/matters/' + itemId, function (data) {
        data.model = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(createModel(data.typeCode), JSON.parse(data.model));
        resolve(new AssistMatter(data));
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о запросе ассистенту ' });
        reject(e);
      });
    });
  },
  getAssistMatterActions: function getAssistMatterActions(_ref3, itemId) {
    var commit = _ref3.commit,
        state = _ref3.state,
        getters = _ref3.getters;

    if (!itemId) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve([]);
    }
    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiGet('/api/me/assist/matters/' + itemId + '/actions', function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка действий для дела' });
        reject(e);
      });
    });
  },
  fetchAssistMatters: function fetchAssistMatters(_ref4, force) {
    var commit = _ref4.commit,
        state = _ref4.state,
        getters = _ref4.getters;

    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    if (!force && !state.assistMatterSet.isChanged()) {
      return;
    }
    var page = force ? 0 : state.assistMatterSet.page;
    var sort = state.assistMatterSet.sort;
    console.log('fetchAssistMatters', sort);
    var fxt = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, getters.getAssistMatterSet.getFilter());
    commit('startAssistMatters');
    __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiGetParams('/api/me/assist/matters', {
      size: 100,
      page: page,
      sort: sort,
      request: {
        search: fxt.search,
        tagIds: fxt.tagIds
      }
    }, function (data) {
      commit('setAssistMatters', { data: data, cxt: fxt });
      commit('setSuccessStatus');
    }, function (e) {
      commit('stopAssistMatters');
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка запросов к ассистенту ' });
    });
  },
  deleteAssistMatters: function deleteAssistMatters(_ref5, requests) {
    var _this = this;

    var commit = _ref5.commit,
        state = _ref5.state,
        rootState = _ref5.rootState;

    __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiPost('/api/me/assist/command-matters-deletes', { ids: requests.ids }, function (data) {
      _this.dispatch('fetchAssistMatters', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении запросов ассистенту ' });
    });
  },
  copyAssistMatters: function copyAssistMatters(_ref6, requests) {
    var _this2 = this;

    var commit = _ref6.commit,
        state = _ref6.state,
        rootState = _ref6.rootState;

    __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiPost('/api/me/assist/command-matters-copies', { ids: requests.ids }, function (data) {
      _this2.dispatch('fetchAssistMatters', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при копировании дел ' });
    });
  },
  createAssistPackage: function createAssistPackage(_ref7, request) {
    var commit = _ref7.commit,
        state = _ref7.state,
        rootState = _ref7.rootState;

    console.log('createAssistPackage', request);
    __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiPost('/api/me/assist/packages', request, function (data) {
      console.log('createAssistPackage', data);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при копировании дел ' });
    });
  },
  updateAssistMatter: function updateAssistMatter(_ref8, request) {
    var _this3 = this;

    var commit = _ref8.commit,
        state = _ref8.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, request);
      // console.log('updateAssistMatter', item)
      item.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.model);
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiPost('/api/me/assist/matters', item, function (data) {
        _this3.dispatch('fetchAssistMatters');
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении запроса для ассистента ' });
        reject(e);
      });
    });
  },
  updateAssistMatterName: function updateAssistMatterName(_ref9, request) {
    var _this4 = this;

    var commit = _ref9.commit,
        state = _ref9.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, request);
      // console.log('updateAssistMatter', item)
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiPost('/api/me/assist/matters/' + item.id + '/command-name-updates', item, function (data) {
        _this4.dispatch('fetchAssistMatters', true);
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении названия запроса для ассистента ' });
        reject(e);
      });
    });
  },
  depoAssistMatter: function depoAssistMatter(_ref10, request) {
    var _this5 = this;

    var commit = _ref10.commit,
        state = _ref10.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, request);
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiPost('/api/me/assist/matters/' + item.id + '/command-depos', item, function (data) {
        resolve(data);
        _this5.dispatch('fetchDashboardCounters');
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при депонировании результатов дела ' });
        reject(e);
      });
    });
  },
  macroAssistMatter: function macroAssistMatter(_ref11, request) {
    var commit = _ref11.commit,
        state = _ref11.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, request);
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiPost('/api/me/assist/matters/' + item.id + '/command-transforms', item, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при выполнении макроса ' });
        reject(e);
      });
    });
  },
  sendAssistMatter: function sendAssistMatter(_ref12, request) {
    var _this6 = this;

    var commit = _ref12.commit,
        state = _ref12.state;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, request);
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiPost('/api/me/assist/matters/' + item.id + '/command-sends', item, function (data) {
        commit('setStatus', { show: true, type: 'success', message: 'Письма подготовлены и поставлены в очередь.' });
        _this6.dispatch('fetchDashboardCounters');
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка во время подготовки писем' });
        reject(e);
      });
    });
  },
  fetchDeeds: function fetchDeeds(_ref13) {
    var commit = _ref13.commit,
        state = _ref13.state,
        getters = _ref13.getters;

    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiGet('/api/me/assist/deeds', function (data) {
      commit('setAssistDeeds', data);
      commit('setSuccessStatus');
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка типов документов ' });
    });
  },
  getAssistDeed: function getAssistDeed(_ref14, itemId) {
    var commit = _ref14.commit,
        state = _ref14.state,
        getters = _ref14.getters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiGet('/api/me/assist/deeds/' + itemId, function (data) {
        resolve({ id: itemId, name: data && data.name || null });
      }, function (e) {
        resolve({ id: itemId, name: null });
      });
    });
  }
};

// mutations
var mutations = {
  // setAssistMatters (state, data) {
  //   state.assistMatters = data.map(m => {
  //     m.model = Object.assign(createModel(m.typeCode), JSON.parse(m.model))
  //     return new AssistMatter(m)
  //   })
  // },
  setAssistMatterFilterContext: function setAssistMatterFilterContext(state, cxt) {
    state.assistMatterSet.setFilter(cxt);
  },
  setAssistMatterSort: function setAssistMatterSort(state, sort) {
    state.assistMatterSet.setSort(sort);
  },
  startAssistMatters: function startAssistMatters(state) {
    state.assistMatterSet.clearChanged();
    state.assistMatterSet.start();
  },
  stopAssistMatters: function stopAssistMatters(state) {
    state.assistMatterSet.stop();
  },
  nextAssistMatters: function nextAssistMatters(state) {
    state.assistMatterSet.nextPage();
  },
  setAssistMatters: function setAssistMatters(state, _ref15) {
    var data = _ref15.data,
        cxt = _ref15.cxt;

    state.assistMatterSet.setItems(data, cxt);
    state.assistMatterSet.stop();
  },
  setAssistDeeds: function setAssistDeeds(state, data) {
    state.deeds = data.filter(function (d) {
      return d.id.startsWith('FOLDER') === false;
    }).map(function (d) {
      return { value: d.id, text: d.name, description: d.description, path: d.path };
    });
    state.folders = data.filter(function (d) {
      return d.id.startsWith('FOLDER');
    }).map(function (d) {
      return { value: d.path, text: d.name, description: d.description };
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepSetParameters_js__ = __webpack_require__(155);












// import client from '../client'


var DocumnentSelectType = function (_AssistClasses$Step) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DocumnentSelectType, _AssistClasses$Step);

  function DocumnentSelectType(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DocumnentSelectType);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumnentSelectType.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DocumnentSelectType)).call(this, 'Выберите тип документа', function (step) {
      return step.model.deedName;
    }, {
      scheme: [{
        fieldType: 'v-text-field',
        label: 'Тип',
        name: 'deedNumber',
        hint: function hint(model, field) {
          return model['deedName'] || 'Введите или выберите код типа документа';
        },
        errors: function errors(model, field) {
          return model['deedNumber'] !== null && model['deedName'] === null && 'Неверный код типа документа' || null;
        },
        events: {
          'input': function input(value) {
            cxt.setDeed('deedNumber', 'deedName', value);
          }
        },
        grow: true,
        size: { sm8: true, xs6: true }
      }, {
        fieldType: 'v-btn',
        slot: 'Выбрать',
        events: { 'click': function click() {
            return cxt.selectDeed('deedNumber', 'deedName');
          } },
        shrink: false,
        size: { sm4: true, xs6: true }
      }, {
        fieldType: 'v-select',
        label: 'Формат документа',
        itemValue: 'value',
        itemText: 'text',
        items: function items(model, field) {
          return cxt.getDeedFormats();
        },
        name: 'deedFormat',
        shrink: false,
        size: { sm8: true, xs12: true }
      }]
    }, {
      deedNumber: null,
      deedName: null,
      deedFormat: 'docx'
    }));

    _this.context = cxt;
    _this.nextEnabled = function () {
      return _this.model['deedName'] !== null;
    };
    _this.editable = true;
    return _this;
  }

  return DocumnentSelectType;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var DocumnentOperations = function (_AssistClasses$Step2) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DocumnentOperations, _AssistClasses$Step2);

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DocumnentOperations, null, [{
    key: 'getOperations',
    value: function getOperations() {
      return [{ value: 'DEPO', text: 'Депонировать документ' }, { value: 'DOWNLOAD', text: 'Скачать депонированный документ' }, { value: 'OPEN_DOC', text: 'Открыть карточку депонирования документа' }, { value: 'UPLOAD', text: 'Загрузить исправленную версию документа' }, { value: 'SEND', text: 'Поделиться документом' }, { value: 'SEND_BY_SERVER', text: 'Направить письмо по электронной почте' }, { value: 'NEW', text: 'Создать новый документ по образцу' }, { value: 'OPEN_XML', text: 'Отладка (xml)' }];
    }
  }]);

  function DocumnentOperations(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DocumnentOperations);

    var _this2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumnentOperations.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DocumnentOperations)).call(this, 'Операции над документом', function (step) {
      return _this2.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {
      '/email-send/options': 'DEPO_LINK'
    }));

    _this2.context = cxt;
    _this2.nextLabel = function () {
      return 'Выполнить';
    };
    _this2.editable = true;
    _this2.macros = [];
    console.log('DocumnentOperations.constructor', _this2);
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DocumnentOperations, [{
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      if (model['depoLink']) {
        return this.context.getDepoUrl(model.depoLink);
      }
      if (model['deedNoContent']) {
        return 'Шаблон не предполагает документов';
      }
      return '';
    }
  }, {
    key: 'fillFields',
    value: function fillFields(fields) {
      var _this3 = this;

      var lScheme = [{
        fieldType: 'v-select-radio',
        name: 'lastOperation',
        itemText: 'text',
        itemValue: 'value',
        items: function items(model) {
          return _this3.getOperations(model);
        },
        size: { sm10: true }
      }];
      this.props.scheme = lScheme;
      this.macros = [];
      fields.forEach(function (f) {
        var fullFieldName = !f.target ? '' + f.name : '/' + f.target + '/' + f.name;
        switch (f.type) {
          case 'macro':
            _this3.macros.push({ k: fullFieldName, t: 'text' });
            break;
          case 'html':
            _this3.macros.push({ k: fullFieldName, t: 'html' });
            break;
        }
      });
      return this;
    }
  }, {
    key: 'getOperations',
    value: function getOperations(model) {
      var ops = ['SEND_BY_SERVER', 'DEPO', 'NEW', 'OPEN_XML'];
      if (model['depoLink']) {
        ops.push('OPEN_DOC', 'DOWNLOAD', 'SEND', 'UPLOAD');
      }
      return DocumnentOperations.getOperations().filter(function (o) {
        return ops.includes(o.value);
      });
    }
  }, {
    key: 'next',
    value: function next(model, cb) {
      this.execute(model);
      return model;
      // return nextFn(model)
    }
  }, {
    key: 'execute',
    value: function execute(model) {
      var _this4 = this;

      var _f = function _f(val, def) {
        if (val == null) {
          return def;
        } else {
          return val;
        }
      };
      var operation = model.lastOperation;
      delete model.lastOperation;
      switch (operation) {
        case 'DEPO':
          __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].confirm(this.context, 'Подтвердите', 'Сгенерировать новые версии документов и загрузить в депозитарий?', function (self) {
            self.depoDoc('depoLink');
          });
          break;
        case 'OPEN_DOC':
          if (model.depoLink) {
            this.context.openDoc('depoLink');
          } else {
            __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий');
          }
          break;
        case 'DOWNLOAD':
          if (model.depoLink) {
            this.context.openDepo(model.depoLink);
          } else {
            __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий');
          }
          break;
        case 'OPEN_XML':
          this.context.preview('xml');
          break;
        case 'UPLOAD':
          var uid = model.depoLink;
          __WEBPACK_IMPORTED_MODULE_10__depo__["a" /* default */].newFile(null, null, uid);
          break;
        case 'SEND':
          if (model.depoLink) {
            __WEBPACK_IMPORTED_MODULE_10__depo__["a" /* default */].sendProps([model.depoLink], model['/email-send/to'], { body: model['/email-send/body'], subject: model['/email-send/subject'] });
          } else {
            __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий');
          }
          break;
        case 'SEND_BY_SERVER':
          model.currentStep = 3;
          this.context.updateData(model);
          if (this.context.getIsAllow({ SEND_MAIL: null })) {
            this.calcMacros(this.macros, model).then(function (obj) {
              var uids = model['deedNoContent'] || model.depoLink === null ? null : [model.depoLink];
              __WEBPACK_IMPORTED_MODULE_9__common_forms_js__["a" /* default */].openEmail({
                uids: uids,
                to: _f(obj['/email-send/to'], model['/email-send/to']),
                subject: _f(obj['/email-send/subject'], model['/email-send/subject']),
                body: _f(obj['/email-send/body'], model['/email-send/body']),
                options: model['/email-send/options'],
                mailbox: model['/email-send/mailbox']
              }).then(function (data) {
                var request = {
                  id: _this4.context.getMatterId(),
                  email: data.email,
                  subject: data.subject,
                  body: data.body,
                  mailbox: data.mailbox,
                  scheduled: data.scheduled,
                  options: data.attach ? null : 'NO_ATTACH'
                };
                _this4.context.$store.dispatch('sendAssistMatter', request);
              });
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Вы не можете посылать письма, сначала включите функцию рассылки для компании');
          }
          break;
        case 'NEW':
          delete model.depoLink;
          model.currentStep = 2;
          this.context.saveAsNew(model);
          break;
        case 'delete':
          this.context.delete();
      }
    }
  }, {
    key: 'calcMacros',
    value: function calcMacros(macros, model) {
      var _this5 = this;

      var calcMacro = function calcMacro(macro, type) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(macro).then(function () {
          if (/xslt:/ig.test(macro)) {
            return _this5.context.macro(macro);
          }
          return macro;
        }).then(function (html) {
          if (/text/ig.test(type)) {
            var toDiv = document.createElement('div');
            toDiv.innerHTML = html;
            return toDiv.innerText;
          }
          return html;
        });
      };
      return macros.reduce(function (p, e) {
        return p.then(function (obj) {
          return calcMacro(model[e.k], e.t).then(function (data) {
            obj[e.k] = data;
            return obj;
          });
        });
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({}));
    }
  }]);

  return DocumnentOperations;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var DeedStrategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DeedStrategy, _AssistClasses$Strate);

  function DeedStrategy() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DeedStrategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DeedStrategy.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DeedStrategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DeedStrategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'DEED';
    }
  }, {
    key: 'next',
    value: function next(model, step) {
      var _this7 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        currentStep = currentStep <= _this7.steps.length ? currentStep + 1 : _this7.steps.length + 1;
        model.setCurrentStep(currentStep);
        _this7.context.updateData(model);
        return model;
      };
      return step && step.next ? step.next(model, cb) : model;
    }
  }, {
    key: 'getCurrentStep',
    value: function getCurrentStep(model) {
      return this.steps.find(function (step) {
        return step.number === model.getCurrentStep();
      });
    }
  }, {
    key: 'back',
    value: function back(model, step) {
      var _this8 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        if (currentStep > 1) {
          currentStep = currentStep - 1;
          model.setCurrentStep(currentStep);
          _this8.context.updateData(model);
        } else {
          _this8.context.refreshData();
        }
        return model;
      };
      return step && step.back ? step.back(model, cb) : model;
    }
  }, {
    key: 'complete',
    value: function complete(model, step) {
      return step && model && model.getCurrentStep() > step.number;
    }
  }, {
    key: 'editable',
    value: function editable(model, step) {
      return step.editable || model && model.getCurrentStep() === step.number;
    }
  }, {
    key: 'previewable',
    value: function previewable(model) {
      return model && model.getCurrentStep() > 1;
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var steps = [];
      var cxt = this.context;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new DocumnentSelectType(cxt), { backLabel: function backLabel() {
          return 'Отмена';
        } }).addToArray(steps);

      if (scheme && scheme.steps && scheme.steps.length > 0) {
        new __WEBPACK_IMPORTED_MODULE_11__StepSetParameters_js__["a" /* default */].Step(cxt).fillFields(scheme.steps[0].fields).addToArray(steps);

        // new DocumnentCheck(cxt)
        // .addToArray(steps)

        new DocumnentOperations(cxt).fillFields(scheme.steps[0].fields).addToArray(steps);
      }

      this.steps = steps;
      return this;
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      if (this.context) {
        model['companyInn'] = this.context.profile.clientInn;
        model['companyRefCode'] = this.context.profile.clientRefCode;
      }
      this.steps.forEach(function (step) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(model, step.model);
      });
      return model;
    }
  }]);

  return DeedStrategy;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Strategy);

function createStrategy(cxt) {
  return new DeedStrategy(cxt);
}

var Model = function (_AssistClasses$Model) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Model, _AssistClasses$Model);

  function Model() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Model);

    var _this9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Model.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Model)).call(this));

    _this9.deedNumber = null;
    _this9.deedNoContent = false;
    return _this9;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Model, [{
    key: 'copy',
    value: function copy() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Model(), this);
    }
  }]);

  return Model;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Model);

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(797),
  /* template */
  __webpack_require__(802),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 797 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_BtnForm__);
//
//
//
//
//
//
//
//
//
//
//


var o = {
  name: 'confirm-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_0__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {}
    };
  },
  props: {
    title: {
      type: String,
      default: 'Подтвердите'
    },
    question: {
      type: String,
      default: 'Подтвердите операцию'
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    noCancel: {
      type: Boolean,
      default: false
    }
  },
  computed: {},
  methods: {
    ok: function ok() {
      this.$emit('ok');
      this.$emit('close');
    },
    cancel: function cancel() {
      this.$emit('cancel');
      this.$emit('close');
    }
  }
};
/* harmony default export */ __webpack_exports__["default"] = (o);

/***/ }),
/* 798 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_CardScroll__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'btn-form',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_2__common_CardScroll___default.a },
  data: function data() {
    return {
      delta: 48 + 52
    };
  },
  props: {
    title: {
      type: String,
      default: ''
    },
    mode: {
      default: null
    },
    deltas: {
      default: function _default() {
        return [0];
      }
    },
    listable: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.setFocus();
  },

  watch: {
    mode: function mode(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.setFocus();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    fullscreen: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  })),
  methods: {
    setFocus: function setFocus() {
      this.$nextTick(function () {
        if (!this.$el.contains(document.activeElement)) {
          this.$el.focus();
        }
      });
    },
    firstFocus: function firstFocus() {
      var input = this.$el.querySelector('input');
      console.log('firstFocus', input);
      if (input) {
        input.focus();
      } else {
        this.$el.focus();
      }
    }
  }
});

/***/ }),
/* 799 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-card-scroll',
  components: {},
  data: function data() {
    return {
      internalHeight: null
    };
  },
  props: {
    height: {
      type: String,
      default: null
    },
    offset: {
      // additional offset, in case automatic calculation
      type: String,
      default: '0'
    },
    up: {
      type: Boolean,
      default: false
    },
    md: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    var _this = this;

    var cb = function cb() {
      _this.onResize();
    };
    this.waitSlotMounted(cb);
  },

  computed: {
    style: function style() {
      // define min-height more than size for turning on scrolling
      return 'min-height: ' + this.internalHeight + '; margin-top: 1px';
    }
  },
  methods: {
    getElIdSelector: function getElIdSelector() {
      return '#scroll_target_' + this._uid;
    },
    waitSlotMounted: function waitSlotMounted(cb) {
      var _this2 = this;

      var i = 0;
      var wait = function wait() {
        setTimeout(function () {
          // console.log('waitChildren', i)
          // TODO - if slot is empty infinite wait
          if (_this2.$refs.slot && _this2.$refs.slot.clientHeight > 0 || i >= 100) {
            cb();
          } else {
            i++;
            wait();
          }
        }, 100);
      };
      wait();
    },
    onResize: function onResize() {
      if (this.height) {
        this.internalHeight = this.height;
        return;
      }
      var offsetTop = 0;
      var l = this.$el;
      while (l) {
        offsetTop = offsetTop + l.offsetTop;
        l = l.offsetParent;
      }
      console.log('onResize1', offsetTop, this.offset);
      this.internalHeight = window.innerHeight - offsetTop - parseInt(this.offset, 10) + 'px';
    },
    onScroll: function onScroll(e) {
      var limit = e.target.scrollHeight > 10 * e.target.clientHeight ? 10 * e.target.clientHeight : 2 * e.target.clientHeight;
      // console.log('onScroll', limit, e.target.scrollTop, e.target.scrollHeight)
      if (limit > 0) {
        if (!this.up && e.target.scrollTop > e.target.scrollHeight - limit || this.up && e.target.scrollTop < limit) {
          this.$emit('nextPage', e);
        }
      }
    },
    scrollTo: function scrollTo(classCss) {
      var el = document.querySelector(this.getElIdSelector() + ' ' + classCss);
      if (el) {
        el.scrollIntoView(true);
      }
    },
    scrollToListActive: function scrollToListActive() {
      this.scrollTo('.v-list__tile--active');
    }
  }
});

/***/ }),
/* 800 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll:[getElIdSelector()]",
      value: (_vm.onScroll),
      expression: "onScroll",
      arg: _vm.getElIdSelector()
    }, {
      name: "resize",
      rawName: "v-resize",
      value: (_vm.onResize),
      expression: "onResize"
    }],
    staticClass: "scroll-y",
    attrs: {
      "id": _vm.getElIdSelector().replace('#', ''),
      "height": _vm.internalHeight,
      "flat": _vm.flat
    }
  }, [(!_vm.md) ? _c('v-container', {
    ref: "slot",
    style: (_vm.style),
    attrs: {
      "px-2": "",
      "pt-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.md) ? _c('v-container', {
    ref: "slot",
    style: (_vm.style),
    attrs: {
      "px-1": "",
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_vm._t("default")], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 801 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fullscreen ? _vm.$vuetify.breakpoint.height + 'px' : 'auto',
      "tabindex": "-1"
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enter')
      }]
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "tabindex": "-1"
    },
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (!_vm.listable) ? _c('v-card', {
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "max-height": _vm.calcDialogScroll(_vm.deltas[0] + _vm.delta, (_vm.deltas[1] || _vm.deltas[0]) + _vm.delta)
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.listable) ? _c('v-card-scroll', {
    attrs: {
      "flat": "",
      "height": _vm.calcDialogScroll(_vm.deltas[0] + _vm.delta, (_vm.deltas[1] || _vm.deltas[0]) + _vm.delta)
    }
  }, [_vm._t("default")], 2) : _vm._e(), _vm._v(" "), (_vm.$slots.actions) ? _c('v-card-actions', [_vm._t("actions"), _vm._v(" "), _c('span', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.firstFocus()
      }
    }
  })], 2) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 802 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("Ок")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.noCancel),
            expression: "!noCancel"
          }],
          on: {
            "click": _vm.cancel
          }
        }, [_vm._v("Отмена")])]
      },
      proxy: true
    }])
  }, [_c('v-card-text', {
    domProps: {
      "innerHTML": _vm._s(_vm.question)
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(804),
  /* template */
  __webpack_require__(841),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 804 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assist_StepGenerator_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assist_StepGenerator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__assist_StepGenerator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_BtnForm__);








var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import people from './index.js'



var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return '';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return '';
    }
  }, {
    key: 'setContext',
    value: function setContext(cxt) {
      this.context = cxt;
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new __WEBPACK_IMPORTED_MODULE_9__assist_AssistClasses_js__["a" /* default */].Model();
      return model;
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(individual) {
      return this.createModel();
    }
  }, {
    key: 'createModelFromData',
    value: function createModelFromData(data) {
      return this.createModel();
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      return this;
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {}
  }, {
    key: 'fetchData',
    value: function fetchData(itemId) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve(null);
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(itemId, model) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve(itemId);
      });
    }
  }, {
    key: 'viewTitle',
    value: function viewTitle(model) {
      return '';
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_9__assist_AssistClasses_js__["a" /* default */].Strategy);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'strategy-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_10__common_BtnForm___default.a, vStepGenerator: __WEBPACK_IMPORTED_MODULE_8__assist_StepGenerator_vue___default.a },
  data: function data() {
    return {
      title: '',
      valid: true,
      model: null
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    parentId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    typeCode: {
      type: String,
      default: null
    },
    strategy: {
      type: Object,
      default: function _default() {
        return new Strategy(_this2);
      }
    }
  },
  created: function created() {
    // this.updateStrategy(null)
  },
  mounted: function mounted() {
    // this.updateStrategy(this.typeCode)
    this.strategy.setContext(this);
    this.fetchData(this.itemId);
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      // this.updateStrategy(this.typeCode)
      this.fetchData(this.itemId);
    },
    strategy: function strategy(newVal, oldVal) {
      // watch it
      // this.updateStrategy(this.typeCode)
      this.strategy = newVal;
      this.strategy.setContext(this);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  }), {
    isEdit: function isEdit() {
      return true;
    },
    isNew: function isNew() {
      return this.itemId === null;
    }
  }),
  methods: {
    // Model methods
    fetchData: function fetchData(itemId) {
      var _this3 = this;

      this.strategy.fetchData(itemId).then(function (data) {
        _this3.updateModel(_this3.strategy.createModelFromData(data));
        _this3.title = _this3.strategy.viewTitle(_this3.strategy.createModelFromData(data));
      });
    },
    updateData: function updateData(model, cb) {
      var _this4 = this;

      this.model = model;
      this.strategy.updateData(this.itemId, this.model, this.parentId).then(function (itemId) {
        _this4.fetchData(itemId);
        if (cb) {
          cb(itemId);
        }
      });
    },
    updateModel: function updateModel(model) {
      var _this5 = this;

      this.$nextTick(function () {
        // console.log('updateModel', model)
        _this5.model = model;
        _this5.strategy.updateModel(model);
        _this5.$forceUpdate();
      });
    },
    add: function add() {
      var _this6 = this;

      var cb = function cb(data) {
        _this6.$emit('change', data);
        _this6.cancel();
      };
      this.updateData(this.model, cb);
    },
    cancel: function cancel() {
      // this.item = Object.assign({}, this.getItemNew())
      this.$emit('close');
    },
    save: function save() {
      var _this7 = this;

      var cb = function cb(data) {
        _this7.$emit('change', data);
        _this7.cancel();
      };
      this.updateData(this.model, cb);
    },
    remove: function remove() {
      var _this8 = this;

      this.strategy.deleteData(this.itemId, this.model).then(function () {
        _this8.$emit('change', null);
        _this8.cancel();
      });
    },
    createNew: function createNew() {
      this.$emit('createNew');
    }
  }
});

/***/ }),
/* 805 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_SelectRadio_vue__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_SelectRadio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_SelectRadio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_SelectCheck_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_SelectCheck_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_SelectCheck_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ChipsField_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_ChipsField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_ChipsField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_FlexField_vue__ = __webpack_require__(818);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_FlexField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_FlexField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_HtmlField_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_HtmlField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_HtmlField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_MacroField_vue__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_MacroField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_MacroField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ItemsField_vue__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ItemsField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_ItemsField_vue__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'step-generator',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_0__common_DateField_vue___default.a, vSelectRadio: __WEBPACK_IMPORTED_MODULE_1__common_SelectRadio_vue___default.a, vSelectCheck: __WEBPACK_IMPORTED_MODULE_2__common_SelectCheck_vue___default.a, vFlexField: __WEBPACK_IMPORTED_MODULE_4__common_FlexField_vue___default.a, vChipsField: __WEBPACK_IMPORTED_MODULE_3__common_ChipsField_vue___default.a, vHtmlField: __WEBPACK_IMPORTED_MODULE_5__common_HtmlField_vue___default.a, vMacroField: __WEBPACK_IMPORTED_MODULE_6__common_MacroField_vue___default.a, vItemsField: __WEBPACK_IMPORTED_MODULE_7__common_ItemsField_vue___default.a },
  props: ['scheme', 'value'],
  data: function data() {
    return {
      formData: this.value || {}
    };
  },

  watch: {
    value: function value(newValue, oldValue) {
      this.formData = newValue;
    }
  },
  mounted: function mounted() {
    this.$nextTick(function () {
      var input = this.$refs.focused && this.$refs.focused.length > 0 && this.$refs.focused[0].$el || this.$el;
      input = input.querySelector('input');
      input && input.focus();
    });
  },

  methods: {
    updateForm: function updateForm(field, value) {
      if (field) {
        this.$set(this.formData, field.name, value);
        this.$emit('input', this.formData);
      }
    },
    formatForm: function formatForm(field, value) {
      if (field && field.format) {
        value = field.format(value);
        this.$set(this.formData, field.name, value);
      }
    },
    checkSize: function checkSize(field, size) {
      return field && field.size && field.size[size] || false;
    },
    checkIf: function checkIf(field) {
      if (!field.if) {
        return true;
      }
      return field.if(this.formData, field);
    },

    // define field which willbe focused after mounting
    checkFocused: function checkFocused(field) {
      if (!field.focus) {
        return null;
      }
      return 'focused';
    },
    checkDisabled: function checkDisabled(field) {
      if (field.disabled === null) {
        return null;
      }
      if (typeof field.disabled === 'function') {
        return field.disabled(this.formData, field);
      }
      return field.disabled;
    },
    calcTabIndex: function calcTabIndex(field) {
      return field.tabindex || 1;
    },
    calcHint: function calcHint(field) {
      if (!field.hint) {
        return null;
      }
      if (typeof field.hint === 'function') {
        return field.hint(this.formData, field);
      }
      return field.hint;
    },
    calcErrors: function calcErrors(field) {
      if (!field.errors) {
        return null;
      }
      if (typeof field.errors === 'function') {
        return field.errors(this.formData, field);
      }
      return field.errors;
    },
    calcSlot: function calcSlot(field) {
      if (!field.slot) {
        return null;
      }
      if (typeof field.slot === 'function') {
        return field.slot(this.formData, field);
      }
      return field.slot;
    },
    calcItems: function calcItems(field) {
      if (!field.items) {
        return null;
      }
      if (typeof field.items === 'function') {
        return field.items(this.formData, field);
      }
      return field.items;
    },
    calcEmptyChip: function calcEmptyChip(field) {
      if (!field.emptyChip) {
        return null;
      }
      if (typeof field.emptyChip === 'function') {
        return field.emptyChip(this.formData, field);
      }
      return field.emptyChip;
    }
  }
});

/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(807);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("34d29f0a", content, true, {});

/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".date-field.input-group--text-field.input-group--prepend-icon .input-group__details{max-width:calc(100% - 24px)}.date-field.input-group--text-field.input-group--prepend-icon .input-group__prepend-icon{min-width:36px}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/DateField.vue"],"names":[],"mappings":"AACA,oFACE,2BAA6B,CAC9B,AACD,yFACE,cAAgB,CACjB","file":"DateField.vue","sourcesContent":["\n.date-field.input-group--text-field.input-group--prepend-icon .input-group__details{\r\n  max-width: calc(100% - 24px);\n}\n.date-field.input-group--text-field.input-group--prepend-icon .input-group__prepend-icon {\r\n  min-width: 36px;\n}\r\n  \r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 808 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'date-field',
  props: {
    allowedDates: {
      type: Function,
      default: null
    },
    max: String,
    min: String,
    value: {
      type: String,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    calendarOnly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    resetTextOnBlur: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: String,
    placeholder: String,
    icon: {
      type: String,
      default: 'event'
    },
    timeMode: Boolean,
    tabindex: 0
  },
  data: function data() {
    return {
      menu: null,
      text: null,
      dateRules: {
        required: function required(v) {
          return !!v || 'введите дату';
        },
        valid: function valid(v) {
          return !v || __WEBPACK_IMPORTED_MODULE_0_moment___default()(v, 'DDMMYYYY', true).isValid() || 'дд.мм.гггг - формат даты';
        }
      }
    };
  },
  mounted: function mounted() {
    this.resetText(this.value);
  },

  watch: {
    value: function value(newVal, oldVal) {
      // watch it
      this.resetText(newVal);
    }
  },
  computed: {
    date: {
      get: function get() {
        var date = this.value ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(this.value, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601) : __WEBPACK_IMPORTED_MODULE_0_moment___default()();
        return date.format('YYYY-MM-DD');
      },
      set: function set(value) {
        if (value != null) {
          this.updateValue(value);
        }
      }
    },
    rulesMerged: function rulesMerged() {
      var result = [this.dateRules.valid];
      if (this.required) {
        result.push(this.dateRules.required);
      }
      result = this.rules.concat(result);
      return result;
    },
    locale: function locale() {
      return navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : 'en-en';
    }
  },
  methods: {
    resetText: function resetText(value) {
      this.text = this.formattedDate(value);
    },
    formattedDate: function formattedDate(value) {
      var date = value ? __WEBPACK_IMPORTED_MODULE_0_moment___default()(value, __WEBPACK_IMPORTED_MODULE_0_moment___default.a.ISO_8601) : null;
      return date ? date.format('DDMMYYYY') : null;
    },

    updateValue: function updateValue(value) {
      // console.log('update 1', 'this.value', this.value, 'value: ', value)
      if (new Date(value).getTime() !== new Date(this.value).getTime()) {
        this.$emit('input', value);
      }
      this.menu = false;
    },
    updateText: function updateText(value) {
      this.text = value;
      // console.log('updateText', 'this.value', this.value, 'value: ', value)
      if (__WEBPACK_IMPORTED_MODULE_0_moment___default()(value, 'DDMMYYYY', true).isValid()) {
        this.updateValue(__WEBPACK_IMPORTED_MODULE_0_moment___default()(value, 'DDMMYYYY', true).format('YYYY-MM-DD'));
      } else {
        if (!value || value.length === 0) {
          this.updateValue(null);
        }
      }
    },
    selectToDay: function selectToDay() {
      this.updateValue(__WEBPACK_IMPORTED_MODULE_0_moment___default()().format('YYYY-MM-DD'));
      this.menu = false;
    },
    onBlur: function onBlur(e) {
      if (this.resetTextOnBlur) {
        this.resetText(this.value);
      }
    }
  }
});

/***/ }),
/* 809 */,
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 322,
	"./af.js": 322,
	"./ar": 323,
	"./ar-dz": 324,
	"./ar-dz.js": 324,
	"./ar-kw": 325,
	"./ar-kw.js": 325,
	"./ar-ly": 326,
	"./ar-ly.js": 326,
	"./ar-ma": 327,
	"./ar-ma.js": 327,
	"./ar-sa": 328,
	"./ar-sa.js": 328,
	"./ar-tn": 329,
	"./ar-tn.js": 329,
	"./ar.js": 323,
	"./az": 330,
	"./az.js": 330,
	"./be": 331,
	"./be.js": 331,
	"./bg": 332,
	"./bg.js": 332,
	"./bm": 333,
	"./bm.js": 333,
	"./bn": 334,
	"./bn-bd": 335,
	"./bn-bd.js": 335,
	"./bn.js": 334,
	"./bo": 336,
	"./bo.js": 336,
	"./br": 337,
	"./br.js": 337,
	"./bs": 338,
	"./bs.js": 338,
	"./ca": 339,
	"./ca.js": 339,
	"./cs": 340,
	"./cs.js": 340,
	"./cv": 341,
	"./cv.js": 341,
	"./cy": 342,
	"./cy.js": 342,
	"./da": 343,
	"./da.js": 343,
	"./de": 344,
	"./de-at": 345,
	"./de-at.js": 345,
	"./de-ch": 346,
	"./de-ch.js": 346,
	"./de.js": 344,
	"./dv": 347,
	"./dv.js": 347,
	"./el": 348,
	"./el.js": 348,
	"./en-au": 349,
	"./en-au.js": 349,
	"./en-ca": 350,
	"./en-ca.js": 350,
	"./en-gb": 351,
	"./en-gb.js": 351,
	"./en-ie": 352,
	"./en-ie.js": 352,
	"./en-il": 353,
	"./en-il.js": 353,
	"./en-in": 354,
	"./en-in.js": 354,
	"./en-nz": 355,
	"./en-nz.js": 355,
	"./en-sg": 356,
	"./en-sg.js": 356,
	"./eo": 357,
	"./eo.js": 357,
	"./es": 358,
	"./es-do": 359,
	"./es-do.js": 359,
	"./es-mx": 360,
	"./es-mx.js": 360,
	"./es-us": 361,
	"./es-us.js": 361,
	"./es.js": 358,
	"./et": 362,
	"./et.js": 362,
	"./eu": 363,
	"./eu.js": 363,
	"./fa": 364,
	"./fa.js": 364,
	"./fi": 365,
	"./fi.js": 365,
	"./fil": 366,
	"./fil.js": 366,
	"./fo": 367,
	"./fo.js": 367,
	"./fr": 368,
	"./fr-ca": 369,
	"./fr-ca.js": 369,
	"./fr-ch": 370,
	"./fr-ch.js": 370,
	"./fr.js": 368,
	"./fy": 371,
	"./fy.js": 371,
	"./ga": 372,
	"./ga.js": 372,
	"./gd": 373,
	"./gd.js": 373,
	"./gl": 374,
	"./gl.js": 374,
	"./gom-deva": 375,
	"./gom-deva.js": 375,
	"./gom-latn": 376,
	"./gom-latn.js": 376,
	"./gu": 377,
	"./gu.js": 377,
	"./he": 378,
	"./he.js": 378,
	"./hi": 379,
	"./hi.js": 379,
	"./hr": 380,
	"./hr.js": 380,
	"./hu": 381,
	"./hu.js": 381,
	"./hy-am": 382,
	"./hy-am.js": 382,
	"./id": 383,
	"./id.js": 383,
	"./is": 384,
	"./is.js": 384,
	"./it": 385,
	"./it-ch": 386,
	"./it-ch.js": 386,
	"./it.js": 385,
	"./ja": 387,
	"./ja.js": 387,
	"./jv": 388,
	"./jv.js": 388,
	"./ka": 389,
	"./ka.js": 389,
	"./kk": 390,
	"./kk.js": 390,
	"./km": 391,
	"./km.js": 391,
	"./kn": 392,
	"./kn.js": 392,
	"./ko": 393,
	"./ko.js": 393,
	"./ku": 394,
	"./ku.js": 394,
	"./ky": 395,
	"./ky.js": 395,
	"./lb": 396,
	"./lb.js": 396,
	"./lo": 397,
	"./lo.js": 397,
	"./lt": 398,
	"./lt.js": 398,
	"./lv": 399,
	"./lv.js": 399,
	"./me": 400,
	"./me.js": 400,
	"./mi": 401,
	"./mi.js": 401,
	"./mk": 402,
	"./mk.js": 402,
	"./ml": 403,
	"./ml.js": 403,
	"./mn": 404,
	"./mn.js": 404,
	"./mr": 405,
	"./mr.js": 405,
	"./ms": 406,
	"./ms-my": 407,
	"./ms-my.js": 407,
	"./ms.js": 406,
	"./mt": 408,
	"./mt.js": 408,
	"./my": 409,
	"./my.js": 409,
	"./nb": 410,
	"./nb.js": 410,
	"./ne": 411,
	"./ne.js": 411,
	"./nl": 412,
	"./nl-be": 413,
	"./nl-be.js": 413,
	"./nl.js": 412,
	"./nn": 414,
	"./nn.js": 414,
	"./oc-lnc": 415,
	"./oc-lnc.js": 415,
	"./pa-in": 416,
	"./pa-in.js": 416,
	"./pl": 417,
	"./pl.js": 417,
	"./pt": 418,
	"./pt-br": 419,
	"./pt-br.js": 419,
	"./pt.js": 418,
	"./ro": 420,
	"./ro.js": 420,
	"./ru": 421,
	"./ru.js": 421,
	"./sd": 422,
	"./sd.js": 422,
	"./se": 423,
	"./se.js": 423,
	"./si": 424,
	"./si.js": 424,
	"./sk": 425,
	"./sk.js": 425,
	"./sl": 426,
	"./sl.js": 426,
	"./sq": 427,
	"./sq.js": 427,
	"./sr": 428,
	"./sr-cyrl": 429,
	"./sr-cyrl.js": 429,
	"./sr.js": 428,
	"./ss": 430,
	"./ss.js": 430,
	"./sv": 431,
	"./sv.js": 431,
	"./sw": 432,
	"./sw.js": 432,
	"./ta": 433,
	"./ta.js": 433,
	"./te": 434,
	"./te.js": 434,
	"./tet": 435,
	"./tet.js": 435,
	"./tg": 436,
	"./tg.js": 436,
	"./th": 437,
	"./th.js": 437,
	"./tk": 438,
	"./tk.js": 438,
	"./tl-ph": 439,
	"./tl-ph.js": 439,
	"./tlh": 440,
	"./tlh.js": 440,
	"./tr": 441,
	"./tr.js": 441,
	"./tzl": 442,
	"./tzl.js": 442,
	"./tzm": 443,
	"./tzm-latn": 444,
	"./tzm-latn.js": 444,
	"./tzm.js": 443,
	"./ug-cn": 445,
	"./ug-cn.js": 445,
	"./uk": 446,
	"./uk.js": 446,
	"./ur": 447,
	"./ur.js": 447,
	"./uz": 448,
	"./uz-latn": 449,
	"./uz-latn.js": 449,
	"./uz.js": 448,
	"./vi": 450,
	"./vi.js": 450,
	"./x-pseudo": 451,
	"./x-pseudo.js": 451,
	"./yo": 452,
	"./yo.js": 452,
	"./zh-cn": 453,
	"./zh-cn.js": 453,
	"./zh-hk": 454,
	"./zh-hk.js": 454,
	"./zh-mo": 455,
	"./zh-mo.js": 455,
	"./zh-tw": 456,
	"./zh-tw.js": 456
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 810;

/***/ }),
/* 811 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px",
      "disabled": _vm.readonly
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    staticClass: "date-field",
    attrs: {
      "slot": "activator",
      "label": _vm.label,
      "value": _vm.text,
      "required": _vm.required,
      "prepend-icon": _vm.icon,
      "rules": _vm.rulesMerged,
      "error-messages": _vm.errorMessages,
      "mask": "##.##.####",
      "readonly": _vm.readonly || _vm.calendarOnly,
      "hint": _vm.hint,
      "placeholder": _vm.placeholder,
      "tabindex": _vm.tabindex
    },
    on: {
      "input": _vm.updateText,
      "blur": _vm.onBlur
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "escape", undefined, $event.key, undefined)) { return null; }
        return _vm.resetText(_vm.value)
      }
    },
    slot: "activator"
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": _vm.locale,
      "no-title": "",
      "color": "primary",
      "first-day-of-week": "1",
      "allowed-dates": _vm.allowedDates,
      "max": _vm.max,
      "min": _vm.min
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(ref) {
        var cancel = ref.cancel;

        return [_c('v-btn', {
          attrs: {
            "flat": "",
            "color": "primary"
          },
          on: {
            "click": _vm.selectToDay
          }
        }, [_vm._v("Сегодня")])]
      }
    }]),
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_formats_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-select-radio',
  props: {
    label: null,
    value: null,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    items: Array,
    default: function _default() {
      return [];
    }
  },
  data: function data() {
    return {
      active: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.active = this.value;
  },

  watch: {
    value: function value(newValue) {
      this.active = newValue;
    }
  },
  computed: {},
  methods: {
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_0__api_formats_js__["a" /* default */].createComp('<span>' + template + '</span>');
    }
  }
});

/***/ }),
/* 813 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-radio-group', {
    attrs: {
      "label": _vm.label,
      "mandatory": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      }
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "align-top": "",
        "pa-1": ""
      }
    }, [_c('v-radio', {
      staticClass: "shrink mr-2",
      attrs: {
        "name": "active",
        "value": item[_vm.itemValue] || Object.values(item)[0]
      }
    }), _vm._v(" "), _c(_vm.createComp(item[_vm.itemText] || Object.values(item)[0]), {
      tag: "component"
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 814 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_formats_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-select-check',
  props: {
    label: null,
    value: null,
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemDisabled: {
      type: String,
      default: 'disabled'
    },
    items: Array,
    default: function _default() {
      return [];
    }
  },
  data: function data() {
    return {
      active: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.active = this.parse(this.value);
  },

  watch: {
    value: function value(newValue) {
      this.active = this.parse(newValue);
    }
  },
  computed: {},
  methods: {
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_0__api_formats_js__["a" /* default */].createComp('<span>' + template + '</span>');
    },
    parse: function parse(v) {
      if (Array.isArray(v)) {
        return v;
      } else {
        return v && v.split(', ') || [];
      }
    },
    onChange: function onChange(e) {
      this.$emit('input', e.join(', '));
    }
  }

});

/***/ }),
/* 815 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-radio-group', {
    attrs: {
      "label": _vm.label,
      "mandatory": false,
      "hide-details": ""
    },
    on: {
      "change": function($event) {
        return _vm.$emit('input', $event)
      }
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, _vm._l((_vm.items), function(item, index) {
    return _c('v-flex', {
      key: index,
      staticStyle: {
        "display": "flex"
      },
      attrs: {
        "align-top": "",
        "pa-1": ""
      }
    }, [_c('v-checkbox', {
      staticClass: "shrink mt-0 mr-2",
      attrs: {
        "hide-details": "",
        "multiple": "",
        "input-value": _vm.active,
        "value": item[_vm.itemValue] || Object.values(item)[0],
        "disabled": item[_vm.itemDisabled]
      },
      on: {
        "change": _vm.onChange
      }
    }), _vm._v(" "), _c(_vm.createComp(item[_vm.itemText] || Object.values(item)[0]), {
      tag: "component"
    })], 1)
  }), 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats_js__ = __webpack_require__(5);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-chips-field',
  props: {
    chipSize: {
      type: Number,
      default: 10
    },
    solo: {
      type: Boolean,
      default: false
    },
    flat: {
      type: Boolean,
      default: false
    },
    disabled: {
      type: Boolean,
      default: false
    },
    value: null,
    emptyChip: {
      type: String,
      default: null
    },
    emptyAlways: {
      type: Boolean,
      default: false
    },
    emptyEnabled: {
      type: Boolean,
      default: false
    },
    hint: {
      type: String,
      default: null
    },
    label: {
      type: String,
      default: null
    },
    tabindex: 0,
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    default: function _default() {
      return [];
    }
  },
  data: function data() {
    return {
      focused: false,
      isDirty: false,
      selected: []
    };
  },
  mounted: function mounted() {
    this.$emit('change', this.value);
    this.onSetItems(this.items);
  },

  watch: {
    value: function value(newVal, oldVal) {
      // watch it
      // this.setSelected(newVal)
      this.$emit('change', newVal);
    },
    items: function items(newVal, oldVal) {
      this.onSetItems(this.items);
    }
  },
  computed: {
    classes: function classes() {
      return {
        // '.pa-0': this.solo,
        'input-group--solo': this.solo,
        'elevation-0': this.flat,
        'input-group': true,
        'input-group--text-field': true,
        'primary--text': this.focused,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': true
      };
    },
    classesLabel: function classesLabel() {
      return {
        'caption': true,
        'v-label': true,
        'theme--light': !this.focused
      };
    },
    filteredItems: function filteredItems() {
      var _this = this;

      var set = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a(this.selected);
      return this.items.filter(function (item) {
        return set.has(_this.getKey(item));
      });
    },
    isEmpty: function isEmpty() {
      return this.emptyChip && this.filteredItems.length === 0;
    }
  },
  methods: {
    onSetItems: function onSetItems(items) {
      var _this2 = this;

      var set = new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_set___default.a();
      if (items && Array.isArray(items)) {
        items.forEach(function (i) {
          return set.add(_this2.getKey(i));
        });
      }
      this.selected = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(set);
      this.isDirty = this.emptyChip || this.selected.length > 0;
    },
    getKey: function getKey(item) {
      return item && (item.value || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(item)[0]);
    },
    getText: function getText(item) {
      var v = item && (item.text || !item.img && this.getKey(item) || '');
      return v.slice(0, this.chipSize);
    },
    getHint: function getHint(item) {
      return item && (item.hint || this.getText(item) || this.getKey(item));
    },
    getImg: function getImg(item) {
      return item && item.img;
    },
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_3__api_formats_js__["a" /* default */].createComp('<span>' + template + '</span>');
    },
    errorItemMessage: function errorItemMessage(item) {
      return item && item.error || null;
    },
    onFocus: function onFocus() {
      this.focused = true;
    },
    onBlur: function onBlur() {
      this.focused = false;
    },
    addItem: function addItem(item) {
      if (!item) {
        if (this.emptyEnabled || !this.disabled) {
          this.$emit('click', item ? this.getKey(item) : null);
          return;
        }
      }
      if (!(this.disabled && this.isEmpty)) {
        this.$emit('click', item ? this.getKey(item) : null);
      }
    },
    removeItem: function removeItem(item) {
      if (!(this.disabled && this.isEmpty)) {
        this.$emit('remove', item ? this.getKey(item) : null);
      }
    }
  }
});

/***/ }),
/* 817 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.classes
  }, [_c('label', {
    class: _vm.classesLabel
  }, [_vm._v(_vm._s(_vm.label) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.filteredItems), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: _vm.getKey(item),
      attrs: {
        "tabindex": _vm.tabindex,
        "small": "",
        "text-color": _vm.errorItemMessage(item) ? 'error' : 'black',
        "close": !_vm.disabled
      },
      on: {
        "click": function($event) {
          return _vm.addItem(item)
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
          return _vm.addItem(item)
        },
        "input": function($event) {
          return _vm.removeItem(item)
        },
        "focus": function($event) {
          return _vm.onFocus()
        },
        "blur": function($event) {
          return _vm.onBlur()
        }
      }
    }, [(_vm.getImg(item)) ? _c('v-avatar', [_c('img', {
      attrs: {
        "src": _vm.getImg(item),
        "alt": ""
      }
    })]) : _vm._e(), _vm._v(" "), (_vm.getText(item)) ? _c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n        " + _vm._s(_vm.getText(item)) + "\n      ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(_vm.getHint(item)))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorItemMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.emptyAlways || _vm.isEmpty),
      expression: "emptyAlways || isEmpty"
    }],
    attrs: {
      "small": "",
      "tabindex": _vm.tabindex,
      "text-color": "secondary",
      "disabled": !_vm.emptyEnabled && _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      },
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.addItem()
      },
      "focus": function($event) {
        return _vm.onFocus()
      },
      "blur": function($event) {
        return _vm.onBlur()
      }
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n        " + _vm._s(this.emptyChip) + "\n        ")])])], 2)], 1), _vm._v(" "), (_vm.hint) ? _c('div', {
    staticClass: "input-group__details"
  }, [_c('div', {
    staticClass: "input-group__messages input-group__hint v-messages theme--light v-messages__wrapper v-messages__message"
  }, [_vm._v(_vm._s(_vm.hint))])]) : _vm._e()])
},staticRenderFns: []}

/***/ }),
/* 818 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(819)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(821),
  /* template */
  __webpack_require__(822),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 819 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(820);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("39e1e83c", content, true, {});

/***/ }),
/* 820 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, "[contenteditable]:focus{outline:0 solid transparent}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/FlexField.vue"],"names":[],"mappings":"AACA,wBACE,2BAA+B,CAChC","file":"FlexField.vue","sourcesContent":["\n[contenteditable]:focus {\n  outline: 0px solid transparent;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_formats_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-flex-field',
  props: {
    label: null,
    value: null
  },
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: {},
  methods: {
    createComp: function createComp(template) {
      // let html = `<span>${template}</span>`
      return __WEBPACK_IMPORTED_MODULE_0__api_formats_js__["a" /* default */].createComp('<span>' + template + '</span>');
    }
  }
});

/***/ }),
/* 822 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c(_vm.createComp(_vm.value), {
    tag: "component",
    attrs: {
      "contenteditable": ""
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 823 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(824);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("6bd33766", content, true, {});

/***/ }),
/* 824 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".vueditor{border-top:none;border-left:none;border-right:none}.input-group--focused .vueditor{border-bottom-color:currentColor;border-bottom-width:2px}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/HtmlField.vue"],"names":[],"mappings":"AACA,UACE,gBAAkB,AAClB,iBAAmB,AACnB,iBAAoB,CACrB,AACD,gCACE,iCAAkC,AAClC,uBAA0B,CAC3B","file":"HtmlField.vue","sourcesContent":["\n.vueditor {\n  border-top:  none;\n  border-left:  none;\n  border-right:  none;\n}\n.input-group--focused .vueditor {\n  border-bottom-color: currentColor;\n  border-bottom-width:  2px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 825 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vueditor__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vueditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vueditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vueditor_lang_ru_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vueditor_macro_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vueditor_macro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vueditor_macro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vueditor_dist_style_vueditor_min_css__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vueditor_dist_style_vueditor_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vueditor_dist_style_vueditor_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//







var plugins = [{
  name: 'macro',
  element: {
    type: 'button',
    lang: {
      title: 'Макрос'
    },
    className: 'icon-macro'
  },
  component: __WEBPACK_IMPORTED_MODULE_2__vueditor_macro_vue___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-html-field',
  props: {
    label: null,
    value: {
      type: String,
      default: ''
    },
    hint: null,
    heightEditor: {
      type: String,
      default: '150px'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    macro: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      editor: null,
      isDirty: false,
      focused: false
    };
  },
  mounted: function mounted() {
    if (!this.editor) {
      this.editor = this.genEditor();
    }
    this.setValue(this.value);
    this.setReadonly(this.readonly);
  },

  watch: {
    value: function value(newValue) {
      this.setValue(newValue);
    },
    readonly: function readonly(newValue) {
      this.setReadonly(newValue);
    }
  },
  computed: {
    classes: function classes() {
      return {
        // '.pa-0': this.solo,
        'input-group--solo': this.solo,
        'elevation-0': this.flat,
        'input-group': true,
        'input-group--text-field': true,
        'primary--text': this.focused,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': true
      };
    },
    classesLabel: function classesLabel() {
      return {
        'caption': true,
        'v-label': true,
        'theme--light': !this.focused
      };
    }
  },
  methods: {
    setValue: function setValue(value) {
      // console.log('setValue', value)
      this.editor && value && (this.editor.value = value);
    },
    setReadonly: function setReadonly(value) {
      this.editor && (this.editor.readonly = value);
    },
    genEditor: function genEditor() {
      var _this = this;

      var config = {
        toolbar: ['fullscreen', 'sourceCode', 'undo', 'redo', '|',
        // 'element',
        'fontName', 'fontSize', 'foreColor', 'backColor', 'divider', 'bold', 'italic', 'underline', 'strikeThrough', 'link', 'unLink',
        // 'divider', 'subscript', 'superscript',
        'divider', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', '|', 'indent', 'outdent', 'insertOrderedList', 'insertUnorderedList', '|',
        // 'picture', 'table', '|',
        // 'code',
        'removeFormat', '|', 'macro'
        // , 'markdown'
        ],
        shortbar: ['fullscreen', 'sourceCode', '|', 'foreColor', 'backColor', '|', 'bold', 'italic', '|', 'macro'],
        fontName: [{ val: 'Arial' }, { val: 'Times New Roman' }, { val: 'Courier New' }],
        headStyle: '\n          <style>\n            body {font-family: Arial;}\n            pre {margin: 0; padding: 0.5rem;}\n          </style>',
        lang: __WEBPACK_IMPORTED_MODULE_1__vueditor_lang_ru_js__["a" /* default */]
      };
      if (this.macro) {
        config.plugins = plugins;
      }
      var inst = Object(__WEBPACK_IMPORTED_MODULE_0_vueditor__["createEditor"])('#htmlValueEditor', config);
      inst.$on('input', function () {
        _this.$emit('input', inst.getContent());
      });
      inst.$on('focus', function () {
        _this.focused = true;
      });
      inst.$on('blur', function () {
        _this.focused = false;
      });
      inst.value = null;
      return inst;
    }
  }
});

/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(827);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("0e26c0a8", content, true, {});

/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".macro{width:276px}.macro .ve-pop-body{max-height:350px;overflow:auto}.macro .wrap li{cursor:pointer;padding:6px}.macro .wrap li:hover{background:rgba(0,0,0,.04)}.ve-btn,.ve-btn:hover{border:1px solid #ccc;color:#333}.ve-btn:hover{background:rgba(0,0,0,.04)}.ve-divider{display:block;-webkit-box-flex:1;-ms-flex:1 1 0px;flex:1 1 0px;max-width:100%;height:0;max-height:0;border:solid;border-width:thin 0 0;-webkit-transition:inherit;transition:inherit;border-color:rgba(0,0,0,.12);padding:0!important}.icon-macro{background:url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAA4UlEQVRYw+2WMQ6DMAxFv0TFBdgQ3I2KEe7HzAISAg7CyAXSobSQKpUdihFS/TMm5iXxdzCgUqncClGiwQyzGZ/azs1oUCLkfj7GaIXTgOcYEfN2PziCOQCDgXOKwhnKAxgUNKBdllZI2DlLUC1RLb34ldrUyxbpO92kvl3JYXEKYCZr8gZMHHOsdqu9ATVlb7tgMm9ARhSmNdkh8AYE6LiAHtGuNzhCzwHkO3a/niK/AOCXKxokk3yzMmCOt+mdsql4oZ3yVOhzfQ2A+E9fvG0Rb7zEW0fx5veE9l2l+jc9AKkzhtUre6odAAAAAElFTkSuQmCC\") no-repeat}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/vueditor/macro.vue"],"names":[],"mappings":"AAGA,OACE,WAAa,CACd,AACD,oBACE,iBAAkB,AAClB,aAAe,CAChB,AAGD,gBACE,eAAgB,AAChB,WAAa,CACd,AACD,sBACI,0BAAgC,CACnC,AAKD,sBAHI,sBAAuB,AACvB,UAAY,CAMf,AAJD,cAGI,0BAAgC,CACnC,AACD,YACE,cAAe,AACf,mBAAoB,AAChB,iBAAkB,AACd,aAAc,AACtB,eAAgB,AAChB,SAAY,AACZ,aAAgB,AAChB,aAAc,AACd,sBAAyB,AACzB,2BAA4B,AAC5B,mBAAoB,AACpB,6BAAkC,AAClC,mBAAwB,CACzB,AAGD,YACE,0aAA4a,CAC7a","file":"macro.vue","sourcesContent":["\n.ctn {\n}\n.macro {\n  width: 276px;\n}\n.macro .ve-pop-body {\n  max-height: 350px;\n  overflow: auto;\n}\n.macro .ve-input {\n}\n.macro .wrap li {\n  cursor: pointer;\n  padding: 6px;\n}\n.macro .wrap li:hover {\n    background: rgba(0, 0, 0, 0.04);\n}\n.ve-btn {\n    border: 1px solid #ccc;\n    color: #333;\n}\n.ve-btn:hover {\n    border: 1px solid #ccc;\n    color: #333;\n    background: rgba(0, 0, 0, 0.04);\n}\n.ve-divider {\n  display: block;\n  -webkit-box-flex: 1;\n      -ms-flex: 1 1 0px;\n          flex: 1 1 0px;\n  max-width: 100%;\n  height: 0px;\n  max-height: 0px;\n  border: solid;\n  border-width: thin 0 0 0;\n  -webkit-transition: inherit;\n  transition: inherit;\n  border-color: rgba(0, 0, 0, 0.12);\n  padding: 0px !important;\n}\n\n/*icon for toolbar button*/\n.icon-macro {\n  background: url(\"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADAAAAAwCAQAAAD9CzEMAAAA4UlEQVRYw+2WMQ6DMAxFv0TFBdgQ3I2KEe7HzAISAg7CyAXSobSQKpUdihFS/TMm5iXxdzCgUqncClGiwQyzGZ/azs1oUCLkfj7GaIXTgOcYEfN2PziCOQCDgXOKwhnKAxgUNKBdllZI2DlLUC1RLb34ldrUyxbpO92kvl3JYXEKYCZr8gZMHHOsdqu9ATVlb7tgMm9ARhSmNdkh8AYE6LiAHtGuNzhCzwHkO3a/niK/AOCXKxokk3yzMmCOt+mdsql4oZ3yVOhzfQ2A+E9fvG0Rb7zEW0fx5veE9l2l+jc9AKkzhtUre6odAAAAAElFTkSuQmCC\") no-repeat;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 828 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_formats__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      val: '',
      newVal: '',
      text: '',
      arr: [{ title: 'Значение', templates: ['<xsl:value-of select="" />'], hint: '' }, { title: 'Начало блока', templates: ['<xsl:for-each select="" >'], hint: '' }, { title: 'Конец блока', templates: ['</xsl:for-each>'], hint: ''
        // ,
        // {title: 'Условие', templates: ['<xsl:if test="">', '</xsl:if>'], hint: ''}
      }]
    };
  },

  watch: {
    'showPopup': function showPopup(val) {
      val && this.setVal();
    }
  },
  computed: {
    rect: function rect() {
      return this.$store.state.rect;
    },
    range: function range() {
      return this.$store.state.range;
    },
    style: function style() {
      if (!this.showPopup) {
        return { left: 0, top: 0 };
      }
      var _rect = this.rect,
          left = _rect.left,
          top = _rect.top,
          width = _rect.width,
          height = _rect.height;

      var offsetLeft = left;
      var offsetTop = top;
      if (this.$el) {
        this.$el.style.display = 'block';
        // > 0 means the popover menu's right part is not totally visible
        if (left + this.$el.offsetWidth - this.$el.parentElement.clientWidth > 0) {
          offsetLeft = left - this.$el.offsetWidth + width;
          if (offsetLeft < 0) {
            offsetLeft = left + width / 2 - this.$el.offsetWidth / 2;
          }
        }
        if (top + this.$el.offsetHeight - this.$el.parentElement.clientHeight > 0) {
          offsetTop = top - this.$el.offsetHeight + height;
          if (offsetTop < 0) {
            offsetTop = top + height / 2 - this.$el.offsetHeight / 2;
            offsetLeft += left > offsetLeft ? -width : width;
          }
        }
        this.$el.style.display = 'none';
      }
      return { left: offsetLeft + 'px', top: offsetTop + 'px' };
    },
    showPopup: function showPopup() {
      return this.$store.state.toolbar.macro.showPopup;
    },
    fullscreen: function fullscreen() {
      return this.$store.state.fullscreen;
    }
  },
  methods: {
    setVal: function setVal() {
      this.val = null;
      if (this.range) {
        var container = this.range.commonAncestorContainer;
        container.nodeType === 3 && (container = container.parentNode);
        container && container.nodeName === 'A' && container.href && (this.val = container.getAttribute('href').replace('xslt:', '')) && (this.text = container.innerText) && (this.newVal = this.val);
      }
    },
    updatePopupDisplay: function updatePopupDisplay() {
      this.$store.dispatch('updatePopupDisplay');
    },

    // insertItem (item) {
    //   console.log('insertItem', item)
    //   if (item.templates) {
    //     let main = document.createElement('span')
    //     item.templates.forEach(template => {
    //       let div = this.createMacro(this.range && this.range.extractContents().textContent || item.title, template)
    //       main.appendChild(div)
    //     })
    //     this.$store.dispatch('execCommand', {name: 'insertHTML', value: main.innerHTML})
    //     this.updatePopupDisplay()
    //   }
    // },
    createMacro: function createMacro(text, value) {
      var div = document.createElement('a');
      if (value) {
        div.setAttribute('href', 'xslt:' + value);
      }
      div.innerText = text || value;
      return div;
    },
    insertMacro: function insertMacro(text, value) {
      var outerHTML = text;
      if (value) {
        var div = this.createMacro(text, value);
        outerHTML = div.outerHTML;
      }
      this.$store.dispatch('execCommand', { name: 'insertHTML', value: outerHTML });
      this.updatePopupDisplay();
    },
    addItem: function addItem(item) {
      this.newVal = item.templates;
      this.val = this.newVal;
      this.text = this.range && this.range.cloneContents().textContent || item.title;
    },
    updateMacro: function updateMacro() {
      var _this = this;

      this.$store.dispatch('execCommand', { name: 'unlink', value: null });
      setTimeout(function () {
        _this.insertMacro(_this.text, _this.newVal);
      }, 200);
    },
    copyForTemplate: function copyForTemplate() {
      var content = this.$store.state.content;
      __WEBPACK_IMPORTED_MODULE_0__store__["a" /* default */].dispatch('copyToClipboard', { text: '<![CDATA[' + content + ']]>' });
      this.updatePopupDisplay();
    },
    toFullScreen: function toFullScreen() {
      this.$store.dispatch('setFullScreen', !this.fullscreen);
      this.updatePopupDisplay();
    },
    check: function check() {
      console.log('check', __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].getValue(this, ['$parent', '$el', 'parentNode', 'parentNode']));
      var content = this.$store.state.content;
      var htmlField = __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].getValue(this, ['$parent', '$el', 'parentNode', 'parentNode', 'parentNode', '__vue__']);
      htmlField && htmlField.$emit('check', content);
      this.updatePopupDisplay();
    }
  }
});

/***/ }),
/* 829 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPopup),
      expression: "showPopup"
    }],
    staticClass: "ve-popover macro",
    style: (_vm.style)
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.val),
      expression: "!val"
    }]
  }, [_c('div', {
    staticClass: "ve-pop-header"
  }, [_vm._v("Макрос")]), _vm._v(" "), _c('div', {
    staticClass: "ve-pop-body"
  }, [_c('div', {
    staticClass: "wrap"
  }, [_c('ul', [_vm._l((_vm.arr), function(item) {
    return _c('li', {
      on: {
        "click": function($event) {
          return _vm.addItem(item)
        }
      }
    }, [_vm._v(_vm._s(item.title))])
  }), _vm._v(" "), _c('li', {
    staticClass: "ve-divider"
  }), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.check()
      }
    }
  }, [_vm._v("Проверить")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.copyForTemplate()
      }
    }
  }, [_vm._v("Копировать для шаблона")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.updatePopupDisplay()
      }
    }
  }, [_vm._v("Отмена")]), _vm._v(" "), _c('li', {
    staticClass: "ve-divider"
  }), _vm._v(" "), _c('li', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.fullscreen),
      expression: "!fullscreen"
    }],
    on: {
      "click": function($event) {
        return _vm.toFullScreen()
      }
    }
  }, [_vm._v("Полный экран")])], 2)])])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.val),
      expression: "val"
    }]
  }, [_c('div', {
    staticClass: "ve-pop-header"
  }, [_vm._v("Изменить макрос")]), _vm._v(" "), _c('div', {
    staticClass: "ve-pop-body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.text),
      expression: "text"
    }],
    staticClass: "ve-input",
    domProps: {
      "value": (_vm.text)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.text = $event.target.value
      }
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "rows": "5"
    },
    model: {
      value: (_vm.newVal),
      callback: function($$v) {
        _vm.newVal = $$v
      },
      expression: "newVal"
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "ve-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updateMacro
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('button', {
    staticClass: "ve-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.updatePopupDisplay
    }
  }, [_vm._v("Отменить")])], 1)])])
},staticRenderFns: []}

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, "/*!\n * vueditor v1.0.1\n * https://github.com/wanazaroff/vueditor.git\n */.vueditor html{font-size:16px}.vueditor h1,.vueditor h2,.vueditor h3,.vueditor h4,.vueditor h5,.vueditor p{margin:0;padding:0}.vueditor ol,.vueditor ul{list-style:none;margin:0;padding:0}.vueditor a{color:#000;text-decoration:none}.vueditor hr{margin:10px 0}.vueditor label{font-weight:400}.vueditor img{max-width:100%}.vueditor{min-width:300px;min-height:150px;height:100%;display:flex;flex-direction:column;border:1px solid #ddd;background:#fff;box-sizing:border-box;position:relative}.ve-fullscreen{position:fixed;left:0;top:0;bottom:0;right:0;z-index:10;margin:0!important}.ve-code,.ve-design,.ve-md{flex:1;overflow:hidden}.ve-design{position:relative}.ve-design iframe{width:100%;height:100%;display:block;position:absolute}.ve-code{position:relative;overflow-y:auto}[class^=ve-triangle]{display:inline-block;width:0;height:0;vertical-align:middle;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;transition:.2s}.ve-triangle-down{transform:rotate(0deg)}.ve-triangle-up{transform:rotate(-180deg)}.ve-btn-box{float:right}.ve-btn-box .ve-btn:not(:last-child){border-right:none}.ve-input-box{display:flex;margin-bottom:10px}.ve-input-box .ve-input{flex:1}.ve-input-box .ve-btn{border-left:none}.ve-btn{display:inline-block;margin:0;padding:5px 15px;text-align:center;white-space:nowrap;cursor:pointer;border:1px solid #ccc;color:#333;outline:none;background-color:#fff;user-select:none;line-height:20px;transition:all .5s}.ve-btn:hover{color:#fff;background:#42b983;border-color:#42b983}.ve-btn:hover+.ve-btn{border-left-color:#42b983}.ve-input{display:block;width:100%;height:32px;padding:5px 10px;color:#555;background-color:#fff;border:1px solid #ccc;outline:none;box-sizing:border-box}.ve-select{position:relative;min-width:60px;line-height:26px;margin:5px 5px 5px 0;padding:0 20px 0 10px!important;border-right:1px solid #ddd;vertical-align:top}.ve-select span{display:inline-block;width:100%;vertical-align:middle;font-size:16px;line-height:26px;letter-spacing:normal}.ve-select i{position:absolute;right:10px;top:50%;margin-top:-2px}.ve-select:hover{background:transparent!important;color:#000}.ve-dropdown{width:176px;padding:5px 10px;position:absolute;top:36px;z-index:1000;background:#fff;border:1px solid #ccc}.ve-disabled{opacity:.5;cursor:not-allowed}.ve-popover{font-size:14px;position:absolute;z-index:1000;background-color:#fff;padding:1px;border:1px solid #ccc;border-radius:5px;box-shadow:0 5px 10px rgba(0,0,0,.2);box-sizing:border-box}.ve-pop-arrow{left:50%;top:-10px;margin-left:-10px;border-bottom:10px solid rgba(0,0,0,.25)}.ve-pop-arrow,.ve-pop-arrow:after{position:absolute;border-left:10px solid transparent;border-right:10px solid transparent}.ve-pop-arrow:after{left:-10px;top:1px;content:\"\";border-bottom:10px solid #fff}.ve-pop-header{background:#f7f7f7;padding:8px 14px;border-bottom:1px solid #ebebeb}.ve-pop-body{padding:8px}.ve-fixed{overflow:hidden}.ve-dialog{width:100%;height:100%;background:rgba(0,0,0,.6);position:fixed;top:0;left:0;z-index:1000}.ve-dialog-header{background:#f7f7f7;padding:10px}.ve-close{float:right}.ve-dialog-body{padding:10px}.ve-dialog-footer{padding:10px;overflow:hidden}.ve-preview{margin-top:10px;text-align:center;font-size:0}.ve-preview img{max-height:300px}.vueditor .icon-align-center{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAmVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlB4vuQPAAAAMnRSTlMAAgMFBwsMDg8QERIUFRYXGBkaJiotLjg6UFFSVVZofoKDqK+3ub7BxcrM0dnk6Pf5+4oUqqUAAAEkSURBVGje7djbUsJQDIXhUFFosSBnioBaKGo57v3+D+eVNx1nSNJm48X6X+Cb6TTJtEQIIfTbU39ws/5jLaJdeFa7dg3kyzP71BtDz+5FjUz5yFSNzPjIDAgQWRM+MlEjHT7S0Y/8B9d4q7MhX48c4rjEuUL/oOih0aI/iFHpG64cVY3Y+ca7xtoFIum9ghQWSFFB9hbIHgiQYK9wkGFMDNaKi++xIMOseoRC1dqc5INx2rREyFY3f1uJMdZO+ViAZFokEyBrLbIGAuRWKy2yEiBzLTKXfHSddcZZdHOTg8Y4JMI93B2I6+J6ofv87ug9G9aLiIiWzpvmMqKFN29BpT3yTT5AQIAYIld740K5PZJT6qwNlxKluekTu+QpDh1CqOl+ACYrEC2lLhvkAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-align-justify{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAWlBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlC+y02GAAAAHXRSTlMAAwQFEhQVFyUmLS46OzxQUVVWqLq8ysze9/n7/bGqpTcAAADCSURBVGje7ZkJDoMwDAQHCunFUZoepIH/f7OvWEtVdz4wUpSsHRuMMX9F0x+F9A3Afdul1AXGXc7IWy95sQdgiSVCyUfvKGS9JJOq2lETpCw9sZKTC50R0x6EtABcV+1bXC9w1sfKiade8qDqJdWV0RKhJOQKhzzGkFgJCciYqDdGR8pF3nCHfB1CPkFFLymujJb8uiRkPDjpJZN+ZLstUcNnY5T7k64X0jUAN3EnUWcY9LEyeH9iiSXen3h/YowxfAF9I35eWqqeiAAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-align-left{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAnFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlD5L8M5AAAAM3RSTlMAAgMEBQcLDg8QERIUFRYXGBomKi0uODo7PFBRVVZofoKor7e5vL7ByszR2d7k6Pf5+/1nKpp+AAABHklEQVRo3u3Z21LCMBDG8bUeEaKCIshJo6LiqS37/u/mTeowQyZcdL9wwfd/gd9Mp93MpiKMsYOq6F236+pspzFfa+teTtPGWC16TyMrE0RvkoiNoXc5kCERIttVNshtEvE2yHkScbWF8bhjQDrf+ol9TXmWsX12fIKo2CSG34pp1f83Bgqr6jTIEofoU4PUQOTV+DyJ9kbkwJEsr3CWjxE4VupO1gGZZ9Qzhsv50ujD+FkcQVeH0DN2CQoN4khpikygi2loToQIDJlBrwdD93HkwdL4LYBXtqHPS9zlc9MFjzS2n/8n3R6wbiEiMkWuQapaT0RGCm9kPCCjfYhmiAgRIFLhjdJ4dYjmbZeg+PByJv9Pks/KOx50jDHr/gDKzMKMu2GFWQAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-align-right{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAnFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlD5L8M5AAAAM3RSTlMAAgMEBQcMDg8QERIUFRYXGRolJiotLjg6OzxQUVJVVmiDqK+5ur7FyszR2d7k6Pf5+/3jauRDAAABG0lEQVRo3u3Zy1ICMRCF4TaoXEfwwkVBlIAKokDs9383V2OxSbKYPtl4/hf4qlKTnklGhDHG6q5vhs0auBxxtdHGhWUG+VCLHpPGyMTQbRIZ2yCaRCZEiMCQBxvjmETaNohPj5WVhRGqzPB63jdeK58zGDPKXSJqnRO3O8X0Nf4zukFh3ZkOkEhvNbIBIqFG3oGIEvnnSJFHuMhm7JUYK0UGZJlRz1ipLl6/jbZJ4oN7bTm6Isq96Z6PHILmpkjkOPeCeZ8QISIiyxLI1NSIXA+6gyXyFJldvU8z4idxZdsZ2pS/fGasYa4/ANZ3IiIL4KFBVTXMRWYKbyY7PLIVLRARIkDkhDeO4vGIlyqgjVCJVB66Yvx/whgD9As3HcK8Wc6lewAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-bold{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAACHFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCeqFE0AAAAs3RSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCkqKywtLi8wMTI0NTc4OTo7PD0+P0BBQkRGR0lKS0xRUlRVVldYW1xdX2FiY2RmZ2hpa2xtb3Bxc3R1d3h5e3x+f4CCg4WGiImLjI6PkZKUlZeYmpudnqCio6WmqKqrra+wsrS1t7m6vL7AwcPFx8jKzM7P0dXX2drc4OLk5ujp6+3v8fP19/n7/fYiXWEAAAR3SURBVBgZtcHpX1RVAAbg99x7BxCwUEPIMMkFkSyXBEvLbLGsFLMpBhVL00QRQ3FFytC0XLBE1ExFFElwARnef7D81C/ue84ZYXoePDWnYuHSmlUffvJ5atvuA8dPX7zWO5hmxkZvNK94Dl6cuL7UNLgNMRv+qDZwuMvsuL/awOoas6V3LmzOMXv2B9CCgunzV6xv6X5Cm77mtYtK8yMDBIn86csbzo/Q5k4R3AqWHKWUxBhm5vZH1IZnw6eYyleIMzW3KKVnw6eLwmZIyweojEyBRzOFbdAS7VR6Q7glKTTCZjuVXXBbQ6EFVnuplMCpmsJRWJnLFM7AqYpCB+ymUimGSzmF83DYTWEnXEopdMPheQrDBg5TKfTA5SqFGXCYTKEfLp9SWAeHSRSG4FJO4SgccqjAZRKFHjhEVOASUBiFQ0DFwIWKgZ2hEsCFSgAHKiEcDBW4UIngEFB4CJc0hQQc8ilcgMtjCgk4lFFIwWWQQgSHlRTmwuUehQgOLYwbMnDppRDC4T7jvoTTTQoB7MoYN5oLp+sUAtjtY1wD3K5QCGBVyLg7AdwuUTCw+pEx6Rfh0UnBwOZdxoxWweccBQOLSsY8mgWvXygYaCvTHKsrH34/UzBQcg9xrNFagwx0UAgQl7PxCce6VISMnKAQYIxoweFRjtW/DBlqp1AzLS80+IcJcovmvLPjCuPuf2CQqTaOy523DTJ3hOOxxeBZHOK4DDRVBMjYAY7XSGMJMtTCCeiqREaaOSHdLyEDeyn81brhvWWLXl342uJlK9ckm04P0q41glcThQTGCIvfbxumNlABnz0UEhCC6m5qSXg0UkhAqxmgdMTAaReFCBbRSUpnDVx2UohglaR0ysBhB4UIdmspNcHhWwohHGopvQW77RRCuLRSGc6F1TcUQriEfVQOw+prCgGcyigVwWYrhQBuJ6l8D5sGCgHcSqikQ1g0UAjgcZPKUlhsoWDgsYHKXlhspmDgMZ1KPyw2UzDwCCiF0DZRMPDpp1IEbRMFA58TVGZBq6dg4LOHSiW0egoGPg1UXodWT8HAZyOVCmj1FAx8PqPyMrQUBXh9QaUYWooCvLZQyYWWogCv/RTSsEgxLg2v3yh0w6KOccPwekghBYs6xj2CTx6VebCoY9wD+MynMBrCoo5xD+DzHYWDsKlj3EP4PKAwGzb1jBuGxwIKPbDaSgEeFygsgVUjBQOn+RT+hF0bhRAuwW0KpbDroZAHl/0UtsHOUJkCh/UUfjewm0KlHHa1FPpz4LCKypuwCQ5SuFcAl3YqDbCo7KPQkw+XAko3IM27SOVECAfzyllq11cn8F+mJHmPSvojWEUz1rQ/oUPXurn5AQATFZa+kTw1Qu3sZEiFVbVt/cyK21WQzDCz5fpiWATMjtHWmbAKmQ0d1REcEpygdGeyPIBbDm0e9d3q7jzT8cOxI8eO/3T6wuWbfYMj/Nfjvs59G5aXFyIDeXxq6O7VX9uat278eMXiirIXnstLBAaaCcIoEQUGz2RyXhTgf/Q3nJOxY9PjxCUAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-code{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABWVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlBnrqOTAAAAcnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGhweICEiJCYoKSotLzIzNDc4OTw9P0JERUlLTlFVV1xeYmZpbG1xdHh8gIWJjJGVmpueo6aoqq2wtbm6vsHFyMrMz9HV2drc3uDi5Obo6evt7/Hz9ff5+/3yYEsPAAACzklEQVRo3u3Y2VsSYRQG8IMpJQhMpZQtpm2222b7npXtq1hWhplQSaDz/1+EvTPODH7b+Wbmqjl3zHnhxzzDM8BLlE022WTzH83on86zqXLKyGt3Y26mamz7Z7jtVJEJIK9SRe4DuZAqsgIk1Su/C0Y91RO5DOROqsg7IGNpGv0w1vrivlBl/pMj2x0F8nzzQHHuy4iF4TRd9+dOyfIhkHP+46Fl123tsTLkyi8gxZBhocDoKttF2xEsv/pXaBmPmYpvuO6kaH3Fjdwdx/0wSwmMlQHRfg7L/f7NctFCCRkl0T6PZSfnHxj8xlZ0Bh3HdjY4wla0Bj3C+jRZK3qDWtgPkq1iYOzFfiF6lKEYGHQNgetkqZgY9BGJUbJTjIwd3gvlSKFU4xl0EpHHgpWBYmbQE2ROkI1iaOTaCAnvnDrF0KB9CNUka6ViatANpK4SXzE26DNi8g+pVDE3Coj9VkQCZbVqZdAZ5GaIqzAMeorgMWIqHCO3huQA8RSOQQeQ/KDL9ShljkG3EJ0mhjJMVOMY5P1k2E0MZTGENCv6Zw55UYO3U/weQkoNhjKF5AOOsbpx2hWG8gLBIxxjGD/fjZW+deT62QZDOYTUWwvDXLmL0CWNURAZxor3ZMfK6CpNA6WCxA9jo/fPl4lyEYF7toaR8gb7cWsjrDQqqs5mXfWXt7CkNPTKYSxfxjG0itfZnI9l6BSvsynFM9SKtrMJGVV1DREoZXFnczu2oVK8zuZgfEOuaDqbwGjpDamypbOJY8iU3s4mniFRejobmWFTSTTy4s4mer+pxyxXJsWdTWTsCpxAaebFnU20LFyyMjZLNUfW2US/0+1KNa8edOSdzRbFwuh+xmrzjqqziSrvF2yKTn1nk/SIO5uER9LZJDuyzibJkXc2Cc4peWeT3Kg6m8SmrupskpppZWeT1BTOzrY7Y5T+5CibbLLJJpuk5y+zUKCeS7gPWgAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-eraser{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABiVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDqUIP+AAAAgnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESFBUZGhscHh8gISIjJCcoKSowMTM0ODs8PT5AQkNFRkdJSlJUVVZXX2FiY2RmZ2lrbG1vdXl7fIWGiImLjo+RkpSVl5ibnaCio6aoqqutr7W3uby+wMHDxcjKzM7R1dfZ2tze4Obo7e/x8/X3+fv9eQZEnwAAAi9JREFUGBntwXk3VXEYBeB9zu1eFLoiDTcqmgyleUIDKtKMSqPQIJEhUw6u/clbee8H2L/3n9ZqnedBKpVKpVL/Rl33q/EJzbu+g/CIBhnkdYxg0XsGms4g1BMGG0CgbjpUIUg7Pc4iRANdOhGgJqHLDejKlunTDFn8nT5JDNlbOnVANkCnh5Bdp9OHCKrTdJrJQHWgSJ+VcqiqftNnsxaq7AKdjkEVTdLpPGQjdOqF7B6dXkB2mU7jEVTNdJrbBVXdFn3W9kBVsUqf4n6oMrN0OgFV9IlOVyB7TKcHkHXRaRSyNjp9i6FqoNNSDqqahD7JXqjKlumzXYAqnqJTC2Rv6HQTsn46DUJ2jU4fI6hO0WkmA1V9kT4rFVBVrtFnsxaq7DydjkMVTdL0QNPOkguQDdMMQ1NgSS9kfTSfI0iq12mGILtE8ysHSXaBZiKCqokmyUMSTdLMZaGq26RphOY5zVolVBWrNOeguUVTrIcqM0vTC00bS05CFY3RjEBzeJvmKmSPaL7EkFSv0/RD1kWzlIMku0AzClkbTZKHJJqgmYqhOsKSRmie0SzloMonNB3QdNMkeajKlmn6oGlhSQGqeIrmJTSHtmlaIRui+RpDUrVO0wlZgWYpB0l2nmYQukHu2KiBJBqnGYugW+SOo9A8pZnJIMAG/1q8qxmmWa1AiGk6bNYiyG06NCFM+QaDXUSoVobqQbgz2wzSCY/dd35sUVP8eX8fUqlUKpX6f/0Bl2O/cU+zSuAAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-file-image-o{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABa1BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCat1vqAAAAeHRSTlMAAQIDBAUGCQoLDA0OERITFBUWHyAkJyosLzAxNDY3PD0/QEJDREVGR0lKS0xNTk9QUVJUVVZXX2RmaGlrbG9wcXN0dXd4eXt8foCCg4aIiYuMjo+RkpSdnqCio6WtsLK1t7m8wMHDz9na3N7g4uTm6O3z9ff5+/0N1+4LAAACq0lEQVRo3u3ZWVvTQBQG4JOJtVTL5obFDVGrshVcUKmiKJtrwQUpWhW0UqlYLdicn+9FSEyTSTPJnAkX9LvLM5l5nyST5EwCYKXjccXAsPmznj8O4jm5ixFTG2WCRiqygYi102LIE5RKXgj5IYfgrAhiYAwKYgzK3p6HmWhmzA4ft0Moezsy4SmfNzuc0e6IK5ERgOu2MqcOgSFRRQaBYUFFChFV5BAYsZV5dQiMiiiyiJAijcBYsCKPQM5WFtQhwQoFAuMBCgkCE60VGgRu2Mq0OsShZNQhcNNCfjN1CNyylJxCxFZqKhGrCU+oRLSa2XafCpk+xUnRbNugQlpW49LIXYFSTBq5EgeSigOBB3EgME+F6MmEv3Ls3sp7bj6EQPoKdUQ01gY0CBcmjPSW7cP+2a8IOd9wnt0pJUjGdQ2nFCDpv+6Z0k+PFD3TcVujRro5k36AGpnkIGvUSImDGNRIhfeQSBAjdR6SJEY2eYhOjKxyjDr1NclykAI1kuQgfZ6xHl6Qu+NnPUbZM9Qj3xtUEElUXUaj191jBhHxotRTuMv1ufCcz6e+Qan3SZfzWHY9iw37fA5KvRkTc7ZRTLt3/9+Gl2QQgGR2dbNeKU12e0ZZcJ7Jy1KIbxabr1dWBfLUPb2v0iPPvDfqNWrkOe/hOUSLvOBXpMOUyEu/uneEDnnlX12PRUbYctP7sNCqhs9FRFgJtxzKUuuVwngkhH1CxGqHtfk6aD0yEQFhn82aPmVuvgleWp0NjbAvVoV6BADgrcAi8XZYRF+3+/46Cto7VIDoG86fVj0rqADRv0b5URMO0b+hcuRQGdUj3zEGBNtIG2kjBwiRTBtpI/uG0GZfkKoCYytwsUmQRTeSNsiNhucTA2SoFYPzXxY6l3cIiZ2lTp/5rdGladx/Xh+3LuObBs4AAAAASUVORK5CYII=) no-repeat}.vueditor .icon-file-text-o{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAA9lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlBBA0bsAAAAUXRSTlMAAQIEBgcJCgsMDQ4QERIVGR0fICEiIyQnLC0uLzAzOkJKTU9kZmlrbW90dXd4eXt8foOFi4yPkZKaqLe5z9HT2drc3uDk5ujr7e/z9ff5+/30iNzRAAABlElEQVRo3u3ZWVPCMBQF4NNaFQXcFZcqrrjv4r6gSEEF2vz/P+NDlxkR6KVJ6oP3vDbJ99KcSSZAmNGDiicGzcdDaQb0FFoiYZxNk2hkEhtCCGeJhhwKqZRIyKscIo4oiCdSUIRIQQlGWiY1ZX/CXW0AJRhokn/5S3/CnLFNVxIjwEakHOtDsE5VZBAUiYoUgjWaIodgOdpnJ/oQLLoERRbBfDtekUYw3YpV5BFMfYXKqT4Ek58xigoEE43+ihIEuXpfRQ2C8aiU9/UhyFRDxdaHYKQSLFU39SEYfg7W2tKIwHoKDko6EeSCxWZ1Irjxv+2qQvrlURq5IJzGpZE9wlFMGrHTQIyXFBCMvaeAYGinph8BYHQ/J1tKkR4xGWGEgBi0yCDFNvFSem8kRxrkq28hOUK/X68wAjhkZCE5YhMV99rgHc8ItzC38P9C6mm08CpRcW+5hRnhFuYW5hbmFmaEEUYYYYSAqM2fIFUNxlsncq4BOetEsp5yw83+ftlRrXhd3mWRLzcVEs2rfK/nEHX5se433aBNZmw1zKwAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-file-text{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAA0lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCLwGkMAAAARXRSTlMAAQIDBAUGBwgJCgsNDxESGhscHR4fICIjJCUmJygpKissLS4wMTg+P0pNUFRdZ3h5ho+RlKWmur7Ays/Z5Obv8/f5+/2SdDsAAAABVUlEQVRo3u3a2VbCQBAE0CQogjsBwX3HXXEXNIrJTP3/L/nigyegTCaTEqXrA3Ifku5TmTOe95nyE7LFy57gGXbITAbkDJZIv2WO9GwRYN8Yie0R7JkiyIHoXQICvUNAoLcJCPQWAYHeJCDQGwTERMmPQK8TEKg1AgK1SkBGKW4QqBYBgWoSECRNAvKT4g5BskJAkDQICJI6AUFcJyCIQwIyXHGN4H3BIdL9LrcOkSwZUyRgICEDeWQguGIgeKgFxSMj0xZEkN9FouVps1Q79six8Zj59shBzmGeMOSIgXRNz5n8cxlGQSYWeW0YbuHZG3vk1HjgS7Ig/xNCefGUT1jWiiB/HOlVTCvRxZiXO9nCmZATxk9QVCubZa4jwyiIIIIIIkhhyGEKeSsCSV81uCsCqaaQsADjfqAKXDo3XqYGC0c7ckqo69LQXlNZXHKWef/Lgz8AEq4GpDAt4LEAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-indent{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAh1BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDQuOtUAAAALHRSTlMAAgMEBQYICwwOERMUFx0jOz9GSlFSX2JjbG17hYiJi4ydqLnR3uDt8/X7/RuUh+AAAAEkSURBVGje7dnbToNAFIXhpdVKFUWt4hlUkFKd938+72WYqdmHaLr+a5IvEzIzmwAwxvap1blxK+A+mHeHrT0yIjhEhAiRv4IM9saAylwZKl517L9Xfbwf556pR+E+GULoM0oh3vEhZJVS54BMK0pIWtFCkooaklL0kISiiMwrmsisoorMKbrIjKKMxJVToTH5PokqnQypJ3NXfC2loALT4a7Pnvy/b7q6fuGAhFsP5NIBeXV4JwYGdjFO1jeCrg6wg3G4kW3Gtx9IG1vsmfBY+ULeUD4gW4f7pHW4GVuHO75xmFYah7mrcZggG4dZ+MVhqk8bCkiXNXD0KTM6LB+usyf1xdOzoMclGDOsKI0rgDqYV2O0R/j/hAiR/UL4/4QxxuJ9A9+JZ3IGueJhAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-italic{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABsFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCRaBZ7AAAAj3RSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGhsdHh8gISIjJicoKSssLS4wMzQ1Njc4OTs8Pj9CQ0RFSktNTlBRUlRVVlhZXF5fYWRobG1vcHFzdHV3eHx/goWGiImLkZKUl5iam52go6irra+wsrS1ubq8wMHDxcfIys7R19na3N7k5ujp6+3v8fP19/n7/Vr3HEQAAAKCSURBVBgZrcH5N1QBAAXg+55Z0kSUGpUMWrVTKS1SlDaR9rRo075rR1OI0XD/5Tqnnzp3HOa534eFOP87+/HZves9XW0tu7fUr1lZVpqIhUGAv4KwJJYoXZ7ObGk6dKqnf/DdaL4UkbxiEfKIJs8ivEYkKRbjNCLZwGJkEEkHi/ClBJHsffBhjAsxPdBcisWILcu0DuQ4txdt6QAOQRMLGu9rCOHDAh6tgxcLSMIrpHoJsxTVEZjVUlXD7ABVCLPLFF/h9oaiH24zFMdglqLaDLNNVJUw66QKYfaQYhhuExS3YJakOgyzOqoamLVRJWA2QPETbmMUd2CWpDoKswxVDczaqeIwu0+Rhdsvin6YLaE6CLMGqmqYnaQKYfaY4hPcchS9MEtR7YDZVqpymJ2lmIbbS4rHMAtmKDpgVkGVgdkuqjjMeimG4faB4irMQqommKWpKmDWQpGH2w2KJ3DLUnTCLE5VB7NaqjjM2ilG4PaQ4hrcpiiaYZaiWgGzRoqZAGbnKJ7D7S1FF8wCqgaYVVElYbaf4gfcrlPchtsoRSvM4lTVMMtQhTA7QfEZboMUfXDLUeyB2TKqCphto5iGWzfFINyGKI7BLKSqgVmaKgazFopvcLtJcQVuWYo9MEtQVcAsQzEbwOw4xXu4PaLog9s0RTPMqqhWwewMVQxewQ+KHMz2UQ3BKzlJ9QJOiY4JFvC1BC5Lm59wLt/vdjZWhlic5NaLI5xX9l7X9kpEU9s9zAV7gEiCWRbhAiKpZDEOIZKdLEYdIunmf/KT4xO/pnJ5FpZEJG/JiaH7lzr2bkyXJUL8JwjCWNn6fReeTvKfcUSTigeYX0n52vr1q8uTWJA/hGHnz5A/HK0AAAAASUVORK5CYII=) no-repeat}.vueditor .icon-link{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB/lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDeqZzvAAAAqXRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExUWFxgZGxwdHh8gISIjJCUmJygpKiwtLi8wMjM1Njc4Oz0+P0BBQkNERUZHSUpLTE1OT1BRUlRVVldYWVtdXl9hYmNkZmdoa2xvcHFzdHd4e3x+f4CChYaJj5GSlJWXmJqbnZ6goqWmqKutsLK0tbe5ury+wMHDxcfIyszOz9PV19na3N7g4uTm6Onr7e/x8/X3+fv93k/zXgAABLVJREFUGBm1wYlDk3UcBvDnPThkHMNClMjCA7MwTSo7lDPv8IK0uzTRwtSoRE0IL2Cilooa5yaOY89/mTJ43/e7vdu737vx+cBdydu7j393Ym9dGZbLym/DXDJ98lUsg9IrlHqDyLUDMSY5gpzSe+jmqo7cMW7S3S0DuWIMMJUBA7lhDDK12zpywRhkOrd0ZM8YYno3dWTLCNHLDR3ZMUP0dl1HNsw7lPprDOjV1yj16/DPHKbUhrgDlP7W4ZcxTKkFS1oo9enwR7tJqRm23ZT6NPhyllITnPZS6tXgwyZKTZD2U7qmQZk2SqERiT6ndFWDqg8oNCDZIUpdUPWATrvg5gilHVATpNNOuDtKYbYASj6hQyNS6aDQBSVdtJ1GascpFEHFEG15SONLOh2Cikla+pHW13QYgYo5Wn5Bej/SoQAKpmm5CA8h2t6AghFaJuFhE207oOAybRuRnknbASjooG00Dy60QEBDHG3tULCeDvdMJMo7NUvyQiFe0GlrgwJ9jg53TUjFY1wwvRZAFW27oOIsne6acNIecVGsFuimbSNUBCkMm3CopyVWW0+HYij5mcIdE7bztMVitIWhJm+Swh0TlutM4XsoqqYUMrDkPFOogKoPKQ0ZWNRKd39DXSulIQNx+ihdVcCHVkqDBuIq5uniB/jSSmnQQFzNPJMMafCnldKAgbjXZ5ngST78aqF020RcJxM0wCm4ufnwsb3bV+vIRAulkRq8UPQrE8VqsaTqzHMu6avX4K2FCcJXu/+hi1gtFqwZoBBugLdmZihWC0A7zSR3S+CpmRmK1aJgmC5mNsBTMzMUa3hKd+/BUxOztg2empi1d+GpiSmMjjFDdfD0Pl09LAyMM0PvwNNrk0z2uwEExpmhzfBknmGCqa14KTDOzMTegreyzlnaHn6qIS4wziS/VZl68WfTFGIbkQF9Xfvlkem5ydC5neWwFY8zQT0WFN6jEFsP31aMUYptRpx5n8J8DXwyRpikDnF5/1KYfxP+9NDFBsTlP6QwvxZ+bKebaBHi8h9RmKuGOj1MV5ewqOAxhblVUNbAFAwsKnxK4VkRVI0whVIsWTFKIaRBzUqmUgxL0RiF/VDTQIc947Q8h0Nggk5zeVByjrajKJniknY4lUzS6RiUhGiZ1YGyCcaFNAilU3SYgpIpWi7ihfxrfKnbQIJghA6roWKelq+woKqxo7EcyV6ZpW0fVEzT8hPS+4i2C1DxiJYHSE+L0nIfKnpoq0J6f9IShop22h6bSKuTlnmoWEeHIQPpXKIlDBX6LB0GDKSmzdByH0o66XRLR0qttJ2HkjIKN3SkUBWjbQ/UdFLo1+Fq9QwdKqHGHKfQp8FF5QwdJqBqTYxCr4YklTN0aoOybZT+0pCgMkqnGRPqPqZ0RYNQGaXQBD92UurR4LAqSqEf/jRS+kODZVWUwlg+fGqh1I0lFVEKkVL4tptSt4YF1VEKkXJkYR+lB1vyoK08SSlSjqwcpLdIObLURi+RILJ2mOlFgsiBo0wnEkROdDC1cBA5cpyphIPImRN0NxVEDh2kmycB5NSGZ0xyyUSOmZ2U/qvDMij6YoKW3i0alknp1sOnus5+07DWhKv/AdvpqR4pUmbtAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-list-ol{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABfVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAcffURAAAAfnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQXGRoeHyAhIiUmKCkqLS4vMDE1Nzg+QURFRklKTU5PUFFSVFZXWFlbXmJnaGxtb3N3eX5/g4WGiImOj5GSl5ianZ6gpaaoqquwsre5ury+wMHHyMzO09fa3N7g4uTo6evt7/Hz9ff5+/2+M7R2AAACj0lEQVRo3u3Z+VPTQBQH8JeUEEtqBVEUULxb6gWK1gMFEbwQ8VYqh6Ki5RKkSAu0+7c7yW5Ca6DOyPtG6+T9tPuYyYc02euFSIU+Juy4T8CIvBdwpP6rgCMN8wKO7Psu4MjBHwKOtG0IPJIQASB0zr76MPrBXxNiSoO/wv0TOuEHo0YBIPQ3kcYDu4/G3yBjgiMyVZE9gieqIlZNIlqI/EtIlx1XZH/a6RxlRzR/djhE/gAxgkCoZ42ByPdQGGH8F6GduPc5V5h7fSmGM7pXvaHzwsQQ5seKAdoOMRYqp4HNFgAy/etkM6dhTifOHXhKgh2pG3UufDdKWqookaeA3+tkToiU07ohkVn3L715hql+TU71xrM78qItMl0g9kWrLI7I5DxsL2xHRiZHkMgDlTyGQ4wJlZvBHR2O51RqPY5CIo/cTLEdteE+tOQmCq2oXf1Vr//BQh0d+r3BeZZQR4e023liEAppLqm3Kmmvw4ft2Mt+xP4iW0vxrX9+UN3KOxZjnKhDNZvJj7CVPUak8ZK2Q7hiZZsb5EZ0EQBiBIFoQSC0GARyqssfreHpIIwaCv+8afIXn/1j8ZZrTLIVn3dGGFfGnRGr5pFuELIct6JmLOu0JzUQsmAvLXJzsmgQEHnjtDb2IzZ3lh1RogGZOYP8tHFaJvqQtXqr4PRfIT8IaDOq5NFbj0OGvEzxQvXt0i6Q62W5rcfCXHyuWy9Ld6BWlcvjU8sukkUuX9aoUpqgq+QniSShiHr+FxE/k9fqk0gnvxHbHNBVXeKbRNoglc6VdJNORmJWGqUIu3HTN3ye82+7fEbRYkdu+5AU4N06X6oscHdCBkfDwzLjrYUag2bycTYvxGomHUd/Q4Fd+Se9zbVMYAMuWgAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-list-ul{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABFFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCdUZl6AAAAW3RSTlMAAQIDBwgJCwwREhMUFRcYGRobHB8gISMnKCorLi8xMz0+SUpLTlBUVVldXl9hYmNnaICDhYaIi4yRlZeborCytLe5ur7DxcfKzM7P0dPZ3N7p6+3v8fP19/n7hn7oSQAAAdJJREFUaN7tmN03AlEUxU/TiCgzUYqK8lUkhISQQRKDhKL7//8fHkxfM1cvc+61Ws5+3D38VmtmztlnA5BIpH8nNVW+/3ip7OjiEN79DrNkaIIYUyYb0KoYxjsb0nb/p4nEsntFAcBrMpuSPUabYegIoOAwXxULEkdhsC9QO043Y0ESOBAGKY5pYkPOeK4PGVLnuRoypMVzY8iQBs8NI0OueK4fGbLLMdseZEiIY5awX2G4dpoBdIjm8I67syuEw3gAgHWbd6f0pvDmpeFe534AgNwQo6qK2VrJZp9RVETtXyX79PPuloJCo4RPX4z4PRSpSGMrnxYLi32FlYxpfYwBYQwZY0XGgLSP+mr/v2SNW/e6mOYtrWKXMYeztB4BDAnrV5cRJPIyIlFFRriTElOlBG4pp0NZxhGUlnHOSTlMOSd2szu8lrBO7FFlgYpTFhxyao/cQHm0lHCvBU6BsyaqiiqIr6IAQE2X661GJa9ToiKRqHwWWj6jTOHI6PJZbaHsk4OR5TPaZqTymcrnMS+f9/6qfD5Bz8I3TjOIDgn9evwi3vGwYfNqAhoJsD37mqDyeeVt4KELK5+9W8+MMcY+T2eFRonJ+Xh0hspnEok0HvoGC+ShTC/TNBUAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-outdent{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAhFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDbLQvCAAAAK3RSTlMAAgMFCAsMDhETFBUXHSAhIiMtLi8/SlFSX2JjZm1ze4KFnbng6O3z9fv9whZhOgAAAStJREFUaN7t2V1PAjEQheFBYYEVgcUPXL9AWai1////aQRkW+ZuOI2R817OzRNC2k6yIoyxc6o/AtcXeQrwHuUDjzgJGSJChMhfQRq80UgFV5qKTx37fz2sl8mkdqc+J8/f83E0KcwnXjPCTTQqzXeXZoCRrYFFdgYU2RtI5NcAIgcDh7QMGNI2UEhkgJDYSJCB0XCqkSCysiG1aqSIDEpDhW4cIfbqgEcuQwak4zIgMvUZEKl8BuRYSZDe/dzQXUdXYuRiYzuM7/pviZGh8Vr51P991FUfKbBHq63gnt+WAlwkJj4DclCgy91ewa6pOwW8cI99BmSrzMDIjzKMnzVvM1bKnXz1eptMrhdvhl66whiwogRXqEvqqavF4RF+PyFC5LwQfj9hjDG9L/DQVRC18NMlAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-repeat{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB2lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDAOIh1AAAAnXRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQWFxgaHB4fICIkJSYnKSorLC0uLzAxMjM1Njc4OTo7PD1AQ0RGR0tRUlRVVlhZXF1eYmNkZmhpbG9xc3R1d3h5e3x/gIKDhYaIiYuMj5KUl5iam52eoKOlpqiqq62vsLK0tbe5ury+wMHFx8jKzM7P0dPV19na3N7g4uTm6Onr7e/x8/X3+fv9BUTaEQAABAhJREFUaN7Nmmlf00AQhzdtoFBuquJRFEQERSii4IECAlYOgcqhUm7kFpFDLkWuiqAchQLaFva7+gJESHaT2WzSn/+Xs0me7iazM7NThIAyJ6Y/dQ9NLW0F9lbnRruddy9FIF0VfqPuB5Zrv6sgQSeCtciD6dp3XeQmmHImsJq8L2K5lsnpxyD1UabjGJurjlRERNQcYLBmUghPeIMxxgfJCgtVdYiZNBIvfUTr0YBPoDGyvJhZdeKZR7T/tVPWMmoca5Ev9dQzOk/M6URGth9rVP3J0nT9M2aQ3kYz1q5vx+7ZjRUhVg/mUSAFISS8w4oQ2w7m1CMk9GBFiN2PuVXbixUhNw+x/pJA7EYwJJBzKmsV/NLmqigpq24YWNMMifIpXLlcdc1y6lohxtG0rQFiWqFetlZkJTltUvU+K6SddtHYZfo2WrDGBLlPQyQpB52CXTgkLki8YOuWeopRC4ZME8dbTJAImuyFQfKI+1AuME6LIxCISFrYrXh4OtAAgDSSdm2W7E1YVYVEE4Y8IgujR30mb+Ujm0zz6FV/J5HyAT9Lwib0Ab6uV/KBLBZGP8BPwuQbfBMLYwDijA9k5nWTjowjyLzMfJ2BMQjaIBNk1iEGxhBsF66QWW1wSD8wnqxLjQNwxkNg0LLKjBfgkGkgJFsWzRk+3xkIJAUht9T2mAFSAoFYENoh2MAyA5LaCoTCpLY5prIy5rMKIliCEDovtT5nrF4tCYkKijMhhNAdKeQK0l9lUkiYAZBOaSAxgIGGJZApIyCzEkirERBplu0yArIjdx39JT0/KTUC4gvFTELyTkLydX0IhZ+ExONDsneFZBfmjicQcUZGjfsKDjcAwpWtQJUjhSwZAOHKIMHa4MiFwarkyeqhktcngwZMZYGn0tJeZLDUjFCnl1e/jRp7OmynL7c1IMRPeDyMwVXYTiSOa9RJjPESnUJoAWwwd/iOwt8ilRLDe0qEEKo+vo9OeU2iMM2l/uS+BdqvE/f4Tu6EUz0ZOoV4YOvPATIiJs/cR6WQi2U3yCszf0lum6dQaOfCmepFY5v8Nholn1K+jiqHF1Mp8dd9pTQXO2hV8ij9rN5STGs9pFJ+03d61+EJqesg2Dvo9TstJkUr9U8WK6+eTmPMtnu9Sq1hJ3Xyap2gwGxrnbO4vKZ5YFPlHKJB4S3q1dPqUvxW9OnODQvKH70efcY+VQ/m75jWAvaIKL7eLy6EBWo3B+J3GnTjdgS0Mj4yxKDoCU2IIGNBkL3NzpiKYU0LzC8ZEcua0s5IF4NnbuQijbJUBYH/jMgXODJYc576Qflhp507U45+tqJE6HeISBdZMurXCYCDqXK7vum/aMsobnk/7fEGA7s/Z3rrCtNiBfQ/6Q8OCt9g8MDarQAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-strikethrough{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABv1BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAhme5xAAAAlHRSTlMAAQIDBAUGBwgJCgsMDhAREhMUFRYXGBkaHB0eHyAhIiMlJicoKissMDEyMzQ1Nzg5OzxCQ0VGR0lKS0xNUFFVVldYWVtdX2FjZ2hrbXBxdHV3eHx/gIKDhomMjo+RkpSVmJqdnqCio6WmqquvsLK0t7q8vsDBw8XHyMrMzs/R09XZ2tze4uTm6Onr7e/x8/X3+fv92eXofwAAAzRJREFUGBntwf1DE3UABvDne9tgA8w5IjMwBCMTTQw1Z0VkJALpEmpiVpSQ0RuUSwtdvkC2Bm66secPtrG72+3lbve93fGL+3zQ0vJCEYFg556uoAJvBF5/bz6xRVXu9vULx3v8cNO+C3+ynvXPj4XgCuX0PVp4MHVAoEkimmYj2bhAM3qStGMfmvAR7XkHjokvabA89lrQB4hQ38TfrBKDU2KRumeTIRi8fIMVVuHUAnUrIVTpe0SDp3BokrorqKV8R4MAHBmkLo66Zlm2F074UtTcF6jvGnWH4MQV6vpgQiSpOQkHOqh7CFOvUDMOB+aoOw9z16iKQZ6So24A5kJULUDecZZFYCHOkhXIu86yPbAQZkkS8jIs64WVVe74F9I6aBCFlWHuyEBaHw3+ghUlx6JNSBuh0auw8gWLEpD2Lo3WYCXQP3z6/KVjkPYhK8zAC2dZ6RQ8cIJVzsJ9B1ntKz/c1s4amTMCLttkrdQZH1w1x3pylyNwUT9NJD/ohFvEFk2tjUfgjo9pJR3rhQvaCrSWntmLpn3KhhInBJrj22JjmakgmjJCOwpzQTTja9pSmPbBOd+oTW8JtLhpKEWPpYaQoudS4C4AdwG4C5Ch557gHD13DlACHlPQ4g/XJeCqyNUCa4XhsuDlbVYbhOtCC6xyEh4YzrPCKXjhQJ5G78MTQzSKwhvTNBiFDF+gPdTZBRvEBsuOQsYSizphwyjLeiFjiUXTsMFXoK4DMm6yKKvAhl+pE5DxO3eMwIYYNQlIuccdd2DDJDWTkPKIJd1obJaafkhZZ8ksGvuRqpwCKQ9YkvOhEbFNVRxy1qi6iEYGqDkIObeoCaOBFaqSkLRKzX0Flg5T8yYk/UzdIqz4U1QtQ9ZPLJuHOfELVek2yFqmwbcCJsQ3VOX3Q9pNGt19CXUFb1G1PQh537PSTAA1lLE8Ven9cGCJVfKxCCqEZ7LU/NYOJxZZa33qjQ6B/4muI5f+YdkncGaMJrKPN7KscDcCpw4t0ZZMVKAJ/iPxJ2zg6UU/mtY9/gfNPYz64I62o/P/sY7bE91wVWgg+tmNxMZmrvBs6/GdH65OvN2joKXlhfEcTA1TnELds/EAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-subscript{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABrVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCngLnmAAAAjnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB4fICEiIyQlJicoKiwtLi8wNjg5Oj4/QEFCREdKS01PUFFUVVlbXmFiY2RmZ2hpbG1vcHF3e3x+f4CDhYiLj5GSlJWYmpueoKKqq6+wtLe5ur7AwcPFyMrMzs/R09XX2drc3uLk6Onr7e/x8/X3+fv9ZIA5OgAAA6FJREFUGBntwftbFFUABuDvDLsrSwQrgrdANCVLKzLILpN0UYPK6GIYHkLT8LpopcQmRq0I7uay398csLsz58w5w8zTLD/0PPu+aGlpafk/chl0HjYvVqmTiM9lULUbFrcYIBGfS8MdmN5kkER8Lk3DCEqtMkgiPpem1RQCvqdBIj6XFhehO0iTRHwubQ5AJRZokojPpc1DqM7QQiI+l1YufNkKLSTic2n1vB2eOdpIxHfqQd1Tan5Cw0lqVh7UfIn/ILdOzXHUOEWqnnciCZeavxxs+ZqaESRzm5pxbOql5joSypap6caGX6haSSOpYWpuADhNzRCSu0rNINIlqr5FE6RXqFoQl6gqOGiGIWqmqKr2ojm+Y7iP0STOY4a5i6bZzxDlLJrnHO2G0UTiV9rMoqm612kqptBc79N0GM12i0GTiKPtlbPXC2uV5flrnxxqQ4T2EnVLAtEOXaHq8h5sSxSoq3QiSm+eQXMZbOMcg/KIMEGLp0MI1UfTGLbTdod2owghfqepmkO4XQsMcxx2n9HmN4Ew6WWGKmVgs5d2ZxFC3OY2pmEhFhmiD3avc1sdME0wTEHA7gN6KrNjp96bLlExBsM+hvsKId6ockt5zMEm53P68ggSBaquUtOPEANlbrjfgYa36BMI+IKqmfQaVcsOQux+Qv4s4PuBnix0+6nJ4R1qLiJMtpAXUPTSsxsa8QdVUwAWqTmGMKk0VIKeXmguUFVKAzhCzZMUYqKnE6qD1Ixg0ww1EvFk6UlBIR5RdQ9bMiVqTiKWd9nwN1ST1PSgZpSa1TRiaCuyYQqKl6i5gIY8NdcQw4/0DMLnLFFVdNCQo24YkabpWcKGT2/WPKTmBHzj1JRv1iCMI+l7DRskbW5A4SzTBiH2PqZvDpskLSodUB2lDazEBBUraWyStPgIuhlawGbwTyoqfdgiaSoI6DIlmmAS31BVeRk1kqYBBI3SBEPPIlVr/aiTNEzDlKcBQSPrVM23o0Ey6FkaphwN0InLVK2fgU8y6G3YjDMIml33qbrXBYVkwDysnGUGQLWnSEXpNDSSAT2wO8oAKA78Q4XMYAd0lekrDmEnOI/ou9SGHTFJT3UEO6ObntV++Abq0AxX2PAsB5/DOoHk2uk5BoXDOoHkPmTDLFQO6wSSu8uGfqgc1gkkJujpzqg6WSeQWBejCCQ2yCgCib3KKAKJnWAUgcQOM4pAYvsYRSCxFxhFIDHBKAItLS0tLXb/Ambs7yvKBRLiAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-superscript{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB0VBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlB928pHAAAAmnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFxgZGhscHR4gISIjJCUmJyotLi8wMTM1Njc4OTo8Pj9AQUNERUZHSkxNTk9RUlRVV1hbXV5fY2Zna2xtb3FzdXh5fH5/goOFhouMjo+RkpSVmJqbnaCjpaaqra+wsrS1t7m6vL7Bw8XHyMrMzs/R09fZ2tze4OLk5ujr7e/x8/X3+fv9jtp5mQAAA6BJREFUGBntwftfU2UAB+Dve7bBuBQMUCmUJGcXL2lmWUmOrMxKwywLKzsGZJQaml2U8FIoF2MYMoR9/9rks7Nz3tvYau/5jefBhg1187If/DC1+Gjmt++PbfMQi63DRUq+zsC5Tb9SN5aCU+I0LRaegUMNf9DuZTjTMsNK+uBI0wNWtJiCE95NrmMITrzJdaXhxAmGVkaOHuj/pkDJEbhxmCVLAx7WJAYZuQpHXljlY783oewVhopwpWeJvCAQOcdQGq60z18RkHQx1AZn0knIBEMdiA1DLYhLE0MJxKWfZXnEJbHAsiHEZYyhLGLyLUNziEfiAiMHEIue+4xMIA7ep5Q8akUMsn9TloV73hBlq8/DvS3TlN3fDPfepuJyEs4lfqSsOAD3Wu9RdjsD93qXKPtQwL3nipRMZKDadUm3GzbJi5dUxxB5qsjIw9egy1G3mITFWWp8hFIPGBlJwZCj4UuYuqnzERpm6OFuWORo6obhFnU+ynoYWmhHZFsAyNF0C7q3aPBR9gvL5lsQ8RgQyNGiH6rGZRp8BDoZ2gKJx4BAjhbLDVCM0uQjMMiyzyHzGBDI0eY8ZH208BGYZVkHZB4DAjla9SIipmnho6SRoeYG2ZMMCORoNSUQOk4bHyU9rEYgR7t3UNa6ShsfJXtYjYCXDhykYqUJgZ+o2JcuSaLkVVYjEBmlYgwlL1LxFTRvsBqBSHKBip1Y4+Upm/Wg2cdqBCQ7qZgVeOwTKp6GbjurEZCdpeI9ABkqTsLQzmoEZN4MZcsp4BplNwUMKVYjoOih4gz2ULbaDhcGqdiap+wInBB/Ulag7Aoc6WRFhTRceZ+VvAR3btBuFA49sUKbfBIuHaZNH9wap+kMHEsXqLsr4Np+6jbBvUmqpuBeN3XvwjVvmrpiJxz7gqa/BJx6ljafwaVknlZ9cOg87fJJOLOLlYzClYZFVrQfjlykbIayQhOcOEjZRBcVP8OF5mXKsjhFxVE4cI2yq0BikbJiB+o2QEUbgENU3BGoU9sqZSex5gYVp1EfMUnZrIc1Gap6UZePqNiBkhNUzCdRh81UjCAgpqkYxv/n3aWs0ICyXqr24j87Pl5ym4pDiJyjojBegtr5tLkOSfIf2qB2Pm0ykO2lDWrn0+JjqC7TArXzaZrzoGpeoQm182nKQjdAE2rn0/AdTJM0oHY+dYVGmLpoQO186l6HzSnqUDufmuuw8uaoQe18ajpgt4MabNiwvn8Bm0Nr3ixTyeYAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-table{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAA81BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDKM9ljAAAAUHRSTlMAAQIDBAUHCQwPEBUWFx0eHyAhIiorLS84OjtAR0lMTU9QUlRcZGZoaWtsb3Fzd3iDhYaJjJGSl5qbnaCjpbS+wdHT1dfa5Ovv8fP19/n7/YwhIscAAAGzSURBVGje7ZpJU8JQEIQ7QRQUZXFfEHeDJBgBRcQtxF2D+f+/xgN5oYqMqRwYS3H62nn5Lm9mOlMBRKIJkaaPWaOA6crtmz92PbVWtSHjwPOZ1CsGCP3aZ9TWANL1WbUGAHu8DL+fAdLvzBD/Atj02ZVGhx+yApcfUkGfH3IEfoZvCOQXQ3aymYiyu8rt5qJuJhd21v1Zwp6/GYVc0pOsExYtpXTgXiHWDiEG/ZwR2N9M0/jDEIhABPKfISb9mJkIYiaEOBqZ9J3AXiBfUlCJV4+1h63eMY2IzJ5yPTvqGnaY012LsBt9Gb8CmTCIVyDLSV31KlVuek19TC0izg4hNt0Y7MAm+wH0wD1DrC2tXiACEcgPRyIrEcRKCHHJVKOrzUuRfEkp9nBoD+eJW69FVH8IN2PNqFtrhnuZx1PCbkkkEsjERaI8VU559XFwTMUVraoOk7Wqn0gkEohABPKnIR5/JDpEsKPp0VsitcEhezSK8ZFI2dto82+JlrDBP7SmkHrlZjQAlJkZHzMAcM4LWR5cIU7K55q6a+UXLsbd3PBGp9bbztj/Lni+t0ry64lIlFRfrJk1hGnKZcAAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-underline{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB+1BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlBP84/vAAAAqHRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIyQlJicoKSosLS4vMTQ1Njc4OTo8PT4/QEFCQ0RGR0lKS0xNTk9RUlRVVldYWVtcXV5fYWJkZmhpa21vcXN0dXl7fH5/gIKDhYaIiYuMkZKVl5iam52eoKKjpaaoqqutsLW3ubq8vsDBxcfIyszOz9PV19na3N7i5Obo6evt7/Hz9ff5+/23OreuAAAECklEQVQYGe3B+3/NdRwH8Nf3bGubtpndy8JiLrHt47okQxgrtiRCSBOxGZpRc8m1Cy0rhNy2nTXn9WdWn+8mHu/v+5zvG6efPJ8AJ4zevnahr2vfjvbWVS2r1qxr3bh5264vDvT0nr509be7Qyn+awQRHvEpw7euXezrPtjZ2XX8zNW7j/mPJoAWSUT4i+l1AKO0QARm8BVwjxaIwAz2AzdpEUAImMEGoHl3V9+FwVGmN/bg1sCFr7c0I0Ll9KnVFVNKSuv2jPFZj64c/3xRKZ7IrVk/wEgjHRU5iKfgB0543L2sKhcR5iUpjRQjvuBnjlsDjaPUCYtajgugyaW0AiaP6N2G7j6FuTA5Qe8OdJcoTIXJFnpj0PVQqIBJM0MBVHsplMJkDkO5UG2lUAyTWobKoWqjUASTMobehmo1hSKYTGLIQbWCQglMchlaBdUyClNgEjDUAdViCuWwGaa3G6rFFCpgM0jvEFSOQiVsztPrhcpRqIRND73zUDkKVbDZRe8qVI5CNWzW07sFlaNQDRtHbwgqR6EGNnUMQeUo1MCmjKEAGkfhDdjkM5SAxlF4EzYBQ3nQOApTYTRCrxAaR6EWRgP0iqFxFGphdJpeGTSOwlswOkSvBhpHYRqMdtKbBo2jUA+jNnr10DgKjTBaSa8BGkehGUZL6C2CxlFYC6NGeu9B4yi0w+gdequhcRR2wmgOvVZoHIVOGNXT+xAaR+EYjOrpbYbGUeiH0Ux67dA0UbgMo3p6HdA0UhiE0Vx6m6BpoPAnjBbQ2wjNPApjMGqitw6amZRg1ExvJTTTKCVgs5beEmiqKeXB5hN6DdBMplQImy/p1UFTQKkUNn30KqHJoVQLm1/oTYIqRWE+bMbo5UB1k8L7MMmnl4TuOwrbYVJH7yfodlI4A5OP6e2HbiGFEZgM0GuBroRSIQyKGKpCGiMUFsLgU3qpAGn0UjiJ+IIhev1IZzmFVAKxtTC0HOnkUVqBuBL3GcpDWv0U7gaIaRtD3yC9BZSWIp7JKYYqkMENCsOvIY6cXxk6hkyaKJ1FDDmXGXqYi4yuUzqMjCZd57hZyKycEY4ESG/+MMe1IY52RrhShDTyT3BCJ+LpY4THHTlQ5G1IckInYgq+Z5Tk9nxEqDmc4hO7EFviDKOdX1qApyTKFh0Z5n9S78JiOzUPe7d+sKRpWUvbvlO/81k3qmEz+x6t9iZgldiRosXZKXgexV2M7dx0PK+Cz5KMIblvMl5EMLt7lGmNdtcHeGHBjI/6k4z08NSacrw8r89Y3H7w3I/X7wylRh/8MXj5+J6NrioXr7zyyktTuP/brDq5KQAGmG2tCJh1PQiYdUcRMOuOImDWHQWYdQeAg8y2WQCmN2ZVQwn+F38DDZqb+BiFAtMAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-undo{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB5lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlB+ErW0AAAAoXRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExUWFxgZGhscHR4fICEiIyQlJicpKissLi8wMTIzNDU2Nzg6Ozw+QEJDREVGR0lKTU5PUlVWV1lbXF1eX2RmZ2hpa2xtcHF0dXd4eXt8fn+AgoOFiImMjo+RkpSXmJqbnZ6jpaaqq62vsLK0tbe5ur7Bw8fIzM/R09XX2drc3uDi5Ojp6+3v8fP19/n7/f29yYMAAAP4SURBVBgZzcGNW1NVAAfg390duFCaSqJWwkohFBIQMJPUDAyN1ELTsjQ/MnVWMFKoCE2PSmbogsptApfffxrfsHPPvffc7fA8vS90ReI1h7+8dWdkbDI7+uDn3rP7q8osmGQnTtyn2/RPRyotGBHdO0RvU711Foq1q59Bcl9UIlDN9w8vr4VK5OBf1PKwDv6ucUbudbjYx3PU9rgJPlo4Z6oKkv0ZhvLndnj6gfOmqrFS1QhDS70ED/e5wElgSeQyC+F0QU1wkfMGFrzyhAUaXgMVwSXOm5hzlIXL1EJBcJmzA4B1k0XpgZvgCtM1KLnLIl2zIBNcafr9URbtdgQSQfOEjXyCq2DYQh5Bfc6jG+c+Odr92cVUmv5SyCOo5/GZnTEss+LvfpejtytYSVDD6LE4FBLXHXrpwAqCgX6thRf7yHOqTVdimWAA8Sr8RA5lqZS2sUTQ1/NmBIlepFIflgj6uVUCDVvTVGnAIkEfH0BPtI8K4xEsEPQ0sQPaTlKhBwsEPR1HCAepEMc8QW/NCKGNbr2YJ+ijCSF00m0D5gj6aUIIZ+lyA3MEfTUihLt0WYdZgv4aoS+WoewrzBIM0Ah9zZRNRDBDMMhu6BuirAEzBAPthrY4ZQOYIRisBtquUhYDIBjshQ1d5ZS9A0BQw05oS1KSBDBEDbugbRslOQAnqaEU+sYo2QiUjDNQD0LopuQggLJh+nM+RRiVlFzErNhGPy9HEIo1xXz3sAr6mW8Sq6CLklKYV0/JJphXQUkC5pVSUgfzbEpaYJ5FSTtWASUdMM+ipB3m2ZS0wLxSSupgXgUlCZhXT8kmmNdFSSnM62e+SZhnTTLfPZhXScklmNdNySGYN0bJRhi3jZIczEtSchPGlVO2D8ZdpSwG0+KUDcK4IcrehmnNlE1E4MlCIWIZys7DS1Nu6gAKcIcu5fCwlzMaEdoZuiThoY2znC0IqYNuG6DWynnP4wiljW4pqO3hoswmhPAeFdZDqZnLJhPQdoIKp6DUyJWmO6DH7qXCeAQquym5XQINW9JUaYBKA13+aUGQ6NdU6oNKNVUevAY/1oEMldI2VFJUG6yBF7vzX3qohNI5ekl3lEOh+ppDL51QKxmlt2ent5dhmRXfl8zS2zfwUvY3fTkieaHn6EenL/Q9pb9+eFufpRF3LPjYPEUDhA1fW7Ms2kAEAdaNskjXLQQq+Y1FOQUd1g0WLvMWNO3JsUDDMWhbM8BCOMcQSvsLhvZjGUKK9jgM5WktChC7RH1PWi0Upvy8Qy2P6lGE6OHfGWTi/FYUq+L4H/Tm9NdbMGJt65U03aZ/+XCzBZOiW1o//nZwZDzr5J49HEp93l691sL/yX+u8yfUO1Z3xQAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-unlink{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAACIlBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDqg592AAAAtXRSTlMAAQIDBAUGBwgJCgsMDQ4PEBETFBUWFxgZGxwdHh8gISIjJCUmJygqKy0uLzAxMjM0NTY3ODk6Ozw9Pj9AQUJDRUZHSktMTU5PUFFSVFVWV1hZW1xdXl9hYmNkZmhpa2xtb3Bxc3R1d3h5e3x+f4CCg4WGiImLjI6PkZKUlZeam52eoKKlpqqrra+wsrS1t7m6vL7AwcPFx8jKzM7P0dPV19na3N7g4uTm6Onr7e/x8/X3+fv9SNvqbwAABZtJREFUGBm1wYt/1XUdx/H371x2hQHOmEmCLWnoBARJLC4SMQNLTSOTWE2JmzDYhKGSSWDyM34pBBsR6BQmOEAuu5zX/9dvt3N+n/P7ncP3HB97PvU9tZz/pF7VqV3+10+v3bk9ePLN1pTKGoSjqsaS0xSMdTepDCBQ5eYFFNmbVklAoIptGCdmqFmlAIEq9RZJxlpVAhCoQgdJlmtTMiBQZQ5SSu4JJQICJfHme0rUTWm5ViUBAiVoHOK/nhIcopzxx5UACBTXcANoUdwhyht7THFAoJj668BIVjGHeZCxRYoBAhWrGwLGlyimB+vm7k0dR0cxRh9VMSBQkdqrQK5VMb1Yv/cUyp7AGH1ERYBAVu3XQG6pYnqxVmlaL8bIQllAIKNmEMi1KWY/1jPK68O4/7AMIFBU9gtCTyrmRayVingf416zooBAEdnLhJYrphlrhYwPMe4+pAggUEHmEqFVihvAWC7LO4FxZ4EKgEB5mYuE1ijuKYynVcw7hfHdfOUBgWak+wn9XAn6iWpXnPcJxu15mgEEmpY+T2iDEswlql1JPB/j1lxNuwYfaErqLKFNSrKRiHYlSwUYw3M0ZcnQxSZNSn1GaIsSHaOgQ6WkPsP4tlGWd4bQViW7TN6gSkudw7jRIGMdod+qhDHyXlcZ6QsY1+sVtQX4nUqhYJXKyVzEGKpRRPrU8C9VEgXPqazM/zAueHJ1j7zdKi97BWO3XJ0j725a5dUMUnB/MGiQo70UHNUD1J44tuvVje2LmxszniqwnIguzY4sUZ2aHR8S9SdVr2WQuGs/UqgF44+q2nmSXNWEv2NsV7V8kgxoQt1djNdUpYa+IO54kyYtw3pFs+E3WC+pMulGOdiB9WtVZMHoejnYibVFlVgEe+SgE2uzKrAMOCIHf8F6Qe6eJ/SuHHRhrZezl5jQIwe7sJ6Xq04mHZKD3Vg/k6MepnTLwR6sZ+XmFNMOyME+rHo56WfGO3KwH6NGTr4lb58cHCAqJSdE7JWDbgpycpIiarccHCbvupzUYuySgx5mnJeTuhzG23LwLtNOys0yrC45OMKUw3LUjvVnOehj0k65WoHVKQfvMWGrnK3G2ikH7xNaK3fPYe2Qg+NAmyrwC6w35aAbHlUlNmK9IQebxxaoIpuxtsvBnIwq04HVodmwDWupJs3p8+N66lSllzHu1GrCAElOqVqvYXygCUMkOauq/QHjBwo9PkTcYIuqt4Oov2l2dBKV0ezoIqJdFfAyDc2L2ze88nbfiRo9QB8Fe+So4cyX9yn4Mqvy0nfJ+1yu9mFcyaq8veTdkavUAMaljMpaS4FK2jR8Mq2I2usYFzMqZzUFKuVl4FeKariBcSGtMraTN6oSthFaJ6NxGONcSqV9Rd4lJesgdMaTNecmxucplbKVgj4l2kzo3ylNmtN/bbGmNN3CCFJKtoKI9UryAqGzKU05BkOaNu82xqeekqwgaq4SrCf0n7Sm+YBmzP8O47SnuJVE9SvBWkIX0prhA8pbcAfjY0/FnsF4SnFrCA1klOcDKnjoLsY/PFmrMAYUt5LQpYwKfEARzfcwPvIUtRqrWTFPE7qcVYQPKOrh+xjHFfEs1ouKeZLQF1lF+YCMhSMY7ylvDdZ+xbTlgMEaGT4g65ERjCOatgarVzFLc8DXtbJ8QEV+OIpxslYh73WsHsW05oCrtSriAyq2aAxj/KNXt71zE6tHMUvGgaE6FfMBxTw2xoMcVkx2BPimXjE+oLjF45R3SHEtwI0GxfmAEvx4nHK6lcC7yLVGJfABJflJjtK6lazJUxIfUKKf5ijloCrjA0rWliPZAVXIB1TCE+Mk6VKlfEClNH9DzPg6VcwHVFJ6H0X+1aTK+YDKaDo4SsE/F6savTCoslKtb5y4Mnzrq9NvtdeoOvUfn12o7+n/kiPdwBPnoS8AAAAASUVORK5CYII=) no-repeat}.vueditor .icon-markdown{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABMlBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCgtID3AAAAZXRSTlMAAQIDBAYHCAsMDg8QExQXGBkcHyAjJCYoKSssLTEyNDc4OkBCRUlKS01OUFFWWVtcXWFiY2Roa21zdHh5gIOFhouUlZqiqKqvsLK0ubzFx8jKzM7P0dPV2tzk6Ovt7/P19/n7/UKwaqAAAAIQSURBVGje7dlrU9NAGAXg07QFLGi5KAUURUBAUItKW0XFgiIXlZulUqTaEs7//wt+aMJsk92aOL7FGfZ8S862TyYzuewGsLGxsbGxsbmK9BX2mxSIe7x6yzeeUDCvW0aRotkAgDEKZwFARRr55SBD8eSQk0fmMCmP5C3yvyNDSh6HBm+rtVq8MBVapO22+S4w9qxHbdVm0lT8GXEO28fegQCCzLnavYQIgodKtQshBGuXTb1HDHG++c0oxBD0u62iAEEE0yTJzxBFUCZZ7xVGnAqZgzCCAbcIcQSjiS4g+ljk+iK1qpdxtfB3VhsRkHuh/50KIEsdj6L3ZwQkXwxdlcGzcrMTsh3ldOU50fajZJVBpOKYjaeMhjT61O0PDCF8YzSyjIhwXznSRWoQjhmM5ElkhO8vt4apRc7SemSd0RHOeBvpH3qEm1pjinGQC2/2ukMDwke62XQzFsJaCgBKNCJuf8hIfGU8hJsA7tKMcC/0uCkwLsJnuNHohLAUMEYYH+H9A3ZEeLvNSJ3+DaKvld2nKbX4SBGktejgZZZCCKdDr5wCSNO/yyUOKYbwi7d3lYIIn8O8GBRAskrWwqPVOtgNAkjXhafYJw7wSXweX8ZSFxYLXl2HZY8uLKrNY0AeGQdq0oabBB5II8u61aB/nK3W43lF0ij7rwCZ0pHIB4GL728H7ecWGxsbGxubK8lvwLSCdxTXckYAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-fullscreen{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAdVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlBBOUZoAAAAJnRSTlMAAwQFDxIUISIjJTRCQ0p0dXd4iYudoKK5usXHzM7Z2vHz9ff7/axzRNIAAAC8SURBVGje7dZJDoJAFIThYrQBxREHcGDs+x/RBdHEDXHRZdTUf4FvV+8BSv1+SWlJlcnDWFliy9HYWWpbAMgtuRzwGzbS+FhYenMc+MgeNz5yxcBHBtgPJESIECFChAiZQGI3z3UsRIgQIUKECBEiRIgQIUKECBHyPpIGTkonEU5CvhCp+UaNio9U2PCRNQwfMcCJbRwBhC3XaEMAMB3T6GbjZkYXnnGOntOcFT1D6Ivs9QR4gfM8KPUf3QHmuxw5jd/C9wAAAABJRU5ErkJggg==) no-repeat}.vueditor [class^=icon]{width:16px;height:16px;display:inline-block;background-size:contain;vertical-align:bottom;opacity:.8}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/node_modules/vueditor/dist/style/vueditor.min.css"],"names":[],"mappings":"AAAA;;;GAGG,AACH,eAAe,cAAc,CAAC,6EAA6E,SAAS,SAAS,CAAC,0BAA0B,gBAAgB,SAAS,SAAS,CAAC,YAAY,WAAW,oBAAoB,CAAC,aAAa,aAAa,CAAC,gBAAgB,eAAe,CAAC,cAAc,cAAc,CAAC,UAAU,gBAAgB,iBAAiB,YAAY,aAAa,sBAAsB,sBAAsB,gBAAgB,sBAAsB,iBAAiB,CAAC,eAAe,eAAe,OAAO,MAAM,SAAS,QAAQ,WAAW,kBAAkB,CAAC,2BAA2B,OAAO,eAAe,CAAC,WAAW,iBAAiB,CAAC,kBAAkB,WAAW,YAAY,cAAc,iBAAiB,CAAC,SAAS,kBAAkB,eAAe,CAAC,qBAAqB,qBAAqB,QAAQ,SAAS,sBAAsB,qBAAqB,mCAAmC,kCAAkC,cAAc,CAAC,kBAAkB,sBAAsB,CAAC,gBAAgB,yBAAyB,CAAC,YAAY,WAAW,CAAC,qCAAqC,iBAAiB,CAAC,cAAc,aAAa,kBAAkB,CAAC,wBAAwB,MAAM,CAAC,sBAAsB,gBAAgB,CAAC,QAAQ,qBAAqB,SAAS,iBAAiB,kBAAkB,mBAAmB,eAAe,sBAAsB,WAAW,aAAa,sBAAsB,iBAAiB,iBAAiB,kBAAkB,CAAC,cAAc,WAAW,mBAAmB,oBAAoB,CAAC,sBAAsB,yBAAyB,CAAC,UAAU,cAAc,WAAW,YAAY,iBAAiB,WAAW,sBAAsB,sBAAsB,aAAa,qBAAqB,CAAC,WAAW,kBAAkB,eAAe,iBAAiB,qBAAqB,gCAAgC,4BAA4B,kBAAkB,CAAC,gBAAgB,qBAAqB,WAAW,sBAAsB,eAAe,iBAAiB,qBAAqB,CAAC,aAAa,kBAAkB,WAAW,QAAQ,eAAe,CAAC,iBAAiB,iCAAiC,UAAU,CAAC,aAAa,YAAY,iBAAiB,kBAAkB,SAAS,aAAa,gBAAgB,qBAAqB,CAAC,aAAa,WAAW,kBAAkB,CAAC,YAAY,eAAe,kBAAkB,aAAa,sBAAsB,YAAY,sBAAsB,kBAAkB,qCAAqC,qBAAqB,CAAC,cAAc,SAAS,UAAU,kBAAkB,wCAAwC,CAAC,kCAAkC,kBAAkB,mCAAmC,mCAAmC,CAAC,oBAAoB,WAAW,QAAQ,WAAW,6BAA6B,CAAC,eAAe,mBAAmB,iBAAiB,+BAA+B,CAAC,aAAa,WAAW,CAAC,UAAU,eAAe,CAAC,WAAW,WAAW,YAAY,0BAA0B,eAAe,MAAM,OAAO,YAAY,CAAC,kBAAkB,mBAAmB,YAAY,CAAC,UAAU,WAAW,CAAC,gBAAgB,YAAY,CAAC,kBAAkB,aAAa,eAAe,CAAC,YAAY,gBAAgB,kBAAkB,WAAW,CAAC,gBAAgB,gBAAgB,CAAC,6BAA6B,gzBAAgzB,CAAC,8BAA8B,gkBAAgkB,CAAC,2BAA2B,gzBAAgzB,CAAC,4BAA4B,4yBAA4yB,CAAC,qBAAqB,glFAAglF,CAAC,qBAAqB,gsDAAgsD,CAAC,uBAAuB,gkDAAgkD,CAAC,6BAA6B,grDAAgrD,CAAC,4BAA4B,4mCAA4mC,CAAC,0BAA0B,w9BAAw9B,CAAC,uBAAuB,gxBAAgxB,CAAC,uBAAuB,ovDAAovD,CAAC,qBAAqB,4mFAA4mF,CAAC,wBAAwB,4qDAA4qD,CAAC,wBAAwB,ovCAAovC,CAAC,wBAAwB,oxBAAoxB,CAAC,uBAAuB,w0EAAw0E,CAAC,8BAA8B,4/DAA4/D,CAAC,0BAA0B,4mEAA4mE,CAAC,4BAA4B,4qEAA4qE,CAAC,sBAAsB,gpCAAgpC,CAAC,0BAA0B,o4EAAo4E,CAAC,qBAAqB,w0EAAw0E,CAAC,uBAAuB,g+FAAg+F,CAAC,yBAAyB,43CAA43C,CAAC,2BAA2B,wmBAAwmB,CAAC,wBAAwB,WAAW,YAAY,qBAAqB,wBAAwB,sBAAsB,UAAU,CAAC","file":"vueditor.min.css","sourcesContent":["/*!\n * vueditor v1.0.1\n * https://github.com/wanazaroff/vueditor.git\n */\n.vueditor html{font-size:16px}.vueditor h1,.vueditor h2,.vueditor h3,.vueditor h4,.vueditor h5,.vueditor p{margin:0;padding:0}.vueditor ol,.vueditor ul{list-style:none;margin:0;padding:0}.vueditor a{color:#000;text-decoration:none}.vueditor hr{margin:10px 0}.vueditor label{font-weight:400}.vueditor img{max-width:100%}.vueditor{min-width:300px;min-height:150px;height:100%;display:flex;flex-direction:column;border:1px solid #ddd;background:#fff;box-sizing:border-box;position:relative}.ve-fullscreen{position:fixed;left:0;top:0;bottom:0;right:0;z-index:10;margin:0!important}.ve-code,.ve-design,.ve-md{flex:1;overflow:hidden}.ve-design{position:relative}.ve-design iframe{width:100%;height:100%;display:block;position:absolute}.ve-code{position:relative;overflow-y:auto}[class^=ve-triangle]{display:inline-block;width:0;height:0;vertical-align:middle;border-top:4px solid;border-right:4px solid transparent;border-left:4px solid transparent;transition:.2s}.ve-triangle-down{transform:rotate(0deg)}.ve-triangle-up{transform:rotate(-180deg)}.ve-btn-box{float:right}.ve-btn-box .ve-btn:not(:last-child){border-right:none}.ve-input-box{display:flex;margin-bottom:10px}.ve-input-box .ve-input{flex:1}.ve-input-box .ve-btn{border-left:none}.ve-btn{display:inline-block;margin:0;padding:5px 15px;text-align:center;white-space:nowrap;cursor:pointer;border:1px solid #ccc;color:#333;outline:none;background-color:#fff;user-select:none;line-height:20px;transition:all .5s}.ve-btn:hover{color:#fff;background:#42b983;border-color:#42b983}.ve-btn:hover+.ve-btn{border-left-color:#42b983}.ve-input{display:block;width:100%;height:32px;padding:5px 10px;color:#555;background-color:#fff;border:1px solid #ccc;outline:none;box-sizing:border-box}.ve-select{position:relative;min-width:60px;line-height:26px;margin:5px 5px 5px 0;padding:0 20px 0 10px!important;border-right:1px solid #ddd;vertical-align:top}.ve-select span{display:inline-block;width:100%;vertical-align:middle;font-size:16px;line-height:26px;letter-spacing:normal}.ve-select i{position:absolute;right:10px;top:50%;margin-top:-2px}.ve-select:hover{background:transparent!important;color:#000}.ve-dropdown{width:176px;padding:5px 10px;position:absolute;top:36px;z-index:1000;background:#fff;border:1px solid #ccc}.ve-disabled{opacity:.5;cursor:not-allowed}.ve-popover{font-size:14px;position:absolute;z-index:1000;background-color:#fff;padding:1px;border:1px solid #ccc;border-radius:5px;box-shadow:0 5px 10px rgba(0,0,0,.2);box-sizing:border-box}.ve-pop-arrow{left:50%;top:-10px;margin-left:-10px;border-bottom:10px solid rgba(0,0,0,.25)}.ve-pop-arrow,.ve-pop-arrow:after{position:absolute;border-left:10px solid transparent;border-right:10px solid transparent}.ve-pop-arrow:after{left:-10px;top:1px;content:\"\";border-bottom:10px solid #fff}.ve-pop-header{background:#f7f7f7;padding:8px 14px;border-bottom:1px solid #ebebeb}.ve-pop-body{padding:8px}.ve-fixed{overflow:hidden}.ve-dialog{width:100%;height:100%;background:rgba(0,0,0,.6);position:fixed;top:0;left:0;z-index:1000}.ve-dialog-header{background:#f7f7f7;padding:10px}.ve-close{float:right}.ve-dialog-body{padding:10px}.ve-dialog-footer{padding:10px;overflow:hidden}.ve-preview{margin-top:10px;text-align:center;font-size:0}.ve-preview img{max-height:300px}.vueditor .icon-align-center{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAmVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlB4vuQPAAAAMnRSTlMAAgMFBwsMDg8QERIUFRYXGBkaJiotLjg6UFFSVVZofoKDqK+3ub7BxcrM0dnk6Pf5+4oUqqUAAAEkSURBVGje7djbUsJQDIXhUFFosSBnioBaKGo57v3+D+eVNx1nSNJm48X6X+Cb6TTJtEQIIfTbU39ws/5jLaJdeFa7dg3kyzP71BtDz+5FjUz5yFSNzPjIDAgQWRM+MlEjHT7S0Y/8B9d4q7MhX48c4rjEuUL/oOih0aI/iFHpG64cVY3Y+ca7xtoFIum9ghQWSFFB9hbIHgiQYK9wkGFMDNaKi++xIMOseoRC1dqc5INx2rREyFY3f1uJMdZO+ViAZFokEyBrLbIGAuRWKy2yEiBzLTKXfHSddcZZdHOTg8Y4JMI93B2I6+J6ofv87ug9G9aLiIiWzpvmMqKFN29BpT3yTT5AQIAYIld740K5PZJT6qwNlxKluekTu+QpDh1CqOl+ACYrEC2lLhvkAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-align-justify{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAWlBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlC+y02GAAAAHXRSTlMAAwQFEhQVFyUmLS46OzxQUVVWqLq8ysze9/n7/bGqpTcAAADCSURBVGje7ZkJDoMwDAQHCunFUZoepIH/f7OvWEtVdz4wUpSsHRuMMX9F0x+F9A3Afdul1AXGXc7IWy95sQdgiSVCyUfvKGS9JJOq2lETpCw9sZKTC50R0x6EtABcV+1bXC9w1sfKiade8qDqJdWV0RKhJOQKhzzGkFgJCciYqDdGR8pF3nCHfB1CPkFFLymujJb8uiRkPDjpJZN+ZLstUcNnY5T7k64X0jUAN3EnUWcY9LEyeH9iiSXen3h/YowxfAF9I35eWqqeiAAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-align-left{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAnFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlD5L8M5AAAAM3RSTlMAAgMEBQcLDg8QERIUFRYXGBomKi0uODo7PFBRVVZofoKor7e5vL7ByszR2d7k6Pf5+/1nKpp+AAABHklEQVRo3u3Z21LCMBDG8bUeEaKCIshJo6LiqS37/u/mTeowQyZcdL9wwfd/gd9Mp93MpiKMsYOq6F236+pspzFfa+teTtPGWC16TyMrE0RvkoiNoXc5kCERIttVNshtEvE2yHkScbWF8bhjQDrf+ol9TXmWsX12fIKo2CSG34pp1f83Bgqr6jTIEofoU4PUQOTV+DyJ9kbkwJEsr3CWjxE4VupO1gGZZ9Qzhsv50ujD+FkcQVeH0DN2CQoN4khpikygi2loToQIDJlBrwdD93HkwdL4LYBXtqHPS9zlc9MFjzS2n/8n3R6wbiEiMkWuQapaT0RGCm9kPCCjfYhmiAgRIFLhjdJ4dYjmbZeg+PByJv9Pks/KOx50jDHr/gDKzMKMu2GFWQAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-align-right{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAnFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlD5L8M5AAAAM3RSTlMAAgMEBQcMDg8QERIUFRYXGRolJiotLjg6OzxQUVJVVmiDqK+5ur7FyszR2d7k6Pf5+/3jauRDAAABG0lEQVRo3u3Zy1ICMRCF4TaoXEfwwkVBlIAKokDs9383V2OxSbKYPtl4/hf4qlKTnklGhDHG6q5vhs0auBxxtdHGhWUG+VCLHpPGyMTQbRIZ2yCaRCZEiMCQBxvjmETaNohPj5WVhRGqzPB63jdeK58zGDPKXSJqnRO3O8X0Nf4zukFh3ZkOkEhvNbIBIqFG3oGIEvnnSJFHuMhm7JUYK0UGZJlRz1ipLl6/jbZJ4oN7bTm6Isq96Z6PHILmpkjkOPeCeZ8QISIiyxLI1NSIXA+6gyXyFJldvU8z4idxZdsZ2pS/fGasYa4/ANZ3IiIL4KFBVTXMRWYKbyY7PLIVLRARIkDkhDeO4vGIlyqgjVCJVB66Yvx/whgD9As3HcK8Wc6lewAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-bold{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAACHFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCeqFE0AAAAs3RSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIiMkJSYnKCkqKywtLi8wMTI0NTc4OTo7PD0+P0BBQkRGR0lKS0xRUlRVVldYW1xdX2FiY2RmZ2hpa2xtb3Bxc3R1d3h5e3x+f4CCg4WGiImLjI6PkZKUlZeYmpudnqCio6WmqKqrra+wsrS1t7m6vL7AwcPFx8jKzM7P0dXX2drc4OLk5ujp6+3v8fP19/n7/fYiXWEAAAR3SURBVBgZtcHpX1RVAAbg99x7BxCwUEPIMMkFkSyXBEvLbLGsFLMpBhVL00QRQ3FFytC0XLBE1ExFFElwARnef7D81C/ue84ZYXoePDWnYuHSmlUffvJ5atvuA8dPX7zWO5hmxkZvNK94Dl6cuL7UNLgNMRv+qDZwuMvsuL/awOoas6V3LmzOMXv2B9CCgunzV6xv6X5Cm77mtYtK8yMDBIn86csbzo/Q5k4R3AqWHKWUxBhm5vZH1IZnw6eYyleIMzW3KKVnw6eLwmZIyweojEyBRzOFbdAS7VR6Q7glKTTCZjuVXXBbQ6EFVnuplMCpmsJRWJnLFM7AqYpCB+ymUimGSzmF83DYTWEnXEopdMPheQrDBg5TKfTA5SqFGXCYTKEfLp9SWAeHSRSG4FJO4SgccqjAZRKFHjhEVOASUBiFQ0DFwIWKgZ2hEsCFSgAHKiEcDBW4UIngEFB4CJc0hQQc8ilcgMtjCgk4lFFIwWWQQgSHlRTmwuUehQgOLYwbMnDppRDC4T7jvoTTTQoB7MoYN5oLp+sUAtjtY1wD3K5QCGBVyLg7AdwuUTCw+pEx6Rfh0UnBwOZdxoxWweccBQOLSsY8mgWvXygYaCvTHKsrH34/UzBQcg9xrNFagwx0UAgQl7PxCce6VISMnKAQYIxoweFRjtW/DBlqp1AzLS80+IcJcovmvLPjCuPuf2CQqTaOy523DTJ3hOOxxeBZHOK4DDRVBMjYAY7XSGMJMtTCCeiqREaaOSHdLyEDeyn81brhvWWLXl342uJlK9ckm04P0q41glcThQTGCIvfbxumNlABnz0UEhCC6m5qSXg0UkhAqxmgdMTAaReFCBbRSUpnDVx2UohglaR0ysBhB4UIdmspNcHhWwohHGopvQW77RRCuLRSGc6F1TcUQriEfVQOw+prCgGcyigVwWYrhQBuJ6l8D5sGCgHcSqikQ1g0UAjgcZPKUlhsoWDgsYHKXlhspmDgMZ1KPyw2UzDwCCiF0DZRMPDpp1IEbRMFA58TVGZBq6dg4LOHSiW0egoGPg1UXodWT8HAZyOVCmj1FAx8PqPyMrQUBXh9QaUYWooCvLZQyYWWogCv/RTSsEgxLg2v3yh0w6KOccPwekghBYs6xj2CTx6VebCoY9wD+MynMBrCoo5xD+DzHYWDsKlj3EP4PKAwGzb1jBuGxwIKPbDaSgEeFygsgVUjBQOn+RT+hF0bhRAuwW0KpbDroZAHl/0UtsHOUJkCh/UUfjewm0KlHHa1FPpz4LCKypuwCQ5SuFcAl3YqDbCo7KPQkw+XAko3IM27SOVECAfzyllq11cn8F+mJHmPSvojWEUz1rQ/oUPXurn5AQATFZa+kTw1Qu3sZEiFVbVt/cyK21WQzDCz5fpiWATMjtHWmbAKmQ0d1REcEpygdGeyPIBbDm0e9d3q7jzT8cOxI8eO/3T6wuWbfYMj/Nfjvs59G5aXFyIDeXxq6O7VX9uat278eMXiirIXnstLBAaaCcIoEQUGz2RyXhTgf/Q3nJOxY9PjxCUAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-code{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABWVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlBnrqOTAAAAcnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGhweICEiJCYoKSotLzIzNDc4OTw9P0JERUlLTlFVV1xeYmZpbG1xdHh8gIWJjJGVmpueo6aoqq2wtbm6vsHFyMrMz9HV2drc3uDi5Obo6evt7/Hz9ff5+/3yYEsPAAACzklEQVRo3u3Y2VsSYRQG8IMpJQhMpZQtpm2222b7npXtq1hWhplQSaDz/1+EvTPODH7b+Wbmqjl3zHnhxzzDM8BLlE022WTzH83on86zqXLKyGt3Y26mamz7Z7jtVJEJIK9SRe4DuZAqsgIk1Su/C0Y91RO5DOROqsg7IGNpGv0w1vrivlBl/pMj2x0F8nzzQHHuy4iF4TRd9+dOyfIhkHP+46Fl123tsTLkyi8gxZBhocDoKttF2xEsv/pXaBmPmYpvuO6kaH3Fjdwdx/0wSwmMlQHRfg7L/f7NctFCCRkl0T6PZSfnHxj8xlZ0Bh3HdjY4wla0Bj3C+jRZK3qDWtgPkq1iYOzFfiF6lKEYGHQNgetkqZgY9BGJUbJTjIwd3gvlSKFU4xl0EpHHgpWBYmbQE2ROkI1iaOTaCAnvnDrF0KB9CNUka6ViatANpK4SXzE26DNi8g+pVDE3Coj9VkQCZbVqZdAZ5GaIqzAMeorgMWIqHCO3huQA8RSOQQeQ/KDL9ShljkG3EJ0mhjJMVOMY5P1k2E0MZTGENCv6Zw55UYO3U/weQkoNhjKF5AOOsbpx2hWG8gLBIxxjGD/fjZW+deT62QZDOYTUWwvDXLmL0CWNURAZxor3ZMfK6CpNA6WCxA9jo/fPl4lyEYF7toaR8gb7cWsjrDQqqs5mXfWXt7CkNPTKYSxfxjG0itfZnI9l6BSvsynFM9SKtrMJGVV1DREoZXFnczu2oVK8zuZgfEOuaDqbwGjpDamypbOJY8iU3s4mniFRejobmWFTSTTy4s4mer+pxyxXJsWdTWTsCpxAaebFnU20LFyyMjZLNUfW2US/0+1KNa8edOSdzRbFwuh+xmrzjqqziSrvF2yKTn1nk/SIO5uER9LZJDuyzibJkXc2Cc4peWeT3Kg6m8SmrupskpppZWeT1BTOzrY7Y5T+5CibbLLJJpuk5y+zUKCeS7gPWgAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-eraser{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABiVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDqUIP+AAAAgnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESFBUZGhscHh8gISIjJCcoKSowMTM0ODs8PT5AQkNFRkdJSlJUVVZXX2FiY2RmZ2lrbG1vdXl7fIWGiImLjo+RkpSVl5ibnaCio6aoqqutr7W3uby+wMHDxcjKzM7R1dfZ2tze4Obo7e/x8/X3+fv9eQZEnwAAAi9JREFUGBntwXk3VXEYBeB9zu1eFLoiDTcqmgyleUIDKtKMSqPQIJEhUw6u/clbee8H2L/3n9ZqnedBKpVKpVL/Rl33q/EJzbu+g/CIBhnkdYxg0XsGms4g1BMGG0CgbjpUIUg7Pc4iRANdOhGgJqHLDejKlunTDFn8nT5JDNlbOnVANkCnh5Bdp9OHCKrTdJrJQHWgSJ+VcqiqftNnsxaq7AKdjkEVTdLpPGQjdOqF7B6dXkB2mU7jEVTNdJrbBVXdFn3W9kBVsUqf4n6oMrN0OgFV9IlOVyB7TKcHkHXRaRSyNjp9i6FqoNNSDqqahD7JXqjKlumzXYAqnqJTC2Rv6HQTsn46DUJ2jU4fI6hO0WkmA1V9kT4rFVBVrtFnsxaq7DydjkMVTdL0QNPOkguQDdMMQ1NgSS9kfTSfI0iq12mGILtE8ysHSXaBZiKCqokmyUMSTdLMZaGq26RphOY5zVolVBWrNOeguUVTrIcqM0vTC00bS05CFY3RjEBzeJvmKmSPaL7EkFSv0/RD1kWzlIMku0AzClkbTZKHJJqgmYqhOsKSRmie0SzloMonNB3QdNMkeajKlmn6oGlhSQGqeIrmJTSHtmlaIRui+RpDUrVO0wlZgWYpB0l2nmYQukHu2KiBJBqnGYugW+SOo9A8pZnJIMAG/1q8qxmmWa1AiGk6bNYiyG06NCFM+QaDXUSoVobqQbgz2wzSCY/dd35sUVP8eX8fUqlUKpX6f/0Bl2O/cU+zSuAAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-file-image-o{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABa1BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCat1vqAAAAeHRSTlMAAQIDBAUGCQoLDA0OERITFBUWHyAkJyosLzAxNDY3PD0/QEJDREVGR0lKS0xNTk9QUVJUVVZXX2RmaGlrbG9wcXN0dXd4eXt8foCCg4aIiYuMjo+RkpSdnqCio6WtsLK1t7m8wMHDz9na3N7g4uTm6O3z9ff5+/0N1+4LAAACq0lEQVRo3u3ZWVvTQBQG4JOJtVTL5obFDVGrshVcUKmiKJtrwQUpWhW0UqlYLdicn+9FSEyTSTPJnAkX9LvLM5l5nyST5EwCYKXjccXAsPmznj8O4jm5ixFTG2WCRiqygYi102LIE5RKXgj5IYfgrAhiYAwKYgzK3p6HmWhmzA4ft0Moezsy4SmfNzuc0e6IK5ERgOu2MqcOgSFRRQaBYUFFChFV5BAYsZV5dQiMiiiyiJAijcBYsCKPQM5WFtQhwQoFAuMBCgkCE60VGgRu2Mq0OsShZNQhcNNCfjN1CNyylJxCxFZqKhGrCU+oRLSa2XafCpk+xUnRbNugQlpW49LIXYFSTBq5EgeSigOBB3EgME+F6MmEv3Ls3sp7bj6EQPoKdUQ01gY0CBcmjPSW7cP+2a8IOd9wnt0pJUjGdQ2nFCDpv+6Z0k+PFD3TcVujRro5k36AGpnkIGvUSImDGNRIhfeQSBAjdR6SJEY2eYhOjKxyjDr1NclykAI1kuQgfZ6xHl6Qu+NnPUbZM9Qj3xtUEElUXUaj191jBhHxotRTuMv1ufCcz6e+Qan3SZfzWHY9iw37fA5KvRkTc7ZRTLt3/9+Gl2QQgGR2dbNeKU12e0ZZcJ7Jy1KIbxabr1dWBfLUPb2v0iPPvDfqNWrkOe/hOUSLvOBXpMOUyEu/uneEDnnlX12PRUbYctP7sNCqhs9FRFgJtxzKUuuVwngkhH1CxGqHtfk6aD0yEQFhn82aPmVuvgleWp0NjbAvVoV6BADgrcAi8XZYRF+3+/46Cto7VIDoG86fVj0rqADRv0b5URMO0b+hcuRQGdUj3zEGBNtIG2kjBwiRTBtpI/uG0GZfkKoCYytwsUmQRTeSNsiNhucTA2SoFYPzXxY6l3cIiZ2lTp/5rdGladx/Xh+3LuObBs4AAAAASUVORK5CYII=) no-repeat}.vueditor .icon-file-text-o{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAA9lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlBBA0bsAAAAUXRSTlMAAQIEBgcJCgsMDQ4QERIVGR0fICEiIyQnLC0uLzAzOkJKTU9kZmlrbW90dXd4eXt8foOFi4yPkZKaqLe5z9HT2drc3uDk5ujr7e/z9ff5+/30iNzRAAABlElEQVRo3u3ZWVPCMBQF4NNaFQXcFZcqrrjv4r6gSEEF2vz/P+NDlxkR6KVJ6oP3vDbJ99KcSSZAmNGDiicGzcdDaQb0FFoiYZxNk2hkEhtCCGeJhhwKqZRIyKscIo4oiCdSUIRIQQlGWiY1ZX/CXW0AJRhokn/5S3/CnLFNVxIjwEakHOtDsE5VZBAUiYoUgjWaIodgOdpnJ/oQLLoERRbBfDtekUYw3YpV5BFMfYXKqT4Ek58xigoEE43+ihIEuXpfRQ2C8aiU9/UhyFRDxdaHYKQSLFU39SEYfg7W2tKIwHoKDko6EeSCxWZ1Irjxv+2qQvrlURq5IJzGpZE9wlFMGrHTQIyXFBCMvaeAYGinph8BYHQ/J1tKkR4xGWGEgBi0yCDFNvFSem8kRxrkq28hOUK/X68wAjhkZCE5YhMV99rgHc8ItzC38P9C6mm08CpRcW+5hRnhFuYW5hbmFmaEEUYYYYSAqM2fIFUNxlsncq4BOetEsp5yw83+ftlRrXhd3mWRLzcVEs2rfK/nEHX5se433aBNZmw1zKwAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-file-text{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAA0lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCLwGkMAAAARXRSTlMAAQIDBAUGBwgJCgsNDxESGhscHR4fICIjJCUmJygpKissLS4wMTg+P0pNUFRdZ3h5ho+RlKWmur7Ays/Z5Obv8/f5+/2SdDsAAAABVUlEQVRo3u3a2VbCQBAE0CQogjsBwX3HXXEXNIrJTP3/L/nigyegTCaTEqXrA3Ifku5TmTOe95nyE7LFy57gGXbITAbkDJZIv2WO9GwRYN8Yie0R7JkiyIHoXQICvUNAoLcJCPQWAYHeJCDQGwTERMmPQK8TEKg1AgK1SkBGKW4QqBYBgWoSECRNAvKT4g5BskJAkDQICJI6AUFcJyCIQwIyXHGN4H3BIdL9LrcOkSwZUyRgICEDeWQguGIgeKgFxSMj0xZEkN9FouVps1Q79six8Zj59shBzmGeMOSIgXRNz5n8cxlGQSYWeW0YbuHZG3vk1HjgS7Ig/xNCefGUT1jWiiB/HOlVTCvRxZiXO9nCmZATxk9QVCubZa4jwyiIIIIIIkhhyGEKeSsCSV81uCsCqaaQsADjfqAKXDo3XqYGC0c7ckqo69LQXlNZXHKWef/Lgz8AEq4GpDAt4LEAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-indent{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAh1BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDQuOtUAAAALHRSTlMAAgMEBQYICwwOERMUFx0jOz9GSlFSX2JjbG17hYiJi4ydqLnR3uDt8/X7/RuUh+AAAAEkSURBVGje7dnbToNAFIXhpdVKFUWt4hlUkFKd938+72WYqdmHaLr+a5IvEzIzmwAwxvap1blxK+A+mHeHrT0yIjhEhAiRv4IM9saAylwZKl517L9Xfbwf556pR+E+GULoM0oh3vEhZJVS54BMK0pIWtFCkooaklL0kISiiMwrmsisoorMKbrIjKKMxJVToTH5PokqnQypJ3NXfC2loALT4a7Pnvy/b7q6fuGAhFsP5NIBeXV4JwYGdjFO1jeCrg6wg3G4kW3Gtx9IG1vsmfBY+ULeUD4gW4f7pHW4GVuHO75xmFYah7mrcZggG4dZ+MVhqk8bCkiXNXD0KTM6LB+usyf1xdOzoMclGDOsKI0rgDqYV2O0R/j/hAiR/UL4/4QxxuJ9A9+JZ3IGueJhAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-italic{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABsFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCRaBZ7AAAAj3RSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGhsdHh8gISIjJicoKSssLS4wMzQ1Njc4OTs8Pj9CQ0RFSktNTlBRUlRVVlhZXF5fYWRobG1vcHFzdHV3eHx/goWGiImLkZKUl5iam52go6irra+wsrS1ubq8wMHDxcfIys7R19na3N7k5ujp6+3v8fP19/n7/Vr3HEQAAAKCSURBVBgZrcH5N1QBAAXg+55Z0kSUGpUMWrVTKS1SlDaR9rRo075rR1OI0XD/5Tqnnzp3HOa534eFOP87+/HZves9XW0tu7fUr1lZVpqIhUGAv4KwJJYoXZ7ObGk6dKqnf/DdaL4UkbxiEfKIJs8ivEYkKRbjNCLZwGJkEEkHi/ClBJHsffBhjAsxPdBcisWILcu0DuQ4txdt6QAOQRMLGu9rCOHDAh6tgxcLSMIrpHoJsxTVEZjVUlXD7ABVCLPLFF/h9oaiH24zFMdglqLaDLNNVJUw66QKYfaQYhhuExS3YJakOgyzOqoamLVRJWA2QPETbmMUd2CWpDoKswxVDczaqeIwu0+Rhdsvin6YLaE6CLMGqmqYnaQKYfaY4hPcchS9MEtR7YDZVqpymJ2lmIbbS4rHMAtmKDpgVkGVgdkuqjjMeimG4faB4irMQqommKWpKmDWQpGH2w2KJ3DLUnTCLE5VB7NaqjjM2ilG4PaQ4hrcpiiaYZaiWgGzRoqZAGbnKJ7D7S1FF8wCqgaYVVElYbaf4gfcrlPchtsoRSvM4lTVMMtQhTA7QfEZboMUfXDLUeyB2TKqCphto5iGWzfFINyGKI7BLKSqgVmaKgazFopvcLtJcQVuWYo9MEtQVcAsQzEbwOw4xXu4PaLog9s0RTPMqqhWwewMVQxewQ+KHMz2UQ3BKzlJ9QJOiY4JFvC1BC5Lm59wLt/vdjZWhlic5NaLI5xX9l7X9kpEU9s9zAV7gEiCWRbhAiKpZDEOIZKdLEYdIunmf/KT4xO/pnJ5FpZEJG/JiaH7lzr2bkyXJUL8JwjCWNn6fReeTvKfcUSTigeYX0n52vr1q8uTWJA/hGHnz5A/HK0AAAAASUVORK5CYII=) no-repeat}.vueditor .icon-link{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB/lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDeqZzvAAAAqXRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExUWFxgZGxwdHh8gISIjJCUmJygpKiwtLi8wMjM1Njc4Oz0+P0BBQkNERUZHSUpLTE1OT1BRUlRVVldYWVtdXl9hYmNkZmdoa2xvcHFzdHd4e3x+f4CChYaJj5GSlJWXmJqbnZ6goqWmqKutsLK0tbe5ury+wMHDxcfIyszOz9PV19na3N7g4uTm6Onr7e/x8/X3+fv93k/zXgAABLVJREFUGBm1wYlDk3UcBvDnPThkHMNClMjCA7MwTSo7lDPv8IK0uzTRwtSoRE0IL2Cilooa5yaOY89/mTJ43/e7vdu737vx+cBdydu7j393Ym9dGZbLym/DXDJ98lUsg9IrlHqDyLUDMSY5gpzSe+jmqo7cMW7S3S0DuWIMMJUBA7lhDDK12zpywRhkOrd0ZM8YYno3dWTLCNHLDR3ZMUP0dl1HNsw7lPprDOjV1yj16/DPHKbUhrgDlP7W4ZcxTKkFS1oo9enwR7tJqRm23ZT6NPhyllITnPZS6tXgwyZKTZD2U7qmQZk2SqERiT6ndFWDqg8oNCDZIUpdUPWATrvg5gilHVATpNNOuDtKYbYASj6hQyNS6aDQBSVdtJ1GascpFEHFEG15SONLOh2Cikla+pHW13QYgYo5Wn5Bej/SoQAKpmm5CA8h2t6AghFaJuFhE207oOAybRuRnknbASjooG00Dy60QEBDHG3tULCeDvdMJMo7NUvyQiFe0GlrgwJ9jg53TUjFY1wwvRZAFW27oOIsne6acNIecVGsFuimbSNUBCkMm3CopyVWW0+HYij5mcIdE7bztMVitIWhJm+Swh0TlutM4XsoqqYUMrDkPFOogKoPKQ0ZWNRKd39DXSulIQNx+ihdVcCHVkqDBuIq5uniB/jSSmnQQFzNPJMMafCnldKAgbjXZ5ngST78aqF020RcJxM0wCm4ufnwsb3bV+vIRAulkRq8UPQrE8VqsaTqzHMu6avX4K2FCcJXu/+hi1gtFqwZoBBugLdmZihWC0A7zSR3S+CpmRmK1aJgmC5mNsBTMzMUa3hKd+/BUxOztg2empi1d+GpiSmMjjFDdfD0Pl09LAyMM0PvwNNrk0z2uwEExpmhzfBknmGCqa14KTDOzMTegreyzlnaHn6qIS4wziS/VZl68WfTFGIbkQF9Xfvlkem5ydC5neWwFY8zQT0WFN6jEFsP31aMUYptRpx5n8J8DXwyRpikDnF5/1KYfxP+9NDFBsTlP6QwvxZ+bKebaBHi8h9RmKuGOj1MV5ewqOAxhblVUNbAFAwsKnxK4VkRVI0whVIsWTFKIaRBzUqmUgxL0RiF/VDTQIc947Q8h0Nggk5zeVByjrajKJniknY4lUzS6RiUhGiZ1YGyCcaFNAilU3SYgpIpWi7ihfxrfKnbQIJghA6roWKelq+woKqxo7EcyV6ZpW0fVEzT8hPS+4i2C1DxiJYHSE+L0nIfKnpoq0J6f9IShop22h6bSKuTlnmoWEeHIQPpXKIlDBX6LB0GDKSmzdByH0o66XRLR0qttJ2HkjIKN3SkUBWjbQ/UdFLo1+Fq9QwdKqHGHKfQp8FF5QwdJqBqTYxCr4YklTN0aoOybZT+0pCgMkqnGRPqPqZ0RYNQGaXQBD92UurR4LAqSqEf/jRS+kODZVWUwlg+fGqh1I0lFVEKkVL4tptSt4YF1VEKkXJkYR+lB1vyoK08SSlSjqwcpLdIObLURi+RILJ2mOlFgsiBo0wnEkROdDC1cBA5cpyphIPImRN0NxVEDh2kmycB5NSGZ0xyyUSOmZ2U/qvDMij6YoKW3i0alknp1sOnus5+07DWhKv/AdvpqR4pUmbtAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-list-ol{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABfVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAcffURAAAAfnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQXGRoeHyAhIiUmKCkqLS4vMDE1Nzg+QURFRklKTU5PUFFSVFZXWFlbXmJnaGxtb3N3eX5/g4WGiImOj5GSl5ianZ6gpaaoqquwsre5ury+wMHHyMzO09fa3N7g4uTo6evt7/Hz9ff5+/2+M7R2AAACj0lEQVRo3u3Z+VPTQBQH8JeUEEtqBVEUULxb6gWK1gMFEbwQ8VYqh6Ki5RKkSAu0+7c7yW5Ca6DOyPtG6+T9tPuYyYc02euFSIU+Juy4T8CIvBdwpP6rgCMN8wKO7Psu4MjBHwKOtG0IPJIQASB0zr76MPrBXxNiSoO/wv0TOuEHo0YBIPQ3kcYDu4/G3yBjgiMyVZE9gieqIlZNIlqI/EtIlx1XZH/a6RxlRzR/djhE/gAxgkCoZ42ByPdQGGH8F6GduPc5V5h7fSmGM7pXvaHzwsQQ5seKAdoOMRYqp4HNFgAy/etkM6dhTifOHXhKgh2pG3UufDdKWqookaeA3+tkToiU07ohkVn3L715hql+TU71xrM78qItMl0g9kWrLI7I5DxsL2xHRiZHkMgDlTyGQ4wJlZvBHR2O51RqPY5CIo/cTLEdteE+tOQmCq2oXf1Vr//BQh0d+r3BeZZQR4e023liEAppLqm3Kmmvw4ft2Mt+xP4iW0vxrX9+UN3KOxZjnKhDNZvJj7CVPUak8ZK2Q7hiZZsb5EZ0EQBiBIFoQSC0GARyqssfreHpIIwaCv+8afIXn/1j8ZZrTLIVn3dGGFfGnRGr5pFuELIct6JmLOu0JzUQsmAvLXJzsmgQEHnjtDb2IzZ3lh1RogGZOYP8tHFaJvqQtXqr4PRfIT8IaDOq5NFbj0OGvEzxQvXt0i6Q62W5rcfCXHyuWy9Ld6BWlcvjU8sukkUuX9aoUpqgq+QniSShiHr+FxE/k9fqk0gnvxHbHNBVXeKbRNoglc6VdJNORmJWGqUIu3HTN3ye82+7fEbRYkdu+5AU4N06X6oscHdCBkfDwzLjrYUag2bycTYvxGomHUd/Q4Fd+Se9zbVMYAMuWgAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-list-ul{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABFFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCdUZl6AAAAW3RSTlMAAQIDBwgJCwwREhMUFRcYGRobHB8gISMnKCorLi8xMz0+SUpLTlBUVVldXl9hYmNnaICDhYaIi4yRlZeborCytLe5ur7DxcfKzM7P0dPZ3N7p6+3v8fP19/n7hn7oSQAAAdJJREFUaN7tmN03AlEUxU/TiCgzUYqK8lUkhISQQRKDhKL7//8fHkxfM1cvc+61Ws5+3D38VmtmztlnA5BIpH8nNVW+/3ip7OjiEN79DrNkaIIYUyYb0KoYxjsb0nb/p4nEsntFAcBrMpuSPUabYegIoOAwXxULEkdhsC9QO043Y0ESOBAGKY5pYkPOeK4PGVLnuRoypMVzY8iQBs8NI0OueK4fGbLLMdseZEiIY5awX2G4dpoBdIjm8I67syuEw3gAgHWbd6f0pvDmpeFe534AgNwQo6qK2VrJZp9RVETtXyX79PPuloJCo4RPX4z4PRSpSGMrnxYLi32FlYxpfYwBYQwZY0XGgLSP+mr/v2SNW/e6mOYtrWKXMYeztB4BDAnrV5cRJPIyIlFFRriTElOlBG4pp0NZxhGUlnHOSTlMOSd2szu8lrBO7FFlgYpTFhxyao/cQHm0lHCvBU6BsyaqiiqIr6IAQE2X661GJa9ToiKRqHwWWj6jTOHI6PJZbaHsk4OR5TPaZqTymcrnMS+f9/6qfD5Bz8I3TjOIDgn9evwi3vGwYfNqAhoJsD37mqDyeeVt4KELK5+9W8+MMcY+T2eFRonJ+Xh0hspnEok0HvoGC+ShTC/TNBUAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-outdent{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAhFBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDbLQvCAAAAK3RSTlMAAgMFCAsMDhETFBUXHSAhIiMtLi8/SlFSX2JjZm1ze4KFnbng6O3z9fv9whZhOgAAAStJREFUaN7t2V1PAjEQheFBYYEVgcUPXL9AWai1////aQRkW+ZuOI2R817OzRNC2k6yIoyxc6o/AtcXeQrwHuUDjzgJGSJChMhfQRq80UgFV5qKTx37fz2sl8mkdqc+J8/f83E0KcwnXjPCTTQqzXeXZoCRrYFFdgYU2RtI5NcAIgcDh7QMGNI2UEhkgJDYSJCB0XCqkSCysiG1aqSIDEpDhW4cIfbqgEcuQwak4zIgMvUZEKl8BuRYSZDe/dzQXUdXYuRiYzuM7/pviZGh8Vr51P991FUfKbBHq63gnt+WAlwkJj4DclCgy91ewa6pOwW8cI99BmSrzMDIjzKMnzVvM1bKnXz1eptMrhdvhl66whiwogRXqEvqqavF4RF+PyFC5LwQfj9hjDG9L/DQVRC18NMlAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-repeat{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB2lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDAOIh1AAAAnXRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQWFxgaHB4fICIkJSYnKSorLC0uLzAxMjM1Njc4OTo7PD1AQ0RGR0tRUlRVVlhZXF1eYmNkZmhpbG9xc3R1d3h5e3x/gIKDhYaIiYuMj5KUl5iam52eoKOlpqiqq62vsLK0tbe5ury+wMHFx8jKzM7P0dPV19na3N7g4uTm6Onr7e/x8/X3+fv9BUTaEQAABAhJREFUaN7Nmmlf00AQhzdtoFBuquJRFEQERSii4IECAlYOgcqhUm7kFpFDLkWuiqAchQLaFva7+gJESHaT2WzSn/+Xs0me7iazM7NThIAyJ6Y/dQ9NLW0F9lbnRruddy9FIF0VfqPuB5Zrv6sgQSeCtciD6dp3XeQmmHImsJq8L2K5lsnpxyD1UabjGJurjlRERNQcYLBmUghPeIMxxgfJCgtVdYiZNBIvfUTr0YBPoDGyvJhZdeKZR7T/tVPWMmoca5Ev9dQzOk/M6URGth9rVP3J0nT9M2aQ3kYz1q5vx+7ZjRUhVg/mUSAFISS8w4oQ2w7m1CMk9GBFiN2PuVXbixUhNw+x/pJA7EYwJJBzKmsV/NLmqigpq24YWNMMifIpXLlcdc1y6lohxtG0rQFiWqFetlZkJTltUvU+K6SddtHYZfo2WrDGBLlPQyQpB52CXTgkLki8YOuWeopRC4ZME8dbTJAImuyFQfKI+1AuME6LIxCISFrYrXh4OtAAgDSSdm2W7E1YVYVEE4Y8IgujR30mb+Ujm0zz6FV/J5HyAT9Lwib0Ab6uV/KBLBZGP8BPwuQbfBMLYwDijA9k5nWTjowjyLzMfJ2BMQjaIBNk1iEGxhBsF66QWW1wSD8wnqxLjQNwxkNg0LLKjBfgkGkgJFsWzRk+3xkIJAUht9T2mAFSAoFYENoh2MAyA5LaCoTCpLY5prIy5rMKIliCEDovtT5nrF4tCYkKijMhhNAdKeQK0l9lUkiYAZBOaSAxgIGGJZApIyCzEkirERBplu0yArIjdx39JT0/KTUC4gvFTELyTkLydX0IhZ+ExONDsneFZBfmjicQcUZGjfsKDjcAwpWtQJUjhSwZAOHKIMHa4MiFwarkyeqhktcngwZMZYGn0tJeZLDUjFCnl1e/jRp7OmynL7c1IMRPeDyMwVXYTiSOa9RJjPESnUJoAWwwd/iOwt8ilRLDe0qEEKo+vo9OeU2iMM2l/uS+BdqvE/f4Tu6EUz0ZOoV4YOvPATIiJs/cR6WQi2U3yCszf0lum6dQaOfCmepFY5v8Nholn1K+jiqHF1Mp8dd9pTQXO2hV8ij9rN5STGs9pFJ+03d61+EJqesg2Dvo9TstJkUr9U8WK6+eTmPMtnu9Sq1hJ3Xyap2gwGxrnbO4vKZ5YFPlHKJB4S3q1dPqUvxW9OnODQvKH70efcY+VQ/m75jWAvaIKL7eLy6EBWo3B+J3GnTjdgS0Mj4yxKDoCU2IIGNBkL3NzpiKYU0LzC8ZEcua0s5IF4NnbuQijbJUBYH/jMgXODJYc576Qflhp507U45+tqJE6HeISBdZMurXCYCDqXK7vum/aMsobnk/7fEGA7s/Z3rrCtNiBfQ/6Q8OCt9g8MDarQAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-strikethrough{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABv1BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAhme5xAAAAlHRSTlMAAQIDBAUGBwgJCgsMDhAREhMUFRYXGBkaHB0eHyAhIiMlJicoKissMDEyMzQ1Nzg5OzxCQ0VGR0lKS0xNUFFVVldYWVtdX2FjZ2hrbXBxdHV3eHx/gIKDhomMjo+RkpSVmJqdnqCio6WmqquvsLK0t7q8vsDBw8XHyMrMzs/R09XZ2tze4uTm6Onr7e/x8/X3+fv92eXofwAAAzRJREFUGBntwf1DE3UABvDne9tgA8w5IjMwBCMTTQw1Z0VkJALpEmpiVpSQ0RuUSwtdvkC2Bm66secPtrG72+3lbve93fGL+3zQ0vJCEYFg556uoAJvBF5/bz6xRVXu9vULx3v8cNO+C3+ynvXPj4XgCuX0PVp4MHVAoEkimmYj2bhAM3qStGMfmvAR7XkHjokvabA89lrQB4hQ38TfrBKDU2KRumeTIRi8fIMVVuHUAnUrIVTpe0SDp3BokrorqKV8R4MAHBmkLo66Zlm2F074UtTcF6jvGnWH4MQV6vpgQiSpOQkHOqh7CFOvUDMOB+aoOw9z16iKQZ6So24A5kJULUDecZZFYCHOkhXIu86yPbAQZkkS8jIs64WVVe74F9I6aBCFlWHuyEBaHw3+ghUlx6JNSBuh0auw8gWLEpD2Lo3WYCXQP3z6/KVjkPYhK8zAC2dZ6RQ8cIJVzsJ9B1ntKz/c1s4amTMCLttkrdQZH1w1x3pylyNwUT9NJD/ohFvEFk2tjUfgjo9pJR3rhQvaCrSWntmLpn3KhhInBJrj22JjmakgmjJCOwpzQTTja9pSmPbBOd+oTW8JtLhpKEWPpYaQoudS4C4AdwG4C5Ch557gHD13DlACHlPQ4g/XJeCqyNUCa4XhsuDlbVYbhOtCC6xyEh4YzrPCKXjhQJ5G78MTQzSKwhvTNBiFDF+gPdTZBRvEBsuOQsYSizphwyjLeiFjiUXTsMFXoK4DMm6yKKvAhl+pE5DxO3eMwIYYNQlIuccdd2DDJDWTkPKIJd1obJaafkhZZ8ksGvuRqpwCKQ9YkvOhEbFNVRxy1qi6iEYGqDkIObeoCaOBFaqSkLRKzX0Flg5T8yYk/UzdIqz4U1QtQ9ZPLJuHOfELVek2yFqmwbcCJsQ3VOX3Q9pNGt19CXUFb1G1PQh537PSTAA1lLE8Ven9cGCJVfKxCCqEZ7LU/NYOJxZZa33qjQ6B/4muI5f+YdkncGaMJrKPN7KscDcCpw4t0ZZMVKAJ/iPxJ2zg6UU/mtY9/gfNPYz64I62o/P/sY7bE91wVWgg+tmNxMZmrvBs6/GdH65OvN2joKXlhfEcTA1TnELds/EAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-subscript{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABrVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCngLnmAAAAjnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB4fICEiIyQlJicoKiwtLi8wNjg5Oj4/QEFCREdKS01PUFFUVVlbXmFiY2RmZ2hpbG1vcHF3e3x+f4CDhYiLj5GSlJWYmpueoKKqq6+wtLe5ur7AwcPFyMrMzs/R09XX2drc3uLk6Onr7e/x8/X3+fv9ZIA5OgAAA6FJREFUGBntwftbFFUABuDvDLsrSwQrgrdANCVLKzLILpN0UYPK6GIYHkLT8LpopcQmRq0I7uay398csLsz58w5w8zTLD/0PPu+aGlpafk/chl0HjYvVqmTiM9lULUbFrcYIBGfS8MdmN5kkER8Lk3DCEqtMkgiPpem1RQCvqdBIj6XFhehO0iTRHwubQ5AJRZokojPpc1DqM7QQiI+l1YufNkKLSTic2n1vB2eOdpIxHfqQd1Tan5Cw0lqVh7UfIn/ILdOzXHUOEWqnnciCZeavxxs+ZqaESRzm5pxbOql5joSypap6caGX6haSSOpYWpuADhNzRCSu0rNINIlqr5FE6RXqFoQl6gqOGiGIWqmqKr2ojm+Y7iP0STOY4a5i6bZzxDlLJrnHO2G0UTiV9rMoqm612kqptBc79N0GM12i0GTiKPtlbPXC2uV5flrnxxqQ4T2EnVLAtEOXaHq8h5sSxSoq3QiSm+eQXMZbOMcg/KIMEGLp0MI1UfTGLbTdod2owghfqepmkO4XQsMcxx2n9HmN4Ew6WWGKmVgs5d2ZxFC3OY2pmEhFhmiD3avc1sdME0wTEHA7gN6KrNjp96bLlExBsM+hvsKId6ockt5zMEm53P68ggSBaquUtOPEANlbrjfgYa36BMI+IKqmfQaVcsOQux+Qv4s4PuBnix0+6nJ4R1qLiJMtpAXUPTSsxsa8QdVUwAWqTmGMKk0VIKeXmguUFVKAzhCzZMUYqKnE6qD1Ixg0ww1EvFk6UlBIR5RdQ9bMiVqTiKWd9nwN1ST1PSgZpSa1TRiaCuyYQqKl6i5gIY8NdcQw4/0DMLnLFFVdNCQo24YkabpWcKGT2/WPKTmBHzj1JRv1iCMI+l7DRskbW5A4SzTBiH2PqZvDpskLSodUB2lDazEBBUraWyStPgIuhlawGbwTyoqfdgiaSoI6DIlmmAS31BVeRk1kqYBBI3SBEPPIlVr/aiTNEzDlKcBQSPrVM23o0Ey6FkaphwN0InLVK2fgU8y6G3YjDMIml33qbrXBYVkwDysnGUGQLWnSEXpNDSSAT2wO8oAKA78Q4XMYAd0lekrDmEnOI/ou9SGHTFJT3UEO6ObntV++Abq0AxX2PAsB5/DOoHk2uk5BoXDOoHkPmTDLFQO6wSSu8uGfqgc1gkkJujpzqg6WSeQWBejCCQ2yCgCib3KKAKJnWAUgcQOM4pAYvsYRSCxFxhFIDHBKAItLS0tLXb/Ambs7yvKBRLiAAAAAElFTkSuQmCC) no-repeat}.vueditor .icon-superscript{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB0VBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlB928pHAAAAmnRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFxgZGhscHR4gISIjJCUmJyotLi8wMTM1Njc4OTo8Pj9AQUNERUZHSkxNTk9RUlRVV1hbXV5fY2Zna2xtb3FzdXh5fH5/goOFhouMjo+RkpSVmJqbnaCjpaaqra+wsrS1t7m6vL7Bw8XHyMrMzs/R09fZ2tze4OLk5ujr7e/x8/X3+fv9jtp5mQAAA6BJREFUGBntwftfU2UAB+Dve7bBuBQMUCmUJGcXL2lmWUmOrMxKwywLKzsGZJQaml2U8FIoF2MYMoR9/9rks7Nz3tvYau/5jefBhg1187If/DC1+Gjmt++PbfMQi63DRUq+zsC5Tb9SN5aCU+I0LRaegUMNf9DuZTjTMsNK+uBI0wNWtJiCE95NrmMITrzJdaXhxAmGVkaOHuj/pkDJEbhxmCVLAx7WJAYZuQpHXljlY783oewVhopwpWeJvCAQOcdQGq60z18RkHQx1AZn0knIBEMdiA1DLYhLE0MJxKWfZXnEJbHAsiHEZYyhLGLyLUNziEfiAiMHEIue+4xMIA7ep5Q8akUMsn9TloV73hBlq8/DvS3TlN3fDPfepuJyEs4lfqSsOAD3Wu9RdjsD93qXKPtQwL3nipRMZKDadUm3GzbJi5dUxxB5qsjIw9egy1G3mITFWWp8hFIPGBlJwZCj4UuYuqnzERpm6OFuWORo6obhFnU+ynoYWmhHZFsAyNF0C7q3aPBR9gvL5lsQ8RgQyNGiH6rGZRp8BDoZ2gKJx4BAjhbLDVCM0uQjMMiyzyHzGBDI0eY8ZH208BGYZVkHZB4DAjla9SIipmnho6SRoeYG2ZMMCORoNSUQOk4bHyU9rEYgR7t3UNa6ShsfJXtYjYCXDhykYqUJgZ+o2JcuSaLkVVYjEBmlYgwlL1LxFTRvsBqBSHKBip1Y4+Upm/Wg2cdqBCQ7qZgVeOwTKp6GbjurEZCdpeI9ABkqTsLQzmoEZN4MZcsp4BplNwUMKVYjoOih4gz2ULbaDhcGqdiap+wInBB/Ulag7Aoc6WRFhTRceZ+VvAR3btBuFA49sUKbfBIuHaZNH9wap+kMHEsXqLsr4Np+6jbBvUmqpuBeN3XvwjVvmrpiJxz7gqa/BJx6ljafwaVknlZ9cOg87fJJOLOLlYzClYZFVrQfjlykbIayQhOcOEjZRBcVP8OF5mXKsjhFxVE4cI2yq0BikbJiB+o2QEUbgENU3BGoU9sqZSex5gYVp1EfMUnZrIc1Gap6UZePqNiBkhNUzCdRh81UjCAgpqkYxv/n3aWs0ICyXqr24j87Pl5ym4pDiJyjojBegtr5tLkOSfIf2qB2Pm0ykO2lDWrn0+JjqC7TArXzaZrzoGpeoQm182nKQjdAE2rn0/AdTJM0oHY+dYVGmLpoQO186l6HzSnqUDufmuuw8uaoQe18ajpgt4MabNiwvn8Bm0Nr3ixTyeYAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-table{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAA81BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDKM9ljAAAAUHRSTlMAAQIDBAUHCQwPEBUWFx0eHyAhIiorLS84OjtAR0lMTU9QUlRcZGZoaWtsb3Fzd3iDhYaJjJGSl5qbnaCjpbS+wdHT1dfa5Ovv8fP19/n7/YwhIscAAAGzSURBVGje7ZpJU8JQEIQ7QRQUZXFfEHeDJBgBRcQtxF2D+f+/xgN5oYqMqRwYS3H62nn5Lm9mOlMBRKIJkaaPWaOA6crtmz92PbVWtSHjwPOZ1CsGCP3aZ9TWANL1WbUGAHu8DL+fAdLvzBD/Atj02ZVGhx+yApcfUkGfH3IEfoZvCOQXQ3aymYiyu8rt5qJuJhd21v1Zwp6/GYVc0pOsExYtpXTgXiHWDiEG/ZwR2N9M0/jDEIhABPKfISb9mJkIYiaEOBqZ9J3AXiBfUlCJV4+1h63eMY2IzJ5yPTvqGnaY012LsBt9Gb8CmTCIVyDLSV31KlVuek19TC0izg4hNt0Y7MAm+wH0wD1DrC2tXiACEcgPRyIrEcRKCHHJVKOrzUuRfEkp9nBoD+eJW69FVH8IN2PNqFtrhnuZx1PCbkkkEsjERaI8VU559XFwTMUVraoOk7Wqn0gkEohABPKnIR5/JDpEsKPp0VsitcEhezSK8ZFI2dto82+JlrDBP7SmkHrlZjQAlJkZHzMAcM4LWR5cIU7K55q6a+UXLsbd3PBGp9bbztj/Lni+t0ry64lIlFRfrJk1hGnKZcAAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-underline{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB+1BMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlBP84/vAAAAqHRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExQVFhcYGRobHB0eHyAhIyQlJicoKSosLS4vMTQ1Njc4OTo8PT4/QEFCQ0RGR0lKS0xNTk9RUlRVVldYWVtcXV5fYWJkZmhpa21vcXN0dXl7fH5/gIKDhYaIiYuMkZKVl5iam52eoKKjpaaoqqutsLW3ubq8vsDBxcfIyszOz9PV19na3N7i5Obo6evt7/Hz9ff5+/23OreuAAAECklEQVQYGe3B+3/NdRwH8Nf3bGubtpndy8JiLrHt47okQxgrtiRCSBOxGZpRc8m1Cy0rhNy2nTXn9WdWn+8mHu/v+5zvG6efPJ8AJ4zevnahr2vfjvbWVS2r1qxr3bh5264vDvT0nr509be7Qyn+awQRHvEpw7euXezrPtjZ2XX8zNW7j/mPJoAWSUT4i+l1AKO0QARm8BVwjxaIwAz2AzdpEUAImMEGoHl3V9+FwVGmN/bg1sCFr7c0I0Ll9KnVFVNKSuv2jPFZj64c/3xRKZ7IrVk/wEgjHRU5iKfgB0543L2sKhcR5iUpjRQjvuBnjlsDjaPUCYtajgugyaW0AiaP6N2G7j6FuTA5Qe8OdJcoTIXJFnpj0PVQqIBJM0MBVHsplMJkDkO5UG2lUAyTWobKoWqjUASTMobehmo1hSKYTGLIQbWCQglMchlaBdUyClNgEjDUAdViCuWwGaa3G6rFFCpgM0jvEFSOQiVsztPrhcpRqIRND73zUDkKVbDZRe8qVI5CNWzW07sFlaNQDRtHbwgqR6EGNnUMQeUo1MCmjKEAGkfhDdjkM5SAxlF4EzYBQ3nQOApTYTRCrxAaR6EWRgP0iqFxFGphdJpeGTSOwlswOkSvBhpHYRqMdtKbBo2jUA+jNnr10DgKjTBaSa8BGkehGUZL6C2CxlFYC6NGeu9B4yi0w+gdequhcRR2wmgOvVZoHIVOGNXT+xAaR+EYjOrpbYbGUeiH0Ux67dA0UbgMo3p6HdA0UhiE0Vx6m6BpoPAnjBbQ2wjNPApjMGqitw6amZRg1ExvJTTTKCVgs5beEmiqKeXB5hN6DdBMplQImy/p1UFTQKkUNn30KqHJoVQLm1/oTYIqRWE+bMbo5UB1k8L7MMmnl4TuOwrbYVJH7yfodlI4A5OP6e2HbiGFEZgM0GuBroRSIQyKGKpCGiMUFsLgU3qpAGn0UjiJ+IIhev1IZzmFVAKxtTC0HOnkUVqBuBL3GcpDWv0U7gaIaRtD3yC9BZSWIp7JKYYqkMENCsOvIY6cXxk6hkyaKJ1FDDmXGXqYi4yuUzqMjCZd57hZyKycEY4ESG/+MMe1IY52RrhShDTyT3BCJ+LpY4THHTlQ5G1IckInYgq+Z5Tk9nxEqDmc4hO7EFviDKOdX1qApyTKFh0Z5n9S78JiOzUPe7d+sKRpWUvbvlO/81k3qmEz+x6t9iZgldiRosXZKXgexV2M7dx0PK+Cz5KMIblvMl5EMLt7lGmNdtcHeGHBjI/6k4z08NSacrw8r89Y3H7w3I/X7wylRh/8MXj5+J6NrioXr7zyyktTuP/brDq5KQAGmG2tCJh1PQiYdUcRMOuOImDWHQWYdQeAg8y2WQCmN2ZVQwn+F38DDZqb+BiFAtMAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-undo{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAB5lBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlB+ErW0AAAAoXRSTlMAAQIDBAUGBwgJCgsMDQ4PEBESExUWFxgZGhscHR4fICEiIyQlJicpKissLi8wMTIzNDU2Nzg6Ozw+QEJDREVGR0lKTU5PUlVWV1lbXF1eX2RmZ2hpa2xtcHF0dXd4eXt8fn+AgoOFiImMjo+RkpSXmJqbnZ6jpaaqq62vsLK0tbe5ur7Bw8fIzM/R09XX2drc3uDi5Ojp6+3v8fP19/n7/f29yYMAAAP4SURBVBgZzcGNW1NVAAfg390duFCaSqJWwkohFBIQMJPUDAyN1ELTsjQ/MnVWMFKoCE2PSmbogsptApfffxrfsHPPvffc7fA8vS90ReI1h7+8dWdkbDI7+uDn3rP7q8osmGQnTtyn2/RPRyotGBHdO0RvU711Foq1q59Bcl9UIlDN9w8vr4VK5OBf1PKwDv6ucUbudbjYx3PU9rgJPlo4Z6oKkv0ZhvLndnj6gfOmqrFS1QhDS70ED/e5wElgSeQyC+F0QU1wkfMGFrzyhAUaXgMVwSXOm5hzlIXL1EJBcJmzA4B1k0XpgZvgCtM1KLnLIl2zIBNcafr9URbtdgQSQfOEjXyCq2DYQh5Bfc6jG+c+Odr92cVUmv5SyCOo5/GZnTEss+LvfpejtytYSVDD6LE4FBLXHXrpwAqCgX6thRf7yHOqTVdimWAA8Sr8RA5lqZS2sUTQ1/NmBIlepFIflgj6uVUCDVvTVGnAIkEfH0BPtI8K4xEsEPQ0sQPaTlKhBwsEPR1HCAepEMc8QW/NCKGNbr2YJ+ijCSF00m0D5gj6aUIIZ+lyA3MEfTUihLt0WYdZgv4aoS+WoewrzBIM0Ah9zZRNRDBDMMhu6BuirAEzBAPthrY4ZQOYIRisBtquUhYDIBjshQ1d5ZS9A0BQw05oS1KSBDBEDbugbRslOQAnqaEU+sYo2QiUjDNQD0LopuQggLJh+nM+RRiVlFzErNhGPy9HEIo1xXz3sAr6mW8Sq6CLklKYV0/JJphXQUkC5pVSUgfzbEpaYJ5FSTtWASUdMM+ipB3m2ZS0wLxSSupgXgUlCZhXT8kmmNdFSSnM62e+SZhnTTLfPZhXScklmNdNySGYN0bJRhi3jZIczEtSchPGlVO2D8ZdpSwG0+KUDcK4IcrehmnNlE1E4MlCIWIZys7DS1Nu6gAKcIcu5fCwlzMaEdoZuiThoY2znC0IqYNuG6DWynnP4wiljW4pqO3hoswmhPAeFdZDqZnLJhPQdoIKp6DUyJWmO6DH7qXCeAQquym5XQINW9JUaYBKA13+aUGQ6NdU6oNKNVUevAY/1oEMldI2VFJUG6yBF7vzX3qohNI5ekl3lEOh+ppDL51QKxmlt2ent5dhmRXfl8zS2zfwUvY3fTkieaHn6EenL/Q9pb9+eFufpRF3LPjYPEUDhA1fW7Ms2kAEAdaNskjXLQQq+Y1FOQUd1g0WLvMWNO3JsUDDMWhbM8BCOMcQSvsLhvZjGUKK9jgM5WktChC7RH1PWi0Upvy8Qy2P6lGE6OHfGWTi/FYUq+L4H/Tm9NdbMGJt65U03aZ/+XCzBZOiW1o//nZwZDzr5J49HEp93l691sL/yX+u8yfUO1Z3xQAAAABJRU5ErkJggg==) no-repeat}.vueditor .icon-unlink{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAACIlBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlDqg592AAAAtXRSTlMAAQIDBAUGBwgJCgsMDQ4PEBETFBUWFxgZGxwdHh8gISIjJCUmJygqKy0uLzAxMjM0NTY3ODk6Ozw9Pj9AQUJDRUZHSktMTU5PUFFSVFVWV1hZW1xdXl9hYmNkZmhpa2xtb3Bxc3R1d3h5e3x+f4CCg4WGiImLjI6PkZKUlZeam52eoKKlpqqrra+wsrS1t7m6vL7AwcPFx8jKzM7P0dPV19na3N7g4uTm6Onr7e/x8/X3+fv9SNvqbwAABZtJREFUGBm1wYt/1XUdx/H371x2hQHOmEmCLWnoBARJLC4SMQNLTSOTWE2JmzDYhKGSSWDyM34pBBsR6BQmOEAuu5zX/9dvt3N+n/P7ncP3HB97PvU9tZz/pF7VqV3+10+v3bk9ePLN1pTKGoSjqsaS0xSMdTepDCBQ5eYFFNmbVklAoIptGCdmqFmlAIEq9RZJxlpVAhCoQgdJlmtTMiBQZQ5SSu4JJQICJfHme0rUTWm5ViUBAiVoHOK/nhIcopzxx5UACBTXcANoUdwhyht7THFAoJj668BIVjGHeZCxRYoBAhWrGwLGlyimB+vm7k0dR0cxRh9VMSBQkdqrQK5VMb1Yv/cUyp7AGH1ERYBAVu3XQG6pYnqxVmlaL8bIQllAIKNmEMi1KWY/1jPK68O4/7AMIFBU9gtCTyrmRayVingf416zooBAEdnLhJYrphlrhYwPMe4+pAggUEHmEqFVihvAWC7LO4FxZ4EKgEB5mYuE1ijuKYynVcw7hfHdfOUBgWak+wn9XAn6iWpXnPcJxu15mgEEmpY+T2iDEswlql1JPB/j1lxNuwYfaErqLKFNSrKRiHYlSwUYw3M0ZcnQxSZNSn1GaIsSHaOgQ6WkPsP4tlGWd4bQViW7TN6gSkudw7jRIGMdod+qhDHyXlcZ6QsY1+sVtQX4nUqhYJXKyVzEGKpRRPrU8C9VEgXPqazM/zAueHJ1j7zdKi97BWO3XJ0j725a5dUMUnB/MGiQo70UHNUD1J44tuvVje2LmxszniqwnIguzY4sUZ2aHR8S9SdVr2WQuGs/UqgF44+q2nmSXNWEv2NsV7V8kgxoQt1djNdUpYa+IO54kyYtw3pFs+E3WC+pMulGOdiB9WtVZMHoejnYibVFlVgEe+SgE2uzKrAMOCIHf8F6Qe6eJ/SuHHRhrZezl5jQIwe7sJ6Xq04mHZKD3Vg/k6MepnTLwR6sZ+XmFNMOyME+rHo56WfGO3KwH6NGTr4lb58cHCAqJSdE7JWDbgpycpIiarccHCbvupzUYuySgx5mnJeTuhzG23LwLtNOys0yrC45OMKUw3LUjvVnOehj0k65WoHVKQfvMWGrnK3G2ikH7xNaK3fPYe2Qg+NAmyrwC6w35aAbHlUlNmK9IQebxxaoIpuxtsvBnIwq04HVodmwDWupJs3p8+N66lSllzHu1GrCAElOqVqvYXygCUMkOauq/QHjBwo9PkTcYIuqt4Oov2l2dBKV0ezoIqJdFfAyDc2L2ze88nbfiRo9QB8Fe+So4cyX9yn4Mqvy0nfJ+1yu9mFcyaq8veTdkavUAMaljMpaS4FK2jR8Mq2I2usYFzMqZzUFKuVl4FeKariBcSGtMraTN6oSthFaJ6NxGONcSqV9Rd4lJesgdMaTNecmxucplbKVgj4l2kzo3ylNmtN/bbGmNN3CCFJKtoKI9UryAqGzKU05BkOaNu82xqeekqwgaq4SrCf0n7Sm+YBmzP8O47SnuJVE9SvBWkIX0prhA8pbcAfjY0/FnsF4SnFrCA1klOcDKnjoLsY/PFmrMAYUt5LQpYwKfEARzfcwPvIUtRqrWTFPE7qcVYQPKOrh+xjHFfEs1ouKeZLQF1lF+YCMhSMY7ylvDdZ+xbTlgMEaGT4g65ERjCOatgarVzFLc8DXtbJ8QEV+OIpxslYh73WsHsW05oCrtSriAyq2aAxj/KNXt71zE6tHMUvGgaE6FfMBxTw2xoMcVkx2BPimXjE+oLjF45R3SHEtwI0GxfmAEvx4nHK6lcC7yLVGJfABJflJjtK6lazJUxIfUKKf5ijloCrjA0rWliPZAVXIB1TCE+Mk6VKlfEClNH9DzPg6VcwHVFJ6H0X+1aTK+YDKaDo4SsE/F6savTCoslKtb5y4Mnzrq9NvtdeoOvUfn12o7+n/kiPdwBPnoS8AAAAASUVORK5CYII=) no-repeat}.vueditor .icon-markdown{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAABMlBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlCgtID3AAAAZXRSTlMAAQIDBAYHCAsMDg8QExQXGBkcHyAjJCYoKSssLTEyNDc4OkBCRUlKS01OUFFWWVtcXWFiY2Roa21zdHh5gIOFhouUlZqiqKqvsLK0ubzFx8jKzM7P0dPV2tzk6Ovt7/P19/n7/UKwaqAAAAIQSURBVGje7dlrU9NAGAXg07QFLGi5KAUURUBAUItKW0XFgiIXlZulUqTaEs7//wt+aMJsk92aOL7FGfZ8S862TyYzuewGsLGxsbGxsbmK9BX2mxSIe7x6yzeeUDCvW0aRotkAgDEKZwFARRr55SBD8eSQk0fmMCmP5C3yvyNDSh6HBm+rtVq8MBVapO22+S4w9qxHbdVm0lT8GXEO28fegQCCzLnavYQIgodKtQshBGuXTb1HDHG++c0oxBD0u62iAEEE0yTJzxBFUCZZ7xVGnAqZgzCCAbcIcQSjiS4g+ljk+iK1qpdxtfB3VhsRkHuh/50KIEsdj6L3ZwQkXwxdlcGzcrMTsh3ldOU50fajZJVBpOKYjaeMhjT61O0PDCF8YzSyjIhwXznSRWoQjhmM5ElkhO8vt4apRc7SemSd0RHOeBvpH3qEm1pjinGQC2/2ukMDwke62XQzFsJaCgBKNCJuf8hIfGU8hJsA7tKMcC/0uCkwLsJnuNHohLAUMEYYH+H9A3ZEeLvNSJ3+DaKvld2nKbX4SBGktejgZZZCCKdDr5wCSNO/yyUOKYbwi7d3lYIIn8O8GBRAskrWwqPVOtgNAkjXhafYJw7wSXweX8ZSFxYLXl2HZY8uLKrNY0AeGQdq0oabBB5II8u61aB/nK3W43lF0ij7rwCZ0pHIB4GL728H7ecWGxsbGxubK8lvwLSCdxTXckYAAAAASUVORK5CYII=) no-repeat}.vueditor .icon-fullscreen{background:url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAMAAABHPGVmAAAAdVBMVEUAAAAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlAsPlBBOUZoAAAAJnRSTlMAAwQFDxIUISIjJTRCQ0p0dXd4iYudoKK5usXHzM7Z2vHz9ff7/axzRNIAAAC8SURBVGje7dZJDoJAFIThYrQBxREHcGDs+x/RBdHEDXHRZdTUf4FvV+8BSv1+SWlJlcnDWFliy9HYWWpbAMgtuRzwGzbS+FhYenMc+MgeNz5yxcBHBtgPJESIECFChAiZQGI3z3UsRIgQIUKECBEiRIgQIUKECBHyPpIGTkonEU5CvhCp+UaNio9U2PCRNQwfMcCJbRwBhC3XaEMAMB3T6GbjZkYXnnGOntOcFT1D6Ivs9QR4gfM8KPUf3QHmuxw5jd/C9wAAAABJRU5ErkJggg==) no-repeat}.vueditor [class^=icon]{width:16px;height:16px;display:inline-block;background-size:contain;vertical-align:bottom;opacity:.8}"],"sourceRoot":""}]);

// exports


/***/ }),
/* 831 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    class: _vm.classes
  }, [_c('label', {
    class: _vm.classesLabel
  }, [_vm._v(_vm._s(_vm.label) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "input-group__input",
    style: (("height: " + _vm.heightEditor))
  }, [_c('div', {
    attrs: {
      "id": "htmlValueEditor"
    }
  })]), _vm._v(" "), (_vm.hint) ? _c('div', {
    staticClass: "input-group__details"
  }, [_c('div', {
    staticClass: "input-group__messages input-group__hint v-messages theme--light v-messages__wrapper v-messages__message"
  }, [_vm._v(_vm._s(_vm.hint))])]) : _vm._e()])])
},staticRenderFns: []}

/***/ }),
/* 832 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(833);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("172c3cf9", content, true, {});

/***/ }),
/* 833 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".vueditor{min-height:38px;min-width:150px;border-top:none;border-left:none;border-right:none}.input-group--focused .vueditor{border-bottom-color:currentColor;border-bottom-width:2px}.vueditor .ve-toolbar{border-bottom-width:0}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/MacroField.vue"],"names":[],"mappings":"AACA,UACE,gBAAiB,AACjB,gBAAiB,AACjB,gBAAkB,AAClB,iBAAmB,AACnB,iBAAoB,CACrB,AACD,gCACE,iCAAkC,AAClC,uBAA0B,CAC3B,AACD,sBACE,qBAAyB,CAC1B","file":"MacroField.vue","sourcesContent":["\n.vueditor {\n  min-height: 38px;\n  min-width: 150px;\n  border-top:  none;\n  border-left:  none;\n  border-right:  none;\n}\n.input-group--focused .vueditor {\n  border-bottom-color: currentColor;\n  border-bottom-width:  2px;\n}\n.vueditor .ve-toolbar {\n  border-bottom-width: 0px;\n}\n\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 834 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vueditor__ = __webpack_require__(458);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vueditor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vueditor__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vueditor_lang_ru_js__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vueditor_macro_vue__ = __webpack_require__(460);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__vueditor_macro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__vueditor_macro_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vueditor_dist_style_vueditor_min_css__ = __webpack_require__(461);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vueditor_dist_style_vueditor_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vueditor_dist_style_vueditor_min_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var plugins = [{
  name: 'macro',
  element: {
    type: 'button',
    lang: {
      title: 'Макрос'
    },
    className: 'icon-macro'
  },
  component: __WEBPACK_IMPORTED_MODULE_2__vueditor_macro_vue___default.a
}];

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-macro-field',
  props: {
    label: null,
    value: {
      type: String,
      default: ''
    },
    hint: null,
    heightEditor: {
      type: String,
      default: '36px'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    macro: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      editor: null,
      isDirty: false,
      focused: false
    };
  },
  mounted: function mounted() {
    if (!this.editor) {
      this.editor = this.genEditor();
    }
    this.setValue(this.value);
    this.setReadonly(this.readonly);
  },

  watch: {
    value: function value(newValue) {
      this.setValue(newValue);
    },
    readonly: function readonly(newValue) {
      this.setReadonly(newValue);
    }
  },
  computed: {
    classes: function classes() {
      return {
        // '.pa-0': this.solo,
        'input-group--solo': this.solo,
        'elevation-0': this.flat,
        'input-group': true,
        'input-group--text-field': true,
        'primary--text': this.focused,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': true
      };
    },
    classesLabel: function classesLabel() {
      return {
        'caption': true,
        'v-label': true,
        'theme--light': !this.focused
      };
    }
  },
  methods: {
    setValue: function setValue(value) {
      // console.log('setValue', value)
      this.editor && value && (this.editor.value = value);
    },
    setReadonly: function setReadonly(value) {
      this.editor && (this.editor.readonly = value);
    },
    genEditor: function genEditor() {
      var _this = this;

      var config = {
        toolbar: ['fullscreen', 'sourceCode', 'undo', 'redo', '|',
        // 'element',
        'fontName', 'fontSize', 'foreColor', 'backColor', 'divider', 'bold', 'italic', 'underline', 'strikeThrough', 'link', 'unLink',
        // 'divider', 'subscript', 'superscript',
        'divider', 'justifyLeft', 'justifyCenter', 'justifyRight', 'justifyFull', '|', 'indent', 'outdent', 'insertOrderedList', 'insertUnorderedList', '|',
        // 'picture', 'table', '|',
        // 'code',
        'removeFormat', '|', 'macro'
        // , 'markdown'
        ],
        shortbar: [],
        fontName: [{ val: 'Arial' }, { val: 'Times New Roman' }, { val: 'Courier New' }],
        headStyle: '\n          <style>\n            body {font-family: Arial; margin: 0; padding-top: 8px; padding-bottom: 8px; line-height: 20px;}\n            pre {margin: 0; padding: 0.5rem;}\n          </style>',
        lang: __WEBPACK_IMPORTED_MODULE_1__vueditor_lang_ru_js__["a" /* default */]
      };
      if (this.macro) {
        config.plugins = plugins;
      }
      var inst = Object(__WEBPACK_IMPORTED_MODULE_0_vueditor__["createEditor"])('#htmlValueEditor', config);
      inst.$on('input', function () {
        _this.$emit('input', inst.getContent());
      });
      inst.$on('focus', function () {
        _this.focused = true;
      });
      inst.$on('blur', function () {
        _this.focused = false;
      });
      inst.value = null;
      return inst;
    },
    showPopup: function showPopup(e) {
      var obj = e.target;
      var action = 'macro';
      if (this.editor) {
        // this.editor.$store.dispatch('showPopup', { name: action, params: null })
        this.editor.$store.dispatch('updatePopupDisplay', { name: action, display: true });
        this.editor.$store.dispatch('updateRect', {
          left: obj.offsetLeft,
          top: obj.offsetTop,
          width: obj.offsetWidth,
          height: obj.offsetHeight + parseInt(window.getComputedStyle(obj).marginBottom)
        });
      }
    }
  }
});

/***/ }),
/* 835 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-input v-text-field"
  }, [_c('div', {
    class: _vm.classes,
    staticStyle: {
      "position": "relative",
      "width": "100%"
    }
  }, [_c('div', {
    staticClass: "input-group__input",
    style: (("height: " + _vm.heightEditor + ";"))
  }, [_c('label', {
    class: _vm.classesLabel,
    staticStyle: {
      "position": "absolute",
      "left": "0px",
      "top": "-16px"
    }
  }, [_vm._v(_vm._s(_vm.label) + " ")]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "htmlValueEditor"
    }
  })]), _vm._v(" "), (_vm.hint) ? _c('div', {
    staticClass: "input-group__details"
  }, [_c('div', {
    staticClass: "input-group__messages input-group__hint v-messages theme--light v-messages__wrapper v-messages__message"
  }, [_vm._v(_vm._s(_vm.hint))])]) : _vm._e()]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "small": "",
      "icon": ""
    },
    on: {
      "click": _vm.showPopup
    }
  }, [_c('i', {
    staticClass: "v-icon theme--light icon-macro",
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "display": "inline-block",
      "background-size": "contain"
    }
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(837);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("b2690afa", content, true, {});

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".set-field{overflow-wrap:anywhere;font-size:14px}.set-field:hover{background:rgba(0,0,0,.04)}.set-time{display:block;text-align:left}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/ItemsField.vue"],"names":[],"mappings":"AACA,WACE,uBAAwB,AACxB,cAAgB,CACjB,AACD,iBACE,0BAAgC,CACjC,AACD,UACE,cAAe,AACf,eAAiB,CAClB","file":"ItemsField.vue","sourcesContent":["\n.set-field {\n  overflow-wrap: anywhere;\n  font-size: 14px;\n}\n.set-field:hover {\n  background: rgba(0, 0, 0, 0.04);\n}\n.set-time {\n  display: block;\n  text-align: left;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 838 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_formats_js__ = __webpack_require__(5);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-items-field',
  props: {
    label: null,
    value: null,
    itemTitle: {
      type: String,
      default: 'title'
    },
    itemDate: {
      type: String,
      default: 'date'
    },
    itemText: {
      type: String,
      default: 'text'
    },
    itemValue: {
      type: String,
      default: 'value'
    },
    itemIcons: {
      type: String,
      default: 'icons'
    },
    smallIcons: {
      type: Boolean,
      default: false
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    icons: {
      type: Array,
      default: function _default() {
        return [
        // {code: 'OK', icon: 'check_circle_outline', class: 'normal--text', text: 'Завершено'},
        { code: 'OK', icon: 'done', class: 'normal--text', text: 'Завершено' }, { code: 'WARNING', icon: 'error_outline', class: 'warning--text', text: 'Предупреждение' }, { code: 'ERROR', icon: 'error_outline', class: 'error--text', text: 'Ошибка' }, { code: 'CANCEL', icon: 'not_interested', class: 'normal--text', text: 'Отменено' }, { code: 'SCHEDULE', icon: 'schedule', class: 'warning--text', text: 'Запланировано' }, { code: 'PROCESS', icon: 'loop', class: 'warning--text', text: 'Выполняется' }];
      }
    }
  },
  data: function data() {
    return {
      active: null
    };
  },
  created: function created() {},
  mounted: function mounted() {
    this.active = this.parse(this.value);
  },

  watch: {
    value: function value(newValue) {
      this.active = this.parse(newValue);
    }
  },
  computed: {},
  methods: {
    classes: function classes() {
      return {
        // '.pa-0': this.solo,
        'input-group--solo': this.solo,
        'elevation-0': this.flat,
        'input-group': true,
        'input-group--text-field': true,
        'primary--text': this.focused,
        'input-group--focused': this.focused,
        'input-group--dirty': this.isDirty,
        'input-group--tab-focused': true
      };
    },
    classesLabel: function classesLabel() {
      return {
        'caption': true,
        'v-label': true,
        'theme--light': !this.focused
      };
    },
    getField: function getField(item, fieldName) {
      return item[fieldName] || null;
    },
    getItemKey: function getItemKey(item) {
      return item[this.itemValue];
    },
    getItemText: function getItemText(item) {
      console.log('getItemText', item);
      return item[this.itemText];
    },
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_1__api_formats_js__["a" /* default */].createComp('<span>' + template + '</span>');
    },
    formatDateTime: function formatDateTime(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_1__api_formats_js__["a" /* default */].formatDateTime(dateTime).replace(',', '');
    },
    parse: function parse(v) {
      if (Array.isArray(v)) {
        return v;
      } else {
        return v && v.split(', ') || [];
      }
    },
    onChange: function onChange(e) {
      this.$emit('input', e.join(', '));
    },
    onClick: function onClick(item) {
      this.$emit('click', item);
    },
    renderIcons: function renderIcons(codes) {
      if (!(codes && Array.isArray(codes) && codes.length > 0)) {
        return null;
      }
      var smallIcons = this.smallIcons;
      var template = '\n        <v-tooltip lazy bottom open-delay="500" max-width="20em">\n          <span slot="activator">\n            <template v-for="flag in flags">\n              <v-icon :small="small" :class="flag.class">{{flag.icon}}</v-icon>\n            </template>\n          </span>\n            <template v-for="flag in flags">\n              <div>\n                <v-icon small :class="flag.class">{{flag.icon}}</v-icon>\n                {{flag.text}}\n              </div>\n            </template>\n        </v-tooltip>\n      ';
      var flagSet = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(codes);
      var flagList = this.icons;
      var flags = flagList.filter(function (f) {
        return flagSet.has(f.code);
      });
      return {
        template: template,
        data: function data() {
          return {
            flags: flags,
            small: smallIcons
          };
        }
      };
    }
  }
});

/***/ }),
/* 839 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "v-input",
    class: _vm.classes()
  }, [_c('v-flex', {
    staticClass: "input-group__input"
  }, [_c('label', {
    class: _vm.classesLabel()
  }, [_vm._v(_vm._s(_vm.label) + " ")]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return [_c('v-flex', {
      staticClass: "set-field v-list--dense",
      attrs: {
        "px-2": ""
      },
      on: {
        "click": function($event) {
          return _vm.onClick(item)
        }
      }
    }, [(item[_vm.itemTitle] || item[_vm.itemDate]) ? _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs9": "",
        "sm10": ""
      }
    }, [_c(_vm.createComp(_vm.getField(item, _vm.itemTitle)), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "v-list__tile__action-text",
      staticStyle: {
        "display": "block",
        "text-align": "end",
        "white-space": "normal"
      },
      attrs: {
        "xs3": "",
        "sm2": "",
        "align-end": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formatDateTime(_vm.getField(item, _vm.itemDate))))])])], 1) : _vm._e(), _vm._v(" "), _c('v-layout', {
      staticClass: "v-list__tile__sub-title",
      staticStyle: {
        "white-space": "normal"
      },
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_c(_vm.getField(item, _vm.itemText) || _vm.createComp(Object.values(item)[0]), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-flex', {
      staticStyle: {
        "text-align": "end"
      }
    }, [_c(_vm.renderIcons(_vm.getField(item, _vm.itemIcons)), {
      tag: "v-component"
    })], 1)], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 840 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.scheme), function(field, index) {
    return (_vm.checkIf(field)) ? _c('v-flex', {
      key: index,
      attrs: {
        "grow": field.grow || false,
        "shrink": field.shrink || false,
        "xs2": _vm.checkSize(field, 'xs2'),
        "xs4": _vm.checkSize(field, 'xs4'),
        "xs6": _vm.checkSize(field, 'xs6'),
        "xs8": _vm.checkSize(field, 'xs8'),
        "xs10": _vm.checkSize(field, 'xs10'),
        "xs12": _vm.checkSize(field, 'xs12'),
        "sm2": _vm.checkSize(field, 'sm2'),
        "sm4": _vm.checkSize(field, 'sm4'),
        "sm6": _vm.checkSize(field, 'sm6'),
        "sm8": _vm.checkSize(field, 'sm8'),
        "sm10": _vm.checkSize(field, 'sm10'),
        "sm12": _vm.checkSize(field, 'sm12'),
        "pa-1": ""
      }
    }, [_c(field.fieldType, _vm._g(_vm._b({
      ref: _vm.checkFocused(field),
      refInFor: true,
      tag: "component",
      attrs: {
        "tabindex": _vm.calcTabIndex(field),
        "value": _vm.formData[field.name],
        "hint": _vm.calcHint(field),
        "error-messages": _vm.calcErrors(field),
        "items": _vm.calcItems(field),
        "emptyChip": _vm.calcEmptyChip(field),
        "disabled": _vm.checkDisabled(field)
      },
      on: {
        "input": function($event) {
          return _vm.updateForm(field, $event)
        },
        "change": function($event) {
          return _vm.formatForm(field, $event)
        }
      }
    }, 'component', field, false), field.events || {}), [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.calcSlot(field))
      }
    })])], 1) : _vm._e()
  }), 1)
},staticRenderFns: []}

/***/ }),
/* 841 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Добавить")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.createNew
          }
        }, [_vm._v("Новый")])]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_vm._l((_vm.strategy.getSteps()), function(step) {
    return [_c('v-step-generator', _vm._b({
      tag: "component",
      model: {
        value: (step.model),
        callback: function($$v) {
          _vm.$set(step, "model", $$v)
        },
        expression: "step.model"
      }
    }, 'component', step.props, false))]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(843),
  /* template */
  __webpack_require__(844),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 843 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BtnForm__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






// import depo from '.'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'strategy-selector',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default.a },
  data: function data() {
    return {
      cxt: null
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: 'Выберите документ'
    }
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return _this.getItemKey(item);
      });
    });
    cxt.mode = __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].modes.SELECT;
    this.cxt = cxt;
    if (this.selected != null) {
      this.selected.forEach(function (id) {
        return _this.cxt.select(id);
      });
    }
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    calcDialogScroll: 'calcDialogScroll'
  }), {
    orderedItems: function orderedItems() {
      // console.log('orderedItems', this.items)
      return this.items.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.text, b.text);
      });
    },
    filteredItems: function filteredItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.text);
      };
      var filter = !this.cxt.isFilterMode() || this.cxt.filterString === null || this.cxt.filterString.length < 3 ? null : this.cxt.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
    }
  }),
  methods: {
    getItemKey: function getItemKey(item) {
      return item.value;
    },
    ok: function ok() {
      this.$emit('input', this.cxt.selected());
      this.cancel();
    },
    cancel: function cancel() {
      this.$emit('close');
      this.itemId = null;
    },
    select: function select(uid) {
      if (this.cxt.uncheck(uid)) {
        if (this.radio) {
          this.cxt.clear();
        }
      }
      this.cxt.select(uid);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
    }
  }
});

/***/ }),
/* 844 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")])]
      },
      proxy: true
    }])
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-content', [_c('b', [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('v-list-tile-action', [(_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(846),
  /* template */
  __webpack_require__(847),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 846 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_BtnForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_HtmlField__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_HtmlField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_HtmlField__);

//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'editor-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_2__common_BtnForm___default.a, vHtmlField: __WEBPACK_IMPORTED_MODULE_3__common_HtmlField___default.a },
  data: function data() {
    return {
      text: null
    };
  },
  props: {
    value: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Редактор HTML'
    },
    readonly: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.setText(this.value);
  },

  watch: {
    value: function value(newValue) {
      this.setText(newValue);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  })),
  methods: {
    calcHeightEditor: function calcHeightEditor() {
      return this.calcDialogScroll(48 + 52, 48 + 52);
    },
    cancel: function cancel() {
      this.$emit('close');
    },
    save: function save() {
      var text = this.editor.getContent();
      this.$emit('change', text);
      this.cancel();
    },
    setText: function setText(value) {
      this.text = value;
    }
  }
});

/***/ }),
/* 847 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": _vm.readonly
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")])]
      },
      proxy: true
    }])
  }, [_c('v-card', [_c('v-html-field', {
    attrs: {
      "heightEditor": _vm.calcHeightEditor()
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(849),
  /* template */
  __webpack_require__(889),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 849 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_SelectCheck_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_SelectCheck_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_SelectCheck_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_BtnForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_HtmlField__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_HtmlField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_HtmlField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











// import people from './index.js'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'email-form',
  components: { vSelectCheck: __WEBPACK_IMPORTED_MODULE_5__common_SelectCheck_vue___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_6__common_BtnForm___default.a, vHtmlField: __WEBPACK_IMPORTED_MODULE_7__common_HtmlField___default.a, vDateField: __WEBPACK_IMPORTED_MODULE_8__common_DateField_vue___default.a },
  data: function data() {
    return {
      to: null,
      text: null,
      iframeWin: null,
      subject: null,
      options: null,
      scheduledDate: null,
      scheduledTime: null,
      mailbox: null,
      mailboxes: [],
      valid: false,
      emailRules: [function (v) {
        return !!v || 'Введите адреса электронной почты';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].isEmails(v) || 'Неверный формат эл. почты';
      }]
    };
  },
  props: {
    model: {
      type: Object,
      default: function _default() {
        return { uids: [], to: '', subject: '', options: '', body: '', signature: null, mailbox: null };
      }
    },
    value: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Редактор почтового сообщения'
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchData(this.model);
  },

  watch: {
    model: function model(newValue) {
      this.fetchData(newValue);
    },
    options: function options(newVal, oldVal) {
      if (oldVal !== null) {
        __WEBPACK_IMPORTED_MODULE_3__common_dialogs__["a" /* default */].confirm(this, 'Внимание', '\u0422\u0435\u043A\u0441\u0442 \u043F\u0438\u0441\u044C\u043C\u0430 \u0431\u0443\u0434\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u043D \u0437\u0430\u043D\u043E\u0432\u043E, \u0445\u043E\u0440\u043E\u0448\u043E?', function (self) {
          self.generateBody(self.model, newVal);
        });
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  })),
  methods: {
    calcHeightEditor: function calcHeightEditor() {
      var height = 280 - 14 - 36;
      return height + 'px';
    },
    cancel: function cancel() {
      // this.item = Object.assign({}, this.getItemNew())
      this.$emit('close');
    },
    send: function send() {
      var scheduled = null;
      if (this.scheduledDate || this.scheduledTime) {
        var scheduledDate = this.scheduledDate || __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('YYYY-MM-DD');
        var scheduledTime = this.scheduledTime || __WEBPACK_IMPORTED_MODULE_9_moment___default()().format('HHmm');
        scheduled = __WEBPACK_IMPORTED_MODULE_9_moment___default()(scheduledDate + ' ' + scheduledTime, 'YYYY-MM-DD HHmm', false);
      }
      var request = { email: this.to, subject: this.subject, body: this.text, uids: this.isAttach(this.options) ? this.model.uids : null, mailbox: this.mailbox, scheduled: scheduled && scheduled.isValid() && scheduled.format() || null, attach: this.isAttach(this.options) };
      this.$emit('change', request);
      this.cancel();
    },
    fetchData: function fetchData(model) {
      var _this = this;

      this.to = model.to;
      if (!this.options) {
        this.options = model.options;
        if (model.options && !model.options.toUpperCase().includes('ATTACH')) {
          this.options = 'ATTACH';
        }
      }
      this.subject = model.subject;
      this.generateBody(model, this.options);
      this.$store.dispatch('getClientMailboxes').then(function (mbs) {
        _this.mailboxes = mbs;
        var name = model.mailbox;
        if (name) {
          _this.mailbox = mbs.reduce(function (accumulator, curValue) {
            return curValue.name === name ? name : accumulator;
          }, '');
        } else {
          _this.mailbox = mbs.length > 0 && mbs[0].name || '';
        }
      });
    },
    setText: function setText(value) {
      this.text = value;
    },
    init: function init(event) {
      this.iframeWin = event.target.contentWindow;
    },
    isAttach: function isAttach(options) {
      return options && options.toUpperCase().includes('ATTACH');
    },
    generateBody: function generateBody(model, options) {
      var _this2 = this;

      this.$store.dispatch('getClientAccount').then(function (clientAccount) {
        if (!_this2.isAttach(options)) {
          __WEBPACK_IMPORTED_MODULE_4__depo__["a" /* default */].getPropsHtml(model.uids, model.body, model.subject, clientAccount.signature).then(function (data) {
            _this2.setText(data.body);
          });
        } else {
          _this2.setText(model.body + '<br/>' + clientAccount.signature);
        }
      });
    }
  }
});

/***/ }),
/* 850 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(851),
  /* template */
  __webpack_require__(852),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_files__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_utils__ = __webpack_require__(152);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_BtnForm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doc-new',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_9__common_DateField_vue___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_10__common_BtnForm___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_7__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      isProcessing: false,
      oldBody: true,
      valid: false,
      imageFile: null,
      files: [],
      fileItem: null,
      oldFileItem: null,
      errorMessage: null
    };
  },
  props: {
    toolbar: {
      type: Boolean,
      default: false
    },
    fileItemId: {
      type: String,
      default: null
    },
    newPath: {
      type: String,
      default: '/'
    },
    newTags: {
      type: String,
      default: ''
    }
  },
  created: function created() {
    this.fileItem = this.getFileItemNew();
    this.fetchData(this.fileItemId);
  },
  mounted: function mounted() {
    this.fileItem.tags = this.newTags ? this.newTags.concat(this.fileItem.tags) : this.fileItem.tags;
  },

  watch: {
    fileItemId: function fileItemId(newVal, oldVal) {
      // watch it
      this.fetchData(newVal);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    getDepoDisplayPaths: 'getDepoDisplayPaths',
    getOpenSettings: 'getOpenSettings',
    renderDepoFileSignature: 'renderDepoFileSignature',
    getDepoUrl: 'getDepoUrl'
  }), {
    isNew: function isNew() {
      return this.fileItemId === null;
    },
    title: function title() {
      return this.isNew ? 'Депонирование файла' : 'Депонирование новой версии файла';
    },

    deleted: {
      get: function get() {
        return new Date(this.fileItem.deleted).toISOString();
      },
      set: function set(value) {
        this.fileItem.deleted = value;
      }
    }
  }),
  methods: {
    errorFileMessage: function errorFileMessage(file) {
      return __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].errorFileMessage(file);
    },
    fetchData: function fetchData(itemId) {
      var _this = this;

      if (itemId) {
        this.$store.dispatch('getDepoFile', itemId).then(function (fs) {
          _this.oldFileItem = fs && fs.length ? fs[0] : null;
          if (_this.oldFileItem) {
            _this.fileItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.oldFileItem, _this.getFileVersionNew());
            _this.fileItem.prevUid = _this.oldFileItem.uid;
          } else {
            _this.fileItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.getFileItemNew());
          }
          _this.oldBody = false;
        }, function () {});
      } else {
        this.fileItem = this.getFileItemNew();
        this.fileItem.path = this.newPath;
      }
    },
    getAcceptedFileFormat: function getAcceptedFileFormat() {
      return '.pdf, .docx, .rtf, .csv, xlsx, .pptx, .odt, .ods, .odp, image/*';
    },
    disableUpload: function disableUpload() {
      var _this2 = this;

      if (this.isProcessing) {
        return true;
      }
      if (this.isNew || !this.oldBody) {
        var filesErrors = this.files.reduce(function (s, file) {
          return s || _this2.errorFileMessage(file);
        }, null) !== null;
        return !this.valid || this.files.length < 1 || filesErrors;
      } else {
        return this.oldFileItem && this.oldFileItem.docName === this.fileItem.docName && __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDate(this.oldFileItem.deleted) === __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDate(this.fileItem.deleted);
      }
    },
    upload: function upload() {
      var _this3 = this;

      if (this.isProcessing) {
        return;
      }
      if (this.$refs.form.validate()) {
        this.isProcessing = true;
        if (this.isNew || !this.oldBody) {
          this.$store.dispatch('uploadDepoFiles', { docItem: this.fileItem, files: this.files }).then(function (uids) {
            return _this3.onUploaded(uids);
          });
        } else {
          this.$store.dispatch('uploadDepoFile', { fileItem: this.fileItem, file: null }).then(function (uid) {
            return _this3.onUploaded([uid]);
          });
        }
      }
    },
    onUploaded: function onUploaded(uids) {
      this.isProcessing = false;
      this.$emit('input', uids);
      this.cancel();
    },
    cancel: function cancel() {
      this.fileItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getFileItemNew());
      this.$emit('close');
    },
    pickFile: function pickFile() {
      this.$refs.image.click();
    },
    onUpdateFiles: function onUpdateFiles() {
      if (this.isNew) {
        if (this.files.length === 1) {
          this.fileItem.docName = this.files[0].name.substring(0, this.files[0].name.lastIndexOf('.'));
        } else {
          this.fileItem.docName = '';
        }
      }
    },
    addFile: function addFile(file) {
      var _this4 = this;

      var self = this;
      var add = function add(file) {
        console.log('addFile', file);
        file.remove = function (e) {
          !e && self.deleteFile(file);
        };
        _this4.files.push(file);
        _this4.onUpdateFiles();
      };
      if (!this.files.find(function (f) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(f.name, file.name) === 0;
      })) {
        __WEBPACK_IMPORTED_MODULE_6__api_utils__["a" /* default */].compress(file, add, {});
      }
    },
    deleteFile: function deleteFile(file) {
      this.files = this.files.filter(function (f) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(f.name, file.name) !== 0;
      });
      this.onUpdateFiles();
    },
    onFilePicked: function onFilePicked(e) {
      var _this5 = this;

      var files = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(e.target.files);
      var readFile = function readFile(file, cb) {
        var reader = new FileReader();
        reader.onload = function () {
          cb(file);
        };
        reader.readAsDataURL(file);
      };
      var addFile = function addFile(file) {
        return _this5.addFile(file);
      };
      if (files.length > 0) {
        files.forEach(function (f) {
          return readFile(f, function (file) {
            addFile(file);
          });
        });
      }
    },
    getDeleted: function getDeleted(dateTime) {
      return new Date(dateTime);
    },
    getFileItemNew: function getFileItemNew() {
      return {
        uid: null,
        fileNo: null,
        fileName: null,
        fileExt: null,
        fileSize: null,
        docName: null,
        desc: null,
        ownerInn: null,
        ownerNameShort: null,
        account: null,
        uploaded: null,
        path: '/',
        tags: '',
        folder: null,
        deleted: __WEBPACK_IMPORTED_MODULE_8_moment___default()().add(7, 'years').format()
      };
    },
    getFileVersionNew: function getFileVersionNew() {
      return {
        uid: null,
        fileNo: null,
        fileName: null,
        fileExt: null,
        fileSize: null
      };
    },
    getDisplayPath: function getDisplayPath(path) {
      return this.getDepoDisplayPaths ? this.getDepoDisplayPaths.get(path) : '';
    },
    getDisplayPaths: function getDisplayPaths() {
      var map = this.getDepoDisplayPaths;
      var result = [];
      if (!map) {
        return result;
      }
      map.forEach(function (val, key) {
        return result.push({ key: key, value: val });
      });
      // console.log('getDisplayPaths', result)
      return result.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(a.value, b.value);
      });
    }
  }
});

/***/ }),
/* 852 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    ref: "btnForm",
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card', [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isNew),
      expression: "!isNew"
    }],
    attrs: {
      "column": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('v-flex', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))]), _vm._v(" "), (_vm.fileItem.signed) ? _c('v-flex', {
    staticClass: "caption"
  }, [_vm._v("Документ заверен, после загрузки новой версии необходимо снова заверить документ")]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', [(_vm.isNew) ? _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                  " + _vm._s(item.name.slice(0, 30)) + "\n                ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                Выбрать файл для депонирования\n                ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat(),
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Название",
      "hint": "Название документа может не совпадать с именем файла",
      "disabled": _vm.files.length > 1,
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.docName),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "docName", $$v)
      },
      expression: "fileItem.docName"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Депонировать до:",
      "hint": "Дата, до которой файл доступен в депозитарии"
    },
    model: {
      value: (_vm.deleted),
      callback: function($$v) {
        _vm.deleted = $$v
      },
      expression: "deleted"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }],
    attrs: {
      "label": "Примечания",
      "rows": "2",
      "hint": "Примечания видны только для пользователей депонента",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.desc),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "desc", $$v)
      },
      expression: "fileItem.desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }],
    attrs: {
      "label": "Поисковые теги",
      "hint": "Поисковые теги используются для поиска по документам депонента",
      "rows": "1",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.tags),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "tags", $$v)
      },
      expression: "fileItem.tags"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.isNew) ? _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_vm._v("\n          Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.fileItem.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(_vm.fileItem.deleted, _vm.formats.formatDate)) + ")\n        ")]), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v(" Депонент: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.ownerShortName))]), _vm._v("\n           ИНН: "), _c('b', [_vm._v(_vm._s(_vm.formats.formatInn(_vm.fileItem.ownerInn)))])])]), _vm._v(" "), _c('v-flex', [_c('span', {
    staticClass: "caption"
  }, [_vm._v("Вы можете загрузить в депозитарий новую версию документа и использовать новую ссылку. Использование старой ссылки позволит видеть историю изменений. ")])]), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Название",
      "hint": "Название документа может не совпадать с именем файла",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.docName),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "docName", $$v)
      },
      expression: "fileItem.docName"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Депонировать до:",
      "hint": "Дата, до которой файл доступен в депозитарии"
    },
    model: {
      value: (_vm.deleted),
      callback: function($$v) {
        _vm.deleted = $$v
      },
      expression: "deleted"
    }
  })], 1), _vm._v(" "), _c('v-flex', [(!_vm.oldBody) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                  " + _vm._s(item.name.slice(0, 30)) + "\n                ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n                Выбрать файл для депонирования\n                ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat()
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-4": "",
      "pt-1": ""
    }
  }, [_c('v-checkbox', {
    attrs: {
      "label": "не загружать файл",
      "persistent-hint": "",
      "color": "secondary",
      "hint": "Версия создается для изменения атрибутов"
    },
    model: {
      value: (_vm.oldBody),
      callback: function($$v) {
        _vm.oldBody = $$v
      },
      expression: "oldBody"
    }
  })], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": _vm.disableUpload()
    },
    on: {
      "click": _vm.upload
    }
  }, [_vm._v("Загрузить")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_js__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doc-form',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_7__common_DateField_vue___default.a, vPanelTitle: __WEBPACK_IMPORTED_MODULE_8__info_PanelTitle___default.a, vOpsBtn: __WEBPACK_IMPORTED_MODULE_10__common_OpsBtn___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_12__common_BtnForm___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      cxt: null,
      edit: false,
      valid: false,
      fileItem: null,
      historyItems: [],
      isLoaded: false,
      fileRule: [function (v) {
        return !!v || 'Выберите файл';
      }]
    };
  },
  props: {
    toolbar: {
      type: Boolean,
      default: false
    },
    fileItemId: {
      type: String,
      default: null
    },
    newPath: {
      type: String,
      default: '/'
    },
    readonly: {
      type: Boolean,
      default: false
    },
    exactVersion: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    var _this = this;

    this.fetchRights();
    this.fetchData(this.fileItemId);
    var cxt = new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].MultiSelectContext(function () {
      return [_this.fileItemId];
    });
    cxt.mode = __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].modes.SELECT;
    // cxt.selectActions.push(new classes.Action(this, 'Копировать Ссылку', null,
    //   () => { this.copyLink() }))
    // cxt.selectActions.push(new classes.Action(this, 'Изменить Атрибуты',
    //   () => {
    //     return this.historyItems && this.historyItems.length > 0 && this.historyItems[0].uid.localeCompare(this.fileItemId) === 0
    //   },
    //   () => { this.edit = true }))
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Загрузить новую версию', null, function () {
      return _this.newVersion();
    }));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Заверить электронную копию', function () {
      return !(_this.fileItem && _this.fileItem.signed) && _this.getIsAllow({ SIGN_FILE: null });
    }, function () {
      return _this.signFile([_this.fileItem.uid]);
    }));
    this.cxt = cxt;
  },

  watch: {
    fileItemId: function fileItemId(newVal, oldVal) {
      // watch it
      this.fetchData(newVal);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getDepoDisplayPaths: 'getDepoDisplayPaths',
    getOpenSettings: 'getOpenSettings',
    getIsAllow: 'getIsAllow',
    getDepoUrl: 'getDepoUrl',
    renderDepoFileSignature: 'renderDepoFileSignature'
  }), {
    isEdit: function isEdit() {
      return this.edit;
    },
    title: function title() {
      return this.isEdit ? 'Изменить атрибуты депонированного файла' : 'Депонированный файл';
    },
    history: function history() {
      return this.historyItems;
    }
  }),
  methods: {
    fetchData: function fetchData(itemId) {
      var _this2 = this;

      if (itemId) {
        this.$store.dispatch('getDepoFile', itemId).then(function (fs) {
          var fileItems = _this2.exactVersion ? fs.filter(function (f) {
            return f.uid === itemId;
          }) : [fs[0]];
          _this2.fileItem = fileItems && fileItems.length > 0 ? __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, fileItems[0]) : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, _this2.getFileItemNew());
          _this2.historyItems = fs;
        }, function () {});
      } else {
        this.fileItem = this.getFileItemNew();
      }
    },
    save: function save() {
      this.$store.dispatch('updateDepoFile', this.fileItem);
      this.edit = false;
    },
    cancel: function cancel() {
      this.edit = false;
      this.fileItem = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getFileItemNew());
      this.$emit('close');
    },
    newVersion: function newVersion() {
      this.$emit('new-version');
      this.cancel();
    },
    signFile: function signFile(ids) {
      var _this3 = this;

      var fetchData = function fetchData() {
        _this3.fetchData(_this3.fileItem.uid);
      };
      __WEBPACK_IMPORTED_MODULE_3__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0417\u0430\u0432\u0435\u0440\u0438\u0442\u044C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u043D\u043D\u044B\u0435 \u043A\u043E\u043F\u0438\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432?', function (self) {
        self.$store.dispatch('signDepoFiles', { uids: ids }).then(function () {
          fetchData();
        });
      });
      this.edit = false;
    },
    open: function open(uid) {
      var url = this.getUrl(uid) + '/stream';
      this.$store.dispatch('openLocation', url);
    },
    getUrl: function getUrl(uid) {
      return this.getDepoUrl(uid);
    },
    getFileItemNew: function getFileItemNew() {
      return {
        uid: null,
        fileNo: null,
        fileName: null,
        fileExt: null,
        fileSize: null,
        docName: null,
        desc: null,
        ownerInn: null,
        ownerNameShort: null,
        account: null,
        uploaded: null,
        path: '//root',
        tags: null,
        folder: null,
        deleted: __WEBPACK_IMPORTED_MODULE_6_moment___default()().add(7, 'years').format()
      };
    },
    getDisplayPath: function getDisplayPath(path) {
      return this.getDepoDisplayPaths ? this.getDepoDisplayPaths.get(path) : '';
    },
    getDisplayPaths: function getDisplayPaths() {
      var map = this.getDepoDisplayPaths;
      var result = [];
      if (!map) {
        return result;
      }
      map.forEach(function (val, key) {
        return result.push({ key: key, value: val });
      });
      // console.log('getDisplayPaths', result)
      return result.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(a.value, b.value);
      });
    },
    copyLink: function copyLink() {
      this.$store.dispatch('copyDepoFileLink', this.getUrl(this.fileItem.uid));
    },
    createCopyButton: function createCopyButton(caption, icon, hint, action) {
      var template = ''.concat('<div><v-tooltip bottom open-delay="500">\n          <div slot="activator">\n            <v-btn  @click="action">\n              <v-icon small>{{icon}}</v-icon>{{caption}}\n            </v-btn>\n          </div>\n          <span>{{hint}}</span>\n        </v-tooltip></div>');
      return {
        template: template,
        data: function data() {
          return {
            caption: caption,
            icon: icon,
            hint: hint,
            action: action
          };
        }
      };
    },
    openFile: function openFile(id) {
      __WEBPACK_IMPORTED_MODULE_11__index_js__["a" /* default */].openFile(id, this.getDepoCurrentPath, true, null, true);
    },
    fetchRights: function fetchRights() {
      this.$store.dispatch('fetchRights', { SIGN_FILE: null });
    }
  }
});

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_PrintBtn__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_PrintBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_PrintBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-panel-title',
  components: { vPrintBtn: __WEBPACK_IMPORTED_MODULE_0__common_PrintBtn___default.a },
  data: function data() {
    return {};
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    expandable: {
      type: Boolean,
      default: true
    },
    printActions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    caption: {
      type: String,
      default: ''
    },
    primary: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    expandableInt: function expandableInt() {
      return this.expandable;
    },
    printable: function printable() {
      return this.printActions && this.printActions.length > 0;
    },
    textClass: function textClass() {
      return this.primary ? 'primary--text' : '';
    }
  }
});

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'print-btn',
  props: {
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    primary: {
      type: Boolean,
      default: true
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: {
    textClass: function textClass() {
      return this.primary ? 'primary--text' : '';
    }
  },
  methods: {}
});

/***/ }),
/* 856 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "left": "",
      "min-width": "10rem",
      "offset-y": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-btn', {
    staticStyle: {
      "margin-right": "0"
    },
    attrs: {
      "icon": "",
      "small": ""
    }
  }, [_c('v-icon', {
    class: _vm.textClass
  }, [_vm._v("print")])], 1), _vm._v(" "), _c('span', {
    class: _vm.textClass
  }, [_vm._v(_vm._s('Печать'))])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((this.actions), function(action) {
    return [(action.divider) ? _c('v-divider') : _c('v-list-tile', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (action.isVisible()),
        expression: "action.isVisible()"
      }],
      key: action.caption(),
      on: {
        "click": function($event) {
          return action.run()
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(action.caption()))])], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 857 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-title', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_vm._t("default"), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expandableInt || _vm.printable),
      expression: "expandableInt || printable"
    }],
    staticStyle: {
      "margin": "-8px"
    },
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printable),
      expression: "printable"
    }],
    attrs: {
      "ma-0": "",
      "align-center": "",
      "justify-start": ""
    }
  }, [_c('v-print-btn', {
    attrs: {
      "actions": _vm.printActions,
      "primary": _vm.primary
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expandableInt),
      expression: "expandableInt"
    }],
    attrs: {
      "ma-0": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('span', {
    class: _vm.textClass,
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_vm._v(_vm._s(_vm.caption))]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('click')
      }
    }
  }, [_c('v-icon', {
    class: _vm.textClass
  }, [_vm._v(_vm._s(_vm.value ? 'arrow_drop_up' : 'arrow_drop_down'))])], 1)], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_classes__ = __webpack_require__(25);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'ops-btn',
  props: {
    cxt: {
      type: Object,
      default: function _default() {
        return new __WEBPACK_IMPORTED_MODULE_0__api_classes__["a" /* default */].MultiSelectContext(function () {
          return [];
        });
      }
    },
    flat: {
      type: Boolean,
      default: false
    }
  },
  data: function data() {
    return {
      menu: false
    };
  },
  computed: {
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  },
  methods: {}
});

/***/ }),
/* 859 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "left": "",
      "min-width": "20rem",
      "offset-y": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.actionCaption),
      expression: "cxt.actionCaption"
    }],
    attrs: {
      "light": "",
      "flat": _vm.flat
    }
  }, [_vm._v("\n      " + _vm._s(_vm.cxt.actionCaption) + "\n      "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.actionCaption),
      expression: "!cxt.actionCaption"
    }],
    attrs: {
      "icon": "",
      "light": ""
    }
  }, [_c('v-icon', [_vm._v(_vm._s(_vm.cxt.actionIcon))])], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isSelectMode()),
      expression: "cxt.isSelectMode()"
    }]
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.cxt.isFilterMode() && _vm.isMobile)),
      expression: "!(cxt.isFilterMode() && isMobile)"
    }],
    attrs: {
      "light": "",
      "flat": _vm.flat
    }
  }, [_vm._v("\n      Операции\n      "), _c('v-icon', {
    attrs: {
      "right": ""
    }
  }, [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.isMobile),
      expression: "cxt.isFilterMode() && isMobile"
    }],
    attrs: {
      "icon": "",
      "light": "",
      "flat": _vm.flat
    }
  }, [_c('v-icon', [_vm._v("arrow_drop_down")])], 1)], 1)]), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((this.cxt.getActions()), function(action) {
    return [(action.divider) ? _c('v-divider') : _c('v-list-tile', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (action.isVisible()),
        expression: "action.isVisible()"
      }],
      key: action.caption(),
      on: {
        "click": function($event) {
          return action.run()
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(action.caption()))])], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 860 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.fileItem) ? _c('v-btn-form', {
    attrs: {
      "mode": _vm.edit,
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [(!_vm.isEdit) ? _c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.open(_vm.fileItem.uid)
            }
          }
        }, [_vm._v("Открыть")]) : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c(_vm.createCopyButton('Ссылку', 'content_copy', 'Копировать ссылку', _vm.copyLink), {
          tag: "v-component"
        }) : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (!_vm.isEdit) ? _c('v-btn', {
          attrs: {
            "disabled": _vm.readonly || !_vm.historyItems || _vm.historyItems.length === 0 || _vm.historyItems[0].uid.localeCompare(_vm.fileItemId) !== 0
          },
          on: {
            "click": function($event) {
              _vm.edit = true
            }
          }
        }, [_vm._v("Атрибуты")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-spacer') : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-ops-btn', {
          attrs: {
            "cxt": _vm.cxt
          }
        }) : _vm._e()]
      },
      proxy: true
    }], null, false, 423556173)
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.isEdit) ? _c('v-flex', [_c('v-card-title', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('div', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName) + "\n          ")]), _vm._v(" "), _c(_vm.renderDepoFileSignature(_vm.fileItem), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('v-flex', [_vm._v("\n          Cсылка: "), _c('b', [_c('a', {
    attrs: {
      "href": _vm.getUrl(_vm.fileItem.uid)
    }
  }, [_vm._v(_vm._s(_vm.getUrl(_vm.fileItem.uid)))])])]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.fileItem.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(_vm.fileItem.deleted, _vm.formats.formatDate)) + ")\n          ")]), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v(" Депонент: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.ownerShortName))]), _vm._v("\n          ИНН: "), _c('b', [_vm._v(_vm._s(_vm.formats.formatInn(_vm.fileItem.ownerInn)))])])]), _vm._v(" "), _c('v-flex', [_vm._v("\n           Файл: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.fileName))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Размещение: " + _vm._s(_vm.getDisplayPath(_vm.fileItem.path)) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Примечания: " + _vm._s(_vm.fileItem.desc) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Теги: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.tags))])]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fileItem.prevUid),
      expression: "fileItem.prevUid"
    }]
  }, [_vm._v("\n            ВАЖНО! Существует\n            "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.openFile(_vm.fileItem.prevUid)
      }
    }
  }, [_vm._v("предыдущая версия файла.")])])], 1)], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isEdit),
      expression: "isEdit"
    }]
  }, [_c('v-card-title', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Размещение в папке",
      "hint": "Структура папок видна только для пользователей депонента",
      "items": _vm.getDisplayPaths(),
      "item-value": "key",
      "item-text": "value"
    },
    model: {
      value: (_vm.fileItem.path),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "path", $$v)
      },
      expression: "fileItem.path"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Примечания",
      "rows": "3",
      "hint": "Примечания видны только для пользователей депонента",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.desc),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "desc", $$v)
      },
      expression: "fileItem.desc"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Поисковые теги",
      "hint": "Поисковые теги используются для поиска по документам депонента",
      "rows": "1",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.tags),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "tags", $$v)
      },
      expression: "fileItem.tags"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), (!_vm.isEdit && (_vm.history.length > 1)) ? _c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": 'Все версии',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.isLoaded = !_vm.isLoaded
      }
    }
  }), _vm._v(" "), _vm._l((_vm.history), function(item) {
    return [_c('v-card', {
      key: item.uid
    }, [(_vm.isLoaded) ? _c('v-card-text', {
      staticStyle: {
        "display": "block",
        "overflow-wrap": "break-word"
      }
    }, [_c('v-flex', [_vm._v("\n        Название: "), _c('b', [_vm._v(_vm._s(item.docName))]), _vm._v(" "), _c(_vm.renderDepoFileSignature(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('span', [_vm._v("\n          Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(item.deleted, _vm.formats.formatDate)) + ")\n          "), _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.open(item.uid)
        }
      }
    }, [_vm._v("Открыть")])], 1)])], 1) : _vm._e()], 1)]
  })], 2) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 861 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(862),
  /* template */
  __webpack_require__(882),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ChipsField_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ChipsField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_ChipsField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__client__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10____ = __webpack_require__(35);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doc-selector',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_7__common_CardScroll___default.a, vChipsField: __WEBPACK_IMPORTED_MODULE_8__common_ChipsField_vue___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_6__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      valid: false,
      path: '//root',
      chipsItems: [],
      cxt: null
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    title: {
      type: String,
      default: 'Выберите документ'
    },
    queryCxt: {
      type: Object,
      default: null
    },
    query: {
      type: String,
      default: null
    }
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return _this.getItemKey(item);
      });
    });
    cxt.filterMode = true;
    cxt.mode = __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].modes.SELECT;
    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.cxt.filterString = this.query;
    this.$store.dispatch('fetchDepoFolders');
    this.setQueryCxt(this.queryCxt);
    this.fetchData();
    this.setFocus();
  },

  watch: {
    queryCxt: function queryCxt(newVal) {
      this.setQueryCxt(newVal);
    },

    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      if (newVal && !oldVal) {
        this.fetchData();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient',
    getDepoDisplayPaths: 'getDepoDisplayPaths',
    calcDialogScroll: 'calcDialogScroll',
    getDepoUrl: 'getDepoUrl',
    getItemSet: 'getDepoFileSet',
    getDepoCurrentPath: 'getDepoCurrentPath',
    getIsMobile: 'getIsMobile',
    getDepoConstant: 'getDepoConstant'
  }), {
    items: function items() {
      return this.getItemSet.getItems();
    },
    orderedItems: function orderedItems() {
      return this.items;
    },
    foldedItems: function foldedItems() {
      var path = this.getDepoCurrentPath;
      return this.orderedItems.filter(function (i) {
        return i.path === path;
      });
    },
    tagedItems: function tagedItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.tags);
      };
      var result = this.foldedItems;
      var refs = this.getRefs(this.getTags());
      if (Array.isArray(refs)) {
        refs.forEach(function (tag) {
          var t = tag.toUpperCase();
          result = result.filter(function (item) {
            return getSearchString(item).toUpperCase().includes(t);
          });
        });
      }
      return result;
    },
    filteredItems: function filteredItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.docName, item.fileName, item.tags, __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDate(item.uploaded));
      };
      // var result = this.orderedItems
      var result = this.tagedItems;

      if (!this.cxt.isFilterMode() || this.cxt.filterString === null) {
        return result;
      }
      var terms = __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString);
      if (terms.length < 1) {
        return result;
      }
      return result.filter(function (item) {
        var searchStr = getSearchString(item).toLowerCase();
        return terms.every(function (t) {
          return searchStr.includes(t);
        });
      });
    },
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : '';
      } else {
        return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : '';
      }
    }
  }),
  methods: {
    setFocus: function setFocus() {
      this.$nextTick(function () {
        if (!this.$el.contains(document.activeElement)) {
          this.$el.focus();
        }
      });
    },
    firstFocus: function firstFocus() {
      var input = this.$el.querySelector('input');
      if (input) {
        input.focus();
      } else {
        this.$el.focus();
      }
    },
    changeFilterContext: function changeFilterContext(ops, force) {
      this.$store.commit('setDepoFileSetFilterContext', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), ops));
      var self = this;
      setTimeout(function () {
        self.$store.dispatch('fetchDepoFileSet', force);
        self.scrollToActive();
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
      if (this.getProfileHaveClient) {
        var search = __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].stringifySearchTerms(__WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString));
        if (__WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(search, this.getItemSet.getFilter().search) !== 0) {
          this.changeFilterContext({ search: search }, true);
        }
      }
    },
    onChangeFolder: function onChangeFolder(path) {
      this.changeFilterContext({ path: path }, true);
    },
    getSortString: function getSortString() {
      switch (this.order) {
        case 'BY_NAME':
          return 'docName';
        case 'BY_UPLOADED':
          return 'uploaded,desc';
        default:
          return '';
      }
    },
    onChangeTags: function onChangeTags(v) {
      this.changeFilterContext({ tags: v }, true);
    },
    onChangeSort: function onChangeSort(v) {
      this.$store.commit('setDepoFileSetSort', this.getSortString());
      this.changeFilterContext(null, true);
    },
    onChangeScope: function onChangeScope(v) {
      this.changeFilterContext({ scope: v }, true);
    },
    fetchData: function fetchData(force) {
      if (this.getProfileHaveClient) {
        this.$store.commit('setDepoFileSetSort', this.getSortString());
        this.changeFilterContext({ search: this.cxt.filterString, path: this.getDepoCurrentPath, tags: this.getTags(), scope: this.getDepoConstant.ALL_SCOPE }, force);
        this.fillRefChips(this.getRefs(this.getTags()));
      }
    },
    nextPage: function nextPage() {
      this.$store.commit('nextDepoFileSet');
      this.$store.dispatch('fetchDepoFileSet');
    },
    scrollToActive: function scrollToActive() {
      var _this2 = this;

      this.$nextTick(function () {
        _this2.$refs.cardScroll.scrollToListActive();
      });
    },
    ok: function ok() {
      this.$emit('input', this.cxt.selected());
      this.cancel();
    },
    cancel: function cancel() {
      this.$emit('close');
      this.cxt.clear();
    },
    getItemKey: function getItemKey(item) {
      return item.uid;
    },
    getDisplayPaths: function getDisplayPaths() {
      var map = this.getDepoDisplayPaths;
      var result = [];
      if (!map) {
        return result;
      }
      map.forEach(function (val, key) {
        return result.push({ key: key, value: val.substring(val.lastIndexOf('/') + 1), dpath: val });
      });
      return result.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(a.dpath, b.dpath);
      });
    },
    getDisplayPathByPath: function getDisplayPathByPath(path) {
      var dpath = this.getDepoDisplayPaths ? this.getDepoDisplayPaths.get(path) : '';
      return dpath.substring(0, dpath.lastIndexOf('/'));
    },
    styleItem: function styleItem(item) {
      var margin = item && item.key && item.key.replace(/(\/\/root)/, '').replace(/\d/g, '').length + 'em' || '0em';
      return 'margin-left: ' + margin;
    },
    select: function select(uid) {
      if (this.cxt.uncheck(uid)) {
        if (this.radio) {
          this.cxt.clear();
        }
      }
      this.cxt.select(uid);
    },
    addFile: function addFile() {
      __WEBPACK_IMPORTED_MODULE_10____["a" /* default */].newFile(this.path, null, null, this.tags.join(', '));
    },
    createPreview: function createPreview(item) {
      return __WEBPACK_IMPORTED_MODULE_10____["a" /* default */].createPreview(item, this);
    },
    onRefChanged: function onRefChanged(refs) {
      var tags = refs.map(function (ref) {
        return '#' + ref;
      });
      this.onChangeTags(tags);
      this.fillRefChips(refs);
    },
    fillRefChips: function fillRefChips(refs) {
      var _this3 = this;

      var getHint = function getHint(company) {
        return company.name + ' (\u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatInn(company.inn) + ')';
      };
      var getError = function getError(company) {
        return null;
      };
      var cb = function cb(companies) {
        console.log('fillRefChips', companies);
        var set = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(refs);
        var items = companies.map(function (c) {
          set.delete(c.ref);
          return { value: c.ref, text: c.caption, hint: getHint(c), error: getError(c) };
        });
        set.forEach(function (ref) {
          return items.push({ value: ref + '', text: '#' + ref, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null });
        });
        _this3.chipsItems = items;
      };
      __WEBPACK_IMPORTED_MODULE_9__client__["a" /* default */].getCachedRefs(refs, cb);
    },
    selectRef: function selectRef() {
      var _this4 = this;

      var onSelect = function onSelect(companies) {
        console.log('onSelect', companies);
        if (Array.isArray(companies)) {
          _this4.onRefChanged(companies.map(function (c) {
            return c.ref + '' || '';
          }));
        }
      };
      __WEBPACK_IMPORTED_MODULE_9__client__["a" /* default */].selectRef(this, onSelect, function () {}, true, true);
    },
    removeRef: function removeRef(v) {
      this.onRefChanged([]);
    },
    setQueryCxt: function setQueryCxt(val) {
      if (val && val.path) {
        this.onChangeFolder(val.path);
      }
      if (val && val.inns) {
        this.onRefChanged(val.inns);
      }
    },
    getRefs: function getRefs(tags) {
      return tags.map(function (tag) {
        return tag.replace('#', '');
      });
    },
    getTags: function getTags() {
      return this.getItemSet && this.getItemSet.getFilter().tags || [];
    }
  }
});

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ActionsBtn__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ActionsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_ActionsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FavoriteSelectorTab_vue__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__FavoriteSelectorTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__FavoriteSelectorTab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchSelectorTab_vue__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__SearchSelectorTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__SearchSelectorTab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ListSelectorTab_vue__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__ListSelectorTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__ListSelectorTab_vue__);








//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









var SourceAction = function (_classes$Action) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(SourceAction, _classes$Action);

  function SourceAction(context, key, title, visibleFunc, runFunc) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, SourceAction);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SourceAction.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(SourceAction)).call(this, context, title, visibleFunc, runFunc));

    _this.key = key;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(SourceAction, [{
    key: 'run',
    value: function run() {
      return this.runFunc(this);
    }
  }]);

  return SourceAction;
}(__WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'client-selector',
  components: { vActionsBtn: __WEBPACK_IMPORTED_MODULE_11__common_ActionsBtn___default.a, vFavoriteSelectorTab: __WEBPACK_IMPORTED_MODULE_12__FavoriteSelectorTab_vue___default.a, vSearchSelectorTab: __WEBPACK_IMPORTED_MODULE_13__SearchSelectorTab_vue___default.a, vListSelectorTab: __WEBPACK_IMPORTED_MODULE_14__ListSelectorTab_vue___default.a },
  data: function data() {
    return {
      request: '',
      source: null,
      sources: [],
      cxt: null,
      radioItem: null,
      methodsQueue: []
    };
  },
  created: function created() {
    var cxt = new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].MultiSelectContext(function () {});
    cxt.mode = __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].modes.SELECT;
    cxt.filterMode = true;
    this.cxt = cxt;
    this.sources = this.sourceActions();
    this.source = this.sources && this.sources.length > 0 ? this.sources[0] : null;
    this.request = this.query;
  },
  mounted: function mounted() {
    this.sources = this.sourceActions();
    this.source = this.sources && this.sources.length > 0 ? this.sources[0] : null;
    this.request = this.query;
  },

  watch: {
    source: function source(newVal, oldVal) {
      // if (newVal !== oldVal) {
      this.$el.focus();
      this.setFocus();
      // }
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    partner: {
      type: Boolean,
      default: false
    },
    refCode: {
      type: Boolean,
      default: false
    },
    favorite: {
      type: Boolean,
      default: false
    },
    query: {
      type: String,
      default: null
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    getProfileHaveClient: 'getProfileHaveClient'
  }), {
    title: function title() {
      return this.partner ? 'Выберите партнера' : 'Выберите компанию';
    },
    items: function items() {
      return [];
    }
  }),
  methods: {
    setFocus: function setFocus() {
      this.$nextTick(function () {
        console.log('firstFocus', document.activeElement, this.$el.contains(document.activeElement));
        if (!this.$el.contains(document.activeElement)) {
          this.$el.focus();
        }
      });
    },
    firstFocus: function firstFocus() {
      var input = this.$el.querySelector('input');
      console.log('firstFocus', input);
      if (input) {
        input.focus();
      } else {
        this.$el.focus();
      }
    },
    ok: function ok() {
      var _this2 = this;

      var result = [];
      if (this.refCode) {
        this.cxt.selected().forEach(function (e) {
          if (e.split('_').length > 0) {
            result.push(e.split('_')[0]);
          }
        });
        this.convertResult(result).then(function (data) {
          _this2.$emit('input', data);
          _this2.cancel();
        });
      } else {
        this.cxt.selected().forEach(function (e) {
          if (e.split('_').length > 1) {
            result.push(e.split('_')[1]);
          }
        });
        this.$emit('input', result);
        this.cancel();
      }
    },
    cancel: function cancel() {
      this.$emit('close');
      this.item = null;
    },
    convertResult: function convertResult(refCodes) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var inns = refCodes.filter(function (r) {
          return !__WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].isRefCode(r);
        }).map(function (r) {
          return r.replace('inn:', '');
        });
        var result = refCodes.filter(function (r) {
          return __WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].isRefCode(r);
        });
        if (inns.length > 0) {
          _this3.$store.dispatch('convertInnToRefCode', { inns: inns }).then(function (map) {
            return resolve(result.concat(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(map)));
          });
        } else {
          resolve(result);
        }
      });
    },
    checkAll: function checkAll() {
      this.methodsQueue.push({ name: 'checkAll', params: {} });
    },
    changeSelected: function changeSelected(ids) {
      console.log('changeSelected', ids);
      this.cxt.setSelected(ids);
    },
    changeRequest: function changeRequest(e) {
      this.request = e;
    },
    sourceActionsCaption: function sourceActionsCaption() {
      return this.source ? this.source.caption() : null;
    },
    sourceIs: function sourceIs(key) {
      return this.source && __WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].compareString(this.source.key, key) === 0;
    },
    getSourceAction: function getSourceAction(key) {
      return this.sources.find(function (o) {
        return __WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].compareString(o.key, key) === 0;
      });
    },
    sourceActions: function sourceActions() {
      var _this4 = this;

      var result = [];
      if (this.favorite && !this.partner) {
        result.push(new SourceAction(this, 'FAVORITE', 'Мои контрагенты', null, function (self) {
          _this4.source = self;
        }));
      }
      result.push(new SourceAction(this, 'SEARCH', 'Поиск', null, function (self) {
        _this4.source = self;
      }));
      if (!this.partner && !this.favorite && !this.radio) {
        result.push(new SourceAction(this, 'LIST', 'Список', null, function (self) {
          _this4.source = self;
        }));
      }
      return result;
    }
  }

});

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-actions-btn',
  props: {
    caption: {
      type: String,
      default: null
    },
    actions: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  data: function data() {
    return {};
  },
  created: function created() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 865 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-menu', {
    attrs: {
      "min-width": "10rem",
      "offset-y": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-btn', {
    attrs: {
      "small": "",
      "icon": !_vm.caption,
      "flat": ""
    }
  }, [_vm._v("\n      " + _vm._s(_vm.caption) + "\n      "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((this.actions), function(action) {
    return [(action.divider) ? _c('v-divider') : _c('v-list-tile', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (action.isVisible()),
        expression: "action.isVisible()"
      }],
      key: action.caption(),
      on: {
        "click": function($event) {
          return action.run()
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(action.caption()))])], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 866 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(867),
  /* template */
  __webpack_require__(873),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__favorite_TagSelector_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__favorite_TagSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__favorite_TagSelector_vue__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var SelectAllAction = function (_classes$Action) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SelectAllAction, _classes$Action);

  function SelectAllAction(context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SelectAllAction);

    return _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SelectAllAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(SelectAllAction)).call(this, context, 'Выбрать Всех', null, function () {
      var fxt = _this.context.getItemSet.getFilter();
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiGetParams('/api/me/favorite/companies', {
        innOnly: true,
        request: {
          search: fxt.search,
          tagIds: fxt.tagIds,
          isShowOther: false,
          isMonitoring: false
        }
      }, function (data) {
        context.setSelected(data.map(function (t) {
          return t.join('_');
        }));
      }, function (e) {});
    }));
  }

  return SelectAllAction;
}(__WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'favorite-selector-tab',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_12__common_CardScroll___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_10__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      tagIds: [],
      cxt: null
    };
  },
  created: function created() {
    var _this2 = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this2.filteredItems.map(function (item) {
        return _this2.getItemKey(item);
      });
    });
    cxt.mode = __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].modes.SELECT;
    cxt.filterMode = true;
    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.cxt.filterString = this.query ? this.query : this.getItemSet ? this.getItemSet.getFilter().search : '';
    this.changeFilterContext({ search: this.cxt.filterString });
    this.fetchData();
    this.processMethodsQueue();
  },

  watch: {
    selected: function selected(newVal, oldVal) {
      this.cxt.setSelected(newVal);
    },
    methodsQueue: function methodsQueue() {
      this.processMethodsQueue();
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    partner: {
      type: Boolean,
      default: false
    },
    query: {
      type: String,
      default: null
    },
    selected: {
      type: Array,
      default: []
    },
    methodsQueue: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    getItemSet: 'getFavoriteSet',
    getProfileHaveClient: 'getProfileHaveClient',
    renderReference: 'renderReference',
    renderHeads: 'renderHeads',
    calcDialogScroll: 'calcDialogScroll',
    getTags: 'getTags',
    renderInnOrInnflHtml: 'renderInnOrInnflHtml'
  }), {
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getSearchTotal > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getSearchTotal + '' : '';
      }
    },
    items: function items() {
      return this.getItemSet.getItems();
    },
    orderedItems: function orderedItems() {
      return this.items;
    },
    filteredItems: function filteredItems() {
      var _this3 = this;

      var getSearchString = function getSearchString(item) {
        return ''.concat(item.ref.caption, item.ref.name, _this3.renderHeads(item.ref), item.ref.inn, item.ref.ogrn, item.ref.kpp,
        // this.formatDate(item.ref.createDate),
        // this.formatDate(item.ref.releaseDate),
        item.ref.address, item.notes, item.privateNotes);
      };
      if (!this.cxt.isFilterMode() || this.cxt.filterString === null) {
        return this.orderedItems;
      }
      var terms = __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString);
      if (terms.length < 1) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        var searchStr = getSearchString(item).toLowerCase();
        return terms.every(function (t) {
          return searchStr.includes(t);
        });
      });
    },
    isSearching: function isSearching() {
      return this.getItemSet.isProcessing();
    },
    getSearchTotal: function getSearchTotal() {
      return this.getItemSet.getTotal();
    }
  }),
  methods: {
    processMethodsQueue: function processMethodsQueue() {
      if (!this.methodsQueue) return;
      var len = this.methodsQueue.length;
      for (var i = 0; i < len; i++) {
        var method = this.methodsQueue.shift();
        if (this[method.name]) {
          this[method.name](method.params);
        }
      }
    },
    checkAll: function checkAll() {
      var action = new SelectAllAction(this);
      action.run();
    },
    nextPage: function nextPage() {
      this.$store.commit('nextFavoriteCompanies');
      this.$store.dispatch('fetchFavoriteCompanies');
    },
    changeFilterContext: function changeFilterContext(ops, force) {
      var self = this;
      this.$store.commit('setFavoritesFilterContext', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), ops));
      setTimeout(function () {
        self.$store.dispatch('fetchFavoriteCompanies', force);
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
      if (this.getProfileHaveClient) {
        var search = __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].stringifySearchTerms(__WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString));
        if (__WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].compareString(search, this.getItemSet.getFilter().search) !== 0) {
          this.changeFilterContext({ search: search }, true);
          this.$emit('change', e);
        }
      }
    },
    fetchData: function fetchData() {
      if (this.getProfileHaveClient) {
        this.tagIds = this.getItemSet.getFilter().tagIds;
        this.changeFilterContext({ search: this.cxt.filterString, isShowOther: false, tagIds: this.tagIds }, true);
        this.$store.dispatch('fetchTags');
      }
    },
    getItemKey: function getItemKey(item) {
      return item.ref.ref + '_' + item.ref.inn;
    },
    select: function select(item) {
      if (this.partner && !item.ref.clientId) {
        return;
      }
      var uid = this.getItemKey(item);
      if (this.cxt.uncheck(uid)) {
        if (this.radio) {
          this.cxt.clear();
        }
      }
      this.cxt.select(uid);
      this.$emit('input', this.cxt.selected());
    },
    setSelected: function setSelected(ids) {
      this.cxt.setSelected(ids);
      this.$emit('input', this.cxt.selected());
    },
    formatTagName: function formatTagName(tagId) {
      var t = this.getTags.find(function (t) {
        return t.id === Math.abs(tagId);
      });
      var n = t ? t.name : '';
      return tagId < 0 ? '- ' + n : '' + n;
    },
    selectTag: function selectTag() {
      var self = this;
      var setItems = function setItems(tagIds) {
        self.tagIds = tagIds;
        self.changeFilterContext({ tagIds: self.tagIds });
      };
      __WEBPACK_IMPORTED_MODULE_11__common_dialogs__["a" /* default */].register('v-tag-selector', __WEBPACK_IMPORTED_MODULE_13__favorite_TagSelector_vue___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-tag-selector v-on:close="$emit(\'close\')"\n        v-on:input="setItem"\n        :fullscreen="fullscreen" :selected="selected" removeMode></v-tag-selector>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            setItem: setItems,
            selected: self.tagIds
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_11__common_dialogs__["a" /* default */].modal(comp);
    }
  }

});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BtnForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TagForm_vue__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TagForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TagForm_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tag-selector',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default.a },
  data: function data() {
    return {
      isLoading: false,
      itemId: null,
      selectedIds: []
    };
  },
  created: function created() {
    this.fetchItems();
    if (this.selected != null) {
      this.selectedIds = this.selected.map(function (t) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_parse_int___default()(t);
      });
    }
  },
  mounted: function mounted() {},

  watch: {},
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: null
    },
    removeMode: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    calcDialogScroll: 'calcDialogScroll',
    getTags: 'getTags'
  }), {
    title: function title() {
      return 'Выберите метки';
    },
    items: function items() {
      return this.getTags;
    }
  }),
  methods: {
    ok: function ok() {
      this.$emit('input', this.selectedIds);
      this.cancel();
    },
    cancel: function cancel() {
      this.$emit('close');
      this.itemId = null;
    },
    select: function select(uid) {
      if (this.removeMode) {
        if (!this.check(uid)) {
          if (!this.check(-1 * uid)) {
            this.selectedIds.push(uid);
          } else {
            this.selectedIds = this.selectedIds.filter(function (i) {
              return i !== -1 * uid;
            });
          }
        } else {
          this.selectedIds = this.selectedIds.filter(function (i) {
            return i !== uid;
          });
          this.selectedIds.push(-1 * uid);
        }
      } else {
        if (!this.check(uid)) {
          this.selectedIds.push(uid);
        } else {
          this.selectedIds = this.selectedIds.filter(function (i) {
            return i !== uid;
          });
        }
      }
    },
    clear: function clear() {
      this.selectedIds = [];
    },
    checkAll: function checkAll() {
      this.selectedIds = this.items.map(function (i) {
        return i.id;
      });
    },
    minusAll: function minusAll() {
      this.selectedIds = this.items.map(function (i) {
        return -1 * i.id;
      });
    },
    open: function open(item) {
      this.dialogOpen(item);
    },
    check: function check(uid) {
      return this.selectedIds.includes(uid);
    },
    addItem: function addItem() {
      this.dialogOpen(null);
    },
    fetchItems: function fetchItems(force) {
      this.$store.dispatch('fetchTags', force);
    },
    dialogOpen: function dialogOpen(item) {
      var self = this;
      var setNotes = function setNotes(data) {
        self.fetchItems(true);
      };

      __WEBPACK_IMPORTED_MODULE_3__common_dialogs__["a" /* default */].register('v-tag-form', __WEBPACK_IMPORTED_MODULE_5__TagForm_vue___default.a);
      var comp = { template: '\n        <v-tag-form :itemId="itemId" :model="model" :fullscreen="fullscreen" v-on:close="$emit(\'close\')" v-on:refresh="setNotes"></v-tag-form>\n        ',
        data: function data() {
          return {
            itemId: item !== null ? item.id : null,
            fullscreen: self.fullscreen,
            model: item,
            setNotes: setNotes
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_3__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 869 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(870),
  /* template */
  __webpack_require__(871),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'tag-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_5__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {}
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: null
    }
  },
  created: function created() {
    if (this.model == null) {
      this.item = this.getItemNew();
    } else {
      this.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.model);
    }
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({}), {
    isEdit: function isEdit() {
      return this.edit || this.isNew;
    },
    isNew: function isNew() {
      // return true
      // Disable functionality to change chat definition
      return this.itemId === null;
    },
    title: function title() {
      return this.isNew ? 'Создание метки' : this.isEdit ? 'Изменение метки' : 'Информация о метке';
    }
  }),
  methods: {
    add: function add() {
      var _this = this;

      var cb = function cb(data) {
        _this.$emit('refresh');
        _this.cancel();
      };
      var cbError = function cbError(e) {
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при добавлении метки ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPost('/api/me/tags', this.item.name, cb, cbError);
      this.edit = false;
    },
    save: function save() {
      var _this2 = this;

      var cb = function cb(data) {
        _this2.$emit('refresh');
        _this2.cancel();
      };
      var cbError = function cbError(e) {
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при изменении метки ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPut('/api/me/tags/' + this.item.id, { name: this.item.name }, cb, cbError);
      this.edit = false;
    },
    remove: function remove() {
      var _this3 = this;

      var cb = function cb(data) {
        _this3.$emit('refresh');
        _this3.cancel();
      };
      var cbError = function cbError(e) {
        _this3.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении метки ' });
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', 'Удалить метку?', function (self) {
        __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiDelete('/api/me/tags/' + self.item.id, cb, cbError);
      });
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        name: null
      };
    }
  }

});

/***/ }),
/* 871 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "mode": _vm.isEdit
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [(!_vm.isEdit) ? _c('v-btn', {
          on: {
            "click": function($event) {
              _vm.edit = !_vm.edit
            }
          }
        }, [_vm._v("Изменить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Создать")]) : _vm._e(), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [(!_vm.isEdit) ? _c('v-flex', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('v-card-text')], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(_vm.isEdit) ? _c('v-flex', [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Название",
      "hint": "Название метки",
      "clearable": ""
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 872 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.addItem()
            }
          }
        }, [_vm._v("Добавить")])]
      },
      proxy: true
    }])
  }, [_c('v-list', {
    attrs: {
      "one-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content'), _vm._v(" "), _c('v-list-tile-action', [_c('div', [_c('v-icon', {
    on: {
      "click": _vm.clear
    }
  }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('v-icon', {
    on: {
      "click": _vm.checkAll
    }
  }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.removeMode),
      expression: "removeMode"
    }],
    on: {
      "click": _vm.minusAll
    }
  }, [_vm._v("indeterminate_check_box")])], 1)])], 1), _vm._v(" "), _vm._l((this.items), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      on: {
        "click": function($event) {
          return _vm.select(item.id)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.open(item)
        }
      }
    }, [_vm._v(_vm._s(item.name))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.check(item.id)),
        expression: "check(item.id)"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.check(item.id) && !_vm.check(-1 * item.id)),
        expression: "!check(item.id) && !check(-1 * item.id)"
      }]
    }, [_vm._v("check_box_outline_blank")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.check(-1 * item.id)),
        expression: "check(-1 * item.id)"
      }]
    }, [_vm._v("indeterminate_check_box")])], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 873 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  })], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: ((_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode())),
      expression: "(cxt.isFilterMode() && cxt.isSelectMode())"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }, [_vm._l((_vm.tagIds), function(tagId) {
    return _c('v-chip', {
      key: tagId,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.selectTag()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center",
      domProps: {
        "innerHTML": _vm._s(_vm.formatTagName(tagId))
      }
    })])
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagIds.length === 0),
      expression: "tagIds.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.selectTag()
      }
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n            Метки\n            ")])])], 2), _vm._v(" "), (_vm.cxt.isFilterMode()) ? _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.isSearching,
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "height": _vm.calcDialogScroll(48 + 48 + 52 + 2)
    },
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.ref, '_blank'))
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                " + _vm._s(_vm.renderHeads(item.ref)) + "\n                "), _c('br'), _vm._v("\n                ИНН: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnOrInnflHtml(item.ref.inn))
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(_vm.formats.blank(item.ref.address)))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ref.clientId),
        expression: "item.ref.clientId"
      }]
    }, [_vm._v("person")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.ref.clientId),
        expression: "!item.ref.clientId"
      }]
    }), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.ref.createDate, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 874 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(875),
  /* template */
  __webpack_require__(876),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_CardScroll__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-selector-tab',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_5__common_CardScroll___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      request: '',
      tagIds: [],
      cxt: null
    };
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return _this.getItemKey(item);
      });
    });
    cxt.mode = __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].modes.SELECT;
    cxt.filterMode = true;
    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.request = this.query ? this.query : this.getItemSet ? this.getItemSet.getFilter().search : '';
    this.changeFilterContext({ search: this.request });
    this.processMethodsQueue();
  },

  watch: {
    query: function query() {
      this.request = this.query;
    },
    selected: function selected(newVal, oldVal) {
      this.cxt.setSelected(newVal);
    },
    methodsQueue: function methodsQueue() {
      this.processMethodsQueue();
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    partner: {
      type: Boolean,
      default: false
    },
    query: {
      type: String,
      default: null
    },
    selected: {
      type: Array,
      default: []
    },
    methodsQueue: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    getItemSet: 'getSearchSet',
    getProfileHaveClient: 'getProfileHaveClient',
    renderReference: 'renderReference',
    renderHeads: 'renderHeads',
    calcDialogScroll: 'calcDialogScroll',
    getTags: 'getTags',
    renderInnOrInnflHtml: 'renderInnOrInnflHtml'
  }), {
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getSearchTotal > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getSearchTotal + ' первых' : '';
      }
    },
    items: function items() {
      return [];
    },
    getRequest: function getRequest() {
      return this.request;
    },
    orderedItems: function orderedItems() {
      return this.getItemSet.getItems();
    },
    filteredItems: function filteredItems() {
      var _this2 = this;

      var getSearchString = function getSearchString(item) {
        return ''.concat(item.ref.ref, item.ref.caption, item.ref.name, _this2.renderHeads(item.ref), item.ref.inn, item.ref.kpp,
        // this.formatDate(item.company.createDate),
        // this.formatDate(item.company.releaseDate),
        item.ref.address, item.notes, item.privateNotes);
      };
      var filter = !this.cxt.isFilterMode() || this.cxt.filterString === null || this.cxt.filterString.length < 0 ? null : this.cxt.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
    },
    isSearching: function isSearching() {
      return this.getItemSet.isProcessing();
    },
    getSearchTotal: function getSearchTotal() {
      return this.getItemSet.getLoadedSize();
    }
  }),
  methods: {
    processMethodsQueue: function processMethodsQueue() {
      if (!this.methodsQueue) return;
      var len = this.methodsQueue.length;
      for (var i = 0; i < len; i++) {
        var method = this.methodsQueue.shift();
        if (this[method.name]) {
          this[method.name](method.params);
        }
      }
    },
    checkAll: function checkAll() {
      this.cxt.checkAll();
      this.$emit('input', this.cxt.selected());
    },
    nextPage: function nextPage() {
      this.$store.commit('nextSearchCompanies');
      this.$store.dispatch('fetchSearchCompanies');
    },
    setRequest: function setRequest(v) {
      this.request = v;
    },
    changeFilterContext: function changeFilterContext(ops, force) {
      var self = this;
      this.$store.commit('setSearchFilterContext', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, ops));
      setTimeout(function () {
        self.$store.dispatch('fetchSearchCompanies', force);
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
    },
    fetchData: function fetchData() {
      this.changeFilterContext({ search: this.request, isShowOther: false }, true);
    },
    getItemKey: function getItemKey(item) {
      return item.ref.ref + '_' + item.ref.inn;
    },

    search: function search() {
      if (!this.isSearching) {
        this.item = null;
        this.fetchData();
      }
    },
    select: function select(item) {
      if (this.partner && !item.ref.clientId) {
        return;
      }
      var uid = this.getItemKey(item);
      if (this.cxt.uncheck(uid)) {
        if (this.radio) {
          this.cxt.clear();
        }
      }
      this.cxt.select(uid);
      this.$emit('input', this.cxt.selected());
    }
  }

});

/***/ }),
/* 876 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  })], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1)], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.isSearching,
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autofocus": "",
      "label": "Введите запрос",
      "hint": "Название, ИНН, руководитель, учредитель, адрес",
      "value": _vm.getRequest,
      "clearable": "",
      "persistent-hint": ""
    },
    on: {
      "input": _vm.setRequest
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "disabled": _vm.isSearching
    },
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Искать")])], 1)], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "height": _vm.calcDialogScroll(48 + 48 + 52 + 102, 48 + 48 + 52 + 116 + 2)
    },
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.select(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.ref, '_blank'))
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                  " + _vm._s(_vm.renderHeads(item.ref)) + "\n                  "), _c('br'), _vm._v("\n                  ИНН: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnOrInnflHtml(item.ref.inn))
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(_vm.formats.blank(item.ref.address)))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.accountId),
        expression: "item.accountId"
      }]
    }, [_vm._v("star")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.accountId),
        expression: "!item.accountId"
      }]
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ref.clientId),
        expression: "item.ref.clientId"
      }]
    }, [_vm._v("person")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.ref.clientId),
        expression: "!item.ref.clientId"
      }]
    }), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.ref.createDate, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 877 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(878),
  /* template */
  __webpack_require__(879),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_CardScroll__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'list-selector-tab',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_3__common_CardScroll___default.a },
  data: function data() {
    return {
      cxt: null
    };
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_2__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return item.ref.inn;
      });
    });
    cxt.mode = __WEBPACK_IMPORTED_MODULE_2__api_classes__["a" /* default */].modes.SELECT;
    cxt.filterMode = true;
    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.processMethodsQueue();
  },

  watch: {
    selected: function selected(newVal, oldVal) {
      var arr = newVal.map(function (r) {
        return r.replace('inn:', '');
      });
      this.cxt.setSelected(arr);
    },
    methodsQueue: function methodsQueue() {
      this.processMethodsQueue();
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    partner: {
      type: Boolean,
      default: false
    },
    query: {
      type: String,
      default: null
    },
    selected: {
      type: Array,
      default: []
    },
    methodsQueue: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    getItemSet: 'getSearchSet',
    getProfileHaveClient: 'getProfileHaveClient',
    renderReference: 'renderReference',
    calcDialogScroll: 'calcDialogScroll',
    getTags: 'getTags'
  }), {
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getSearchTotal > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getSearchTotal + '' : '';
      }
    },
    items: function items() {
      return [];
    },
    filteredItems: function filteredItems() {
      return [];
    },
    isSearching: function isSearching() {
      return false;
    },
    getSearchTotal: function getSearchTotal() {
      return this.cxt.selectedCount();
    }
  }),
  methods: {
    processMethodsQueue: function processMethodsQueue() {
      if (!this.methodsQueue) return;
      var len = this.methodsQueue.length;
      for (var i = 0; i < len; i++) {
        var method = this.methodsQueue.shift();
        if (this[method.name]) {
          this[method.name](method.params);
        }
      }
    },
    setSelectedIds: function setSelectedIds(value) {
      var codes = value ? value.match(/[0-9]{9,10}|nza:\d{11}|ogrn:\d{13}|ogrnip:\d{15}/g) : [];
      var refCodes = codes.map(function (code) {
        return code.includes(':') ? code : 'inn:' + code;
      });
      this.$emit('input', refCodes);
    }
  }

});

/***/ }),
/* 879 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "flat": "",
      "dense": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  })], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.isSearching,
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "height": _vm.calcDialogScroll(48 + 48 + 52 + 102, 48 + 48 + 52 + 116)
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Введите список инн компаний",
      "hint": "Инн могут разделяться пробелами или запятыми, можно также вводить ОГРН (ogrn:1111111111111), НЗА (nza:11111111111), ОГРНИП (ogrnip:111111111111111)",
      "value": _vm.cxt.selectedIds,
      "clearable": "",
      "persistent-hint": "",
      "rows": "16",
      "autofocus": ""
    },
    on: {
      "input": _vm.setSelectedIds
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 880 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enter')
      }]
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v("Выберите")]) : _vm._e(), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-actions-btn', {
    attrs: {
      "caption": _vm.sourceActionsCaption(),
      "actions": _vm.sourceActions()
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.sourceIs('FAVORITE')) ? _c('div', [_c('v-favorite-selector-tab', {
    attrs: {
      "query": _vm.request,
      "radio": _vm.radio,
      "fullscreen": _vm.fullscreen,
      "partner": _vm.partner,
      "selected": _vm.cxt.selected(),
      "methodsQueue": _vm.methodsQueue
    },
    on: {
      "input": _vm.changeSelected,
      "change": _vm.changeRequest
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sourceIs('SEARCH')) ? _c('div', [_c('v-search-selector-tab', {
    attrs: {
      "query": _vm.request,
      "radio": _vm.radio,
      "fullscreen": _vm.fullscreen,
      "partner": _vm.partner,
      "selected": _vm.cxt.selected(),
      "methodsQueue": _vm.methodsQueue
    },
    on: {
      "input": _vm.changeSelected
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sourceIs('LIST')) ? _c('div', [_c('v-list-selector-tab', {
    attrs: {
      "query": _vm.request,
      "radio": _vm.radio,
      "fullscreen": _vm.fullscreen,
      "partner": _vm.partner,
      "selected": _vm.cxt.selected(),
      "methodsQueue": _vm.methodsQueue
    },
    on: {
      "input": _vm.changeSelected
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": _vm.cxt.selectedCount() === 0
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() === 0 && !_vm.radio),
      expression: "cxt.selectedCount() === 0 && !radio"
    }],
    on: {
      "click": function($event) {
        return _vm.checkAll()
      }
    }
  }, [_vm._v("Выбрать все")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() > 0),
      expression: "cxt.selectedCount() > 0"
    }],
    on: {
      "click": function($event) {
        return _vm.cxt.clear()
      }
    }
  }, [_vm._v("Очистить")]), _vm._v(" "), _c('span', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.firstFocus()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assist_AssistClasses_js__ = __webpack_require__(32);












// import client from '../client'

var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).call(this, cxt));

    _this.chipsItems = [];
    _this.pProps = null;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'CLIENT_MAILBOX';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Почтовый ящик';
    }
  }, {
    key: 'setContext',
    value: function setContext(cxt) {
      this.context = cxt;
    }
  }, {
    key: 'setParentProps',
    value: function setParentProps(pProps) {
      this.pProps = pProps;
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createModelFromJSON',
    value: function createModelFromJSON(json) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), JSON.parse(json));
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(parent) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), {});
    }
  }, {
    key: 'createModelFromData',
    value: function createModelFromData(data) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), data);
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var emailRules = function emailRules(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат адреса Эл.почты';
      };

      var steps = [];
      new __WEBPACK_IMPORTED_MODULE_11__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Название',
          name: 'name',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-select',
          label: 'Режим',
          name: 'mode',
          itemText: 'text',
          itemValue: 'value',
          items: [{ value: 'OUT', text: 'Только отсылка' }, { value: 'ALL', text: 'Доступ к письмам' }, { value: 'DIF', text: 'Специальные параметры' }],
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Исходящий сервер',
          name: 'host',
          grow: true,
          size: { sm8: true, xs8: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Порт',
          name: 'port',
          grow: true,
          size: { sm4: true, xs4: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Пользователь',
          name: 'username',
          hint: 'С этого адреса отправляется почта',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(emailRules),
          grow: true,
          size: { sm8: true, xs8: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Пароль',
          name: 'pwd',
          type: 'password',
          hint: 'Пароль хранится в шифрованном виде',
          grow: true,
          size: { sm4: true, xs4: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Скрытая копия',
          name: 'bcc',
          hint: 'Адрес для скрытых копий всех писем компании, копия посылается на рабочий адрес отправителя',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(emailRules),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Адрес для ответа',
          name: 'replyTo',
          hint: 'Адрес будет подставляться при использовании \'Ответить\' адресатом',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(emailRules),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Сервер писем  (IMAP-сервер)',
          name: 'hostIn',
          if: function _if(model, field) {
            return ['DIF'].includes(model['mode']);
          },
          grow: true,
          size: { sm8: true, xs8: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Порт',
          name: 'portIn',
          if: function _if(model, field) {
            return ['DIF'].includes(model['mode']);
          },
          grow: true,
          size: { sm4: true, xs4: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Пользователь',
          name: 'usernameIn',
          hint: 'Доступ к письмам на почтовом сервере',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(emailRules),
          if: function _if(model, field) {
            return ['DIF'].includes(model['mode']);
          },
          grow: true,
          size: { sm8: true, xs8: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Пароль',
          name: 'pwdIn',
          type: 'password',
          hint: 'Пароль хранится в шифрованном виде',
          if: function _if(model, field) {
            return ['DIF'].includes(model['mode']);
          },
          grow: true,
          size: { sm4: true, xs4: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отправленные',
          name: 'outbox',
          hint: 'Папка на сервере для отправленных писем',
          if: function _if(model, field) {
            return ['ALL', 'DIF'].includes(model['mode']);
          },
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Входящие',
          name: 'inbox',
          hint: 'Папка на сервере для входящих писем',
          if: function _if(model, field) {
            return ['ALL', 'DIF'].includes(model['mode']);
          },
          grow: true,
          size: { sm6: true, xs12: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      return this;
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      return model['name'] ? model['name'] : '-';
    }
  }, {
    key: 'viewTitle',
    value: function viewTitle(model) {
      if (this.parent) {
        return '\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0435 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B ' + this.pProps.companyNameShort;
      }
      return this.getTypeName();
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].createComp('\n      <span>' + (model['name'] ? model['name'] : this.getTypeName()) + '</span>\n    ');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      var _f = function _f(v) {
        return v || '-';
      };
      var value = this.viewContent(model);
      var caption = '\n      <span>\n        <span><b>' + _f(model['name']) + '</b></span>\n        <span>\u0418\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0439 \u0441\u0435\u0440\u0432\u0435\u0440:<b>' + _f(model['host']) + '</b></span>\n        <span>\u0412\u0445\u043E\u0434\u044F\u0449\u0438\u0439 \u0441\u0435\u0440\u0432\u0435\u0440: <b>' + _f(model['hostIn']) + '</b></span>\n      </span>\n    ';
      return {
        template: '<span><component :is="renderValueLink()"></component></span>',
        methods: {
          renderValueLink: function renderValueLink() {
            return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.renderValueLink(value, null, null, null, caption);
          }
        }
      };
    }
  }, {
    key: 'viewContent',
    value: function viewContent(model) {
      var _f = function _f(v) {
        return v || '-';
      };
      return '\n        ' + _f(model['name']) + '\n        \u0438\u0441\u0445\u043E\u0434\u044F\u0449\u0438\u0439: ' + _f(model['username']) + '\n        \u0432\u0445\u043E\u0434\u044F\u0449\u0438\u0439: ' + _f(model['usernameIn']) + '\n    ';
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'fetchData',
    value: function fetchData(itemId) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (itemId) {
          _this2.context.$store.dispatch('getClientMailbox', itemId).then(function (data) {
            data.mode = data.mode || 'OUT';
            data.portIn = data.portIn || '993';
            data.hostIn = data.hostIn || data.host;
            data.usernameIn = data.usernameIn || data.username;
            data.inbox = data.inbox || 'Inbox';
            data.outbox = data.outbox || 'Sent';
            resolve(data);
          });
        } else {
          var def = {
            mode: 'OUT',
            host: 'smtp.mail.ru',
            port: '587',
            username: '[Почтовый ящик]@mail.ru'
          };
          resolve(def);
        }
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(itemId, model, parentId) {
      var _this3 = this;

      var item = model;
      item['id'] = itemId;
      if (this.pProps) {
        item['clientId'] = this.pProps.clientId;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.context.$store.dispatch('updateClientMailbox', { dto: item }).then(function (id) {
          resolve(id);
        });
      });
    }
  }, {
    key: 'deleteData',
    value: function deleteData(itemId, model) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_9__common_dialogs_js__["a" /* default */].confirm(_this4.context, 'Подтвердите', '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u0447\u0442\u043E\u0432\u044B\u0439 \u044F\u0449\u0438\u043A?', function (self) {
          self.$store.dispatch('deleteClientMailbox', { ids: [itemId] }).then(function () {
            return resolve();
          });
        });
      });
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_11__assist_AssistClasses_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '213.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 882 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enter')
      }]
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    },
    model: {
      value: (_vm.cxt.filterString),
      callback: function($$v) {
        _vm.$set(_vm.cxt, "filterString", $$v)
      },
      expression: "cxt.filterString"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-chips-field', {
    attrs: {
      "emptyChip": "Контрагент",
      "solo": "",
      "flat": "",
      "items": _vm.chipsItems,
      "chipSize": _vm.fullscreen ? 12 : 25
    },
    on: {
      "remove": _vm.removeRef,
      "click": _vm.selectRef
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": "",
      "xs6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Папка",
      "value": _vm.path,
      "hint": _vm.getDisplayPathByPath(_vm.getDepoCurrentPath),
      "items": _vm.getDisplayPaths(),
      "item-value": "key",
      "item-text": "value"
    },
    on: {
      "input": _vm.onChangeFolder,
      "change": _vm.onChangeFolder
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('span', {
          style: (_vm.styleItem(data.item))
        }, [_vm._v(_vm._s(data.item.value))])]
      }
    }])
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    attrs: {
      "flat": "",
      "height": _vm.calcDialogScroll(48 + 100 + 52)
    },
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: _vm.getItemKey(item),
      attrs: {
        "tabindex": "0"
      },
      on: {
        "click": function($event) {
          _vm.select(_vm.getItemKey(item))
        },
        "keydown": function($event) {
          if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "space", 32, $event.key, [" ", "Spacebar"])) { return null; }
          $event.preventDefault();
          _vm.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-avatar', {
      attrs: {
        "tile": ""
      }
    }, [_c(_vm.createPreview(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('b', [_vm._v(_vm._s(item.docName))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.uid))])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e(), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.uploaded, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": _vm.cxt.selectedCount() === 0
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("ОК")]), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.addFile()
      }
    }
  }, [_vm._v("Депонировать")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() === 0 && !_vm.radio),
      expression: "cxt.selectedCount() === 0 && !radio"
    }],
    on: {
      "click": function($event) {
        return _vm.cxt.checkAll()
      }
    }
  }, [_vm._v("Выбрать все")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() > 0),
      expression: "cxt.selectedCount() > 0"
    }],
    on: {
      "click": function($event) {
        return _vm.cxt.clear()
      }
    }
  }, [_vm._v("Очистить")]), _vm._v(" "), _c('span', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.firstFocus()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 883 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(884),
  /* template */
  __webpack_require__(885),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BtnForm__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'docprop-selector',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_4__common_CardScroll___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_5__common_BtnForm___default.a },
  data: function data() {
    return {
      cxt: null
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: 'Выберите документ'
    }
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return _this.getItemKey(item);
      });
    });
    cxt.mode = __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].modes.SELECT;
    this.cxt = cxt;
    if (this.selected != null) {
      this.selected.forEach(function (id) {
        return _this.cxt.select(id);
      });
    }
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    calcDialogScroll: 'calcDialogScroll'
  }), {
    orderedItems: function orderedItems() {
      console.log('orderedItems', this.items);
      return this.items.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.docName, b.docName);
      });
    },
    filteredItems: function filteredItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.docName);
      };
      var filter = !this.cxt.isFilterMode() || this.cxt.filterString === null || this.cxt.filterString.length < 3 ? null : this.cxt.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
    }
  }),
  methods: {
    getItemKey: function getItemKey(item) {
      return item.value;
    },
    ok: function ok() {
      this.$emit('input', this.cxt.selected());
      this.cancel();
    },
    cancel: function cancel() {
      this.$emit('close');
      this.itemId = null;
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
    }
  }
});

/***/ }),
/* 885 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")])]
      },
      proxy: true
    }])
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.cxt.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-content', [_c('b', [_vm._v(_vm._s(item.text))])]), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 886 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(887),
  /* template */
  __webpack_require__(888),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_OpsBtn__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'docprop-list',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_7__common_CardScroll___default.a, vOpsBtn: __WEBPACK_IMPORTED_MODULE_8__common_OpsBtn___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      cxt: null,
      items: []
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    docprops: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: 'Список документов'
    },
    companyRefCode: {
      type: String,
      default: null
    }
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return _this.getItemKey(item);
      });
    });
    // cxt.mode = classes.modes.SELECT
    cxt.actionCaption = 'Изменить';
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].SelectAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].Action(this, 'Добавить из депозитария', null, function () {
      return _this.attachDocs();
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].Action(this, 'Загрузить в депозитарий', null, function () {
      return _this.loadDocs();
    }));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].Action(this, 'Удалить из списка', null, function () {
      return _this.deleteItems(cxt.selectedIds);
    }));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].SelectAllAction(cxt));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].SelectEndAction(cxt));

    this.cxt = cxt;
    if (this.selected != null) {
      this.selected.forEach(function (id) {
        return _this.cxt.select(id);
      });
    }
  },
  mounted: function mounted() {
    this.fetchData();
    this.setFocus();
  },

  watch: {
    docprops: function docprops(newVal, oldVal) {
      // watch it
      this.fetchData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  }), {
    orderedItems: function orderedItems() {
      var _this2 = this;

      // console.log('orderedItems', this.items)
      return this.items.sort(function (a, b) {
        return _this2.formats.compareString(_this2.getItemTitle(a), _this2.getItemTitle(b));
      });
    },
    filteredItems: function filteredItems() {
      var _this3 = this;

      var getSearchString = function getSearchString(item) {
        return ''.concat(_this3.getItemTitle(item)).concat(_this3.getItemText(item));
      };
      var filter = !this.cxt.isFilterMode() || this.cxt.filterString === null || this.cxt.filterString.length < 3 ? null : this.cxt.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
    }
  }),
  methods: {
    setFocus: function setFocus() {
      this.$nextTick(function () {
        if (!this.$el.contains(document.activeElement)) {
          this.$el.focus();
        }
      });
    },
    firstFocus: function firstFocus() {
      var input = this.$el.querySelector('input');
      if (input) {
        input.focus();
      } else {
        this.$el.focus();
      }
    },
    getItemKey: function getItemKey(item) {
      return item.uid;
    },
    fetchData: function fetchData() {
      var _this4 = this;

      var docprops = this.docprops;
      if (docprops) {
        docprops.forEach(function (h) {
          var item = { uid: h.uid, docName: h.docName };
          _this4.items.push(item);
        });
      }
    },
    ok: function ok() {
      var docprops = [];
      this.items.forEach(function (i) {
        docprops.push({
          uid: i.uid,
          docName: i.docName
        });
      });
      this.$emit('input', docprops);
      this.cancel();
    },
    cancel: function cancel() {
      this.$emit('close');
      this.itemId = null;
    },
    select: function select(uid) {
      if (this.cxt.uncheck(uid)) {
        if (this.radio) {
          this.cxt.clear();
        }
      }
      this.cxt.select(uid);
    },
    click: function click(item) {},
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
    },
    onSetItems: function onSetItems(values) {
      var _this5 = this;

      if (Array.isArray(values) && values.length > 0) {
        var set = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(values);
        this.items.map(function (item) {
          return item.uid;
        }).forEach(function (v) {
          set.add(v);
        });
        this.$store.dispatch('getDepoFileProps', { uids: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(set) }).then(function (data) {
          if (Array.isArray(data)) {
            var items = data.map(function (item) {
              return { uid: item.uid, docName: item.docName };
            });
            _this5.items = items;
          }
        }, function () {});
      }
    },
    attachDocs: function attachDocs() {
      var inns = this.companyRefCode ? [this.companyRefCode] : [];
      var queryCxt = { path: null, inns: inns };
      __WEBPACK_IMPORTED_MODULE_6__depo__["a" /* default */].selectDoc(this, this.onSetItems, true, queryCxt);
    },
    loadDocs: function loadDocs(fieldName, fieldPathName) {
      var path = null;
      __WEBPACK_IMPORTED_MODULE_6__depo__["a" /* default */].newFile(path, this.onSetItems);
    },
    deleteItems: function deleteItems(ids) {
      this.items = this.items.filter(function (item) {
        return !ids.includes(item.uid);
      });
      this.cxt && this.cxt.toViewMode();
    },
    getItemTitle: function getItemTitle(item) {
      return item.docName;
    },
    getItemText: function getItemText(item) {
      return item.uid;
    }
  }
});

/***/ }),
/* 888 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enter')
      }]
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.cxt.filterString),
      callback: function($$v) {
        _vm.$set(_vm.cxt, "filterString", $$v)
      },
      expression: "cxt.filterString"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "flat": "",
      "height": _vm.calcDialogScroll(48 + 52)
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: _vm.getItemKey(item),
      on: {
        "click": function($event) {
          _vm.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s('<b>' + _vm.getItemTitle(item) + '</b>')
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.getItemText(item))
      }
    })], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e(), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.uploaded, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.ok()
      }
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt
    }
  }), _vm._v(" "), _c('span', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.firstFocus()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 889 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.send
          }
        }, [_vm._v("Отправить")])]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Адреса эл. почты",
      "hint": "Введите адреса для рассылки документа",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.to),
      callback: function($$v) {
        _vm.to = $$v
      },
      expression: "to"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Почтовый ящик",
      "hint": "Выберите ящик из которого будет осуществляться рассылка",
      "items": _vm.mailboxes,
      "item-value": "name",
      "item-text": "name"
    },
    model: {
      value: (_vm.mailbox),
      callback: function($$v) {
        _vm.mailbox = $$v
      },
      expression: "mailbox"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Тема",
      "hint": "Тема письма с сылкой на документ",
      "rows": "3"
    },
    model: {
      value: (_vm.subject),
      callback: function($$v) {
        _vm.subject = $$v
      },
      expression: "subject"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "sm6": ""
    }
  }, [_c('v-select-check', {
    attrs: {
      "items": [{
        value: 'ATTACH',
        text: 'Прикрепить файлы',
        disabled: !_vm.model.uids
      }]
    },
    model: {
      value: (_vm.options),
      callback: function($$v) {
        _vm.options = $$v
      },
      expression: "options"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs5": "",
      "sm4": ""
    }
  }, [_c('v-date-field', {
    attrs: {
      "placeholder": "Сейчас"
    },
    model: {
      value: (_vm.scheduledDate),
      callback: function($$v) {
        _vm.scheduledDate = $$v
      },
      expression: "scheduledDate"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "mask": "##:##",
      "rules": [function (v) { return !v || /^(2[0-3]|[01]?[0-9])([0-5]?[0-9])$/.test(v) || 'чч:мм'; }]
    },
    model: {
      value: (_vm.scheduledTime),
      callback: function($$v) {
        _vm.scheduledTime = $$v
      },
      expression: "scheduledTime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-html-field', {
    attrs: {
      "value": this.text,
      "heightEditor": _vm.calcHeightEditor(),
      "label": "Сообщение"
    },
    on: {
      "input": _vm.setText
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 890 */,
/* 891 */,
/* 892 */,
/* 893 */,
/* 894 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(895),
  /* template */
  __webpack_require__(902),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__people_index_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__client_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_ActionsBtn__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_ActionsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__common_ActionsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PeopleSelectorTab_vue__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__PeopleSelectorTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__PeopleSelectorTab_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HumanSelectorTab_vue__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__HumanSelectorTab_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__HumanSelectorTab_vue__);







//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var SourceAction = function (_classes$Action) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(SourceAction, _classes$Action);

  function SourceAction(context, key, title, visibleFunc, runFunc) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SourceAction);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SourceAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(SourceAction)).call(this, context, title, visibleFunc, runFunc));

    _this.key = key;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(SourceAction, [{
    key: 'run',
    value: function run() {
      return this.runFunc(this);
    }
  }]);

  return SourceAction;
}(__WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'individual-selector',
  components: { vActionsBtn: __WEBPACK_IMPORTED_MODULE_13__common_ActionsBtn___default.a, vPeopleSelectorTab: __WEBPACK_IMPORTED_MODULE_14__PeopleSelectorTab_vue___default.a, vHumanSelectorTab: __WEBPACK_IMPORTED_MODULE_15__HumanSelectorTab_vue___default.a },
  data: function data() {
    return {
      request: '',
      source: null,
      sources: [],
      cxt: null,
      radioItem: null,
      methodsQueue: []
    };
  },
  created: function created() {
    var cxt = new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].MultiSelectContext(function () {});
    cxt.mode = __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].modes.SELECT;
    cxt.filterMode = true;
    this.cxt = cxt;
    this.sources = this.sourceActions();
    this.source = this.sources && this.sources.length > 0 ? this.sources[0] : null;
    this.request = this.query;
  },
  mounted: function mounted() {
    this.sources = this.sourceActions();
    this.source = this.sources && this.sources.length > 0 ? this.sources[0] : null;
    this.request = this.query;
    this.setFocus();
  },

  watch: {},
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    queryCxt: {
      type: String,
      default: null
    },
    query: {
      type: String,
      default: null
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    getProfileHaveClient: 'getProfileHaveClient'
  }), {
    title: function title() {
      return 'Выберите персону';
    },
    items: function items() {
      return [];
    }
  }),
  methods: {
    setFocus: function setFocus() {
      this.$nextTick(function () {
        console.log('firstFocus', document.activeElement, this.$el.contains(document.activeElement));
        if (!this.$el.contains(document.activeElement)) {
          this.$el.focus();
        }
      });
    },
    firstFocus: function firstFocus() {
      var input = this.$el.querySelector('input');
      console.log('firstFocus', input);
      if (input) {
        input.focus();
      } else {
        this.$el.focus();
      }
    },
    ok: function ok() {
      var _this2 = this;

      var result = [];
      var convert = [];
      this.cxt.selected().forEach(function (e) {
        if (e.split('inn:').length > 1) {
          convert.push(e.split('inn:')[1]);
        } else {
          result.push(e);
        }
      });
      this.convertResult(convert).then(function (data) {
        result = result.concat(data);
        _this2.$emit('input', result);
        _this2.cancel();
      });
    },
    cancel: function cancel() {
      this.$emit('close');
      this.item = null;
    },
    convertResult: function convertResult(inns) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (inns.length > 0) {
          __WEBPACK_IMPORTED_MODULE_11__people_index_js__["a" /* default */].findPeopleByInn(inns[0]).then(function (data) {
            if (data && data.content) {
              if (data.content.length > 0) {
                resolve([data.content[0].id]);
              } else {
                __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__["a" /* default */].confirm(_this3, 'Подтвердите', '\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C \u043E \u043F\u0435\u0440\u0441\u043E\u043D\u0435 \u0432 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E\u0439 \u0431\u0430\u0437\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438?', function (self) {
                  __WEBPACK_IMPORTED_MODULE_12__client_index_js__["a" /* default */].getHumanProps(inns[0]).then(function (human) {
                    __WEBPACK_IMPORTED_MODULE_11__people_index_js__["a" /* default */].addHuman(_this3.queryCxt, human).then(function (id) {
                      resolve(id);
                    });
                  });
                });
              }
            }
          });
        } else {
          resolve([]);
        }
      });
    },
    checkAll: function checkAll() {
      this.methodsQueue.push({ name: 'checkAll', params: {} });
    },
    changeSelected: function changeSelected(ids) {
      console.log('changeSelected', ids);
      this.cxt.setSelected(ids);
    },
    changeRequest: function changeRequest(e) {
      this.request = e;
    },
    sourceActionsCaption: function sourceActionsCaption() {
      return this.source ? this.source.caption() : null;
    },
    sourceIs: function sourceIs(key) {
      return this.source && __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].compareString(this.source.key, key) === 0;
    },
    getSourceAction: function getSourceAction(key) {
      return this.sources.find(function (o) {
        return __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].compareString(o.key, key) === 0;
      });
    },
    sourceActions: function sourceActions() {
      var _this4 = this;

      var result = [];
      if (this.queryCxt) {
        result.push(new SourceAction(this, 'SEARCH', 'Администрация', null, function (self) {
          _this4.source = self;
        }));
      }
      result.push(new SourceAction(this, 'LOCAL', 'Физические лица', null, function (self) {
        _this4.source = self;
      }));
      return result;
    }
  }

});

/***/ }),
/* 896 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(897),
  /* template */
  __webpack_require__(898),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__people_index_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_CardScroll__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'people-selector-tab',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_6__common_CardScroll___default.a },
  data: function data() {
    return {
      itemId: null,
      cxt: null,
      humans: []
    };
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_4__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return item.id + '';
      });
    });
    cxt.filterMode = true;
    cxt.mode = __WEBPACK_IMPORTED_MODULE_4__api_classes__["a" /* default */].modes.SELECT;
    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.cxt.filterString = this.query || this.getItemSet.getFilter().search;
    this.itemId = this.queryCxt;
    this.fetchData();
  },

  watch: {
    queryCxt: function queryCxt(newVal) {
      this.itemId = newVal;
      this.fetchItems();
    },
    query: function query(newVal) {
      if (newVal) {
        this.cxt.filterString = newVal;
      }
    },
    selected: function selected(newVal, oldVal) {
      this.cxt.setSelected(newVal);
    },
    methodsQueue: function methodsQueue() {
      this.processMethodsQueue();
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    queryCxt: {
      type: String,
      default: null
    },
    query: {
      type: String,
      default: null
    },
    selected: {
      type: Array,
      default: []
    },
    methodsQueue: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient',
    getIsMobile: 'getIsMobile',
    getPeople: 'getPeople',
    getPeopleFilterContext: 'getPeopleFilterContext',
    getPeopleTotal: 'getPeopleTotal',
    calcDialogScroll: 'calcDialogScroll',
    getItemSet: 'getPeopleSet'
  }), {
    title: function title() {
      return 'Выберите физическое лицо';
    },
    items: function items() {
      return this.getItemSet.getItems();
    },
    orderedItems: function orderedItems() {
      return this.items.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].compareString(a.title, b.title);
      });
    },
    filteredItems: function filteredItems() {
      return this.orderedItems;
    },
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : '';
      } else {
        return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : '';
      }
    }
  }),
  methods: {
    changeFilterContext: function changeFilterContext(ops, force) {
      this.$store.commit('setPeopleFilterContext', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), ops));
      var self = this;
      setTimeout(function () {
        self.$store.dispatch('fetchPeople', force);
        // self.scrollToActive()
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
      if (this.getProfileHaveClient) {
        var search = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].stringifySearchTerms(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString));
        if (__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].compareString(search, this.getItemSet.getFilter().search) !== 0) {
          this.changeFilterContext({ search: search }, true);
        }
      }
    },
    nextPage: function nextPage() {
      this.$store.commit('nextPeople');
      this.$store.dispatch('fetchPeople');
    },
    fetchData: function fetchData() {
      if (this.getProfileHaveClient) {
        this.changeFilterContext({ search: this.cxt.filterString });
      }
    },
    formatState: function formatState(state) {
      return state;
    },
    processMethodsQueue: function processMethodsQueue() {
      if (!this.methodsQueue) return;
      var len = this.methodsQueue.length;
      for (var i = 0; i < len; i++) {
        var method = this.methodsQueue.shift();
        if (this[method.name]) {
          this[method.name](method.params);
        }
      }
    },
    checkAll: function checkAll() {
      this.cxt.checkAll();
      this.$emit('input', this.cxt.selected());
    },
    select: function select(uid) {
      if (this.cxt.uncheck(uid + '')) {
        if (this.radio) {
          this.cxt.clear();
        }
      }
      this.cxt.select(uid + '');
      this.$emit('input', this.cxt.selected());
    },
    openItem: function openItem(item) {
      __WEBPACK_IMPORTED_MODULE_5__people_index_js__["a" /* default */].open(item.id);
    },
    getItemRef: function getItemRef(item) {
      return __WEBPACK_IMPORTED_MODULE_5__people_index_js__["a" /* default */].getItemRef(item.id);
    }
  }

});

/***/ }),
/* 898 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  })], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    attrs: {
      "height": _vm.calcDialogScroll(48 + 48 + 52)
    },
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      on: {
        "click": function($event) {
          $event.stopPropagation();
          !_vm.cxt.isSelectMode() ? _vm.openItem(item) : _vm.select(item.id)
        }
      }
    }, [_c('v-list-tile-content', {
      staticStyle: {
        "justify-content": "start"
      }
    }, [_c('v-list-tile-title', [_c('b', [_c('a', {
      attrs: {
        "href": _vm.getItemRef(item),
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(item.title))])])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n              " + _vm._s(item.description) + "\n               ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.cxt.isSelectMode()),
        expression: "!cxt.isSelectMode()"
      }]
    }, [_vm._v(" " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.isSelectMode()),
        expression: "cxt.isSelectMode()"
      }]
    }, [_c('v-list-tile-action-text', [_vm._v("  " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.id + '')),
        expression: "cxt.check(item.id + '')"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.id + '')),
        expression: "cxt.uncheck(item.id + '')"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.id + '')),
        expression: "cxt.check(item.id + '')"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.id + '')),
        expression: "cxt.uncheck(item.id + '')"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 899 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(900),
  /* template */
  __webpack_require__(901),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_CardScroll__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-human-selector-tab',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_5__common_CardScroll___default.a },
  data: function data() {
    return {
      itemId: null,
      cxt: null,
      humans: [],
      isLoading: false
    };
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_4__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return _this.getItemKey(item);
      });
    });
    cxt.filterMode = true;
    cxt.mode = __WEBPACK_IMPORTED_MODULE_4__api_classes__["a" /* default */].modes.SELECT;
    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.cxt.filterString = this.query;
    this.itemId = this.queryCxt;
    this.fetchItems();
  },

  watch: {
    queryCxt: function queryCxt(newVal) {
      this.itemId = newVal;
      this.fetchItems();
    },
    query: function query() {
      this.request = this.query;
    },
    selected: function selected(newVal, oldVal) {
      this.cxt.setSelected(newVal);
    },
    methodsQueue: function methodsQueue() {
      this.processMethodsQueue();
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    queryCxt: {
      type: String,
      default: null
    },
    query: {
      type: String,
      default: null
    },
    selected: {
      type: Array,
      default: []
    },
    methodsQueue: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    getIsMobile: 'getIsMobile',
    renderInnflHtml: 'renderInnflHtml',
    calcDialogScroll: 'calcDialogScroll',
    renderShare: 'renderShare'
  }), {
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getSearchTotal > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getSearchTotal + ' первых' : '';
      }
    },
    title: function title() {
      return 'Выберите физическое лицо';
    },
    items: function items() {
      return this.humans;
    },
    orderedItems: function orderedItems() {
      return this.items.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.caption, b.caption);
      });
    },
    filteredItems: function filteredItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.inn, item.caption);
      };
      var filter = !this.cxt.isFilterMode() || this.cxt.filterString === null || this.cxt.filterString.length < 3 ? null : this.cxt.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
    },
    isSearching: function isSearching() {
      return this.isLoading;
    },
    getSearchTotal: function getSearchTotal() {
      return this.humans && this.humans.length || 0;
    }
  }),
  methods: {
    processMethodsQueue: function processMethodsQueue() {
      if (!this.methodsQueue) return;
      var len = this.methodsQueue.length;
      for (var i = 0; i < len; i++) {
        var method = this.methodsQueue.shift();
        if (this[method.name]) {
          this[method.name](method.params);
        }
      }
    },
    checkAll: function checkAll() {
      this.cxt.checkAll();
      this.$emit('input', this.cxt.selected());
    },
    select: function select(uid) {
      if (this.cxt.uncheck('inn:' + uid)) {
        if (this.radio) {
          this.cxt.clear();
        }
      }
      this.cxt.select('inn:' + uid);
      this.$emit('input', this.cxt.selected());
    },
    setRequest: function setRequest(v) {
      this.cxt.filterString = v;
    },
    getItems: function getItems(id, cb) {
      var _this2 = this;

      var cbError = function cbError(e) {
        _this2.isLoading = false;
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка физических лиц компании ' });
      };
      var companyRefCode = id;
      if (!__WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].isRefCode(companyRefCode)) {
        this.$store.commit('setErrorStatus', { error: '\u041D\u0435\u0432\u0435\u0440\u043D\u044B\u0439 \u043A\u043E\u0434 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 [' + companyRefCode + '] ', context: 'Ошибка клиента при получении списка физических лиц компании ' });
      }
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGet('/openapi/companies/' + __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].splitRefCode(companyRefCode).code + '/humans', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this3 = this;

      this.isLoading = true;
      this.humans = [];
      this.getItems(this.itemId, function (data) {
        _this3.humans = data;
        _this3.isLoading = false;
      });
    },
    getItemKey: function getItemKey(item) {
      return 'inn:' + item.inn;
    },
    formatPercent: function formatPercent(item) {
      var share = __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].getValue(item, ['holderShares', 0]);
      return this.renderShare(share);
    },
    formatDescription: function formatDescription(item) {
      var result = '.';
      if (item.holderName) {
        result = '\u0423\u0447\u0430\u0441\u0442\u043D\u0438\u043A ' + this.formatPercent(item) + ' ' + (item.holderDetails ? item.holderName : '') + ' ' + (item.holderDetails ? '(' + item.holderDetails + ')' : '') + result;
      }
      if (item.position) {
        result = item.position + ', ' + result;
      }
      if (result.length > 0) {
        result = ': ' + result;
      }
      return '\u0418\u041D\u041D ' + this.renderInnflHtml(item.inn) + ' ' + result;
    }
  }

});

/***/ }),
/* 901 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  })], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.setRequest
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "flat": "",
      "height": _vm.calcDialogScroll(48 + 48 + 52)
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: item.inn,
      on: {
        "click": function($event) {
          return _vm.select(item.inn)
        }
      }
    }, [_c('v-list-tile-content', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item, '_blank'))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatDescription(item))
      }
    })])])], 1), _vm._v(" "), _c('v-list-tile-action', [(_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_checked")]) : _vm._e(), _vm._v(" "), (_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("radio_button_unchecked")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]) : _vm._e(), _vm._v(" "), (!_vm.radio) ? _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")]) : _vm._e()], 1)], 1)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 902 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "tabindex": "-1"
    },
    on: {
      "keydown": [function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "esc", 27, $event.key, ["Esc", "Escape"])) { return null; }
        return _vm.$emit('close')
      }, function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.$emit('enter')
      }]
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "dense": "",
      "light": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [(_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v("Выберите")]) : _vm._e(), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title))]) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-actions-btn', {
    attrs: {
      "caption": _vm.sourceActionsCaption(),
      "actions": _vm.sourceActions()
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), (_vm.sourceIs('LOCAL')) ? _c('div', [_c('v-people-selector-tab', {
    attrs: {
      "query": _vm.request,
      "radio": _vm.radio,
      "fullscreen": _vm.fullscreen,
      "selected": _vm.cxt.selected(),
      "methodsQueue": _vm.methodsQueue
    },
    on: {
      "input": _vm.changeSelected,
      "change": _vm.changeRequest
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.sourceIs('SEARCH')) ? _c('div', [_c('v-human-selector-tab', {
    attrs: {
      "query": _vm.request,
      "queryCxt": _vm.queryCxt,
      "radio": _vm.radio,
      "fullscreen": _vm.fullscreen,
      "selected": _vm.cxt.selected(),
      "methodsQueue": _vm.methodsQueue
    },
    on: {
      "input": _vm.changeSelected
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": _vm.cxt.selectedCount() === 0
    },
    on: {
      "click": _vm.ok
    }
  }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() === 0 && !_vm.radio),
      expression: "cxt.selectedCount() === 0 && !radio"
    }],
    on: {
      "click": function($event) {
        return _vm.checkAll()
      }
    }
  }, [_vm._v("Выбрать все")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.selectedCount() > 0),
      expression: "cxt.selectedCount() > 0"
    }],
    on: {
      "click": function($event) {
        return _vm.cxt.clear()
      }
    }
  }, [_vm._v("Очистить")]), _vm._v(" "), _c('span', {
    attrs: {
      "tabindex": "0"
    },
    on: {
      "focus": function($event) {
        return _vm.firstFocus()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 903 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(904),
  /* template */
  __webpack_require__(905),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_files__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__client_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_BtnForm__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'people-loader',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_10__common_BtnForm___default.a },
  data: function data() {
    return {
      files: [],
      fields: [{ name: 'innfl', label: 'ИНН Физ. лица', number: 0 }, { name: 'lastName', label: 'Фамилия', number: 1 }, { name: 'firstName', label: 'Имя', number: 2 }, { name: 'middleName', label: 'Отчество', number: 3 }, { name: 'sex', label: 'Пол', number: 4 }, { name: 'birthday', label: 'Дата рождения', number: 5 }, { name: 'birthplace', label: 'Место рождения', number: 6 }, { name: 'snils', label: 'СНИЛС', number: 7 }, { name: 'sernum', label: 'Серия номер паспорта РФ', number: 8 }, { name: 'issuer', label: 'Организация выдавшая документ', number: 9 }, { name: 'issued', label: 'Дата выдачи', number: 10 }, { name: 'issuerCode', label: 'Код подразделения', number: 11 }, { name: 'passportAddress', label: 'Адрес регистрации', number: 12 }, { name: 'companyInn', label: 'ИНН компании', number: 13 }, { name: 'position', label: 'Должность', number: 14 }, { name: 'phone', label: 'Телефон', number: 15 }, { name: 'email', label: 'Эл. почта', number: 16 }, { name: 'address', label: 'Адрес', number: 17 }],
      genderFormat: 'MF',
      dateFormat: 'YYYY-MM-DD',
      textData: null,
      arrData: null,
      test: null,
      selectedIds: []
    };
  },
  mounted: function mounted() {},

  watch: {
    textData: function textData(newVal, oldVal) {
      this.updateArrData();
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_5_vuex__["mapGetters"])({}), {
    title: function title() {
      return 'Импорт данных о Физ. лицах';
    }
  }),
  methods: {
    errorFileMessage: function errorFileMessage(file) {
      return __WEBPACK_IMPORTED_MODULE_7__api_files__["a" /* default */].errorFileMessage(file);
    },
    getAcceptedFileFormat: function getAcceptedFileFormat() {
      return '.csv, .xlsx';
    },
    pickFile: function pickFile() {
      this.$refs.image.click();
    },
    onFilePicked: function onFilePicked(e) {
      var _this = this;

      var fs = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(e.target.files);
      if (fs.length > 0) {
        fs.forEach(function (f) {
          return __WEBPACK_IMPORTED_MODULE_7__api_files__["a" /* default */].readFileAsByteArray(f, function (bytes) {
            _this.addFile(f, bytes);
          });
        });
      }
    },
    addFile: function addFile(f, data) {
      var _this2 = this;

      var cb = function cb(bytes) {
        f.remove = function (e) {
          return !e && _this2.deleteFile(f);
        };
        _this2.files = [f];
        _this2.textData = bytes;
      };
      var cbErr = function cbErr(e) {
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при экспорте данных из файла ' });
      };
      __WEBPACK_IMPORTED_MODULE_7__api_files__["a" /* default */].convertToCsv(f, data, cb, cbErr);
    },
    deleteFile: function deleteFile(file) {
      this.files = this.files.filter(function (f) {
        return __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].compareString(f.name, file.name) !== 0;
      });
    },
    getNewFields: function getNewFields() {
      var result = [{ value: null, text: '(не задано)' }];
      if (this.arrData && this.arrData[0]) {
        this.arrData[0].forEach(function (value, key) {
          result.push({ value: key, text: value });
        });
      }
      return result;
    },
    getValue: function getValue(item) {
      return this.arrData && this.arrData[1] ? this.arrData[1][item.number] : '';
    },
    import: function _import(fields, data) {
      var _this3 = this;

      var map = [];
      fields.forEach(function (f) {
        map[f.name] = f.number;
      });
      var _g = function _g(rec, name) {
        return map[name] !== null ? rec[map[name]] : null;
      };
      var _d = function _d(v) {
        if (!v) return null;
        var result = null;
        var ms = null;
        switch (_this3.dateFormat) {
          case 'YYYY-MM-DD':
            ms = /^((?:19|20)\d\d)-(0[1-9]|1[012])-(0[1-9]|1[0-9]|2[0-9]|3[0,1])$/.exec(v);
            result = ms ? ms[1] + '-' + ms[2] + '-' + ms[3] : null;
            break;
          case 'DD/MM/YYYY':
            ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\/(0[1-9]|1[012])\/((?:19|20)\d\d)$/.exec(v);
            result = ms ? ms[3] + '-' + ms[2] + '-' + ms[1] : null;
            break;
          case 'DD.MM.YYYY':
            ms = /^(0[1-9]|1[0-9]|2[0-9]|3[0,1])\.(0[1-9]|1[012])\.((?:19|20)\d\d)$/.exec(v);
            result = ms ? ms[3] + '-' + ms[2] + '-' + ms[1] : null;
            break;
        }
        console.log('_d', v, result);
        return result;
      };
      var _s = function _s(v) {
        if (!v) return null;
        switch (_this3.genderFormat) {
          case 'MF':
            return (/^F|M$/.test(v) ? v : null
            );
          case '01':
            return (/^0|1$/.test(v) ? /^0$/.test(v) ? 'M' : 'F' : null
            );
          case '12':
            return (/^1|2$/.test(v) ? /^1$/.test(v) ? 'M' : 'F' : null
            );
        }
        return null;
      };
      var _inn = function _inn(v) {
        return !v ? null : __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isInn(v) ? v : null;
      };
      var _innfl = function _innfl(v) {
        return !v ? null : __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isInnfl(v) ? v : null;
      };
      var _snils = function _snils(v) {
        if (!v) return null;
        if (__WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isSnils(v)) return v;
        var s = v.split(/-|\s/).join('');
        if (__WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isSnils(s)) return s;
        return null;
      };
      var _sernum = function _sernum(v) {
        if (!v) return null;
        if (/^\d{4}\s\d{6}$/.test(v)) return v;
        if (/^\d{4}\d{6}$/.test(v)) return v.slice(0, 4) + ' ' + v.slice(4);
      };
      var _name = function _name(v) {
        if (!v) return null;
        if (__WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isNameRu(v, 60)) return v;
        return null;
      };
      var _camelName = function _camelName(v) {
        return '' + v.slice(0, 1).toUpperCase() + v.slice(1).toLowerCase();
      };
      var _nameCanonic = function _nameCanonic(v) {
        if (!v) return null;
        if (__WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isNameRu(v, 60)) {
          var s = v;
          v.split(/-|\s/).forEach(function (w) {
            s = s.replace(w, _camelName(w));
          });
          return s;
        }
        return null;
      };
      // const _p = (v) => //
      var result = [];
      data.forEach(function (r, index) {
        if (index !== 0 && _g(r, 'lastName')) {
          result.push({
            individual: { lastName: _nameCanonic(_g(r, 'lastName')), firstName: _nameCanonic(_g(r, 'firstName')), middleName: _nameCanonic(_g(r, 'middleName')), innfl: _innfl(_g(r, 'innfl')), birthday: _d(_g(r, 'birthday')), sex: _s(_g(r, 'sex')), snils: _snils(_g(r, 'snils')), address: _g(r, 'passportAddress') },
            contact: { companyInn: _inn(_g(r, 'companyInn')), position: _g(r, 'position'), phone: _g(r, 'phone'), email: _g(r, 'email'), address: _g(r, 'address') },
            doc: _sernum(_g(r, 'sernum')) ? {
              type: 'PASSPORT_RF',
              model: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_json_stringify___default()({ modelType: '21.01', surname: _name(_g(r, 'lastName')), firstname: _name(_g(r, 'firstName')), patronymic: _name(_g(r, 'middleName')), sernum: _sernum(_g(r, 'sernum')), birthday: _d(_g(r, 'birthday')), sex: _s(_g(r, 'sex')), issuer: _g(r, 'issuer'), issued: _d(_g(r, 'issued')), issuerCode: _g(r, 'issuerCode'), address: _g(r, 'passportAddress'), birthplace: _g(r, 'birthplace')
              })
            } : null
          });
        }
      });
      return this.addRefCode(result).then(function (dtos) {
        return _this3.$store.dispatch('updatePeopleIndividuals', { dtos: dtos });
      });
    },
    addRefCode: function addRefCode(dtos) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var inns = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
        dtos.forEach(function (dto) {
          if (dto.contact && dto.contact.companyInn) {
            inns.add(dto.contact.companyInn);
          }
        });
        __WEBPACK_IMPORTED_MODULE_9__client_index_js__["a" /* default */].convertInnToRefCode(inns).then(function (map) {
          dtos.forEach(function (dto) {
            if (dto.contact && dto.contact.companyInn && map[dto.contact.companyInn]) {
              dto.contact['companyRefCode'] = map[dto.contact.companyInn];
            }
          });
          resolve(dtos);
        });
      });
    },
    ok: function ok() {
      var _this4 = this;

      var result = this.arrData;
      console.log('ok', result);
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u043E \u0424\u0438\u0437. \u043B\u0438\u0446\u0430\u0445 (' + (result.length - 1) + ')?', function (self) {
        _this4.import(_this4.fields, result).then(function () {
          return __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].message(_this4, 'Импорт', 'Данные загружены на сервер');
        });
        _this4.$emit('input', result);
        _this4.cancel();
      });
    },
    cancel: function cancel() {
      this.$emit('close');
      this.item = null;
    },
    updateArrData: function updateArrData() {
      var arrData = __WEBPACK_IMPORTED_MODULE_7__api_files__["a" /* default */].parseCsv(__WEBPACK_IMPORTED_MODULE_7__api_files__["a" /* default */].decode(this.textData));
      // skip empty lines
      while (arrData.length > 0 && arrData[0].join('').length === 0) {
        arrData.shift();
      }
      this.arrData = arrData;
    }
  }

});

/***/ }),
/* 905 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.arrData || _vm.arrData.length === 0
          },
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "py-3": ""
    }
  }, [_vm._v("\n            Для импорта данных, выберите файл (xlsx, csv), содержащий обязательные  колонки: "), _c('b', [_vm._v("\n            инн физ. лица, фамилия, имя, отчество")]), _vm._v(" и дополнительные колонки: "), _c('b', [_vm._v(" пол, дата рождения, снилс, номер паспорта РФ, инн компании, должность, телефон, email, адрес.")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm6": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(item.name.slice(0, 30)) + "\n              ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile,
      "keydown": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.pickFile.apply(null, arguments)
      }
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n              Выберите файл для импорта\n              ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat(),
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n            Уточните соответствие атрибутов записи о физ.лице и колонок в загружаемом файле\n          ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('b', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Атрибут")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Название колонки")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Пример значения")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.fields), function(item) {
    return [_c('v-layout', {
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "sm3": ""
      }
    }, [_c('span', [_vm._v(_vm._s(item.label))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('v-select', {
      attrs: {
        "hide-details": "",
        "items": _vm.getNewFields(),
        "item-value": "value",
        "item-text": "text"
      },
      model: {
        value: (item.number),
        callback: function($$v) {
          _vm.$set(item, "number", $$v)
        },
        expression: "item.number"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.getValue(item)))])])], 1)]
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n          При импорте данных происходит проверка формата, если данные не удовлетворяют формату, то они не записываются в систему. "), _c('br'), _vm._v("Для более точной настройки укажите форматы следующих данных:\n        ")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Муж/Жен",
      "items": [{
          value: 'MF',
          text: 'Муж.(M)/Жен.(F)'
        },
        {
          value: '01',
          text: 'Муж.(0)/Жен.(1)'
        },
        {
          value: '12',
          text: 'Муж.(1)/Жен.(2)'
        }
      ]
    },
    model: {
      value: (_vm.genderFormat),
      callback: function($$v) {
        _vm.genderFormat = $$v
      },
      expression: "genderFormat"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs8": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Формат дат",
      "items": [{
          value: 'YYYY-MM-DD',
          text: 'гггг-мм-дд'
        },
        {
          value: 'DD/MM/YYYY',
          text: 'дд/мм/гггг'
        },
        {
          value: 'DD.MM.YYYY',
          text: 'дд.мм.гггг'
        }
      ]
    },
    model: {
      value: (_vm.dateFormat),
      callback: function($$v) {
        _vm.dateFormat = $$v
      },
      expression: "dateFormat"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 906 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(907),
  /* template */
  __webpack_require__(908),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_ChipsField_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_ChipsField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_ChipsField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__client__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BtnForm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import server from '../../api/server'

// import dialogs from '../common/dialogs'




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default.a, vChipsField: __WEBPACK_IMPORTED_MODULE_5__common_ChipsField_vue___default.a },
  data: function data() {
    return {
      valid: false,
      company: null,
      item: {},
      phoneRules: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].isPhone(__WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatPhone(v)) || 'Формат номера +7(921)1234567';
      }],
      emailRules: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      }],
      innflRules: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].isInnfl(v) || 'Неверный формат ИНН';
      }],
      snilsRules: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].isSnils(v) || 'Неверный формат СНИЛС';
      }],
      ruleNameRu: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].isNameRu(v, 60) || 'Допустимы русские буквы';
      }],
      lastnameNotNullRule: [function (v) {
        return !!v || 'Введите фамилию';
      }]
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    parentId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchData(this.parentId, this.itemId);
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.fetchData(this.parentId, this.itemId);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile'
  }), {
    isEdit: function isEdit() {
      return true;
    },
    isNew: function isNew() {
      return this.itemId === null;
    },
    title: function title() {
      return this.isNew ? 'Добавить контакт' : this.isEdit ? 'Изменить атрибуты' : 'Информация о контакте';
    },
    chipsItems: function chipsItems() {
      var getHint = function getHint(company) {
        return company.name + ' (\u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatInn(company.inn) + ')';
      };
      var getError = function getError(company) {
        return null;
      };
      if (this.company && this.item && this.item.companyRefCode === this.company.ref) {
        var c = this.company;
        return [{ value: c.ref, text: c.caption, hint: getHint(c), error: getError(c) }];
      }
      if (this.item && this.item.companyRefCode) {
        return [{ value: this.item.companyRefCode + '', text: this.item.companyRefCode, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null }];
      }
      return [];
    }
  }),
  methods: {
    formatPhone: function formatPhone(v) {
      return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatPhone(v);
    },
    fetchData: function fetchData(parentId, itemId) {
      var _this = this;

      if (parentId && itemId) {
        this.$store.dispatch('getPeopleIndividual', parentId).then(function (data) {
          var contact = data.contacts.find(function (contact) {
            return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(itemId, contact.id) === 0;
          });
          delete data.contacts;
          _this.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this.getItemNew(), data);
          if (contact) {
            _this.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(_this.item, contact);
            _this.fetchCompany(_this.item.companyRefCode);
            // console.log('fetchData1', contact, this.item)
          }
        });
      } else {
        this.item = this.getItemNew();
      }
    },
    fetchCompany: function fetchCompany(companyRefCode) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!companyRefCode) {
          _this2.company = null;
          resolve(null);
        }
        __WEBPACK_IMPORTED_MODULE_6__client__["a" /* default */].getCachedRefs([companyRefCode], function (companies) {
          _this2.company = companies.length > 0 ? companies[0] : null;
          resolve(_this2.company);
        });
      });
    },
    add: function add() {
      var _this3 = this;

      if (this.$refs.form.validate()) {
        var item = this.item;
        var name = item.name;
        if (!this.parentId) {
          this.$store.dispatch('updatePeopleIndividual', {
            id: null,
            individual: { lastName: item.lastName, firstName: item.firstName, middleName: item.middleName, innfl: item.innfl },
            contact: { id: this.itemId, name: name, companyRefCode: item.companyRefCode, position: item.position, phone: item.phone, email: item.email, address: item.address, notes: item.notes }
          }).then(function (id) {
            _this3.$emit('change', id);
            _this3.cancel();
          });
        } else {
          this.$store.dispatch('updatePeopleIndividual', {
            id: this.parentId,
            contact: { id: this.itemId, name: name, companyRefCode: item.companyRefCode, position: item.position, phone: item.phone, email: item.email, address: item.address, notes: item.notes }
          }).then(function () {
            _this3.$emit('change', _this3.parentId);
            _this3.cancel();
          });
        }
      }
    },
    cancel: function cancel() {
      this.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    save: function save() {},
    remove: function remove() {},
    selectInn: function selectInn() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_6__client__["a" /* default */].selectRef(this, function (companies) {
        _this4.item.companyRefCode = companies.length > 0 ? companies[0].ref : null;
        _this4.fetchCompany(_this4.item.companyRefCode).then(function (company) {
          _this4.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this4.item, { position: null });
        });
      }, function () {}, true, true);
    },
    clearInn: function clearInn() {
      delete this.item.companyRefCode;
      this.fetchCompany(null);
    },
    getItemNew: function getItemNew() {
      return {
        individualId: null,
        firstName: null,
        middleName: null,
        lastName: null,
        innfl: null,
        companyRefCode: null,
        phone: null,
        email: null,
        adderess: null,
        notes: null
      };
    }
  }

});

/***/ }),
/* 908 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Добавить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "lastName",
      "label": "Фамилия",
      "type": "text",
      "rules": this.lastnameNotNullRule.concat(this.ruleNameRu)
    },
    model: {
      value: (_vm.item.lastName),
      callback: function($$v) {
        _vm.$set(_vm.item, "lastName", $$v)
      },
      expression: "item.lastName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "firstName",
      "label": "Имя",
      "type": "text",
      "rules": _vm.ruleNameRu
    },
    model: {
      value: (_vm.item.firstName),
      callback: function($$v) {
        _vm.$set(_vm.item, "firstName", $$v)
      },
      expression: "item.firstName"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "middleName",
      "label": "Отчество",
      "type": "text",
      "rules": _vm.ruleNameRu
    },
    model: {
      value: (_vm.item.middleName),
      callback: function($$v) {
        _vm.$set(_vm.item, "middleName", $$v)
      },
      expression: "item.middleName"
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "innfl",
      "label": "Инн",
      "type": "text",
      "rules": _vm.innflRules
    },
    model: {
      value: (_vm.item.innfl),
      callback: function($$v) {
        _vm.$set(_vm.item, "innfl", $$v)
      },
      expression: "item.innfl"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "name",
      "label": "Название",
      "type": "text"
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-chips-field', {
    attrs: {
      "emptyChip": "Организация",
      "solo": "",
      "flat": "",
      "items": _vm.chipsItems,
      "chipSize": _vm.getIsMobile ? 12 : 25
    },
    on: {
      "remove": _vm.clearInn,
      "click": _vm.selectInn
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "position",
      "label": "Должность",
      "type": "text"
    },
    model: {
      value: (_vm.item.position),
      callback: function($$v) {
        _vm.$set(_vm.item, "position", $$v)
      },
      expression: "item.position"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "label": "Эл. почта",
      "type": "text",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.item.email),
      callback: function($$v) {
        _vm.$set(_vm.item, "email", $$v)
      },
      expression: "item.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.phoneRules,
      "name": "phone",
      "label": "Тел.",
      "type": "text"
    },
    on: {
      "change": function($event) {
        _vm.item.phone = _vm.formatPhone($event)
      }
    },
    model: {
      value: (_vm.item.phone),
      callback: function($$v) {
        _vm.$set(_vm.item, "phone", $$v)
      },
      expression: "item.phone"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "address",
      "label": "Адрес",
      "type": "text"
    },
    model: {
      value: (_vm.item.address),
      callback: function($$v) {
        _vm.$set(_vm.item, "address", $$v)
      },
      expression: "item.address"
    }
  }), _vm._v(" "), (_vm.parentId) ? _c('v-text-field', {
    attrs: {
      "name": "notes",
      "label": "Заметки",
      "type": "text"
    },
    model: {
      value: (_vm.item.notes),
      callback: function($$v) {
        _vm.$set(_vm.item, "notes", $$v)
      },
      expression: "item.notes"
    }
  }) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 909 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(910),
  /* template */
  __webpack_require__(911),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__client_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BtnForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ChipsField_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_ChipsField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_ChipsField_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import depo from '.'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'holder-list',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default.a, vChipsField: __WEBPACK_IMPORTED_MODULE_8__common_ChipsField_vue___default.a },
  data: function data() {
    return {
      cxt: null,
      items: []
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    holders: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    title: {
      type: String,
      default: 'Выберите документ'
    },
    companyRefCode: {
      type: String,
      default: null
    }
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_2__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return _this.getItemKey(item);
      });
    });
    // cxt.mode = classes.modes.SELECT
    this.cxt = cxt;
    if (this.selected != null) {
      this.selected.forEach(function (id) {
        return _this.cxt.select(id);
      });
    }
  },
  mounted: function mounted() {
    this.fetchData();
  },

  watch: {
    companyRefCode: function companyRefCode(newVal, oldVal) {
      // watch it
      this.fetchData();
    },
    holders: function holders(newVal, oldVal) {
      // watch it
      this.fetchData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  }), {
    orderedItems: function orderedItems() {
      // console.log('orderedItems', this.items)
      return this.items.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].compareString(a.title, b.title);
      });
    },
    filteredItems: function filteredItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.title).concat(item.text);
      };
      var filter = !this.cxt.isFilterMode() || this.cxt.filterString === null || this.cxt.filterString.length < 3 ? null : this.cxt.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
    }
  }),
  methods: {
    getItemKey: function getItemKey(item) {
      return item.value;
    },
    fetchData: function fetchData() {
      var _this2 = this;

      if (this.holders) {
        console.log('fetchData', this.holders);
        this.holders.forEach(function (h) {
          var item = { value: h.ref, title: h.name, text: null, ref: h.ref, name: h.name, share: h.share, personId: h.personId, individual: h.individual, passportId: h.passportId, passport_rf: h.passport_rf, contactId: h.contactId, contact: h.contact, innfl: h.innfl };
          item.text = _this2.getText(item);
          _this2.items.push(item);
        });
      }
    },
    ok: function ok() {
      var holders = [];
      this.items.forEach(function (i) {
        holders.push({
          ref: i.ref,
          name: i.name,
          share: i.share,
          innfl: i.innfl,
          personId: i.personId,
          individual: i.individual,
          passportId: i.passportId,
          passport_rf: i.passport_rf,
          contactId: i.contactId,
          contact: i.contact,
          reason: ''
        });
      });
      console.log('input', holders);
      this.$emit('input', holders);
      this.cancel();
    },
    cancel: function cancel() {
      this.$emit('close');
      this.itemId = null;
    },
    select: function select(uid) {
      if (this.cxt.uncheck(uid)) {
        if (this.radio) {
          this.cxt.clear();
        }
      }
      this.cxt.select(uid);
    },
    click: function click(item) {},
    removePassport: function removePassport(item) {
      item.passportId = null;
      item.passport_rf = null;
    },
    clickPassport: function clickPassport(item) {
      if (this.cxt === __WEBPACK_IMPORTED_MODULE_2__api_classes__["a" /* default */].modes.SELECT) {
        this.select(this.getItemKey(item));
      } else {
        this.onClickPassport(item);
      }
    },
    removeContact: function removeContact(item) {
      item.contactId = null;
      item.contact = null;
    },
    clickContact: function clickContact(item) {
      if (this.cxt === __WEBPACK_IMPORTED_MODULE_2__api_classes__["a" /* default */].modes.SELECT) {
        this.select(this.getItemKey(item));
      } else {
        this.onClickContact(item);
      }
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
    },
    onSetItem: function onSetItem(values) {
      if (Array.isArray(values) && values.length > 0) {
        // this.setCode(model, values[0], onChange)
      }
    },
    getText: function getText(item) {
      console.log('getText', item);
      var fstrategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, 'PASSPORT_RF');
      return item.passport_rf ? '\u041F\u0430\u0441\u043F\u043E\u0440\u0442: ' + item.passport_rf.surname + ' ' + item.passport_rf.firstname + ' ' + item.passport_rf.patronymic + ' ' + fstrategy.viewNumber(item.passport_rf) : 'Введите паспортные данные';
    },
    getContact: function getContact(item) {
      var fstrategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, 'CONTACT');
      return item.contact ? ' ' + fstrategy.viewNumber(item.contact) : 'Введите контактные данные';
    },
    getContactHint: function getContactHint(item) {
      var fstrategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, 'CONTACT');
      return item.contact ? ' ' + fstrategy.viewContent(item.contact) : '';
    },
    openPassport: function openPassport(item) {
      var _this3 = this;

      var type = 'PASSPORT_RF';
      var getQuery = function getQuery() {
        return '';
      };
      var setPassport = function setPassport(fstrategy, passportId) {
        item.passportId = passportId;
        fstrategy.fetchData(item.passportId).then(function (data) {
          var model = fstrategy.createModelFromData(data);
          item.passport_rf = model;
          item.text = _this3.getText(item);
        });
      };
      var personId = item.personId;
      var passportId = item.passportId;
      var fstrategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, type);
      if (!fstrategy) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].getIndividual(personId).then(function (individual) {
        if (passportId) {
          fstrategy.setParentProps(individual);
          __WEBPACK_IMPORTED_MODULE_4__common_forms_js__["a" /* default */].openFormStg(fstrategy, passportId).then(function (data) {
            setPassport(fstrategy, data);
          });
        } else {
          var arr = individual.docs.filter(function (d) {
            return d.type === type;
          });
          if (arr.length > 0) {
            __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].selectDocByIndividual(null, individual, getQuery, type).then(function (data) {
              if (Array.isArray(data) && data.length > 0) {
                setPassport(fstrategy, data[0]);
              }
            });
          } else {
            fstrategy.setParentProps(individual);
            __WEBPACK_IMPORTED_MODULE_4__common_forms_js__["a" /* default */].openFormStg(fstrategy, null).then(function (data) {
              setPassport(fstrategy, data);
            });
          }
        }
      });
    },
    openContact: function openContact(item) {
      var type = 'CONTACT';
      var getQuery = function getQuery() {
        return '';
      };
      var setContact = function setContact(fstrategy, contactId) {
        item.contactId = contactId;
        fstrategy.fetchData(item.contactId).then(function (data) {
          var model = fstrategy.createModelFromData(data);
          item.contact = model;
        });
      };
      var personId = item.personId;
      var contactId = item.contactId;
      var fstrategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, type);
      if (!fstrategy) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].getIndividual(personId).then(function (individual) {
        if (contactId) {
          fstrategy.setParentProps(individual);
          __WEBPACK_IMPORTED_MODULE_4__common_forms_js__["a" /* default */].openFormStg(fstrategy, contactId).then(function (data) {
            setContact(fstrategy, data);
          });
        } else {
          var arr = individual.contacts;
          if (arr.length > 0) {
            __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].selectContactByIndividual(null, individual, getQuery).then(function (data) {
              if (Array.isArray(data) && data.length > 0) {
                setContact(fstrategy, data[0]);
              }
            });
          } else {
            fstrategy.setParentProps(individual);
            __WEBPACK_IMPORTED_MODULE_4__common_forms_js__["a" /* default */].openFormStg(fstrategy, null).then(function (data) {
              setContact(fstrategy, data);
            });
          }
        }
      });
    },
    onClickPassport: function onClickPassport(item) {
      var _this4 = this;

      var setPerson = function setPerson(innfl) {
        __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].findIndividualByInn(item.innfl).then(function (person) {
          if (person) {
            item.personId = person.id;
            item.individual = person;
            _this4.openPassport(item);
          } else {
            __WEBPACK_IMPORTED_MODULE_5__client_index_js__["a" /* default */].getHumanProps(item.innfl).then(function (human) {
              __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].addHuman(_this4.companyRefCode, human).then(function (id) {
                item.personId = id;
                item.individual = person;
                _this4.openPassport(item);
              });
            });
          }
        });
      };
      var setIndividual = function setIndividual(values) {
        if (Array.isArray(values) && values.length > 0) {
          var id = values[0];
          __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].getIndividual(id).then(function (person) {
            if (person) {
              item.innfl = person.inn;
              item.personId = person.id;
              item.individual = person;
              _this4.openPassport(item);
            }
          });
        }
      };
      var getQuery = function getQuery() {
        return null;
      };
      if (!item.innfl) {
        __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].selectIndividual(this, this.companyRefCode, getQuery, true, true).then(function (data) {
          return setIndividual(data);
        });
      } else {
        setPerson(item.innfl);
      }
    },
    onClickContact: function onClickContact(item) {
      var _this5 = this;

      var setPerson = function setPerson(innfl) {
        __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].findIndividualByInn(item.innfl).then(function (person) {
          if (person) {
            item.personId = person.id;
            item.individual = person;
            _this5.openContact(item);
          } else {
            __WEBPACK_IMPORTED_MODULE_5__client_index_js__["a" /* default */].getHumanProps(item.innfl).then(function (human) {
              __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].addHuman(_this5.companyRefCode, human).then(function (id) {
                item.personId = id;
                item.individual = person;
                _this5.openContact(item);
              });
            });
          }
        });
      };
      var setIndividual = function setIndividual(values) {
        if (Array.isArray(values) && values.length > 0) {
          var id = values[0];
          __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].getIndividual(id).then(function (person) {
            if (person) {
              item.innfl = person.inn;
              item.personId = person.id;
              item.individual = person;
              _this5.openContact(item);
            }
          });
        }
      };
      var getQuery = function getQuery() {
        return null;
      };
      if (!item.innfl) {
        __WEBPACK_IMPORTED_MODULE_5__client_index_js__["a" /* default */].selectIndividual(this, this.companyRefCode, getQuery, true, true).then(function (data) {
          return setIndividual(data);
        });
      } else {
        setPerson(item.innfl);
      }
    }
  }
});

/***/ }),
/* 911 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")])]
      },
      proxy: true
    }])
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "mb-1": ""
      }
    }, [_c('v-card', {
      key: _vm.getItemKey(item),
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.click(item)
        }
      }
    }, [_c('v-card-text', [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm12": ""
      }
    }, [_c('b', [_vm._v(_vm._s(item.title))])]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-chips-field', {
      attrs: {
        "emptyChip": "Паспортные данные",
        "solo": "",
        "flat": "",
        "items": item.passportId ? [{
          value: item.passportId + '',
          text: item.text,
          hint: item.text,
          error: null
        }] : [],
        "chipSize": _vm.getIsMobile ? 25 : 25
      },
      on: {
        "remove": function($event) {
          return _vm.removePassport(item)
        },
        "click": function($event) {
          return _vm.clickPassport(item)
        }
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-chips-field', {
      attrs: {
        "emptyChip": "Контактная информация",
        "solo": "",
        "flat": "",
        "items": item.contactId ? [{
          value: item.contactId + '',
          text: _vm.getContact(item),
          hint: _vm.getContactHint(item),
          error: null
        }] : [],
        "chipSize": _vm.getIsMobile ? 25 : 25
      },
      on: {
        "remove": function($event) {
          return _vm.removeContact(item)
        },
        "click": function($event) {
          return _vm.clickContact(item)
        }
      }
    })], 1)], 1)], 1)], 1)], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__ = __webpack_require__(106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(36);












var Strategy = function (_DocAbstract$Strategy) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _DocAbstract$Strategy);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'PASSPORT_RF';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Паспорт РФ';
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(individual) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.createModel(), individual ? {
        surname: individual.lastName ? individual.lastName.toUpperCase() : null,
        firstname: individual.firstName ? individual.firstName.toUpperCase() : null,
        patronymic: individual.middleName ? individual.middleName.toUpperCase() : null,
        sex: individual.sex,
        birthday: individual.birthday
      } : {});
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var formatSerNum = function formatSerNum(v) {
        v = v.replaceAll(' ', '');
        return v.slice(0, 4) + ' ' + v.slice(4);
      };
      var ruleSerNum = function ruleSerNum(v) {
        return !v || /^\d{4}\s\d{6}$/.test(formatSerNum(v)) || 'Неверный формат - [4004 123456]';
      };
      var ruleNameRu = function ruleNameRu(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isNameRu(v, 60) || 'Допустимы русские буквы';
      };

      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Фамилия',
          name: 'surname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя',
          name: 'firstname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество',
          name: 'patronymic',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm8: true, xs8: true }
        }, {
          fieldType: 'v-select',
          label: 'Пол',
          name: 'sex',
          itemText: 'text',
          itemValue: 'value',
          items: [{ value: 'F', text: 'Жен.' }, { value: 'M', text: 'Муж.' }],
          grow: true,
          size: { sm4: true, xs4: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата рождения',
          name: 'birthday',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Место рождения',
          name: 'birthplace',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Серия номер',
          name: 'sernum',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleSerNum),
          format: formatSerNum,
          grow: true,
          size: { sm4: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата выдачи',
          name: 'issued',
          grow: true,
          size: { sm4: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Код подразделения',
          name: 'issuerCode',
          grow: true,
          size: { sm4: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Выдан',
          name: 'issuer',
          grow: true,
          size: { sm12: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Адрес регистрации',
          name: 'address',
          grow: true,
          size: { sm12: true, xs12: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      return this;
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      var issued = __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].blank(model['issued'], __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate);
      var sernum = __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].blank(model['sernum']);
      return sernum + ' \u0432\u044B\u0434\u0430\u043D: ' + issued;
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <span>' + this.getTypeName() + '</span>\n    ');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      var _f = function _f(v, f) {
        return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].blank(v, f);
      };
      var value = this.viewContent(model);
      var caption = '\n      <span>\n        <span>\u041D\u043E\u043C\u0435\u0440:&nbsp<b>' + _f(model['sernum']) + '</b></span><br/>\n        <span>\u0414\u0430\u0442\u0430 \u0432\u044B\u0434\u0430\u0447\u0438:&nbsp<b>' + _f(model['issued'], __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate) + '</b></span>\n      </span>\n    ';
      return {
        template: '<span><component :is="renderValueLink()"></component></span>',
        methods: {
          renderValueLink: function renderValueLink() {
            return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.renderValueLink(value, null, null, null, caption);
          }
        }
      };
    }
  }, {
    key: 'viewContent',
    value: function viewContent(model) {
      var _f = function _f(v, f) {
        return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].blank(v, f);
      };
      return '\n        \u041F\u0430\u0441\u043F\u043E\u0440\u0442: ' + _f(model['surname']) + ' ' + _f(model['firstname']) + ' ' + _f(model['patronymic']) + '\n        \u041D\u043E\u043C\u0435\u0440: ' + _f(model['sernum']) + '\n        \u0414\u0430\u0442\u0430 \u0432\u044B\u0434\u0430\u0447\u0438: ' + _f(model['issued'], __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate) + '\n        \u041A\u043E\u0434 \u043F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F: ' + _f(model['issuerCode']) + '\n        \u0412\u044B\u0434\u0430\u043D: ' + _f(model['issuer']) + '\n        \u0410\u0434\u0440\u0435\u0441: ' + _f(model['address']) + '\n    ';
    }
  }, {
    key: 'viewContentComp1',
    value: function viewContentComp1(model) {
      var fields = [{ value: __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].blank(model['sernum']), label: 'Номер:' }, { value: __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].blank(model['issued'], __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate), label: 'Дата выдачи:' }];
      return {
        template: '\n        <div>\n          <template v-for="item in fields">\n            <span><component :is="renderValueLink(item)"></component></span>\n          </template>\n        </div>\n        ',
        methods: {
          renderValueLink: function renderValueLink(item) {
            if (!item.value) {
              return '';
            }
            return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.renderValueLink(item.value, item.label);
          }
        },
        data: function data() {
          return {
            fields: fields
          };
        }
      };
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '21.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__ = __webpack_require__(106);











var Strategy = function (_DocAbstract$Strategy) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _DocAbstract$Strategy);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'TEMPORARY_ID_RF';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Временное удостоверение личности РФ';
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(individual) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.createModel(), {
        surname: individual.lastName,
        firstname: individual.firstName,
        patronymic: individual.middleName,
        birthday: individual.birthday
      });
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var ruleNameRu = function ruleNameRu(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isNameRu(v, 60) || 'Допустимы русские буквы';
      };

      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Фамилия',
          name: 'surname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm8: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя',
          name: 'firstname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество',
          name: 'patronymic',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs8: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата рождения',
          name: 'birthday',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Место рождения',
          name: 'birthplace',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Адрес места жительства(места пребывания)',
          name: 'address',
          grow: true,
          size: { sm12: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата выдачи',
          name: 'issued',
          grow: true,
          size: { sm4: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Наименование подразделения',
          name: 'issuer',
          grow: true,
          size: { sm8: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Причина выдачи',
          name: 'cause',
          grow: true,
          size: { sm12: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Действительно до',
          name: 'validTo',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Продлено до',
          name: 'extendedTo',
          grow: true,
          size: { sm6: true, xs12: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      return this;
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      return '-';
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <span>' + this.getTypeName() + '</span>\n    ');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <div>\n      <div>\u0414\u0430\u0442\u0430 \u0432\u044B\u0434\u0430\u0447\u0438:<b> ' + (model['issued'] ? __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate(model['issued']) : '-') + '</b></div>\n      <div>\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043E:<b> ' + (model['validTo'] ? __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate(model['validTo']) : '-') + '</b></div>\n      <div>\u041F\u0440\u043E\u0434\u043B\u0435\u043D\u043E \u0434\u043E:<b> ' + (model['extendedTo'] ? __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate(model['extendedTo']) : '-') + '</b></div>\n      </div>');
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '14.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__ = __webpack_require__(106);











var Strategy = function (_DocAbstract$Strategy) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _DocAbstract$Strategy);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'BIRTH_CERT_RF';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Свидетельство о рождении РФ';
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(individual) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.createModel(), {
        surname: individual.lastName,
        firstname: individual.firstName,
        patronymic: individual.middleName,
        sex: individual.sex,
        birthday: individual.birthday
      });
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var formatSerNum = function formatSerNum(v) {
        var ms = /^([IVX]{2,})[\s-]*([А-ЯЁ]{2,2})[\s-№#]*(\d{6})$/.exec(v.toUpperCase());
        v = ms ? ms[1] + ' ' + ms[2] + ' ' + ms[3] : v;
        return v;
      };
      var ruleSerNum = function ruleSerNum(v) {
        return !v || /^[IVX]{2,}\s*[А-ЯЁ]{2,2}\s*\d{6}$/.test(formatSerNum(v)) || 'Неверный формат - [II БЮ 123456]';
      };
      var ruleNameRu = function ruleNameRu(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isNameRu(v, 60) || 'Допустимы русские буквы';
      };
      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Фамилия',
          name: 'surname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя',
          name: 'firstname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество',
          name: 'patronymic',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm8: true, xs8: true }
        }, {
          fieldType: 'v-select',
          label: 'Пол',
          name: 'sex',
          itemText: 'text',
          itemValue: 'value',
          items: [{ value: 'F', text: 'Жен.' }, { value: 'M', text: 'Муж.' }],
          grow: true,
          size: { sm4: true, xs4: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата рождения',
          name: 'birthday',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Место рождения',
          name: 'birthplace',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Номер записи акта о рождении',
          name: 'birthNumber',
          grow: true,
          size: { sm4: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Серия номер',
          name: 'sernum',
          format: formatSerNum,
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleSerNum),
          grow: true,
          size: { sm4: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата выдачи',
          name: 'issued',
          grow: true,
          size: { sm4: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Организация выдавшая документ',
          name: 'issuer',
          grow: true,
          size: { sm12: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Фамилия отца',
          name: 'fatherSurname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя отца',
          name: 'fatherFirstname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество отца',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          name: 'fatherPatronymic',
          grow: true,
          size: { sm6: true, xs8: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Гражданство отца',
          name: 'fatherCitizenship',
          grow: true,
          size: { sm6: true, xs8: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Фамилия матери',
          name: 'motherSurname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя матери',
          name: 'motherFirstname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество матери',
          name: 'motherPatronymic',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs8: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Гражданство матери',
          name: 'motherCitizenship',
          grow: true,
          size: { sm6: true, xs8: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      return this;
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      return '' + (model['sernum'] ? model['sernum'] : '-');
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <span>' + this.getTypeName() + '</span>\n    ');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <div>\n      <div>\u041D\u043E\u043C\u0435\u0440:<b> ' + (model['sernum'] ? model['sernum'] : '-') + '</b></div>\n      <div>\u0414\u0430\u0442\u0430 \u0432\u044B\u0434\u0430\u0447\u0438:<b> ' + (model['issued'] ? __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate(model['issued']) : '-') + '</b></div>\n      </div>');
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '03.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__ = __webpack_require__(106);











var Strategy = function (_DocAbstract$Strategy) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _DocAbstract$Strategy);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'PENSION_CERT_RF';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Страховое свидетельство государственного пенсионного страхования';
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(individual) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.createModel(), {
        surname: individual.lastName,
        firstname: individual.firstName,
        patronymic: individual.middleName,
        sex: individual.sex,
        birthday: individual.birthday,
        snils: individual.snils
      });
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var ruleSnils = function ruleSnils(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isSnils(v) || 'Неверный формат СНИЛС';
      };
      var ruleNameRu = function ruleNameRu(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isNameRu(v, 60) || 'Допустимы русские буквы';
      };
      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Страховой номер',
          name: 'snils',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleSnils),
          grow: true,
          size: { sm8: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Фамилия',
          name: 'surname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя',
          name: 'firstname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество',
          name: 'patronymic',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-select',
          label: 'Пол',
          name: 'sex',
          itemText: 'text',
          itemValue: 'value',
          items: [{ value: 'F', text: 'Жен.' }, { value: 'M', text: 'Муж.' }],
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата рождения',
          name: 'birthday',
          grow: true,
          size: { sm6: true, xs8: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Место рождения',
          name: 'birthplace',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата регистрации',
          name: 'registered',
          grow: true,
          size: { sm6: true, xs8: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      return this;
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      return '' + (model['snils'] ? model['snils'] : '-');
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <span>' + this.getTypeName() + '</span>\n    ');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <div>\n      <div>\u0421\u0442\u0440\u0430\u0445\u043E\u0432\u043E\u0439 \u043D\u043E\u043C\u0435\u0440:<b> ' + (model['snils'] ? model['snils'] : '-') + '</b></div>\n      <div>\u0414\u0430\u0442\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438:<b> ' + (model['registered'] ? __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate(model['registered']) : '-') + '</b></div>\n      </div>');
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '101.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__ = __webpack_require__(106);











var Strategy = function (_DocAbstract$Strategy) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _DocAbstract$Strategy);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'DRIVER_LIC_RF';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Водительское удостоверение';
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(individual) {
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.createModel(), {
        surname: individual.lastName,
        firstname: individual.firstName,
        patronymic: individual.middleName,
        birthday: individual.birthday
      });
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var ruleSerNum = function ruleSerNum(v) {
        return !v || /^\d{2}\s[А-ЯЁ0-9]{2}\s\d{6}$/.test(v) || 'Неверный формат - [78 04 123456]';
      };
      var ruleNameRu = function ruleNameRu(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isNameRu(v, 60) || 'Допустимы русские буквы';
      };

      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Фамилия',
          name: 'surname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя',
          name: 'firstname',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество',
          name: 'patronymic',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm8: true, xs6: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата рождения',
          name: 'birthday',
          grow: true,
          size: { sm6: true, xs8: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Место рождения',
          name: 'birthplace',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата выдачи',
          name: 'issued',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Действительно до',
          name: 'validTo',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Подразделение',
          name: 'issuer',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Номер удостоверения',
          name: 'number',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleSerNum),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Место жительства',
          name: 'address',
          grow: true,
          size: { sm12: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Категории, подкатегории транспортных средств',
          name: 'category',
          grow: true,
          size: { sm12: true, xs12: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      return this;
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      return '' + (model['number'] ? model['number'] : '-');
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <span>' + this.getTypeName() + '</span>\n    ');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <div>\n      <div>\u041D\u043E\u043C\u0435\u0440 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0435\u043D\u0438\u044F:<b> ' + (model['number'] ? model['number'] : '-') + '</b></div>\n      <div>\u0414\u0430\u0442\u0430 \u0432\u044B\u0434\u0430\u0447\u0438:<b> ' + (model['issued'] ? __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate(model['issued']) : '-') + '</b></div>\n      <div>\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043E:<b> ' + (model['validTo'] ? __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate(model['validTo']) : '-') + '</b></div>\n      </div>');
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '102.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__ = __webpack_require__(106);











var Strategy = function (_DocAbstract$Strategy) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _DocAbstract$Strategy);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'MARRIAGE_CERT_RF';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Свидетельство о заключении брака';
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(individual) {
      var ops = {};
      if (individual.sex) {
        if (individual.sex === 'M') {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(ops, {
            surnameM: individual.lastName,
            firstnameM: individual.firstName,
            patronymicM: individual.middleName,
            birthdayM: individual.birthday
          });
        }
        if (individual.sex === 'F') {
          __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(ops, {
            surnameF: individual.lastName,
            firstnameF: individual.firstName,
            patronymicF: individual.middleName,
            birthdayF: individual.birthday
          });
        }
      }
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(this.createModel(), ops);
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var formatSerNum = function formatSerNum(v) {
        var ms = /^([IVX]{1,})[\s-]*([А-ЯЁ]{2,2})[\s-№#]*(\d{6})$/.exec(v.toUpperCase());
        v = ms ? ms[1] + ' ' + ms[2] + ' ' + ms[3] : v;
        return v;
      };
      var ruleSerNum = function ruleSerNum(v) {
        return !v || /^[IVX]{1,}\s*[А-ЯЁ]{2,2}\s*\d{6}$/.test(formatSerNum(v)) || 'Неверный формат - [I БЮ 123456]';
      };
      var ruleNameRu = function ruleNameRu(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isNameRu(v, 60) || 'Допустимы русские буквы';
      };

      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_8__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Фамилия',
          name: 'surnameM',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя',
          name: 'firstnameM',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество',
          name: 'patronymicM',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm8: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Гражданство',
          name: 'citizenshipM',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Национальность',
          name: 'nationalityM',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата рождения',
          name: 'birthdayM',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Место рождения',
          name: 'birthplaceM',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Фамилия',
          name: 'surnameF',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя',
          name: 'firstnameF',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество',
          name: 'patronymicF',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm8: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Гражданство',
          name: 'citizenshipF',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Национальность',
          name: 'nationalityF',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата рождения',
          name: 'birthdayF',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Место рождения',
          name: 'birthplaceF',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата заключения брака',
          name: 'married',
          grow: true,
          size: { sm8: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата регистрации',
          name: 'registered',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Номер записи об акте заключения брака',
          name: 'registerNumber',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Фамилия мужа после заключения брака',
          name: 'surnameNewM',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm8: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Фамилия жены после заключения брака',
          name: 'surnameNewF',
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm8: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Место государственной регистрации',
          name: 'issuer',
          grow: true,
          size: { sm12: true, xs12: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата выдачи',
          name: 'issued',
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Серия номер удостоверения',
          name: 'sernum',
          format: formatSerNum,
          rules: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_of___default()(ruleSerNum),
          grow: true,
          size: { sm6: true, xs12: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      return this;
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      return '' + (model['sernum'] ? model['sernum'] : '-');
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <span>' + this.getTypeName() + '</span>\n    ');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].createComp('\n      <div>\n      <div>\u041D\u043E\u043C\u0435\u0440 \u0443\u0434\u043E\u0441\u0442\u043E\u0432\u0435\u0440\u0435\u043D\u0438\u044F:<b> ' + (model['sernum'] ? model['sernum'] : '-') + '</b></div>\n      <div>\u0414\u0430\u0442\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438:<b> ' + (model['registered'] ? __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate(model['registered']) : '-') + '</b></div>\n      </div>');
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_9__DocAbstract_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '103.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__index_js__ = __webpack_require__(27);













var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).call(this, cxt));

    _this.citzenships = [];
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'INDIVIDUAL';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Физическое лицо';
    }
  }, {
    key: 'setContext',
    value: function setContext(cxt) {
      this.context = cxt;
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createModelFromJSON',
    value: function createModelFromJSON(json) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), JSON.parse(json));
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(individual) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), {});
    }
  }, {
    key: 'createModelFromData',
    value: function createModelFromData(data) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), data);
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var _this2 = this;

      var ruleNameRu = function ruleNameRu(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isNameRu(v, 60) || 'Допустимы русские буквы';
      };
      var innflRules = function innflRules(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isInnfl(v) || 'Неверный формат ИНН';
      };
      var snilsRules = function snilsRules(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isSnils(v) || 'Неверный формат СНИЛС';
      };

      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_10__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Фамилия',
          name: 'lastName',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Имя',
          name: 'firstName',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Отчество',
          name: 'middleName',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(ruleNameRu),
          grow: true,
          size: { sm8: true, xs8: true }
        }, {
          fieldType: 'v-select',
          label: 'Пол',
          name: 'sex',
          itemText: 'text',
          itemValue: 'value',
          items: [{ value: 'F', text: 'Жен.' }, { value: 'M', text: 'Муж.' }],
          grow: true,
          size: { sm4: true, xs4: true }
        }, {
          fieldType: 'v-date-field',
          label: 'Дата рождения',
          name: 'birthday',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-select',
          label: 'Гражданство',
          name: 'citizenship',
          itemText: 'value',
          itemValue: 'value',
          items: function items(model, field) {
            return _this2.citzenships;
          },
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'ИНН',
          name: 'innfl',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(innflRules),
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'СНИЛС',
          name: 'snils',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(snilsRules),
          grow: true,
          size: { sm6: true, xs6: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      this.citzenships = __WEBPACK_IMPORTED_MODULE_11__index_js__["a" /* default */].citizenships();
      return this;
    }
  }, {
    key: 'viewTitle',
    value: function viewTitle(model) {
      return model['nameShort'] ? model['nameShort'] : this.getTypeName();
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].createComp('\n      <span>' + (model['nameShort'] ? model['nameShort'] : this.getTypeName()) + '</span>\n    ');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      var _n = function _n(name) {
        return name ? name + ' ' : '';
      };
      var _fname = function _fname(lastName, firstName, middleName) {
        return (lastName || firstName || middleName) && '' + _n(lastName) + _n(firstName) + _n(middleName) || '-';
      };
      return __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].createComp('\n      <div>\n      <div><b> ' + _fname(model['lastName'], model['firstName'], model['middleName']) + '</b></div>\n      <span>\u0418\u041D\u041D:<b> ' + (__WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isInnfl(model['innfl']) ? __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].formatInnfl(model['innfl']) : '-') + ' </b></span>\n      <span>\u0421\u041D\u0418\u041B\u0421:<b> ' + (__WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isSnils(model['snils']) ? model['snils'] : '-') + '</b></span>\n      <div>\u0413\u0440\u0430\u0436\u0434\u0430\u043D\u0441\u0442\u0432\u043E:<b> ' + (model['citizenship'] ? model['citizenship'] : '-') + '</b></div>\n      </div>');
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'fetchData',
    value: function fetchData(itemId) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (itemId) {
          __WEBPACK_IMPORTED_MODULE_11__index_js__["a" /* default */].getIndividual(itemId).then(function (individual) {
            resolve(individual);
          });
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(itemId, model) {
      var _this3 = this;

      var item = model;
      console.log('updateData', model);
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.context.$store.dispatch('updatePeopleIndividual', {
          id: itemId,
          individual: {
            id: itemId,
            lastName: item.lastName,
            firstName: item.firstName,
            middleName: item.middleName,
            sex: item.sex,
            birthday: item.birthday,
            citizenship: item.citizenship,
            innfl: item.innfl,
            snils: item.snils
          }
        }).then(function (id) {
          resolve(id);
        });
      });
    }
  }, {
    key: 'deleteData',
    value: function deleteData(itemId, model) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_9__common_dialogs_js__["a" /* default */].confirm(_this4.context, 'Подтвердите', '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C \u043E \u0444\u0438\u0437. \u043B\u0438\u0446\u0435?', function (self) {
          self.$store.dispatch('deletePeopleIndividuals', { ids: [itemId] }).then(function () {
            return resolve();
          });
        });
      });
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_10__assist_AssistClasses_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '200.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__client__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ContactLinks_js__ = __webpack_require__(920);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__store__ = __webpack_require__(36);


















var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy(cxt) {
    __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    var _this = __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).call(this, cxt));

    _this.citzenships = [];
    _this.chipsItems = [];
    _this.pProps = null;
    _this.isIndividual = true;
    _this.editLinkMode = false;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'CONTACT';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return '\u041A\u043E\u043D\u0442\u0430\u043A\u0442 ' + (this.isIndividual ? 'физического лица' : 'компании');
    }
  }, {
    key: 'setContext',
    value: function setContext(cxt) {
      this.context = cxt;
    }
  }, {
    key: 'setParentProps',
    value: function setParentProps(pProps) {
      this.isIndividual = pProps.id != null;
      this.pProps = pProps;
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createModelFromJSON',
    value: function createModelFromJSON(json) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.createModel(), JSON.parse(json));
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(pProps) {
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.createModel(), {});
    }
  }, {
    key: 'createModelFromData',
    value: function createModelFromData(data) {
      if (data) {
        data.companyRefCode = data && data.companyRefCode ? data.companyRefCode : null;
      }
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(this.createModel(), data);
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var _this2 = this;

      var phoneRules = function phoneRules(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_9__api_formats__["a" /* default */].isPhone(__WEBPACK_IMPORTED_MODULE_9__api_formats__["a" /* default */].formatPhone(v)) || 'Формат номера +7(921)1234567';
      };
      var emailRules = function emailRules(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_9__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      };

      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_12__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Название',
          name: 'name',
          hint: 'Задает порядок, может заполнятся автоматически',
          grow: true,
          size: { sm8: true, xs12: true },
          if: function _if(model, field) {
            return _this2.isIndividual;
          }
        }, {
          fieldType: 'v-text-field',
          label: 'Название внутри компании',
          name: 'nameForCompany',
          hint: 'Задает порядок, может заполнятся автоматически',
          grow: true,
          size: { sm8: true, xs12: true
            // ,
            // if: (model, field) => !this.isIndividual
          } }, {
          fieldType: 'v-chips-field',
          emptyChip: 'Организация',
          name: 'companyRefCode',
          events: {
            'click': function click(key) {
              return _this2.selectCompanyRefCode(key);
            },
            'remove': function remove(key) {
              return _this2.removeCompanyRefCode(key);
            }
          },
          chipSize: this.getIsMobile ? 12 : 25,
          items: function items(model, field) {
            return _this2.chipsItems.filter(function (i) {
              return i.fieldName === 'companyRefCode';
            });
          },
          size: { sm6: true, xs6: true },
          if: function _if(model, field) {
            return _this2.isIndividual;
          }
        }, {
          fieldType: 'v-text-field',
          label: 'Должность',
          name: 'position',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-chips-field',
          emptyChip: 'Физ. Лицо',
          name: 'clientIndividualId',
          events: {
            'click': function click(key) {
              return _this2.selectIndividualId(key);
            },
            'remove': function remove(key) {
              return _this2.removeIndividualId(key);
            }
          },
          chipSize: this.getIsMobile ? 12 : 25,
          items: function items(model, field) {
            return _this2.chipsItems.filter(function (i) {
              return i.fieldName === 'clientIndividualId';
            });
          },
          size: { sm6: true, xs6: true },
          if: function _if(model, field) {
            return !_this2.isIndividual;
          }
        }, {
          fieldType: 'v-text-field',
          label: 'Эл. почта',
          name: 'email',
          rules: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_of___default()(emailRules),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Тел.',
          name: 'phone',
          rules: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_of___default()(phoneRules),
          format: __WEBPACK_IMPORTED_MODULE_9__api_formats__["a" /* default */].formatPhone,
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Адрес',
          name: 'address',
          grow: true,
          size: { sm12: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Заметки',
          name: 'notes',
          grow: true,
          size: { sm12: true, xs12: true }
        }, {
          fieldType: 'v-chips-field',
          emptyChip: function emptyChip(model, field) {
            return _this2.editLinkMode ? 'Добавить' : 'Изменить';
          },
          emptyAlways: true,
          emptyEnabled: true,
          name: 'links',
          disabled: function disabled(model, field) {
            return !_this2.editLinkMode;
          },
          events: {
            'click': function click(key) {
              return _this2.openLink(key);
            },
            'remove': function remove(key) {
              return _this2.removeLink(key);
            }
          },
          chipSize: this.getIsMobile ? 12 : 25,
          items: function items(model, field) {
            return _this2.getLinkItems(model);
          },
          size: { sm12: true, xs12: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      this.citzenships = __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].citizenships();
      return this;
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      return model['name'] ? model['name'] : '-';
    }
  }, {
    key: 'viewTitle',
    value: function viewTitle(model) {
      if (this.pProps) {
        return '\u041A\u043E\u043D\u0442\u0430\u043A\u0442 ' + this.pProps.nameShort;
      }
      return this.getTypeName();
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      if (this.isIndividual) {
        return __WEBPACK_IMPORTED_MODULE_9__api_formats__["a" /* default */].createComp('\n        <span>' + (model['name'] ? model['name'] : this.getTypeName()) + '</span>\n      ');
      } else {
        return __WEBPACK_IMPORTED_MODULE_9__api_formats__["a" /* default */].createComp('\n        <span>' + (model['nameForCompany'] ? model['nameForCompany'] : this.getTypeName()) + '</span>\n      ');
      }
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      var _f = function _f(v) {
        return v || '-';
      };
      var fields = [];
      if (this.isIndividual) {
        fields = [{ value: _f(model['position']), label: 'Должность:' }, { value: _f(model['email']), label: 'Эл. почта:' }, { value: _f(model['phone']), label: 'Тел.:' }, { value: _f(model['address']), label: 'Адрес:' }, { value: model['notes'], label: 'Заметки:' }];
      } else {
        fields = [{ value: _f(model['email']), label: 'Эл. почта:' }, { value: _f(model['phone']), label: 'Тел.:' }, { value: _f(model['address']), label: 'Адрес:' }, { value: model['notes'], label: 'Заметки:' }];
      }
      return {
        template: '\n        <div>\n          <template v-for="item in fields">\n            <span><component :is="renderValueLink(item)"></component></span>\n          </template>\n          <span>' + this.getLinkImgs(model) + '</span>\n        </div>\n        ',
        methods: {
          renderValueLink: function renderValueLink(item) {
            if (!item.value) {
              return '';
            }
            return __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters.renderValueLink(item.value, item.label);
          }
        },
        data: function data() {
          return {
            fields: fields
          };
        }
      };
    }
  }, {
    key: 'viewContent',
    value: function viewContent(model) {
      var _f = function _f(v) {
        return v || '-';
      };
      return '\n        \u0414\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C: ' + _f(model['position']) + '\n\n        \u042D\u043B. \u043F\u043E\u0447\u0442\u0430: ' + _f(model['email']) + '\n\n        \u0422\u0435\u043B.: ' + _f(model['phone']) + '\n\n        \u0410\u0434\u0440\u0435\u0441: ' + _f(model['address']) + '\n\n        \u0417\u0430\u043C\u0435\u0442\u043A\u0438: ' + _f(model['notes']) + '\n\n    ';
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
      this.updateChipsItems(model);
    }
  }, {
    key: 'fetchData',
    value: function fetchData(itemId) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (itemId) {
          __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].getIndividualContact(itemId).then(function (contact) {
            resolve(contact);
          });
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(itemId, model) {
      var _this3 = this;

      var item = model;
      item['id'] = itemId;
      if (this.pProps) {
        if (this.isIndividual) {
          item['clientIndividualId'] = this.pProps.id;
        } else {
          item['companyRefCode'] = this.pProps.refCode;
        }
      }
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.context.$store.dispatch('updatePeopleContact', item).then(function (id) {
          resolve(id);
        });
      });
    }
  }, {
    key: 'deleteData',
    value: function deleteData(itemId, model) {
      var _this4 = this;

      var filled = this.isIndividual && model['companyRefCode'] || !this.isIndividual && model['clientIndividualId'];
      var msg = filled ? '\u0417\u0430\u043F\u0438\u0441\u044C \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u0443\u0434\u0430\u043B\u0435\u043D\u0430. \u0415\u0441\u043B\u0438 \u0412\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u0442\u043E\u043B\u044C\u043A\u043E \u043E\u0442\u0432\u044F\u0437\u0430\u0442\u044C\n    \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u043D\u0443\u044E \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043E\u0442 ' + (this.isIndividual ? 'компании' : 'физ. лица') + ', \u0442\u043E \u043F\u0440\u043E\u0441\u0442\u043E \u043E\u0447\u0438\u0441\u0442\u0438\u0442\u0435 \u043F\u043E\u043B\u0435' : '';
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__["a" /* default */].confirm(_this4.context, 'Подтвердите', msg + ' \u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C \u043E \u043A\u043E\u043D\u0442\u0430\u043A\u0442\u0435?', function (self) {
          self.$store.dispatch('deletePeopleContact', { ids: [itemId] }).then(function () {
            return resolve();
          });
        });
      });
    }
  }, {
    key: 'getCompanyChipsItem',
    value: function getCompanyChipsItem(companyRefCode, company) {
      var getHint = function getHint(company) {
        return company.name + ' (\u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_9__api_formats__["a" /* default */].formatInn(company.inn) + ')';
      };
      var getError = function getError(company) {
        return null;
      };
      if (company) {
        var c = company;
        return { value: c.ref, text: c.caption, hint: getHint(c), error: getError(c) };
      }
      if (companyRefCode) {
        return { value: companyRefCode, text: '#' + companyRefCode, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null };
      }
      return {};
    }
  }, {
    key: 'addChipsItem',
    value: function addChipsItem(value, text, hint, error) {
      this.chipsItems.push({ value: value.toString(), text: text, hint: hint, error: error });
    }
  }, {
    key: 'fetchIndividual',
    value: function fetchIndividual(clientIndividualId) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!clientIndividualId) {
          resolve(null);
        } else {
          __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].getIndividual(clientIndividualId).then(function (individual) {
            resolve(individual);
          });
        }
      });
    }
  }, {
    key: 'fetchCompany',
    value: function fetchCompany(companyRefCode) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!companyRefCode) {
          resolve(null);
        }
        __WEBPACK_IMPORTED_MODULE_14__client__["a" /* default */].getCachedRefs([companyRefCode], function (companies) {
          var company = companies.length > 0 ? companies[0] : null;
          resolve(company);
        });
      });
    }
  }, {
    key: 'updateChipsItems',
    value: function updateChipsItems(model) {
      var _this5 = this;

      this.chipsItems = [];
      if (model['companyRefCode']) {
        this.fetchCompany(model['companyRefCode']).then(function (c) {
          _this5.chipsItems.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ fieldName: 'companyRefCode' }, _this5.getCompanyChipsItem(model['companyRefCode'], c)));
        });
      }
      if (model['clientIndividualId']) {
        this.fetchIndividual(model['clientIndividualId']).then(function (i) {
          if (i) {
            _this5.chipsItems.push(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({ fieldName: 'clientIndividualId' }, { value: i.id.toString(), text: i.nameShort, hint: null, error: null }));
          }
        });
      }
    }
  }, {
    key: 'selectCompanyRefCode',
    value: function selectCompanyRefCode(key) {
      var _this6 = this;

      var model = this.steps[0].model;
      if (!model.companyRefCode) {
        __WEBPACK_IMPORTED_MODULE_14__client__["a" /* default */].selectRef(this.context, function (companies) {
          model.companyRefCode = companies.length > 0 ? companies[0].ref : null;
          model.position = '';
          _this6.updateChipsItems(model);
        }, function () {}, true, true);
      } else {
        this.openCompanyRefCode(model.companyRefCode);
      }
    }
  }, {
    key: 'openCompanyRefCode',
    value: function openCompanyRefCode(key) {
      var url = __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].getters.getClientUrl(key);
      __WEBPACK_IMPORTED_MODULE_16__store__["a" /* default */].dispatch('openLocation', url);
    }
  }, {
    key: 'removeCompanyRefCode',
    value: function removeCompanyRefCode(key) {
      var model = this.steps[0].model;
      model.companyRefCode = null;
      model.position = '';
      this.updateChipsItems(model);
    }
  }, {
    key: 'selectIndividualId',
    value: function selectIndividualId(key) {
      var _this7 = this;

      var getQuery = function getQuery() {
        return '';
      };
      var model = this.steps[0].model;
      if (!model.clientIndividualId) {
        __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].selectIndividual(this.context, null, getQuery, true, true).then(function (values) {
          if (Array.isArray(values) && values.length > 0) {
            // console.log('selectIndividualId', values)
            model.clientIndividualId = values[0];
            _this7.updateChipsItems(model);
          }
        });
      } else {
        this.openIndividualId(model.clientIndividualId);
      }
    }
  }, {
    key: 'openIndividualId',
    value: function openIndividualId(key) {
      __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].open(key, true);
    }
  }, {
    key: 'removeIndividualId',
    value: function removeIndividualId(key) {
      var model = this.steps[0].model;
      model.clientIndividualId = null;
      this.updateChipsItems(model);
    }
  }, {
    key: 'openLink',
    value: function openLink(key) {
      console.log('editLinks', key);
      if (this.editLinkMode) {
        var model = this.steps[0].model;
        var fmodel = model.links ? JSON.parse(model.links) : [];
        var fstrategy = __WEBPACK_IMPORTED_MODULE_15__ContactLinks_js__["a" /* default */].createStrategy(this.cxt);
        var frepo = new __WEBPACK_IMPORTED_MODULE_12__assist_AssistClasses_js__["a" /* default */].MapRepository(function (item) {
          return item.link;
        }, fmodel);
        fstrategy.setRepo(frepo);
        __WEBPACK_IMPORTED_MODULE_11__common_forms_js__["a" /* default */].openFormStg(fstrategy, key).then(function (key) {
          model.links = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(frepo.getItems());
        });
      } else {
        if (!key) {
          this.editLinkMode = true;
        } else {
          this.context.$store.dispatch('openLocation', key);
        }
      }
    }
  }, {
    key: 'removeLink',
    value: function removeLink(key) {
      var model = this.steps[0].model;
      var fmodel = model.links ? JSON.parse(model.links) : [];
      var frepo = new __WEBPACK_IMPORTED_MODULE_12__assist_AssistClasses_js__["a" /* default */].MapRepository(function (item) {
        return item.link;
      }, fmodel);
      frepo.delete(key).then(function () {
        model.links = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(frepo.getItems());
      });
    }
  }, {
    key: 'getLinkItems',
    value: function getLinkItems(model) {
      var fmodel = model.links ? JSON.parse(model.links) : [];
      var fstrategy = __WEBPACK_IMPORTED_MODULE_15__ContactLinks_js__["a" /* default */].createStrategy(this.cxt);
      var frepo = new __WEBPACK_IMPORTED_MODULE_12__assist_AssistClasses_js__["a" /* default */].MapRepository(function (item) {
        return item.link;
      }, fmodel);
      return fstrategy.viewChipsList(frepo);
    }
  }, {
    key: 'getLinkImgs',
    value: function getLinkImgs(model) {
      var result = '';
      this.getLinkItems(model).forEach(function (item) {
        result = result.concat('\n        <v-tooltip bottom open-delay="500" max-width="20em">\n        <span slot="activator">\n        <v-btn style="margin:0" icon small href="' + item.value + '" target="_blank">\n          <img height="16px" width="16px"  src="' + item.img + '"></img>\n        </v-btn>\n        </span>\n        <span style="overflow-wrap: break-word">' + item.hint + '</span>\n        </v-tooltip>\n        ');
      });
      return result;
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_12__assist_AssistClasses_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '201.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__ = __webpack_require__(150);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__assist_AssistClasses_js__ = __webpack_require__(32);







// import formats from '../../api/formats'


var Strategy = function (_AssistClasses$Single) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Single);

  function Strategy(cxt, repo) {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).call(this, cxt, 'LINKS'));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeName',
    value: function getTypeName() {
      return '\u0421\u0441\u044B\u043B\u043A\u0430';
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      return {};
    }
  }, {
    key: 'updateScheme',
    value: function updateScheme(scheme) {
      var _this2 = this;

      return [{
        fieldType: 'v-text-field',
        label: 'Ссылка',
        name: 'link',
        events: {
          'input': function input(e) {
            return _this2.onLinkChange(e);
          }
        },
        hint: 'Укажите ссылку на страницу',
        grow: true,
        size: { sm12: true, xs12: true }
      }, {
        fieldType: 'v-text-field',
        label: 'Наименование',
        name: 'name',
        hint: '',
        grow: true,
        size: { sm8: true, xs8: true }
      }, {
        fieldType: 'v-select',
        label: 'Тип ссылки',
        itemValue: 'value',
        itemText: 'text',
        items: function items(model, field) {
          return _this2.getLinkTypes();
        },
        name: 'type',
        events: {
          'change': function change(e) {
            return _this2.onTypeChange(e);
          }
        },
        shrink: false,
        size: { sm4: true, xs4: true }
      }, {
        fieldType: 'v-btn',
        slot: 'Проверить',
        events: { 'click': function click() {
            return _this2.openLink();
          } },
        shrink: true,
        size: { sm4: true, xs4: true }
      }];
    }
  }, {
    key: 'getLinkTypes',
    value: function getLinkTypes() {
      var linkTypes = [{ value: 'as', text: 'Атлант-Смарт', rule: function rule(v) {
          return v && /atlant-smart\.ru/i.test(v);
        }, url: 'https://atlant-smart.ru/', img: 'static/img/icons/favicon-32x32.png' }, { value: 'vk', text: 'VKontakt', rule: function rule(v) {
          return v && /vk\.com/i.test(v);
        }, url: 'https://vk.com/[id]', img: 'static/img/lnks/vk.png' }, { value: 'fb', text: 'Facebook', rule: function rule(v) {
          return v && /facebook\.com/i.test(v);
        }, url: 'https://facebook.com/[id]', img: 'static/img/lnks/fb.png' }, { value: 'ok', text: 'Одноклассники', rule: function rule(v) {
          return v && /ok\.ru/i.test(v);
        }, url: 'https://ok.ru/profile/[id]', img: 'static/img/lnks/ok.svg' }, { value: 'wa', text: 'WhatsApp', rule: function rule(v) {
          return v && /wa\.me/i.test(v);
        }, url: 'https://wa.me/[id]', img: 'static/img/lnks/wa.png' }, { value: 'vb', text: 'Viber', rule: function rule(v) {
          return v && /viber:/i.test(v);
        }, url: 'viber://add?number=[id]', img: 'static/img/lnks/vb.png' }, { value: 'tg', text: 'Telegram', rule: function rule(v) {
          return v && /t\.me/i.test(v);
        }, url: 'https://t.me/[id]', img: 'static/img/lnks/tg.svg' }, { value: 'sk', text: 'Skype', rule: function rule(v) {
          return v && /skype:/i.test(v);
        }, url: 'skype:[id]', img: 'static/img/lnks/sk.ico' }, { value: 'ln', text: 'LinkedInn', rule: function rule(v) {
          return v && /linkedin\.com/i.test(v);
        }, url: 'https://www.linkedin.com/in/[id]', img: 'static/img/lnks/ln.png' }, { value: 'tw', text: 'Twitter', rule: function rule(v) {
          return v && /twitter\.com/i.test(v);
        }, url: 'https://twitter.com/[id]', img: 'static/img/lnks/tw.png' }, { value: 'in', text: 'Instagramm', rule: function rule(v) {
          return v && /instagram\.com/i.test(v);
        }, url: 'https://instagram.com/[id]', img: 'static/img/lnks/in.png' }, { value: 'wb', text: 'Веб сайт', rule: null, url: 'https://[id]', img: 'static/img/lnks/public.png' }];
      return linkTypes;
    }
  }, {
    key: 'getLinkTypesByValue',
    value: function getLinkTypesByValue() {
      var map = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a();
      var order = 0;
      this.getLinkTypes().forEach(function (i) {
        i['order'] = order++;
        map.set(i.value, i);
      });
      return map;
    }
  }, {
    key: 'onLinkChange',
    value: function onLinkChange(v) {
      var arr = this.getLinkTypes().filter(function (i) {
        return i.rule && i.rule(v);
      });
      var type = arr && arr.length > 0 && arr[0];
      if (type) {
        var model = this.getModel();
        model['type'] = type.value;
        // model['name'] = type.text
        // model['img'] = type.img
      }
    }
  }, {
    key: 'isDefault',
    value: function isDefault(model) {
      var arr = this.getLinkTypes().filter(function (i) {
        return i.url.replace(/\[id\]/, model['name'] === model.link);
      });
      return arr && arr.length > 0;
    }
  }, {
    key: 'onTypeChange',
    value: function onTypeChange(v) {
      var arr = this.getLinkTypes().filter(function (i) {
        return i.value === v;
      });
      var type = arr && arr.length > 0 && arr[0];
      if (type) {
        var model = this.getModel();
        var def = this.isDefault(model);
        model['link'] = model['link'] && !def ? model['link'] : type.url.replace(/\[id\]/, model['name']);
      }
    }
  }, {
    key: 'viewChipsList',
    value: function viewChipsList(repo) {
      var chips = [];
      var types = this.getLinkTypesByValue();
      repo.getItems().forEach(function (item) {
        var type = types.get(item.type);
        chips.push({
          value: item.link,
          text: item.name ? item.name : type.text,
          img: type ? type.img : null,
          hint: item.link,
          error: null,
          order: type.order
        });
      });
      return chips.sort(function (a, b) {
        return a.order - b.order;
      });
    }
  }, {
    key: 'setName',
    value: function setName(model) {
      console.log('setName', model);
      if (!model.name && model.link && model.type) {
        var type = this.getLinkTypesByValue().get(model.type);
        var name = model.link;
        var ps = type.url.split('[id]');
        var _iteratorNormalCompletion = true;
        var _didIteratorError = false;
        var _iteratorError = undefined;

        try {
          for (var _iterator = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_get_iterator___default()(ps), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
            var p = _step.value;

            name = name.replace(p, '');
          }
        } catch (err) {
          _didIteratorError = true;
          _iteratorError = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion && _iterator.return) {
              _iterator.return();
            }
          } finally {
            if (_didIteratorError) {
              throw _iteratorError;
            }
          }
        }

        model.name = name;
      }
    }
  }, {
    key: 'openLink',
    value: function openLink() {
      var model = this.getModel();
      this.setName(model);
      this.context.$store.dispatch('openLocation', model.link);
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_7__assist_AssistClasses_js__["a" /* default */].SingleStepStrategy);

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy
});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__FieldObject_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);









var SimpleField = function (_FieldObject) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SimpleField, _FieldObject);

  function SimpleField() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, SimpleField);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SimpleField.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(SimpleField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(SimpleField, [{
    key: 'fillRef',
    value: function fillRef(model, data, onChange) {
      var _this2 = this;

      if (this.type === 'DATE') {
        var date = data && __WEBPACK_IMPORTED_MODULE_7_moment___default()(data).set({ hour: 10, minute: 0 }).format('YYYY-MM-DD HH:mm') || null;
        var refs = this.cxt.refMap.get(this.name);
        if (refs) {
          refs.forEach(function (r) {
            var fobj = _this2.cxt.fieldObjects.get(r);
            var obj = void 0,
                code = void 0;
            if (fobj.type === 'ACTION') {
              obj = fobj.getValue(model);
              obj = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(obj, { input: date != null ? 'true' : 'false', inputted: date });
              if (!obj.logId) {
                code = obj;
                fobj.setValue(model, code, obj, onChange);
              }
            } else {
              fobj.setValue(model, code, obj, onChange);
            }
          });
        }
      }
      this.cxt.updateItems(model);
    }
  }]);

  return SimpleField;
}(__WEBPACK_IMPORTED_MODULE_6__FieldObject_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (SimpleField);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__FieldObject_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__client__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__people__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__favorite__ = __webpack_require__(124);












var CompanyField = function (_FieldObject) {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_inherits___default()(CompanyField, _FieldObject);

  function CompanyField() {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, CompanyField);

    return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CompanyField.__proto__ || __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_get_prototype_of___default()(CompanyField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(CompanyField, [{
    key: 'getCode',
    value: function getCode(model) {
      return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null;
    }
  }, {
    key: 'setCode',
    value: function setCode(model, newCode, onChange) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_8__client__["a" /* default */].getBriefCompanies([newCode]).then(function (refs) {
        if (refs && refs.length > 0) {
          var newObject = refs[0];
          _this2.setValue(model, newObject.ref, newObject, onChange);
        } else {
          _this2.setValue(model, null, null, onChange);
        }
        _this2.cxt.updateItems(model);
      });
    }
  }, {
    key: 'getDescription',
    value: function getDescription(model) {
      var result = model[this.name + 'DESCRIPTION'];
      if (this.ref === 'SELF') {
        result = result + ' (Наша компания)';
      }
      return result;
    }
  }, {
    key: 'setValue',
    value: function setValue(model, newCode, newObject, onChange) {
      // console.log('setValue', this.name, newCode, newObject)
      if (!this.equalCode(model, newCode)) {
        onChange && onChange(model, this.name, newCode);
        model[this.name + '_CODE'] = newCode ? newCode + '' : null;
      }
      model[this.name] = newCode && newObject ? newObject.inn : null;
      model[this.name + 'DESCRIPTION'] = newCode && newObject ? newObject.caption : null;
    }
  }, {
    key: 'fillRef',
    value: function fillRef(model, data, onChange) {
      var _this3 = this;

      if (__WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isRefCode(data)) {
        var refs = this.cxt.refMap.get(this.name);
        if (refs) {
          refs.forEach(function (r) {
            var fobj = _this3.cxt.fieldObjects.get(r);
            if (fobj.type === 'HOLDERS') {
              __WEBPACK_IMPORTED_MODULE_8__client__["a" /* default */].getBriefCompanies([data]).then(function (refs) {
                if (refs && refs.length > 0) {
                  fobj.setCode(model, refs[0].ref, onChange);
                }
              });
            }
            if (fobj.type === 'CONTACT') {
              __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].getContactsByCompany(data).then(function (contacts) {
                var items = __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].sortContactsByCompany(contacts);
                if (items && items.length > 0) {
                  fobj.setCode(model, items[0].id, onChange);
                }
              });
            }
            if (fobj.type === 'COMPANY_BANK') {
              __WEBPACK_IMPORTED_MODULE_10__favorite__["a" /* default */].getCompanyBanks(data).then(function (data) {
                var items = data.sort(function (b, a) {
                  return __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].compareString(a.name, b.name);
                });
                if (items && items.length > 0) {
                  fobj.setCode(model, items[0].id, onChange);
                }
              });
            }
          });
          this.cxt.updateItems(model);
        }
      }
    }
  }, {
    key: 'open',
    value: function open(model, onChange) {
      var url = this.cxt.context.getClientUrl(this.getCode(model));
      __WEBPACK_IMPORTED_MODULE_7__store__["a" /* default */].dispatch('openLocation', url);
    }
  }, {
    key: 'select',
    value: function select(model, onChange) {
      var _this4 = this;

      console.log('CompanyField:select', model);
      var setItem = function setItem(values) {
        // console.log('setItem', values)
        if (Array.isArray(values) && values.length > 0) {
          var newObject = values[0];
          _this4.setValue(model, newObject.ref, newObject, onChange);
          _this4.cxt.updateItems(model);
        }
      };
      var getQuery = function getQuery() {
        return _this4.getCode(model) ? _this4.getCode(model) : '';
      };
      __WEBPACK_IMPORTED_MODULE_8__client__["a" /* default */].selectRef(this.cxt.context, setItem, getQuery, true, true);
    }
  }]);

  return CompanyField;
}(__WEBPACK_IMPORTED_MODULE_5__FieldObject_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CompanyField);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assist_AssistClasses_js__ = __webpack_require__(32);












// import client from '../client'

var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).call(this, cxt));

    _this.chipsItems = [];
    _this.pProps = null;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'COMPANY_BANK';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Банковские реквизиты';
    }
  }, {
    key: 'setContext',
    value: function setContext(cxt) {
      this.context = cxt;
    }
  }, {
    key: 'setParentProps',
    value: function setParentProps(pProps) {
      this.pProps = pProps;
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createModelFromJSON',
    value: function createModelFromJSON(json) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), JSON.parse(json));
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(parent) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), {});
    }
  }, {
    key: 'createModelFromData',
    value: function createModelFromData(data) {
      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.createModel(), data);
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var bankAccountRules = function bankAccountRules(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isBankAccount(v) || 'Неверный формат банковского счета';
      };
      var bankRcbicRules = function bankRcbicRules(v) {
        return !v || __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isBankRcbic(v) || 'Неверный формат БИК банка';
      };

      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_11__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-text-field',
          label: 'Название',
          hint: 'Используется для поиска значения по умолчанию, первый элемент в обратном порядке',
          name: 'name',
          grow: true,
          size: { sm8: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Расчетный счет',
          name: 'bankAccount',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(bankAccountRules),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Название банка',
          name: 'bankName',
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Корреспондентский счет',
          name: 'bankCorrAccount',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(bankAccountRules),
          grow: true,
          size: { sm6: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'БИК',
          name: 'bankRcbic',
          rules: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_of___default()(bankRcbicRules),
          grow: true,
          size: { sm6: true, xs6: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Адрес банка',
          name: 'bankAddress',
          grow: true,
          size: { sm12: true, xs12: true }
        }, {
          fieldType: 'v-text-field',
          label: 'Примечание',
          name: 'notes',
          grow: true,
          size: { sm12: true, xs12: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      return this;
    }
  }, {
    key: 'viewNumber',
    value: function viewNumber(model) {
      return model['name'] ? model['name'] : '-';
    }
  }, {
    key: 'viewTitle',
    value: function viewTitle(model) {
      if (this.parent) {
        return '\u0411\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0435 \u0440\u0435\u043A\u0432\u0438\u0437\u0438\u0442\u044B ' + this.pProps.companyNameShort;
      }
      return this.getTypeName();
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].createComp('\n      <span>' + (model['name'] ? model['name'] : this.getTypeName()) + '</span>\n    ');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      var _f = function _f(v) {
        return v || '-';
      };
      var value = this.viewContent(model);
      var caption = '\n      <span>\n        <span>\u0420/\u0441: <b>' + _f(model['bankAccount']) + '</b></span>\n        <span>\u0432 <b>' + _f(model['bankName']) + '</b></span>\n        <span>\u041A/\u0441: <b>' + _f(model['bankCorrAccount']) + '</b></span>\n        <span>\u0411\u0418\u041A: <b>' + _f(model['bankRcbic']) + '</b></span>\n      </span>\n    ';
      return {
        template: '<span><component :is="renderValueLink()"></component></span>',
        methods: {
          renderValueLink: function renderValueLink() {
            return __WEBPACK_IMPORTED_MODULE_10__store__["a" /* default */].getters.renderValueLink(value, null, null, null, caption);
          }
        }
      };
    }
  }, {
    key: 'viewContent',
    value: function viewContent(model) {
      var _f = function _f(v) {
        return v || '-';
      };
      return '\n        \u0420/\u0441: ' + _f(model['bankAccount']) + '\n        \u0432 ' + _f(model['bankName']) + '\n        \u041A/\u0441: ' + _f(model['bankCorrAccount']) + '\n        \u0411\u0418\u041A: ' + _f(model['bankRcbic']) + '\n    ';
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'fetchData',
    value: function fetchData(itemId) {
      var _this2 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (itemId) {
          _this2.context.$store.dispatch('getCompanyBank', itemId).then(function (data) {
            return resolve(data);
          });
        } else {
          resolve(null);
        }
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(itemId, model, parentId) {
      var _this3 = this;

      var item = model;
      item['id'] = itemId;
      if (this.pProps) {
        item['clientCompanyId'] = this.pProps.clientCompanyId;
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this3.context.$store.dispatch('updateCompanyBank', { dto: item }).then(function (id) {
          resolve(id);
        });
      });
    }
  }, {
    key: 'deleteData',
    value: function deleteData(itemId, model) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_9__common_dialogs_js__["a" /* default */].confirm(_this4.context, 'Подтвердите', '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0437\u0430\u043F\u0438\u0441\u044C \u043E \u0431\u0430\u043D\u043A\u0435?', function (self) {
          self.$store.dispatch('deleteCompanyBank', { ids: [itemId] }).then(function () {
            return resolve();
          });
        });
      });
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_11__assist_AssistClasses_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Model);

  this.modelType = '212.01';
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FieldObject_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__people__ = __webpack_require__(27);










var HoldersField = function (_FieldObject) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(HoldersField, _FieldObject);

  function HoldersField() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, HoldersField);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (HoldersField.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(HoldersField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(HoldersField, [{
    key: 'getCode',
    value: function getCode(model) {
      return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null;
    }
  }, {
    key: 'setCode',
    value: function setCode(model, newCode, onChange) {
      var _this2 = this;

      var companyRefCode = newCode;
      if (companyRefCode) {
        __WEBPACK_IMPORTED_MODULE_8__people__["a" /* default */].getHolderPassports(companyRefCode).then(function (holders) {
          _this2.setValue(model, companyRefCode, holders, onChange);
          _this2.cxt.updateItems(model);
        });
      } else {
        this.setValue(model, null, null, onChange);
        this.cxt.updateItems(model);
      }
    }
  }, {
    key: 'setValue',
    value: function setValue(model, newCode, newObject, onChange) {
      if (!this.equalCode(model, newCode)) {
        onChange && onChange(model, this.name, newCode);
        model[this.name + '_CODE'] = newCode ? newCode + '' : null;
      }
      model[this.name] = newCode ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newObject) : null;
    }
  }, {
    key: 'getValue',
    value: function getValue(model) {
      return model[this.name] ? JSON.parse(model[this.name]) : [];
    }
  }, {
    key: 'getDescription',
    value: function getDescription(model) {
      var obj = model[this.name] ? JSON.parse(model[this.name]) : null;
      if (!obj) {
        return '';
      }
      return Array.isArray(obj) ? '\u0421\u043F\u0438\u0441\u043E\u043A \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u043E\u0432 (' + obj.length + ')' : '';
    }
  }, {
    key: 'getHint',
    value: function getHint(model) {
      var obj = model[this.name] ? JSON.parse(model[this.name]) : null;
      if (!obj) {
        return '';
      }
      return Array.isArray(obj) ? obj.map(function (v) {
        return v.name;
      }).join(', ') : '';
    }
  }, {
    key: 'open',
    value: function open(model, onChange) {
      var _this3 = this;

      var companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name);
      var items = this.getValue(model);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(items).then(function (items) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (!items || items.length === 0) {
            __WEBPACK_IMPORTED_MODULE_8__people__["a" /* default */].getHolderPassports(companyRefCode).then(function (data) {
              __WEBPACK_IMPORTED_MODULE_8__people__["a" /* default */].openHolders(companyRefCode, data).then(function (holders) {
                resolve(holders);
              });
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_8__people__["a" /* default */].openHolders(companyRefCode, items).then(function (holders) {
              resolve(holders);
            });
          }
        });
      }).then(function (items) {
        _this3.setValue(model, companyRefCode, items, onChange);
        // console.log('open', this.getValue(model))
        _this3.cxt.updateItems(model);
      });
    }
  }, {
    key: 'select',
    value: function select(model, onChange) {
      this.open(model, onChange);
    }
  }]);

  return HoldersField;
}(__WEBPACK_IMPORTED_MODULE_7__FieldObject_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (HoldersField);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FieldObject_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__ = __webpack_require__(7);












var CompanyFilesField = function (_FieldObject) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(CompanyFilesField, _FieldObject);

  function CompanyFilesField() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CompanyFilesField);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CompanyFilesField.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CompanyFilesField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(CompanyFilesField, [{
    key: 'getCode',
    value: function getCode(model) {
      return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null;
    }
    // setCode (model, newCode, onChange) {
    //   if (!this.equalCode(model, newCode)) {
    //     onChange && onChange(model, this.name, newCode)
    //     if (!newCode) {
    //       this.init(model)
    //     } else {
    //       model[this.name + '_CODE'] = newCode
    //     }
    //   }
    // }

  }, {
    key: 'setValue',
    value: function setValue(model, newCode, newObject, onChange) {
      console.log('CompanyFilesField.setValue', newCode);
      if (!this.equalCode(model, newCode)) {
        onChange && onChange(model, this.name, newCode);
        model[this.name + '_CODE'] = newCode ? newCode + '' : null;
      }
      model[this.name] = newCode ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newObject) : null;
    }
  }, {
    key: 'getValue',
    value: function getValue(model) {
      return model[this.name] ? JSON.parse(model[this.name]) : [];
    }
  }, {
    key: 'getDescription',
    value: function getDescription(model) {
      var obj = model[this.name] ? JSON.parse(model[this.name]) : null;
      if (!obj) {
        return '';
      }
      return Array.isArray(obj) ? '\u0421\u043F\u0438\u0441\u043E\u043A \u0444\u0430\u0439\u043B\u043E\u0432 (' + obj.length + ')' : '';
    }
  }, {
    key: 'getHint',
    value: function getHint(model) {
      var obj = model[this.name] ? JSON.parse(model[this.name]) : null;
      if (!obj) {
        return '';
      }
      return Array.isArray(obj) ? obj.map(function (v) {
        return v.docName;
      }).join(', ') : '';
    }
  }, {
    key: 'open',
    value: function open(model, onChange) {
      var _this2 = this;

      var companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name);
      if (!this.checkCompanyRefCode(companyRefCode)) {
        return;
      }
      var items = this.getValue(model);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(items).then(function (items) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (!items || items.length === 0) {
            __WEBPACK_IMPORTED_MODULE_9__depo__["a" /* default */].openDocProps(companyRefCode, items).then(function (docprops) {
              resolve(docprops);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_9__depo__["a" /* default */].openDocProps(companyRefCode, items).then(function (docprops) {
              resolve(docprops);
            });
          }
        });
      }).then(function (items) {
        _this2.setValue(model, companyRefCode, items, onChange);
        // console.log('open', this.getValue(model))
        _this2.cxt.updateItems(model);
      });
    }
  }, {
    key: 'select',
    value: function select(model, onChange) {
      this.open(model, onChange);
    }
  }, {
    key: 'checkCompanyRefCode',
    value: function checkCompanyRefCode(refCode) {
      if (__WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isRefCode(refCode)) {
        return true;
      }
      __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__["a" /* default */].message(this, 'Совет', 'Сначала выберите компанию');
      return false;
    }
  }]);

  return CompanyFilesField;
}(__WEBPACK_IMPORTED_MODULE_7__FieldObject_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CompanyFilesField);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldObject_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CalcForm__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__CalcForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__CalcForm__);













var CalcField = function (_FieldObject) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(CalcField, _FieldObject);

  function CalcField() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CalcField);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CalcField.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CalcField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(CalcField, [{
    key: 'getCode',
    value: function getCode(model) {
      return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null;
    }
    // setCode (model, newCode, onChange) {
    //   if (!this.equalCode(model, newCode)) {
    //     onChange && onChange(model, this.name, newCode)
    //     if (!newCode) {
    //       this.init(model)
    //     } else {
    //       model[this.name + '_CODE'] = newCode
    //     }
    //   }
    // }

  }, {
    key: 'setValue',
    value: function setValue(model, newCode, newObject, onChange) {
      var nCode = newObject ? __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].hashCode(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newObject)) : null;
      if (!this.equalCode(model, nCode)) {
        onChange && onChange(model, this.name, nCode);
      }
      model[this.name + '_CODE'] = nCode;
      model[this.name] = nCode ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newObject) : null;
      this.cxt.updateItems(model);
    }
  }, {
    key: 'getValue',
    value: function getValue(model) {
      var jsonStr = model[this.name];
      return jsonStr ? JSON.parse(jsonStr) : {};
    }
  }, {
    key: 'getDescription',
    value: function getDescription(model) {
      var obj = this.getValue(model);
      if (!obj) {
        return '';
      }
      return '\u041E\u043F\u0435\u0440\u0430\u0446\u0438\u0439 (' + __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].blank(obj.loans && obj.loans.length) + ' + ' + __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].blank(obj.pays && obj.pays.length) + ')';
    }
  }, {
    key: 'getHint',
    value: function getHint(model) {
      var obj = this.getValue(model);
      if (!obj) {
        return '';
      }
      var paysSum = obj.pays ? obj.pays.reduce(function (s, i) {
        return s + i.amount;
      }, 0) : null;
      var loansSum = obj.loans ? obj.loans.reduce(function (s, i) {
        return s + i.amount;
      }, 0) : null;
      return '\u041F\u043E\u0441\u0442\u0430\u0432\u043A\u0438: ' + __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].blank(loansSum) + ' \u0440\u0443\u0431. \u041F\u043B\u0430\u0442\u0435\u0436\u0438: ' + __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].blank(paysSum) + ' \u0440\u0443\u0431.';
    }
  }, {
    key: 'open',
    value: function open(model, onChange) {
      var _this2 = this;

      var calc = this.getValue(model);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(calc).then(function (calc) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (!calc) {
            _this2.openCalcForm(calc).then(function (calc) {
              resolve(calc);
            });
          } else {
            _this2.openCalcForm(calc).then(function (calc) {
              resolve(calc);
            });
          }
        });
      }).then(function (calc) {
        _this2.setValue(model, calc, calc, onChange);
        // console.log('open', model)
        _this2.cxt.updateItems(model);
      });
    }
  }, {
    key: 'select',
    value: function select(model, onChange) {
      this.open(model, onChange);
    }
  }, {
    key: 'openCalcForm',
    value: function openCalcForm(calc) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].register('v-calc-form', __WEBPACK_IMPORTED_MODULE_11__CalcForm___default.a);
        var onInput = function onInput(data) {
          // console.log('openCalcForm', data)
          resolve(data);
        };
        var title = 'Сверка платежей';
        var fullscreen = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters.getIsMobile;
        var comp = { template: '\n        <v-calc-form :fullscreen="fullscreen" :value="calc" :title="title" v-on:input="onInput" v-on:close="$emit(\'close\')"></v-calc-form>\n      ',
          data: function data() {
            return {
              onInput: onInput,
              fullscreen: fullscreen,
              calc: calc,
              title: title
            };
          }
        };
        __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].modal(comp);
      });
    }
  }]);

  return CalcField;
}(__WEBPACK_IMPORTED_MODULE_8__FieldObject_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CalcField);

/***/ }),
/* 927 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(928)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(930),
  /* template */
  __webpack_require__(945),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 928 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(929);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("056180e5", content, true, {});

/***/ }),
/* 929 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, "table.report_table{width:100%;border-color:#e0e0e0;border:0}table.report_table td,th{padding-left:2px;padding-right:2px}table.report_table th{background-color:#f0f0f0}table.report_table td,table.report_table th{vertical-align:top;text-align:left}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/assist/fields/CalcForm.vue"],"names":[],"mappings":"AACA,mBACE,WAAY,AACZ,qBAAsB,AAEtB,QAAuB,CAGxB,AACD,yBACE,iBAAkB,AAClB,iBAAmB,CACpB,AACD,sBACE,wBAA0B,CAG3B,AACD,4CAHE,mBAAoB,AACpB,eAAiB,CAKlB","file":"CalcForm.vue","sourcesContent":["\ntable.report_table {\n  width: 100%;\n  border-color: #e0e0e0;\n  border-top-width:  0px;\n  border-left-width: 0px;\n  border-right-width:  0px;\n  border-bottom-width:  0px;\n}\ntable.report_table td, th {\n  padding-left: 2px;\n  padding-right: 2px;\n}\ntable.report_table th {\n  background-color: #F0F0F0;\n  vertical-align: top;\n  text-align: left;\n}\ntable.report_table td {\n  vertical-align: top;\n  text-align: left;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CalcPanel__ = __webpack_require__(931);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__CalcPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__CalcPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CalcCSVLoader__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__CalcCSVLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__CalcCSVLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CalcCSV1SLoader__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__CalcCSV1SLoader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__CalcCSV1SLoader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__info_PanelTitle__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'calc-form',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_8__common_CardScroll___default.a, vOpsBtn: __WEBPACK_IMPORTED_MODULE_9__common_OpsBtn___default.a, vCalcPanel: __WEBPACK_IMPORTED_MODULE_10__CalcPanel___default.a, vPanelTitle: __WEBPACK_IMPORTED_MODULE_14__info_PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      cxt: null,
      fillHeight: true,
      showDetails: false,
      calc: null
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: 'Список документов'
    },
    companyRefCode: {
      type: String,
      default: null
    }
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return _this.getItemKey(item);
      });
    });
    // cxt.mode = classes.modes.SELECT
    cxt.actionCaption = 'Операции';
    // // cxt.actions.push({divider: true})
    // // cxt.actions.push(new classes.SelectAction(cxt))
    // cxt.actions.push({divider: true})
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].Action(this, 'Загрузить из 1C XSLX файла', null, function () {
      return _this.loadOps1S();
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].Action(this, 'Загрузить из CSV файла', null, function () {
      return _this.loadOps();
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].Action(this, 'Рассчитать', null, function () {
      return _this.calculate();
    }));
    this.cxt = cxt;
    if (this.selected != null) {
      this.selected.forEach(function (id) {
        return _this.cxt.select(id);
      });
    }
    this.calc = this.init();
  },
  mounted: function mounted() {
    this.fetchData();
  },

  watch: {
    value: function value(newVal, oldVal) {
      // watch it
      this.fetchData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  }), {
    orderedItems: function orderedItems() {
      var _this2 = this;

      // console.log('orderedItems', this.items)
      return this.items.sort(function (a, b) {
        return _this2.getItemTitle(a) ? _this2.getItemTitle(a).localeCompare(_this2.getItemTitle(b)) : -1;
      });
    },
    filteredItems: function filteredItems() {
      var _this3 = this;

      var getSearchString = function getSearchString(item) {
        return ''.concat(_this3.getItemTitle(item)).concat(_this3.getItemText(item));
      };
      var filter = !this.cxt.isFilterMode() || this.cxt.filterString === null || this.cxt.filterString.length < 3 ? null : this.cxt.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
    }
  }),
  methods: {
    init: function init() {
      return {
        params: {
          start: null,
          end: null,
          lateDays: 0,
          rates: [{ from: 1, percent: 0.1 }],
          calcType: 'CONTRACT',
          startType: 'DELAY',
          periodType: 'DAYS_365',
          minusType: 'BASE_ONLY',
          rateType: 'DAY',
          dutyType: 'ARBITR'
        },
        loans: [],
        pays: [],
        details: [],
        result: {
          sum: null,
          percent: null,
          total: null,
          duties: null
        }
      };
    },
    getItemKey: function getItemKey(item) {
      return item.uid;
    },
    fetchData: function fetchData() {
      if (this.value) {
        this.calc = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(this.calc, this.value);
        if (this.calc.params && this.calc.params.start && this.calc.params.end && this.calc.loans.length + this.calc.pays.length > 0) {
          this.calculate();
        }
      }
    },
    ok: function ok() {
      var _this4 = this;

      this.calculate().then(function () {
        _this4.$emit('input', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(_this4.calc, { details: [], result: {} }));
        _this4.cancel();
      });
    },
    cancel: function cancel() {
      this.$emit('close');
      this.itemId = null;
    },
    select: function select(uid) {
      if (this.cxt.uncheck(uid)) {
        if (this.radio) {
          this.cxt.clear();
        }
      }
      this.cxt.select(uid);
    },
    click: function click(item) {},
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
    },
    getItemTitle: function getItemTitle(item) {
      return item.docName;
    },
    getItemText: function getItemText(item) {
      return item.uid;
    },
    loadFrom: function loadFrom() {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_11__components_common_dialogs__["a" /* default */].register('v-csv-loader', __WEBPACK_IMPORTED_MODULE_12__CalcCSVLoader___default.a);
        var listFields = [];
        listFields.push({ name: 'key', label: 'Уникальный ключ', number: 0, type: 'TEXT', key: true });
        listFields.push({ name: 'date', label: 'Дата операции', number: 0, type: 'DATE' });
        listFields.push({ name: 'note', label: 'Название операции', number: 1, type: 'TEXT' });
        listFields.push({ name: 'loan', label: 'Увеличение долга', number: 2, type: 'NUMBER' });
        listFields.push({ name: 'pay', label: 'Уменьшение долга', number: 3, type: 'NUMBER' });
        var fullscreen = _this5.isMobile;
        // var fullscreen = false
        var comp = { template: '\n          <v-csv-loader\n          v-on:close="$emit(\'close\')"\n          v-on:change="onChange"\n          :fields="fields"\n          :keyField="keyField"\n          :fullscreen="fullscreen"></v-csv-loader>\n          ',
          data: function data() {
            return {
              fullscreen: fullscreen,
              onChange: function onChange(data) {
                return resolve(data);
              },
              fields: listFields,
              keyField: 'key'
            };
          }
        };
        __WEBPACK_IMPORTED_MODULE_11__components_common_dialogs__["a" /* default */].modal(comp);
      });
    },
    loadOps: function loadOps() {
      var _this6 = this;

      this.loadFrom().then(function (values) {
        if (values && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(values)) {
          var ops = [];
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(values).forEach(function (r) {
            ops.push({ code: r.loan ? 'LOAN' : 'PAY', date: r.date, amount: r.loan ? Math.abs(r.loan) : Math.abs(r.pay), note: r.note });
          });
          ops = ops.sort(function (a, b) {
            return a.date ? a.date.localeCompare(b.date) : -1;
          });
          if (ops.length > 0) {
            var op = ops[0];
            _this6.calc.params.startType = 'RELEASE';
            _this6.calc.loans = ops.filter(function (op) {
              return op.code === 'LOAN';
            });
            _this6.calc.pays = ops.filter(function (op) {
              return op.code === 'PAY';
            });
            _this6.calc.params.start = op.date;
            _this6.calc.params.end = _this6.formats.formatDateToISO(new Date());
          }
          _this6.calculate();
        }
      });
    },
    loadFrom1S: function loadFrom1S() {
      var _this7 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_11__components_common_dialogs__["a" /* default */].register('v-csv1s-loader', __WEBPACK_IMPORTED_MODULE_13__CalcCSV1SLoader___default.a);
        var listFields = [];
        listFields.push({ name: 'key', label: 'Уникальный ключ', number: 0, type: 'TEXT', key: true });
        listFields.push({ name: 'date', label: 'Дата операции', number: 0, type: 'DATE' });
        listFields.push({ name: 'note', label: 'Название операции', number: 1, type: 'TEXT' });
        listFields.push({ name: 'loan', label: 'Увеличение долга', number: 2, type: 'NUMBER' });
        listFields.push({ name: 'pay', label: 'Уменьшение долга', number: 3, type: 'NUMBER' });
        var fullscreen = _this7.isMobile;
        // var fullscreen = false
        var comp = { template: '\n          <v-csv1s-loader\n          v-on:close="$emit(\'close\')"\n          v-on:change="onChange"\n          :fields="fields"\n          :fullscreen="fullscreen"></v-csv1s-loader>\n          ',
          data: function data() {
            return {
              fullscreen: fullscreen,
              onChange: function onChange(data) {
                return resolve(data);
              },
              fields: listFields
            };
          }
        };
        __WEBPACK_IMPORTED_MODULE_11__components_common_dialogs__["a" /* default */].modal(comp);
      });
    },
    loadOps1S: function loadOps1S() {
      var _this8 = this;

      this.loadFrom1S().then(function (values) {
        if (values && __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(values)) {
          var ops = [];
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(values).forEach(function (r) {
            ops.push({ code: r.loan ? 'LOAN' : 'PAY', date: r.date, amount: r.loan ? Math.abs(r.loan) : Math.abs(r.pay), note: r.note });
          });
          ops = ops.sort(function (a, b) {
            return a.date ? a.date.localeCompare(b.date) : -1;
          });
          if (ops.length > 0) {
            var op = ops[0];
            _this8.calc.params.startType = 'RELEASE';
            _this8.calc.loans = ops.filter(function (op) {
              return op.code === 'LOAN';
            });
            _this8.calc.pays = ops.filter(function (op) {
              return op.code === 'PAY';
            });
            _this8.calc.params.start = op.date;
            _this8.calc.params.end = _this8.formats.formatDateToISO(new Date());
          }
          _this8.calculate();
        }
      });
    },
    calcRequest: function calcRequest(request) {
      var _this9 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_6__api_server__["a" /* default */].apiPost('/openapi/calc-requests', __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(request, { details: [], result: {} }), function (data) {
          resolve(data);
        }, function (e) {
          _this9.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при расчете задолжностей ' });
          reject(e);
        });
      });
    },
    calculate: function calculate() {
      var _this10 = this;

      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this10.calcRequest(_this10.calc).then(function (data) {
          _this10.calc = data;
          resolve();
        });
      });
    },
    formatNote: function formatNote(value) {
      return value != null ? '(' + value + ')' : '';
    },
    formatDate: function formatDate(isoDate) {
      return this.formats.formatDate(isoDate);
    },
    formatPercent: function formatPercent(num) {
      return num != null ? num.toLocaleString(this.locale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%' : '-';
    },
    formatNumber: function formatNumber(num) {
      if (Math.abs(num) < 0.005) {
        num = 0.004;
      }
      return num != null ? num.toLocaleString(this.locale(), { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '-';
    },
    formatCurrency: function formatCurrency(num) {
      return num != null ? num.toLocaleString(this.locale(), { minimumFractionDigits: 0, maximumFractionDigits: 2 }) : '-';
    },
    locale: function locale() {
      return navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : 'en-en';
    }
  }
});

/***/ }),
/* 931 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(932),
  /* template */
  __webpack_require__(938),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_NumberField_vue__ = __webpack_require__(933);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_NumberField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_NumberField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_moment__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import dialogs from '../../../components/common/dialogs'
// import vCSVLoader from './CalcCSVLoader'

// Const of valid dates
var FIRST_STARTDATE_STRING = '1995-01-01';
var HINT_STARTDATE = 'Следующий день после срока оплаты';
var HINT_STARTDATE_RELEASE = 'Дата поставки, след. день 1й день просрочки';
var HINT_ENDDATE = 'День фактического погашения долга либо иная дата, на которую рассчитывается неустойка, если долг не погашен';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'calc-panel',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_2__common_DateField_vue___default.a, vNumberField: __WEBPACK_IMPORTED_MODULE_3__common_NumberField_vue___default.a, vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__info_PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      fillHeight: true,
      refresh: false,
      localValue: null,
      valid: true,
      showPlusses: false,
      showMinuses: false,
      showParams: false,
      showDetails: false,
      hints: {
        startDate: HINT_STARTDATE,
        startDateRelease: HINT_STARTDATE_RELEASE,
        endDate: HINT_ENDDATE
      },
      startDateRules: [function (v) {
        return !!v || HINT_STARTDATE;
      }],
      startDateReleaseRules: [function (v) {
        return !!v || HINT_STARTDATE_RELEASE;
      }],
      endDateRules: [function (v) {
        return !!v || HINT_ENDDATE;
      }],
      opsDateRules: [function (v) {
        return !!v || 'Заполните дату';
      }],
      opsAmountRules: function opsAmountRules() {
        return [function (v) {
          return !!v || 'Заполните сумму';
        }];
      },

      sumRules: [function (v) {
        return !!v || 'Заполните величину задолженности';
      }],
      currencyItems: [{ text: 'рублей', value: 'RUB' }, { text: 'долларов США', value: 'USD' }, { text: 'евро', value: 'EUR' }],
      startDayItems: [{ text: 'Начало просрочки', value: 'DELAY' }, { text: 'Дата поставки', value: 'RELEASE' }],
      periodTypeItems: [{ text: 'В календарных днях', value: 'DAYS_365' }, { text: 'Из расчета 360 дней в году', value: 'DAYS_360' }],
      minusTypeItems: [{ text: 'Только основной долг', value: 'BASE_ONLY' }, { text: 'Основной долг, неустойка', value: 'BASE_PRIOR' }, { text: 'Неустойка, основной долг', value: 'PERCENT_PRIOR' }],
      rateTypeItems: [
      // {text: 'цена договора', value: 'BASE_OVERALL'},
      { text: 'Cтавка в годовых процентах', value: 'YEAR' }, { text: 'Cтавка в процентах за день', value: 'DAY' }],
      baseTypeItems: [
      // {text: 'цена договора', value: 'BASE_OVERALL'},
      { text: 'на сумму просроченного платежа', value: 'BASE_LATE_PAYMENT' }],
      calcTypeItems: [{ text: 'Проценты по ст. 395 ГК РФ', value: 'PERCENT_395' }, { text: 'Проценты по ст. 317.1 ГК РФ', value: 'PERCENT_317' }, { text: 'Договорная неустойка', value: 'CONTRACT' }],
      calcDutyItems: [{ text: 'Cумма гос.пошлины для арбитражных судов', value: 'ARBITR' }, { text: 'Cумма гос.пошлины для судов общей юрисдикции', value: 'COMMON' }]
    };
  },
  mounted: function mounted() {
    this.clear();
  },

  props: {
    value: {
      type: Object,
      default: function _default() {
        return {
          params: {
            start: null,
            end: null,
            lateDays: 0,
            rates: [{ from: 1, percent: 0.1 }],
            calcType: 'CONTRACT',
            startType: 'DELAY',
            periodType: 'DAYS_365',
            minusType: 'BASE_ONLY',
            rateType: 'DAY',
            dutyType: 'ARBITR'
          },
          loans: [],
          pays: [],
          details: [],
          result: {
            sum: null,
            percent: null,
            total: null,
            duties: null
          }
        };
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])({}), {
    params: function params() {
      return this.value && this.value.params ? this.value.params : {};
    },
    plusses: function plusses() {
      return this.value.loans;
    },
    minuses: function minuses() {
      return this.value.pays;
    },
    minusesSum: function minusesSum() {
      return this.value.pays.reduce(function (s, i) {
        return s + i.amount;
      }, 0);
    },
    plussesSum: function plussesSum() {
      return this.value.loans.reduce(function (s, i) {
        return s + i.amount;
      }, 0);
    },
    rates: function rates() {
      return this.value.params.rates;
    },
    isAreaVisible: function isAreaVisible() {
      if (!(this.value && this.value.startDate && this.value.endDate)) {
        return false;
      }
      var areaStart = __WEBPACK_IMPORTED_MODULE_7_moment___default()('2015-06-01');
      var areaEnd = __WEBPACK_IMPORTED_MODULE_7_moment___default()('2016-08-01');
      var start = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.value.startDate);
      var end = __WEBPACK_IMPORTED_MODULE_7_moment___default()(this.value.endDate);
      if (start.isBefore(areaStart) && end.isBefore(areaStart) || areaEnd.isBefore(start) && areaEnd.isBefore(end)) {
        return false;
      }
      return true;
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    isCalendarOnly: function isCalendarOnly() {
      return this.isMobile;
    }
  }),
  methods: {
    updateValid: function updateValid(value) {
      this.valid = value;
    },
    errorDateOrder: function errorDateOrder() {
      if (this.value != null && this.value.startDate != null && this.value.endDate != null) {
        if (!__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.value.startDate).isBefore(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.value.endDate))) {
          return ['Ошибочный порядок дат'];
        }
      }
      return [];
    },
    errorOpsDateOrder: function errorOpsDateOrder(v) {
      if (!__WEBPACK_IMPORTED_MODULE_7_moment___default()(v).isValid()) {
        return [];
      }
      var date = __WEBPACK_IMPORTED_MODULE_7_moment___default()(v);
      if (this.value != null && this.value.startDate != null && this.value.endDate != null) {
        if (!(!__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.value.startDate).isAfter(date) && date.isBefore(__WEBPACK_IMPORTED_MODULE_7_moment___default()(this.value.endDate)))) {
          return ['Ошибочный порядок дат'];
        }
      }
      return [];
    },
    getFirstStartDateString: function getFirstStartDateString() {
      return FIRST_STARTDATE_STRING;
    },
    addPercent: function addPercent() {
      if (!this.rates) {
        this.rates = [];
      }
      this.rates.push({ from: null, to: null, percent: null });
    },
    deletePercent: function deletePercent(item) {
      this.rates.splice(this.rates.indexOf(item), 1);
    },
    isDisabledRate: function isDisabledRate(i) {
      return i === 0;
    },
    submit: function submit() {
      if (this.$refs.form.validate()) {
        if (!this.isAreaVisible) {
          this.value.area = null;
        }
        var request = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.localValue));
        this.$store.dispatch('calculate', request);
        this.$emit('submit');
      }
    },
    clear: function clear() {
      this.refresh = true;
    },
    formatPercent: function formatPercent(num) {
      return num != null ? num.toLocaleString({ minimumFractionDigits: 2, maximumFractionDigits: 2 }) + '%' : '-';
    }
  }
});

/***/ }),
/* 933 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(934)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(936),
  /* template */
  __webpack_require__(937),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 934 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(935);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("17189ad0", content, true, {});

/***/ }),
/* 935 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"NumberField.vue","sourceRoot":""}]);

// exports


/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'number-field',
  props: {
    value: {
      type: Number,
      default: null
    },
    hint: {
      type: String,
      default: null
    },
    readonly: {
      type: Boolean,
      default: false
    },
    required: {
      type: Boolean,
      default: false
    },
    rules: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    errorMessages: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    label: String
  },
  data: function data() {
    return {
      menu: null,
      val: null,
      valText: null,
      errors: [],
      dateRules: {
        required: function required(v) {
          return !!v || 'введите число';
        }
      }
    };
  },
  mounted: function mounted() {
    this.val = this.value;
    this.valText = this.formattedText();
  },

  watch: {
    value: function value(newVal, oldVal) {
      if (newVal !== oldVal) {
        this.val = newVal;
      }
      this.valText = this.formattedText();
    }
  },
  computed: {
    rulesMerged: function rulesMerged() {
      var result = [this.dateRules.required];
      result = this.rules.concat(result);
      return result;
    },
    errorsMerged: function errorsMerged() {
      var result = this.errors;
      result = this.errorMessages.concat(result);
      return result;
    },
    locale: function locale() {
      return navigator.languages && navigator.languages.length > 0 ? navigator.languages[0] : 'en-en';
    }
  },
  methods: {
    formattedText: function formattedText() {
      this.valText = this.val != null ? this.val.toLocaleString(this.locale, { minimumFractionDigits: 0, maximumFractionDigits: 2 }) : '';
      return this.valText;
    },

    updateText: function updateText(v) {
      console.log('updateText', 'this.value', this.value, 'value: ', v);
      if (v) {
        var r = v != null ? v.match(/[0-9\s]+[,.]?[0-9]?[0-9]?$/) : null;
        if (r != null && r[0].length === v.length) {
          this.valText = v;
          this.errors = [];
          v = v.replace(',', '.');
          v = v.replace(/\s/g, '');
          this.val = Number(v);
          this.$emit('input', this.val);
        } else {
          this.errors.push('Неверный формат числа');
        }
      } else {
        this.val = null;
        this.$emit('input', this.val);
      }
    }
  }
});

/***/ }),
/* 937 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-text-field', {
    attrs: {
      "label": _vm.label,
      "value": _vm.formattedText(),
      "required": _vm.required,
      "rules": _vm.rulesMerged,
      "error-messages": _vm.errorsMerged,
      "readonly": _vm.readonly,
      "hint": _vm.hint
    },
    on: {
      "input": _vm.updateText
    }
  })
},staticRenderFns: []}

/***/ }),
/* 938 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.showPlusses,
      "caption": this.showPlusses ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.showPlusses = !_vm.showPlusses
      }
    }
  }, [_c('span', [_vm._v(" Поставки (" + _vm._s(_vm.plusses.length) + "):\n      "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.plussesSum, _vm.formats.formatNumber)) + " руб.")])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlusses),
      expression: "showPlusses"
    }]
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((_vm.plusses), function(item, i) {
    return [_c('v-list-tile', {
      key: 'p' + i
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s('Поставка ' + '<b>' + item.amount + '</b>' + ' руб.')
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.note))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.date, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.showMinuses,
      "caption": this.showMinuses ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.showMinuses = !_vm.showMinuses
      }
    }
  }, [_c('span', [_vm._v("Платежи (" + _vm._s(_vm.minuses.length) + "):\n      "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.minusesSum, _vm.formats.formatNumber)) + "  руб.")])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showMinuses),
      expression: "showMinuses"
    }]
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_vm._l((_vm.minuses), function(item, i) {
    return [_c('v-list-tile', {
      key: 'm' + i
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s('Платеж ' + '<b>' + item.amount + '</b>' + ' руб.')
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.note))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.date, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.showParams,
      "caption": this.showParams ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.showParams = !_vm.showParams
      }
    }
  }, [_vm._v("\n      Параметры расчета:\n    "), _c('div', [_c('span', [_vm._v(_vm._s(_vm.params.startType === 'RELEASE' ? 'Дата поставки' : 'Начало просрочки') + ": "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.params.start, _vm.formats.formatDate)))])]), _vm._v(" - "), _c('span', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.params.end, _vm.formats.formatDate)))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.params.rateType === 'DAY' && _vm.params.rates && _vm.params.rates.length === 1 ? ("Ставка " + (this.formatPercent(_vm.params.rates[0].percent)) + " в день") : "Сложная ставка"))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(("Отсрочка платежа " + (_vm.formats.blank(_vm.params.lateDays, _vm.formats.formatNumber)))))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('b', [_c('span', [_vm._v(_vm._s(_vm.params.minusType !== 'BASE_ONLY' || _vm.params.periodType !== 'DAYS_365' || _vm.params.dutyType !== "ARBITR" ? 'Не стандартные параметры' : ''))])])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showParams),
      expression: "showParams"
    }],
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "mt-3": "",
      "row": "",
      "wrap": "",
      "justify-left": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm4": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Начало расчета",
      "items": _vm.startDayItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.startType),
      callback: function($$v) {
        _vm.$set(_vm.params, "startType", $$v)
      },
      expression: "params.startType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs5": ""
    }
  }, [(_vm.params.startType !== 'RELEASE') ? _c('v-date-field', {
    attrs: {
      "label": "Начало просрочки",
      "rules": _vm.startDateRules,
      "error-messages": _vm.errorDateOrder(),
      "hint": _vm.hints.startDate,
      "min": _vm.getFirstStartDateString(),
      "calendarOnly": _vm.isCalendarOnly
    },
    model: {
      value: (_vm.params.start),
      callback: function($$v) {
        _vm.$set(_vm.params, "start", $$v)
      },
      expression: "params.start"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.params.startType === 'RELEASE') ? _c('v-date-field', {
    attrs: {
      "label": "Дата поставки",
      "rules": _vm.startDateReleaseRules,
      "error-messages": _vm.errorDateOrder(),
      "hint": _vm.hints.startDateRelease,
      "min": _vm.getFirstStartDateString(),
      "calendarOnly": _vm.isCalendarOnly
    },
    model: {
      value: (_vm.params.start),
      callback: function($$v) {
        _vm.$set(_vm.params, "start", $$v)
      },
      expression: "params.start"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm3": "",
      "xs5": ""
    }
  }, [_c('v-date-field', {
    attrs: {
      "label": "Конец",
      "rules": _vm.endDateRules,
      "error-messages": _vm.errorDateOrder(),
      "hint": _vm.hints.endDate,
      "calendarOnly": _vm.isCalendarOnly
    },
    model: {
      value: (_vm.params.end),
      callback: function($$v) {
        _vm.$set(_vm.params, "end", $$v)
      },
      expression: "params.end"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "px-2": "",
      "sm12": "",
      "xs12": ""
    }
  }, [_c('v-subheader', {
    attrs: {
      "value.calcType": ""
    }
  }, [_vm._v("\n        Процентные ставки:\n        "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addPercent()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm12": "",
      "xs12": ""
    }
  }, _vm._l((_vm.rates), function(item, i) {
    return _c('v-card', {
      key: 'rate' + i
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "justify-space-around": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "sm2": "",
        "xs3": ""
      }
    }, [_c('v-text-field', {
      attrs: {
        "disabled": _vm.isDisabledRate(i),
        "label": "с (дня)"
      },
      model: {
        value: (item.from),
        callback: function($$v) {
          _vm.$set(item, "from", $$v)
        },
        expression: "item.from"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "sm2": "",
        "xs3": ""
      }
    }, [_c('v-number-field', {
      attrs: {
        "label": "ставка, %"
      },
      model: {
        value: (item.percent),
        callback: function($$v) {
          _vm.$set(item, "percent", $$v)
        },
        expression: "item.percent"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pt-2": "",
        "sm1": "",
        "xs2": ""
      }
    }, [_c('v-btn', {
      attrs: {
        "disabled": _vm.isDisabledRate(i),
        "icon": "",
        "small": ""
      },
      on: {
        "click": function($event) {
          return _vm.deletePercent(item)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v("clear")])], 1)], 1)], 1)], 1)
  }), 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Размер ставки",
      "items": _vm.rateTypeItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.rateType),
      callback: function($$v) {
        _vm.$set(_vm.params, "rateType", $$v)
      },
      expression: "params.rateType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-number-field', {
    attrs: {
      "label": "Отсрочка оплаты, в днях."
    },
    model: {
      value: (_vm.params.lateDays),
      callback: function($$v) {
        _vm.$set(_vm.params, "lateDays", $$v)
      },
      expression: "params.lateDays"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Очередность погашения",
      "items": _vm.minusTypeItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.minusType),
      callback: function($$v) {
        _vm.$set(_vm.params, "minusType", $$v)
      },
      expression: "params.minusType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm5": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Период определять",
      "items": _vm.periodTypeItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.periodType),
      callback: function($$v) {
        _vm.$set(_vm.params, "periodType", $$v)
      },
      expression: "params.periodType"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "mr-4": "",
      "sm10": "",
      "xs12": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Расчет гос.пошлины",
      "items": _vm.calcDutyItems,
      "item-text": "text",
      "item-value": "value"
    },
    model: {
      value: (_vm.params.dutyType),
      callback: function($$v) {
        _vm.$set(_vm.params, "dutyType", $$v)
      },
      expression: "params.dutyType"
    }
  })], 1), _vm._v(" "), _c('v-spacer')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 939 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(940),
  /* template */
  __webpack_require__(941),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_files__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BtnForm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'calc-csv-loader',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default.a },
  data: function data() {
    return {
      files: [],
      dateFormat: 'DD.MM.YYYY',
      delimiter: ',',
      textData: null,
      arrData: null
    };
  },
  watch: {
    textData: function textData(newVal, oldVal) {
      this.updateArrData();
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: []
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    calcDialogScroll: 'calcDialogScroll'
  }), {
    title: function title() {
      return 'Загрузите данные операций';
    },
    exsistDate: function exsistDate() {
      return this.fields.find(function (f) {
        return f.type === 'DATE';
      });
    }
  }),
  methods: {
    errorFileMessage: function errorFileMessage(file) {
      return __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].errorFileMessage(file);
    },
    getAcceptedFileFormat: function getAcceptedFileFormat() {
      return '.csv, .xlsx';
    },
    pickFile: function pickFile() {
      this.$refs.image.click();
    },
    onFilePicked: function onFilePicked(e) {
      var _this = this;

      var fs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(e.target.files);
      if (fs.length > 0) {
        fs.forEach(function (f) {
          return __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].readFileAsByteArray(f, function (bytes) {
            _this.addFile(f, bytes);
          });
        });
      }
    },
    addFile: function addFile(f, data) {
      var _this2 = this;

      var cb = function cb(bytes) {
        f.remove = function (e) {
          return !e && _this2.deleteFile(f);
        };
        _this2.files = [f];
        _this2.textData = bytes;
      };
      var cbErr = function cbErr(e) {
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при экспорте данных из 1С ' });
      };
      __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].convertToCsv(f, data, cb, cbErr);
    },
    deleteFile: function deleteFile(file) {
      this.files = this.files.filter(function (f) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(file.name, f.name) !== 0;
      });
    },
    getNewFields: function getNewFields() {
      var result = [{ value: null, text: '(не задано)' }];
      if (this.arrData && this.arrData[0]) {
        this.arrData[0].forEach(function (value, key) {
          result.push({ value: key, text: value });
        });
      }
      return result;
    },
    getValue: function getValue(item) {
      return this.arrData && this.arrData[1] ? this.arrData[1][item.number] : '';
    },
    ok: function ok() {
      var _this3 = this;

      var result = __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].import(this.fields, this.arrData, this.dateFormat);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result).length > 0 && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result)[0]) {
        __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].message(this, 'Совет', 'Поле Идентификатора должно быть заполненным');
      } else {
        __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u043E\u0431 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F\u0445 (' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result).length + ')?', function (self) {
          console.log('ok', result);
          _this3.$emit('change', result);
          _this3.cancel();
        });
      }
    },
    cancel: function cancel() {
      this.$emit('close');
      this.item = null;
    },
    updateArrData: function updateArrData() {
      var arrData = __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].parseCsv(__WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].decode(this.textData));
      // skip empty lines
      while (arrData.length > 0 && arrData[0].join('').length === 0) {
        arrData.shift();
      }
      this.arrData = arrData;
    }
  }
});

/***/ }),
/* 941 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.arrData || _vm.arrData.length === 0
          },
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_vm._v("\n          Подготовьте файл (xslx, csv), содержащий колонки: "), _c('b', [_vm._v(" дата")]), _vm._v(", "), _c('b', [_vm._v("название")]), _vm._v(" операции и "), _c('b', [_vm._v(" увеличение")]), _vm._v(", "), _c('b', [_vm._v("уменьшение долга")]), _vm._v(".\n        ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(item.name.slice(0, 30)) + "\n              ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n            Выберите файл\n            ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat(),
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n        Задайте соответствие полей документа и колонок в загружаемом файле\n      ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('b', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Поле")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Название колонки")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Пример значения")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.fields), function(field) {
    return [_c('v-layout', {
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "sm3": ""
      }
    }, [_c('span', [_vm._v(_vm._s(field.label) + _vm._s(field.key ? ' (идентификатор)' : ''))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('v-select', {
      attrs: {
        "hide-details": "",
        "items": _vm.getNewFields(),
        "item-value": "value",
        "item-text": "text"
      },
      model: {
        value: (field.number),
        callback: function($$v) {
          _vm.$set(field, "number", $$v)
        },
        expression: "field.number"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.getValue(field)))])])], 1)]
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n        Данные игнорируются если не удовлетворяют формату.\n        "), (_vm.exsistDate) ? _c('v-flex', {
    attrs: {
      "pl-3": "",
      "xs8": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Формат дат",
      "hint": "Выберите формат для полей даты",
      "persistent-hint": "",
      "items": [{
          value: 'DD.MM.YYYY',
          text: 'дд.мм.гггг'
        },
        {
          value: 'DD.MM.YY',
          text: 'дд.мм.гг'
        },
        {
          value: 'DD/MM/YYYY',
          text: 'дд/мм/гггг'
        },
        {
          value: 'DD/MM/YY',
          text: 'дд/мм/гг'
        },
        {
          value: 'YYYY-MM-DD',
          text: 'гггг-мм-дд'
        }
      ]
    },
    model: {
      value: (_vm.dateFormat),
      callback: function($$v) {
        _vm.dateFormat = $$v
      },
      expression: "dateFormat"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(943),
  /* template */
  __webpack_require__(944),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 943 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_files__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BtnForm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'calc-csv1s-loader',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default.a },
  data: function data() {
    return {
      files: [],
      dateFormat: 'DD.MM.YYYY',
      codepage: 'UTF-8',
      // codepage: 'windows-1251',
      textData: null,
      arrData: null
    };
  },
  watch: {
    textData: function textData(newVal, oldVal) {
      this.updateArrData();
    },
    codepage: function codepage(newVal, oldVal) {
      this.updateArrData();
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: []
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    calcDialogScroll: 'calcDialogScroll'
  }), {
    title: function title() {
      return 'Загрузите данные операций';
    }
  }),
  methods: {
    errorFileMessage: function errorFileMessage(file) {
      return __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].errorFileMessage(file);
    },
    getAcceptedFileFormat: function getAcceptedFileFormat() {
      return '.csv, .xlsx';
    },
    pickFile: function pickFile() {
      this.$refs.image.click();
    },
    onFilePicked: function onFilePicked(e) {
      var _this = this;

      var fs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(e.target.files);
      if (fs.length > 0) {
        fs.forEach(function (f) {
          return __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].readFileAsByteArray(f, function (bytes) {
            _this.addFile(f, bytes);
          });
        });
      }
    },
    addFile: function addFile(f, data) {
      var _this2 = this;

      var cb = function cb(bytes) {
        f.remove = function (e) {
          return !e && _this2.deleteFile(f);
        };
        _this2.files = [f];
        _this2.textData = bytes;
      };
      var cbErr = function cbErr(e) {
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при экспорте данных из 1С ' });
      };
      __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].convertToCsv(f, data, cb, cbErr);
    },
    deleteFile: function deleteFile(file) {
      this.files = this.files.filter(function (f) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(f.name, file.name) !== 0;
      });
      this.textData = '';
    },
    getValue: function getValue(field, index) {
      var i = index == null ? 1 : index;
      return this.arrData && this.arrData[i] ? this.arrData[i][field.number] : '';
    },
    ok: function ok() {
      var _this3 = this;

      var result = __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].import(this.fields, this.arrData, this.dateFormat);
      if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result).length > 0 && !__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result)[0]) {
        __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].message(this, 'Совет', 'Поле Идентификатора должно быть заполненным');
      } else {
        __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u043E\u0431 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F\u0445 (' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result).length + ')?', function (self) {
          console.log('ok', result);
          _this3.$emit('change', result);
          _this3.cancel();
        });
      }
    },
    cancel: function cancel() {
      this.$emit('close');
      this.item = null;
    },
    updateArrData: function updateArrData() {
      this.arrData = this.parse1Sformat(__WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].parseCsv(__WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].decode(this.textData)));
    },
    parse1Sformat: function parse1Sformat(arrData) {
      var bLine = 0;
      var eLine = 0;
      var arrTitle = [];
      var saldoData = null;
      if (arrData) {
        for (var i = 0; i < arrData.length; i++) {
          if (!saldoData) {
            var period = arrData[i].find(function (s) {
              return s.startsWith('за период:');
            });
            if (period) {
              period = period.match(/(\d{2,2}.\d{2,2}.\d{4,4})/)[0];
              saldoData = period;
            }
          }
          if (arrData[i].includes('Дата')) {
            arrTitle = arrData[i];
            this.fields[0].number = arrData[i].indexOf('Документ');
            this.fields[1].number = arrData[i].indexOf('Дата');
            this.fields[2].number = arrData[i].indexOf('Документ');
          }
          if (arrData[i].includes('Дебет')) {
            arrTitle[arrData[i].indexOf('Дебет')] = 'Дебет';
            this.fields[3].number = arrData[i].indexOf('Дебет');
            arrTitle[arrData[i].indexOf('Кредит')] = 'Кредит';
            this.fields[4].number = arrData[i].indexOf('Кредит');
            bLine = i + 1;
          }
          if (arrData[i].includes('Сальдо начальное')) {
            arrData[i][this.fields[1].number] = saldoData;
          }
          if (arrData[i].includes('Обороты за период')) {
            eLine = i;
          }
        }
      }
      var result = [];
      result[0] = arrTitle;
      result = result.concat(arrData.slice(bLine, eLine));
      return result;
    }
  }
});

/***/ }),
/* 944 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.arrData || _vm.arrData.length === 0
          },
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_vm._v("\n          Экспортируйте акт сверки из 1С программы в XSLX формате и выберите его для загрузки.\n        ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(item.name.slice(0, 30)) + "\n              ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n            Выберите файл\n            ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat(),
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n        Проверте соответствие полей документа\n      ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('b', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Поле")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm4": "",
      "px-2": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm4": "",
      "px-2": ""
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.fields), function(field) {
    return [_c('v-layout', {
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [(!field.key) ? _c('v-flex', {
      attrs: {
        "xs3": "",
        "sm3": ""
      }
    }, [_c('span', [_vm._v(_vm._s(field.label) + _vm._s(field.key ? ' (идентификатор)' : ''))])]) : _vm._e(), _vm._v(" "), (!field.key) ? _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.getValue(field)))])]) : _vm._e(), _vm._v(" "), (!field.key) ? _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.getValue(field, 2)))])]) : _vm._e()], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 945 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n    ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.cxt.filterString),
      callback: function($$v) {
        _vm.$set(_vm.cxt, "filterString", $$v)
      },
      expression: "cxt.filterString"
    }
  })], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.cancel
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "md": "",
      "flat": "",
      "height": _vm.calcDialogScroll(48 + 52)
    }
  }, [_c('v-calc-panel', {
    model: {
      value: (_vm.calc),
      callback: function($$v) {
        _vm.calc = $$v
      },
      expression: "calc"
    }
  }), _vm._v(" "), _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.showDetails,
      "caption": this.showDetails ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.showDetails = !_vm.showDetails
      }
    }
  }, [_c('span', [_vm._v("Сумма основного долга: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.calc.result.sum, _vm.formats.formatNumber)) + " руб.")])]), _vm._v(" "), _c('span', [_vm._v("Сумма процентов: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.calc.result.profit, _vm.formats.formatNumber)) + " pуб.")])]), _vm._v(" "), _c('span', [_vm._v("ИТОГО: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.calc.result.total, _vm.formats.formatNumber)) + " pуб.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', [_vm._v("Гос. пошлина: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.calc.result.duties, _vm.formats.formatNumber)) + " pуб.")])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }]
  }, [_c('table', {
    staticClass: "report_table",
    staticStyle: {
      "width": "100%",
      "min-width": "500px",
      "border-collapse": "collapse"
    },
    attrs: {
      "border": "1",
      "cellpadding": ""
    }
  }, [_c('tbody', [_c('tr', [_c('th', [_vm._v("Cумма операции, в руб.")]), _vm._v(" "), _c('th', [_vm._v("Долг, в руб.")]), _vm._v(" "), _c('th', [_vm._v("С")]), _vm._v(" "), _c('th', [_vm._v("По")]), _vm._v(" "), _c('th', [_vm._v("Дней")]), _vm._v(" "), _c('th', [_vm._v("Ставка")]), _vm._v(" "), _c('th', [_vm._v("Неустойка")])]), _vm._v(" "), _vm._l((_vm.calc.details), function(item) {
    return [(item.amount > 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.amount, _vm.formats.formatNumber)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.start)))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm.formatNote(item.ref)))]), _vm._v(" "), _c('td')]) : _vm._e(), _vm._v(" "), (item.amount < 0) ? _c('tr', [_c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.sum, _vm.formats.formatNumber)))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.start)))]), _vm._v(" "), _c('td', {
      attrs: {
        "colspan": "3"
      }
    }, [_vm._v(_vm._s(_vm.formatNote(item.ref)) + " на " + _vm._s(_vm.formats.blank(item.amount, _vm.formats.formatNumber)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(item.profit ? _vm.formats.blank(item.profit, _vm.formats.formatNumber) : ''))])]) : _vm._e(), _vm._v(" "), (item.amount == null) ? _c('tr', [_c('td'), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.sum, _vm.formats.formatNumber)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.start)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.formatDate(item.end)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.days, _vm.formatNumber)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.rate, _vm.formatPercent)))]), _vm._v(" "), _c('td', {
      staticStyle: {
        "text-align": "right"
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.profit, _vm.formatNumber)))])]) : _vm._e()]
  })], 2)])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.ok()
      }
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 946 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JsonField_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__people__ = __webpack_require__(27);












var IndividualField = function (_JsonField) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(IndividualField, _JsonField);

  function IndividualField() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, IndividualField);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (IndividualField.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(IndividualField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(IndividualField, [{
    key: 'getDescription',
    value: function getDescription(model) {
      var obj = model[this.name] ? JSON.parse(model[this.name]) : null;
      if (!obj) {
        return '';
      }
      return obj.lastName + ' ' + obj.firstName + ' ' + obj.middleName + ' \u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatInnfl(obj.innfl);
    }
  }, {
    key: 'open',
    value: function open(model, onChange) {
      var _this2 = this;

      var key = this.getCode(model);
      var fstrategy = this.getStrategy();
      if (!fstrategy) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_9__common_forms_js__["a" /* default */].openFormStg(fstrategy, key).then(function (key) {
        _this2.setCode(model, key, onChange);
      });
      return;
    }
  }, {
    key: 'select',
    value: function select(model, onChange) {
      var _this3 = this;

      var companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name);
      console.log('select', companyRefCode);
      var setPerson = function setPerson(id) {
        _this3.setCode(model, id, onChange);
      };
      var getQueryCxt = function getQueryCxt() {
        var refCode = companyRefCode;
        if (__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isRefCode(refCode)) {
          return refCode;
        } else {
          __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].message(_this3, 'Совет', 'Сначала выберите компанию');
        }
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (_this3.getCode(model)) {
          __WEBPACK_IMPORTED_MODULE_10__people__["a" /* default */].getIndividual(_this3.getCode(model));
        } else {
          return null;
        }
      }).then(function (individual) {
        var queryString = individual ? individual.innfl ? individual.innfl : individual.lastName : null;
        var getQuery = function getQuery() {
          return queryString;
        };
        if (!['LOCAL'].includes(_this3.ref)) {
          var queryCxt = getQueryCxt();
          if (__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isRefCode(queryCxt)) {
            __WEBPACK_IMPORTED_MODULE_10__people__["a" /* default */].selectIndividual(_this3.cxt.context, queryCxt, getQuery, true, true).then(function (values) {
              if (Array.isArray(values) && values.length > 0) {
                setPerson(values[0]);
              }
            });
          }
        }
        if (['LOCAL'].includes(_this3.ref)) {
          __WEBPACK_IMPORTED_MODULE_10__people__["a" /* default */].selectIndividual(_this3.cxt.context, null, getQuery, true, true).then(function (values) {
            if (Array.isArray(values) && values.length > 0) {
              setPerson(values[0]);
            }
          });
        }
      });
    }
  }, {
    key: 'fillRef',
    value: function fillRef(model, data, onChange) {
      var _this4 = this;

      var individual = data;
      var refs = this.cxt.refMap.get(this.name);
      if (refs) {
        refs.forEach(function (r) {
          var fobj = _this4.cxt.fieldObjects.get(r);
          var obj = void 0,
              code = void 0;
          if (fobj.type === 'CONTACT') {
            var items = individual ? individual.contacts : [];
            items = __WEBPACK_IMPORTED_MODULE_10__people__["a" /* default */].sortIndividualContact(items);
            obj = items.length > 0 ? items[0] : null;
            code = obj ? obj.id : null;
          }
          if (__WEBPACK_IMPORTED_MODULE_10__people__["a" /* default */].registeredTypeDoc().includes(fobj.type)) {
            var docs = individual && individual.docs ? individual.docs.filter(function (d) {
              return d.type === fobj.type;
            }) : null;
            console.log('fillRef', docs);
            docs = docs ? __WEBPACK_IMPORTED_MODULE_10__people__["a" /* default */].sortIndividualDoc(docs) : docs;
            obj = docs && docs.length > 0 ? JSON.parse(docs[0].model) : null;
            code = docs && docs.length > 0 ? docs[0].id : null;
          }
          fobj.setValue(model, code, obj, onChange);
          // console.log('fillRefPersonValues', code)
        });
      }
      this.cxt.updateItems(model);
    }
  }]);

  return IndividualField;
}(__WEBPACK_IMPORTED_MODULE_6__JsonField_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (IndividualField);

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JsonField_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__people__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__favorite__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_dialogs_js__ = __webpack_require__(7);













var ContactField = function (_JsonField) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ContactField, _JsonField);

  function ContactField() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, ContactField);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContactField.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(ContactField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(ContactField, [{
    key: 'isIndividual',
    value: function isIndividual() {
      return this.ref && this.cxt.getFieldObject(this.ref).type === 'INDIVIDUAL';
    }
  }, {
    key: 'getDescription',
    value: function getDescription(model) {
      var obj = model[this.name] ? JSON.parse(model[this.name]) : null;
      if (!obj) {
        return '';
      }
      return this.isIndividual() ? '' + obj.name : '' + obj.nameForCompany;
    }
  }, {
    key: 'open',
    value: function open(model, onChange) {
      var _this2 = this;

      var key = this.getCode(model);
      var fstrategy = this.getStrategy();
      if (!fstrategy) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.isIndividual()).then(function (isIndividual) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (isIndividual) {
            _this2.cxt.getReferencePerson(model, _this2.name).then(function (personId) {
              __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].getIndividual(personId).then(function (person) {
                fstrategy.setParentProps(person);
                __WEBPACK_IMPORTED_MODULE_8__common_forms_js__["a" /* default */].openFormStg(fstrategy, key).then(function (key) {
                  resolve(key);
                });
              });
            });
          } else {
            var companyRefCode = _this2.cxt.getReferenceCompanyRefCode(model, _this2.name);
            if (!_this2.checkCompanyRefCode(companyRefCode)) {
              reject('Not valid RefCode [' + companyRefCode + ']');
            }
            __WEBPACK_IMPORTED_MODULE_10__favorite__["a" /* default */].getCompanyRef(companyRefCode).then(function (props) {
              __WEBPACK_IMPORTED_MODULE_10__favorite__["a" /* default */].openCompanyContact(key, props.ref.ref, props.ref.caption, props.clientCompanyId).then(function (key) {
                resolve(key);
              });
            });
          }
        });
      }).then(function (key) {
        _this2.setCode(model, key, onChange);
      });
    }
  }, {
    key: 'selectIndividualContacts',
    value: function selectIndividualContacts(model) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var getQuery = function getQuery() {
          return _this3.getCode(model) ? _this3.getCode(model) : '';
        };
        _this3.cxt.getReferencePerson(model, _this3.name).then(function (personId) {
          var companyInn = void 0;
          // companyInn = this.getReferenceCompanyInn(model, fieldName)
          companyInn = companyInn ? companyInn + '' : null;
          __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].getIndividual(personId).then(function (person) {
            var contacts = person.contacts;
            if (contacts.length > 0) {
              __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].selectContactByIndividual(_this3.cxt.context, person, getQuery, companyInn).then(function (data) {
                return resolve(data);
              });
            } else {
              var fstrategy = _this3.getStrategy();
              fstrategy.setParentProps(person);
              __WEBPACK_IMPORTED_MODULE_8__common_forms_js__["a" /* default */].openFormStg(fstrategy, null).then(function (data) {
                resolve([data]);
              });
            }
          });
        }).catch(function () {
          return reject();
        });
      });
    }
  }, {
    key: 'selectCompanyContacts',
    value: function selectCompanyContacts(model) {
      var _this4 = this;

      var companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name);
      if (!this.checkCompanyRefCode(companyRefCode)) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject('Not valid RefCode [' + companyRefCode + ']');
      }
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].selectContactByCompany(_this4.cxt.context, companyRefCode).then(function (data) {
          return resolve(data);
        });
      });
    }
  }, {
    key: 'select',
    value: function select(model, onChange) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(this.isIndividual()).then(function (isIndividual) {
        if (isIndividual) {
          return _this5.selectIndividualContacts(model);
        } else {
          return _this5.selectCompanyContacts(model);
        }
      }).then(function (values) {
        if (Array.isArray(values) && values.length > 0) {
          _this5.setCode(model, values[0], onChange);
        }
      }).catch(function (error) {
        console.log('ContactField:error', error);
      });
    }
  }, {
    key: 'checkCompanyRefCode',
    value: function checkCompanyRefCode(refCode) {
      if (__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isRefCode(refCode)) {
        return true;
      }
      __WEBPACK_IMPORTED_MODULE_11__common_dialogs_js__["a" /* default */].message(this, 'Совет', 'Сначала выберите компанию');
      return false;
    }
  }]);

  return ContactField;
}(__WEBPACK_IMPORTED_MODULE_6__JsonField_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ContactField);

/***/ }),
/* 948 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JsonField_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__people__ = __webpack_require__(27);











var PersonDocField = function (_JsonField) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(PersonDocField, _JsonField);

  function PersonDocField() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, PersonDocField);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PersonDocField.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(PersonDocField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(PersonDocField, [{
    key: 'getDescription',
    value: function getDescription(model) {
      var _f = function _f(v) {
        return v || '-';
      };
      var obj = model[this.name] ? JSON.parse(model[this.name]) : null;
      if (!obj) {
        return '';
      }
      switch (this.type.toUpperCase()) {
        case 'PASSPORT_RF':
        case 'BIRTH_CERT_RF':
        case 'MARRIAGE_CERT_RF':
          return '' + _f(obj.sernum);
        case 'PENSION_CERT_RF':
          return '' + _f(obj.snils);
        case 'DRIVER_LIC_RF':
          return '' + _f(obj.number);
        case 'TEMPORARY_ID_RF':
          return '\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0434\u043E ' + (obj.validTo ? __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].formatDate(obj.validTo) : '-');
      }
      return '';
    }
  }, {
    key: 'open',
    value: function open(model, onChange) {
      var _this2 = this;

      var key = this.getCode(model);
      var fstrategy = this.getStrategy();
      this.cxt.getReferencePerson(model, this.name).then(function (personId) {
        __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].getIndividual(personId).then(function (person) {
          fstrategy.setParentProps(person);
          __WEBPACK_IMPORTED_MODULE_8__common_forms_js__["a" /* default */].openFormStg(fstrategy, key).then(function (data) {
            _this2.setCode(model, key, onChange);
          });
        });
      });
    }
  }, {
    key: 'select',
    value: function select(model, onChange) {
      var _this3 = this;

      var getQuery = function getQuery() {
        return _this3.getCode(model) ? _this3.getCode(model) : '';
      };
      this.cxt.getReferencePerson(model, this.name).then(function (personId) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].getIndividual(personId).then(function (person) {
            var docs = person.docs.filter(function (d) {
              return d.type === _this3.type;
            });
            if (docs.length > 0) {
              __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].selectDocByIndividual(_this3.cxt.context, person, getQuery, _this3.type).then(function (data) {
                return resolve(data);
              });
            } else {
              var fstrategy = _this3.getStrategy();
              fstrategy.setParentProps(person);
              __WEBPACK_IMPORTED_MODULE_8__common_forms_js__["a" /* default */].openFormStg(fstrategy, null).then(function (data) {
                resolve([data]);
              });
            }
          });
        });
      }).then(function (values) {
        if (Array.isArray(values) && values.length > 0) {
          _this3.setCode(model, values[0], onChange);
        }
      });
    }
  }]);

  return PersonDocField;
}(__WEBPACK_IMPORTED_MODULE_6__JsonField_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (PersonDocField);

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__JsonField_js__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__favorite__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_dialogs_js__ = __webpack_require__(7);











var CompanyBankField = function (_JsonField) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CompanyBankField, _JsonField);

  function CompanyBankField() {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, CompanyBankField);

    return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CompanyBankField.__proto__ || __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_get_prototype_of___default()(CompanyBankField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(CompanyBankField, [{
    key: 'getStrategy',
    value: function getStrategy() {
      return __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].createStrategy(this.cxt.context, this.type);
    }
  }, {
    key: 'getDescription',
    value: function getDescription(model) {
      var obj = model[this.name] ? JSON.parse(model[this.name]) : null;
      if (!obj) {
        return '';
      }
      return '' + obj.name;
    }
  }, {
    key: 'open',
    value: function open(model, onChange) {
      var _this2 = this;

      var key = this.getCode(model);
      var companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name);
      if (!this.checkCompanyRefCode(companyRefCode)) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].getCompanyRef(companyRefCode).then(function (props) {
        __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].openCompanyBank(key, props.ref.ref, props.ref.caption, props.clientCompanyId).then(function (key) {
          _this2.setCode(model, key, onChange);
        });
      });
    }
  }, {
    key: 'select',
    value: function select(model, onChange) {
      var _this3 = this;

      var getQuery = function getQuery() {
        return _this3.getCode(model) ? _this3.getCode(model) : '';
      };
      var companyRefCode = this.cxt.getReferenceCompanyRefCode(model, this.name);
      if (!this.checkCompanyRefCode(companyRefCode)) {
        return;
      }
      __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].getCompanyRef(companyRefCode).then(function (props) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (props && props.banks && props.banks.length > 0) {
            __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].selectCompanyBankByInn(_this3.cxt.context, props.ref.ref, getQuery).then(function (data) {
              return resolve(data);
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].openCompanyBank(null, props.ref.ref, props.ref.caption, props.clientCompanyId).then(function (data) {
              resolve([data]);
            });
          }
        });
      }).then(function (values) {
        if (Array.isArray(values) && values.length > 0) {
          _this3.setCode(model, values[0], onChange);
        }
      });
    }
  }, {
    key: 'checkCompanyRefCode',
    value: function checkCompanyRefCode(refCode) {
      if (__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].isRefCode(refCode)) {
        return true;
      }
      __WEBPACK_IMPORTED_MODULE_9__common_dialogs_js__["a" /* default */].message(this, 'Совет', 'Сначала выберите компанию');
      return false;
    }
  }]);

  return CompanyBankField;
}(__WEBPACK_IMPORTED_MODULE_6__JsonField_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (CompanyBankField);

/***/ }),
/* 950 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__FieldObject_js__ = __webpack_require__(94);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ActionForm__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__ActionForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__ActionForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__profile_index_js__ = __webpack_require__(126);















var ActionField = function (_FieldObject) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ActionField, _FieldObject);

  function ActionField() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ActionField);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ActionField.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ActionField)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(ActionField, [{
    key: 'getCode',
    value: function getCode(model) {
      return model[this.name + '_CODE'] ? model[this.name + '_CODE'] + '' : null;
    }
  }, {
    key: 'init',
    value: function init(model) {
      this.setValue(model, null, { scheduled: null, command: this.fieldValue });
    }
  }, {
    key: 'setCode',
    value: function setCode(model, newCode, onChange) {
      if (!newCode) {
        // console.log('ActionField:setCode', newCode, this)
        this.setValue(model, null, { scheduled: null, command: this.fieldValue }, onChange);
      } else {
        this.setValue(model, null, newCode, onChange);
      }
    }
  }, {
    key: 'calcScheduled',
    value: function calcScheduled(newObject) {
      if (!newObject.inputted) {
        return __WEBPACK_IMPORTED_MODULE_11_moment___default()();
      }
      var result = __WEBPACK_IMPORTED_MODULE_11_moment___default()(newObject.inputted);
      if (newObject.command) {
        var searchParams = new URLSearchParams(newObject.command.replace(/([^?]+\?)/, ''));
        result.add(searchParams.get('day-plus'), 'days');
        result.subtract(searchParams.get('day-minus'), 'days');
        if (searchParams.has('time')) {
          var time = __WEBPACK_IMPORTED_MODULE_11_moment___default()(searchParams.get('time'), 'HH:mm');
          result = result.set({ hour: time.get('hour'), minute: time.get('minute') });
        } else {
          result.add(searchParams.get('hour-plus'), 'hours');
          result.subtract(searchParams.get('hour-minus'), 'hours');
          result.add(searchParams.get('minute-plus'), 'minutes');
          result.subtract(searchParams.get('minute-minus'), 'minutes');
        }
        // console.log('calcScheduled', result.format('YYYY-MM-DD HH:mm'))
      }
      return result.format('YYYY-MM-DD HH:mm');
    }
  }, {
    key: 'setValue',
    value: function setValue(model, newCode, newObject, onChange) {
      console.log('ActionField:setValue', newCode, newObject);
      var nCode = newObject ? __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].hashCode(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newObject)) : null;
      if (!this.equalCode(model, nCode)) {
        if (newObject) {
          if (!newObject.logId && newObject.inputted) {
            newObject.scheduled = this.calcScheduled(newObject);
          }
          nCode = __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].hashCode(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newObject));
        }
        onChange && onChange(model, this.name, nCode);
        model[this.name + '_CODE'] = nCode;
        model[this.name] = nCode ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(newObject) : null;
        this.cxt.updateItems(model);
      }
    }
  }, {
    key: 'getValue',
    value: function getValue(model) {
      var jsonStr = model[this.name];
      return jsonStr ? JSON.parse(jsonStr) : {};
    }
  }, {
    key: 'getDescription',
    value: function getDescription(model) {
      var obj = this.getValue(model);
      // console.log('getDescription', obj)
      if (!obj) {
        return '';
      }
      var time = obj.scheduled;
      return time && '' + __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].blank(time) || 'Время неопределено';
    }
  }, {
    key: 'getHint',
    value: function getHint(model) {
      var obj = this.getValue(model);
      if (!obj) {
        return '';
      }

      // let searchParams = new URLSearchParams(obj.command && obj.command.replace(/([^?]+\?)/, '') || '')
      var time = obj.scheduled;
      var command = obj.command && obj.command.replace(/([^?]+\?)/, '') || '';
      return '\u0414\u0430\u0442\u0430: ' + __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].blank(time) + ' \u041A\u043E\u043C\u0430\u043D\u0434\u0430: ' + __WEBPACK_IMPORTED_MODULE_7__api_formats_js__["a" /* default */].blank(command);
    }
  }, {
    key: 'open',
    value: function open(model, onChange) {
      var _this2 = this;

      var value = this.getValue(model);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(value).then(function (value) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (!value.logId) {
            _this2.openForm(value).then(function (value) {
              resolve(value);
            });
          } else {
            _this2.openAction(value).then(function (value) {
              // resolve(value)
            });
          }
        });
      }).then(function (value) {
        _this2.setValue(model, null, value, onChange);
        console.log('open', value);
        _this2.cxt.updateItems(model);
      });
    }
  }, {
    key: 'select',
    value: function select(model, onChange) {
      var _this3 = this;

      var value = this.getValue(model);
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve(value).then(function (value) {
        return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (!value) {
            _this3.openForm(value).then(function (value) {
              resolve(value);
            });
          } else {
            _this3.openForm(value).then(function (value) {
              resolve(value);
            });
          }
        });
      }).then(function (value) {
        _this3.setValue(model, null, value, onChange);
        console.log('open', value);
        _this3.cxt.updateItems(model);
      });
    }
  }, {
    key: 'openForm',
    value: function openForm(value) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].register('v-action-form', __WEBPACK_IMPORTED_MODULE_12__ActionForm___default.a);
        var onInput = function onInput(data) {
          // console.log('openCalcForm', data)
          resolve(data);
        };
        var title = 'Действие';
        var fullscreen = __WEBPACK_IMPORTED_MODULE_9__store__["a" /* default */].getters.getIsMobile;
        var comp = { template: '\n        <v-action-form :fullscreen="fullscreen" :value="value" :title="title" v-on:input="onInput" v-on:close="$emit(\'close\')"></v-action-form>\n      ',
          data: function data() {
            return {
              onInput: onInput,
              fullscreen: fullscreen,
              value: value,
              title: title
            };
          }
        };
        __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].modal(comp);
      });
    }
  }, {
    key: 'openAction',
    value: function openAction(item) {
      return __WEBPACK_IMPORTED_MODULE_13__profile_index_js__["a" /* default */].openLogAction(item.logId, this.cxt.context.getMatterId());
    }
  }, {
    key: 'clearRef',
    value: function clearRef(model) {
      var _this4 = this;

      console.log('clearRef:ActionField', this);
      var refs = this.cxt.refMap.get(this.name);
      if (refs) {
        refs.forEach(function (r) {
          var fobj = _this4.cxt.fieldObjects.get(r);
          if (fobj.type === 'ACTION') {
            var obj = fobj.getValue(model);
            if (!obj.logId) {
              fobj.init(model);
              fobj.clearRef(model);
            }
          }
        });
      }
    }
  }, {
    key: 'fillRef',
    value: function fillRef(model, data, onChange) {
      // console.log('fillRef:ActionField', data, this)
    }
  }]);

  return ActionField;
}(__WEBPACK_IMPORTED_MODULE_8__FieldObject_js__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (ActionField);

/***/ }),
/* 951 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(952),
  /* template */
  __webpack_require__(953),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 952 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_DateField__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_DateField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_DateField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BtnForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







// import depo from '.'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'action-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default.a, vDateField: __WEBPACK_IMPORTED_MODULE_3__common_DateField___default.a },
  data: function data() {
    return {
      cxt: null,
      scheduledDate: null,
      scheduledTime: null,
      command: null
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    radio: {
      type: Boolean,
      default: false
    },
    selected: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    value: {
      type: Object,
      default: null
    },
    title: {
      type: String,
      default: 'Выберите документ'
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.fetchData();
  },

  watch: {
    value: function value(newVal, oldVal) {
      // watch it
      this.fetchData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  }), {
    isEdit: function isEdit() {
      console.log('isEdit', this.value && this.value.logId);
      return !(this.value && this.value.logId);
    }
  }),
  methods: {
    fetchData: function fetchData() {
      if (this.value) {
        if (this.value.scheduled) {
          var mom = __WEBPACK_IMPORTED_MODULE_5_moment___default()(this.value.scheduled, __WEBPACK_IMPORTED_MODULE_5_moment___default.a.ISO_8601);
          this.scheduledDate = mom.format('YYYY-MM-DD');
          this.scheduledTime = mom.format('HHmm');
        }
        if (this.value.command) {
          this.command = this.value.command;
        }
      }
    },
    ok: function ok() {
      var scheduled = null;
      if (this.scheduledDate || this.scheduledTime) {
        var scheduledDate = this.scheduledDate || __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('YYYY-MM-DD');
        var scheduledTime = this.scheduledTime || __WEBPACK_IMPORTED_MODULE_5_moment___default()().format('HHmm');
        scheduled = __WEBPACK_IMPORTED_MODULE_5_moment___default()(scheduledDate + ' ' + scheduledTime, 'YYYY-MM-DD HHmm', false).format('YYYY-MM-DD HH:mm');
      }
      this.$emit('input', { scheduled: scheduled, command: this.value && this.value.command || '' });
      this.cancel();
    },
    cancel: function cancel() {
      this.$emit('close');
      this.itemId = null;
    },
    onChangeDate: function onChangeDate(v) {
      console.log('onChangeDate', v);
      this.scheduledDate = v;
    },
    rollback: function rollback() {
      var _this = this;

      var cb = function cb(data) {
        _this.$emit('input', { scheduled: null, command: _this.command || '' });
        _this.cancel();
      };
      var cbError = function cbError(e) {
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при отмене действия ' });
      };
      __WEBPACK_IMPORTED_MODULE_1__api_server__["a" /* default */].apiPost('/api/me/action-rollbacks', {
        actionCode: 'MATTER_RUN',
        resourceId: this.value && this.value.logId || null
      }, cb, cbError);
    }
  }
});

/***/ }),
/* 953 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isEdit),
            expression: "!isEdit"
          }],
          on: {
            "click": function($event) {
              return _vm.rollback()
            }
          }
        }, [_vm._v("Отменить выполнение")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isEdit),
            expression: "isEdit"
          }],
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")])]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-flex', [_vm._v("\n        Действие планируется после заполнения даты и времени.\n        "), _c('div', [_vm._v("Внимание! Дата может заполняться автоматически.")])]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs5": "",
      "sm6": ""
    }
  }, [_c('v-date-field', {
    attrs: {
      "placeholder": "Сейчас",
      "value": _vm.scheduledDate,
      "readonly": !_vm.isEdit
    },
    on: {
      "input": _vm.onChangeDate
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs2": "",
      "sm2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "placeholder": "чч:мм",
      "mask": "##:##",
      "rules": [function (v) { return !v || /^(2[0-3]|[01]?[0-9])([0-5]?[0-9])$/.test(v) || 'чч:мм'; }],
      "readonly": !_vm.isEdit
    },
    model: {
      value: (_vm.scheduledTime),
      callback: function($$v) {
        _vm.scheduledTime = $$v
      },
      expression: "scheduledTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "rows": "3",
      "readonly": !_vm.isEdit
    },
    model: {
      value: (_vm.value && _vm.value.command),
      callback: function($$v) {
        _vm.$set(_vm.value && _vm.value, "command", $$v)
      },
      expression: "value && value.command"
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 954 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__assist_AssistClasses_js__ = __webpack_require__(32);
















var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'Action';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return 'Операция';
    }
  }, {
    key: 'setContext',
    value: function setContext(cxt) {
      this.context = cxt;
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      return model;
    }
  }, {
    key: 'createModelFromJSON',
    value: function createModelFromJSON(json) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.createModel(), JSON.parse(json));
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel() {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.createModel(), {});
    }
  }, {
    key: 'createModelFromData',
    value: function createModelFromData(data) {
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_assign___default()(this.createModel(), data);
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var steps = [];

      new __WEBPACK_IMPORTED_MODULE_13__assist_AssistClasses_js__["a" /* default */].Step('', function (step) {}, {
        scheme: [{
          fieldType: 'v-flex',
          name: 'actionCode',
          grow: true,
          size: { sm6: true, xs12: true }
        }]
      }, {}).addToArray(steps);

      this.steps = steps;
      return this;
    }
  }, {
    key: 'viewTitle',
    value: function viewTitle(model) {
      var it = this.formatActionData(model);
      return it.caption ? it.caption : this.getTypeName();
    }
  }, {
    key: 'viewTitleComp',
    value: function viewTitleComp(model) {
      return __WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].createComp('<span>' + this.viewTitle(model) + '</span>');
    }
  }, {
    key: 'viewContentComp',
    value: function viewContentComp(model) {
      if (!model) {
        return '';
      }
      var _f = function _f(v) {
        return v || '-';
      };
      var _b = function _b(v) {
        return v || '';
      };
      var _s = function _s(rCode, model) {
        var finished = model['finished'] && __WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].formatDateTime(model['finished']) || null;
        var statuses = {
          'OK': '\u0412\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u043E: ' + _f(finished),
          'ERROR': '\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u043E: ' + _f(finished),
          'CANCEL': '\u041E\u0442\u043C\u0435\u043D\u0435\u043D\u043E: ' + _f(finished),
          'PROCESS': '\u0412\u044B\u043F\u043E\u043B\u043D\u044F\u0435\u0442\u0441\u044F: ' + _f(finished),
          'SCHEDULE': '\u041E\u0436\u0438\u0434\u0430\u0435\u0442 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F'
        };
        return statuses[rCode];
      };
      var rCode = model['started'] && model['resultCode'] || model['scheduled'] && 'SCHEDULE' || model['started'] && 'PROCESS';
      var it = this.formatActionData(model);
      var details = this.formatActionDetails(model);
      var oper = '<div>\u041E\u043F\u0435\u0440\u0430\u0442\u043E\u0440: <b>' + _f(model['accountNameShort']) + '</b></div>';
      return __WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].createComp('\n      <div>\n        <div>\u0422\u0438\u043F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438: <b>' + _f(it && it.caption) + '</b></div>\n        ' + (oper || '') + '\n        <div>\u0417\u0430\u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E: <b>' + _f(model['scheduled'] ? __WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].formatDateTime(model['scheduled']) : null) + '</b></div>\n        <div>\u041D\u0430\u0447\u0430\u0442\u043E: <b>' + _f(model['started'] ? __WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].formatDateTime(model['started']) : null) + '</b></div>\n        <div><b>' + _s(rCode, model) + '</b></div>\n        ' + (it && it.state ? '<div>' + it.state + '</div>' : '') + '\n        <div>' + _f(it && it.data) + '</div>\n        <div>' + _b(details && details.data) + '</div>\n      </div>\n    ');
    }
  }, {
    key: 'viewContentListComp',
    value: function viewContentListComp(model) {
      if (!model) {
        return '';
      }
      var it = this.formatActionData(model);
      return __WEBPACK_IMPORTED_MODULE_10__api_formats__["a" /* default */].createComp('\n      <span>\n        ' + (!it.data ? '' : it.data) + (!it.state ? '' : ' Статус: ' + it.state) + '\n      </span>\n    ');
    }
  }, {
    key: 'viewContentList',
    value: function viewContentList(model) {
      if (!model) {
        return '';
      }
      var it = this.formatActionData(model);
      return '\n      <span>\n        ' + it.caption + (!it.data ? '' : ': ' + it.data) + (!it.state ? '' : ' Статус: ' + it.state) + '\n      </span>\n    ';
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'getDepoLinkUrl',
    value: function getDepoLinkUrl(depoId, title) {
      if (!depoId) {
        return '';
      }
      return '<a href="' + __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getDepoUrl(depoId) + '" target="blank">' + title + '</a>';
    }
  }, {
    key: 'formatActionData',
    value: function formatActionData(item) {
      var getPostType = function getPostType(typeCode) {
        return __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getPostTypes && __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getPostTypes.has(typeCode) ? __WEBPACK_IMPORTED_MODULE_12__store__["a" /* default */].getters.getPostTypes.get(typeCode).caption : typeCode;
      };
      var _f = function _f(v) {
        return v || '-';
      };
      try {
        var result;
        if (!item) {
          return result;
        }
        var caption;
        var jsn = JSON.parse(item.data);
        console.log('formatActionData', jsn, item);
        switch (item.actionCode) {
          case 'LOGIN':
            return { caption: '\u041D\u0430\u0447\u0430\u0442 \u0441\u0435\u0430\u043D\u0441 \u0440\u0430\u0431\u043E\u0442\u044B', data: '\u0430\u0434\u0440\u0435\u0441 ' + jsn.ip + ', \u0431\u0440\u0430\u0443\u0437\u0435\u0440 ' + jsn.userAgent };
          case 'REFRESH':
            return { caption: '\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0435\u043D \u0441\u0435\u0430\u043D\u0441 \u0440\u0430\u0431\u043E\u0442\u044B', data: '\u0430\u0434\u0440\u0435\u0441 ' + jsn.ip + ', \u0431\u0440\u0430\u0443\u0437\u0435\u0440 ' + jsn.userAgent };
          case 'AGENT_CREATE':
            return { caption: '\u0421\u043E\u0437\u0434\u0430\u043B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F ', data: '' + jsn.username };
          case 'AGENT_UPDATE':
            return { caption: '\u0418\u0437\u043C\u0435\u043D\u0438\u043B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F ', data: '' + jsn.username };
          case 'AGENT_DELETE':
            return { caption: '\u0423\u0434\u0430\u043B\u0438\u043B \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F ', data: '' + jsn.username };
          case 'AGENT_RESET_PASSWORD':
            return { caption: '\u0421\u0431\u0440\u043E\u0441\u0438\u043B \u043F\u0430\u0440\u043E\u043B\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F ', data: '' + jsn.username };
          case 'CLIENT_UPDATE':
            return { caption: '\u0418\u0437\u043C\u0435\u043D\u0438\u043B \u043E\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 ', data: '' };
          case 'POST_ACTION_CREATE':
            return { caption: '\u0421\u043E\u0437\u0434\u0430\u043B \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438 \u0437\u043D\u0430\u0447\u0438\u043C\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 ', data: '' + getPostType(jsn.typeCode) };
          case 'POST_ACTION_APPLY':
            return { caption: '\u041E\u0442\u0432\u0435\u0442\u0438\u043B \u043D\u0430 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438 \u0437\u043D\u0430\u0447\u0438\u043C\u043E\u0435 \u0441\u043E\u043E\u0431\u0449\u0435\u043D\u0438\u0435 ', data: '' + getPostType(jsn.typeCode) };
          case 'MONITORING_SWITCH':
            if (jsn.monitoring) {
              return { caption: '\u0412\u043A\u043B\u044E\u0447\u0438\u043B \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433', data: '\u0430\u0434\u0440\u0435\u0441: ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(jsn.email, null, ' ') };
            } else {
              return { caption: '\u0412\u044B\u043A\u043B\u044E\u0447\u0438\u043B \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433', data: null };
            }
          case 'MONITORING_UPDATE':
            result = JSON.parse(item.result);
            return { caption: jsn.monitoring ? '\u041F\u043E\u0441\u0442\u0430\u0432\u0438\u043B \u043D\u0430 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433' : '\u0423\u0431\u0440\u0430\u043B \u0441 \u043C\u043E\u043D\u0438\u0442\u043E\u0440\u0438\u043D\u0433\u0430', data: '\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 (' + result.applyed.length + ') [' + (result.applyed.length > 0 ? result.applyed.join(', ') : '-') + '] ' + (result.errors.length > 0 ? ', ошибочные инн (' + result.errors.length + ')[' + result.errors.join(', ') + ']' : '') + '.' };
          case 'FAVORITE_COMPANY_UPDATE':
            result = JSON.parse(item.result);
            caption = jsn.operation === 'UPDATE' ? '\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435/\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u043A\u043E\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u043E\u0432' : '\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F';
            caption = jsn.operation === 'DELETE' ? '\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u043A\u043E\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u043E\u0432' : caption;
            return { caption: caption, data: '\u041A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 (' + result.applyed.length + ') [' + (result.applyed.length > 0 ? result.applyed.join(', ') : '-') + '] ' + (result.errors.length > 0 ? ', ошибочные инн (' + result.errors.length + ')[' + result.errors.join(', ') + ']' : '') + '.' };
          case 'CLIENT_INDIVIDUAL_UPDATE':
            result = JSON.parse(item.result);
            caption = jsn.operation === 'UPDATE' ? '\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435/\u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043E \u0424\u0438\u0437. \u043B\u0438\u0446\u0435' : '\u041D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0430\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044F';
            caption = jsn.operation === 'DELETE' ? '\u0423\u0434\u0430\u043B\u0435\u043D\u0438\u0435 \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043E \u0424\u0438\u0437. \u043B\u0438\u0446\u0435' : caption;
            var errors = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(result.errors).map(function (_ref) {
              var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                  k = _ref2[0],
                  v = _ref2[1];

              return k + ' - ' + v;
            });
            return { caption: caption, data: '(' + result.applyed.length + ') [' + (result.applyed.length > 0 ? result.applyed.join(', ') : '-') + '] ' + (errors.length > 0 ? ', ошибочные данные (' + errors.length + ') [' + errors.join(', ') + ']' : '') + '.' };
          case 'SIGN_FILE':
            result = JSON.parse(item.result);
            return { caption: '\u0417\u0430\u0432\u0435\u0440\u0438\u043B \u043A\u043E\u043F\u0438\u0438 ', data: '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B (' + result.applyed.length + ') [' + (result.applyed.length > 0 ? result.applyed.join(', ') : '-') + '] ' + (result.errors.length > 0 ? ', ошибочные идентификаторы (' + result.errors.length + ')[' + result.errors.join(', ') + ']' : '') + '.' };
          case 'DEPO_MATTER':
            result = item.result ? JSON.parse(item.result) : null;
            if (result && result.message) {
              return { caption: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0438 \u0434\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 ', data: result && result.depoId ? '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442: ' + result.depoId : result.message ? result.message : 'Документ: -' };
            } else {
              return { caption: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0438 \u0434\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432', data: '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442: ' + (result && result.depoId ? result.depoId : '-') + (result && result.errors ? ' Ошибка: ' + result.errors : '') };
            }
          case 'DEPO_PACKAGE':
            result = item.result ? JSON.parse(item.result) : null;
            if (result && !result.errors) {
              return { caption: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0438 \u0434\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 ', data: '\u0428\u0430\u0431\u043B\u043E\u043D: ' + _f(jsn.deedId) };
            } else {
              return { caption: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043A\u0430 \u0438 \u0434\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 ', data: '\u0428\u0430\u0431\u043B\u043E\u043D: ' + _f(jsn.deedId) + ' ' + (result && result.errors || '') };
            }
          case 'SEND_MAIL':
            result = item.result ? JSON.parse(item.result) : null;
            if (result && !result.errors) {
              return { caption: '\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0438\u0441\u044C\u043C\u0430', data: '<b>' + _f(jsn.subject) + '</b> \u0434\u043B\u044F ' + _f(jsn.email) + ' \u0438\u0437 ' + _f(result.mailbox) };
            } else {
              return { caption: '\u041E\u0442\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u043F\u0438\u0441\u044C\u043C\u0430', data: '<b>' + _f(jsn.subject) + '</b> \u0434\u043B\u044F ' + _f(jsn.email) + ' \u0438\u0437 ' + _f(jsn.mailbox) + '  ' + (result && result.errors || '') };
            }
          case 'SEND_MATTER':
            result = item.result ? JSON.parse(item.result) : null;
            if (result && result.message) {
              return { caption: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0430 \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0434\u0435\u043B\u0430 ', data: '<b>' + _f(jsn.subject) + '</b>' };
            } else {
              return { caption: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u0430 \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0430 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0434\u0435\u043B\u0430  ', data: '<b>' + _f(jsn.subject) + '</b> ' + (result && result.errors || '') };
            }
          case 'SEND_PACKAGE':
            result = item.result ? JSON.parse(item.result) : null;
            if (result && !result.errors) {
              return { caption: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0438\u0441\u044C\u043C\u043E \u0441 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C\u0438 \u0434\u0435\u043B\u0430 ', data: '<b>' + _f(jsn.subject) + '</b>' };
            } else {
              return { caption: '\u041F\u043E\u0434\u0433\u043E\u0442\u043E\u0432\u043B\u0435\u043D\u043E \u043F\u0438\u0441\u044C\u043C\u043E \u0441 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C\u0438 \u0434\u0435\u043B\u0430  ', data: '<b>' + _f(jsn.subject) + '</b> ' + (result && result.errors || '') };
            }
          case 'MATTER_RUN':
            result = item.result ? JSON.parse(item.result) : null;
            var action = jsn.command.indexOf('send_mail') > 0 ? 'подготовка письма' : jsn.command.indexOf('wait_mail') > 0 ? 'ожидание письма' : 'проверка поля';
            if (result && !result.errors) {
              return { caption: '\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 ' + action + ' ', data: '<b>' + _f(jsn.fieldLabel || jsn.command) + '</b>' };
            } else {
              return { caption: '\u0414\u0435\u0439\u0441\u0442\u0432\u0438\u0435 ' + action + ' ', data: '<b>' + _f(jsn.fieldLabel || jsn.command) + '</b> ' + (result && result.errors && '<br/>' + result.errors || '') };
            }
          default:
            return { caption: '\u0421\u043E\u0432\u0435\u0440\u0448\u0438\u043B \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0443\u044E \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044E', data: '\u0414\u0430\u043D\u043D\u044B\u0435: ' + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_json_stringify___default()(jsn, null, ' ') };
        }
      } catch (e) {
        return { caption: '\u0421\u043E\u0432\u0435\u0440\u0448\u0438\u043B \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0443\u044E \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044E', data: '\u0414\u0430\u043D\u043D\u044B\u0435: ' + item.data };
      }
    }
  }, {
    key: 'formatActionDetails',
    value: function formatActionDetails(item) {
      var _f = function _f(v) {
        return v || '-';
      };
      try {
        var result;
        if (!item) {
          return result;
        }
        var jsn = JSON.parse(item.data);
        switch (item.actionCode) {
          case 'DEPO_MATTER':
            result = item.result ? JSON.parse(item.result) : null;
            return { data: result ? '<br/>' + this.getDepoLinkUrl(result.depoId, 'Ссылка на документ в депозитарии') : '' };
          case 'DEPO_PACKAGE':
            result = item.result ? JSON.parse(item.result) : null;
            return { data: result ? '<br/>' + this.getDepoLinkUrl(result.depoId, 'Ссылка на документ в депозитарии') : '' };
          case 'SEND_PACKAGE':
            return { data: '<br/>' + _f(jsn.body) };
          case 'SEND_MAIL':
            return { data: '<br/>' + _f(jsn.body) };
          case 'MATTER_RUN':
            return { data: '<br/> ' + _f(jsn.command) + ' <br/><br/>\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u044F: ' + _f(jsn.fieldName) };
          default:
            return null;
        }
      } catch (e) {
        return { caption: '\u0421\u043E\u0432\u0435\u0440\u0448\u0438\u043B \u043D\u0435\u0438\u0437\u0432\u0435\u0441\u0442\u043D\u0443\u044E \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u044E', data: '\u0414\u0430\u043D\u043D\u044B\u0435: ' + item.data };
      }
    }
  }, {
    key: 'getItems',
    value: function getItems(actionId, cb) {
      var _this2 = this;

      var cbError = function cbError(e) {
        _this2.isLoading = false;
        _this2.context.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении данных операции ' });
      };
      __WEBPACK_IMPORTED_MODULE_11__api_server__["a" /* default */].apiGet('/api/me/actions/' + actionId, cb, cbError);
    }
  }, {
    key: 'fetchData',
    value: function fetchData(itemId) {
      var _this3 = this;

      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        var cb = function cb(item) {
          return resolve(item);
        };
        if (itemId) {
          _this3.getItems(itemId, cb);
        } else {
          resolve(null);
        }
      });
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_13__assist_AssistClasses_js__["a" /* default */].Strategy);

var Model = function Model() {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Model);
};

function createStrategy(cxt) {
  return new Strategy(cxt);
}

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 955 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(956),
  /* template */
  __webpack_require__(957),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 956 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assist_StepGenerator_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__assist_StepGenerator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__assist_StepGenerator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assist_AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_BtnForm__);








var _this2 = this;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




// import people from './index.js'



var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return '';
    }
  }, {
    key: 'getTypeName',
    value: function getTypeName() {
      return '';
    }
  }, {
    key: 'setContext',
    value: function setContext(cxt) {
      this.context = cxt;
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new __WEBPACK_IMPORTED_MODULE_10__assist_AssistClasses_js__["a" /* default */].Model();
      return model;
    }
  }, {
    key: 'createDefaultModel',
    value: function createDefaultModel(individual) {
      return this.createModel();
    }
  }, {
    key: 'createModelFromData',
    value: function createModelFromData(data) {
      return this.createModel();
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      return this;
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {}
  }, {
    key: 'fetchData',
    value: function fetchData(itemId) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve(null);
      });
    }
  }, {
    key: 'updateData',
    value: function updateData(itemId, model) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        return resolve(itemId);
      });
    }
  }, {
    key: 'viewTitle',
    value: function viewTitle(model) {
      return '';
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_10__assist_AssistClasses_js__["a" /* default */].Strategy);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'action-prop',
  components: { vStepGenerator: __WEBPACK_IMPORTED_MODULE_9__assist_StepGenerator_vue___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_11__common_BtnForm___default.a },
  data: function data() {
    return {
      title: '',
      valid: true,
      model: null
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    resourceId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    typeCode: {
      type: String,
      default: null
    },
    strategy: {
      type: Object,
      default: function _default() {
        return new Strategy(_this2);
      }
    }
  },
  created: function created() {},
  mounted: function mounted() {
    this.strategy.setContext(this);
    this.fetchData(this.itemId);
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.fetchData(this.itemId);
    },
    strategy: function strategy(newVal, oldVal) {
      // watch it
      this.strategy = newVal;
      this.strategy.setContext(this);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_8_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  })),
  methods: {
    // Model methods
    fetchData: function fetchData(itemId) {
      var _this3 = this;

      this.strategy.fetchData(itemId).then(function (data) {
        _this3.updateModel(_this3.strategy.createModelFromData(data));
        _this3.title = _this3.strategy.getTypeName();
      });
    },
    updateModel: function updateModel(model) {
      var _this4 = this;

      this.$nextTick(function () {
        // console.log('updateModel', model)
        _this4.model = model;
        _this4.strategy.updateModel(model);
        _this4.$forceUpdate();
      });
    },
    cancel: function cancel() {
      this.$emit('close');
    },
    refresh: function refresh() {
      this.fetchData(this.itemId);
    },
    rollback: function rollback() {
      var _this5 = this;

      var cb = function cb(data) {
        _this5.fetchData(_this5.itemId);
      };
      var cbError = function cbError(e) {
        _this5.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при отмене действия ' });
      };
      __WEBPACK_IMPORTED_MODULE_7__api_server__["a" /* default */].apiPost('/api/me/action-rollbacks', {
        actionCode: this.model.actionCode,
        resourceId: this.itemId
      }, cb, cbError);
    }
  }
});

/***/ }),
/* 957 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      },
      "enter": function($event) {
        return _vm.refresh()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.model && _vm.model.scheduled && !_vm.model.started),
            expression: "model && model.scheduled && !model.started"
          }],
          on: {
            "click": function($event) {
              return _vm.rollback()
            }
          }
        }, [_vm._v("Отменить выполнение")]), _vm._v(" "), _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.model && _vm.model.resultCode === 'PROCESS'),
            expression: "model && model.resultCode === 'PROCESS'"
          }],
          on: {
            "click": function($event) {
              return _vm.rollback()
            }
          }
        }, [_vm._v("Прервать выполнение")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
          on: {
            "click": _vm.refresh
          }
        }, [_vm._v("Обновить")])]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c(_vm.strategy.viewContentComp(_vm.model), {
    tag: "component"
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 958 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__ = __webpack_require__(149);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__ = __webpack_require__(151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepSetParameters_js__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__StepPostList_js__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_moment__);















var PostSelectType = function (_AssistClasses$Step) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(PostSelectType, _AssistClasses$Step);

  function PostSelectType(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, PostSelectType);

    var _this = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PostSelectType.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(PostSelectType)).call(this, 'Выберите вид рассылки', function (step) {
      return _this.getPostTypeName(_this.model.postTypeCode);
    }, {}, {
      postTypeCode: null,
      postListField: null
    }));

    _this.context = cxt;
    _this.editable = true;
    _this.nextEnabled = function () {
      return ['FAVORITES', 'CSV'].includes(_this.model['postTypeCode']) && _this.model['postListField'] !== null;
    };

    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(PostSelectType, [{
    key: 'fillFields',
    value: function fillFields(fields) {
      var _this2 = this;

      this.fields = fields;
      var lScheme = [];
      // var cxt = this.context
      lScheme.push({
        fieldType: 'v-select-radio',
        name: 'postTypeCode',
        itemText: 'text',
        itemValue: 'value',
        events: {
          'input': function input() {
            _this2.model['postListField'] = null;
          }
        },
        items: [{ value: 'FAVORITES', text: 'Рассылка моим контрагентам' }, { value: 'CSV', text: 'Рассылка по данным из файла' }, { value: 'HOLDERS', text: 'Рассылка участникам компании (не реализована)' }],
        size: { sm10: true }
      });
      lScheme.push({
        fieldType: 'v-flex',
        slot: '\u0423\u043A\u0430\u0436\u0438\u0442\u0435 \u043F\u043E\u043B\u0435 \u0441 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u044B\u043C\u0438 \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F\u043C\u0438 \u0434\u043B\u044F \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0438\u0441\u0435\u043C \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438',
        shrink: false,
        size: { sm8: true, xs12: true },
        if: function _if(model, field) {
          return ['FAVORITES', 'CSV'].includes(model['postTypeCode']);
        }
      });
      lScheme.push({
        fieldType: 'v-select',
        label: 'Уникальное поле в рассылке',
        hint: 'Обычно содержит ИНН контрагента или Физ. Лица',
        itemValue: 'name',
        itemText: 'label',
        items: function items(model, field) {
          if (['FAVORITES'].includes(model['postTypeCode'])) {
            return _this2.fields.filter(function (f) {
              return !/^\s*(self)\s*$/gi.test(f.value) && f.type.toUpperCase() === 'COMPANY';
            });
          }
          if (['CSV'].includes(model['postTypeCode'])) {
            return _this2.fields.filter(function (f) {
              return (!/^\s*(self)\s*$/gi.test(f.value) && f.type.toUpperCase() === 'COMPANY' || f.type.toUpperCase() === 'INDIVIDUAL' || f.type.toUpperCase() === 'TEXT') && f.label;
            });
          }
        },
        persistentHint: true,
        name: 'postListField',
        shrink: false,
        size: { sm8: true, xs12: true },
        if: function _if(model, field) {
          return ['FAVORITES', 'CSV'].includes(model['postTypeCode']);
        }
      });
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'getPostTypeName',
    value: function getPostTypeName(value) {
      var arr = [{ value: 'FAVORITES', text: 'Рассылка моим контрагентам' }, { value: 'HOLDERS', text: 'Рассылка участникам компании' }, { value: 'CSV', text: 'Список значений' }];
      var item = arr.find(function (i) {
        return i.value === value;
      });
      return item ? item.text : null;
    }
  }]);

  return PostSelectType;
}(__WEBPACK_IMPORTED_MODULE_8__AssistClasses_js__["a" /* default */].Step);

var DocumnentSelectType = function (_AssistClasses$Step2) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(DocumnentSelectType, _AssistClasses$Step2);

  function DocumnentSelectType(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DocumnentSelectType);

    var _this3 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumnentSelectType.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DocumnentSelectType)).call(this, 'Выберите тип документа', function (step) {
      return step.model.deedName;
    }, {
      scheme: [{
        fieldType: 'v-text-field',
        label: 'Тип',
        name: 'deedNumber',
        hint: function hint(model, field) {
          return model['deedName'] || 'Введите или выберите код типа документа';
        },
        errors: function errors(model, field) {
          return model['deedNumber'] !== null && model['deedName'] === null && 'Неверный код типа документа' || null;
        },
        events: {
          'input': function input(value) {
            cxt.setDeed('deedNumber', 'deedName', value);
          }
        },
        grow: true,
        size: { sm8: true, xs6: true }
      }, {
        fieldType: 'v-btn',
        slot: 'Выбрать',
        events: { 'click': function click() {
            return cxt.selectDeed('deedNumber', 'deedName');
          } },
        shrink: false,
        size: { sm4: true, xs6: true }
      }, {
        fieldType: 'v-select',
        label: 'Формат документа',
        itemValue: 'value',
        itemText: 'text',
        items: function items(model, field) {
          return cxt.getDeedFormats();
        },
        name: 'deedFormat',
        shrink: false,
        size: { sm8: true, xs12: true }
      }]
    }, {
      deedNumber: null,
      deedName: null,
      deedFormat: 'docx'
    }));

    _this3.context = cxt;
    _this3.nextEnabled = function () {
      return _this3.model['deedName'] !== null;
    };
    _this3.editable = true;
    return _this3;
  }

  return DocumnentSelectType;
}(__WEBPACK_IMPORTED_MODULE_8__AssistClasses_js__["a" /* default */].Step);

var ChildrenSelect = function (_AssistClasses$Step3) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(ChildrenSelect, _AssistClasses$Step3);

  function ChildrenSelect(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ChildrenSelect);

    var _this4 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChildrenSelect.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ChildrenSelect)).call(this, 'Выберите документы для подшивки', function (step) {
      return _this4.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {
      selectedChildren: null
    }));

    _this4.context = cxt;
    _this4.editable = true;
    _this4.childrenItems = [];
    return _this4;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(ChildrenSelect, [{
    key: 'fillChildren',
    value: function fillChildren(items) {
      if (!items) {
        this.props.scheme = [];
        return this;
      }
      this.childrenItems = items;
      var lScheme = [{
        fieldType: 'v-select-check',
        name: 'selectedChildren',
        itemText: 'name',
        itemValue: 'id',
        items: this.childrenItems,
        size: { sm10: true }
      }];
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      return model['selectedChildren'] && '\u0412\u044B\u0431\u0440\u0430\u043D\u043E ' + model['selectedChildren'].split(',').length + ' \u0438\u0437 ' + this.childrenItems.length + ' \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432' || '';
    }
  }]);

  return ChildrenSelect;
}(__WEBPACK_IMPORTED_MODULE_8__AssistClasses_js__["a" /* default */].Step);

var PostListSend = function (_AssistClasses$Step4) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(PostListSend, _AssistClasses$Step4);

  function PostListSend(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, PostListSend);

    var _this5 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PostListSend.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(PostListSend)).call(this, 'Проверьте документы', function (step) {
      return '';
    }, {
      scheme: []
    }, {}));

    _this5.context = cxt;
    _this5.editable = true;
    return _this5;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(PostListSend, [{
    key: 'fillFields',
    value: function fillFields(fields) {
      var _this6 = this;

      if (!fields) {
        this.props.scheme = [];
        return this;
      }
      var lScheme = [];
      var cxt = this.context;
      fields.forEach(function (f) {
        lScheme.push({
          fieldType: 'v-checkbox',
          name: f.name,
          label: f.label,
          hint: f.hint,
          persistentHint: true,
          grow: true,
          size: { sm8: true, xs6: true },
          if: function _if(model, field) {
            return !model[field.name];
          }
        });
        lScheme.push({
          fieldType: 'v-checkbox',
          inputValue: true,
          label: f.label,
          hint: f.hint,
          name: f.name,
          persistentHint: true,
          grow: true,
          size: { sm8: true, xs6: true },
          if: function _if(model, field) {
            return model[field.name];
          }
        });
        lScheme.push({
          fieldType: 'v-btn',
          slot: 'Проверить',
          events: { 'click': function click() {
              cxt.print(null, f.name);
              _this6.model[f.name] = true;
              _this6.model.setCurrentStep(cxt.currentStep);
              cxt.updateData(_this6.model);
            }
          },
          size: { sm4: true, xs6: true },
          shrink: false
        });
      });
      this.props.scheme = lScheme;
      return this;
    }
  }]);

  return PostListSend;
}(__WEBPACK_IMPORTED_MODULE_8__AssistClasses_js__["a" /* default */].Step);

var DocumnentOperations = function (_AssistClasses$Step5) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(DocumnentOperations, _AssistClasses$Step5);

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(DocumnentOperations, null, [{
    key: 'getOperations',
    value: function getOperations() {
      return [{ value: 'DEPO', text: 'Подготовьте общий файл для рассылки' }, { value: 'DOWNLOAD', text: 'Скачать депонированные документы' }, { value: 'OPEN_DOC', text: 'Открыть карточку депонирования документов' }, { value: 'SEND_BY_SERVER', text: 'Разослать документы по электронной почте' }];
    }
  }]);

  function DocumnentOperations(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DocumnentOperations);

    var _this7 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumnentOperations.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DocumnentOperations)).call(this, 'Операции над рвссылкой', function (step) {
      return _this7.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {
      '/email-send/options': 'DEPO_LINK',
      '/email-send/scheduledDate': null,
      '/email-send/scheduledTime': null,
      '/email-send/interval': 10
    }));

    _this7.context = cxt;
    _this7.editable = true;
    _this7.nextLabel = function () {
      return 'Выполнить';
    };
    return _this7;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(DocumnentOperations, [{
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      if (model['depoLink']) {
        return this.context.getDepoUrl(model.depoLink);
      }
      if (model['deedNoContent']) {
        return 'Шаблон не предполагает документов';
      }
      return '';
    }
  }, {
    key: 'fillFields',
    value: function fillFields() {
      var _this8 = this;

      var lScheme = [{
        fieldType: 'v-select-radio',
        name: 'lastOperation',
        itemText: 'text',
        itemValue: 'value',
        items: function items(model) {
          return _this8.getOperations(model);
        },
        size: { sm10: true }
      }, {
        fieldType: 'v-date-field',
        label: 'Начало рассылки',
        hint: 'Укажите начало рассылки',
        name: '/email-send/scheduledDate',
        size: { sm4: true, xs6: true },
        if: function _if(model, field) {
          return model['lastOperation'] === 'SEND_BY_SERVER';
        }
      }, {
        fieldType: 'v-text-field',
        name: '/email-send/scheduledTime',
        placeholder: 'чч:мм',
        mask: '##:##',
        rules: [function (v) {
          return !v || /^(2[0-3]|[01]?[0-9])([0-5]?[0-9])$/.test(v) || 'чч:мм';
        }],
        size: { sm2: true, xs4: true },
        if: function _if(model, field) {
          return model['lastOperation'] === 'SEND_BY_SERVER';
        }
      }, {
        fieldType: 'v-text-field',
        label: 'Интервал, сек',
        name: '/email-send/interval',
        mask: '####',
        rules: [function (v) {
          return !v || v > 0 || 'сек. > 0';
        }],
        size: { sm2: true, xs4: true },
        if: function _if(model, field) {
          return model['lastOperation'] === 'SEND_BY_SERVER';
        }
      }];
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'getOperations',
    value: function getOperations(model) {
      var ops = ['SEND_BY_SERVER', 'DEPO'];
      if (model['depoLink']) {
        ops.push('OPEN_DOC', 'DOWNLOAD');
      }
      return DocumnentOperations.getOperations().filter(function (o) {
        return ops.includes(o.value);
      });
    }
  }, {
    key: 'next',
    value: function next(model, cb) {
      this.execute(model);
      return model;
    }
  }, {
    key: 'execute',
    value: function execute(model) {
      var _this9 = this;

      var operation = model.lastOperation;
      delete model.lastOperation;
      switch (operation) {
        case 'DEPO':
          __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__["a" /* default */].confirm(this.context, 'Подтвердите', 'Сгенерировать новые версии документов и загрузить в депозитарий?', function (self) {
            self.depoDoc('depoLink');
          });
          break;
        case 'OPEN_DOC':
          if (model.depoLink) {
            this.context.openDoc('depoLink');
          } else {
            __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий');
          }
          break;
        case 'DOWNLOAD':
          if (model.depoLink) {
            this.context.openDepo(model.depoLink);
          } else {
            __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий');
          }
          break;
        case 'SEND_BY_SERVER':
          model.currentStep = 6;
          this.context.updateData(model);
          if (this.context.getIsAllow({ SEND_MAIL: null })) {
            var list = model.postList;
            if (list) {
              var items = JSON.parse(list);
              var addresses = [];
              var subjects = [];
              var errors = [];
              __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_entries___default()(items).forEach(function (_ref) {
                var _ref2 = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_slicedToArray___default()(_ref, 2),
                    k = _ref2[0],
                    v = _ref2[1];

                if (v['/email-send/to'] && __WEBPACK_IMPORTED_MODULE_9__api_formats__["a" /* default */].isEmail(v['/email-send/to'])) {
                  addresses.push({ key: k, email: v['/email-send/to'] });
                } else {
                  errors.push({ key: k, err: v['/email-send/to'] });
                }
                if (v['/email-send/subject']) {
                  subjects.push(v['/email-send/subject']);
                }
              });
              if (errors.length === 0) {
                this.context.calcMailbox(model['/email-send/mailbox']).then(function (mailbox) {
                  var scheduled = null;
                  if (model['/email-send/scheduledDate'] || model['/email-send/scheduledTime']) {
                    var scheduledDate = model['/email-send/scheduledDate'] || __WEBPACK_IMPORTED_MODULE_13_moment___default()().format('YYYY-MM-DD');
                    var scheduledTime = model['/email-send/scheduledTime'] || __WEBPACK_IMPORTED_MODULE_13_moment___default()().format('HHmm');
                    scheduled = __WEBPACK_IMPORTED_MODULE_13_moment___default()(scheduledDate + ' ' + scheduledTime, 'YYYY-MM-DD HHmm', false);
                  }
                  if (!scheduled) {
                    scheduled = __WEBPACK_IMPORTED_MODULE_13_moment___default()();
                  }
                  var subjectStr = subjects.length > 0 ? subjects[0] : model['/email-send/subject'];
                  var addressStr = addresses.map(function (i) {
                    return i.key + ': <b>' + i.email + '</b>';
                  }).join(', <br/>');
                  __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__["a" /* default */].confirm(_this9, 'Подтвердите', '\n                    \u0420\u0430\u0437\u043E\u0441\u043B\u0430\u0442\u044C \u043F\u0438\u0441\u044C\u043C\u0430 "' + subjectStr + '" \u0438\u0437 \u043F\u043E\u0447\u0442\u043E\u0432\u043E\u0433\u043E \u044F\u0449\u0438\u043A\u0430: "' + mailbox + '" \u0430\u0434\u0440\u0435\u0441\u0430\u0442\u0430\u043C?\n                    <br/>' + addressStr + '<br/>\u041F\u0438\u0441\u044C\u043C\u0430 \u0440\u0430\u0441\u0441\u044B\u043B\u0430\u044E\u0442\u0441\u044F \u0441 ' + scheduled.format('YYYY-MM-DD HH:mm') + ' \u0438\u043D\u0442\u0435\u0440\u0432\u0430\u043B \u0432 ' + model['/email-send/interval'] + ' \u0441\u0435\u043A\u0443\u043D\u0434.\n                    <br/>\u041A \u043F\u0438\u0441\u044C\u043C\u0430\u043C \u043F\u0440\u0438\u043A\u0440\u0435\u043F\u043B\u044F\u044E\u0442\u0441\u044F \u0430\u043A\u0442\u0443\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u0435\u0440\u0441\u0438\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0438\u0437 \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u0430\u0440\u0438\u044F, \n                    \u0435\u0441\u043B\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0443\u0435\u0442 \u043E\u043D \u0431\u0443\u0434\u0435\u0442 \u0441\u043E\u0437\u0434\u0430\u043D.', function (self) {
                    var request = {
                      id: _this9.context.getMatterId(),
                      mailbox: mailbox,
                      scheduled: scheduled.format(),
                      interval: model['/email-send/interval']
                    };
                    _this9.context.$store.dispatch('sendAssistMatter', request);
                  });
                });
              } else {
                var errorsStr = errors.map(function (i) {
                  return i.key + ': <b>' + (i.err ? i.err : '-') + '</b>';
                }).join(', <br/>');
                __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', '\u041F\u0435\u0440\u0435\u0434 \u043E\u0442\u0441\u044B\u043B\u043A\u043E\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0437\u0430\u0434\u0430\u0442\u044C \u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043B\u044F <b>\u044D\u043B. \u043F\u043E\u0447\u0442\u044B</b> \u0430\u0434\u0440\u0435\u0441\u0430\u0442\u043E\u0432.\n                \u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0439\u0442\u0435 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0434\u0430\u043D\u043D\u044B\u0445 \u0438\u0437 \u0444\u0430\u0439\u043B\u0430 \u0434\u043B\u044F \u0437\u0430\u0434\u0430\u043D\u0438\u044F \u0430\u0434\u0440\u0435\u0441\u0430 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B. <br/>\u041E\u0448\u0438\u0431\u043E\u0447\u043D\u044B\u0435 \u0430\u0434\u0440\u0435\u0441\u0430:<br/>' + errorsStr + '.');
              }
            }
          } else {
            __WEBPACK_IMPORTED_MODULE_10__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Вы не можете посылать письма, сначала включите функцию рассылки для компании');
          }
          break;
      }
    }
  }]);

  return DocumnentOperations;
}(__WEBPACK_IMPORTED_MODULE_8__AssistClasses_js__["a" /* default */].Step);

var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'POST';
    }
  }, {
    key: 'next',
    value: function next(model, step) {
      var _this11 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        currentStep = currentStep <= _this11.steps.length ? currentStep + 1 : _this11.steps.length + 1;
        model.setCurrentStep(currentStep);
        _this11.context.updateData(model);
        return model;
      };
      return step && step.next ? step.next(model, cb) : model;
    }
  }, {
    key: 'getCurrentStep',
    value: function getCurrentStep(model) {
      return this.steps.find(function (step) {
        return step.number === model.getCurrentStep();
      });
    }
  }, {
    key: 'back',
    value: function back(model, step) {
      var _this12 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        if (currentStep > 1) {
          currentStep = currentStep - 1;
          model.setCurrentStep(currentStep);
          _this12.context.updateData(model);
        } else {
          _this12.context.refreshData();
        }
        return model;
      };
      return step && step.back ? step.back(model, cb) : model;
    }
  }, {
    key: 'complete',
    value: function complete(model, step) {
      return step && model && model.getCurrentStep() > step.number;
    }
  }, {
    key: 'editable',
    value: function editable(model, step) {
      return step.editable || model && model.getCurrentStep() === step.number;
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var steps = [];
      var cxt = this.context;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new DocumnentSelectType(cxt), { backLabel: function backLabel() {
          return 'Отмена';
        } }).addToArray(steps);

      if (scheme && scheme.steps && scheme.steps.length > 0 && scheme.steps[0].fields.length > 0) {
        new ChildrenSelect(cxt).fillChildren(scheme.steps[0].fields).addToArray(steps);
      }

      if (scheme && scheme.steps && scheme.steps.length > 1) {
        new __WEBPACK_IMPORTED_MODULE_11__StepSetParameters_js__["a" /* default */].Step(cxt).fillFields(scheme.steps[1].fields).addToArray(steps);

        new PostSelectType(cxt).fillFields(scheme.steps[1].fields).addToArray(steps);

        new __WEBPACK_IMPORTED_MODULE_12__StepPostList_js__["a" /* default */].Step(cxt).fillFields(scheme.steps[1].fields).addToArray(steps);

        if (scheme.steps.length > 2) {
          new PostListSend(cxt).fillFields(scheme.steps[2].fields).addToArray(steps);
        }

        // if (scheme.steps.length > 2) {
        //   new DocumnentCheck(cxt)
        //   .addToArray(steps)
        // }

        if (scheme.steps.length > 2) {
          new DocumnentOperations(cxt).fillFields().addToArray(steps);
        }
      }

      this.steps = steps;
      return this;
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      if (this.context) {
        model['companyInn'] = this.context.profile.clientInn;
      }
      this.steps.forEach(function (step) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(model, step.model);
      });
      return model;
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_8__AssistClasses_js__["a" /* default */].Strategy);

function createStrategy(cxt) {
  return new Strategy(cxt);
}

var Model = function (_AssistClasses$Model) {
  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_inherits___default()(Model, _AssistClasses$Model);

  function Model() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Model);

    // this.companyInn = null
    var _this13 = __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Model.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Model)).call(this));

    _this13.deedNumber = null;
    _this13.deedNoContent = false;
    return _this13;
  }

  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_createClass___default()(Model, [{
    key: 'copy',
    value: function copy() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Model(), this);
    }
  }]);

  return Model;
}(__WEBPACK_IMPORTED_MODULE_8__AssistClasses_js__["a" /* default */].Model);

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__client__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__store__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AssistCSVLoader_vue__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__AssistCSVLoader_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__AssistCSVLoader_vue__);


















var Step = function (_AssistClasses$Step) {
  __WEBPACK_IMPORTED_MODULE_10_babel_runtime_helpers_inherits___default()(Step, _AssistClasses$Step);

  function Step(cxt) {
    __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_classCallCheck___default()(this, Step);

    var _this = __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Step.__proto__ || __WEBPACK_IMPORTED_MODULE_6_babel_runtime_core_js_object_get_prototype_of___default()(Step)).call(this, 'Сформируйте рассылку', function (step) {
      return step.model['postListDESCRIPTION'];
    }, {
      scheme: []
    }, {
      postList: null,
      postList_CODE: null
    }));
    // const ruleInns = v => !v || formats.isInns(v) || 'Введите правильные ИННы или Выберите компании из списка'


    _this.context = cxt;
    _this.editable = true;
    _this.items = [];
    _this.fields = null;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_createClass___default()(Step, [{
    key: 'fillFields',
    value: function fillFields(fields) {
      var _this2 = this;

      // console.log('fillFields', fields)
      this.fields = fields;
      var lScheme = [];
      var cxt = this.context;
      lScheme.push({
        fieldType: 'v-chips-field',
        label: 'Список рассылки ',
        name: 'postList_CODE',
        events: {
          'change': function change() {
            return _this2.onPostListChange();
          },
          'remove': function remove(key) {
            return _this2.onPostListRemove(key);
          }
        },
        chipSize: 10,
        items: function items(model, field) {
          // console.log('onPostListChange', this.items)
          return _this2.items;
        },
        size: { sm8: true, xs12: true },
        if: function _if(model, field) {
          return model['postTypeCode'] === 'FAVORITES';
        }
      });
      lScheme.push({
        fieldType: 'v-btn',
        slot: 'Выбрать',
        events: { 'click': function click() {
            return _this2.selectCompanies('postList');
          } },
        size: { sm4: true, xs12: true },
        shrink: false,
        if: function _if(model, field) {
          return model['postTypeCode'] === 'FAVORITES';
        }
      });
      lScheme.push({
        fieldType: 'v-flex',
        slot: '\u041F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u044B \u0434\u043B\u044F \u0444\u043E\u0440\u043C\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438 \u043C\u043E\u0436\u043D\u043E \u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0437 csv \u0444\u0430\u0439\u043B\u0430. \u0423\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0435 \u043F\u043E\u043B\u0435  \u0438 \u043F\u0443\u0441\u0442\u044B\u0435 \u043F\u043E\u043B\u044F \u0431\u0443\u0434\u0443\u0442 \u0437\u0430\u043F\u043E\u043B\u043D\u0435\u043D\u044B \u0438\u0437 \u0444\u0430\u0439\u043B\u0430',
        shrink: false,
        size: { sm8: true, xs12: true },
        if: function _if(model, field) {
          return model['postTypeCode'] === 'CSV';
        }
      });
      lScheme.push({
        fieldType: 'v-chips-field',
        label: 'Рассылка ',
        name: 'postList_CODE',
        events: {
          'change': function change() {
            return _this2.onPostListChange();
          },
          'remove': function remove(key) {
            return _this2.onPostListRemove(key);
          }
        },
        chipSize: 10,
        items: function items(model, field) {
          // console.log('onPostListChange', this.items)
          return _this2.items;
        },
        size: { sm8: true, xs12: true },
        if: function _if(model, field) {
          return model['postTypeCode'] === 'CSV';
        }
      });
      lScheme.push({
        fieldType: 'v-btn',
        slot: 'Загрузить',
        events: { 'click': function click() {
            return _this2.loadFromFile('postList');
          } },
        size: { sm4: true, xs12: true },
        shrink: false,
        if: function _if(model, field) {
          return model['postTypeCode'] === 'CSV';
        }
      });
      lScheme.push({
        fieldType: 'v-text-field',
        label: 'Введите инн',
        hint: 'Выберите компанию для получения списка участников ',
        name: 'postList',
        size: { sm6: true, xs6: true },
        if: function _if(model, field) {
          return model['postTypeCode'] === 'HOLDERS';
        }
      });
      lScheme.push({
        fieldType: 'v-btn',
        slot: 'Выбрать',
        events: { 'click': function click() {
            return cxt.selectCompany('postList');
          } },
        disabled: false,
        size: { sm4: true, xs4: true },
        shrink: false,
        if: function _if(model, field) {
          return model['postTypeCode'] === 'HOLDERS';
        }
      });
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'syncPostList',
    value: function syncPostList(inns, json) {
      var result = {};
      var values = void 0;
      try {
        values = JSON.parse(json);
      } catch (e) {}
      if (values) {
        inns.forEach(function (inn) {
          result[inn] = values[inn];
        });
      }
      return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(result);
    }
  }, {
    key: 'getFileListType',
    value: function getFileListType(fileName) {
      var field = this.model && this.model[fileName] && this.fields[this.model[fileName]];
      return field && field.type || null;
    }
  }, {
    key: 'onPostListChange',
    value: function onPostListChange() {
      var _this3 = this;

      var getHint = function getHint(company) {
        return company.name + ' (\u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_12__api_formats__["a" /* default */].formatInn(company.inn) + ')';
      };
      var getError = function getError(company) {
        return null;
      };
      var cb = function cb(companies) {
        var set = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(inns);
        var items = companies.map(function (c) {
          set.delete(c.ref);
          return { value: c.ref, text: c.caption, hint: getHint(c), error: getError(c) };
        });
        set.forEach(function (inn) {
          return items.push({ value: inn, text: inn, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null });
        });
        _this3.items = items.sort(function (a, b) {
          return __WEBPACK_IMPORTED_MODULE_12__api_formats__["a" /* default */].compareString(a.text, b.text);
        });
      };
      var fieldName = 'postList';
      var inns = this.model[fieldName + '_CODE'] ? this.model[fieldName + '_CODE'].split(', ') : [];
      this.model[fieldName] = this.syncPostList(inns, this.model[fieldName]);
      if (this.getFileListType(fieldName + 'Field') === 'company') {
        __WEBPACK_IMPORTED_MODULE_13__client__["a" /* default */].getCachedRefs(inns, cb);
      } else {
        this.items = inns.map(function (inn) {
          return { value: inn, text: inn, hint: '', error: null };
        }).sort(function (a, b) {
          return __WEBPACK_IMPORTED_MODULE_12__api_formats__["a" /* default */].compareString(a.text, b.text);
        });
      }
    }
  }, {
    key: 'onPostListRemove',
    value: function onPostListRemove(key) {
      var fieldName = 'postList';
      var inns = this.model[fieldName + '_CODE'] ? this.model[fieldName + '_CODE'].split(', ') : [];
      inns = inns.filter(function (inn) {
        return inn !== key;
      });
      this.model[fieldName + '_CODE'] = inns.join(', ');
    }
  }, {
    key: 'mergePostList',
    value: function mergePostList(fieldName, model, references) {
      var set = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a(__WEBPACK_IMPORTED_MODULE_12__api_formats__["a" /* default */].splitRefCodes(model[fieldName + '_CODE']));
      var node = model[fieldName] ? JSON.parse(model[fieldName]) : {};
      var postListField = model['postListField'] ? model['postListField'] : fieldName;
      references.forEach(function (r) {
        set.add(r.ref);
        var item = {};
        item[postListField] = r.inn;
        item[postListField + '_CODE'] = r.ref;
        node[r.ref] = item;
      });
      model[fieldName] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(node);
      model[fieldName + '_CODE'] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(set).sort(function (a, b) {
        return a - b;
      }).join(', ');
      // console.log('mergePostList', fieldName, model)
      return model;
    }
  }, {
    key: 'selectCompanies',
    value: function selectCompanies(fieldName) {
      var _this4 = this;

      var setReferences = function setReferences(references) {
        if (Array.isArray(references) && references.length > 0) {
          // console.log('selectCompanies', references)
          var model = _this4.model;
          _this4.mergePostList(fieldName, _this4.model, references);
          model.setCurrentStep(_this4.context.currentStep);
        }
      };
      var setRefCodes = function setRefCodes(refcodes) {
        if (Array.isArray(refcodes) && refcodes.length > 0) {
          __WEBPACK_IMPORTED_MODULE_13__client__["a" /* default */].getCachedRefs(refcodes, setReferences);
        }
      };
      var getQuery = function getQuery() {};
      __WEBPACK_IMPORTED_MODULE_13__client__["a" /* default */].selectRef(this.context, setRefCodes, getQuery, true, false);
    }
  }, {
    key: 'transformValuesToRefCode',
    value: function transformValuesToRefCode(fields, values, postListField) {
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        if (!(fields && fields.length > 1 && values && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(values).length > 1)) {
          reject();
        }
        var vf = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(values)[0]);
        var cf = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();
        var inns = new __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_set___default.a();
        fields.forEach(function (f) {
          if (f.type === 'company' && vf.includes(f.name)) {
            cf.add(f.name);
          }
        });
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(values).forEach(function (v) {
          cf.forEach(function (f) {
            if (v[f]) {
              inns.add(v[f]);
            }
          });
        });
        __WEBPACK_IMPORTED_MODULE_13__client__["a" /* default */].convertInnToRefCode(inns).then(function (map) {
          var result = {};
          __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_values___default()(values).forEach(function (v) {
            cf.forEach(function (f) {
              v[f + '_CODE'] = map[v[f]];
            });
            if (v[postListField + '_CODE']) {
              result[v[postListField + '_CODE']] = v;
            } else {
              result[v[postListField]] = v;
            }
          });
          resolve(result);
        });
      });
    }
  }, {
    key: 'loadFromFile',
    value: function loadFromFile(fieldName) {
      var _this5 = this;

      var postListField = this.model['postListField'];
      this.loadForm(this.fields, this.model, postListField).then(function (values) {
        return _this5.transformValuesToRefCode(_this5.fields, values, postListField);
      }).then(function (values) {
        if (values && __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(values).length > 0) {
          var model = _this5.model;
          var set = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(values);
          model[fieldName] = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_json_stringify___default()(values);
          model[fieldName + '_CODE'] = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_array_from___default()(set).sort(function (a, b) {
            return a - b;
          }).join(', ');
          model.setCurrentStep(_this5.context.currentStep);
        }
      });
    }
  }, {
    key: 'loadForm',
    value: function loadForm(fields, model, postListField) {
      var fullname = function fullname(f) {
        return f ? '' + (f.target ? '/' + f.target + '/' : '') + f.name : '';
      };
      var types = { company: 'COMPANY', date: 'DATE', text: 'TEXT', textarea: 'TEXT', macro: 'MACRO' };
      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        __WEBPACK_IMPORTED_MODULE_15__common_dialogs__["a" /* default */].register('v-assist-csv-loader', __WEBPACK_IMPORTED_MODULE_16__AssistCSVLoader_vue___default.a);
        var listFields = [];
        var i = 0;
        fields.forEach(function (f) {
          if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_keys___default()(types).includes(f.type)) {
            var needAdd = false;
            if (f.type === 'macro') {
              var div = document.createElement('div');
              div.innerHTML = model[fullname(f)];
              needAdd = div.innerText.length === 0;
            }
            if (fullname(f) === postListField || !model[fullname(f)] || needAdd) {
              listFields.push({ name: fullname(f), label: f.label, number: i++, type: types[f.type], key: fullname(f) === postListField });
            }
          }
        });
        console.log('loadForm', listFields);
        var fullscreen = __WEBPACK_IMPORTED_MODULE_14__store__["a" /* default */].getters.getIsMobile;
        var comp = { template: '\n        <v-assist-csv-loader\n        v-on:close="$emit(\'close\')"\n        v-on:change="onChange"\n        :fields="fields"\n        :keyField="keyField"\n        :fullscreen="fullscreen"></v-assist-csv-loader>\n        ',
          data: function data() {
            return {
              fullscreen: fullscreen,
              onChange: function onChange(data) {
                return resolve(data);
              },
              fields: listFields,
              keyField: postListField
            };
          }
        };
        __WEBPACK_IMPORTED_MODULE_15__common_dialogs__["a" /* default */].modal(comp);
      });
    }
  }]);

  return Step;
}(__WEBPACK_IMPORTED_MODULE_11__AssistClasses_js__["a" /* default */].Step);

/* harmony default export */ __webpack_exports__["a"] = ({
  Step: Step
});

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(961),
  /* template */
  __webpack_require__(962),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_files__ = __webpack_require__(123);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BtnForm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assist-csv-loader',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default.a },
  data: function data() {
    return {
      files: [],
      dateFormat: 'DD.MM.YYYY',
      delimiter: ',',
      textData: null,
      arrData: null
    };
  },
  watch: {
    textData: function textData(newVal, oldVal) {
      this.updateArrData();
    }
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    fields: {
      type: Array,
      default: []
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    calcDialogScroll: 'calcDialogScroll'
  }), {
    title: function title() {
      return 'Загрузите данные рассылки';
    },
    exsistDate: function exsistDate() {
      return this.fields.find(function (f) {
        return f.type === 'DATE';
      });
    }
  }),
  methods: {
    errorFileMessage: function errorFileMessage(file) {
      return __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].errorFileMessage(file);
    },
    getAcceptedFileFormat: function getAcceptedFileFormat() {
      return '.csv, .xlsx';
    },
    pickFile: function pickFile() {
      this.$refs.image.click();
    },
    onFilePicked: function onFilePicked(e) {
      var _this = this;

      var fs = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_array_from___default()(e.target.files);
      if (fs.length > 0) {
        fs.forEach(function (f) {
          return __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].readFileAsByteArray(f, function (bytes) {
            _this.addFile(f, bytes);
          });
        });
      }
    },
    addFile: function addFile(f, data) {
      var _this2 = this;

      var cb = function cb(bytes) {
        f.remove = function (e) {
          return !e && _this2.deleteFile(f);
        };
        _this2.files = [f];
        _this2.textData = bytes;
      };
      var cbErr = function cbErr(e) {
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при экспорте данных из файла ' });
      };
      __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].convertToCsv(f, data, cb, cbErr);
    },
    deleteFile: function deleteFile(file) {
      this.files = this.files.filter(function (f) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(f.name, file.name) !== 0;
      });
    },
    getNewFields: function getNewFields() {
      var result = [{ value: null, text: '(не задано)' }];
      if (this.arrData && this.arrData[0]) {
        this.arrData[0].forEach(function (value, key) {
          result.push({ value: key, text: value });
        });
      }
      return result;
    },
    getValue: function getValue(item) {
      return this.arrData && this.arrData[1] ? this.arrData[1][item.number] : '';
    },
    ok: function ok() {
      var _this3 = this;

      var result = __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].import(this.fields, this.arrData, this.dateFormat);
      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0417\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0434\u0430\u043D\u043D\u044B\u0435 \u0434\u043B\u044F \u0440\u0430\u0441\u0441\u044B\u043B\u043A\u0438 (' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(result).length + ')?', function (self) {
        _this3.$emit('change', result);
        _this3.cancel();
      });
    },
    cancel: function cancel() {
      this.$emit('close');
      this.item = null;
    },
    updateArrData: function updateArrData() {
      var arrData = __WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].parseCsv(__WEBPACK_IMPORTED_MODULE_5__api_files__["a" /* default */].decode(this.textData));
      // skip empty lines
      while (arrData.length > 0 && arrData[0].join('').length === 0) {
        arrData.shift();
      }
      this.arrData = arrData;
    }
  }
});

/***/ }),
/* 962 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.arrData || _vm.arrData.length === 0
          },
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_vm._v("\n          Чтобы сформировать рассылку, нужно заполнить не заданные поля значениями для каждого уникального поля. "), _c('br'), _vm._v("\n          Подготовьте файл (xslx, csv), содержащий колонку: "), _c('b', [_vm._v(" уникального поля")]), _vm._v(" и дополнительные колонки.")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": "",
      "sm8": ""
    }
  }, [_vm._l((_vm.files), function(item) {
    return [_c('div', [_c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('div', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-chip', {
      key: item.name,
      attrs: {
        "small": "",
        "text-color": _vm.errorFileMessage(item) ? 'error' : 'black',
        "close": ""
      },
      on: {
        "click": _vm.pickFile,
        "input": item.remove
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(item.name.slice(0, 30)) + "\n              ")])])], 1), _vm._v(" "), _c('span', {
      staticStyle: {
        "overflow-wrap": "break-word"
      }
    }, [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('div', {
      staticClass: "error",
      attrs: {
        "light": ""
      }
    }, [_vm._v(_vm._s(_vm.errorFileMessage(item)))])])], 1)]
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.files.length === 0),
      expression: "files.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": _vm.pickFile
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n            Выберите файл\n            ")])]), _vm._v(" "), _c('input', {
    ref: "image",
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "accept": _vm.getAcceptedFileFormat(),
      "multiple": ""
    },
    on: {
      "change": _vm.onFilePicked
    }
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n        Задайте соответствие полей документа и колонок в загружаемом файле\n      ")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('b', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs3": "",
      "sm3": ""
    }
  }, [_c('span', [_vm._v("Поле")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Название колонки")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs3": "",
      "sm4": "",
      "px-2": ""
    }
  }, [_c('span', [_vm._v("Пример значения")])])], 1)], 1), _vm._v(" "), _vm._l((_vm.fields), function(field) {
    return [_c('v-layout', {
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs3": "",
        "sm3": ""
      }
    }, [_c('span', [_vm._v(_vm._s(field.label) + _vm._s(field.key ? ' (уникальное)' : ''))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs6": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('v-select', {
      attrs: {
        "hide-details": "",
        "items": _vm.getNewFields(),
        "item-value": "value",
        "item-text": "text"
      },
      model: {
        value: (field.number),
        callback: function($$v) {
          _vm.$set(field, "number", $$v)
        },
        expression: "field.number"
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": "",
        "sm4": "",
        "px-2": ""
      }
    }, [_c('span', [_vm._v(_vm._s(_vm.getValue(field)))])])], 1)]
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "py-3": ""
    }
  }, [_vm._v("\n        Данные игнорируются если не удовлетворяют формату.\n        "), (_vm.exsistDate) ? _c('v-flex', {
    attrs: {
      "pl-3": "",
      "xs8": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Формат дат",
      "hint": "Выберите формат для полей даты",
      "persistent-hint": "",
      "items": [{
          value: 'DD.MM.YYYY',
          text: 'дд.мм.гггг'
        },
        {
          value: 'DD.MM.YY',
          text: 'дд.мм.гг'
        },
        {
          value: 'DD/MM/YYYY',
          text: 'дд/мм/гггг'
        },
        {
          value: 'DD/MM/YY',
          text: 'дд/мм/гг'
        },
        {
          value: 'YYYY-MM-DD',
          text: 'гггг-мм-дд'
        }
      ]
    },
    model: {
      value: (_vm.dateFormat),
      callback: function($$v) {
        _vm.dateFormat = $$v
      },
      expression: "dateFormat"
    }
  })], 1) : _vm._e()], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_formats__ = __webpack_require__(5);










var ContractorCheckSelectContractor = function (_AssistClasses$Step) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ContractorCheckSelectContractor, _AssistClasses$Step);

  function ContractorCheckSelectContractor(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ContractorCheckSelectContractor);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContractorCheckSelectContractor.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ContractorCheckSelectContractor)).call(this, 'Выберите контрагента', function (step) {
      return step.formatField('contractorInn' + 'DESCRIPTION') + ' \u0418\u043D\u043D: ' + step.formatField('contractorInn');
    }, {
      scheme: [{
        fieldType: 'v-text-field',
        label: 'Инн контрагента',
        name: 'contractorInn',
        persistentHint: true,
        hint: function hint(model, field) {
          var result = model[field.name + 'DESCRIPTION'];
          if (result) {
            return result;
          }
          return 'Введите ИНН или выберите контрагента';
        },
        grow: true,
        size: { sm8: true, xs6: true }
      }, {
        fieldType: 'v-btn',
        slot: 'Выбрать',
        events: { 'click': function click() {
            return cxt.selectCompany('contractorInn');
          } },
        shrink: true,
        size: { sm4: true, xs6: true }
      }]
    }, {
      contractorInn: null
    }));

    _this.context = cxt;
    _this.editable = true;
    _this.nextEnabled = function () {
      return _this.model['contractorInn'];
    };
    return _this;
  }

  return ContractorCheckSelectContractor;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var ContractorCheckLoadDocuments = function (_AssistClasses$Step2) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ContractorCheckLoadDocuments, _AssistClasses$Step2);

  function ContractorCheckLoadDocuments(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ContractorCheckLoadDocuments);

    var _this2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContractorCheckLoadDocuments.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ContractorCheckLoadDocuments)).call(this, 'Загрузите в депозитарий документы, полученные от контрагента или выберите из депозитария', null, {
      scheme: []
    }, {
      fileList: null
    }));

    _this2.context = cxt;
    _this2.editable = true;
    _this2.items = [];
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContractorCheckLoadDocuments, [{
    key: 'fillFields',
    value: function fillFields() {
      var _this3 = this;

      var lScheme = [];
      var cxt = this.context;
      lScheme.push({
        fieldType: 'v-chips-field',
        label: 'Список документов ',
        name: 'fileList',
        events: {
          'change': function change() {
            return _this3.onListChange();
          },
          'remove': function remove(key) {
            return _this3.onRemove('fileList', key);
          }
        },
        chipSize: 10,
        items: function items(model, field) {
          return _this3.items;
        },
        size: { sm12: true, xs12: true }
      });
      lScheme.push({
        fieldType: 'v-btn',
        slot: 'Загрузить',
        events: { 'click': function click() {
            return cxt.loadDocs('fileList', 'depoFolder');
          } },
        size: { sm4: true, xs6: true },
        shrink: false
      });
      lScheme.push({
        fieldType: 'v-btn',
        slot: 'Выбрать',
        events: { 'click': function click() {
            return cxt.attachDocs('fileList', { path: _this3.model['depoFolder'].toString(), inns: [_this3.model['contractorInn_CODE'].toString()] });
          } },
        size: { sm4: true, xs6: true },
        shrink: false
      });
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'onListChange',
    value: function onListChange() {
      var _this4 = this;

      var getHint = function getHint(file) {
        return file.docName + ' (UID: ' + file.uid + ')';
      };
      var getError = function getError(files) {
        return null;
      };
      var cb = function cb(files) {
        var set = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(uids);
        var items = files.map(function (c) {
          set.delete(c.uid.toString());
          return { value: c.uid.toString(), text: c.docName, hint: getHint(c), error: getError(c) };
        });
        _this4.items = items.sort(function (a, b) {
          return __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].compareString(a.text, b.text);
        });
      };
      var uids = __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].splitDepoUids(this.model['fileList']);
      this.context.getDepoFileProps(uids, cb);
    }
  }, {
    key: 'onRemove',
    value: function onRemove(fieldname, key) {
      var uids = __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].splitDepoUids(this.model[fieldname]);
      uids = uids.filter(function (uid) {
        return uid !== key;
      });
      this.model[fieldname] = uids.join(', ');
    }
  }]);

  return ContractorCheckLoadDocuments;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var ContractorCheckAttachDocuments = function (_AssistClasses$Step3) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ContractorCheckAttachDocuments, _AssistClasses$Step3);

  function ContractorCheckAttachDocuments(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ContractorCheckAttachDocuments);

    var _this5 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContractorCheckAttachDocuments.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ContractorCheckAttachDocuments)).call(this, 'Проверьте автоматическую классифиакцию документов', function (step) {
      return _this5.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {}));

    _this5.context = cxt;
    _this5.editable = true;
    _this5.items = [];
    return _this5;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContractorCheckAttachDocuments, [{
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      var _this6 = this;

      this.onListChange();
      var result = [];
      fields.forEach(function (f) {
        if (/depo/i.test(f.defValue)) {
          var _uids = model[f.name];
          __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].splitDepoUids(_uids).forEach(function (uid) {
            return result.push('<a href="' + _this6.context.getDepoUrl(uid).concat('/stream') + '" target="_blank">\u041E\u0442\u043A\u0440\u044B\u0442\u044C ' + f.label + '</a>');
          });
        }
      });
      return result.join('<br/>');
    }
  }, {
    key: 'fillFields',
    value: function fillFields(fields) {
      var _this7 = this;

      if (!fields) {
        this.props.scheme = [];
        return this;
      }
      var persistentHint = true;
      var lScheme = [];
      var model = {};
      var cxt = this.context;
      fields.forEach(function (f) {
        if (/depo/i.test(f.value)) {
          model[f.name + 'Uid'] = null;
          switch (f.type) {
            case 'text':
              lScheme.push({
                fieldType: 'v-chips-field',
                emptyChip: 'Добавить',
                label: f.label,
                name: f.name + 'Uid',
                defValue: f.value,
                events: {
                  'click': function click() {
                    return cxt.selectDocs(f.name + 'Uid', _this7.items, f.label);
                  },
                  'remove': function remove(key) {
                    return _this7.onRemove(f.name + 'Uid', key);
                  }
                },
                chipSize: 30,
                items: function items(model, field) {
                  var uids = model[f.name + 'Uid'] || '';
                  // console.log('items', uids)
                  return _this7.items.filter(function (item) {
                    return uids.includes(item.value);
                  });
                },
                size: { sm12: true, xs12: true }
              });
              break;
            case 'textarea':
              lScheme.push({
                fieldType: 'v-textarea',
                label: f.label,
                hint: f.hint,
                persistentHint: persistentHint,
                name: f.name,
                rows: f.rows > 0 ? f.rows : 1,
                size: { sm12: true, xs12: true }
              });
              break;
          }
        }
      });
      this.props.scheme = lScheme;
      this.setModel(model);
      return this;
    }
  }, {
    key: 'onListChange',
    value: function onListChange() {
      var _this8 = this;

      var getHint = function getHint(file) {
        return file.docName + ' (UID: ' + file.uid + ')';
      };
      var getError = function getError(files) {
        return null;
      };
      var cb = function cb(files) {
        var set = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(uids);
        var items = files.map(function (c) {
          set.delete(c.uid.toString());
          return { value: c.uid.toString(), text: c.docName, hint: getHint(c), error: getError(c) };
        });
        _this8.items = items.sort(function (a, b) {
          return __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].compareString(a.text, b.text);
        });
      };
      var uids = __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].splitDepoUids(this.model['fileList']);
      this.context.getDepoFileProps(uids, cb);
    }
  }, {
    key: 'onRemove',
    value: function onRemove(fieldname, key) {
      var uids = __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].splitDepoUids(this.model[fieldname]);
      uids = uids.filter(function (uid) {
        return uid !== key;
      });
      this.model[fieldname] = uids.join(', ');
    }
  }]);

  return ContractorCheckAttachDocuments;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var ContractorCheckConfirmation = function (_AssistClasses$Step4) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ContractorCheckConfirmation, _AssistClasses$Step4);

  function ContractorCheckConfirmation(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ContractorCheckConfirmation);

    var _this9 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ContractorCheckConfirmation.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ContractorCheckConfirmation)).call(this, 'Сделайте заключение', function (step) {
      return _this9.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {}));

    _this9.context = cxt;
    _this9.editable = true;
    return _this9;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ContractorCheckConfirmation, [{
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      return model['zakluchenieOProverke'];
    }
  }, {
    key: 'fillFields',
    value: function fillFields(fields) {
      if (!fields) {
        this.props.scheme = [];
        return this;
      }
      var persistentHint = true;
      var lScheme = [];
      fields.forEach(function (f) {
        if (/depo/i.test(f.value) === false) {
          switch (f.type) {
            case 'text':
            case 'textarea':
              lScheme.push({
                fieldType: 'v-textarea',
                label: f.label,
                hint: f.hint,
                persistentHint: persistentHint,
                name: f.name,
                rows: f.rows > 0 ? f.rows : 1,
                size: { sm12: true, xs12: true }
              });
              break;
          }
        }
      });
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'next',
    value: function next(model, cb) {
      delete model.depoLink;
      return cb(model);
    }
  }]);

  return ContractorCheckConfirmation;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var DocumnentCheck = function (_AssistClasses$Step5) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DocumnentCheck, _AssistClasses$Step5);

  function DocumnentCheck(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DocumnentCheck);

    var _this10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumnentCheck.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DocumnentCheck)).call(this, 'Для завершения проверки поместите результат в депозитарий', function (step) {
      return _this10.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: [{
        fieldType: 'v-flex',
        slot: 'Документ будет создан и помещен в депозитарий',
        shrink: false,
        size: { sm6: true, xs6: true },
        if: function _if(model, field) {
          return model['depoLinkAction'] == null && model['depoLink'] == null;
        }
      }, {
        fieldType: 'v-btn',
        slot: 'Подготовить',
        events: { 'click': function click() {
            return cxt.depoDoc('depoLink');
          } },
        shrink: false,
        size: { sm4: true, xs6: true },
        if: function _if(model, field) {
          return model['depoLinkAction'] == null && model['depoLink'] == null;
        }
      }, {
        fieldType: 'v-flex',
        slot: 'Подготовка документа еще не завершена!',
        shrink: false,
        size: { sm8: true, xs6: true },
        if: function _if(model, field) {
          return model['depoLinkAction'];
        }
      }, {
        fieldType: 'v-btn',
        slot: 'Обновить',
        events: { 'click': function click() {
            return cxt.refreshData();
          } },
        shrink: false,
        size: { sm4: true, xs6: true },
        if: function _if(model, field) {
          return model['depoLinkAction'];
        }
      }, {
        fieldType: 'v-flex',
        slot: 'Теперь Вы можете открыть документ в депозитарии и при необходимости изменить его',
        shrink: false,
        size: { sm8: true, xs6: true },
        if: function _if(model, field) {
          return !model['depoLinkAction'] && model['depoLink'] && __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isDepoUid(model['depoLink']);
        }
      }, {
        fieldType: 'v-btn',
        slot: 'Открыть',
        events: { 'click': function click() {
            return cxt.openDoc('depoLink');
          } },
        size: { sm4: true, xs6: true },
        if: function _if(model, field) {
          return !model['depoLinkAction'] && model['depoLink'] && __WEBPACK_IMPORTED_MODULE_8__api_formats__["a" /* default */].isDepoUid(model['depoLink']);
        }
      }, {
        fieldType: 'v-flex',
        slot: 'Вы можете подготовить новую версию документа и поместить в депозитарий. ' + 'Важно! Если Вы уже отправляли ссылки на документ, то адресаты будут видеть старую и новую версии',
        shrink: false,
        size: { sm8: true, xs6: true },
        if: function _if(model, field) {
          return model['depoLink'] != null;
        }
      }, {
        fieldType: 'v-btn',
        slot: 'Новая версия',
        events: { 'click': function click() {
            return cxt.depoDoc('depoLink');
          } },
        shrink: false,
        size: { sm4: true, xs6: true },
        if: function _if(model, field) {
          return model['depoLink'] != null;
        }
      }]
    }, {
      depoLink: null
    }));

    _this10.context = cxt;
    _this10.nextEnabled = function () {
      return _this10.model.depoLink;
    };
    return _this10;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DocumnentCheck, [{
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      return model.depoLink ? '<a href="' + this.context.getDepoUrl(model.depoLink).concat('/stream') + '" target="_blank">\u041E\u0442\u043A\u0440\u044B\u0442\u044C</a>' : '';
    }
  }]);

  return DocumnentCheck;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var Strategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Strategy, _AssistClasses$Strate);

  function Strategy() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Strategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Strategy.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Strategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Strategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'CONTRACTOR_CHECK';
    }
  }, {
    key: 'next',
    value: function next(model, step) {
      var _this12 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        currentStep = currentStep <= _this12.steps.length ? currentStep + 1 : _this12.steps.length + 1;
        model.setCurrentStep(currentStep);
        _this12.context.updateData(model);
        return model;
      };
      return step && step.next ? step.next(model, cb) : model;
    }
  }, {
    key: 'getCurrentStep',
    value: function getCurrentStep(model) {
      return this.steps.find(function (step) {
        return step.number === model.getCurrentStep();
      });
    }
  }, {
    key: 'back',
    value: function back(model, step) {
      var _this13 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        if (currentStep > 1) {
          currentStep = currentStep - 1;
          model.setCurrentStep(currentStep);
          _this13.context.updateData(model);
        } else {
          _this13.context.refreshData();
        }
        return model;
      };
      return step && step.back ? step.back(model, cb) : model;
    }
  }, {
    key: 'complete',
    value: function complete(model, step) {
      return step && model && model.getCurrentStep() > step.number;
    }
  }, {
    key: 'editable',
    value: function editable(model, step) {
      return step.editable || model && model.getCurrentStep() === step.number;
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var steps = [];
      var cxt = this.context;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new ContractorCheckSelectContractor(cxt), { backLabel: function backLabel() {
          return 'Отмена';
        } }).addToArray(steps);
      new ContractorCheckLoadDocuments(cxt).fillFields().addToArray(steps);
      if (scheme && scheme.steps && scheme.steps.length > 0) {
        new ContractorCheckAttachDocuments(cxt).fillFields(scheme.steps[0].fields).addToArray(steps);
        new ContractorCheckConfirmation(cxt).fillFields(scheme.steps[0].fields).addToArray(steps);
        new DocumnentCheck(cxt).addToArray(steps);
      }

      this.steps = steps;
      return this;
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      // console.log('updateModel', model)
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      if (this.context) {
        model['companyInn'] = this.context.profile.clientInn;
      }
      this.steps.forEach(function (step) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(model, step.model);
      });
      return model;
    }
  }]);

  return Strategy;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Strategy);

function createStrategy(cxt) {
  return new Strategy(cxt);
}

var Model = function (_AssistClasses$Model) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Model, _AssistClasses$Model);

  function Model() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Model);

    // this.companyInn = null
    var _this14 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Model.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Model)).call(this));

    _this14.deedNumber = null;
    _this14.contractorInn = null;
    return _this14;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Model, [{
    key: 'copy',
    value: function copy() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Model(), this);
    }
  }]);

  return Model;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Model);

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 964 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepSetParameters_js__ = __webpack_require__(155);












// import client from '../client'


var DocumnentSelectType = function (_AssistClasses$Step) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DocumnentSelectType, _AssistClasses$Step);

  function DocumnentSelectType(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DocumnentSelectType);

    var _this = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumnentSelectType.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DocumnentSelectType)).call(this, 'Выберите тип подшивки', function (step) {
      return step.model.deedName;
    }, {
      scheme: [{
        fieldType: 'v-text-field',
        label: 'Тип',
        name: 'deedNumber',
        hint: function hint(model, field) {
          return model['deedName'] || 'Введите или выберите код типа документа';
        },
        errors: function errors(model, field) {
          return model['deedNumber'] !== null && model['deedName'] === null && 'Неверный код типа документа' || null;
        },
        events: {
          'input': function input(value) {
            cxt.setDeed('deedNumber', 'deedName', value, 'BINDER:');
          }
        },
        grow: true,
        size: { sm8: true, xs6: true }
      }, {
        fieldType: 'v-btn',
        slot: 'Выбрать',
        events: { 'click': function click() {
            return cxt.selectDeed('deedNumber', 'deedName', true);
          } },
        shrink: false,
        size: { sm4: true, xs6: true }
      }, {
        fieldType: 'v-select',
        label: 'Формат документа',
        itemValue: 'value',
        itemText: 'text',
        items: function items(model, field) {
          return cxt.getDeedFormats();
        },
        name: 'deedFormat',
        shrink: false,
        size: { sm8: true, xs12: true }
      }]
    }, {
      deedNumber: null,
      deedName: null,
      deedFormat: 'docx'
    }));

    _this.context = cxt;
    _this.nextEnabled = function () {
      return _this.model['deedName'] !== null;
    };
    _this.editable = true;
    return _this;
  }

  return DocumnentSelectType;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var ChildrenSelect = function (_AssistClasses$Step2) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(ChildrenSelect, _AssistClasses$Step2);

  function ChildrenSelect(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, ChildrenSelect);

    var _this2 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChildrenSelect.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(ChildrenSelect)).call(this, 'Выберите документы для подшивки', function (step) {
      return _this2.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {
      selectedChildren: null
    }));

    _this2.context = cxt;
    _this2.editable = true;
    _this2.childrenItems = [];
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(ChildrenSelect, [{
    key: 'fillChildren',
    value: function fillChildren(items) {
      if (!items) {
        this.props.scheme = [];
        return this;
      }
      this.childrenItems = items;
      var lScheme = [{
        fieldType: 'v-select-check',
        name: 'selectedChildren',
        itemText: 'name',
        itemValue: 'id',
        items: this.childrenItems,
        size: { sm10: true }
      }];
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      return model['selectedChildren'] && '\u0412\u044B\u0431\u0440\u0430\u043D\u043E ' + model['selectedChildren'].split(',').length + ' \u0438\u0437 ' + this.childrenItems.length + ' \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432' || '';
    }
  }]);

  return ChildrenSelect;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var DocumnentOperations = function (_AssistClasses$Step3) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DocumnentOperations, _AssistClasses$Step3);

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DocumnentOperations, null, [{
    key: 'getOperations',
    value: function getOperations() {
      return [{ value: 'DEPO', text: 'Депонировать документ' }, { value: 'DOWNLOAD', text: 'Скачать депонированный документ' }, { value: 'OPEN_DOC', text: 'Открыть карточку депонирования документа' }, { value: 'UPLOAD', text: 'Загрузить исправленную версию документа' }, { value: 'SEND', text: 'Поделиться документом' }, { value: 'SEND_BY_SERVER', text: 'Направить письмо по электронной почте' }, { value: 'NEW', text: 'Создать новый документ по образцу' }, { value: 'OPEN_XML', text: 'Отладка (xml)' }];
    }
  }]);

  function DocumnentOperations(cxt) {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DocumnentOperations);

    var _this3 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumnentOperations.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DocumnentOperations)).call(this, 'Операции над документом', function (step) {
      return _this3.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {
      '/email-send/options': 'DEPO_LINK'
    }));

    _this3.context = cxt;
    _this3.nextLabel = function () {
      return 'Выполнить';
    };
    _this3.editable = true;
    _this3.macros = [];
    console.log('DocumnentOperations.constructor', _this3);
    return _this3;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DocumnentOperations, [{
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      if (model['depoLink']) {
        return this.context.getDepoUrl(model.depoLink);
      }
      if (model['deedNoContent']) {
        return 'Шаблон не предполагает документов';
      }
      return '';
    }
  }, {
    key: 'fillFields',
    value: function fillFields(fields) {
      var _this4 = this;

      var lScheme = [{
        fieldType: 'v-select-radio',
        name: 'lastOperation',
        itemText: 'text',
        itemValue: 'value',
        items: function items(model) {
          return _this4.getOperations(model);
        },
        size: { sm10: true }
      }];
      this.props.scheme = lScheme;
      this.macros = [];
      fields.forEach(function (f) {
        var fullFieldName = !f.target ? '' + f.name : '/' + f.target + '/' + f.name;
        switch (f.type) {
          case 'macro':
            _this4.macros.push({ k: fullFieldName, t: 'text' });
            break;
          case 'html':
            _this4.macros.push({ k: fullFieldName, t: 'html' });
            break;
        }
      });
      return this;
    }
  }, {
    key: 'getOperations',
    value: function getOperations(model) {
      var ops = ['SEND_BY_SERVER', 'DEPO', 'NEW', 'OPEN_XML'];
      if (model['depoLink']) {
        ops.push('OPEN_DOC', 'DOWNLOAD', 'SEND', 'UPLOAD');
      }
      return DocumnentOperations.getOperations().filter(function (o) {
        return ops.includes(o.value);
      });
    }
  }, {
    key: 'next',
    value: function next(model, cb) {
      this.execute(model);
      return model;
    }
  }, {
    key: 'execute',
    value: function execute(model) {
      var _this5 = this;

      var _f = function _f(val, def) {
        if (val == null) {
          return def;
        } else {
          return val;
        }
      };
      var operation = model.lastOperation;
      delete model.lastOperation;
      switch (operation) {
        case 'DEPO':
          __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].confirm(this.context, 'Подтвердите', 'Сгенерировать новые версии документов и загрузить в депозитарий?', function (self) {
            self.depoDoc('depoLink');
          });
          break;
        case 'OPEN_DOC':
          if (model.depoLink) {
            this.context.openDoc('depoLink');
          } else {
            __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий');
          }
          break;
        case 'DOWNLOAD':
          if (model.depoLink) {
            this.context.openDepo(model.depoLink);
          } else {
            __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий');
          }
          break;
        case 'OPEN_XML':
          this.context.preview('xml');
          break;
        case 'UPLOAD':
          var uid = model.depoLink;
          __WEBPACK_IMPORTED_MODULE_10__depo__["a" /* default */].newFile(null, null, uid);
          break;
        case 'SEND':
          if (model.depoLink) {
            __WEBPACK_IMPORTED_MODULE_10__depo__["a" /* default */].sendProps([model.depoLink], model['/email-send/to'], { body: model['/email-send/body'], subject: model['/email-send/subject'] });
          } else {
            __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий');
          }
          break;
        case 'SEND_BY_SERVER':
          model.currentStep = 4;
          this.context.updateData(model);
          if (this.context.getIsAllow({ SEND_MAIL: null })) {
            this.calcMacros(this.macros, model).then(function (obj) {
              var uids = model['deedNoContent'] || model.depoLink === null ? null : [model.depoLink];
              __WEBPACK_IMPORTED_MODULE_9__common_forms_js__["a" /* default */].openEmail({
                uids: uids,
                to: _f(obj['/email-send/to'], model['/email-send/to']),
                subject: _f(obj['/email-send/subject'], model['/email-send/subject']),
                body: _f(obj['/email-send/body'], model['/email-send/body']),
                options: model['/email-send/options'],
                mailbox: model['/email-send/mailbox']
              }).then(function (data) {
                var request = {
                  id: _this5.context.getMatterId(),
                  email: data.email,
                  subject: data.subject,
                  body: data.body,
                  mailbox: data.mailbox,
                  scheduled: data.scheduled,
                  options: data.attach ? null : 'NO_ATTACH'
                };
                _this5.context.$store.dispatch('sendAssistMatter', request);
              });
            });
          } else {
            __WEBPACK_IMPORTED_MODULE_8__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Вы не можете посылать письма, сначала включите функцию рассылки для компании');
          }
          break;
        case 'NEW':
          delete model.depoLink;
          model.currentStep = 2;
          this.context.saveAsNew(model);
          break;
        case 'delete':
          this.context.delete();
      }
    }
  }, {
    key: 'calcMacros',
    value: function calcMacros(macros, model) {
      var _this6 = this;

      var calcMacro = function calcMacro(macro, type) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          if (/xslt:/ig.test(macro)) {
            _this6.context.macro(macro).then(function (html) {
              var result = html;
              if (/text/ig.test(type)) {
                var toDiv = document.createElement('div');
                toDiv.innerHTML = html;
                result = toDiv.innerText;
              }
              resolve(result);
            });
          } else {
            resolve(macro);
          }
        });
      };
      return macros.reduce(function (p, e) {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
          calcMacro(model[e.k], e.t).then(function (data) {
            p.then(function (obj) {
              obj[e.k] = data;
              resolve(obj);
            });
          });
        });
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({}));
    }
  }]);

  return DocumnentOperations;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Step);

var DeedStrategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(DeedStrategy, _AssistClasses$Strate);

  function DeedStrategy() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, DeedStrategy);

    return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DeedStrategy.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(DeedStrategy)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(DeedStrategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'BINDER';
    }
  }, {
    key: 'next',
    value: function next(model, step) {
      var _this8 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        currentStep = currentStep <= _this8.steps.length ? currentStep + 1 : _this8.steps.length + 1;
        model.setCurrentStep(currentStep);
        _this8.context.updateData(model);
        return model;
      };
      return step && step.next ? step.next(model, cb) : model;
    }
  }, {
    key: 'getCurrentStep',
    value: function getCurrentStep(model) {
      return this.steps.find(function (step) {
        return step.number === model.getCurrentStep();
      });
    }
  }, {
    key: 'back',
    value: function back(model, step) {
      var _this9 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        if (currentStep > 1) {
          currentStep = currentStep - 1;
          model.setCurrentStep(currentStep);
          _this9.context.updateData(model);
        } else {
          _this9.context.refreshData();
        }
        return model;
      };
      return step && step.back ? step.back(model, cb) : model;
    }
  }, {
    key: 'complete',
    value: function complete(model, step) {
      return step && model && model.getCurrentStep() > step.number;
    }
  }, {
    key: 'editable',
    value: function editable(model, step) {
      return step.editable || model && model.getCurrentStep() === step.number;
    }
  }, {
    key: 'previewable',
    value: function previewable(model) {
      return model && model.getCurrentStep() > 1;
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var steps = [];
      var cxt = this.context;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new DocumnentSelectType(cxt), { backLabel: function backLabel() {
          return 'Отмена';
        } }).addToArray(steps);

      if (scheme && scheme.steps && scheme.steps.length > 0 && scheme.steps[0].fields.length > 0) {
        new ChildrenSelect(cxt).fillChildren(scheme.steps[0].fields).addToArray(steps);
      }

      if (scheme && scheme.steps && scheme.steps.length > 1) {
        new __WEBPACK_IMPORTED_MODULE_11__StepSetParameters_js__["a" /* default */].Step(cxt).fillFields(scheme.steps[1].fields).addToArray(steps);

        new DocumnentOperations(cxt).fillFields(scheme.steps[1].fields).addToArray(steps);
      }

      this.steps = steps;
      return this;
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      if (this.context) {
        model['companyInn'] = this.context.profile.clientInn;
        model['companyRefCode'] = this.context.profile.clientRefCode;
      }
      this.steps.forEach(function (step) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(model, step.model);
      });
      return model;
    }
  }]);

  return DeedStrategy;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Strategy);

function createStrategy(cxt) {
  return new DeedStrategy(cxt);
}

var Model = function (_AssistClasses$Model) {
  __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Model, _AssistClasses$Model);

  function Model() {
    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_classCallCheck___default()(this, Model);

    var _this10 = __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Model.__proto__ || __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_get_prototype_of___default()(Model)).call(this));

    _this10.deedNumber = null;
    return _this10;
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Model, [{
    key: 'copy',
    value: function copy() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Model(), this);
    }
  }]);

  return Model;
}(__WEBPACK_IMPORTED_MODULE_7__AssistClasses_js__["a" /* default */].Model);

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__ = __webpack_require__(105);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AssistClasses_js__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_dialogs_js__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_forms_js__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__profile_index_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__StepSetParameters_js__ = __webpack_require__(155);

















// import client from '../client'


var DocumnentSelectType = function (_AssistClasses$Step) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(DocumnentSelectType, _AssistClasses$Step);

  function DocumnentSelectType(cxt) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, DocumnentSelectType);

    var _this = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumnentSelectType.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(DocumnentSelectType)).call(this, 'Выберите пакет документов', function (step) {
      return step.model.deedName;
    }, {
      scheme: [{
        fieldType: 'v-text-field',
        label: 'Тип',
        hint: function hint(model, field) {
          return model['deedName'] || 'Введите или выберите код типа документа';
        },
        errors: function errors(model, field) {
          return model['deedNumber'] !== null && model['deedName'] === null && 'Неверный код типа документа' || null;
        },
        name: 'deedNumber',
        events: {
          'input': function input(value) {
            cxt.setDeed('deedNumber', 'deedName', value, 'BINDER:');
          }
        },
        grow: true,
        size: { sm8: true, xs6: true }
      }, {
        fieldType: 'v-btn',
        slot: 'Выбрать',
        events: { 'click': function click() {
            return cxt.selectDeed('deedNumber', 'deedName', true);
          } },
        shrink: false,
        size: { sm4: true, xs6: true }
      }, {
        fieldType: 'v-select',
        label: 'Формат документа',
        itemValue: 'value',
        itemText: 'text',
        items: function items(model, field) {
          return cxt.getDeedFormats();
        },
        name: 'deedFormat',
        shrink: false,
        size: { sm8: true, xs12: true }
      }]
    }, {
      deedNumber: null,
      deedName: null,
      deedFormat: 'docx'
    }));

    _this.context = cxt;
    _this.nextEnabled = function () {
      return _this.model['deedName'] !== null;
    };
    _this.editable = true;
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(DocumnentSelectType, [{
    key: 'next',
    value: function next(model, cb) {
      model.setCurrentStep(1);
      delete model.currentOperation;
      this.context.updateData(model);
      return model;
    }
  }]);

  return DocumnentSelectType;
}(__WEBPACK_IMPORTED_MODULE_10__AssistClasses_js__["a" /* default */].Step);

var ChildrenList = function (_AssistClasses$Step2) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(ChildrenList, _AssistClasses$Step2);

  function ChildrenList(cxt) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ChildrenList);

    var _this2 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChildrenList.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(ChildrenList)).call(this, 'Список документов в пакете', function (step) {
      return _this2.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {
      selectedChildren: null,
      '/email-send/options': 'DEPO_LINK'
    }));

    _this2.context = cxt;
    _this2.editable = true;
    _this2.childrenItems = [];
    _this2.macros = [];
    return _this2;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(ChildrenList, [{
    key: 'fillChildren',
    value: function fillChildren(items) {
      var _this3 = this;

      if (!items) {
        this.props.scheme = [];
        return this;
      }
      this.childrenItems = items;
      var lScheme = [{
        fieldType: 'v-select-check',
        name: 'selectedChildren',
        itemText: 'name',
        itemValue: 'id',
        items: function items(model, field) {
          return _this3.parseChildrenList(model);
        },
        size: { sm10: true }
      }];
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'onActionClick',
    value: function onActionClick(item) {
      __WEBPACK_IMPORTED_MODULE_15__profile_index_js__["a" /* default */].openLogAction(item.id, this.context.getMatterId());
    }
  }, {
    key: 'getSelectedChildren',
    value: function getSelectedChildren(model) {
      if (!model['childrenList']) {
        return [];
      }
      var deedsIds = model.selectedChildren && model['selectedChildren'].split(', ') || [];
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(JSON.parse(model['childrenList'])).filter(function (e) {
        return deedsIds.includes(e.deedId);
      });
    }
  }, {
    key: 'parseChildrenList',
    value: function parseChildrenList(model) {
      var _this4 = this;

      var makeText = function makeText(e) {
        var state = '';
        var text = e.name;
        if (e.uploaded != null && e.logId != null) {
          state = '(начато депонирование)';
        }
        if (e.uploaded != null && e.logId == null && e.uid != null) {
          var url = _this4.context.getDepoUrl(e.uid);
          var file = url + '/stream';
          state = '<a href="' + file + '" target="_blank">(\u0432\u0435\u0440\u0441\u0438\u044F:&nbsp' + __WEBPACK_IMPORTED_MODULE_11__api_formats__["a" /* default */].formatDate(e.uploaded) + ')</a>';
        }
        if (e.uploaded != null && e.logId == null && e.uid == null) {
          state = '(\u043F\u0443\u0441\u0442\u043E: ' + __WEBPACK_IMPORTED_MODULE_11__api_formats__["a" /* default */].formatDate(e.uploaded) + ')';
        }
        if (e.uploaded == null && e.logId == null && e.uid == null) {
          state = e.checked != null ? '(\u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u043E: ' + __WEBPACK_IMPORTED_MODULE_11__api_formats__["a" /* default */].formatDate(e.checked) + ')' : '';
        }
        return text + ' ' + state;
      };
      var result = [];
      try {
        __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(JSON.parse(model['childrenList'])).forEach(function (e) {
          return result.push({ name: makeText(e), id: e.deedId });
        });
      } catch (e) {
        // pass
      }
      this.childrenItems = result;
      return result;
    }
  }, {
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      return model['selectedChildren'] && '\u0412\u044B\u0431\u0440\u0430\u043D\u043E ' + model['selectedChildren'].split(', ').length + ' \u0438\u0437 ' + this.childrenItems.length + ' \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432' || '';
    }
  }]);

  return ChildrenList;
}(__WEBPACK_IMPORTED_MODULE_10__AssistClasses_js__["a" /* default */].Step);

var OperationList = function (_AssistClasses$Step3) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(OperationList, _AssistClasses$Step3);

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(OperationList, null, [{
    key: 'getOperations',
    value: function getOperations() {
      return [
      // {value: 'OPEN', text: 'Открыть последнюю версию документа'},
      { value: 'SEND_BY_SERVER', text: 'Направить письмо и документы по электронной почте' }, { value: 'ADD', text: 'Добавить новые документы в пакет' }, { value: 'ATTACH_DOC', text: 'Прикрепить документы к пакету' }, { value: 'UPDATE', text: 'Изменить данные в документах' }, { value: 'DEPO', text: 'Депонировать документы' }, { value: 'DOWNLOAD', text: 'Скачать депонированные документы' }, { value: 'UPLOAD', text: 'Загрузить исправленную версию документа' }, { value: 'OPEN_DOC', text: 'Открыть карточку депонирования документа' }, { value: 'REMOVE_DOC', text: 'Удалить документы из пакета' }, { value: 'CHANGE_DEED', text: 'Изменить тип пакета' }];
    }
  }]);

  function OperationList(cxt) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, OperationList);

    var _this5 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (OperationList.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(OperationList)).call(this, 'Операции', function (step) {
      return _this5.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {
      selectedChildren: null,
      '/email-send/options': 'DEPO_LINK'
    }));

    _this5.context = cxt;
    _this5.editable = true;
    _this5.childrenItems = [];
    _this5.nextLabel = function () {
      return 'Выполнить';
    };
    _this5.macros = [];
    return _this5;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(OperationList, [{
    key: 'fillChildren',
    value: function fillChildren(items) {
      var _this6 = this;

      if (!items) {
        this.props.scheme = [];
        return this;
      }
      var lScheme = [{
        fieldType: 'v-select-radio',
        name: 'currentOperation',
        itemText: 'text',
        itemValue: 'value',
        items: function items(model) {
          return _this6.getOperationsForSelected(model);
        },
        size: { sm10: true }
      }];
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'getSelectedChildren',
    value: function getSelectedChildren(model) {
      if (!model['childrenList']) {
        return [];
      }
      var deedsIds = model.selectedChildren && model['selectedChildren'].split(', ') || [];
      return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_core_js_object_values___default()(JSON.parse(model['childrenList'])).filter(function (e) {
        return deedsIds.includes(e.deedId);
      });
    }
  }, {
    key: 'getOperationsForSelected',
    value: function getOperationsForSelected(model) {
      var ops = ['ADD', 'ATTACH_DOC'];
      var children = this.getSelectedChildren(model);
      if (children.length > 0) {
        ops.push('DEPO', 'UPDATE', 'DOWNLOAD', 'SEND_BY_SERVER', 'REMOVE_DOC');
      }
      if (children.length === 1) {
        if (children[0] && children[0].uid) {
          ops.push('UPLOAD', 'OPEN_DOC');
        }
      }
      if (children.length === 0) {
        ops.push('CHANGE_DEED');
      }
      return OperationList.getOperations().filter(function (o) {
        return ops.includes(o.value);
      });
    }
  }, {
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      return model['currentOperation'] && '' + this.getOperationsName(model) || 'Начните новую операцию';
    }
  }, {
    key: 'getOperationsName',
    value: function getOperationsName(model) {
      var ops = [model.currentOperation];
      var operations = OperationList.getOperations().filter(function (o) {
        return ops.includes(o.value);
      });
      return operations && operations.length > 0 && operations[0].text || '';
    }
  }, {
    key: 'next',
    value: function next(model, cb) {
      var operation = model.currentOperation;
      if (['ATTACH_DOC', 'DEPO', 'UPLOAD', 'OPEN_DOC', 'DOWNLOAD', 'SEND_BY_SERVER', 'REMOVE_DOC'].includes(operation)) {
        return this.execute(model, cb);
      } else {
        return cb(model);
      }
    }
  }, {
    key: 'execute',
    value: function execute(model, cb) {
      var _this7 = this;

      var _f = function _f(val, def) {
        if (val === null) {
          return def;
        } else {
          return val;
        }
      };
      var operation = model.currentOperation;
      var children = this.getSelectedChildren(model);
      delete model.currentOperation;
      switch (operation) {
        case 'DEPO':
          __WEBPACK_IMPORTED_MODULE_12__common_dialogs_js__["a" /* default */].confirm(this.context, 'Подтвердите', 'Сгенерировать новые версии документов и загрузить в депозитарий?', function (self) {
            model.currentState = 'DEPO';
            cb(model);
          });
          break;
        case 'DOWNLOAD':
          var uids = [];
          children.forEach(function (c) {
            if (c.uid) uids.push(c.uid);
          });
          __WEBPACK_IMPORTED_MODULE_14__depo__["a" /* default */].downloadFiles(uids);
          break;
        case 'ATTACH_DOC':
          var onSelect = function onSelect(values) {
            if (Array.isArray(values)) {
              var set = new __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_set___default.a(values);
              model['selectedChildren'] = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_array_from___default()(set).map(function (uid) {
                return 'DEPO:' + uid;
              }).sort(function (a, b) {
                return a - b;
              }).join(', ');
              model.currentState = 'ATTACH_DOC';
              cb(model);
            }
          };
          __WEBPACK_IMPORTED_MODULE_14__depo__["a" /* default */].selectDoc(this, onSelect, true, { path: this.context.getDepoCurrentPath });
          break;
        case 'REMOVE_DOC':
          __WEBPACK_IMPORTED_MODULE_12__common_dialogs_js__["a" /* default */].confirm(this.context, 'Подтвердите', 'Удалить документы из пакета, документы останутся в депозитарии?', function (self) {
            model.currentState = 'REMOVE_DOC';
            cb(model);
          });
          break;
        case 'OPEN_DOC':
          if (children.length === 1) {
            var child = children[0];
            if (child.uid) {
              var uid = child.uid;
              var onNewVersion = function onNewVersion() {
                __WEBPACK_IMPORTED_MODULE_14__depo__["a" /* default */].newFile(_this7.context.getDepoCurrentPath, null, uid);
              };
              if (uid) {
                if (__WEBPACK_IMPORTED_MODULE_11__api_formats__["a" /* default */].isDepoUid(uid)) {
                  __WEBPACK_IMPORTED_MODULE_14__depo__["a" /* default */].openFile(uid, this.context.getDepoCurrentPath, false, onNewVersion);
                }
              }
            } else {
              __WEBPACK_IMPORTED_MODULE_12__common_dialogs_js__["a" /* default */].message(this.context, 'Совет', 'Сначала загрузите документ в депозитарий');
            }
          }
          break;
        case 'UPLOAD':
          if (children.length === 1) {
            var _child = children[0];
            if (_child.uid) {
              var _uid = _child.uid;
              __WEBPACK_IMPORTED_MODULE_14__depo__["a" /* default */].newFile(null, null, _uid);
            }
          }
          break;
        case 'SEND_BY_SERVER':
          {
            var _uids = [];
            children.forEach(function (c) {
              if (c.uid) _uids.push(c.uid);
            });
            __WEBPACK_IMPORTED_MODULE_12__common_dialogs_js__["a" /* default */].confirm(this.context, 'Подтвердите', 'К письму прикрепляются актуальные версии из депозитария.' + ' Если документ отсутствует он будет создан. Продолжить?', function (self) {
              _this7.context.updateData(model);
              if (_this7.context.getIsAllow({ SEND_MAIL: null })) {
                var macros = [{ k: '/email-send/to', t: 'text' }, { k: '/email-send/body', t: 'html' }, { k: '/email-send/subject', t: 'text' }];
                _this7.calcMacros(macros, model).then(function (obj) {
                  __WEBPACK_IMPORTED_MODULE_13__common_forms_js__["a" /* default */].openEmail({
                    uids: _uids,
                    to: _f(obj['/email-send/to'], model['/email-send/to']),
                    subject: _f(obj['/email-send/subject'], model['/email-send/subject']),
                    body: _f(obj['/email-send/body'], model['/email-send/body']),
                    options: model['/email-send/options'],
                    mailbox: model['/email-send/mailbox']
                  }).then(function (data) {
                    var request = {
                      id: _this7.context.getMatterId(),
                      parts: children.map(function (c) {
                        return c.deedId;
                      }).join(', '),
                      email: data.email,
                      subject: data.subject,
                      body: data.body,
                      mailbox: data.mailbox,
                      scheduled: data.scheduled
                      // console.log('SEND_BY_SERVER', request)
                    };_this7.context.$store.dispatch('sendAssistMatter', request);
                  });
                });
              } else {
                __WEBPACK_IMPORTED_MODULE_12__common_dialogs_js__["a" /* default */].message(_this7.context, 'Совет', 'Вы не можете посылать письма, сначала включите функцию рассылки для компании');
              }
            });
          }
          break;
      }
    }
  }, {
    key: 'calcMacros',
    value: function calcMacros(macros, model) {
      var _this8 = this;

      var calcMacro = function calcMacro(macro, type) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve(macro).then(function () {
          if (/xslt:/ig.test(macro)) {
            return _this8.context.macro(macro);
          }
          return macro;
        }).then(function (html) {
          if (/text/ig.test(type)) {
            var toDiv = document.createElement('div');
            toDiv.innerHTML = html;
            return toDiv.innerText;
          }
          return html;
        });
      };
      return macros.reduce(function (p, e) {
        return p.then(function (obj) {
          return calcMacro(model[e.k], e.t).then(function (data) {
            obj[e.k] = data;
            return obj;
          });
        });
      }, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a.resolve({}));
    }
  }]);

  return OperationList;
}(__WEBPACK_IMPORTED_MODULE_10__AssistClasses_js__["a" /* default */].Step);

var ChildrenSelect = function (_AssistClasses$Step4) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(ChildrenSelect, _AssistClasses$Step4);

  function ChildrenSelect(cxt) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, ChildrenSelect);

    var _this9 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChildrenSelect.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(ChildrenSelect)).call(this, 'Выберите документы для добавления', function (step) {
      return _this9.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: []
    }, {
      selectedChildren: null
    }));

    _this9.context = cxt;
    _this9.editable = true;
    _this9.childrenItems = [];
    return _this9;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(ChildrenSelect, [{
    key: 'fillChildren',
    value: function fillChildren(items) {
      if (!items) {
        this.props.scheme = [];
        return this;
      }
      this.childrenItems = items;
      var lScheme = [{
        fieldType: 'v-select-check',
        name: 'selectedChildren',
        itemText: 'name',
        itemValue: 'id',
        items: this.childrenItems,
        size: { sm10: true }
      }];
      this.props.scheme = lScheme;
      return this;
    }
  }, {
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      return model['selectedChildren'] && '\u0412\u044B\u0431\u0440\u0430\u043D\u043E ' + model['selectedChildren'].split(',').length + ' \u0438\u0437 ' + this.childrenItems.length + ' \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432' || '';
    }
  }]);

  return ChildrenSelect;
}(__WEBPACK_IMPORTED_MODULE_10__AssistClasses_js__["a" /* default */].Step);

var DocumnentCheck = function (_AssistClasses$Step5) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(DocumnentCheck, _AssistClasses$Step5);

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(DocumnentCheck, null, [{
    key: 'getStates',
    value: function getStates() {
      return [{ value: 'CHECKED', text: 'Подготовка завершена' }, { value: 'DEPO', text: 'Поместить в депозитарий' }];
    }
  }]);

  function DocumnentCheck(cxt) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, DocumnentCheck);

    var _this10 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (DocumnentCheck.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(DocumnentCheck)).call(this, 'Подготовьте документы', function (step) {
      return _this10.fillSubTitle(step.model, step.props.scheme);
    }, {
      scheme: [{
        fieldType: 'v-select',
        label: 'Формат документа',
        itemValue: 'value',
        itemText: 'text',
        items: function items(model, field) {
          return cxt.getDeedFormats();
        },
        name: 'deedFormat',
        shrink: false,
        size: { sm8: true, xs12: true }
      }, {
        fieldType: 'v-select-check',
        name: 'currentState',
        itemText: 'text',
        itemValue: 'value',
        items: function items(model, field) {
          return DocumnentCheck.getStates();
        },
        size: { sm10: true }
      }]
    }, {
      depoLink: null
    }));

    _this10.context = cxt;
    _this10.nextEnabled = function () {
      return _this10.model.currentState && _this10.model.currentState.includes('CHECKED');
    };
    return _this10;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(DocumnentCheck, [{
    key: 'fillSubTitle',
    value: function fillSubTitle(model, fields) {
      return model.depoLink ? this.context.getDepoUrl(model.depoLink) : '';
    }
  }, {
    key: 'next',
    value: function next(model, cb) {
      model.setCurrentStep(1);
      delete model.currentOperation;
      this.context.updateData(model);
      return model;
    }
  }]);

  return DocumnentCheck;
}(__WEBPACK_IMPORTED_MODULE_10__AssistClasses_js__["a" /* default */].Step);

var PackageStrategy = function (_AssistClasses$Strate) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(PackageStrategy, _AssistClasses$Strate);

  function PackageStrategy(cxt) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, PackageStrategy);

    var _this11 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (PackageStrategy.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(PackageStrategy)).call(this, cxt));

    _this11.childrenStep = null;
    return _this11;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(PackageStrategy, [{
    key: 'getTypeCode',
    value: function getTypeCode() {
      return 'PACKAGE';
    }
  }, {
    key: 'next',
    value: function next(model, step) {
      var _this12 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        if (currentStep <= _this12.steps.length) {
          currentStep = currentStep + 1;
        } else {
          currentStep = 1;
          delete model.currentOperation;
        }
        console.log('next', currentStep, _this12.steps);
        model.setCurrentStep(currentStep);
        _this12.context.updateData(model);
        return model;
      };
      return step && step.next ? step.next(model, cb) : model;
    }
  }, {
    key: 'getCurrentStep',
    value: function getCurrentStep(model) {
      return this.steps.find(function (step) {
        return step.number === model.getCurrentStep();
      });
    }
  }, {
    key: 'back',
    value: function back(model, step) {
      var _this13 = this;

      var cb = function cb(model) {
        var currentStep = step.number;
        if (currentStep > 1) {
          currentStep = currentStep - 1;
          model.setCurrentStep(currentStep);
          _this13.context.updateData(model);
        } else {
          _this13.context.refreshData();
        }
        return model;
      };
      return step && step.back ? step.back(model, cb) : model;
    }
  }, {
    key: 'complete',
    value: function complete(model, step) {
      return step && model && model.getCurrentStep() > step.number;
    }
  }, {
    key: 'editable',
    value: function editable(model, step) {
      return step.editable || model && model.getCurrentStep() === step.number;
    }
  }, {
    key: 'previewable',
    value: function previewable(model) {
      return model && model.getCurrentStep() > 1;
    }
  }, {
    key: 'updateSteps',
    value: function updateSteps(scheme) {
      var steps = [];
      var cxt = this.context;
      if (!(scheme && scheme.steps && scheme.steps.length > 0)) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new DocumnentSelectType(cxt), { backLabel: function backLabel() {
            return 'Отмена';
          } }).addToArray(steps);
      }
      if (scheme && scheme.steps && scheme.steps.length > 0) {
        this.childrenStep = new ChildrenList(cxt).fillChildren(scheme.steps[0].fields);
        new OperationList(cxt).fillChildren(scheme.steps[0].fields).addToArray(steps);
      }
      if (scheme && scheme.steps && scheme.steps.length > 2) {
        new ChildrenSelect(cxt).fillChildren(scheme.steps[2].fields).addToArray(steps);
      }

      if (scheme && scheme.steps && scheme.steps.length > 1) {
        new __WEBPACK_IMPORTED_MODULE_16__StepSetParameters_js__["a" /* default */].Step(cxt).fillFields(scheme.steps[1].fields).addToArray(steps);

        new DocumnentCheck(cxt).addToArray(steps);

        // new DocumnentOperations(cxt)
        // .addToArray(steps)
      }

      this.steps = steps;
      return this;
    }
  }, {
    key: 'updateModel',
    value: function updateModel(model) {
      this.steps.forEach(function (step) {
        return step.setModel(model);
      });
      if (this.childrenStep) {
        this.childrenStep.setModel(model);
      }
    }
  }, {
    key: 'createModel',
    value: function createModel() {
      var model = new Model();
      if (this.context) {
        model['companyInn'] = this.context.profile.clientInn;
        model['companyRefCode'] = this.context.profile.clientRefCode;
      }
      this.steps.forEach(function (step) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(model, step.model);
      });
      return model;
    }
  }]);

  return PackageStrategy;
}(__WEBPACK_IMPORTED_MODULE_10__AssistClasses_js__["a" /* default */].Strategy);

function createStrategy(cxt) {
  return new PackageStrategy(cxt);
}

var Model = function (_AssistClasses$Model) {
  __WEBPACK_IMPORTED_MODULE_9_babel_runtime_helpers_inherits___default()(Model, _AssistClasses$Model);

  function Model() {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_classCallCheck___default()(this, Model);

    var _this14 = __WEBPACK_IMPORTED_MODULE_8_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Model.__proto__ || __WEBPACK_IMPORTED_MODULE_5_babel_runtime_core_js_object_get_prototype_of___default()(Model)).call(this));

    _this14.deedNumber = null;
    return _this14;
  }

  __WEBPACK_IMPORTED_MODULE_7_babel_runtime_helpers_createClass___default()(Model, [{
    key: 'copy',
    value: function copy() {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(new Model(), this);
    }
  }]);

  return Model;
}(__WEBPACK_IMPORTED_MODULE_10__AssistClasses_js__["a" /* default */].Model);

/* harmony default export */ __webpack_exports__["a"] = ({
  createStrategy: createStrategy,
  Model: Model
});

/***/ }),
/* 966 */,
/* 967 */,
/* 968 */,
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__StoreClasses__ = __webpack_require__(153);



// import Vue from 'vue'



// import moment from 'moment'
// class ItemSet {
//   constructor () {
//     this.items = []
//     this.loadedPages = 0
//     this.total = 0
//     this.page = 0
//     this.filter = {
//       search: '',
//       tagIds: [],
//       isShowOther: false
//     }
//     this.filterChanged = true
//   }
//   setItems (data, cxt) {
//     if (JSON.stringify(this.filter) === JSON.stringify(cxt)) {
//       this.items = this.loadedPages === 0 || data.first ? data.content : this.items.concat(data.content)
//       this.loadedPages = data.totalPages > data.number ? data.number + 1 : data.totalPages
//       this.total = data.totalElements
//     }
//   }
//   setFilter (cxt) {
//     if (JSON.stringify(this.filter) !== JSON.stringify(cxt)) {
//       this.loadedPages = 0
//       this.page = 0
//       this.filter = cxt
//       this.filterChanged = true
//     }
//   }
//   isChanged () {
//     return this.filterChanged
//   }
//   clearChanged () {
//     this.filterChanged = false
//   }
//   nextPage () {
//     if (this.page !== this.loadedPages) {
//       if (this.items.length < this.total) {
//         this.page = this.loadedPages
//         this.filterChanged = true
//       }
//     }
//   }
// }

var state = {
  constant: {
    ACTIVE_SCOPE: 'ACTIVE_SCOPE',
    ALL_SCOPE: 'ALL_SCOPE'
  },
  tags: [],
  peopleSet: new __WEBPACK_IMPORTED_MODULE_4__StoreClasses__["a" /* default */].ItemSet(function (item) {
    return item.id;
  })

  // getters
};var getters = {
  getPeopleFilterContext: function getPeopleFilterContext(state) {
    return state.peopleSet.filter;
  },
  getPeople: function getPeople(state) {
    return state.peopleSet.items;
  },
  getPeopleTotal: function getPeopleTotal(state) {
    return state.peopleSet.total;
  },
  getPeopleSet: function getPeopleSet(state) {
    return state.peopleSet;
  }

  // actions
};var actions = {
  fetchPeople: function fetchPeople(_ref, force) {
    var commit = _ref.commit,
        state = _ref.state,
        getters = _ref.getters;

    if (getters.getProfileLoaded && getters.getProfileHaveClient !== true) {
      return;
    }
    if (!force && !state.peopleSet.isChanged()) {
      return;
    }
    var page = force ? 0 : state.peopleSet.page;
    var fxt = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, state.peopleSet.getFilter());
    commit('startPeopleFileSet');
    __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiGetParams('/api/me/people/individuals', {
      size: 100,
      page: page,
      request: {
        search: fxt.search
      }
    }, function (data) {
      commit('setPeopleFileSet', { data: data, cxt: fxt });
      commit('setSuccessStatus');
    }, function (e) {
      commit('stopPeopleFileSet');
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении контактов клиента  ' });
    });
  },
  findPeople: function findPeople(_ref2, search) {
    var commit = _ref2.commit,
        state = _ref2.state,
        getters = _ref2.getters;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiGetParams('/api/me/people/individuals', {
        size: 5,
        page: 0,
        request: {
          search: search
        }
      }, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении при получении контактов клиента ' });
        reject(e);
      });
    });
  },
  getPeopleIndividual: function getPeopleIndividual(_ref3, id) {
    var commit = _ref3.commit,
        state = _ref3.state,
        rootState = _ref3.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiGet('/api/me/people/individuals/' + id, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении контакта' });
      });
    });
  },
  getPeopleIndividualDoc: function getPeopleIndividualDoc(_ref4, id) {
    var commit = _ref4.commit,
        state = _ref4.state,
        rootState = _ref4.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiGet('/api/me/people/individualDocs/' + id, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении документа контакта' });
      });
    });
  },
  getPeopleIndividualPassport: function getPeopleIndividualPassport(_ref5, request) {
    var commit = _ref5.commit,
        state = _ref5.state,
        rootState = _ref5.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var innflsStr = request && request.innfls ? request.innfls.join(',') : null;
      var companyRefCode = request && request.companyRefCode ? request.companyRefCode : null;
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiGetParams('/api/me/people/individualPassports', {
        innfls: innflsStr,
        companyRefCode: companyRefCode
      }, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении документа контакта' });
      });
    });
  },
  getPeopleIndividualContact: function getPeopleIndividualContact(_ref6, id) {
    var commit = _ref6.commit,
        state = _ref6.state,
        rootState = _ref6.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiGet('/api/me/people/individualContacts/' + id, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении документа контакта' });
      });
    });
  },
  updatePeopleIndividual: function updatePeopleIndividual(_ref7, request) {
    var _this = this;

    var commit = _ref7.commit,
        state = _ref7.state,
        rootState = _ref7.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPost('/api/me/people/individuals/', request, function (data) {
        _this.dispatch('fetchPeople', true);
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при добавлении/изменении  контакта ' });
      });
    });
  },
  updatePeopleIndividuals: function updatePeopleIndividuals(_ref8, request) {
    var _this2 = this;

    var commit = _ref8.commit,
        state = _ref8.state,
        rootState = _ref8.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPost('/api/me/people/command-individuals-updates', { dtos: request.dtos }, function (data) {
        _this2.dispatch('fetchPeople', true);
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при добавлении/изменении контакта ' });
      });
    });
  },
  deletePeopleIndividuals: function deletePeopleIndividuals(_ref9, request) {
    var _this3 = this;

    var commit = _ref9.commit,
        state = _ref9.state,
        rootState = _ref9.rootState;

    // console.log('deletePeopleIndividuals', request)
    __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPost('/api/me/people/command-individuals-deletes', { ids: request.ids }, function (data) {
      _this3.dispatch('fetchPeople', true);
    }, function (e) {
      commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении записей о контактах ' });
    });
  },
  updatePeopleContact: function updatePeopleContact(_ref10, request) {
    var _this4 = this;

    var commit = _ref10.commit,
        state = _ref10.state,
        rootState = _ref10.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPost('/api/me/people/command-contact-updates', { dto: request }, function (data) {
        _this4.dispatch('fetchPeople', true);
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при добавлении контакта в избранное ' });
      });
    });
  },
  deletePeopleContact: function deletePeopleContact(_ref11, request) {
    var commit = _ref11.commit,
        state = _ref11.state,
        rootState = _ref11.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPost('/api/me/people/command-contact-deletes', { ids: request.ids }, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении записей о контактах ' });
      });
    });
  },
  updatePeopleDoc: function updatePeopleDoc(_ref12, request) {
    var _this5 = this;

    var commit = _ref12.commit,
        state = _ref12.state,
        rootState = _ref12.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      var item = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()({}, request);
      item.model = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(item.model);
      // console.log('updatePeopleDoc', item)
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPost('/api/me/people/command-doc-updates', { dto: item }, function (data) {
        _this5.dispatch('fetchPeople', true);
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при добавлении контакта в избранное ' });
      });
    });
  },
  deletePeopleDocs: function deletePeopleDocs(_ref13, request) {
    var commit = _ref13.commit,
        state = _ref13.state,
        rootState = _ref13.rootState;

    return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiPost('/api/me/people/command-doc-deletes', { ids: request.ids }, function (data) {
        resolve(data);
      }, function (e) {
        commit('setErrorStatus', { error: e, context: 'Ошибка сервера при удалении записей о контактах ' });
      });
    });
  }
};
// mutations
var mutations = {
  setPeopleFilterContext: function setPeopleFilterContext(state, cxt) {
    state.peopleSet.setFilter(cxt);
  },
  clearPeopleFilterContextChanged: function clearPeopleFilterContextChanged(state) {
    state.peopleSet.clearChanged();
  },
  nextPeople: function nextPeople(state) {
    state.peopleSet.nextPage();
  },
  setPeople: function setPeople(state, _ref14) {
    var data = _ref14.data,
        cxt = _ref14.cxt;

    state.peopleSet.setItems(data, cxt);
  },
  startPeopleFileSet: function startPeopleFileSet(state) {
    state.peopleSet.clearChanged();
    state.peopleSet.start();
  },
  stopPeopleFileSet: function stopPeopleFileSet(state) {
    state.peopleSet.stop();
  },
  nextPeopleFileSet: function nextPeopleFileSet(state) {
    state.peopleSet.nextPage();
  },
  setPeopleFileSet: function setPeopleFileSet(state, _ref15) {
    var data = _ref15.data,
        cxt = _ref15.cxt;

    state.peopleSet.setItems(data, cxt);
    state.peopleSet.stop();
  }
};

/* harmony default export */ __webpack_exports__["a"] = ({
  state: state,
  getters: getters,
  actions: actions,
  mutations: mutations
});

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(971)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(973),
  /* template */
  __webpack_require__(979),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 971 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(972);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("6f1231c8", content, true, {});

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".container.fluid{padding:0}.v-content{height:100%}.v-list--three-line .v-list__tile__sub-title{height:42px}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/containers/Full.vue"],"names":[],"mappings":"AACA,iBACE,SAAW,CACZ,AAED,WACE,WAAa,CACd,AACD,6CACA,WAAa,CACZ","file":"Full.vue","sourcesContent":["\n.container.fluid {\n  padding: 0;\n}\n/*VN instead fill-height for container, because fill-height center items also*/\n.v-content {\n  height: 100%;\n}\n.v-list--three-line .v-list__tile__sub-title {\nheight: 42px;\n}\n/*.v-snack--multi-line .v-snack__content {*/\n  /*padding: 8px;*/\n/*}*/\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ModalFactory_vue__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_common_ModalFactory_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_common_ModalFactory_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_info_PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'full',
  components: { vModalFactory: __WEBPACK_IMPORTED_MODULE_2__components_common_ModalFactory_vue___default.a, vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__components_info_PanelTitle___default.a },
  data: function data() {
    return {
      title: 'АТЛАНТ-СМАРТ',
      showDetails: false,
      drawer: this.$vuetify.breakpoint.lgAndUp
    };
  },
  created: function created() {
    this.$store.dispatch('fetchOpenSettings');
    this.$store.commit('setBreakpoint', this.$vuetify.breakpoint);
  },
  mounted: function mounted() {
    __WEBPACK_IMPORTED_MODULE_3__components_common_dialogs__["a" /* default */].setModalFactory(this.$refs.modal);
  },

  watch: {
    '$vuetify.breakpoint': function $vuetifyBreakpoint(newVal) {
      this.$store.commit('setBreakpoint', newVal);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    status: 'getStatus',
    profile: 'getProfile',
    getIsAuthorized: 'getIsAuthorized',
    counters: 'getDashboardCounters',
    getOpenSettings: 'getOpenSettings'
  }), {
    alertShow: function alertShow() {
      return this.status.show;
    },
    expandDetails: function expandDetails() {
      console.log('expandDetails', this.status);
      return this.status.details != null;
    },
    getAlertColor: function getAlertColor() {
      return this.status.type ? this.status.type : 'info';
    },
    getAlertTimeout: function getAlertTimeout() {
      switch (this.status.type) {
        case 'info':
          return 6000;
        case 'error':
          return 0;
        case 'success':
          return 6000;
        case 'warning':
          return 0;
      }
    },
    getActionBadgeColor: function getActionBadgeColor() {
      return this.counters.newActions && this.counters.newActions.error > 0 ? 'warning' : 'info';
    },
    getActionBadgeValue: function getActionBadgeValue() {
      return this.counters.newActions && (this.counters.newActions.error || this.counters.newActions.process);
    },
    profileMenu: function profileMenu() {
      var menu = [{
        icon: '',
        title: this.profile.nameShort,
        route: '/profile'
      }];
      if (this.profile && this.profile.haveClient) {
        menu.push({
          icon: '',
          title: this.profile.clientNameShort,
          route: '/client_profile'
        });
      }
      if (this.profile && this.profile.haveClient) {
        menu.push({
          icon: '',
          title: 'Журнал',
          route: '/profile_log',
          badge: this.getActionBadgeValue,
          badgeColor: this.getActionBadgeColor
        });
      }
      return menu;
    }
  }),
  methods: {
    isLogged: function isLogged() {
      return this.getIsAuthorized(true);
    },
    onCloseAlert: function onCloseAlert() {
      this.showDetails = false;
      this.$store.commit('closeAlert');
    },
    logout: function logout() {
      this.$store.dispatch('logout');
    },
    items: function items() {
      return this.isLogged() ? [{
        icon: 'home',
        title: 'Главная',
        route: '/home'
      }, {
        icon: 'storage',
        title: 'Депозитарий',
        route: '/doc_list/root'
      }, {
        icon: 'people_outline',
        title: 'Физические лица',
        route: '/people'
      }, {
        icon: 'contacts',
        title: 'Мои контрагенты',
        route: '/favoritecompanies'
      }, {
        icon: 'alarm',
        title: 'Мониторинг',
        route: '/monitoring_page'
      }, {
        icon: 'chat',
        title: 'Сообщения',
        route: '/chats/root',
        badge: this.counters.notReviewedChats
      }, {
        icon: 'search',
        title: 'Компании, ИП',
        route: '/clients'
      }, {
        icon: 'school',
        title: 'Делопроизводство',
        route: '/assist'
      }, {
        icon: 'file_download',
        title: 'Импорт',
        route: '/payment'
      }] : [{
        icon: 'home',
        title: 'Главная',
        route: '/home'
      }, {
        icon: 'search',
        title: 'Компании, ИП',
        route: '/clients'
      }];
    },
    sendError: function sendError() {
      var email = this.getOpenSettings.supportMail;
      var subject = 'Сообщение об ошибке в Системе "АТЛАНТ-СМАРТ"';
      var emailBody = ''.concat('Господа,', '\n\t', 'c\u043E\u043E\u0431\u0449\u0430\u044E \u0412\u0430\u043C \u043E\u0431 \u043E\u0448\u0438\u0431\u043A\u0435 \u043E\u0431\u043D\u0430\u0440\u0443\u0436\u0435\u043D\u043D\u043E\u0439 \u043C\u043D\u043E\u0439 \u0432 \u0432\u0435\u0440\u0441\u0438\u0438 ' + this.getOpenSettings.version + ',', '\n\tна странице', '\n\t\t' + document.location, '\n', '\n Описание ошибки ', '\n', '\n', '<ВВЕДИТЕ ИНФОРМАЦИЮ ОБ ОШИБКЕ>', '\n', '\n С уважением, ', this.isLogged() ? this.profile.nameShort : '<ВВЕДИТЕ ВАШЕ ИМЯ>', '\n', this.isLogged() ? this.profile.clientNameShort + ' \n \u0418\u041D\u041D ' + this.profile.clientInn : '');
      this.$store.dispatch('mailTo', { email: email, subject: subject, emailBody: emailBody });
    },
    sendSuggestion: function sendSuggestion() {
      var email = this.getOpenSettings.supportMail;
      var subject = 'Предложение по развитию Системы "АТЛАНТ-СМАРТ"';
      var emailBody = ''.concat('Господа,', '\n\t', '\u0445\u043E\u0447\u0443 \u043F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F \u0438\u0434\u0435\u044F\u043C\u0438 \u043F\u043E \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044E \u0421\u0438\u0441\u0442\u0435\u043C\u044B "\u0410\u0422\u041B\u0410\u041D\u0422-\u0421\u041C\u0410\u0420\u0422" \u0432\u0435\u0440\u0441\u0438\u0438 ' + this.getOpenSettings.version, '\n', '\n', '<ВВЕДИТЕ ИНФОРМАЦИЮ О ПРЕДЛОЖЕНИИ>', '\n', '\n', 'С уважением, ', this.isLogged() ? this.profile.nameShort : '<ВВЕДИТЕ ВАШЕ ИМЯ>', '\n', this.isLogged() ? this.profile.clientNameShort + ' \n \u0418\u041D\u041D ' + this.profile.clientInn : '');
      this.$store.dispatch('mailTo', { email: email, subject: subject, emailBody: emailBody });
    }
  }
});

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(975)
}
var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(977),
  /* template */
  __webpack_require__(978),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 975 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(976);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("dd28df1e", content, true, {});

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".v-dialog.v-modal-factory-fullscreen{margin:0;max-height:100%}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/common/ModalFactory.vue"],"names":[],"mappings":"AACA,qCACE,SAAU,AACV,eAAiB,CAClB","file":"ModalFactory.vue","sourcesContent":["\n.v-dialog.v-modal-factory-fullscreen {\n  margin: 0;\n  max-height: 100%;\n}\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//

var Dialog = function Dialog(comp, fullscreen) {
  __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, Dialog);

  this.id = new Date();
  this.show = true;
  this.comp = comp;
  this.fullscreen = fullscreen;
};

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'modal-factory',
  data: function data() {
    return {
      dialogs: []
    };
  },
  methods: {
    isModal: function isModal() {
      return this.dialogs.length > 0;
    },
    close: function close(id) {
      this.dialogs = this.dialogs.filter(function (item) {
        return item.id !== id;
      });
    },
    open: function open(comp) {
      var data = comp.data instanceof Function ? comp.data() : comp.data;
      var fullscreen = data && data.fullscreen != null ? data.fullscreen : this.$vuetify.breakpoint.xsOnly;
      console.log('open', fullscreen, data);
      var item = new Dialog(comp, fullscreen);
      this.dialogs.push(item);
    }
  }
});

/***/ }),
/* 978 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._l((_vm.dialogs), function(item) {
    return [_c('v-dialog', {
      attrs: {
        "contentClass": item.fullscreen && 'v-modal-factory-fullscreen',
        "max-width": "600px",
        "persistent": ""
      },
      model: {
        value: (item.show),
        callback: function($$v) {
          _vm.$set(item, "show", $$v)
        },
        expression: "item.show"
      }
    }, [_c(item.comp, {
      tag: "component",
      on: {
        "close": function($event) {
          return _vm.close(item.id)
        }
      }
    })], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 979 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "clipped": "",
      "permanent": this.$vuetify.breakpoint.lgAndUp,
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', _vm._l((_vm.items()), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "exact": "",
        "href": item.href,
        "to": item.route
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "light": ""
      },
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-badge', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.badge && item.badge > 0),
        expression: "item.badge && item.badge > 0"
      }],
      attrs: {
        "right": ""
      }
    }, [_c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(item.badge))]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-title', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.badge || item.badge === 0),
        expression: "!item.badge || item.badge === 0"
      }],
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }), 1), _vm._v(" "), _c('v-card', {
    staticStyle: {
      "position": "absolute",
      "bottom": "0",
      "width": "100%"
    },
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-center": "",
      "wrap": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.sendSuggestion
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("mail_outline")]), _vm._v("Предложения")], 1), _vm._v(" "), _c('v-btn', {
    attrs: {
      "flat": "",
      "small": ""
    },
    on: {
      "click": _vm.sendError
    }
  }, [_c('v-icon', {
    attrs: {
      "small": ""
    }
  }, [_vm._v("error_outline")]), _vm._v("Замечания")], 1), _vm._v(" "), _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "text-xs-center": "",
      "xs12": ""
    }
  }, [_vm._v("\n       ©2016-2026 OOO \"БВР\"\n      ")])], 1)], 1)], 1), _vm._v(" "), _c('v-toolbar', {
    attrs: {
      "color": "primary",
      "fixed": "",
      "app": "",
      "dark": "",
      "clipped-left": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "color": _vm.getOpenSettings.env !== 'test' ? 'primary' : 'secondary'
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/logo.png",
      "height": "32px"
    }
  })]), _vm._v(" "), _c('v-toolbar-title', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getIsMobile),
      expression: "!getIsMobile"
    }],
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-toolbar-title', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getIsMobile),
      expression: "!getIsMobile"
    }]
  }, [_vm._v(_vm._s(_vm.profile.clientNameShort))]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLogged()),
      expression: "!isLogged()"
    }],
    attrs: {
      "flat": "",
      "dark": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/login')
      }
    }
  }, [_vm._v("\n        Вход\n      ")]), _vm._v(" "), _c('v-menu', {
    attrs: {
      "offset-y": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogged()),
      expression: "isLogged()"
    }],
    attrs: {
      "slot": "activator",
      "flat": "",
      "dark": ""
    },
    slot: "activator"
  }, [_c('v-badge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.getActionBadgeValue > 0),
      expression: "getActionBadgeValue > 0"
    }],
    attrs: {
      "overlap": "",
      "color": _vm.getActionBadgeColor
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.getActionBadgeValue))]), _vm._v("\n                  " + _vm._s(_vm.profile.nameShort) + "\n                ")]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.getActionBadgeValue),
      expression: "!getActionBadgeValue"
    }]
  }, [_vm._v(_vm._s(_vm.profile.nameShort))]), _vm._v(" "), _c('v-icon', [_vm._v("arrow_drop_down")])], 1), _vm._v(" "), _c('v-list', [_vm._l((_vm.profileMenu), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      on: {
        "click": function($event) {
          return _vm.$router.push(item.route)
        }
      }
    }, [_c('v-badge', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.badge && item.badge > 0),
        expression: "item.badge && item.badge > 0"
      }],
      attrs: {
        "right": "",
        "color": item.badgeColor
      }
    }, [_c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(item.badge))]), _vm._v(" "), _c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-title', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.badge || item.badge === 0),
        expression: "!item.badge || item.badge === 0"
      }],
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)
  }), _vm._v(" "), _c('v-list-tile', {
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-title', [_vm._v("Выход")])], 1)], 2)], 1)], 1), _vm._v(" "), _c('v-content', [_c('v-snackbar', {
    attrs: {
      "value": _vm.alertShow,
      "top": "",
      "auto-height": "",
      "color": _vm.getAlertColor,
      "multi-line": "",
      "timeout": _vm.getAlertTimeout
    },
    on: {
      "input": _vm.onCloseAlert
    }
  }, [_c('v-layout', {
    staticStyle: {
      "margin": "-24px"
    },
    attrs: {
      "column": ""
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.showDetails,
      "caption": _vm.showDetails ? 'Кратко' : 'Подробно',
      "expandable": _vm.expandDetails,
      "primary": false
    },
    on: {
      "click": function($event) {
        _vm.showDetails = !_vm.showDetails
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_vm._v("\n          " + _vm._s(_vm.status.message) + "\n        ")]), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": _vm.onCloseAlert
    }
  }, [_c('v-icon', [_vm._v("close")])], 1)], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDetails),
      expression: "showDetails"
    }],
    staticStyle: {
      "display": "block",
      "overflow": "auto",
      "overflow-wrap": "break-word",
      "color": "rgba(0,0,0,0.87)",
      "background-color": "white"
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.status.details)
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('v-modal-factory', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLogged()),
      expression: "isLogged()"
    }],
    ref: "modal"
  })], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(981),
  /* template */
  __webpack_require__(982),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_formats__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      valid: false,
      isRegister: false,
      credentials: {
        username: '',
        password: ''
      },
      emailRules: [function (v) {
        return !!v || 'Введите адрес электронной почты, для идентификации в системе';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_0__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      }],
      passwordRules: [],
      errorMessage: ''
    };
  },
  mounted: function mounted() {
    this.credentials.username = this.$store.getters.getLastLogin(true);
    if (this.credentials.username.includes('@dealger.ru')) {
      this.credentials.password = 'pass1';
    }
  },

  methods: {
    login: function login() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('login', this.credentials);
      }
    }
  }
});

/***/ }),
/* 982 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Вход в систему")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          " + _vm._s(_vm.errorMessage) + "\n          "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "person",
      "label": "Эл. почта",
      "rules": _vm.emailRules,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.credentials.username),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "username", $$v)
      },
      expression: "credentials.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "prepend-icon": "lock",
      "label": "Пароль",
      "type": "password",
      "rules": _vm.passwordRules,
      "clearable": ""
    },
    model: {
      value: (_vm.credentials.password),
      callback: function($$v) {
        _vm.$set(_vm.credentials, "password", $$v)
      },
      expression: "credentials.password"
    }
  }), _vm._v("\n            Вы еще не зарегистрированы?\n            "), _c('router-link', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрируйтесь")])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "disabled": !_vm.valid,
      "color": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Войти")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 983 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(984),
  /* template */
  __webpack_require__(985),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 984 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__client_ClientSelector_vue__ = __webpack_require__(465);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__client_ClientSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__client_ClientSelector_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      valid: false,
      request: {
        inn: '',
        email: ''
      },
      company: null,
      personAgreementCheck: false,
      emailRules: [function (v) {
        return !!v || 'Введите адрес электронной почты, для отсылки счета';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      }]
    };
  },
  created: function created() {
    this.initCompany();
  },
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getOpenSettings: 'getOpenSettings',
    getDepoUrl: 'getDepoUrl'
  })),
  methods: {
    initCompany: function initCompany() {
      this.company = {
        name: null,
        head: {
          position: null,
          lastName: null,
          firstName: null,
          middleName: null
        }
      };
    },
    formatHeads: function formatHeads(heads) {
      return heads ? heads.map(function (h) {
        return ''.concat(h.position, ': ', '<b>', h.nameFull, '</b>');
      }).join('<br/>') : '';
    },
    formatHeadNames: function formatHeadNames(heads) {
      return heads ? heads.map(function (h) {
        return ''.concat('<b>', h.firstName, ' ', h.middleName, '</b>');
      }).join(', ') : '';
    },

    setPartner: function setPartner(value) {
      var _this = this;

      if (value.length > 0) {
        var ms = /ogrn:(\d{13})/.exec(value[0]);
        console.log('setPartner', value);
        if (ms && ms.length > 1) {
          this.$store.dispatch('getCompanyProps', ms[1]).then(function (data) {
            _this.company = data;
            _this.request.inn = _this.company ? _this.company.inn : null;
          });
        } else {
          this.company = null;
          this.request.inn = null;
          this.$store.commit('setWarningStatus', 'Тип организации не поддерживается.');
        }
      } else {
        this.company = null;
        this.request.inn = null;
      }
    },
    selectClient: function selectClient() {
      __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-client-selector', __WEBPACK_IMPORTED_MODULE_6__client_ClientSelector_vue___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var setItem = this.setPartner;
      var comp = { template: '\n        <v-client-selector v-on:close="$emit(\'close\')"\n        v-on:input="setItem"\n        :fullscreen="fullscreen" radio\n        refCode\n        ></v-client-selector>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            setItem: setItem
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].modal(comp);
    },
    registerRequest: function registerRequest() {
      var _this2 = this;

      if (this.$refs.form.validate()) {
        __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].openApiPost('/openapi/register-requests', this.request, function (data) {
          _this2.$store.commit('setStatus', {
            show: true,
            type: 'success',
            message: 'На адрес ' + _this2.request.email + ' был отправлен счет для совершения Вашей компанией удостоверяющего платежа'
          });
          _this2.$store.dispatch('logout');
        }, function (e) {
          _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении счета для регистрации ' });
        });
      }
    }
  }
});

/***/ }),
/* 985 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Регистрация в системе")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          В Системе \"АТЛАНТ-СМАРТ\" могут работать только представители компаний.\n          "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.selectClient
    }
  }, [_vm._v("Указать компанию")])], 1), _vm._v(" "), _c('div', [(!!_vm.company.name) ? _c('div', [_c('b', [_vm._v(_vm._s(_vm.company.name.value))])]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.inn),
      expression: "!!company.inn"
    }]
  }, [_vm._v("\n            ИНН: "), _c('b', [_vm._v(_vm._s(_vm.formats.formatInn(_vm.company.inn)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.address),
      expression: "!!company.address"
    }]
  }, [_vm._v("\n            Адрес: "), _c('b', [_vm._v(_vm._s(!!_vm.company.address ? _vm.company.address.value : ''))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.heads),
      expression: "!!company.heads"
    }]
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeads(_vm.company.heads))
    }
  })]), _vm._v(" "), _c('p'), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.heads),
      expression: "!!company.heads"
    }]
  }, [_c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeadNames(_vm.company.heads))
    }
  }), _vm._v(",")]), _vm._v(" если это Вы, то укажите эл. почту для направления Вам счета с реквизитами для совершения Вашей компанией удостоверяющего платежа.\n            ")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!!_vm.company.heads),
      expression: "!!company.heads"
    }],
    attrs: {
      "label": "Введите адрес эл. почты для посылки счета",
      "rules": _vm.emailRules,
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.request.email),
      callback: function($$v) {
        _vm.$set(_vm.request, "email", $$v)
      },
      expression: "request.email"
    }
  }), _vm._v(" "), _c('div', [_c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.useRules)
    }
  }, [_vm._v("Лицензионное соглашение")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.personInfoRules)
    }
  }, [_vm._v("Политика обработки персональных данных")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.personInfoAgreement)
    }
  }, [_vm._v("Согласие на обработку персональных данных")])]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Даю согласие",
      "persistent-hint": "",
      "hint": "Политику обработки персональных данных изучил, Даю свое соглашение на обработку моих персональных данных"
    },
    model: {
      value: (_vm.personAgreementCheck),
      callback: function($$v) {
        _vm.personAgreementCheck = $$v
      },
      expression: "personAgreementCheck"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "disabled": !_vm.valid || !this.request.inn || !_vm.personAgreementCheck,
      "color": "primary"
    },
    on: {
      "click": _vm.registerRequest
    }
  }, [_vm._v("Получить счет")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(987),
  /* template */
  __webpack_require__(988),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      personAgreementCheck: false
    };
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getOpenSettings: 'getOpenSettings',
    getDepoUrl: 'getDepoUrl'
  })),
  methods: {
    apply: function apply() {
      var _this = this;

      if (this.personAgreementCheck) {
        __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].apiPost('/api/me/profile/command-rules-agrees', null, function (data) {
          _this.$store.dispatch('fetchAccountProfile');
          _this.$router.push('/home');
        }, function (e) {
          _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при сохранении соглашения об использовании ' });
        });
      }
    }
  }
});

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Соглашение об использовании")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Для продолжения работы с системой Вам необходимо ознакомиться с правилами и подтвердить Ваше согласие на работу в соответствии с правилами\n            "), _c('div', [_c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.useRules)
    }
  }, [_vm._v("Лицензионное соглашение")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.personInfoRules)
    }
  }, [_vm._v("Политика обработки персональных данных")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": _vm.getDepoUrl(_vm.getOpenSettings.personInfoAgreement)
    }
  }, [_vm._v("Согласие на обработку персональных данных")])]), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Даю согласие",
      "persistent-hint": "",
      "hint": "Политику обработки персональных данных изучил, Даю свое согласие на обработку моих персональных данных"
    },
    model: {
      value: (_vm.personAgreementCheck),
      callback: function($$v) {
        _vm.personAgreementCheck = $$v
      },
      expression: "personAgreementCheck"
    }
  })], 1)]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "disabled": !_vm.personAgreementCheck,
      "color": "primary"
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v("Принять")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 989 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(990),
  /* template */
  __webpack_require__(995),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionLogsPanel__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ActionLogsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ActionLogsPanel__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'profile',
  components: { vActionLogsPanel: __WEBPACK_IMPORTED_MODULE_3__ActionLogsPanel___default.a },
  data: function data() {
    return {
      editProfile: false,
      needCredentials: false,
      password: '',
      retype: '',
      confirmationCode: '',
      clientValid: true,
      profileValid: true,
      enableClientCheck: false,
      needPersonAgreementCheck: false,
      clientInnRules: [function (v) {
        return !!v || 'Введите ИНН организации, которую Вы представляете';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].isInn(v) || 'Неверный формат ИНН';
      }],
      emailRules: [function (v) {
        return !!v || 'Введите адрес электронной почты, для идентификации в системе';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      }],
      clientEmailRules: [function (v) {
        return !!v || 'Введите адрес Вашей корпоративной электронной почты, для оповещений системы';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      }],
      passwordRules: [function (v) {
        return !!v || 'Введите пароль';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].isPassword(v) || 'Пароль должен содержать латинские символы и цифры';
      }],
      phoneRules: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].isPhone(__WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatPhone(v)) || 'Формат номера +7(921)1234567';
      }]
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('fetchAccountClients');
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    profile: 'getProfile',
    getAccountClients: 'getAccountClients'
  }), {
    isRequested: function isRequested() {
      return (/CONFIRMED/i.test(this.accountClient.state) || /NEW/i.test(this.accountClient.state)
      );
    },
    isNeedPersonAgreement: function isNeedPersonAgreement() {
      return false && !this.profile.rulesAgreed;
    },
    statusText: function statusText() {
      var ac = this.accountClient;
      if (!(ac && ac.state && ac.state.length > 0)) {
        return '';
      }
      if (/CONFIRMED/i.test(ac.state)) {
        return 'Данные подтверждены ';
      }
      if (/NEW/i.test(ac.state)) {
        return 'Запрос ожидает подтверждения ';
      }
      if (/REJECTED/i.test(ac.state)) {
        return 'Запрос отклонен';
      }
    },
    accountClients: function accountClients() {
      return this.getAccountClients.slice(0).sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.clientNameShort, b.clientNameShort);
      });
    },
    enableClient: function enableClient() {
      return this.profile.confirmed && this.profile.lastName && this.profile.lastName.length > 0 && this.profile.firstName && this.profile.firstName.length > 0 && (!this.isRequested || this.enableClientCheck);
    }
  }),
  methods: {
    calcHeight: function calcHeight() {
      var height = this.$vuetify.breakpoint.height - 56 - 48;
      return height + 'px';
    },
    confirmEmail: function confirmEmail() {
      this.$store.dispatch('confirmEmail', this.confirmationCode);
    },
    errorRetype: function errorRetype() {
      if (this.needCredentials && this.password !== this.retype) {
        return ['Пароли не совпадают'];
      }
      return [];
    },
    saveProfile: function saveProfile() {
      if (this.$refs.profile.validate()) {
        var els = this.$refs.profile.$el.elements;
        var r = {};
        for (var i = 0; i < els.length; i++) {
          if (els[i] && els[i].name) {
            r[els[i].name] = els[i].value;
          }
        }
        r['phone'] = __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatPhone(r['phone']);
        if (this.needCredentials && this.$refs.newPassword.validate(true) && this.$refs.retype.validate(true)) {
          r['newEmail'] = els['email'].value;
          r['newPassword'] = this.password;
        }
        this.$store.dispatch('saveAccountProfile', r);
        this.editProfile = false;
      }
    },
    setCurrentClient: function setCurrentClient(item) {
      this.$store.dispatch('setCurrentClient', item.clientId);
    },
    isCurrentClient: function isCurrentClient(item) {
      return this.profile && this.profile.clientInn === item.clientInn;
    }
  }
});

/***/ }),
/* 991 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(992);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("43690560", content, true, {});

/***/ }),
/* 992 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".align-end{text-align:right}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/profile/ActionLogsPanel.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB","file":"ActionLogsPanel.vue","sourcesContent":["\n.align-end{\r\n  text-align: right;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ItemsField__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_ItemsField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_ItemsField__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-actionlogs-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_5__info_PanelTitle___default.a, vItemsField: __WEBPACK_IMPORTED_MODULE_7__common_ItemsField___default.a },
  data: function data() {
    return {
      id: null,
      items: [],
      totalPages: 0,
      loadedPages: 0,
      isLoaded: false,
      isLoading: false,
      actions: function actions() {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a([['OTHER', 'Неизвестная операция'], ['LOGIN', 'вход в систему']]);
      }
    };
  },
  props: {
    fillHeight: {
      type: Boolean,
      default: false
    },
    topCount: {
      type: Number,
      default: 2
    }
  },
  created: function created() {
    this.fetchItems();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getPostTypes: 'getPostTypes'
  }), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.items.slice(this.topCount);
    }
  }),
  methods: {
    switchItems: function switchItems() {
      if (!this.isLoaded) {
        if (this.totalPages > this.loadedPages) {
          this.fetchItems();
        }
      } else {
        this.isLoaded = false;
        this.loadedPages = 1;
        this.items = this.topItems;
      }
    },
    formatDateTime: function formatDateTime(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDateTime(dateTime);
    },
    formatActionContent: function formatActionContent(item) {
      var fstrategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, 'ACTION');
      if (!fstrategy) {
        return;
      }
      return fstrategy.viewContentListComp(fstrategy.createModelFromData(item));
    },
    getScheduledActions: function getScheduledActions() {
      var fstrategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, 'ACTION');
      if (!fstrategy) {
        return;
      }
      var actions = this.items;
      return actions.map(function (al) {
        var model = fstrategy.createModelFromData(al);
        var icon = al.started && al.resultCode || al.scheduled && 'SCHEDULE';
        return {
          title: '<b>' + fstrategy.viewTitle(model) + '</b> (' + al.clientNameShort + ')',
          date: al.finished || al.scheduled || al.started,
          text: fstrategy.viewContentListComp(model),
          icons: [icon],
          time: al.finished || al.scheduled || al.started,
          id: al.id
        };
      }).sort(function (b, a) {
        return a.time - b.time;
      });
    },
    onActionClick: function onActionClick(item) {
      __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].openLogAction(item.id, null);
    },
    getItems: function getItems(cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка операций ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiGetParams('/api/me/actions', {
        actions: null,
        size: this.topCount,
        page: this.loadedPages,
        sort: 'started,desc'
      }, cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (!this.isLoading) {
        // this.items = []
        this.isLoading = true;
        this.getItems(function (data) {
          _this2.items = _this2.items.concat(data.content);
          _this2.totalPages = data.totalPages;
          _this2.loadedPages = data.totalPages > data.number ? data.number + 1 : data.totalPages;
          _this2.isLoading = false;
          _this2.isLoaded = _this2.totalPages === _this2.loadedPages;
          if (data.number === 0) {
            _this2.$store.dispatch('fetchDashboardCounters');
          }
        });
      }
    }
  }
});

/***/ }),
/* 994 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Показать ' + this.topCount : 'Еще',
      "expandable": !((_vm.totalPages == _vm.loadedPages) && (this.topCount > this.items.length))
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading && _vm.loadedPages < 0),
      expression: "isLoading && loadedPages < 0"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.isLoading && _vm.loadedPages == 0)),
      expression: "!(isLoading && loadedPages == 0)"
    }]
  }, [_c('v-items-field', {
    attrs: {
      "items": _vm.getScheduledActions(),
      "smallIcons": ""
    },
    on: {
      "click": function($event) {
        return _vm.onActionClick($event)
      }
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 995 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.profile.confirmed),
      expression: "!profile.confirmed"
    }],
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Подтверждение электронной почты\n          ")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n          Для продолжения работы с системой Вам необходимо ввести код подтверждения, код был послан на адрес электронной почты " + _vm._s(_vm.profile.email) + ".\n          "), _c('v-text-field', {
    attrs: {
      "label": "Код подтверждения",
      "type": "text",
      "clearable": ""
    },
    model: {
      value: (_vm.confirmationCode),
      callback: function($$v) {
        _vm.confirmationCode = $$v
      },
      expression: "confirmationCode"
    }
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": _vm.confirmEmail
    }
  }, [_vm._v("Подтвердить")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": '100%'
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Обо мне\n          ")])], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedPersonAgreement),
      expression: "isNeedPersonAgreement"
    }]
  }, [_c('div', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Политика обработки персональных данных")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": "/"
    }
  }, [_vm._v("Согласие на обработку персональных данных")])]), _vm._v(" "), _c('v-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNeedPersonAgreement),
      expression: "isNeedPersonAgreement"
    }],
    attrs: {
      "label": "Даю согласие",
      "persistent-hint": "",
      "hint": "Политику обработки персональных данных изучил, Даю свое соглашение на обработку моих персональных данных"
    },
    model: {
      value: (_vm.needPersonAgreementCheck),
      callback: function($$v) {
        _vm.needPersonAgreementCheck = $$v
      },
      expression: "needPersonAgreementCheck"
    }
  })], 1), _vm._v(" "), _c('v-form', {
    ref: "profile",
    model: {
      value: (_vm.profileValid),
      callback: function($$v) {
        _vm.profileValid = $$v
      },
      expression: "profileValid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "lastName",
      "value": _vm.profile.lastName,
      "label": "Фамилия",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "firstName",
      "value": _vm.profile.firstName,
      "label": "Имя",
      "type": "text"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "middleName",
      "value": _vm.profile.middleName,
      "label": "Отчество",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "phone",
      "value": _vm.profile.phone,
      "rules": _vm.phoneRules,
      "label": "Тел. личный",
      "type": "text",
      "clearable": ""
    }
  })], 1), _vm._v(" "), _c('v-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editProfile),
      expression: "editProfile"
    }],
    attrs: {
      "hide-details": "",
      "label": "Изменить параметры входа"
    },
    model: {
      value: (_vm.needCredentials),
      callback: function($$v) {
        _vm.needCredentials = $$v
      },
      expression: "needCredentials"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "readonly": !_vm.needCredentials,
      "name": "email",
      "value": _vm.profile.email,
      "label": "Эл. почта",
      "type": "text",
      "rules": _vm.emailRules,
      "clearable": _vm.needCredentials
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needCredentials && _vm.editProfile),
      expression: "needCredentials && editProfile"
    }],
    ref: "newPassword",
    attrs: {
      "type": "password",
      "label": "Пароль",
      "rules": _vm.passwordRules,
      "clearable": _vm.needCredentials
    },
    model: {
      value: (_vm.password),
      callback: function($$v) {
        _vm.password = $$v
      },
      expression: "password"
    }
  }), _vm._v(" "), _c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.needCredentials && _vm.editProfile),
      expression: "needCredentials && editProfile"
    }],
    ref: "retype",
    attrs: {
      "error-messages": _vm.errorRetype(),
      "type": "password",
      "label": "Подтверждение",
      "hint": "Подтвердите пароль",
      "clearable": _vm.needCredentials
    },
    model: {
      value: (_vm.retype),
      callback: function($$v) {
        _vm.retype = $$v
      },
      expression: "retype"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.editProfile),
      expression: "editProfile"
    }],
    attrs: {
      "disabled": _vm.isNeedPersonAgreement && !_vm.needPersonAgreementCheck
    },
    on: {
      "click": _vm.saveProfile
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.editProfile),
      expression: "!editProfile"
    }],
    on: {
      "click": function($event) {
        _vm.editProfile = true
      }
    }
  }, [_vm._v("Изменить")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "height": _vm.calcHeight()
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Мои компании\n          ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.accountClients), function(item) {
    return [_c('v-flex', [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_vm._v(_vm._s(item.clientNameShort))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isCurrentClient(item)),
        expression: "isCurrentClient(item)"
      }]
    }, [_vm._v("done")])], 1), _vm._v(" "), _c('v-card-text', [_c('div', [_vm._v("Эл. почта компании: "), _c('b', [_vm._v(_vm._s(item.clientEmail))])]), _vm._v(" "), _c('div', [_vm._v("Тел. рабочий: "), _c('b', [_vm._v(_vm._s(item.clientPhone))])]), _vm._v(" "), _c('div', [_vm._v("Полномочия: "), _c('b', [_vm._v(_vm._s(item.roleNotes))])])]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.isCurrentClient(item)),
        expression: "!isCurrentClient(item)"
      }],
      on: {
        "click": function($event) {
          return _vm.setCurrentClient(item)
        }
      }
    }, [_vm._v("Сделать текущей")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 996 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(997),
  /* template */
  __webpack_require__(998),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionLogsPanel__ = __webpack_require__(468);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ActionLogsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ActionLogsPanel__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'action-log-page',
  components: { vActionLogsPanel: __WEBPACK_IMPORTED_MODULE_2__ActionLogsPanel___default.a },
  data: function data() {
    return {};
  },
  mounted: function mounted() {},

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    calcScroll: 'calcScroll'
  })),
  methods: {}
});

/***/ }),
/* 998 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "max-height": _vm.calcScroll(64 + 2, 56 + 2)
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Журнал операций\n        ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "fluid": ""
    }
  }, [_c('v-action-logs-panel', {
    attrs: {
      "topCount": 5
    }
  })], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 999 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1000),
  /* template */
  __webpack_require__(1009),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientPreview__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__ClientPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__ClientPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientAgentForm__ = __webpack_require__(1003);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientAgentForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ClientAgentForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8____ = __webpack_require__(37);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  components: { vClientPreview: __WEBPACK_IMPORTED_MODULE_4__ClientPreview___default.a },
  data: function data() {
    return {
      profileEdit: false,
      profileAddEdit: false,
      outgoingEdit: false,
      selected: [],
      clientProps: null,
      rights: null,
      clientMailboxes: [],
      clientEmailRules: [function (v) {
        return !!v || 'Введите адрес Вашей корпоративной электронной почты, для оповещений системы';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      }],
      phoneRules: [function (v) {
        return !!v || 'Введите телефон';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].isPhone(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatPhone(v)) || 'формат номера +7(921)3003333';
      }],
      accountRules: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].isBankAccount(v) || 'неверный формат рассчетного счета';
      }],
      corrAccountRules: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].isBankAccount(v) || 'неверный формат корресподентского счета';
      }],
      bankBicRules: [function (v) {
        var re = /^\d{9}$/;
        return !v || re.test(String(v)) || 'неверный формат корресподентского счета';
      }]
    };
  },
  created: function created() {
    this.fetchAll();
    this.setClientProps();
  },
  mounted: function mounted() {
    this.fetchAll();
  },

  watch: {
    getClientProfile: function getClientProfile(newVal, oldVal) {
      // watch it
      this.setClientProps();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getClientProfile: 'getClientProfile',
    clientAccounts: 'getClientAccounts',
    getDepoUrl: 'getDepoUrl',
    getIsAllow: 'getIsAllow',
    getClientMonitoring: 'getClientMonitoring'
  })),
  methods: {
    fetchAll: function fetchAll() {
      this.profileEdit = false;
      this.profileAddEdit = false;
      this.outgoingEdit = false;
      this.$store.dispatch('fetchClientProfile');
      this.$store.dispatch('fetchClientAccounts');
      this.fetchMailboxes();
      this.fetchRights();
    },
    fetchMailboxes: function fetchMailboxes() {
      var _this = this;

      this.$store.dispatch('getClientMailboxes').then(function (data) {
        _this.clientMailboxes = data;
        return;
      });
    },
    cancel: function cancel() {
      this.fetchAll();
    },
    setClientProps: function setClientProps() {
      this.clientProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getClientProfile);
      if (this.clientProps.outgoingConf) {
        this.clientProps.outgoingConf.bcc = this.clientProps.outgoingConf.bcc || this.clientProps.email;
        this.clientProps.outgoingConf.replyTo = this.clientProps.outgoingConf.replyTo || this.clientProps.email;
      }
    },
    updateFromEgrul: function updateFromEgrul() {
      this.profileEdit = false;
      this.$store.dispatch('updateFromEgrul');
    },
    saveClientProfile: function saveClientProfile() {
      if (this.$refs.profile.validate()) {
        var els = this.$refs.profile.$el.elements;
        var d = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.clientProps);
        var bd = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.clientProps.bankDetails);
        d.email = els['email'].value;
        d.address = els['address'].value;
        d.phone = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatPhone(els['phone'].value);
        d.inn = els['inn'].value;
        bd.account = els['bankDetails.account'].value;
        bd.bankName = els['bankDetails.bankName'].value;
        bd.corrAccount = els['bankDetails.corrAccount'].value;
        bd.bankBic = els['bankDetails.bankBic'].value;
        d.bankDetails = bd;
        this.$store.dispatch('saveClientProfile', d);
        this.profileEdit = false;
      }
    },
    saveClientProfileOutgoing: function saveClientProfileOutgoing() {
      var _this2 = this;

      if (this.clientMailboxes.length > 0) {
        var d = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.clientProps);
        d.outgoing = true;
        this.$store.dispatch('saveClientProfile', d).then(function (data) {
          _this2.outgoingEdit = false;
          _this2.clientProps.outgoing = true;
        });
      }
    },
    saveClientProfileAdd: function saveClientProfileAdd() {
      if (this.$refs.profileAdd.validate()) {
        var els = this.$refs.profileAdd.$el.elements;
        var d = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.clientProps);
        d.website = els['website'].value;
        d.about = els['about'].value;
        d.contacts = els['contacts'].value;
        d.services = els['services'].value;
        d.price = els['price'].value;
        d.docs = els['docs'].value;
        d.tags = els['tags'].value;
        d.other = els['other'].value;
        this.$store.dispatch('saveClientProfile', d);
        this.profileAddEdit = false;
      }
    },

    addLink: function addLink(value) {
      var _this3 = this;

      this.$store.dispatch('getDepoFile', value).then(function (files) {
        var docLink = _this3.getDepoUrl(value);
        var docName = files && files[0] && files[0].docName || docLink;
        var els = _this3.$refs.profileAdd.$el.elements;
        _this3.clientProps.docs = els['docs'].value + ('<p><a href="' + docLink + '">' + docName + '</a></p>');
      });
    },
    openDocSelector: function openDocSelector() {
      __WEBPACK_IMPORTED_MODULE_6__depo__["a" /* default */].selectDoc(this, this.addLink);
    },
    openUser: function openUser(accountProfileId) {
      __WEBPACK_IMPORTED_MODULE_7__common_dialogs__["a" /* default */].register('v-client-agent-form', __WEBPACK_IMPORTED_MODULE_5__ClientAgentForm___default.a);
      var comp = { template: '\n        <v-client-agent-form toolbar :itemId="itemId"\n        v-on:close="$emit(\'close\')"\n          :fullscreen="$vuetify.breakpoint.xsOnly"></v-client-agent-form>\n        ',
        data: function data() {
          return {
            itemId: accountProfileId
          };
        }
      };
      this.dialogOpen(comp);
    },
    addUser: function addUser() {
      this.openUser(null);
    },
    openMailbox: function openMailbox(mailbox) {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_8____["a" /* default */].openClientMailbox(mailbox && mailbox.id || null).then(function () {
        _this4.fetchMailboxes();
      });
    },
    dialogOpen: function dialogOpen(comp) {
      __WEBPACK_IMPORTED_MODULE_7__common_dialogs__["a" /* default */].modal(comp);
    },
    fetchRights: function fetchRights() {
      this.$store.dispatch('fetchRights', { CLIENT_UPDATE: null, AGENT_CREATE: null, MONITORING_SWITCH: null });
    },
    switchMonitoring: function switchMonitoring() {
      this.$store.dispatch('switchClientMonitoring', { monitoring: !this.getClientMonitoring, addFavorites: true });
    },
    turnOffOutgoing: function turnOffOutgoing() {
      var d = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.clientProps);
      d.outgoing = false;
      this.$store.dispatch('saveClientProfile', d);
    }
  }
});

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'client-preview',
  props: {
    clientProfile: {
      type: Object,
      default: {
        website: '',
        about: '',
        contacts: '',
        services: '',
        price: '',
        docs: '',
        tags: '',
        other: ''
      }
    }
  },
  methods: {
    isFilled: function isFilled(value) {
      return value && value.length > 0;
    }
  }

});

/***/ }),
/* 1002 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.about)),
      expression: "clientProfile && isFilled(clientProfile.about)"
    }]
  }, [_c('b', [_vm._v("О компании:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.about)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.website)),
      expression: "clientProfile && isFilled(clientProfile.website)"
    }]
  }, [_c('b', [_vm._v("Сайт:")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": _vm.clientProfile.website
    }
  }, [_vm._v(_vm._s(_vm.clientProfile.website))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.contacts)),
      expression: "clientProfile && isFilled(clientProfile.contacts)"
    }]
  }, [_c('b', [_vm._v("Контакты:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.contacts)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.services)),
      expression: "clientProfile && isFilled(clientProfile.services)"
    }]
  }, [_c('b', [_vm._v("Товары и услуги:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.services)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.price)),
      expression: "clientProfile && isFilled(clientProfile.price)"
    }]
  }, [_c('b', [_vm._v("Цены:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.price)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.docs)),
      expression: "clientProfile && isFilled(clientProfile.docs)"
    }]
  }, [_c('b', [_vm._v("Публичные документы:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.docs)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.tags)),
      expression: "clientProfile && isFilled(clientProfile.tags)"
    }]
  }, [_c('b', [_vm._v("Поисковые Теги:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.tags)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.clientProfile && _vm.isFilled(_vm.clientProfile.other)),
      expression: "clientProfile && isFilled(clientProfile.other)"
    }]
  }, [_c('b', [_vm._v("Разное:")]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.clientProfile.other)
    }
  })])])
},staticRenderFns: []}

/***/ }),
/* 1003 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1004),
  /* template */
  __webpack_require__(1008),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__ = __webpack_require__(1005);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__ = __webpack_require__(240);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_forms__ = __webpack_require__(47);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_HtmlField__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_HtmlField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_HtmlField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_BtnForm__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'client-agent-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_11__common_BtnForm___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_9__common_CardScroll___default.a, vHtmlField: __WEBPACK_IMPORTED_MODULE_10__common_HtmlField___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      registerNew: false,
      username: null,
      item: {},
      phoneRules: [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isPhone(__WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].formatPhone(v)) || 'Формат номера +7(921)1234567';
      }]
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.fetchClientUser(this.itemId);
    this.fetchRights();
  },
  mounted: function mounted() {},

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.fetchClientUser(newVal);
      this.fetchRights();
    },
    registerNew: function registerNew(newVal, oldVal) {
      if (newVal === true) {
        this.username = null;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])({
    profile: 'getProfile',
    getIsAllow: 'getIsAllow',
    calcDialogScroll: 'calcDialogScroll'
  }), {
    isEdit: function isEdit() {
      return this.edit || this.isNew;
    },
    isNew: function isNew() {
      return this.itemId === null;
    },
    title: function title() {
      return this.isNew ? 'Добавить представителя' : this.isEdit ? 'Изменить атрибуты' : 'Информация о представителе';
    },
    lastnameNotNullRule: function lastnameNotNullRule(name) {
      return this.registerNew ? [function (v) {
        return !!v || 'Введите фамилию';
      }] : [];
    },
    emailRules: function emailRules() {
      return !this.registerNew ? [function (v) {
        return !!v || 'Введите адрес эл. почты, используемый для входа';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      }] : [];
    },
    clientEmailRules: function clientEmailRules() {
      return !this.registerNew ? [function (v) {
        return !v || __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      }] : [function (v) {
        return !!v || 'Введите адрес корпоративной почты';
      }, function (v) {
        return __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].isEmail(v) || 'Неверный формат эл. почты';
      }];
    }
  }),
  methods: {
    calcHeightEditor: function calcHeightEditor() {
      var height = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_number_parse_int___default()(this.calcDialogScroll(48 + 52), 10);
      if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_number_is_nan___default()(height)) {
        return 0;
      }
      return height * 0.4 + 'px';
    },
    onChangePhone: function onChangePhone(item, v) {
      item.clientPhone = __WEBPACK_IMPORTED_MODULE_6__api_formats__["a" /* default */].formatPhone(v);
    },
    add: function add() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('addClientAgent', { username: this.username, dto: this.item });
        this.cancel();
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    save: function save() {
      this.$store.dispatch('updateClientAgent', this.item);
      this.edit = false;
    },
    remove: function remove() {
      __WEBPACK_IMPORTED_MODULE_7__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', 'Удалить представителя компании?', function (self) {
        self.$store.dispatch('removeClientAgent', self.item);
        self.edit = false;
        self.cancel();
      });
    },
    updatePassword: function updatePassword() {
      __WEBPACK_IMPORTED_MODULE_7__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', 'Сбросить пароль?', function (self) {
        self.$store.dispatch('refreshAgentPassword', self.item);
        self.edit = false;
      });
    },
    getItemNew: function getItemNew() {
      return {
        clientInn: this.profile.clientInn,
        accountProfileId: null,
        firstName: null,
        middleName: null,
        lastName: null,
        clientPhone: null,
        clientEmail: null,
        clientRole: null,
        clientRoleNotes: null
      };
    },
    fetchClientUser: function fetchClientUser(accountProfileId) {
      var _this = this;

      if (!!this.profile && !!this.profile.clientInn && !!accountProfileId) {
        __WEBPACK_IMPORTED_MODULE_5__api_server__["a" /* default */].apiGet('/api/clients/' + this.profile.clientInn + '/agents/' + accountProfileId, function (data) {
          _this.item = data;
        }, function (e) {
          _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о представителе компании ' });
          _this.item = _this.getItemNew();
        });
      } else {
        this.item = this.getItemNew();
      }
    },
    fetchRights: function fetchRights() {
      this.$store.dispatch('fetchRights', { AGENT_UPDATE: this.itemId, AGENT_DELETE: this.itemId, AGENT_RESET_PASSWORD: this.itemId });
    },
    editSignature: function editSignature() {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_8__common_forms__["a" /* default */].openEditor(this.item.signature).then(function (data) {
        _this2.item.signature = data;
      });
    }
  }

});

/***/ }),
/* 1005 */,
/* 1006 */,
/* 1007 */,
/* 1008 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [(!_vm.isEdit) ? _c('v-btn', {
          attrs: {
            "disabled": !_vm.getIsAllow({
              AGENT_UPDATE: _vm.itemId
            })
          },
          on: {
            "click": function($event) {
              _vm.edit = !_vm.edit
            }
          }
        }, [_vm._v("Изменить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          attrs: {
            "disabled": !_vm.getIsAllow({
              AGENT_DELETE: _vm.itemId
            })
          },
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Добавить")]) : _vm._e(), _vm._v(" "), _c('v-spacer'), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          attrs: {
            "disabled": !_vm.getIsAllow({
              AGENT_RESET_PASSWORD: _vm.itemId
            })
          },
          on: {
            "click": _vm.updatePassword
          }
        }, [_vm._v("Сбросить пароль")]) : _vm._e()]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [(!_vm.isEdit) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "lastName",
      "value": _vm.item.lastName,
      "label": "Фамилия",
      "type": "text",
      "readonly": "",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "firstName",
      "value": _vm.item.firstName,
      "label": "Имя",
      "type": "text",
      "readonly": "",
      "disabled": ""
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "middleName",
      "value": _vm.item.middleName,
      "label": "Отчество",
      "type": "text",
      "readonly": "",
      "disabled": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.item.clientEmail,
      "name": "clientEmail",
      "label": "Эл. почта рабочая",
      "type": "text",
      "rules": _vm.clientEmailRules,
      "readonly": ""
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "value": _vm.item.clientPhone,
      "rules": _vm.phoneRules,
      "name": "clientPhone",
      "label": "Тел. рабочий",
      "type": "text",
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "value": _vm.item.roleNotes,
      "name": "roleNotes",
      "label": "Зоны ответственности в компании",
      "type": "text",
      "readonly": ""
    }
  })], 1), _vm._v(" "), _c('v-layout', [_c('v-flex', {
    attrs: {
      "pa-0": ""
    }
  }, [_c('v-html-field', {
    attrs: {
      "label": "Подпись в письмах",
      "readonly": "",
      "heightEditor": _vm.calcHeightEditor(),
      "value": _vm.item.signature
    }
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('div', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }],
    attrs: {
      "label": "Эл. почта зарегистрированного пользователя",
      "type": "text",
      "disabled": _vm.registerNew,
      "hint": "Введите адрес, используемый для входа в систему",
      "persistent-hint": "",
      "rules": _vm.emailRules
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('v-checkbox', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }],
    attrs: {
      "label": "Регистрировать нового пользователя",
      "hide-details": ""
    },
    model: {
      value: (_vm.registerNew),
      callback: function($$v) {
        _vm.registerNew = $$v
      },
      expression: "registerNew"
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "lastName",
      "label": "Фамилия",
      "type": "text",
      "disabled": !_vm.registerNew,
      "rules": _vm.lastnameNotNullRule
    },
    model: {
      value: (_vm.item.lastName),
      callback: function($$v) {
        _vm.$set(_vm.item, "lastName", $$v)
      },
      expression: "item.lastName"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "firstName",
      "label": "Имя",
      "type": "text",
      "disabled": !_vm.registerNew
    },
    model: {
      value: (_vm.item.firstName),
      callback: function($$v) {
        _vm.$set(_vm.item, "firstName", $$v)
      },
      expression: "item.firstName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "middleName",
      "label": "Отчество",
      "type": "text",
      "disabled": !_vm.registerNew
    },
    model: {
      value: (_vm.item.middleName),
      callback: function($$v) {
        _vm.$set(_vm.item, "middleName", $$v)
      },
      expression: "item.middleName"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "clientEmail",
      "label": "Эл. почта рабочая",
      "type": "text",
      "rules": _vm.clientEmailRules
    },
    model: {
      value: (_vm.item.clientEmail),
      callback: function($$v) {
        _vm.$set(_vm.item, "clientEmail", $$v)
      },
      expression: "item.clientEmail"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "rules": _vm.phoneRules,
      "name": "clientPhone",
      "label": "Тел. рабочий",
      "type": "text"
    },
    on: {
      "change": function($event) {
        return _vm.onChangePhone(_vm.item, $event)
      }
    },
    model: {
      value: (_vm.item.clientPhone),
      callback: function($$v) {
        _vm.$set(_vm.item, "clientPhone", $$v)
      },
      expression: "item.clientPhone"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "roleNotes",
      "label": "Зоны ответственности в компании",
      "type": "text"
    },
    model: {
      value: (_vm.item.roleNotes),
      callback: function($$v) {
        _vm.$set(_vm.item, "roleNotes", $$v)
      },
      expression: "item.roleNotes"
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-0": ""
    }
  }, [_c('v-html-field', {
    attrs: {
      "label": "Подпись в письмах",
      "heightEditor": _vm.calcHeightEditor(),
      "name": "signature"
    },
    model: {
      value: (_vm.item.signature),
      callback: function($$v) {
        _vm.$set(_vm.item, "signature", $$v)
      },
      expression: "item.signature"
    }
  })], 1)], 1)], 1) : _vm._e()])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1009 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "fill-height": "",
      "px-1": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Компания " + _vm._s(_vm.clientProps.nameShort) + "\n          ")])], 1), _vm._v(" "), _c('v-card-text', [_c('v-form', {
    ref: "profile"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "nameShort",
      "value": _vm.clientProps.nameShort,
      "readonly": "",
      "label": "Название",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "inn",
      "value": _vm.clientProps.inn,
      "readonly": "",
      "label": "ИНН",
      "type": "text"
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "email",
      "value": _vm.clientProps.email,
      "readonly": !_vm.profileEdit,
      "rules": _vm.clientEmailRules,
      "label": "Эл. почта",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "phone",
      "value": _vm.clientProps.phone,
      "readonly": !_vm.profileEdit,
      "rules": _vm.phoneRules,
      "label": "Телефон",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  })], 1), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "address",
      "rows": "3",
      "value": _vm.clientProps.address,
      "readonly": !_vm.profileEdit,
      "label": "Адрес",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  }), _vm._v(" "), _c('v-subheader', [_vm._v("Банковские реквизиты")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "bankDetails.account",
      "value": _vm.clientProps.bankDetails.account,
      "readonly": !_vm.profileEdit,
      "rules": _vm.accountRules,
      "label": "Р/с",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "name": "bankDetails.bankName",
      "rows": "2",
      "value": _vm.clientProps.bankDetails.bankName,
      "readonly": !_vm.profileEdit,
      "label": "Название банка",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs8": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "bankDetails.corrAccount",
      "value": _vm.clientProps.bankDetails.corrAccount,
      "readonly": !_vm.profileEdit,
      "rules": _vm.corrAccountRules,
      "label": "К/с",
      "type": "text",
      "clearable": _vm.profileEdit
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs4": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "bankDetails.bankBic",
      "value": _vm.clientProps.bankDetails.bankBic,
      "readonly": !_vm.profileEdit,
      "label": "БИК",
      "type": "text",
      "clearable": _vm.profileEdit,
      "rules": _vm.bankBicRules
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.profileEdit),
      expression: "!profileEdit"
    }],
    attrs: {
      "disabled": !_vm.getIsAllow({
        CLIENT_UPDATE: null
      })
    },
    on: {
      "click": function($event) {
        _vm.profileEdit = !_vm.profileEdit
      }
    }
  }, [_vm._v("Изменить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileEdit),
      expression: "profileEdit"
    }],
    on: {
      "click": _vm.saveClientProfile
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileEdit),
      expression: "profileEdit"
    }],
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Отменить")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileEdit),
      expression: "profileEdit"
    }],
    on: {
      "click": _vm.updateFromEgrul
    }
  }, [_vm._v("Обновить из ЕГРЮЛ")])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Представители\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        AGENT_CREATE: null
      }),
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addUser()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.clientAccounts), function(item, index) {
    return [_c('v-list-tile', {
      key: item.title,
      on: {
        "click": function($event) {
          return _vm.openUser(item.accountProfileId)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.nameShort))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(item.clientPhone))]), _vm._v(" "), _c('v-list-tile-action-text'), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(item.clientEmail))])], 1)], 1), _vm._v(" "), (index + 1 < _vm.clientAccounts.length) ? _c('v-divider', {
      key: index
    }) : _vm._e()]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Настройка\n          ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-flex', [_c('b', [_vm._v("Мониторинг контрагентов в ЕГРЮЛ.")])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Отслеживание изменений информации о контрагентах полезно для минимизации рисков при заключении договоров.\n            Для активации этой функциональности нажмите кнопку \"Включить\". После активации все \"Мои контрагенты\" будут поставлены на мониторинг и Вы будете получать рассылку об изменениях на почту компании.\n            ")])], 1), _vm._v(" "), _c('v-card-actions', [(!_vm.getClientMonitoring) ? _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": function($event) {
        return _vm.switchMonitoring()
      }
    }
  }, [_vm._v("\n            Включить\n          ")]) : _vm._e(), _vm._v(" "), (_vm.getClientMonitoring) ? _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": function($event) {
        return _vm.switchMonitoring()
      }
    }
  }, [_vm._v("\n            Отключить\n          ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-flex', [_c('b', [_vm._v("Рассылка документов.")])]), _vm._v(" "), (!_vm.clientProps.outgoing && !_vm.outgoingEdit) ? _c('div', [_c('v-flex', [_vm._v("\n            Позволяет в автоматическом режиме посылать документы после подготовки от имени клиента.\n            Для использования функциональности нужно создать почтовый ящик на одном из почтовых сервисах и указать параметры SMTP сервера. Желательно в этом почтовом ящике настроить переадресацию почты на основоой адрес компании, чтобы не потерять отклики адресатов.\n            ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Для активации функциональности нажмите кнопку \"Включить\".\n            ")])], 1) : _vm._e(), _vm._v(" "), (_vm.clientProps.outgoing || _vm.outgoingEdit) ? _c('div', [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Почтовые ящики\n              ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      }),
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openMailbox(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "two-line": ""
    }
  }, [_vm._l((_vm.clientMailboxes), function(item, index) {
    return [_c('v-list-tile', {
      key: item.title,
      on: {
        "click": function($event) {
          return _vm.openMailbox(item)
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.name || item.user))]), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    }), _vm._v(" "), _c('v-list-tile-sub-title', {
      staticClass: "text--primary"
    })], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', [_vm._v(_vm._s(item.host))]), _vm._v(" "), _c('v-list-tile-action-text'), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(item.user))])], 1)], 1)]
  })], 2)], 1)], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [(!_vm.clientProps.outgoing && !_vm.outgoingEdit) ? _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": function($event) {
        _vm.outgoingEdit = true
      }
    }
  }, [_vm._v("\n            Включить\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.outgoingEdit),
      expression: "outgoingEdit"
    }],
    on: {
      "click": _vm.saveClientProfileOutgoing
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.outgoingEdit),
      expression: "outgoingEdit"
    }],
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Отменить")]), _vm._v(" "), (!_vm.outgoingEdit && _vm.clientProps.outgoing) ? _c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": function($event) {
        return _vm.turnOffOutgoing()
      }
    }
  }, [_vm._v("\n            Отключить\n          ")]) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "100%"
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Дополнительная информация\n          ")])], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileAddEdit),
      expression: "profileAddEdit"
    }]
  }, [_c('v-form', {
    ref: "profileAdd"
  }, [_c('v-textarea', {
    attrs: {
      "name": "about",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.about,
      "label": "О компании",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "website",
      "value": _vm.clientProps.website,
      "label": "Интернет сайт",
      "type": "text"
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "contacts",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.contacts,
      "label": "Контакты",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "services",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.services,
      "label": "Товары и услуги",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "price",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.price,
      "label": "Цены",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "prepend-icon": "attach_file",
      "auto-grow": "",
      "rows": "1",
      "name": "docs",
      "value": _vm.clientProps.docs,
      "label": "Публичные документы",
      "type": "text",
      "clearable": ""
    },
    on: {
      "click:prepend": _vm.openDocSelector
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "tags",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.tags,
      "label": "Поисковые Теги",
      "type": "text",
      "clearable": ""
    }
  }), _vm._v(" "), _c('v-textarea', {
    attrs: {
      "name": "other",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.clientProps.other,
      "label": "Разное",
      "type": "text",
      "clearable": ""
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.profileAddEdit),
      expression: "!profileAddEdit"
    }]
  }, [_c('v-client-preview', {
    attrs: {
      "clientProfile": _vm.clientProps
    }
  }), _vm._v(" "), _c('div', {
    ref: "htmlDiv"
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.profileAddEdit),
      expression: "!profileAddEdit"
    }],
    attrs: {
      "disabled": !_vm.getIsAllow({
        CLIENT_UPDATE: null
      })
    },
    on: {
      "click": function($event) {
        _vm.profileAddEdit = !_vm.profileAddEdit
      }
    }
  }, [_vm._v("Изменить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileAddEdit),
      expression: "profileAddEdit"
    }],
    on: {
      "click": _vm.saveClientProfileAdd
    }
  }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.profileAddEdit),
      expression: "profileAddEdit"
    }],
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("Отменить")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1011),
  /* template */
  __webpack_require__(1118),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1011 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientList_vue__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ClientList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ClientList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__info_ClientPage_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__info_ClientPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__info_ClientPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__info_HumanPage_vue__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__info_HumanPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__info_HumanPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_ForeignPage_vue__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_ForeignPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__info_ForeignPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__info_ForeignAgencyPage_vue__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__info_ForeignAgencyPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__info_ForeignAgencyPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__info_LonerPage_vue__ = __webpack_require__(1106);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__info_LonerPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__info_LonerPage_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'client-panel',
  components: { vClientList: __WEBPACK_IMPORTED_MODULE_2__ClientList_vue___default.a, vClientPage: __WEBPACK_IMPORTED_MODULE_3__info_ClientPage_vue___default.a, vHumanPage: __WEBPACK_IMPORTED_MODULE_4__info_HumanPage_vue___default.a, vForeignPage: __WEBPACK_IMPORTED_MODULE_5__info_ForeignPage_vue___default.a, vForeignAgencyPage: __WEBPACK_IMPORTED_MODULE_6__info_ForeignAgencyPage_vue___default.a, vLonerPage: __WEBPACK_IMPORTED_MODULE_7__info_LonerPage_vue___default.a },
  props: {},
  data: function data() {
    return {
      isRoot: true,
      itemId: null,
      humanId: null,
      foreignId: null,
      fagencyId: null,
      lonerId: null
    };
  },
  created: function created() {
    this.setItemId();
  },
  mounted: function mounted() {
    this.setItemId();
  },

  watch: {
    // в случае изменения маршрута запрашиваем данные вновь
    '$route': function $route() {
      this.setItemId();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({}), {
    title: function title() {}
  }),
  methods: {
    setItemId: function setItemId() {
      if (this.$route.params.humanId) {
        this.humanId = this.$route.params.humanId;
      } else {
        this.humanId = null;
      }
      if (this.$route.params.foreignId) {
        this.foreignId = this.$route.params.foreignId;
      } else {
        this.foreignId = null;
      }
      if (this.$route.params.fagencyId) {
        this.fagencyId = this.$route.params.fagencyId;
      } else {
        this.fagencyId = null;
      }
      if (this.$route.params.ogrnip) {
        this.lonerId = this.$route.params.ogrnip;
      } else {
        this.lonerId = null;
      }
      if (this.$route.params.clientInn) {
        this.itemId = this.$route.params.clientInn;
        this.profileId = this.$route.query.profileId;
      } else {
        this.itemId = null;
        this.profileId = null;
      }
      if (!this.humanId && !this.foreignId && !this.itemId && !this.fagencyId && !this.lonerId) {
        this.isRoot = true;
      } else {
        this.isRoot = false;
      }
    }
  }
});

/***/ }),
/* 1012 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1013),
  /* template */
  __webpack_require__(1014),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_CardScroll__);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var CopyInnAction = function (_classes$Action) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CopyInnAction, _classes$Action);

  function CopyInnAction(context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CopyInnAction);

    return _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CopyInnAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CopyInnAction)).call(this, context, 'Копировать в буфер обмена', null, function () {
      _this.context.copyInnToClipboard(_this.context.cxt.selectedIds);
    }));
  }

  return CopyInnAction;
}(__WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].Action);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'search-set',
  components: { vOpsBtn: __WEBPACK_IMPORTED_MODULE_9__common_OpsBtn___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_10__common_CardScroll___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_8__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      tags: [],
      cxt: null,
      searchString: null
    };
  },
  created: function created() {
    var _this2 = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this2.filteredItems.map(function (item) {
        return _this2.getItemKey(item);
      });
    });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].FilterEndAction(cxt));
    // cxt.actions.push(new classes.ActiveScopeAction(cxt))
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].AllScopeAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].SelectAction(cxt));
    cxt.actions.push({ divider: true });

    // cxt.selectActions.push(new classes.FilterAction(cxt))
    // cxt.selectActions.push(new classes.FilterEndAction(cxt))
    cxt.selectActions.push(new CopyInnAction(this));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].SelectAllAction(cxt));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_7__api_classes__["a" /* default */].SelectEndAction(cxt));

    cxt.title = 'Компании';
    cxt.titleIcon = 'search';
    cxt.selectTitle = 'Поиск компании';
    cxt.filterMode = true;

    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.loadData();
    this.setActivated();
  },

  props: {
    itemId: {
      type: String,
      default: null
    },
    tagIds: {
      type: Array,
      default: null
    }
  },
  watch: {
    itemId: function itemId(newVal, oldVal) {// watch it
    },
    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      this.loadData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    getItemSet: 'getSearchSet',
    getProfileHaveClient: 'getProfileHaveClient',
    getRefToUrl: 'getRefToUrl',
    renderReference: 'renderReference',
    renderHeads: 'renderHeads',
    renderFlags: 'renderFlags',
    renderInnOrInnflHtml: 'renderInnOrInnflHtml'
  }), {
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.filteredItems.length + '' : '';
      } else {
        return !this.getItemSet.isLast() ? label + this.filteredItems.length + ' первых' : label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '';
      }
    },
    items: function items() {
      return this.getItemSet.getItems();
    },
    orderedItems: function orderedItems() {
      return this.items;
    },
    filteredItems: function filteredItems() {
      var _this3 = this;

      var getSearchString = function getSearchString(item) {
        return ''.concat(item.ref.ref, item.ref.caption, item.ref.name, _this3.renderHeads(item.ref), item.ref.inn, item.ref.kpp,
        // this.formatDate(item.company.createDate),
        // this.formatDate(item.company.releaseDate),
        item.ref.address, item.notes, item.privateNotes);
      };
      var filter = !this.cxt.isFilterMode() || this.cxt.filterString === null || this.cxt.filterString.length < 0 ? null : this.cxt.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      var result = this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
      return result;
    }
  }),
  methods: {
    changeFilterContext: function changeFilterContext(ops, force) {
      this.$store.commit('setSearchFilterContext', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), ops));
      var self = this;
      setTimeout(function () {
        self.$store.dispatch('fetchSearchCompanies', force);
        self.scrollToActive();
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
    },
    nextPage: function nextPage() {
      this.$store.commit('nextSearchCompanies');
      this.$store.dispatch('fetchSearchCompanies');
    },
    loadData: function loadData() {
      if (this.getProfileHaveClient) {
        this.searchString = this.getItemSet.getFilter().search;
        this.fetchData();
      }
    },
    fetchData: function fetchData() {
      var search = this.searchString ? this.searchString : '';
      this.changeFilterContext({ search: search });
    },
    getItemKey: function getItemKey(item) {
      if (!item) {
        return null;
      }
      return item.ref.ref + '_' + item.ref.inn;
    },
    getInnfromKey: function getInnfromKey(key) {
      return key && key.split('_').length > 0 ? key.split('_')[1] : null;
    },
    renderCompanyFlags: function renderCompanyFlags(item) {
      return this.renderFlags(item.ref.flags);
    },
    search: function search() {
      this.fetchData();
    },

    copyInnToClipboard: function copyInnToClipboard(selectedIds) {
      var _this4 = this;

      if (Array.isArray(selectedIds)) {
        var values = selectedIds.map(function (selectedId) {
          return _this4.getInnfromKey(selectedId);
        });
        var text = values.join(', ');
        this.$store.dispatch('copyToClipboard', { text: text });
        this.cxt && this.cxt.toViewMode();
      }
    },
    scrollToActive: function scrollToActive() {
      var _this5 = this;

      this.$nextTick(function () {
        _this5.$refs.cardScroll.scrollToListActive();
      });
    },
    setActivated: function setActivated() {
      if (this.$router && this.$router.options && this.$router.options.from) {
        var from = this.$router.options.from;
        if (from.params && from.params.clientInn) {
          var itemId = from.params.clientInn;
          var item = this.items.find(function (i) {
            return '' + i.ref.ogrn === itemId;
          });
          if (item) {
            this.cxt.activate(this.getItemKey(item));
          } else {
            this.$store.commit('setInfoStatus', 'Позиционировать не удалось, возможно выборка была изменена. ');
          }
        }
      }
    }
  }
});

/***/ }),
/* 1014 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.getItemSet.isProcessing(),
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "autofocus": "",
      "label": "Введите запрос",
      "hint": "Название, ИНН, руководитель, учредитель, адрес",
      "clearable": "",
      "persistent-hint": ""
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.search.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.searchString),
      callback: function($$v) {
        _vm.searchString = $$v
      },
      expression: "searchString"
    }
  }), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.search
    }
  }, [_vm._v("Искать")])], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      attrs: {
        "value": _vm.cxt.activated(_vm.getItemKey(item)),
        "active-class": "v-list__tile--highlighted"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.cxt.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.ref))
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n               " + _vm._s(_vm.renderHeads(item.ref)) + "\n               "), _c('br'), _vm._v("\n               ИНН: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnOrInnflHtml(item.ref.inn))
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(_vm.formats.blank(item.ref.address)))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.accountId),
        expression: "item.accountId"
      }]
    }, [_vm._v("star")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.accountId),
        expression: "!item.accountId"
      }]
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ref.clientId),
        expression: "item.ref.clientId"
      }]
    }, [_vm._v("person")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.ref.clientId),
        expression: "!item.ref.clientId"
      }]
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('div', [_c(_vm.renderCompanyFlags(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('v-list-tile-action-text', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.ref.createDate, _vm.formats.formatDate)))])]), _vm._v("\n               Регистрация\n             ")], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__client_ClientPreview__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__client_ClientPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__client_ClientPreview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientPreviewPanel__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__ClientPreviewPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__ClientPreviewPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompanyPanel__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__CompanyPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__CompanyPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActivitiesPanel__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ActivitiesPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__ActivitiesPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TaxPayPanel__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__TaxPayPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__TaxPayPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ManagedsPanel__ = __webpack_require__(1028);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ManagedsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ManagedsPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ChildrenPanel__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ChildrenPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__ChildrenPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HoldersPanel__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__HoldersPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__HoldersPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ArrearsPanel__ = __webpack_require__(1037);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ArrearsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ArrearsPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AssigneesPanel__ = __webpack_require__(1040);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__AssigneesPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__AssigneesPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BranchesPanel__ = __webpack_require__(1043);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__BranchesPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__BranchesPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EnforcementsPanel__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__EnforcementsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__EnforcementsPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__EnforcementDebtsPanel__ = __webpack_require__(1055);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__EnforcementDebtsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__EnforcementDebtsPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LicensesPanel__ = __webpack_require__(1058);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__LicensesPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__LicensesPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TrademarksPanel__ = __webpack_require__(1063);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__TrademarksPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_19__TrademarksPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ReorgPanel__ = __webpack_require__(1069);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__ReorgPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20__ReorgPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RecordsPanel__ = __webpack_require__(1072);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__RecordsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21__RecordsPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__HistoryPanel__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__HistoryPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22__HistoryPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__NotesForm__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__NotesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23__NotesForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__FinPanel__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__FinPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_24__FinPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__VisitPanel__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__VisitPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_25__VisitPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__info_ContactsPanel__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__info_ContactsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_26__info_ContactsPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__info_BanksPanel__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__info_BanksPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_27__info_BanksPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__info_CredentinalsPanel__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__info_CredentinalsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_28__info_CredentinalsPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__info_LinksPanel__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__info_LinksPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_29__info_LinksPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__common_dialogs__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import server from '../../api/server'






























/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'client-page',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_3__common_CardScroll___default.a, vClientPreview: __WEBPACK_IMPORTED_MODULE_4__client_ClientPreview___default.a, vClientPreviewPanel: __WEBPACK_IMPORTED_MODULE_5__ClientPreviewPanel___default.a, vCompanyPanel: __WEBPACK_IMPORTED_MODULE_6__CompanyPanel___default.a, vActivitiesPanel: __WEBPACK_IMPORTED_MODULE_7__ActivitiesPanel___default.a, vTaxPayPanel: __WEBPACK_IMPORTED_MODULE_8__TaxPayPanel___default.a, vPanelTitle: __WEBPACK_IMPORTED_MODULE_12__PanelTitle___default.a, vManagedsPanel: __WEBPACK_IMPORTED_MODULE_9__ManagedsPanel___default.a, vChildrenPanel: __WEBPACK_IMPORTED_MODULE_10__ChildrenPanel___default.a, vHoldersPanel: __WEBPACK_IMPORTED_MODULE_11__HoldersPanel___default.a, vArrearsPanel: __WEBPACK_IMPORTED_MODULE_13__ArrearsPanel___default.a, vAssigneesPanel: __WEBPACK_IMPORTED_MODULE_14__AssigneesPanel___default.a, vBranchesPanel: __WEBPACK_IMPORTED_MODULE_15__BranchesPanel___default.a, vEnforcementsPanel: __WEBPACK_IMPORTED_MODULE_16__EnforcementsPanel___default.a, vEnforcementDebtsPanel: __WEBPACK_IMPORTED_MODULE_17__EnforcementDebtsPanel___default.a, vLicensesPanel: __WEBPACK_IMPORTED_MODULE_18__LicensesPanel___default.a, vTrademarksPanel: __WEBPACK_IMPORTED_MODULE_19__TrademarksPanel___default.a, vReorgPanel: __WEBPACK_IMPORTED_MODULE_20__ReorgPanel___default.a, vRecordsPanel: __WEBPACK_IMPORTED_MODULE_21__RecordsPanel___default.a, vHistoryPanel: __WEBPACK_IMPORTED_MODULE_22__HistoryPanel___default.a, vFinPanel: __WEBPACK_IMPORTED_MODULE_24__FinPanel___default.a, vVisitPanel: __WEBPACK_IMPORTED_MODULE_25__VisitPanel___default.a, vContactsPanel: __WEBPACK_IMPORTED_MODULE_26__info_ContactsPanel___default.a, vBanksPanel: __WEBPACK_IMPORTED_MODULE_27__info_BanksPanel___default.a, vCredentinalsPanel: __WEBPACK_IMPORTED_MODULE_28__info_CredentinalsPanel___default.a, vLinksPanel: __WEBPACK_IMPORTED_MODULE_29__info_LinksPanel___default.a },
  data: function data() {
    return {
      clientCompanyId: null,
      refCode: null,
      banks: [],
      company: null,
      favoriteLists: null,
      privateNotes: null,
      notes: null,
      tags: null,
      monitoring: false,
      accountNameShort: null,
      otherAttribs: [],
      isReorg: false
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'page'
    }
  },
  created: function created() {
    this.initCompany();
  },
  mounted: function mounted() {
    if (this.itemId) {
      console.log('fetchCompanyProps mounted', this.itemId);
      this.fetchCompanyProps(this.itemId);
    }
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      if (newVal) {
        console.log('fetchCompanyProps watch', newVal, oldVal);
        this.fetchCompanyProps(newVal);
      } else {}
    },
    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      console.log('getProfileHaveClient', newVal, oldVal);
      this.refreshCompanyProps();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    profile: 'getProfile',
    getClientUrl: 'getClientUrl',
    getRefToUrl: 'getRefToUrl',
    getProfileHaveClient: 'getProfileHaveClient',
    getClientProfile: 'getClientProfile',
    getClientCompany: 'getClientCompany',
    getIsAuthorized: 'getIsAuthorized',
    calcDialogOfs: 'calcDialogOfs',
    calcOfs: 'calcOfs'
  })),
  methods: {
    calcOffset: function calcOffset(off, offModal) {
      return this.calcOfs(off, offModal);
    },
    getOtherAttribsNameShort: function getOtherAttribsNameShort() {
      var result = this.otherAttribs.reduce(function (s, i) {
        return s + i.accountNameShort + ', ';
      }, '');
      return result.length > 2 ? result.slice(0, -2) : result;
    },
    createButton: function createButton(caption, icon, hint, action) {
      var template = ''.concat('<v-tooltip top open-delay="500">\n            <div slot="activator">\n              <v-btn flat  @click="action">\n                <v-icon left>{{icon}}</v-icon>{{caption}}\n              </v-btn>\n            </div>\n            <span>{{hint}}</span>\n          </v-tooltip>');
      return {
        template: template,
        data: function data() {
          return {
            caption: caption,
            icon: icon,
            hint: hint,
            action: action
          };
        }
      };
    },
    fetchCompanyProps: function fetchCompanyProps(inn) {
      var _this = this;

      this.initCompany();
      this.$store.dispatch('getCompanyProps', inn).then(function (data) {
        _this.company = data;
        if (_this.company) {
          _this.fetchFavoriteProps(_this.company.ogrn);
          _this.fetchClientCompany();
        }
      });
    },
    fetchFavoriteProps: function fetchFavoriteProps(ogrn) {
      var _this2 = this;

      var refCode = __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].isOgrn(ogrn) ? 'ogrn:' + ogrn : null;
      this.$store.dispatch('getFavoriteRefs', refCode).then(function (data) {
        if (!Array.isArray(data) || data.length < 1) {
          console.log('fetchCompanyProps', data);
          return;
        }
        if (_this2.getProfileHaveClient) {
          _this2.clientCompanyId = data[0].clientCompanyId;
          _this2.banks = data[0].banks;
          _this2.favoriteLists = data[0].tags;
          _this2.privateNotes = data[0].privateNotes;
          _this2.notes = data[0].notes;
          _this2.tags = data[0].tags;
          _this2.monitoring = data[0].monitoring;
          _this2.accountNameShort = data[0].accountNameShort;
          _this2.otherAttribs = data.slice(1);
          _this2.refCode = refCode;
        } else {
          _this2.clientCompanyId = null;
          _this2.banks = [];
          _this2.favoriteLists = null;
          _this2.privateNotes = null;
          _this2.notes = null;
          _this2.tags = null;
          _this2.monitoring = false;
          _this2.accountNameShort = null;
          _this2.otherAttribs = [];
          _this2.refCode = null;
        }
      });
    },
    fetchClientCompany: function fetchClientCompany() {
      var _this3 = this;

      if (this.getProfileHaveClient && !this.getClientCompany) {
        this.$store.dispatch('getCompanyProps', this.profile.clientInn).then(function (data) {
          _this3.$store.commit('setClientCompany', data);
          _this3.$store.dispatch('fetchClientProfile');
        });
      }
    },
    refreshCompanyProps: function refreshCompanyProps() {
      if (this.itemId) {
        this.fetchCompanyProps(this.itemId);
      }
    },
    invite: function invite() {
      var email = '';
      var subject = 'Приглашение работать через Систему "АТЛАНТ-СМАРТ"';
      var emailHeader = this.company.head ? this.company.head.firstName + ' ' + this.company.head.middleName + ',' : 'Господа,';
      var emailBody = emailHeader + '\n' + '\n Предлагаем Вам использовать Систему "АТЛАНТ-СМАРТ" для ' + '\n\t продолжения нашего делового общения,' + '\n\t депонирования файлов и ' + '\n\t оперативного заключения договоров в электронной форме.' + '\n' + '\n Ссылка для регистрации в системе:' + '\n https://atlant-smart.ru/#/register' + '\n' + '\n С уважением, ' + this.profile.nameShort + '\n' + this.profile.clientNameShort;
      this.$store.dispatch('mailTo', { email: email, subject: subject, emailBody: emailBody });
    },
    initCompany: function initCompany() {
      this.company = {
        ogrn: null,
        ogrnDate: null,
        releaseDate: null,
        inn: null,
        kpp: null,
        nameShort: '',
        name: '',
        address: '',
        clientId: null,
        activities: [],
        head: {
          position: '',
          lastName: '',
          firstName: '',
          middleName: ''
        }
      };
    },
    copyLink: function copyLink() {
      var refCode = __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].getValue(this.company, ['reference', 'ref']);
      this.$store.dispatch('copyCompanyLink', this.getClientUrl(refCode));
    },
    addFavorite: function addFavorite() {
      var refCode = __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].getValue(this.company, ['reference', 'ref']);
      if (refCode) {
        this.$store.dispatch('addFavoriteCompany', { refCode: refCode, tags: this.tags ? this.tags.map(function (t) {
            return t.id;
          }) : null });
        this.refreshCompanyProps();
      }
    },
    dialogOpenFavorite: function dialogOpenFavorite() {
      var self = this;
      var setNotes = function setNotes(data) {
        // if (self.notes || self.notes && self.notes.localeCompare(data) !== 0) {
        self.refreshCompanyProps();
        // }
      };
      __WEBPACK_IMPORTED_MODULE_30__common_dialogs__["a" /* default */].register('v-notes-form', __WEBPACK_IMPORTED_MODULE_23__NotesForm___default.a);
      var comp = { template: '\n        <v-notes-form v-on:input="setNotes" v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-notes-form>\n      ',
        data: function data() {
          return {
            model: { clientCompanyId: self.clientCompanyId, banks: self.banks, company: self.company, notes: self.notes, privateNotes: self.privateNotes, tags: self.tags, monitoring: self.monitoring },
            setNotes: setNotes,
            fullscreen: self.$vuetify.breakpoint.xsOnly
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_30__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__client_ClientPreview__ = __webpack_require__(247);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__client_ClientPreview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__client_ClientPreview__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-client-preview-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default.a, vClientPreview: __WEBPACK_IMPORTED_MODULE_4__client_ClientPreview___default.a },
  data: function data() {
    return {
      id: null,
      item: null,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    inn: {
      type: Number,
      default: null
    },
    clientId: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.item = this.getItemNew();
    this.id = this.inn;
  },

  watch: {
    inn: function inn(newVal, oldVal) {
      // watch it
      this.id = this.inn;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({})),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && (!this.item.inn || this.item.inn.length === 0)) {
        this.fetchItems();
      }
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о клиенте для компании ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/client', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (this.id && !this.isLoading) {
        this.item = this.getItemNew();
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this2.isLoading = false;
          _this2.item = data;
        });
      }
    },
    getItemNew: function getItemNew() {
      return {
        inn: '',
        email: '',
        nameShort: '',
        address: '',
        phone: '',
        website: '',
        notes: '',
        about: '',
        contacts: '',
        services: '',
        price: '',
        docs: '',
        tags: '',
        other: ''
      };
    }
  }
});

/***/ }),
/* 1017 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": !!this.clientId
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inn && !!_vm.clientId),
      expression: "inn && !!clientId"
    }]
  }, [_c('b', [_vm._v("Компания использует Систему \"АТЛАНТ-СМАРТ\" ")])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inn && !_vm.clientId),
      expression: "inn && !clientId"
    }]
  }, [_c('b', [_vm._v("Компания пока не использует Систему \"АТЛАНТ-СМАРТ\".")])])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('v-client-preview', {
    attrs: {
      "clientProfile": _vm.item
    }
  })], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1018 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1019),
  /* template */
  __webpack_require__(1022),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotesForm__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__NotesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__NotesForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__people_index_js__ = __webpack_require__(27);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-company-panel',
  components: {},
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_apimix__["a" /* default */]],
  data: function data() {
    return {};
  },
  props: {
    clientCompanyId: {
      type: Number,
      default: null
    },
    banks: {
      type: Array,
      default: []
    },
    company: {
      type: Object,
      default: function _default() {
        return this.getItemNew();
      }
    },
    monitoring: {
      type: Boolean,
      default: false
    },
    notesAvailable: {
      type: Boolean,
      default: false
    },
    notesEditable: {
      type: Boolean,
      default: false
    },
    privateNotes: {
      type: String,
      default: null
    },
    notes: {
      type: String,
      default: null
    },
    tags: {
      type: Array,
      default: null
    },
    otherAttribs: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getRefToUrl: 'getRefToUrl',
    getClientProfile: 'getClientProfile',
    getClientCompany: 'getClientCompany',
    renderInnHtml: 'renderInnHtml',
    renderInnflHtml: 'renderInnflHtml',
    renderDateSince: 'renderDateSince',
    renderStatus: 'renderStatus',
    renderFlags: 'renderFlags',
    renderUnreliableHtml: 'renderUnreliableHtml',
    renderReference: 'renderReference',
    renderEmployeeReference: 'renderEmployeeReference',
    getIconName: 'getIconName',
    getEmailHeaderReport: 'getEmailHeaderReport',
    getAgreementHeader1Report: 'getAgreementHeader1Report',
    getAgreementHeader2Report: 'getAgreementHeader2Report',
    getAgreementFooterReport: 'getAgreementFooterReport',
    getClientEnvelopeReport: 'getClientEnvelopeReport',
    renderCopyButton: 'renderCopyButton',
    renderContactButton: 'renderContactButton',
    renderValueLink: 'renderValueLink'
  })),
  methods: {
    formatDate: function formatDate(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(dateTime);
    },
    formatDateAt: function formatDateAt(valueDTO) {
      if (!valueDTO || !valueDTO.created && !valueDTO.updated) {
        return '';
      }
      var result = '';
      result = result.concat('(на', '\xa0', valueDTO.created ? this.formatDate(valueDTO.created) : this.formatDate(valueDTO.updated), ')');
      return result;
    },
    renderInnHtmlBold: function renderInnHtmlBold(inn) {
      return '<b>' + this.renderInnHtml(inn) + '</b>';
    },
    formatStatus: function formatStatus(status) {
      return ''.concat('<div>', 'Статус в ЕГРЮЛ: ', this.renderStatus(status), '</div>');
    },
    formatTaxMode: function formatTaxMode(taxMode) {
      if (!taxMode || !taxMode.isEnvd && !taxMode.isEshn && !taxMode.isUsn && !taxMode.isSpr) {
        return '';
      }
      var arr = [];
      if (taxMode.isUsn) {
        arr.push('Упрощенная система налогообложения (УСН)');
      }
      if (taxMode.isEnvd) {
        arr.push('Единый налог на вменённый доход (ЕНВД)');
      }
      if (taxMode.isSpr) {
        arr.push('Система налогообложения при выполнении соглашений о разделе продукции (СРП)');
      }
      if (taxMode.isEshn) {
        arr.push('Единый сельскохозяйственный налог (ЕСХН)');
      }
      return ''.concat('<div>', 'Налоговый режим: ', '<b>', arr.join(', '), '</b> ', this.formatDateAt(taxMode), '<div>');
    },
    createNameComp: function createNameComp(company) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            <b><span v-html="getDto()"></span></b>\n            {{self.renderDateSince(dto)}}\n             <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\', self.getCompanyNameFull)" />\n             <v-component :is="self.createAddMonitoringButton()" />\n          </div>\n          <div>\n           <span v-html="self.renderUnreliableHtml(dto)"></span>\n          </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            company: company,
            dto: company.name,
            formats: __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */]
          };
        },
        methods: {
          getDto: function getDto() {
            return this.dto && this.dto.value ? this.dto.value : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись о названии компании');
          },
          getCompanyNameFull: function getCompanyNameFull() {
            return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(self.company, ['name', 'value']);
          }
        }
      };
    },
    createNameShortComp: function createNameShortComp(company) {
      return this.renderValueLink(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].blank(this.getCompanyNameShort()), 'Сокращенное название:', null, 'Копировать название');
    },
    createAddressComp: function createAddressComp(company) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            \u0410\u0434\u0440\u0435\u0441: <b><span v-html="getDto()"></span></b>\n            {{self.renderDateSince(dto)}}\n            <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0434\u0440\u0435\u0441\', self.getCompanyAddress)" />\n\n          </div>\n          <div>\n           <span v-html="self.renderUnreliableHtml(dto)"></span>\n          </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            company: company,
            dto: company.address,
            formats: __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */]
          };
        },
        methods: {
          getDto: function getDto() {
            return this.dto && this.dto.value ? this.dto.value : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись об адресе компании');
          }
        }
      };
    },
    createHeadsComp: function createHeadsComp(heads, management) {
      var self = this;
      var template = '\n      <div>\n        <b v-if="(!heads || heads.length === 0) && !management">' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись о руководителе компании') + '</b>\n        <template v-for="head in heads">\n          <v-component :is="self.createEmployeeComp(head)"/>\n        </template>\n      </div>\n      ';
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            heads: heads,
            management: management
          };
        }
      };
    },
    createEmployeeComp: function createEmployeeComp(employee) {
      var self = this;
      var template = '\n      <div>\n      <div>\n        {{employee.position}}\n        <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C\', getPosition)" /> :\n      </div>\n      <span v-html="self.renderEmployeeReference(employee)"></span>\n      <b> ' + self.formatHumanCountersHtml(employee.counters) + ' </b>\n      <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0418\u041E\', getNameFull)" />\n      <v-component :is="self.renderContactButton(\'\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430\', openContact)" />\n        <div>\n          \u0418\u041D\u041D <b>' + self.renderInnflHtml(employee.inn) + '</b>\n          <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0418\u041D\u041D\', getInn)" />\n        </div>\n        <div> ' + self.renderDateSince(employee) + '</div>\n        <div> ' + self.renderUnreliableHtml(employee) + '</div>\n        <div> ' + self.formatDisqHtml(employee.disqualification) + '</div>\n        <div> ' + self.formatDisqCountersHtml(employee.counters, employee.disqualification) + '</div>\n      </div>\n      ';
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            employee: employee
          };
        },
        methods: {
          getPosition: function getPosition() {
            return self.getCompanyEmployeePosition(employee);
          },
          getNameFull: function getNameFull() {
            return self.getCompanyEmployeeNameFull(employee);
          },
          getInn: function getInn() {
            return self.getCompanyEmployeeInn(employee);
          },
          openContact: function openContact() {
            var refCode = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(self.company, ['reference', 'ref']);
            __WEBPACK_IMPORTED_MODULE_7__people_index_js__["a" /* default */].openByHuman(refCode, employee);
          }
        }
      };
    },
    createManagementComp: function createManagementComp(management) {
      var self = this;
      // Агент: <v-component :is="self.renderReference(management.agent)" />
      var template = '\n      <div>\n        <div v-if="management.ref">\n          \u0423\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0430\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\n          <v-flex> \n          <span v-html="self.renderReference(management.ref.value, \'_blank\')"></span>\n          <span v-html="self.renderDateSince(management.ref)"></span>\n          </v-flex>\n          <v-flex v-if="management.refAddress"> \u0410\u0434\u0440\u0435\u0441: {{management.refAddress}}</v-flex>\n          <v-flex v-if="management.refPhone"> \u0422\u0435\u043B\u0435\u0444\u043E\u043D: {{management.refPhone}}</v-flex>\n        </div>\n        <div v-if="management.agent">\n          \u0410\u0433\u0435\u043D\u0442: \n          span v-html="self.renderReference(management.agent.value, \'_blank\')"></span>\n          <span v-html="self.renderDateSince(management.agent)"></span>\n          <div v-if="management.agentPhone"> \u0442\u0435\u043B\u0435\u0444\u043E\u043D: {{management.agentPhone}}</div> \n        </div>\n        <div> ' + self.renderUnreliableHtml(management) + '</div>\n      </div>          \n      ';
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            management: management
          };
        }
      };
    },
    formatHumanCountersHtml: function formatHumanCountersHtml(counters) {
      var _f = function _f(v) {
        return v !== null ? v : 'нет данных';
      };
      if (!counters) {
        return '<div></div>';
      }
      var result = ''.concat('<v-tooltip bottom>', '<span slot="activator">', '<v-icon small>' + this.getIconName('head') + '</v-icon>' + _f(counters.managedCompaniesExact) + '(' + _f(counters.managedCompaniesGeneral) + ')&nbsp', '<v-icon small>' + this.getIconName('holder') + '</v-icon>' + _f(counters.sharedCompaniesExact) + '(' + _f(counters.sharedCompaniesGeneral) + ')', '<v-icon small>' + this.getIconName('loner') + '</v-icon>' + _f(counters.loners), '</span>', '<span>\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0438 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\u0445, \u043D\u0430\u043B\u0438\u0447\u0438\u0435 \u0418\u041F <br/> \u0442\u043E\u0447\u043D\u043E\u0435 (\u043D\u0435 \u0442\u043E\u0447\u043D\u043E\u0435) \u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0435</span>', '</v-tooltip>');
      return result;
    },
    formatDisqHtml: function formatDisqHtml(disq) {
      if (!disq) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatErrorHtml('\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u0446\u0438\u044F \u0441 ' + this.formatDate(disq.fromDate) + ' \u043F\u043E ' + this.formatDate(disq.toDate) + ' \u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u043E\u0442 ' + this.formatDate(disq.decisionDate));
    },
    formatDisqCountersHtml: function formatDisqCountersHtml(counters, disq) {
      if (counters.disqualificationsGeneral) {
        if (counters.disqualificationsGeneral > 1 || !disq && counters.disqualificationsGeneral > 0) {
          return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('\u041D\u0430\u0439\u0434\u0435\u043D\u044B \u0434\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438 \u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\u0445!');
        }
      }
      return '';
    },
    createCopyButton: function createCopyButton(caption, icon, hint, action) {
      var template = ''.concat('<div><v-tooltip bottom open-delay="500">\n          <div slot="activator">\n            <v-btn  small flat  @click="self.copyToClipboard(action)">\n              <v-icon small>{{icon}}</v-icon>{{caption}}\n            </v-btn>\n          </div>\n          <span>{{hint}}</span>\n        </v-tooltip></div>');
      var self = this;
      return {
        template: template,
        data: function data() {
          return {
            caption: caption,
            icon: icon,
            hint: hint,
            action: action,
            self: self
          };
        }
      };
    },
    getCompanyNameFull: function getCompanyNameFull() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.company, ['name', 'value']);
    },
    getCompanyNameShort: function getCompanyNameShort() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.company, ['nameShort']);
    },
    getCompanyOgrn: function getCompanyOgrn() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.company, ['ogrn']);
    },
    getCompanyInn: function getCompanyInn() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInn(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.company, ['inn']));
    },
    getCompanyKpp: function getCompanyKpp() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.company, ['kpp']);
    },
    getCompanyAddress: function getCompanyAddress() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.company, ['address', 'value']);
    },
    getCompanyEmployeePosition: function getCompanyEmployeePosition(employee) {
      console.log('getCompanyEmployeePosition', employee);
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(employee, ['position']);
    },
    getCompanyEmployeeNameFull: function getCompanyEmployeeNameFull(employee) {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(employee, ['nameFull']);
    },
    getCompanyEmployeeInn: function getCompanyEmployeeInn(employee) {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInnfl(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(employee, ['inn']));
    },
    createAddMonitoringButton: function createAddMonitoringButton() {
      var template = ''.concat('<span v-show="!self.monitoring"><v-tooltip bottom open-delay="500">\n          <span slot="activator">\n            <v-btn style="margin:0" small icon @click="onClick">\n              <v-icon small>{{icon}}</v-icon>\n            </v-btn>\n          </span>\n          <span>{{hint}}</span>\n        </v-tooltip></span>');
      var self = this;
      return {
        template: template,
        data: function data() {
          return {
            icon: 'alarm_add',
            hint: 'Включить мониторинг',
            self: self
          };
        },
        methods: {
          onClick: function onClick() {
            var refCode = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(self.company, ['reference', 'ref']);
            if (refCode) {
              self.$store.dispatch('updateMonitoringCompanies', { refCodes: [refCode], monitoring: true });
              self.$emit('refresh');
            }
          }
        }
      };
    },
    copyToClipboard: function copyToClipboard(template) {
      var _this = this;

      var action = function action(template, company, clientCompany, companyInfo, clientInfo) {
        var text = company ? template(company, clientCompany, companyInfo, clientInfo) : '';
        _this.$store.dispatch('copyToClipboard', { text: text });
      };
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (_this.company.heads && _this.company.heads.length > 0 && _this.company.heads[0].inn) {
          return __WEBPACK_IMPORTED_MODULE_7__people_index_js__["a" /* default */].findIndividualByInn(_this.company.heads[0].inn);
        } else {
          return null;
        }
      }).then(function (individual) {
        var bank = _this.banks && _this.banks.length > 0 ? _this.banks.sort(function (a, b) {
          return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].compareString(a.name, b.name);
        })[0] : null;
        var companyInfo = {
          isRefreshed: true,
          email: null,
          phone: null,
          bankDetails: {
            account: bank ? bank.bankAccount : null,
            bankName: bank ? bank.bankName : null,
            corrAccount: bank ? bank.bankCorrAccount : null,
            bankBic: bank ? bank.bankRcbic : null
          }
        };
        if (individual && individual.contacts && individual.contacts.length > 0) {
          var contacts = individual.contacts.filter(function (c) {
            return _this.company.inn === c.companyInn;
          });
          if (contacts.length === 0) {
            contacts = individual.contacts;
          }
          companyInfo.email = contacts[0].email;
          companyInfo.phone = contacts[0].phone;
        }
        return companyInfo;
      }).then(function (ci) {
        action(template, _this.company, _this.getClientCompany, ci, _this.getClientProfile);
      });
    },

    editNotesDialogOpen: function editNotesDialogOpen(item) {
      if (!this.notesEditable) {
        return;
      }
      var self = this;
      var setNotes = function setNotes(data) {
        // if (self.notes || self.notes && self.notes.localeCompare(data) !== 0) {
        self.$emit('refresh');
        // }
      };
      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].register('v-notes-form', __WEBPACK_IMPORTED_MODULE_5__NotesForm___default.a);
      var comp = { template: '\n        <v-notes-form v-on:input="setNotes" v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-notes-form>\n      ',
        data: function data() {
          return {
            model: { clientCompanyId: self.clientCompanyId, banks: self.banks, company: self.company, privateNotes: self.privateNotes, notes: self.notes, tags: self.tags, monitoring: self.monitoring },
            setNotes: setNotes,
            fullscreen: self.$vuetify.breakpoint.xsOnly
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].modal(comp);
    },
    goDepo: function goDepo() {
      var tag = '#' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.company, ['reference', 'ref']);
      this.$router.push({ path: '/doc_list/root', query: { tag: [tag] } });
    },
    renderCompanyFlags: function renderCompanyFlags() {
      return this.company ? this.renderFlags(this.company.flags, false) : null;
    },
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].createComp(template);
    },
    getItemNew: function getItemNew() {
      return {
        ref: null,
        ogrn: null,
        ogrnDate: null,
        releaseDate: null,
        inn: null,
        kpp: null,
        nameShort: '',
        name: '',
        address: '',
        clientId: null,
        activities: [],
        head: {
          position: '',
          lastName: '',
          firstName: '',
          middleName: ''
        }
      };
    }
  }
});

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats_js__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__favorite_TagSelector__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__favorite_TagSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__favorite_TagSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__favorite__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__people__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_BtnForm__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'notes-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_10__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: true,
      valid: false,
      item: {}
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: null
    }
  },
  created: function created() {
    if (!this.model) {
      this.item = this.getItemNew();
    } else {
      this.item.ref = this.model.company.reference.ref;
      this.item.inn = this.model.company.inn;
      this.item.nameShort = this.model.company.name.caption;
      this.item.clientCompanyId = this.model.clientCompanyId;
      this.item.text = this.model.notes;
      this.item.link = null;
      this.item.lastUid = null;
      this.item.tags = this.model.tags.slice();
      this.item.monitoring = this.model.monitoring;
      this.item.privateNotes = this.model.privateNotes;
      this.fetchCompanyBanks(this.item.ref);
      this.fetchCompanyContacts(this.item.ref);
    }
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    profile: 'getProfile',
    getTags: 'getTags',
    getDepoUrl: 'getDepoUrl'
  }), {
    docLink: function docLink() {
      return this.item.link ? this.item.link : '';
    },
    isEdit: function isEdit() {
      return this.edit || this.isNew;
    },
    isNew: function isNew() {
      return false;
    },
    title: function title() {
      return this.isNew ? '\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 ' + this.item.nameShort : this.isEdit ? '\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u044B ' + this.item.nameShort : '\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u044B ' + this.item.nameShort;
    },
    banks: function banks() {
      return this.item && this.item.banks ? this.item.banks.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats_js__["a" /* default */].compareString(a.name, b.name);
      }) : [];
    },
    contacts: function contacts() {
      return this.item && this.item.contacts ? __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].sortContactsByCompany(this.item.contacts) : [];
    }
  }),
  methods: {
    calcHeight: function calcHeight() {
      var height = this.$vuetify.breakpoint.height - 48 - 48 - 16;
      if (this.fullscreen) {
        height = height + 8;
      } else {
        height = height - 148 + 16 + 64;
      }
      return height + 'px';
    },
    fetchCompanyBanks: function fetchCompanyBanks(refCode) {
      var _this = this;

      this.$store.dispatch('getCompanyBanks', refCode).then(function (data) {
        _this.item.banks = data;
        _this.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this.item);
      });
    },
    fetchCompanyContacts: function fetchCompanyContacts(refCode) {
      var _this2 = this;

      this.$store.dispatch('getCompanyContacts', refCode).then(function (data) {
        _this2.item.contacts = data;
        console.log('fetchCompanyContacts', data);
        _this2.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, _this2.item);
      });
    },
    add: function add() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('updateFavoriteCompanyNotes', { refCode: this.item.ref, notes: this.item.text, privateNotes: this.item.privateNotes });
        this.$store.dispatch('updateFavoriteCompanyTags', { refCode: this.item.ref, tags: this.item.tags });
        this.$store.dispatch('updateMonitoringCompanies', { refCodes: [this.item.ref], monitoring: this.item.monitoring });
        this.edit = false;
        this.$emit('input', this.item.text);
        this.cancel();
      }
    },
    remove: function remove() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', 'Убрать из "Мои контрагенты" и отключить мониторинг компаний?', function (self) {
        self.$store.dispatch('deleteFavoriteCompanies', { refCodes: [_this3.item.ref] });
        self.$emit('input', '');
        self.cancel();
      });
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        ref: null,
        clientCompanyId: null,
        banks: [],
        inn: null,
        nameShort: null,
        text: '',
        link: null,
        lastUid: null,
        tags: [],
        monitoring: false,
        privateNotes: ''
      };
    },
    addLink: function addLink() {
      var _this4 = this;

      var docLink = this.docLink;
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.resolve().then(function () {
        if (docLink.includes(_this4.item.lastUid)) {
          return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
            _this4.$store.dispatch('getDepoFile', _this4.item.lastUid).then(function (files) {
              resolve(files && files[0] && files[0].docName || docLink);
            });
          });
        }
        return docLink;
      }).then(function (refName) {
        _this4.item.text = (_this4.item.text || '') + ('<a href="' + docLink + '">' + refName + '</a>');
        _this4.item.link = null;
        _this4.item.lastUid = null;
      });
    },

    dialogOpen: function dialogOpen() {
      var self = this;
      var setDoc = function setDoc(value) {
        var docLink = self.getDepoUrl(value);
        self.item.lastUid = value;
        self.item.link = docLink;
        self.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, self.item);
      };
      __WEBPACK_IMPORTED_MODULE_7__depo__["a" /* default */].selectDoc(this, setDoc);
    },
    addTag: function addTag() {
      var self = this;
      var setItems = function setItems(tagIds) {
        self.item.tags = self.getTags.filter(function (t) {
          return tagIds.includes(t.id);
        });
        self.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, self.item);
      };
      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].register('v-tag-selector', __WEBPACK_IMPORTED_MODULE_5__favorite_TagSelector___default.a);
      var comp = { template: '\n        <v-tag-selector v-on:close="$emit(\'close\')"\n        v-on:input="setItems"\n        :fullscreen="fullscreen" :selected="selected"></v-tag-selector>\n        ',
        data: function data() {
          return {
            fullscreen: self.fullscreen,
            setItems: setItems,
            selected: self.item.tags.map(function (t) {
              return t.id;
            })
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].modal(comp);
    },
    switchMonitoring: function switchMonitoring() {
      this.item.monitoring = !this.item.monitoring;
      this.item = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.item);
    },
    openCompanyBank: function openCompanyBank(item) {
      var _this5 = this;

      var id = item ? item.id : null;
      __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].openCompanyBank(id, this.item.ref, this.item.nameShort, this.item.clientCompanyId).then(function () {
        _this5.fetchCompanyBanks(_this5.item.ref);
      });
    },
    createBankTitle: function createBankTitle(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].createStrategy(this, 'COMPANY_BANK');
      if (strategy && strategy.viewTitleComp) {
        return strategy.viewTitleComp(strategy.createModelFromData(item));
      }
      return __WEBPACK_IMPORTED_MODULE_4__api_formats_js__["a" /* default */].createComp('<span>Новый тип документа</span>');
    },
    createBankContent: function createBankContent(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].createStrategy(this, 'COMPANY_BANK');
      if (strategy && strategy.viewContentComp) {
        return strategy.viewContentComp(strategy.createModelFromData(item));
      }
      return __WEBPACK_IMPORTED_MODULE_4__api_formats_js__["a" /* default */].createComp('<span></span>');
    },
    openContact: function openContact(item) {
      var _this6 = this;

      var id = item ? item.id : null;
      __WEBPACK_IMPORTED_MODULE_8__favorite__["a" /* default */].openCompanyContact(id, this.item.ref, this.item.nameShort, this.item.clientCompanyId).then(function () {
        _this6.fetchCompanyContacts(_this6.item.ref);
      });
    },
    createContactTitle: function createContactTitle(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].createStrategy(this, 'CONTACT');
      strategy.setParentProps({ refCode: this.item.ref });
      if (strategy && strategy.viewTitleComp) {
        return strategy.viewTitleComp(strategy.createModelFromData(item));
      }
      return this.createComp('<span>Новый тип документа</span>');
    },
    createContactContent: function createContactContent(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_9__people__["a" /* default */].createStrategy(this, 'CONTACT');
      strategy.setParentProps({ refCode: this.item.ref });
      if (strategy && strategy.viewContentComp) {
        return strategy.viewContentComp(strategy.createModelFromData(item));
      }
      return this.createComp('<span></span>');
    }
  }
});

/***/ }),
/* 1021 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card', {
    ref: "scroll_target",
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "height": _vm.calcHeight()
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": "0"
    },
    attrs: {
      "px-2": "",
      "pt-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [(!_vm.isEdit) ? [_c('v-card-text')] : _vm._e(), _vm._v(" "), (_vm.isEdit) ? [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Корпоративные заметки",
      "rows": "5",
      "persistent-hint": "",
      "hint": "Корпоративные заметки видны только пользователям Вашей компании"
    },
    model: {
      value: (_vm.item.text),
      callback: function($$v) {
        _vm.$set(_vm.item, "text", $$v)
      },
      expression: "item.text"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на документ",
      "hint": ""
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !this.item.link
    },
    on: {
      "click": _vm.addLink
    }
  }, [_vm._v("Добавить")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-up": "",
      "justify-end": ""
    }
  }, [_c('v-flex', _vm._l((_vm.item.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n          " + _vm._s(tag.name) + "\n          ")])])
  }), 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.addTag
    }
  }, [_vm._v("Метки")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('v-flex', [_c('v-chip', {
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    }
  }, [_c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.monitoring),
      expression: "item.monitoring"
    }]
  }, [_vm._v("alarm")]), _vm._v(" "), _c('v-icon', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.item.monitoring),
      expression: "!item.monitoring"
    }]
  }, [_vm._v("alarm_off")])], 1)], 1), _vm._v(" "), _c('v-btn', {
    on: {
      "click": _vm.switchMonitoring
    }
  }, [_vm._v("Мониторинг")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Личные заметки",
      "rows": "2",
      "persistent-hint": "",
      "hint": "Личные заметки видны только Вам"
    },
    model: {
      value: (_vm.item.privateNotes),
      callback: function($$v) {
        _vm.$set(_vm.item, "privateNotes", $$v)
      },
      expression: "item.privateNotes"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Банки\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openCompanyBank()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.banks), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createBankTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createBankContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openCompanyBank(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Контакты\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openContact()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.contacts), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createContactTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createContactContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openContact(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)], 1)], 1)] : _vm._e()], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1022 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c(_vm.renderCompanyFlags(), {
    tag: "v-component"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.editNotesDialogOpen()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n      " + _vm._s(tag.name) + "\n      ")])])
  }), 1)], 1), _vm._v(" "), _c(_vm.createNameComp(_vm.company), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createNameShortComp(_vm.company), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_vm._v("Дата создания: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.company.createDate)))])]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatStatus(_vm.company.status))
    }
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.getCompanyOgrn()), 'ОГРН', null, 'Копировать огрн'), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.renderValueLink(_vm.formats.blank(_vm.getCompanyInn()), 'ИНН', null, 'Копировать инн', _vm.renderInnHtmlBold(_vm.company.inn)), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.renderValueLink(_vm.formats.blank(_vm.getCompanyKpp()), 'КПП', null, 'Копировать кпп'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_vm._v("Численность: "), _c('b', [_vm._v(_vm._s(_vm.company.staffNumber && _vm.company.staffNumber.value !== null ? _vm.company.staffNumber.value : 'нет данных'))]), _vm._v(" " + _vm._s(_vm.formatDateAt(_vm.company.staffNumber)))]), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatTaxMode(_vm.company.taxMode))
    }
  }), _vm._v(" "), _c(_vm.createAddressComp(_vm.company), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createHeadsComp(_vm.company.heads, _vm.company.management), {
    tag: "component"
  }), _vm._v(" "), (_vm.company.management) ? _c(_vm.createManagementComp(_vm.company.management), {
    tag: "component"
  }) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.notes ? 'Примечания:' : 'Внесите корпоративные заметки (они будут видны Вашим коллегам).'))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.notes)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('v-layout', {
    attrs: {
      "justify-begin": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.goDepo()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("storage")])], 1), _vm._v(" "), _c('span', [_vm._v("Перейти в депозитарий")])])], 1), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.monitoring),
      expression: "monitoring"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("alarm")])], 1), _vm._v(" "), _c('span', [_vm._v("Мониторинг включен")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.privateNotes ? 'Личные заметки:' : 'Внесите личные заметки (они будут видны только Вам).'))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.privateNotes)
    }
  })])], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c(_vm.createCopyButton('Письмо', 'content_copy', 'Копировать для письма', _vm.getEmailHeaderReport), {
    tag: "v-component"
  }), _vm._v(" "), _c(_vm.createCopyButton('Преамбула 1', 'content_copy', 'Копировать для преамбулы договора вариант 1', _vm.getAgreementHeader1Report), {
    tag: "v-component"
  }), _vm._v(" "), _c(_vm.createCopyButton('Преамбула 2', 'content_copy', 'Копировать для преамбулы договора вариант 2', _vm.getAgreementHeader2Report), {
    tag: "v-component"
  }), _vm._v(" "), _c(_vm.createCopyButton('Реквизиты договора', 'content_copy', 'Копировать для реквизитов договора', _vm.getAgreementFooterReport), {
    tag: "v-component"
  }), _vm._v(" "), _c(_vm.createCopyButton('Конверт', 'content_copy', 'Копировать для конверта', _vm.getClientEnvelopeReport), {
    tag: "v-component"
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import server from '../../api/server'



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-records-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      isLoaded: false,
      isLoading: false,
      topCount: 1
    };
  },
  props: {
    fillHeight: {
      type: Boolean,
      default: false
    },
    activities: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({}), {
    mainActivity: function mainActivity() {
      var result = this.items.filter(function (a) {
        return a.isMain;
      });
      return result.length > 0 ? result[0].code + '\t' + result[0].name : null;
    },
    otherActivities: function otherActivities() {
      return this.items.filter(function (a) {
        return !a.isMain;
      }).sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.code, b.code);
      });
    },
    items: function items() {
      return this.activities;
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        // this.fetchItems()
      }
    },
    formatMainActivityHtml: function formatMainActivityHtml(activity) {
      return activity && activity.length > 0 ? activity : __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatWarningHtml('Регистр не содержит запись об основном виде деятельности');
    }
  }
});

/***/ }),
/* 1024 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать основной' : 'Показать все',
      "expandable": _vm.otherActivities.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      Виды деятельности (" + _vm._s(_vm.items.length) + ")\n      "), _c('div', [_c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatMainActivityHtml(_vm.mainActivity))
    }
  })])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded && _vm.items.length > 0),
      expression: "isLoaded && items.length > 0"
    }],
    staticClass: "pt-0"
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n    Данные не найдены.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.otherActivities), function(item) {
    return [_c('div', [_vm._v(_vm._s(item.code) + "\t" + _vm._s(item.name))])]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1025 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1026),
  /* template */
  __webpack_require__(1027),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-tax-pay-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      items: [],
      isLoaded: false,
      revexps: []
    };
  },
  props: {
    model: {
      type: Object,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.model) {
      this.id = this.model.ogrn;
    }
    this.fetchItems();
  },

  watch: {
    model: function model(newVal, oldVal) {
      if (this.model) {
        this.id = this.model.ogrn;
      }
      this.fetchItems();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({}), {
    headerHtml: function headerHtml() {
      var period = this.revexps && this.revexps.length > 0 ? this.revexps[0].period + ' г.' : '';
      var sumStr = null;
      var sum = null;
      if (this.items && this.items.length > 0) {
        sum = this.items.reduce(function (s, i) {
          return s + i.amount;
        }, 0);
        sumStr = '\u041D\u0430\u043B\u043E\u0433\u0438 \u0438 \u0441\u0431\u043E\u0440\u044B <b>' + this.formatCurrency(sum) + '</b>';
      } else {
        sumStr = 'Налоги и сборы не опубликованы ФНС России';
      }
      var revenue = null;
      var expenses = null;
      var percent = '';
      var staff = '';
      if (this.revexps && this.revexps.length > 0) {
        revenue = '\u0414\u043E\u0445\u043E\u0434\u044B <b>' + this.formatCurrency(this.revexps[0].revenue) + '</b>';
        expenses = '\u0420\u0430\u0441\u0445\u043E\u0434\u044B <b>' + this.formatCurrency(this.revexps[0].expense) + '</b>';
        if (sum && this.revexps[0].revenue > 0) {
          percent = '(' + (sum / this.revexps[0].revenue * 100).toFixed(2) + '%&nbsp\u043E\u0442&nbsp\u0434\u043E\u0445\u043E\u0434\u0430)';
        }
        if (this.model && this.model.staffNumber != null && this.model.staffNumber.value != null) {
          staff = '(\u043F\u0440\u0438 \u0447\u0438\u0441\u043B\u0435\u043D\u043D\u043E\u0441\u0442\u0438 ' + this.model.staffNumber.value + ' \u0447\u0435\u043B.)';
        }
      } else {
        revenue = 'Доходы не опубликованы ФНС России';
        expenses = 'Расходы не опубликованы ФНС России';
      }
      var taxOffence = '';
      if (this.model.taxOffence) {
        taxOffence = '\u0428\u0442\u0440\u0430\u0444 \u0437\u0430 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0435 \u043F\u0440\u0430\u0432\u043E\u043D\u0430\u0440\u0443\u0448\u0435\u043D\u0438\u044F <b>' + this.formatCurrency(this.model.taxOffence) + '</b>';
      }

      return '\u0414\u043E\u0445\u043E\u0434\u044B \u0438 \u0440\u0430\u0441\u0445\u043E\u0434\u044B. \u0423\u043F\u043B\u0430\u0447\u0435\u043D\u043D\u044B\u0435 \u043D\u0430\u043B\u043E\u0433\u0438. <b>' + period + '</b><br/>' + revenue + ' ' + staff + '<br/>' + expenses + ' <br/> ' + sumStr + ' ' + percent + ' <br/>' + taxOffence;
    }
  }),
  methods: {
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatCurrency(number) + '&nbspр.' : '';
    },
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о налогах из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/taxes', cb, cbError);
    },
    getRevExps: function getRevExps(id, cb) {
      var _this2 = this;

      var cbError = function cbError(e) {
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о доходах и расходах из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/revexps', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this3 = this;

      this.items = [];
      if (this.id) {
        this.getItems(this.id, function (data) {
          _this3.items = data;
          _this3.items.sort(function (a, b) {
            return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].compareString(a.tax, b.tax);
          });
        });
        this.getRevExps(this.id, function (data) {
          _this3.revexps = data;
        });
      }
    }
  }
});

/***/ }),
/* 1027 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded && this.items.length > 0 ? 'Кратко' : 'Подробно',
      "expandable": _vm.items.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.headerHtml)
    }
  })]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded && _vm.items.length > 0),
      expression: "isLoaded && items.length > 0"
    }],
    staticClass: "pt-0"
  }, [_vm._l((_vm.items), function(item) {
    return [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_vm._v(_vm._s(item.tax))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.amount))
      }
    })])])], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1028 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1029),
  /* template */
  __webpack_require__(1030),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-manageds-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    },
    topCount: {
      type: Number,
      default: 2
    }
  },
  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    renderInnHtml: 'renderInnHtml',
    renderDateSince: 'renderDateSince',
    renderStatus: 'renderStatus',
    renderFlags: 'renderFlags',
    renderFirstActivityHtml: 'renderFirstActivityHtml',
    renderShare: 'renderShare',
    renderUnreliableHtml: 'renderUnreliableHtml',
    getOpenSettings: 'getOpenSettings'
  }), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.items.slice(this.topCount);
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о компаниях под управлением из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/manageds', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this2.items = data;
          _this2.isLoading = false;
        });
      }
    }
  }
});

/***/ }),
/* 1030 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      Компаний под управлением (" + _vm._s(_vm.items.length > 100 ? 'более 100' : _vm.items.length) + ")\n      "), _vm._l((_vm.topItems), function(item) {
    return [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.ref.value))
      }
    }), _vm._v(" "), _c(_vm.renderFlags(item.ref.value.flags, true), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.ref.value.inn))
      }
    })]), _vm._v(" - \n              "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.ref.value.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.ref.value.activities))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })], 1)]
  })], 2)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded && _vm.items.length > 0),
      expression: "isLoaded && items.length > 0"
    }],
    staticClass: "pt-0"
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n    Данные не найдены.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0 && _vm.items.length > 100),
      expression: "items.length > 0 && items.length > 100"
    }]
  }, [_c('b', [_vm._v("ВАЖНО!")]), _vm._v(" Показываются только 100 компаний под управлением. Для показа всех компаний под управлением направьте нам письмо на электронную почту " + _vm._s(_vm.getOpenSettings.supportMail)), _c('br'), _c('br')]), _vm._v(" "), _vm._l((_vm.lastItems), function(item) {
    return [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.ref.value))
      }
    }), _vm._v(" "), _c(_vm.renderFlags(item.ref.value.flags, true), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.ref.value.inn))
      }
    })]), _vm._v(" - \n            "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.ref.value.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.ref.value.activities))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1032),
  /* template */
  __webpack_require__(1033),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1032 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-children-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    },
    topCount: {
      type: Number,
      default: 2
    }
  },
  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    renderInnHtml: 'renderInnHtml',
    renderDateSince: 'renderDateSince',
    renderStatus: 'renderStatus',
    renderFirstActivityHtml: 'renderFirstActivityHtml',
    renderShare: 'renderShare',
    getOpenSettings: 'getOpenSettings'
  }), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.items.slice(this.topCount);
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatCurrency(number) + ' руб.' : '';
    },
    formatShare: function formatShare(holder) {
      var share = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(holder, ['shares', 0, 'share']);
      return share !== null ? '(' + this.formatCurrency(share) + ')' : '';
    },
    formatPercent: function formatPercent(holder) {
      var share = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(holder, ['shares', 0]);
      return this.renderShare(share);
    },
    getFirst: function getFirst(items) {
      return items && items.length > 0 && items[0] || null;
    },
    sortItems: function sortItems(a, b) {
      var getRank = function getRank(kind) {
        return ['GOOD', 'WARN', 'BAD', 'OLD'].indexOf(kind);
      };

      var result = 0;
      if (!result) {
        result = getRank(a.status.kind) - getRank(b.status.kind);
      }
      var aholder = this.getFirst(a.holders);
      var bholder = this.getFirst(b.holders);
      if (!result && !(bholder && aholder)) {
        result = (bholder != null) - (aholder != null);
      }
      if (!result && bholder && aholder) {
        var valB = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(bholder, ['shares', 0, 'part', 'numerator']) / __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(bholder, ['shares', 0, 'part', 'denominator']);
        var valA = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(aholder, ['shares', 0, 'part', 'numerator']) / __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(aholder, ['shares', 0, 'part', 'denominator']);
        result = valB - valA;
      }
      if (!result && bholder && aholder) {
        result = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(bholder, ['shares', 0, 'share']) - __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(aholder, ['shares', 0, 'share']);
      }
      return result;
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о дочерних компаниях из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/children', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this2.items = data;
          _this2.items.sort(function (a, b) {
            return _this2.sortItems(a, b);
          });
          _this2.isLoading = false;
        });
      }
    }
  }
});

/***/ }),
/* 1033 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      Участие в других компаниях (" + _vm._s(_vm.items.length > 100 ? 'более 100' : _vm.items.length) + ")\n      "), _vm._l((_vm.topItems), function(item) {
    return [_c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.inn))
      }
    })]), _vm._v(" - \n              "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.activities))
      }
    }), _vm._v(" "), _vm._l(([_vm.getFirst(item.holders)]), function(holder) {
      return [_c('b', [_vm._v("Участие " + _vm._s(_vm.formatPercent(holder)) + " " + _vm._s(_vm.formatShare(holder)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(holder))
        }
      })]
    })], 2)], 1)]
  })], 2)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded && _vm.items.length > 0),
      expression: "isLoaded && items.length > 0"
    }],
    staticClass: "pt-0"
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n    Данные не найдены.\n    ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0 && _vm.items.length > 100),
      expression: "items.length > 0 && items.length > 100"
    }]
  }, [_c('b', [_vm._v("ВАЖНО!")]), _vm._v(" Показываются только 100 дочерних компаний, отфильтрованных по величине доли. Для показа всех дочерних компаний направьте нам письмо на электронную почту " + _vm._s(_vm.getOpenSettings.supportMail)), _c('br'), _c('br')]), _vm._v(" "), _vm._l((_vm.lastItems), function(item) {
    return [_c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.inn))
      }
    })]), _vm._v(" - \n            "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.activities))
      }
    }), _vm._v(" "), _vm._l(([_vm.getFirst(item.holders)]), function(holder) {
      return [_c('b', [_vm._v("Участие " + _vm._s(_vm.formatPercent(holder)) + " " + _vm._s(_vm.formatShare(holder)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(holder))
        }
      })]
    })], 2)], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1035),
  /* template */
  __webpack_require__(1036),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1035 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__people_index_js__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-holder-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    capital: {
      type: Object,
      default: null
    },
    holderRegister: {
      type: Object,
      default: null
    },
    topCount: {
      type: Number,
      default: 5
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    renderHolderPercent: 'renderHolderPercent',
    renderInnHtml: 'renderInnHtml',
    renderInnflHtml: 'renderInnflHtml',
    renderDateSince: 'renderDateSince',
    renderUnreliableHtml: 'renderUnreliableHtml',
    renderCopyButton: 'renderCopyButton',
    renderContactButton: 'renderContactButton',
    getIconName: 'getIconName',
    getOpenSettings: 'getOpenSettings'
  }), {
    topHolders: function topHolders() {
      return this.holders.slice(0, this.topCount);
    },
    lowHolders: function lowHolders() {
      console.log('lowHolders', this.holders.slice(this.topCount, 100));
      return this.holders.slice(this.topCount, 100);
    },
    holders: function holders() {
      return this.items.sort(function (a, b) {
        var result = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(b, ['shares', 0, 'share']) - __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(a, ['shares', 0, 'share']);
        return result !== 0 ? result : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].compareString(a.name, b.name);
      });
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    formatCurrency: function formatCurrency(number) {
      return number != null ? __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatCurrency(number) + ' руб.' : '';
    },
    formatWarningHtml: function formatWarningHtml(warning) {
      return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml(warning);
    },
    formatCapital: function formatCapital(capital) {
      if (!capital) {
        return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись об уставном капитале компании');
      }
      return ''.concat('<div>', capital.type ? capital.type + ':' : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись о типе уставнго капитала'), ' <b>' + this.formatCurrency(capital.value) + '</b>', this.renderDateSince(capital), '</div>', '<div>', this.formatLessenings(capital), __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml(capital.desc), '</div>');
    },
    formatLessenings: function formatLessenings(capital) {
      var _this = this;

      if (!capital.lessenings) {
        return '';
      }
      var result = '';
      capital.lessenings.forEach(function (l) {
        result = result.concat('<div>', '\xa0\xa0', 'Уменьшение капитала на ', _this.formatCurrency(l.value), _this.renderDateSince(l), '</div>');
      });
      return result;
    },
    formatHolderRegister: function formatHolderRegister(holderRegister) {
      var self = this;
      var template = ''.concat(holderRegister ? '\n        <div>\n          \u0414\u0435\u0440\u0436\u0430\u0442\u0435\u043B\u044C \u0440\u0435\u0435\u0441\u0442\u0440\u0430 \u0430\u043A\u0446\u0438\u043E\u043D\u0435\u0440\u043E\u0432:\n          <div v-html="self.renderReference(dto.value)">\n          </div>\n          <v-flex pl-2>\n            <div>\u0418\u041D\u041D <b><span v-html="self.renderInnHtml(dto.value.inn)"></span></b>\n            </div>\n            <span v-html="self.renderDateSince(dto)"></span>\n          </v-flex>\n        </div>\n        ' : '<div></div>'
      // `<div v-html="formats.formatWarningHtml('ЕГРЮЛ не содержит запись о регистраторе')"></div>`
      );
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            dto: holderRegister,
            formats: __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */]
          };
        }
      };
    },
    formatHoldersHtml: function formatHoldersHtml(holders) {
      return holders && holders.length > 0 ? '\u0423\u0447\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u0438 (' + (holders.length > 100 ? 'более 100' : holders.length) + ')' : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись об учредителях компании');
    },
    formatShare: function formatShare(holder) {
      return this.formatCurrency(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(holder, ['shares', '0', 'share']));
    },
    formatHumanCountersHtml: function formatHumanCountersHtml(counters) {
      var _f = function _f(v) {
        return v !== null ? v : 'нет данных';
      };
      if (!counters) {
        return '<div></div>';
      }
      var result = ''.concat('<v-tooltip bottom>', '<span slot="activator">', '<v-icon small>' + this.getIconName('head') + '</v-icon>' + _f(counters.managedCompaniesExact) + '(' + _f(counters.managedCompaniesGeneral) + ')&nbsp', '<v-icon small>' + this.getIconName('holder') + '</v-icon>' + _f(counters.sharedCompaniesExact) + '(' + _f(counters.sharedCompaniesGeneral) + ')', '<v-icon small>' + this.getIconName('loner') + '</v-icon>' + _f(counters.loners), '</span>', '<span>\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0438 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\u0445, \u043D\u0430\u043B\u0438\u0447\u0438\u0435 \u0418\u041F <br/> \u0442\u043E\u0447\u043D\u043E\u0435 (\u043D\u0435 \u0442\u043E\u0447\u043D\u043E\u0435) \u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0435</span>', '</v-tooltip>');
      return result;
    },
    createCompanyComp: function createCompanyComp(item) {
      var self = this;
      var template = '\n      <div>\n        <span v-html="self.renderHolderPercent(item)"></span>\n        <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\', getNameFull)" />\n        <v-flex pl-2>\n          <div>\n            \u0418\u041D\u041D <span v-html="self.renderInnHtml(item.refObject.inn)"></span>\n            <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u043D\u043D\', getInn)" />\n          </div>\n          <div><b>{{self.formatShare(item)}}</b>{{self.renderDateSince(item)}}</div>\n        </v-flex>\n      </div>\n      ';
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            item: item
          };
        },
        methods: {
          getNameFull: function getNameFull() {
            return self.getHumanNameFull(item);
          },
          getInn: function getInn() {
            return self.getHumanInn(item);
          }
        }
      };
    },
    createHumanComp: function createHumanComp(item) {
      var self = this;
      var template = '\n      <div>\n        <span v-html="self.renderHolderPercent(item)"></span>\n        <component :is="self.createComp(self.formatHumanCountersHtml(item.refObject.counters))"/>\n        <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0418\u041E\', getNameFull)" />\n        <v-component :is="self.renderContactButton(\'\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430\', openContact)" />\n        <v-flex pl-2>\n          <div>\n            \u0418\u041D\u041D <span v-html="self.renderInnflHtml(item.refObject.inn)"></span>\n            <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0438\u043D\u043D\', getInn)" />\n          </div>\n          <div><b>{{self.formatShare(item)}}</b>{{self.renderDateSince(item)}}</div>\n        </v-flex>\n      </div>\n      ';
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            item: item
          };
        },
        methods: {
          getNameFull: function getNameFull() {
            return self.getHumanNameFull(item);
          },
          getInn: function getInn() {
            return self.getHumanInn(item);
          },
          openContact: function openContact() {
            var names = this.getNameFull().split(' ');
            var ops = {
              inn: this.getInn(),
              lastName: names.length > 0 ? names[0] : '',
              firstName: names.length > 1 ? names[1] : '',
              middleName: names.length > 2 ? names[2] : '',
              position: 'Участник'
            };
            __WEBPACK_IMPORTED_MODULE_5__people_index_js__["a" /* default */].openByHuman('ogrn:' + self.id, ops);
          }
        }
      };
    },
    createNoInnHolder: function createNoInnHolder(item) {
      var self = this;
      var template = '\n      <div>\n        <span v-html="self.renderHolderPercent(item)"></span>\n        <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\', getNameFull)" />\n        <v-flex pl-2>\n          <div><b>{{self.formatShare(item)}}</b>{{self.renderDateSince(item)}}</div>\n        </v-flex>\n      </div>\n      ';
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            item: item
          };
        },
        methods: {
          getNameFull: function getNameFull() {
            return self.getHumanNameFull(item);
          }
        }
      };
    },
    getHumanNameFull: function getHumanNameFull(item) {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(item, ['refObject', 'name']);
    },
    getHumanInn: function getHumanInn(item) {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInnfl(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(item, ['refObject', 'inn']));
    },
    getItems: function getItems(id, cb) {
      var _this2 = this;

      var cbError = function cbError(e) {
        _this2.isLoading = false;
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации об учередителях компании из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/holders', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this3 = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this3.items = data;
          _this3.isLoading = false;
        });
      }
    },
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].createComp(template);
    },
    getItemsLength: function getItemsLength(items) {
      return items ? items.length : 0;
    }
  }
});

/***/ }),
/* 1036 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCapital(_vm.capital))
    }
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c(_vm.formatHolderRegister(_vm.holderRegister), {
    tag: "component"
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHoldersHtml(_vm.items))
    }
  }), _vm._v(" "), _vm._l((_vm.topHolders), function(item) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'ogrn'),
        expression: "item.refObject.namespace === 'ogrn'"
      }]
    }, [_c(_vm.createCompanyComp(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'HUMAN'),
        expression: "item.refObject.namespace === 'HUMAN'"
      }]
    }, [_c(_vm.createHumanComp(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'FOREIGN'),
        expression: "item.refObject.namespace === 'FOREIGN'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'MUNICIPAL'),
        expression: "item.refObject.namespace === 'MUNICIPAL'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'PIF'),
        expression: "item.refObject.namespace === 'PIF'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'OTHER'),
        expression: "item.refObject.namespace === 'OTHER'"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderHolderPercent(item))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatWarningHtml('Запись об учредителе не поддерживается.'))
      }
    }), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.formatShare(item)))]), _vm._v(_vm._s(_vm.renderDateSince(item)))])])], 1), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })]
  })], 2)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n        Данные не найдены.\n      ")]) : _vm._e(), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0 && _vm.items.length > 100),
      expression: "items.length > 0 && items.length > 100"
    }]
  }, [_c('b', [_vm._v("ВАЖНО!")]), _vm._v(" Показываются только 100 учредителей, отфильтрованных по величине доли. Для показа всех учредителей направьте нам письмо на электронную почту " + _vm._s(_vm.getOpenSettings.supportMail)), _c('br'), _c('br')]), _vm._v(" "), _vm._l((_vm.lowHolders), function(item) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'ogrn'),
        expression: "item.refObject.namespace === 'ogrn'"
      }]
    }, [_c(_vm.createCompanyComp(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'HUMAN'),
        expression: "item.refObject.namespace === 'HUMAN'"
      }]
    }, [_c(_vm.createHumanComp(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'FOREIGN'),
        expression: "item.refObject.namespace === 'FOREIGN'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'MUNICIPAL'),
        expression: "item.refObject.namespace === 'MUNICIPAL'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'PIF'),
        expression: "item.refObject.namespace === 'PIF'"
      }]
    }, [_c(_vm.createNoInnHolder(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.refObject.namespace === 'OTHER'),
        expression: "item.refObject.namespace === 'OTHER'"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderHolderPercent(item))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatWarningHtml('Запись об учредителе не поддерживается.'))
      }
    }), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.formatShare(item)))]), _vm._v(_vm._s(_vm.renderDateSince(item)))])])], 1), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })]
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1038),
  /* template */
  __webpack_require__(1039),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1038 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-arrears-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      items: [],
      overallCount: null,
      sumArrear: null,
      sumPenalty: null,
      sumForFeit: null,
      sumTotal: null,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderDateSince: 'renderDateSince'
  }), {
    lowItems: function lowItems() {
      return this.items.slice(0, 20);
    },
    formatCount: function formatCount() {
      return ''.concat('Задолженностей и недоимок всего ', this.overallCount ? this.overallCount : 0);
    },
    formatSumArrears: function formatSumArrears() {
      if (this.sumArrear === null) {
        return '';
      }
      return ''.concat('Сумма задолженностей ', this.formatCurrency(this.sumArrear));
    },
    formatSumTotals: function formatSumTotals() {
      if (this.sumTotal === null) {
        return '';
      }
      return ''.concat('Задолженностей и недоимок всего ', this.formatCurrency(this.sumTotal));
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatCurrency(number) + ' р.' : '';
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о суммах недоимок и задолженностей по пеням и штрафам ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/arrears', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.overallCount = null;
        this.sumArrear = null;
        this.sumPenalty = null;
        this.sumForFeit = null;
        this.sumTotal = null;
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this2.isLoading = false;
          _this2.items = data.items;
          _this2.overallCount = data.count;
          _this2.sumArrear = data.sumArrear;
          _this2.sumPenalty = data.sumPenalty;
          _this2.sumForFeit = data.sumForFeit;
          _this2.sumTotal = data.sumTotal;
        });
      }
    }
  }
});

/***/ }),
/* 1039 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": _vm.items.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCount)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatSumArrears)
    }
  }), _vm._v(" "), _c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatSumTotals)
    }
  })]), _vm._v(" "), _c('div')])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.items.length > 0 && _vm.overallCount > 20),
      expression: "items.length > 0 && overallCount > 20"
    }]
  }, [_c('b', [_vm._v("ВАЖНО!")]), _vm._v(" Показываются только 20 задолжностей в порядке убывания суммы текущего долга."), _c('br'), _c('br')]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }]
  }, [_vm._l((_vm.lowItems), function(item) {
    return [_c('div', [_c('div', [_c('b', [_vm._v("\n            " + _vm._s(item.tax) + " за " + _vm._s(item.period) + " г.\n            ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("Задолженность/пени/штрафы/всего: " + _vm._s(_vm.formatCurrency(item.arrear)) + " / " + _vm._s(_vm.formatCurrency(item.penalty)) + " / " + _vm._s(_vm.formatCurrency(item.forFeit)) + " / "), _c('b', [_vm._v(_vm._s(_vm.formatCurrency(item.total)))])])])], 1)]
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1041),
  /* template */
  __webpack_require__(1042),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1041 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-assignees-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    renderInnHtml: 'renderInnHtml',
    renderDateSince: 'renderDateSince'
  }), {
    prevItems: function prevItems() {
      return this.items.filter(function (a) {
        return a.type === 'PREV';
      });
    },
    nextItems: function nextItems() {
      return this.items.filter(function (a) {
        return a.type === 'NEXT';
      });
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    sortItems: function sortItems(a, b) {
      var getRank = function getRank(kind) {
        return ['PREV', 'NEXT'].indexOf(kind);
      };

      var result = 0;
      if (!result) {
        result = getRank(a.type) - getRank(b.type);
      }
      if (!result && !(b.value && a.value)) {
        result = (b.value != null) - (a.value != null);
      }
      if (!result && b.value && a.value) {
        result = __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.value.name, b.value.name);
      }
      return result;
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о компаниях правоприемниках и правопредшественниках из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/assignees', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this2.items = data;
          _this2.isLoading = false;
          _this2.items.sort(function (a, b) {
            return _this2.sortItems(a, b);
          });
        });
      }
    }
  }
});

/***/ }),
/* 1042 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": _vm.items.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', [_vm._v("\n      Правопредшественник (" + _vm._s(_vm.prevItems.length) + ")\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        Правопреемник (" + _vm._s(_vm.nextItems.length) + ")\n      ")])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n        Данные не найдены.\n      ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n      Правопредшественник (" + _vm._s(_vm.prevItems.length) + ")\n        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }]
  }, [_vm._l((_vm.prevItems), function(item) {
    return [_c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.value))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.value.inn))
      }
    })])]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    })])], 1)]
  })], 2)]), _vm._v(" "), _c('div', [_vm._v("\n        Правопреемник (" + _vm._s(_vm.nextItems.length) + ")\n        "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }]
  }, [_vm._l((_vm.nextItems), function(item) {
    return [_c('div', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.value))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.value.inn))
      }
    })])]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    })])], 1)]
  })], 2)])], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1044),
  /* template */
  __webpack_require__(1045),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1044 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-branches-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderDateSince: 'renderDateSince'
  }), {
    branchItems: function branchItems() {
      return this.items.filter(function (a) {
        return a.kind === 'BRANCH';
      });
    },
    repItems: function repItems() {
      return this.items.filter(function (a) {
        return a.kind === 'REP_OFFICE';
      });
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    sortItems: function sortItems(a, b) {
      var getRank = function getRank(kind) {
        return ['BRANCH', 'REP_OFFICE'].indexOf(kind);
      };

      var result = 0;
      if (!result) {
        result = getRank(a.type) - getRank(b.type);
      }
      if (!result) {
        result = __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.name, b.name);
      }
      if (!result) {
        result = a.address && __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.address.value, b.address.value) || -1;
      }
      return result;
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о филиалах и представительствах компаний из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/branches', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this2.items = data;
          _this2.isLoading = false;
          _this2.items.sort(function (a, b) {
            return _this2.sortItems(a, b);
          });
        });
      }
    }
  }
});

/***/ }),
/* 1045 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": _vm.items.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', [_vm._v("\n      Филиалы (" + _vm._s(_vm.branchItems.length) + ")\n      ")]), _vm._v(" "), _c('div', [_vm._v("\n        Представительства (" + _vm._s(_vm.repItems.length) + ")\n      ")])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n        Данные не найдены.\n      ")]) : _vm._e(), _vm._v(" "), _c('div', [_vm._v("\n        Филиалы (" + _vm._s(_vm.branchItems.length) + ")\n        "), _vm._l((_vm.branchItems), function(item) {
    return [_c('div', [_c('b', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n              " + _vm._s(item.address.value) + "\n              "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    })])], 1)]
  })], 2), _vm._v(" "), _c('div', [_vm._v("\n        Представительства (" + _vm._s(_vm.repItems.length) + ")\n        "), _vm._l((_vm.repItems), function(item) {
    return [_c('div', [_c('b', [_vm._v(_vm._s(item.name))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n              " + _vm._s(item.address.value) + "\n              "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    })])], 1)]
  })], 2)], 1)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1046 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1047),
  /* template */
  __webpack_require__(1054),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1047 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelText__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PanelText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EnforcementForm__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EnforcementForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EnforcementForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_dialogs__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-enforcement-debts-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_5__PanelTitle___default.a, vPanelText: __WEBPACK_IMPORTED_MODULE_6__PanelText___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      items: [],
      count: null,
      sumAmount: null,
      sumRemaining: null,
      topCount: 20,
      loadedPages: 0,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    inn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.ogrn) {
      this.id = this.ogrn;
      this.fetchAggrs();
    }
  },

  watch: {
    inn: function inn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchAggrs();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    renderFlags: 'renderFlags',
    renderDateSince: 'renderDateSince'
  }), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lowItems: function lowItems() {
      return this.items.slice(this.topCount);
    }
  }),
  methods: {
    switchTitle: function switchTitle() {
      if (this.loadedPages === 0) {
        this.fetchItems();
      } else {
        this.isLoaded = false;
        this.loadedPages = 0;
        this.items = [];
      }
    },
    switchText: function switchText() {
      if (!this.isLoaded) {
        this.fetchItems();
      } else {
        this.isLoaded = false;
        this.loadedPages = 0;
        this.items = [];
      }
    },
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatCurrency(number) + '&nbsp;р.' : '-';
    },
    getAggrs: function getAggrs(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о судебных производствах ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGetParams('/openapi/companies/' + id + '/enforcementAggrs', {
        litigant: 'CREDITOR',
        stage: 'OPEN'
      }, cb, cbError);
    },
    fetchAggrs: function fetchAggrs() {
      var _this2 = this;

      if (this.id) {
        this.getAggrs(this.id, function (data) {
          if (data) {
            _this2.count = data.count;
            _this2.sumAmount = data.amount;
            _this2.sumRemaining = data.remaining;
          }
        });
      }
    },
    getItems: function getItems(id, cb) {
      var _this3 = this;

      var cbError = function cbError(e) {
        _this3.isLoading = false;
        _this3.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о судебных производствах ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGetParams('/openapi/companies/' + id + '/enforcements', {
        litigant: 'CREDITOR',
        stage: 'OPEN',
        size: this.topCount,
        page: this.loadedPages
      }, cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this4 = this;

      if (this.id && !this.isLoading) {
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this4.items = _this4.items.concat(data.content);
          _this4.loadedPages = !data.last ? data.number + 1 : data.number;
          _this4.isLoading = false;
          _this4.isLoaded = data.last;
        });
      }
    },

    dialogOpen: function dialogOpen(item) {
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].register('v-enforcement-form', __WEBPACK_IMPORTED_MODULE_7__EnforcementForm___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-enforcement-form v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-enforcement-form>\n      ',
        data: function data() {
          return {
            model: item,
            fullscreen: fullscreen
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1048 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_PrintBtn__ = __webpack_require__(464);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_PrintBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_PrintBtn__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-panel-text',
  components: { vPrintBtn: __WEBPACK_IMPORTED_MODULE_0__common_PrintBtn___default.a },
  data: function data() {
    return {};
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    expandable: {
      type: Boolean,
      default: true
    },
    printActions: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    caption: {
      type: String,
      default: ''
    },
    primary: {
      type: Boolean,
      default: true
    }
  },
  computed: {
    expandableInt: function expandableInt() {
      return this.expandable;
    },
    printable: function printable() {
      return this.printActions && this.printActions.length > 0;
    },
    textClass: function textClass() {
      return this.primary ? 'primary--text' : '';
    }
  }
});

/***/ }),
/* 1049 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card-text', {
    staticStyle: {
      "padding-top": "0"
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_vm._t("default"), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expandableInt || _vm.printable),
      expression: "expandableInt || printable"
    }],
    staticStyle: {
      "margin": "-8px"
    },
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.printable),
      expression: "printable"
    }],
    attrs: {
      "ma-0": "",
      "align-center": "",
      "justify-start": ""
    }
  }, [_c('v-print-btn', {
    attrs: {
      "actions": _vm.printActions,
      "primary": _vm.primary
    }
  })], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.expandableInt),
      expression: "expandableInt"
    }],
    attrs: {
      "ma-0": "",
      "align-center": "",
      "justify-end": ""
    }
  }, [_c('span', {
    class: _vm.textClass,
    on: {
      "click": function($event) {
        return _vm.$emit('click')
      }
    }
  }, [_vm._v(_vm._s(_vm.caption))]), _vm._v(" "), _c('v-btn', {
    staticStyle: {
      "margin-left": "0"
    },
    attrs: {
      "icon": "",
      "small": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.$emit('click')
      }
    }
  }, [_c('v-icon', {
    class: _vm.textClass
  }, [_vm._v(_vm._s(_vm.value ? 'arrow_drop_up' : 'arrow_drop_down'))])], 1)], 1)], 1)], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1050 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_InfoForm__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_InfoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_InfoForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__info_PanelText__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__info_PanelText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__info_PanelText__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-enforcement-form',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_7__info_PanelTitle___default.a, vPanelText: __WEBPACK_IMPORTED_MODULE_8__info_PanelText___default.a, vInfoForm: __WEBPACK_IMPORTED_MODULE_6__common_InfoForm___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      items: [],
      topCount: 10,
      loadedPages: 0,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: function _default() {}
    }
  },
  mounted: function mounted() {
    if (this.model) {
      this.items = [this.model];
    }
    this.fetchData();
  },

  watch: {
    model: function model(newVal, oldVal) {
      if (newVal) {
        this.items = [newVal];
      }
      this.fetchData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    renderFlags: 'renderFlags'
  }), {
    title: function title() {
      return '' + (this.model.enforcementNumber ? this.model.enforcementNumber : 'Исполнительное производство');
    },
    topItems: function topItems() {
      return this.items.slice(0, 1);
    },
    lastItems: function lastItems() {
      return this.items.slice(1);
    }
  }),
  methods: {
    cancel: function cancel() {
      this.$emit('close');
    },
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatCurrency(number) + ' р.' : '';
    },
    isInDiff: function isInDiff(item, fieldName) {
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(item).includes(fieldName);
    },
    fetchData: function fetchData() {
      if (!this.model) {
        return;
      }
      this.fetchItems();
    },
    formatReference: function formatReference(ref) {
      return ref && this.renderReference(ref, '_blank') || '';
    },
    switchTitle: function switchTitle() {
      if (!this.isLoaded) {
        this.fetchItems();
      } else {
        this.isLoaded = false;
        this.loadedPages = 0;
        this.items = this.topItems;
      }
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении изменений исполнтьельного производсва ' });
      };
      id = id.replaceAll('/', '%2F');
      id = encodeURIComponent(id);
      __WEBPACK_IMPORTED_MODULE_5__api_server__["a" /* default */].openApiGetParams('/openapi/enforcements/' + id, {
        size: this.topCount,
        page: this.loadedPages
      }, cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (!this.isLoading) {
        this.isLoading = true;
        this.getItems(this.model.enforcementNumber, function (data) {
          if (data.number > 0) {
            _this2.items = _this2.items.concat(data.content);
          } else {
            _this2.items = data.content;
          }
          _this2.loadedPages = !data.last ? data.number + 1 : data.number;
          _this2.isLoading = false;
          _this2.isLoaded = data.last;
        });
      }
    }
  }
});

/***/ }),
/* 1051 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_BtnForm__);

//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'info-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_2__common_BtnForm___default.a },
  data: function data() {
    return {};
  },
  props: {
    title: {
      type: String,
      default: ''
    }
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    fullscreen: 'getIsMobile',
    calcDialogScroll: 'calcDialogScroll'
  })),
  methods: {}
});

/***/ }),
/* 1052 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._t("default")], 2)
},staticRenderFns: []}

/***/ }),
/* 1053 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-info-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Кратко ' : 'Еще ',
      "expandable": (!_vm.isLoaded && this.lastItems.length > 0) || (this.topCount <= this.lastItems.length && this.lastItems.length > 0)
    },
    on: {
      "click": function($event) {
        return _vm.switchTitle()
      }
    }
  }, [_vm._l((_vm.topItems), function(item) {
    return [_c('v-layout', {
      attrs: {
        "column": ""
      }
    }, [_c('v-flex', [_vm._v("\n           Номер сводного исполнительного производства: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.totalNumber)))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n           Номер исполнительного производства: "), _c('b', [_vm._v(_vm._s(item.enforcementNumber))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Задолженность по документу: " + _vm._s(_vm.formats.blank(item.amount, this.formatCurrency)) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Остаток задолженности: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.remaining, this.formatCurrency)))])]), _vm._v(" "), _c('v-flex', [_c('b', [_vm._v(_vm._s(item.executionObject))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Исполнительный документ:\n            "), (item.document) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(item.document.type))]), _vm._v(" "), _c('div', [_vm._v("\n              Номер "), _c('b', [_vm._v(_vm._s(item.document.number))]), _vm._v(" от "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.document.date, _vm.formats.formatDate)))])])]) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [_vm._v("\n            Взыскатель:\n            "), (item.collector && !item.collectorRef) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("ИНН:"), _c('b', [_vm._v(_vm._s(_vm.formats.formatInn(item.collector)))])]) : _vm._e(), _vm._v(" "), (item.collectorRef) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatReference(item.collectorRef))
      }
    }), _vm._v(" "), _c(_vm.renderFlags(item.collectorRef.flags, true), {
      tag: "v-component"
    })], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', [_vm._v("\n            Должник:\n            "), (item.debtorRef) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatReference(item.debtorRef))
      }
    }), _vm._v(" "), _c(_vm.renderFlags(item.debtorRef.flags, true), {
      tag: "v-component"
    })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("По ФССП:")]), _vm._v(" "), (item.debtor) ? _c('v-flex', {
      attrs: {
        "pl-3": ""
      }
    }, [_vm._v(_vm._s(item.debtorName) + " (" + _vm._s(item.debtor) + ")")]) : _vm._e(), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-3": ""
      }
    }, [_vm._v("\n              Адрес: " + _vm._s(item.debtorAddress) + "\n            ")])], 1), _vm._v(" "), _c('v-flex', [_vm._v("\n            Дело в производстве в:\n            "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(item.department))])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n             Адрес "), _c('b', [_vm._v(_vm._s(item.departmentAddress))])])], 1), _vm._v(" "), _c('v-flex', [_vm._v("\n            Актуальность с "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.fileDate, _vm.formats.formatDate)))]), _vm._v(" по " + _vm._s(_vm.formats.blank(item.lastDate, _vm.formats.formatDate)) + "\n          ")])], 1)]
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pt-2": ""
    }
  }, [_vm._v(" История изменений: ")]), _vm._v(" "), (_vm.isLoaded && this.lastItems.length === 0) ? _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._v("Нет данных")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lastItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "pl-2": "",
        "pb-2": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "column": ""
      }
    }, [(_vm.isInDiff(item, 'totalNumber')) ? _c('v-flex', [_vm._v("\n               Номер сводного исполнительного.производства: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.totalNumber)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'enforcementNumber')) ? _c('v-flex', [_vm._v("\n               Номер исполнительного производства: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.enforcementNumber)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'stage')) ? _c('v-flex', [_vm._v("\n               Статус: "), _c('b', [_vm._v(_vm._s(item.stage ? (item.stage == 1 ? 'Открыто' : 'Закрыто') : '-'))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'amount')) ? _c('v-flex', [_vm._v("\n                Задолженность по документу: " + _vm._s(_vm.formats.blank(item.amount, this.formatCurrency)) + "\n              ")]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'remaining')) ? _c('v-flex', [_vm._v("\n                Остаток задолженности: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.remaining, this.formatCurrency)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'executionObject')) ? _c('v-flex', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.executionObject)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'document')) ? _c('v-flex', [_vm._v("\n                Исп. документ: "), (item.document) ? _c('span', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("-")]) : _vm._e(), _vm._v(" "), (item.document) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.document.type)))]), _vm._v(" "), _c('div', [_vm._v("\n                  Номер "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.document.number)))]), _vm._v(" от "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.document.date, _vm.formats.formatDate)))])])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'collector')) ? _c('v-flex', [_vm._v("\n                Взыскатель:\n                "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v("ИНН: " + _vm._s(_vm.formats.blank(_vm.formats.formatInn(item.collector))))])])], 1) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'debtor') || _vm.isInDiff(item, 'debtorName') || _vm.isInDiff(item, 'debtorAddress')) ? _c('v-flex', [_vm._v("\n                Должник:\n                "), (_vm.isInDiff(item, 'debtor')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n                  ИНН:"), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.formats.formatInn(item.debtor))))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'debtorName')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n                  Название"), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.debtorName)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'debtorAddress')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n                  Адрес: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.debtorAddress)))])]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'department') || _vm.isInDiff(item, 'departmentAddress')) ? _c('v-flex', [_vm._v("\n                Дело в производстве в:\n                "), (_vm.isInDiff(item, 'departmentAddress')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.department)))])]) : _vm._e(), _vm._v(" "), (_vm.isInDiff(item, 'departmentAddress')) ? _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n                 Адрес "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.departmentAddress)))])]) : _vm._e()], 1) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pb-0": "",
        "align-end": ""
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.fileDate, _vm.formats.formatDate)))])], 1)], 1)]
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1054 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.loadedPages === 0 ? 'Подробно' : 'Кратко ',
      "expandable": !((this.topCount > this.items.length) && _vm.isLoaded) && this.count > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchTitle()
      }
    }
  }, [_c('div', [_vm._v("\n        Прав требования открыто "), _c('b', [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), (this.sumAmount != null) ? _c('div', [_vm._v("\n            Сумма прав требования \n            "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(this.sumAmount))
    }
  })])]) : _vm._e(), _vm._v(" "), (this.sumRemaining != null) ? _c('div', [_vm._v("\n            Сумма текущих прав требования \n            "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(this.sumRemaining))
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading || this.items.length > 0) ? _c('v-panel-text', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Кратко ' : 'Еще ',
      "expandable": !((this.topCount > this.items.length) && _vm.isLoaded)
    },
    on: {
      "click": function($event) {
        return _vm.switchText()
      }
    }
  }, [_c('div', [_vm._l((_vm.items), function(item) {
    return [_c('div', [_c('div', [_c('b', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.enforcementNumber) + " ")]), _vm._v(" от " + _vm._s(_vm.formats.blank(item.institutionDate, _vm.formats.formatDate)) + "\n            ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n            Должник: "), (item.debtorRef) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.debtorRef, '_blank'))
      }
    }) : _vm._e(), _vm._v(" "), (!item.debtorRef) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (item.debtorRef) ? _c(_vm.renderFlags(item.debtorRef.flags, true), {
      tag: "v-component"
    }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_c('b', [_vm._v("Права требования")]), _vm._v(" были/сейчас: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.amount))
      }
    }), _vm._v("/"), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.remaining))
      }
    })]), _vm._v(" - " + _vm._s(item.executionObject) + ".\n            ")])])], 1)]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1056),
  /* template */
  __webpack_require__(1057),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1056 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelText__ = __webpack_require__(249);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelText___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PanelText__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EnforcementForm__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__EnforcementForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__EnforcementForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_dialogs__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-enforcement-debts-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_5__PanelTitle___default.a, vPanelText: __WEBPACK_IMPORTED_MODULE_6__PanelText___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      items: [],
      count: null,
      sumAmount: null,
      sumRemaining: null,
      topCount: 20,
      loadedPages: 0,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    inn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.ogrn) {
      this.id = this.ogrn;
      this.fetchAggrs();
    }
  },

  watch: {
    inn: function inn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchAggrs();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    renderFlags: 'renderFlags',
    renderDateSince: 'renderDateSince'
  }), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lowItems: function lowItems() {
      return this.items.slice(this.topCount);
    }
  }),
  methods: {
    switchTitle: function switchTitle() {
      if (this.loadedPages === 0) {
        this.fetchItems();
      } else {
        this.isLoaded = false;
        this.loadedPages = 0;
        this.items = [];
      }
    },
    switchText: function switchText() {
      if (!this.isLoaded) {
        this.fetchItems();
      } else {
        this.isLoaded = false;
        this.loadedPages = 0;
        this.items = [];
      }
    },
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatCurrency(number) + '&nbsp;р.' : '-';
    },
    getAggrs: function getAggrs(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о судебных производствах ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGetParams('/openapi/companies/' + id + '/enforcementAggrs', {
        litigant: 'DEBTOR',
        stage: 'OPEN'
      }, cb, cbError);
    },
    fetchAggrs: function fetchAggrs() {
      var _this2 = this;

      if (this.id) {
        this.getAggrs(this.id, function (data) {
          if (data) {
            _this2.count = data.count;
            _this2.sumAmount = data.amount;
            _this2.sumRemaining = data.remaining;
          }
        });
      }
    },
    getItems: function getItems(id, cb) {
      var _this3 = this;

      var cbError = function cbError(e) {
        _this3.isLoading = false;
        _this3.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о судебных производствах ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGetParams('/openapi/companies/' + id + '/enforcements', {
        litigant: 'DEBTOR',
        stage: 'OPEN',
        size: this.topCount,
        page: this.loadedPages
      }, cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this4 = this;

      if (this.id && !this.isLoading) {
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this4.items = _this4.items.concat(data.content);
          _this4.loadedPages = !data.last ? data.number + 1 : data.number;
          _this4.isLoading = false;
          _this4.isLoaded = data.last;
        });
      }
    },

    dialogOpen: function dialogOpen(item) {
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].register('v-enforcement-form', __WEBPACK_IMPORTED_MODULE_7__EnforcementForm___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-enforcement-form v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-enforcement-form>\n      ',
        data: function data() {
          return {
            model: item,
            fullscreen: fullscreen
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1057 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.loadedPages === 0 ? 'Подробно' : 'Кратко ',
      "expandable": !((this.topCount > this.items.length) && _vm.isLoaded) && this.count > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchTitle()
      }
    }
  }, [_c('div', [_vm._v("\n        Долговых обязательств открыто "), _c('b', [_vm._v(_vm._s(_vm.count))]), _vm._v(" "), (this.sumAmount != null) ? _c('div', [_vm._v("\n            Сумма долга\n            "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(this.sumAmount))
    }
  })])]) : _vm._e(), _vm._v(" "), (this.sumRemaining != null) ? _c('div', [_vm._v("\n            Сумма текущего долга\n            "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCurrency(this.sumRemaining))
    }
  })])]) : _vm._e()])]), _vm._v(" "), (_vm.isLoading || this.items.length > 0) ? _c('v-panel-text', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Кратко ' : 'Еще ',
      "expandable": !((this.topCount > this.items.length) && _vm.isLoaded)
    },
    on: {
      "click": function($event) {
        return _vm.switchText()
      }
    }
  }, [_c('div', [_vm._l((_vm.items), function(item) {
    return [_c('div', [_c('div', [_c('b', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.enforcementNumber) + " ")]), _vm._v(" от " + _vm._s(_vm.formats.blank(item.institutionDate, _vm.formats.formatDate)) + "\n            ")])]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_vm._v("\n            Кредитор: "), (item.collectorRef) ? _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.collectorRef, '_blank'))
      }
    }) : _vm._e(), _vm._v(" "), (!item.collectorRef) ? _c('span', [_vm._v("-")]) : _vm._e(), _vm._v(" "), (item.collectorRef) ? _c(_vm.renderFlags(item.collectorRef.flags, true), {
      tag: "v-component"
    }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_c('b', [_vm._v("Задолженность")]), _vm._v(" была/сейчас: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.amount))
      }
    }), _vm._v("/"), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCurrency(item.remaining))
      }
    })]), _vm._v(" - " + _vm._s(item.executionObject) + ".\n            ")]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.department))])])], 1)]
  })], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1)]) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1059),
  /* template */
  __webpack_require__(1062),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1059 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LicenseForm__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__LicenseForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__LicenseForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_dialogs__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-licenses-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_5__PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      items: [],
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderDateSince: 'renderDateSince'
  }), {
    lowItems: function lowItems() {
      return this.items.slice(0, 20);
    },
    formatCountLicenses: function formatCountLicenses() {
      return ''.concat('Лицензий всего ', this.items ? this.items.length : 0);
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatCurrency(number) + ' р.' : '';
    },
    sortItems: function sortItems(a, b) {
      var result = 0;
      if (!result) {
        result = new Date(a.issued.date).getTime() - new Date(b.issued.date).getTime();
      }
      return result;
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о лицензиях ' });
      };
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/licenses', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this2.isLoading = false;
          _this2.items = data;
          _this2.items.sort(function (a, b) {
            return _this2.sortItems(a, b);
          });
        });
      }
    },

    dialogOpen: function dialogOpen(item) {
      __WEBPACK_IMPORTED_MODULE_7__common_dialogs__["a" /* default */].register('v-license-form', __WEBPACK_IMPORTED_MODULE_6__LicenseForm___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-license-form v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-license-form>\n      ',
        data: function data() {
          return {
            model: item,
            fullscreen: fullscreen
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_7__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1060 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_InfoForm__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_InfoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_InfoForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-license-form',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_apimix__["a" /* default */]],
  components: { vInfoForm: __WEBPACK_IMPORTED_MODULE_4__common_InfoForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {}
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: function _default() {}
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {
    if (!this.model) {
      this.item = this.getItemNew();
    } else {
      this.item = this.model;
    }
  },

  watch: {
    model: function model(newVal, oldVal) {
      if (!newVal) {
        this.item = this.getItemNew();
      } else {
        this.item = newVal;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({}), {
    title: function title() {
      return '\u041B\u0438\u0446\u0435\u043D\u0437\u0438\u044F ' + (this.item.number ? this.item.number : 'Лицензия');
    }
  }),
  methods: {
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        number: null,
        startDate: null,
        finishDate: null,
        activities: [],
        locations: [],
        issued: {
          date: null,
          org: null
        },
        paused: null
      };
    }
  }

});

/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-info-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_vm._v("\n           Номер лицензии: "), _c('b', [_vm._v(_vm._s(_vm.item.number))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n           с "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.startDate, _vm.formats.formatDate)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.finishDate),
      expression: "item.finishDate"
    }]
  }, [_vm._v(" по "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.finishDate, _vm.formats.formatDate)))])])]), _vm._v(" "), _c('v-flex', [_c('b', [_vm._v(_vm._s(_vm.item.activities.map(function (a) { return a.name; }).join(', ')))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            Выдана: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.issued.date, _vm.formats.formatDate)))]), _vm._v(" - " + _vm._s(_vm.item.issued.org) + " \n          ")]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.paused != null),
      expression: "item.paused != null"
    }]
  }, [_vm._v("\n            Приостановлена: "), _c('b', [_vm._v(_vm._s(_vm.item.paused ? _vm.formats.blank(_vm.item.paused.date, _vm.formats.formatDate) : ''))]), _vm._v(" - " + _vm._s(_vm.item.paused ? _vm.item.paused.org : '') + " \n          ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1062 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": _vm.items.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountLicenses)
    }
  })])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }]
  }, [_vm._l((_vm.lowItems), function(item) {
    return [_c('div', [_c('div', [_c('b', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.number) + " ")])]), _vm._v(" от " + _vm._s(_vm.formats.blank(item.issued.date, _vm.formats.formatDate)) + "\n            \n          ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_c('b', [_vm._v(_vm._s(item.activities.map(function (a) { return a.name; }).join(', ')))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.issued.org))])])], 1)]
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1064),
  /* template */
  __webpack_require__(1068),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1064 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TrademarkForm__ = __webpack_require__(1065);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TrademarkForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__TrademarkForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_dialogs__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-trademarks-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      items: [],
      topCount: 5,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.ogrn) {
      this.id = this.ogrn;
      this.fetchItems();
    }
  },

  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderDateSince: 'renderDateSince'
  }), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.items.slice(this.topCount);
    },
    formatCountLicenses: function formatCountLicenses() {
      return ''.concat('Товарных знаков ', this.items ? this.items.length : 0);
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    sortItems: function sortItems(a, b) {
      var result = 0;
      if (!result) {
        result = new Date(a.registrationDate).getTime() - new Date(b.registrationDate).getTime();
      }
      return result;
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о лицензиях ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/trademarks', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this2.isLoading = false;
          _this2.items = data;
          _this2.items.sort(function (a, b) {
            return _this2.sortItems(a, b);
          });
        });
      }
    },

    dialogOpen: function dialogOpen(item) {
      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].register('v-trademark-form', __WEBPACK_IMPORTED_MODULE_5__TrademarkForm___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-trademark-form v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-trademark-form>\n      ',
        data: function data() {
          return {
            model: item,
            fullscreen: fullscreen
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].modal(comp);
    },
    getImageUrl: function getImageUrl(item) {
      if (!item || !item.imageUrl) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].getBaseUrl() + '/openapi/trademarks/' + item.registrationNumber + '/preview';
    }
  }
});

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1066),
  /* template */
  __webpack_require__(1067),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_InfoForm__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_InfoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_InfoForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-trademark-form',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_apimix__["a" /* default */]],
  components: { vInfoForm: __WEBPACK_IMPORTED_MODULE_5__common_InfoForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {}
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: function _default() {}
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {
    if (!this.model) {
      this.item = this.getItemNew();
    } else {
      this.item = this.model;
    }
  },

  watch: {
    model: function model(newVal, oldVal) {
      if (!newVal) {
        this.item = this.getItemNew();
      } else {
        this.item = newVal;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({}), {
    title: function title() {
      return '\u0422\u043E\u0432\u0430\u0440\u043D\u044B\u0439 \u0437\u043D\u0430\u043A ' + (this.item.registrationNumber ? this.item.registrationNumber : '');
    }
  }),
  methods: {
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        registrationNumber: null,
        startDate: null,
        finishDate: null,
        activities: [],
        locations: [],
        issued: {
          date: null,
          org: null
        },
        paused: null
      };
    },
    getImageUrl: function getImageUrl(item) {
      if (!item || !item.imageUrl) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].getBaseUrl() + '/openapi/trademarks/' + item.registrationNumber + '/preview';
    },
    getAudioUrl: function getAudioUrl(item) {
      if (!item || !item.imageUrl || !item.sound) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].getBaseUrl() + '/openapi/trademarks/' + item.registrationNumber + '/stream';
    },
    getStreamUrl: function getStreamUrl(item) {
      if (!item || !item.imageUrl) {
        return null;
      }
      return __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].getBaseUrl() + '/openapi/trademarks/' + item.registrationNumber + '/stream';
    },
    getHref: function getHref() {
      if (!this.item || !this.item.publicationUrl) {
        return '';
      }
      return this.item.publicationUrl;
    }
  }

});

/***/ }),
/* 1067 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-info-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_vm._v("\n             Номер государственной регистрации:\n             "), _c('b', [_c('a', {
    attrs: {
      "href": _vm.getHref(),
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.item.registrationNumber))])])]), _vm._v(" "), _c('v-flex', [_vm._v("\n             с "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.registrationDate, _vm.formats.formatDate)))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.expirationDate),
      expression: "item.expirationDate"
    }]
  }, [_vm._v(" по "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.expirationDate, _vm.formats.formatDate)))])]), _vm._v(" "), _c('b', [(_vm.item.actual) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formats.formatSuccessHtml('- актуальный'))
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.item.actual) ? _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formats.formatErrorHtml('- не актуальный'))
    }
  }) : _vm._e()])]), _vm._v(" "), _c('v-flex', [_vm._v("\n              Описание: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.description)))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n              Изображение (воспроизведение) товарного знака, знака обслуживания:\n              "), _c('div', [(!_vm.getImageUrl(_vm.item)) ? _c('span', [_vm._v("Изображение не обнаружено ")]) : _vm._e(), _vm._v(" "), (_vm.getAudioUrl(_vm.item)) ? _c('span', [_c('audio', {
    attrs: {
      "controls": ""
    }
  }, [_c('source', {
    attrs: {
      "src": _vm.getAudioUrl(_vm.item),
      "type": "audio/mpeg"
    }
  }), _vm._v("\n                    Your browser does not support the audio element.\n                  ")])]) : _vm._e(), _vm._v(" "), (_vm.getImageUrl(_vm.item) && !_vm.item.sound) ? _c('a', {
    attrs: {
      "href": _vm.getStreamUrl(_vm.item),
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "width": "60%",
      "src": _vm.getImageUrl(_vm.item)
    }
  })]) : _vm._e()])]), _vm._v(" "), _c('v-flex', [_vm._v("\n              Классы МКТУ и перечень товаров и/или услуг:\n              "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.nice)))])])])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1068 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountLicenses)
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-left": "",
      "justify-center": ""
    }
  }, [_vm._l((_vm.topItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "px-2": ""
      }
    }, [_c('b', [(!_vm.getImageUrl(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v(_vm._s(item.registrationNumber))]) : _vm._e()]), _vm._v(" "), _c('b', [(_vm.getImageUrl(item) && item.sound) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v("Звук"), _c('br'), _vm._v(" " + _vm._s(item.registrationNumber))]) : _vm._e()]), _vm._v(" "), (_vm.getImageUrl(item) && !item.sound) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_c('img', {
      staticStyle: {
        "max-height": "120px"
      },
      attrs: {
        "src": _vm.getImageUrl(item)
      }
    })]) : _vm._e()])]
  })], 2)], 1)]), _vm._v(" "), (_vm.isLoaded && _vm.lastItems.length > 0) ? _c('v-card-text', {
    staticClass: "pt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-center": ""
    }
  }, [_vm._l((_vm.lastItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "px-2": ""
      }
    }, [_c('b', [(!_vm.getImageUrl(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v(_vm._s(item.registrationNumber))]) : _vm._e()]), _vm._v(" "), (_vm.getImageUrl(item)) ? _c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [(_vm.getImageUrl(item)) ? _c('img', {
      staticStyle: {
        "max-height": "120px"
      },
      attrs: {
        "src": _vm.getImageUrl(item)
      }
    }) : _vm._e()]) : _vm._e()])]
  })], 2)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1069 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1070),
  /* template */
  __webpack_require__(1071),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-reorg-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      items: [],
      item: null,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {},

  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    renderInnHtml: 'renderInnHtml',
    renderDateSince: 'renderDateSince'
  })),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о реорганизации компании из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/reorgs', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this2.isLoading = false;
          if (data && data.length > 0) {
            _this2.items = data;
          }
        });
      }
    }
  }
});

/***/ }),
/* 1071 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": this.items.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', [_vm._v("\n        Реорганизации(" + _vm._s(_vm.items.length) + "):\n      ")]), _vm._v(" "), (this.items.length === 0) ? _c('v-flex', [_vm._v("\n        Данные не найдены.\n      ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.items), function(reorg) {
    return [(reorg.restricted && reorg.restricted.code > 0) ? _c('div', [_vm._v("Доступ ограничен "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(reorg.restricted))
      }
    })]) : _vm._e(), _vm._v(" "), _c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(reorg.created, _vm.formats.formatDate)))]), _vm._v(" " + _vm._s(reorg.form) + "\n            ")]), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isLoaded),
        expression: "isLoaded"
      }]
    }, [_vm._l((reorg.reorgees), function(item) {
      return [_c('v-flex', {
        attrs: {
          "pl-2": ""
        }
      }, [_c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderReference(item))
        }
      }), _vm._v(" "), _c('v-flex', {
        attrs: {
          "pl-2": ""
        }
      }, [_c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderInnHtml(item.inn))
        }
      })])]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(item))
        }
      }), _vm._v("\n                      " + _vm._s(item.nextState) + "\n                    ")])], 1)]
    })], 2)]
  })], 2)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  })])], 1)
},staticRenderFns: []}

/***/ }),
/* 1072 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1073),
  /* template */
  __webpack_require__(1074),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-records-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    fillHeight: {
      type: Boolean,
      default: false
    },
    topCount: {
      type: Number,
      default: 2
    },
    records: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({}), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.items.slice(this.topCount);
    },
    items: function items() {
      return this.records;
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        // this.fetchItems()
      }
    }
    // ,
    // getItems (id, cb) {
    //   const cbError = (e) => {
    //     this.isLoading = false
    //     this.$store.commit('setErrorStatus', {error: e, context: 'Ошибка сервера при получении информации о записях из ЕГРЮЛ '})
    //   }
    //   server.openApiGet(
    //     '/openapi/companies/' + id + '/records',
    //     cb,
    //     cbError)
    // },
    // fetchItems () {
    //   if (this.id && !this.isLoading) {
    //     this.items = []
    //     this.isLoading = true
    //     this.getItems(this.id, (data) => {
    //       this.items = data
    //       this.items.sort((a, b) => this.sortItems(a, b))
    //       this.isLoading = false
    //     })
    //   }
    // }

  }
});

/***/ }),
/* 1074 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      Изменения в ЕГРЮЛ (" + _vm._s(_vm.items.length) + ")\n      "), _vm._l((_vm.topItems), function(item) {
    return [_c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.updated, _vm.formats.formatDate)))]), _vm._v(" " + _vm._s(item.value) + "\n        ")])]
  })], 2)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded && _vm.items.length > 0),
      expression: "isLoaded && items.length > 0"
    }],
    staticClass: "pt-0"
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n    Данные не найдены.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lastItems), function(item) {
    return [_c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.updated, _vm.formats.formatDate)))]), _vm._v(" " + _vm._s(item.value) + "\n      ")])]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1075 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1076),
  /* template */
  __webpack_require__(1077),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(14);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__people_index__ = __webpack_require__(27);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var Items = function () {
  function Items(id, f) {
    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, Items);

    this.id = id;
    this.getFunction = f;
    this.fill([]);
  }

  __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(Items, [{
    key: 'lock',
    value: function lock() {
      this.isLoading = true;
    }
  }, {
    key: 'unlock',
    value: function unlock() {
      this.isLoading = false;
    }
  }, {
    key: 'fill',
    value: function fill(data) {
      this.items = data;
      this.isLoading = false;
    }
  }]);

  return Items;
}();

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-history-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_6__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      item: null,
      isLoaded: false,
      names: null,
      addresses: null,
      capitals: null,
      heads: null,
      holders: null,
      lists: []
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      this.initData();
    }
  },
  created: function created() {
    this.initData();
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    getRefToUrl: 'getRefToUrl',
    renderReference: 'renderReference',
    renderCopyButton: 'renderCopyButton',
    renderContactButton: 'renderContactButton',
    renderEmployeeReference: 'renderEmployeeReference',
    renderInnHtml: 'renderInnHtml',
    renderInnflHtml: 'renderInnflHtml',
    renderDateSince: 'renderDateSince',
    renderUnreliableHtml: 'renderUnreliableHtml',
    getIconName: 'getIconName'
  }), {
    isLoading: function isLoading() {
      return this.names.isLoading || this.addresses.isLoading || this.capitals.isLoading || this.heads.isLoading || this.holders.isLoading;
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded) {
        this.fetchData();
      }
    },
    fetchData: function fetchData() {
      this.fetchItems(this.names);
      this.fetchItems(this.addresses);
      this.fetchItems(this.capitals);
      this.fetchItems(this.heads);
      this.fetchItems(this.holders);
    },
    initData: function initData() {
      this.isLoaded = false;
      this.names = new Items(this.id, this.getNameItems);
      this.addresses = new Items(this.id, this.getAddressItems);
      this.capitals = new Items(this.id, this.getCapitalItems);
      this.heads = new Items(this.id, this.getHeadItems);
      this.holders = new Items(this.id, this.getHolderItems);
    },
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatCurrency(number) + ' руб.' : '';
    },
    formatCapital: function formatCapital(capital) {
      if (!capital) {
        return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись об уставном капитале компании');
      }
      return ''.concat('<div>', capital.type ? capital.type + ':' : __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись о типе уставнго капитала'), ' <b>' + this.formatCurrency(capital.value) + '</b>', this.renderDateSince(capital), '</div>', '<div>', this.formatLessenings(capital), __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatWarningHtml(capital.desc), '</div>');
    },
    formatLessenings: function formatLessenings(capital) {
      var _this = this;

      if (!capital.lessenings) {
        return '';
      }
      var result = '';
      capital.lessenings.forEach(function (l) {
        result = result.concat('<div>', '\xa0\xa0', 'Уменьшение капитала на ', _this.formatCurrency(l.value), _this.renderDateSince(l), '</div>');
      });
      return result;
    },
    createEmployeeComp: function createEmployeeComp(employee) {
      var self = this;
      var template = '\n      <div>\n      <div>\n        {{employee.position}}\n        <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C\', getPosition)" /> :\n      </div>\n      <span v-html="self.renderEmployeeReference(employee)"></span>\n      <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0418\u041E\', getNameFull)" />\n      <v-component :is="self.renderContactButton(\'\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430\', openContact)" />\n        <div>\n          \u0418\u041D\u041D ' + self.renderInnflHtml(employee.inn) + '\n          <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0418\u041D\u041D\', getInn)" />\n        </div>\n        <div> ' + self.renderDateSince(employee) + '</div>\n        <div> ' + self.renderUnreliableHtml(employee) + '</div>\n        <div> ' + self.formatDisqHtml(employee.disqualification) + '</div>\n      </div>\n      ';
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            employee: employee
          };
        },
        methods: {
          getPosition: function getPosition() {
            return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(employee, ['position']);
          },
          getNameFull: function getNameFull() {
            return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(employee, ['nameFull']);
          },
          getInn: function getInn() {
            return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatInnfl(__WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(employee, ['inn']));
          },
          openContact: function openContact() {
            var refCode = __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(self.company, ['reference', 'ref']);
            __WEBPACK_IMPORTED_MODULE_7__people_index__["a" /* default */].openByHuman(refCode, employee);
          }
        }
      };
    },
    formatDisqHtml: function formatDisqHtml(disq) {
      if (!disq) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatErrorHtml('\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u0446\u0438\u044F \u0441 ' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDate(disq.fromDate) + ' \u043F\u043E ' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDate(disq.toDate) + ' \u0440\u0435\u0448\u0435\u043D\u0438\u0435 \u043E\u0442 ' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDate(disq.decisionDate));
    },
    formatShares: function formatShares(shares) {
      var _this2 = this;

      var fShare = function fShare(v) {
        return v ? '(' + _this2.formatCurrency(v) + ')' : '';
      };
      var fPercent = function fPercent(v) {
        return v ? v + '%' : '';
      };
      var fSince = function fSince(v) {
        return _this2.renderDateSince(v);
      };
      var result = '';
      shares.forEach(function (s) {
        result = result.concat('<div><b>' + fPercent(s.percent) + ' ' + fShare(s.share) + '</b> ' + fSince(s) + '</div>');
      });
      return result;
    },
    formatWarningHtml: function formatWarningHtml(message) {
      return __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatWarningHtml(message);
    },
    getCompanyNameFull: function getCompanyNameFull(item) {
      return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(item, ['value']);
    },
    getCompanyNameShort: function getCompanyNameShort(item) {
      return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(item, ['nameShort']);
    },
    getAddress: function getAddress(item) {
      return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(item, ['value']);
    },
    getNameFull: function getNameFull(item) {
      return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(item, ['refObject', 'name']);
    },
    getMunicipalNameFull: function getMunicipalNameFull(item) {
      return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(item, ['refObject', 'desc']);
    },
    getPifNameFull: function getPifNameFull(item) {
      return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(item, ['name']);
    },
    getInn: function getInn(item) {
      return '' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].getValue(item, ['refObject', 'inn']);
    },
    openContact: function openContact(item) {
      console.log('openContact', item);
      var names = this.getNameFull(item).split(' ');
      var ops = {
        inn: this.getInn(item),
        lastName: names.length > 0 ? names[0] : '',
        firstName: names.length > 1 ? names[1] : '',
        middleName: names.length > 2 ? names[2] : '',
        position: 'Участник'
      };
      __WEBPACK_IMPORTED_MODULE_7__people_index__["a" /* default */].openByHuman(null, ops);
    },
    isHolderNamespace: function isHolderNamespace(item, namespace) {
      return item && item.refObject && __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(item.refObject.namespace, namespace) === 0;
    },
    getNameItems: function getNameItems(list, cb) {
      var _this3 = this;

      var cbError = function cbError(e) {
        list.unlock();
        _this3.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации об названиях компании ' });
      };
      __WEBPACK_IMPORTED_MODULE_5__api_server__["a" /* default */].openApiGet('/openapi/companies/' + list.id + '/names', cb, cbError);
    },
    getAddressItems: function getAddressItems(list, cb) {
      var _this4 = this;

      var cbError = function cbError(e) {
        list.unlock();
        _this4.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации об адресах компании ' });
      };
      __WEBPACK_IMPORTED_MODULE_5__api_server__["a" /* default */].openApiGet('/openapi/companies/' + list.id + '/addresses', cb, cbError);
    },
    getCapitalItems: function getCapitalItems(list, cb) {
      var _this5 = this;

      var cbError = function cbError(e) {
        list.unlock();
        _this5.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации об изменении капитала компании ' });
      };
      __WEBPACK_IMPORTED_MODULE_5__api_server__["a" /* default */].openApiGet('/openapi/companies/' + list.id + '/capitals', cb, cbError);
    },
    getHeadItems: function getHeadItems(list, cb) {
      var _this6 = this;

      var cbError = function cbError(e) {
        list.unlock();
        _this6.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации об изменении руководителей компании ' });
      };
      __WEBPACK_IMPORTED_MODULE_5__api_server__["a" /* default */].openApiGet('/openapi/companies/' + list.id + '/heads', cb, cbError);
    },
    getHolderItems: function getHolderItems(list, cb) {
      var _this7 = this;

      var cbError = function cbError(e) {
        list.unlock();
        _this7.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации об изменении участников компании ' });
      };
      __WEBPACK_IMPORTED_MODULE_5__api_server__["a" /* default */].openApiGet('/openapi/companies/' + list.id + '/owners', cb, cbError);
    },
    fetchItems: function fetchItems(list) {
      if (list.id && !list.isLoading) {
        list.lock();
        list.getFunction(list, function (data) {
          list.fill(data);
        });
      }
    }
  }
});

/***/ }),
/* 1077 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded,
      "caption": this.isLoaded ? 'Свернуть' : 'Загрузить',
      "expandable": true
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      История изменений\n    ")])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', [_c('b', [_vm._v("Названия (" + _vm._s(_vm.names.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.names.items), function(item) {
    return [_c('div', [_vm._v("\n              " + _vm._s(_vm.getCompanyNameFull(item)) + "\n              "), _c(_vm.renderCopyButton('Копировать название', _vm.getCompanyNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("Кратко: " + _vm._s(_vm.getCompanyNameShort(item)) + "\n                  "), _c(_vm.renderCopyButton('Копировать краткое название', _vm.getCompanyNameShort, item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })])], 1)]
  })], 2)], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Адреса (" + _vm._s(_vm.addresses.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.addresses.items), function(item) {
    return [_c('div', [_vm._v("\n              " + _vm._s(_vm.getAddress(item)) + "\n              "), _c(_vm.renderCopyButton('Копировать название', _vm.getAddress, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })])], 1)]
  })], 2)], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Капитал (" + _vm._s(_vm.capitals.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.capitals.items), function(item) {
    return [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatCapital(item))
      }
    })]
  })], 2)], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Руководители (" + _vm._s(_vm.heads.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.heads.items), function(item) {
    return [_c(_vm.createEmployeeComp(item), {
      tag: "v-component"
    })]
  })], 2)], 1), _vm._v(" "), _c('div', [_c('b', [_vm._v("Участники (" + _vm._s(_vm.holders.items.length) + "):")]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_vm._l((_vm.holders.items), function(item) {
    return [_c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'ogrn')),
        expression: "isHolderNamespace(item,'ogrn')"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.refObject))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать название', _vm.getNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.refObject.inn))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать инн', _vm.getInn, item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'HUMAN')),
        expression: "isHolderNamespace(item,'HUMAN')"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.refObject))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать ФИО', _vm.getNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c(_vm.renderContactButton('Открыть контакт физического лица', _vm.openContact, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ИНН "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnflHtml(item.refObject.inn))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать инн', _vm.getInn, item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'FOREIGN')),
        expression: "isHolderNamespace(item,'FOREIGN')"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.refObject))
      }
    }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать название', _vm.getNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'MUNICIPAL')),
        expression: "isHolderNamespace(item,'MUNICIPAL')"
      }]
    }, [_c('span', [_vm._v(_vm._s(_vm.getMunicipalNameFull(item)) + "\n              ")]), _vm._v(" "), _c(_vm.renderCopyButton('Копировать название', _vm.getMunicipalNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'PIF')),
        expression: "isHolderNamespace(item,'PIF')"
      }]
    }, [_c('span', [_vm._v(_vm._s(_vm.getPifNameFull(item)))]), _vm._v(" "), _c(_vm.renderCopyButton('Копировать название', _vm.getPifNameFull, item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('div', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isHolderNamespace(item, 'OTHER')),
        expression: "isHolderNamespace(item,'OTHER')"
      }]
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.refObject))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatWarningHtml('Запись об учредителе не поддерживается.'))
      }
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatShares(item.shares))
      }
    })])], 1), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderUnreliableHtml(item))
      }
    })]
  })], 2)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 1078 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1079),
  /* template */
  __webpack_require__(1083),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PanelTitle__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-fin-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_6__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      items: [],
      years: [],
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    ogrn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        // this.fetchItems()
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    renderDateSince: 'renderDateSince'
  }), {
    balanceItems: function balanceItems() {
      return this.items.filter(function (i) {
        return i.code < 20000;
      });
    },
    printActions: function printActions() {
      var _this = this;

      var result = [];
      result.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].Action(this, 'Pdf', null, function () {
        return _this.print('pdf');
      }));
      result.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].Action(this, 'Экспорт в docx', null, function () {
        return _this.print('docx');
      }));
      result.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].Action(this, 'Экспорт в odt', null, function () {
        return _this.print('odt');
      }));
      result.push(new __WEBPACK_IMPORTED_MODULE_5__api_classes__["a" /* default */].Action(this, 'Экспорт в rtf', null, function () {
        return _this.print('rtf');
      }));
      return result;
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded) {
        this.fetchItems();
      }
    },
    getPartItems: function getPartItems(from, to) {
      return this.items.filter(function (i) {
        return i.code > from && i.code < to;
      });
    },
    formatCurrency: function formatCurrency(number) {
      return number != null ? number >= 0 ? __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatCurrency(number) : '(' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatCurrency(Math.abs(number)) + ')' : '';
    },
    formatHeaders: function formatHeaders() {
      var result = '';
      var years = this.years;
      if (years) {
        var width = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(100 / years.length);
        years.forEach(function (k) {
          var template = '<th align="right" width="' + width + '%">' + k.year + ' \u0433. </th>';
          result = result + template;
        });
      }
      return result;
    },
    formatValues: function formatValues(item) {
      var _this2 = this;

      var result = '';
      var years = this.years;
      if (item && years) {
        var lastKey = years[years.length - 1];
        years.forEach(function (k) {
          var value = _this2.formatCurrency(item.values[k.year]);
          if (k === lastKey) {
            value = '<b>' + value + '</b>';
          }
          var template = '<td align="right">' + value + '</td>';
          result = result + template;
        });
      }
      return result;
    },
    formatCounter: function formatCounter(item) {
      return '<tr><td colspan="' + this.years.length + '"> <b>' + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_math_trunc___default()(item.code / 10) + '</b> ' + item.name + '</td></tr> \n      <tr>' + this.formatValues(item) + '</tr>';
    },
    print: function print(format) {
      var url = __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].getBaseUrl() + '/openapi/companies/' + this.ogrn + '/fin/year_statements/redirect?format=' + format;
      this.$store.dispatch('openLocation', url);
    },
    getItems: function getItems(id, cb) {
      var _this3 = this;

      var cbError = function cbError(e) {
        _this3.isLoading = false;
        _this3.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении финансового отчета ' });
      };
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].openApiGet('/openapi/companies/' + id + '/fin/year_statements', cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this4 = this;

      if (this.id && !this.isLoading) {
        this.years = [];
        this.items = [];
        this.isLoading = true;
        this.getItems(this.id, function (data) {
          _this4.isLoading = false;
          _this4.years = data.years;
          _this4.items = data.counters;
        });
      }
    }
  }
});

/***/ }),
/* 1080 */,
/* 1081 */,
/* 1082 */,
/* 1083 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded,
      "caption": this.isLoaded ? 'Свернуть' : 'Загрузить',
      "expandable": true,
      "printActions": _vm.printActions
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v(" Финансовая отчетность (тыс.р.)")])])]), _c('br')])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [(_vm.isLoaded) ? _c('div', [_c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Бухгалтерский баланс")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(0, 20000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Отчет о прибылях и убытках")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(20000, 30000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Отчет об изменениях капитала")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(30000, 40000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Отчет о движении денежных средств")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(40000, 50000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2), _vm._v(" "), _c('br'), _vm._v(" "), _c('table', {
    attrs: {
      "width": "100%"
    }
  }, [_c('tr', [_c('th', {
    attrs: {
      "align": "left",
      "colspan": _vm.years.length
    }
  }, [_vm._v("Отчет о целевом использовании полученных средств")])]), _vm._v(" "), _c('tr', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatHeaders())
    }
  }), _vm._v(" "), _vm._l((this.getPartItems(60000, 70000)), function(item) {
    return [(item) ? _c('tr', [_c('td', {
      attrs: {
        "colspan": _vm.years.length
      }
    }, [_c('b', [_vm._v(_vm._s(Math.trunc(item.code / 10)))]), _vm._v(" " + _vm._s(item.name))])]) : _vm._e(), _vm._v(" "), (item) ? _c('tr', {
      domProps: {
        "innerHTML": _vm._s(_vm.formatValues(item))
      }
    }) : _vm._e()]
  })], 2)]) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1085);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("d5d52e60", content, true, {});

/***/ }),
/* 1085 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".align-end{text-align:right}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/info/VisitPanel.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB","file":"VisitPanel.vue","sourcesContent":["\n.align-end{\r\n  text-align: right;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__info_PanelTitle__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-visit-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_5__info_PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      items: [],
      totalPages: 0,
      loadedPages: 0,
      isLoaded: false,
      isLoading: false,
      actions: function actions() {
        return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_map___default.a([['OTHER', 'Неизвестная операция'], ['LOGIN', 'вход в систему']]);
      }
    };
  },
  props: {
    refCode: {
      type: String,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    },
    topCount: {
      type: Number,
      default: 2
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient'
  }), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.items.slice(this.topCount);
    }
  }),
  methods: {
    switchItems: function switchItems() {
      if (!this.isLoaded) {
        this.fetchItems();
      } else {
        this.isLoaded = false;
        this.loadedPages = 1;
        this.items = this.topItems;
      }
    },
    getItems: function getItems(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.isLoading = false;
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка посещений ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].apiGetParams('/api/me/companies/' + id + '/visits', {
        size: this.topCount,
        page: this.loadedPages
      }, cb, cbError);
    },
    fetchItems: function fetchItems() {
      var _this2 = this;

      if (!this.isLoading && this.refCode && this.getProfileHaveClient) {
        // this.items = []
        this.isLoading = true;
        this.getItems(this.refCode, function (data) {
          _this2.items = _this2.items.concat(data.content);
          _this2.totalPages = data.totalPages;
          _this2.loadedPages = data.totalPages > data.number ? data.number + 1 : data.totalPages;
          _this2.isLoading = false;
          _this2.isLoaded = _this2.totalPages === _this2.loadedPages;
        });
      }
    }
  }
});

/***/ }),
/* 1087 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": _vm.isLoaded ? 'Показать ' + this.topCount : _vm.loadedPages === 0 ? 'Загрузить' : 'Еще',
      "expandable": !((_vm.totalPages == _vm.loadedPages) && (this.topCount > this.items.length) && _vm.isLoaded)
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading && _vm.loadedPages < 0),
      expression: "isLoading && loadedPages < 0"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.isLoading && _vm.loadedPages == 0)),
      expression: "!(isLoading && loadedPages == 0)"
    }]
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "left",
      "colspan": "2"
    }
  }, [_vm._v(" История просмотров")])]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "pb-0": ""
      }
    }, [_vm._v(_vm._s(item.accountNameShort))]), _c('v-flex', {
      attrs: {
        "pb-0": "",
        "align-end": ""
      }
    }, [_vm._v(_vm._s(_vm.formats.blank(item.created, _vm.formats.formatDateTime)))])], 1)]
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__people_index_js__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-records-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      isLoaded: false,
      isLoading: false,
      items: [],
      topCount: 1
    };
  },
  props: {
    fillHeight: {
      type: Boolean,
      default: false
    },
    refCode: {
      type: String,
      default: false
    }
  },
  mounted: function mounted() {
    if (this.refCode) {
      this.id = this.refCode;
      this.fetchItems();
    }
  },

  watch: {
    ogrn: function ogrn(newVal, oldVal) {
      // watch it
      this.id = newVal;
      if (this.id) {
        this.fetchItems();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderContactButton: 'renderContactButton'
  }), {
    topItems: function topItems() {
      return this.orderedItems.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.orderedItems.slice(this.topCount);
    },
    orderedItems: function orderedItems() {
      return __WEBPACK_IMPORTED_MODULE_4__people_index_js__["a" /* default */].sortContactsByCompany(this.items);
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
    },
    fetchItems: function fetchItems() {
      var _this = this;

      if (this.id && !this.isLoading) {
        this.items = [];
        this.isLoading = true;
        this.$store.dispatch('getCompanyContacts', this.id).then(function (data) {
          _this.isLoading = false;
          _this.items = data;
        });
      }
    },
    createContactTitle: function createContactTitle(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_4__people_index_js__["a" /* default */].createStrategy(this, 'CONTACT');
      strategy.setParentProps({ refCode: this.id });
      if (strategy && strategy.viewTitleComp) {
        return strategy.viewTitleComp(strategy.createModelFromData(item));
      }
      return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].createComp('<span>Новый тип документа</span>');
    },
    createContactContent: function createContactContent(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_4__people_index_js__["a" /* default */].createStrategy(this, 'CONTACT');
      strategy.setParentProps({ refCode: this.id });
      if (item && strategy && strategy.viewContentComp) {
        return strategy.viewContentComp(strategy.createModelFromData(item));
      }
      return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].createComp('<span></span>');
    },
    openContact: function openContact(item) {
      __WEBPACK_IMPORTED_MODULE_4__people_index_js__["a" /* default */].open(item.clientIndividualId);
    }
  }
});

/***/ }),
/* 1089 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      Контакты (" + _vm._s(_vm.items.length) + ")\n      "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-left": ""
    }
  }, [_vm._l((_vm.topItems), function(item) {
    return [_c('v-flex', [_c('b', [_c(_vm.createContactTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c(_vm.renderContactButton('Открыть контакт физического лица', _vm.openContact, item), {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.clientIndividualId),
        expression: "item.clientIndividualId"
      }],
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c(_vm.createContactContent(item), {
      tag: "component"
    })], 1)], 1)]
  })], 2)], 1)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded && _vm.items.length > 0),
      expression: "isLoaded && items.length > 0"
    }],
    staticClass: "pt-0"
  }, [_vm._l((_vm.lastItems), function(item) {
    return [_c('v-flex', [_c('b', [_c(_vm.createContactTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c(_vm.renderContactButton('Открыть контакт физического лица', _vm.openContact, item), {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.clientIndividualId),
        expression: "item.clientIndividualId"
      }],
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c(_vm.createContactContent(item), {
      tag: "component"
    })], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__favorite_index_js__ = __webpack_require__(124);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-banks-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      isLoaded: false,
      isLoading: false,
      topCount: 1
    };
  },
  props: {
    fillHeight: {
      type: Boolean,
      default: false
    },
    banks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({}), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.items.slice(this.topCount);
    },
    items: function items() {
      return this.banks;
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
    },
    createBankTitle: function createBankTitle(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_4__favorite_index_js__["a" /* default */].createStrategy(this, 'COMPANY_BANK');
      if (strategy && strategy.viewTitleComp) {
        return strategy.viewTitleComp(strategy.createModelFromData(item));
      }
      return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].createComp('<span>Новый тип документа</span>');
    },
    createBankContent: function createBankContent(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_4__favorite_index_js__["a" /* default */].createStrategy(this, 'COMPANY_BANK');
      if (strategy && strategy.viewContentComp) {
        return strategy.viewContentComp(strategy.createModelFromData(item));
      }
      return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].createComp('<span></span>');
    }
  }
});

/***/ }),
/* 1091 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      Счета в банках (" + _vm._s(_vm.items.length) + ")\n      "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "align-left": ""
    }
  }, [_vm._l((_vm.topItems), function(item) {
    return [_c('v-flex', [_c('b', [_c(_vm.createBankTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c(_vm.createBankContent(item), {
      tag: "component"
    })], 1)], 1)]
  })], 2)], 1)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded && _vm.items.length > 0),
      expression: "isLoaded && items.length > 0"
    }],
    staticClass: "pt-0"
  }, [_vm._l((_vm.lastItems), function(item) {
    return [_c('v-flex', [_c('b', [_c(_vm.createBankTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c(_vm.createBankContent(item), {
      tag: "component"
    })], 1)], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_apimix__ = __webpack_require__(20);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-credentinals-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_2__PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_4__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      isLoaded: false,
      isLoading: false,
      topCount: 1
    };
  },
  props: {
    fillHeight: {
      type: Boolean,
      default: false
    },
    reg: null,
    tax: null,
    pf: null,
    fss: null
  },
  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderValueLink: 'renderValueLink'
  }), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.items.slice(this.topCount);
    },
    items: function items() {
      return [];
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
    },
    formatDate: function formatDate(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].blank(dateTime, __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate);
    },
    createTaxOfficeComp: function createTaxOfficeComp(taxOffice) {
      console.log('createTaxOfficeComp', taxOffice);
      var self = this;
      var template = ''.concat('<div>              \n            <div v-if="dto && dto.name">\n              <component :is="self.renderValueLink(self.formats.blank(dto.name) , null, null, \'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\')"/>\n            </div>\n            <div v-if="dto && dto.code">\n              <component :is="self.renderValueLink(dto.code, \'\u041A\u043E\u0434 \u043F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F:\', null, \'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043A\u043E\u0434\')"/>\n            </div>\n            <div v-if="dto && dto.address">\n            <component :is="self.renderValueLink(dto.address , \'\u0410\u0434\u0440\u0435\u0441:\', null, \'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0434\u0440\u0435\u0441\')"/>\n            </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            dto: taxOffice
          };
        }
      };
    }
  }
});

/***/ }),
/* 1093 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": true
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [(_vm.reg) ? _c('div', [_vm._v(" Регистрация: " + _vm._s(_vm.formatDate(_vm.reg.regDate)))]) : _vm._e(), _vm._v("\n\n      Постановка на учет:        \n      "), (_vm.tax) ? _c('div', [_vm._v(" Налоговая служба с " + _vm._s(_vm.formatDate(_vm.tax.regDate)))]) : _vm._e(), _vm._v(" "), (_vm.pf) ? _c('div', [_vm._v(" Пенсионный фонд с " + _vm._s(_vm.formatDate(_vm.pf.regDate)))]) : _vm._e(), _vm._v(" "), (_vm.fss) ? _c('div', [_vm._v(" Фонд Социального Страхования с " + _vm._s(_vm.formatDate(_vm.fss.regDate)))]) : _vm._e()])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [(_vm.reg) ? _c('div', [_vm._v("\n      Регистрация:\n      "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_c(_vm.createTaxOfficeComp(_vm.reg.authority), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.reg.number), 'Номер:', null, 'Копировать номер'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.formatDate(_vm.reg.regDate)), 'Дата регистрации:', null, 'Копировать дату'), {
    tag: "component"
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.tax) ? _c('div', [_vm._v("\n      Налоговая служба:\n      "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_c(_vm.createTaxOfficeComp(_vm.tax.authority), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.tax.inn), 'ИНН:', null, 'Копировать ИНН'), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.renderValueLink(_vm.formats.blank(_vm.tax.kpp), 'КПП:', null, 'Копировать КПП'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.formatDate(_vm.tax.regDate)), 'Дата постановки на учет:', null, 'Копировать дату'), {
    tag: "component"
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.pf) ? _c('div', [_vm._v("\n      Пенсионный фонд:\n      "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_c(_vm.createTaxOfficeComp(_vm.pf.authority), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.pf.number), 'Номер:', null, 'Копировать номер'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.formatDate(_vm.pf.regDate)), 'Дата постановки на учет:', null, 'Копировать дату'), {
    tag: "component"
  })], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.fss) ? _c('div', [_vm._v("\n      Фонд Социального Страхования:\n      "), _c('v-flex', {
    attrs: {
      "pl-2": ""
    }
  }, [_c(_vm.createTaxOfficeComp(_vm.fss.authority), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.fss.number), 'Номер:', null, 'Копировать номер'), {
    tag: "component"
  })], 1), _vm._v(" "), _c('div', [_c(_vm.renderValueLink(_vm.formats.blank(_vm.formatDate(_vm.fss.regDate)), 'Дата постановки на учет:', null, 'Копировать дату'), {
    tag: "component"
  })], 1)], 1)], 1) : _vm._e()])], 1)
},staticRenderFns: []}

/***/ }),
/* 1094 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PanelTitle__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import server from '../../api/server'


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-links-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_2__PanelTitle___default.a },
  data: function data() {
    return {
      id: null,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    inn: {
      type: Number,
      default: null
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.id = this.inn;
  },

  watch: {
    inn: function inn(newVal, oldVal) {
      // watch it
      this.id = this.inn;
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({})),
  methods: {
    switchItems: function switchItems() {},
    open: function open(url) {
      this.$store.dispatch('copyToClipboard', { text: this.inn });
      this.$store.dispatch('openLocation', url);
    }
  }
});

/***/ }),
/* 1095 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": false
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.inn),
      expression: "inn"
    }]
  }, [_vm._v("\n        Полезные ссылки\n        "), _c('div', [_c('a', {
    attrs: {
      "href": 'https://atlant-smart.ru/services/entities/' + _vm.inn + '/excerpt?mode=redirect',
      "target": "_blank"
    }
  }, [_vm._v("Выписка из ЕГРЮЛ/ЕГРИП с ЭЦП ФНС РФ")])]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": 'https://bo.nalog.gov.ru/search?query=' + _vm.inn + '&page=1',
      "target": "_blank"
    }
  }, [_vm._v("Бухгалтерская отчетность")])]), _vm._v(" "), _c('div', [_c('a', {
    on: {
      "click": function($event) {
        return _vm.open('https://kad.arbitr.ru')
      }
    }
  }, [_vm._v("Картотека арбитражных дел ")]), _c('br'), _vm._v("(ИНН копируется в буфер обмена)")]), _vm._v(" "), _c('div', [_c('a', {
    attrs: {
      "href": 'https://fedresurs.ru/entities?searchString=' + _vm.inn,
      "target": "_blank"
    }
  }, [_vm._v("Федресурс (публикации существенных фактов)")])])])])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1096 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.company.name.caption) + "\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-tooltip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (this.otherAttribs.length > 0),
      expression: "this.otherAttribs.length > 0"
    }],
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    }
  }, [_c('v-icon', [_vm._v("face")])], 1)], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(this.getOtherAttribsNameShort()))])])], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(60, 104)
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-company-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "company": _vm.company,
      "notesAvailable": _vm.company && _vm.company.inn && _vm.getProfileHaveClient && _vm.favoriteLists != null,
      "notesEditable": !_vm.accountNameShort,
      "privateNotes": _vm.privateNotes,
      "notes": _vm.notes,
      "tags": _vm.tags,
      "monitoring": _vm.monitoring,
      "otherAttribs": _vm.otherAttribs,
      "clientCompanyId": _vm.clientCompanyId,
      "banks": _vm.banks
    },
    on: {
      "refresh": function($event) {
        return _vm.refreshCompanyProps()
      }
    }
  })], 1), _vm._v(" "), (_vm.refCode && _vm.clientCompanyId != null) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-contacts-panel', {
    attrs: {
      "fill-height": "",
      "refCode": _vm.refCode
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.refCode && _vm.clientCompanyId != null) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-banks-panel', {
    attrs: {
      "fill-height": "",
      "banks": _vm.banks
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.company && !(_vm.company.status && _vm.company.status.kind === 'GOOD')) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-reorg-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-assignees-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-branches-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-activities-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "activities": _vm.company.activities
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-licenses-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": ""
    }
  }, [_c('v-trademarks-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-holders-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn,
      "capital": _vm.company.capital,
      "holderRegister": _vm.company.holderRegister
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-children-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-manageds-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-fin-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-tax-pay-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "model": {
        ogrn: _vm.company.ogrn,
        staffNumber: _vm.company.staffNumber,
        taxOffence: _vm.company.taxOffence ? _vm.company.taxOffence.value : null
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-arrears-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-enforcement-debts-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn),
      expression: "company && company.inn"
    }],
    attrs: {
      "fill-height": "",
      "inn": _vm.company.inn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-enforcements-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn),
      expression: "company && company.inn"
    }],
    attrs: {
      "fill-height": "",
      "inn": _vm.company.inn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-records-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "records": _vm.company.records
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-credentinals-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && (_vm.company.tax || _vm.company.pf || _vm.company.fss || _vm.company.registration)),
      expression: "company && (company.tax || company.pf || company.fss || company.registration)"
    }],
    attrs: {
      "fill-height": "",
      "reg": _vm.company.registration,
      "tax": _vm.company.tax,
      "pf": _vm.company.pf,
      "fss": _vm.company.fss
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-history-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "fill-height": "",
      "ogrn": _vm.company.ogrn,
      "clientId": _vm.company.clientId
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-links-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn),
      expression: "company && company.inn"
    }],
    attrs: {
      "fill-height": "",
      "inn": _vm.company.inn,
      "clientId": _vm.company.clientId
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.company && _vm.company.inn) ? _c('v-client-preview-panel', {
    attrs: {
      "fill-height": "",
      "inn": _vm.company.inn
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.company && _vm.company.reference && _vm.company.reference.ref && _vm.getProfileHaveClient) ? _c('v-visit-panel', {
    attrs: {
      "fill-height": "",
      "topCount": 5,
      "refCode": _vm.company.reference.ref
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode !== 'mainPage'),
      expression: "mode !== 'mainPage'"
    }]
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn && !_vm.company.clientId && !this.accountNameShort),
      expression: "company && company.inn && !company.clientId && !this.accountNameShort"
    }],
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Приглашение', 'mail_outline', 'Пригласить в Систему АТЛАНТ-СМАРТ', _vm.invite), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.ogrn),
      expression: "company && company.ogrn"
    }],
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Ссылка', 'content_copy', 'Копировать ссылку в буфер обмена', _vm.copyLink), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn && _vm.getProfileHaveClient && !_vm.favoriteLists && !this.accountNameShort),
      expression: "company && company.inn && getProfileHaveClient && !favoriteLists && !this.accountNameShort"
    }],
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Контрагент', 'add_circle_outline', 'Добавить контрагента в Мои контрагенты', _vm.addFavorite), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.company && _vm.company.inn && _vm.getProfileHaveClient && _vm.favoriteLists && !this.accountNameShort),
      expression: "company && company.inn && getProfileHaveClient && favoriteLists && !this.accountNameShort"
    }],
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Атрибуты', 'info_outline', 'Атрибуты котрагента в Моих контрагентах', _vm.dialogOpenFavorite), {
    tag: "v-component"
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1097 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1098),
  /* template */
  __webpack_require__(1099),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_CardScroll__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'human-page',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_6__PanelTitle___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_7__common_CardScroll___default.a },
  data: function data() {
    return {
      human: null,
      showExactCompanies: true,
      showNotExactCompanies: false,
      showLoners: true
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'page'
    }
  },
  created: function created() {
    this.initHuman();
  },
  mounted: function mounted() {
    if (this.itemId) {
      this.fetchHumanProps(this.itemId);
    }
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      if (newVal) {
        this.fetchHumanProps(newVal);
      } else {}
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    renderReference: 'renderReference',
    renderInnHtml: 'renderInnHtml',
    renderInnflHtml: 'renderInnflHtml',
    renderDateSince: 'renderDateSince',
    renderStatus: 'renderStatus',
    renderFlags: 'renderFlags',
    renderFirstActivityHtml: 'renderFirstActivityHtml',
    getIconName: 'getIconName',
    renderShare: 'renderShare',
    calcDialogOfs: 'calcDialogOfs',
    calcOfs: 'calcOfs'
  }), {
    displayCompaniesExact: function displayCompaniesExact() {
      var _this = this;

      return this.mergeHeadsAndHolders(this.displayHeadsExact, this.displayHoldersExact).sort(function (a, b) {
        return _this.sortCompanies(a, b);
      });
    },
    displayCompaniesNotExact: function displayCompaniesNotExact() {
      var _this2 = this;

      return this.mergeHeadsAndHolders(this.displayHeadsNotExact, this.displayHoldersNotExact).sort(function (a, b) {
        return _this2.sortCompanies(a, b);
      });
    },
    displayHeadsExact: function displayHeadsExact() {
      if (!this.human || !this.human.heads) {
        return [];
      }
      return this.human.heads.filter(function (h) {
        return h.exact;
      });
    },
    displayHoldersExact: function displayHoldersExact() {
      if (!this.human || !this.human.holders) {
        return [];
      }
      return this.human.holders.filter(function (h) {
        return h.exact;
      });
    },
    displayHeadsNotExact: function displayHeadsNotExact() {
      if (!this.human || !this.human.heads) {
        return [];
      }
      return this.human.heads.filter(function (h) {
        return !h.exact;
      });
    },
    displayHoldersNotExact: function displayHoldersNotExact() {
      if (!this.human || !this.human.holders) {
        return [];
      }
      return this.human.holders.filter(function (h) {
        return !h.exact;
      });
    },
    loners: function loners() {
      return this.human && this.human.loners && this.human.loners.map(function (l) {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()(l, { created: l.createDate, updated: l.releaseDate });
      });
    }
  }),
  methods: {
    calcOffset: function calcOffset(off, offModal) {
      return this.calcOfs(off, offModal);
    },
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].formatCurrency(number) + ' руб.' : '';
    },
    formatShare: function formatShare(holder) {
      var share = __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].getValue(holder, ['shares', 0, 'share']);
      return share !== null ? '(' + this.formatCurrency(share) + ')' : '';
    },
    formatPercent: function formatPercent(holder) {
      var share = __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].getValue(holder, ['shares', 0]);
      return this.renderShare(share);
    },
    formatHumanCountersHtml: function formatHumanCountersHtml(counters) {
      var _f = function _f(v) {
        return v !== null ? v : 'нет данных';
      };
      if (!counters) {
        return '<div></div>';
      }
      var result = ''.concat('<div>', '<div>', '\u0420\u0443\u043A\u043E\u0432\u043E\u0434\u0438\u0442\u0435\u043B\u044C \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439 (\u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0435 \u043F\u043E \u0418\u041D\u041D / \u0424\u0418\u041E*): ', '<b><v-icon small>' + this.getIconName('head') + '</v-icon> ' + _f(counters.managedCompaniesExact) + ' / ' + _f(counters.managedCompaniesGeneral) + '</b>', '</div>', '<div>', '\u0423\u0447\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u044C \u0438\u043B\u0438 \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A (\u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0435 \u043F\u043E \u0418\u041D\u041D /  \u0424\u0418\u041E*): ', '<b><v-icon small>' + this.getIconName('holder') + '</v-icon> ' + _f(counters.sharedCompaniesExact) + ' / ' + _f(counters.sharedCompaniesGeneral) + '</b>', '</div>', '<div>', '\u0418\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044C: ', '<b><v-icon small>' + this.getIconName('loner') + '</v-icon> ' + _f(counters.loners) + '</b>', '</div>', '<div>', '\u041F\u0440\u043E\u0432\u0435\u0434\u0435\u043D\u0430 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0430 \u0432 \u0440\u0435\u0435\u0441\u0442\u0440\u0435 \u0434\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0432\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u043B\u0438\u0446, \u043D\u0430\u0439\u0434\u0435\u043D\u043E \u0434\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0439 (\u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0435 \u043F\u043E \u0418\u041D\u041D / \u0424\u0418\u041E*): ', '<b> ' + _f(counters.disqualificationsExact) + ' / ' + _f(counters.disqualificationsGeneral) + '</b>', '</div>', '<div>', '* \u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u0432 \u043E\u0442\u0447\u0435\u0442 \u043E \u043F\u043E\u0438\u0441\u043A\u0435 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430 \u043F\u043E \u0424\u0418\u041E \u043C\u043E\u0433\u043B\u0438 \u043F\u043E\u043F\u0430\u0441\u0442\u044C \u0438\u043D\u044B\u0435 \u043B\u0438\u0446\u0430 \u0441 \u0442\u043E\u0436\u0434\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u0424\u0418\u041E. ', '</div>', '</div>');
      return result;
    },
    isExistActualItem: function isExistActualItem(items) {
      return items && items.length > 0 && items[0].created && items[0].deleted === null;
    },
    formatDisqualificationHtml: function formatDisqualificationHtml(disq) {
      if (!disq) {
        return '';
      }
      return __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].formatErrorHtml('\u0414\u0438\u0441\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D \u0441 ' + __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].formatDate(disq.fromDate) + ' \u043F\u043E ' + __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].formatDate(disq.toDate) + ' \u0440\u0435\u0448\u0435\u043D\u0438\u0435\u043C \u043E\u0442 ' + __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].formatDate(disq.decisionDate));
    },
    mergeHeadsAndHolders: function mergeHeadsAndHolders(heads, holders) {
      var st = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a();
      var result = heads.map(function (hd) {
        var hl = holders.find(function (i) {
          return i.ogrn === hd.ogrn;
        });
        if (hl) {
          hd.holders = hl.holders;
          st.add(hd.ogrn);
        }
        return hd;
      });
      result = result.concat(holders.filter(function (i) {
        return !st.has(i.ogrn);
      }));
      return result;
    },
    sortCompanies: function sortCompanies(a, b) {
      var getRank = function getRank(kind) {
        return ['GOOD', 'WARN', 'BAD', 'OLD'].indexOf(kind);
      };
      var getFirst = function getFirst(items) {
        return items && items.length > 0 && items[0] || null;
      };

      var result = 0;
      if (!result) {
        result = getRank(a.status.kind) - getRank(b.status.kind);
      }
      var ahead = getFirst(a.heads);
      var bhead = getFirst(b.heads);
      if (!result && !(bhead && ahead)) {
        result = (bhead != null) - (ahead != null);
      }
      if (!result && bhead && ahead && !(!bhead.deleted && !ahead.deleted)) {
        result = (ahead.deleted != null) - (bhead.deleted != null);
      }
      var aholder = getFirst(a.holders);
      var bholder = getFirst(b.holders);
      if (!result && !(bholder && aholder)) {
        result = (bholder != null) - (aholder != null);
      }
      if (!result && bholder && aholder && !(!bholder.deleted && !aholder.deleted)) {
        result = (aholder.deleted != null) - (bholder.deleted != null);
      }
      if (!result && bholder && aholder) {
        var valB = __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].getValue(bholder, ['shares', 0, 'part', 'numerator']) / __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].getValue(bholder, ['shares', 0, 'part', 'denominator']);
        var valA = __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].getValue(aholder, ['shares', 0, 'part', 'numerator']) / __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].getValue(aholder, ['shares', 0, 'part', 'denominator']);
        result = valB - valA;
      }
      if (!result && bholder && aholder) {
        result = __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].getValue(bholder, ['shares', 0, 'share']) - __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].getValue(aholder, ['shares', 0, 'share']);
      }
      return result;
    },
    getHumanProps: function getHumanProps(inn, cb) {
      var _this3 = this;

      var cbError = function cbError(e) {
        _this3.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о компании из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].openApiGet('/openapi/humans/' + inn, cb, cbError);
    },
    fetchHumanProps: function fetchHumanProps(inn) {
      var _this4 = this;

      this.initHuman();
      this.getHumanProps(inn, function (data) {
        _this4.human = data;
      });
    },
    initHuman: function initHuman() {
      this.human = {
        id: null,
        inn: null,
        nameShort: '',
        nameFull: ''
      };
    },
    renderCompanyFlags: function renderCompanyFlags(item) {
      return item ? this.renderFlags(item.flags, true) : null;
    },
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].createComp(template);
    }
  }
});

/***/ }),
/* 1099 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.human.nameShort) + "\n        ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.human && _vm.human.id),
      expression: "human && human.id"
    }],
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(0, 0)
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-text', [_c('div', [_c('b', [_vm._v(_vm._s(_vm.human.nameFull))])]), _vm._v(" "), _c('div', [_vm._v("ИНН "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderInnflHtml(_vm.human.inn))
    }
  })])]), _vm._v(" "), _c(_vm.createComp(_vm.formatHumanCountersHtml(_vm.human.counters)), {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.human && _vm.human.id),
      expression: "human && human.id"
    }],
    tag: "component"
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.showExactCompanies
    },
    on: {
      "click": function($event) {
        _vm.showExactCompanies = !_vm.showExactCompanies
      }
    }
  }, [_vm._v("\n                Отчет о найденных компаниях при совпадении ИНН \n                физического лица\n            ")]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showExactCompanies),
      expression: "showExactCompanies"
    }],
    staticClass: "pt-0"
  }, [(_vm.displayCompaniesExact.length === 0) ? _c('v-flex', [_vm._v("\n              Данные не найдены.\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.displayCompaniesExact), function(item) {
    return [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item))
      }
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExistActualItem(item.heads)),
        expression: "isExistActualItem(item.heads)"
      }],
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('head')))]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExistActualItem(item.holders)),
        expression: "isExistActualItem(item.holders)"
      }],
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('holder')))]), _vm._v(" "), _c(_vm.renderCompanyFlags(item), {
      tag: "v-component"
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ОГРН "), _c('b', {
      domProps: {
        "innerHTML": _vm._s(item.id)
      }
    }), _vm._v(" ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.inn))
      }
    })]), _vm._v(" - \n                    "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.activities))
      }
    }), _vm._v(" "), _vm._l((item.heads), function(head) {
      return [_c('div', [_c('b', {
        style: (head.deleted ? 'text-decoration: line-through;' : '')
      }, [_vm._v(_vm._s(head.position ? head.position : ''))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(head))
        }
      }), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.formatDisqualificationHtml(head.disqualification))
        }
      })])]
    }), _vm._v(" "), _vm._l((item.holders), function(holder) {
      return [_c('div', [_c('b', {
        style: (holder.deleted ? 'text-decoration: line-through;' : '')
      }, [_vm._v("Участие " + _vm._s(_vm.formatPercent(holder)) + " " + _vm._s(_vm.formatShare(holder)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(holder))
        }
      })])]
    })], 2)], 1)]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.showLoners
    },
    on: {
      "click": function($event) {
        _vm.showLoners = !_vm.showLoners
      }
    }
  }, [_vm._v("\n                Отчет о ИП при совпадении ИНН \n                физического лица\n            ")]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoners),
      expression: "showLoners"
    }],
    staticClass: "pt-0"
  }, [(!_vm.loners || _vm.loners.length === 0) ? _c('v-flex', [_vm._v("\n              Данные не найдены.\n              ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.loners), function(item) {
    return [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item))
      }
    }), _vm._v(" "), _c('v-icon', {
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('loner')))]), _vm._v(" "), _c(_vm.renderCompanyFlags(item), {
      tag: "v-component"
    }), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderDateSince(item))
      }
    }), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ОГРНИП "), _c('b', {
      domProps: {
        "innerHTML": _vm._s(item.id)
      }
    }), _vm._v(" ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnflHtml(item.inn))
      }
    })]), _vm._v(" - \n                  "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.activities))
      }
    })])]
  })], 2)], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.showNotExactCompanies
    },
    on: {
      "click": function($event) {
        _vm.showNotExactCompanies = !_vm.showNotExactCompanies
      }
    }
  }, [_vm._v("\n                Отчет о найденных компаниях при совпадении: ФИО (без совпадений по ИНН)\n            ")]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showNotExactCompanies),
      expression: "showNotExactCompanies"
    }],
    staticClass: "pt-0"
  }, [(_vm.displayCompaniesNotExact.length === 0) ? _c('v-flex', [_vm._v("\n              Данные не найдены.\n              ")]) : _c('v-flex', [_c('b', [_vm._v("ВАЖНО!")]), _vm._v(" В этот отчет могли попасть иные лица с тождественными ФИО.\n              ")]), _vm._v(" "), _vm._l((_vm.displayCompaniesNotExact), function(item) {
    return [_c('div', [_c('div', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item))
      }
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExistActualItem(item.heads)),
        expression: "isExistActualItem(item.heads)"
      }],
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('head')))]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.isExistActualItem(item.holders)),
        expression: "isExistActualItem(item.holders)"
      }],
      attrs: {
        "small": ""
      }
    }, [_vm._v(_vm._s(_vm.getIconName('holder')))]), _vm._v(" "), _c(_vm.renderCompanyFlags(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v("ОГРН "), _c('b', {
      domProps: {
        "innerHTML": _vm._s(item.id)
      }
    }), _vm._v(" ИНН "), _c('b', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnHtml(item.inn))
      }
    })]), _vm._v(" - \n                    "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderStatus(item.status))
      }
    })]), _vm._v(" "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderFirstActivityHtml(item.activities))
      }
    }), _vm._v(" "), _vm._l((item.heads), function(head) {
      return [_c('div', [_c('b', {
        style: (head.deleted ? 'text-decoration: line-through;' : '')
      }, [_vm._v(_vm._s(head.position ? head.position : ''))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(head))
        }
      }), _vm._v(" "), _c('div', {
        domProps: {
          "innerHTML": _vm._s(_vm.formatDisqualificationHtml(head.disqualification))
        }
      })])]
    }), _vm._v(" "), _vm._l((item.holders), function(holder) {
      return [_c('div', [_c('b', {
        style: (holder.deleted ? 'text-decoration: line-through;' : '')
      }, [_vm._v("Участие " + _vm._s(_vm.formatPercent(holder)) + " " + _vm._s(_vm.formatShare(holder)))]), _vm._v(" "), _c('span', {
        domProps: {
          "innerHTML": _vm._s(_vm.renderDateSince(holder))
        }
      })])]
    })], 2)], 1)]
  })], 2)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1100 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1101),
  /* template */
  __webpack_require__(1102),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_apimix_js__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_CardScroll__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'foreign-page',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_4__common_CardScroll___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_apimix_js__["a" /* default */]],
  data: function data() {
    return {
      foreign: null,
      showAllCompanies: false,
      favoriteLists: null,
      holders: []
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'page'
    }
  },
  created: function created() {
    this.initForeign();
  },
  mounted: function mounted() {
    if (this.itemId) {
      this.fetchForeignProps(this.itemId);
    }
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      if (newVal) {
        this.fetchForeignProps(newVal);
      } else {}
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    calcDialogOfs: 'calcDialogOfs',
    calcOfs: 'calcOfs'
  })),
  methods: {
    calcOffset: function calcOffset(off, offModal) {
      return this.calcOfs(off, offModal);
    },
    getForeignProps: function getForeignProps(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о иностранной компании из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_3__api_server__["a" /* default */].openApiGet('/openapi/foreigns/' + id, cb, cbError);
    },
    fetchForeignProps: function fetchForeignProps(id) {
      var _this2 = this;

      this.initForeign();
      this.getForeignProps(id, function (data) {
        _this2.foreign = data;
      });
    },
    initForeign: function initForeign() {
      this.foreign = {
        id: null,
        inn: null,
        nameShort: '',
        name: ''
      };
    }
  }
});

/***/ }),
/* 1102 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.foreign.nameShort ? _vm.foreign.nameShort : _vm.formats.blank(_vm.foreign.name, function (v) { return v.slice(0, 30) + '...'; })) + "\n          ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.foreign && _vm.foreign.id),
      expression: "foreign && foreign.id"
    }],
    attrs: {
      "flat": "",
      "md": "",
      "offset": _vm.calcOffset(0, 0)
    }
  }, [_c('v-card-text', [_c('div', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.name)))])]), _vm._v(" "), _c('div', [_vm._v("Страна: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.countryName)))]), _vm._v(" Код страны: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.countryCode)))])]), _vm._v(" "), _c('div', [_vm._v("Адрес: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.address)))])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v("Дата регистрации: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.regDate, _vm.formats.formatDate)))])]), _vm._v(" "), _c('div', [_vm._v("Регистрирующая организация: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.regOrgName)))])]), _vm._v(" "), _c('div', [_vm._v("Регистрационный номер: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.foreign.regNumber)))])])])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1103 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1104),
  /* template */
  __webpack_require__(1105),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1104 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__people_index_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotesForm__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NotesForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VisitPanel__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VisitPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__VisitPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ClientPreviewPanel__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ClientPreviewPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ClientPreviewPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__info_CredentinalsPanel__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__info_CredentinalsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__info_CredentinalsPanel__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'foreign-agency-page',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_6__common_CardScroll___default.a, vVisitPanel: __WEBPACK_IMPORTED_MODULE_8__VisitPanel___default.a, vClientPreviewPanel: __WEBPACK_IMPORTED_MODULE_9__ClientPreviewPanel___default.a, vCredentinalsPanel: __WEBPACK_IMPORTED_MODULE_10__info_CredentinalsPanel___default.a },
  data: function data() {
    return {
      showAllCompanies: false,
      fagency: null,
      clientCompanyId: null,
      banks: [],
      favoriteLists: null,
      privateNotes: null,
      notes: null,
      tags: null,
      accountNameShort: null,
      otherAttribs: []
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'page'
    },
    notesAvailable: {
      type: Boolean,
      default: true
    },
    notesEditable: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.initFAgency();
  },
  mounted: function mounted() {
    if (this.itemId) {
      this.fetchFAgencyProps(this.itemId);
    }
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      if (newVal) {
        this.fetchFAgencyProps(newVal);
      } else {}
    },
    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      this.refreshCompanyProps();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient',
    getClientUrl: 'getClientUrl',
    getRefToUrl: 'getRefToUrl',
    renderEmployeeReference: 'renderEmployeeReference',
    renderReference: 'renderReference',
    renderInnHtml: 'renderInnHtml',
    renderInnflHtml: 'renderInnflHtml',
    renderDateSince: 'renderDateSince',
    renderStatus: 'renderStatus',
    renderFlags: 'renderFlags',
    renderFirstActivityHtml: 'renderFirstActivityHtml',
    renderUnreliableHtml: 'renderUnreliableHtml',
    getIconName: 'getIconName',
    getEmailHeaderReport: 'getEmailHeaderReport',
    getAgreementHeader1Report: 'getAgreementHeader1Report',
    getAgreementHeader2Report: 'getAgreementHeader2Report',
    getAgreementFooterReport: 'getAgreementFooterReport',
    getClientEnvelopeReport: 'getClientEnvelopeReport',
    renderCopyButton: 'renderCopyButton',
    renderContactButton: 'renderContactButton',
    calcDialogOfs: 'calcDialogOfs',
    calcOfs: 'calcOfs'
  })),
  methods: {
    calcOffset: function calcOffset(off, offModal) {
      return this.calcOfs(off, offModal);
    },
    formatDate: function formatDate(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].blank(dateTime, __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate);
    },
    createNameComp: function createNameComp(fagency) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            <b><span v-html="getDto()"></span></b>\n            {{self.renderDateSince(dto)}}\n             <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\', self.getCompanyNameFull)" />\n          </div>\n          <div>\n           <span v-html="self.renderUnreliableHtml(dto)"></span>\n          </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            fagency: fagency,
            dto: fagency.name,
            formats: __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */]
          };
        },
        methods: {
          getDto: function getDto() {
            return this.dto && this.dto.value ? this.dto.value : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись о названии компании');
          }
        }
      };
    },
    createNameShortComp: function createNameShortComp(fagency) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            \u0421\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435: <b><span v-html="getDto()"></span></b>\n             <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\', self.getCompanyNameShort)" />\n          </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            fagency: fagency,
            dto: fagency.name.nameShort,
            formats: __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */]
          };
        },
        methods: {
          getDto: function getDto() {
            return this.dto ? this.dto : '-';
          }
        }
      };
    },
    createForeignOrgComp: function createForeignOrgComp(company) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            \u0413\u043E\u043B\u043E\u0432\u043D\u0430\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F: <div><b><span v-html="getDto()"></span></b>\n            <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438\', self.getForeignName)" /></div>\n            <div v-show="dto">{{dto && dto.countryName ? dto.countryName : \'-\'}} </div>\n          </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            dto: company.foreignOrg
          };
        },
        methods: {
          getDto: function getDto() {
            if (!this.dto) {
              return '-';
            }
            return '' + (this.dto.name ? this.dto.name : this.dto.nameShort ? this.dto.nameShort : '-');
          }
        }
      };
    },
    createTaxOfficeComp: function createTaxOfficeComp(taxOffice) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            <b><span v-html="getDto()"></span></b>\n            <div v-if="dto && dto.code">\u041A\u043E\u0434 \u043F\u043E\u0434\u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u0438\u044F: <b>{{dto.code}}</b></div>\n            <div v-if="dto && dto.address">\u0410\u0434\u0440\u0435\u0441: <b>{{dto.address}}</b></div>\n         </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            dto: taxOffice
          };
        },
        methods: {
          getDto: function getDto() {
            if (!this.dto) {
              return '-';
            }
            return '' + (this.dto.name ? this.dto.name : '-');
          }
        }
      };
    },
    createAddressComp: function createAddressComp(company) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            \u0410\u0434\u0440\u0435\u0441: <b><span v-html="getDto()"></span></b>\n            {{self.renderDateSince(dto)}}\n            <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0434\u0440\u0435\u0441\', self.getCompanyAddress)" />\n          </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            company: company,
            dto: company.address,
            formats: __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */]
          };
        },
        methods: {
          getDto: function getDto() {
            return this.dto && this.dto.value ? this.dto.value : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись об адресе компании');
          }
        }
      };
    },
    createHeadsComp: function createHeadsComp(heads) {
      var self = this;
      var template = '\n      <div>\n        <b v-if="!heads || heads.length === 0">' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись о руководителе компании') + '</b>\n        <template v-for="head in heads">\n          <v-component :is="self.createEmployeeComp(head)"/>\n        </template>\n      </div>\n      ';
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            heads: heads
          };
        }
      };
    },
    createEmployeeComp: function createEmployeeComp(employee) {
      var self = this;
      var template = '\n      <div>\n      <div>\n        {{employee.position}}\n        <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0434\u043E\u043B\u0436\u043D\u043E\u0441\u0442\u044C\', getPosition)" /> :\n      </div>\n      <span v-html="self.renderEmployeeReference(employee)"></span>\n      <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0418\u041E\', getNameFull)" />' + '\n      <v-component :is="self.renderContactButton(\'\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430\', openContact)" />\n      ' + ('\n        <div>\n          \u0418\u041D\u041D ' + self.renderInnflHtml(employee.inn) + '\n          <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0418\u041D\u041D\', getInn)" />\n        </div>\n      </div>\n      ');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            employee: employee
          };
        },
        methods: {
          getPosition: function getPosition() {
            return self.getCompanyEmployeePosition(employee);
          },
          getNameFull: function getNameFull() {
            return self.getCompanyEmployeeNameFull(employee);
          },
          getInn: function getInn() {
            return self.getCompanyEmployeeInn(employee);
          },
          openContact: function openContact() {
            var refCode = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(self.fagency, ['reference', 'ref']);
            __WEBPACK_IMPORTED_MODULE_5__people_index_js__["a" /* default */].openByHuman(refCode, employee);
          }
        }
      };
    },
    createCopyButton: function createCopyButton(caption, icon, hint, action) {
      var template = ''.concat('<div><v-tooltip bottom open-delay="500">\n          <div slot="activator">\n            <v-btn  small flat  @click="self.copyToClipboard(action)">\n              <v-icon small>{{icon}}</v-icon>{{caption}}\n            </v-btn>\n          </div>\n          <span>{{hint}}</span>\n        </v-tooltip></div>');
      var self = this;
      return {
        template: template,
        data: function data() {
          return {
            caption: caption,
            icon: icon,
            hint: hint,
            action: action,
            self: self
          };
        }
      };
    },
    getCompanyNameFull: function getCompanyNameFull() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['name', 'value']);
    },
    getCompanyNameShort: function getCompanyNameShort() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['name', 'nameShort']);
    },
    getCompanyNza: function getCompanyNza() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['nza']);
    },
    getCompanyInn: function getCompanyInn() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInn(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['inn']));
    },
    getCompanyKpp: function getCompanyKpp() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['kpp']);
    },
    getCompanyAddress: function getCompanyAddress() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['address', 'value']);
    },
    getForeignName: function getForeignName() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['foreignOrg', 'name']);
    },
    getCompanyEmployeePosition: function getCompanyEmployeePosition(employee) {
      console.log('getCompanyEmployeePosition', employee);
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(employee, ['position']);
    },
    getCompanyEmployeeNameFull: function getCompanyEmployeeNameFull(employee) {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(employee, ['nameFull']);
    },
    getCompanyEmployeeInn: function getCompanyEmployeeInn(employee) {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInnfl(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(employee, ['inn']));
    },
    getFAgencyProps: function getFAgencyProps(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о представительстве иностранной компании из ЕГРЮЛ ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/foreign-agencies/' + id, cb, cbError);
    },
    fetchFAgencyProps: function fetchFAgencyProps(id) {
      var _this2 = this;

      this.initFAgency();
      this.getFAgencyProps(id, function (data) {
        _this2.fagency = data;
        _this2.fetchFavoriteProps(id);
      });
    },
    initFAgency: function initFAgency() {
      this.fagency = {
        id: null,
        inn: null,
        nameShort: '',
        name: ''
      };
    },
    fetchFavoriteProps: function fetchFavoriteProps(inn) {
      var _this3 = this;

      this.$store.dispatch('getFavoriteRefs', 'nza:' + inn).then(function (data) {
        if (!Array.isArray(data) || data.length < 1) {
          console.log('fetchFAgencyProps', data);
          return;
        }
        if (_this3.getProfileHaveClient) {
          _this3.clientCompanyId = data[0].clientCompanyId;
          _this3.banks = data[0].banks;
          _this3.favoriteLists = data[0].tags;
          _this3.privateNotes = data[0].privateNotes;
          _this3.notes = data[0].notes;
          _this3.tags = data[0].tags;
          _this3.monitoring = data[0].monitoring;
          _this3.accountNameShort = data[0].accountNameShort;
          _this3.otherAttribs = data.slice(1);
        } else {
          _this3.clientCompanyId = null;
          _this3.banks = [];
          _this3.favoriteLists = null;
          _this3.privateNotes = null;
          _this3.notes = null;
          _this3.tags = null;
          _this3.monitoring = false;
          _this3.accountNameShort = null;
          _this3.otherAttribs = [];
        }
      });
    },
    refreshCompanyProps: function refreshCompanyProps() {
      if (this.itemId) {
        this.fetchFAgencyProps(this.itemId);
      }
    },
    copyLink: function copyLink() {
      var refCode = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['reference', 'ref']);
      this.$store.dispatch('copyCompanyLink', this.getClientUrl(refCode));
    },
    addFavorite: function addFavorite() {
      var refCode = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['reference', 'ref']);
      if (refCode) {
        this.$store.dispatch('addFavoriteCompany', { refCode: refCode, tags: this.tags ? this.tags.map(function (t) {
            return t.id;
          }) : null });
        this.refreshCompanyProps();
      }
    },

    editNotesDialogOpen: function editNotesDialogOpen(item) {
      if (!this.notesEditable) {
        return;
      }
      var self = this;
      var setNotes = function setNotes(data) {
        self.refreshCompanyProps();
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].register('v-notes-form', __WEBPACK_IMPORTED_MODULE_7__NotesForm___default.a);
      var comp = { template: '\n        <v-notes-form v-on:input="setNotes" v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-notes-form>\n      ',
        data: function data() {
          return {
            model: { clientCompanyId: self.clientCompanyId, banks: self.banks, company: self.fagency, privateNotes: self.privateNotes, notes: self.notes, tags: self.tags, monitoring: self.monitoring },
            setNotes: setNotes,
            fullscreen: self.$vuetify.breakpoint.xsOnly
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].modal(comp);
    },
    goDepo: function goDepo() {
      var tag = '#' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.fagency, ['reference', 'ref']);
      this.$router.push({ path: '/doc_list/root', query: { tag: [tag] } });
    },
    createButton: function createButton(caption, icon, hint, action) {
      var template = ''.concat('<v-tooltip top open-delay="500">\n            <div slot="activator">\n              <v-btn flat  @click="action">\n                <v-icon left>{{icon}}</v-icon>{{caption}}\n              </v-btn>\n            </div>\n            <span>{{hint}}</span>\n          </v-tooltip>');
      return {
        template: template,
        data: function data() {
          return {
            caption: caption,
            icon: icon,
            hint: hint,
            action: action
          };
        }
      };
    }
  }
});

/***/ }),
/* 1105 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.fagency.name.caption) + "\n            ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency && _vm.fagency.nza),
      expression: "fagency && fagency.nza"
    }],
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(60, 104)
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.editNotesDialogOpen()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(tag.name) + "\n                ")])])
  }), 1)], 1), _vm._v(" "), _c(_vm.createNameComp(_vm.fagency), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createNameShortComp(_vm.fagency), {
    tag: "component"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency.accrStartDate),
      expression: "fagency.accrStartDate"
    }]
  }, [_vm._v("Дата аккредитации: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.fagency.accrStartDate)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency.accrFinalDate),
      expression: "fagency.accrFinalDate"
    }]
  }, [_vm._v("Дата прекращения действия аккредитации: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.fagency.accrFinalDate)))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency.prolongationDate),
      expression: "fagency.prolongationDate"
    }]
  }, [_vm._v("Дата начала осуществления деятельности : "), _c('b', [_vm._v(_vm._s(_vm.fagency.accrStartDate ? _vm.formatDate(_vm.fagency.accrStartDate) : '-'))])]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.fagency.prolongationDate),
      expression: "fagency.prolongationDate"
    }]
  }, [_vm._v("Дата решения о продлении срока действия аккредитации: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.fagency.prolongationDate)))])]), _vm._v(" "), _c('div', [_vm._v("\n                НЗА "), _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.fagency.nza)
    }
  }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать нза', _vm.getCompanyNza), {
    tag: "v-component"
  }), _vm._v("\n                ИНН "), _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderInnHtml(_vm.fagency.inn))
    }
  }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать инн', _vm.getCompanyInn), {
    tag: "v-component"
  }), _vm._v("\n                КПП "), _c('b', [_vm._v(_vm._s(_vm.fagency.kpp))]), _vm._v(" "), _c(_vm.renderCopyButton('Копировать кпп', _vm.getCompanyKpp), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('div', [_vm._v("\n              Вид обособленного подразделения: "), _c('b', [_vm._v(" " + _vm._s(_vm.fagency.kind === 'BRANCH' ? 'Филиал иностранного юридического лица' : 'Представительство иностранного юридического лица'))])]), _vm._v(" "), _c('div', [_vm._v("\n              Основной вид деятельности: "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderFirstActivityHtml(_vm.fagency.activities))
    }
  })])]), _vm._v(" "), _c('div', [_vm._v("Численность иностранных сотрудников: "), _c('b', [_vm._v(_vm._s(_vm.fagency.staffNumber && _vm.fagency.staffNumber.value !== null ? _vm.fagency.staffNumber.value : 'нет данных'))])]), _vm._v(" "), _c(_vm.createAddressComp(_vm.fagency), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createHeadsComp(_vm.fagency.heads), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createForeignOrgComp(_vm.fagency), {
    tag: "component"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.notes ? 'Примечания:' : 'Внесите корпоративные заметки (они будут видны Вашим коллегам).'))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.notes)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('v-layout', {
    attrs: {
      "justify-begin": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.goDepo()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("storage")])], 1), _vm._v(" "), _c('span', [_vm._v("Перейти в депозитарий")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.privateNotes ? 'Личные заметки:' : 'Внесите личные заметки (они будут видны только Вам).'))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.privateNotes)
    }
  })])], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v("\n        Организация проводившая аккредитацию:\n        "), _c(_vm.createTaxOfficeComp(_vm.fagency.accrTaxOffice), {
    tag: "component"
  })], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [(_vm.fagency.taxCredential) ? _c('v-credentinals-panel', {
    attrs: {
      "fill-height": "",
      "tax": _vm.fagency.taxCredential
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [(_vm.fagency && _vm.fagency.reference && _vm.fagency.reference.inn) ? _c('v-client-preview-panel', {
    attrs: {
      "fill-height": "",
      "inn": parseInt(_vm.fagency.reference.inn),
      "clientId": _vm.fagency.clientId
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [(_vm.fagency && _vm.fagency.reference && _vm.fagency.reference.ref && _vm.getProfileHaveClient) ? _c('v-visit-panel', {
    attrs: {
      "fill-height": "",
      "topCount": 5,
      "refCode": _vm.fagency.reference.ref
    }
  }) : _vm._e()], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.fagency && _vm.fagency.reference) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Ссылка', 'content_copy', 'Копировать ссылку в буфер обмена', _vm.copyLink), {
    tag: "v-component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fagency && _vm.fagency.reference && _vm.getProfileHaveClient && !_vm.favoriteLists && !this.accountNameShort) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Контрагент', 'add_circle_outline', 'Добавить контрагента в Мои контрагенты', _vm.addFavorite), {
    tag: "v-component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.fagency && _vm.fagency.reference && _vm.getProfileHaveClient && _vm.favoriteLists && !this.accountNameShort) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Атрибуты', 'info_outline', 'Атрибуты котрагента в Моих контрагентах', _vm.editNotesDialogOpen), {
    tag: "v-component"
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1106 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1107),
  /* template */
  __webpack_require__(1117),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1107 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__people_index_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotesForm__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__NotesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__NotesForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VisitPanel__ = __webpack_require__(250);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__VisitPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__VisitPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ClientPreviewPanel__ = __webpack_require__(248);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ClientPreviewPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__ClientPreviewPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__info_CredentinalsPanel__ = __webpack_require__(251);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__info_CredentinalsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__info_CredentinalsPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__info_ContactsPanel__ = __webpack_require__(473);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__info_ContactsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__info_ContactsPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__info_BanksPanel__ = __webpack_require__(474);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__info_BanksPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__info_BanksPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ActivitiesPanel__ = __webpack_require__(470);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ActivitiesPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__ActivitiesPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__info_LinksPanel__ = __webpack_require__(475);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__info_LinksPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__info_LinksPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__info_LonerLicensesPanel__ = __webpack_require__(1108);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__info_LonerLicensesPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__info_LonerLicensesPanel__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__info_LonerRecordsPanel__ = __webpack_require__(1111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__info_LonerRecordsPanel___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__info_LonerRecordsPanel__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'loner-page',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_6__common_CardScroll___default.a, vVisitPanel: __WEBPACK_IMPORTED_MODULE_8__VisitPanel___default.a, vClientPreviewPanel: __WEBPACK_IMPORTED_MODULE_9__ClientPreviewPanel___default.a, vCredentinalsPanel: __WEBPACK_IMPORTED_MODULE_10__info_CredentinalsPanel___default.a, vContactsPanel: __WEBPACK_IMPORTED_MODULE_11__info_ContactsPanel___default.a, vBanksPanel: __WEBPACK_IMPORTED_MODULE_12__info_BanksPanel___default.a, vActivitiesPanel: __WEBPACK_IMPORTED_MODULE_13__ActivitiesPanel___default.a, vLinksPanel: __WEBPACK_IMPORTED_MODULE_14__info_LinksPanel___default.a, vLonerLicensesPanel: __WEBPACK_IMPORTED_MODULE_15__info_LonerLicensesPanel___default.a, vLonerRecordsPanel: __WEBPACK_IMPORTED_MODULE_16__info_LonerRecordsPanel___default.a },
  data: function data() {
    return {
      showAllCompanies: false,
      loner: null,
      clientCompanyId: null,
      banks: [],
      favoriteLists: null,
      privateNotes: null,
      notes: null,
      tags: null,
      accountNameShort: null,
      otherAttribs: []
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'page'
    },
    notesAvailable: {
      type: Boolean,
      default: true
    },
    notesEditable: {
      type: Boolean,
      default: true
    }
  },
  created: function created() {
    this.initLoner();
  },
  mounted: function mounted() {
    if (this.itemId) {
      this.fetchLonerProps(this.itemId);
    }
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      if (newVal) {
        this.fetchLonerProps(newVal);
      } else {}
    },
    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      this.refreshCompanyProps();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient',
    getClientUrl: 'getClientUrl',
    getRefToUrl: 'getRefToUrl',
    renderEmployeeReference: 'renderEmployeeReference',
    renderReference: 'renderReference',
    renderInnHtml: 'renderInnHtml',
    renderInnflHtml: 'renderInnflHtml',
    renderDateSince: 'renderDateSince',
    renderStatus: 'renderStatus',
    renderFlags: 'renderFlags',
    renderFirstActivityHtml: 'renderFirstActivityHtml',
    renderUnreliableHtml: 'renderUnreliableHtml',
    getIconName: 'getIconName',
    getEmailHeaderReport: 'getEmailHeaderReport',
    getAgreementHeader1Report: 'getAgreementHeader1Report',
    getAgreementHeader2Report: 'getAgreementHeader2Report',
    getAgreementFooterReport: 'getAgreementFooterReport',
    getClientEnvelopeReport: 'getClientEnvelopeReport',
    renderCopyButton: 'renderCopyButton',
    renderContactButton: 'renderContactButton',
    calcDialogOfs: 'calcDialogOfs',
    calcOfs: 'calcOfs'
  })),
  methods: {
    calcOffset: function calcOffset(off, offModal) {
      return this.calcOfs(off, offModal);
    },
    formatDate: function formatDate(dateTime) {
      return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].blank(dateTime, __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate);
    },
    createNameComp: function createNameComp(loner) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            <b><span v-html="getDto()"></span></b>\n            {{self.renderDateSince(dto)}}\n             <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\', self.getCompanyNameFull)" />\n          </div>\n          <div>\n           <span v-html="self.renderUnreliableHtml(dto)"></span>\n          </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            loner: loner,
            dto: loner.name,
            formats: __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */]
          };
        },
        methods: {
          getDto: function getDto() {
            return this.dto && this.dto.value ? this.dto.value : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись о названии компании');
          }
        }
      };
    },
    createNameShortComp: function createNameShortComp(loner) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            \u0421\u043E\u043A\u0440\u0430\u0449\u0435\u043D\u043D\u043E\u0435 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435: <b><span v-html="getDto()"></span></b>\n             <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u0435\', self.getCompanyNameShort)" />\n          </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            loner: loner,
            dto: loner.name.nameShort,
            formats: __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */]
          };
        },
        methods: {
          getDto: function getDto() {
            return this.dto ? this.dto : '-';
          }
        }
      };
    },
    formatStatus: function formatStatus(status) {
      return ''.concat('<div>', 'Статус в ЕГРИП: ', this.renderStatus(status), '</div>');
    },
    createEmailComp: function createEmailComp(loner) {
      var self = this;
      var template = ''.concat('<div>\n          <div>\n            \u0410\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B: <b><span v-html="getDto()"></span></b>\n            {{self.renderDateSince(dto)}}\n            <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0430\u0434\u0440\u0435\u0441 \u044D\u043B. \u043F\u043E\u0447\u0442\u044B\', self.getCompanyAddress)" />\n          </div>\n         </div>');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            company: loner,
            dto: loner.email,
            formats: __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */]
          };
        },
        methods: {
          getDto: function getDto() {
            return this.dto && this.dto.value ? this.dto.value : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРИП не содержит запись об адресе эл. почты');
          }
        }
      };
    },
    createHeadsComp: function createHeadsComp(heads) {
      var self = this;
      var template = '\n      <div>\n        <b v-if="!heads || heads.length === 0">' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatWarningHtml('ЕГРЮЛ не содержит запись о руководителе компании') + '</b>\n        <template v-for="head in heads">\n          <v-component :is="self.createEmployeeComp(head)"/>\n        </template>\n      </div>\n      ';
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            heads: heads
          };
        }
      };
    },
    createEmployeeComp: function createEmployeeComp(employee) {
      var self = this;
      var template = '\n      <div>\n      <span v-html="self.renderEmployeeReference(employee)"></span>\n      <b> ' + self.formatHumanCountersHtml(employee.counters) + ' </b> \n      <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0424\u0418\u041E\', getNameFull)" />' + '\n      <v-component :is="self.renderContactButton(\'\u041E\u0442\u043A\u0440\u044B\u0442\u044C \u043A\u043E\u043D\u0442\u0430\u043A\u0442 \u0444\u0438\u0437\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043B\u0438\u0446\u0430\', openContact)" />\n      ' + ('\n        <div>\n          \u0418\u041D\u041D ' + self.renderInnflHtml(employee.inn) + '\n          <v-component :is="self.renderCopyButton(\'\u041A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0418\u041D\u041D\', getInn)" />\n        </div>\n      </div>\n      ');
      return {
        template: template,
        data: function data() {
          return {
            self: self,
            employee: employee
          };
        },
        methods: {
          getPosition: function getPosition() {
            return self.getCompanyEmployeePosition(employee);
          },
          getNameFull: function getNameFull() {
            return self.getCompanyEmployeeNameFull(employee);
          },
          getInn: function getInn() {
            return self.getCompanyEmployeeInn(employee);
          },
          openContact: function openContact() {
            var refCode = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(self.loner, ['reference', 'ref']);
            __WEBPACK_IMPORTED_MODULE_5__people_index_js__["a" /* default */].openByHuman(refCode, employee);
          }
        }
      };
    },
    formatHumanCountersHtml: function formatHumanCountersHtml(counters) {
      var _f = function _f(v) {
        return v !== null ? v : 'нет данных';
      };
      if (!counters) {
        return '<div></div>';
      }
      var result = ''.concat('<v-tooltip bottom>', '<span slot="activator">', '<v-icon small>' + this.getIconName('head') + '</v-icon>' + _f(counters.managedCompaniesExact) + '(' + _f(counters.managedCompaniesGeneral) + ')&nbsp', '<v-icon small>' + this.getIconName('holder') + '</v-icon>' + _f(counters.sharedCompaniesExact) + '(' + _f(counters.sharedCompaniesGeneral) + ')&nbsp', '<v-icon small>' + this.getIconName('loner') + '</v-icon>' + _f(counters.loners), '</span>', '<span>\u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0438 \u0443\u0447\u0430\u0441\u0442\u0438\u0435 \u0432 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\u0445, \u043D\u0430\u043B\u0438\u0447\u0438\u0435 \u0418\u041F <br/> \u0442\u043E\u0447\u043D\u043E\u0435 (\u043D\u0435 \u0442\u043E\u0447\u043D\u043E\u0435) \u0441\u043E\u0432\u043F\u0430\u0434\u0435\u043D\u0438\u0435</span>', '</v-tooltip>');
      return result;
    },
    createCopyButton: function createCopyButton(caption, icon, hint, action) {
      var template = ''.concat('<div><v-tooltip bottom open-delay="500">\n          <div slot="activator">\n            <v-btn  small flat  @click="self.copyToClipboard(action)">\n              <v-icon small>{{icon}}</v-icon>{{caption}}\n            </v-btn>\n          </div>\n          <span>{{hint}}</span>\n        </v-tooltip></div>');
      var self = this;
      return {
        template: template,
        data: function data() {
          return {
            caption: caption,
            icon: icon,
            hint: hint,
            action: action,
            self: self
          };
        }
      };
    },
    getCompanyNameFull: function getCompanyNameFull() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.loner, ['name', 'value']);
    },
    getCompanyNameShort: function getCompanyNameShort() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.loner, ['name', 'nameShort']);
    },
    getCompanyOgrnIp: function getCompanyOgrnIp() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.loner, ['ogrnip']);
    },
    getCompanyInn: function getCompanyInn() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInn(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.loner, ['inn']));
    },
    getCompanyKpp: function getCompanyKpp() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.loner, ['kpp']);
    },
    getCompanyAddress: function getCompanyAddress() {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.loner, ['email', 'value']);
    },
    getCompanyEmployeePosition: function getCompanyEmployeePosition(employee) {
      console.log('getCompanyEmployeePosition', employee);
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(employee, ['position']);
    },
    getCompanyEmployeeNameFull: function getCompanyEmployeeNameFull(employee) {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(employee, ['nameFull']);
    },
    getCompanyEmployeeInn: function getCompanyEmployeeInn(employee) {
      return '' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatInnfl(__WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(employee, ['inn']));
    },
    getLonerProps: function getLonerProps(id, cb) {
      var _this = this;

      var cbError = function cbError(e) {
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о индивидуальных предпринимателях из ЕГРИП ' });
      };
      __WEBPACK_IMPORTED_MODULE_2__api_server__["a" /* default */].openApiGet('/openapi/loners/' + id, cb, cbError);
    },
    fetchLonerProps: function fetchLonerProps(id) {
      var _this2 = this;

      this.initLoner();
      this.getLonerProps(id, function (data) {
        _this2.loner = data;
        _this2.fetchFavoriteProps(id);
      });
    },
    initLoner: function initLoner() {
      this.loner = {
        id: null,
        inn: null,
        nameShort: '',
        name: ''
      };
    },
    fetchFavoriteProps: function fetchFavoriteProps(inn) {
      var _this3 = this;

      this.$store.dispatch('getFavoriteRefs', 'ogrnip:' + inn).then(function (data) {
        console.log('fetchLonerProps', data);
        if (!Array.isArray(data) || data.length < 1) {
          console.log('fetchLonerProps', data);
          return;
        }
        if (_this3.getProfileHaveClient) {
          _this3.clientCompanyId = data[0].clientCompanyId;
          _this3.banks = data[0].banks;
          _this3.favoriteLists = data[0].tags;
          _this3.privateNotes = data[0].privateNotes;
          _this3.notes = data[0].notes;
          _this3.tags = data[0].tags;
          _this3.monitoring = data[0].monitoring;
          _this3.accountNameShort = data[0].accountNameShort;
          _this3.otherAttribs = data.slice(1);
        } else {
          _this3.clientCompanyId = null;
          _this3.banks = [];
          _this3.favoriteLists = null;
          _this3.privateNotes = null;
          _this3.notes = null;
          _this3.tags = null;
          _this3.monitoring = false;
          _this3.accountNameShort = null;
          _this3.otherAttribs = [];
        }
      });
    },
    refreshCompanyProps: function refreshCompanyProps() {
      if (this.itemId) {
        this.fetchLonerProps(this.itemId);
      }
    },
    copyLink: function copyLink() {
      var refCode = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.loner, ['reference', 'ref']);
      this.$store.dispatch('copyCompanyLink', this.getClientUrl(refCode));
    },
    addFavorite: function addFavorite() {
      var refCode = __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.loner, ['reference', 'ref']);
      if (refCode) {
        this.$store.dispatch('addFavoriteCompany', { refCode: refCode, tags: this.tags ? this.tags.map(function (t) {
            return t.id;
          }) : null });
        this.refreshCompanyProps();
      }
    },

    editNotesDialogOpen: function editNotesDialogOpen(item) {
      if (!this.notesEditable) {
        return;
      }
      var self = this;
      var setNotes = function setNotes(data) {
        self.refreshCompanyProps();
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].register('v-notes-form', __WEBPACK_IMPORTED_MODULE_7__NotesForm___default.a);
      var comp = { template: '\n        <v-notes-form v-on:input="setNotes" v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-notes-form>\n      ',
        data: function data() {
          return {
            model: { clientCompanyId: self.clientCompanyId, banks: self.banks, company: self.loner, privateNotes: self.privateNotes, notes: self.notes, tags: self.tags, monitoring: self.monitoring },
            setNotes: setNotes,
            fullscreen: self.$vuetify.breakpoint.xsOnly
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].modal(comp);
    },
    renderCompanyFlags: function renderCompanyFlags() {
      console.log('renderCompanyFlags', this.loner);
      return this.loner ? this.renderFlags(this.loner.flags, false) : null;
    },

    goDepo: function goDepo() {
      var tag = '#' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].getValue(this.loner, ['reference', 'ref']);
      this.$router.push({ path: '/doc_list/root', query: { tag: [tag] } });
    },
    createButton: function createButton(caption, icon, hint, action) {
      var template = ''.concat('<v-tooltip top open-delay="500">\n            <div slot="activator">\n              <v-btn flat  @click="action">\n                <v-icon left>{{icon}}</v-icon>{{caption}}\n              </v-btn>\n            </div>\n            <span>{{hint}}</span>\n          </v-tooltip>');
      return {
        template: template,
        data: function data() {
          return {
            caption: caption,
            icon: icon,
            hint: hint,
            action: action
          };
        }
      };
    }
  }
});

/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1109),
  /* template */
  __webpack_require__(1110),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LicenseForm__ = __webpack_require__(472);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__LicenseForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__LicenseForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_dialogs__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-licenses-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_4__PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    items: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    fillHeight: {
      type: Boolean,
      default: false
    }
  },
  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    renderDateSince: 'renderDateSince'
  }), {
    lowItems: function lowItems() {
      return this.items.slice(0, 20);
    },
    formatCountLicenses: function formatCountLicenses() {
      return ''.concat('Лицензий всего ', this.items ? this.items.length : 0);
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {
        this.fetchItems();
      }
    },
    formatCurrency: function formatCurrency(number) {
      return number !== null ? __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatCurrency(number) + ' р.' : '';
    },
    sortItems: function sortItems(a, b) {
      var result = 0;
      if (!result) {
        result = new Date(a.issued.date).getTime() - new Date(b.issued.date).getTime();
      }
      return result;
    },
    fetchItems: function fetchItems() {
      var _this = this;

      this.items.sort(function (a, b) {
        return _this.sortItems(a, b);
      });
    },

    dialogOpen: function dialogOpen(item) {
      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].register('v-license-form', __WEBPACK_IMPORTED_MODULE_5__LicenseForm___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-license-form v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-license-form>\n      ',
        data: function data() {
          return {
            model: item,
            fullscreen: fullscreen
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_6__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1110 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Кратко' : 'Подробно',
      "expandable": _vm.items.length > 0
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountLicenses)
    }
  })])]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }],
    staticClass: "pt-0"
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded),
      expression: "isLoaded"
    }]
  }, [_vm._l((_vm.lowItems), function(item) {
    return [_c('div', [_c('div', [_c('b', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v("\n            " + _vm._s(item.number) + " ")])]), _vm._v(" от " + _vm._s(_vm.formats.blank(item.issued.date, _vm.formats.formatDate)) + "\n            \n          ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_c('b', [_vm._v(_vm._s(item.activities.map(function (a) { return a.name; }).join(', ')))])]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.issued.org))])])], 1)]
  })], 2)])], 1)
},staticRenderFns: []}

/***/ }),
/* 1111 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1112),
  /* template */
  __webpack_require__(1116),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LonerRecordForm__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__LonerRecordForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__LonerRecordForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_dialogs__ = __webpack_require__(7);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-loner-records-panel',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_3__PanelTitle___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      id: null,
      isLoaded: false,
      isLoading: false
    };
  },
  props: {
    fillHeight: {
      type: Boolean,
      default: false
    },
    topCount: {
      type: Number,
      default: 2
    },
    records: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({}), {
    topItems: function topItems() {
      return this.items.slice(0, this.topCount);
    },
    lastItems: function lastItems() {
      return this.items.slice(this.topCount);
    },
    items: function items() {
      return this.records;
    }
  }),
  methods: {
    switchItems: function switchItems() {
      this.isLoaded = !this.isLoaded;
      if (this.isLoaded && this.items.length === 0) {}
    },

    dialogOpen: function dialogOpen(item) {
      __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-loner-record-form', __WEBPACK_IMPORTED_MODULE_4__LonerRecordForm___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-loner-record-form v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-loner-record-form>\n      ',
        data: function data() {
          return {
            model: item,
            fullscreen: fullscreen
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1113 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1114),
  /* template */
  __webpack_require__(1115),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_InfoForm__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_InfoForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_InfoForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-loner-record-form',
  mixins: [__WEBPACK_IMPORTED_MODULE_3__common_apimix__["a" /* default */]],
  components: { vInfoForm: __WEBPACK_IMPORTED_MODULE_4__common_InfoForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {}
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: function _default() {}
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {
    if (!this.model) {
      this.item = this.getItemNew();
    } else {
      this.item = this.model;
      console.log('mounted', this.item);
    }
  },

  watch: {
    model: function model(newVal, oldVal) {
      if (!newVal) {
        this.item = this.getItemNew();
      } else {
        this.item = newVal;
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({}), {
    title: function title() {
      return '\u0417\u0430\u043F\u0438\u0441\u044C ' + (this.item.grnip ? this.item.grnip : '');
    }
  }),
  methods: {
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        date: null
      };
    }
  }

});

/***/ }),
/* 1115 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-info-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('b', [_vm._v(_vm._s(_vm.item.code))]), _vm._v(" от " + _vm._s(_vm.formats.blank(_vm.item.date, _vm.formats.formatDate)) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n           Номер: "), _c('b', [_vm._v(_vm._s(_vm.item.grnip))])]), _vm._v(" "), _c('v-flex', [_vm._v("\n            " + _vm._s(_vm.item.name) + "\n          ")]), _vm._v(" "), _c('v-flex', [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.item.date, _vm.formats.formatDate)))]), _vm._v(" - " + _vm._s(_vm.formats.blank(_vm.formats.getValue(_vm.item, ['tax', 'name']))) + " (" + _vm._s(_vm.formats.blank(_vm.formats.getValue(_vm.item, ['tax', 'code']))) + ") \n          ")]), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.documents != null),
      expression: "item.documents != null"
    }]
  }, [_vm._v("\n            Документы:\n            "), _vm._l((_vm.item.documents), function(doc) {
    return [_c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.formats.getValue(doc, ['date']), _vm.formats.formatDate)))]), _vm._v(" - " + _vm._s(_vm.formats.blank(_vm.formats.getValue(doc, ['name']))) + " (" + _vm._s(_vm.formats.blank(_vm.formats.getValue(_vm.item, ['number']))) + ") \n              ")])]
  })], 2), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.item.certificates != null),
      expression: "item.certificates != null"
    }]
  }, [_vm._v("\n            Свидетельства:\n            "), _vm._l((_vm.item.certificates), function(cert) {
    return [_c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.formats.getValue(cert, ['date']), _vm.formats.formatDate)))]), _vm._v(" - серия: " + _vm._s(_vm.formats.blank(_vm.formats.getValue(cert, ['series']))) + " номер: " + _vm._s(_vm.formats.blank(_vm.formats.getValue(cert, ['number']))) + " \n              ")])]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1116 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    attrs: {
      "height": _vm.fillHeight ? '100%' : 'auto'
    }
  }, [_c('v-panel-title', {
    attrs: {
      "value": this.isLoaded && this.items.length > 0,
      "caption": this.isLoaded ? 'Показать ' + this.topCount : 'Показать все',
      "expandable": _vm.items.length > _vm.topCount
    },
    on: {
      "click": function($event) {
        return _vm.switchItems()
      }
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticClass: "text-xs-center"
  }, [_c('v-progress-circular', {
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  })], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isLoading),
      expression: "!isLoading"
    }]
  }, [_vm._v("\n      Изменения в ЕГРИП (" + _vm._s(_vm.items.length) + ")\n      "), _vm._l((_vm.topItems), function(item) {
    return [_c('div', [_c('div', [_c('b', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v(_vm._s(item.code) + " ")])]), _vm._v("\n            от " + _vm._s(_vm.formats.blank(item.date, _vm.formats.formatDate)) + "              \n          ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v(_vm._s(item.name) + "\n            ")])])], 1)]
  })], 2)]), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isLoaded && _vm.items.length > 0),
      expression: "isLoaded && items.length > 0"
    }],
    staticClass: "pt-0"
  }, [(_vm.items.length === 0) ? _c('v-flex', [_vm._v("\n    Данные не найдены.\n    ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.lastItems), function(item) {
    return [_c('div', [_c('div', [_c('b', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.dialogOpen(item)
        }
      }
    }, [_vm._v(_vm._s(item.code) + " ")])]), _vm._v("\n            от " + _vm._s(_vm.formats.blank(item.date, _vm.formats.formatDate)) + "              \n          ")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "pl-2": ""
      }
    }, [_c('div', [_vm._v(_vm._s(item.name) + "\n            ")])])], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 1117 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.loner.name.caption) + "\n            ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.ogrnip),
      expression: "loner && loner.ogrnip"
    }],
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(60, 60)
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-card', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c(_vm.renderCompanyFlags(), {
    tag: "v-component"
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.editNotesDialogOpen()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n                " + _vm._s(tag.name) + "\n                ")])])
  }), 1)], 1), _vm._v(" "), _c(_vm.createNameComp(_vm.loner), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createNameShortComp(_vm.loner), {
    tag: "component"
  }), _vm._v(" "), _c('div', [_vm._v("Дата создания: "), _c('b', [_vm._v(_vm._s(_vm.formatDate(_vm.loner.createDate)))])]), _vm._v(" "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.formatStatus(_vm.loner.status))
    }
  }), _vm._v(" "), _c('div', [_vm._v("\n                ОГРНИП "), _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.loner.ogrnip)
    }
  }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать огрнип', _vm.getCompanyOgrnIp), {
    tag: "v-component"
  }), _vm._v("\n                ИНН "), _c('b', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderInnflHtml(_vm.loner.inn))
    }
  }), _vm._v(" "), _c(_vm.renderCopyButton('Копировать инн', _vm.getCompanyInn), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('div'), _vm._v(" "), _c('div', [_vm._v("\n              Основной вид деятельности: "), _c('b', [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.renderFirstActivityHtml(_vm.loner.activities))
    }
  })])]), _vm._v(" "), _c(_vm.createEmailComp(_vm.loner), {
    tag: "component"
  }), _vm._v(" "), _c(_vm.createHeadsComp(_vm.loner.heads), {
    tag: "component"
  }), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.notes ? 'Примечания:' : 'Внесите корпоративные заметки (они будут видны Вашим коллегам).'))]), _vm._v(" "), _c('div', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.notes)
    }
  })]), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('v-layout', {
    attrs: {
      "justify-begin": "",
      "row": "",
      "wrap": ""
    }
  }, [_c('v-chip', {
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.goDepo()
      }
    }
  }, [_c('v-tooltip', {
    attrs: {
      "bottom": "",
      "open-delay": "500"
    }
  }, [_c('span', {
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("storage")])], 1), _vm._v(" "), _c('span', [_vm._v("Перейти в депозитарий")])])], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.notesAvailable),
      expression: "notesAvailable"
    }]
  }, [_c('br'), _vm._v(" "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v(_vm._s(_vm.privateNotes ? 'Личные заметки:' : 'Внесите личные заметки (они будут видны только Вам).'))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "white-space": "pre-wrap",
      "overflow-wrap": "break-word"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.privateNotes)
    }
  })])], 1)], 1)], 1), _vm._v(" "), (_vm.loner && _vm.loner.reference && _vm.loner.reference.ref && _vm.clientCompanyId != null) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-contacts-panel', {
    attrs: {
      "fill-height": "",
      "refCode": _vm.loner.reference.ref
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loner && _vm.loner.reference && _vm.loner.reference.ref && _vm.clientCompanyId != null) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-banks-panel', {
    attrs: {
      "fill-height": "",
      "banks": _vm.banks
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-activities-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.reference),
      expression: "loner && loner.reference "
    }],
    attrs: {
      "fill-height": "",
      "activities": _vm.loner.activities
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-credentinals-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && (_vm.loner.tax || _vm.loner.pf || _vm.loner.fss || _vm.loner.registration)),
      expression: "loner && (loner.tax || loner.pf || loner.fss || loner.registration)"
    }],
    attrs: {
      "fill-height": "",
      "reg": _vm.loner.registration,
      "tax": _vm.loner.tax,
      "pf": _vm.loner.pf,
      "fss": _vm.loner.fss
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-loner-licenses-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.reference),
      expression: "loner && loner.reference "
    }],
    attrs: {
      "fill-height": "",
      "items": _vm.loner.licenses
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm6": ""
    }
  }, [(_vm.loner && _vm.loner.reference && _vm.loner.reference.ref && _vm.getProfileHaveClient) ? _c('v-visit-panel', {
    attrs: {
      "fill-height": "",
      "topCount": 5,
      "refCode": _vm.loner.reference.ref
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-loner-records-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.reference),
      expression: "loner && loner.reference "
    }],
    attrs: {
      "fill-height": "",
      "records": _vm.loner.records
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-links-panel', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.loner && _vm.loner.ogrnip),
      expression: "loner && loner.ogrnip"
    }],
    attrs: {
      "fill-height": "",
      "inn": _vm.loner.ogrnip
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.loner && _vm.loner.reference) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Ссылка', 'content_copy', 'Копировать ссылку в буфер обмена', _vm.copyLink), {
    tag: "v-component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loner && _vm.loner.reference && _vm.getProfileHaveClient && !_vm.favoriteLists && !this.accountNameShort) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Контрагент', 'add_circle_outline', 'Добавить контрагента в Мои контрагенты', _vm.addFavorite), {
    tag: "v-component"
  })], 1) : _vm._e(), _vm._v(" "), (_vm.loner && _vm.loner.reference && _vm.getProfileHaveClient && _vm.favoriteLists && !this.accountNameShort) ? _c('v-flex', {
    attrs: {
      "py-1": ""
    }
  }, [_c(_vm.createButton('Атрибуты', 'info_outline', 'Атрибуты котрагента в Моих контрагентах', _vm.editNotesDialogOpen), {
    tag: "v-component"
  })], 1) : _vm._e()], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1118 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [(_vm.isRoot) ? _c('v-client-list') : _vm._e(), _vm._v(" "), (_vm.itemId !== null && _vm.itemId !== 'root') ? _c('v-client-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.itemId,
      "profileId": _vm.profileId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.humanId !== null) ? _c('v-human-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.humanId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.fagencyId !== null) ? _c('v-foreign-agency-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.fagencyId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.foreignId !== null) ? _c('v-foreign-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.foreignId
    }
  }) : _vm._e(), _vm._v(" "), (_vm.lonerId !== null) ? _c('v-loner-page', {
    attrs: {
      "mode": 'page',
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly,
      "itemId": _vm.lonerId
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1119 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1120),
  /* template */
  __webpack_require__(1127),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PeopleSet_vue__ = __webpack_require__(1121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__PeopleSet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__PeopleSet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PersonPage_vue__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PersonPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__PersonPage_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'people-panel',
  components: { vPeopleSet: __WEBPACK_IMPORTED_MODULE_2__PeopleSet_vue___default.a, vPersonPage: __WEBPACK_IMPORTED_MODULE_3__PersonPage_vue___default.a },
  props: {},
  data: function data() {
    return {};
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    // в случае изменения маршрута запрашиваем данные вновь
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient'
  })),
  methods: {}
});

/***/ }),
/* 1121 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1122),
  /* template */
  __webpack_require__(1123),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_js__ = __webpack_require__(27);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









// import vContactNew from './ContactNew.vue'


var RemoveAssistAction = function (_classes$Action) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RemoveAssistAction, _classes$Action);

  function RemoveAssistAction(context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RemoveAssistAction);

    return _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RemoveAssistAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(RemoveAssistAction)).call(this, context, 'Удалить записи о людях', null, function () {
      _this.context.deleteIndividuals(_this.context.cxt.selectedIds);
    }));
  }

  return RemoveAssistAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'people-set',
  components: { vOpsBtn: __WEBPACK_IMPORTED_MODULE_10__common_OpsBtn___default.a, vPanelTitle: __WEBPACK_IMPORTED_MODULE_12__info_PanelTitle___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_11__common_CardScroll___default.a },
  data: function data() {
    return {
      cxt: null
    };
  },
  created: function created() {
    var _this2 = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this2.filteredItems.map(function (item) {
        return item.id + '';
      });
    });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterEndAction(cxt));
    // cxt.actions.push(new classes.ActiveScopeAction(cxt))
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].AllScopeAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Новый контакт', null, function () {
      return _this2.newContact();
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Импорт из файла', null, function () {
      return _this2.loadContact();
    }));

    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterEndAction(cxt));
    cxt.selectActions.push(new RemoveAssistAction(this));

    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectAllAction(cxt));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectEndAction(cxt));

    cxt.title = 'Физические лица';
    cxt.titleIcon = 'people_outline';
    cxt.selectTitle = 'Выбор контакта';
    cxt.filterMode = true;

    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.cxt.filterString = this.getItemSet.getFilter().search;
    this.setActivated();
    this.fetchData();
  },

  props: {
    itemId: {
      type: String,
      default: null
    }
  },
  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.setActivated();
      this.fetchData();
    },
    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      this.setActivated();
      this.fetchData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    getRefToUrl: 'getRefToUrl',
    getProfileHaveClient: 'getProfileHaveClient',
    getItemSet: 'getPeopleSet'
  }), {
    items: function items() {
      return this.getItemSet.getItems();
    },
    orderedItems: function orderedItems() {
      return this.items.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].compareString(a.title, b.title);
      });
    },
    filteredItems: function filteredItems() {
      return this.orderedItems;
    },
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : '';
      } else {
        return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : '';
      }
    }
  }),
  methods: {
    changeFilterContext: function changeFilterContext(ops, force) {
      this.$store.commit('setPeopleFilterContext', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), ops));
      var self = this;
      setTimeout(function () {
        self.$store.dispatch('fetchPeople', force);
        self.scrollToActive();
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
      if (this.getProfileHaveClient) {
        var search = __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].stringifySearchTerms(__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString));
        if (__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].compareString(search, this.getItemSet.getFilter().search) !== 0) {
          this.changeFilterContext({ search: search }, true);
        }
      }
    },
    nextPage: function nextPage() {
      this.$store.commit('nextPeople');
      this.$store.dispatch('fetchPeople');
    },
    fetchData: function fetchData() {
      if (this.getProfileHaveClient) {
        this.changeFilterContext({ search: this.cxt.filterString });
      }
    },
    scrollToActive: function scrollToActive() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs.cardScroll.scrollToListActive();
      });
    },
    setActivated: function setActivated() {
      console.log('setActivated 0');
      if (this.$router && this.$router.options && this.$router.options.from) {
        var from = this.$router.options.from;
        if (from.params && from.params.personId) {
          var itemId = from.params.personId;
          var item = this.items.find(function (i) {
            return '' + i.id === itemId;
          });
          if (item) {
            console.log('setActivated', item.id);
            this.cxt.activate(item.id);
          } else {
            this.$store.commit('setInfoStatus', 'Позиционировать не удалось, возможно выборка была изменена. ');
          }
        }
      }
    },
    formatState: function formatState(state) {
      return state;
    },
    openItem: function openItem(item) {
      __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].open(item.id);
    },
    getItemRef: function getItemRef(item) {
      return __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].getItemRef(item.id);
    },
    newContact: function newContact() {
      var _this4 = this;

      __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].newForm().then(function () {
        _this4.fetchData();
      });
    },
    loadContact: function loadContact() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].loadForm().then(function () {
        _this5.fetchData();
      });
    },
    deleteIndividuals: function deleteIndividuals(selectedIds) {
      if (Array.isArray(selectedIds)) {
        __WEBPACK_IMPORTED_MODULE_9__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0423\u0434\u0430\u043B\u0438\u0442\u044C ' + selectedIds.length + ' \u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043E \u043B\u044E\u0434\u044F\u0445?', function (self) {
          self.$store.dispatch('deletePeopleIndividuals', { ids: selectedIds });
          self.cxt.toViewMode();
        });
      }
    }
  }
});

/***/ }),
/* 1123 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs8": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    },
    model: {
      value: (_vm.cxt.filterString),
      callback: function($$v) {
        _vm.$set(_vm.cxt, "filterString", $$v)
      },
      expression: "cxt.filterString"
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }]
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDeed(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.getItemSet.isProcessing(),
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: item.id,
      attrs: {
        "value": _vm.cxt.activated(item.id),
        "active-class": "v-dealger-favorite-active v-list__tile--highlighted "
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          !_vm.cxt.isSelectMode() ? _vm.openItem(item) : _vm.cxt.select(item.id)
        }
      }
    }, [_c('v-list-tile-content', {
      staticStyle: {
        "justify-content": "start"
      }
    }, [_c('v-list-tile-title', [_c('b', [_c('a', {
      attrs: {
        "href": _vm.getItemRef(item)
      }
    }, [_vm._v(_vm._s(item.title))])])]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n               " + _vm._s(item.description) + "\n                ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.cxt.isSelectMode()),
        expression: "!cxt.isSelectMode()"
      }]
    }, [_vm._v(" " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.isSelectMode()),
        expression: "cxt.isSelectMode()"
      }]
    }, [_c('v-list-tile-action-text', [_vm._v("  " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.id)),
        expression: "cxt.check(item.id)"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.id)),
        expression: "cxt.uncheck(item.id)"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1)], 1)], 1)]
  })], 2), _vm._v(" "), _c('v-panel-title', {
    attrs: {
      "value": false,
      "caption": 'Еще',
      "expandable": _vm.filteredItems.length < _vm.getItemSet.getTotal()
    },
    on: {
      "click": function($event) {
        return _vm.nextPage()
      }
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1124 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1125),
  /* template */
  __webpack_require__(1126),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__index_js__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import server from '../../api/server'






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'person-page',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_5__info_PanelTitle___default.a, vOpsBtn: __WEBPACK_IMPORTED_MODULE_4__common_OpsBtn___default.a },
  data: function data() {
    return {
      title: '',
      strategy: null,
      profile: null,
      cxtDoc: null
    };
  },
  props: {
    // itemId: {
    //   type: String,
    //   default: null
    // },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'page'
    }
  },
  created: function created() {
    var _this = this;

    this.strategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, 'INDIVIDUAL');
    var cxt = new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].MultiSelectContext(function () {});
    cxt.actionIcon = 'add';
    // cxt.mode = classes.modes.SELECT
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Паспорт РФ', null, function () {
      return _this.openDoc(null, 'PASSPORT_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Свидетельство о рождении РФ', null, function () {
      return _this.openDoc(null, 'BIRTH_CERT_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Временное удоостоверение личности РФ', null, function () {
      return _this.openDoc(null, 'TEMPORARY_ID_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Свидет о пенс. страховании РФ', null, function () {
      return _this.openDoc(null, 'PENSION_CERT_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Водительское удостоверение', null, function () {
      return _this.openDoc(null, 'DRIVER_LIC_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Свидетельство о заключении брака', null, function () {
      return _this.openDoc(null, 'MARRIAGE_CERT_RF');
    }));
    this.cxtDoc = cxt;
  },
  mounted: function mounted() {
    if (this.itemId) {
      this.fetchIndividual(this.itemId);
    }
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      if (newVal) {
        this.fetchIndividual(newVal);
      } else {}
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({}), {
    itemId: function itemId() {
      return this.$route.params.personId;
    },
    genders: function genders() {
      return __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].genders();
    },
    citizenships: function citizenships() {
      return __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].citizenships();
    },
    contacts: function contacts() {
      var items = this.profile ? this.profile.contacts : [];
      return __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].sortIndividualContact(items);
    },
    documents: function documents() {
      var items = this.profile ? this.profile.docs : [];
      return __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].sortIndividualDoc(items);
    }
  }),
  methods: {
    back: function back() {
      this.$router.go(-1);
    },
    fetchIndividual: function fetchIndividual(id) {
      var _this2 = this;

      if (id) {
        return this.strategy.fetchData(id).then(function (data) {
          _this2.profile = data;
          _this2.title = _this2.strategy.viewTitle(_this2.strategy.createModelFromData(_this2.profile));
        });
      } else {
        this.back();
      }
    },
    editProfile: function editProfile() {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].openForm(this.itemId).then(function (id) {
        _this3.fetchIndividual(id);
      });
    },
    createProfileContent: function createProfileContent() {
      if (this.strategy && this.strategy.viewContentComp) {
        return this.strategy.viewContentComp(this.strategy.createModelFromData(this.profile));
      }
      return this.createComp('<span></span>');
    },
    openContact: function openContact(item) {
      var _this4 = this;

      // console.log('openContact', this.fullscreen)
      __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].openContact(item ? item.id : null, this.itemId).then(function () {
        _this4.fetchIndividual(_this4.itemId);
      });
    },
    createContactTitle: function createContactTitle(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, 'CONTACT');
      if (strategy && strategy.viewTitleComp) {
        return strategy.viewTitleComp(strategy.createModelFromData(item));
      }
      return this.createComp('<span>Новый тип документа</span>');
    },
    createContactContent: function createContactContent(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, 'CONTACT');
      if (strategy && strategy.viewContentComp) {
        return strategy.viewContentComp(strategy.createModelFromData(item));
      }
      return this.createComp('<span></span>');
    },
    openDoc: function openDoc(item, type) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].openDoc(item ? item.id : null, this.itemId, item ? item.type : type).then(function () {
        _this5.fetchIndividual(_this5.itemId);
      });
    },
    createDocTitle: function createDocTitle(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, item.type);
      if (strategy && strategy.viewTitleComp) {
        return strategy.viewTitleComp(strategy.createModelFromJSON(item.model));
      }
      return this.createComp('<span>Новый тип документа</span>');
    },
    createDocContent: function createDocContent(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_6__index_js__["a" /* default */].createStrategy(this, item.type);
      if (strategy && strategy.viewContentComp) {
        return strategy.viewContentComp(strategy.createModelFromJSON(item.model));
      }
      return this.createComp('<span></span>');
    },
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].createComp(template);
    }
  }
});

/***/ }),
/* 1126 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createProfileContent(), {
    tag: "component"
  })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.editProfile()
      }
    }
  }, [_vm._v("Изменить")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Документы\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxtDoc
    }
  })], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.documents), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createDocTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createDocContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openDoc(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Контакты\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openContact(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.contacts), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createContactTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createContactContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openContact(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1127 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Служба физических лиц.")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Служба физических лиц позволяет сохранять информацию о физических лицах необходимыхдля деятельности компании. Физические лица могут быть сотрудниками компании или представителями контрагентов, данные о которых хранятся в компании.\n        Для работы с физическими лицами , необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и общайтесь от имени Вашей компании.        ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && !this.$route.params.personId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-people-set')], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && _vm.$route.params.personId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-person-page', {
    attrs: {
      "itemId": _vm.$route.params.personId
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1128 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1129),
  /* template */
  __webpack_require__(1136),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1129 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FavoriteCompanySet_vue__ = __webpack_require__(1130);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__FavoriteCompanySet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__FavoriteCompanySet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CAgentPage_vue__ = __webpack_require__(1133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__CAgentPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__CAgentPage_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'favorite-company-panel',
  components: { vFavoriteCompanySet: __WEBPACK_IMPORTED_MODULE_2__FavoriteCompanySet_vue___default.a, vCAgentPage: __WEBPACK_IMPORTED_MODULE_3__CAgentPage_vue___default.a },
  props: {},
  data: function data() {
    return {
      tagIds: []
    };
  },
  mounted: function mounted() {
    this.setTagIds();
  },

  watch: {
    // в случае изменения маршрута запрашиваем данные вновь
    '$route': function $route() {
      this.setTagIds();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient'
  })),
  methods: {
    setTagIds: function setTagIds() {
      this.tagIds = [].concat(this.$route.query && this.$route.query.tag ? this.$route.query.tag : []);
    }
  }
});

/***/ }),
/* 1130 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1131),
  /* template */
  __webpack_require__(1132),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1131 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__client_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TagSelector_vue__ = __webpack_require__(246);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__TagSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__TagSelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__api_server__ = __webpack_require__(8);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var AllScopeAction = function (_classes$Action) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AllScopeAction, _classes$Action);

  function AllScopeAction(context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AllScopeAction);

    return _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AllScopeAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AllScopeAction)).call(this, context, 'Все', null, function () {
      _this.context.cxt.showAll();
      _this.context.setTags([]);
    }));
  }

  return AllScopeAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var ShowOtherOwnersAction = function (_classes$Action2) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ShowOtherOwnersAction, _classes$Action2);

  function ShowOtherOwnersAction(context) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ShowOtherOwnersAction);

    return _this2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ShowOtherOwnersAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ShowOtherOwnersAction)).call(this, context, 'Показывать чужиx контрагентов', function () {
      return _this2.context.isShowOtherAllow() && !_this2.context.getItemSet.getFilter().isShowOther;
    }, function () {
      return _this2.context.switchOther(true);
    }));
  }

  return ShowOtherOwnersAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var NotShowOtherOwnersAction = function (_classes$Action3) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(NotShowOtherOwnersAction, _classes$Action3);

  function NotShowOtherOwnersAction(context) {
    var _this3;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, NotShowOtherOwnersAction);

    return _this3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (NotShowOtherOwnersAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(NotShowOtherOwnersAction)).call(this, context, 'Не показывать чужиx контрагентов', function () {
      return _this3.context.isShowOtherAllow() && _this3.context.getItemSet.getFilter().isShowOther;
    }, function () {
      return _this3.context.switchOther(false);
    }));
  }

  return NotShowOtherOwnersAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var CopyInnAction = function (_classes$Action4) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CopyInnAction, _classes$Action4);

  function CopyInnAction(context) {
    var _this4;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CopyInnAction);

    return _this4 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CopyInnAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CopyInnAction)).call(this, context, 'Копировать в буфер обмена', null, function () {
      _this4.context.copyFavorites(_this4.context.cxt.selectedIds);
    }));
  }

  return CopyInnAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var AddMyContragentAction = function (_classes$Action5) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AddMyContragentAction, _classes$Action5);

  function AddMyContragentAction(context) {
    var _this5;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AddMyContragentAction);

    return _this5 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AddMyContragentAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AddMyContragentAction)).call(this, context, 'Добавить в Мои контрагенты', null, function () {
      return _this5.context.addItem();
    }));
  }

  return AddMyContragentAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var RemoveMyContragentAction = function (_classes$Action6) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RemoveMyContragentAction, _classes$Action6);

  function RemoveMyContragentAction(context) {
    var _this6;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RemoveMyContragentAction);

    return _this6 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RemoveMyContragentAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(RemoveMyContragentAction)).call(this, context, 'Исключить из Моих контрагентов', null, function () {
      _this6.context.deleteFavorites(_this6.context.cxt.selectedIds);
    }));
  }

  return RemoveMyContragentAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var ChangeTagsAction = function (_classes$Action7) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(ChangeTagsAction, _classes$Action7);

  function ChangeTagsAction(context) {
    var _this7;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, ChangeTagsAction);

    return _this7 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (ChangeTagsAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(ChangeTagsAction)).call(this, context, 'Метки', null, function () {
      return _this7.context.selectTag();
    }));
  }

  return ChangeTagsAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var UpdateTagsForItemsAction = function (_classes$Action8) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(UpdateTagsForItemsAction, _classes$Action8);

  function UpdateTagsForItemsAction(context) {
    var _this8;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, UpdateTagsForItemsAction);

    return _this8 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (UpdateTagsForItemsAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(UpdateTagsForItemsAction)).call(this, context, 'Пометить', null, function () {
      _this8.context.updateTag(_this8.context.cxt.selectedIds);
    }));
  }

  return UpdateTagsForItemsAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var AddItemsToMonitoringAction = function (_classes$Action9) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AddItemsToMonitoringAction, _classes$Action9);

  function AddItemsToMonitoringAction(context) {
    var _this9;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AddItemsToMonitoringAction);

    return _this9 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AddItemsToMonitoringAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AddItemsToMonitoringAction)).call(this, context, 'Добавить на Мониторинг', null, function () {
      _this9.context.addMonitoring(_this9.context.cxt.selectedIds);
    }));
  }

  return AddItemsToMonitoringAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var SelectAllAction = function (_classes$Action10) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SelectAllAction, _classes$Action10);

  function SelectAllAction(context) {
    var _this10;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SelectAllAction);

    return _this10 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SelectAllAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(SelectAllAction)).call(this, context, 'Выбрать Всех', null, function () {
      var fxt = _this10.context.getItemSet.getFilter();
      __WEBPACK_IMPORTED_MODULE_15__api_server__["a" /* default */].apiGetParams('/api/me/favorite/companies', {
        innOnly: true,
        request: {
          search: fxt.search,
          tagIds: fxt.tagIds,
          isShowOther: fxt.isShowOther,
          isMonitoring: false
        }
      }, function (data) {
        console.log('SelectAllAction', data);
        context.cxt.selectedIds = data.map(function (t) {
          return t.join('_');
        });
      }, function (e) {
        context.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка контрагентов клиента  ' });
      });
    }));
  }

  return SelectAllAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'favorite-company-set',
  components: { vOpsBtn: __WEBPACK_IMPORTED_MODULE_11__common_OpsBtn___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_12__common_CardScroll___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      tags: [],
      cxt: null,
      isShowOther: false
    };
  },
  created: function created() {
    var _this11 = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this11.filteredItems.map(function (item) {
        return _this11.getItemKey(item);
      });
    });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterEndAction(cxt));
    // cxt.actions.push(new classes.ActiveScopeAction(cxt))
    cxt.actions.push(new AllScopeAction(this));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new AddMyContragentAction(this));
    cxt.actions.push(new ShowOtherOwnersAction(this));
    cxt.actions.push(new NotShowOtherOwnersAction(this));
    cxt.actions.push(new ChangeTagsAction(this));

    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterEndAction(cxt));

    cxt.selectActions.push(new UpdateTagsForItemsAction(this));
    cxt.selectActions.push(new CopyInnAction(this));
    cxt.selectActions.push(new AddItemsToMonitoringAction(this));
    cxt.selectActions.push(new RemoveMyContragentAction(this));

    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new SelectAllAction(this));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectEndAction(cxt));

    cxt.title = 'Мои контрагенты';
    cxt.titleIcon = 'contacts';
    cxt.selectTitle = 'Выбор контрагента';
    cxt.filterMode = true;

    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.cxt.filterString = this.getItemSet.getFilter().search;
    this.setActivated();
    this.fetchData();
  },

  props: {
    itemId: {
      type: String,
      default: null
    },
    tagIds: {
      type: Array,
      default: null
    }
  },
  watch: {
    tagIds: function tagIds(newVal, oldVal) {
      if (Array.isArray(newVal)) {
        this.$store.commit('setFavoritesFilterContext', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), { tagIds: this.tagIds, isShowOther: false }));
        this.$store.dispatch('fetchFavoriteCompanies');
      }
    },
    // getTags: function (newVal, oldVal) {
    //   if (Array.isArray(newVal)) {
    //     this.tags = this.getTagsByIds(this.tagIds)
    //   }
    // },
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.fetchData();
    },
    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      this.fetchData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])({
    profile: 'getProfile',
    getIsMobile: 'getIsMobile',
    getItemSet: 'getFavoriteSet',
    getProfileHaveClient: 'getProfileHaveClient',
    getRefToUrl: 'getRefToUrl',
    getTags: 'getTags',
    getIsAllow: 'getIsAllow',
    renderReference: 'renderReference',
    renderHeads: 'renderHeads',
    renderFlags: 'renderFlags',
    renderInnOrInnflHtml: 'renderInnOrInnflHtml'
  }), {
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : '';
      } else {
        return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : '';
      }
    },
    items: function items() {
      return this.getItemSet.getItems();
    },
    orderedItems: function orderedItems() {
      return this.items;
    },
    filteredItems: function filteredItems() {
      var _this12 = this;

      var getSearchString = function getSearchString(item) {
        return ''.concat(item.ref.ref, item.ref.caption, item.ref.name, _this12.renderHeads(item.ref), item.ref.inn, item.ref.kpp,
        // this.formatDate(item.company.createDate),
        // this.formatDate(item.company.releaseDate),
        item.ref.address, item.notes, item.privateNotes, item.accountNameShort ? item.accountNameShort : _this12.profile.nameShort);
      };
      if (!this.cxt.isFilterMode() || this.cxt.filterString === null) {
        return this.orderedItems;
      }
      var terms = __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString);
      if (terms.length < 1) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        var searchStr = getSearchString(item).toLowerCase();
        return terms.every(function (t) {
          return searchStr.includes(t);
        });
      });
    },
    isMobile: function isMobile() {
      return this.$vuetify.breakpoint.xsOnly;
    }
  }),
  methods: {
    changeFilterContext: function changeFilterContext(ops, force) {
      this.$store.commit('setFavoritesFilterContext', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), ops));
      var self = this;
      setTimeout(function () {
        self.$store.dispatch('fetchFavoriteCompanies', force);
        self.scrollToActive();
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
      if (this.getProfileHaveClient) {
        var search = __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].stringifySearchTerms(__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString));
        if (__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].compareString(search, this.getItemSet.getFilter().search) !== 0) {
          this.changeFilterContext({ search: search }, true);
        }
      }
    },
    fetchData: function fetchData() {
      if (this.getProfileHaveClient) {
        this.changeFilterContext({ tagIds: this.tagIds, search: this.cxt.filterString, isShowOther: false });
        this.$store.dispatch('fetchTags');
        this.$store.dispatch('fetchRights', { LOCAL_ADMIN_CHECK: null });
      }
    },
    nextPage: function nextPage() {
      this.$store.commit('nextFavoriteCompanies');
      this.$store.dispatch('fetchFavoriteCompanies');
    },
    isShowOtherAllow: function isShowOtherAllow() {
      return this.getIsAllow({ LOCAL_ADMIN_CHECK: null });
    },
    openItem: function openItem(id) {
      this.dialogOpen(id);
    },
    switchOther: function switchOther(on) {
      this.$store.commit('setFavoritesFilterContext', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), { isShowOther: on }));
      this.$store.dispatch('fetchFavoriteCompanies');
    },
    getItemRef: function getItemRef(item) {
      return this.getRefToUrl(item.ref.ref);
    },
    getItemKey: function getItemKey(item) {
      return item.ref.ref + '_' + item.ref.inn + '_' + item.accountId;
    },
    getRefCodefromKey: function getRefCodefromKey(key) {
      return key.split('_')[0];
    },
    getInnfromKey: function getInnfromKey(key) {
      return key.split('_')[1];
    },
    addItem: function addItem() {
      this.selectClient();
    },

    addFavorites: function addFavorites(values) {
      if (Array.isArray(values)) {
        var refCodes = values;
        this.$store.dispatch('addFavoriteCompanies', { refCodes: refCodes, tagIds: this.tagIds });
      }
    },
    addMonitoring: function addMonitoring(selectedIds) {
      var _this13 = this;

      if (Array.isArray(selectedIds)) {
        var values = selectedIds.map(function (selectedId) {
          return _this13.getRefCodefromKey(selectedId);
        });
        this.$store.dispatch('updateMonitoringCompanies', { refCodes: values, monitoring: true });
        this.cxt && this.cxt.toViewMode();
      }
    },
    copyFavorites: function copyFavorites(selectedIds) {
      var _this14 = this;

      if (Array.isArray(selectedIds)) {
        var values = selectedIds.map(function (selectedId) {
          return _this14.getInnfromKey(selectedId);
        });
        var text = values.join(', ');
        this.$store.dispatch('copyToClipboard', { text: text });
        this.cxt && this.cxt.toViewMode();
      }
    },
    deleteFavorites: function deleteFavorites(selectedIds) {
      var _this15 = this;

      if (Array.isArray(selectedIds)) {
        var values = selectedIds.map(function (selectedId) {
          return _this15.getRefCodefromKey(selectedId);
        });
        __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', 'Убрать из "Мои контрагенты" и отключить мониторинг компаний?', function (self) {
          self.$store.dispatch('deleteFavoriteCompanies', { refCodes: values });
          self.cxt && self.cxt.toViewMode();
        });
      }
    },
    selectClient: function selectClient() {
      __WEBPACK_IMPORTED_MODULE_13__client_index_js__["a" /* default */].selectRef(this, this.addFavorites, function () {}, null, null, null);
    },
    formatTagName: function formatTagName(tagId) {
      var t = this.getTags.find(function (t) {
        return t.id === Math.abs(tagId);
      });
      var n = t ? t.name : '';
      return tagId < 0 ? '- ' + n : '' + n;
    },
    setTags: function setTags(tagIds) {
      this.$router.push({ path: this.$router.path, query: { tag: tagIds } });
    },
    selectTag: function selectTag() {
      var self = this;
      var setItems = function setItems(tagIds) {
        self.$nextTick(function () {
          self.setTags(tagIds);
        });
      };
      __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].register('v-tag-selector', __WEBPACK_IMPORTED_MODULE_14__TagSelector_vue___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-tag-selector v-on:close="$emit(\'close\')"\n        v-on:input="setItem"\n        :fullscreen="fullscreen" :selected="selected" removeMode></v-tag-selector>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            setItem: setItems,
            selected: self.tagIds
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].modal(comp);
    },
    updateTag: function updateTag(selectedIds) {
      var self = this;
      var setItems = function setItems(tagIds) {
        if (Array.isArray(selectedIds)) {
          var refCodes = selectedIds.map(function (v) {
            return self.getRefCodefromKey(v);
          });
          self.$store.dispatch('addFavoriteCompanies', { refCodes: refCodes, tagIds: tagIds });
          self.cxt && self.cxt.toViewMode();
        }
      };
      __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].register('v-tag-selector', __WEBPACK_IMPORTED_MODULE_14__TagSelector_vue___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-tag-selector v-on:close="$emit(\'close\')"\n        v-on:input="setItem"\n        :fullscreen="fullscreen" :selected="selected" removeMode></v-tag-selector>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            setItem: setItems,
            selected: self.tagIds
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].modal(comp);
    },
    renderCompanyFlags: function renderCompanyFlags(item) {
      return this.renderFlags(item.ref.flags);
    },
    scrollToActive: function scrollToActive() {
      var _this16 = this;

      this.$nextTick(function () {
        _this16.$refs.cardScroll.scrollToListActive();
      });
    },
    setActivated: function setActivated() {
      if (this.$router && this.$router.options && this.$router.options.from) {
        var from = this.$router.options.from;
        if (from.params && from.params.clientInn) {
          var itemId = from.params.clientInn;
          var item = this.items.find(function (i) {
            return '' + i.ref.ogrn === itemId;
          });
          if (item) {
            this.cxt.activate(this.getItemKey(item));
          } else {
            this.$store.commit('setInfoStatus', 'Позиционировать не удалось, возможно выборка была изменена. ');
          }
        }
        if (from.params && from.params.fagencyId) {
          var _itemId = from.params.fagencyId;
          var _item = this.items.find(function (i) {
            return '' + i.ref.nza === _itemId;
          });
          if (_item) {
            this.cxt.activate(this.getItemKey(_item));
          } else {
            this.$store.commit('setInfoStatus', 'Позиционировать не удалось, возможно выборка была изменена. ');
          }
        }
        if (from.params && from.params.lonerId) {
          var _itemId2 = from.params.lonerId;
          var _item2 = this.items.find(function (i) {
            return '' + i.ref.ogrnip === _itemId2;
          });
          if (_item2) {
            this.cxt.activate(this.getItemKey(_item2));
          } else {
            this.$store.commit('setInfoStatus', 'Позиционировать не удалось, возможно выборка была изменена. ');
          }
        }
      }
    }
  }
});

/***/ }),
/* 1132 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode()),
      expression: "cxt.isFilterMode() && cxt.isSelectMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!(_vm.cxt.isFilterMode() && _vm.cxt.isSelectMode())),
      expression: "!(cxt.isFilterMode() && cxt.isSelectMode())"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }, [_vm._l((_vm.tagIds), function(tagId) {
    return _c('v-chip', {
      key: tagId,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.selectTag()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center",
      domProps: {
        "innerHTML": _vm._s(_vm.formatTagName(tagId))
      }
    })])
  }), _vm._v(" "), _c('v-chip', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.tagIds.length === 0),
      expression: "tagIds.length === 0"
    }],
    attrs: {
      "small": "",
      "disabled": "",
      "text-color": "secondary"
    },
    on: {
      "click": function($event) {
        return _vm.selectTag()
      }
    }
  }, [_c('span', {
    staticClass: "text-xs-center"
  }, [_vm._v("\n               Метки\n               ")])])], 2), _vm._v(" "), (_vm.cxt.isFilterMode()) ? _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }]
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.getItemSet.isProcessing(),
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      attrs: {
        "value": _vm.cxt.activated(_vm.getItemKey(item)),
        "active-class": "v-dealger-favorite-active v-list__tile--highlighted "
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.cxt.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.ref))
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                 " + _vm._s(_vm.renderHeads(item.ref)) + "\n               "), _c('br'), _vm._v("\n               ИНН: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnOrInnflHtml(item.ref.inn))
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(_vm.formats.blank(item.ref.address)))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-layout', {
      attrs: {
        "justify-end": ""
      }
    }, [_c('v-tooltip', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.accountNameShort),
        expression: "item.accountNameShort"
      }],
      attrs: {
        "bottom": "",
        "open-delay": "500"
      }
    }, [_c('span', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("face")])], 1), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.accountNameShort))])]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.monitoring),
        expression: "item.monitoring"
      }]
    }, [_vm._v("alarm")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.monitoring),
        expression: "!item.monitoring"
      }]
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ref.clientId),
        expression: "item.ref.clientId"
      }]
    }, [_vm._v("person")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.ref.clientId),
        expression: "!item.ref.clientId"
      }]
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('v-layout', {
      attrs: {
        "justify-end": ""
      }
    }, [_c(_vm.renderCompanyFlags(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('v-list-tile-action-text', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.ref.createDate, _vm.formats.formatDate)))])]), _vm._v("\n               Регистрация\n             ")], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1133 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1134),
  /* template */
  __webpack_require__(1135),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1134 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__info_NotesForm__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__info_NotesForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__info_NotesForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__people_index_js__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


// import server from '../../api/server'








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'c-agent-page',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_6__info_PanelTitle___default.a, vOpsBtn: __WEBPACK_IMPORTED_MODULE_5__common_OpsBtn___default.a },
  data: function data() {
    return {
      title: '',
      strategy: null,
      cxtDoc: null,
      notesEditable: true,
      ref: null,
      clientCompanyId: null,
      banks: [],
      favoriteLists: null,
      privateNotes: null,
      notes: null,
      tags: null,
      accountNameShort: null,
      otherAttribs: []
    };
  },
  props: {
    // itemId: {
    //   type: String,
    //   default: null
    // },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'page'
    }
  },
  created: function created() {
    var _this = this;

    this.strategy = __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].createStrategy(this, 'INDIVIDUAL');
    var cxt = new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].MultiSelectContext(function () {});
    cxt.actionIcon = 'add';
    // cxt.mode = classes.modes.SELECT
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Паспорт РФ', null, function () {
      return _this.openDoc(null, 'PASSPORT_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Свидетельство о рождении РФ', null, function () {
      return _this.openDoc(null, 'BIRTH_CERT_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Временное удоостоверение личности РФ', null, function () {
      return _this.openDoc(null, 'TEMPORARY_ID_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Свидет о пенс. страховании РФ', null, function () {
      return _this.openDoc(null, 'PENSION_CERT_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Водительское удостоверение', null, function () {
      return _this.openDoc(null, 'DRIVER_LIC_RF');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_3__api_classes__["a" /* default */].Action(this, 'Свидетельство о заключении брака', null, function () {
      return _this.openDoc(null, 'MARRIAGE_CERT_RF');
    }));
    this.cxtDoc = cxt;
  },
  mounted: function mounted() {
    if (this.itemId) {
      this.fetchFavoriteProps(this.itemId);
    }
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      if (newVal) {
        this.fetchFavoriteProps(newVal);
      } else {}
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient'
  }), {
    itemId: function itemId() {
      return this.$route.params.cagentId;
    },
    genders: function genders() {
      return __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].genders();
    },
    citizenships: function citizenships() {
      return __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].citizenships();
    },
    contacts: function contacts() {
      var items = this.profile ? this.profile.contacts : [];
      return __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].sortIndividualContact(items);
    },
    documents: function documents() {
      var items = this.profile ? this.profile.docs : [];
      return __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].sortIndividualDoc(items);
    }
  }),
  methods: {
    back: function back() {
      this.$router.go(-1);
    },
    fetchFavoriteProps: function fetchFavoriteProps(refCode) {
      var _this2 = this;

      this.$store.dispatch('getFavoriteRefs', refCode).then(function (data) {
        if (!Array.isArray(data) || data.length < 1) {
          console.log('fetchFavoriteProps', data);
          return;
        }
        if (_this2.getProfileHaveClient) {
          _this2.ref = data[0].ref;
          _this2.title = _this2.ref ? _this2.ref.caption : '';
          _this2.clientCompanyId = data[0].clientCompanyId;
          _this2.banks = data[0].banks;
          _this2.favoriteLists = data[0].tags;
          _this2.privateNotes = data[0].privateNotes;
          _this2.notes = data[0].notes;
          _this2.tags = data[0].tags;
          _this2.monitoring = data[0].monitoring;
          _this2.accountNameShort = data[0].accountNameShort;
          _this2.otherAttribs = data.slice(1);
        } else {
          _this2.ref = null;
          _this2.clientCompanyId = null;
          _this2.banks = [];
          _this2.favoriteLists = null;
          _this2.privateNotes = null;
          _this2.notes = null;
          _this2.tags = null;
          _this2.monitoring = false;
          _this2.accountNameShort = null;
          _this2.otherAttribs = [];
        }
      });
    },
    fetchIndividual: function fetchIndividual(id) {
      var _this3 = this;

      if (id) {
        return this.strategy.fetchData(id).then(function (data) {
          _this3.profile = data;
          _this3.title = _this3.strategy.viewTitle(_this3.strategy.createModelFromData(_this3.profile));
        });
      } else {
        this.back();
      }
    },
    editProfile: function editProfile() {},
    createProfileContent: function createProfileContent() {
      if (this.strategy && this.strategy.viewContentComp) {
        return this.strategy.viewContentComp(this.strategy.createModelFromData(this.profile));
      }
      return this.createComp('<span></span>');
    },
    openContact: function openContact(item) {
      var _this4 = this;

      // console.log('openContact', this.fullscreen)
      __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].openContact(item ? item.id : null, this.itemId).then(function () {
        _this4.fetchIndividual(_this4.itemId);
      });
    },
    createContactTitle: function createContactTitle(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].createStrategy(this, 'CONTACT');
      if (strategy && strategy.viewTitleComp) {
        return strategy.viewTitleComp(strategy.createModelFromData(item));
      }
      return this.createComp('<span>Новый тип документа</span>');
    },
    createContactContent: function createContactContent(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].createStrategy(this, 'CONTACT');
      if (strategy && strategy.viewContentComp) {
        return strategy.viewContentComp(strategy.createModelFromData(item));
      }
      return this.createComp('<span></span>');
    },
    openDoc: function openDoc(item, type) {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].openDoc(item ? item.id : null, this.itemId, item ? item.type : type).then(function () {
        _this5.fetchIndividual(_this5.itemId);
      });
    },
    createDocTitle: function createDocTitle(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].createStrategy(this, item.type);
      if (strategy && strategy.viewTitleComp) {
        return strategy.viewTitleComp(strategy.createModelFromJSON(item.model));
      }
      return this.createComp('<span>Новый тип документа</span>');
    },
    createDocContent: function createDocContent(item) {
      var strategy = __WEBPACK_IMPORTED_MODULE_8__people_index_js__["a" /* default */].createStrategy(this, item.type);
      if (strategy && strategy.viewContentComp) {
        return strategy.viewContentComp(strategy.createModelFromJSON(item.model));
      }
      return this.createComp('<span></span>');
    },
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].createComp(template);
    },

    editNotesDialogOpen: function editNotesDialogOpen(item) {
      if (!this.notesEditable) {
        return;
      }
      var self = this;
      var setNotes = function setNotes(data) {
        self.refreshCompanyProps();
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].register('v-notes-form', __WEBPACK_IMPORTED_MODULE_7__info_NotesForm___default.a);
      var comp = { template: '\n        <v-notes-form v-on:input="setNotes" v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-notes-form>\n      ',
        data: function data() {
          return {
            model: { clientCompanyId: self.clientCompanyId, banks: self.banks, company: { reference: self.ref, name: { caption: self.ref.caption } }, privateNotes: self.privateNotes, notes: self.notes, tags: self.tags, monitoring: self.monitoring },
            setNotes: setNotes,
            fullscreen: self.$vuetify.breakpoint.xsOnly
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1135 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.back()
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n        ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "justify-end": "",
      "row": "",
      "wrap": ""
    }
  }, _vm._l((_vm.tags), function(tag) {
    return _c('v-chip', {
      key: tag.id,
      attrs: {
        "small": "",
        "disabled": "",
        "text-color": "secondary"
      },
      on: {
        "click": function($event) {
          return _vm.editNotesDialogOpen()
        }
      }
    }, [_c('span', {
      staticClass: "text-xs-center"
    }, [_vm._v("\n              " + _vm._s(tag.name) + "\n              ")])])
  }), 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.editNotesDialogOpen()
      }
    }
  }, [_vm._v("Изменить")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Документы\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxtDoc
    }
  })], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.documents), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createDocTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createDocContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openDoc(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md12": "",
      "pa-2": ""
    }
  }, [_c('v-card', {
    ref: "scroll_target",
    attrs: {
      "flat": ""
    }
  }, [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Контакты\n          ")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openContact(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1), _vm._v(" "), _c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": ""
    },
    attrs: {
      "pt-2": "",
      "px-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.contacts), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', [_c('v-card-title', [_c('span', {
      staticClass: "subheading"
    }, [_c(_vm.createContactTitle(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_c(_vm.createContactContent(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      on: {
        "click": function($event) {
          return _vm.openContact(item)
        }
      }
    }, [_vm._v("Изменить")])], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1136 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Служба контрагентов. ")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Служба контрагентов позволяет быстро находить избранных контрагентов, ставить их на мониторинг в егрюл, позволяет группировать контрагентов по спискам, а также вести протокол просмотра контрагентов.\n        Для работы с избранными контрагентами, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и общайтесь от имени Вашей компании.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && !_vm.$route.params.cagentId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-favorite-company-set', {
    attrs: {
      "tagIds": _vm.tagIds
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && _vm.$route.params.cagentId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-c-agent-page', {
    attrs: {
      "itemId": _vm.$route.params.cagentId
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1137 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1138),
  /* template */
  __webpack_require__(1142),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1138 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info_ClientPage_vue__ = __webpack_require__(469);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__info_ClientPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__info_ClientPage_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HomePanel_vue__ = __webpack_require__(1139);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__HomePanel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__HomePanel_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  components: { vClientPage: __WEBPACK_IMPORTED_MODULE_2__info_ClientPage_vue___default.a, vHomePanel: __WEBPACK_IMPORTED_MODULE_3__HomePanel_vue___default.a },
  data: function data() {
    return {};
  },
  mounted: function mounted() {
    if (this.getProfileHaveClient) {
      this.$store.dispatch('fetchDashboardCounters');
    }
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient',
    profile: 'getProfile',
    counters: 'getDashboardCounters'
  })),
  methods: {}
});

/***/ }),
/* 1139 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1140),
  /* template */
  __webpack_require__(1141),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1140 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-home-panel',
  components: {},
  data: function data() {
    return {
      aspects: [{
        name: 'Федеральная налоговая служба',
        nameShort: 'ФНС',
        img: 'static/img/dbs/fns.svg',
        items: [{ name: 'Изменения в ЕГРЮЛ' }, { name: 'Количество сотрудников' }, { name: 'Специальные налоговые режимы' }, { name: 'Уплаченные налоги и сборы' }, { name: 'Налоговая задолженность' }, { name: 'Лицензии' }, { name: 'РАФП – Реестр аккредитованных филиалов и представительств иностранных компаний' }]
      }, {
        name: 'Федеральная служба судебных приставов',
        nameShort: 'ФССП',
        img: 'static/img/dbs/fssp.svg',
        items: [{ name: 'Исполнительные производства' }]
      }, {
        name: 'Федеральная служба государственной статистики',
        nameShort: 'Росстат',
        img: 'static/img/dbs/rfss.png',
        items: [{ name: 'Бухгалтерская отчетность' }]
      }, {
        name: 'Федеральная служба по интеллектуальной собственности',
        nameShort: 'Роспатент',
        img: 'static/img/dbs/rospatent.png',
        items: [{ name: 'Товарные знаки и знаки обслуживания' }, { name: 'Общеизвестные в РФ товарные знаки' }]
      }],
      features: [{
        nameShort: 'Мои контрагенты',
        name: 'Позволяет использовать общие списки контрагентов для представителей одной компании и вносить примечания, видимые этим представителям'
      }, {
        nameShort: 'Мониторинг',
        name: 'Позволяет отслеживать изменения, которые вносятся в ЕГРЮЛ вашими контрагентами. Это позволяет избежать сюрпризов и быть в курсе об изменнених происходящих у Ваших партнеров.'
      }]
    };
  },
  mounted: function mounted() {},

  computed: {},
  methods: {}
});

/***/ }),
/* 1141 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "color": "primary darken-2",
      "dark": ""
    }
  }, [_c('v-responsive', {
    attrs: {
      "height": "400px"
    }
  }, [_c('v-container', {
    attrs: {
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('h2', {
    staticClass: "display-1"
  }, [_vm._v("Система \"АТЛАНТ-СМАРТ\"")]), _vm._v(" "), _c('h3', [_vm._v("удобная и быстрая система проверки контрагентов и партнеров.")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('v-flex', {
    attrs: {
      "text-xs-center": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "to": "/clients"
    }
  }, [_vm._v("Поиск контрагентов")])], 1)], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Критерии поиска")]), _vm._v(" "), _c('div', [_vm._v("\n        Система позволяет осуществлять поиск Юридических Лиц на основе текущих и исторических данных о названиях, адресах, руководителях, участниках и уставном капитале компаний. \n      ")])])], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Аспекты проверки и источники данных")]), _vm._v(" "), _c('div', [_vm._v("\n        Система позволяет проверять контрагентов на основе данных, полученных из официальных источников.\n      ")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.aspects), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "100%"
      }
    }, [_c('v-card-title', [_c('v-container', {
      attrs: {
        "fluid": "",
        "grid-list-lg": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "xs4": ""
      }
    }, [_c('v-img', {
      attrs: {
        "src": item.img,
        "height": "64px",
        "contain": ""
      }
    })], 1), _vm._v(" "), _c('v-flex', {
      attrs: {
        "xs8": ""
      }
    }, [_c('div', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.nameShort))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(item.name))])])])], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', _vm._l((item.items), function(item) {
      return _c('div', [_vm._v(_vm._s(item.name))])
    }), 0)], 1)], 1)]
  })], 2)], 1)], 1)], 1), _vm._v(" "), _c('v-card', {
    attrs: {
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', [_c('div', [_c('div', {
    staticClass: "headline"
  }, [_vm._v("Регистрация в системе")]), _vm._v("\n      Дополнительные сервисы для зарегистрированных пользователей\n      ")])]), _vm._v(" "), _c('v-card-text', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.features), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": "",
        "sm6": ""
      }
    }, [_c('v-card', {
      attrs: {
        "height": "100%"
      }
    }, [_c('v-container', {
      attrs: {
        "fluid": "",
        "grid-list-lg": ""
      }
    }, [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_c('v-card-title', [_c('div', [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(item.nameShort))])])]), _vm._v(" "), _c('v-card-text', [_c('span', [_vm._v(_vm._s(item.name))])])], 1)], 1)], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1142 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.getProfileHaveClient) ? _c('v-flex', [_c('v-card', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-client-page', {
    attrs: {
      "mode": 'mainPage',
      "itemId": _vm.profile.clientInn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md4": ""
    }
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0"
    },
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-card', {
    attrs: {
      "to": "/doc_list/root",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', {
    staticClass: "title",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n              Депозитарий\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Сервис позволяет задепонировать документы и гарантирует что документы были опубликованы именно в том виде в каком они существуют. Вы можете ссылаться на задепонированные документы и использовать их для разрешения спорных ситуаций\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    attrs: {
      "to": "/chats/root",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', {
    staticClass: "title",
    attrs: {
      "primary-title": ""
    }
  }, [_c('v-badge', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.counters.notReviewedChats > 0),
      expression: "counters.notReviewedChats > 0"
    }],
    attrs: {
      "right": ""
    }
  }, [_c('span', {
    attrs: {
      "slot": "badge"
    },
    slot: "badge"
  }, [_vm._v(_vm._s(_vm.counters.notReviewedChats))]), _vm._v(" "), _c('span', [_vm._v("Сообщения")])]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.counters.notReviewedChats || _vm.counters.notReviewedChats === 0),
      expression: "!counters.notReviewedChats || counters.notReviewedChats === 0"
    }]
  }, [_vm._v("Сообщения")])], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Сервис позволяет обмениваться сообщениями, как и многие другие сервисы. Отличие Системы \"АТЛАНТ-СМАРТ\" в том, что вся переписка хранится в надежной базе Системы \"АТЛАНТ-СМАРТ\" и может быть использована для решения спорных ситуаций.\n            ")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-card', {
    attrs: {
      "to": "/monitoring_page",
      "color": "grey lighten-4"
    }
  }, [_c('v-card-title', {
    staticClass: "title",
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("\n              Мониторинг контрагентов\n            ")]), _vm._v(" "), _c('v-card-text', [_vm._v("\n            Сервис позволяет отслеживать изменения, которые вносятся в ЕГРЮЛ вашими контрагентами. Это позволяет избежать сюрпризов и быть в курсе об изменениях, происходящих у Ваших партнеров.\n            ")])], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (!_vm.getProfileHaveClient) ? _c('v-flex', [_c('v-home-panel')], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1143 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1144),
  /* template */
  __webpack_require__(1148),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MonitoringSet_vue__ = __webpack_require__(1145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__MonitoringSet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__MonitoringSet_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'monitoring-panel',
  components: { vMonitoringSet: __WEBPACK_IMPORTED_MODULE_2__MonitoringSet_vue___default.a },
  props: {},
  data: function data() {
    return {
      tagIds: []
    };
  },
  created: function created() {
    this.fetchRights();
  },
  mounted: function mounted() {
    this.fetchRights();
  },

  watch: {
    // в случае изменения маршрута запрашиваем данные вновь
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient',
    getClientMonitoring: 'getClientMonitoring',
    getIsAllow: 'getIsAllow'
  })),
  methods: {
    switchMonitoringOn: function switchMonitoringOn() {
      this.$store.dispatch('switchClientMonitoring', { monitoring: true, addFavorites: true });
    },
    fetchRights: function fetchRights() {
      this.$store.dispatch('fetchRights', { MONITORING_SWITCH: null });
    }
  }
});

/***/ }),
/* 1145 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1146),
  /* template */
  __webpack_require__(1147),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__client_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__api_server__ = __webpack_require__(8);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//











var AddMonitoringAction = function (_classes$Action) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(AddMonitoringAction, _classes$Action);

  function AddMonitoringAction(context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, AddMonitoringAction);

    return _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AddMonitoringAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(AddMonitoringAction)).call(this, context, 'Добавить на Мониторинг', null, function () {
      return _this.context.addItem();
    }));
  }

  return AddMonitoringAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var RemoveMonitoringAction = function (_classes$Action2) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RemoveMonitoringAction, _classes$Action2);

  function RemoveMonitoringAction(context) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RemoveMonitoringAction);

    return _this2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RemoveMonitoringAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(RemoveMonitoringAction)).call(this, context, 'Отключить Мониторинг', null, function () {
      _this2.context.removeMonitoring(_this2.context.cxt.selectedIds);
    }));
  }

  return RemoveMonitoringAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var SelectAllAction = function (_classes$Action3) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(SelectAllAction, _classes$Action3);

  function SelectAllAction(context) {
    var _this3;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, SelectAllAction);

    return _this3 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (SelectAllAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(SelectAllAction)).call(this, context, 'Выбрать Всех', null, function () {
      var fxt = _this3.context.getItemSet.getFilter();
      __WEBPACK_IMPORTED_MODULE_14__api_server__["a" /* default */].apiGetParams('/api/me/favorite/companies', {
        innOnly: true,
        request: {
          search: fxt.search,
          tagIds: fxt.tagIds,
          isShowOther: false,
          isMonitoring: true
        }
      }, function (data) {
        context.cxt.selectedIds = data.map(function (o) {
          return o[0];
        });
        console.log('SelectAllAction', context.cxt.selectedIds);
      }, function (e) {
        context.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении списка контрагентов клиента  ' });
      });
    }));
  }

  return SelectAllAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'monitoring-set',
  components: { vOpsBtn: __WEBPACK_IMPORTED_MODULE_11__common_OpsBtn___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_12__common_CardScroll___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      tags: [],
      cxt: null
    };
  },
  created: function created() {
    var _this4 = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this4.filteredItems.map(function (item) {
        return _this4.getItemKey(item);
      });
    });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterEndAction(cxt));
    // cxt.actions.push(new classes.ActiveScopeAction(cxt))
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].AllScopeAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new AddMonitoringAction(this));

    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterEndAction(cxt));
    cxt.selectActions.push(new RemoveMonitoringAction(this));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new SelectAllAction(this));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectEndAction(cxt));

    cxt.title = 'Мониторинг';
    cxt.titleIcon = 'alarm';
    cxt.selectTitle = 'Выбор контрагента';
    cxt.filterMode = true;

    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.fetchData();
    this.setActivated();
  },

  props: {
    itemId: {
      type: String,
      default: null
    },
    tagIds: {
      type: Array,
      default: null
    }
  },
  watch: {
    tagIds: function tagIds(newVal, oldVal) {
      if (Array.isArray(newVal)) {
        this.tags = this.getTags.filter(function (t) {
          return newVal.includes(t.id.toString());
        });
      }
    },
    getTags: function getTags(newVal, oldVal) {
      var _this5 = this;

      if (Array.isArray(newVal)) {
        this.tags = this.getTags.filter(function (t) {
          return _this5.tagIds && _this5.tagIds.includes(t.id.toString());
        });
      }
    },
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.fetchData();
    },
    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      this.fetchData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    getItemSet: 'getMonitoredSet',
    getProfileHaveClient: 'getProfileHaveClient',
    getRefToUrl: 'getRefToUrl',
    getTags: 'getTags',
    renderReference: 'renderReference',
    renderHeads: 'renderHeads',
    renderFlags: 'renderFlags',
    renderInnOrInnflHtml: 'renderInnOrInnflHtml'
  }), {
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : '';
      } else {
        return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : '';
      }
    },
    items: function items() {
      return this.getItemSet.getItems();
    },
    orderedItems: function orderedItems() {
      return this.items;
    },
    filteredItems: function filteredItems() {
      var _this6 = this;

      var getSearchString = function getSearchString(item) {
        return ''.concat(item.ref.caption, item.ref.name, _this6.renderHeads(item.ref), item.ref.inn, item.ref.ogrn, item.ref.kpp,
        // this.formatDate(item.ref.createDate),
        // this.formatDate(item.ref.releaseDate),
        item.ref.address, item.notes, item.privateNotes);
      };
      if (!this.cxt.isFilterMode() || this.cxt.filterString === null) {
        return this.orderedItems;
      }
      var terms = __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString);
      if (terms.length < 1) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        var searchStr = getSearchString(item).toLowerCase();
        return terms.every(function (t) {
          return searchStr.includes(t);
        });
      });
    }
  }),
  methods: {
    changeFilterContext: function changeFilterContext(ops, force) {
      this.$store.commit('setMonitoredFilterContext', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), ops));
      var self = this;
      setTimeout(function () {
        self.$store.dispatch('fetchMonitoredCompanies', force);
        self.scrollToActive();
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
      if (this.getProfileHaveClient) {
        var search = __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].stringifySearchTerms(__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString));
        if (__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].compareString(search, this.getItemSet.getFilter().search) !== 0) {
          this.changeFilterContext({ search: search }, true);
        }
      }
    },
    fetchData: function fetchData() {
      if (this.getProfileHaveClient) {
        this.changeFilterContext({ tagIds: this.tagIds, search: this.cxt.filterString, isShowOther: false });
        this.$store.dispatch('fetchTags');
      }
    },
    nextPage: function nextPage() {
      this.$store.commit('nextMonitoredCompanies');
      this.$store.dispatch('fetchMonitoredCompanies');
    },
    getItemKey: function getItemKey(item) {
      return item ? item.ref.ref : null;
    },
    getInnfromKey: function getInnfromKey(key) {
      return key.split('_')[0];
    },
    openItem: function openItem(id) {
      this.dialogOpen(id);
    },
    addItem: function addItem() {
      this.selectClient();
    },

    addMonitoring: function addMonitoring(values) {
      if (Array.isArray(values)) {
        var list = values;
        this.$store.dispatch('updateMonitoringCompanies', { refCodes: list, monitoring: true });
      }
    },
    removeMonitoring: function removeMonitoring(refCodes) {
      if (Array.isArray(refCodes)) {
        __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', 'Отключить мониторинг для компаний?', function (self) {
          self.$store.dispatch('updateMonitoringCompanies', { refCodes: refCodes, monitoring: false });
          self.cxt && self.cxt.toViewMode();
        });
      }
    },
    selectClient: function selectClient() {
      __WEBPACK_IMPORTED_MODULE_13__client_index_js__["a" /* default */].selectRef(this, this.addMonitoring, function () {}, null, null, null);
    },
    renderCompanyFlags: function renderCompanyFlags(item) {
      return this.renderFlags(item.ref.flags);
    },
    scrollToActive: function scrollToActive() {
      var _this7 = this;

      this.$nextTick(function () {
        _this7.$refs.cardScroll.scrollToListActive();
      });
    },
    setActivated: function setActivated() {
      if (this.$router && this.$router.options && this.$router.options.from) {
        var from = this.$router.options.from;
        if (from.params && from.params.clientInn) {
          var itemId = from.params.clientInn;
          var item = this.items.find(function (i) {
            return '' + i.ref.ogrn === itemId;
          });
          if (item) {
            this.cxt.activate(this.getItemKey(item));
          } else {
            this.$store.commit('setInfoStatus', 'Позиционировать не удалось, возможно выборка была изменена. ');
          }
        }
      }
    }
  }
});

/***/ }),
/* 1147 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }]
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.getItemSet.isProcessing(),
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      attrs: {
        "value": _vm.cxt.activated(_vm.getItemKey(item)),
        "active-class": "v-dealger-favorite-active v-list__tile--highlighted"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          _vm.cxt.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item.ref))
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                 " + _vm._s(_vm.renderHeads(item.ref)) + "\n                 "), _c('br'), _vm._v("\n                 ИНН: "), _c('span', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderInnOrInnflHtml(item.ref.inn))
      }
    }), _vm._v(" "), _c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(_vm.formats.blank(item.ref.address)))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.ref.clientId),
        expression: "item.ref.clientId"
      }]
    }, [_vm._v("person")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!item.ref.clientId),
        expression: "!item.ref.clientId"
      }]
    }), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(_vm.getItemKey(item))),
        expression: "cxt.check(getItemKey(item))"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(_vm.getItemKey(item))),
        expression: "cxt.uncheck(getItemKey(item))"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('div', [_c(_vm.renderCompanyFlags(item), {
      tag: "component"
    })], 1), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('v-list-tile-action-text', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.ref.releaseDate, _vm.formats.formatDate)))])]), _vm._v("\n                 Изменено\n               ")], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1148 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Мониторинг изменений информации о контрагентах в ЕГРЮЛ.")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Для мониторинга изменений, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и мониторьте изменения в ЕГРЮЛ.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && !_vm.getClientMonitoring) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("\n        Мониторинг контрагентов в ЕГРЮЛ.\n      ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Отслеживание изменений информации о контрагентах полезно для минимизации рисков при заключении договоров.\n        Для активации этой функциональности нажмите кнопку \"Включить\". После активации все \"Мои контрагенты\" будут поставлены на мониторинг и Вы будете получать рассылку об изменениях на почту компании.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "disabled": !_vm.getIsAllow({
        MONITORING_SWITCH: null
      })
    },
    on: {
      "click": _vm.switchMonitoringOn
    }
  }, [_vm._v("Включить")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getClientMonitoring) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-monitoring-set')], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1149 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1150),
  /* template */
  __webpack_require__(1170),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1150 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssistSet_vue__ = __webpack_require__(1151);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__AssistSet_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__AssistSet_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssistPage_vue__ = __webpack_require__(1154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssistPage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AssistPage_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assist-panel',
  components: { vAssistSet: __WEBPACK_IMPORTED_MODULE_2__AssistSet_vue___default.a, vAssistPage: __WEBPACK_IMPORTED_MODULE_3__AssistPage_vue___default.a },
  props: {},
  data: function data() {
    return {
      tagIds: []
    };
  },
  created: function created() {},
  mounted: function mounted() {},

  watch: {
    // в случае изменения маршрута запрашиваем данные вновь
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient'
  })),
  methods: {}
});

/***/ }),
/* 1151 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1152),
  /* template */
  __webpack_require__(1153),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__index_js__ = __webpack_require__(476);






//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










var RemoveAssistAction = function (_classes$Action) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(RemoveAssistAction, _classes$Action);

  function RemoveAssistAction(context) {
    var _this;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, RemoveAssistAction);

    return _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (RemoveAssistAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(RemoveAssistAction)).call(this, context, 'Удалить дела', null, function () {
      _this.context.deleteAssists(_this.context.cxt.selectedIds);
    }));
  }

  return RemoveAssistAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

var CopyAssistAction = function (_classes$Action2) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(CopyAssistAction, _classes$Action2);

  function CopyAssistAction(context) {
    var _this2;

    __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, CopyAssistAction);

    return _this2 = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (CopyAssistAction.__proto__ || __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_get_prototype_of___default()(CopyAssistAction)).call(this, context, 'Создать по образцу', null, function () {
      _this2.context.copyAssists(_this2.context.cxt.selectedIds);
    }));
  }

  return CopyAssistAction;
}(__WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action);

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assist-set',
  components: { vOpsBtn: __WEBPACK_IMPORTED_MODULE_11__common_OpsBtn___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_12__common_CardScroll___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_9__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      cxt: null,
      order: 'BY_UPDATED'
    };
  },
  created: function created() {
    var _this3 = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this3.filteredItems.map(function (item) {
        return _this3.getItemKey(item);
      });
    });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterEndAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Упорядочить по дате создания', function () {
      return _this3.order !== 'BY_CREATED';
    }, function () {
      _this3.order = 'BY_CREATED';
      _this3.onChangeSort();
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Упорядочить по дате изменения', function () {
      return _this3.order !== 'BY_UPDATED';
    }, function () {
      _this3.order = 'BY_UPDATED';
      _this3.onChangeSort();
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Упорядочить по названию', function () {
      return _this3.order !== 'BY_NAME';
    }, function () {
      _this3.order = 'BY_NAME';
      _this3.onChangeSort();
    }));
    // cxt.actions.push(new classes.ActiveScopeAction(cxt))
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].AllScopeAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Новый пакет', null, function () {
      return __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].open('PACKAGE');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Новый документ', null, function () {
      return __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].open('DEED');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Новая подшивка', null, function () {
      return __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].open('BINDER');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Новая рассылка', null, function () {
      return __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].open('POST');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Новая претензия', null, function () {
      return __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].open('CLAIM');
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].Action(this, 'Проверить контрагента', null, function () {
      return __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].open('CONTRACTOR_CHECK');
    }));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].FilterEndAction(cxt));
    cxt.selectActions.push(new CopyAssistAction(this));
    cxt.selectActions.push(new RemoveAssistAction(this));

    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectAllAction(cxt));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_8__api_classes__["a" /* default */].SelectEndAction(cxt));

    cxt.title = 'Делопроизводство';
    cxt.titleIcon = 'school';
    cxt.selectTitle = 'Выбор дела';
    cxt.filterMode = true;

    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.fetchData(true);
    this.setActivated();
  },

  props: {},
  watch: {
    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      this.fetchData();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    getItemSet: 'getAssistMatterSet',
    getAssistMatters: 'getAssistMatters',
    getProfileHaveClient: 'getProfileHaveClient',
    getRefToUrl: 'getRefToUrl'
  }), {
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : '';
      } else {
        return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : '';
      }
    },
    items: function items() {
      return this.getItemSet.getItems();
    },
    orderedItems: function orderedItems() {
      return this.items;
    },
    filteredItems: function filteredItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.name, item.notes, item.accountNameShort);
      };

      if (!this.cxt.isFilterMode() || this.cxt.filterString === null) {
        return this.orderedItems;
      }
      var terms = __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString);
      if (terms.length < 1) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        var searchStr = getSearchString(item).toLowerCase();
        return terms.every(function (t) {
          return searchStr.includes(t);
        });
      });
    }
  }),
  methods: {
    changeFilterContext: function changeFilterContext(ops, force) {
      this.$store.commit('setAssistMatterFilterContext', __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), ops));
      var self = this;
      setTimeout(function () {
        self.$store.dispatch('fetchAssistMatters', force);
        self.scrollToActive();
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
      if (this.getProfileHaveClient) {
        var search = __WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].stringifySearchTerms(__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString));
        if (__WEBPACK_IMPORTED_MODULE_7__api_formats__["a" /* default */].compareString(search, this.getItemSet.getFilter().search) !== 0) {
          this.changeFilterContext({ search: search }, true);
        }
      }
    },
    getSortString: function getSortString() {
      switch (this.order) {
        case 'BY_NAME':
          return 'name,asc';
        case 'BY_UPDATED':
          return 'changed,desc';
        case 'BY_CREATED':
          return 'created,desc';
        default:
          return 'changed,desc';
      }
    },
    onChangeSort: function onChangeSort(v) {
      this.$store.commit('setAssistMatterSort', this.getSortString());
      this.changeFilterContext(null, true);
    },
    fetchData: function fetchData(force) {
      if (this.getProfileHaveClient) {
        this.$store.commit('setAssistMatterSort', this.getSortString());
        this.changeFilterContext({ tagIds: this.tagIds, search: this.cxt.filterString, isShowOther: false }, force);
      }
    },
    nextPage: function nextPage() {
      this.$store.commit('nextAssistMatters');
      this.$store.dispatch('fetchAssistMatters');
    },
    scrollToActive: function scrollToActive() {
      var _this4 = this;

      this.$nextTick(function () {
        _this4.$refs.cardScroll.scrollToListActive();
      });
    },
    setActivated: function setActivated() {
      var _this5 = this;

      if (this.$router && this.$router.options && this.$router.options.from) {
        var from = this.$router.options.from;
        if (from.params && from.params.matterId) {
          var itemId = from.params.matterId;
          if (itemId === 'deed') {
            this.cxt.activate(null);
            return;
          }
          var item = this.items.find(function (i) {
            return _this5.getItemKey(i) === itemId;
          });
          if (item) {
            this.cxt.activate(this.getItemKey(item));
          } else {
            this.$store.commit('setInfoStatus', 'Позиционировать не удалось, возможно выборка была изменена. ');
          }
        }
      }
    },
    formatTypeCode: function formatTypeCode(typeCode) {
      switch (typeCode) {
        case 'CLAIM':
          return 'Претензия';
        case 'DEED':
          return 'Документ';
        default:
          return typeCode;
      }
    },
    formatState: function formatState(state) {
      if (/NEW/i.test(state)) {
        return 'Новое';
      }
      if (/CLOSED/i.test(state)) {
        return 'Завершено';
      }
      return state;
    },
    renderReference: function renderReference(item, target) {
      return ''.concat('<b><a :href=" ' + this.getItemRef(item) + '">' + item.name + '</a></b>');
    },
    getItemKey: function getItemKey(item) {
      return item ? item.id : null;
    },
    getItemRef: function getItemRef(item) {
      return __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].getItemRef(item.id);
    },
    openItem: function openItem(item) {
      __WEBPACK_IMPORTED_MODULE_13__index_js__["a" /* default */].open(item.id);
    },
    deleteAssists: function deleteAssists(selectedIds) {
      if (Array.isArray(selectedIds)) {
        __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0423\u0434\u0430\u043B\u0438\u0442\u044C ' + selectedIds.length + ' \u0434\u0435\u043B\u0430?', function (self) {
          self.$store.dispatch('deleteAssistMatters', { ids: selectedIds });
          self.cxt && self.cxt.toViewMode();
        });
      }
    },
    copyAssists: function copyAssists(selectedIds) {
      if (Array.isArray(selectedIds)) {
        __WEBPACK_IMPORTED_MODULE_10__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0421\u043E\u0437\u0434\u0430\u0442\u044C ' + selectedIds.length + ' \u043D\u043E\u0432\u044B\u0445 \u0434\u0435\u043B\u0430 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0435 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u0445?', function (self) {
          self.$store.dispatch('copyAssistMatters', { ids: selectedIds });
          self.cxt && self.cxt.toViewMode();
        });
      }
    }
  }
});

/***/ }),
/* 1153 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "justify-end": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm6": "",
      "xs8": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1)], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }]
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.openDeed(null)
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.getItemSet.isProcessing(),
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": "",
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [_c('v-list-tile', {
      key: _vm.getItemKey(item),
      attrs: {
        "value": _vm.cxt.activated(_vm.getItemKey(item)),
        "active-class": "v-dealger-favorite-active v-list__tile--highlighted"
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          !_vm.cxt.isSelectMode() ? _vm.openItem(item) : _vm.cxt.select(_vm.getItemKey(item))
        }
      }
    }, [_c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "innerHTML": _vm._s(_vm.renderReference(item))
      }
    }), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v("\n                 " + _vm._s(_vm.formats.blank(item.notes)) + "\n               ")])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-list-tile-action-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.cxt.isSelectMode()),
        expression: "!cxt.isSelectMode()"
      }]
    }, [_vm._v(" " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.isSelectMode()),
        expression: "cxt.isSelectMode()"
      }]
    }, [_c('v-list-tile-action-text', [_vm._v("  " + _vm._s(_vm.formatState(item.state)) + " ")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.id)),
        expression: "cxt.check(item.id)"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.id)),
        expression: "cxt.uncheck(item.id)"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(" " + _vm._s(item.accountNameShort))]), _vm._v(" "), _c('v-tooltip', {
      attrs: {
        "bottom": "",
        "open-delay": "500",
        "max-width": "20em"
      }
    }, [_c('v-list-tile-action-text', {
      attrs: {
        "slot": "activator"
      },
      slot: "activator"
    }, [_c('b', [_vm._v(_vm._s(_vm.formats.blank(item.changed, _vm.formats.formatDate)))])]), _vm._v("\n                   Изменено: " + _vm._s(_vm.formats.blank(item.changed, _vm.formats.formatDateTime)) + "\n                   Создано: " + _vm._s(_vm.formats.blank(item.created, _vm.formats.formatDateTime)) + "\n              ")], 1)], 1)], 1)]
  })], 2)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1154 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1155),
  /* template */
  __webpack_require__(1169),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1155 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__index_js__ = __webpack_require__(476);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssistClaim_vue__ = __webpack_require__(1156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__AssistClaim_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__AssistClaim_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AssistDeed_vue__ = __webpack_require__(1159);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__AssistDeed_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__AssistDeed_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AssistPackage_vue__ = __webpack_require__(1166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__AssistPackage_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__AssistPackage_vue__);

//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assist-page',
  components: { vAssistClaim: __WEBPACK_IMPORTED_MODULE_3__AssistClaim_vue___default.a, vAssistDeed: __WEBPACK_IMPORTED_MODULE_4__AssistDeed_vue___default.a, vAssistPackage: __WEBPACK_IMPORTED_MODULE_5__AssistPackage_vue___default.a },
  data: function data() {
    return {
      id: null,
      typeCode: null
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    mode: {
      type: String,
      default: 'page'
    }
  },
  created: function created() {},
  mounted: function mounted() {
    if (this.itemId) {
      this.fetchData(this.itemId);
    }
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      if (newVal) {
        this.fetchData(newVal);
      } else {}
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({})),
  methods: {
    fetchData: function fetchData(itemId) {
      var _this = this;

      if (itemId) {
        if (__WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */].getTypeCode(itemId)) {
          this.typeCode = __WEBPACK_IMPORTED_MODULE_2__index_js__["a" /* default */].getTypeCode(itemId);
          this.id = null;
        } else {
          this.$store.dispatch('getAssistMatter', itemId).then(function (item) {
            _this.typeCode = item.typeCode;
            _this.id = itemId;
          }, function () {});
        }
      }
    }
  }
});

/***/ }),
/* 1156 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1157),
  /* template */
  __webpack_require__(1158),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1157 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_server_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__client__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepGenerator_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__StepGenerator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__StepGenerator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__ClaimSteps_js__ = __webpack_require__(319);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__common_CardScroll__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assist-claim',
  components: { vStepGenerator: __WEBPACK_IMPORTED_MODULE_6__StepGenerator_vue___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_8__common_CardScroll___default.a },
  data: function data() {
    return {
      currentStep: 1,
      edit: false,
      valid: false,
      item: {},
      steps: [],
      mode: 'page'
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    // const rule = v => !!v || 'хаха'
    this.steps = __WEBPACK_IMPORTED_MODULE_7__ClaimSteps_js__["a" /* default */].createSteps(this);
    this.fetchData(this.itemId);
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.fetchData(newVal);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_4_vuex__["mapGetters"])({
    profile: 'getProfile',
    calcDialogOfs: 'calcDialogOfs',
    calcOfs: 'calcOfs',
    getNewAssistMatter: 'getNewAssistMatter',
    getDepoUrl: 'getDepoUrl'
  }), {
    title: function title() {
      return 'Претензия';
    }
  }),
  methods: {
    calcOffset: function calcOffset(off, offModal) {
      return this.calcOfs(off, offModal);
    },
    next: function next(step) {
      var _this = this;

      // var self = this
      this.currentStep = step.number + 1;
      this.item.model.currentStep = this.currentStep;
      this.$store.dispatch('updateAssistMatter', this.item).then(function () {
        _this.fetchData(_this.item.id);
      }, function () {});
    },
    back: function back(step) {
      this.currentStep = step.number - 1;
    },
    complete: function complete(step) {
      return this.currentStep > step.number;
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    print: function print(format) {
      var url = __WEBPACK_IMPORTED_MODULE_2__api_server_js__["a" /* default */].getBaseUrl() + '/openapi/assist/matters/' + this.item.id + '/reports_redirect?format=' + format;
      this.$store.dispatch('openLocation', url);
    },
    getItemNew: function getItemNew() {
      var defOps = {
        'agreement_topic_title1': 'В соответствии с п.1.1, 1.2 Договора от 03.03.2016 № М-448',
        'agreement_topic_content1': 'ООО "ПОСТАВЩИК" (Поставщик) приняло на себя обязательства в течение срока действия данного договора поставлять по заказу ООО "ДОЛЖНИК" (Покупателя) алкогольную продукцию российского и/или иностранного производства (Товар) в количестве, ассортименте и по цене, согласованным в Заявках Покупателя, а Покупатель принял на себя обязательства принимать и оплачивать Товар в соответствии с условиями этого Договора.',
        'agreement_topic_title2': 'Согласно п. 2.1 Договора от 14.12.2015 № М-429 (далее – Договор поставки)',
        'agreement_topic_content2': 'Поставщиком осуществляется доставка Товара по указанному в лицензии складу/магазину Покупателя.',
        'agreement_topic_title3': 'В соответствии с п. 2.2 Договора',
        'agreement_topic_content3': 'отпуск товара Покупателю оформляется товарно-транспортной накладной, один экземпляр которой остается у Поставщика, а другой - у Покупателя.',
        'agreement_topic_title4': 'В силу п. 2.4 Договора',
        'agreement_topic_content4': 'обязанности Поставщика по поставке Товара считаются исполненными с момента приёмки Товара Покупателем, что подтверждается подписанием Покупателем товарной накладной.',
        'agreement_topic_title5': 'Согласно п. 2.5 Договора',
        'agreement_topic_content5': 'право собственности на товар, риски утраты, недостачи или повреждения товара от Поставщика к Покупателю с момента приёмки Товара и подписания уполномоченными представителями Сторон накладной.'
      };
      var item = this.getNewAssistMatter();
      __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()(item.model, defOps);
      this.steps.forEach(function (step) {
        return step.setModel(item.model);
      });
      return item;
    },
    fetchData: function fetchData(itemId) {
      var _this2 = this;

      if (itemId) {
        this.$store.dispatch('getAssistMatter', itemId).then(function (item) {
          _this2.item = item;
          _this2.currentStep = _this2.item.model.currentStep;
          _this2.steps.forEach(function (step) {
            return step.setModel(_this2.item.model);
          });
        }, function () {});
      } else {
        console.log('fetchData', 'itemId == null');
        this.item = this.getItemNew();
      }
    },
    selectCompany: function selectCompany(fieldName) {
      var _this3 = this;

      var setItem = function setItem(values) {
        if (Array.isArray(values) && values.length > 0) {
          if (!values[0].ref || values[0].namespace === 'nza' || values[0].namespace === 'ogrnip') {
            __WEBPACK_IMPORTED_MODULE_3__common_dialogs__["a" /* default */].message(_this3, 'Совет', '\u0422\u0438\u043F \u043A\u043E\u043D\u0442\u0440\u0430\u0433\u0435\u043D\u0442\u0430 [' + values[0].namespace + '] \u043D\u0435 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F ');
          } else {
            _this3.item.company = values[0];
            _this3.item.refCode = _this3.item.company.ref;
            _this3.item.model.companyInn = _this3.item.company.inn;
          }
        }
      };
      var getQuery = function getQuery() {};
      __WEBPACK_IMPORTED_MODULE_5__client__["a" /* default */].selectRef(this, setItem, getQuery, true, true);
    }
  }
});

/***/ }),
/* 1158 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(52)
    }
  }, [_c('v-stepper', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.currentStep),
      callback: function($$v) {
        _vm.currentStep = $$v
      },
      expression: "currentStep"
    }
  }, [_vm._l((_vm.steps), function(step) {
    return [_c('v-stepper-step', {
      attrs: {
        "complete": _vm.complete(step),
        "step": step.number,
        "editable": ""
      }
    }, [_vm._v("\n            " + _vm._s(step.title) + "\n            "), (step.subTitle) ? _c('small', [_vm._v(_vm._s(typeof step.subTitle === "function" ? step.subTitle(step) : ''))]) : _vm._e()]), _vm._v(" "), _c('v-stepper-content', {
      attrs: {
        "step": step.number
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', [_c(step.class || 'v-step-generator', _vm._b({
      tag: "component",
      model: {
        value: (step.model),
        callback: function($$v) {
          _vm.$set(step, "model", $$v)
        },
        expression: "step.model"
      }
    }, 'component', step.props, false))], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.next(step)
        }
      }
    }, [_vm._v("Дальше")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.back(step)
        }
      }
    }, [_vm._v(_vm._s(step.number > 1 ? 'Назад' : 'Отмена'))])], 1)], 1)], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.print('docx')
      }
    }
  }, [_vm._v("Составить")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1159 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1160),
  /* template */
  __webpack_require__(1165),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1160 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_server_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__client__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DeedSelector__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DeedSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DeedSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepGenerator_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepGenerator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__StepGenerator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AssistForm__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AssistForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AssistForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_ItemsField__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_ItemsField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__common_ItemsField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__profile_index_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__common_CardScroll__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import DeedSteps from './DeedSteps.js'







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assist-deed',
  components: { vStepGenerator: __WEBPACK_IMPORTED_MODULE_11__StepGenerator_vue___default.a, vItemsField: __WEBPACK_IMPORTED_MODULE_14__common_ItemsField___default.a, vPanelTitle: __WEBPACK_IMPORTED_MODULE_16__info_PanelTitle___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_17__common_CardScroll___default.a },
  data: function data() {
    return {
      currentStep: 0,
      edit: false,
      valid: false,
      isProcessing: false,
      isAllActions: false,
      item: {},
      actions: [],
      strategy: {},
      mode: 'page'
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    typeCode: {
      type: String,
      default: 'DEED'
    }
  },
  created: function created() {
    this.strategy = this.getAssistMatterStrategy(this.typeCode, this);
    this.fetchData(this.itemId);
    this.$store.dispatch('fetchRights', { SEND_MAIL: null });
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.fetchData(newVal);
      this.$store.dispatch('fetchRights', { SEND_MAIL: null });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["mapGetters"])({
    profile: 'getProfile',
    calcDialogOfs: 'calcDialogOfs',
    calcOfs: 'calcOfs',
    getIsAllow: 'getIsAllow',
    getAssistMatterTypes: 'getAssistMatterTypes',
    getAssistMatterStrategy: 'getAssistMatterStrategy',
    getNewAssistMatter: 'getNewAssistMatter',
    getAssistDeedsByPath: 'getAssistDeedsByPath',
    getDepoCurrentPath: 'getDepoCurrentPath',
    getClientUrl: 'getClientUrl',
    getDepoUrl: 'getDepoUrl'
  }), {
    title: function title() {
      return this.item && this.item.name ? this.item.name : !this.itemId && this.typeCode ? this.getAssistMatterTypes().get(this.typeCode) : '';
    }
  }),
  methods: {
    getMatterId: function getMatterId() {
      return this.item && this.item.id || this.itemId || null;
    },
    getScheduledActions: function getScheduledActions() {
      var fstrategy = __WEBPACK_IMPORTED_MODULE_15__profile_index_js__["a" /* default */].createStrategy(this, 'ACTION');
      if (!fstrategy) {
        return;
      }
      var actions = this.isAllActions ? this.actions : this.actions.filter(function (al) {
        return al.scheduled && !al.finished || al.finished && al.resultCode === 'PROCESS';
      });
      return actions.map(function (al) {
        var model = fstrategy.createModelFromData(al);
        var icon = al.started && al.resultCode || al.scheduled && 'SCHEDULE';
        return {
          title: fstrategy.viewTitle(model),
          date: al.finished || al.scheduled || al.started,
          text: fstrategy.viewContentListComp(model),
          icons: [icon],
          time: al.finished || al.scheduled || al.started,
          id: al.id
        };
      }).sort(function (b, a) {
        return a.time - b.time;
      });
    },
    onActionClick: function onActionClick(item) {
      __WEBPACK_IMPORTED_MODULE_15__profile_index_js__["a" /* default */].openLogAction(item.id, this.getMatterId());
    },

    // Format methods
    calcOffset: function calcOffset(off, offModal) {
      return this.calcOfs(off, offModal);
    },

    // Controller Methods
    next: function next(step) {
      this.strategy.next(this.item.model, step);
    },
    back: function back(step) {
      this.strategy.back(this.item.model, step);
    },
    complete: function complete(step) {
      return this.strategy.complete(this.item.model, step);
    },
    editable: function editable(step) {
      return this.strategy.editable(this.item.model, step);
    },
    previewable: function previewable() {
      return !this.strategy.previewable || this.strategy.previewable(this.item.model);
    },

    // Model methods
    updateModel: function updateModel(model) {
      console.log('updateModel', model);
      this.item.model = model;
      this.strategy.updateModel(model);
      this.currentStep = model.getCurrentStep();
      this.$forceUpdate();
    },
    getItemNew: function getItemNew() {
      var item = this.getNewAssistMatter({ typeCode: this.strategy.getTypeCode(), model: this.strategy.createModel() });
      return item;
    },
    fetchData: function fetchData(itemId) {
      var _this = this;

      if (itemId) {
        this.$store.dispatch('getAssistScheme', itemId).then(function (scheme) {
          _this.strategy.updateSteps(scheme);
          _this.$store.dispatch('getAssistMatter', itemId).then(function (item) {
            _this.item = item;
            var model = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this.strategy.createModel(), _this.item.model);
            _this.updateModel(model);
          }, function () {});
        }, function () {});
        this.$store.dispatch('getAssistMatterActions', itemId).then(function (actions) {
          _this.actions = actions;
        });
      } else {
        this.strategy.updateSteps(null);
        this.item = this.getItemNew();
        this.updateModel(this.item.model);
      }
    },
    updateData: function updateData(model, cb) {
      var _this2 = this;

      this.item.model = model;
      this.$store.dispatch('updateAssistMatter', this.item).then(function () {
        _this2.fetchData(_this2.item.id);
        if (cb) {
          cb();
        }
      }, function () {});
    },
    refreshData: function refreshData() {
      if (this.itemId) {
        this.fetchData(this.itemId);
      } else {
        if (this.item) {
          this.fetchData(this.item.id);
        }
      }
    },

    // Action methods
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    preview: function preview(format, color) {
      var _this3 = this;

      var cb = function cb() {
        return _this3.print(/xml|rtf|docx/.test(format) ? format : null, null, color);
      };
      this.updateData(this.item.model, cb);
    },
    print: function print(format, data, color) {
      var formatStr = format ? '&format=' + format : '';
      var colorStr = color ? '&color=1' : '';
      var dataStr = data ? '&data=' + data : '';
      var url = __WEBPACK_IMPORTED_MODULE_6__api_server_js__["a" /* default */].getBaseUrl() + '/openapi/assist/matters/' + this.item.id + '/reports_redirect?' + formatStr + colorStr + dataStr;
      this.$store.dispatch('openLocation', url);
    },
    macro: function macro(_macro) {
      var request = { id: this.item.id, macro: _macro };
      return this.$store.dispatch('macroAssistMatter', request);
    },
    send: function send(mailbox, scheduled) {
      var request = { id: this.item.id, mailbox: mailbox, scheduled: scheduled };
      return this.$store.dispatch('sendAssistMatter', request);
    },
    calcMailbox: function calcMailbox(name) {
      var _this4 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this4.$store.dispatch('getClientMailboxes').then(function (mbs) {
          if (name) {
            name = name.toLowerCase();
            resolve(mbs.reduce(function (accumulator, curValue) {
              return curValue.name && __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].compareString(name, curValue.name) === 0 ? curValue.name : accumulator;
            }, ''));
          } else {
            resolve(mbs.length > 0 && mbs[0].name || null);
          }
        });
      });
    },
    openDepo: function openDepo(depoId) {
      var _this5 = this;

      this.$store.dispatch('getDepoFileVersions', depoId).then(function (fs) {
        return fs[0];
      }).then(function (fileItem) {
        return fileItem && fileItem.uid ? _this5.getDepoUrl(fileItem.uid) + '/stream' : null;
      }).then(function (url) {
        return url ? _this5.$store.dispatch('openLocation', url) : null;
      });
    },
    saveAsNew: function saveAsNew(model) {
      var _this6 = this;

      var item = this.getItemNew();
      item.model = model;
      this.$store.dispatch('updateAssistMatter', item).then(function () {
        _this6.fetchData(item.id);
      }, function () {});
    },
    delete: function _delete() {
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u0435\u043B\u043E?', function (self) {
        self.$store.dispatch('deleteAssistMatters', { ids: [self.item.id] });
        self.cancel();
      });
    },
    selectCompany: function selectCompany(fieldName, onChange) {
      var _this7 = this;

      var setItem = function setItem(values) {
        console.log('setItem', values);
        if (Array.isArray(values) && values.length > 0) {
          var model = _this7.item.model;
          if (model[fieldName] !== values[0].ref) {
            if (onChange) {
              onChange(model, fieldName, values[0].ref);
            }
            model[fieldName + '_CODE'] = values[0].ref;
            model[fieldName] = values[0].inn;
            model[fieldName + 'DESCRIPTION'] = values[0].caption;
            model.setCurrentStep(_this7.currentStep);
            _this7.updateModel(model);
          }
        }
      };
      var getQuery = function getQuery() {
        return _this7.item.model[fieldName] ? _this7.item.model[fieldName].toString() : '';
      };
      __WEBPACK_IMPORTED_MODULE_9__client__["a" /* default */].selectRef(this, setItem, getQuery, true, true);
    },
    setDeed: function setDeed(valueFieldName, textFieldName, value, prefix) {
      var _this8 = this;

      var deedNumber = value.toUpperCase();
      if (/^\d+$/.test(deedNumber)) {
        deedNumber = prefix ? prefix + deedNumber : 'DEED:' + deedNumber;
      }
      var model = this.item.model;
      model.setCurrentStep(this.currentStep);
      this.$store.dispatch('getAssistDeed', deedNumber).then(function (deed) {
        model[valueFieldName] = deed.id;
        model[textFieldName] = deed && deed.name || null;
        _this8.updateModel(model);
      });
    },
    selectDeed: function selectDeed(valueFieldName, textFieldName, bindersOnly) {
      var _this9 = this;

      var setItem = function setItem(value) {
        _this9.setDeed(valueFieldName, textFieldName, value);
      };
      var getQuery = function getQuery() {
        return _this9.item.model[valueFieldName];
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].register('v-deed-selector', __WEBPACK_IMPORTED_MODULE_10__DeedSelector___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-deed-selector v-on:close="$emit(\'close\')"\n        v-on:input="setItem"\n        :bindersOnly="bindersOnly"\n        :fullscreen="fullscreen" radio :query="getQuery()"></v-deed-selector>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            setItem: setItem,
            getQuery: getQuery,
            bindersOnly: bindersOnly
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].modal(comp);
    },
    getDeedFormats: function getDeedFormats() {
      return [{ value: 'docx', text: 'DOCX' }, { value: 'pdf', text: 'PDF' }, { value: 'rtf', text: 'RTF' }, { value: 'xml', text: 'XML' }];
    },
    getDepoFileProps: function getDepoFileProps(uids, cb) {
      if (uids && Array.isArray(uids)) {
        this.$store.dispatch('getDepoFileProps', { uids: uids }).then(function (data) {
          return cb(data);
        }, function () {});
      } else {
        cb([]);
      }
    },
    attachDocs: function attachDocs(fieldName, queryCxt) {
      var _this10 = this;

      var onSelect = function onSelect(values) {
        if (Array.isArray(values)) {
          var model = _this10.item.model;
          var set = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(values);
          __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].splitDepoUids(model[fieldName]).forEach(function (v) {
            set.add(v);
          });
          model[fieldName] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(set).sort(function (a, b) {
            return a - b;
          }).join(', ');
          model.setCurrentStep(_this10.currentStep);
          _this10.updateModel(model);
        }
      };
      __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].selectDoc(this, onSelect, true, queryCxt);
    },
    selectDocs: function selectDocs(fieldName, items, title) {
      var _this11 = this;

      var onSelect = function onSelect(values) {
        if (Array.isArray(values)) {
          var model = _this11.item.model;
          var set = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(values);
          // formats.splitDepoUids(model[fieldName]).forEach(v => {
          //   set.add(v)
          // })
          model[fieldName] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(set).sort(function (a, b) {
            return a - b;
          }).join(', ');
          model.setCurrentStep(_this11.currentStep);
          _this11.updateModel(model);
        }
      };
      var valueStr = this.item.model[fieldName];
      __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].selectDocProp(this, onSelect, items, __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].splitDepoUids(valueStr), title);
    },
    loadDocs: function loadDocs(fieldName, fieldPathName) {
      var _this12 = this;

      var setDocs = function setDocs(values) {
        if (Array.isArray(values) && values.length > 0) {
          var model = _this12.item.model;
          var set = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(values);
          __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].splitDepoUids(model[fieldName]).forEach(function (v) {
            set.add(v);
          });
          model[fieldName] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(set).sort(function (a, b) {
            return a - b;
          }).join(', ');
          model.setCurrentStep(_this12.currentStep);
          _this12.updateModel(model);
        }
      };
      var path = this.item.model[fieldPathName];
      __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].newFile(path, setDocs);
    },
    openDoc: function openDoc(valueFieldName) {
      var _this13 = this;

      var uid = this.item.model[valueFieldName];
      var onNewVersion = function onNewVersion() {
        __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].newFile(_this13.getDepoCurrentPath, null, uid);
      };
      if (uid) {
        if (__WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].isDepoUid(uid)) {
          __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].openFile(uid, this.getDepoCurrentPath, false, onNewVersion);
        }
      }
    },
    depoDoc: function depoDoc(valueFieldName) {
      var _this14 = this;

      var depoAssistMatter = function depoAssistMatter(id, depoPrevUid) {
        _this14.item.model[valueFieldName] = null;
        _this14.item.model[valueFieldName + 'Action'] = 'NONE';
        _this14.$store.dispatch('depoAssistMatter', { id: id, depoPrevUid: __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].isDepoUid(depoPrevUid) ? depoPrevUid : null }).then(function (data) {
          _this14.refreshData();
        }, function () {
          _this14.item.model[valueFieldName + 'Action'] = null;
        });
      };
      var actionLogId = this.item.model[valueFieldName + 'Action'];
      if (actionLogId === 'NONE') {
        return;
      }
      var prevUid = this.item.model[valueFieldName];
      if (actionLogId) {
        __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].confirm(this, 'Подготовка документа еще не завершена.', '\u041D\u0430\u0447\u0430\u0442\u044C \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E?', function () {
          return depoAssistMatter(_this14.item.id, prevUid);
        });
      } else {
        depoAssistMatter(this.item.id, prevUid);
      }
    },
    dialogOpenAssistForm: function dialogOpenAssistForm() {
      var self = this;
      var onInput = function onInput(data) {
        self.fetchData(self.item.id);
      };
      var onDelete = function onDelete(data) {
        self.delete(self.item.id);
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].register('v-assist-form', __WEBPACK_IMPORTED_MODULE_13__AssistForm___default.a);
      var comp = { template: '\n        <v-assist-form v-on:input="onInput" v-on:delete="onDelete" v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-assist-form>\n      ',
        data: function data() {
          return {
            model: { id: self.item.id, name: self.item.name, notes: self.item.notes },
            onInput: onInput,
            onDelete: onDelete,
            fullscreen: self.$vuetify.breakpoint.xsOnly
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1161 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BtnForm__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'deed-selector',
  components: { vCardScroll: __WEBPACK_IMPORTED_MODULE_3__common_CardScroll___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default.a },
  data: function data() {
    return {
      valid: false,
      path: '/',
      itemId: null,
      filterString: null
    };
  },
  mounted: function mounted() {
    this.$store.dispatch('fetchDeeds');
    this.filterString = this.query;
  },

  watch: {},
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    query: {
      type: String,
      default: null
    },
    bindersOnly: {
      type: Boolean,
      default: false
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    calcDialogScroll: 'calcDialogScroll',
    getAssistDeedsByPath: 'getAssistDeedsByPath',
    getAssistDeedFolders: 'getAssistDeedFolders'
  }), {
    title: function title() {
      return this.bindersOnly && 'Выберите тип подшивки' || 'Выберите тип документа';
    },
    items: function items() {
      var result = this.getAssistDeedsByPath(this.path);
      if (!this.bindersOnly) {
        return result;
      }
      var re = new RegExp('BINDER:', 'i');
      return result.filter(function (d) {
        return re.test(d.value);
      });
    },
    orderedItems: function orderedItems() {
      return this.items.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.text, b.text);
      });
    },
    filteredItems: function filteredItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.value, item.text, item.description);
      };

      var filter = this.filterString === null || this.filterString.length < 1 ? null : this.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
    }
  }),
  methods: {
    ok: function ok() {
      this.$emit('input', this.itemId);
      this.cancel();
    },
    cancel: function cancel() {
      this.$emit('close');
      this.itemId = null;
    },
    getDisplayPathByPath: function getDisplayPathByPath(path) {
      if (!path) {
        return null;
      }
      var currPath = '';
      var currDisplayPath = '';
      var paths = path.split('/');
      paths.pop();
      for (var i = 1; i < paths.length; i++) {
        currPath = currPath + '/' + paths[i];
        var folder = this.getAssistDeedFolders.find(function (f) {
          return f.value === currPath;
        });
        if (folder) {
          currDisplayPath = currDisplayPath + ' /' + folder.text;
        }
      }
      return currDisplayPath;
    },
    getDisplayPaths: function getDisplayPaths() {
      var map = this.getAssistDeedFolders;
      var result = [];
      if (!map) {
        return result;
      }
      map.forEach(function (i) {
        // var shift = i.value.replace(/\//g, '').replace(/\d/g, '')
        result.push({ key: i.value, value: i.text });
      });
      return result;
      // return result.sort((a, b) => a.value.localeCompare(b.value))
    },
    styleItem: function styleItem(item) {
      var margin = item && item.key && item.key.replace(/\d/g, '').length - 1 + 'em' || '0em';
      return 'margin-left: ' + margin;
    },
    select: function select(uid) {
      this.itemId = this.itemId !== uid ? uid : null;
    },
    check: function check(uid) {
      return uid === this.itemId;
    }
  }

});

/***/ }),
/* 1162 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.itemId
          },
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Введите запрос",
      "clearable": "",
      "persistent-hint": ""
    },
    model: {
      value: (_vm.filterString),
      callback: function($$v) {
        _vm.filterString = $$v
      },
      expression: "filterString"
    }
  }), _vm._v(" "), _c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Категория",
      "hint": _vm.getDisplayPathByPath(_vm.path),
      "items": _vm.getDisplayPaths(),
      "item-value": "key",
      "item-text": "value",
      "clearable": ""
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function(data) {
        return [_c('span', {
          style: (_vm.styleItem(data.item))
        }, [_vm._v(_vm._s(data.item.value))])]
      }
    }]),
    model: {
      value: (_vm.path),
      callback: function($$v) {
        _vm.path = $$v
      },
      expression: "path"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "flat": "",
      "height": _vm.calcDialogScroll(48 + 168 + 52)
    }
  }, [_c('v-list', {
    attrs: {
      "three-line": true,
      "dense": ""
    }
  }, [_vm._l((this.filteredItems), function(item) {
    return [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: item.value,
      on: {
        "click": function($event) {
          return _vm.select(item.value)
        }
      }
    }, [_c('v-list-tile-content', {
      staticStyle: {
        "justify-content": "start"
      }
    }, [_c('b', [_vm._v(_vm._s(item.text))]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('span', {
      staticStyle: {
        "white-space": "normal"
      }
    }, [_vm._v(" " + _vm._s(item.description))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.check(item.value)),
        expression: "check(item.value)"
      }]
    }, [_vm._v("radio_button_checked")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.check(item.value)),
        expression: "!check(item.value)"
      }]
    }, [_vm._v("radio_button_unchecked")])], 1)], 1)]
  })], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1163 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



// import dialogs from '../common/dialogs'

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assist-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_3__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: true,
      valid: false,
      item: {}
    };
  },
  props: {
    fullscreen: {
      type: Boolean,
      default: false
    },
    model: {
      type: Object,
      default: null
    }
  },
  created: function created() {
    if (!this.model) {
      this.item = this.getItemNew();
    } else {
      this.item.id = this.model.id;
      this.item.nameShort = this.model.name;
      this.item.notes = this.model.notes;
    }
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    calcDialogScroll: 'calcDialogScroll'
  }), {
    isEdit: function isEdit() {
      return this.edit || this.isNew;
    },
    isNew: function isNew() {
      return false;
    },
    title: function title() {
      return this.isNew ? '\u0414\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u0438\u0435 ' + this.item.nameShort : this.isEdit ? '\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u044B ' + this.item.nameShort : '\u0410\u0442\u0440\u0438\u0431\u0443\u0442\u044B ' + this.item.nameShort;
    }
  }),
  methods: {
    save: function save() {
      if (this.$refs.form.validate()) {
        this.$store.dispatch('updateAssistMatterName', { id: this.item.id, name: this.item.nameShort, notes: this.item.notes });
        this.edit = false;
        this.$emit('input', this.item);
        this.cancel();
      }
    },
    remove: function remove() {
      this.$emit('delete');
      this.cancel();
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        nameShort: null,
        notes: ''
      };
    }
  }
});

/***/ }),
/* 1164 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "listable": ""
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]), _vm._v(" "), _c('v-btn', {
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [(!_vm.isEdit) ? [_c('v-card-text')] : _vm._e(), _vm._v(" "), (_vm.isEdit) ? [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Название",
      "rows": "2",
      "persistent-hint": "",
      "hint": "Измените при необходимости название дела"
    },
    model: {
      value: (_vm.item.nameShort),
      callback: function($$v) {
        _vm.$set(_vm.item, "nameShort", $$v)
      },
      expression: "item.nameShort"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Примечание",
      "rows": "5",
      "persistent-hint": "",
      "hint": "Показывается во 2-3 строчках списка"
    },
    model: {
      value: (_vm.item.notes),
      callback: function($$v) {
        _vm.$set(_vm.item, "notes", $$v)
      },
      expression: "item.notes"
    }
  })], 1)], 1)], 1)], 1)] : _vm._e()], 2)
},staticRenderFns: []}

/***/ }),
/* 1165 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(52)
    }
  }, [(_vm.actions && _vm.actions.length > 0) ? _c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.isAllActions,
      "caption": this.isAllActions ? 'Показать незавершенные' : 'Показать все'
    },
    on: {
      "click": function($event) {
        _vm.isAllActions = !_vm.isAllActions
      }
    }
  }, [_c('v-items-field', {
    attrs: {
      "label": "Журнал",
      "items": _vm.getScheduledActions(),
      "smallIcons": ""
    },
    on: {
      "click": function($event) {
        return _vm.onActionClick($event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.strategy.getSteps().length > 0) ? _c('v-stepper', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.currentStep),
      callback: function($$v) {
        _vm.currentStep = $$v
      },
      expression: "currentStep"
    }
  }, [_vm._l((_vm.strategy.getSteps()), function(step) {
    return [_c('v-stepper-step', {
      attrs: {
        "complete": _vm.complete(step),
        "step": step.number,
        "editable": _vm.editable(step)
      }
    }, [_vm._v("\n            " + _vm._s(step.title) + "\n            "), (step.subTitle) ? _c('small', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(typeof step.subTitle === 'function' ? step.subTitle(step) : '')
      }
    })]) : _vm._e()]), _vm._v(" "), _c('v-stepper-content', {
      attrs: {
        "step": step.number
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c(step.class || 'v-step-generator', _vm._b({
      tag: "component",
      model: {
        value: (step.model),
        callback: function($$v) {
          _vm.$set(step, "model", $$v)
        },
        expression: "step.model"
      }
    }, 'component', step.props, false)), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary",
        "disabled": !step.nextEnabled()
      },
      on: {
        "click": function($event) {
          return _vm.next(step)
        }
      }
    }, [_vm._v(_vm._s(step.nextLabel()))]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "flat": "",
        "disabled": !step.backEnabled()
      },
      on: {
        "click": function($event) {
          return _vm.back(step)
        }
      }
    }, [_vm._v(_vm._s(step.backLabel()))])], 1)], 1)], 1)]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewable()),
      expression: "previewable()"
    }],
    on: {
      "click": function($event) {
        return _vm.preview(null, 'color')
      }
    }
  }, [_vm._v("Просмотр")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.dialogOpenAssistForm()
      }
    }
  }, [_vm._v("Атрибуты")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1166 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1167),
  /* template */
  __webpack_require__(1168),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1167 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__api_server_js__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__client__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DeedSelector__ = __webpack_require__(477);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__DeedSelector___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__DeedSelector__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepGenerator_vue__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__StepGenerator_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__StepGenerator_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AssistForm__ = __webpack_require__(478);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__AssistForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__AssistForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_ItemsField__ = __webpack_require__(154);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__common_ItemsField___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__common_ItemsField__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__profile_index_js__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18__common_CardScroll__);





//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








// import DeedSteps from './DeedSteps.js'








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'assist-package',
  components: { vStepGenerator: __WEBPACK_IMPORTED_MODULE_11__StepGenerator_vue___default.a, vItemsField: __WEBPACK_IMPORTED_MODULE_14__common_ItemsField___default.a, vPanelTitle: __WEBPACK_IMPORTED_MODULE_17__info_PanelTitle___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_18__common_CardScroll___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_15__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      currentStep: 0,
      edit: false,
      valid: false,
      isProcessing: false,
      isAllActions: false,
      item: {},
      actions: [],
      depos: [],
      strategy: {},
      mode: 'page'
    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    },
    typeCode: {
      type: String,
      default: 'DEED'
    }
  },
  created: function created() {
    this.strategy = this.getAssistMatterStrategy(this.typeCode, this);
    this.fetchData(this.itemId);
    this.$store.dispatch('fetchRights', { SEND_MAIL: null });
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.fetchData(newVal);
      this.$store.dispatch('fetchRights', { SEND_MAIL: null });
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_7_vuex__["mapGetters"])({
    profile: 'getProfile',
    calcDialogOfs: 'calcDialogOfs',
    calcOfs: 'calcOfs',
    getIsAllow: 'getIsAllow',
    getAssistMatterTypes: 'getAssistMatterTypes',
    getAssistMatterStrategy: 'getAssistMatterStrategy',
    getNewAssistMatter: 'getNewAssistMatter',
    getAssistDeedsByPath: 'getAssistDeedsByPath',
    getDepoCurrentPath: 'getDepoCurrentPath',
    getClientUrl: 'getClientUrl',
    getDepoUrl: 'getDepoUrl'
  }), {
    title: function title() {
      return this.item && this.item.name ? this.item.name : !this.itemId && this.typeCode ? this.getAssistMatterTypes().get(this.typeCode) : '';
    },
    getChildrenListSteps: function getChildrenListSteps() {
      return this.strategy && this.strategy.childrenStep && [this.strategy.childrenStep] || [];
    }
  }),
  methods: {
    getMatterId: function getMatterId() {
      return this.item && this.item.id || this.itemId || null;
    },
    getScheduledActions: function getScheduledActions() {
      var fstrategy = __WEBPACK_IMPORTED_MODULE_16__profile_index_js__["a" /* default */].createStrategy(this, 'ACTION');
      if (!fstrategy) {
        return;
      }
      var actions = this.isAllActions ? this.actions : this.actions.filter(function (al) {
        return al.scheduled && !al.finished || al.finished && al.resultCode === 'PROCESS';
      });
      return actions.map(function (al) {
        var model = fstrategy.createModelFromData(al);
        var icon = al.started && al.resultCode || al.scheduled && 'SCHEDULE';
        return {
          title: fstrategy.viewTitle(model),
          date: al.finished || al.scheduled || al.started,
          text: fstrategy.viewContentListComp(model),
          icons: [icon],
          time: al.finished || al.scheduled || al.started,
          id: al.id
        };
      }).sort(function (b, a) {
        return a.time - b.time;
      });
    },
    onActionClick: function onActionClick(item) {
      __WEBPACK_IMPORTED_MODULE_16__profile_index_js__["a" /* default */].openLogAction(item.id, this.getMatterId());
    },

    // Format methods
    calcOffset: function calcOffset(off, offModal) {
      return this.calcOfs(off, offModal);
    },

    // Controller Methods
    next: function next(step) {
      this.strategy.next(this.item.model, step);
    },
    back: function back(step) {
      this.strategy.back(this.item.model, step);
    },
    complete: function complete(step) {
      return this.strategy.complete(this.item.model, step);
    },
    editable: function editable(step) {
      return this.strategy.editable(this.item.model, step);
    },
    previewable: function previewable() {
      return !this.strategy.previewable || this.strategy.previewable(this.item.model);
    },

    // Model methods
    updateModel: function updateModel(model) {
      console.log('updateModel', model);
      this.item.model = model;
      this.strategy.updateModel(model);
      this.currentStep = model.getCurrentStep();
      this.$forceUpdate();
    },
    getItemNew: function getItemNew() {
      var item = this.getNewAssistMatter({ typeCode: this.strategy.getTypeCode(), model: this.strategy.createModel() });
      return item;
    },
    fetchData: function fetchData(itemId) {
      var _this = this;

      if (itemId) {
        this.$store.dispatch('getAssistScheme', itemId).then(function (scheme) {
          _this.strategy.updateSteps(scheme);
          _this.$store.dispatch('getAssistMatter', itemId).then(function (item) {
            _this.item = item;
            var model = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()(_this.strategy.createModel(), _this.item.model);
            _this.updateModel(model);
          }, function () {});
        }, function () {});
        this.fetchActions();
      } else {
        this.strategy.updateSteps(null);
        this.item = this.getItemNew();
        this.updateModel(this.item.model);
      }
    },
    fetchActions: function fetchActions() {
      var _this2 = this;

      var itemId = this.itemId || this.item && this.item.id;
      this.$store.dispatch('getAssistMatterActions', itemId).then(function (actions) {
        _this2.actions = actions;
      });
    },
    updateData: function updateData(model, cb) {
      var _this3 = this;

      this.item.model = model;
      this.$store.dispatch('updateAssistMatter', this.item).then(function () {
        _this3.fetchData(_this3.item.id);
        if (cb) {
          cb();
        }
      }, function () {});
    },
    refreshData: function refreshData() {
      if (this.itemId) {
        this.fetchData(this.itemId);
      } else {
        if (this.item) {
          this.fetchData(this.item.id);
        }
      }
    },

    // Action methods
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    preview: function preview(format, color) {
      var _this4 = this;

      var cb = function cb() {
        return _this4.print(/xml|rtf|docx/.test(format) ? format : null, null, color);
      };
      this.updateData(this.item.model, cb);
    },
    print: function print(format, data, color) {
      var formatStr = format ? '&format=' + format : '';
      var colorStr = color ? '&color=1' : '';
      var dataStr = data ? '&data=' + data : '';
      var url = __WEBPACK_IMPORTED_MODULE_6__api_server_js__["a" /* default */].getBaseUrl() + '/openapi/assist/matters/' + this.item.id + '/reports_redirect?' + formatStr + colorStr + dataStr;
      this.$store.dispatch('openLocation', url);
    },
    macro: function macro(_macro) {
      var request = { id: this.item.id, macro: _macro };
      return this.$store.dispatch('macroAssistMatter', request);
    },
    send: function send(macro, mailbox) {
      var request = { id: this.item.id, macro: macro, mailbox: mailbox };
      return this.$store.dispatch('sendAssistMatter', request);
    },
    calcMailbox: function calcMailbox(name) {
      var _this5 = this;

      return new __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a(function (resolve, reject) {
        _this5.$store.dispatch('getClientMailboxes').then(function (mbs) {
          if (name) {
            name = name.toLowerCase();
            resolve(mbs.reduce(function (accumulator, curValue) {
              return curValue.name && __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].compareString(name, curValue.name) === 0 ? curValue.name : accumulator;
            }, ''));
          } else {
            resolve(mbs.length > 0 && mbs[0].name || null);
          }
        });
      });
    },
    openDepo: function openDepo(depoId) {
      var _this6 = this;

      this.$store.dispatch('getDepoFileVersions', depoId).then(function (fs) {
        return fs[0];
      }).then(function (fileItem) {
        return fileItem && fileItem.uid ? _this6.getDepoUrl(fileItem.uid) + '/stream' : null;
      }).then(function (url) {
        return url ? _this6.$store.dispatch('openLocation', url) : null;
      });
    },
    saveAsNew: function saveAsNew(model) {
      var _this7 = this;

      var item = this.getItemNew();
      item.model = model;
      this.$store.dispatch('updateAssistMatter', item).then(function () {
        _this7.fetchData(item.id);
      }, function () {});
    },
    delete: function _delete() {
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', '\u0423\u0434\u0430\u043B\u0438\u0442\u044C \u0434\u0435\u043B\u043E?', function (self) {
        self.$store.dispatch('deleteAssistMatters', { ids: [self.item.id] });
        self.cancel();
      });
    },
    selectCompany: function selectCompany(fieldName, onChange) {
      var _this8 = this;

      var setItem = function setItem(values) {
        console.log('setItem', values);
        if (Array.isArray(values) && values.length > 0) {
          var model = _this8.item.model;
          if (model[fieldName] !== values[0].ref) {
            if (onChange) {
              onChange(model, fieldName, values[0].ref);
            }
            model[fieldName + '_CODE'] = values[0].ref;
            model[fieldName] = values[0].inn;
            model[fieldName + 'DESCRIPTION'] = values[0].caption;
            model.setCurrentStep(_this8.currentStep);
            _this8.updateModel(model);
          }
        }
      };
      var getQuery = function getQuery() {
        return _this8.item.model[fieldName] ? _this8.item.model[fieldName].toString() : '';
      };
      __WEBPACK_IMPORTED_MODULE_9__client__["a" /* default */].selectRef(this, setItem, getQuery, true, true);
    },
    setDeed: function setDeed(valueFieldName, textFieldName, value, prefix) {
      var _this9 = this;

      var deedNumber = value.toUpperCase();
      if (/^\d+$/.test(deedNumber)) {
        deedNumber = prefix ? prefix + deedNumber : 'DEED:' + deedNumber;
      }
      var model = this.item.model;
      model.setCurrentStep(this.currentStep);
      this.$store.dispatch('getAssistDeed', deedNumber).then(function (deed) {
        model[valueFieldName] = deed.id;
        model[textFieldName] = deed && deed.name || null;
        _this9.updateModel(model);
      });
    },
    selectDeed: function selectDeed(valueFieldName, textFieldName, bindersOnly) {
      var _this10 = this;

      var setItem = function setItem(value) {
        _this10.setDeed(valueFieldName, textFieldName, value);
      };
      var getQuery = function getQuery() {
        return _this10.item.model[valueFieldName];
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].register('v-deed-selector', __WEBPACK_IMPORTED_MODULE_10__DeedSelector___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-deed-selector v-on:close="$emit(\'close\')"\n        v-on:input="setItem"\n        :bindersOnly="bindersOnly"\n        :fullscreen="fullscreen" radio :query="getQuery()"></v-deed-selector>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            setItem: setItem,
            getQuery: getQuery,
            bindersOnly: bindersOnly
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].modal(comp);
    },
    getDeedFormats: function getDeedFormats() {
      return [{ value: 'docx', text: 'DOCX' }, { value: 'pdf', text: 'PDF' }, { value: 'rtf', text: 'RTF' }, { value: 'xml', text: 'XML' }];
    },
    getDepoFileProps: function getDepoFileProps(uids, cb) {
      if (uids && Array.isArray(uids)) {
        this.$store.dispatch('getDepoFileProps', { uids: uids }).then(function (data) {
          return cb(data);
        }, function () {});
      } else {
        cb([]);
      }
    },
    attachDocs: function attachDocs(fieldName, queryCxt) {
      var _this11 = this;

      var onSelect = function onSelect(values) {
        if (Array.isArray(values)) {
          var model = _this11.item.model;
          var set = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(values);
          __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].splitDepoUids(model[fieldName]).forEach(function (v) {
            set.add(v);
          });
          model[fieldName] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(set).sort(function (a, b) {
            return a - b;
          }).join(', ');
          model.setCurrentStep(_this11.currentStep);
          _this11.updateModel(model);
        }
      };
      __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].selectDoc(this, onSelect, true, queryCxt);
    },
    selectDocs: function selectDocs(fieldName, items, title) {
      var _this12 = this;

      var onSelect = function onSelect(values) {
        if (Array.isArray(values)) {
          var model = _this12.item.model;
          var set = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(values);
          // formats.splitDepoUids(model[fieldName]).forEach(v => {
          //   set.add(v)
          // })
          model[fieldName] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(set).sort(function (a, b) {
            return a - b;
          }).join(', ');
          model.setCurrentStep(_this12.currentStep);
          _this12.updateModel(model);
        }
      };
      var valueStr = this.item.model[fieldName];
      __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].selectDocProp(this, onSelect, items, __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].splitDepoUids(valueStr), title);
    },
    loadDocs: function loadDocs(fieldName, fieldPathName) {
      var _this13 = this;

      var setDocs = function setDocs(values) {
        if (Array.isArray(values) && values.length > 0) {
          var model = _this13.item.model;
          var set = new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_set___default.a(values);
          __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].splitDepoUids(model[fieldName]).forEach(function (v) {
            set.add(v);
          });
          model[fieldName] = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(set).sort(function (a, b) {
            return a - b;
          }).join(', ');
          model.setCurrentStep(_this13.currentStep);
          _this13.updateModel(model);
        }
      };
      var path = this.item.model[fieldPathName];
      __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].newFile(path, setDocs);
    },
    openDoc: function openDoc(valueFieldName) {
      var _this14 = this;

      var uid = this.item.model[valueFieldName];
      var onNewVersion = function onNewVersion() {
        __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].newFile(_this14.getDepoCurrentPath, null, uid);
      };
      if (uid) {
        if (__WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].isDepoUid(uid)) {
          __WEBPACK_IMPORTED_MODULE_12__depo__["a" /* default */].openFile(uid, this.getDepoCurrentPath, false, onNewVersion);
        }
      }
    },
    depoDoc: function depoDoc(valueFieldName) {
      var _this15 = this;

      var depoAssistMatter = function depoAssistMatter(id, depoPrevUid) {
        _this15.item.model[valueFieldName] = null;
        _this15.item.model[valueFieldName + 'Action'] = 'NONE';
        _this15.$store.dispatch('depoAssistMatter', { id: id, depoPrevUid: __WEBPACK_IMPORTED_MODULE_5__api_formats__["a" /* default */].isDepoUid(depoPrevUid) ? depoPrevUid : null }).then(function (data) {
          _this15.refreshData();
        }, function () {
          _this15.item.model[valueFieldName + 'Action'] = null;
        });
      };
      var actionLogId = this.item.model[valueFieldName + 'Action'];
      if (actionLogId === 'NONE') {
        return;
      }
      var prevUid = this.item.model[valueFieldName];
      if (actionLogId) {
        __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].confirm(this, 'Подготовка документа еще не завершена.', '\u041D\u0430\u0447\u0430\u0442\u044C \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u043D\u043E\u0432\u043E\u0433\u043E?', function () {
          return depoAssistMatter(_this15.item.id, prevUid);
        });
      } else {
        depoAssistMatter(this.item.id, prevUid);
      }
    },
    dialogOpenAssistForm: function dialogOpenAssistForm() {
      var self = this;
      var onInput = function onInput(data) {
        self.fetchData(self.item.id);
      };
      var onDelete = function onDelete(data) {
        self.delete(self.item.id);
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].register('v-assist-form', __WEBPACK_IMPORTED_MODULE_13__AssistForm___default.a);
      var comp = { template: '\n        <v-assist-form v-on:input="onInput" v-on:delete="onDelete" v-on:close="$emit(\'close\')" :fullscreen="fullscreen" :model="model"></v-assist-form>\n      ',
        data: function data() {
          return {
            model: { id: self.item.id, name: self.item.name, notes: self.item.notes },
            onInput: onInput,
            onDelete: onDelete,
            fullscreen: self.$vuetify.breakpoint.xsOnly
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1168 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "card": "",
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.mode === 'page'),
      expression: "mode === 'page'"
    }],
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.title) + "\n      ")]), _vm._v(" "), _c('v-spacer')], 1), _vm._v(" "), _c('v-card-scroll', {
    attrs: {
      "md": "",
      "flat": "",
      "offset": _vm.calcOffset(52)
    }
  }, [_c('v-card', [_vm._l((_vm.getChildrenListSteps), function(step) {
    return [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c(step.class || 'v-step-generator', _vm._b({
      tag: "component",
      model: {
        value: (step.model),
        callback: function($$v) {
          _vm.$set(step, "model", $$v)
        },
        expression: "step.model"
      }
    }, 'component', step.props, false))], 1)]
  })], 2), _vm._v(" "), (_vm.actions && _vm.actions.length > 0) ? _c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.isAllActions,
      "caption": this.isAllActions ? 'Показать незавершенные' : 'Показать все'
    },
    on: {
      "click": function($event) {
        _vm.isAllActions = !_vm.isAllActions
      }
    }
  }, [_c('v-items-field', {
    attrs: {
      "label": "Журнал",
      "items": _vm.getScheduledActions(),
      "smallIcons": ""
    },
    on: {
      "click": function($event) {
        return _vm.onActionClick($event)
      }
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.strategy.getSteps().length > 0) ? _c('v-stepper', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.currentStep),
      callback: function($$v) {
        _vm.currentStep = $$v
      },
      expression: "currentStep"
    }
  }, [_vm._l((_vm.strategy.getSteps()), function(step) {
    return [_c('v-stepper-step', {
      attrs: {
        "complete": _vm.complete(step),
        "step": step.number,
        "editable": _vm.editable(step)
      }
    }, [_vm._v("\n            " + _vm._s(step.title) + "\n            "), (step.subTitle) ? _c('small', [_c('span', {
      domProps: {
        "innerHTML": _vm._s(typeof step.subTitle === 'function' ? step.subTitle(step) : '')
      }
    })]) : _vm._e()]), _vm._v(" "), _c('v-stepper-content', {
      attrs: {
        "step": step.number
      }
    }, [_c('v-card', {
      attrs: {
        "flat": ""
      }
    }, [_c(step.class || 'v-step-generator', _vm._b({
      tag: "component",
      model: {
        value: (step.model),
        callback: function($$v) {
          _vm.$set(step, "model", $$v)
        },
        expression: "step.model"
      }
    }, 'component', step.props, false)), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "primary",
        "disabled": !step.nextEnabled()
      },
      on: {
        "click": function($event) {
          return _vm.next(step)
        }
      }
    }, [_vm._v(_vm._s(step.nextLabel()))]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "flat": "",
        "disabled": !step.backEnabled()
      },
      on: {
        "click": function($event) {
          return _vm.back(step)
        }
      }
    }, [_vm._v(_vm._s(step.backLabel()))])], 1)], 1)], 1)]
  })], 2) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.previewable()),
      expression: "previewable()"
    }],
    on: {
      "click": function($event) {
        return _vm.preview(null, 'color')
      }
    }
  }, [_vm._v("Просмотр")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    on: {
      "click": function($event) {
        return _vm.dialogOpenAssistForm()
      }
    }
  }, [_vm._v("Атрибуты")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1169 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.typeCode === 'CLAIM') ? _c('v-assist-claim', {
    attrs: {
      "itemId": _vm.id,
      "typeCode": _vm.typeCode
    }
  }) : _vm._e(), _vm._v(" "), (['DEED', 'BINDER', 'POST', 'CONTRACTOR_CHECK'].includes(_vm.typeCode)) ? _c('v-assist-deed', {
    attrs: {
      "itemId": _vm.id,
      "typeCode": _vm.typeCode
    }
  }) : _vm._e(), _vm._v(" "), (['PACKAGE'].includes(_vm.typeCode)) ? _c('v-assist-package', {
    attrs: {
      "itemId": _vm.id,
      "typeCode": _vm.typeCode
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1170 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Юридический ассистент служба автоматизации рутиных юридических оппераций.")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Для использования Юридического ассистента, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и направляйте запросы для подготовки Юридических документов: претензий ...\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && !_vm.$route.params.matterId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-assist-set')], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient && _vm.$route.params.matterId) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-assist-page', {
    attrs: {
      "itemId": _vm.$route.params.matterId
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1171 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1172),
  /* template */
  __webpack_require__(1179),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DocFolder_vue__ = __webpack_require__(1173);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__DocFolder_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__DocFolder_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FolderSelector_vue__ = __webpack_require__(1176);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__FolderSelector_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__FolderSelector_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ActionsBtn__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__common_ActionsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__common_ActionsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_ChipsField_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__common_ChipsField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__common_ChipsField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__common_CardScroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14____ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__client__ = __webpack_require__(37);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//















/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doc-list',
  components: { vOpsBtn: __WEBPACK_IMPORTED_MODULE_10__common_OpsBtn___default.a, vActionsBtn: __WEBPACK_IMPORTED_MODULE_11__common_ActionsBtn___default.a, vChipsField: __WEBPACK_IMPORTED_MODULE_12__common_ChipsField_vue___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_13__common_CardScroll___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_5__common_apimix__["a" /* default */]],
  props: {},
  data: function data() {
    return {
      timer: '',
      chipsItems: [],
      cxt: null,
      order: 'BY_UPLOADED'
    };
  },
  beforeDestroy: function beforeDestroy() {
    window.clearInterval(this.timer);
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return item.uid;
      });
    });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].FilterEndAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Упорядочить по дате', function () {
      return _this.order !== 'BY_UPLOADED';
    }, function () {
      _this.order = 'BY_UPLOADED';
      _this.onChangeSort();
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Упорядочить по названию', function () {
      return _this.order !== 'BY_NAME';
    }, function () {
      _this.order = 'BY_NAME';
      _this.onChangeSort();
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Сегодня', function () {
      return _this.getItemSet.getFilter().scope !== _this.getDepoConstant.ACTIVE_SCOPE;
    }, function () {
      return _this.onChangeScope(_this.getDepoConstant.ACTIVE_SCOPE);
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Все', null, function () {
      _this.cxt.showAll();
      _this.onChangeScope(_this.getDepoConstant.ALL_SCOPE);
    }));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].SelectAction(cxt));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Новый документ', null, function () {
      return _this.addFile();
    }));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Новая папка', null, function () {
      return _this.addFolder();
    }));

    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].FilterEndAction(cxt));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Удалить папку', null, function () {
      return _this.deleteFolders(cxt.selectedIds);
    }));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Копировать свойства', null, function () {
      return _this.copyProps(cxt.selectedIds);
    }));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Копировать ссылку', null, function () {
      return _this.copyLinks(cxt.selectedIds);
    }));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Поделиться', null, function () {
      return _this.sendProps(cxt.selectedIds);
    }));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Скачать', null, function () {
      return _this.downloadFiles(cxt.selectedIds);
    }));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Переместить', null, function () {
      return _this.updateFolder(cxt.selectedIds);
    }));
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(this, 'Пометить', null, function () {
      return _this.updateTags(cxt.selectedIds);
    }));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].SelectAllAction(cxt));
    cxt.selectActions.push({ divider: true });
    cxt.selectActions.push(new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].SelectEndAction(cxt));

    cxt.title = 'Депозитарий';
    cxt.titleIcon = 'storage';
    cxt.selectTitle = 'Выбор файлов';
    cxt.filterMode = true;

    this.cxt = cxt;
  },
  mounted: function mounted() {
    this.$store.dispatch('fetchDepoFolders');
    this.fetchData();
  },

  watch: {
    // в случае изменения маршрута запрашиваем данные вновь
    '$route': function $route() {
      this.fetchData();
    },

    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      if (newVal && !oldVal) {
        this.fetchData();
      }
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    profile: 'getProfile',
    depoFolders: 'getDepoFilteredFolders',
    getItemSet: 'getDepoFileSet',
    depoPathFolders: 'getDepoPathFolders',
    getDepoConstant: 'getDepoConstant',
    getProfileHaveClient: 'getProfileHaveClient',
    getDepoPathByFolder: 'getDepoPathByFolder',
    getDepoCurrentPath: 'getDepoCurrentPath',
    renderDepoFileSignMessage: 'renderDepoFileSignMessage',
    getDepoFilesUrl: 'getDepoFilesUrl',
    getDepoUrl: 'getDepoUrl'

  }), {
    title: function title() {
      return;
    },
    items: function items() {
      return this.getItemSet.getItems();
    },
    orderedItems: function orderedItems() {
      return this.items;
    },
    foldedItems: function foldedItems() {
      var path = this.getDepoCurrentPath;
      return this.orderedItems.filter(function (i) {
        return i.path === path;
      });
    },
    tagedItems: function tagedItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.tags);
      };
      var result = this.foldedItems;
      var refs = this.getRefs(this.getTags());
      if (Array.isArray(refs)) {
        refs.forEach(function (tag) {
          var t = tag.toUpperCase();
          result = result.filter(function (item) {
            return getSearchString(item).toUpperCase().includes(t);
          });
        });
      }
      return result;
    },
    filteredItems: function filteredItems() {
      var getSearchString = function getSearchString(item) {
        return ''.concat(item.docName, item.fileName, item.tags, __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDate(item.uploaded));
      };
      // var result = this.orderedItems
      var result = this.tagedItems;

      if (!this.cxt.isFilterMode() || this.cxt.filterString === null) {
        return result;
      }
      var terms = __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString);
      if (terms.length < 1) {
        return result;
      }
      return result.filter(function (item) {
        var searchStr = getSearchString(item).toLowerCase();
        return terms.every(function (t) {
          return searchStr.includes(t);
        });
      });
    },
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.getItemSet.getTotal() > 0 ? label + this.cxt.selectedCount() + ' из ' + this.getItemSet.getTotal() + '' : '';
      } else {
        return this.getItemSet.getTotal() > 0 ? label + this.filteredItems.length + ' из ' + this.getItemSet.getTotal() + '' : '';
      }
    },
    folderActionsCaption: function folderActionsCaption() {
      if (this.folderActions.length > 0) {
        return this.folderActions[0].title;
      }
      return null;
    },
    folderActions: function folderActions() {
      var _this2 = this;

      return this.depoPathFolders.sort(function (a, b) {
        return b.path.length - a.path.length;
      }).map(function (item) {
        return new __WEBPACK_IMPORTED_MODULE_9__api_classes__["a" /* default */].Action(_this2, item.docName, null, function () {
          return _this2.setFolder(item.fileName);
        });
      });
    }
  }),
  methods: {
    changeFilterContext: function changeFilterContext(ops, force) {
      this.$store.commit('setDepoFileSetFilterContext', __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getItemSet.getFilter(), ops));
      var self = this;
      setTimeout(function () {
        self.$store.dispatch('fetchDepoFileSet', force);
        self.scrollToActive();
      }, 500);
    },
    onChangeFilter: function onChangeFilter(e) {
      this.cxt.filterString = e;
      if (this.getProfileHaveClient) {
        var search = __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].stringifySearchTerms(__WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].parseSearchTerms(this.cxt.filterString));
        if (__WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].compareString(search, this.getItemSet.getFilter().search) !== 0) {
          this.changeFilterContext({ search: search }, true);
        }
      }
    },
    getSortString: function getSortString() {
      switch (this.order) {
        case 'BY_NAME':
          return 'docName';
        case 'BY_UPLOADED':
          return 'uploaded,desc';
        default:
          return '';
      }
    },
    onChangeSort: function onChangeSort(v) {
      this.$store.commit('setDepoFileSetSort', this.getSortString());
      this.changeFilterContext(null, true);
    },
    onChangeScope: function onChangeScope(v) {
      this.changeFilterContext({ scope: v }, true);
    },
    fetchData: function fetchData(force) {
      if (this.getProfileHaveClient) {
        this.$store.commit('setDepoFileSetSort', this.getSortString());
        var folderName = this.$route.params.folderName ? this.$route.params.folderName : 'root';
        var path = this.getDepoPathByFolder(folderName);
        this.changeFilterContext({ search: this.cxt.filterString, path: path, tags: this.getTags() }, force);
        this.fillRefChips(this.getRefs(this.getTags()));
      }
    },
    nextPage: function nextPage() {
      this.$store.commit('nextDepoFileSet');
      this.$store.dispatch('fetchDepoFileSet');
    },
    scrollToActive: function scrollToActive() {
      var _this3 = this;

      this.$nextTick(function () {
        _this3.$refs.cardScroll.scrollToListActive();
      });
    },
    newFile: function newFile(id) {
      __WEBPACK_IMPORTED_MODULE_14____["a" /* default */].newFile(this.getDepoCurrentPath, null, id, this.getTags().join(', '));
    },
    openFile: function openFile(id) {
      var _this4 = this;

      var onNewVersion = function onNewVersion() {
        return _this4.newFile(id);
      };
      __WEBPACK_IMPORTED_MODULE_14____["a" /* default */].openFile(id, this.getDepoCurrentPath, false, onNewVersion);
    },
    addFile: function addFile() {
      this.newFile(null);
    },
    deleteFolders: function deleteFolders(ids) {
      var _this5 = this;

      this.depoFolders.filter(function (i) {
        return ids.includes(i.uid);
      }).forEach(function (f) {
        return __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].confirm(_this5, 'Подтвердите', '\u041F\u0430\u043F\u043A\u0430 ' + f.docName + ' \u0431\u0443\u0434\u0435\u0442 \u0443\u0434\u0430\u043B\u0435\u043D\u0430 \u0438 \u0432\u0441\u0435 \u0444\u0430\u0439\u043B\u044B \u043F\u0435\u0440\u0435\u043C\u0435\u0449\u0435\u043D\u044B \u0432 \u0442\u0435\u043A\u0443\u0449\u0443\u044E \u043F\u0430\u043F\u043A\u0443. \u0423\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u0430\u043F\u043A\u0443?', function (self) {
          self.$store.dispatch('deleteDepoFolder', f);
          self.cxt && self.cxt.toViewMode();
        });
      });
    },
    copyProps: function copyProps(ids) {
      var _this6 = this;

      var printProps = function printProps(f) {
        return '\u0414\u043E\u043A\u0443\u043C\u0435\u043D\u0442: ' + f.docName + (f.signed ? '\n\t' + _this6.renderDepoFileSignMessage(f) : '') + '\n\tC\u0441\u044B\u043B\u043A\u0430: ' + _this6.getDepoUrl(f.uid) + ' \n\t\u0414\u0435\u043F\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u043E: ' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDateTime(f.uploaded) + ' (\u043F\u043E: ' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatDate(f.deleted) + ')\n\t\u0414\u0435\u043F\u043E\u043D\u0435\u043D\u0442: ' + f.ownerShortName + ' \u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatInn(f.ownerInn) + '\n';
      };
      var text = this.items.filter(function (i) {
        return ids.includes(i.uid);
      }).map(function (i) {
        return printProps(i);
      }).join('\n');
      this.$store.dispatch('copyToClipboard', { text: text });
      this.cxt && this.cxt.toViewMode();
    },
    sendProps: function sendProps(ids) {
      __WEBPACK_IMPORTED_MODULE_14____["a" /* default */].sendProps(ids);
      this.cxt && this.cxt.toViewMode();
    },
    copyLinks: function copyLinks(ids) {
      var _this7 = this;

      var html = this.items.filter(function (i) {
        return ids.includes(i.uid);
      }).map(function (i) {
        return '<a href="' + _this7.getDepoUrl(i.uid) + '">' + i.docName + '</a>';
      }).join(' ');
      // var text = this.items.filter(i => ids.includes(i.uid)).map(i => {
      //   return `${i.docName}: ${this.getDepoUrl(i.uid)}`
      // }).join('\n')
      this.$store.dispatch('copyToClipboard', { text: html, html: html });
      this.cxt && this.cxt.toViewMode();
    },
    updateFolder: function updateFolder(ids) {
      var _this8 = this;

      var setPath = function setPath(path) {
        if (Array.isArray(ids)) {
          __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].confirm(_this8, 'Подтвердите', 'Переместить файлы?', function (self) {
            self.$store.dispatch('updateDepoFilePaths', { uids: ids, path: path });
            self.cxt && self.cxt.toViewMode();
          });
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].register('v-folder-selector', __WEBPACK_IMPORTED_MODULE_7__FolderSelector_vue___default.a);
      var path = this.getDepoCurrentPath;
      var fullscreen = false;
      var comp = { template: '\n        <v-folder-selector v-on:close="$emit(\'close\')"\n        v-on:input="setItem"\n        :path="path"\n        :fullscreen="fullscreen"></v-folder-selector>\n        ',
        data: function data() {
          return {
            fullscreen: fullscreen,
            setItem: setPath,
            path: path
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].modal(comp);
    },
    openFolder: function openFolder(id) {
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].register('v-doc-folder', __WEBPACK_IMPORTED_MODULE_6__DocFolder_vue___default.a);
      var path = this.getDepoCurrentPath;
      var comp = { template: '\n        <v-doc-folder toolbar :fileItemId="dialogItemId" :newPath="path" v-on:close="$emit(\'close\')"></v-doc-folder>\n        ',
        data: function data() {
          return {
            dialogItemId: id,
            path: path
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].modal(comp);
    },
    addFolder: function addFolder() {
      this.openFolder(null);
    },
    open: function open(item) {
      var url = this.getDepoUrl(item.uid) + '/stream';
      this.$store.dispatch('openLocation', url);
    },
    downloadFiles: function downloadFiles(ids) {
      var link = this.getDepoFilesUrl(ids);
      __WEBPACK_IMPORTED_MODULE_14____["a" /* default */].downloadFile(link);
      this.cxt && this.cxt.toViewMode();
    },
    createPreview: function createPreview(item) {
      return __WEBPACK_IMPORTED_MODULE_14____["a" /* default */].createPreview(item, this);
    },
    onInnChanged: function onInnChanged(refs) {
      var tags = refs.map(function (ref) {
        return '#' + ref;
      });
      this.setTags(tags);
    },
    fillRefChips: function fillRefChips(refs) {
      var _this9 = this;

      var getHint = function getHint(company) {
        return company.name + ' (\u0418\u041D\u041D: ' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatInn(company.inn) + ')';
      };
      var getError = function getError(company) {
        return null;
      };
      var cb = function cb(companies) {
        var set = new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(refs);
        var items = companies.map(function (c) {
          set.delete(c.ref);
          return { value: c.ref, text: c.caption, hint: getHint(c), error: getError(c) };
        });
        set.forEach(function (ref) {
          return items.push({ value: ref + '', text: '#' + ref, hint: 'Чтобы видеть название компании, добавьте компанию в Мои Контрагенты', error: null });
        });
        _this9.chipsItems = items;
      };
      __WEBPACK_IMPORTED_MODULE_15__client__["a" /* default */].getCachedRefs(refs, cb);
    },
    selectInn: function selectInn() {
      var _this10 = this;

      var onSelect = function onSelect(companies) {
        console.log('onSelect', companies);
        if (Array.isArray(companies)) {
          _this10.onInnChanged(companies.map(function (c) {
            return c.ref + '' || '';
          }));
        }
      };
      __WEBPACK_IMPORTED_MODULE_15__client__["a" /* default */].selectRef(this, onSelect, function () {}, true, true);
    },
    removeInn: function removeInn(v) {
      this.onInnChanged([]);
    },
    getRefs: function getRefs(tags) {
      return tags.map(function (tag) {
        return tag.replace('#', '');
      });
    },
    getTags: function getTags() {
      return [].concat(this.$route.query && this.$route.query.tag ? this.$route.query.tag : []);
    },
    setTags: function setTags(tags) {
      this.$router.push({ path: this.$router.path, query: { tag: tags } });
    },
    setFolder: function setFolder(folder) {
      this.$router.push({ path: '/doc_list/' + folder, query: { tag: this.getTags() } });
    },
    updateTags: function updateTags(selectedIds) {
      var _this11 = this;

      var onTagChange = function onTagChange(inns) {
        var innTags = inns.map(function (inn) {
          return '#' + inn;
        });
        __WEBPACK_IMPORTED_MODULE_8__common_dialogs__["a" /* default */].confirm(_this11, 'Подтвердите', '\u041C\u0435\u0442\u043A\u0438 [' + innTags.join(', ') + '] \u0431\u0443\u0434\u0443\u0442 \u0434\u043E\u0431\u0430\u0432\u043B\u0435\u043D\u044B \u043A \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u044B\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u043C. \u0414\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u043C\u0435\u0442\u043A\u0438?', function () {
          _this11.$store.dispatch('updateDepoFileTags', { uids: selectedIds, tags: innTags });
          _this11.cxt && _this11.cxt.toViewMode();
        });
      };
      var onSelect = function onSelect(companies) {
        console.log('onSelect', companies);
        if (Array.isArray(companies)) {
          onTagChange(companies.map(function (c) {
            return c.ref || '';
          }));
        }
      };
      __WEBPACK_IMPORTED_MODULE_15__client__["a" /* default */].selectRef(this, onSelect, function () {}, true, true);
    }
  }
});

/***/ }),
/* 1173 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1174),
  /* template */
  __webpack_require__(1175),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doc-folder',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_5__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      imageFile: '',
      fileItem: {
        uid: null,
        fileNo: null,
        fileName: null,
        fileExt: null,
        fileSize: null,
        docName: null,
        desc: null,
        ownerInn: null,
        ownerNameShort: null,
        account: null,
        uploaded: null,
        path: null,
        tags: null,
        folder: null
      }
    };
  },
  props: {
    fileItemId: {
      type: String,
      default: null
    },
    newPath: {
      type: String,
      default: '/'
    }
  },
  created: function created() {
    if (this.fileItemId) {
      var fi = this.getDepoFolderById(this.fileItemId);
      this.fileItem = fi ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, fi) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getFileItemNew());
    } else {
      this.fileItem = this.getFileItemNew();
    }
  },

  watch: {
    fileItemId: function fileItemId(newVal, oldVal) {
      // watch it
      var fi = this.getDepoFolderById(newVal);
      this.fileItem = fi ? __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, fi) : __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getFileItemNew());
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    getDepoFolderById: 'getDepoFolderById',
    getDepoDisplayPaths: 'getDepoDisplayPaths'
  }), {
    isEdit: function isEdit() {
      return this.edit || this.isNew;
    },
    isNew: function isNew() {
      return this.fileItemId === null;
    },
    title: function title() {
      return this.isNew ? 'Создать папку депозитария' : this.isEdit ? 'Изменить атрибуты папки' : 'Информация о папке депозитария';
    }
  }),
  methods: {
    upload: function upload() {
      this.fileItem.folder = true;
      this.fileItem.path = this.newPath;
      this.$store.dispatch('createDepoFolder', this.fileItem);
      this.edit = false;
      this.cancel();
    },
    save: function save() {
      this.$store.dispatch('updateDepoFolder', this.fileItem);
      this.edit = false;
    },
    remove: function remove() {
      __WEBPACK_IMPORTED_MODULE_4__common_dialogs__["a" /* default */].confirm(this, 'Подтвердите', 'Удалить папку?', function (self) {
        self.$store.dispatch('deleteDepoFolder', self.fileItem);
        self.edit = false;
        self.cancel();
      });
    },
    cancel: function cancel() {
      this.edit = false;
      this.fileItem = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_object_assign___default()({}, this.getFileItemNew());
      this.$emit('close');
    },
    open: function open() {
      var url = this.getUrl(this.fileItem.uid);
      this.$store.dispatch('openLocation', url);
    },
    getFileItemNew: function getFileItemNew() {
      return {
        uid: null,
        fileNo: null,
        fileName: null,
        fileExt: null,
        fileSize: null,
        docName: null,
        desc: null,
        ownerInn: null,
        ownerNameShort: null,
        account: null,
        uploaded: null,
        path: '//root',
        tags: null,
        folder: null
      };
    },
    getDispalayPath: function getDispalayPath(path) {
      return this.getDepoDisplayPaths ? this.getDepoDisplayPaths.get(path) : '';
    },
    getDispalayPaths: function getDispalayPaths() {
      var map = this.getDepoDisplayPaths;
      var result = [];
      if (!map) {
        return result;
      }
      map.forEach(function (val, key) {
        return result.push({ key: key, value: val });
      });
      // console.log('getDispalayPaths', result)
      return result.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].compareString(a.value, b.value);
      });
    }
  }

});

/***/ }),
/* 1175 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "mode": _vm.edit,
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [(!_vm.isEdit) ? _c('v-btn', {
          on: {
            "click": function($event) {
              _vm.edit = !_vm.edit
            }
          }
        }, [_vm._v("Изменить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          on: {
            "click": _vm.upload
          }
        }, [_vm._v("Создать")]) : _vm._e(), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.isEdit) ? _c('v-flex', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))])]), _vm._v(" "), _c('v-card-text', [_c('v-flex', [_vm._v("\n          Размещение: " + _vm._s(_vm.getDispalayPath(_vm.fileItem.path)) + "\n          ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n          Примечания: " + _vm._s(_vm.fileItem.desc) + "\n          ")])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))])]), _vm._v(" "), _c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Название",
      "hint": "Название папки",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.docName),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "docName", $$v)
      },
      expression: "fileItem.docName"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-select', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (false),
      expression: "false"
    }],
    attrs: {
      "label": "Размещение в папке",
      "hint": "Структура папок видна только для пользователей депонента",
      "items": _vm.getDispalayPaths(),
      "item-value": "key",
      "item-text": "value"
    },
    model: {
      value: (_vm.fileItem.path),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "path", $$v)
      },
      expression: "fileItem.path"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Примечания",
      "rows": "3",
      "hint": "Примечания видны только для пользователей депонента",
      "clearable": ""
    },
    model: {
      value: (_vm.fileItem.desc),
      callback: function($$v) {
        _vm.$set(_vm.fileItem, "desc", $$v)
      },
      expression: "fileItem.desc"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1176 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1177),
  /* template */
  __webpack_require__(1178),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1177 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_BtnForm__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// import Vue from 'vue'




/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'folder-selector',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_3__common_BtnForm___default.a },
  data: function data() {
    return {
      itemId: null
    };
  },
  props: {
    toolbar: {
      type: Boolean,
      default: false
    },
    path: {
      type: String,
      default: '/'
    }
  },
  created: function created() {
    if (this.getProfileHaveClient) {
      this.$store.dispatch('fetchDepoFolders');
    }
  },
  mounted: function mounted() {
    this.itemId = this.path;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient',
    getDepoDisplayPaths: 'getDepoDisplayPaths'
  }), {
    title: function title() {
      return 'Выберите папку';
    }
  }),
  methods: {
    ok: function ok() {
      this.$emit('input', this.itemId);
      this.cancel();
    },
    cancel: function cancel() {
      this.$emit('close');
      this.itemId = null;
    },
    getDisplayPaths: function getDisplayPaths() {
      var map = this.getDepoDisplayPaths;
      var result = [];
      if (!map) {
        return result;
      }
      map.forEach(function (val, key) {
        return result.push({ key: key, value: val });
      });
      return result.sort(function (a, b) {
        return __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].compareString(a.value, b.value);
      });
    }
  }

});

/***/ }),
/* 1178 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": _vm.ok
          }
        }, [_vm._v("ОК")])]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_c('v-flex', [_c('v-select', {
    attrs: {
      "label": "Папки",
      "hint": "Структура папок видна только для пользователей депонента",
      "items": _vm.getDisplayPaths(),
      "item-value": "key",
      "item-text": "value"
    },
    model: {
      value: (_vm.itemId),
      callback: function($$v) {
        _vm.itemId = $$v
      },
      expression: "itemId"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1179 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Депозитарий обеспечивает Юридическую Значимость Вашим документам.")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Для загрузки документов, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и загрузите свои первые документы.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": "",
      "align-center": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs6": ""
    }
  }, [_c('v-chips-field', {
    attrs: {
      "emptyChip": "Метки",
      "solo": "",
      "flat": "",
      "items": _vm.chipsItems,
      "chipSize": _vm.getIsMobile ? 12 : 25
    },
    on: {
      "remove": _vm.removeInn,
      "click": _vm.selectInn
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "value": _vm.cxt.filterString,
      "solo": "",
      "flat": ""
    },
    on: {
      "input": _vm.onChangeFilter
    }
  })], 1), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }]
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addFile()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-progress-linear', {
    staticStyle: {
      "margin-top": "0",
      "margin-bottom": "0"
    },
    attrs: {
      "height": "2",
      "active": _vm.getItemSet.isProcessing(),
      "indeterminate": true
    }
  }), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll",
    on: {
      "nextPage": _vm.nextPage
    }
  }, [_c('v-list', {
    attrs: {
      "two-line": "",
      "dense": ""
    }
  }, [_c('v-list-tile', [_c('v-list-tile-content', [_c('v-actions-btn', {
    attrs: {
      "caption": _vm.folderActionsCaption,
      "actions": _vm.folderActions
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.depoFolders), function(item) {
    return _c('v-list-tile', {
      key: item.uid,
      attrs: {
        "avatar": ""
      },
      on: {
        "click": function($event) {
          !_vm.cxt.isSelectMode() ? _vm.setFolder(item.fileName) : _vm.cxt.select(item.uid)
        }
      }
    }, [_c('v-list-tile-avatar', [_c('v-icon', [_vm._v("folder")])], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_vm._v(_vm._s(item.docName))]), _vm._v(" "), _c('v-list-tile-sub-title', [_vm._v(_vm._s(item.subtitle))])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.cxt.isSelectMode()),
        expression: "!cxt.isSelectMode()"
      }],
      attrs: {
        "icon": ""
      },
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openFolder(item.uid)
        }
      }
    }, [_c('v-icon', {
      attrs: {
        "color": "grey lighten-1"
      }
    }, [_vm._v("info_outline")])], 1), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.uid)),
        expression: "cxt.check(item.uid)"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.uid)),
        expression: "cxt.uncheck(item.uid)"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1)])], 1)
  }), _vm._v(" "), _c('v-divider', {
    attrs: {
      "inset": ""
    }
  }), _vm._v(" "), _vm._l((this.filteredItems), function(item) {
    return [(item.header) ? _c('v-subheader', {
      domProps: {
        "textContent": _vm._s(item.header)
      }
    }) : (item.divider) ? _c('v-divider', {
      attrs: {
        "inset": item.inset
      }
    }) : _c('v-list-tile', {
      key: item.uid,
      on: {
        "click": function($event) {
          !_vm.cxt.isSelectMode() ? _vm.openFile(item.uid) : _vm.cxt.select(item.uid)
        }
      }
    }, [_c('v-list-tile-avatar', {
      attrs: {
        "tile": ""
      }
    }, [_c(_vm.createPreview(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', [_c('b', [_vm._v(_vm._s(item.docName))])]), _vm._v(" "), _c('v-list-tile-sub-title', [_c('a', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          !_vm.cxt.isSelectMode() ? _vm.open(item) : _vm.cxt.select(item.uid)
        }
      }
    }, [_vm._v(_vm._s(item.uid))])])], 1), _vm._v(" "), _c('v-list-tile-action', [_c('span', [_c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.check(item.uid)),
        expression: "cxt.check(item.uid)"
      }]
    }, [_vm._v("check_box")]), _vm._v(" "), _c('v-icon', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.cxt.uncheck(item.uid)),
        expression: "cxt.uncheck(item.uid)"
      }]
    }, [_vm._v("check_box_outline_blank")])], 1), _vm._v(" "), _c('v-list-tile-action-text', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (!_vm.cxt.isSelectMode()),
        expression: "!cxt.isSelectMode()"
      }]
    }, [_c('p')]), _vm._v(" "), _c('v-list-tile-action-text', [_vm._v(_vm._s(_vm.formats.blank(item.uploaded, _vm.formats.formatDate)))])], 1)], 1)]
  })], 2)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1180 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1181),
  /* template */
  __webpack_require__(1185),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DocProp_vue__ = __webpack_require__(1182);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__DocProp_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__DocProp_vue__);
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doc-dlg',
  components: { vDocProp: __WEBPACK_IMPORTED_MODULE_0__DocProp_vue___default.a },
  data: function data() {
    return {
      dialog: true,
      dialogItemId: null
    };
  },
  mounted: function mounted() {
    this.dialogItemId = this.$route.params.uid ? this.$route.params.uid : null;
  },

  watch: {
    // в случае изменения маршрута запрашиваем данные вновь
    '$route': function $route() {
      this.dialogItemId = this.$route.params.uid ? this.$route.params.uid : null;
      this.dialog = true;
    }
  }

});

/***/ }),
/* 1182 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1183),
  /* template */
  __webpack_require__(1184),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1183 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_apimix__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__info_PanelTitle__ = __webpack_require__(16);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__info_PanelTitle___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__info_PanelTitle__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BtnForm__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'doc-prop',
  components: { vPanelTitle: __WEBPACK_IMPORTED_MODULE_3__info_PanelTitle___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default.a },
  mixins: [__WEBPACK_IMPORTED_MODULE_2__common_apimix__["a" /* default */]],
  data: function data() {
    return {
      fileItems: [],
      isLoaded: false
    };
  },
  props: {
    toolbar: {
      type: Boolean,
      default: false
    },
    fileItemId: {
      type: String,
      default: null
    },
    mode: {
      type: String,
      default: null
    }
  },
  watch: {
    fileItemId: function fileItemId(newVal, oldVal) {
      // watch it
      this.fetchData(newVal);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getDepoFileProp: 'getDepoFileProp',
    getOpenSettings: 'getOpenSettings',
    renderDepoFileSignature: 'renderDepoFileSignature',
    getDepoUrl: 'getDepoUrl'
  }), {
    title: function title() {
      return 'Депонированный файл';
    },
    fileItem: function fileItem() {
      return this.fileItems.length > 0 ? this.fileItems[0] : null;
    },
    history: function history() {
      return this.fileItems.slice(1);
    }
  }),
  methods: {
    fetchData: function fetchData(itemId) {
      var _this = this;

      if (itemId) {
        this.$store.dispatch('getDepoFileVersions', itemId).then(function (fs) {
          _this.fileItems = fs;
        }, function () {});
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.$emit('close');
    },
    open: function open(uid) {
      var url = this.getUrl(uid) + '/stream';
      this.$store.dispatch('openLocation', url);
    },
    getUrl: function getUrl(uid) {
      return this.getDepoUrl(uid);
    },
    copyLink: function copyLink() {
      this.$store.dispatch('copyDepoFileLink', this.getUrl(this.fileItem.uid));
    },
    createCopyButton: function createCopyButton(caption, icon, hint, action) {
      var template = ''.concat('<div><v-tooltip bottom open-delay="500">\n          <div slot="activator">\n            <v-btn  @click="action">\n              <v-icon small>{{icon}}</v-icon>{{caption}}\n            </v-btn>\n          </div>\n          <span>{{hint}}</span>\n        </v-tooltip></div>');
      return {
        template: template,
        data: function data() {
          return {
            caption: caption,
            icon: icon,
            hint: hint,
            action: action
          };
        }
      };
    }
  }
});

/***/ }),
/* 1184 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "mode": _vm.isLoaded
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          on: {
            "click": function($event) {
              return _vm.open(_vm.fileItem.uid)
            }
          }
        }, [_vm._v("Открыть")]), _vm._v(" "), _c(_vm.createCopyButton('Ссылку', 'content_copy', 'Копировать ссылку', _vm.copyLink), {
          tag: "v-component"
        }), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [(_vm.fileItem) ? _c('v-flex', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.fileItem.docName))]), _vm._v(" "), _c(_vm.renderDepoFileSignature(_vm.fileItem), {
    tag: "v-component"
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_c('v-flex', [_vm._v("\n        Cсылка: "), _c('b', [_c('a', {
    attrs: {
      "href": _vm.getUrl(_vm.fileItem.uid)
    }
  }, [_vm._v(_vm._s(_vm.getUrl(_vm.fileItem.uid)))])])]), _vm._v(" "), _c('v-flex', [_vm._v("\n        Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(_vm.fileItem.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(_vm.fileItem.deleted, _vm.formats.formatDate)) + ")\n        ")]), _vm._v(" "), _c('v-flex', [_vm._v("\n        Депонент: "), _c('b', [_vm._v(_vm._s(_vm.fileItem.ownerShortName))]), _vm._v(" ИНН: " + _vm._s(_vm.formats.formatInn(_vm.fileItem.ownerInn)) + "\n        ")])], 1)], 1), _vm._v(" "), (_vm.history.length > 0) ? _c('v-card', [_c('v-panel-title', {
    attrs: {
      "value": _vm.isLoaded,
      "caption": 'История',
      "expandable": true
    },
    on: {
      "click": function($event) {
        _vm.isLoaded = !_vm.isLoaded
      }
    }
  }, [_c('span', [_vm._v("ВАЖНО! Депонент загрузил новые версии файла с момента депонирования, показана актуальная версия! Смотрите изменения в "), _c('a', {
    on: {
      "click": function($event) {
        _vm.isLoaded = true
      }
    }
  }, [_vm._v("истории")]), _vm._v(", рекомендуем "), _c('a', {
    on: {
      "click": function($event) {
        return _vm.copyLink()
      }
    }
  }, [_vm._v("обновить ссылку")]), _vm._v(".")])]), _vm._v(" "), (_vm.isLoaded) ? _c('v-card-text', {
    staticStyle: {
      "display": "block",
      "overflow-wrap": "break-word"
    }
  }, [_vm._l((_vm.history), function(item) {
    return [_c('v-flex', [_vm._v("\n        Название: "), _c('b', [_vm._v(_vm._s(item.docName))]), _vm._v(" "), _c(_vm.renderDepoFileSignature(item), {
      tag: "v-component"
    })], 1), _vm._v(" "), _c('v-flex', [_c('span', [_vm._v("\n        Депонировано: "), _c('b', [_vm._v(_vm._s(_vm.formats.blank(item.uploaded, _vm.formats.formatDateTime)))]), _vm._v(" (по: " + _vm._s(_vm.formats.blank(item.deleted, _vm.formats.formatDate)) + ")\n        "), _c('v-btn', {
      attrs: {
        "small": "",
        "flat": ""
      },
      on: {
        "click": function($event) {
          return _vm.open(item.uid)
        }
      }
    }, [_vm._v("Открыть")])], 1)])]
  })], 2) : _vm._e()], 1) : _vm._e()], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1185 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "max-width": "600px",
      "fullscreen": _vm.$vuetify.breakpoint.xsOnly
    },
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-doc-prop', {
    attrs: {
      "toolbar": "",
      "fileItemId": _vm.dialogItemId
    },
    on: {
      "close": function($event) {
        _vm.dialog = false
      }
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 1186 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1187),
  /* template */
  __webpack_require__(1222),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatList_vue__ = __webpack_require__(1188);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ChatList_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ChatList_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Chat_vue__ = __webpack_require__(479);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Chat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__Chat_vue__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chat-panel',
  components: { vChatList: __WEBPACK_IMPORTED_MODULE_2__ChatList_vue___default.a, vChat: __WEBPACK_IMPORTED_MODULE_3__Chat_vue___default.a },
  props: {},
  data: function data() {
    return {
      itemId: null,
      isRoot: true
    };
  },
  mounted: function mounted() {
    this.setItemId();
  },

  watch: {
    // в случае изменения маршрута запрашиваем данные вновь
    '$route': function $route() {
      this.setItemId();
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getProfileHaveClient: 'getProfileHaveClient'
  }), {
    title: function title() {}
  }),
  methods: {
    setItemId: function setItemId() {
      if (this.$route.params.chatId) {
        this.itemId = this.$route.params.chatId;
      } else {
        this.itemId = null;
      }
      if (!(this.itemId && this.itemId !== 'root')) {
        this.isRoot = true;
        this.itemId = 'root';
      } else {
        this.isRoot = false;
      }
    }
  }
});

/***/ }),
/* 1188 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1189),
  /* template */
  __webpack_require__(1193),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_classes__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_OpsBtn__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_OpsBtn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_OpsBtn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChatForm_vue__ = __webpack_require__(1190);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ChatForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__ChatForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CardScroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_CardScroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_CardScroll__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chat-list',
  components: { vOpsBtn: __WEBPACK_IMPORTED_MODULE_5__common_OpsBtn___default.a, vCardScroll: __WEBPACK_IMPORTED_MODULE_7__common_CardScroll___default.a },
  data: function data() {
    return {
      cxt: null,
      timer: ''
    };
  },
  mounted: function mounted() {
    this.fetchData();
  },

  props: {
    itemId: {
      type: String,
      default: null
    }
  },
  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      if (newVal === 'root') {
        this.fetchData();
      }
    },
    getProfileHaveClient: function getProfileHaveClient(newVal, oldVal) {
      // watch it
      if (newVal && this.itemId === 'root') {
        this.fetchData();
      }
    }
  },
  created: function created() {
    var _this = this;

    var cxt = new __WEBPACK_IMPORTED_MODULE_4__api_classes__["a" /* default */].MultiSelectContext(function () {
      return _this.filteredItems.map(function (item) {
        return item.uid;
      });
    });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_4__api_classes__["a" /* default */].FilterAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_4__api_classes__["a" /* default */].FilterEndAction(cxt));
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_4__api_classes__["a" /* default */].Action(this, 'Все', null, function () {
      _this.cxt.showAll();
    }));
    cxt.actions.push({ divider: true });
    cxt.actions.push(new __WEBPACK_IMPORTED_MODULE_4__api_classes__["a" /* default */].Action(this, 'Новый обсуждение', null, function () {
      return _this.addItem();
    }));

    cxt.title = 'Сообщения';
    cxt.titleIcon = 'chat';
    cxt.selectTitle = 'Выбор диалогов';
    cxt.filterMode = true;
    this.cxt = cxt;
  },

  computed: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_1_vuex__["mapGetters"])({
    getIsMobile: 'getIsMobile',
    chatterChats: 'getChatterChats',
    getProfileHaveClient: 'getProfileHaveClient'
  }), {
    orderedItems: function orderedItems() {
      var result = this.chatterChats.slice();
      return result.sort(function (a, b) {
        if (a.lastCount > 0 && b.lastCount > 0) {
          return b.last.published - a.last.published;
        }
        if (a.lastCount === 0 && b.lastCount === 0) {
          return b.last.published - a.last.published;
        }
        return b.lastCount - a.lastCount;
      });
    },
    filteredItems: function filteredItems() {
      var _this2 = this;

      var getSearchString = function getSearchString(item) {
        return ''.concat(_this2.getItemTitle(item), _this2.getItemHTML(item), _this2.getItemLastTime(item));
      };

      var filter = !this.cxt.isFilterMode() || this.cxt.filterString === null || this.cxt.filterString.length < 3 ? null : this.cxt.filterString.toUpperCase();
      if (!filter) {
        return this.orderedItems;
      }
      return this.orderedItems.filter(function (item) {
        return getSearchString(item).toUpperCase().includes(filter);
      });
    },
    formatCountTitle: function formatCountTitle() {
      var label = this.getIsMobile ? '' : this.cxt.isSelectMode() ? 'Выбрано ' : 'Показано ';
      if (this.cxt.isSelectMode()) {
        return this.orderedItems ? label + this.cxt.selectedCount() + ' из ' + this.orderedItems.length + '' : '';
      } else {
        return this.orderedItems ? label + this.filteredItems.length + ' из ' + this.orderedItems.length + '' : '';
      }
    }
  }),
  methods: {
    fetchData: function fetchData() {
      if (this.getProfileHaveClient) {
        this.$store.dispatch('fetchChatterChats');
      }
    },
    chatClick: function chatClick(value) {
      this.$router.push({ name: 'Chat' });
    },
    openItem: function openItem(id) {
      this.dialogOpen(id);
    },
    addItem: function addItem() {
      this.openItem(null);
    },
    getItemTitle: function getItemTitle(item) {
      return item.name ? item.partnerName + ': ' + item.name : item.partnerName;
    },
    getItemHTML: function getItemHTML(item) {
      var result = item.last.clientName ? item.last.clientName : '';
      result = result + (item.last.text ? ': ' + item.last.text : '');
      return result;
    },
    getItemLastTime: function getItemLastTime(item) {
      var result = item.last.published ? __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatDateTime(item.last.published) : '';
      return result;
    },
    dialogOpen: function dialogOpen(id) {
      __WEBPACK_IMPORTED_MODULE_3__common_dialogs__["a" /* default */].register('v-chat-form', __WEBPACK_IMPORTED_MODULE_6__ChatForm_vue___default.a);
      var fullscreen = this.$vuetify.breakpoint.xsOnly;
      var comp = { template: '\n        <v-chat-form toolbar :itemId="dialogItemId"  v-on:close="$emit(\'close\')"\n        :fullscreen="fullscreen"></v-chat-form>\n        ',
        data: function data() {
          return {
            dialogItemId: id,
            fullscreen: fullscreen
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_3__common_dialogs__["a" /* default */].modal(comp);
    }
  }
});

/***/ }),
/* 1190 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1191),
  /* template */
  __webpack_require__(1192),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1191 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__client_index_js__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chat-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_5__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      request: '',
      item: {},
      partner: null,
      isSearching: false
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  create: function create() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({}), {
    isEdit: function isEdit() {
      return this.edit || this.isNew;
    },
    isNew: function isNew() {
      return true;
      // Disable functionality to change chat definition
      // this.itemId === null
    },
    title: function title() {
      return this.isNew ? 'Создать беседу' : this.isEdit ? 'Изменить атрибуты беседы' : 'Информация о беседе';
    },
    partnerDescription: function partnerDescription() {
      var result = this.partner ? this.partner.caption + ' (ИНН:' + __WEBPACK_IMPORTED_MODULE_4__api_formats__["a" /* default */].formatInn(this.partner.inn) + ')' : '';
      if (this.partner && this.partner.heads) {
        result = result + '\n' + this.formatHeads(this.partner.heads);
      }
      return result;
    }
  }),
  methods: {
    add: function add() {
      if (this.partner) {
        this.item.partnerInn = this.partner.inn;
        this.$store.dispatch('addChatterChat', this.item);
        this.edit = false;
        this.cancel();
      }
    },
    save: function save() {
      this.$store.dispatch('updateChatterChat', this.item);
      this.edit = false;
    },
    remove: function remove() {
      this.$store.dispatch('deleteChatterChat', this.item);
      this.edit = false;
      this.cancel();
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    formatHeads: function formatHeads(heads) {
      return heads ? heads.map(function (h) {
        return ''.concat(h.position, ': ', h.nameShort);
      }).join('\n') : '';
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        name: null,
        partnerInn: null,
        msg: ''
      };
    },

    setPartner: function setPartner(value) {
      this.partner = value.length > 0 ? value[0] : null;
    },
    selectClient: function selectClient() {
      __WEBPACK_IMPORTED_MODULE_3__client_index_js__["a" /* default */].selectRef(this, this.setPartner, function () {}, null, true, true);
    }
  }

});

/***/ }),
/* 1192 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title,
      "mode": _vm.edit
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [(!_vm.isEdit) ? _c('v-btn', {
          on: {
            "click": function($event) {
              _vm.edit = !_vm.edit
            }
          }
        }, [_vm._v("Изменить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.save
          }
        }, [_vm._v("Сохранить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (!_vm.isNew),
            expression: "!isNew"
          }],
          on: {
            "click": _vm.remove
          }
        }, [_vm._v("Удалить")]) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-btn', {
          directives: [{
            name: "show",
            rawName: "v-show",
            value: (_vm.isNew),
            expression: "isNew"
          }],
          attrs: {
            "disabled": !_vm.partner || !_vm.partner.clientId
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Создать")]) : _vm._e(), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [(!_vm.isEdit) ? _c('v-flex', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v(_vm._s(_vm.item.name))])]), _vm._v(" "), _c('v-card-text')], 1) : _vm._e(), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "sm8": "",
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "label": "Партнер",
      "readonly": "",
      "auto-grow": "",
      "rows": "1",
      "value": _vm.partnerDescription
    },
    on: {
      "click": _vm.selectClient
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-btn', {
    on: {
      "click": _vm.selectClient
    }
  }, [_vm._v("Выбрать партнера")])], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Название",
      "hint": "Название беседы",
      "clearable": ""
    },
    model: {
      value: (_vm.item.name),
      callback: function($$v) {
        _vm.$set(_vm.item, "name", $$v)
      },
      expression: "item.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isNew),
      expression: "isNew"
    }]
  }, [_c('v-text-field', {
    attrs: {
      "label": "Сообщение",
      "hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.item.msg),
      callback: function($$v) {
        _vm.$set(_vm.item, "msg", $$v)
      },
      expression: "item.msg"
    }
  })], 1)], 1)], 1)], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1193 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "prominent": "",
      "flat": ""
    }
  }, [_c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "light": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.cxt.getTitleIcon())
    }
  }), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-toolbar-title', [_vm._v(_vm._s(_vm.cxt.getTitle()))]) : _vm._e()], 1), _vm._v(" "), (!_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    attrs: {
      "pl-3": ""
    },
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.getIsMobile) ? _c('v-flex', {
    staticClass: "caption",
    domProps: {
      "innerHTML": _vm._s(_vm.formatCountTitle)
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-layout', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }],
    staticStyle: {
      "overflow": "hidden"
    },
    attrs: {
      "justify-end": ""
    }
  }), _vm._v(" "), (_vm.cxt.isFilterMode()) ? _c('v-flex', {
    attrs: {
      "sm4": "",
      "xs4": ""
    }
  }, [_c('v-text-field', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.cxt.isFilterMode()),
      expression: "cxt.isFilterMode()"
    }],
    attrs: {
      "autofocus": "",
      "label": "Фильтр",
      "solo": "",
      "flat": ""
    },
    model: {
      value: (_vm.cxt.filterString),
      callback: function($$v) {
        _vm.$set(_vm.cxt, "filterString", $$v)
      },
      expression: "cxt.filterString"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isSelectMode()),
      expression: "!cxt.isSelectMode()"
    }]
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.cxt.isFilterMode()),
      expression: "!cxt.isFilterMode()"
    }]
  }, [_c('v-btn', {
    attrs: {
      "icon": ""
    },
    on: {
      "click": function($event) {
        return _vm.addItem()
      }
    }
  }, [_c('v-icon', [_vm._v("add")])], 1)], 1)]), _vm._v(" "), _c('v-ops-btn', {
    attrs: {
      "cxt": _vm.cxt,
      "flat": ""
    }
  })], 1), _vm._v(" "), _c('v-card-scroll', {
    ref: "cardScroll"
  }, [_c('v-container', {
    staticStyle: {
      "min-height": "0",
      "margin-top": "0"
    },
    attrs: {
      "px-2": "",
      "pt-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_vm._l((_vm.filteredItems), function(item) {
    return [_c('v-flex', {
      attrs: {
        "xs12": ""
      }
    }, [_c('v-card', {
      attrs: {
        "to": '/chats/' + item.id
      }
    }, [_c('v-card-title', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('div', [_c('v-badge', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.lastCount > 0),
        expression: "item.lastCount > 0"
      }],
      attrs: {
        "right": ""
      }
    }, [_c('span', {
      attrs: {
        "slot": "badge"
      },
      slot: "badge"
    }, [_vm._v(_vm._s(item.lastCount))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.getItemTitle(item)))])]), _vm._v(" "), _c('span', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.lastCount === 0),
        expression: "item.lastCount === 0"
      }]
    }, [_vm._v(_vm._s(_vm.getItemTitle(item)))])], 1), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.getItemLastTime(item)))])], 1)], 1), _vm._v(" "), _c('v-card-text', [_c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getItemHTML(item))
      }
    })])], 1)], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1194 */
/***/ (function(module, exports, __webpack_require__) {

// style-loader: Adds some css to the DOM by adding a <style> tag

// load the styles
var content = __webpack_require__(1195);
if(typeof content === 'string') content = [[module.i, content, '']];
if(content.locals) module.exports = content.locals;
// add the styles to the DOM
var update = __webpack_require__(30)("ace79e52", content, true, {});

/***/ }),
/* 1195 */
/***/ (function(module, exports, __webpack_require__) {

exports = module.exports = __webpack_require__(29)(true);
// imports


// module
exports.push([module.i, ".align-end{text-align:right}", "", {"version":3,"sources":["D:/A32/Atlant/dealger_spring_1/client/src/components/chat/Chat.vue"],"names":[],"mappings":"AACA,WACE,gBAAkB,CACnB","file":"Chat.vue","sourcesContent":["\n.align-end{\r\n  text-align: right;\n}\r\n"],"sourceRoot":""}]);

// exports


/***/ }),
/* 1196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__ = __webpack_require__(40);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue__ = __webpack_require__(69);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_dialogs__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PostForm_vue__ = __webpack_require__(1197);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PostForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__PostForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PostOfferForm_vue__ = __webpack_require__(1200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__PostOfferForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__PostOfferForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostNotifyForm_vue__ = __webpack_require__(1203);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__PostNotifyForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__PostNotifyForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PostOfferCancelForm_vue__ = __webpack_require__(1206);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__PostOfferCancelForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__PostOfferCancelForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PostActForm_vue__ = __webpack_require__(1209);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__PostActForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__PostActForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PostClaimForm_vue__ = __webpack_require__(1212);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__PostClaimForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__PostClaimForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PostOfferRequestForm_vue__ = __webpack_require__(1215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__PostOfferRequestForm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__PostOfferRequestForm_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ConfirmDialog_vue__ = __webpack_require__(1218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__ConfirmDialog_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__ConfirmDialog_vue__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
















// import moment from 'moment'

var SHOW_DESCRIPTION_ACTION = 'ADD_SPOT';
var ADD_PLAIN_ACTION = 'ADD_PLAIN';
var ADD_OFFER_ACTION = 'ADD_OFFER';
var ADD_NOTIFY_ACTION = 'ADD_NOTIFY';
var ADD_OFFER_CANCEL_ACTION = 'ADD_OFFER_CANCEL';
var ADD_ACT_ACTION = 'ADD_ACT';
var ADD_CLAIM_ACTION = 'ADD_CLAIM';
var ADD_OFFER_REQUEST_ACTION = 'ADD_OFFER_REQUEST';
var ALL_SCOPE_ACTION = 'ALL_SCOPE';
var ACTIVE_SCOPE_ACTION = 'ACTIVE_SCOPE';
var FAVORITE_SCOPE_ACTION = 'FAVORITE_SCOPE';

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'chat',
  data: function data() {
    return {
      menu: false,
      fileLink: null,
      showDescription: false,
      timer: '',
      rights: null,
      item: {
        text: '',
        link: ''
      },
      lastScrollHeight: 0,
      valid: false,
      menus: [{ title: 'Поиск...' }, { title: 'Информация о диалоге', action: SHOW_DESCRIPTION_ACTION }, { divider: true }, { title: 'Сообщение', action: ADD_PLAIN_ACTION }, { title: 'Оферта', action: ADD_OFFER_ACTION, needRights: true }, { title: 'Уведомление', action: ADD_NOTIFY_ACTION, needRights: true }, { title: 'Акт/накладная', action: ADD_ACT_ACTION, needRights: true }, { title: 'Претензия', action: ADD_CLAIM_ACTION, needRights: true }, { title: 'Запрос оферты / коммерческого предложения', action: ADD_OFFER_REQUEST_ACTION, needRights: true }, { title: 'Отмена оферты', action: ADD_OFFER_CANCEL_ACTION, needRights: true }]

    };
  },
  props: {
    itemId: {
      type: String,
      default: null
    }
  },
  created: function created() {
    this.fetchData(this.itemId);
  },

  watch: {
    itemId: function itemId(newVal, oldVal) {
      // watch it
      this.fetchData(newVal);
    }
  },
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_6_vuex__["mapGetters"])({
    chatterChat: 'getChatterChat',
    chatterPosts: 'getChatterPosts',
    profile: 'getProfile',
    clientProfile: 'getClientProfile',
    getDepoUrl: 'getDepoUrl',
    getIsAllow: 'getIsAllow',
    calcScroll: 'calcScroll'
  }), {
    getTitle: function getTitle() {
      var result = this.chatterChat && this.chatterChat.partnerName && !this.chatterChat.name ? this.chatterChat.partnerName : '';
      result = result + (result.length !== 0 && this.chatterChat.name ? ': ' : '');
      result = result + (this.chatterChat && this.chatterChat.name ? this.chatterChat.name : '');
      return result;
    },
    getDescriptionHtml: function getDescriptionHtml() {
      var partnerText = this.chatterChat && this.chatterChat.partnerName ? '<b>' + this.chatterChat.partnerName + '</b>, ИНН <b>' + this.chatterChat.partnerInn + '</b>' : '';
      var clientText = this.profile && this.profile.clientNameShort ? '<b>' + this.profile.clientNameShort + '</b>, ИНН <b>' + this.profile.clientInn + '</b>' : '';

      return '<div>' + partnerText + ' (белый фон)</div>  <div>' + clientText + ' (серый фон).</div>';
    },
    getPosts: function getPosts() {
      this.scrollBottom();
      return this.chatterPosts;
    },
    getMenus: function getMenus() {
      return this.getIsAllow({ POST_ACTION_CREATE: null }) ? this.menus : this.menus.filter(function (i) {
        return !i.needRights || i.needRights !== true;
      });
    }
  }),
  methods: {
    calcHeight: function calcHeight() {
      var delta = 56 + 48;
      delta = this.$refs.focused ? delta + this.$refs.focused.$el.offsetHeight + 16 : delta + 62 + 12;
      return this.calcScroll(delta);
    },
    getOffsetClass: function getOffsetClass(item) {
      // return this.profile.clientId === item.clientId ? 'offset-xs1' : ''
      return __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].compareString(this.profile.nameShort, item.accountName) === 0 ? 'offset-xs1' : '';
    },
    getColor: function getColor(item) {
      return this.profile.clientId === item.clientId ? 'grey lighten-3' : 'white';
    },
    formatExpiryTime: function formatExpiryTime(dateTime) {
      if (dateTime) {
        return 'Действует по: ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(dateTime);
      }
      return '';
    },
    scrollBottom: function scrollBottom() {
      var self = this;
      __WEBPACK_IMPORTED_MODULE_2_vue__["default"].nextTick(function () {
        self.$refs.scroll_target.$el.scrollTop = self.$refs.scroll_target.$el.scrollHeight - self.lastScrollHeight;
        self.lastScrollHeight = 0;
      });
    },
    addItem: function addItem(type) {
      this.dialogOpen(type);
    },
    runAction: function runAction(item) {
      switch (item.action) {
        case SHOW_DESCRIPTION_ACTION:
          this.showDescription = true;
          break;
        case ADD_PLAIN_ACTION:
          this.addItem('PLAIN');
          break;
        case ADD_OFFER_ACTION:
          this.addItem('OFFER');
          break;
        case ADD_OFFER_CANCEL_ACTION:
          this.addItem('OFFER_CANCEL');
          break;
        case ADD_ACT_ACTION:
          this.addItem('ACT');
          break;
        case ADD_CLAIM_ACTION:
          this.addItem('CLAIM');
          break;
        case ADD_OFFER_REQUEST_ACTION:
          this.addItem('OFFER_REQUEST');
          break;
        case ADD_NOTIFY_ACTION:
          this.addItem('NOTIFY');
          break;
        case ACTIVE_SCOPE_ACTION:
          break;
        case ALL_SCOPE_ACTION:
          break;
        case FAVORITE_SCOPE_ACTION:
          break;
      }
    },
    changeActionState: function changeActionState(item, newState) {
      this.$store.dispatch('setChatterPostAction', { item: item, action: { actionState: newState } });
    },
    getHTMLHeader: function getHTMLHeader(item) {
      var result = item.clientName + '<br/>' + item.accountName + '<br/>' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDateTime(item.published);
      return result;
    },
    getHTMLActionSign: function getHTMLActionSign(item) {
      if (!item.actionState) {
        return null;
      }
      switch (item.actionState) {
        case 'CANCELED':
        case 'REJECTED':
        case 'SIGNED':
          {
            return item.actionClientName + '<br/>' + item.actionAccountName + '<br/>' + this.formatActionTime(item);
          }
        case 'PUBLISHED':
        case 'EXPIRED':
          {
            return '' + this.formatActionTime(item);
          }
      }
    },
    getHTMLText: function getHTMLText(item) {
      var _this = this;

      var addImg = function addImg(d) {
        var depoUrl = _this.getDepoUrl('');
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_array_from___default()(d.getElementsByTagName('a')).forEach(function (a) {
          if (!a.href || !a.href.toString().startsWith(depoUrl)) {
            return;
          }
          var n = a.cloneNode(false);
          var img = document.createElement('img');
          img.src = n.href + '/preview';
          img.alt = '';
          img.style = 'width:100%';
          n.appendChild(img);
          d.appendChild(n);
        });
      };

      var result = item.text.replace(/\n/g, '<br/>');
      var d = document.createElement('div');
      d.innerHTML = result;
      addImg(d);
      return d.innerHTML;
    },
    resultText: function resultText(item) {
      if (!item.actionState) {
        return null;
      }
      switch (item.actionState) {
        case 'CANCELED':
          return 'Запрос отменен ';
        case 'REJECTED':
          if (item.typeCode === 'ACT') {
            return 'Работа не принята ';
          }
          return 'Запрос отклонен ';
        case 'SIGNED':
          {
            if (item.typeCode === 'OFFER') {
              return 'Оферта принята ';
            }
            if (item.typeCode === 'ACT') {
              return 'Работа принята, замечаний нет ';
            }
            return 'Запрос подписан ';
          }
        case 'PUBLISHED':
          {
            if (item.typeCode === 'CLAIM') {
              return 'Претензия доставлена ';
            }
            if (item.typeCode === 'NOTIFY') {
              return 'Уведомление доставлено ';
            }
            if (item.typeCode === 'OFFER_REQUEST') {
              return 'Запрос доставлен ';
            }
            if (item.typeCode === 'OFFER_CANCEL') {
              return 'Отмена оферты доставлена ';
            }
            return 'Сообщение доставлено ';
          }
        case 'EXPIRED':
          if (item.typeCode === 'OFFER') {
            return 'Срок действия оферты истек, оферта не принята.';
          }
          if (item.typeCode === 'ACT') {
            return 'Время принятия акта истекло.';
          }
          return 'Запрос устарел ';
      }
    },
    partnerAction: function partnerAction(item) {
      return item.actionState == null && this.profile.clientId !== item.clientId;
    },
    clientAction: function clientAction(item) {
      return item.actionState == null && this.profile.clientId === item.clientId;
    },
    formatActionTime: function formatActionTime(item) {
      return item.actionState == null ? this.formatExpiryTime(item.expiryTime) : __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDateTime(item.actionTime);
    },
    hideDescription: function hideDescription() {
      this.showDescription = false;
    },

    addLink: function addLink(value) {
      var docLink = this.getDepoUrl(value);
      this.item.text = this.item.text + ('<a href="' + docLink + '">' + docLink + '</a>');
    },
    addPost: function addPost() {
      if (this.item.text && this.item.text.length > 0) {
        var item = {};
        item.text = this.item.text;
        item.chatId = this.chatterChat.id;
        item.typeCode = 'PLAIN';
        this.$store.dispatch('addChatterPost', item);
        this.item.text = '';
      }
    },
    getActionCode: function getActionCode(item) {
      return item.state === 'NEW' ? 'POST_ACTION_CREATE' : 'POST_ACTION_APPLY';
    },
    confirm: function confirm(item) {
      var self = this;
      var refresh = function refresh(data) {
        self.fetchData(self.itemId);
      };
      var actionCode = this.getActionCode(item);
      __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-confirm-dlg', __WEBPACK_IMPORTED_MODULE_15__ConfirmDialog_vue___default.a);
      var comp = {
        template: '\n            <v-confirm-dlg :actionCode="actionCode" :resourceId="itemId" v-on:refresh="refresh" v-on:close="$emit(\'close\')"></v-confirm-dlg>\n        ',
        data: function data() {
          return {
            actionCode: actionCode,
            itemId: item.id,
            refresh: refresh
          };
        }
      };
      __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].modal(comp);
    },
    rollback: function rollback(item) {
      var _this2 = this;

      var cb = function cb(data) {
        _this2.fetchData(_this2.itemId);
      };
      var cbError = function cbError(e) {
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при отмене действия ' });
      };
      __WEBPACK_IMPORTED_MODULE_4__api_server__["a" /* default */].apiPost('/api/me/action-rollbacks', {
        actionCode: this.getActionCode(item),
        resourceId: item.id
      }, cb, cbError);
    },
    dialogOpen: function dialogOpen(type) {
      var comp = {};
      switch (type) {
        case 'DOC_SELECTOR':
          __WEBPACK_IMPORTED_MODULE_14__depo__["a" /* default */].selectDoc(this, this.addLink);
          return;
        case 'PLAIN':
          __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-post-form', __WEBPACK_IMPORTED_MODULE_7__PostForm_vue___default.a);
          comp = { template: '\n            <v-post-form toolbar v-on:close="$emit(\'close\')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-post-form>\n          ' };
          break;
        case 'OFFER':
          __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-post-offer-form', __WEBPACK_IMPORTED_MODULE_8__PostOfferForm_vue___default.a);
          comp = { template: '\n            <v-post-offer-form toolbar v-on:close="$emit(\'close\')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-post-offer-form>\n          ' };
          break;
        case 'OFFER_CANCEL':
          __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-post-offer-cancel-form', __WEBPACK_IMPORTED_MODULE_10__PostOfferCancelForm_vue___default.a);
          comp = { template: '\n            <v-post-offer-cancel-form toolbar v-on:close="$emit(\'close\')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-post-offer-cancel-form>\n          ' };
          break;
        case 'ACT':
          __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-act-form', __WEBPACK_IMPORTED_MODULE_11__PostActForm_vue___default.a);
          comp = { template: '\n            <v-act-form toolbar v-on:close="$emit(\'close\')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-act-form>\n          ' };
          break;
        case 'CLAIM':
          __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-claim-form', __WEBPACK_IMPORTED_MODULE_12__PostClaimForm_vue___default.a);
          comp = { template: '\n            <v-claim-form toolbar v-on:close="$emit(\'close\')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-claim-form>\n          ' };
          break;
        case 'OFFER_REQUEST':
          __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-offer-request-form', __WEBPACK_IMPORTED_MODULE_13__PostOfferRequestForm_vue___default.a);
          comp = { template: '\n            <v-offer-request-form toolbar v-on:close="$emit(\'close\')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-offer-request-form>\n          ' };
          break;
        case 'NOTIFY':
          __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].register('v-notify-form', __WEBPACK_IMPORTED_MODULE_9__PostNotifyForm_vue___default.a);
          comp = { template: '\n            <v-notify-form toolbar v-on:close="$emit(\'close\')" :fullscreen="$vuetify.breakpoint.xsOnly"></v-notify-form>\n          ' };
          break;
      }
      __WEBPACK_IMPORTED_MODULE_5__common_dialogs__["a" /* default */].modal(comp);
    },
    isAdmin: function isAdmin() {
      return this.getIsAllow({ POST_ACTION_APPLY: null });
    },
    fetchRights: function fetchRights() {
      this.$store.dispatch('fetchRights', { POST_ACTION_CREATE: null, POST_ACTION_APPLY: null });
    },
    fetchData: function fetchData(itemId) {
      if (itemId) {
        this.$store.dispatch('fetchChatterChat', itemId);
        this.$store.dispatch('fetchChatterChatPosts', { chatId: itemId, force: true });
        this.fetchRights('LOCAL_ADMIN_CHECK');
      }
    },
    onScroll: function onScroll(e) {
      if (e.target.scrollTop > 0) {
        return;
      }
      if (this.itemId) {
        this.lastScrollHeight = e.target.scrollHeight;
        this.$store.dispatch('fetchChatterChatPosts', { chatId: this.itemId, force: false });
      }
    }
  }
});

/***/ }),
/* 1197 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1198),
  /* template */
  __webpack_require__(1199),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post-form',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_4__common_BtnForm___default.a },
  data: function data() {
    return {
      docSelector: false,
      edit: false,
      valid: false,
      item: {}
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    chat: 'getChatterChat',
    profile: 'getProfile',
    getDepoUrl: 'getDepoUrl'
  }), {
    title: function title() {
      return 'Направить сообщение';
    },
    docLink: function docLink() {
      return this.item.link ? this.item.link : '';
    }
  }),
  methods: {
    add: function add() {
      if (this.$refs.form.validate()) {
        this.item.chatId = this.chat.id;
        this.$store.dispatch('addChatterPost', this.item);
        this.edit = false;
        this.cancel();
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        chatId: null,
        text: '',
        typeCode: 'PLAIN',
        expiryTime: null,
        link: null
      };
    },
    addLink: function addLink() {
      this.item.text = this.item.text + ('<a href="' + this.docLink + '">' + this.docLink + '</a>');
      this.item.link = null;
    },

    setDoc: function setDoc(value) {
      var docLink = this.getDepoUrl(value);
      this.item.link = docLink;
    },
    dialogOpen: function dialogOpen() {
      __WEBPACK_IMPORTED_MODULE_3__depo__["a" /* default */].selectDoc(this, this.setDoc);
    }
  }

});

/***/ }),
/* 1199 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Текст",
      "rows": "5",
      "hint": "",
      "rules": [function (v) { return !!v || 'введите текст'; }]
    },
    model: {
      value: (_vm.item.text),
      callback: function($$v) {
        _vm.$set(_vm.item, "text", $$v)
      },
      expression: "item.text"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на документ",
      "hint": ""
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "disabled": !this.item.link
    },
    on: {
      "click": _vm.addLink
    }
  }, [_vm._v("Добавить")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1200 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1201),
  /* template */
  __webpack_require__(1202),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post-offer-form',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      clientRole: '',
      partnerRole: ''
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    chat: 'getChatterChat',
    profile: 'getProfile',
    getDepoUrl: 'getDepoUrl'
  }), {
    partnerName: function partnerName() {
      return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]';
    },
    partnerInn: function partnerInn() {
      return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]';
    },
    clientName: function clientName() {
      return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]';
    },
    clientInn: function clientInn() {
      return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]';
    },
    expiryTime: function expiryTime() {
      return this.item.expiryTime ? 'Срок действия настоящей оферты по ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.item.expiryTime)) + '.' : '';
    },
    docLink: function docLink() {
      return this.item.link ? this.item.link : '';
    },
    title: function title() {
      return 'Направить оферту';
    },

    text: {
      get: function get() {
        return this.getText();
      }
    }
  }),
  methods: {
    add: function add() {
      if (this.$refs.form.validate()) {
        this.item.text = this.getText();
        this.item.chatId = this.chat.id;
        this.$store.dispatch('addChatterPost', this.item);
        this.edit = false;
        this.cancel();
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        chatId: null,
        text: '',
        typeCode: 'OFFER',
        expiryTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(5, 'days').format(),
        link: null
      };
    },
    getText: function getText() {
      return this.clientName + ', \u0418\u041D\u041D ' + this.clientInn + ' \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 ' + this.partnerName + ', \u0418\u041D\u041D ' + this.partnerInn + ' \u0437\u0430\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u0434\u043E\u0433\u043E\u0432\u043E\u0440 \u2116 ' + this.agreementNumber + ' \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445, \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0432 \u0444\u0430\u0439\u043B\u0435 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: <a href="' + this.docLink + '">' + this.docLink + '</a>, \u0433\u0434\u0435 ' + this.clientName + '  \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F ' + this.clientRole + ', \u0430 ' + this.partnerName + ' - ' + this.partnerRole + '. ' + this.expiryTime + ' \u0414\u043B\u044F \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u044F \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u043E\u0444\u0435\u0440\u0442\u044B \u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u043D\u0430\u0436\u0430\u0442\u044C \u043A\u043D\u043E\u043F\u043A\u0443 "\u0410\u043A\u0446\u0435\u043F\u0442"';
    },

    setDoc: function setDoc(value) {
      var docLink = this.getDepoUrl(value);
      this.item.link = docLink;
    },
    dialogOpen: function dialogOpen() {
      __WEBPACK_IMPORTED_MODULE_6__depo__["a" /* default */].selectDoc(this, this.setDoc);
    }
  }

});

/***/ }),
/* 1202 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Номер договора",
      "hint": "",
      "rules": [function (v) { return !!v || 'номер должен быть указан'; }],
      "clearable": ""
    },
    model: {
      value: (_vm.agreementNumber),
      callback: function($$v) {
        _vm.agreementNumber = $$v
      },
      expression: "agreementNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Срок действия по",
      "rules": [],
      "hint": ""
    },
    model: {
      value: (_vm.item.expiryTime),
      callback: function($$v) {
        _vm.$set(_vm.item, "expiryTime", $$v)
      },
      expression: "item.expiryTime"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Вы являетесь",
      "hint": "",
      "clearable": "",
      "rules": [function (v) { return !!v || 'например: Стороной 1'; }]
    },
    model: {
      value: (_vm.clientRole),
      callback: function($$v) {
        _vm.clientRole = $$v
      },
      expression: "clientRole"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Партнер является",
      "rules": [function (v) { return !!v || 'например: Стороной 2'; }],
      "hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.partnerRole),
      callback: function($$v) {
        _vm.partnerRole = $$v
      },
      expression: "partnerRole"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на документ",
      "clearable": "",
      "hint": "",
      "rules": [function (v) { return !!v || 'cсылка должна быть указана'; }]
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1203 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1204),
  /* template */
  __webpack_require__(1205),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_BtnForm__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__depo__ = __webpack_require__(35);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post-notification-form',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_6__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      contentText: null
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    chat: 'getChatterChat',
    profile: 'getProfile',
    getDepoUrl: 'getDepoUrl'
  }), {
    partnerName: function partnerName() {
      return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]';
    },
    partnerInn: function partnerInn() {
      return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]';
    },
    clientName: function clientName() {
      return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]';
    },
    clientInn: function clientInn() {
      return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]';
    },
    expiryTime: function expiryTime() {
      return this.item.expiryTime ? __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.item.expiryTime)) : '';
    },
    docLink: function docLink() {
      return this.item.link ? this.item.link : '[Ссылка на файл]';
    },
    offerContent: function offerContent() {
      return this.contentText ? this.contentText : '[Описание уведомления]';
    },
    title: function title() {
      return 'Направить уведомление';
    },

    text: {
      get: function get() {
        return this.getText();
      }
    }
  }),
  methods: {
    add: function add() {
      if (this.$refs.form.validate()) {
        this.item.text = this.getText();
        this.item.chatId = this.chat.id;
        this.$store.dispatch('addChatterPost', this.item);
        this.edit = false;
        this.cancel();
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        chatId: null,
        text: '',
        typeCode: 'NOTIFY',
        expiryTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(5, 'days').format(),
        link: null
      };
    },
    getText: function getText() {
      return this.clientName + ', \u0418\u041D\u041D ' + this.clientInn + ' \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u044F\u0435\u0442 ' + this.partnerName + ', \u0418\u041D\u041D ' + this.partnerInn + ' \u043E \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u043C: ' + this.offerContent + '. \u041F\u043E\u043B\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442 \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0444\u0430\u0439\u043B\u0435 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: <a href="' + this.docLink + '">' + this.docLink + '</a>.';
    },

    setDoc: function setDoc(value) {
      var docLink = this.getDepoUrl(value);
      this.item.link = docLink;
    },
    dialogOpen: function dialogOpen() {
      __WEBPACK_IMPORTED_MODULE_7__depo__["a" /* default */].selectDoc(this, this.setDoc);
    }
  }
});

/***/ }),
/* 1205 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Описание уведомления",
      "rules": [function (v) { return !!v || 'введите краткое описание'; }],
      "rows": "3",
      "hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.contentText),
      callback: function($$v) {
        _vm.contentText = $$v
      },
      expression: "contentText"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на документ",
      "rules": [function (v) { return !!v || 'cсылка должна быть указана'; }],
      "hint": "",
      "clearable": ""
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Ознакомиться до",
      "rules": [],
      "hint": ""
    },
    model: {
      value: (_vm.item.expiryTime),
      callback: function($$v) {
        _vm.$set(_vm.item, "expiryTime", $$v)
      },
      expression: "item.expiryTime"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1206 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1207),
  /* template */
  __webpack_require__(1208),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post-offer-cancel-form',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_6__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      agreementDate: ''
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    chat: 'getChatterChat',
    profile: 'getProfile'
  }), {
    partnerName: function partnerName() {
      return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]';
    },
    partnerInn: function partnerInn() {
      return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]';
    },
    clientName: function clientName() {
      return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]';
    },
    clientInn: function clientInn() {
      return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]';
    },
    expiryTime: function expiryTime() {
      return this.item.expiryTime ? 'Срок действия настоящей оферты по ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.item.expiryTime)) + '.' : '';
    },
    docLink: function docLink() {
      return this.item.link ? this.item.link : '';
    },
    title: function title() {
      return 'Направить отмену оферты';
    },

    text: {
      get: function get() {
        return this.getText();
      }
    }
  }),
  methods: {
    add: function add() {
      if (this.$refs.form.validate()) {
        this.item.text = this.getText();
        this.item.chatId = this.chat.id;
        this.$store.dispatch('addChatterPost', this.item);
        this.edit = false;
        this.cancel();
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        chatId: null,
        text: '',
        typeCode: 'OFFER_CANCEL',
        link: null
      };
    },
    getText: function getText() {
      return this.clientName + ', \u0418\u041D\u041D ' + this.clientInn + ' \u043E\u0442\u043C\u0435\u043D\u044F\u0435\u0442 \u043E\u0444\u0435\u0440\u0442\u0443 \u2116 ' + this.agreementNumber + ' \u043E\u0442 ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(this.agreementDate) + ' \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u043D\u0443\u044E ' + this.partnerName + ', \u0418\u041D\u041D ' + this.partnerInn;
    }
  }

});

/***/ }),
/* 1208 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Номер оферты",
      "hint": "",
      "rules": [function (v) { return !!v || 'номер должен быть указан'; }],
      "clearable": ""
    },
    model: {
      value: (_vm.agreementNumber),
      callback: function($$v) {
        _vm.agreementNumber = $$v
      },
      expression: "agreementNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Дата оферты",
      "rules": [function (v) { return !!v || 'дата должна быть указана'; }],
      "hint": ""
    },
    model: {
      value: (_vm.agreementDate),
      callback: function($$v) {
        _vm.agreementDate = $$v
      },
      expression: "agreementDate"
    }
  })], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1209 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1210),
  /* template */
  __webpack_require__(1211),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1210 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post-act-form',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      agreementDate: ''
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    chat: 'getChatterChat',
    profile: 'getProfile',
    getDepoUrl: 'getDepoUrl'
  }), {
    partnerName: function partnerName() {
      return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]';
    },
    partnerInn: function partnerInn() {
      return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]';
    },
    clientName: function clientName() {
      return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]';
    },
    clientInn: function clientInn() {
      return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]';
    },
    expiryTime: function expiryTime() {
      return this.item.expiryTime ? __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.item.expiryTime)) : '';
    },
    docLink: function docLink() {
      return this.item.link ? this.item.link : '';
    },
    title: function title() {
      return 'Направить Акт/Накладную';
    },

    text: {
      get: function get() {
        return this.getText();
      },
      set: function set(value) {
        this.item.text = value;
      }
    }
  }),
  methods: {
    add: function add() {
      if (this.$refs.form.validate()) {
        this.item.text = this.getText();
        this.item.chatId = this.chat.id;
        this.$store.dispatch('addChatterPost', this.item);
        this.edit = false;
        this.cancel();
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        chatId: null,
        text: '',
        typeCode: 'ACT',
        expiryTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(5, 'days').format(),
        link: null
      };
    },
    getText: function getText() {
      return this.clientName + ', \u0418\u041D\u041D ' + this.clientInn + ' \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u044F\u0435\u0442 \u043E\u0431 \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 (\u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E\u043C \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438) \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u2116 ' + this.agreementNumber + ' \u043E\u0442 ' + __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(this.agreementDate) + ' (\u0434\u0430\u043B\u0435\u0435 \u2013 \u0414\u043E\u0433\u043E\u0432\u043E\u0440) \u0438 \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442 \u0430\u043A\u0442/\u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0443\u044E ' + this.partnerName + ', \u0418\u041D\u041D ' + this.partnerInn + ' \u0432 \u0444\u0430\u0439\u043B\u0435 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: <a href="' + this.docLink + '">' + this.docLink + '</a> \u0434\u043B\u044F \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u044F \u0441\u043E \u0441\u0442\u043E\u0440\u043E\u043D\u044B ' + this.partnerName + '. \u0421\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C \u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u043F\u0440\u0438 \u043E\u0442\u0441\u0443\u0442\u0441\u0442\u0432\u0438\u0438 \u0443 ' + this.partnerName + ' \u0437\u0430\u043C\u0435\u0447\u0430\u043D\u0438\u0439/\u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0439 \u043A ' + this.clientName + ' \u0430\u043A\u0442 / \u043D\u0430\u043A\u043B\u0430\u0434\u043D\u0430\u044F \u0434\u043E\u043B\u0436\u043D\u0430 \u0431\u044B\u0442\u044C \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0430 \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 ' + this.expiryTime + '.';
    },

    setDoc: function setDoc(value) {
      var docLink = this.getDepoUrl(value);
      this.item.link = docLink;
    },
    dialogOpen: function dialogOpen() {
      __WEBPACK_IMPORTED_MODULE_6__depo__["a" /* default */].selectDoc(this, this.setDoc);
    }
  }
});

/***/ }),
/* 1211 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Номер договора",
      "rules": [function (v) { return !!v || 'номер должен быть указан'; }],
      "hint": "",
      "clearable": ""
    },
    model: {
      value: (_vm.agreementNumber),
      callback: function($$v) {
        _vm.agreementNumber = $$v
      },
      expression: "agreementNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Дата договора",
      "rules": [function (v) { return !!v || 'дата должна быть указана'; }],
      "hint": ""
    },
    model: {
      value: (_vm.agreementDate),
      callback: function($$v) {
        _vm.agreementDate = $$v
      },
      expression: "agreementDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на акт/накладную",
      "hint": "",
      "rules": [function (v) { return !!v || 'cсылка должна быть указана'; }],
      "clearable": ""
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Подписать по",
      "rules": [],
      "hint": ""
    },
    model: {
      value: (_vm.item.expiryTime),
      callback: function($$v) {
        _vm.$set(_vm.item, "expiryTime", $$v)
      },
      expression: "item.expiryTime"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1212 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1213),
  /* template */
  __webpack_require__(1214),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post-claim-form',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      agreementDate: ''
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_3_vuex__["mapGetters"])({
    chat: 'getChatterChat',
    profile: 'getProfile',
    getDepoUrl: 'getDepoUrl'
  }), {
    partnerName: function partnerName() {
      return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]';
    },
    partnerInn: function partnerInn() {
      return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]';
    },
    clientName: function clientName() {
      return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]';
    },
    clientInn: function clientInn() {
      return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]';
    },
    expiryTime: function expiryTime() {
      return this.item.expiryTime ? __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatDate(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.item.expiryTime)) : '';
    },
    docLink: function docLink() {
      return this.item.link ? this.item.link : '';
    },
    title: function title() {
      return 'Направить Претензию';
    },

    text: {
      get: function get() {
        return this.getText();
      },
      set: function set(value) {
        this.item.text = value;
      }
    }
  }),
  methods: {
    add: function add() {
      if (this.$refs.form.validate()) {
        this.item.text = this.getText();
        this.item.chatId = this.chat.id;
        this.$store.dispatch('addChatterPost', this.item);
        this.edit = false;
        this.cancel();
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        chatId: null,
        text: '',
        typeCode: 'CLAIM',
        expiryTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(5, 'days').format(),
        link: null
      };
    },
    getText: function getText() {
      return this.clientName + ', \u0418\u041D\u041D ' + this.clientInn + ' \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u0442 ' + this.partnerName + ', \u0418\u041D\u041D ' + this.partnerInn + ' \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u044E \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u043D\u0435\u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435\u043C \u0438\u043B\u0438 \u043D\u0435\u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0438\u043C \u0438\u0441\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u2116 ' + this.agreementNumber + ' \u043E\u0442 ' + __WEBPACK_IMPORTED_MODULE_2__api_formats__["a" /* default */].formatDate(this.agreementDate) + ' (\u0434\u0430\u043B\u0435\u0435 \u2013 \u0414\u043E\u0433\u043E\u0432\u043E\u0440) \u041F\u043E\u043B\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442 \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u0438 \u0432 \u0444\u0430\u0439\u043B\u0435 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: <a href="' + this.docLink + '">' + this.docLink + '</a>. \u0421\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C \u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0430 ' + this.partnerName + ' \u0434\u043E\u043B\u0436\u0435\u043D \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u0442\u044C \u043F\u0440\u0435\u0442\u0435\u043D\u0437\u0438\u044E \u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0442\u0432\u0435\u0442 ' + this.clientName + ' \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 ' + this.expiryTime + '.';
    },

    setDoc: function setDoc(value) {
      var docLink = this.getDepoUrl(value);
      this.item.link = docLink;
    },
    dialogOpen: function dialogOpen() {
      __WEBPACK_IMPORTED_MODULE_6__depo__["a" /* default */].selectDoc(this, this.setDoc);
    }
  }
});

/***/ }),
/* 1214 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', [_c('v-text-field', {
    attrs: {
      "label": "Номер договора",
      "hint": "",
      "rules": [function (v) { return !!v || 'номер должен быть указан'; }],
      "clearable": ""
    },
    model: {
      value: (_vm.agreementNumber),
      callback: function($$v) {
        _vm.agreementNumber = $$v
      },
      expression: "agreementNumber"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Дата договора",
      "rules": [function (v) { return !!v || 'дата должна быть указана'; }],
      "hint": ""
    },
    model: {
      value: (_vm.agreementDate),
      callback: function($$v) {
        _vm.agreementDate = $$v
      },
      expression: "agreementDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на текст претензии",
      "hint": "",
      "rules": [function (v) { return !!v || 'cсылка должна быть указана'; }],
      "clearable": ""
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Предоставить ответ не позднее",
      "rules": [],
      "hint": ""
    },
    model: {
      value: (_vm.item.expiryTime),
      callback: function($$v) {
        _vm.$set(_vm.item, "expiryTime", $$v)
      },
      expression: "item.expiryTime"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1215 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1216),
  /* template */
  __webpack_require__(1217),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_moment__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__common_DateField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__depo__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__common_BtnForm__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'post-offer-request-form',
  components: { vDateField: __WEBPACK_IMPORTED_MODULE_5__common_DateField_vue___default.a, vBtnForm: __WEBPACK_IMPORTED_MODULE_7__common_BtnForm___default.a },
  data: function data() {
    return {
      edit: false,
      valid: false,
      item: {},
      agreementNumber: '',
      contentText: null
    };
  },
  props: {
    itemId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.item = this.getItemNew();
  },
  mounted: function mounted() {},

  watch: {},
  computed: __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, Object(__WEBPACK_IMPORTED_MODULE_2_vuex__["mapGetters"])({
    chat: 'getChatterChat',
    profile: 'getProfile',
    getDepoUrl: 'getDepoUrl'
  }), {
    partnerName: function partnerName() {
      return this.chat && this.chat.partnerName ? this.chat.partnerName : '[Название компании]';
    },
    partnerInn: function partnerInn() {
      return this.chat && this.chat.partnerInn ? this.chat.partnerInn : '[ИНН компании]';
    },
    clientName: function clientName() {
      return this.profile && this.profile.clientNameShort ? this.profile.clientNameShort : '[Название компании]';
    },
    clientInn: function clientInn() {
      return this.profile && this.profile.clientInn ? this.profile.clientInn : '[ИНН компании]';
    },
    expiryTime: function expiryTime() {
      return this.item.expiryTime ? __WEBPACK_IMPORTED_MODULE_3__api_formats__["a" /* default */].formatDate(__WEBPACK_IMPORTED_MODULE_4_moment___default()(this.item.expiryTime)) : '';
    },
    docLink: function docLink() {
      return this.item.link ? this.item.link : '[Ссылка на файл]';
    },
    offerContent: function offerContent() {
      return this.contentText ? this.contentText : '[Описание оферты]';
    },
    title: function title() {
      return 'Направить запрос оферты / коммерческого предложения';
    },

    text: {
      get: function get() {
        return this.getText();
      }
    }
  }),
  methods: {
    add: function add() {
      if (this.$refs.form.validate()) {
        this.item.text = this.getText();
        this.item.chatId = this.chat.id;
        this.$store.dispatch('addChatterPost', this.item);
        this.edit = false;
        this.cancel();
      }
    },
    cancel: function cancel() {
      this.edit = false;
      this.item = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_assign___default()({}, this.getItemNew());
      this.$emit('close');
    },
    getItemNew: function getItemNew() {
      return {
        id: null,
        chatId: null,
        text: '',
        typeCode: 'OFFER_REQUEST',
        expiryTime: __WEBPACK_IMPORTED_MODULE_4_moment___default()().add(5, 'days').format(),
        link: null
      };
    },
    getText: function getText() {
      return this.clientName + ', \u0418\u041D\u041D ' + this.clientInn + ' \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 ' + this.partnerName + ', \u0418\u041D\u041D ' + this.partnerInn + ' \u043D\u0430\u043F\u0440\u0430\u0432\u0438\u0442\u044C \u0441\u0432\u043E\u044E \u043E\u0444\u0435\u0440\u0442\u0443 \u043E ' + this.offerContent + '. \u041F\u043E\u043B\u043D\u044B\u0439 \u0442\u0435\u043A\u0441\u0442 \u0437\u0430\u043F\u0440\u043E\u0441\u0430 \u043D\u0430\u0445\u043E\u0434\u0438\u0442\u0441\u044F \u0432 \u0444\u0430\u0439\u043B\u0435 \u043F\u043E \u0430\u0434\u0440\u0435\u0441\u0443: <a href="' + this.docLink + '">' + this.docLink + '</a>. \u0421\u0440\u043E\u043A \u0434\u043B\u044F \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043E\u0444\u0435\u0440\u0442\u044B \u043D\u0435 \u043F\u043E\u0437\u0434\u043D\u0435\u0435 ' + this.expiryTime + '.';
    },

    setDoc: function setDoc(value) {
      var docLink = this.getDepoUrl(value);
      this.item.link = docLink;
    },
    dialogOpen: function dialogOpen() {
      __WEBPACK_IMPORTED_MODULE_6__depo__["a" /* default */].selectDoc(this, this.setDoc);
    }
  }

});

/***/ }),
/* 1217 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.add
          }
        }, [_vm._v("Направить")]), _vm._v(" "), _c('v-spacer')]
      },
      proxy: true
    }])
  }, [_c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-card-text', [_c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', {
    domProps: {
      "innerHTML": _vm._s(_vm.text)
    }
  }), _vm._v(" "), _c('v-flex', [_c('v-textarea', {
    attrs: {
      "label": "Описание оферты",
      "rows": "3",
      "hint": "",
      "rules": [function (v) { return !!v || 'введите краткое описание'; }],
      "clearable": ""
    },
    model: {
      value: (_vm.contentText),
      callback: function($$v) {
        _vm.contentText = $$v
      },
      expression: "contentText"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-text-field', {
    attrs: {
      "prepend-icon": "attach_file",
      "label": "Ссылка на документ",
      "hint": "",
      "rules": [function (v) { return !!v || 'cсылка должна быть указана'; }],
      "clearable": ""
    },
    on: {
      "click:prepend": _vm.dialogOpen
    },
    model: {
      value: (_vm.item.link),
      callback: function($$v) {
        _vm.$set(_vm.item, "link", $$v)
      },
      expression: "item.link"
    }
  })], 1), _vm._v(" "), _c('v-flex', [_c('v-date-field', {
    attrs: {
      "label": "Срок ответа не позднее",
      "rules": [],
      "hint": ""
    },
    model: {
      value: (_vm.item.expiryTime),
      callback: function($$v) {
        _vm.$set(_vm.item, "expiryTime", $$v)
      },
      expression: "item.expiryTime"
    }
  })], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1218 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1219),
  /* template */
  __webpack_require__(1220),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_server__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__api_formats__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BtnForm__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_BtnForm___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_BtnForm__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'v-confirm-dlg',
  components: { vBtnForm: __WEBPACK_IMPORTED_MODULE_2__common_BtnForm___default.a },
  data: function data() {
    return {
      valid: false,
      code: '',
      title: 'Подтверждение операции',
      errorMessage: '',
      expiryTime: null
    };
  },
  props: {
    actionCode: {
      type: String,
      default: null
    },
    resourceId: {
      type: Number,
      default: null
    },
    fullscreen: {
      type: Boolean,
      default: false
    }
  },
  created: function created() {
    this.fetchInfo();
  },

  methods: {
    cancel: function cancel() {
      this.$emit('close');
    },
    send: function send() {
      var _this = this;

      var cb = function cb(data) {
        _this.$emit('refresh');
        _this.cancel();
      };
      var cbError = function cbError(e) {
        var error = e;
        if (error.response && error.response.data && error.response.data.code) {
          switch (error.response.data.code) {
            case 'CONFIRMATION_CODE_WRONG':
              _this.$store.commit('setWarningStatus', 'Неверный код подтверждения или истек срок действия кода.');
              return;
          }
        }
        _this.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при посылке кода подтверждения ' });
      };
      __WEBPACK_IMPORTED_MODULE_0__api_server__["a" /* default */].apiPost('/api/me/confirmations', { code: this.code }, cb, cbError);
    },
    request: function request() {
      var _this2 = this;

      var cb = function cb(data) {
        _this2.fetchInfo();
      };
      var cbError = function cbError(e) {
        _this2.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при запросе кода подтверждения ' });
      };
      __WEBPACK_IMPORTED_MODULE_0__api_server__["a" /* default */].apiPost('/api/me/confirmation-requests', {
        actionCode: this.actionCode,
        resourceId: this.resourceId
      }, cb, cbError);
    },
    fetchInfo: function fetchInfo() {
      var _this3 = this;

      var cb = function cb(data) {
        if (data.length > 0) {
          _this3.expiryTime = data[0].expiryTime;
          _this3.errorMessage = '\u041A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u0431\u044B\u043B \u0432\u044B\u0441\u043B\u0430\u043D \u043F\u043E \u0441\u043C\u0441 \u043D\u0430 \u0442\u0435\u043B\u0435\u0444\u043E\u043D ' + data[0].address + '. \u0421\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u043A\u043E\u0434\u0430 \u0434\u043E ' + __WEBPACK_IMPORTED_MODULE_1__api_formats__["a" /* default */].formatTime(data[0].expiryTime) + ' \u043F\u043E \u043C\u043E\u0441\u043A\u043E\u0432\u0441\u043A\u043E\u043C\u0443 \u0432\u0440\u0435\u043C\u0435\u043D\u0438.';
        } else {
          _this3.errorMessage = '\u0414\u043B\u044F \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u0435 \u043F\u043E \u0441\u043C\u0441 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F, \u043D\u0430\u0436\u0430\u0432 \u043A\u043D\u043E\u043F\u043A\u0443 "\u041F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u041A\u043E\u0434", \u0438 \u0432\u0441\u0442\u0430\u0432\u044C\u0442\u0435 \u0435\u0433\u043E \u0432 \u043F\u043E\u043B\u0435 "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043A\u043E\u0434 \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0436\u0434\u0435\u043D\u0438\u044F"';
        }
      };
      var cbError = function cbError(e) {
        _this3.$store.commit('setErrorStatus', { error: e, context: 'Ошибка сервера при получении информации о кодах подтверждения ' });
      };
      __WEBPACK_IMPORTED_MODULE_0__api_server__["a" /* default */].apiGet('/api/me/confirmation-requests', cb, cbError);
    }
  }
});

/***/ }),
/* 1220 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-btn-form', {
    attrs: {
      "title": _vm.title
    },
    on: {
      "close": function($event) {
        return _vm.cancel()
      }
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function() {
        return [_c('v-btn', {
          attrs: {
            "disabled": !_vm.valid
          },
          on: {
            "click": _vm.send
          }
        }, [_vm._v("Ок")]), _vm._v(" "), _c('v-btn', {
          on: {
            "click": _vm.request
          }
        }, [_vm._v("Получить код")])]
      },
      proxy: true
    }])
  }, [_c('v-card-text', [_vm._v("\n    " + _vm._s(_vm.errorMessage) + "\n    "), _c('v-form', {
    ref: "form",
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-text-field', {
    attrs: {
      "type": "text",
      "label": "Введите код подтверждения",
      "clearable": ""
    },
    model: {
      value: (_vm.code),
      callback: function($$v) {
        _vm.code = $$v
      },
      expression: "code"
    }
  })], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1221 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "light": "",
      "dense": "",
      "flat": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.go(-1)
      }
    }
  }, [_c('v-icon', [_vm._v("chevron_left")])], 1), _vm._v(" "), _c('v-toolbar-title', [_vm._v(_vm._s(_vm.getTitle) + "\r\n    ")])], 1), _vm._v(" "), _c('v-card-text', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showDescription),
      expression: "showDescription"
    }]
  }, [_c('v-flex', {
    attrs: {
      "offset-xs10": ""
    }
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.hideDescription()
      }
    }
  }, [_vm._v("\r\n      скрыть\r\n  ")])]), _vm._v(" "), _c('v-flex', [_c('div', {
    domProps: {
      "innerHTML": _vm._s(_vm.getDescriptionHtml)
    }
  })])], 1), _vm._v(" "), _c('v-card', {
    ref: "scroll_target",
    staticClass: "scroll-y",
    attrs: {
      "flat": "",
      "id": "scroll_target",
      "height": _vm.calcHeight()
    }
  }, [_c('v-container', {
    directives: [{
      name: "scroll",
      rawName: "v-scroll:#scroll_target",
      value: (_vm.onScroll),
      expression: "onScroll",
      arg: "#scroll_target"
    }],
    staticStyle: {
      "min-height": "0",
      "margin-top": "0"
    },
    attrs: {
      "px-2": "",
      "pt-2": "",
      "fluid": "",
      "grid-list-lg": ""
    }
  }, [_vm._l((_vm.getPosts), function(item) {
    return [_c('v-flex', {
      class: _vm.getOffsetClass(item),
      attrs: {
        "xs11": "",
        "pb-2": ""
      }
    }, [(item.typeCode === 'CHAT_INVITATION') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'PLAIN') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'OFFER') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Оферта")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.partnerAction(item)),
        expression: "partnerAction(item)"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.changeActionState(item, 'SIGNED')
        }
      }
    }, [_vm._v("Акцепт")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.partnerAction(item)),
        expression: "partnerAction(item)"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.changeActionState(item, 'REJECTED')
        }
      }
    }, [_vm._v("Отклонить")]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'OFFER_CANCEL') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Отмена оферты")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'ACT') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Акт/Накладная")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.partnerAction(item)),
        expression: "partnerAction(item)"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.changeActionState(item, 'SIGNED')
        }
      }
    }, [_vm._v("Акцепт")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (_vm.partnerAction(item)),
        expression: "partnerAction(item)"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.changeActionState(item, 'REJECTED')
        }
      }
    }, [_vm._v("Отклонить")]), _vm._v(" "), _c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'CLAIM') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Претензия")]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'OFFER_REQUEST') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Запрос оферты / коммерческого предложения")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e(), _vm._v(" "), (item.typeCode === 'NOTIFY') ? _c('v-card', {
      attrs: {
        "color": _vm.getColor(item)
      }
    }, [_c('v-card-text', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v("Уведомление")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLHeader(item))
      }
    })], 1), _vm._v(" "), _c('div', {
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLText(item))
      }
    })], 1), _vm._v(" "), _c('v-card-actions', [_c('v-layout', {
      attrs: {
        "row": ""
      }
    }, [_c('v-flex', [_vm._v(_vm._s(_vm.resultText(item)))]), _vm._v(" "), _c('v-flex', {
      attrs: {
        "align-end": ""
      },
      domProps: {
        "innerHTML": _vm._s(_vm.getHTMLActionSign(item))
      }
    })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.confirm(item)
        }
      }
    }, [_vm._v("Подтвердить")]), _vm._v(" "), _c('v-btn', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (item.state === 'NEW' || item.state === 'UPDATED'),
        expression: "item.state === 'NEW' || item.state === 'UPDATED'"
      }],
      attrs: {
        "disabled": !_vm.isAdmin()
      },
      on: {
        "click": function($event) {
          return _vm.rollback(item)
        }
      }
    }, [_vm._v("Отменить")])], 1)], 1) : _vm._e()], 1)]
  })], 2)], 1), _vm._v(" "), _c('v-card-actions', {
    staticStyle: {
      "align-items": "flex-end"
    }
  }, [_c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": function($event) {
        return _vm.dialogOpen('DOC_SELECTOR')
      }
    }
  }, [_c('v-icon', [_vm._v("attach_file")])], 1), _vm._v(" "), _c('v-textarea', {
    ref: "focused",
    attrs: {
      "label": "Введите текст",
      "auto-grow": "",
      "rows": "1",
      "hint": "",
      "solo": "",
      "hide-details": ""
    },
    model: {
      value: (_vm.item.text),
      callback: function($$v) {
        _vm.$set(_vm.item, "text", $$v)
      },
      expression: "item.text"
    }
  }), _vm._v(" "), _c('v-btn', {
    attrs: {
      "icon": "",
      "light": ""
    },
    on: {
      "click": _vm.addPost
    }
  }, [_c('v-icon', [_vm._v("send")])], 1), _vm._v(" "), _c('v-menu', {
    attrs: {
      "left": "",
      "min-width": "20rem"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "icon": "",
      "light": ""
    },
    slot: "activator"
  }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
    attrs: {
      "dense": ""
    }
  }, [_vm._l((this.getMenus), function(item) {
    return [(item.divider) ? _c('v-divider') : _c('v-list-tile', {
      key: item.title,
      on: {
        "click": function($event) {
          return _vm.runAction(item)
        }
      }
    }, [_c('v-list-tile-title', [_vm._v(_vm._s(item.title))])], 1)]
  })], 2)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1222 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(!_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-card', [_c('v-card-title', [_c('span', {
    staticClass: "headline"
  }, [_vm._v("Служба обмена юридически значимыми сообщениями СОЮЗ. ")])]), _vm._v(" "), _c('v-card-text', [_vm._v("\n        Общение в службе СОЮЗ позволяет Вам использовать вашу переписку в судах.\n        Для работы в службе СОЮЗ, необходимо определить Юридическое лицо которое Вы представляете.\n        Регистрируйтесь и общайтесь от имени Вашей компании.\n      ")]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "to": "/register"
    }
  }, [_vm._v("Регистрация")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.getProfileHaveClient) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md8": ""
    }
  }, [_c('v-chat-list', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isRoot),
      expression: "isRoot"
    }],
    attrs: {
      "itemId": _vm.itemId
    }
  }), _vm._v(" "), _c('v-chat', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRoot),
      expression: "!isRoot"
    }],
    attrs: {
      "itemId": _vm.itemId
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),
/* 1223 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1224),
  /* template */
  __webpack_require__(1225),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 1225 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-card-text', {
    staticClass: "headline"
  }, [_vm._v("Компонент не реализован пока")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1226 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1227),
  /* template */
  __webpack_require__(1228),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SelectRadio_vue__ = __webpack_require__(457);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__common_SelectRadio_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__common_SelectRadio_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_SelectCheck_vue__ = __webpack_require__(244);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common_SelectCheck_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__common_SelectCheck_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_HtmlField_vue__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__common_HtmlField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__common_HtmlField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_MacroField_vue__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__common_MacroField_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__common_MacroField_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__api_formats_js__ = __webpack_require__(5);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





// import forms from './common/forms.js'


/* harmony default export */ __webpack_exports__["default"] = ({
  components: { vSelectRadio: __WEBPACK_IMPORTED_MODULE_0__common_SelectRadio_vue___default.a, vSelectCheck: __WEBPACK_IMPORTED_MODULE_1__common_SelectCheck_vue___default.a, vHtmlField: __WEBPACK_IMPORTED_MODULE_2__common_HtmlField_vue___default.a, vMacroField: __WEBPACK_IMPORTED_MODULE_3__common_MacroField_vue___default.a },
  data: function data() {
    return {
      items: [{ value: 'ATTACH', text: 'Прикрепить файлы' }, { value: 'DEPO_LINK', text: 'Без файлов' }],
      checkboxValue: 'Не выбрано',
      htmlValue: 'введите текст1',
      htmlValue2: 'введите текст2'
    };
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    console.log('beforeRouteLeave: HOME');
    next();
  },

  methods: {
    createComp: function createComp(template) {
      return __WEBPACK_IMPORTED_MODULE_4__api_formats_js__["a" /* default */].createComp('<span>' + template + '</span>');
    },
    replaceMacroTags: function replaceMacroTags(value) {
      var tags = [];
      var div = document.createElement('div');
      div.innerHTML = value;
      div.querySelectorAll('a').forEach(function (node) {
        if (node.href && /xslt:/ig.test(node.href)) {
          tags.push({ find: node.outerHTML, replace: node.href.replaceAll(/xslt:/ig, '') });
        }
      });
      var text = value;
      tags.forEach(function (tag) {
        text = text.replace(tag.find, tag.replace);
      });
      console.log('replaceMacroTags', tags, text);
      return text;
    },
    open: function open() {
      var action = 'macro';
      this.$refs.editor1.editor.$store.dispatch('showPopup', { name: action, params: null });
      this.$refs.editor1.editor.$store.dispatch('updatePopupDisplay', { name: action, display: true });
    },
    check: function check(content) {
      console.log('check', content, this.$refs.editor1.editor.$store);
    }
  }
});

/***/ }),
/* 1228 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    attrs: {
      "height": "500px"
    }
  }, [_c('v-select-radio', {
    attrs: {
      "label": "wwwwwww",
      "items": _vm.items
    },
    model: {
      value: (_vm.checkboxValue),
      callback: function($$v) {
        _vm.checkboxValue = $$v
      },
      expression: "checkboxValue"
    }
  }), _vm._v(" "), _c('v-select-check', {
    attrs: {
      "items": _vm.items
    },
    model: {
      value: (_vm.checkboxValue),
      callback: function($$v) {
        _vm.checkboxValue = $$v
      },
      expression: "checkboxValue"
    }
  }), _vm._v(" "), _c('v-textarea'), _vm._v(" "), _c('v-html-field', {
    ref: "editor1",
    attrs: {
      "macro": "",
      "label": "html редактор1"
    },
    on: {
      "check": _vm.check
    },
    model: {
      value: (_vm.htmlValue),
      callback: function($$v) {
        _vm.htmlValue = $$v
      },
      expression: "htmlValue"
    }
  }), _vm._v(" "), _c('v-flex', [_c('v-macro-field', {
    attrs: {
      "macro": "",
      "label": "html редактор2"
    },
    model: {
      value: (_vm.htmlValue2),
      callback: function($$v) {
        _vm.htmlValue2 = $$v
      },
      expression: "htmlValue2"
    }
  })], 1), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.htmlValue))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', [_vm._v(_vm._s(_vm.replaceMacroTags(_vm.htmlValue)))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("Макро")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 1229 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1230),
  /* template */
  __webpack_require__(1231),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__api_server_js__ = __webpack_require__(8);
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'new_window',
  created: function created() {
    // console.log('new_window', this)
    __WEBPACK_IMPORTED_MODULE_0__api_server_js__["a" /* default */].openApiGet(this.$router.query.url, function () {}, function () {});
  }
});

/***/ }),
/* 1231 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div')
},staticRenderFns: []}

/***/ }),
/* 1232 */
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(1)(
  /* script */
  __webpack_require__(1233),
  /* template */
  __webpack_require__(1234),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),
/* 1233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  components: {},
  data: function data() {
    return {};
  },
  methods: {}
});

/***/ }),
/* 1234 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "fluid": "",
      "fill-height": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "align-center": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md6": "",
      "lg6": ""
    }
  }, [_c('v-card', [_c('v-toolbar', {
    attrs: {
      "dense": "",
      "flat": ""
    }
  }, [_c('v-toolbar-title', [_vm._v("Импорт платежек\n            ")])], 1), _vm._v(" "), _c('v-card-text'), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "block": "",
      "color": "primary"
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v("Импорт")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ })
],[480]);


// WEBPACK FOOTER //
// static/js/app.1a489186edf53aa6799b.js